var UN = Object.defineProperty;
var $N = (o, t, e) => t in o ? UN(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var We = (o, t, e) => $N(o, typeof t != "symbol" ? t + "" : t, e);
import * as z from "react";
import y, { createContext as Mi, useMemo as pr, createElement as Ne, useContext as si, Children as sD, isValidElement as fh, cloneElement as Yd, useEffect as wr, useLayoutEffect as lD, Fragment as yn, useRef as Cr, Component as Oy, useCallback as Ai, memo as zN, forwardRef as sE, useState as er, useDebugValue as YN, useReducer as KN, createRef as qN } from "react";
import * as _s from "react-dom";
import qu, { createPortal as XN } from "react-dom";
import { j as Dr } from "./jsx-runtime-DmTjM30f.js";
var ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uD(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function ZN(o) {
  if (o.__esModule) return o;
  var t = o.default;
  if (typeof t == "function") {
    var e = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(o).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(o, r);
    Object.defineProperty(e, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return o[r];
      }
    });
  }), e;
}
function Wr(o) {
  if (o === null || o === !0 || o === !1)
    return NaN;
  var t = Number(o);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function dt(o, t) {
  if (t.length < o)
    throw new TypeError(o + " argument" + (o > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ut(o) {
  dt(1, arguments);
  var t = Object.prototype.toString.call(o);
  return o instanceof Date || typeof o == "object" && t === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || t === "[object Number]" ? new Date(o) : ((typeof o == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function U_(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && e.setDate(e.getDate() + r), e);
}
function Gb(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return e;
  var n = e.getDate(), i = new Date(e.getTime());
  i.setMonth(e.getMonth() + r + 1, 0);
  var a = i.getDate();
  return n >= a ? i : (e.setFullYear(i.getFullYear(), i.getMonth(), n), e);
}
function QN(o, t) {
  dt(2, arguments);
  var e = Wr(t);
  return Gb(o, e * 12);
}
function JN(o, t) {
  return dt(2, arguments), ut(o).getTime() - ut(t).getTime();
}
function ek(o, t) {
  var e;
  dt(1, arguments);
  var r = o || {}, n = ut(r.start), i = ut(r.end), a = i.getTime();
  if (!(n.getTime() <= a))
    throw new RangeError("Invalid interval");
  var s = [], l = n;
  l.setHours(0, 0, 0, 0);
  var u = Number((e = void 0) !== null && e !== void 0 ? e : 1);
  if (u < 1 || isNaN(u)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= a; )
    s.push(ut(l)), l.setDate(l.getDate() + u), l.setHours(0, 0, 0, 0);
  return s;
}
function $_(o) {
  dt(1, arguments);
  var t = ut(o);
  return t.setHours(23, 59, 59, 999), t;
}
var tk = {};
function Hl() {
  return tk;
}
function z_(o, t) {
  var e, r, n, i, a, s, l, u;
  dt(1, arguments);
  var c = Hl(), d = Wr((e = (r = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ut(o), v = f.getDay(), g = (v < d ? -7 : 0) + 6 - (v - d);
  return f.setDate(f.getDate() + g), f.setHours(23, 59, 59, 999), f;
}
function Y_(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getFullYear();
  return t.setFullYear(e + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function rk(o) {
  return dt(1, arguments), o instanceof Date || typeof o == "object" && Object.prototype.toString.call(o) === "[object Date]";
}
function cD(o) {
  if (dt(1, arguments), !rk(o) && typeof o != "number")
    return !1;
  var t = ut(o);
  return !isNaN(Number(t));
}
function nk(o, t) {
  dt(2, arguments);
  var e = ut(o).getTime(), r = Wr(t);
  return new Date(e + r);
}
function dD(o, t) {
  dt(2, arguments);
  var e = Wr(t);
  return nk(o, -e);
}
var ok = 864e5;
function ik(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), n = e - r;
  return Math.floor(n / ok) + 1;
}
function Jd(o) {
  dt(1, arguments);
  var t = 1, e = ut(o), r = e.getUTCDay(), n = (r < t ? 7 : 0) + r - t;
  return e.setUTCDate(e.getUTCDate() - n), e.setUTCHours(0, 0, 0, 0), e;
}
function pD(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Jd(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(e, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = Jd(i);
  return t.getTime() >= n.getTime() ? e + 1 : t.getTime() >= a.getTime() ? e : e - 1;
}
function ak(o) {
  dt(1, arguments);
  var t = pD(o), e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(t, 0, 4), e.setUTCHours(0, 0, 0, 0);
  var r = Jd(e);
  return r;
}
var sk = 6048e5;
function fD(o) {
  dt(1, arguments);
  var t = ut(o), e = Jd(t).getTime() - ak(t).getTime();
  return Math.round(e / sk) + 1;
}
function cc(o, t) {
  var e, r, n, i, a, s, l, u;
  dt(1, arguments);
  var c = Hl(), d = Wr((e = (r = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ut(o), v = f.getUTCDay(), g = (v < d ? 7 : 0) + v - d;
  return f.setUTCDate(f.getUTCDate() - g), f.setUTCHours(0, 0, 0, 0), f;
}
function lE(o, t) {
  var e, r, n, i, a, s, l, u;
  dt(1, arguments);
  var c = ut(o), d = c.getUTCFullYear(), f = Hl(), v = Wr((e = (r = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && e !== void 0 ? e : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d + 1, 0, v), g.setUTCHours(0, 0, 0, 0);
  var m = cc(g, t), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(d, 0, v), b.setUTCHours(0, 0, 0, 0);
  var S = cc(b, t);
  return c.getTime() >= m.getTime() ? d + 1 : c.getTime() >= S.getTime() ? d : d - 1;
}
function lk(o, t) {
  var e, r, n, i, a, s, l, u;
  dt(1, arguments);
  var c = Hl(), d = Wr((e = (r = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && e !== void 0 ? e : 1), f = lE(o, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(f, 0, d), v.setUTCHours(0, 0, 0, 0);
  var g = cc(v, t);
  return g;
}
var uk = 6048e5;
function hD(o, t) {
  dt(1, arguments);
  var e = ut(o), r = cc(e, t).getTime() - lk(e, t).getTime();
  return Math.round(r / uk) + 1;
}
function mr(o, t) {
  for (var e = o < 0 ? "-" : "", r = Math.abs(o).toString(); r.length < t; )
    r = "0" + r;
  return e + r;
}
var nl = {
  // Year
  y: function(o, t) {
    var e = o.getUTCFullYear(), r = e > 0 ? e : 1 - e;
    return mr(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M: function(o, t) {
    var e = o.getUTCMonth();
    return t === "M" ? String(e + 1) : mr(e + 1, 2);
  },
  // Day of the month
  d: function(o, t) {
    return mr(o.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(o, t) {
    var e = o.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(o, t) {
    return mr(o.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(o, t) {
    return mr(o.getUTCHours(), t.length);
  },
  // Minute
  m: function(o, t) {
    return mr(o.getUTCMinutes(), t.length);
  },
  // Second
  s: function(o, t) {
    return mr(o.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(o, t) {
    var e = t.length, r = o.getUTCMilliseconds(), n = Math.floor(r * Math.pow(10, e - 3));
    return mr(n, t.length);
  }
}, _d = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ck = {
  // Era
  G: function(o, t, e) {
    var r = o.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return e.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return e.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return e.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(o, t, e) {
    if (t === "yo") {
      var r = o.getUTCFullYear(), n = r > 0 ? r : 1 - r;
      return e.ordinalNumber(n, {
        unit: "year"
      });
    }
    return nl.y(o, t);
  },
  // Local week-numbering year
  Y: function(o, t, e, r) {
    var n = lE(o, r), i = n > 0 ? n : 1 - n;
    if (t === "YY") {
      var a = i % 100;
      return mr(a, 2);
    }
    return t === "Yo" ? e.ordinalNumber(i, {
      unit: "year"
    }) : mr(i, t.length);
  },
  // ISO week-numbering year
  R: function(o, t) {
    var e = pD(o);
    return mr(e, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(o, t) {
    var e = o.getUTCFullYear();
    return mr(e, t.length);
  },
  // Quarter
  Q: function(o, t, e) {
    var r = Math.ceil((o.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return mr(r, 2);
      case "Qo":
        return e.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return e.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return e.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(o, t, e) {
    var r = Math.ceil((o.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return mr(r, 2);
      case "qo":
        return e.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return e.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return e.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(o, t, e) {
    var r = o.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return nl.M(o, t);
      case "Mo":
        return e.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return e.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return e.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return e.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(o, t, e) {
    var r = o.getUTCMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return mr(r + 1, 2);
      case "Lo":
        return e.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return e.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return e.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return e.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(o, t, e, r) {
    var n = hD(o, r);
    return t === "wo" ? e.ordinalNumber(n, {
      unit: "week"
    }) : mr(n, t.length);
  },
  // ISO week of year
  I: function(o, t, e) {
    var r = fD(o);
    return t === "Io" ? e.ordinalNumber(r, {
      unit: "week"
    }) : mr(r, t.length);
  },
  // Day of the month
  d: function(o, t, e) {
    return t === "do" ? e.ordinalNumber(o.getUTCDate(), {
      unit: "date"
    }) : nl.d(o, t);
  },
  // Day of year
  D: function(o, t, e) {
    var r = ik(o);
    return t === "Do" ? e.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : mr(r, t.length);
  },
  // Day of week
  E: function(o, t, e) {
    var r = o.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(o, t, e, r) {
    var n = o.getUTCDay(), i = (n - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return mr(i, 2);
      case "eo":
        return e.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return e.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return e.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return e.day(n, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return e.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(o, t, e, r) {
    var n = o.getUTCDay(), i = (n - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return mr(i, t.length);
      case "co":
        return e.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return e.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return e.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return e.day(n, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return e.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(o, t, e) {
    var r = o.getUTCDay(), n = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(n);
      case "ii":
        return mr(n, t.length);
      case "io":
        return e.ordinalNumber(n, {
          unit: "day"
        });
      case "iii":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(o, t, e) {
    var r = o.getUTCHours(), n = r / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(o, t, e) {
    var r = o.getUTCHours(), n;
    switch (r === 12 ? n = _d.noon : r === 0 ? n = _d.midnight : n = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return e.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(o, t, e) {
    var r = o.getUTCHours(), n;
    switch (r >= 17 ? n = _d.evening : r >= 12 ? n = _d.afternoon : r >= 4 ? n = _d.morning : n = _d.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(o, t, e) {
    if (t === "ho") {
      var r = o.getUTCHours() % 12;
      return r === 0 && (r = 12), e.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return nl.h(o, t);
  },
  // Hour [0-23]
  H: function(o, t, e) {
    return t === "Ho" ? e.ordinalNumber(o.getUTCHours(), {
      unit: "hour"
    }) : nl.H(o, t);
  },
  // Hour [0-11]
  K: function(o, t, e) {
    var r = o.getUTCHours() % 12;
    return t === "Ko" ? e.ordinalNumber(r, {
      unit: "hour"
    }) : mr(r, t.length);
  },
  // Hour [1-24]
  k: function(o, t, e) {
    var r = o.getUTCHours();
    return r === 0 && (r = 24), t === "ko" ? e.ordinalNumber(r, {
      unit: "hour"
    }) : mr(r, t.length);
  },
  // Minute
  m: function(o, t, e) {
    return t === "mo" ? e.ordinalNumber(o.getUTCMinutes(), {
      unit: "minute"
    }) : nl.m(o, t);
  },
  // Second
  s: function(o, t, e) {
    return t === "so" ? e.ordinalNumber(o.getUTCSeconds(), {
      unit: "second"
    }) : nl.s(o, t);
  },
  // Fraction of second
  S: function(o, t) {
    return nl.S(o, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(o, t, e, r) {
    var n = r._originalDate || o, i = n.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (t) {
      case "X":
        return q_(i);
      case "XXXX":
      case "XX":
        return Wu(i);
      case "XXXXX":
      case "XXX":
      default:
        return Wu(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(o, t, e, r) {
    var n = r._originalDate || o, i = n.getTimezoneOffset();
    switch (t) {
      case "x":
        return q_(i);
      case "xxxx":
      case "xx":
        return Wu(i);
      case "xxxxx":
      case "xxx":
      default:
        return Wu(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(o, t, e, r) {
    var n = r._originalDate || o, i = n.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + K_(i, ":");
      case "OOOO":
      default:
        return "GMT" + Wu(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(o, t, e, r) {
    var n = r._originalDate || o, i = n.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + K_(i, ":");
      case "zzzz":
      default:
        return "GMT" + Wu(i, ":");
    }
  },
  // Seconds timestamp
  t: function(o, t, e, r) {
    var n = r._originalDate || o, i = Math.floor(n.getTime() / 1e3);
    return mr(i, t.length);
  },
  // Milliseconds timestamp
  T: function(o, t, e, r) {
    var n = r._originalDate || o, i = n.getTime();
    return mr(i, t.length);
  }
};
function K_(o, t) {
  var e = o > 0 ? "-" : "+", r = Math.abs(o), n = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return e + String(n);
  var a = t;
  return e + String(n) + a + mr(i, 2);
}
function q_(o, t) {
  if (o % 60 === 0) {
    var e = o > 0 ? "-" : "+";
    return e + mr(Math.abs(o) / 60, 2);
  }
  return Wu(o, t);
}
function Wu(o, t) {
  var e = t || "", r = o > 0 ? "-" : "+", n = Math.abs(o), i = mr(Math.floor(n / 60), 2), a = mr(n % 60, 2);
  return r + i + e + a;
}
var X_ = function(o, t) {
  switch (o) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, vD = function(o, t) {
  switch (o) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, dk = function(o, t) {
  var e = o.match(/(P+)(p+)?/) || [], r = e[1], n = e[2];
  if (!n)
    return X_(o, t);
  var i;
  switch (r) {
    case "P":
      i = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = t.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", X_(r, t)).replace("{{time}}", vD(n, t));
}, Vb = {
  p: vD,
  P: dk
};
function gD(o) {
  var t = new Date(Date.UTC(o.getFullYear(), o.getMonth(), o.getDate(), o.getHours(), o.getMinutes(), o.getSeconds(), o.getMilliseconds()));
  return t.setUTCFullYear(o.getFullYear()), o.getTime() - t.getTime();
}
var pk = ["D", "DD"], fk = ["YY", "YYYY"];
function mD(o) {
  return pk.indexOf(o) !== -1;
}
function yD(o) {
  return fk.indexOf(o) !== -1;
}
function Sm(o, t, e) {
  if (o === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (o === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (o === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (o === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var hk = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, vk = function(o, t, e) {
  var r, n = hk[o];
  return typeof n == "string" ? r = n : t === 1 ? r = n.one : r = n.other.replace("{{count}}", t.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + r : r + " ago" : r;
};
function E0(o) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.width ? String(t.width) : o.defaultWidth, r = o.formats[e] || o.formats[o.defaultWidth];
    return r;
  };
}
var gk = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, mk = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yk = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ck = {
  date: E0({
    formats: gk,
    defaultWidth: "full"
  }),
  time: E0({
    formats: mk,
    defaultWidth: "full"
  }),
  dateTime: E0({
    formats: yk,
    defaultWidth: "full"
  })
}, wk = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, bk = function(o, t, e, r) {
  return wk[o];
};
function df(o) {
  return function(t, e) {
    var r = e != null && e.context ? String(e.context) : "standalone", n;
    if (r === "formatting" && o.formattingValues) {
      var i = o.defaultFormattingWidth || o.defaultWidth, a = e != null && e.width ? String(e.width) : i;
      n = o.formattingValues[a] || o.formattingValues[i];
    } else {
      var s = o.defaultWidth, l = e != null && e.width ? String(e.width) : o.defaultWidth;
      n = o.values[l] || o.values[s];
    }
    var u = o.argumentCallback ? o.argumentCallback(t) : t;
    return n[u];
  };
}
var Sk = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ek = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, _k = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, xk = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Rk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Tk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ok = function(o, t) {
  var e = Number(o), r = e % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, Pk = {
  ordinalNumber: Ok,
  era: df({
    values: Sk,
    defaultWidth: "wide"
  }),
  quarter: df({
    values: Ek,
    defaultWidth: "wide",
    argumentCallback: function(o) {
      return o - 1;
    }
  }),
  month: df({
    values: _k,
    defaultWidth: "wide"
  }),
  day: df({
    values: xk,
    defaultWidth: "wide"
  }),
  dayPeriod: df({
    values: Rk,
    defaultWidth: "wide",
    formattingValues: Tk,
    defaultFormattingWidth: "wide"
  })
};
function pf(o) {
  return function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.width, n = r && o.matchPatterns[r] || o.matchPatterns[o.defaultMatchWidth], i = t.match(n);
    if (!i)
      return null;
    var a = i[0], s = r && o.parsePatterns[r] || o.parsePatterns[o.defaultParseWidth], l = Array.isArray(s) ? Ak(s, function(d) {
      return d.test(a);
    }) : Dk(s, function(d) {
      return d.test(a);
    }), u;
    u = o.valueCallback ? o.valueCallback(l) : l, u = e.valueCallback ? e.valueCallback(u) : u;
    var c = t.slice(a.length);
    return {
      value: u,
      rest: c
    };
  };
}
function Dk(o, t) {
  for (var e in o)
    if (o.hasOwnProperty(e) && t(o[e]))
      return e;
}
function Ak(o, t) {
  for (var e = 0; e < o.length; e++)
    if (t(o[e]))
      return e;
}
function Mk(o) {
  return function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(o.matchPattern);
    if (!r) return null;
    var n = r[0], i = t.match(o.parsePattern);
    if (!i) return null;
    var a = o.valueCallback ? o.valueCallback(i[0]) : i[0];
    a = e.valueCallback ? e.valueCallback(a) : a;
    var s = t.slice(n.length);
    return {
      value: a,
      rest: s
    };
  };
}
var Fk = /^(\d+)(th|st|nd|rd)?/i, Ik = /\d+/i, Lk = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Nk = {
  any: [/^b/i, /^(a|c)/i]
}, kk = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Gk = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Vk = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Hk = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Bk = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Wk = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, jk = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Uk = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $k = {
  ordinalNumber: Mk({
    matchPattern: Fk,
    parsePattern: Ik,
    valueCallback: function(o) {
      return parseInt(o, 10);
    }
  }),
  era: pf({
    matchPatterns: Lk,
    defaultMatchWidth: "wide",
    parsePatterns: Nk,
    defaultParseWidth: "any"
  }),
  quarter: pf({
    matchPatterns: kk,
    defaultMatchWidth: "wide",
    parsePatterns: Gk,
    defaultParseWidth: "any",
    valueCallback: function(o) {
      return o + 1;
    }
  }),
  month: pf({
    matchPatterns: Vk,
    defaultMatchWidth: "wide",
    parsePatterns: Hk,
    defaultParseWidth: "any"
  }),
  day: pf({
    matchPatterns: Bk,
    defaultMatchWidth: "wide",
    parsePatterns: Wk,
    defaultParseWidth: "any"
  }),
  dayPeriod: pf({
    matchPatterns: jk,
    defaultMatchWidth: "any",
    parsePatterns: Uk,
    defaultParseWidth: "any"
  })
}, CD = {
  code: "en-US",
  formatDistance: vk,
  formatLong: Ck,
  formatRelative: bk,
  localize: Pk,
  match: $k,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zk = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Kk = /^'([^]*?)'?$/, qk = /''/g, Xk = /[a-zA-Z]/;
function Zk(o, t, e) {
  var r, n, i, a, s, l, u, c, d, f, v, g, m, b, S, R, P, D;
  dt(2, arguments);
  var x = String(t), M = Hl(), F = (r = (n = e == null ? void 0 : e.locale) !== null && n !== void 0 ? n : M.locale) !== null && r !== void 0 ? r : CD, H = Wr((i = (a = (s = (l = e == null ? void 0 : e.firstWeekContainsDate) !== null && l !== void 0 ? l : e == null || (u = e.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : M.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = M.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(H >= 1 && H <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var B = Wr((v = (g = (m = (b = e == null ? void 0 : e.weekStartsOn) !== null && b !== void 0 ? b : e == null || (S = e.locale) === null || S === void 0 || (R = S.options) === null || R === void 0 ? void 0 : R.weekStartsOn) !== null && m !== void 0 ? m : M.weekStartsOn) !== null && g !== void 0 ? g : (P = M.locale) === null || P === void 0 || (D = P.options) === null || D === void 0 ? void 0 : D.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(B >= 0 && B <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!F.localize)
    throw new RangeError("locale must contain localize property");
  if (!F.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var j = ut(o);
  if (!cD(j))
    throw new RangeError("Invalid time value");
  var V = gD(j), W = dD(j, V), q = {
    firstWeekContainsDate: H,
    weekStartsOn: B,
    locale: F,
    _originalDate: j
  }, ee = x.match(Yk).map(function(re) {
    var ie = re[0];
    if (ie === "p" || ie === "P") {
      var ne = Vb[ie];
      return ne(re, F.formatLong);
    }
    return re;
  }).join("").match(zk).map(function(re) {
    if (re === "''")
      return "'";
    var ie = re[0];
    if (ie === "'")
      return Qk(re);
    var ne = ck[ie];
    if (ne)
      return !(e != null && e.useAdditionalWeekYearTokens) && yD(re) && Sm(re, t, String(o)), !(e != null && e.useAdditionalDayOfYearTokens) && mD(re) && Sm(re, t, String(o)), ne(W, re, F.localize, q);
    if (ie.match(Xk))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + ie + "`");
    return re;
  }).join("");
  return ee;
}
function Qk(o) {
  var t = o.match(Kk);
  return t ? t[1].replace(qk, "'") : o;
}
function Jk(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getHours();
  return e;
}
function e3(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getSeconds();
  return e;
}
function t3(o) {
  return dt(1, arguments), ut(o).getFullYear();
}
function _0(o, t) {
  dt(2, arguments);
  var e = ut(o), r = ut(t);
  return e.getTime() > r.getTime();
}
function ff(o, t) {
  dt(2, arguments);
  var e = ut(o), r = ut(t);
  return e.getTime() < r.getTime();
}
function r3(o, t) {
  dt(2, arguments);
  var e = ut(o), r = ut(t);
  return e.getTime() === r.getTime();
}
function Em(o) {
  dt(1, arguments);
  var t = ut(o);
  return t.setHours(0, 0, 0, 0), t;
}
function n3(o, t) {
  dt(2, arguments);
  var e = Em(o), r = Em(t);
  return e.getTime() === r.getTime();
}
function o3(o, t) {
  dt(2, arguments);
  var e = ut(o), r = ut(t);
  return e.getFullYear() === r.getFullYear();
}
function i3(o, t) {
  dt(2, arguments);
  var e = ut(o), r = ut(t);
  return e.getFullYear() === r.getFullYear() && e.getMonth() === r.getMonth();
}
function Z_(o) {
  dt(1, arguments);
  var t = ut(o);
  return t.setMinutes(0, 0, 0), t;
}
function a3(o, t) {
  dt(2, arguments);
  var e = Z_(o), r = Z_(t);
  return e.getTime() === r.getTime();
}
function s3(o, t) {
  if (o == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var e in t)
    Object.prototype.hasOwnProperty.call(t, e) && (o[e] = t[e]);
  return o;
}
function _m(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
var l3 = 10;
class wD {
  constructor() {
    _m(this, "priority", void 0), _m(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
}
class u3 extends wD {
  constructor(t, e, r, n, i) {
    super(), this.value = t, this.validateValue = e, this.setValue = r, this.priority = n, i && (this.subPriority = i);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, r) {
    return this.setValue(t, e, this.value, r);
  }
}
class c3 extends wD {
  constructor() {
    super(...arguments), _m(this, "priority", l3), _m(this, "subPriority", -1);
  }
  set(t, e) {
    if (e.timestampIsSet)
      return t;
    var r = /* @__PURE__ */ new Date(0);
    return r.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), r.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), r;
  }
}
function x0(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class tr {
  constructor() {
    x0(this, "incompatibleTokens", void 0), x0(this, "priority", void 0), x0(this, "subPriority", void 0);
  }
  run(t, e, r, n) {
    var i = this.parse(t, e, r, n);
    return i ? {
      setter: new u3(i.value, this.validate, this.set, this.priority, this.subPriority),
      rest: i.rest
    } : null;
  }
  validate(t, e, r) {
    return !0;
  }
}
function Q_(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class d3 extends tr {
  constructor() {
    super(...arguments), Q_(this, "priority", 140), Q_(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, {
          width: "abbreviated"
        }) || r.era(t, {
          width: "narrow"
        });
      case "GGGGG":
        return r.era(t, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(t, {
          width: "wide"
        }) || r.era(t, {
          width: "abbreviated"
        }) || r.era(t, {
          width: "narrow"
        });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setUTCFullYear(r, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
var p3 = 6e4, f3 = 36e5, h3 = 1e3, nn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Da = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function on(o, t) {
  return o && {
    value: t(o.value),
    rest: o.rest
  };
}
function $r(o, t) {
  var e = t.match(o);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function Aa(o, t) {
  var e = t.match(o);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = e[1] === "+" ? 1 : -1, n = e[2] ? parseInt(e[2], 10) : 0, i = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (n * f3 + i * p3 + a * h3),
    rest: t.slice(e[0].length)
  };
}
function bD(o) {
  return $r(nn.anyDigitsSigned, o);
}
function Qr(o, t) {
  switch (o) {
    case 1:
      return $r(nn.singleDigit, t);
    case 2:
      return $r(nn.twoDigits, t);
    case 3:
      return $r(nn.threeDigits, t);
    case 4:
      return $r(nn.fourDigits, t);
    default:
      return $r(new RegExp("^\\d{1," + o + "}"), t);
  }
}
function xm(o, t) {
  switch (o) {
    case 1:
      return $r(nn.singleDigitSigned, t);
    case 2:
      return $r(nn.twoDigitsSigned, t);
    case 3:
      return $r(nn.threeDigitsSigned, t);
    case 4:
      return $r(nn.fourDigitsSigned, t);
    default:
      return $r(new RegExp("^-?\\d{1," + o + "}"), t);
  }
}
function uE(o) {
  switch (o) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function SD(o, t) {
  var e = t > 0, r = e ? t : 1 - t, n;
  if (r <= 50)
    n = o || 100;
  else {
    var i = r + 50, a = Math.floor(i / 100) * 100, s = o >= i % 100;
    n = o + a - (s ? 100 : 0);
  }
  return e ? n : 1 - n;
}
function ED(o) {
  return o % 400 === 0 || o % 4 === 0 && o % 100 !== 0;
}
function J_(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class v3 extends tr {
  constructor() {
    super(...arguments), J_(this, "priority", 130), J_(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    var n = function(i) {
      return {
        year: i,
        isTwoDigitYear: e === "yy"
      };
    };
    switch (e) {
      case "y":
        return on(Qr(4, t), n);
      case "yo":
        return on(r.ordinalNumber(t, {
          unit: "year"
        }), n);
      default:
        return on(Qr(e.length, t), n);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    var n = t.getUTCFullYear();
    if (r.isTwoDigitYear) {
      var i = SD(r.year, n);
      return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
    }
    var a = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setUTCFullYear(a, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function ex(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class g3 extends tr {
  constructor() {
    super(...arguments), ex(this, "priority", 130), ex(this, "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(t, e, r) {
    var n = function(i) {
      return {
        year: i,
        isTwoDigitYear: e === "YY"
      };
    };
    switch (e) {
      case "Y":
        return on(Qr(4, t), n);
      case "Yo":
        return on(r.ordinalNumber(t, {
          unit: "year"
        }), n);
      default:
        return on(Qr(e.length, t), n);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, n) {
    var i = lE(t, n);
    if (r.isTwoDigitYear) {
      var a = SD(r.year, i);
      return t.setUTCFullYear(a, 0, n.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), cc(t, n);
    }
    var s = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setUTCFullYear(s, 0, n.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), cc(t, n);
  }
}
function tx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class m3 extends tr {
  constructor() {
    super(...arguments), tx(this, "priority", 130), tx(this, "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return xm(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    var n = /* @__PURE__ */ new Date(0);
    return n.setUTCFullYear(r, 0, 4), n.setUTCHours(0, 0, 0, 0), Jd(n);
  }
}
function rx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class y3 extends tr {
  constructor() {
    super(...arguments), rx(this, "priority", 130), rx(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return xm(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setUTCFullYear(r, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function nx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class C3 extends tr {
  constructor() {
    super(...arguments), nx(this, "priority", 120), nx(this, "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return Qr(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setUTCMonth((r - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function ox(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class w3 extends tr {
  constructor() {
    super(...arguments), ox(this, "priority", 120), ox(this, "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return Qr(e.length, t);
      case "qo":
        return r.ordinalNumber(t, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setUTCMonth((r - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function ix(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class b3 extends tr {
  constructor() {
    super(...arguments), ix(this, "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ix(this, "priority", 110);
  }
  parse(t, e, r) {
    var n = function(i) {
      return i - 1;
    };
    switch (e) {
      case "M":
        return on($r(nn.month, t), n);
      case "MM":
        return on(Qr(2, t), n);
      case "Mo":
        return on(r.ordinalNumber(t, {
          unit: "month"
        }), n);
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, {
          width: "wide",
          context: "formatting"
        }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setUTCMonth(r, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function ax(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class S3 extends tr {
  constructor() {
    super(...arguments), ax(this, "priority", 110), ax(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    var n = function(i) {
      return i - 1;
    };
    switch (e) {
      case "L":
        return on($r(nn.month, t), n);
      case "LL":
        return on(Qr(2, t), n);
      case "Lo":
        return on(r.ordinalNumber(t, {
          unit: "month"
        }), n);
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, {
          width: "wide",
          context: "standalone"
        }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setUTCMonth(r, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function E3(o, t, e) {
  dt(2, arguments);
  var r = ut(o), n = Wr(t), i = hD(r, e) - n;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
function sx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class _3 extends tr {
  constructor() {
    super(...arguments), sx(this, "priority", 100), sx(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return $r(nn.week, t);
      case "wo":
        return r.ordinalNumber(t, {
          unit: "week"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, n) {
    return cc(E3(t, r, n), n);
  }
}
function x3(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t), n = fD(e) - r;
  return e.setUTCDate(e.getUTCDate() - n * 7), e;
}
function lx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class R3 extends tr {
  constructor() {
    super(...arguments), lx(this, "priority", 100), lx(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return $r(nn.week, t);
      case "Io":
        return r.ordinalNumber(t, {
          unit: "week"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return Jd(x3(t, r));
  }
}
function R0(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
var T3 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], O3 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class P3 extends tr {
  constructor() {
    super(...arguments), R0(this, "priority", 90), R0(this, "subPriority", 1), R0(this, "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return $r(nn.date, t);
      case "do":
        return r.ordinalNumber(t, {
          unit: "date"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    var r = t.getUTCFullYear(), n = ED(r), i = t.getUTCMonth();
    return n ? e >= 1 && e <= O3[i] : e >= 1 && e <= T3[i];
  }
  set(t, e, r) {
    return t.setUTCDate(r), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function T0(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class D3 extends tr {
  constructor() {
    super(...arguments), T0(this, "priority", 90), T0(this, "subpriority", 1), T0(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return $r(nn.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, {
          unit: "date"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    var r = t.getUTCFullYear(), n = ED(r);
    return n ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setUTCMonth(0, r), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function cE(o, t, e) {
  var r, n, i, a, s, l, u, c;
  dt(2, arguments);
  var d = Hl(), f = Wr((r = (n = (i = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (s = e.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = ut(o), g = Wr(t), m = v.getUTCDay(), b = g % 7, S = (b + 7) % 7, R = (S < f ? 7 : 0) + g - m;
  return v.setUTCDate(v.getUTCDate() + R), v;
}
function ux(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class A3 extends tr {
  constructor() {
    super(...arguments), ux(this, "priority", 90), ux(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(t, {
          width: "wide",
          context: "formatting"
        }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, n) {
    return t = cE(t, r, n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function cx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class M3 extends tr {
  constructor() {
    super(...arguments), cx(this, "priority", 90), cx(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
  }
  parse(t, e, r, n) {
    var i = function(a) {
      var s = Math.floor((a - 1) / 7) * 7;
      return (a + n.weekStartsOn + 6) % 7 + s;
    };
    switch (e) {
      case "e":
      case "ee":
        return on(Qr(e.length, t), i);
      case "eo":
        return on(r.ordinalNumber(t, {
          unit: "day"
        }), i);
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(t, {
          width: "wide",
          context: "formatting"
        }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, n) {
    return t = cE(t, r, n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function dx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class F3 extends tr {
  constructor() {
    super(...arguments), dx(this, "priority", 90), dx(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
  }
  parse(t, e, r, n) {
    var i = function(a) {
      var s = Math.floor((a - 1) / 7) * 7;
      return (a + n.weekStartsOn + 6) % 7 + s;
    };
    switch (e) {
      case "c":
      case "cc":
        return on(Qr(e.length, t), i);
      case "co":
        return on(r.ordinalNumber(t, {
          unit: "day"
        }), i);
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, {
          width: "short",
          context: "standalone"
        }) || r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, {
          width: "short",
          context: "standalone"
        }) || r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(t, {
          width: "wide",
          context: "standalone"
        }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, {
          width: "short",
          context: "standalone"
        }) || r.day(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, n) {
    return t = cE(t, r, n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function I3(o, t) {
  dt(2, arguments);
  var e = Wr(t);
  e % 7 === 0 && (e = e - 7);
  var r = 1, n = ut(o), i = n.getUTCDay(), a = e % 7, s = (a + 7) % 7, l = (s < r ? 7 : 0) + e - i;
  return n.setUTCDate(n.getUTCDate() + l), n;
}
function px(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class L3 extends tr {
  constructor() {
    super(...arguments), px(this, "priority", 90), px(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    var n = function(i) {
      return i === 0 ? 7 : i;
    };
    switch (e) {
      case "i":
      case "ii":
        return Qr(e.length, t);
      case "io":
        return r.ordinalNumber(t, {
          unit: "day"
        });
      case "iii":
        return on(r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        }), n);
      case "iiiii":
        return on(r.day(t, {
          width: "narrow",
          context: "formatting"
        }), n);
      case "iiiiii":
        return on(r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        }), n);
      case "iiii":
      default:
        return on(r.day(t, {
          width: "wide",
          context: "formatting"
        }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, {
          width: "short",
          context: "formatting"
        }) || r.day(t, {
          width: "narrow",
          context: "formatting"
        }), n);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = I3(t, r), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function fx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class N3 extends tr {
  constructor() {
    super(...arguments), fx(this, "priority", 80), fx(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setUTCHours(uE(r), 0, 0, 0), t;
  }
}
function hx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class k3 extends tr {
  constructor() {
    super(...arguments), hx(this, "priority", 80), hx(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setUTCHours(uE(r), 0, 0, 0), t;
  }
}
function vx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class G3 extends tr {
  constructor() {
    super(...arguments), vx(this, "priority", 80), vx(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setUTCHours(uE(r), 0, 0, 0), t;
  }
}
function gx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class V3 extends tr {
  constructor() {
    super(...arguments), gx(this, "priority", 70), gx(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return $r(nn.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    var n = t.getUTCHours() >= 12;
    return n && r < 12 ? t.setUTCHours(r + 12, 0, 0, 0) : !n && r === 12 ? t.setUTCHours(0, 0, 0, 0) : t.setUTCHours(r, 0, 0, 0), t;
  }
}
function mx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class H3 extends tr {
  constructor() {
    super(...arguments), mx(this, "priority", 70), mx(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return $r(nn.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setUTCHours(r, 0, 0, 0), t;
  }
}
function yx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class B3 extends tr {
  constructor() {
    super(...arguments), yx(this, "priority", 70), yx(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return $r(nn.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    var n = t.getUTCHours() >= 12;
    return n && r < 12 ? t.setUTCHours(r + 12, 0, 0, 0) : t.setUTCHours(r, 0, 0, 0), t;
  }
}
function Cx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class W3 extends tr {
  constructor() {
    super(...arguments), Cx(this, "priority", 70), Cx(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return $r(nn.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    var n = r <= 24 ? r % 24 : r;
    return t.setUTCHours(n, 0, 0, 0), t;
  }
}
function wx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class j3 extends tr {
  constructor() {
    super(...arguments), wx(this, "priority", 60), wx(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return $r(nn.minute, t);
      case "mo":
        return r.ordinalNumber(t, {
          unit: "minute"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setUTCMinutes(r, 0, 0), t;
  }
}
function bx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class U3 extends tr {
  constructor() {
    super(...arguments), bx(this, "priority", 50), bx(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return $r(nn.second, t);
      case "so":
        return r.ordinalNumber(t, {
          unit: "second"
        });
      default:
        return Qr(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setUTCSeconds(r, 0), t;
  }
}
function Sx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class $3 extends tr {
  constructor() {
    super(...arguments), Sx(this, "priority", 30), Sx(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    var r = function(n) {
      return Math.floor(n * Math.pow(10, -e.length + 3));
    };
    return on(Qr(e.length, t), r);
  }
  set(t, e, r) {
    return t.setUTCMilliseconds(r), t;
  }
}
function Ex(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class z3 extends tr {
  constructor() {
    super(...arguments), Ex(this, "priority", 10), Ex(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return Aa(Da.basicOptionalMinutes, t);
      case "XX":
        return Aa(Da.basic, t);
      case "XXXX":
        return Aa(Da.basicOptionalSeconds, t);
      case "XXXXX":
        return Aa(Da.extendedOptionalSeconds, t);
      case "XXX":
      default:
        return Aa(Da.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : new Date(t.getTime() - r);
  }
}
function _x(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class Y3 extends tr {
  constructor() {
    super(...arguments), _x(this, "priority", 10), _x(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return Aa(Da.basicOptionalMinutes, t);
      case "xx":
        return Aa(Da.basic, t);
      case "xxxx":
        return Aa(Da.basicOptionalSeconds, t);
      case "xxxxx":
        return Aa(Da.extendedOptionalSeconds, t);
      case "xxx":
      default:
        return Aa(Da.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : new Date(t.getTime() - r);
  }
}
function xx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class K3 extends tr {
  constructor() {
    super(...arguments), xx(this, "priority", 40), xx(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return bD(t);
  }
  set(t, e, r) {
    return [new Date(r * 1e3), {
      timestampIsSet: !0
    }];
  }
}
function Rx(o, t, e) {
  return t in o ? Object.defineProperty(o, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : o[t] = e, o;
}
class q3 extends tr {
  constructor() {
    super(...arguments), Rx(this, "priority", 20), Rx(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return bD(t);
  }
  set(t, e, r) {
    return [new Date(r), {
      timestampIsSet: !0
    }];
  }
}
var X3 = {
  G: new d3(),
  y: new v3(),
  Y: new g3(),
  R: new m3(),
  u: new y3(),
  Q: new C3(),
  q: new w3(),
  M: new b3(),
  L: new S3(),
  w: new _3(),
  I: new R3(),
  d: new P3(),
  D: new D3(),
  E: new A3(),
  e: new M3(),
  c: new F3(),
  i: new L3(),
  a: new N3(),
  b: new k3(),
  B: new G3(),
  h: new V3(),
  H: new H3(),
  K: new B3(),
  k: new W3(),
  m: new j3(),
  s: new U3(),
  S: new $3(),
  X: new z3(),
  x: new Y3(),
  t: new K3(),
  T: new q3()
}, Z3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Q3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, J3 = /^'([^]*?)'?$/, e5 = /''/g, t5 = /\S/, r5 = /[a-zA-Z]/;
function n5(o, t, e, r) {
  var n, i, a, s, l, u, c, d, f, v, g, m, b, S, R, P, D, x;
  dt(3, arguments);
  var M = String(o), F = String(t), H = Hl(), B = (n = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : H.locale) !== null && n !== void 0 ? n : CD;
  if (!B.match)
    throw new RangeError("locale must contain match property");
  var j = Wr((a = (s = (l = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (c = r.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : H.firstWeekContainsDate) !== null && s !== void 0 ? s : (f = H.locale) === null || f === void 0 || (v = f.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = Wr((g = (m = (b = (S = r == null ? void 0 : r.weekStartsOn) !== null && S !== void 0 ? S : r == null || (R = r.locale) === null || R === void 0 || (P = R.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && b !== void 0 ? b : H.weekStartsOn) !== null && m !== void 0 ? m : (D = H.locale) === null || D === void 0 || (x = D.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (F === "")
    return M === "" ? ut(e) : /* @__PURE__ */ new Date(NaN);
  var W = {
    firstWeekContainsDate: j,
    weekStartsOn: V,
    locale: B
  }, q = [new c3()], ee = F.match(Q3).map(function(ae) {
    var oe = ae[0];
    if (oe in Vb) {
      var ve = Vb[oe];
      return ve(ae, B.formatLong);
    }
    return ae;
  }).join("").match(Z3), re = [], ie = function(ae) {
    !(r != null && r.useAdditionalWeekYearTokens) && yD(ae) && Sm(ae, F, o), !(r != null && r.useAdditionalDayOfYearTokens) && mD(ae) && Sm(ae, F, o);
    var oe = ae[0], ve = X3[oe];
    if (ve) {
      var _e = ve.incompatibleTokens;
      if (Array.isArray(_e)) {
        var le = re.find(function(de) {
          return _e.includes(de.token) || de.token === oe;
        });
        if (le)
          throw new RangeError("The format string mustn't contain `".concat(le.fullToken, "` and `").concat(ae, "` at the same time"));
      } else if (ve.incompatibleTokens === "*" && re.length > 0)
        throw new RangeError("The format string mustn't contain `".concat(ae, "` and any other token at the same time"));
      re.push({
        token: oe,
        fullToken: ae
      });
      var Ee = ve.run(M, ae, B.match, W);
      if (!Ee)
        return ne = ae, {
          v: /* @__PURE__ */ new Date(NaN)
        };
      q.push(Ee.setter), M = Ee.rest;
    } else {
      if (oe.match(r5))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
      if (ae === "''" ? ae = "'" : oe === "'" && (ae = o5(ae)), M.indexOf(ae) === 0)
        M = M.slice(ae.length);
      else
        return ne = ae, {
          v: /* @__PURE__ */ new Date(NaN)
        };
    }
    ne = ae;
  };
  for (var ne of ee) {
    var se = ie(ne);
    if (typeof se == "object") return se.v;
  }
  if (M.length > 0 && t5.test(M))
    return /* @__PURE__ */ new Date(NaN);
  var pe = q.map(function(ae) {
    return ae.priority;
  }).sort(function(ae, oe) {
    return oe - ae;
  }).filter(function(ae, oe, ve) {
    return ve.indexOf(ae) === oe;
  }).map(function(ae) {
    return q.filter(function(oe) {
      return oe.priority === ae;
    }).sort(function(oe, ve) {
      return ve.subPriority - oe.subPriority;
    });
  }).map(function(ae) {
    return ae[0];
  }), K = ut(e);
  if (isNaN(K.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var J = dD(K, gD(K)), ue = {};
  for (var he of pe) {
    if (!he.validate(J, W))
      return /* @__PURE__ */ new Date(NaN);
    var fe = he.set(J, ue, W);
    Array.isArray(fe) ? (J = fe[0], s3(ue, fe[1])) : J = fe;
  }
  return J;
}
function o5(o) {
  return o.match(J3)[1].replace(e5, "'");
}
function i5(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  return e.setHours(r), e;
}
function a5(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  return e.setMinutes(r), e;
}
function s5(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getFullYear(), r = t.getMonth(), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e, r + 1, 0), n.setHours(0, 0, 0, 0), n.getDate();
}
function l5(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t), n = e.getFullYear(), i = e.getDate(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n, r, 15), a.setHours(0, 0, 0, 0);
  var s = s5(a);
  return e.setMonth(r, Math.min(i, s)), e;
}
function u5(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  return e.setSeconds(r), e;
}
function c5(o, t) {
  dt(2, arguments);
  var e = ut(o), r = Wr(t);
  return isNaN(e.getTime()) ? /* @__PURE__ */ new Date(NaN) : (e.setFullYear(r), e);
}
function Tx(o) {
  dt(1, arguments);
  var t = ut(o);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Ox(o) {
  dt(1, arguments);
  var t = ut(o), e = t.getMonth();
  return t.setFullYear(t.getFullYear(), e + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Px(o, t) {
  var e, r, n, i, a, s, l, u;
  dt(1, arguments);
  var c = Hl(), d = Wr((e = (r = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ut(o), v = f.getDay(), g = (v < d ? 7 : 0) + v - d;
  return f.setDate(f.getDate() - g), f.setHours(0, 0, 0, 0), f;
}
function O0(o) {
  dt(1, arguments);
  var t = ut(o), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(t.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
var Dx = (
  /** @class */
  function() {
    function o(t) {
      var e = (t === void 0 ? {} : t).locale;
      this.yearFormat = "yyyy", this.yearMonthFormat = "MMMM yyyy", this.dateTime12hFormat = "MMMM do hh:mm aaaa", this.dateTime24hFormat = "MMMM do HH:mm", this.time12hFormat = "hh:mm a", this.time24hFormat = "HH:mm", this.dateFormat = "MMMM do", this.locale = e;
    }
    return o.prototype.addDays = function(t, e) {
      return U_(t, e);
    }, o.prototype.isValid = function(t) {
      return cD(this.date(t));
    }, o.prototype.getDiff = function(t, e) {
      return JN(t, this.date(e));
    }, o.prototype.isAfter = function(t, e) {
      return _0(t, e);
    }, o.prototype.isBefore = function(t, e) {
      return ff(t, e);
    }, o.prototype.startOfDay = function(t) {
      return Em(t);
    }, o.prototype.endOfDay = function(t) {
      return $_(t);
    }, o.prototype.getHours = function(t) {
      return Jk(t);
    }, o.prototype.setHours = function(t, e) {
      return i5(t, e);
    }, o.prototype.setMinutes = function(t, e) {
      return a5(t, e);
    }, o.prototype.getSeconds = function(t) {
      return e3(t);
    }, o.prototype.setSeconds = function(t, e) {
      return u5(t, e);
    }, o.prototype.isSameDay = function(t, e) {
      return n3(t, e);
    }, o.prototype.isSameMonth = function(t, e) {
      return i3(t, e);
    }, o.prototype.isSameYear = function(t, e) {
      return o3(t, e);
    }, o.prototype.isSameHour = function(t, e) {
      return a3(t, e);
    }, o.prototype.startOfMonth = function(t) {
      return Tx(t);
    }, o.prototype.endOfMonth = function(t) {
      return Ox(t);
    }, o.prototype.getYear = function(t) {
      return t3(t);
    }, o.prototype.setYear = function(t, e) {
      return c5(t, e);
    }, o.prototype.date = function(t) {
      return typeof t > "u" ? /* @__PURE__ */ new Date() : t === null ? null : new Date(t);
    }, o.prototype.parse = function(t, e) {
      return t === "" ? null : n5(t, e, /* @__PURE__ */ new Date(), { locale: this.locale });
    }, o.prototype.format = function(t, e) {
      return Zk(t, e, { locale: this.locale });
    }, o.prototype.isEqual = function(t, e) {
      return t === null && e === null ? !0 : r3(t, e);
    }, o.prototype.isNull = function(t) {
      return t === null;
    }, o.prototype.isAfterDay = function(t, e) {
      return _0(t, $_(e));
    }, o.prototype.isBeforeDay = function(t, e) {
      return ff(t, Em(e));
    }, o.prototype.isBeforeYear = function(t, e) {
      return ff(t, O0(e));
    }, o.prototype.isAfterYear = function(t, e) {
      return _0(t, Y_(e));
    }, o.prototype.formatNumber = function(t) {
      return t;
    }, o.prototype.getMinutes = function(t) {
      return t.getMinutes();
    }, o.prototype.getMonth = function(t) {
      return t.getMonth();
    }, o.prototype.setMonth = function(t, e) {
      return l5(t, e);
    }, o.prototype.getMeridiemText = function(t) {
      return t === "am" ? "AM" : "PM";
    }, o.prototype.getNextMonth = function(t) {
      return Gb(t, 1);
    }, o.prototype.getPreviousMonth = function(t) {
      return Gb(t, -1);
    }, o.prototype.getMonthArray = function(t) {
      for (var e = O0(t), r = [e]; r.length < 12; ) {
        var n = r[r.length - 1];
        r.push(this.getNextMonth(n));
      }
      return r;
    }, o.prototype.mergeDateAndTime = function(t, e) {
      return this.setMinutes(this.setHours(t, this.getHours(e)), this.getMinutes(e));
    }, o.prototype.getWeekdays = function() {
      var t = this, e = /* @__PURE__ */ new Date();
      return ek({
        start: Px(e, { locale: this.locale }),
        end: z_(e, { locale: this.locale })
      }).map(function(r) {
        return t.format(r, "EEEEEE");
      });
    }, o.prototype.getWeekArray = function(t) {
      for (var e = Px(Tx(t), { locale: this.locale }), r = z_(Ox(t), { locale: this.locale }), n = 0, i = e, a = []; ff(i, r); ) {
        var s = Math.floor(n / 7);
        a[s] = a[s] || [], a[s].push(i), i = U_(i, 1), n += 1;
      }
      return a;
    }, o.prototype.getYearRange = function(t, e) {
      for (var r = O0(t), n = Y_(e), i = [], a = r; ff(a, n); )
        i.push(a), a = QN(a, 1);
      return i;
    }, o.prototype.getCalendarHeaderText = function(t) {
      return this.format(t, this.yearMonthFormat);
    }, o.prototype.getYearText = function(t) {
      return this.format(t, "yyyy");
    }, o.prototype.getDatePickerHeaderText = function(t) {
      return this.format(t, "EEE, MMM d");
    }, o.prototype.getDateTimePickerHeaderText = function(t) {
      return this.format(t, "MMM d");
    }, o.prototype.getMonthText = function(t) {
      return this.format(t, "MMMM");
    }, o.prototype.getDayText = function(t) {
      return this.format(t, "d");
    }, o.prototype.getHourText = function(t, e) {
      return this.format(t, e ? "hh" : "HH");
    }, o.prototype.getMinuteText = function(t) {
      return this.format(t, "mm");
    }, o.prototype.getSecondText = function(t) {
      return this.format(t, "ss");
    }, o;
  }()
);
function ka(o) {
  "@babel/helpers - typeof";
  return ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ka(o);
}
function d5(o, t) {
  if (ka(o) != "object" || !o) return o;
  var e = o[Symbol.toPrimitive];
  if (e !== void 0) {
    var r = e.call(o, t || "default");
    if (ka(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(o);
}
function _D(o) {
  var t = d5(o, "string");
  return ka(t) == "symbol" ? t : t + "";
}
function Cn(o, t, e) {
  return (t = _D(t)) in o ? Object.defineProperty(o, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[t] = e, o;
}
var Hb = { exports: {} }, ig = { exports: {} }, nr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ax;
function p5() {
  if (Ax) return nr;
  Ax = 1;
  var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
  function P(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case t:
          switch (x = x.type, x) {
            case l:
            case u:
            case r:
            case i:
            case n:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case c:
                case g:
                case v:
                case a:
                  return x;
                default:
                  return M;
              }
          }
        case e:
          return M;
      }
    }
  }
  function D(x) {
    return P(x) === u;
  }
  return nr.AsyncMode = l, nr.ConcurrentMode = u, nr.ContextConsumer = s, nr.ContextProvider = a, nr.Element = t, nr.ForwardRef = c, nr.Fragment = r, nr.Lazy = g, nr.Memo = v, nr.Portal = e, nr.Profiler = i, nr.StrictMode = n, nr.Suspense = d, nr.isAsyncMode = function(x) {
    return D(x) || P(x) === l;
  }, nr.isConcurrentMode = D, nr.isContextConsumer = function(x) {
    return P(x) === s;
  }, nr.isContextProvider = function(x) {
    return P(x) === a;
  }, nr.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, nr.isForwardRef = function(x) {
    return P(x) === c;
  }, nr.isFragment = function(x) {
    return P(x) === r;
  }, nr.isLazy = function(x) {
    return P(x) === g;
  }, nr.isMemo = function(x) {
    return P(x) === v;
  }, nr.isPortal = function(x) {
    return P(x) === e;
  }, nr.isProfiler = function(x) {
    return P(x) === i;
  }, nr.isStrictMode = function(x) {
    return P(x) === n;
  }, nr.isSuspense = function(x) {
    return P(x) === d;
  }, nr.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === u || x === i || x === n || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === v || x.$$typeof === a || x.$$typeof === s || x.$$typeof === c || x.$$typeof === b || x.$$typeof === S || x.$$typeof === R || x.$$typeof === m);
  }, nr.typeOf = P, nr;
}
var or = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mx;
function f5() {
  return Mx || (Mx = 1, process.env.NODE_ENV !== "production" && function() {
    var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
    function P(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === u || X === i || X === n || X === d || X === f || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === v || X.$$typeof === a || X.$$typeof === s || X.$$typeof === c || X.$$typeof === b || X.$$typeof === S || X.$$typeof === R || X.$$typeof === m);
    }
    function D(X) {
      if (typeof X == "object" && X !== null) {
        var xe = X.$$typeof;
        switch (xe) {
          case t:
            var Le = X.type;
            switch (Le) {
              case l:
              case u:
              case r:
              case i:
              case n:
              case d:
                return Le;
              default:
                var Ue = Le && Le.$$typeof;
                switch (Ue) {
                  case s:
                  case c:
                  case g:
                  case v:
                  case a:
                    return Ue;
                  default:
                    return xe;
                }
            }
          case e:
            return xe;
        }
      }
    }
    var x = l, M = u, F = s, H = a, B = t, j = c, V = r, W = g, q = v, ee = e, re = i, ie = n, ne = d, se = !1;
    function pe(X) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(X) || D(X) === l;
    }
    function K(X) {
      return D(X) === u;
    }
    function J(X) {
      return D(X) === s;
    }
    function ue(X) {
      return D(X) === a;
    }
    function he(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function fe(X) {
      return D(X) === c;
    }
    function ae(X) {
      return D(X) === r;
    }
    function oe(X) {
      return D(X) === g;
    }
    function ve(X) {
      return D(X) === v;
    }
    function _e(X) {
      return D(X) === e;
    }
    function le(X) {
      return D(X) === i;
    }
    function Ee(X) {
      return D(X) === n;
    }
    function de(X) {
      return D(X) === d;
    }
    or.AsyncMode = x, or.ConcurrentMode = M, or.ContextConsumer = F, or.ContextProvider = H, or.Element = B, or.ForwardRef = j, or.Fragment = V, or.Lazy = W, or.Memo = q, or.Portal = ee, or.Profiler = re, or.StrictMode = ie, or.Suspense = ne, or.isAsyncMode = pe, or.isConcurrentMode = K, or.isContextConsumer = J, or.isContextProvider = ue, or.isElement = he, or.isForwardRef = fe, or.isFragment = ae, or.isLazy = oe, or.isMemo = ve, or.isPortal = _e, or.isProfiler = le, or.isStrictMode = Ee, or.isSuspense = de, or.isValidElementType = P, or.typeOf = D;
  }()), or;
}
var Fx;
function xD() {
  return Fx || (Fx = 1, process.env.NODE_ENV === "production" ? ig.exports = p5() : ig.exports = f5()), ig.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var P0, Ix;
function h5() {
  if (Ix) return P0;
  Ix = 1;
  var o = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return P0 = n() ? Object.assign : function(i, a) {
    for (var s, l = r(i), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (o) {
        u = o(s);
        for (var f = 0; f < u.length; f++)
          e.call(s, u[f]) && (l[u[f]] = s[u[f]]);
      }
    }
    return l;
  }, P0;
}
var D0, Lx;
function dE() {
  if (Lx) return D0;
  Lx = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return D0 = o, D0;
}
var A0, Nx;
function RD() {
  return Nx || (Nx = 1, A0 = Function.call.bind(Object.prototype.hasOwnProperty)), A0;
}
var M0, kx;
function v5() {
  if (kx) return M0;
  kx = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = dE(), e = {}, r = RD();
    o = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function n(i, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[c](a, c, l, s, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && o(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in e)) {
            e[d.message] = !0;
            var v = u ? u() : "";
            o(
              "Failed " + s + " type: " + d.message + (v ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, M0 = n, M0;
}
var F0, Gx;
function g5() {
  if (Gx) return F0;
  Gx = 1;
  var o = xD(), t = h5(), e = dE(), r = RD(), n = v5(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return F0 = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(K) {
      var J = K && (u && K[u] || K[c]);
      if (typeof J == "function")
        return J;
    }
    var f = "<<anonymous>>", v = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: R(),
      arrayOf: P,
      element: D(),
      elementType: x(),
      instanceOf: M,
      node: j(),
      objectOf: H,
      oneOf: F,
      oneOfType: B,
      shape: W,
      exact: q
    };
    function g(K, J) {
      return K === J ? K !== 0 || 1 / K === 1 / J : K !== K && J !== J;
    }
    function m(K, J) {
      this.message = K, this.data = J && typeof J == "object" ? J : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(K) {
      if (process.env.NODE_ENV !== "production")
        var J = {}, ue = 0;
      function he(ae, oe, ve, _e, le, Ee, de) {
        if (_e = _e || f, Ee = Ee || ve, de !== e) {
          if (l) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xe = _e + ":" + ve;
            !J[xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            ue < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Ee + "` prop on `" + _e + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), J[xe] = !0, ue++);
          }
        }
        return oe[ve] == null ? ae ? oe[ve] === null ? new m("The " + le + " `" + Ee + "` is marked as required " + ("in `" + _e + "`, but its value is `null`.")) : new m("The " + le + " `" + Ee + "` is marked as required in " + ("`" + _e + "`, but its value is `undefined`.")) : null : K(oe, ve, _e, le, Ee);
      }
      var fe = he.bind(null, !1);
      return fe.isRequired = he.bind(null, !0), fe;
    }
    function S(K) {
      function J(ue, he, fe, ae, oe, ve) {
        var _e = ue[he], le = ie(_e);
        if (le !== K) {
          var Ee = ne(_e);
          return new m(
            "Invalid " + ae + " `" + oe + "` of type " + ("`" + Ee + "` supplied to `" + fe + "`, expected ") + ("`" + K + "`."),
            { expectedType: K }
          );
        }
        return null;
      }
      return b(J);
    }
    function R() {
      return b(a);
    }
    function P(K) {
      function J(ue, he, fe, ae, oe) {
        if (typeof K != "function")
          return new m("Property `" + oe + "` of component `" + fe + "` has invalid PropType notation inside arrayOf.");
        var ve = ue[he];
        if (!Array.isArray(ve)) {
          var _e = ie(ve);
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected an array."));
        }
        for (var le = 0; le < ve.length; le++) {
          var Ee = K(ve, le, fe, ae, oe + "[" + le + "]", e);
          if (Ee instanceof Error)
            return Ee;
        }
        return null;
      }
      return b(J);
    }
    function D() {
      function K(J, ue, he, fe, ae) {
        var oe = J[ue];
        if (!s(oe)) {
          var ve = ie(oe);
          return new m("Invalid " + fe + " `" + ae + "` of type " + ("`" + ve + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(K);
    }
    function x() {
      function K(J, ue, he, fe, ae) {
        var oe = J[ue];
        if (!o.isValidElementType(oe)) {
          var ve = ie(oe);
          return new m("Invalid " + fe + " `" + ae + "` of type " + ("`" + ve + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(K);
    }
    function M(K) {
      function J(ue, he, fe, ae, oe) {
        if (!(ue[he] instanceof K)) {
          var ve = K.name || f, _e = pe(ue[he]);
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected ") + ("instance of `" + ve + "`."));
        }
        return null;
      }
      return b(J);
    }
    function F(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function J(ue, he, fe, ae, oe) {
        for (var ve = ue[he], _e = 0; _e < K.length; _e++)
          if (g(ve, K[_e]))
            return null;
        var le = JSON.stringify(K, function(de, X) {
          var xe = ne(X);
          return xe === "symbol" ? String(X) : X;
        });
        return new m("Invalid " + ae + " `" + oe + "` of value `" + String(ve) + "` " + ("supplied to `" + fe + "`, expected one of " + le + "."));
      }
      return b(J);
    }
    function H(K) {
      function J(ue, he, fe, ae, oe) {
        if (typeof K != "function")
          return new m("Property `" + oe + "` of component `" + fe + "` has invalid PropType notation inside objectOf.");
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected an object."));
        for (var le in ve)
          if (r(ve, le)) {
            var Ee = K(ve, le, fe, ae, oe + "." + le, e);
            if (Ee instanceof Error)
              return Ee;
          }
        return null;
      }
      return b(J);
    }
    function B(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var J = 0; J < K.length; J++) {
        var ue = K[J];
        if (typeof ue != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(ue) + " at index " + J + "."
          ), a;
      }
      function he(fe, ae, oe, ve, _e) {
        for (var le = [], Ee = 0; Ee < K.length; Ee++) {
          var de = K[Ee], X = de(fe, ae, oe, ve, _e, e);
          if (X == null)
            return null;
          X.data && r(X.data, "expectedType") && le.push(X.data.expectedType);
        }
        var xe = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new m("Invalid " + ve + " `" + _e + "` supplied to " + ("`" + oe + "`" + xe + "."));
      }
      return b(he);
    }
    function j() {
      function K(J, ue, he, fe, ae) {
        return ee(J[ue]) ? null : new m("Invalid " + fe + " `" + ae + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return b(K);
    }
    function V(K, J, ue, he, fe) {
      return new m(
        (K || "React class") + ": " + J + " type `" + ue + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + fe + "`."
      );
    }
    function W(K) {
      function J(ue, he, fe, ae, oe) {
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type `" + _e + "` " + ("supplied to `" + fe + "`, expected `object`."));
        for (var le in K) {
          var Ee = K[le];
          if (typeof Ee != "function")
            return V(fe, ae, oe, le, ne(Ee));
          var de = Ee(ve, le, fe, ae, oe + "." + le, e);
          if (de)
            return de;
        }
        return null;
      }
      return b(J);
    }
    function q(K) {
      function J(ue, he, fe, ae, oe) {
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type `" + _e + "` " + ("supplied to `" + fe + "`, expected `object`."));
        var le = t({}, ue[he], K);
        for (var Ee in le) {
          var de = K[Ee];
          if (r(K, Ee) && typeof de != "function")
            return V(fe, ae, oe, Ee, ne(de));
          if (!de)
            return new m(
              "Invalid " + ae + " `" + oe + "` key `" + Ee + "` supplied to `" + fe + "`.\nBad object: " + JSON.stringify(ue[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(K), null, "  ")
            );
          var X = de(ve, Ee, fe, ae, oe + "." + Ee, e);
          if (X)
            return X;
        }
        return null;
      }
      return b(J);
    }
    function ee(K) {
      switch (typeof K) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !K;
        case "object":
          if (Array.isArray(K))
            return K.every(ee);
          if (K === null || s(K))
            return !0;
          var J = d(K);
          if (J) {
            var ue = J.call(K), he;
            if (J !== K.entries) {
              for (; !(he = ue.next()).done; )
                if (!ee(he.value))
                  return !1;
            } else
              for (; !(he = ue.next()).done; ) {
                var fe = he.value;
                if (fe && !ee(fe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(K, J) {
      return K === "symbol" ? !0 : J ? J["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && J instanceof Symbol : !1;
    }
    function ie(K) {
      var J = typeof K;
      return Array.isArray(K) ? "array" : K instanceof RegExp ? "object" : re(J, K) ? "symbol" : J;
    }
    function ne(K) {
      if (typeof K > "u" || K === null)
        return "" + K;
      var J = ie(K);
      if (J === "object") {
        if (K instanceof Date)
          return "date";
        if (K instanceof RegExp)
          return "regexp";
      }
      return J;
    }
    function se(K) {
      var J = ne(K);
      switch (J) {
        case "array":
        case "object":
          return "an " + J;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + J;
        default:
          return J;
      }
    }
    function pe(K) {
      return !K.constructor || !K.constructor.name ? f : K.constructor.name;
    }
    return v.checkPropTypes = n, v.resetWarningCache = n.resetWarningCache, v.PropTypes = v, v;
  }, F0;
}
var I0, Vx;
function m5() {
  if (Vx) return I0;
  Vx = 1;
  var o = dE();
  function t() {
  }
  function e() {
  }
  return e.resetWarningCache = t, I0 = function() {
    function r(a, s, l, u, c, d) {
      if (d !== o) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: e,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, I0;
}
if (process.env.NODE_ENV !== "production") {
  var y5 = xD(), C5 = !0;
  Hb.exports = g5()(y5.isElement, C5);
} else
  Hb.exports = m5()();
var Je = Hb.exports;
const _ = /* @__PURE__ */ uD(Je);
var TD = Mi(null), Bb = function(t) {
  var e = t.utils, r = t.children, n = t.locale, i = t.libInstance, a = pr(function() {
    return new e({
      locale: n,
      instance: i
    });
  }, [e, i, n]);
  return Ne(TD.Provider, {
    value: a,
    children: r
  });
};
process.env.NODE_ENV !== "production" && (Bb.propTypes = {
  utils: Je.func.isRequired,
  locale: Je.oneOfType([Je.object, Je.string]),
  children: Je.oneOfType([Je.element.isRequired, Je.arrayOf(Je.element.isRequired)]).isRequired
});
var w5 = function(t) {
  if (!t)
    throw new Error("Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.");
};
function aa() {
  var o = si(TD);
  return w5(o), o;
}
function OD(o) {
  var t, e, r = "";
  if (typeof o == "string" || typeof o == "number") r += o;
  else if (typeof o == "object") if (Array.isArray(o)) for (t = 0; t < o.length; t++) o[t] && (e = OD(o[t])) && (r && (r += " "), r += e);
  else for (t in o) o[t] && (r && (r += " "), r += t);
  return r;
}
function Xe() {
  for (var o, t, e = 0, r = ""; e < arguments.length; ) (o = arguments[e++]) && (t = OD(o)) && (r && (r += " "), r += t);
  return r;
}
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e) ({}).hasOwnProperty.call(e, r) && (o[r] = e[r]);
    }
    return o;
  }, Ce.apply(null, arguments);
}
function tv(o, t) {
  if (o == null) return {};
  var e = {};
  for (var r in o) if ({}.hasOwnProperty.call(o, r)) {
    if (t.indexOf(r) >= 0) continue;
    e[r] = o[r];
  }
  return e;
}
function Ke(o, t) {
  if (o == null) return {};
  var e, r, n = tv(o, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(o);
    for (r = 0; r < i.length; r++) e = i[r], t.indexOf(e) >= 0 || {}.propertyIsEnumerable.call(o, e) && (n[e] = o[e]);
  }
  return n;
}
function Ga(o, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return o.apply(void 0, arguments) || t.apply(void 0, arguments);
  };
}
function L0(o) {
  return o && ka(o) === "object" && o.constructor === Object;
}
function ep(o, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, r = e.clone ? Ce({}, o) : o;
  return L0(o) && L0(t) && Object.keys(t).forEach(function(n) {
    n !== "__proto__" && (L0(t[n]) && n in o ? r[n] = ep(o[n], t[n], e) : r[n] = t[n]);
  }), r;
}
function b5(o) {
  var t = o.prototype, e = t === void 0 ? {} : t;
  return !!e.isReactComponent;
}
function PD(o, t, e, r, n) {
  var i = o[t], a = n || t;
  if (i == null)
    return null;
  var s, l = i.type;
  return typeof l == "function" && !b5(l) && (s = "Did you accidentally use a plain function component for an element instead?"), s !== void 0 ? new Error("Invalid ".concat(r, " `").concat(a, "` supplied to `").concat(e, "`. ") + "Expected an element that can hold a ref. ".concat(s, " ") + "For more information see https://mui.com/r/caveat-with-refs-guide") : null;
}
var DD = Ga(_.element, PD);
DD.isRequired = Ga(_.element.isRequired, PD);
function S5(o) {
  var t = o.prototype, e = t === void 0 ? {} : t;
  return !!e.isReactComponent;
}
function E5(o, t, e, r, n) {
  var i = o[t], a = n || t;
  if (i == null)
    return null;
  var s;
  return typeof i == "function" && !S5(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error("Invalid ".concat(r, " `").concat(a, "` supplied to `").concat(e, "`. ") + "Expected an element type that can hold a ref. ".concat(s, " ") + "For more information see https://mui.com/r/caveat-with-refs-guide") : null;
}
const AD = Ga(Je.elementType, E5);
var _5 = "exact-prop: ​";
function Py(o) {
  return process.env.NODE_ENV === "production" ? o : Ce({}, o, Cn({}, _5, function(t) {
    var e = Object.keys(t).filter(function(r) {
      return !o.hasOwnProperty(r);
    });
    return e.length > 0 ? new Error("The following props are not supported: ".concat(e.map(function(r) {
      return "`".concat(r, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
function tp(o) {
  for (var t = "https://mui.com/production-error/?code=" + o, e = 1; e < arguments.length; e += 1)
    t += "&args[]=" + encodeURIComponent(arguments[e]);
  return "Minified Material-UI error #" + o + "; visit " + t + " for the full message.";
}
var Wb = { exports: {} }, xr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hx;
function x5() {
  if (Hx) return xr;
  Hx = 1;
  var o = 60103, t = 60106, e = 60107, r = 60108, n = 60114, i = 60109, a = 60110, s = 60112, l = 60113, u = 60120, c = 60115, d = 60116, f = 60121, v = 60122, g = 60117, m = 60129, b = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var S = Symbol.for;
    o = S("react.element"), t = S("react.portal"), e = S("react.fragment"), r = S("react.strict_mode"), n = S("react.profiler"), i = S("react.provider"), a = S("react.context"), s = S("react.forward_ref"), l = S("react.suspense"), u = S("react.suspense_list"), c = S("react.memo"), d = S("react.lazy"), f = S("react.block"), v = S("react.server.block"), g = S("react.fundamental"), m = S("react.debug_trace_mode"), b = S("react.legacy_hidden");
  }
  function R(q) {
    if (typeof q == "object" && q !== null) {
      var ee = q.$$typeof;
      switch (ee) {
        case o:
          switch (q = q.type, q) {
            case e:
            case n:
            case r:
            case l:
            case u:
              return q;
            default:
              switch (q = q && q.$$typeof, q) {
                case a:
                case s:
                case d:
                case c:
                case i:
                  return q;
                default:
                  return ee;
              }
          }
        case t:
          return ee;
      }
    }
  }
  var P = i, D = o, x = s, M = e, F = d, H = c, B = t, j = n, V = r, W = l;
  return xr.ContextConsumer = a, xr.ContextProvider = P, xr.Element = D, xr.ForwardRef = x, xr.Fragment = M, xr.Lazy = F, xr.Memo = H, xr.Portal = B, xr.Profiler = j, xr.StrictMode = V, xr.Suspense = W, xr.isAsyncMode = function() {
    return !1;
  }, xr.isConcurrentMode = function() {
    return !1;
  }, xr.isContextConsumer = function(q) {
    return R(q) === a;
  }, xr.isContextProvider = function(q) {
    return R(q) === i;
  }, xr.isElement = function(q) {
    return typeof q == "object" && q !== null && q.$$typeof === o;
  }, xr.isForwardRef = function(q) {
    return R(q) === s;
  }, xr.isFragment = function(q) {
    return R(q) === e;
  }, xr.isLazy = function(q) {
    return R(q) === d;
  }, xr.isMemo = function(q) {
    return R(q) === c;
  }, xr.isPortal = function(q) {
    return R(q) === t;
  }, xr.isProfiler = function(q) {
    return R(q) === n;
  }, xr.isStrictMode = function(q) {
    return R(q) === r;
  }, xr.isSuspense = function(q) {
    return R(q) === l;
  }, xr.isValidElementType = function(q) {
    return typeof q == "string" || typeof q == "function" || q === e || q === n || q === m || q === r || q === l || q === u || q === b || typeof q == "object" && q !== null && (q.$$typeof === d || q.$$typeof === c || q.$$typeof === i || q.$$typeof === a || q.$$typeof === s || q.$$typeof === g || q.$$typeof === f || q[0] === v);
  }, xr.typeOf = R, xr;
}
var Rr = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bx;
function R5() {
  return Bx || (Bx = 1, process.env.NODE_ENV !== "production" && function() {
    var o = 60103, t = 60106, e = 60107, r = 60108, n = 60114, i = 60109, a = 60110, s = 60112, l = 60113, u = 60120, c = 60115, d = 60116, f = 60121, v = 60122, g = 60117, m = 60129, b = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var S = Symbol.for;
      o = S("react.element"), t = S("react.portal"), e = S("react.fragment"), r = S("react.strict_mode"), n = S("react.profiler"), i = S("react.provider"), a = S("react.context"), s = S("react.forward_ref"), l = S("react.suspense"), u = S("react.suspense_list"), c = S("react.memo"), d = S("react.lazy"), f = S("react.block"), v = S("react.server.block"), g = S("react.fundamental"), S("react.scope"), S("react.opaque.id"), m = S("react.debug_trace_mode"), S("react.offscreen"), b = S("react.legacy_hidden");
    }
    var R = !1;
    function P(de) {
      return !!(typeof de == "string" || typeof de == "function" || de === e || de === n || de === m || de === r || de === l || de === u || de === b || R || typeof de == "object" && de !== null && (de.$$typeof === d || de.$$typeof === c || de.$$typeof === i || de.$$typeof === a || de.$$typeof === s || de.$$typeof === g || de.$$typeof === f || de[0] === v));
    }
    function D(de) {
      if (typeof de == "object" && de !== null) {
        var X = de.$$typeof;
        switch (X) {
          case o:
            var xe = de.type;
            switch (xe) {
              case e:
              case n:
              case r:
              case l:
              case u:
                return xe;
              default:
                var Le = xe && xe.$$typeof;
                switch (Le) {
                  case a:
                  case s:
                  case d:
                  case c:
                  case i:
                    return Le;
                  default:
                    return X;
                }
            }
          case t:
            return X;
        }
      }
    }
    var x = a, M = i, F = o, H = s, B = e, j = d, V = c, W = t, q = n, ee = r, re = l, ie = !1, ne = !1;
    function se(de) {
      return ie || (ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function pe(de) {
      return ne || (ne = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function K(de) {
      return D(de) === a;
    }
    function J(de) {
      return D(de) === i;
    }
    function ue(de) {
      return typeof de == "object" && de !== null && de.$$typeof === o;
    }
    function he(de) {
      return D(de) === s;
    }
    function fe(de) {
      return D(de) === e;
    }
    function ae(de) {
      return D(de) === d;
    }
    function oe(de) {
      return D(de) === c;
    }
    function ve(de) {
      return D(de) === t;
    }
    function _e(de) {
      return D(de) === n;
    }
    function le(de) {
      return D(de) === r;
    }
    function Ee(de) {
      return D(de) === l;
    }
    Rr.ContextConsumer = x, Rr.ContextProvider = M, Rr.Element = F, Rr.ForwardRef = H, Rr.Fragment = B, Rr.Lazy = j, Rr.Memo = V, Rr.Portal = W, Rr.Profiler = q, Rr.StrictMode = ee, Rr.Suspense = re, Rr.isAsyncMode = se, Rr.isConcurrentMode = pe, Rr.isContextConsumer = K, Rr.isContextProvider = J, Rr.isElement = ue, Rr.isForwardRef = he, Rr.isFragment = fe, Rr.isLazy = ae, Rr.isMemo = oe, Rr.isPortal = ve, Rr.isProfiler = _e, Rr.isStrictMode = le, Rr.isSuspense = Ee, Rr.isValidElementType = P, Rr.typeOf = D;
  }()), Rr;
}
process.env.NODE_ENV === "production" ? Wb.exports = x5() : Wb.exports = R5();
var Dh = Wb.exports, T5 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function O5(o) {
  var t = "".concat(o).match(T5), e = t && t[1];
  return e || "";
}
function MD(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return o.displayName || o.name || O5(o) || t;
}
function Wx(o, t, e) {
  var r = MD(t);
  return o.displayName || (r !== "" ? "".concat(e, "(").concat(r, ")") : e);
}
function hh(o) {
  if (o != null) {
    if (typeof o == "string")
      return o;
    if (typeof o == "function")
      return MD(o, "Component");
    if (ka(o) === "object")
      switch (o.$$typeof) {
        case Dh.ForwardRef:
          return Wx(o, o.render, "ForwardRef");
        case Dh.Memo:
          return Wx(o, o.type, "memo");
        default:
          return;
      }
  }
}
function Ah(o, t, e, r, n) {
  if (process.env.NODE_ENV === "production")
    return null;
  var i = o[t], a = n || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error("Invalid ".concat(r, " `").concat(a, "` supplied to `").concat(e, "`. ") + "Expected an HTMLElement.") : null;
}
var Va = _.oneOfType([_.func, _.object]), P5 = typeof Symbol == "function" && Symbol.for;
const FD = P5 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var D5 = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function A5() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = o.disableGlobal, e = t === void 0 ? !1 : t, r = o.productionPrefix, n = r === void 0 ? "jss" : r, i = o.seed, a = i === void 0 ? "" : i, s = a === "" ? "" : "".concat(a, "-"), l = 0, u = function() {
    return l += 1, process.env.NODE_ENV !== "production" && l >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), l;
  };
  return function(c, d) {
    var f = d.options.name;
    if (f && f.indexOf("Mui") === 0 && !d.options.link && !e) {
      if (D5.indexOf(c.key) !== -1)
        return "Mui-".concat(c.key);
      var v = "".concat(s).concat(f, "-").concat(c.key);
      return !d.options.theme[FD] || a !== "" ? v : "".concat(v, "-").concat(u());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(s).concat(n).concat(u());
    var g = "".concat(c.key, "-").concat(u());
    return d.options.classNamePrefix ? "".concat(s).concat(d.options.classNamePrefix, "-").concat(g) : "".concat(s).concat(g);
  };
}
function ID(o) {
  var t = o.theme, e = o.name, r = o.props;
  if (!t || !t.props || !t.props[e])
    return r;
  var n = t.props[e], i;
  for (i in n)
    r[i] === void 0 && (r[i] = n[i]);
  return r;
}
var M5 = process.env.NODE_ENV === "production";
function Fi(o, t) {
  if (!M5) {
    var e = "Warning: " + t;
    typeof console < "u" && console.warn(e);
    try {
      throw Error(e);
    } catch {
    }
  }
}
var jx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
  return typeof o;
} : function(o) {
  return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
}, rv = (typeof window > "u" ? "undefined" : jx(window)) === "object" && (typeof document > "u" ? "undefined" : jx(document)) === "object" && document.nodeType === 9;
function Ux(o, t) {
  for (var e = 0; e < t.length; e++) {
    var r = t[e];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, _D(r.key), r);
  }
}
function cp(o, t, e) {
  return t && Ux(o.prototype, t), e && Ux(o, e), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function Rm(o, t) {
  return Rm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
    return e.__proto__ = r, e;
  }, Rm(o, t);
}
function dp(o, t) {
  o.prototype = Object.create(t.prototype), o.prototype.constructor = o, Rm(o, t);
}
function Tm(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
var F5 = {}.constructor;
function jb(o) {
  if (o == null || typeof o != "object") return o;
  if (Array.isArray(o)) return o.map(jb);
  if (o.constructor !== F5) return o;
  var t = {};
  for (var e in o)
    t[e] = jb(o[e]);
  return t;
}
function pE(o, t, e) {
  o === void 0 && (o = "unnamed");
  var r = e.jss, n = jb(t), i = r.plugins.onCreateRule(o, n, e);
  return i || (o[0] === "@" && process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] Unknown rule " + o), null);
}
var $x = function(t, e) {
  for (var r = "", n = 0; n < t.length && t[n] !== "!important"; n++)
    r && (r += e), r += t[n];
  return r;
}, rc = function(t) {
  if (!Array.isArray(t)) return t;
  var e = "";
  if (Array.isArray(t[0]))
    for (var r = 0; r < t.length && t[r] !== "!important"; r++)
      e && (e += ", "), e += $x(t[r], " ");
  else e = $x(t, ", ");
  return t[t.length - 1] === "!important" && (e += " !important"), e;
};
function pp(o) {
  return o && o.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function hf(o, t) {
  for (var e = "", r = 0; r < t; r++)
    e += "  ";
  return e + o;
}
function Mh(o, t, e) {
  e === void 0 && (e = {});
  var r = "";
  if (!t) return r;
  var n = e, i = n.indent, a = i === void 0 ? 0 : i, s = t.fallbacks;
  e.format === !1 && (a = -1 / 0);
  var l = pp(e), u = l.linebreak, c = l.space;
  if (o && a++, s)
    if (Array.isArray(s))
      for (var d = 0; d < s.length; d++) {
        var f = s[d];
        for (var v in f) {
          var g = f[v];
          g != null && (r && (r += u), r += hf(v + ":" + c + rc(g) + ";", a));
        }
      }
    else
      for (var m in s) {
        var b = s[m];
        b != null && (r && (r += u), r += hf(m + ":" + c + rc(b) + ";", a));
      }
  for (var S in t) {
    var R = t[S];
    R != null && S !== "fallbacks" && (r && (r += u), r += hf(S + ":" + c + rc(R) + ";", a));
  }
  return !r && !e.allowEmpty || !o ? r : (a--, r && (r = "" + u + r + u), hf("" + o + c + "{" + r, a) + hf("}", a));
}
var I5 = /([[\].#*$><+~=|^:(),"'`\s])/g, zx = typeof CSS < "u" && CSS.escape, fE = function(o) {
  return zx ? zx(o) : o.replace(I5, "\\$1");
}, LD = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "style", this.isProcessed = !1;
    var i = n.sheet, a = n.Renderer;
    this.key = e, this.options = n, this.style = r, i ? this.renderer = i.renderer : a && (this.renderer = new a());
  }
  var t = o.prototype;
  return t.prop = function(r, n, i) {
    if (n === void 0) return this.style[r];
    var a = i ? i.force : !1;
    if (!a && this.style[r] === n) return this;
    var s = n;
    (!i || i.process !== !1) && (s = this.options.jss.plugins.onChangeValue(n, r, this));
    var l = s == null || s === !1, u = r in this.style;
    if (l && !u && !a) return this;
    var c = l && u;
    if (c ? delete this.style[r] : this.style[r] = s, this.renderable && this.renderer)
      return c ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, s), this;
    var d = this.options.sheet;
    return d && d.attached && process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, o;
}(), Ub = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t(r, n, i) {
    var a;
    a = o.call(this, r, n, i) || this;
    var s = i.selector, l = i.scoped, u = i.sheet, c = i.generateId;
    return s ? a.selectorText = s : l !== !1 && (a.id = c(Tm(Tm(a)), u), a.selectorText = "." + fE(a.id)), a;
  }
  var e = t.prototype;
  return e.applyTo = function(n) {
    var i = this.renderer;
    if (i) {
      var a = this.toJSON();
      for (var s in a)
        i.setProperty(n, s, a[s]);
    }
    return this;
  }, e.toJSON = function() {
    var n = {};
    for (var i in this.style) {
      var a = this.style[i];
      typeof a != "object" ? n[i] = a : Array.isArray(a) && (n[i] = rc(a));
    }
    return n;
  }, e.toString = function(n) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? Ce({}, n, {
      allowEmpty: !0
    }) : n;
    return Mh(this.selectorText, this.style, s);
  }, cp(t, [{
    key: "selector",
    set: function(n) {
      if (n !== this.selectorText) {
        this.selectorText = n;
        var i = this.renderer, a = this.renderable;
        if (!(!a || !i)) {
          var s = i.setSelector(a, n);
          s || i.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(LD), L5 = {
  onCreateRule: function(t, e, r) {
    return t[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new Ub(t, e, r);
  }
}, N0 = {
  indent: 1,
  children: !0
}, N5 = /@([\w-]+)/, k5 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "conditional", this.isProcessed = !1, this.key = e;
    var i = e.match(N5);
    this.at = i ? i[1] : "unknown", this.query = n.name || "@" + this.at, this.options = n, this.rules = new Dy(Ce({}, n, {
      parent: this
    }));
    for (var a in r)
      this.rules.add(a, r[a]);
    this.rules.process();
  }
  var t = o.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.addRule = function(r, n, i) {
    var a = this.rules.add(r, n, i);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, t.replaceRule = function(r, n, i) {
    var a = this.rules.replace(r, n, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.toString = function(r) {
    r === void 0 && (r = N0);
    var n = pp(r), i = n.linebreak;
    if (r.indent == null && (r.indent = N0.indent), r.children == null && (r.children = N0.children), r.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(r);
    return a ? this.query + " {" + i + a + i + "}" : "";
  }, o;
}(), G5 = /@media|@supports\s+/, V5 = {
  onCreateRule: function(t, e, r) {
    return G5.test(t) ? new k5(t, e, r) : null;
  }
}, k0 = {
  indent: 1,
  children: !0
}, H5 = /@keyframes\s+([\w-]+)/, $b = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = e.match(H5);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] Bad keyframes name " + e)), this.key = this.type + "-" + this.name, this.options = n;
    var a = n.scoped, s = n.sheet, l = n.generateId;
    this.id = a === !1 ? this.name : fE(l(this, s)), this.rules = new Dy(Ce({}, n, {
      parent: this
    }));
    for (var u in r)
      this.rules.add(u, r[u], Ce({}, n, {
        parent: this
      }));
    this.rules.process();
  }
  var t = o.prototype;
  return t.toString = function(r) {
    r === void 0 && (r = k0);
    var n = pp(r), i = n.linebreak;
    if (r.indent == null && (r.indent = k0.indent), r.children == null && (r.children = k0.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(r);
    return a && (a = "" + i + a + i), this.at + " " + this.id + " {" + a + "}";
  }, o;
}(), B5 = /@keyframes\s+/, W5 = /\$([\w-]+)/g, zb = function(t, e) {
  return typeof t == "string" ? t.replace(W5, function(r, n) {
    return n in e ? e[n] : (process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] Referenced keyframes rule "' + n + '" is not defined.'), r);
  }) : t;
}, Yx = function(t, e, r) {
  var n = t[e], i = zb(n, r);
  i !== n && (t[e] = i);
}, j5 = {
  onCreateRule: function(t, e, r) {
    return typeof t == "string" && B5.test(t) ? new $b(t, e, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, e, r) {
    return e.type !== "style" || !r || ("animation-name" in t && Yx(t, "animation-name", r.keyframes), "animation" in t && Yx(t, "animation", r.keyframes)), t;
  },
  onChangeValue: function(t, e, r) {
    var n = r.options.sheet;
    if (!n)
      return t;
    switch (e) {
      case "animation":
        return zb(t, n.keyframes);
      case "animation-name":
        return zb(t, n.keyframes);
      default:
        return t;
    }
  }
}, U5 = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t() {
    return o.apply(this, arguments) || this;
  }
  var e = t.prototype;
  return e.toString = function(n) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? Ce({}, n, {
      allowEmpty: !0
    }) : n;
    return Mh(this.key, this.style, s);
  }, t;
}(LD), $5 = {
  onCreateRule: function(t, e, r) {
    return r.parent && r.parent.type === "keyframes" ? new U5(t, e, r) : null;
  }
}, z5 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = e, this.style = r, this.options = n;
  }
  var t = o.prototype;
  return t.toString = function(r) {
    var n = pp(r), i = n.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", s = 0; s < this.style.length; s++)
        a += Mh(this.at, this.style[s]), this.style[s + 1] && (a += i);
      return a;
    }
    return Mh(this.at, this.style, r);
  }, o;
}(), Y5 = /@font-face/, K5 = {
  onCreateRule: function(t, e, r) {
    return Y5.test(t) ? new z5(t, e, r) : null;
  }
}, q5 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = e, this.style = r, this.options = n;
  }
  var t = o.prototype;
  return t.toString = function(r) {
    return Mh(this.key, this.style, r);
  }, o;
}(), X5 = {
  onCreateRule: function(t, e, r) {
    return t === "@viewport" || t === "@-ms-viewport" ? new q5(t, e, r) : null;
  }
}, Z5 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "simple", this.isProcessed = !1, this.key = e, this.value = r, this.options = n;
  }
  var t = o.prototype;
  return t.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var n = "", i = 0; i < this.value.length; i++)
        n += this.key + " " + this.value[i] + ";", this.value[i + 1] && (n += `
`);
      return n;
    }
    return this.key + " " + this.value + ";";
  }, o;
}(), Q5 = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, J5 = {
  onCreateRule: function(t, e, r) {
    return t in Q5 ? new Z5(t, e, r) : null;
  }
}, Kx = [L5, V5, j5, $5, K5, X5, J5], e6 = {
  process: !0
}, qx = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Dy = /* @__PURE__ */ function() {
  function o(e) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = e, this.classes = e.classes, this.keyframes = e.keyframes;
  }
  var t = o.prototype;
  return t.add = function(r, n, i) {
    var a = this.options, s = a.parent, l = a.sheet, u = a.jss, c = a.Renderer, d = a.generateId, f = a.scoped, v = Ce({
      classes: this.classes,
      parent: s,
      sheet: l,
      jss: u,
      Renderer: c,
      generateId: d,
      scoped: f,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, i), g = r;
    r in this.raw && (g = r + "-d" + this.counter++), this.raw[g] = n, g in this.classes && (v.selector = "." + fE(this.classes[g]));
    var m = pE(g, n, v);
    if (!m) return null;
    this.register(m);
    var b = v.index === void 0 ? this.index.length : v.index;
    return this.index.splice(b, 0, m), m;
  }, t.replace = function(r, n, i) {
    var a = this.get(r), s = this.index.indexOf(a);
    a && this.remove(a);
    var l = i;
    return s !== -1 && (l = Ce({}, i, {
      index: s
    })), this.add(r, n, l);
  }, t.get = function(r) {
    return this.map[r];
  }, t.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, t.indexOf = function(r) {
    return this.index.indexOf(r);
  }, t.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, t.register = function(r) {
    this.map[r.key] = r, r instanceof Ub ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof $b && this.keyframes && (this.keyframes[r.name] = r.id);
  }, t.unregister = function(r) {
    delete this.map[r.key], r instanceof Ub ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof $b && delete this.keyframes[r.name];
  }, t.update = function() {
    var r, n, i;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], i = arguments.length <= 2 ? void 0 : arguments[2]) : (n = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), n, i);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], n, i);
  }, t.updateOne = function(r, n, i) {
    i === void 0 && (i = e6);
    var a = this.options, s = a.jss.plugins, l = a.sheet;
    if (r.rules instanceof o) {
      r.rules.update(n, i);
      return;
    }
    var u = r.style;
    if (s.onUpdate(n, r, l, i), i.process && u && u !== r.style) {
      s.onProcessStyle(r.style, r, l);
      for (var c in r.style) {
        var d = r.style[c], f = u[c];
        d !== f && r.prop(c, d, qx);
      }
      for (var v in u) {
        var g = r.style[v], m = u[v];
        g == null && g !== m && r.prop(v, null, qx);
      }
    }
  }, t.toString = function(r) {
    for (var n = "", i = this.options.sheet, a = i ? i.options.link : !1, s = pp(r), l = s.linebreak, u = 0; u < this.index.length; u++) {
      var c = this.index[u], d = c.toString(r);
      !d && !a || (n && (n += l), n += d);
    }
    return n;
  }, o;
}(), ND = /* @__PURE__ */ function() {
  function o(e, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = Ce({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new Dy(this.options);
    for (var n in e)
      this.rules.add(n, e[n]);
    this.rules.process();
  }
  var t = o.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(r, n, i) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var s = this.rules.add(r, n, i);
    return s ? (this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && (a ? a.push(s) : (this.insertRule(s), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), s) : (this.deployed = !1, s)) : null;
  }, t.replaceRule = function(r, n, i) {
    var a = this.rules.get(r);
    if (!a) return this.addRule(r, n, i);
    var s = this.rules.replace(r, n, i);
    return s && this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && this.renderer && (s ? a.renderable && this.renderer.replaceRule(a.renderable, s) : this.renderer.deleteRule(a)), s) : (this.deployed = !1, s);
  }, t.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, t.addRules = function(r, n) {
    var i = [];
    for (var a in r) {
      var s = this.addRule(a, r[a], n);
      s && i.push(s);
    }
    return i;
  }, t.getRule = function(r) {
    return this.rules.get(r);
  }, t.deleteRule = function(r) {
    var n = typeof r == "object" ? r : this.rules.get(r);
    return !n || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !n.renderable ? !1 : (this.rules.remove(n), this.attached && n.renderable && this.renderer ? this.renderer.deleteRule(n.renderable) : !0);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, t.updateOne = function(r, n, i) {
    return this.rules.updateOne(r, n, i), this;
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, o;
}(), t6 = /* @__PURE__ */ function() {
  function o() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = o.prototype;
  return t.onCreateRule = function(r, n, i) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var s = this.registry.onCreateRule[a](r, n, i);
      if (s) return s;
    }
    return null;
  }, t.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var n = r.options.sheet, i = 0; i < this.registry.onProcessRule.length; i++)
        this.registry.onProcessRule[i](r, n);
      r.style && this.onProcessStyle(r.style, r, n), r.isProcessed = !0;
    }
  }, t.onProcessStyle = function(r, n, i) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      n.style = this.registry.onProcessStyle[a](n.style, n, i);
  }, t.onProcessSheet = function(r) {
    for (var n = 0; n < this.registry.onProcessSheet.length; n++)
      this.registry.onProcessSheet[n](r);
  }, t.onUpdate = function(r, n, i, a) {
    for (var s = 0; s < this.registry.onUpdate.length; s++)
      this.registry.onUpdate[s](r, n, i, a);
  }, t.onChangeValue = function(r, n, i) {
    for (var a = r, s = 0; s < this.registry.onChangeValue.length; s++)
      a = this.registry.onChangeValue[s](a, n, i);
    return a;
  }, t.use = function(r, n) {
    n === void 0 && (n = {
      queue: "external"
    });
    var i = this.plugins[n.queue];
    i.indexOf(r) === -1 && (i.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, s) {
      for (var l in s)
        l in a ? a[l].push(s[l]) : process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] Unknown hook "' + l + '".');
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, o;
}(), r6 = /* @__PURE__ */ function() {
  function o() {
    this.registry = [];
  }
  var t = o.prototype;
  return t.add = function(r) {
    var n = this.registry, i = r.options.index;
    if (n.indexOf(r) === -1) {
      if (n.length === 0 || i >= this.index) {
        n.push(r);
        return;
      }
      for (var a = 0; a < n.length; a++)
        if (n[a].options.index > i) {
          n.splice(a, 0, r);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(r) {
    var n = this.registry.indexOf(r);
    this.registry.splice(n, 1);
  }, t.toString = function(r) {
    for (var n = r === void 0 ? {} : r, i = n.attached, a = tv(n, ["attached"]), s = pp(a), l = s.linebreak, u = "", c = 0; c < this.registry.length; c++) {
      var d = this.registry[c];
      i != null && d.attached !== i || (u && (u += l), u += d.toString(a));
    }
    return u;
  }, cp(o, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), o;
}(), vh = new r6(), Yb = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Kb = "2f1acc6c3a606b082e5eef5e54414ffb";
Yb[Kb] == null && (Yb[Kb] = 0);
var Xx = Yb[Kb]++, n6 = 1e10, Zx = function(t) {
  t === void 0 && (t = {});
  var e = 0, r = function(i, a) {
    e += 1, e > n6 && process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] You might have a memory leak. Rule counter is at " + e + ".");
    var s = "", l = "";
    return a && (a.options.classNamePrefix && (l = a.options.classNamePrefix), a.options.jss.id != null && (s = String(a.options.jss.id))), t.minify ? "" + (l || "c") + Xx + s + e : l + i.key + "-" + Xx + (s ? "-" + s : "") + "-" + e;
  };
  return r;
}, kD = function(t) {
  var e;
  return function() {
    return e || (e = t()), e;
  };
}, o6 = function(t, e) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(e) : t.style.getPropertyValue(e);
  } catch {
    return "";
  }
}, i6 = function(t, e, r) {
  try {
    var n = r;
    if (Array.isArray(r) && (n = rc(r)), t.attributeStyleMap)
      t.attributeStyleMap.set(e, n);
    else {
      var i = n ? n.indexOf("!important") : -1, a = i > -1 ? n.substr(0, i - 1) : n;
      t.style.setProperty(e, a, i > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, a6 = function(t, e) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(e) : t.style.removeProperty(e);
  } catch (r) {
    process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] DOMException "' + r.message + '" was thrown. Tried to remove property "' + e + '".');
  }
}, s6 = function(t, e) {
  return t.selectorText = e, t.selectorText === e;
}, GD = kD(function() {
  return document.querySelector("head");
});
function l6(o, t) {
  for (var e = 0; e < o.length; e++) {
    var r = o[e];
    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function u6(o, t) {
  for (var e = o.length - 1; e >= 0; e--) {
    var r = o[e];
    if (r.attached && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function c6(o) {
  for (var t = GD(), e = 0; e < t.childNodes.length; e++) {
    var r = t.childNodes[e];
    if (r.nodeType === 8 && r.nodeValue.trim() === o)
      return r;
  }
  return null;
}
function d6(o) {
  var t = vh.registry;
  if (t.length > 0) {
    var e = l6(t, o);
    if (e && e.renderer)
      return {
        parent: e.renderer.element.parentNode,
        node: e.renderer.element
      };
    if (e = u6(t, o), e && e.renderer)
      return {
        parent: e.renderer.element.parentNode,
        node: e.renderer.element.nextSibling
      };
  }
  var r = o.insertionPoint;
  if (r && typeof r == "string") {
    var n = c6(r);
    if (n)
      return {
        parent: n.parentNode,
        node: n.nextSibling
      };
    process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function p6(o, t) {
  var e = t.insertionPoint, r = d6(t);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(o, r.node);
    return;
  }
  if (e && typeof e.nodeType == "number") {
    var n = e, i = n.parentNode;
    i ? i.insertBefore(o, n.nextSibling) : process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  GD().appendChild(o);
}
var f6 = kD(function() {
  var o = document.querySelector('meta[property="csp-nonce"]');
  return o ? o.getAttribute("content") : null;
}), Qx = function(t, e, r) {
  try {
    "insertRule" in t ? t.insertRule(e, r) : "appendRule" in t && t.appendRule(e);
  } catch (n) {
    return process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] " + n.message), !1;
  }
  return t.cssRules[r];
}, Jx = function(t, e) {
  var r = t.cssRules.length;
  return e === void 0 || e > r ? r : e;
}, h6 = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, v6 = /* @__PURE__ */ function() {
  function o(e) {
    this.getPropertyValue = o6, this.setProperty = i6, this.removeProperty = a6, this.setSelector = s6, this.hasInsertedRules = !1, this.cssRules = [], e && vh.add(e), this.sheet = e;
    var r = this.sheet ? this.sheet.options : {}, n = r.media, i = r.meta, a = r.element;
    this.element = a || h6(), this.element.setAttribute("data-jss", ""), n && this.element.setAttribute("media", n), i && this.element.setAttribute("data-meta", i);
    var s = f6();
    s && this.element.setAttribute("nonce", s);
  }
  var t = o.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      p6(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, t.insertRules = function(r, n) {
    for (var i = 0; i < r.index.length; i++)
      this.insertRule(r.index[i], i, n);
  }, t.insertRule = function(r, n, i) {
    if (i === void 0 && (i = this.element.sheet), r.rules) {
      var a = r, s = i;
      if (r.type === "conditional" || r.type === "keyframes") {
        var l = Jx(i, n);
        if (s = Qx(i, a.toString({
          children: !1
        }), l), s === !1)
          return !1;
        this.refCssRule(r, l, s);
      }
      return this.insertRules(a.rules, s), s;
    }
    var u = r.toString();
    if (!u) return !1;
    var c = Jx(i, n), d = Qx(i, u, c);
    return d === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, c, d), d);
  }, t.refCssRule = function(r, n, i) {
    r.renderable = i, r.options.parent instanceof ND && this.cssRules.splice(n, 0, i);
  }, t.deleteRule = function(r) {
    var n = this.element.sheet, i = this.indexOf(r);
    return i === -1 ? !1 : (n.deleteRule(i), this.cssRules.splice(i, 1), !0);
  }, t.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, t.replaceRule = function(r, n) {
    var i = this.indexOf(r);
    return i === -1 ? !1 : (this.element.sheet.deleteRule(i), this.cssRules.splice(i, 1), this.insertRule(n, i));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, o;
}(), g6 = 0, m6 = /* @__PURE__ */ function() {
  function o(e) {
    this.id = g6++, this.version = "10.9.2", this.plugins = new t6(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Zx,
      Renderer: rv ? v6 : null,
      plugins: []
    }, this.generateId = Zx({
      minify: !1
    });
    for (var r = 0; r < Kx.length; r++)
      this.plugins.use(Kx[r], {
        queue: "internal"
      });
    this.setup(e);
  }
  var t = o.prototype;
  return t.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = Ce({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, t.createStyleSheet = function(r, n) {
    n === void 0 && (n = {});
    var i = n, a = i.index;
    typeof a != "number" && (a = vh.index === 0 ? 0 : vh.index + 1);
    var s = new ND(r, Ce({}, n, {
      jss: this,
      generateId: n.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(s), s;
  }, t.removeStyleSheet = function(r) {
    return r.detach(), vh.remove(r), this;
  }, t.createRule = function(r, n, i) {
    if (n === void 0 && (n = {}), i === void 0 && (i = {}), typeof r == "object")
      return this.createRule(void 0, r, n);
    var a = Ce({}, i, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var s = pE(r, n, a);
    return s && this.plugins.onProcessRule(s), s;
  }, t.use = function() {
    for (var r = this, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return i.forEach(function(s) {
      r.plugins.use(s);
    }), this;
  }, o;
}(), hE = function(t) {
  return new m6(t);
}, vE = typeof CSS == "object" && CSS != null && "number" in CSS;
function VD(o) {
  var t = null;
  for (var e in o) {
    var r = o[e], n = typeof r;
    if (n === "function")
      t || (t = {}), t[e] = r;
    else if (n === "object" && r !== null && !Array.isArray(r)) {
      var i = VD(r);
      i && (t || (t = {}), t[e] = i);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
hE();
var HD = Date.now(), G0 = "fnValues" + HD, V0 = "fnStyle" + ++HD, y6 = function() {
  return {
    onCreateRule: function(e, r, n) {
      if (typeof r != "function") return null;
      var i = pE(e, {}, n);
      return i[V0] = r, i;
    },
    onProcessStyle: function(e, r) {
      if (G0 in r || V0 in r) return e;
      var n = {};
      for (var i in e) {
        var a = e[i];
        typeof a == "function" && (delete e[i], n[i] = a);
      }
      return r[G0] = n, e;
    },
    onUpdate: function(e, r, n, i) {
      var a = r, s = a[V0];
      if (s && (a.style = s(e) || {}, process.env.NODE_ENV === "development")) {
        for (var l in a.style)
          if (typeof a.style[l] == "function") {
            process.env.NODE_ENV !== "production" && Fi(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var u = a[G0];
      if (u)
        for (var c in u)
          a.prop(c, u[c](e), i);
    }
  };
}, Ol = "@global", qb = "@global ", C6 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "global", this.at = Ol, this.isProcessed = !1, this.key = e, this.options = n, this.rules = new Dy(Ce({}, n, {
      parent: this
    }));
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var t = o.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.addRule = function(r, n, i) {
    var a = this.rules.add(r, n, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.replaceRule = function(r, n, i) {
    var a = this.rules.replace(r, n, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, o;
}(), w6 = /* @__PURE__ */ function() {
  function o(e, r, n) {
    this.type = "global", this.at = Ol, this.isProcessed = !1, this.key = e, this.options = n;
    var i = e.substr(qb.length);
    this.rule = n.jss.createRule(i, r, Ce({}, n, {
      parent: this
    }));
  }
  var t = o.prototype;
  return t.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, o;
}(), b6 = /\s*,\s*/g;
function BD(o, t) {
  for (var e = o.split(b6), r = "", n = 0; n < e.length; n++)
    r += t + " " + e[n].trim(), e[n + 1] && (r += ", ");
  return r;
}
function S6(o, t) {
  var e = o.options, r = o.style, n = r ? r[Ol] : null;
  if (n) {
    for (var i in n)
      t.addRule(i, n[i], Ce({}, e, {
        selector: BD(i, o.selector)
      }));
    delete r[Ol];
  }
}
function E6(o, t) {
  var e = o.options, r = o.style;
  for (var n in r)
    if (!(n[0] !== "@" || n.substr(0, Ol.length) !== Ol)) {
      var i = BD(n.substr(Ol.length), o.selector);
      t.addRule(i, r[n], Ce({}, e, {
        selector: i
      })), delete r[n];
    }
}
function _6() {
  function o(e, r, n) {
    if (!e) return null;
    if (e === Ol)
      return new C6(e, r, n);
    if (e[0] === "@" && e.substr(0, qb.length) === qb)
      return new w6(e, r, n);
    var i = n.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (n.scoped = !1), !n.selector && n.scoped === !1 && (n.selector = e), null;
  }
  function t(e, r) {
    e.type !== "style" || !r || (S6(e, r), E6(e, r));
  }
  return {
    onCreateRule: o,
    onProcessRule: t
  };
}
var eR = /\s*,\s*/g, x6 = /&/g, R6 = /\$([\w-]+)/g;
function T6() {
  function o(n, i) {
    return function(a, s) {
      var l = n.getRule(s) || i && i.getRule(s);
      return l ? l.selector : (process.env.NODE_ENV !== "production" && Fi(!1, '[JSS] Could not find the referenced rule "' + s + '" in "' + (n.options.meta || n.toString()) + '".'), s);
    };
  }
  function t(n, i) {
    for (var a = i.split(eR), s = n.split(eR), l = "", u = 0; u < a.length; u++)
      for (var c = a[u], d = 0; d < s.length; d++) {
        var f = s[d];
        l && (l += ", "), l += f.indexOf("&") !== -1 ? f.replace(x6, c) : c + " " + f;
      }
    return l;
  }
  function e(n, i, a) {
    if (a) return Ce({}, a, {
      index: a.index + 1
    });
    var s = n.options.nestingLevel;
    s = s === void 0 ? 1 : s + 1;
    var l = Ce({}, n.options, {
      nestingLevel: s,
      index: i.indexOf(n) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete l.name, l;
  }
  function r(n, i, a) {
    if (i.type !== "style") return n;
    var s = i, l = s.options.parent, u, c;
    for (var d in n) {
      var f = d.indexOf("&") !== -1, v = d[0] === "@";
      if (!(!f && !v)) {
        if (u = e(s, l, u), f) {
          var g = t(d, s.selector);
          c || (c = o(l, a)), g = g.replace(R6, c);
          var m = s.key + "-" + d;
          "replaceRule" in l ? l.replaceRule(m, n[d], Ce({}, u, {
            selector: g
          })) : l.addRule(m, n[d], Ce({}, u, {
            selector: g
          }));
        } else v && l.addRule(d, {}, u).addRule(s.key, n[d], {
          selector: s.selector
        });
        delete n[d];
      }
    }
    return n;
  }
  return {
    onProcessStyle: r
  };
}
var O6 = /[A-Z]/g, P6 = /^ms-/, H0 = {};
function D6(o) {
  return "-" + o.toLowerCase();
}
function WD(o) {
  if (H0.hasOwnProperty(o))
    return H0[o];
  var t = o.replace(O6, D6);
  return H0[o] = P6.test(t) ? "-" + t : t;
}
function Om(o) {
  var t = {};
  for (var e in o) {
    var r = e.indexOf("--") === 0 ? e : WD(e);
    t[r] = o[e];
  }
  return o.fallbacks && (Array.isArray(o.fallbacks) ? t.fallbacks = o.fallbacks.map(Om) : t.fallbacks = Om(o.fallbacks)), t;
}
function A6() {
  function o(e) {
    if (Array.isArray(e)) {
      for (var r = 0; r < e.length; r++)
        e[r] = Om(e[r]);
      return e;
    }
    return Om(e);
  }
  function t(e, r, n) {
    if (r.indexOf("--") === 0)
      return e;
    var i = WD(r);
    return r === i ? e : (n.prop(i, e), null);
  }
  return {
    onProcessStyle: o,
    onChangeValue: t
  };
}
var De = vE && CSS ? CSS.px : "px", ag = vE && CSS ? CSS.ms : "ms", xd = vE && CSS ? CSS.percent : "%", M6 = {
  // Animation properties
  "animation-delay": ag,
  "animation-duration": ag,
  // Background properties
  "background-position": De,
  "background-position-x": De,
  "background-position-y": De,
  "background-size": De,
  // Border Properties
  border: De,
  "border-bottom": De,
  "border-bottom-left-radius": De,
  "border-bottom-right-radius": De,
  "border-bottom-width": De,
  "border-left": De,
  "border-left-width": De,
  "border-radius": De,
  "border-right": De,
  "border-right-width": De,
  "border-top": De,
  "border-top-left-radius": De,
  "border-top-right-radius": De,
  "border-top-width": De,
  "border-width": De,
  "border-block": De,
  "border-block-end": De,
  "border-block-end-width": De,
  "border-block-start": De,
  "border-block-start-width": De,
  "border-block-width": De,
  "border-inline": De,
  "border-inline-end": De,
  "border-inline-end-width": De,
  "border-inline-start": De,
  "border-inline-start-width": De,
  "border-inline-width": De,
  "border-start-start-radius": De,
  "border-start-end-radius": De,
  "border-end-start-radius": De,
  "border-end-end-radius": De,
  // Margin properties
  margin: De,
  "margin-bottom": De,
  "margin-left": De,
  "margin-right": De,
  "margin-top": De,
  "margin-block": De,
  "margin-block-end": De,
  "margin-block-start": De,
  "margin-inline": De,
  "margin-inline-end": De,
  "margin-inline-start": De,
  // Padding properties
  padding: De,
  "padding-bottom": De,
  "padding-left": De,
  "padding-right": De,
  "padding-top": De,
  "padding-block": De,
  "padding-block-end": De,
  "padding-block-start": De,
  "padding-inline": De,
  "padding-inline-end": De,
  "padding-inline-start": De,
  // Mask properties
  "mask-position-x": De,
  "mask-position-y": De,
  "mask-size": De,
  // Width and height properties
  height: De,
  width: De,
  "min-height": De,
  "max-height": De,
  "min-width": De,
  "max-width": De,
  // Position properties
  bottom: De,
  left: De,
  top: De,
  right: De,
  inset: De,
  "inset-block": De,
  "inset-block-end": De,
  "inset-block-start": De,
  "inset-inline": De,
  "inset-inline-end": De,
  "inset-inline-start": De,
  // Shadow properties
  "box-shadow": De,
  "text-shadow": De,
  // Column properties
  "column-gap": De,
  "column-rule": De,
  "column-rule-width": De,
  "column-width": De,
  // Font and text properties
  "font-size": De,
  "font-size-delta": De,
  "letter-spacing": De,
  "text-decoration-thickness": De,
  "text-indent": De,
  "text-stroke": De,
  "text-stroke-width": De,
  "word-spacing": De,
  // Motion properties
  motion: De,
  "motion-offset": De,
  // Outline properties
  outline: De,
  "outline-offset": De,
  "outline-width": De,
  // Perspective properties
  perspective: De,
  "perspective-origin-x": xd,
  "perspective-origin-y": xd,
  // Transform properties
  "transform-origin": xd,
  "transform-origin-x": xd,
  "transform-origin-y": xd,
  "transform-origin-z": xd,
  // Transition properties
  "transition-delay": ag,
  "transition-duration": ag,
  // Alignment properties
  "vertical-align": De,
  "flex-basis": De,
  // Some random properties
  "shape-margin": De,
  size: De,
  gap: De,
  // Grid properties
  grid: De,
  "grid-gap": De,
  "row-gap": De,
  "grid-row-gap": De,
  "grid-column-gap": De,
  "grid-template-rows": De,
  "grid-template-columns": De,
  "grid-auto-rows": De,
  "grid-auto-columns": De,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": De,
  "box-shadow-y": De,
  "box-shadow-blur": De,
  "box-shadow-spread": De,
  "font-line-height": De,
  "text-shadow-x": De,
  "text-shadow-y": De,
  "text-shadow-blur": De
};
function jD(o) {
  var t = /(-[a-z])/g, e = function(a) {
    return a[1].toUpperCase();
  }, r = {};
  for (var n in o)
    r[n] = o[n], r[n.replace(t, e)] = o[n];
  return r;
}
var F6 = jD(M6);
function gh(o, t, e) {
  if (t == null) return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      t[r] = gh(o, t[r], e);
  else if (typeof t == "object")
    if (o === "fallbacks")
      for (var n in t)
        t[n] = gh(n, t[n], e);
    else
      for (var i in t)
        t[i] = gh(o + "-" + i, t[i], e);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var a = e[o] || F6[o];
    return a && !(t === 0 && a === De) ? typeof a == "function" ? a(t).toString() : "" + t + a : t.toString();
  }
  return t;
}
function I6(o) {
  o === void 0 && (o = {});
  var t = jD(o);
  function e(n, i) {
    if (i.type !== "style") return n;
    for (var a in n)
      n[a] = gh(a, n[a], t);
    return n;
  }
  function r(n, i) {
    return gh(i, n, t);
  }
  return {
    onProcessStyle: e,
    onChangeValue: r
  };
}
function Xb(o, t) {
  (t == null || t > o.length) && (t = o.length);
  for (var e = 0, r = Array(t); e < t; e++) r[e] = o[e];
  return r;
}
function L6(o) {
  if (Array.isArray(o)) return Xb(o);
}
function N6(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function UD(o, t) {
  if (o) {
    if (typeof o == "string") return Xb(o, t);
    var e = {}.toString.call(o).slice(8, -1);
    return e === "Object" && o.constructor && (e = o.constructor.name), e === "Map" || e === "Set" ? Array.from(o) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? Xb(o, t) : void 0;
  }
}
function k6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gE(o) {
  return L6(o) || N6(o) || UD(o) || k6();
}
var rh = "", Zb = "", $D = "", zD = "", G6 = rv && "ontouchstart" in document.documentElement;
if (rv) {
  var B0 = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, V6 = document.createElement("p"), W0 = V6.style, H6 = "Transform";
  for (var j0 in B0)
    if (j0 + H6 in W0) {
      rh = j0, Zb = B0[j0];
      break;
    }
  rh === "Webkit" && "msHyphens" in W0 && (rh = "ms", Zb = B0.ms, zD = "edge"), rh === "Webkit" && "-apple-trailing-word" in W0 && ($D = "apple");
}
var Rt = {
  js: rh,
  css: Zb,
  vendor: $D,
  browser: zD,
  isTouch: G6
};
function B6(o) {
  return o[1] === "-" || Rt.js === "ms" ? o : "@" + Rt.css + "keyframes" + o.substr(10);
}
var W6 = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : Rt.js === "ms" ? "-webkit-" + t : Rt.css + t;
  }
}, j6 = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : Rt.js === "Webkit" ? Rt.css + "print-" + t : t;
  }
}, U6 = /[-\s]+(.)?/g;
function $6(o, t) {
  return t ? t.toUpperCase() : "";
}
function mE(o) {
  return o.replace(U6, $6);
}
function Il(o) {
  return mE("-" + o);
}
var z6 = {
  noPrefill: ["mask"],
  supportedProperty: function(t, e) {
    if (!/^mask/.test(t)) return !1;
    if (Rt.js === "Webkit") {
      var r = "mask-image";
      if (mE(r) in e)
        return t;
      if (Rt.js + Il(r) in e)
        return Rt.css + t;
    }
    return t;
  }
}, Y6 = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : Rt.vendor === "apple" && !Rt.isTouch ? Rt.css + t : t;
  }
}, K6 = {
  noPrefill: ["transform"],
  supportedProperty: function(t, e, r) {
    return t !== "transform" ? !1 : r.transform ? t : Rt.css + t;
  }
}, q6 = {
  noPrefill: ["transition"],
  supportedProperty: function(t, e, r) {
    return t !== "transition" ? !1 : r.transition ? t : Rt.css + t;
  }
}, X6 = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : Rt.js === "Webkit" || Rt.js === "ms" && Rt.browser !== "edge" ? Rt.css + t : t;
  }
}, Z6 = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : Rt.js === "Moz" || Rt.js === "ms" || Rt.vendor === "apple" ? Rt.css + t : t;
  }
}, Q6 = {
  supportedProperty: function(t, e) {
    if (!/^break-/.test(t)) return !1;
    if (Rt.js === "Webkit") {
      var r = "WebkitColumn" + Il(t);
      return r in e ? Rt.css + "column-" + t : !1;
    }
    if (Rt.js === "Moz") {
      var n = "page" + Il(t);
      return n in e ? "page-" + t : !1;
    }
    return !1;
  }
}, J6 = {
  supportedProperty: function(t, e) {
    if (!/^(border|margin|padding)-inline/.test(t)) return !1;
    if (Rt.js === "Moz") return t;
    var r = t.replace("-inline", "");
    return Rt.js + Il(r) in e ? Rt.css + r : !1;
  }
}, e9 = {
  supportedProperty: function(t, e) {
    return mE(t) in e ? t : !1;
  }
}, t9 = {
  supportedProperty: function(t, e) {
    var r = Il(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : Rt.js + r in e ? Rt.css + t : Rt.js !== "Webkit" && "Webkit" + r in e ? "-webkit-" + t : !1;
  }
}, r9 = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : Rt.js === "ms" ? "" + Rt.css + t : t;
  }
}, n9 = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : Rt.js === "ms" ? Rt.css + "scroll-chaining" : t;
  }
}, o9 = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, i9 = {
  supportedProperty: function(t, e) {
    var r = o9[t];
    return r && Rt.js + Il(r) in e ? Rt.css + r : !1;
  }
}, YD = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, a9 = Object.keys(YD), s9 = function(t) {
  return Rt.css + t;
}, l9 = {
  supportedProperty: function(t, e, r) {
    var n = r.multiple;
    if (a9.indexOf(t) > -1) {
      var i = YD[t];
      if (!Array.isArray(i))
        return Rt.js + Il(i) in e ? Rt.css + i : !1;
      if (!n) return !1;
      for (var a = 0; a < i.length; a++)
        if (!(Rt.js + Il(i[0]) in e))
          return !1;
      return i.map(s9);
    }
    return !1;
  }
}, KD = [W6, j6, z6, Y6, K6, q6, X6, Z6, Q6, J6, e9, t9, r9, n9, i9, l9], tR = KD.filter(function(o) {
  return o.supportedProperty;
}).map(function(o) {
  return o.supportedProperty;
}), u9 = KD.filter(function(o) {
  return o.noPrefill;
}).reduce(function(o, t) {
  return o.push.apply(o, gE(t.noPrefill)), o;
}, []), nh, Yu = {};
if (rv) {
  nh = document.createElement("p");
  var U0 = window.getComputedStyle(document.documentElement, "");
  for (var $0 in U0)
    isNaN($0) || (Yu[U0[$0]] = U0[$0]);
  u9.forEach(function(o) {
    return delete Yu[o];
  });
}
function Qb(o, t) {
  if (t === void 0 && (t = {}), !nh) return o;
  if (process.env.NODE_ENV !== "benchmark" && Yu[o] != null)
    return Yu[o];
  (o === "transition" || o === "transform") && (t[o] = o in nh.style);
  for (var e = 0; e < tR.length && (Yu[o] = tR[e](o, nh.style, t), !Yu[o]); e++)
    ;
  try {
    nh.style[o] = "";
  } catch {
    return !1;
  }
  return Yu[o];
}
var Rd = {}, c9 = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, d9 = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, Cl;
function p9(o, t, e) {
  if (t === "var") return "var";
  if (t === "all") return "all";
  if (e === "all") return ", all";
  var r = t ? Qb(t) : ", " + Qb(e);
  return r || t || e;
}
rv && (Cl = document.createElement("p"));
function rR(o, t) {
  var e = t;
  if (!Cl || o === "content") return t;
  if (typeof e != "string" || !isNaN(parseInt(e, 10)))
    return e;
  var r = o + e;
  if (process.env.NODE_ENV !== "benchmark" && Rd[r] != null)
    return Rd[r];
  try {
    Cl.style[o] = e;
  } catch {
    return Rd[r] = !1, !1;
  }
  if (c9[o])
    e = e.replace(d9, p9);
  else if (Cl.style[o] === "" && (e = Rt.css + e, e === "-ms-flex" && (Cl.style[o] = "-ms-flexbox"), Cl.style[o] = e, Cl.style[o] === ""))
    return Rd[r] = !1, !1;
  return Cl.style[o] = "", Rd[r] = e, Rd[r];
}
function f9() {
  function o(n) {
    if (n.type === "keyframes") {
      var i = n;
      i.at = B6(i.at);
    }
  }
  function t(n) {
    for (var i in n) {
      var a = n[i];
      if (i === "fallbacks" && Array.isArray(a)) {
        n[i] = a.map(t);
        continue;
      }
      var s = !1, l = Qb(i);
      l && l !== i && (s = !0);
      var u = !1, c = rR(l, rc(a));
      c && c !== a && (u = !0), (s || u) && (s && delete n[i], n[l || i] = c || a);
    }
    return n;
  }
  function e(n, i) {
    return i.type !== "style" ? n : t(n);
  }
  function r(n, i) {
    return rR(i, rc(n)) || n;
  }
  return {
    onProcessRule: o,
    onProcessStyle: e,
    onChangeValue: r
  };
}
function h9() {
  var o = function(e, r) {
    return e.length === r.length ? e > r ? 1 : -1 : e.length - r.length;
  };
  return {
    onProcessStyle: function(e, r) {
      if (r.type !== "style") return e;
      for (var n = {}, i = Object.keys(e).sort(o), a = 0; a < i.length; a++)
        n[i[a]] = e[i[a]];
      return n;
    }
  };
}
function qD() {
  return {
    plugins: [
      y6(),
      _6(),
      T6(),
      A6(),
      I6(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : f9(),
      h9()
    ]
  };
}
function yE() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = o.baseClasses, e = o.newClasses, r = o.Component;
  if (!e)
    return t;
  var n = Ce({}, t);
  return process.env.NODE_ENV !== "production" && typeof e == "string" ? (console.error(["Material-UI: The value `".concat(e, "` ") + "provided to the classes prop of ".concat(hh(r), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(e).forEach(function(i) {
    process.env.NODE_ENV !== "production" && (!t[i] && e[i] && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not implemented in ".concat(hh(r), "."), "You can only override one of the following: ".concat(Object.keys(t).join(","), ".")].join(`
`)), e[i] && typeof e[i] != "string" && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not valid for ".concat(hh(r), "."), "You need to provide a non empty string instead of: ".concat(e[i], ".")].join(`
`))), e[i] && (n[i] = "".concat(t[i], " ").concat(e[i]));
  }), n);
}
var Bd = {
  set: function(t, e, r, n) {
    var i = t.get(e);
    i || (i = /* @__PURE__ */ new Map(), t.set(e, i)), i.set(r, n);
  },
  get: function(t, e, r) {
    var n = t.get(e);
    return n ? n.get(r) : void 0;
  },
  delete: function(t, e, r) {
    var n = t.get(e);
    n.delete(r);
  }
}, CE = y.createContext(null);
process.env.NODE_ENV !== "production" && (CE.displayName = "ThemeContext");
function nv() {
  var o = y.useContext(CE);
  return process.env.NODE_ENV !== "production" && y.useDebugValue(o), o;
}
var v9 = hE(qD()), g9 = A5(), m9 = /* @__PURE__ */ new Map(), y9 = {
  disableGeneration: !1,
  generateClassName: g9,
  jss: v9,
  sheetsCache: null,
  sheetsManager: m9,
  sheetsRegistry: null
}, Pm = y.createContext(y9);
process.env.NODE_ENV !== "production" && (Pm.displayName = "StylesContext");
var sg;
function Jb(o) {
  var t = o.children, e = o.injectFirst, r = e === void 0 ? !1 : e, n = o.disableGeneration, i = n === void 0 ? !1 : n, a = Ke(o, ["children", "injectFirst", "disableGeneration"]), s = y.useContext(Pm), l = Ce({}, s, {
    disableGeneration: i
  }, a);
  if (process.env.NODE_ENV !== "production" && typeof window > "u" && !l.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && l.jss.options.insertionPoint && r && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && r && a.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !l.jss.options.insertionPoint && r && typeof window < "u") {
    if (!sg) {
      var u = document.head;
      sg = document.createComment("mui-inject-first"), u.insertBefore(sg, u.firstChild);
    }
    l.jss = hE({
      plugins: qD().plugins,
      insertionPoint: sg
    });
  }
  return /* @__PURE__ */ y.createElement(Pm.Provider, {
    value: l
  }, t);
}
process.env.NODE_ENV !== "production" && (Jb.propTypes = {
  /**
   * Your component tree.
   */
  children: _.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: _.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: _.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: _.bool,
  /**
   * JSS's instance.
   */
  jss: _.object,
  /**
   * @ignore
   */
  serverGenerateClassName: _.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: _.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: _.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Jb.propTypes = Py(Jb.propTypes));
var z0 = -1e9;
function C9() {
  return z0 += 1, process.env.NODE_ENV !== "production" && z0 >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), z0;
}
var XD = {};
function w9(o) {
  var t = typeof o == "function";
  return process.env.NODE_ENV !== "production" && ka(o) !== "object" && !t && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(r, n) {
      var i;
      try {
        i = t ? o(r) : o;
      } catch (l) {
        throw process.env.NODE_ENV !== "production" && t === !0 && r === XD && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), l;
      }
      if (!n || !r.overrides || !r.overrides[n])
        return i;
      var a = r.overrides[n], s = Ce({}, i);
      return Object.keys(a).forEach(function(l) {
        process.env.NODE_ENV !== "production" && (s[l] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(l, "` key of `theme.overrides.").concat(n, "`.")].join(`
`))), s[l] = ep(s[l], a[l]);
      }), s;
    },
    options: {}
  };
}
function b9(o, t, e) {
  var r = o.state, n = o.stylesOptions;
  if (n.disableGeneration)
    return t || {};
  r.cacheClasses || (r.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var i = !1;
  return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, i = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, i = !0), i && (r.cacheClasses.value = yE({
    baseClasses: r.cacheClasses.lastJSS,
    newClasses: t,
    Component: e
  })), r.cacheClasses.value;
}
function S9(o, t) {
  var e = o.state, r = o.theme, n = o.stylesOptions, i = o.stylesCreator, a = o.name;
  if (!n.disableGeneration) {
    var s = Bd.get(n.sheetsManager, i, r);
    s || (s = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, Bd.set(n.sheetsManager, i, r, s));
    var l = Ce({}, i.options, n, {
      theme: r,
      flip: typeof n.flip == "boolean" ? n.flip : r.direction === "rtl"
    });
    l.generateId = l.serverGenerateClassName || l.generateClassName;
    var u = n.sheetsRegistry;
    if (s.refs === 0) {
      var c;
      n.sheetsCache && (c = Bd.get(n.sheetsCache, i, r));
      var d = i.create(r, a);
      c || (c = n.jss.createStyleSheet(d, Ce({
        link: !1
      }, l)), c.attach(), n.sheetsCache && Bd.set(n.sheetsCache, i, r, c)), u && u.add(c), s.staticSheet = c, s.dynamicStyles = VD(d);
    }
    if (s.dynamicStyles) {
      var f = n.jss.createStyleSheet(s.dynamicStyles, Ce({
        link: !0
      }, l));
      f.update(t), f.attach(), e.dynamicSheet = f, e.classes = yE({
        baseClasses: s.staticSheet.classes,
        newClasses: f.classes
      }), u && u.add(f);
    } else
      e.classes = s.staticSheet.classes;
    s.refs += 1;
  }
}
function E9(o, t) {
  var e = o.state;
  e.dynamicSheet && e.dynamicSheet.update(t);
}
function _9(o) {
  var t = o.state, e = o.theme, r = o.stylesOptions, n = o.stylesCreator;
  if (!r.disableGeneration) {
    var i = Bd.get(r.sheetsManager, n, e);
    i.refs -= 1;
    var a = r.sheetsRegistry;
    i.refs === 0 && (Bd.delete(r.sheetsManager, n, e), r.jss.removeStyleSheet(i.staticSheet), a && a.remove(i.staticSheet)), t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet), a && a.remove(t.dynamicSheet));
  }
}
function x9(o, t) {
  var e = y.useRef([]), r, n = y.useMemo(function() {
    return {};
  }, t);
  e.current !== n && (e.current = n, r = o()), y.useEffect(
    function() {
      return function() {
        r && r();
      };
    },
    [n]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function ZD(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = t.name, r = t.classNamePrefix, n = t.Component, i = t.defaultTheme, a = i === void 0 ? XD : i, s = Ke(t, ["name", "classNamePrefix", "Component", "defaultTheme"]), l = w9(o), u = e || r || "makeStyles";
  l.options = {
    index: C9(),
    name: e,
    meta: u,
    classNamePrefix: u
  };
  var c = function() {
    var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = nv() || a, g = Ce({}, y.useContext(Pm), s), m = y.useRef(), b = y.useRef();
    x9(function() {
      var R = {
        name: e,
        state: {},
        stylesCreator: l,
        stylesOptions: g,
        theme: v
      };
      return S9(R, f), b.current = !1, m.current = R, function() {
        _9(R);
      };
    }, [v, l]), y.useEffect(function() {
      b.current && E9(m.current, f), b.current = !0;
    });
    var S = b9(m.current, f.classes, n);
    return process.env.NODE_ENV !== "production" && y.useDebugValue(S), S;
  };
  return c;
}
function Ay(o, t) {
  if (!(o instanceof t)) throw new TypeError("Cannot call a class as a function");
}
var eS = { exports: {} }, ir = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nR;
function R9() {
  if (nR) return ir;
  nR = 1;
  var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
  function P(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case t:
          switch (x = x.type, x) {
            case l:
            case u:
            case r:
            case i:
            case n:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case c:
                case g:
                case v:
                case a:
                  return x;
                default:
                  return M;
              }
          }
        case e:
          return M;
      }
    }
  }
  function D(x) {
    return P(x) === u;
  }
  return ir.AsyncMode = l, ir.ConcurrentMode = u, ir.ContextConsumer = s, ir.ContextProvider = a, ir.Element = t, ir.ForwardRef = c, ir.Fragment = r, ir.Lazy = g, ir.Memo = v, ir.Portal = e, ir.Profiler = i, ir.StrictMode = n, ir.Suspense = d, ir.isAsyncMode = function(x) {
    return D(x) || P(x) === l;
  }, ir.isConcurrentMode = D, ir.isContextConsumer = function(x) {
    return P(x) === s;
  }, ir.isContextProvider = function(x) {
    return P(x) === a;
  }, ir.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ir.isForwardRef = function(x) {
    return P(x) === c;
  }, ir.isFragment = function(x) {
    return P(x) === r;
  }, ir.isLazy = function(x) {
    return P(x) === g;
  }, ir.isMemo = function(x) {
    return P(x) === v;
  }, ir.isPortal = function(x) {
    return P(x) === e;
  }, ir.isProfiler = function(x) {
    return P(x) === i;
  }, ir.isStrictMode = function(x) {
    return P(x) === n;
  }, ir.isSuspense = function(x) {
    return P(x) === d;
  }, ir.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === u || x === i || x === n || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === v || x.$$typeof === a || x.$$typeof === s || x.$$typeof === c || x.$$typeof === b || x.$$typeof === S || x.$$typeof === R || x.$$typeof === m);
  }, ir.typeOf = P, ir;
}
var ar = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oR;
function T9() {
  return oR || (oR = 1, process.env.NODE_ENV !== "production" && function() {
    var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
    function P(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === u || X === i || X === n || X === d || X === f || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === v || X.$$typeof === a || X.$$typeof === s || X.$$typeof === c || X.$$typeof === b || X.$$typeof === S || X.$$typeof === R || X.$$typeof === m);
    }
    function D(X) {
      if (typeof X == "object" && X !== null) {
        var xe = X.$$typeof;
        switch (xe) {
          case t:
            var Le = X.type;
            switch (Le) {
              case l:
              case u:
              case r:
              case i:
              case n:
              case d:
                return Le;
              default:
                var Ue = Le && Le.$$typeof;
                switch (Ue) {
                  case s:
                  case c:
                  case g:
                  case v:
                  case a:
                    return Ue;
                  default:
                    return xe;
                }
            }
          case e:
            return xe;
        }
      }
    }
    var x = l, M = u, F = s, H = a, B = t, j = c, V = r, W = g, q = v, ee = e, re = i, ie = n, ne = d, se = !1;
    function pe(X) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(X) || D(X) === l;
    }
    function K(X) {
      return D(X) === u;
    }
    function J(X) {
      return D(X) === s;
    }
    function ue(X) {
      return D(X) === a;
    }
    function he(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function fe(X) {
      return D(X) === c;
    }
    function ae(X) {
      return D(X) === r;
    }
    function oe(X) {
      return D(X) === g;
    }
    function ve(X) {
      return D(X) === v;
    }
    function _e(X) {
      return D(X) === e;
    }
    function le(X) {
      return D(X) === i;
    }
    function Ee(X) {
      return D(X) === n;
    }
    function de(X) {
      return D(X) === d;
    }
    ar.AsyncMode = x, ar.ConcurrentMode = M, ar.ContextConsumer = F, ar.ContextProvider = H, ar.Element = B, ar.ForwardRef = j, ar.Fragment = V, ar.Lazy = W, ar.Memo = q, ar.Portal = ee, ar.Profiler = re, ar.StrictMode = ie, ar.Suspense = ne, ar.isAsyncMode = pe, ar.isConcurrentMode = K, ar.isContextConsumer = J, ar.isContextProvider = ue, ar.isElement = he, ar.isForwardRef = fe, ar.isFragment = ae, ar.isLazy = oe, ar.isMemo = ve, ar.isPortal = _e, ar.isProfiler = le, ar.isStrictMode = Ee, ar.isSuspense = de, ar.isValidElementType = P, ar.typeOf = D;
  }()), ar;
}
process.env.NODE_ENV === "production" ? eS.exports = R9() : eS.exports = T9();
var O9 = eS.exports, wE = O9, P9 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, D9 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, A9 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, QD = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, bE = {};
bE[wE.ForwardRef] = A9;
bE[wE.Memo] = QD;
function iR(o) {
  return wE.isMemo(o) ? QD : bE[o.$$typeof] || P9;
}
var M9 = Object.defineProperty, F9 = Object.getOwnPropertyNames, aR = Object.getOwnPropertySymbols, I9 = Object.getOwnPropertyDescriptor, L9 = Object.getPrototypeOf, sR = Object.prototype;
function JD(o, t, e) {
  if (typeof t != "string") {
    if (sR) {
      var r = L9(t);
      r && r !== sR && JD(o, r, e);
    }
    var n = F9(t);
    aR && (n = n.concat(aR(t)));
    for (var i = iR(o), a = iR(t), s = 0; s < n.length; ++s) {
      var l = n[s];
      if (!D9[l] && !(e && e[l]) && !(a && a[l]) && !(i && i[l])) {
        var u = I9(t, l);
        try {
          M9(o, l, u);
        } catch {
        }
      }
    }
  }
  return o;
}
var N9 = JD;
const k9 = /* @__PURE__ */ uD(N9);
function G9(o, t) {
  if (typeof t == "function") {
    var e = t(o);
    return process.env.NODE_ENV !== "production" && (e || console.error(["Material-UI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), e;
  }
  return Ce({}, o, t);
}
function Fh(o) {
  var t = o.children, e = o.theme, r = nv();
  process.env.NODE_ENV !== "production" && r === null && typeof e == "function" && console.error(["Material-UI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  var n = y.useMemo(function() {
    var i = r === null ? e : G9(r, e);
    return i != null && (i[FD] = r !== null), i;
  }, [e, r]);
  return /* @__PURE__ */ y.createElement(CE.Provider, {
    value: n
  }, t);
}
process.env.NODE_ENV !== "production" && (Fh.propTypes = {
  /**
   * Your component tree.
   */
  children: _.node.isRequired,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: _.oneOfType([_.object, _.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Fh.propTypes = Py(Fh.propTypes));
var V9 = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(r) {
    var n = e.defaultTheme, i = e.withTheme, a = i === void 0 ? !1 : i, s = e.name, l = Ke(e, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var u = s;
    if (process.env.NODE_ENV !== "production" && !s) {
      var c = hh(r);
      c !== void 0 && (u = c);
    }
    var d = ZD(t, Ce({
      defaultTheme: n,
      Component: r,
      name: s || r.displayName,
      classNamePrefix: u
    }, l)), f = /* @__PURE__ */ y.forwardRef(function(g, m) {
      g.classes;
      var b = g.innerRef, S = Ke(g, ["classes", "innerRef"]), R = d(Ce({}, r.defaultProps, g)), P, D = S;
      return (typeof s == "string" || a) && (P = nv() || n, s && (D = ID({
        theme: P,
        name: s,
        props: S
      })), a && !D.theme && (D.theme = P)), /* @__PURE__ */ y.createElement(r, Ce({
        ref: b || m,
        classes: R
      }, D));
    });
    return process.env.NODE_ENV !== "production" && (f.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: Ga(_.oneOfType([_.func, _.object]), function(v) {
        return v.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (f.displayName = "WithStyles(".concat(hh(r), ")")), k9(f, r), process.env.NODE_ENV !== "production" && (f.Naked = r, f.options = e, f.useStyles = d), f;
  };
}, ol = ["xs", "sm", "md", "lg", "xl"];
function H9(o) {
  var t = o.values, e = t === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : t, r = o.unit, n = r === void 0 ? "px" : r, i = o.step, a = i === void 0 ? 5 : i, s = Ke(o, ["values", "unit", "step"]);
  function l(g) {
    var m = typeof e[g] == "number" ? e[g] : g;
    return "@media (min-width:".concat(m).concat(n, ")");
  }
  function u(g) {
    var m = ol.indexOf(g) + 1, b = e[ol[m]];
    if (m === ol.length)
      return l("xs");
    var S = typeof b == "number" && m > 0 ? b : g;
    return "@media (max-width:".concat(S - a / 100).concat(n, ")");
  }
  function c(g, m) {
    var b = ol.indexOf(m);
    return b === ol.length - 1 ? l(g) : "@media (min-width:".concat(typeof e[g] == "number" ? e[g] : g).concat(n, ") and ") + "(max-width:".concat((b !== -1 && typeof e[ol[b + 1]] == "number" ? e[ol[b + 1]] : m) - a / 100).concat(n, ")");
  }
  function d(g) {
    return c(g, g);
  }
  var f = !1;
  function v(g) {
    return process.env.NODE_ENV !== "production" && (f || (f = !0, console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join(`
`)))), e[g];
  }
  return Ce({
    keys: ol,
    values: e,
    up: l,
    down: u,
    between: c,
    only: d,
    width: v
  }, s);
}
function B9(o, t, e) {
  var r;
  return Ce({
    gutters: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), Ce({
        paddingLeft: t(2),
        paddingRight: t(2)
      }, i, Cn({}, o.up("sm"), Ce({
        paddingLeft: t(3),
        paddingRight: t(3)
      }, i[o.up("sm")])));
    },
    toolbar: (r = {
      minHeight: 56
    }, Cn(r, "".concat(o.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), Cn(r, o.up("sm"), {
      minHeight: 64
    }), r)
  }, e);
}
var Dm = {
  black: "#000",
  white: "#fff"
}, SE = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
}, Y0 = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, K0 = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, q0 = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, X0 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Z0 = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Q0 = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function EE(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (o < t || o > e) && console.error("Material-UI: The value provided ".concat(o, " is out of range [").concat(t, ", ").concat(e, "].")), Math.min(Math.max(t, o), e);
}
function W9(o) {
  o = o.substr(1);
  var t = new RegExp(".{1,".concat(o.length >= 6 ? 2 : 1, "}"), "g"), e = o.match(t);
  return e && e[0].length === 1 && (e = e.map(function(r) {
    return r + r;
  })), e ? "rgb".concat(e.length === 4 ? "a" : "", "(").concat(e.map(function(r, n) {
    return n < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function j9(o) {
  o = dc(o);
  var t = o, e = t.values, r = e[0], n = e[1] / 100, i = e[2] / 100, a = n * Math.min(i, 1 - i), s = function(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (d + r / 30) % 12;
    return i - a * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  }, l = "rgb", u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return o.type === "hsla" && (l += "a", u.push(e[3])), My({
    type: l,
    values: u
  });
}
function dc(o) {
  if (o.type)
    return o;
  if (o.charAt(0) === "#")
    return dc(W9(o));
  var t = o.indexOf("("), e = o.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(e) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(o, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : tp(3, o));
  var r = o.substring(t + 1, o.length - 1).split(",");
  return r = r.map(function(n) {
    return parseFloat(n);
  }), {
    type: e,
    values: r
  };
}
function My(o) {
  var t = o.type, e = o.values;
  return t.indexOf("rgb") !== -1 ? e = e.map(function(r, n) {
    return n < 3 ? parseInt(r, 10) : r;
  }) : t.indexOf("hsl") !== -1 && (e[1] = "".concat(e[1], "%"), e[2] = "".concat(e[2], "%")), "".concat(t, "(").concat(e.join(", "), ")");
}
function lR(o, t) {
  var e = uR(o), r = uR(t);
  return (Math.max(e, r) + 0.05) / (Math.min(e, r) + 0.05);
}
function uR(o) {
  o = dc(o);
  var t = o.type === "hsl" ? dc(j9(o)).values : o.values;
  return t = t.map(function(e) {
    return e /= 255, e <= 0.03928 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
var cR = !1;
function U9(o, t) {
  return process.env.NODE_ENV !== "production" && (cR || (cR = !0, console.error(["Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.", "", "You should use `import { alpha } from '@material-ui/core/styles'`"].join(`
`)))), Ki(o, t);
}
function Ki(o, t) {
  return o = dc(o), t = EE(t), (o.type === "rgb" || o.type === "hsl") && (o.type += "a"), o.values[3] = t, My(o);
}
function $9(o, t) {
  if (o = dc(o), t = EE(t), o.type.indexOf("hsl") !== -1)
    o.values[2] *= 1 - t;
  else if (o.type.indexOf("rgb") !== -1)
    for (var e = 0; e < 3; e += 1)
      o.values[e] *= 1 - t;
  return My(o);
}
function z9(o, t) {
  if (o = dc(o), t = EE(t), o.type.indexOf("hsl") !== -1)
    o.values[2] += (100 - o.values[2]) * t;
  else if (o.type.indexOf("rgb") !== -1)
    for (var e = 0; e < 3; e += 1)
      o.values[e] += (255 - o.values[e]) * t;
  return My(o);
}
var dR = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Dm.white,
    default: SE[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, J0 = {
  text: {
    primary: Dm.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: SE[800],
    default: "#303030"
  },
  action: {
    active: Dm.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function pR(o, t, e, r) {
  var n = r.light || r, i = r.dark || r * 1.5;
  o[t] || (o.hasOwnProperty(e) ? o[t] = o[e] : t === "light" ? o.light = z9(o.main, n) : t === "dark" && (o.dark = $9(o.main, i)));
}
function Y9(o) {
  var t = o.primary, e = t === void 0 ? {
    light: Y0[300],
    main: Y0[500],
    dark: Y0[700]
  } : t, r = o.secondary, n = r === void 0 ? {
    light: K0.A200,
    main: K0.A400,
    dark: K0.A700
  } : r, i = o.error, a = i === void 0 ? {
    light: q0[300],
    main: q0[500],
    dark: q0[700]
  } : i, s = o.warning, l = s === void 0 ? {
    light: X0[300],
    main: X0[500],
    dark: X0[700]
  } : s, u = o.info, c = u === void 0 ? {
    light: Z0[300],
    main: Z0[500],
    dark: Z0[700]
  } : u, d = o.success, f = d === void 0 ? {
    light: Q0[300],
    main: Q0[500],
    dark: Q0[700]
  } : d, v = o.type, g = v === void 0 ? "light" : v, m = o.contrastThreshold, b = m === void 0 ? 3 : m, S = o.tonalOffset, R = S === void 0 ? 0.2 : S, P = Ke(o, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function D(H) {
    var B = lR(H, J0.text.primary) >= b ? J0.text.primary : dR.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var j = lR(H, B);
      j < 3 && console.error(["Material-UI: The contrast ratio of ".concat(j, ":1 for ").concat(B, " on ").concat(H), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return B;
  }
  var x = function(B) {
    var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, V = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, W = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (B = Ce({}, B), !B.main && B[j] && (B.main = B[j]), !B.main)
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(j, "` property.") : tp(4, j));
    if (typeof B.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(B.main), `\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@material-ui/core/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`) : tp(5, JSON.stringify(B.main)));
    return pR(B, "light", V, R), pR(B, "dark", W, R), B.contrastText || (B.contrastText = D(B.main)), B;
  }, M = {
    dark: J0,
    light: dR
  };
  process.env.NODE_ENV !== "production" && (M[g] || console.error("Material-UI: The palette type `".concat(g, "` is not supported.")));
  var F = ep(Ce({
    // A collection of common colors.
    common: Dm,
    // The palette type, can be light or dark.
    type: g,
    // The colors used to represent primary interface elements for a user.
    primary: x(e),
    // The colors used to represent secondary interface elements for a user.
    secondary: x(n, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: x(a),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: x(l),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: x(c),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: x(f),
    // The grey colors.
    grey: SE,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: b,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: D,
    // Generate a rich color object.
    augmentColor: x,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: R
  }, M[g]), P);
  return F;
}
function eA(o) {
  return Math.round(o * 1e5) / 1e5;
}
var fR = !1;
function K9(o) {
  return process.env.NODE_ENV !== "production" && (fR || (console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://mui.com/r/migration-v4/#theme for a migration path."].join(`
`)), fR = !0)), eA(o);
}
var hR = {
  textTransform: "uppercase"
}, vR = '"Roboto", "Helvetica", "Arial", sans-serif';
function q9(o, t) {
  var e = typeof t == "function" ? t(o) : t, r = e.fontFamily, n = r === void 0 ? vR : r, i = e.fontSize, a = i === void 0 ? 14 : i, s = e.fontWeightLight, l = s === void 0 ? 300 : s, u = e.fontWeightRegular, c = u === void 0 ? 400 : u, d = e.fontWeightMedium, f = d === void 0 ? 500 : d, v = e.fontWeightBold, g = v === void 0 ? 700 : v, m = e.htmlFontSize, b = m === void 0 ? 16 : m, S = e.allVariants, R = e.pxToRem, P = Ke(e, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof a != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof b != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var D = a / 14, x = R || function(H) {
    return "".concat(H / b * D, "rem");
  }, M = function(B, j, V, W, q) {
    return Ce({
      fontFamily: n,
      fontWeight: B,
      fontSize: x(j),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: V
    }, n === vR ? {
      letterSpacing: "".concat(eA(W / j), "em")
    } : {}, q, S);
  }, F = {
    h1: M(l, 96, 1.167, -1.5),
    h2: M(l, 60, 1.2, -0.5),
    h3: M(c, 48, 1.167, 0),
    h4: M(c, 34, 1.235, 0.25),
    h5: M(c, 24, 1.334, 0),
    h6: M(f, 20, 1.6, 0.15),
    subtitle1: M(c, 16, 1.75, 0.15),
    subtitle2: M(f, 14, 1.57, 0.1),
    body1: M(c, 16, 1.5, 0.15),
    body2: M(c, 14, 1.43, 0.15),
    button: M(f, 14, 1.75, 0.4, hR),
    caption: M(c, 12, 1.66, 0.4),
    overline: M(c, 12, 2.66, 1, hR)
  };
  return ep(Ce({
    htmlFontSize: b,
    pxToRem: x,
    round: K9,
    // TODO v5: remove
    fontFamily: n,
    fontSize: a,
    fontWeightLight: l,
    fontWeightRegular: c,
    fontWeightMedium: f,
    fontWeightBold: g
  }, F), P, {
    clone: !1
    // No need to clone deep
  });
}
var X9 = 0.2, Z9 = 0.14, Q9 = 0.12;
function Br() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(X9, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(Z9, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(Q9, ")")].join(",");
}
var J9 = ["none", Br(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Br(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Br(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Br(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Br(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Br(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Br(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Br(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Br(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Br(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Br(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Br(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Br(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Br(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Br(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Br(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Br(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Br(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Br(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Br(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Br(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Br(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Br(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Br(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], eG = {
  borderRadius: 4
}, tG = process.env.NODE_ENV !== "production" ? _.oneOfType([_.number, _.string, _.object, _.array]) : {};
function rG(o) {
  if (Array.isArray(o)) return o;
}
function nG(o, t) {
  var e = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (e != null) {
    var r, n, i, a, s = [], l = !0, u = !1;
    try {
      if (i = (e = e.call(o)).next, t !== 0) for (; !(l = (r = i.call(e)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, n = c;
    } finally {
      try {
        if (!l && e.return != null && (a = e.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw n;
      }
    }
    return s;
  }
}
function oG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bl(o, t) {
  return rG(o) || nG(o, t) || UD(o, t) || oG();
}
var iG = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function aG(o) {
  var t = o.spacing || 8;
  return typeof t == "number" ? function(e) {
    return process.env.NODE_ENV !== "production" && typeof e != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(e, ".")), t * e;
  } : Array.isArray(t) ? function(e) {
    return process.env.NODE_ENV !== "production" && e > t.length - 1 && console.error(["Material-UI: The value provided (".concat(e, ") overflows."), "The supported values are: ".concat(JSON.stringify(t), "."), "".concat(e, " > ").concat(t.length - 1, ", you need to add the missing values.")].join(`
`)), t[e];
  } : typeof t == "function" ? t : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(t, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
process.env.NODE_ENV !== "production" && iG.reduce(function(o, t) {
  return o[t] = tG, o;
}, {});
var gR;
function sG() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (o.mui)
    return o;
  var t = aG({
    spacing: o
  }), e = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(i.length))), i.length === 0 ? t(1) : i.length === 1 ? t(i[0]) : i.map(function(s) {
      if (typeof s == "string")
        return s;
      var l = t(s);
      return typeof l == "number" ? "".concat(l, "px") : l;
    }).join(" ");
  };
  return Object.defineProperty(e, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!gR || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), gR = !0), o;
    }
  }), e.mui = !0, e;
}
var mR = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, rp = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function yR(o) {
  return "".concat(Math.round(o), "ms");
}
const lG = {
  easing: mR,
  duration: rp,
  create: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.duration, n = r === void 0 ? rp.standard : r, i = e.easing, a = i === void 0 ? mR.easeInOut : i, s = e.delay, l = s === void 0 ? 0 : s, u = Ke(e, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var c = function(v) {
        return typeof v == "string";
      }, d = function(v) {
        return !isNaN(parseFloat(v));
      };
      !c(t) && !Array.isArray(t) && console.error('Material-UI: Argument "props" must be a string or Array.'), !d(n) && !c(n) && console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(n, ".")), c(a) || console.error('Material-UI: Argument "easing" must be a string.'), !d(l) && !c(l) && console.error('Material-UI: Argument "delay" must be a number or a string.'), Object.keys(u).length !== 0 && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(u).join(","), "]."));
    }
    return (Array.isArray(t) ? t : [t]).map(function(f) {
      return "".concat(f, " ").concat(typeof n == "string" ? n : yR(n), " ").concat(a, " ").concat(typeof l == "string" ? l : yR(l));
    }).join(",");
  },
  getAutoHeightDuration: function(t) {
    if (!t)
      return 0;
    var e = t / 36;
    return Math.round((4 + 15 * Math.pow(e, 0.25) + e / 5) * 10);
  }
};
var tA = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function rA() {
  for (var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = o.breakpoints, e = t === void 0 ? {} : t, r = o.mixins, n = r === void 0 ? {} : r, i = o.palette, a = i === void 0 ? {} : i, s = o.spacing, l = o.typography, u = l === void 0 ? {} : l, c = Ke(o, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = Y9(a), f = H9(e), v = sG(s), g = ep({
    breakpoints: f,
    direction: "ltr",
    mixins: B9(f, v, n),
    overrides: {},
    // Inject custom styles
    palette: d,
    props: {},
    // Provide default props
    shadows: J9,
    typography: q9(d, u),
    spacing: v,
    shape: eG,
    transitions: lG,
    zIndex: tA
  }, c), m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), S = 1; S < m; S++)
    b[S - 1] = arguments[S];
  if (g = b.reduce(function(D, x) {
    return ep(D, x);
  }, g), process.env.NODE_ENV !== "production") {
    var R = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], P = function D(x, M) {
      var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, H;
      for (H in x) {
        var B = x[H];
        F === 1 ? H.indexOf("Mui") === 0 && B && D(B, H, F + 1) : R.indexOf(H) !== -1 && Object.keys(B).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `".concat(M, "` component increases ") + "the CSS specificity of the `".concat(H, "` internal state."), "You can not override it like this: ", JSON.stringify(x, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: Cn({}, "&$".concat(H), B)
        }, null, 2), "", "https://mui.com/r/pseudo-classes-guide"].join(`
`)), x[H] = {});
      }
    };
    P(g.overrides);
  }
  return g;
}
var _E = rA();
function qt(o, t) {
  return V9(o, Ce({
    defaultTheme: _E
  }, t));
}
function Xr(o) {
  if (typeof o != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : tp(7));
  return o.charAt(0).toUpperCase() + o.slice(1);
}
var uG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },
    /* Styles applied to the root element if `variant="body2"`. */
    body2: t.typography.body2,
    /* Styles applied to the root element if `variant="body1"`. */
    body1: t.typography.body1,
    /* Styles applied to the root element if `variant="caption"`. */
    caption: t.typography.caption,
    /* Styles applied to the root element if `variant="button"`. */
    button: t.typography.button,
    /* Styles applied to the root element if `variant="h1"`. */
    h1: t.typography.h1,
    /* Styles applied to the root element if `variant="h2"`. */
    h2: t.typography.h2,
    /* Styles applied to the root element if `variant="h3"`. */
    h3: t.typography.h3,
    /* Styles applied to the root element if `variant="h4"`. */
    h4: t.typography.h4,
    /* Styles applied to the root element if `variant="h5"`. */
    h5: t.typography.h5,
    /* Styles applied to the root element if `variant="h6"`. */
    h6: t.typography.h6,
    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: t.typography.subtitle1,
    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: t.typography.subtitle2,
    /* Styles applied to the root element if `variant="overline"`. */
    overline: t.typography.overline,
    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: "absolute",
      height: 1,
      width: 1,
      overflow: "hidden"
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: "0.35em"
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: t.palette.text.primary
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: t.palette.text.secondary
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: t.palette.error.main
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: "inline"
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: "block"
    }
  };
}, CR = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p"
}, nA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.align, n = r === void 0 ? "inherit" : r, i = t.classes, a = t.className, s = t.color, l = s === void 0 ? "initial" : s, u = t.component, c = t.display, d = c === void 0 ? "initial" : c, f = t.gutterBottom, v = f === void 0 ? !1 : f, g = t.noWrap, m = g === void 0 ? !1 : g, b = t.paragraph, S = b === void 0 ? !1 : b, R = t.variant, P = R === void 0 ? "body1" : R, D = t.variantMapping, x = D === void 0 ? CR : D, M = Ke(t, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]), F = u || (S ? "p" : x[P] || CR[P]) || "span";
  return /* @__PURE__ */ z.createElement(F, Ce({
    className: Xe(i.root, a, P !== "inherit" && i[P], l !== "initial" && i["color".concat(Xr(l))], m && i.noWrap, v && i.gutterBottom, S && i.paragraph, n !== "inherit" && i["align".concat(Xr(n))], d !== "initial" && i["display".concat(Xr(d))]),
    ref: e
  }, M));
});
process.env.NODE_ENV !== "production" && (nA.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: _.oneOf(["inherit", "left", "center", "right", "justify"]),
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["initial", "inherit", "primary", "secondary", "textPrimary", "textSecondary", "error"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: _.elementType,
  /**
   * Controls the display type
   */
  display: _.oneOf(["initial", "block", "inline"]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: _.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _.bool,
  /**
   * Applies the theme typography styles.
   */
  variant: _.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline", "srOnly", "inherit"]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: _.object
});
const Ll = qt(uG, {
  name: "MuiTypography"
})(nA);
function Fy(o) {
  return o;
}
function li(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return ZD(o, Ce({
    defaultTheme: _E
  }, t));
}
function ov() {
  var o = nv() || _E;
  return process.env.NODE_ENV !== "production" && y.useDebugValue(o), o;
}
function Ih(o, t) {
  typeof o == "function" ? o(t) : o && (o.current = t);
}
function Jn(o, t) {
  return z.useMemo(function() {
    return o == null && t == null ? null : function(e) {
      Ih(o, e), Ih(t, e);
    };
  }, [o, t]);
}
var cG = typeof window < "u" ? z.useLayoutEffect : z.useEffect;
function Xu(o) {
  var t = z.useRef(o);
  return cG(function() {
    t.current = o;
  }), z.useCallback(function() {
    return t.current.apply(void 0, arguments);
  }, []);
}
function Zt(o, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function(e, r, n, i, a) {
    var s = n || "<<anonymous>>", l = a || r;
    return typeof e[r] < "u" ? new Error("The ".concat(i, " `").concat(l, "` of ") + "`".concat(s, "` is deprecated. ").concat(t)) : null;
  };
}
var Iy = !0, tS = !1, wR = null, dG = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function pG(o) {
  var t = o.type, e = o.tagName;
  return !!(e === "INPUT" && dG[t] && !o.readOnly || e === "TEXTAREA" && !o.readOnly || o.isContentEditable);
}
function fG(o) {
  o.metaKey || o.altKey || o.ctrlKey || (Iy = !0);
}
function ew() {
  Iy = !1;
}
function hG() {
  this.visibilityState === "hidden" && tS && (Iy = !0);
}
function vG(o) {
  o.addEventListener("keydown", fG, !0), o.addEventListener("mousedown", ew, !0), o.addEventListener("pointerdown", ew, !0), o.addEventListener("touchstart", ew, !0), o.addEventListener("visibilitychange", hG, !0);
}
function bR(o) {
  var t = o.target;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Iy || pG(t);
}
function gG() {
  tS = !0, window.clearTimeout(wR), wR = window.setTimeout(function() {
    tS = !1;
  }, 100);
}
function mG() {
  var o = z.useCallback(function(t) {
    var e = _s.findDOMNode(t);
    e != null && vG(e.ownerDocument);
  }, []);
  return process.env.NODE_ENV !== "production" && z.useDebugValue(bR), {
    isFocusVisible: bR,
    onBlurVisible: gG,
    ref: o
  };
}
function yG(o, t) {
  return o.classList ? !!t && o.classList.contains(t) : (" " + (o.className.baseVal || o.className) + " ").indexOf(" " + t + " ") !== -1;
}
function CG(o, t) {
  o.classList ? o.classList.add(t) : yG(o, t) || (typeof o.className == "string" ? o.className = o.className + " " + t : o.setAttribute("class", (o.className && o.className.baseVal || "") + " " + t));
}
function SR(o, t) {
  return o.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function wG(o, t) {
  o.classList ? o.classList.remove(t) : typeof o.className == "string" ? o.className = SR(o.className, t) : o.setAttribute("class", SR(o.className && o.className.baseVal || "", t));
}
const ER = {
  disabled: !1
};
var bG = process.env.NODE_ENV !== "production" ? _.oneOfType([_.number, _.shape({
  enter: _.number,
  exit: _.number,
  appear: _.number
}).isRequired]) : null, SG = process.env.NODE_ENV !== "production" ? _.oneOfType([_.string, _.shape({
  enter: _.string,
  exit: _.string,
  active: _.string
}), _.shape({
  enter: _.string,
  enterDone: _.string,
  enterActive: _.string,
  exit: _.string,
  exitDone: _.string,
  exitActive: _.string
})]) : null;
const Am = y.createContext(null);
var oA = function(t) {
  return t.scrollTop;
}, oh = "unmounted", ju = "exited", Uu = "entering", Vd = "entered", rS = "exiting", Ii = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t(r, n) {
    var i;
    i = o.call(this, r, n) || this;
    var a = n, s = a && !a.isMounting ? r.enter : r.appear, l;
    return i.appearStatus = null, r.in ? s ? (l = ju, i.appearStatus = Uu) : l = Vd : r.unmountOnExit || r.mountOnEnter ? l = oh : l = ju, i.state = {
      status: l
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(n, i) {
    var a = n.in;
    return a && i.status === oh ? {
      status: ju
    } : null;
  };
  var e = t.prototype;
  return e.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, e.componentDidUpdate = function(n) {
    var i = null;
    if (n !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== Uu && a !== Vd && (i = Uu) : (a === Uu || a === Vd) && (i = rS);
    }
    this.updateStatus(!1, i);
  }, e.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, e.getTimeouts = function() {
    var n = this.props.timeout, i, a, s;
    return i = a = s = n, n != null && typeof n != "number" && (i = n.exit, a = n.enter, s = n.appear !== void 0 ? n.appear : a), {
      exit: i,
      enter: a,
      appear: s
    };
  }, e.updateStatus = function(n, i) {
    if (n === void 0 && (n = !1), i !== null)
      if (this.cancelNextCallback(), i === Uu) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : qu.findDOMNode(this);
          a && oA(a);
        }
        this.performEnter(n);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ju && this.setState({
      status: oh
    });
  }, e.performEnter = function(n) {
    var i = this, a = this.props.enter, s = this.context ? this.context.isMounting : n, l = this.props.nodeRef ? [s] : [qu.findDOMNode(this), s], u = l[0], c = l[1], d = this.getTimeouts(), f = s ? d.appear : d.enter;
    if (!n && !a || ER.disabled) {
      this.safeSetState({
        status: Vd
      }, function() {
        i.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, c), this.safeSetState({
      status: Uu
    }, function() {
      i.props.onEntering(u, c), i.onTransitionEnd(f, function() {
        i.safeSetState({
          status: Vd
        }, function() {
          i.props.onEntered(u, c);
        });
      });
    });
  }, e.performExit = function() {
    var n = this, i = this.props.exit, a = this.getTimeouts(), s = this.props.nodeRef ? void 0 : qu.findDOMNode(this);
    if (!i || ER.disabled) {
      this.safeSetState({
        status: ju
      }, function() {
        n.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: rS
    }, function() {
      n.props.onExiting(s), n.onTransitionEnd(a.exit, function() {
        n.safeSetState({
          status: ju
        }, function() {
          n.props.onExited(s);
        });
      });
    });
  }, e.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, e.safeSetState = function(n, i) {
    i = this.setNextCallback(i), this.setState(n, i);
  }, e.setNextCallback = function(n) {
    var i = this, a = !0;
    return this.nextCallback = function(s) {
      a && (a = !1, i.nextCallback = null, n(s));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, e.onTransitionEnd = function(n, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : qu.findDOMNode(this), s = n == null && !this.props.addEndListener;
    if (!a || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], u = l[0], c = l[1];
      this.props.addEndListener(u, c);
    }
    n != null && setTimeout(this.nextCallback, n);
  }, e.render = function() {
    var n = this.state.status;
    if (n === oh)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var s = tv(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ y.createElement(Am.Provider, {
        value: null
      }, typeof a == "function" ? a(n, s) : y.cloneElement(y.Children.only(a), s))
    );
  }, t;
}(y.Component);
Ii.contextType = Am;
Ii.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: _.shape({
    current: typeof Element > "u" ? _.any : function(o, t, e, r, n, i) {
      var a = o[t];
      return _.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(o, t, e, r, n, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: _.oneOfType([_.func.isRequired, _.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: _.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: _.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: _.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: _.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: _.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: _.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var e = bG;
    t.addEndListener || (e = e.isRequired);
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      n[i - 1] = arguments[i];
    return e.apply(void 0, [t].concat(n));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: _.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: _.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: _.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: _.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: _.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: _.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: _.func
} : {};
function Td() {
}
Ii.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Td,
  onEntering: Td,
  onEntered: Td,
  onExit: Td,
  onExiting: Td,
  onExited: Td
};
Ii.UNMOUNTED = oh;
Ii.EXITED = ju;
Ii.ENTERING = Uu;
Ii.ENTERED = Vd;
Ii.EXITING = rS;
var EG = function(t, e) {
  return t && e && e.split(" ").forEach(function(r) {
    return CG(t, r);
  });
}, tw = function(t, e) {
  return t && e && e.split(" ").forEach(function(r) {
    return wG(t, r);
  });
}, xE = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t() {
    for (var r, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = o.call.apply(o, [this].concat(i)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(s, l) {
      var u = r.resolveArguments(s, l), c = u[0], d = u[1];
      r.removeClasses(c, "exit"), r.addClass(c, d ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(s, l);
    }, r.onEntering = function(s, l) {
      var u = r.resolveArguments(s, l), c = u[0], d = u[1], f = d ? "appear" : "enter";
      r.addClass(c, f, "active"), r.props.onEntering && r.props.onEntering(s, l);
    }, r.onEntered = function(s, l) {
      var u = r.resolveArguments(s, l), c = u[0], d = u[1], f = d ? "appear" : "enter";
      r.removeClasses(c, f), r.addClass(c, f, "done"), r.props.onEntered && r.props.onEntered(s, l);
    }, r.onExit = function(s) {
      var l = r.resolveArguments(s), u = l[0];
      r.removeClasses(u, "appear"), r.removeClasses(u, "enter"), r.addClass(u, "exit", "base"), r.props.onExit && r.props.onExit(s);
    }, r.onExiting = function(s) {
      var l = r.resolveArguments(s), u = l[0];
      r.addClass(u, "exit", "active"), r.props.onExiting && r.props.onExiting(s);
    }, r.onExited = function(s) {
      var l = r.resolveArguments(s), u = l[0];
      r.removeClasses(u, "exit"), r.addClass(u, "exit", "done"), r.props.onExited && r.props.onExited(s);
    }, r.resolveArguments = function(s, l) {
      return r.props.nodeRef ? [r.props.nodeRef.current, s] : [s, l];
    }, r.getClassNames = function(s) {
      var l = r.props.classNames, u = typeof l == "string", c = u && l ? l + "-" : "", d = u ? "" + c + s : l[s], f = u ? d + "-active" : l[s + "Active"], v = u ? d + "-done" : l[s + "Done"];
      return {
        baseClassName: d,
        activeClassName: f,
        doneClassName: v
      };
    }, r;
  }
  var e = t.prototype;
  return e.addClass = function(n, i, a) {
    var s = this.getClassNames(i)[a + "ClassName"], l = this.getClassNames("enter"), u = l.doneClassName;
    i === "appear" && a === "done" && u && (s += " " + u), a === "active" && n && oA(n), s && (this.appliedClasses[i][a] = s, EG(n, s));
  }, e.removeClasses = function(n, i) {
    var a = this.appliedClasses[i], s = a.base, l = a.active, u = a.done;
    this.appliedClasses[i] = {}, s && tw(n, s), l && tw(n, l), u && tw(n, u);
  }, e.render = function() {
    var n = this.props;
    n.classNames;
    var i = tv(n, ["classNames"]);
    return /* @__PURE__ */ y.createElement(Ii, Ce({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(y.Component);
xE.defaultProps = {
  classNames: ""
};
xE.propTypes = process.env.NODE_ENV !== "production" ? Ce({}, Ii.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: SG,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: _.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: _.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: _.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: _.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: _.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: _.func
}) : {};
function RE(o, t) {
  var e = function(i) {
    return t && fh(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return o && sD.map(o, function(n) {
    return n;
  }).forEach(function(n) {
    r[n.key] = e(n);
  }), r;
}
function _G(o, t) {
  o = o || {}, t = t || {};
  function e(c) {
    return c in t ? t[c] : o[c];
  }
  var r = /* @__PURE__ */ Object.create(null), n = [];
  for (var i in o)
    i in t ? n.length && (r[i] = n, n = []) : n.push(i);
  var a, s = {};
  for (var l in t) {
    if (r[l])
      for (a = 0; a < r[l].length; a++) {
        var u = r[l][a];
        s[r[l][a]] = e(u);
      }
    s[l] = e(l);
  }
  for (a = 0; a < n.length; a++)
    s[n[a]] = e(n[a]);
  return s;
}
function Zu(o, t, e) {
  return e[t] != null ? e[t] : o.props[t];
}
function xG(o, t) {
  return RE(o.children, function(e) {
    return Yd(e, {
      onExited: t.bind(null, e),
      in: !0,
      appear: Zu(e, "appear", o),
      enter: Zu(e, "enter", o),
      exit: Zu(e, "exit", o)
    });
  });
}
function RG(o, t, e) {
  var r = RE(o.children), n = _G(t, r);
  return Object.keys(n).forEach(function(i) {
    var a = n[i];
    if (fh(a)) {
      var s = i in t, l = i in r, u = t[i], c = fh(u) && !u.props.in;
      l && (!s || c) ? n[i] = Yd(a, {
        onExited: e.bind(null, a),
        in: !0,
        exit: Zu(a, "exit", o),
        enter: Zu(a, "enter", o)
      }) : !l && s && !c ? n[i] = Yd(a, {
        in: !1
      }) : l && s && fh(u) && (n[i] = Yd(a, {
        onExited: e.bind(null, a),
        in: u.props.in,
        exit: Zu(a, "exit", o),
        enter: Zu(a, "enter", o)
      }));
    }
  }), n;
}
var TG = Object.values || function(o) {
  return Object.keys(o).map(function(t) {
    return o[t];
  });
}, OG = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Ly = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t(r, n) {
    var i;
    i = o.call(this, r, n) || this;
    var a = i.handleExited.bind(Tm(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var e = t.prototype;
  return e.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, e.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(n, i) {
    var a = i.children, s = i.handleExited, l = i.firstRender;
    return {
      children: l ? xG(n, s) : RG(n, a, s),
      firstRender: !1
    };
  }, e.handleExited = function(n, i) {
    var a = RE(this.props.children);
    n.key in a || (n.props.onExited && n.props.onExited(i), this.mounted && this.setState(function(s) {
      var l = Ce({}, s.children);
      return delete l[n.key], {
        children: l
      };
    }));
  }, e.render = function() {
    var n = this.props, i = n.component, a = n.childFactory, s = tv(n, ["component", "childFactory"]), l = this.state.contextValue, u = TG(this.state.children).map(a);
    return delete s.appear, delete s.enter, delete s.exit, i === null ? /* @__PURE__ */ y.createElement(Am.Provider, {
      value: l
    }, u) : /* @__PURE__ */ y.createElement(Am.Provider, {
      value: l
    }, /* @__PURE__ */ y.createElement(i, s, u));
  }, t;
}(y.Component);
Ly.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _.func
} : {};
Ly.defaultProps = OG;
var PG = typeof window > "u" ? z.useEffect : z.useLayoutEffect;
function iA(o) {
  var t = o.classes, e = o.pulsate, r = e === void 0 ? !1 : e, n = o.rippleX, i = o.rippleY, a = o.rippleSize, s = o.in, l = o.onExited, u = l === void 0 ? function() {
  } : l, c = o.timeout, d = z.useState(!1), f = d[0], v = d[1], g = Xe(t.ripple, t.rippleVisible, r && t.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + n
  }, b = Xe(t.child, f && t.childLeaving, r && t.childPulsate), S = Xu(u);
  return PG(function() {
    if (!s) {
      v(!0);
      var R = setTimeout(S, c);
      return function() {
        clearTimeout(R);
      };
    }
  }, [S, s, c]), /* @__PURE__ */ z.createElement("span", {
    className: g,
    style: m
  }, /* @__PURE__ */ z.createElement("span", {
    className: b
  }));
}
process.env.NODE_ENV !== "production" && (iA.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: _.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: _.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: _.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: _.number,
  /**
   * exit delay
   */
  timeout: _.number.isRequired
});
var nS = 550, DG = 80, AG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit"
    },
    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: "absolute"
    },
    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: "scale(1)",
      animation: "$enter ".concat(nS, "ms ").concat(t.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(t.transitions.duration.shorter, "ms")
    },
    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "currentColor"
    },
    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(nS, "ms ").concat(t.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: "absolute",
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(t.transitions.easing.easeInOut, " 200ms infinite")
    },
    "@keyframes enter": {
      "0%": {
        transform: "scale(0)",
        opacity: 0.1
      },
      "100%": {
        transform: "scale(1)",
        opacity: 0.3
      }
    },
    "@keyframes exit": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    "@keyframes pulsate": {
      "0%": {
        transform: "scale(1)"
      },
      "50%": {
        transform: "scale(0.92)"
      },
      "100%": {
        transform: "scale(1)"
      }
    }
  };
}, aA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.center, n = r === void 0 ? !1 : r, i = t.classes, a = t.className, s = Ke(t, ["center", "classes", "className"]), l = z.useState([]), u = l[0], c = l[1], d = z.useRef(0), f = z.useRef(null);
  z.useEffect(function() {
    f.current && (f.current(), f.current = null);
  }, [u]);
  var v = z.useRef(!1), g = z.useRef(null), m = z.useRef(null), b = z.useRef(null);
  z.useEffect(function() {
    return function() {
      clearTimeout(g.current);
    };
  }, []);
  var S = z.useCallback(function(x) {
    var M = x.pulsate, F = x.rippleX, H = x.rippleY, B = x.rippleSize, j = x.cb;
    c(function(V) {
      return [].concat(gE(V), [/* @__PURE__ */ z.createElement(iA, {
        key: d.current,
        classes: i,
        timeout: nS,
        pulsate: M,
        rippleX: F,
        rippleY: H,
        rippleSize: B
      })]);
    }), d.current += 1, f.current = j;
  }, [i]), R = z.useCallback(function() {
    var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = arguments.length > 2 ? arguments[2] : void 0, H = M.pulsate, B = H === void 0 ? !1 : H, j = M.center, V = j === void 0 ? n || M.pulsate : j, W = M.fakeElement, q = W === void 0 ? !1 : W;
    if (x.type === "mousedown" && v.current) {
      v.current = !1;
      return;
    }
    x.type === "touchstart" && (v.current = !0);
    var ee = q ? null : b.current, re = ee ? ee.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }, ie, ne, se;
    if (V || x.clientX === 0 && x.clientY === 0 || !x.clientX && !x.touches)
      ie = Math.round(re.width / 2), ne = Math.round(re.height / 2);
    else {
      var pe = x.touches ? x.touches[0] : x, K = pe.clientX, J = pe.clientY;
      ie = Math.round(K - re.left), ne = Math.round(J - re.top);
    }
    if (V)
      se = Math.sqrt((2 * Math.pow(re.width, 2) + Math.pow(re.height, 2)) / 3), se % 2 === 0 && (se += 1);
    else {
      var ue = Math.max(Math.abs((ee ? ee.clientWidth : 0) - ie), ie) * 2 + 2, he = Math.max(Math.abs((ee ? ee.clientHeight : 0) - ne), ne) * 2 + 2;
      se = Math.sqrt(Math.pow(ue, 2) + Math.pow(he, 2));
    }
    x.touches ? m.current === null && (m.current = function() {
      S({
        pulsate: B,
        rippleX: ie,
        rippleY: ne,
        rippleSize: se,
        cb: F
      });
    }, g.current = setTimeout(function() {
      m.current && (m.current(), m.current = null);
    }, DG)) : S({
      pulsate: B,
      rippleX: ie,
      rippleY: ne,
      rippleSize: se,
      cb: F
    });
  }, [n, S]), P = z.useCallback(function() {
    R({}, {
      pulsate: !0
    });
  }, [R]), D = z.useCallback(function(x, M) {
    if (clearTimeout(g.current), x.type === "touchend" && m.current) {
      x.persist(), m.current(), m.current = null, g.current = setTimeout(function() {
        D(x, M);
      });
      return;
    }
    m.current = null, c(function(F) {
      return F.length > 0 ? F.slice(1) : F;
    }), f.current = M;
  }, []);
  return z.useImperativeHandle(e, function() {
    return {
      pulsate: P,
      start: R,
      stop: D
    };
  }, [P, R, D]), /* @__PURE__ */ z.createElement("span", Ce({
    className: Xe(i.root, a),
    ref: b
  }, s), /* @__PURE__ */ z.createElement(Ly, {
    component: null,
    exit: !0
  }, u));
});
process.env.NODE_ENV !== "production" && (aA.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string
});
const MG = qt(AG, {
  flip: !1,
  name: "MuiTouchRipple"
})(/* @__PURE__ */ z.memo(aA));
var FG = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$disabled": {
      pointerEvents: "none",
      // Disable link interactions
      cursor: "default"
    },
    "@media print": {
      colorAdjust: "exact"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
}, sA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.action, n = t.buttonRef, i = t.centerRipple, a = i === void 0 ? !1 : i, s = t.children, l = t.classes, u = t.className, c = t.component, d = c === void 0 ? "button" : c, f = t.disabled, v = f === void 0 ? !1 : f, g = t.disableRipple, m = g === void 0 ? !1 : g, b = t.disableTouchRipple, S = b === void 0 ? !1 : b, R = t.focusRipple, P = R === void 0 ? !1 : R, D = t.focusVisibleClassName, x = t.onBlur, M = t.onClick, F = t.onFocus, H = t.onFocusVisible, B = t.onKeyDown, j = t.onKeyUp, V = t.onMouseDown, W = t.onMouseLeave, q = t.onMouseUp, ee = t.onTouchEnd, re = t.onTouchMove, ie = t.onTouchStart, ne = t.onDragLeave, se = t.tabIndex, pe = se === void 0 ? 0 : se, K = t.TouchRippleProps, J = t.type, ue = J === void 0 ? "button" : J, he = Ke(t, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]), fe = z.useRef(null);
  function ae() {
    return _s.findDOMNode(fe.current);
  }
  var oe = z.useRef(null), ve = z.useState(!1), _e = ve[0], le = ve[1];
  v && _e && le(!1);
  var Ee = mG(), de = Ee.isFocusVisible, X = Ee.onBlurVisible, xe = Ee.ref;
  z.useImperativeHandle(r, function() {
    return {
      focusVisible: function() {
        le(!0), fe.current.focus();
      }
    };
  }, []), z.useEffect(function() {
    _e && P && !m && oe.current.pulsate();
  }, [m, P, _e]);
  function Le(Ze, Un) {
    var Kr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : S;
    return Xu(function(ln) {
      Un && Un(ln);
      var Ft = Kr;
      return !Ft && oe.current && oe.current[Ze](ln), !0;
    });
  }
  var Ue = Le("start", V), He = Le("stop", ne), et = Le("stop", q), $e = Le("stop", function(Ze) {
    _e && Ze.preventDefault(), W && W(Ze);
  }), pt = Le("start", ie), st = Le("stop", ee), Bt = Le("stop", re), vt = Le("stop", function(Ze) {
    _e && (X(Ze), le(!1)), x && x(Ze);
  }, !1), nt = Xu(function(Ze) {
    fe.current || (fe.current = Ze.currentTarget), de(Ze) && (le(!0), H && H(Ze)), F && F(Ze);
  }), ze = function() {
    var Un = ae();
    return d && d !== "button" && !(Un.tagName === "A" && Un.href);
  }, Ct = z.useRef(!1), Mt = Xu(function(Ze) {
    P && !Ct.current && _e && oe.current && Ze.key === " " && (Ct.current = !0, Ze.persist(), oe.current.stop(Ze, function() {
      oe.current.start(Ze);
    })), Ze.target === Ze.currentTarget && ze() && Ze.key === " " && Ze.preventDefault(), B && B(Ze), Ze.target === Ze.currentTarget && ze() && Ze.key === "Enter" && !v && (Ze.preventDefault(), M && M(Ze));
  }), fr = Xu(function(Ze) {
    P && Ze.key === " " && oe.current && _e && !Ze.defaultPrevented && (Ct.current = !1, Ze.persist(), oe.current.stop(Ze, function() {
      oe.current.pulsate(Ze);
    })), j && j(Ze), M && Ze.target === Ze.currentTarget && ze() && Ze.key === " " && !Ze.defaultPrevented && M(Ze);
  }), lt = d;
  lt === "button" && he.href && (lt = "a");
  var Et = {};
  lt === "button" ? (Et.type = ue, Et.disabled = v) : ((lt !== "a" || !he.href) && (Et.role = "button"), Et["aria-disabled"] = v);
  var kt = Jn(n, e), $t = Jn(xe, fe), br = Jn(kt, $t), mt = z.useState(!1), rt = mt[0], Gt = mt[1];
  z.useEffect(function() {
    Gt(!0);
  }, []);
  var zt = rt && !m && !v;
  return process.env.NODE_ENV !== "production" && z.useEffect(function() {
    zt && !oe.current && console.error(["Material-UI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [zt]), /* @__PURE__ */ z.createElement(lt, Ce({
    className: Xe(l.root, u, _e && [l.focusVisible, D], v && l.disabled),
    onBlur: vt,
    onClick: M,
    onFocus: nt,
    onKeyDown: Mt,
    onKeyUp: fr,
    onMouseDown: Ue,
    onMouseLeave: $e,
    onMouseUp: et,
    onDragLeave: He,
    onTouchEnd: st,
    onTouchMove: Bt,
    onTouchStart: pt,
    ref: br,
    tabIndex: v ? -1 : pe
  }, Et, he), s, zt ? (
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    /* @__PURE__ */ z.createElement(MG, Ce({
      ref: oe,
      center: a
    }, K))
  ) : null);
});
process.env.NODE_ENV !== "production" && (sA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Va,
  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: Zt(Va, "Use `ref` instead."),
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _.bool,
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: AD,
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: _.bool,
  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: _.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _.string,
  /**
   * @ignore
   */
  href: _.string,
  /**
   * @ignore
   */
  onBlur: _.func,
  /**
   * @ignore
   */
  onClick: _.func,
  /**
   * @ignore
   */
  onDragLeave: _.func,
  /**
   * @ignore
   */
  onFocus: _.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _.func,
  /**
   * @ignore
   */
  onKeyDown: _.func,
  /**
   * @ignore
   */
  onKeyUp: _.func,
  /**
   * @ignore
   */
  onMouseDown: _.func,
  /**
   * @ignore
   */
  onMouseLeave: _.func,
  /**
   * @ignore
   */
  onMouseUp: _.func,
  /**
   * @ignore
   */
  onTouchEnd: _.func,
  /**
   * @ignore
   */
  onTouchMove: _.func,
  /**
   * @ignore
   */
  onTouchStart: _.func,
  /**
   * @ignore
   */
  tabIndex: _.oneOfType([_.number, _.string]),
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: _.object,
  /**
   * @ignore
   */
  type: _.oneOfType([_.oneOf(["button", "reset", "submit"]), _.string])
});
const lA = qt(FG, {
  name: "MuiButtonBase"
})(sA);
var IG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: Ce({}, t.typography.button, {
      boxSizing: "border-box",
      minWidth: 64,
      padding: "6px 16px",
      borderRadius: t.shape.borderRadius,
      color: t.palette.text.primary,
      transition: t.transitions.create(["background-color", "box-shadow", "border"], {
        duration: t.transitions.duration.short
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: Ki(t.palette.text.primary, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        },
        "&$disabled": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        color: t.palette.action.disabled
      }
    }),
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: "100%",
      // Ensure the correct width for iOS Safari
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit"
    },
    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: "6px 8px"
    },
    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: t.palette.primary.main,
      "&:hover": {
        backgroundColor: Ki(t.palette.primary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: t.palette.secondary.main,
      "&:hover": {
        backgroundColor: Ki(t.palette.secondary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: "5px 15px",
      border: "1px solid ".concat(t.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "&$disabled": {
        border: "1px solid ".concat(t.palette.action.disabledBackground)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: t.palette.primary.main,
      border: "1px solid ".concat(Ki(t.palette.primary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(t.palette.primary.main),
        backgroundColor: Ki(t.palette.primary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: t.palette.secondary.main,
      border: "1px solid ".concat(Ki(t.palette.secondary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(t.palette.secondary.main),
        backgroundColor: Ki(t.palette.secondary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        border: "1px solid ".concat(t.palette.action.disabled)
      }
    },
    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: t.palette.getContrastText(t.palette.grey[300]),
      backgroundColor: t.palette.grey[300],
      boxShadow: t.shadows[2],
      "&:hover": {
        backgroundColor: t.palette.grey.A100,
        boxShadow: t.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          boxShadow: t.shadows[2],
          backgroundColor: t.palette.grey[300]
        },
        "&$disabled": {
          backgroundColor: t.palette.action.disabledBackground
        }
      },
      "&$focusVisible": {
        boxShadow: t.shadows[6]
      },
      "&:active": {
        boxShadow: t.shadows[8]
      },
      "&$disabled": {
        color: t.palette.action.disabled,
        boxShadow: t.shadows[0],
        backgroundColor: t.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: t.palette.primary.contrastText,
      backgroundColor: t.palette.primary.main,
      "&:hover": {
        backgroundColor: t.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: t.palette.primary.main
        }
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: t.palette.secondary.contrastText,
      backgroundColor: t.palette.secondary.main,
      "&:hover": {
        backgroundColor: t.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: t.palette.secondary.main
        }
      }
    },
    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      },
      "&$focusVisible": {
        boxShadow: "none"
      },
      "&:active": {
        boxShadow: "none"
      },
      "&$disabled": {
        boxShadow: "none"
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit",
      borderColor: "currentColor"
    },
    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: "4px 5px",
      fontSize: t.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: "8px 11px",
      fontSize: t.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: "3px 9px",
      fontSize: t.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: "7px 21px",
      fontSize: t.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: "4px 10px",
      fontSize: t.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: "8px 22px",
      fontSize: t.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: "inherit",
      marginRight: 8,
      marginLeft: -4,
      "&$iconSizeSmall": {
        marginLeft: -2
      }
    },
    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: "inherit",
      marginRight: -4,
      marginLeft: 8,
      "&$iconSizeSmall": {
        marginRight: -2
      }
    },
    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      "& > *:first-child": {
        fontSize: 18
      }
    },
    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      "& > *:first-child": {
        fontSize: 20
      }
    },
    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      "& > *:first-child": {
        fontSize: 22
      }
    }
  };
}, uA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.color, s = a === void 0 ? "default" : a, l = t.component, u = l === void 0 ? "button" : l, c = t.disabled, d = c === void 0 ? !1 : c, f = t.disableElevation, v = f === void 0 ? !1 : f, g = t.disableFocusRipple, m = g === void 0 ? !1 : g, b = t.endIcon, S = t.focusVisibleClassName, R = t.fullWidth, P = R === void 0 ? !1 : R, D = t.size, x = D === void 0 ? "medium" : D, M = t.startIcon, F = t.type, H = F === void 0 ? "button" : F, B = t.variant, j = B === void 0 ? "text" : B, V = Ke(t, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]), W = M && /* @__PURE__ */ z.createElement("span", {
    className: Xe(n.startIcon, n["iconSize".concat(Xr(x))])
  }, M), q = b && /* @__PURE__ */ z.createElement("span", {
    className: Xe(n.endIcon, n["iconSize".concat(Xr(x))])
  }, b);
  return /* @__PURE__ */ z.createElement(lA, Ce({
    className: Xe(n.root, n[j], i, s === "inherit" ? n.colorInherit : s !== "default" && n["".concat(j).concat(Xr(s))], x !== "medium" && [n["".concat(j, "Size").concat(Xr(x))], n["size".concat(Xr(x))]], v && n.disableElevation, d && n.disabled, P && n.fullWidth),
    component: u,
    disabled: d,
    focusRipple: !m,
    focusVisibleClassName: Xe(n.focusVisible, S),
    ref: e,
    type: H
  }, V), /* @__PURE__ */ z.createElement("span", {
    className: n.label
  }, W, r, q));
});
process.env.NODE_ENV !== "production" && (uA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the button.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, no elevation is used.
   */
  disableElevation: _.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: _.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: _.bool,
  /**
   * Element placed after the children.
   */
  endIcon: _.node,
  /**
   * @ignore
   */
  focusVisibleClassName: _.string,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _.string,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _.oneOf(["large", "medium", "small"]),
  /**
   * Element placed before the children.
   */
  startIcon: _.node,
  /**
   * @ignore
   */
  type: _.oneOfType([_.oneOf(["button", "reset", "submit"]), _.string]),
  /**
   * The variant to use.
   */
  variant: _.oneOf(["contained", "outlined", "text"])
});
const ih = qt(IG, {
  name: "MuiButton"
})(uA);
var LG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Cn({
      paddingLeft: t.spacing(2),
      paddingRight: t.spacing(2)
    }, t.breakpoints.up("sm"), {
      paddingLeft: t.spacing(3),
      paddingRight: t.spacing(3)
    }),
    /* Styles applied to the root element if `variant="regular"`. */
    regular: t.mixins.toolbar,
    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
}, cA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.component, a = i === void 0 ? "div" : i, s = t.disableGutters, l = s === void 0 ? !1 : s, u = t.variant, c = u === void 0 ? "regular" : u, d = Ke(t, ["classes", "className", "component", "disableGutters", "variant"]);
  return /* @__PURE__ */ z.createElement(a, Ce({
    className: Xe(r.root, r[c], n, !l && r.gutters),
    ref: e
  }, d));
});
process.env.NODE_ENV !== "production" && (cA.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _.bool,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["regular", "dense"])
});
const NG = qt(LG, {
  name: "MuiToolbar"
})(cA);
var kG = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end",
    flex: "0 0 auto"
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
}, dA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.disableSpacing, n = r === void 0 ? !1 : r, i = t.classes, a = t.className, s = Ke(t, ["disableSpacing", "classes", "className"]);
  return /* @__PURE__ */ z.createElement("div", Ce({
    className: Xe(i.root, a, !n && i.spacing),
    ref: e
  }, s));
});
process.env.NODE_ENV !== "production" && (dA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: _.bool
});
const GG = qt(kG, {
  name: "MuiDialogActions"
})(dA);
var VG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: "1 1 auto",
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      overflowY: "auto",
      padding: "8px 24px",
      "&:first-child": {
        // dialog without title
        paddingTop: 20
      }
    },
    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: "16px 24px",
      borderTop: "1px solid ".concat(t.palette.divider),
      borderBottom: "1px solid ".concat(t.palette.divider)
    }
  };
}, pA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.dividers, a = i === void 0 ? !1 : i, s = Ke(t, ["classes", "className", "dividers"]);
  return /* @__PURE__ */ z.createElement("div", Ce({
    className: Xe(r.root, n, a && r.dividers),
    ref: e
  }, s));
});
process.env.NODE_ENV !== "production" && (pA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * Display the top and bottom dividers.
   */
  dividers: _.bool
});
const HG = qt(VG, {
  name: "MuiDialogContent"
})(pA);
function Es(o) {
  return o && o.ownerDocument || document;
}
function BG(o) {
  return o = typeof o == "function" ? o() : o, _s.findDOMNode(o);
}
var rw = typeof window < "u" ? z.useLayoutEffect : z.useEffect, Mm = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.container, i = t.disablePortal, a = i === void 0 ? !1 : i, s = t.onRendered, l = z.useState(null), u = l[0], c = l[1], d = Jn(/* @__PURE__ */ z.isValidElement(r) ? r.ref : null, e);
  return rw(function() {
    a || c(BG(n) || document.body);
  }, [n, a]), rw(function() {
    if (u && !a)
      return Ih(e, u), function() {
        Ih(e, null);
      };
  }, [e, u, a]), rw(function() {
    s && (u || a) && s();
  }, [s, u, a]), a ? /* @__PURE__ */ z.isValidElement(r) ? /* @__PURE__ */ z.cloneElement(r, {
    ref: d
  }) : r : u && /* @__PURE__ */ _s.createPortal(r, u);
});
process.env.NODE_ENV !== "production" && (Mm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: _.node,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _.oneOfType([Ah, _.instanceOf(z.Component), _.func]),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _.bool,
  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */
  onRendered: Zt(_.func, "Use the ref instead.")
});
process.env.NODE_ENV !== "production" && (Mm.propTypes = Py(Mm.propTypes));
function oS() {
  for (var o = arguments.length, t = new Array(o), e = 0; e < o; e++)
    t[e] = arguments[e];
  return t.reduce(function(r, n) {
    return n == null ? r : (process.env.NODE_ENV !== "production" && typeof n != "function" && console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var a = arguments.length, s = new Array(a), l = 0; l < a; l++)
        s[l] = arguments[l];
      r.apply(this, s), n.apply(this, s);
    });
  }, function() {
  });
}
function fA() {
  var o = document.createElement("div");
  o.style.width = "99px", o.style.height = "99px", o.style.position = "absolute", o.style.top = "-9999px", o.style.overflow = "scroll", document.body.appendChild(o);
  var t = o.offsetWidth - o.clientWidth;
  return document.body.removeChild(o), t;
}
function hA(o) {
  var t = Es(o);
  return t.defaultView || window;
}
function WG(o) {
  var t = Es(o);
  return t.body === o ? hA(t).innerWidth > t.documentElement.clientWidth : o.scrollHeight > o.clientHeight;
}
function mh(o, t) {
  t ? o.setAttribute("aria-hidden", "true") : o.removeAttribute("aria-hidden");
}
function _R(o) {
  return parseInt(window.getComputedStyle(o)["padding-right"], 10) || 0;
}
function xR(o, t, e) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], n = arguments.length > 4 ? arguments[4] : void 0, i = [t, e].concat(gE(r)), a = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(o.children, function(s) {
    s.nodeType === 1 && i.indexOf(s) === -1 && a.indexOf(s.tagName) === -1 && mh(s, n);
  });
}
function nw(o, t) {
  var e = -1;
  return o.some(function(r, n) {
    return t(r) ? (e = n, !0) : !1;
  }), e;
}
function jG(o, t) {
  var e = [], r = [], n = o.container, i;
  if (!t.disableScrollLock) {
    if (WG(n)) {
      var a = fA();
      e.push({
        value: n.style.paddingRight,
        key: "padding-right",
        el: n
      }), n.style["padding-right"] = "".concat(_R(n) + a, "px"), i = Es(n).querySelectorAll(".mui-fixed"), [].forEach.call(i, function(c) {
        r.push(c.style.paddingRight), c.style.paddingRight = "".concat(_R(c) + a, "px");
      });
    }
    var s = n.parentElement, l = s.nodeName === "HTML" && window.getComputedStyle(s)["overflow-y"] === "scroll" ? s : n;
    e.push({
      value: l.style.overflow,
      key: "overflow",
      el: l
    }), l.style.overflow = "hidden";
  }
  var u = function() {
    i && [].forEach.call(i, function(d, f) {
      r[f] ? d.style.paddingRight = r[f] : d.style.removeProperty("padding-right");
    }), e.forEach(function(d) {
      var f = d.value, v = d.el, g = d.key;
      f ? v.style.setProperty(g, f) : v.style.removeProperty(g);
    });
  };
  return u;
}
function UG(o) {
  var t = [];
  return [].forEach.call(o.children, function(e) {
    e.getAttribute && e.getAttribute("aria-hidden") === "true" && t.push(e);
  }), t;
}
var $G = /* @__PURE__ */ function() {
  function o() {
    Ay(this, o), this.modals = [], this.containers = [];
  }
  return cp(o, [{
    key: "add",
    value: function(e, r) {
      var n = this.modals.indexOf(e);
      if (n !== -1)
        return n;
      n = this.modals.length, this.modals.push(e), e.modalRef && mh(e.modalRef, !1);
      var i = UG(r);
      xR(r, e.mountNode, e.modalRef, i, !0);
      var a = nw(this.containers, function(s) {
        return s.container === r;
      });
      return a !== -1 ? (this.containers[a].modals.push(e), n) : (this.containers.push({
        modals: [e],
        container: r,
        restore: null,
        hiddenSiblingNodes: i
      }), n);
    }
  }, {
    key: "mount",
    value: function(e, r) {
      var n = nw(this.containers, function(a) {
        return a.modals.indexOf(e) !== -1;
      }), i = this.containers[n];
      i.restore || (i.restore = jG(i, r));
    }
  }, {
    key: "remove",
    value: function(e) {
      var r = this.modals.indexOf(e);
      if (r === -1)
        return r;
      var n = nw(this.containers, function(s) {
        return s.modals.indexOf(e) !== -1;
      }), i = this.containers[n];
      if (i.modals.splice(i.modals.indexOf(e), 1), this.modals.splice(r, 1), i.modals.length === 0)
        i.restore && i.restore(), e.modalRef && mh(e.modalRef, !0), xR(i.container, e.mountNode, e.modalRef, i.hiddenSiblingNodes, !1), this.containers.splice(n, 1);
      else {
        var a = i.modals[i.modals.length - 1];
        a.modalRef && mh(a.modalRef, !1);
      }
      return r;
    }
  }, {
    key: "isTopModal",
    value: function(e) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === e;
    }
  }]), o;
}();
function Fm(o) {
  var t = o.children, e = o.disableAutoFocus, r = e === void 0 ? !1 : e, n = o.disableEnforceFocus, i = n === void 0 ? !1 : n, a = o.disableRestoreFocus, s = a === void 0 ? !1 : a, l = o.getDoc, u = o.isEnabled, c = o.open, d = z.useRef(), f = z.useRef(null), v = z.useRef(null), g = z.useRef(), m = z.useRef(null), b = z.useCallback(function(P) {
    m.current = _s.findDOMNode(P);
  }, []), S = Jn(t.ref, b), R = z.useRef();
  return z.useEffect(function() {
    R.current = c;
  }, [c]), !R.current && c && typeof window < "u" && (g.current = l().activeElement), z.useEffect(function() {
    if (c) {
      var P = Es(m.current);
      !r && m.current && !m.current.contains(P.activeElement) && (m.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), m.current.setAttribute("tabIndex", -1)), m.current.focus());
      var D = function() {
        var H = m.current;
        if (H !== null) {
          if (!P.hasFocus() || i || !u() || d.current) {
            d.current = !1;
            return;
          }
          m.current && !m.current.contains(P.activeElement) && m.current.focus();
        }
      }, x = function(H) {
        i || !u() || H.keyCode !== 9 || P.activeElement === m.current && (d.current = !0, H.shiftKey ? v.current.focus() : f.current.focus());
      };
      P.addEventListener("focus", D, !0), P.addEventListener("keydown", x, !0);
      var M = setInterval(function() {
        D();
      }, 50);
      return function() {
        clearInterval(M), P.removeEventListener("focus", D, !0), P.removeEventListener("keydown", x, !0), s || (g.current && g.current.focus && g.current.focus(), g.current = null);
      };
    }
  }, [r, i, s, u, c]), /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement("div", {
    tabIndex: 0,
    ref: f,
    "data-test": "sentinelStart"
  }), /* @__PURE__ */ z.cloneElement(t, {
    ref: S
  }), /* @__PURE__ */ z.createElement("div", {
    tabIndex: 0,
    ref: v,
    "data-test": "sentinelEnd"
  }));
}
process.env.NODE_ENV !== "production" && (Fm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: _.node,
  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _.bool,
  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _.bool,
  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: _.bool,
  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: _.func.isRequired,
  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: _.func.isRequired,
  /**
   * If `true`, focus will be locked.
   */
  open: _.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Fm.propTypes = Py(Fm.propTypes));
var RR = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: "fixed",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
}, vA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.invisible, n = r === void 0 ? !1 : r, i = t.open, a = Ke(t, ["invisible", "open"]);
  return i ? /* @__PURE__ */ z.createElement("div", Ce({
    "aria-hidden": !0,
    ref: e
  }, a, {
    style: Ce({}, RR.root, n ? RR.invisible : {}, a.style)
  })) : null;
});
process.env.NODE_ENV !== "production" && (vA.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: _.bool.isRequired
});
function zG(o) {
  return o = typeof o == "function" ? o() : o, _s.findDOMNode(o);
}
function YG(o) {
  return o.children ? o.children.props.hasOwnProperty("in") : !1;
}
var KG = new $G(), qG = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "fixed",
      zIndex: t.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },
    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: "hidden"
    }
  };
}, TE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = nv(), n = ID({
    name: "MuiModal",
    props: Ce({}, t),
    theme: r
  }), i = n.BackdropComponent, a = i === void 0 ? vA : i, s = n.BackdropProps, l = n.children, u = n.closeAfterTransition, c = u === void 0 ? !1 : u, d = n.container, f = n.disableAutoFocus, v = f === void 0 ? !1 : f, g = n.disableBackdropClick, m = g === void 0 ? !1 : g, b = n.disableEnforceFocus, S = b === void 0 ? !1 : b, R = n.disableEscapeKeyDown, P = R === void 0 ? !1 : R, D = n.disablePortal, x = D === void 0 ? !1 : D, M = n.disableRestoreFocus, F = M === void 0 ? !1 : M, H = n.disableScrollLock, B = H === void 0 ? !1 : H, j = n.hideBackdrop, V = j === void 0 ? !1 : j, W = n.keepMounted, q = W === void 0 ? !1 : W, ee = n.manager, re = ee === void 0 ? KG : ee, ie = n.onBackdropClick, ne = n.onClose, se = n.onEscapeKeyDown, pe = n.onRendered, K = n.open, J = Ke(n, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]), ue = z.useState(!0), he = ue[0], fe = ue[1], ae = z.useRef({}), oe = z.useRef(null), ve = z.useRef(null), _e = Jn(ve, e), le = YG(n), Ee = function() {
    return Es(oe.current);
  }, de = function() {
    return ae.current.modalRef = ve.current, ae.current.mountNode = oe.current, ae.current;
  }, X = function() {
    re.mount(de(), {
      disableScrollLock: B
    }), ve.current.scrollTop = 0;
  }, xe = Xu(function() {
    var nt = zG(d) || Ee().body;
    re.add(de(), nt), ve.current && X();
  }), Le = z.useCallback(function() {
    return re.isTopModal(de());
  }, [re]), Ue = Xu(function(nt) {
    oe.current = nt, nt && (pe && pe(), K && Le() ? X() : mh(ve.current, !0));
  }), He = z.useCallback(function() {
    re.remove(de());
  }, [re]);
  if (z.useEffect(function() {
    return function() {
      He();
    };
  }, [He]), z.useEffect(function() {
    K ? xe() : (!le || !c) && He();
  }, [K, He, le, c, xe]), !q && !K && (!le || he))
    return null;
  var et = function() {
    fe(!1);
  }, $e = function() {
    fe(!0), c && He();
  }, pt = function(ze) {
    ze.target === ze.currentTarget && (ie && ie(ze), !m && ne && ne(ze, "backdropClick"));
  }, st = function(ze) {
    ze.key !== "Escape" || !Le() || (se && se(ze), P || (ze.stopPropagation(), ne && ne(ze, "escapeKeyDown")));
  }, Bt = qG(r || {
    zIndex: tA
  }), vt = {};
  return l.props.tabIndex === void 0 && (vt.tabIndex = l.props.tabIndex || "-1"), le && (vt.onEnter = oS(et, l.props.onEnter), vt.onExited = oS($e, l.props.onExited)), /* @__PURE__ */ z.createElement(Mm, {
    ref: Ue,
    container: d,
    disablePortal: x
  }, /* @__PURE__ */ z.createElement("div", Ce({
    ref: _e,
    onKeyDown: st,
    role: "presentation"
  }, J, {
    style: Ce({}, Bt.root, !K && he ? Bt.hidden : {}, J.style)
  }), V ? null : /* @__PURE__ */ z.createElement(a, Ce({
    open: K,
    onClick: pt
  }, s)), /* @__PURE__ */ z.createElement(Fm, {
    disableEnforceFocus: S,
    disableAutoFocus: v,
    disableRestoreFocus: F,
    getDoc: Ee,
    isEnabled: Le,
    open: K
  }, /* @__PURE__ */ z.cloneElement(l, vt))));
});
process.env.NODE_ENV !== "production" && (TE.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: _.elementType,
  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: _.object,
  /**
   * A single child content element.
   */
  children: DD.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: _.bool,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _.oneOfType([Ah, _.instanceOf(z.Component), _.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _.bool,
  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: Zt(_.bool, "Use the onClose prop with the `reason` argument to filter the `backdropClick` events."),
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _.bool,
  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: _.bool,
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _.bool,
  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: _.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _.bool,
  /**
   * @ignore
   */
  manager: _.object,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: Zt(_.func, "Use the onClose prop with the `reason` argument to handle the `backdropClick` events."),
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: _.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: Zt(_.func, "Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events."),
  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be removed in v5, the ref can be used instead.
   */
  onRendered: Zt(_.func, "Use the ref instead."),
  /**
   * If `true`, the modal is open.
   */
  open: _.bool.isRequired
});
var gA = function(t) {
  return t.scrollTop;
};
function Im(o, t) {
  var e = o.timeout, r = o.style, n = r === void 0 ? {} : r;
  return {
    duration: n.transitionDuration || typeof e == "number" ? e : e[t.mode] || 0,
    delay: n.transitionDelay
  };
}
var XG = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ZG = {
  enter: rp.enteringScreen,
  exit: rp.leavingScreen
}, OE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.disableStrictModeCompat, i = n === void 0 ? !1 : n, a = t.in, s = t.onEnter, l = t.onEntered, u = t.onEntering, c = t.onExit, d = t.onExited, f = t.onExiting, v = t.style, g = t.TransitionComponent, m = g === void 0 ? Ii : g, b = t.timeout, S = b === void 0 ? ZG : b, R = Ke(t, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]), P = ov(), D = P.unstable_strictMode && !i, x = z.useRef(null), M = Jn(r.ref, e), F = Jn(D ? x : void 0, M), H = function(ie) {
    return function(ne, se) {
      if (ie) {
        var pe = D ? [x.current, ne] : [ne, se], K = Bl(pe, 2), J = K[0], ue = K[1];
        ue === void 0 ? ie(J) : ie(J, ue);
      }
    };
  }, B = H(u), j = H(function(re, ie) {
    gA(re);
    var ne = Im({
      style: v,
      timeout: S
    }, {
      mode: "enter"
    });
    re.style.webkitTransition = P.transitions.create("opacity", ne), re.style.transition = P.transitions.create("opacity", ne), s && s(re, ie);
  }), V = H(l), W = H(f), q = H(function(re) {
    var ie = Im({
      style: v,
      timeout: S
    }, {
      mode: "exit"
    });
    re.style.webkitTransition = P.transitions.create("opacity", ie), re.style.transition = P.transitions.create("opacity", ie), c && c(re);
  }), ee = H(d);
  return /* @__PURE__ */ z.createElement(m, Ce({
    appear: !0,
    in: a,
    nodeRef: D ? x : void 0,
    onEnter: j,
    onEntered: V,
    onEntering: B,
    onExit: q,
    onExited: ee,
    onExiting: W,
    timeout: S
  }, R), function(re, ie) {
    return /* @__PURE__ */ z.cloneElement(r, Ce({
      style: Ce({
        opacity: 0,
        visibility: re === "exited" && !a ? "hidden" : void 0
      }, XG[re], v, r.props.style),
      ref: F
    }, ie));
  });
});
process.env.NODE_ENV !== "production" && (OE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: _.element,
  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: _.bool,
  /**
   * If `true`, the component will transition in.
   */
  in: _.bool,
  /**
   * @ignore
   */
  onEnter: _.func,
  /**
   * @ignore
   */
  onEntered: _.func,
  /**
   * @ignore
   */
  onEntering: _.func,
  /**
   * @ignore
   */
  onExit: _.func,
  /**
   * @ignore
   */
  onExited: _.func,
  /**
   * @ignore
   */
  onExiting: _.func,
  /**
   * @ignore
   */
  style: _.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _.oneOfType([_.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })])
});
var QG = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
}, mA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.invisible, s = a === void 0 ? !1 : a, l = t.open, u = t.transitionDuration, c = t.TransitionComponent, d = c === void 0 ? OE : c, f = Ke(t, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
  return /* @__PURE__ */ z.createElement(d, Ce({
    in: l,
    timeout: u
  }, f), /* @__PURE__ */ z.createElement("div", {
    className: Xe(n.root, i, s && n.invisible),
    "aria-hidden": !0,
    ref: e
  }, r));
});
process.env.NODE_ENV !== "production" && (mA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: _.bool.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _.oneOfType([_.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })])
});
const JG = qt(QG, {
  name: "MuiBackdrop"
})(mA);
var e4 = function(t) {
  var e = {};
  return t.shadows.forEach(function(r, n) {
    e["elevation".concat(n)] = {
      boxShadow: r
    };
  }), Ce({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: t.palette.background.paper,
      color: t.palette.text.primary,
      transition: t.transitions.create("box-shadow")
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: t.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(t.palette.divider)
    }
  }, e);
}, yA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.component, a = i === void 0 ? "div" : i, s = t.square, l = s === void 0 ? !1 : s, u = t.elevation, c = u === void 0 ? 1 : u, d = t.variant, f = d === void 0 ? "elevation" : d, v = Ke(t, ["classes", "className", "component", "square", "elevation", "variant"]);
  return /* @__PURE__ */ z.createElement(a, Ce({
    className: Xe(r.root, n, f === "outlined" ? r.outlined : r["elevation".concat(c)], !l && r.rounded),
    ref: e
  }, v));
});
process.env.NODE_ENV !== "production" && (yA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: Ga(_.number, function(o) {
    var t = o.classes, e = o.elevation;
    return t === void 0 ? null : e != null && t["elevation".concat(e)] === void 0 ? new Error("Material-UI: This elevation `".concat(e, "` is not implemented.")) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   */
  square: _.bool,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["elevation", "outlined"])
});
const CA = qt(e4, {
  name: "MuiPaper"
})(yA);
var t4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
      }
    },
    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&:after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    },
    /* Styles applied to the container element. */
    container: {
      height: "100%",
      "@media print": {
        height: "auto"
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },
    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: "relative",
      overflowY: "auto",
      // Fix IE 11 issue, to remove at some point.
      "@media print": {
        overflowY: "visible",
        boxShadow: "none"
      }
    },
    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "left"
      // 'initial' doesn't work on IE 11
    },
    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(t.breakpoints.values.xs, 444),
      "&$paperScrollBody": Cn({}, t.breakpoints.down(Math.max(t.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: t.breakpoints.values.sm,
      "&$paperScrollBody": Cn({}, t.breakpoints.down(t.breakpoints.values.sm + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: t.breakpoints.values.md,
      "&$paperScrollBody": Cn({}, t.breakpoints.down(t.breakpoints.values.md + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: t.breakpoints.values.lg,
      "&$paperScrollBody": Cn({}, t.breakpoints.down(t.breakpoints.values.lg + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: t.breakpoints.values.xl,
      "&$paperScrollBody": Cn({}, t.breakpoints.down(t.breakpoints.values.xl + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      "&$paperScrollBody": {
        margin: 0,
        maxWidth: "100%"
      }
    }
  };
}, r4 = {
  enter: rp.enteringScreen,
  exit: rp.leavingScreen
}, wA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.BackdropProps, n = t.children, i = t.classes, a = t.className, s = t.disableBackdropClick, l = s === void 0 ? !1 : s, u = t.disableEscapeKeyDown, c = u === void 0 ? !1 : u, d = t.fullScreen, f = d === void 0 ? !1 : d, v = t.fullWidth, g = v === void 0 ? !1 : v, m = t.maxWidth, b = m === void 0 ? "sm" : m, S = t.onBackdropClick, R = t.onClose, P = t.onEnter, D = t.onEntered, x = t.onEntering, M = t.onEscapeKeyDown, F = t.onExit, H = t.onExited, B = t.onExiting, j = t.open, V = t.PaperComponent, W = V === void 0 ? CA : V, q = t.PaperProps, ee = q === void 0 ? {} : q, re = t.scroll, ie = re === void 0 ? "paper" : re, ne = t.TransitionComponent, se = ne === void 0 ? OE : ne, pe = t.transitionDuration, K = pe === void 0 ? r4 : pe, J = t.TransitionProps, ue = t["aria-describedby"], he = t["aria-labelledby"], fe = Ke(t, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]), ae = z.useRef(), oe = function(le) {
    ae.current = le.target;
  }, ve = function(le) {
    le.target === le.currentTarget && le.target === ae.current && (ae.current = null, S && S(le), !l && R && R(le, "backdropClick"));
  };
  return /* @__PURE__ */ z.createElement(TE, Ce({
    className: Xe(i.root, a),
    BackdropComponent: JG,
    BackdropProps: Ce({
      transitionDuration: K
    }, r),
    closeAfterTransition: !0
  }, l ? {
    disableBackdropClick: l
  } : {}, {
    disableEscapeKeyDown: c,
    onEscapeKeyDown: M,
    onClose: R,
    open: j,
    ref: e
  }, fe), /* @__PURE__ */ z.createElement(se, Ce({
    appear: !0,
    in: j,
    timeout: K,
    onEnter: P,
    onEntering: x,
    onEntered: D,
    onExit: F,
    onExiting: B,
    onExited: H,
    role: "none presentation"
  }, J), /* @__PURE__ */ z.createElement("div", {
    className: Xe(i.container, i["scroll".concat(Xr(ie))]),
    onMouseUp: ve,
    onMouseDown: oe
  }, /* @__PURE__ */ z.createElement(W, Ce({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ue,
    "aria-labelledby": he
  }, ee, {
    className: Xe(i.paper, i["paperScroll".concat(Xr(ie))], i["paperWidth".concat(Xr(String(b)))], ee.className, f && i.paperFullScreen, g && i.paperFullWidth)
  }), n))));
});
process.env.NODE_ENV !== "production" && (wA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": _.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": _.string,
  /**
   * @ignore
   */
  BackdropProps: _.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   * @deprecated Use the onClose prop with the `reason` argument to filter the `backdropClick` events.
   */
  disableBackdropClick: Zt(_.bool, "Use the onClose prop with the `reason` argument to filter the `backdropClick` events."),
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _.bool,
  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: _.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: _.oneOf(["lg", "md", "sm", "xl", "xs", !1]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: Zt(_.func, "Use the onClose prop with the `reason` argument to handle the `backdropClick` events."),
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: _.func,
  /**
   * Callback fired before the dialog enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the dialog has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the dialog is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.
   */
  onEscapeKeyDown: Zt(_.func, "Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events."),
  /**
   * Callback fired before the dialog exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the dialog has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the dialog is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * If `true`, the Dialog is open.
   */
  open: _.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: _.elementType,
  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _.object,
  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _.oneOf(["body", "paper"]),
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: _.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _.oneOfType([_.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })]),
  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: _.object
});
const n4 = qt(t4, {
  name: "MuiDialog"
})(wA);
function bA(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, e;
  function r() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var s = this, l = function() {
      o.apply(s, i);
    };
    clearTimeout(e), e = setTimeout(l, t);
  }
  return r.clear = function() {
    clearTimeout(e);
  }, r;
}
function iS(o) {
  return "scale(".concat(o, ", ").concat(Math.pow(o, 2), ")");
}
var o4 = {
  entering: {
    opacity: 1,
    transform: iS(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, PE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.disableStrictModeCompat, i = n === void 0 ? !1 : n, a = t.in, s = t.onEnter, l = t.onEntered, u = t.onEntering, c = t.onExit, d = t.onExited, f = t.onExiting, v = t.style, g = t.timeout, m = g === void 0 ? "auto" : g, b = t.TransitionComponent, S = b === void 0 ? Ii : b, R = Ke(t, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]), P = z.useRef(), D = z.useRef(), x = ov(), M = x.unstable_strictMode && !i, F = z.useRef(null), H = Jn(r.ref, e), B = Jn(M ? F : void 0, H), j = function(pe) {
    return function(K, J) {
      if (pe) {
        var ue = M ? [F.current, K] : [K, J], he = Bl(ue, 2), fe = he[0], ae = he[1];
        ae === void 0 ? pe(fe) : pe(fe, ae);
      }
    };
  }, V = j(u), W = j(function(se, pe) {
    gA(se);
    var K = Im({
      style: v,
      timeout: m
    }, {
      mode: "enter"
    }), J = K.duration, ue = K.delay, he;
    m === "auto" ? (he = x.transitions.getAutoHeightDuration(se.clientHeight), D.current = he) : he = J, se.style.transition = [x.transitions.create("opacity", {
      duration: he,
      delay: ue
    }), x.transitions.create("transform", {
      duration: he * 0.666,
      delay: ue
    })].join(","), s && s(se, pe);
  }), q = j(l), ee = j(f), re = j(function(se) {
    var pe = Im({
      style: v,
      timeout: m
    }, {
      mode: "exit"
    }), K = pe.duration, J = pe.delay, ue;
    m === "auto" ? (ue = x.transitions.getAutoHeightDuration(se.clientHeight), D.current = ue) : ue = K, se.style.transition = [x.transitions.create("opacity", {
      duration: ue,
      delay: J
    }), x.transitions.create("transform", {
      duration: ue * 0.666,
      delay: J || ue * 0.333
    })].join(","), se.style.opacity = "0", se.style.transform = iS(0.75), c && c(se);
  }), ie = j(d), ne = function(pe, K) {
    var J = M ? pe : K;
    m === "auto" && (P.current = setTimeout(J, D.current || 0));
  };
  return z.useEffect(function() {
    return function() {
      clearTimeout(P.current);
    };
  }, []), /* @__PURE__ */ z.createElement(S, Ce({
    appear: !0,
    in: a,
    nodeRef: M ? F : void 0,
    onEnter: W,
    onEntered: q,
    onEntering: V,
    onExit: re,
    onExited: ie,
    onExiting: ee,
    addEndListener: ne,
    timeout: m === "auto" ? null : m
  }, R), function(se, pe) {
    return /* @__PURE__ */ z.cloneElement(r, Ce({
      style: Ce({
        opacity: 0,
        transform: iS(0.75),
        visibility: se === "exited" && !a ? "hidden" : void 0
      }, o4[se], v, r.props.style),
      ref: B
    }, pe));
  });
});
process.env.NODE_ENV !== "production" && (PE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: _.element,
  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: _.bool,
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _.bool,
  /**
   * @ignore
   */
  onEnter: _.func,
  /**
   * @ignore
   */
  onEntered: _.func,
  /**
   * @ignore
   */
  onEntering: _.func,
  /**
   * @ignore
   */
  onExit: _.func,
  /**
   * @ignore
   */
  onExited: _.func,
  /**
   * @ignore
   */
  onExiting: _.func,
  /**
   * @ignore
   */
  style: _.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _.oneOfType([_.oneOf(["auto"]), _.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })])
});
PE.muiSupportAuto = !0;
function TR(o, t) {
  var e = 0;
  return typeof t == "number" ? e = t : t === "center" ? e = o.height / 2 : t === "bottom" && (e = o.height), e;
}
function OR(o, t) {
  var e = 0;
  return typeof t == "number" ? e = t : t === "center" ? e = o.width / 2 : t === "right" && (e = o.width), e;
}
function PR(o) {
  return [o.horizontal, o.vertical].map(function(t) {
    return typeof t == "number" ? "".concat(t, "px") : t;
  }).join(" ");
}
function i4(o, t) {
  for (var e = t, r = 0; e && e !== o; )
    e = e.parentElement, r += e.scrollTop;
  return r;
}
function pm(o) {
  return typeof o == "function" ? o() : o;
}
var a4 = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the `Paper` component. */
  paper: {
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
}, SA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.action, n = t.anchorEl, i = t.anchorOrigin, a = i === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : i, s = t.anchorPosition, l = t.anchorReference, u = l === void 0 ? "anchorEl" : l, c = t.children, d = t.classes, f = t.className, v = t.container, g = t.elevation, m = g === void 0 ? 8 : g, b = t.getContentAnchorEl, S = t.marginThreshold, R = S === void 0 ? 16 : S, P = t.onEnter, D = t.onEntered, x = t.onEntering, M = t.onExit, F = t.onExited, H = t.onExiting, B = t.open, j = t.PaperProps, V = j === void 0 ? {} : j, W = t.transformOrigin, q = W === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : W, ee = t.TransitionComponent, re = ee === void 0 ? PE : ee, ie = t.transitionDuration, ne = ie === void 0 ? "auto" : ie, se = t.TransitionProps, pe = se === void 0 ? {} : se, K = Ke(t, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]), J = z.useRef(), ue = z.useCallback(function(de) {
    if (u === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (s || console.error('Material-UI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), s;
    var X = pm(n), xe = X && X.nodeType === 1 ? X : Es(J.current).body, Le = xe.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      var Ue = xe.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Ue.top === 0 && Ue.left === 0 && Ue.right === 0 && Ue.bottom === 0 && console.warn(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    var He = de === 0 ? a.vertical : "center";
    return {
      top: Le.top + TR(Le, He),
      left: Le.left + OR(Le, a.horizontal)
    };
  }, [n, a.horizontal, a.vertical, s, u]), he = z.useCallback(function(de) {
    var X = 0;
    if (b && u === "anchorEl") {
      var xe = b(de);
      if (xe && de.contains(xe)) {
        var Le = i4(de, xe);
        X = xe.offsetTop + xe.clientHeight / 2 - Le || 0;
      }
      process.env.NODE_ENV !== "production" && a.vertical !== "top" && console.error(["Material-UI: You can not change the default `anchorOrigin.vertical` value ", "when also providing the `getContentAnchorEl` prop to the popover component.", "Only use one of the two props.", "Set `getContentAnchorEl` to `null | undefined` or leave `anchorOrigin.vertical` unchanged."].join(`
`));
    }
    return X;
  }, [a.vertical, u, b]), fe = z.useCallback(function(de) {
    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return {
      vertical: TR(de, q.vertical) + X,
      horizontal: OR(de, q.horizontal)
    };
  }, [q.horizontal, q.vertical]), ae = z.useCallback(function(de) {
    var X = he(de), xe = {
      width: de.offsetWidth,
      height: de.offsetHeight
    }, Le = fe(xe, X);
    if (u === "none")
      return {
        top: null,
        left: null,
        transformOrigin: PR(Le)
      };
    var Ue = ue(X), He = Ue.top - Le.vertical, et = Ue.left - Le.horizontal, $e = He + xe.height, pt = et + xe.width, st = hA(pm(n)), Bt = st.innerHeight - R, vt = st.innerWidth - R;
    if (He < R) {
      var nt = He - R;
      He -= nt, Le.vertical += nt;
    } else if ($e > Bt) {
      var ze = $e - Bt;
      He -= ze, Le.vertical += ze;
    }
    if (process.env.NODE_ENV !== "production" && xe.height > Bt && xe.height && Bt && console.error(["Material-UI: The popover component is too tall.", "Some part of it can not be seen on the screen (".concat(xe.height - Bt, "px)."), "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), et < R) {
      var Ct = et - R;
      et -= Ct, Le.horizontal += Ct;
    } else if (pt > vt) {
      var Mt = pt - vt;
      et -= Mt, Le.horizontal += Mt;
    }
    return {
      top: "".concat(Math.round(He), "px"),
      left: "".concat(Math.round(et), "px"),
      transformOrigin: PR(Le)
    };
  }, [n, u, ue, he, fe, R]), oe = z.useCallback(function() {
    var de = J.current;
    if (de) {
      var X = ae(de);
      X.top !== null && (de.style.top = X.top), X.left !== null && (de.style.left = X.left), de.style.transformOrigin = X.transformOrigin;
    }
  }, [ae]), ve = function(X, xe) {
    x && x(X, xe), oe();
  }, _e = z.useCallback(function(de) {
    J.current = _s.findDOMNode(de);
  }, []);
  z.useEffect(function() {
    B && oe();
  }), z.useImperativeHandle(r, function() {
    return B ? {
      updatePosition: function() {
        oe();
      }
    } : null;
  }, [B, oe]), z.useEffect(function() {
    if (B) {
      var de = bA(function() {
        oe();
      });
      return window.addEventListener("resize", de), function() {
        de.clear(), window.removeEventListener("resize", de);
      };
    }
  }, [B, oe]);
  var le = ne;
  ne === "auto" && !re.muiSupportAuto && (le = void 0);
  var Ee = v || (n ? Es(pm(n)).body : void 0);
  return /* @__PURE__ */ z.createElement(TE, Ce({
    container: Ee,
    open: B,
    ref: e,
    BackdropProps: {
      invisible: !0
    },
    className: Xe(d.root, f)
  }, K), /* @__PURE__ */ z.createElement(re, Ce({
    appear: !0,
    in: B,
    onEnter: P,
    onEntered: D,
    onExit: M,
    onExited: F,
    onExiting: H,
    timeout: le
  }, pe, {
    onEntering: oS(ve, pe.onEntering)
  }), /* @__PURE__ */ z.createElement(CA, Ce({
    elevation: m,
    ref: _e
  }, V, {
    className: Xe(d.paper, V.className)
  }), c)));
});
process.env.NODE_ENV !== "production" && (SA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Va,
  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: Ga(_.oneOfType([Ah, _.func]), function(o) {
    if (o.open && (!o.anchorReference || o.anchorReference === "anchorEl")) {
      var t = pm(o.anchorEl);
      if (t && t.nodeType === 1) {
        var e = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && e.top === 0 && e.left === 0 && e.right === 0 && e.bottom === 0)
          return new Error(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "It should be an Element instance but it's `".concat(t, "` instead.")].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _.shape({
    horizontal: _.oneOfType([_.oneOf(["center", "left", "right"]), _.number]).isRequired,
    vertical: _.oneOfType([_.oneOf(["bottom", "center", "top"]), _.number]).isRequired
  }),
  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _.shape({
    left: _.number.isRequired,
    top: _.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _.oneOfType([Ah, _.instanceOf(z.Component), _.func]),
  /**
   * The elevation of the popover.
   */
  elevation: _.number,
  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _.func,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _.number,
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: _.func,
  /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * If `true`, the popover is visible.
   */
  open: _.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _.shape({
    component: AD
  }),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _.shape({
    horizontal: _.oneOfType([_.oneOf(["center", "left", "right"]), _.number]).isRequired,
    vertical: _.oneOfType([_.oneOf(["bottom", "center", "top"]), _.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: _.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _.oneOfType([_.oneOf(["auto"]), _.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })]),
  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: _.object
});
const EA = qt(a4, {
  name: "MuiPopover"
})(SA);
function aS(o, t) {
  return Array.isArray(t) ? t.every(function(e) {
    return o.indexOf(e) !== -1;
  }) : o.indexOf(t) !== -1;
}
var DE = 310, _A = 325, s4 = 305, l4 = li(function(o) {
  return {
    staticWrapperRoot: {
      overflow: "hidden",
      minWidth: DE,
      display: "flex",
      flexDirection: "column",
      backgroundColor: o.palette.background.paper
    }
  };
}, {
  name: "MuiPickersStaticWrapper"
}), u4 = function(t) {
  var e = t.children, r = l4();
  return Ne("div", {
    className: r.staticWrapperRoot,
    children: e
  });
}, xA = function(t) {
  var e = t.children, r = t.classes, n = t.onAccept, i = t.onDismiss, a = t.onClear, s = t.onSetToday, l = t.okLabel, u = t.cancelLabel, c = t.clearLabel, d = t.todayLabel, f = t.clearable, v = t.showTodayButton;
  t.showTabs;
  var g = t.wider, m = Ke(t, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);
  return Ne(n4, Ce({
    role: "dialog",
    onClose: i,
    classes: {
      paper: Xe(r.dialogRoot, g && r.dialogRootWider)
    }
  }, m), Ne(HG, {
    children: e,
    className: r.dialog
  }), Ne(GG, {
    classes: {
      root: Xe((f || v) && r.withAdditionalAction)
    }
  }, f && Ne(ih, {
    color: "primary",
    onClick: a
  }, c), v && Ne(ih, {
    color: "primary",
    onClick: s
  }, d), u && Ne(ih, {
    color: "primary",
    onClick: i
  }, u), l && Ne(ih, {
    color: "primary",
    onClick: n
  }, l)));
};
xA.displayName = "ModalDialog";
var c4 = Fy({
  dialogRoot: {
    minWidth: DE
  },
  dialogRootWider: {
    minWidth: _A
  },
  dialog: {
    "&:first-child": {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: "flex-start",
    "& > *:first-child": {
      marginRight: "auto"
    }
  }
}), d4 = qt(c4, {
  name: "MuiPickersModal"
})(xA), RA = typeof window > "u" ? wr : lD;
function TA(o, t) {
  var e = t[o.key];
  e && (e(), o.preventDefault());
}
function OA(o, t) {
  var e = Cr(t);
  e.current = t, RA(function() {
    if (o) {
      var r = function(i) {
        TA(i, e.current);
      };
      return window.addEventListener("keydown", r), function() {
        window.removeEventListener("keydown", r);
      };
    }
  }, [o]);
}
var AE = function(t) {
  var e = t.open, r = t.children, n = t.okLabel, i = t.cancelLabel, a = t.clearLabel, s = t.todayLabel, l = t.showTodayButton, u = t.clearable, c = t.DialogProps, d = t.showTabs, f = t.wider, v = t.InputComponent, g = t.DateInputProps, m = t.onClear, b = t.onAccept, S = t.onDismiss, R = t.onSetToday, P = Ke(t, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);
  return OA(e, {
    Enter: b
  }), Ne(yn, null, Ne(v, Ce({}, P, g)), Ne(d4, Ce({
    wider: f,
    showTabs: d,
    open: e,
    onClear: m,
    onAccept: b,
    onDismiss: S,
    onSetToday: R,
    clearLabel: a,
    todayLabel: s,
    okLabel: n,
    cancelLabel: i,
    clearable: u,
    showTodayButton: l,
    children: r
  }, c)));
};
process.env.NODE_ENV !== "production" && (AE.propTypes = {
  okLabel: Je.node,
  cancelLabel: Je.node,
  clearLabel: Je.node,
  clearable: Je.bool,
  todayLabel: Je.node,
  showTodayButton: Je.bool,
  DialogProps: Je.object
});
AE.defaultProps = {
  okLabel: "OK",
  cancelLabel: "Cancel",
  clearLabel: "Clear",
  todayLabel: "Today",
  clearable: !1,
  showTodayButton: !1
};
var PA = function(t) {
  var e = t.open;
  t.wider;
  var r = t.children, n = t.PopoverProps;
  t.onClear;
  var i = t.onDismiss;
  t.onSetToday;
  var a = t.onAccept;
  t.showTabs;
  var s = t.DateInputProps, l = t.InputComponent, u = Ke(t, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]), c = Cr();
  return OA(e, {
    Enter: a
  }), Ne(yn, null, Ne(l, Ce({}, u, s, {
    inputRef: c
  })), Ne(EA, Ce({
    open: e,
    onClose: i,
    anchorEl: c.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    children: r
  }, n)));
};
process.env.NODE_ENV !== "production" && (PA.propTypes = {
  onOpen: Je.func,
  onClose: Je.func,
  PopoverProps: Je.object
});
function p4(o) {
  switch (o) {
    case "inline":
      return PA;
    case "static":
      return u4;
    default:
      return AE;
  }
}
var ME = Mi(null), f4 = function(t) {
  var e = t.variant, r = Ke(t, ["variant"]), n = p4(e);
  return Ne(ME.Provider, {
    value: e || "dialog"
  }, Ne(n, r));
};
function fp(o) {
  var t = o.props, e = o.states, r = o.muiFormControl;
  return e.reduce(function(n, i) {
    return n[i] = t[i], r && typeof t[i] > "u" && (n[i] = r[i]), n;
  }, {});
}
var FE = z.createContext();
process.env.NODE_ENV !== "production" && (FE.displayName = "FormControlContext");
function DA() {
  return z.useContext(FE);
}
const Ny = FE;
function lg(o, t) {
  return parseInt(o[t], 10) || 0;
}
var h4 = typeof window < "u" ? z.useLayoutEffect : z.useEffect, v4 = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
}, AA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.onChange, n = t.rows, i = t.rowsMax, a = t.rowsMin, s = t.maxRows, l = t.minRows, u = l === void 0 ? 1 : l, c = t.style, d = t.value, f = Ke(t, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]), v = s || i, g = n || a || u, m = z.useRef(d != null), b = m.current, S = z.useRef(null), R = Jn(e, S), P = z.useRef(null), D = z.useRef(0), x = z.useState({}), M = x[0], F = x[1], H = z.useCallback(function() {
    var j = S.current, V = window.getComputedStyle(j), W = P.current;
    W.style.width = V.width, W.value = j.value || t.placeholder || "x", W.value.slice(-1) === `
` && (W.value += " ");
    var q = V["box-sizing"], ee = lg(V, "padding-bottom") + lg(V, "padding-top"), re = lg(V, "border-bottom-width") + lg(V, "border-top-width"), ie = W.scrollHeight - ee;
    W.value = "x";
    var ne = W.scrollHeight - ee, se = ie;
    g && (se = Math.max(Number(g) * ne, se)), v && (se = Math.min(Number(v) * ne, se)), se = Math.max(se, ne);
    var pe = se + (q === "border-box" ? ee + re : 0), K = Math.abs(se - ie) <= 1;
    F(function(J) {
      return D.current < 20 && (pe > 0 && Math.abs((J.outerHeightStyle || 0) - pe) > 1 || J.overflow !== K) ? (D.current += 1, {
        overflow: K,
        outerHeightStyle: pe
      }) : (process.env.NODE_ENV !== "production" && D.current === 20 && console.error(["Material-UI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), J);
    });
  }, [v, g, t.placeholder]);
  z.useEffect(function() {
    var j = bA(function() {
      D.current = 0, H();
    });
    return window.addEventListener("resize", j), function() {
      j.clear(), window.removeEventListener("resize", j);
    };
  }, [H]), h4(function() {
    H();
  }), z.useEffect(function() {
    D.current = 0;
  }, [d]);
  var B = function(V) {
    D.current = 0, b || H(), r && r(V);
  };
  return /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement("textarea", Ce({
    value: d,
    onChange: B,
    ref: R,
    rows: g,
    style: Ce({
      height: M.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: M.overflow ? "hidden" : null
    }, c)
  }, f)), /* @__PURE__ */ z.createElement("textarea", {
    "aria-hidden": !0,
    className: t.className,
    readOnly: !0,
    ref: P,
    tabIndex: -1,
    style: Ce({}, v4.shadow, c)
  }));
});
process.env.NODE_ENV !== "production" && (AA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  className: _.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * Minimum number of rows to display.
   */
  minRows: _.oneOfType([_.number, _.string]),
  /**
   * @ignore
   */
  onChange: _.func,
  /**
   * @ignore
   */
  placeholder: _.string,
  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rows: Zt(_.oneOfType([_.number, _.string]), "Use `minRows` instead."),
  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: Zt(_.oneOfType([_.number, _.string]), "Use `maxRows` instead."),
  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: Zt(_.oneOfType([_.number, _.string]), "Use `minRows` instead."),
  /**
   * @ignore
   */
  style: _.object,
  /**
   * @ignore
   */
  value: _.oneOfType([_.arrayOf(_.string), _.number, _.string])
});
function DR(o) {
  return o != null && !(Array.isArray(o) && o.length === 0);
}
function IE(o) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return o && (DR(o.value) && o.value !== "" || t && DR(o.defaultValue) && o.defaultValue !== "");
}
function g4(o) {
  return o.startAdornment;
}
var m4 = function(t) {
  var e = t.palette.type === "light", r = {
    color: "currentColor",
    opacity: e ? 0.42 : 0.5,
    transition: t.transitions.create("opacity", {
      duration: t.transitions.duration.shorter
    })
  }, n = {
    opacity: "0 !important"
  }, i = {
    opacity: e ? 0.42 : 0.5
  };
  return {
    "@global": {
      "@keyframes mui-auto-fill": {},
      "@keyframes mui-auto-fill-cancel": {}
    },
    /* Styles applied to the root element. */
    root: Ce({}, t.typography.body1, {
      color: t.palette.text.primary,
      lineHeight: "1.1876em",
      // Reset (19px), match the native input line-height
      boxSizing: "border-box",
      // Prevent padding issue with fullWidth.
      position: "relative",
      cursor: "text",
      display: "inline-flex",
      alignItems: "center",
      "&$disabled": {
        color: t.palette.text.disabled,
        cursor: "default"
      }
    }),
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(6, "px 0 ").concat(7, "px"),
      "&$marginDense": {
        paddingTop: 3
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the `input` element. */
    input: {
      font: "inherit",
      letterSpacing: "inherit",
      color: "currentColor",
      padding: "".concat(6, "px 0 ").concat(7, "px"),
      border: 0,
      boxSizing: "content-box",
      background: "none",
      height: "1.1876em",
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: "transparent",
      display: "block",
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: "100%",
      // Fix IE 11 width issue
      animationName: "mui-auto-fill-cancel",
      animationDuration: "10ms",
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&:-ms-input-placeholder": r,
      // IE 11
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus": {
        outline: 0
      },
      // Reset Firefox invalid required input style
      "&:invalid": {
        boxShadow: "none"
      },
      "&::-webkit-search-decoration": {
        // Remove the padding when type=search.
        "-webkit-appearance": "none"
      },
      // Show and hide the placeholder logic
      "label[data-shrink=false] + $formControl &": {
        "&::-webkit-input-placeholder": n,
        "&::-moz-placeholder": n,
        // Firefox 19+
        "&:-ms-input-placeholder": n,
        // IE 11
        "&::-ms-input-placeholder": n,
        // Edge
        "&:focus::-webkit-input-placeholder": i,
        "&:focus::-moz-placeholder": i,
        // Firefox 19+
        "&:focus:-ms-input-placeholder": i,
        // IE 11
        "&:focus::-ms-input-placeholder": i
        // Edge
      },
      "&$disabled": {
        opacity: 1
        // Reset iOS opacity
      },
      "&:-webkit-autofill": {
        animationDuration: "5000s",
        animationName: "mui-auto-fill"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 3
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: "auto",
      resize: "none",
      padding: 0
    },
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield"
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},
    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
}, y4 = typeof window > "u" ? z.useEffect : z.useLayoutEffect, MA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t["aria-describedby"], n = t.autoComplete, i = t.autoFocus, a = t.classes, s = t.className;
  t.color;
  var l = t.defaultValue, u = t.disabled, c = t.endAdornment;
  t.error;
  var d = t.fullWidth, f = d === void 0 ? !1 : d, v = t.id, g = t.inputComponent, m = g === void 0 ? "input" : g, b = t.inputProps, S = b === void 0 ? {} : b, R = t.inputRef;
  t.margin;
  var P = t.multiline, D = P === void 0 ? !1 : P, x = t.name, M = t.onBlur, F = t.onChange, H = t.onClick, B = t.onFocus, j = t.onKeyDown, V = t.onKeyUp, W = t.placeholder, q = t.readOnly, ee = t.renderSuffix, re = t.rows, ie = t.rowsMax, ne = t.rowsMin, se = t.maxRows, pe = t.minRows, K = t.startAdornment, J = t.type, ue = J === void 0 ? "text" : J, he = t.value, fe = Ke(t, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]), ae = S.value != null ? S.value : he, oe = z.useRef(ae != null), ve = oe.current, _e = z.useRef(), le = z.useCallback(function(lt) {
    process.env.NODE_ENV !== "production" && lt && lt.nodeName !== "INPUT" && !lt.focus && console.error(["Material-UI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `inputRef` prop.", "Make sure the `inputRef` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Ee = Jn(S.ref, le), de = Jn(R, Ee), X = Jn(_e, de), xe = z.useState(!1), Le = xe[0], Ue = xe[1], He = DA();
  process.env.NODE_ENV !== "production" && z.useEffect(function() {
    if (He)
      return He.registerEffect();
  }, [He]);
  var et = fp({
    props: t,
    muiFormControl: He,
    states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
  });
  et.focused = He ? He.focused : Le, z.useEffect(function() {
    !He && u && Le && (Ue(!1), M && M());
  }, [He, u, Le, M]);
  var $e = He && He.onFilled, pt = He && He.onEmpty, st = z.useCallback(function(lt) {
    IE(lt) ? $e && $e() : pt && pt();
  }, [$e, pt]);
  y4(function() {
    ve && st({
      value: ae
    });
  }, [ae, st, ve]);
  var Bt = function(Et) {
    if (et.disabled) {
      Et.stopPropagation();
      return;
    }
    B && B(Et), S.onFocus && S.onFocus(Et), He && He.onFocus ? He.onFocus(Et) : Ue(!0);
  }, vt = function(Et) {
    M && M(Et), S.onBlur && S.onBlur(Et), He && He.onBlur ? He.onBlur(Et) : Ue(!1);
  }, nt = function(Et) {
    if (!ve) {
      var kt = Et.target || _e.current;
      if (kt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : tp(1));
      st({
        value: kt.value
      });
    }
    for (var $t = arguments.length, br = new Array($t > 1 ? $t - 1 : 0), mt = 1; mt < $t; mt++)
      br[mt - 1] = arguments[mt];
    S.onChange && S.onChange.apply(S, [Et].concat(br)), F && F.apply(void 0, [Et].concat(br));
  };
  z.useEffect(function() {
    st(_e.current);
  }, []);
  var ze = function(Et) {
    _e.current && Et.currentTarget === Et.target && _e.current.focus(), H && H(Et);
  }, Ct = m, Mt = Ce({}, S, {
    ref: X
  });
  typeof Ct != "string" ? Mt = Ce({
    // Rename ref to inputRef as we don't know the
    // provided `inputComponent` structure.
    inputRef: X,
    type: ue
  }, Mt, {
    ref: null
  }) : D ? re && !se && !pe && !ie && !ne ? Ct = "textarea" : (Mt = Ce({
    minRows: re || pe,
    rowsMax: ie,
    maxRows: se
  }, Mt), Ct = AA) : Mt = Ce({
    type: ue
  }, Mt);
  var fr = function(Et) {
    st(Et.animationName === "mui-auto-fill-cancel" ? _e.current : {
      value: "x"
    });
  };
  return z.useEffect(function() {
    He && He.setAdornedStart(!!K);
  }, [He, K]), /* @__PURE__ */ z.createElement("div", Ce({
    className: Xe(a.root, a["color".concat(Xr(et.color || "primary"))], s, et.disabled && a.disabled, et.error && a.error, f && a.fullWidth, et.focused && a.focused, He && a.formControl, D && a.multiline, K && a.adornedStart, c && a.adornedEnd, et.margin === "dense" && a.marginDense),
    onClick: ze,
    ref: e
  }, fe), K, /* @__PURE__ */ z.createElement(Ny.Provider, {
    value: null
  }, /* @__PURE__ */ z.createElement(Ct, Ce({
    "aria-invalid": et.error,
    "aria-describedby": r,
    autoComplete: n,
    autoFocus: i,
    defaultValue: l,
    disabled: et.disabled,
    id: v,
    onAnimationStart: fr,
    name: x,
    placeholder: W,
    readOnly: q,
    required: et.required,
    rows: re,
    value: ae,
    onKeyDown: j,
    onKeyUp: V
  }, Mt, {
    className: Xe(a.input, S.className, et.disabled && a.disabled, D && a.inputMultiline, et.hiddenLabel && a.inputHiddenLabel, K && a.inputAdornedStart, c && a.inputAdornedEnd, ue === "search" && a.inputTypeSearch, et.margin === "dense" && a.inputMarginDense),
    onBlur: vt,
    onChange: nt,
    onFocus: Bt
  }))), c, ee ? ee(Ce({}, et, {
    startAdornment: K
  })) : null);
});
process.env.NODE_ENV !== "production" && (MA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  "aria-describedby": _.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _.string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The id of the `input` element.
   */
  id: _.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: _.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Va,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _.oneOfType([_.number, _.string]),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _.string,
  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: _.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * @ignore
   */
  onClick: _.func,
  /**
   * @ignore
   */
  onFocus: _.func,
  /**
   * @ignore
   */
  onKeyDown: _.func,
  /**
   * @ignore
   */
  onKeyUp: _.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _.bool,
  /**
   * @ignore
   */
  renderSuffix: _.func,
  /**
   * If `true`, the `input` element will be required.
   */
  required: _.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _.oneOfType([_.number, _.string]),
  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: _.oneOfType([_.number, _.string]),
  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: _.oneOfType([_.number, _.string]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _.any
});
const LE = qt(m4, {
  name: "MuiInputBase"
})(MA);
var C4 = function(t) {
  var e = t.palette.type === "light", r = e ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative"
    },
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      "label + &": {
        marginTop: 16
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: t.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(t.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: t.transitions.create("transform", {
          duration: t.transitions.duration.shorter,
          easing: t.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: t.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(r),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: t.transitions.create("border-bottom-color", {
          duration: t.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:not($disabled):before": {
        borderBottom: "2px solid ".concat(t.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          borderBottom: "1px solid ".concat(r)
        }
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /* Styles applied to the `input` element. */
    input: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
}, NE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.disableUnderline, n = t.classes, i = t.fullWidth, a = i === void 0 ? !1 : i, s = t.inputComponent, l = s === void 0 ? "input" : s, u = t.multiline, c = u === void 0 ? !1 : u, d = t.type, f = d === void 0 ? "text" : d, v = Ke(t, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ z.createElement(LE, Ce({
    classes: Ce({}, n, {
      root: Xe(n.root, !r && n.underline),
      underline: null
    }),
    fullWidth: a,
    inputComponent: l,
    multiline: c,
    ref: e,
    type: f
  }, v));
});
process.env.NODE_ENV !== "production" && (NE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _.string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The id of the `input` element.
   */
  id: _.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: _.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Va,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _.bool,
  /**
   * If `true`, the `input` element will be required.
   */
  required: _.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _.oneOfType([_.number, _.string]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _.any
});
NE.muiName = "Input";
const kE = qt(C4, {
  name: "MuiInput"
})(NE);
var w4 = function(t) {
  var e = t.palette.type === "light", r = e ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", n = e ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      backgroundColor: n,
      borderTopLeftRadius: t.shape.borderRadius,
      borderTopRightRadius: t.shape.borderRadius,
      transition: t.transitions.create("background-color", {
        duration: t.transitions.duration.shorter,
        easing: t.transitions.easing.easeOut
      }),
      "&:hover": {
        backgroundColor: e ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: n
        }
      },
      "&$focused": {
        backgroundColor: e ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
      },
      "&$disabled": {
        backgroundColor: e ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
      }
    },
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: t.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(t.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: t.transitions.create("transform", {
          duration: t.transitions.duration.shorter,
          easing: t.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: t.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(r),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: t.transitions.create("border-bottom-color", {
          duration: t.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:before": {
        borderBottom: "1px solid ".concat(t.palette.text.primary)
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "27px 12px 10px",
      "&$marginDense": {
        paddingTop: 23,
        paddingBottom: 6
      }
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "27px 12px 10px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: t.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: t.palette.type === "light" ? null : "#fff",
        caretColor: t.palette.type === "light" ? null : "#fff",
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },
    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      "&$inputMarginDense": {
        paddingTop: 10,
        paddingBottom: 11
      }
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
}, GE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.disableUnderline, n = t.classes, i = t.fullWidth, a = i === void 0 ? !1 : i, s = t.inputComponent, l = s === void 0 ? "input" : s, u = t.multiline, c = u === void 0 ? !1 : u, d = t.type, f = d === void 0 ? "text" : d, v = Ke(t, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ z.createElement(LE, Ce({
    classes: Ce({}, n, {
      root: Xe(n.root, !r && n.underline),
      underline: null
    }),
    fullWidth: a,
    inputComponent: l,
    multiline: c,
    ref: e,
    type: f
  }, v));
});
process.env.NODE_ENV !== "production" && (GE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _.string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The id of the `input` element.
   */
  id: _.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: _.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Va,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _.bool,
  /**
   * If `true`, the `input` element will be required.
   */
  required: _.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _.oneOfType([_.number, _.string]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _.any
});
GE.muiName = "Input";
const FA = qt(w4, {
  name: "MuiFilledInput"
})(GE);
var b4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "absolute",
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: "0 8px",
      pointerEvents: "none",
      borderRadius: "inherit",
      borderStyle: "solid",
      borderWidth: 1,
      overflow: "hidden"
    },
    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: "left",
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: t.transitions.create("width", {
        duration: 150,
        easing: t.transitions.easing.easeOut
      })
    },
    /* Styles applied to the legend element. */
    legendLabelled: {
      display: "block",
      width: "auto",
      textAlign: "left",
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: t.transitions.create("max-width", {
        duration: 50,
        easing: t.transitions.easing.easeOut
      }),
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block"
      }
    },
    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1e3,
      transition: t.transitions.create("max-width", {
        duration: 100,
        easing: t.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
}, IA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  t.children;
  var r = t.classes, n = t.className, i = t.label, a = t.labelWidth, s = t.notched, l = t.style, u = Ke(t, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]), c = ov(), d = c.direction === "rtl" ? "right" : "left";
  if (i !== void 0)
    return /* @__PURE__ */ z.createElement("fieldset", Ce({
      "aria-hidden": !0,
      className: Xe(r.root, n),
      ref: e,
      style: l
    }, u), /* @__PURE__ */ z.createElement("legend", {
      className: Xe(r.legendLabelled, s && r.legendNotched)
    }, i ? /* @__PURE__ */ z.createElement("span", null, i) : /* @__PURE__ */ z.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })));
  var f = a > 0 ? a * 0.75 + 8 : 0.01;
  return /* @__PURE__ */ z.createElement("fieldset", Ce({
    "aria-hidden": !0,
    style: Ce(Cn({}, "padding".concat(Xr(d)), 8), l),
    className: Xe(r.root, n),
    ref: e
  }, u), /* @__PURE__ */ z.createElement("legend", {
    className: r.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: s ? f : 0.01
    }
  }, /* @__PURE__ */ z.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "&#8203;"
    }
  })));
});
process.env.NODE_ENV !== "production" && (IA.propTypes = {
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The label.
   */
  label: _.node,
  /**
   * The width of the label.
   */
  labelWidth: _.number.isRequired,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _.bool.isRequired,
  /**
   * @ignore
   */
  style: _.object
});
const S4 = qt(b4, {
  name: "PrivateNotchedOutline"
})(IA);
var E4 = function(t) {
  var e = t.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      borderRadius: t.shape.borderRadius,
      "&:hover $notchedOutline": {
        borderColor: t.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        "&:hover $notchedOutline": {
          borderColor: e
        }
      },
      "&$focused $notchedOutline": {
        borderColor: t.palette.primary.main,
        borderWidth: 2
      },
      "&$error $notchedOutline": {
        borderColor: t.palette.error.main
      },
      "&$disabled $notchedOutline": {
        borderColor: t.palette.action.disabled
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused $notchedOutline": {
        borderColor: t.palette.secondary.main
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "18.5px 14px",
      "&$marginDense": {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },
    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: e
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "18.5px 14px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: t.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: t.palette.type === "light" ? null : "#fff",
        caretColor: t.palette.type === "light" ? null : "#fff",
        borderRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
}, VE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.fullWidth, i = n === void 0 ? !1 : n, a = t.inputComponent, s = a === void 0 ? "input" : a, l = t.label, u = t.labelWidth, c = u === void 0 ? 0 : u, d = t.multiline, f = d === void 0 ? !1 : d, v = t.notched, g = t.type, m = g === void 0 ? "text" : g, b = Ke(t, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
  return /* @__PURE__ */ z.createElement(LE, Ce({
    renderSuffix: function(R) {
      return /* @__PURE__ */ z.createElement(S4, {
        className: r.notchedOutline,
        label: l,
        labelWidth: c,
        notched: typeof v < "u" ? v : !!(R.startAdornment || R.filled || R.focused)
      });
    },
    classes: Ce({}, r, {
      root: Xe(r.root, r.underline),
      notchedOutline: null
    }),
    fullWidth: i,
    inputComponent: s,
    multiline: f,
    ref: e,
    type: m
  }, b));
});
process.env.NODE_ENV !== "production" && (VE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _.string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The id of the `input` element.
   */
  id: _.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: _.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Va,
  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: _.node,
  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: _.number,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _.bool,
  /**
   * If `true`, the `input` element will be required.
   */
  required: _.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _.oneOfType([_.number, _.string]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _.any
});
VE.muiName = "Input";
const LA = qt(E4, {
  name: "MuiOutlinedInput"
})(VE);
function iv() {
  return z.useContext(Ny);
}
var _4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: Ce({
      color: t.palette.text.secondary
    }, t.typography.body1, {
      lineHeight: 1,
      padding: 0,
      "&$focused": {
        color: t.palette.primary.main
      },
      "&$disabled": {
        color: t.palette.text.disabled
      },
      "&$error": {
        color: t.palette.error.main
      }
    }),
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused": {
        color: t.palette.secondary.main
      }
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Styles applied to the asterisk element. */
    asterisk: {
      "&$error": {
        color: t.palette.error.main
      }
    }
  };
}, NA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className;
  t.color;
  var a = t.component, s = a === void 0 ? "label" : a;
  t.disabled, t.error, t.filled, t.focused, t.required;
  var l = Ke(t, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]), u = iv(), c = fp({
    props: t,
    muiFormControl: u,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  });
  return /* @__PURE__ */ z.createElement(s, Ce({
    className: Xe(n.root, n["color".concat(Xr(c.color || "primary"))], i, c.disabled && n.disabled, c.error && n.error, c.filled && n.filled, c.focused && n.focused, c.required && n.required),
    ref: e
  }, l), r, c.required && /* @__PURE__ */ z.createElement("span", {
    "aria-hidden": !0,
    className: Xe(n.asterisk, c.error && n.error)
  }, " ", "*"));
});
process.env.NODE_ENV !== "production" && (NA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _.bool,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _.bool
});
const x4 = qt(_4, {
  name: "MuiFormLabel"
})(NA);
var R4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "block",
      transformOrigin: "top left"
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 24px) scale(1)"
    },
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: "translate(0, 21px) scale(1)"
    },
    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: "translate(0, 1.5px) scale(0.75)",
      transformOrigin: "top left"
    },
    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: t.transitions.create(["color", "transform"], {
        duration: t.transitions.duration.shorter,
        easing: t.transitions.easing.easeOut
      })
    },
    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(12px, 17px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(12px, 10px) scale(0.75)",
        "&$marginDense": {
          transform: "translate(12px, 7px) scale(0.75)"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(14px, 12px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(14px, -6px) scale(0.75)"
      }
    }
  };
}, kA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.disableAnimation, a = i === void 0 ? !1 : i;
  t.margin;
  var s = t.shrink;
  t.variant;
  var l = Ke(t, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]), u = iv(), c = s;
  typeof c > "u" && u && (c = u.filled || u.focused || u.adornedStart);
  var d = fp({
    props: t,
    muiFormControl: u,
    states: ["margin", "variant"]
  });
  return /* @__PURE__ */ z.createElement(x4, Ce({
    "data-shrink": c,
    className: Xe(r.root, n, u && r.formControl, !a && r.animated, c && r.shrink, d.margin === "dense" && r.marginDense, {
      filled: r.filled,
      outlined: r.outlined
    }[d.variant]),
    classes: {
      focused: r.focused,
      disabled: r.disabled,
      error: r.error,
      required: r.required,
      asterisk: r.asterisk
    },
    ref: e
  }, l));
});
process.env.NODE_ENV !== "production" && (kA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The contents of the `InputLabel`.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _.bool,
  /**
   * If `true`, apply disabled class.
   */
  disabled: _.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _.bool,
  /**
   * If `true`, the input of this label is focused.
   */
  focused: _.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: _.bool,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
const T4 = qt(R4, {
  name: "MuiInputLabel"
})(kA);
function ow(o, t) {
  return /* @__PURE__ */ z.isValidElement(o) && t.indexOf(o.type.muiName) !== -1;
}
var O4 = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top"
    // Fix alignment issue on Safari.
  },
  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },
  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },
  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: "100%"
  }
}, GA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.color, s = a === void 0 ? "primary" : a, l = t.component, u = l === void 0 ? "div" : l, c = t.disabled, d = c === void 0 ? !1 : c, f = t.error, v = f === void 0 ? !1 : f, g = t.fullWidth, m = g === void 0 ? !1 : g, b = t.focused, S = t.hiddenLabel, R = S === void 0 ? !1 : S, P = t.margin, D = P === void 0 ? "none" : P, x = t.required, M = x === void 0 ? !1 : x, F = t.size, H = t.variant, B = H === void 0 ? "standard" : H, j = Ke(t, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]), V = z.useState(function() {
    var oe = !1;
    return r && z.Children.forEach(r, function(ve) {
      if (ow(ve, ["Input", "Select"])) {
        var _e = ow(ve, ["Select"]) ? ve.props.input : ve;
        _e && g4(_e.props) && (oe = !0);
      }
    }), oe;
  }), W = V[0], q = V[1], ee = z.useState(function() {
    var oe = !1;
    return r && z.Children.forEach(r, function(ve) {
      ow(ve, ["Input", "Select"]) && IE(ve.props, !0) && (oe = !0);
    }), oe;
  }), re = ee[0], ie = ee[1], ne = z.useState(!1), se = ne[0], pe = ne[1], K = b !== void 0 ? b : se;
  d && K && pe(!1);
  var J;
  if (process.env.NODE_ENV !== "production") {
    var ue = z.useRef(!1);
    J = function() {
      return ue.current && console.error(["Material-UI: There are multiple InputBase components inside a FormControl.", "This is not supported. It might cause infinite rendering loops.", "Only use one InputBase."].join(`
`)), ue.current = !0, function() {
        ue.current = !1;
      };
    };
  }
  var he = z.useCallback(function() {
    ie(!0);
  }, []), fe = z.useCallback(function() {
    ie(!1);
  }, []), ae = {
    adornedStart: W,
    setAdornedStart: q,
    color: s,
    disabled: d,
    error: v,
    filled: re,
    focused: K,
    fullWidth: m,
    hiddenLabel: R,
    margin: (F === "small" ? "dense" : void 0) || D,
    onBlur: function() {
      pe(!1);
    },
    onEmpty: fe,
    onFilled: he,
    onFocus: function() {
      pe(!0);
    },
    registerEffect: J,
    required: M,
    variant: B
  };
  return /* @__PURE__ */ z.createElement(Ny.Provider, {
    value: ae
  }, /* @__PURE__ */ z.createElement(u, Ce({
    className: Xe(n.root, i, D !== "none" && n["margin".concat(Xr(D))], m && n.fullWidth),
    ref: e
  }, j), r));
});
process.env.NODE_ENV !== "production" && (GA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The contents of the form control.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _.bool,
  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: _.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: _.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _.bool,
  /**
   * The size of the text field.
   */
  size: _.oneOf(["medium", "small"]),
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
const P4 = qt(O4, {
  name: "MuiFormControl"
})(GA);
var D4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: Ce({
      color: t.palette.text.secondary
    }, t.typography.caption, {
      textAlign: "left",
      marginTop: 3,
      margin: 0,
      "&$disabled": {
        color: t.palette.text.disabled
      },
      "&$error": {
        color: t.palette.error.main
      }
    }),
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },
    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
}, VA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.component, s = a === void 0 ? "p" : a;
  t.disabled, t.error, t.filled, t.focused, t.margin, t.required, t.variant;
  var l = Ke(t, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]), u = iv(), c = fp({
    props: t,
    muiFormControl: u,
    states: ["variant", "margin", "disabled", "error", "filled", "focused", "required"]
  });
  return /* @__PURE__ */ z.createElement(s, Ce({
    className: Xe(n.root, (c.variant === "filled" || c.variant === "outlined") && n.contained, i, c.disabled && n.disabled, c.error && n.error, c.filled && n.filled, c.focused && n.focused, c.required && n.required, c.margin === "dense" && n.marginDense),
    ref: e
  }, l), r === " " ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ z.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : r);
});
process.env.NODE_ENV !== "production" && (VA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _.bool,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
const A4 = qt(D4, {
  name: "MuiFormHelperText"
})(VA);
var HA = z.createContext({});
process.env.NODE_ENV !== "production" && (HA.displayName = "ListContext");
var M4 = {
  /* Styles applied to the root element. */
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative"
  },
  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },
  /* Styles applied to the root element if dense. */
  dense: {},
  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
}, BA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.component, s = a === void 0 ? "ul" : a, l = t.dense, u = l === void 0 ? !1 : l, c = t.disablePadding, d = c === void 0 ? !1 : c, f = t.subheader, v = Ke(t, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]), g = z.useMemo(function() {
    return {
      dense: u
    };
  }, [u]);
  return /* @__PURE__ */ z.createElement(HA.Provider, {
    value: g
  }, /* @__PURE__ */ z.createElement(s, Ce({
    className: Xe(n.root, i, u && n.dense, !d && n.padding, f && n.subheader),
    ref: e
  }, v), f, r));
});
process.env.NODE_ENV !== "production" && (BA.propTypes = {
  /**
   * The content of the component.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: _.bool,
  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _.node
});
const F4 = qt(M4, {
  name: "MuiList"
})(BA);
function iw(o, t, e) {
  return o === t ? o.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e ? null : o.firstChild;
}
function AR(o, t, e) {
  return o === t ? e ? o.firstChild : o.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e ? null : o.lastChild;
}
function WA(o, t) {
  if (t === void 0)
    return !0;
  var e = o.innerText;
  return e === void 0 && (e = o.textContent), e = e.trim().toLowerCase(), e.length === 0 ? !1 : t.repeating ? e[0] === t.keys[0] : e.indexOf(t.keys.join("")) === 0;
}
function vf(o, t, e, r, n, i) {
  for (var a = !1, s = n(o, t, t ? e : !1); s; ) {
    if (s === o.firstChild) {
      if (a)
        return;
      a = !0;
    }
    var l = r ? !1 : s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || !WA(s, i) || l)
      s = n(o, s, e);
    else {
      s.focus();
      return;
    }
  }
}
var I4 = typeof window > "u" ? z.useEffect : z.useLayoutEffect, jA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.actions, n = t.autoFocus, i = n === void 0 ? !1 : n, a = t.autoFocusItem, s = a === void 0 ? !1 : a, l = t.children, u = t.className, c = t.disabledItemsFocusable, d = c === void 0 ? !1 : c, f = t.disableListWrap, v = f === void 0 ? !1 : f, g = t.onKeyDown, m = t.variant, b = m === void 0 ? "selectedMenu" : m, S = Ke(t, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]), R = z.useRef(null), P = z.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  I4(function() {
    i && R.current.focus();
  }, [i]), z.useImperativeHandle(r, function() {
    return {
      adjustStyleForScrollbar: function(j, V) {
        var W = !R.current.style.width;
        if (j.clientHeight < R.current.clientHeight && W) {
          var q = "".concat(fA(), "px");
          R.current.style[V.direction === "rtl" ? "paddingLeft" : "paddingRight"] = q, R.current.style.width = "calc(100% + ".concat(q, ")");
        }
        return R.current;
      }
    };
  }, []);
  var D = function(j) {
    var V = R.current, W = j.key, q = Es(V).activeElement;
    if (W === "ArrowDown")
      j.preventDefault(), vf(V, q, v, d, iw);
    else if (W === "ArrowUp")
      j.preventDefault(), vf(V, q, v, d, AR);
    else if (W === "Home")
      j.preventDefault(), vf(V, null, v, d, iw);
    else if (W === "End")
      j.preventDefault(), vf(V, null, v, d, AR);
    else if (W.length === 1) {
      var ee = P.current, re = W.toLowerCase(), ie = performance.now();
      ee.keys.length > 0 && (ie - ee.lastTime > 500 ? (ee.keys = [], ee.repeating = !0, ee.previousKeyMatched = !0) : ee.repeating && re !== ee.keys[0] && (ee.repeating = !1)), ee.lastTime = ie, ee.keys.push(re);
      var ne = q && !ee.repeating && WA(q, ee);
      ee.previousKeyMatched && (ne || vf(V, q, !1, d, iw, ee)) ? j.preventDefault() : ee.previousKeyMatched = !1;
    }
    g && g(j);
  }, x = z.useCallback(function(B) {
    R.current = _s.findDOMNode(B);
  }, []), M = Jn(x, e), F = -1;
  z.Children.forEach(l, function(B, j) {
    /* @__PURE__ */ z.isValidElement(B) && (process.env.NODE_ENV !== "production" && Dh.isFragment(B) && console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), B.props.disabled || (b === "selectedMenu" && B.props.selected || F === -1) && (F = j));
  });
  var H = z.Children.map(l, function(B, j) {
    if (j === F) {
      var V = {};
      return s && (V.autoFocus = !0), B.props.tabIndex === void 0 && b === "selectedMenu" && (V.tabIndex = 0), /* @__PURE__ */ z.cloneElement(B, V);
    }
    return B;
  });
  return /* @__PURE__ */ z.createElement(F4, Ce({
    role: "menu",
    ref: M,
    className: u,
    onKeyDown: D,
    tabIndex: i ? 0 : -1
  }, S), H);
});
process.env.NODE_ENV !== "production" && (jA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: _.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: _.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _.node,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: _.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: _.bool,
  /**
   * @ignore
   */
  onKeyDown: _.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: _.oneOf(["menu", "selectedMenu"])
});
var MR = {
  vertical: "top",
  horizontal: "right"
}, FR = {
  vertical: "top",
  horizontal: "left"
}, L4 = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: "touch"
  },
  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
}, UA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.autoFocus, n = r === void 0 ? !0 : r, i = t.children, a = t.classes, s = t.disableAutoFocusItem, l = s === void 0 ? !1 : s, u = t.MenuListProps, c = u === void 0 ? {} : u, d = t.onClose, f = t.onEntering, v = t.open, g = t.PaperProps, m = g === void 0 ? {} : g, b = t.PopoverClasses, S = t.transitionDuration, R = S === void 0 ? "auto" : S, P = t.TransitionProps;
  P = P === void 0 ? {} : P;
  var D = P.onEntering, x = Ke(P, ["onEntering"]), M = t.variant, F = M === void 0 ? "selectedMenu" : M, H = Ke(t, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]), B = ov(), j = n && !l && v, V = z.useRef(null), W = z.useRef(null), q = function() {
    return W.current;
  }, ee = function(pe, K) {
    V.current && V.current.adjustStyleForScrollbar(pe, B), f && f(pe, K), D && D(pe, K);
  }, re = function(pe) {
    pe.key === "Tab" && (pe.preventDefault(), d && d(pe, "tabKeyDown"));
  }, ie = -1;
  z.Children.map(i, function(se, pe) {
    /* @__PURE__ */ z.isValidElement(se) && (process.env.NODE_ENV !== "production" && Dh.isFragment(se) && console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), se.props.disabled || (F !== "menu" && se.props.selected || ie === -1) && (ie = pe));
  });
  var ne = z.Children.map(i, function(se, pe) {
    return pe === ie ? /* @__PURE__ */ z.cloneElement(se, {
      ref: function(J) {
        W.current = _s.findDOMNode(J), Ih(se.ref, J);
      }
    }) : se;
  });
  return /* @__PURE__ */ z.createElement(EA, Ce({
    getContentAnchorEl: q,
    classes: b,
    onClose: d,
    TransitionProps: Ce({
      onEntering: ee
    }, x),
    anchorOrigin: B.direction === "rtl" ? MR : FR,
    transformOrigin: B.direction === "rtl" ? MR : FR,
    PaperProps: Ce({}, m, {
      classes: Ce({}, m.classes, {
        root: a.paper
      })
    }),
    open: v,
    ref: e,
    transitionDuration: R
  }, H), /* @__PURE__ */ z.createElement(jA, Ce({
    onKeyDown: re,
    actions: V,
    autoFocus: n && (ie === -1 || l),
    autoFocusItem: j,
    variant: F
  }, c, {
    className: Xe(a.list, c.className)
  }), ne));
});
process.env.NODE_ENV !== "production" && (UA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: _.oneOfType([Ah, _.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: _.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: _.bool,
  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: _.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: _.func,
  /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: Zt(_.func, "Use the `TransitionProps` prop instead."),
  /**
   * If `true`, the menu is visible.
   */
  open: _.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: _.object,
  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: _.object,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _.oneOfType([_.oneOf(["auto"]), _.number, _.shape({
    appear: _.number,
    enter: _.number,
    exit: _.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */
  TransitionProps: _.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: _.oneOf(["menu", "selectedMenu"])
});
const N4 = qt(L4, {
  name: "MuiMenu"
})(UA);
function k4(o) {
  var t = o.controlled, e = o.default, r = o.name, n = o.state, i = n === void 0 ? "value" : n, a = z.useRef(t !== void 0), s = a.current, l = z.useState(e), u = l[0], c = l[1], d = s ? t : u;
  if (process.env.NODE_ENV !== "production") {
    z.useEffect(function() {
      s !== (t !== void 0) && console.error(["Material-UI: A component is changing the ".concat(s ? "" : "un", "controlled ").concat(i, " state of ").concat(r, " to be ").concat(s ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(r, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [t]);
    var f = z.useRef(e), v = f.current;
    z.useEffect(function() {
      !s && v !== e && console.error(["Material-UI: A component is changing the default ".concat(i, " state of an uncontrolled ").concat(r, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(r, ".")].join(`
`));
    }, [JSON.stringify(e)]);
  }
  var g = z.useCallback(function(m) {
    s || c(m);
  }, []);
  return [d, g];
}
function IR(o, t) {
  return ka(t) === "object" && t !== null ? o === t : String(o) === String(t);
}
function G4(o) {
  return o == null || typeof o == "string" && !o.trim();
}
var $A = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t["aria-label"], n = t.autoFocus, i = t.autoWidth, a = t.children, s = t.classes, l = t.className, u = t.defaultValue, c = t.disabled, d = t.displayEmpty, f = t.IconComponent, v = t.inputRef, g = t.labelId, m = t.MenuProps, b = m === void 0 ? {} : m, S = t.multiple, R = t.name, P = t.onBlur, D = t.onChange, x = t.onClose, M = t.onFocus, F = t.onOpen, H = t.open, B = t.readOnly, j = t.renderValue, V = t.SelectDisplayProps, W = V === void 0 ? {} : V, q = t.tabIndex;
  t.type;
  var ee = t.value, re = t.variant, ie = re === void 0 ? "standard" : re, ne = Ke(t, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]), se = k4({
    controlled: ee,
    default: u,
    name: "Select"
  }), pe = Bl(se, 2), K = pe[0], J = pe[1], ue = z.useRef(null), he = z.useState(null), fe = he[0], ae = he[1], oe = z.useRef(H != null), ve = oe.current, _e = z.useState(), le = _e[0], Ee = _e[1], de = z.useState(!1), X = de[0], xe = de[1], Le = Jn(e, v);
  z.useImperativeHandle(Le, function() {
    return {
      focus: function() {
        fe.focus();
      },
      node: ue.current,
      value: K
    };
  }, [fe, K]), z.useEffect(function() {
    n && fe && fe.focus();
  }, [n, fe]), z.useEffect(function() {
    if (fe) {
      var mt = Es(fe).getElementById(g);
      if (mt) {
        var rt = function() {
          getSelection().isCollapsed && fe.focus();
        };
        return mt.addEventListener("click", rt), function() {
          mt.removeEventListener("click", rt);
        };
      }
    }
  }, [g, fe]);
  var Ue = function(rt, Gt) {
    rt ? F && F(Gt) : x && x(Gt), ve || (Ee(i ? null : fe.clientWidth), xe(rt));
  }, He = function(rt) {
    rt.button === 0 && (rt.preventDefault(), fe.focus(), Ue(!0, rt));
  }, et = function(rt) {
    Ue(!1, rt);
  }, $e = z.Children.toArray(a), pt = function(rt) {
    var Gt = $e.map(function(Ze) {
      return Ze.props.value;
    }).indexOf(rt.target.value);
    if (Gt !== -1) {
      var zt = $e[Gt];
      J(zt.props.value), D && D(rt, zt);
    }
  }, st = function(rt) {
    return function(Gt) {
      S || Ue(!1, Gt);
      var zt;
      if (S) {
        zt = Array.isArray(K) ? K.slice() : [];
        var Ze = K.indexOf(rt.props.value);
        Ze === -1 ? zt.push(rt.props.value) : zt.splice(Ze, 1);
      } else
        zt = rt.props.value;
      rt.props.onClick && rt.props.onClick(Gt), K !== zt && (J(zt), D && (Gt.persist(), Object.defineProperty(Gt, "target", {
        writable: !0,
        value: {
          value: zt,
          name: R
        }
      }), D(Gt, rt)));
    };
  }, Bt = function(rt) {
    if (!B) {
      var Gt = [
        " ",
        "ArrowUp",
        "ArrowDown",
        // The native select doesn't respond to enter on MacOS, but it's recommended by
        // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
        "Enter"
      ];
      Gt.indexOf(rt.key) !== -1 && (rt.preventDefault(), Ue(!0, rt));
    }
  }, vt = fe !== null && (ve ? H : X), nt = function(rt) {
    !vt && P && (rt.persist(), Object.defineProperty(rt, "target", {
      writable: !0,
      value: {
        value: K,
        name: R
      }
    }), P(rt));
  };
  delete ne["aria-invalid"];
  var ze, Ct, Mt = [], fr = !1, lt = !1;
  (IE({
    value: K
  }) || d) && (j ? ze = j(K) : fr = !0);
  var Et = $e.map(function(mt) {
    if (!/* @__PURE__ */ z.isValidElement(mt))
      return null;
    process.env.NODE_ENV !== "production" && Dh.isFragment(mt) && console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    var rt;
    if (S) {
      if (!Array.isArray(K))
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : tp(2));
      rt = K.some(function(Gt) {
        return IR(Gt, mt.props.value);
      }), rt && fr && Mt.push(mt.props.children);
    } else
      rt = IR(K, mt.props.value), rt && fr && (Ct = mt.props.children);
    return rt && (lt = !0), /* @__PURE__ */ z.cloneElement(mt, {
      "aria-selected": rt ? "true" : void 0,
      onClick: st(mt),
      onKeyUp: function(zt) {
        zt.key === " " && zt.preventDefault(), mt.props.onKeyUp && mt.props.onKeyUp(zt);
      },
      role: "option",
      selected: rt,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": mt.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && z.useEffect(function() {
    if (!lt && !S && K !== "") {
      var mt = $e.map(function(rt) {
        return rt.props.value;
      });
      console.warn(["Material-UI: You have provided an out-of-range value `".concat(K, "` for the select ").concat(R ? '(name="'.concat(R, '") ') : "", "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(mt.filter(function(rt) {
        return rt != null;
      }).map(function(rt) {
        return "`".concat(rt, "`");
      }).join(", ") || '""', ".")].join(`
`));
    }
  }, [lt, $e, S, R, K]), fr && (ze = S ? Mt.join(", ") : Ct);
  var kt = le;
  !i && ve && fe && (kt = fe.clientWidth);
  var $t;
  typeof q < "u" ? $t = q : $t = c ? null : 0;
  var br = W.id || (R ? "mui-component-select-".concat(R) : void 0);
  return /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement("div", Ce({
    className: Xe(
      s.root,
      // TODO v5: merge root and select
      s.select,
      s.selectMenu,
      s[ie],
      l,
      c && s.disabled
    ),
    ref: ae,
    tabIndex: $t,
    role: "button",
    "aria-disabled": c ? "true" : void 0,
    "aria-expanded": vt ? "true" : void 0,
    "aria-haspopup": "listbox",
    "aria-label": r,
    "aria-labelledby": [g, br].filter(Boolean).join(" ") || void 0,
    onKeyDown: Bt,
    onMouseDown: c || B ? null : He,
    onBlur: nt,
    onFocus: M
  }, W, {
    // The id is required for proper a11y
    id: br
  }), G4(ze) ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ z.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : ze), /* @__PURE__ */ z.createElement("input", Ce({
    value: Array.isArray(K) ? K.join(",") : K,
    name: R,
    ref: ue,
    "aria-hidden": !0,
    onChange: pt,
    tabIndex: -1,
    className: s.nativeInput,
    autoFocus: n
  }, ne)), /* @__PURE__ */ z.createElement(f, {
    className: Xe(s.icon, s["icon".concat(Xr(ie))], vt && s.iconOpen, c && s.disabled)
  }), /* @__PURE__ */ z.createElement(N4, Ce({
    id: "menu-".concat(R || ""),
    anchorEl: fe,
    open: vt,
    onClose: et
  }, b, {
    MenuListProps: Ce({
      "aria-labelledby": g,
      role: "listbox",
      disableListWrap: !0
    }, b.MenuListProps),
    PaperProps: Ce({}, b.PaperProps, {
      style: Ce({
        minWidth: kt
      }, b.PaperProps != null ? b.PaperProps.style : null)
    })
  }), Et));
});
process.env.NODE_ENV !== "production" && ($A.propTypes = {
  /**
   * @ignore
   */
  "aria-label": _.string,
  /**
   * @ignore
   */
  autoFocus: _.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * The CSS class name of the select element.
   */
  className: _.string,
  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Va,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: _.string,
  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _.string,
  /**
   * @ignore
   */
  onBlur: _.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: _.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _.func,
  /**
   * @ignore
   */
  onFocus: _.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: _.func,
  /**
   * Control `select` open state.
   */
  open: _.bool,
  /**
   * @ignore
   */
  readOnly: _.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: _.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: _.object,
  /**
   * @ignore
   */
  tabIndex: _.oneOfType([_.number, _.string]),
  /**
   * @ignore
   */
  type: _.any,
  /**
   * The input value.
   */
  value: _.any,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["standard", "outlined", "filled"])
});
var V4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: t.typography.pxToRem(24),
      transition: t.transitions.create("fill", {
        duration: t.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: t.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: t.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: t.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: t.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: t.typography.pxToRem(35)
    }
  };
}, HE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.color, s = a === void 0 ? "inherit" : a, l = t.component, u = l === void 0 ? "svg" : l, c = t.fontSize, d = c === void 0 ? "medium" : c, f = t.htmlColor, v = t.titleAccess, g = t.viewBox, m = g === void 0 ? "0 0 24 24" : g, b = Ke(t, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ z.createElement(u, Ce({
    className: Xe(n.root, i, s !== "inherit" && n["color".concat(Xr(s))], d !== "default" && d !== "medium" && n["fontSize".concat(Xr(d))]),
    focusable: "false",
    viewBox: m,
    color: f,
    "aria-hidden": v ? void 0 : !0,
    role: v ? "img" : void 0,
    ref: e
  }, b), r, v ? /* @__PURE__ */ z.createElement("title", null, v) : null);
});
process.env.NODE_ENV !== "production" && (HE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: _.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: Ga(_.oneOf(["default", "inherit", "large", "medium", "small"]), function(o) {
    var t = o.fontSize;
    if (t === "default")
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: _.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: _.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _.string
});
HE.muiName = "SvgIcon";
const Lh = qt(V4, {
  name: "MuiSvgIcon"
})(HE);
function H4(o, t) {
  var e = function(n, i) {
    return /* @__PURE__ */ y.createElement(Lh, Ce({
      ref: i
    }, n), o);
  };
  return process.env.NODE_ENV !== "production" && (e.displayName = "".concat(t, "Icon")), e.muiName = Lh.muiName, /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(e));
}
const zA = H4(/* @__PURE__ */ z.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
var BE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.disabled, a = t.IconComponent, s = t.inputRef, l = t.variant, u = l === void 0 ? "standard" : l, c = Ke(t, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
  return /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement("select", Ce({
    className: Xe(
      r.root,
      // TODO v5: merge root and select
      r.select,
      r[u],
      n,
      i && r.disabled
    ),
    disabled: i,
    ref: s || e
  }, c)), t.multiple ? null : /* @__PURE__ */ z.createElement(a, {
    className: Xe(r.icon, r["icon".concat(Xr(u))], i && r.disabled)
  }));
});
process.env.NODE_ENV !== "production" && (BE.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * The CSS class name of the select element.
   */
  className: _.string,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Va,
  /**
   * @ignore
   */
  multiple: _.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _.string,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * The input value.
   */
  value: _.any,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["standard", "outlined", "filled"])
});
var YA = function(t) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},
    /* Styles applied to the select component `select` class. */
    select: {
      "-moz-appearance": "none",
      // Reset
      "-webkit-appearance": "none",
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: "none",
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: "pointer",
      "&:focus": {
        // Show that it's not an text input
        backgroundColor: t.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
        borderRadius: 0
        // Reset Chrome style
      },
      // Remove IE 11 arrow
      "&::-ms-expand": {
        display: "none"
      },
      "&$disabled": {
        cursor: "default"
      },
      "&[multiple]": {
        height: "auto"
      },
      "&:not([multiple]) option, &:not([multiple]) optgroup": {
        backgroundColor: t.palette.background.paper
      },
      "&&": {
        paddingRight: 24
      }
    },
    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: t.shape.borderRadius,
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: "auto",
      // Resets for multpile select with chips
      minHeight: "1.1876em",
      // Required for select\text-field height consistency
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},
    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: "absolute",
      right: 0,
      top: "calc(50% - 12px)",
      // Center vertically
      pointerEvents: "none",
      // Don't block pointer events on the select under the icon.
      color: t.palette.action.active,
      "&$disabled": {
        color: t.palette.action.disabled
      }
    },
    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },
    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },
    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%"
    }
  };
}, B4 = /* @__PURE__ */ z.createElement(kE, null), WE = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.IconComponent, a = i === void 0 ? zA : i, s = t.input, l = s === void 0 ? B4 : s, u = t.inputProps;
  t.variant;
  var c = Ke(t, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]), d = iv(), f = fp({
    props: t,
    muiFormControl: d,
    states: ["variant"]
  });
  return /* @__PURE__ */ z.cloneElement(l, Ce({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: BE,
    inputProps: Ce({
      children: r,
      classes: n,
      IconComponent: a,
      variant: f.variant,
      type: void 0
    }, u, l ? l.props.inputProps : {}),
    ref: e
  }, c));
});
process.env.NODE_ENV !== "production" && (WE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _.elementType,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _.element,
  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _.object,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * The input value. The DOM API casts this to a string.
   */
  value: _.any,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
WE.muiName = "Select";
qt(YA, {
  name: "MuiNativeSelect"
})(WE);
var W4 = YA, j4 = /* @__PURE__ */ z.createElement(kE, null), U4 = /* @__PURE__ */ z.createElement(FA, null), jE = /* @__PURE__ */ z.forwardRef(function o(t, e) {
  var r = t.autoWidth, n = r === void 0 ? !1 : r, i = t.children, a = t.classes, s = t.displayEmpty, l = s === void 0 ? !1 : s, u = t.IconComponent, c = u === void 0 ? zA : u, d = t.id, f = t.input, v = t.inputProps, g = t.label, m = t.labelId, b = t.labelWidth, S = b === void 0 ? 0 : b, R = t.MenuProps, P = t.multiple, D = P === void 0 ? !1 : P, x = t.native, M = x === void 0 ? !1 : x, F = t.onClose, H = t.onOpen, B = t.open, j = t.renderValue, V = t.SelectDisplayProps, W = t.variant, q = W === void 0 ? "standard" : W, ee = Ke(t, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]), re = M ? BE : $A, ie = iv(), ne = fp({
    props: t,
    muiFormControl: ie,
    states: ["variant"]
  }), se = ne.variant || q, pe = f || {
    standard: j4,
    outlined: /* @__PURE__ */ z.createElement(LA, {
      label: g,
      labelWidth: S
    }),
    filled: U4
  }[se];
  return /* @__PURE__ */ z.cloneElement(pe, Ce({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: re,
    inputProps: Ce({
      children: i,
      IconComponent: c,
      variant: se,
      type: void 0,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: D
    }, M ? {
      id: d
    } : {
      autoWidth: n,
      displayEmpty: l,
      labelId: m,
      MenuProps: R,
      onClose: F,
      onOpen: H,
      open: B,
      renderValue: j,
      SelectDisplayProps: Ce({
        id: d
      }, V)
    }, v, {
      classes: v ? yE({
        baseClasses: a,
        newClasses: v.classes,
        Component: o
      }) : a
    }, f ? f.props.inputProps : {}),
    ref: e
  }, ee));
});
process.env.NODE_ENV !== "production" && (jE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: _.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: _.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: _.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _.object,
  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: _.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: _.string,
  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: _.number,
  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _.bool,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _.bool,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: _.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: _.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: _.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: _.object,
  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: _.any,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
jE.muiName = "Select";
const $4 = qt(W4, {
  name: "MuiSelect"
})(jE);
var z4 = {
  standard: kE,
  filled: FA,
  outlined: LA
}, Y4 = {
  /* Styles applied to the root element. */
  root: {}
}, KA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.autoComplete, n = t.autoFocus, i = n === void 0 ? !1 : n, a = t.children, s = t.classes, l = t.className, u = t.color, c = u === void 0 ? "primary" : u, d = t.defaultValue, f = t.disabled, v = f === void 0 ? !1 : f, g = t.error, m = g === void 0 ? !1 : g, b = t.FormHelperTextProps, S = t.fullWidth, R = S === void 0 ? !1 : S, P = t.helperText, D = t.hiddenLabel, x = t.id, M = t.InputLabelProps, F = t.inputProps, H = t.InputProps, B = t.inputRef, j = t.label, V = t.multiline, W = V === void 0 ? !1 : V, q = t.name, ee = t.onBlur, re = t.onChange, ie = t.onFocus, ne = t.placeholder, se = t.required, pe = se === void 0 ? !1 : se, K = t.rows, J = t.rowsMax, ue = t.maxRows, he = t.minRows, fe = t.select, ae = fe === void 0 ? !1 : fe, oe = t.SelectProps, ve = t.type, _e = t.value, le = t.variant, Ee = le === void 0 ? "standard" : le, de = Ke(t, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);
  process.env.NODE_ENV !== "production" && ae && !a && console.error("Material-UI: `children` must be passed when using the `TextField` component with `select`.");
  var X = {};
  if (Ee === "outlined" && (M && typeof M.shrink < "u" && (X.notched = M.shrink), j)) {
    var xe, Le = (xe = M == null ? void 0 : M.required) !== null && xe !== void 0 ? xe : pe;
    X.label = /* @__PURE__ */ z.createElement(z.Fragment, null, j, Le && " *");
  }
  ae && ((!oe || !oe.native) && (X.id = void 0), X["aria-describedby"] = void 0);
  var Ue = P && x ? "".concat(x, "-helper-text") : void 0, He = j && x ? "".concat(x, "-label") : void 0, et = z4[Ee], $e = /* @__PURE__ */ z.createElement(et, Ce({
    "aria-describedby": Ue,
    autoComplete: r,
    autoFocus: i,
    defaultValue: d,
    fullWidth: R,
    multiline: W,
    name: q,
    rows: K,
    rowsMax: J,
    maxRows: ue,
    minRows: he,
    type: ve,
    value: _e,
    id: x,
    inputRef: B,
    onBlur: ee,
    onChange: re,
    onFocus: ie,
    placeholder: ne,
    inputProps: F
  }, X, H));
  return /* @__PURE__ */ z.createElement(P4, Ce({
    className: Xe(s.root, l),
    disabled: v,
    error: m,
    fullWidth: R,
    hiddenLabel: D,
    ref: e,
    required: pe,
    color: c,
    variant: Ee
  }, de), j && /* @__PURE__ */ z.createElement(T4, Ce({
    htmlFor: x,
    id: He
  }, M), j), ae ? /* @__PURE__ */ z.createElement($4, Ce({
    "aria-describedby": Ue,
    id: x,
    labelId: He,
    value: _e,
    input: $e
  }, oe), a) : $e, P && /* @__PURE__ */ z.createElement(A4, Ce({
    id: Ue
  }, b), P));
});
process.env.NODE_ENV !== "production" && (KA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _.string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _.bool,
  /**
   * @ignore
   */
  children: _.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["primary", "secondary"]),
  /**
   * The default value of the `input` element.
   */
  defaultValue: _.any,
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _.bool,
  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: _.object,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _.bool,
  /**
   * The helper text content.
   */
  helperText: _.node,
  /**
   * @ignore
   */
  hiddenLabel: _.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: _.string,
  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: _.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: _.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Va,
  /**
   * The label content.
   */
  label: _.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _.oneOfType([_.number, _.string]),
  /**
   * Minimum number of rows to display.
   */
  minRows: _.oneOfType([_.number, _.string]),
  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _.string,
  /**
   * @ignore
   */
  onBlur: _.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _.func,
  /**
   * @ignore
   */
  onFocus: _.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _.string,
  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: _.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   * @deprecated Use `minRows` instead.
   */
  rows: Zt(_.oneOfType([_.number, _.string]), "Use `minRows` instead"),
  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: Zt(_.oneOfType([_.number, _.string]), "Use `maxRows` instead"),
  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _.bool,
  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: _.object,
  /**
   * The size of the text field.
   */
  size: _.oneOf(["medium", "small"]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _.any,
  /**
   * The variant to use.
   */
  variant: _.oneOf(["filled", "outlined", "standard"])
});
const qA = qt(Y4, {
  name: "MuiTextField"
})(KA);
var K4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: "center",
      flex: "0 0 auto",
      fontSize: t.typography.pxToRem(24),
      padding: 12,
      borderRadius: "50%",
      overflow: "visible",
      // Explicitly set the default value to solve a bug on IE 11.
      color: t.palette.action.active,
      transition: t.transitions.create("background-color", {
        duration: t.transitions.duration.shortest
      }),
      "&:hover": {
        backgroundColor: Ki(t.palette.action.active, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        backgroundColor: "transparent",
        color: t.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      "$sizeSmall&": {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      "$sizeSmall&": {
        marginRight: -3
      }
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main,
      "&:hover": {
        backgroundColor: Ki(t.palette.primary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main,
      "&:hover": {
        backgroundColor: Ki(t.palette.secondary.main, t.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: t.typography.pxToRem(18)
    },
    /* Styles applied to the children container element. */
    label: {
      width: "100%",
      display: "flex",
      alignItems: "inherit",
      justifyContent: "inherit"
    }
  };
}, XA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.edge, n = r === void 0 ? !1 : r, i = t.children, a = t.classes, s = t.className, l = t.color, u = l === void 0 ? "default" : l, c = t.disabled, d = c === void 0 ? !1 : c, f = t.disableFocusRipple, v = f === void 0 ? !1 : f, g = t.size, m = g === void 0 ? "medium" : g, b = Ke(t, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
  return /* @__PURE__ */ z.createElement(lA, Ce({
    className: Xe(a.root, s, u !== "default" && a["color".concat(Xr(u))], d && a.disabled, m === "small" && a["size".concat(Xr(m))], {
      start: a.edgeStart,
      end: a.edgeEnd
    }[n]),
    centerRipple: !0,
    focusRipple: !v,
    disabled: d,
    ref: e
  }, b), /* @__PURE__ */ z.createElement("span", {
    className: a.label
  }, i));
});
process.env.NODE_ENV !== "production" && (XA.propTypes = {
  /**
   * The icon element.
   */
  children: Ga(_.node, function(o) {
    var t = z.Children.toArray(o.children).some(function(e) {
      return /* @__PURE__ */ z.isValidElement(e) && e.props.onClick;
    });
    return t ? new Error(["Material-UI: You are providing an onClick event listener to a child of a button element.", "Firefox will never trigger the event.", "You should move the onClick listener to the parent button element.", "https://github.com/mui-org/material-ui/issues/13957"].join(`
`)) : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: _.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: _.oneOf(["start", "end", !1]),
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _.oneOf(["small", "medium"])
});
const Lm = qt(K4, {
  name: "MuiIconButton"
})(XA);
var q4 = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    height: "0.01em",
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: "2em",
    alignItems: "center",
    whiteSpace: "nowrap"
  },
  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    "&$positionStart:not($hiddenLabel)": {
      marginTop: 16
    }
  },
  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },
  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },
  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: "none"
  },
  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},
  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
}, ZA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.children, n = t.classes, i = t.className, a = t.component, s = a === void 0 ? "div" : a, l = t.disablePointerEvents, u = l === void 0 ? !1 : l, c = t.disableTypography, d = c === void 0 ? !1 : c, f = t.position, v = t.variant, g = Ke(t, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]), m = DA() || {}, b = v;
  return v && m.variant && process.env.NODE_ENV !== "production" && v === m.variant && console.error("Material-UI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), m && !b && (b = m.variant), /* @__PURE__ */ z.createElement(Ny.Provider, {
    value: null
  }, /* @__PURE__ */ z.createElement(s, Ce({
    className: Xe(n.root, i, f === "end" ? n.positionEnd : n.positionStart, u && n.disablePointerEvents, m.hiddenLabel && n.hiddenLabel, b === "filled" && n.filled, m.margin === "dense" && n.marginDense),
    ref: e
  }, g), typeof r == "string" && !d ? /* @__PURE__ */ z.createElement(Ll, {
    color: "textSecondary"
  }, r) : r));
});
process.env.NODE_ENV !== "production" && (ZA.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object.isRequired,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: _.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _.bool,
  /**
   * @ignore
   */
  muiFormControl: _.object,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _.oneOf(["start", "end"]).isRequired,
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: _.oneOf(["standard", "outlined", "filled"])
});
const X4 = qt(q4, {
  name: "MuiInputAdornment"
})(ZA);
var Z4 = /* @__PURE__ */ function(o) {
  dp(t, o);
  function t(r) {
    var n;
    return n = o.call(this, r) || this, n._state = null, n._del = !1, n._handleChange = function(i) {
      if (process.env.NODE_ENV !== "production" && i.target.type === "number") {
        console.error("Rifm does not support input type=number, use type=tel instead.");
        return;
      }
      var a = n.state.value, s = i.target.value, l = i.target, u = s.length > a.length, c = n._del, d = a === n.props.format(s);
      n.setState({
        value: s,
        local: !0
      }, function() {
        var f = l.selectionStart, v = n.props.refuse || /[^\d]+/g, g = s.substr(0, f).replace(v, "");
        if (n._state = {
          input: l,
          before: g,
          op: u,
          di: c && d,
          del: c
        }, n.props.replace && n.props.replace(a) && u && !d) {
          for (var m = -1, b = 0; b !== g.length; ++b)
            m = Math.max(m, s.toLowerCase().indexOf(g[b].toLowerCase(), m + 1));
          var S = s.substr(m + 1).replace(v, "")[0];
          m = s.indexOf(S, m + 1), s = "" + s.substr(0, m) + s.substr(m + 1);
        }
        var R = n.props.format(s);
        a === R ? n.setState({
          value: s
        }) : n.props.onChange(R);
      });
    }, n._hKD = function(i) {
      i.code === "Delete" && (n._del = !0);
    }, n._hKU = function(i) {
      i.code === "Delete" && (n._del = !1);
    }, n.state = {
      value: r.value,
      local: !0
    }, n;
  }
  t.getDerivedStateFromProps = function(n, i) {
    return {
      value: i.local ? i.value : n.value,
      local: !1
    };
  };
  var e = t.prototype;
  return e.render = function() {
    var n = this._handleChange, i = this.state.value, a = this.props.children;
    return a({
      value: i,
      onChange: n
    });
  }, e.componentWillUnmount = function() {
    document.removeEventListener("keydown", this._hKD), document.removeEventListener("keyup", this._hKU);
  }, e.componentDidMount = function() {
    document.addEventListener("keydown", this._hKD), document.addEventListener("keyup", this._hKU);
  }, e.componentDidUpdate = function() {
    var n = this._state;
    if (n) {
      for (var i = this.state.value, a = -1, s = 0; s !== n.before.length; ++s)
        a = Math.max(a, i.toLowerCase().indexOf(n.before[s].toLowerCase(), a + 1));
      if (this.props.replace && (n.op || n.del && !n.di))
        for (; i[a + 1] && (this.props.refuse || /[^\d]+/).test(i[a + 1]); )
          a += 1;
      n.input.selectionStart = n.input.selectionEnd = a + 1 + (n.di ? 1 : 0);
    }
    this._state = null;
  }, t;
}(Oy);
function UE(o, t) {
  if (t && (ka(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Tm(o);
}
function Nh(o) {
  return Nh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Nh(o);
}
function $E(o, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: o,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(o, "prototype", {
    writable: !1
  }), t && Rm(o, t);
}
var Q4 = li(function(o) {
  return {
    day: {
      width: 36,
      height: 36,
      fontSize: o.typography.caption.fontSize,
      margin: "0 2px",
      color: o.palette.text.primary,
      fontWeight: o.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: "none"
    },
    current: {
      color: o.palette.primary.main,
      fontWeight: 600
    },
    daySelected: {
      color: o.palette.primary.contrastText,
      backgroundColor: o.palette.primary.main,
      fontWeight: o.typography.fontWeightMedium,
      "&:hover": {
        backgroundColor: o.palette.primary.main
      }
    },
    dayDisabled: {
      pointerEvents: "none",
      color: o.palette.text.hint
    }
  };
}, {
  name: "MuiPickersDay"
}), ky = function(t) {
  var e = t.children, r = t.disabled, n = t.hidden, i = t.current, a = t.selected, s = Ke(t, ["children", "disabled", "hidden", "current", "selected"]), l = Q4(), u = Xe(l.day, n && l.hidden, i && l.current, a && l.daySelected, r && l.dayDisabled);
  return Ne(Lm, Ce({
    className: u,
    tabIndex: n || r ? -1 : 0
  }, s), Ne(Ll, {
    variant: "body2",
    color: "inherit"
  }, e));
};
ky.displayName = "Day";
process.env.NODE_ENV !== "production" && (ky.propTypes = {
  current: Je.bool,
  disabled: Je.bool,
  hidden: Je.bool,
  selected: Je.bool
});
ky.defaultProps = {
  disabled: !1,
  hidden: !1,
  current: !1,
  selected: !1
};
var il = 44, J4 = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-block"
    },
    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: t.transitions.create("transform")
    },
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: "$circular-rotate 1.4s linear infinite"
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: t.transitions.create("transform")
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main
    },
    /* Styles applied to the `svg` element. */
    svg: {
      display: "block"
      // Keeps the progress centered
    },
    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: "currentColor"
      // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',
    },
    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: t.transitions.create("stroke-dashoffset")
    },
    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: "$circular-dash 1.4s ease-in-out infinite",
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: "0px"
      // Add the unit to fix a Edge 16 and below bug.
    },
    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: t.transitions.create("stroke-dashoffset")
    },
    "@keyframes circular-rotate": {
      "0%": {
        // Fix IE 11 wobbly
        transformOrigin: "50% 50%"
      },
      "100%": {
        transform: "rotate(360deg)"
      }
    },
    "@keyframes circular-dash": {
      "0%": {
        strokeDasharray: "1px, 200px",
        strokeDashoffset: "0px"
      },
      "50%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-15px"
      },
      "100%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-125px"
      }
    },
    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: "none"
    }
  };
}, QA = /* @__PURE__ */ z.forwardRef(function(t, e) {
  var r = t.classes, n = t.className, i = t.color, a = i === void 0 ? "primary" : i, s = t.disableShrink, l = s === void 0 ? !1 : s, u = t.size, c = u === void 0 ? 40 : u, d = t.style, f = t.thickness, v = f === void 0 ? 3.6 : f, g = t.value, m = g === void 0 ? 0 : g, b = t.variant, S = b === void 0 ? "indeterminate" : b, R = Ke(t, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]), P = {}, D = {}, x = {};
  if (S === "determinate" || S === "static") {
    var M = 2 * Math.PI * ((il - v) / 2);
    P.strokeDasharray = M.toFixed(3), x["aria-valuenow"] = Math.round(m), P.strokeDashoffset = "".concat(((100 - m) / 100 * M).toFixed(3), "px"), D.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ z.createElement("div", Ce({
    className: Xe(r.root, n, a !== "inherit" && r["color".concat(Xr(a))], {
      determinate: r.determinate,
      indeterminate: r.indeterminate,
      static: r.static
    }[S]),
    style: Ce({
      width: c,
      height: c
    }, D, d),
    ref: e,
    role: "progressbar"
  }, x, R), /* @__PURE__ */ z.createElement("svg", {
    className: r.svg,
    viewBox: "".concat(il / 2, " ").concat(il / 2, " ").concat(il, " ").concat(il)
  }, /* @__PURE__ */ z.createElement("circle", {
    className: Xe(r.circle, l && r.circleDisableShrink, {
      determinate: r.circleDeterminate,
      indeterminate: r.circleIndeterminate,
      static: r.circleStatic
    }[S]),
    style: P,
    cx: il,
    cy: il,
    r: (il - v) / 2,
    fill: "none",
    strokeWidth: v
  })));
});
process.env.NODE_ENV !== "production" && (QA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _.object,
  /**
   * @ignore
   */
  className: _.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _.oneOf(["inherit", "primary", "secondary"]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: Ga(_.bool, function(o) {
    return o.disableShrink && o.variant && o.variant !== "indeterminate" ? new Error("Material-UI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null;
  }),
  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: _.oneOfType([_.number, _.string]),
  /**
   * @ignore
   */
  style: _.object,
  /**
   * The thickness of the circle.
   */
  thickness: _.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: _.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: Ga(_.oneOf(["determinate", "indeterminate", "static"]), function(o) {
    var t = o.variant;
    if (t === "static")
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    return null;
  })
});
const e8 = qt(J4, {
  name: "MuiCircularProgress",
  flip: !1
})(QA);
var t8 = function(t) {
  var e = t.date, r = t.utils, n = t.minDate, i = t.maxDate, a = t.disableFuture, s = t.disablePast, l = t.shouldDisableDate, u = r.startOfDay(r.date());
  s && r.isBefore(n, u) && (n = u), a && r.isAfter(i, u) && (i = u);
  var c = e, d = e;
  for (r.isBefore(e, n) && (c = r.date(n), d = null), r.isAfter(e, i) && (d && (d = r.date(i)), c = null); c || d; ) {
    if (c && r.isAfter(c, i) && (c = null), d && r.isBefore(d, n) && (d = null), c) {
      if (!l(c))
        return c;
      c = r.addDays(c, 1);
    }
    if (d) {
      if (!l(d))
        return d;
      d = r.addDays(d, -1);
    }
  }
  return r.date();
}, JA = function(t) {
  return t.length === 1 && t[0] === "year";
}, eM = function(t) {
  return t.length === 2 && aS(t, "month") && aS(t, "year");
}, r8 = function(t, e) {
  return JA(t) ? e.yearFormat : eM(t) ? e.yearMonthFormat : e.dateFormat;
}, n8 = function(t) {
  var e = t.children, r = t.value, n = t.disabled, i = t.onSelect, a = t.dayInCurrentMonth, s = Ke(t, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]), l = Ai(function() {
    return i(r);
  }, [i, r]);
  return Ne("div", Ce({
    role: "presentation",
    onClick: a && !n ? l : void 0,
    onKeyPress: a && !n ? l : void 0
  }, s), e);
}, tM = 350, o8 = li(function(o) {
  var t = o.transitions.create("transform", {
    duration: tM,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    transitionContainer: {
      display: "block",
      position: "relative",
      "& > *": {
        position: "absolute",
        top: 0,
        right: 0,
        left: 0
      }
    },
    "slideEnter-left": {
      willChange: "transform",
      transform: "translate(100%)"
    },
    "slideEnter-right": {
      willChange: "transform",
      transform: "translate(-100%)"
    },
    slideEnterActive: {
      transform: "translate(0%)",
      transition: t
    },
    slideExit: {
      transform: "translate(0%)"
    },
    "slideExitActiveLeft-left": {
      willChange: "transform",
      transform: "translate(-200%)",
      transition: t
    },
    "slideExitActiveLeft-right": {
      willChange: "transform",
      transform: "translate(200%)",
      transition: t
    }
  };
}, {
  name: "MuiPickersSlideTransition"
}), rM = function(t) {
  var e = t.children, r = t.transKey, n = t.slideDirection, i = t.className, a = i === void 0 ? null : i, s = o8(), l = {
    exit: s.slideExit,
    enterActive: s.slideEnterActive,
    // @ts-ignore
    enter: s["slideEnter-" + n],
    // @ts-ignore
    exitActive: s["slideExitActiveLeft-" + n]
  };
  return Ne(Ly, {
    className: Xe(s.transitionContainer, a),
    childFactory: function(c) {
      return Yd(c, {
        classNames: l
      });
    }
  }, Ne(xE, {
    mountOnEnter: !0,
    unmountOnExit: !0,
    key: r + n,
    timeout: tM,
    classNames: l,
    children: e
  }));
}, i8 = function(t) {
  return y.createElement(Lh, t, y.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), y.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
}, a8 = function(t) {
  return y.createElement(Lh, t, y.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), y.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
}, s8 = li(function(o) {
  return {
    switchHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: o.spacing(0.5),
      marginBottom: o.spacing(1)
    },
    transitionContainer: {
      width: "100%",
      overflow: "hidden",
      height: 23
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: o.palette.background.paper
    },
    daysHeader: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: "0 2px",
      textAlign: "center",
      color: o.palette.text.hint
    }
  };
}, {
  name: "MuiPickersCalendarHeader"
}), Gy = function(t) {
  var e = t.currentMonth, r = t.onMonthChange, n = t.leftArrowIcon, i = t.rightArrowIcon, a = t.leftArrowButtonProps, s = t.rightArrowButtonProps, l = t.disablePrevMonth, u = t.disableNextMonth, c = t.slideDirection, d = aa(), f = s8(), v = ov(), g = v.direction === "rtl", m = function() {
    return r(d.getNextMonth(e), "left");
  }, b = function() {
    return r(d.getPreviousMonth(e), "right");
  };
  return Ne("div", null, Ne("div", {
    className: f.switchHeader
  }, Ne(Lm, Ce({}, a, {
    disabled: l,
    onClick: b,
    className: f.iconButton
  }), g ? i : n), Ne(rM, {
    slideDirection: c,
    transKey: e.toString(),
    className: f.transitionContainer
  }, Ne(Ll, {
    align: "center",
    variant: "body1"
  }, d.getCalendarHeaderText(e))), Ne(Lm, Ce({}, s, {
    disabled: u,
    onClick: m,
    className: f.iconButton
  }), g ? n : i)), Ne("div", {
    className: f.daysHeader
  }, d.getWeekdays().map(function(S, R) {
    return Ne(Ll, {
      key: R,
      variant: "caption",
      className: f.dayLabel
    }, S);
  })));
};
Gy.displayName = "CalendarHeader";
process.env.NODE_ENV !== "production" && (Gy.propTypes = {
  leftArrowIcon: Je.node,
  rightArrowIcon: Je.node,
  disablePrevMonth: Je.bool,
  disableNextMonth: Je.bool
});
Gy.defaultProps = {
  leftArrowIcon: Ne(i8, null),
  rightArrowIcon: Ne(a8, null),
  disablePrevMonth: !1,
  disableNextMonth: !1
};
var l8 = function() {
  return function(t) {
    var e = function(n) {
      var i = aa();
      return Ne(t, Ce({
        utils: i
      }, n));
    };
    return e.displayName = "WithUtils(".concat(t.displayName || t.name, ")"), e;
  };
}, u8 = function(t) {
  var e = t.onKeyDown;
  return wr(function() {
    return window.addEventListener("keydown", e), function() {
      window.removeEventListener("keydown", e);
    };
  }, [e]), null;
}, Vy = /* @__PURE__ */ function(o) {
  $E(t, o);
  function t() {
    var e, r;
    Ay(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = UE(this, (e = Nh(t)).call.apply(e, [this].concat(i))), r.state = {
      slideDirection: "left",
      currentMonth: r.props.utils.startOfMonth(r.props.date),
      loadingQueue: 0
    }, r.pushToLoadingQueue = function() {
      var s = r.state.loadingQueue + 1;
      r.setState({
        loadingQueue: s
      });
    }, r.popFromLoadingQueue = function() {
      var s = r.state.loadingQueue;
      s = s <= 0 ? 0 : s - 1, r.setState({
        loadingQueue: s
      });
    }, r.handleChangeMonth = function(s, l) {
      if (r.setState({
        currentMonth: s,
        slideDirection: l
      }), r.props.onMonthChange) {
        var u = r.props.onMonthChange(s);
        u && (r.pushToLoadingQueue(), u.then(function() {
          r.popFromLoadingQueue();
        }));
      }
    }, r.validateMinMaxDate = function(s) {
      var l = r.props, u = l.minDate, c = l.maxDate, d = l.utils, f = l.disableFuture, v = l.disablePast, g = d.date();
      return !!(f && d.isAfterDay(s, g) || v && d.isBeforeDay(s, g) || u && d.isBeforeDay(s, d.date(u)) || c && d.isAfterDay(s, d.date(c)));
    }, r.shouldDisablePrevMonth = function() {
      var s = r.props, l = s.utils, u = s.disablePast, c = s.minDate, d = l.date(), f = l.startOfMonth(u && l.isAfter(d, l.date(c)) ? d : l.date(c));
      return !l.isBefore(f, r.state.currentMonth);
    }, r.shouldDisableNextMonth = function() {
      var s = r.props, l = s.utils, u = s.disableFuture, c = s.maxDate, d = l.date(), f = l.startOfMonth(u && l.isBefore(d, l.date(c)) ? d : l.date(c));
      return !l.isAfter(f, r.state.currentMonth);
    }, r.shouldDisableDate = function(s) {
      var l = r.props.shouldDisableDate;
      return r.validateMinMaxDate(s) || !!(l && l(s));
    }, r.handleDaySelect = function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, u = r.props, c = u.date, d = u.utils;
      r.props.onChange(d.mergeDateAndTime(s, c), l);
    }, r.moveToDay = function(s) {
      var l = r.props.utils;
      s && !r.shouldDisableDate(s) && (l.getMonth(s) !== l.getMonth(r.state.currentMonth) && r.handleChangeMonth(l.startOfMonth(s), "left"), r.handleDaySelect(s, !1));
    }, r.handleKeyDown = function(s) {
      var l = r.props, u = l.theme, c = l.date, d = l.utils;
      TA(s, {
        ArrowUp: function() {
          return r.moveToDay(d.addDays(c, -7));
        },
        ArrowDown: function() {
          return r.moveToDay(d.addDays(c, 7));
        },
        ArrowLeft: function() {
          return r.moveToDay(d.addDays(c, u.direction === "ltr" ? -1 : 1));
        },
        ArrowRight: function() {
          return r.moveToDay(d.addDays(c, u.direction === "ltr" ? 1 : -1));
        }
      });
    }, r.renderWeeks = function() {
      var s = r.props, l = s.utils, u = s.classes, c = l.getWeekArray(r.state.currentMonth);
      return c.map(function(d) {
        return Ne("div", {
          key: "week-".concat(d[0].toString()),
          className: u.week
        }, r.renderDays(d));
      });
    }, r.renderDays = function(s) {
      var l = r.props, u = l.date, c = l.renderDay, d = l.utils, f = d.date(), v = d.startOfDay(u), g = d.getMonth(r.state.currentMonth);
      return s.map(function(m) {
        var b = r.shouldDisableDate(m), S = d.getMonth(m) === g, R = Ne(ky, {
          disabled: b,
          current: d.isSameDay(m, f),
          hidden: !S,
          selected: d.isSameDay(v, m)
        }, d.getDayText(m));
        return c && (R = c(m, v, S, R)), Ne(n8, {
          value: m,
          key: m.toString(),
          disabled: b,
          dayInCurrentMonth: S,
          onSelect: r.handleDaySelect
        }, R);
      });
    }, r;
  }
  return cp(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props, n = r.date, i = r.minDate, a = r.maxDate, s = r.utils, l = r.disablePast, u = r.disableFuture;
      if (this.shouldDisableDate(n)) {
        var c = t8({
          date: n,
          utils: s,
          minDate: s.date(i),
          maxDate: s.date(a),
          disablePast: !!l,
          disableFuture: !!u,
          shouldDisableDate: this.shouldDisableDate
        });
        this.handleDaySelect(c, !1);
      }
    }
  }, {
    key: "render",
    value: function() {
      var r = this.state, n = r.currentMonth, i = r.slideDirection, a = this.props, s = a.classes, l = a.allowKeyboardControl, u = a.leftArrowButtonProps, c = a.leftArrowIcon, d = a.rightArrowButtonProps, f = a.rightArrowIcon, v = a.loadingIndicator, g = v || Ne(e8, null);
      return Ne(yn, null, l && this.context !== "static" && Ne(u8, {
        onKeyDown: this.handleKeyDown
      }), Ne(Gy, {
        currentMonth: n,
        slideDirection: i,
        onMonthChange: this.handleChangeMonth,
        leftArrowIcon: c,
        leftArrowButtonProps: u,
        rightArrowIcon: f,
        rightArrowButtonProps: d,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), Ne(rM, {
        slideDirection: i,
        transKey: n.toString(),
        className: s.transitionContainer
      }, Ne(yn, null, this.state.loadingQueue > 0 && Ne("div", {
        className: s.progressContainer
      }, g) || Ne("div", null, this.renderWeeks()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, n) {
      var i = r.utils, a = r.date;
      if (!i.isEqual(a, n.lastDate)) {
        var s = i.getMonth(a), l = n.lastDate || a, u = i.getMonth(l);
        return {
          lastDate: a,
          currentMonth: r.utils.startOfMonth(a),
          // prettier-ignore
          slideDirection: s === u ? n.slideDirection : i.isAfterDay(a, l) ? "left" : "right"
        };
      }
      return null;
    }
  }]), t;
}(Oy);
Vy.contextType = ME;
process.env.NODE_ENV !== "production" && (Vy.propTypes = {
  renderDay: Je.func,
  shouldDisableDate: Je.func,
  allowKeyboardControl: Je.bool
});
Vy.defaultProps = {
  minDate: /* @__PURE__ */ new Date("1900-01-01"),
  maxDate: /* @__PURE__ */ new Date("2100-01-01"),
  disablePast: !1,
  disableFuture: !1,
  allowKeyboardControl: !0
};
var c8 = function(t) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: t.spacing(1.5)
    },
    progressContainer: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    week: {
      display: "flex",
      justifyContent: "center"
    }
  };
}, nM = qt(c8, {
  name: "MuiPickersCalendar",
  withTheme: !0
})(l8()(Vy)), sS;
(function(o) {
  o.HOURS = "hours", o.MINUTES = "minutes", o.SECONDS = "seconds";
})(sS || (sS = {}));
var ni = sS, oM = /* @__PURE__ */ function(o) {
  $E(t, o);
  function t() {
    var e, r;
    Ay(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = UE(this, (e = Nh(t)).call.apply(e, [this].concat(i))), r.state = {
      toAnimateTransform: !1,
      previousType: void 0
    }, r.getAngleStyle = function() {
      var s = r.props, l = s.value, u = s.isInner, c = s.type, d = c === ni.HOURS ? 12 : 60, f = 360 / d * l;
      return c === ni.HOURS && l > 12 && (f -= 360), {
        height: u ? "26%" : "40%",
        transform: "rotateZ(".concat(f, "deg)")
      };
    }, r;
  }
  return cp(t, [{
    key: "render",
    value: function() {
      var r = this.props, n = r.classes, i = r.hasSelected;
      return Ne("div", {
        style: this.getAngleStyle(),
        className: Xe(n.pointer, this.state.toAnimateTransform && n.animateTransform)
      }, Ne("div", {
        className: Xe(n.thumb, i && n.noPoint)
      }));
    }
  }]), t;
}(Oy);
oM.getDerivedStateFromProps = function(o, t) {
  return o.type !== t.previousType ? {
    toAnimateTransform: !0,
    previousType: o.type
  } : {
    toAnimateTransform: !1,
    previousType: o.type
  };
};
var d8 = function(t) {
  return Fy({
    pointer: {
      width: 2,
      backgroundColor: t.palette.primary.main,
      position: "absolute",
      left: "calc(50% - 1px)",
      bottom: "50%",
      transformOrigin: "center bottom 0px"
    },
    animateTransform: {
      transition: t.transitions.create(["transform", "height"])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: t.palette.primary.contrastText,
      borderRadius: "100%",
      position: "absolute",
      top: -21,
      left: -15,
      border: "14px solid ".concat(t.palette.primary.main),
      boxSizing: "content-box"
    },
    noPoint: {
      backgroundColor: t.palette.primary.main
    }
  });
}, p8 = qt(d8, {
  name: "MuiPickersClockPointer"
})(oM), kh = {
  x: 260 / 2,
  y: 260 / 2
}, iM = {
  x: kh.x,
  y: 0
}, f8 = iM.x - kh.x, h8 = iM.y - kh.y, v8 = function(t) {
  return t * 57.29577951308232;
}, aM = function(t, e, r) {
  var n = e - kh.x, i = r - kh.y, a = Math.atan2(f8, h8) - Math.atan2(n, i), s = v8(a);
  s = Math.round(s / t) * t, s %= 360;
  var l = Math.floor(s / t) || 0, u = Math.pow(n, 2) + Math.pow(i, 2), c = Math.sqrt(u);
  return {
    value: l,
    distance: c
  };
}, g8 = function(t, e, r) {
  var n = aM(30, t, e), i = n.value, a = n.distance;
  return i = i || 12, r ? i %= 12 : a < 90 && (i += 12, i %= 24), i;
}, m8 = function(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = r * 6, i = aM(n, t, e), a = i.value;
  return a = a * r % 60, a;
}, y8 = function(t, e) {
  return e.getHours(t) >= 12 ? "pm" : "am";
}, C8 = function(t, e, r, n) {
  if (r) {
    var i = n.getHours(t) >= 12 ? "pm" : "am";
    if (i !== e) {
      var a = e === "am" ? n.getHours(t) - 12 : n.getHours(t) + 12;
      return n.setHours(t, a);
    }
  }
  return t;
}, zE = /* @__PURE__ */ function(o) {
  $E(t, o);
  function t() {
    var e, r;
    Ay(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = UE(this, (e = Nh(t)).call.apply(e, [this].concat(i))), r.isMoving = !1, r.handleTouchMove = function(s) {
      r.isMoving = !0, r.setTime(s);
    }, r.handleTouchEnd = function(s) {
      r.isMoving && (r.setTime(s, !0), r.isMoving = !1);
    }, r.handleMove = function(s) {
      s.preventDefault(), s.stopPropagation();
      var l = typeof s.buttons > "u" ? s.nativeEvent.which === 1 : s.buttons === 1;
      l && r.setTime(s.nativeEvent, !1);
    }, r.handleMouseUp = function(s) {
      r.isMoving && (r.isMoving = !1), r.setTime(s.nativeEvent, !0);
    }, r.hasSelected = function() {
      var s = r.props, l = s.type, u = s.value;
      return l === ni.HOURS ? !0 : u % 5 === 0;
    }, r;
  }
  return cp(t, [{
    key: "setTime",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = r.offsetX, a = r.offsetY;
      if (typeof i > "u") {
        var s = r.target.getBoundingClientRect();
        i = r.changedTouches[0].clientX - s.left, a = r.changedTouches[0].clientY - s.top;
      }
      var l = this.props.type === ni.SECONDS || this.props.type === ni.MINUTES ? m8(i, a, this.props.minutesStep) : g8(i, a, !!this.props.ampm);
      this.props.onChange(l, n);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, n = r.classes, i = r.value, a = r.children, s = r.type, l = r.ampm, u = !l && s === ni.HOURS && (i < 1 || i > 12);
      return Ne("div", {
        className: n.container
      }, Ne("div", {
        className: n.clock
      }, Ne("div", {
        role: "menu",
        tabIndex: -1,
        className: n.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), Ne("div", {
        className: n.pin
      }), Ne(p8, {
        type: s,
        value: i,
        isInner: u,
        hasSelected: this.hasSelected()
      }), a));
    }
  }]), t;
}(Oy);
process.env.NODE_ENV !== "production" && (zE.propTypes = {
  type: Je.oneOf(Object.keys(ni).map(function(o) {
    return ni[o];
  })).isRequired,
  value: Je.number.isRequired,
  onChange: Je.func.isRequired,
  children: Je.arrayOf(Je.node).isRequired,
  ampm: Je.bool,
  minutesStep: Je.number,
  innerRef: Je.any
});
zE.defaultProps = {
  ampm: !1,
  minutesStep: 1
};
var w8 = function(t) {
  return Fy({
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      margin: "".concat(t.spacing(2), "px 0 ").concat(t.spacing(1), "px")
    },
    clock: {
      backgroundColor: "rgba(0,0,0,.07)",
      borderRadius: "50%",
      height: 260,
      width: 260,
      position: "relative",
      pointerEvents: "none"
    },
    squareMask: {
      width: "100%",
      height: "100%",
      position: "absolute",
      pointerEvents: "auto",
      outline: "none",
      touchActions: "none",
      userSelect: "none",
      "&:active": {
        cursor: "move"
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: t.palette.primary.main,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }
  });
}, b8 = qt(w8, {
  name: "MuiPickersClock"
})(zE), S8 = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
}, E8 = li(function(o) {
  var t = o.spacing(4);
  return {
    clockNumber: {
      width: t,
      height: 32,
      userSelect: "none",
      position: "absolute",
      left: "calc((100% - ".concat(typeof t == "number" ? "".concat(t, "px") : t, ") / 2)"),
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      color: o.palette.type === "light" ? o.palette.text.primary : o.palette.text.hint
    },
    clockNumberSelected: {
      color: o.palette.primary.contrastText
    }
  };
}, {
  name: "MuiPickersClockNumber"
}), Xo = function(t) {
  var e = t.selected, r = t.label, n = t.index, i = t.isInner, a = E8(), s = Xe(a.clockNumber, e && a.clockNumberSelected), l = pr(function() {
    var u = S8[n];
    return {
      transform: "translate(".concat(u[0], "px, ").concat(u[1], "px")
    };
  }, [n]);
  return Ne(Ll, {
    component: "span",
    className: s,
    variant: i ? "body2" : "body1",
    style: l,
    children: r
  });
}, _8 = function(t) {
  for (var e = t.ampm, r = t.utils, n = t.date, i = r.getHours(n), a = [], s = e ? 1 : 0, l = e ? 12 : 23, u = function(g) {
    return e ? g === 12 ? i === 12 || i === 0 : i === g || i - 12 === g : i === g;
  }, c = s; c <= l; c += 1) {
    var d = c.toString();
    c === 0 && (d = "00");
    var f = {
      index: c,
      label: r.formatNumber(d),
      selected: u(c),
      isInner: !e && (c === 0 || c > 12)
    };
    a.push(Ne(Xo, Ce({
      key: c
    }, f)));
  }
  return a;
}, LR = function(t) {
  var e = t.value, r = t.utils, n = r.formatNumber;
  return [Ne(Xo, {
    label: n("00"),
    selected: e === 0,
    index: 12,
    key: 12
  }), Ne(Xo, {
    label: n("05"),
    selected: e === 5,
    index: 1,
    key: 1
  }), Ne(Xo, {
    label: n("10"),
    selected: e === 10,
    index: 2,
    key: 2
  }), Ne(Xo, {
    label: n("15"),
    selected: e === 15,
    index: 3,
    key: 3
  }), Ne(Xo, {
    label: n("20"),
    selected: e === 20,
    index: 4,
    key: 4
  }), Ne(Xo, {
    label: n("25"),
    selected: e === 25,
    index: 5,
    key: 5
  }), Ne(Xo, {
    label: n("30"),
    selected: e === 30,
    index: 6,
    key: 6
  }), Ne(Xo, {
    label: n("35"),
    selected: e === 35,
    index: 7,
    key: 7
  }), Ne(Xo, {
    label: n("40"),
    selected: e === 40,
    index: 8,
    key: 8
  }), Ne(Xo, {
    label: n("45"),
    selected: e === 45,
    index: 9,
    key: 9
  }), Ne(Xo, {
    label: n("50"),
    selected: e === 50,
    index: 10,
    key: 10
  }), Ne(Xo, {
    label: n("55"),
    selected: e === 55,
    index: 11,
    key: 11
  })];
}, Pl = function(t) {
  var e = t.type, r = t.onHourChange, n = t.onMinutesChange, i = t.onSecondsChange, a = t.ampm, s = t.date, l = t.minutesStep, u = aa(), c = pr(function() {
    switch (e) {
      case ni.HOURS:
        return {
          value: u.getHours(s),
          children: _8({
            date: s,
            utils: u,
            ampm: !!a
          }),
          onChange: function(g, m) {
            var b = y8(s, u), S = C8(u.setHours(s, g), b, !!a, u);
            r(S, m);
          }
        };
      case ni.MINUTES:
        var d = u.getMinutes(s);
        return {
          value: d,
          children: LR({
            value: d,
            utils: u
          }),
          onChange: function(g, m) {
            var b = u.setMinutes(s, g);
            n(b, m);
          }
        };
      case ni.SECONDS:
        var f = u.getSeconds(s);
        return {
          value: f,
          children: LR({
            value: f,
            utils: u
          }),
          onChange: function(g, m) {
            var b = u.setSeconds(s, g);
            i(b, m);
          }
        };
      default:
        throw new Error("You must provide the type for TimePickerView");
    }
  }, [a, s, r, n, i, e, u]);
  return Ne(b8, Ce({
    type: e,
    ampm: a,
    minutesStep: l
  }, c));
};
Pl.displayName = "TimePickerView";
process.env.NODE_ENV !== "production" && (Pl.propTypes = {
  date: Je.object.isRequired,
  onHourChange: Je.func.isRequired,
  onMinutesChange: Je.func.isRequired,
  onSecondsChange: Je.func.isRequired,
  ampm: Je.bool,
  minutesStep: Je.number,
  type: Je.oneOf(Object.keys(ni).map(function(o) {
    return ni[o];
  })).isRequired
});
Pl.defaultProps = {
  ampm: !0,
  minutesStep: 1
};
zN(Pl);
function NR(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function x8(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NR(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : NR(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
Je.oneOfType([Je.object, Je.string, Je.number, Je.instanceOf(Date)]);
Je.oneOf(["year", "month", "day"]);
var R8 = {
  ampm: !0,
  invalidDateMessage: "Invalid Time Format"
}, YE = {
  minDate: /* @__PURE__ */ new Date("1900-01-01"),
  maxDate: /* @__PURE__ */ new Date("2100-01-01"),
  invalidDateMessage: "Invalid Date Format",
  minDateMessage: "Date should not be before minimal date",
  maxDateMessage: "Date should not be after maximal date",
  allowKeyboardControl: !0
};
x8({}, R8, {}, YE, {
  showTabs: !0
});
function T8(o, t, e) {
  var r = er(t && aS(o, t) ? t : o[0]), n = Bl(r, 2), i = n[0], a = n[1], s = Ai(function(l, u) {
    var c = o[o.indexOf(i) + 1];
    if (u && c) {
      e(l, !1), a(c);
      return;
    }
    e(l, !!u);
  }, [e, i, o]);
  return {
    handleChangeAndOpenNext: s,
    openView: i,
    setOpenView: a
  };
}
var O8 = li(function(o) {
  return {
    root: {
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      outline: "none",
      "&:focus": {
        color: o.palette.primary.main,
        fontWeight: o.typography.fontWeightMedium
      }
    },
    yearSelected: {
      margin: "10px 0",
      fontWeight: o.typography.fontWeightMedium
    },
    yearDisabled: {
      pointerEvents: "none",
      color: o.palette.text.hint
    }
  };
}, {
  name: "MuiPickersYear"
}), sM = function(t) {
  var e = t.onSelect, r = t.forwardedRef, n = t.value, i = t.selected, a = t.disabled, s = t.children, l = Ke(t, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]), u = O8(), c = Ai(function() {
    return e(n);
  }, [e, n]);
  return Ne(Ll, Ce({
    role: "button",
    component: "div",
    tabIndex: a ? -1 : 0,
    onClick: c,
    onKeyPress: c,
    color: i ? "primary" : void 0,
    variant: i ? "h5" : "subtitle1",
    children: s,
    ref: r,
    className: Xe(u.root, i && u.yearSelected, a && u.yearDisabled)
  }, l));
};
sM.displayName = "Year";
var P8 = sE(function(o, t) {
  return Ne(sM, Ce({}, o, {
    forwardedRef: t
  }));
}), D8 = li({
  container: {
    height: 300,
    overflowY: "auto"
  }
}, {
  name: "MuiPickersYearSelection"
}), lM = function(t) {
  var e = t.date, r = t.onChange, n = t.onYearChange, i = t.minDate, a = t.maxDate, s = t.disablePast, l = t.disableFuture, u = t.animateYearScrolling, c = aa(), d = D8(), f = si(ME), v = Cr(null);
  wr(function() {
    if (v.current && v.current.scrollIntoView)
      try {
        v.current.scrollIntoView({
          block: f === "static" ? "nearest" : "center",
          behavior: u ? "smooth" : "auto"
        });
      } catch {
        v.current.scrollIntoView();
      }
  }, []);
  var g = c.getYear(e), m = Ai(function(b) {
    var S = c.setYear(e, b);
    n && n(S), r(S, !0);
  }, [e, r, n, c]);
  return Ne("div", {
    className: d.container
  }, c.getYearRange(i, a).map(function(b) {
    var S = c.getYear(b), R = S === g;
    return Ne(P8, {
      key: c.getYearText(b),
      selected: R,
      value: S,
      onSelect: m,
      ref: R ? v : void 0,
      disabled: !!(s && c.isBeforeYear(b, c.date()) || l && c.isAfterYear(b, c.date()))
    }, c.getYearText(b));
  }));
}, A8 = li(function(o) {
  return {
    root: {
      flex: "1 0 33.33%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      outline: "none",
      height: 75,
      transition: o.transitions.create("font-size", {
        duration: "100ms"
      }),
      "&:focus": {
        color: o.palette.primary.main,
        fontWeight: o.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: o.palette.primary.main,
      fontWeight: o.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: "none",
      color: o.palette.text.hint
    }
  };
}, {
  name: "MuiPickersMonth"
}), uM = function(t) {
  var e = t.selected, r = t.onSelect, n = t.disabled, i = t.value, a = t.children, s = Ke(t, ["selected", "onSelect", "disabled", "value", "children"]), l = A8(), u = Ai(function() {
    r(i);
  }, [r, i]);
  return Ne(Ll, Ce({
    role: "button",
    component: "div",
    className: Xe(l.root, e && l.monthSelected, n && l.monthDisabled),
    tabIndex: n ? -1 : 0,
    onClick: u,
    onKeyPress: u,
    color: e ? "primary" : void 0,
    variant: e ? "h5" : "subtitle1",
    children: a
  }, s));
};
uM.displayName = "Month";
var M8 = li({
  container: {
    width: 310,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch"
  }
}, {
  name: "MuiPickersMonthSelection"
}), cM = function(t) {
  var e = t.disablePast, r = t.disableFuture, n = t.minDate, i = t.maxDate, a = t.date, s = t.onMonthChange, l = t.onChange, u = aa(), c = M8(), d = u.getMonth(a), f = function(m) {
    var b = u.date(), S = u.date(n), R = u.date(i), P = u.startOfMonth(e && u.isAfter(b, S) ? b : S), D = u.startOfMonth(r && u.isBefore(b, R) ? b : R), x = u.isBefore(m, P), M = u.isAfter(m, D);
    return x || M;
  }, v = Ai(function(g) {
    var m = u.setMonth(a, g);
    l(m, !0), s && s(m);
  }, [a, l, s, u]);
  return Ne("div", {
    className: c.container
  }, u.getMonthArray(a).map(function(g) {
    var m = u.getMonth(g), b = u.format(g, "MMM");
    return Ne(uM, {
      key: b,
      value: m,
      selected: m === d,
      onSelect: v,
      disabled: f(g)
    }, b);
  }));
}, kR = function() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
};
function F8(o) {
  var t = er(kR()), e = Bl(t, 2), r = e[0], n = e[1], i = Ai(function() {
    return n(kR());
  }, []);
  RA(function() {
    return window.addEventListener("orientationchange", i), function() {
      return window.removeEventListener("orientationchange", i);
    };
  }, [i]);
  var a = o || r;
  return a === "landscape";
}
function GR(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function I8(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GR(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : GR(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
var L8 = {
  year: lM,
  month: cM,
  date: nM,
  hours: Pl,
  minutes: Pl,
  seconds: Pl
}, N8 = li({
  container: {
    display: "flex",
    flexDirection: "column"
  },
  containerLandscape: {
    flexDirection: "row"
  },
  pickerView: {
    overflowX: "hidden",
    minHeight: s4,
    minWidth: DE,
    maxWidth: _A,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  pickerViewLandscape: {
    padding: "0 8px"
  }
}, {
  name: "MuiPickersBasePicker"
}), dM = function(t) {
  var e = t.date, r = t.views, n = t.disableToolbar, i = t.onChange, a = t.openTo, s = t.minDate, l = t.maxDate, u = t.ToolbarComponent, c = t.orientation, d = Ke(t, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]), f = aa(), v = N8(), g = F8(c), m = T8(r, a, i), b = m.openView, S = m.setOpenView, R = m.handleChangeAndOpenNext, P = pr(function() {
    return f.date(s);
  }, [s, f]), D = pr(function() {
    return f.date(l);
  }, [l, f]);
  return Ne("div", {
    className: Xe(v.container, g && v.containerLandscape)
  }, !n && Ne(u, Ce({}, d, {
    views: r,
    isLandscape: g,
    date: e,
    onChange: i,
    setOpenView: S,
    openView: b
  })), Ne("div", {
    className: Xe(v.pickerView, g && v.pickerViewLandscape)
  }, b === "year" && Ne(lM, Ce({}, d, {
    date: e,
    onChange: R,
    minDate: P,
    maxDate: D
  })), b === "month" && Ne(cM, Ce({}, d, {
    date: e,
    onChange: R,
    minDate: P,
    maxDate: D
  })), b === "date" && Ne(nM, Ce({}, d, {
    date: e,
    onChange: R,
    minDate: P,
    maxDate: D
  })), (b === "hours" || b === "minutes" || b === "seconds") && Ne(Pl, Ce({}, d, {
    date: e,
    type: b,
    onHourChange: R,
    onMinutesChange: R,
    onSecondsChange: R
  }))));
};
dM.defaultProps = I8({}, YE, {
  views: Object.keys(L8)
});
var k8 = li(function(o) {
  var t = o.palette.type === "light" ? o.palette.primary.contrastText : o.palette.getContrastText(o.palette.background.default);
  return {
    toolbarTxt: {
      color: U9(t, 0.54)
    },
    toolbarBtnSelected: {
      color: t
    }
  };
}, {
  name: "MuiPickersToolbarText"
}), G8 = function(t) {
  var e = t.selected, r = t.label, n = t.className, i = n === void 0 ? null : n, a = Ke(t, ["selected", "label", "className"]), s = k8();
  return Ne(Ll, Ce({
    children: r,
    className: Xe(s.toolbarTxt, i, e && s.toolbarBtnSelected)
  }, a));
}, KE = function(t) {
  var e = t.classes, r = t.className, n = r === void 0 ? null : r, i = t.label, a = t.selected, s = t.variant, l = t.align, u = t.typographyClassName, c = Ke(t, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);
  return Ne(ih, Ce({
    variant: "text",
    className: Xe(e.toolbarBtn, n)
  }, c), Ne(G8, {
    align: l,
    className: u,
    variant: s,
    label: i,
    selected: a
  }));
};
process.env.NODE_ENV !== "production" && (KE.propTypes = {
  selected: Je.bool.isRequired,
  label: Je.string.isRequired,
  classes: Je.any.isRequired,
  className: Je.string,
  innerRef: Je.any
});
KE.defaultProps = {
  className: ""
};
var V8 = Fy({
  toolbarBtn: {
    padding: 0,
    minWidth: "16px",
    textTransform: "none"
  }
}), aw = qt(V8, {
  name: "MuiPickersToolbarButton"
})(KE), H8 = li(function(o) {
  return {
    toolbar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      height: 100,
      backgroundColor: o.palette.type === "light" ? o.palette.primary.main : o.palette.background.default
    },
    toolbarLandscape: {
      height: "auto",
      maxWidth: 150,
      padding: 8,
      justifyContent: "flex-start"
    }
  };
}, {
  name: "MuiPickersToolbar"
}), B8 = function(t) {
  var e = t.children, r = t.isLandscape, n = t.className, i = n === void 0 ? null : n, a = Ke(t, ["children", "isLandscape", "className"]), s = H8();
  return Ne(NG, Ce({
    className: Xe(s.toolbar, i, r && s.toolbarLandscape)
  }, a), e);
};
function VR(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function W8(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VR(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : VR(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
var pM = function(t) {
  var e = t.inputValue, r = t.inputVariant, n = t.validationError, i = t.InputProps, a = t.openPicker, s = t.TextFieldComponent, l = s === void 0 ? qA : s, u = Ke(t, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]), c = pr(function() {
    return W8({}, i, {
      readOnly: !0
    });
  }, [i]);
  return Ne(l, Ce({
    error: !!n,
    helperText: n
  }, u, {
    // do not overridable
    onClick: a,
    value: e,
    variant: r,
    InputProps: c,
    onKeyDown: function(f) {
      f.keyCode === 32 && (f.stopPropagation(), a());
    }
  }));
};
pM.displayName = "PureDateInput";
var j8 = function(t) {
  return y.createElement(Lh, t, y.createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), y.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}, fM = function(t, e, r, n, i) {
  var a = i.invalidLabel, s = i.emptyLabel, l = i.labelFunc, u = r.date(t);
  return l ? l(n ? null : u, a) : n ? s || "" : r.isValid(u) ? r.format(u, e) : a;
}, HR = function(t, e, r) {
  return e ? r : t.endOfDay(r);
}, BR = function(t, e, r) {
  return e ? r : t.startOfDay(r);
}, U8 = function(t, e, r) {
  var n = r.maxDate, i = r.minDate, a = r.disablePast, s = r.disableFuture, l = r.maxDateMessage, u = r.minDateMessage, c = r.invalidDateMessage, d = r.strictCompareDates, f = e.date(t);
  return t === null ? "" : e.isValid(t) ? n && e.isAfter(f, HR(e, !!d, e.date(n))) || s && e.isAfter(f, HR(e, !!d, e.date())) ? l : i && e.isBefore(f, BR(e, !!d, e.date(i))) || a && e.isBefore(f, BR(e, !!d, e.date())) ? u : "" : c;
};
function $8(o, t) {
  return o.replace(/[a-z]/gi, t);
}
var z8 = function(t, e, r) {
  return function(n) {
    var i = "", a = n.replace(r, "");
    if (a === "")
      return a;
    for (var s = 0, l = 0; s < t.length; ) {
      var u = t[s];
      if (u === e && l < a.length) {
        var c = a[l];
        i += c, l += 1;
      } else
        i += u;
      s += 1;
    }
    return i;
  };
};
function WR(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function Y8(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WR(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : WR(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
var hM = function(t) {
  var e = t.inputValue, r = t.inputVariant, n = t.validationError, i = t.KeyboardButtonProps, a = t.InputAdornmentProps, s = t.openPicker, l = t.onChange, u = t.InputProps, c = t.mask, d = t.maskChar, f = d === void 0 ? "_" : d, v = t.refuse, g = v === void 0 ? /[^\d]+/gi : v, m = t.format, b = t.keyboardIcon, S = t.disabled, R = t.rifmFormatter, P = t.TextFieldComponent, D = P === void 0 ? qA : P, x = Ke(t, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]), M = c || $8(m, f), F = pr(function() {
    return z8(M, f, g);
  }, [M, f, g]), H = a && a.position ? a.position : "end", B = function(V) {
    var W = V === "" || V === M ? null : V;
    l(W);
  };
  return Ne(Z4, {
    key: M,
    value: e,
    onChange: B,
    refuse: g,
    format: R || F
  }, function(j) {
    var V = j.onChange, W = j.value;
    return Ne(D, Ce({
      disabled: S,
      error: !!n,
      helperText: n
    }, x, {
      value: W,
      onChange: V,
      variant: r,
      InputProps: Y8({}, u, Cn({}, "".concat(H, "Adornment"), Ne(X4, Ce({
        position: H
      }, a), Ne(Lm, Ce({
        disabled: S
      }, i, {
        onClick: s
      }), b))))
    }));
  });
};
hM.defaultProps = {
  keyboardIcon: Ne(j8, null)
};
function K8(o) {
  var t = o.open, e = o.onOpen, r = o.onClose, n = null;
  if (t == null) {
    var i = er(!1), a = Bl(i, 2);
    t = a[0], n = a[1];
  }
  var s = Ai(function(l) {
    return n && n(l), l ? e && e() : r && r();
  }, [e, r, n]);
  return {
    isOpen: t,
    setIsOpen: s
  };
}
var q8 = function(t, e) {
  var r = e.value, n = e.initialFocusedDate, i = Cr(t.date()), a = t.date(r || n || i.current);
  return a && t.isValid(a) ? a : i.current;
};
function X8(o, t) {
  var e = aa(), r = q8(e, o), n = o.format || t.getDefaultFormat();
  return {
    date: r,
    format: n
  };
}
function vM(o, t) {
  var e = o.autoOk, r = o.disabled, n = o.readOnly, i = o.onAccept, a = o.onChange, s = o.onError, l = o.value, u = o.variant, c = aa(), d = K8(o), f = d.isOpen, v = d.setIsOpen, g = X8(o, t), m = g.date, b = g.format, S = er(m), R = Bl(S, 2), P = R[0], D = R[1];
  wr(function() {
    !f && !c.isEqual(P, m) && D(m);
  }, [m, f, P, c]);
  var x = Ai(function(W) {
    a(W), i && i(W), v(!1);
  }, [i, a, v]), M = pr(function() {
    return {
      format: b,
      open: f,
      onClear: function() {
        return x(null);
      },
      onAccept: function() {
        return x(P);
      },
      onSetToday: function() {
        return D(c.date());
      },
      onDismiss: function() {
        v(!1);
      }
    };
  }, [x, b, f, P, v, c]), F = pr(function() {
    return {
      date: P,
      onChange: function(q) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        if (D(q), ee && e) {
          x(q);
          return;
        }
        (u === "inline" || u === "static") && (a(q), i && i(q));
      }
    };
  }, [x, e, i, a, P, u]), H = U8(l, c, o);
  wr(function() {
    s && s(H, l);
  }, [s, H, l]);
  var B = fM(m, b, c, l === null, o), j = pr(function() {
    return {
      inputValue: B,
      validationError: H,
      openPicker: function() {
        return !n && !r && v(!0);
      }
    };
  }, [r, B, n, v, H]), V = {
    pickerProps: F,
    inputProps: j,
    wrapperProps: M
  };
  return YN(V), V;
}
function jR(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function UR(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jR(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : jR(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
function Z8(o, t, e) {
  try {
    return t.parse(o, e);
  } catch {
    return null;
  }
}
function Q8(o, t) {
  var e = o.format, r = e === void 0 ? t.getDefaultFormat() : e, n = o.inputValue, i = o.onChange, a = o.value, s = aa(), l = fM(a, r, s, a === null, o), u = er(l), c = Bl(u, 2), d = c[0], f = c[1], v = n ? Z8(n, s, r) : a;
  wr(function() {
    (a === null || s.isValid(a)) && f(l);
  }, [l, f, s, a]);
  var g = Ai(function(D) {
    i(D, D === null ? null : s.format(D, r));
  }, [r, i, s]), m = vM(
    // Extend props interface
    UR({}, o, {
      value: v,
      onChange: g
    }),
    t
  ), b = m.inputProps, S = m.wrapperProps, R = m.pickerProps, P = pr(function() {
    return UR({}, b, {
      // reuse validation and open/close logic
      format: S.format,
      inputValue: n || d,
      onChange: function(x) {
        f(x || "");
        var M = x === null ? null : s.parse(x, S.format);
        i(M, x);
      }
    });
  }, [b, d, n, i, s, S.format]);
  return {
    inputProps: P,
    wrapperProps: S,
    pickerProps: R
  };
}
function gM(o) {
  var t = o.Input, e = o.useState, r = o.useOptions, n = o.getCustomProps, i = o.DefaultToolbarComponent;
  function a(s) {
    var l = s.allowKeyboardControl, u = s.ampm, c = s.animateYearScrolling;
    s.autoOk;
    var d = s.dateRangeIcon, f = s.disableFuture, v = s.disablePast, g = s.disableToolbar;
    s.emptyLabel, s.format, s.forwardedRef;
    var m = s.hideTabs;
    s.initialFocusedDate, s.invalidDateMessage, s.invalidLabel, s.labelFunc;
    var b = s.leftArrowButtonProps, S = s.leftArrowIcon, R = s.loadingIndicator, P = s.maxDate;
    s.maxDateMessage;
    var D = s.minDate;
    s.minDateMessage;
    var x = s.minutesStep;
    s.onAccept, s.onChange, s.onClose;
    var M = s.onMonthChange;
    s.onOpen;
    var F = s.onYearChange, H = s.openTo, B = s.orientation, j = s.renderDay, V = s.rightArrowButtonProps, W = s.rightArrowIcon, q = s.shouldDisableDate, ee = s.strictCompareDates, re = s.timeIcon, ie = s.ToolbarComponent, ne = ie === void 0 ? i : ie;
    s.value;
    var se = s.variant, pe = s.views, K = Ke(s, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]), J = n ? n(s) : {}, ue = r(s), he = e(s, ue), fe = he.pickerProps, ae = he.inputProps, oe = he.wrapperProps;
    return Ne(f4, Ce({
      variant: se,
      InputComponent: t,
      DateInputProps: ae
    }, J, oe, K), Ne(dM, Ce({}, fe, {
      allowKeyboardControl: l,
      ampm: u,
      animateYearScrolling: c,
      dateRangeIcon: d,
      disableFuture: f,
      disablePast: v,
      disableToolbar: g,
      hideTabs: m,
      leftArrowButtonProps: b,
      leftArrowIcon: S,
      loadingIndicator: R,
      maxDate: P,
      minDate: D,
      minutesStep: x,
      onMonthChange: M,
      onYearChange: F,
      openTo: H,
      orientation: B,
      renderDay: j,
      rightArrowButtonProps: V,
      rightArrowIcon: W,
      shouldDisableDate: q,
      strictCompareDates: ee,
      timeIcon: re,
      ToolbarComponent: ne,
      views: pe
    })));
  }
  return a;
}
var J8 = li({
  toolbar: {
    flexDirection: "column",
    alignItems: "flex-start"
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: "MuiPickersDatePickerRoot"
}), mM = function(t) {
  var e = t.date, r = t.views, n = t.setOpenView, i = t.isLandscape, a = t.openView, s = aa(), l = J8(), u = pr(function() {
    return JA(r);
  }, [r]), c = pr(function() {
    return eM(r);
  }, [r]);
  return Ne(B8, {
    isLandscape: i,
    className: Xe(!u && l.toolbar, i && l.toolbarLandscape)
  }, Ne(aw, {
    variant: u ? "h3" : "subtitle1",
    onClick: function() {
      return n("year");
    },
    selected: a === "year",
    label: s.getYearText(e)
  }), !u && !c && Ne(aw, {
    variant: "h4",
    selected: a === "date",
    onClick: function() {
      return n("date");
    },
    align: i ? "left" : "center",
    label: s.getDatePickerHeaderText(e),
    className: Xe(i && l.dateLandscape)
  }), c && Ne(aw, {
    variant: "h4",
    onClick: function() {
      return n("month");
    },
    selected: a === "month",
    label: s.getMonthText(e)
  }));
};
function $R(o, t) {
  var e = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function eV(o) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $R(e, !0).forEach(function(r) {
      Cn(o, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(e)) : $R(e).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return o;
}
var yM = eV({}, YE, {
  openTo: "date",
  views: ["year", "date"]
});
function CM(o) {
  var t = aa();
  return {
    getDefaultFormat: function() {
      return r8(o.views, t);
    }
  };
}
var wM = gM({
  useOptions: CM,
  Input: pM,
  useState: vM,
  DefaultToolbarComponent: mM
}), bM = gM({
  useOptions: CM,
  Input: hM,
  useState: Q8,
  DefaultToolbarComponent: mM
});
wM.defaultProps = yM;
bM.defaultProps = yM;
let gn = typeof window < "u" ? lD : wr;
function Ss(o) {
  let t = Cr(o);
  return gn(() => {
    t.current = o;
  }, [o]), t;
}
function qE(o, t) {
  let [e, r] = er(o), n = Ss(o);
  return gn(() => r(n.current), [n, r, ...t]), e;
}
function np() {
  let o = [], t = [], e = { enqueue(r) {
    t.push(r);
  }, addEventListener(r, n, i, a) {
    return r.addEventListener(n, i, a), e.add(() => r.removeEventListener(n, i, a));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return e.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return e.requestAnimationFrame(() => e.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return e.add(() => clearTimeout(n));
  }, add(r) {
    return o.push(r), () => {
      let n = o.indexOf(r);
      if (n >= 0) {
        let [i] = o.splice(n, 1);
        i();
      }
    };
  }, dispose() {
    for (let r of o.splice(0)) r();
  }, async workQueue() {
    for (let r of t.splice(0)) await r();
  } };
  return e;
}
function XE() {
  let [o] = er(np);
  return wr(() => () => o.dispose(), [o]), o;
}
let yr = function(o) {
  let t = Ss(o);
  return y.useCallback((...e) => t.current(...e), [t]);
}, sw = { serverHandoffComplete: !1 };
function ZE() {
  let [o, t] = er(sw.serverHandoffComplete);
  return wr(() => {
    o !== !0 && t(!0);
  }, [o]), wr(() => {
    sw.serverHandoffComplete === !1 && (sw.serverHandoffComplete = !0);
  }, []), o;
}
var zR;
let tV = 0;
function YR() {
  return ++tV;
}
let xs = (zR = y.useId) != null ? zR : function() {
  let o = ZE(), [t, e] = y.useState(o ? YR : null);
  return gn(() => {
    t === null && e(YR());
  }, [t]), t != null ? "" + t : void 0;
};
function wn(o, t, ...e) {
  if (o in t) {
    let n = t[o];
    return typeof n == "function" ? n(...e) : n;
  }
  let r = new Error(`Tried to handle "${o}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((n) => `"${n}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, wn), r;
}
function SM(o) {
  return typeof window > "u" ? null : o instanceof Node ? o.ownerDocument : o != null && o.hasOwnProperty("current") && o.current instanceof Node ? o.current.ownerDocument : document;
}
let KR = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((o) => `${o}:not([tabindex='-1'])`).join(",");
var rV = ((o) => (o[o.First = 1] = "First", o[o.Previous = 2] = "Previous", o[o.Next = 4] = "Next", o[o.Last = 8] = "Last", o[o.WrapAround = 16] = "WrapAround", o[o.NoScroll = 32] = "NoScroll", o))(rV || {}), nV = ((o) => (o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))(nV || {}), oV = ((o) => (o[o.Previous = -1] = "Previous", o[o.Next = 1] = "Next", o))(oV || {}), EM = ((o) => (o[o.Strict = 0] = "Strict", o[o.Loose = 1] = "Loose", o))(EM || {});
function iV(o, t = 0) {
  var e;
  return o === ((e = SM(o)) == null ? void 0 : e.body) ? !1 : wn(t, { 0() {
    return o.matches(KR);
  }, 1() {
    let r = o;
    for (; r !== null; ) {
      if (r.matches(KR)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function aV(o, t = (e) => e) {
  return o.slice().sort((e, r) => {
    let n = t(e), i = t(r);
    if (n === null || i === null) return 0;
    let a = n.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function qR(o, t, e) {
  let r = Ss(t);
  wr(() => {
    function n(i) {
      r.current(i);
    }
    return window.addEventListener(o, n, e), () => window.removeEventListener(o, n, e);
  }, [o, e]);
}
function sV(o, t, e = !0) {
  let r = Cr(!1);
  wr(() => {
    requestAnimationFrame(() => {
      r.current = e;
    });
  }, [e]);
  function n(i, a) {
    if (!r.current || i.defaultPrevented) return;
    let s = function u(c) {
      return typeof c == "function" ? u(c()) : Array.isArray(c) || c instanceof Set ? c : [c];
    }(o), l = a(i);
    if (l !== null && l.ownerDocument.documentElement.contains(l)) {
      for (let u of s) {
        if (u === null) continue;
        let c = u instanceof HTMLElement ? u : u.current;
        if (c != null && c.contains(l)) return;
      }
      return !iV(l, EM.Loose) && l.tabIndex !== -1 && i.preventDefault(), t(i, l);
    }
  }
  qR("click", (i) => n(i, (a) => a.target), !0), qR("blur", (i) => n(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function XR(o) {
  var t;
  if (o.type) return o.type;
  let e = (t = o.as) != null ? t : "button";
  if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function _M(o, t) {
  let [e, r] = er(() => XR(o));
  return gn(() => {
    r(XR(o));
  }, [o.type, o.as]), gn(() => {
    e || !t.current || t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [e, t]), e;
}
let lV = Symbol();
function Wa(...o) {
  let t = Cr(o);
  wr(() => {
    t.current = o;
  }, [o]);
  let e = yr((r) => {
    for (let n of t.current) n != null && (typeof n == "function" ? n(r) : n.current = r);
  });
  return o.every((r) => r == null || (r == null ? void 0 : r[lV])) ? void 0 : e;
}
function uV({ container: o, accept: t, walk: e, enabled: r = !0 }) {
  let n = Cr(t), i = Cr(e);
  wr(() => {
    n.current = t, i.current = e;
  }, [t, e]), gn(() => {
    if (!o || !r) return;
    let a = SM(o);
    if (!a) return;
    let s = n.current, l = i.current, u = Object.assign((d) => s(d), { acceptNode: s }), c = a.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; c.nextNode(); ) l(c.currentNode);
  }, [o, r, n, i]);
}
function cV(o) {
  throw new Error("Unexpected object: " + o);
}
var fo = ((o) => (o[o.First = 0] = "First", o[o.Previous = 1] = "Previous", o[o.Next = 2] = "Next", o[o.Last = 3] = "Last", o[o.Specific = 4] = "Specific", o[o.Nothing = 5] = "Nothing", o))(fo || {});
function dV(o, t) {
  let e = t.resolveItems();
  if (e.length <= 0) return null;
  let r = t.resolveActiveIndex(), n = r ?? -1, i = (() => {
    switch (o.focus) {
      case 0:
        return e.findIndex((a) => !t.resolveDisabled(a));
      case 1: {
        let a = e.slice().reverse().findIndex((s, l, u) => n !== -1 && u.length - l - 1 >= n ? !1 : !t.resolveDisabled(s));
        return a === -1 ? a : e.length - 1 - a;
      }
      case 2:
        return e.findIndex((a, s) => s <= n ? !1 : !t.resolveDisabled(a));
      case 3: {
        let a = e.slice().reverse().findIndex((s) => !t.resolveDisabled(s));
        return a === -1 ? a : e.length - 1 - a;
      }
      case 4:
        return e.findIndex((a) => t.resolveId(a) === o.id);
      case 5:
        return null;
      default:
        cV(o);
    }
  })();
  return i === -1 ? r : i;
}
var Nm = ((o) => (o[o.None = 0] = "None", o[o.RenderStrategy = 1] = "RenderStrategy", o[o.Static = 2] = "Static", o))(Nm || {}), vs = ((o) => (o[o.Unmount = 0] = "Unmount", o[o.Hidden = 1] = "Hidden", o))(vs || {});
function ui({ ourProps: o, theirProps: t, slot: e, defaultTag: r, features: n, visible: i = !0, name: a }) {
  let s = xM(t, o);
  if (i) return ug(s, e, r, a);
  let l = n ?? 0;
  if (l & 2) {
    let { static: u = !1, ...c } = s;
    if (u) return ug(c, e, r, a);
  }
  if (l & 1) {
    let { unmount: u = !0, ...c } = s;
    return wn(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return ug({ ...c, hidden: !0, style: { display: "none" } }, e, r, a);
    } });
  }
  return ug(s, e, r, a);
}
function ug(o, t = {}, e, r) {
  let { as: n = e, children: i, refName: a = "ref", ...s } = lw(o, ["unmount", "static"]), l = o.ref !== void 0 ? { [a]: o.ref } : {}, u = typeof i == "function" ? i(t) : i;
  s.className && typeof s.className == "function" && (s.className = s.className(t));
  let c = {};
  if (n === yn && Object.keys(km(s)).length > 0) {
    if (!fh(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s).map((d) => `  - ${d}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d) => `  - ${d}`).join(`
`)].join(`
`));
    return Yd(u, Object.assign({}, xM(u.props, km(lw(s, ["ref"]))), c, l));
  }
  return Ne(n, Object.assign({}, lw(s, ["ref"]), n !== yn && l, n !== yn && c), u);
}
function xM(...o) {
  if (o.length === 0) return {};
  if (o.length === 1) return o[0];
  let t = {}, e = {};
  for (let r of o) for (let n in r) n.startsWith("on") && typeof r[n] == "function" ? (e[n] != null || (e[n] = []), e[n].push(r[n])) : t[n] = r[n];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((r) => [r, void 0])));
  for (let r in e) Object.assign(t, { [r](n, ...i) {
    let a = e[r];
    for (let s of a) {
      if (n.defaultPrevented) return;
      s(n, ...i);
    }
  } });
  return t;
}
function ci(o) {
  var t;
  return Object.assign(sE(o), { displayName: (t = o.displayName) != null ? t : o.name });
}
function km(o) {
  let t = Object.assign({}, o);
  for (let e in t) t[e] === void 0 && delete t[e];
  return t;
}
function lw(o, t = []) {
  let e = Object.assign({}, o);
  for (let r of t) r in e && delete e[r];
  return e;
}
function RM(o) {
  let t = o.parentElement, e = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (e = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && pV(e) ? !1 : r;
}
function pV(o) {
  if (!o) return !1;
  let t = o.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function TM(o = {}, t = null, e = []) {
  for (let [r, n] of Object.entries(o)) PM(e, OM(t, r), n);
  return e;
}
function OM(o, t) {
  return o ? o + "[" + t + "]" : t;
}
function PM(o, t, e) {
  if (Array.isArray(e)) for (let [r, n] of e.entries()) PM(o, OM(t, r.toString()), n);
  else e instanceof Date ? o.push([t, e.toISOString()]) : typeof e == "boolean" ? o.push([t, e ? "1" : "0"]) : typeof e == "string" ? o.push([t, e]) : typeof e == "number" ? o.push([t, `${e}`]) : e == null ? o.push([t, ""]) : TM(e, t, o);
}
function fV(o) {
  var t;
  let e = (t = o == null ? void 0 : o.form) != null ? t : o.closest("form");
  if (e) {
    for (let r of e.elements) if (r.tagName === "INPUT" && r.type === "submit" || r.tagName === "BUTTON" && r.type === "submit" || r.nodeName === "INPUT" && r.type === "image") {
      r.click();
      return;
    }
  }
}
let hV = "div";
var QE = ((o) => (o[o.None = 1] = "None", o[o.Focusable = 2] = "Focusable", o[o.Hidden = 4] = "Hidden", o))(QE || {});
let DM = ci(function(o, t) {
  let { features: e = 1, ...r } = o, n = { ref: t, "aria-hidden": (e & 2) === 2 ? !0 : void 0, style: { position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(e & 4) === 4 && (e & 2) !== 2 && { display: "none" } } };
  return ui({ ourProps: n, theirProps: r, slot: {}, defaultTag: hV, name: "Hidden" });
}), JE = Mi(null);
JE.displayName = "OpenClosedContext";
var Nl = ((o) => (o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))(Nl || {});
function e1() {
  return si(JE);
}
function AM({ value: o, children: t }) {
  return y.createElement(JE.Provider, { value: o }, t);
}
var Wn = ((o) => (o.Space = " ", o.Enter = "Enter", o.Escape = "Escape", o.Backspace = "Backspace", o.Delete = "Delete", o.ArrowLeft = "ArrowLeft", o.ArrowUp = "ArrowUp", o.ArrowRight = "ArrowRight", o.ArrowDown = "ArrowDown", o.Home = "Home", o.End = "End", o.PageUp = "PageUp", o.PageDown = "PageDown", o.Tab = "Tab", o))(Wn || {}), vV = ((o) => (o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))(vV || {}), gV = ((o) => (o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))(gV || {}), mV = ((o) => (o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))(mV || {}), yV = ((o) => (o[o.OpenCombobox = 0] = "OpenCombobox", o[o.CloseCombobox = 1] = "CloseCombobox", o[o.GoToOption = 2] = "GoToOption", o[o.RegisterOption = 3] = "RegisterOption", o[o.UnregisterOption = 4] = "UnregisterOption", o))(yV || {});
function uw(o, t = (e) => e) {
  let e = o.activeOptionIndex !== null ? o.options[o.activeOptionIndex] : null, r = aV(t(o.options.slice()), (i) => i.dataRef.current.domRef.current), n = e ? r.indexOf(e) : null;
  return n === -1 && (n = null), { options: r, activeOptionIndex: n };
}
let CV = { 1(o) {
  return o.dataRef.current.disabled || o.comboboxState === 1 ? o : { ...o, activeOptionIndex: null, comboboxState: 1 };
}, 0(o) {
  if (o.dataRef.current.disabled || o.comboboxState === 0) return o;
  let t = o.activeOptionIndex, { isSelected: e } = o.dataRef.current, r = o.options.findIndex((n) => e(n.dataRef.current.value));
  return r !== -1 && (t = r), { ...o, comboboxState: 0, activeOptionIndex: t };
}, 2(o, t) {
  var e;
  if (o.dataRef.current.disabled || o.dataRef.current.optionsRef.current && !o.dataRef.current.optionsPropsRef.current.static && o.comboboxState === 1) return o;
  let r = uw(o);
  if (r.activeOptionIndex === null) {
    let i = r.options.findIndex((a) => !a.dataRef.current.disabled);
    i !== -1 && (r.activeOptionIndex = i);
  }
  let n = dV(t, { resolveItems: () => r.options, resolveActiveIndex: () => r.activeOptionIndex, resolveId: (i) => i.id, resolveDisabled: (i) => i.dataRef.current.disabled });
  return { ...o, ...r, activeOptionIndex: n, activationTrigger: (e = t.trigger) != null ? e : 1 };
}, 3: (o, t) => {
  let e = { id: t.id, dataRef: t.dataRef }, r = uw(o, (i) => [...i, e]);
  o.activeOptionIndex === null && o.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(e));
  let n = { ...o, ...r, activationTrigger: 1 };
  return o.dataRef.current.__demoMode && o.dataRef.current.value === void 0 && (n.activeOptionIndex = 0), n;
}, 4: (o, t) => {
  let e = uw(o, (r) => {
    let n = r.findIndex((i) => i.id === t.id);
    return n !== -1 && r.splice(n, 1), r;
  });
  return { ...o, ...e, activationTrigger: 1 };
} }, t1 = Mi(null);
t1.displayName = "ComboboxActionsContext";
function Hy(o) {
  let t = si(t1);
  if (t === null) {
    let e = new Error(`<${o} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(e, Hy), e;
  }
  return t;
}
let r1 = Mi(null);
r1.displayName = "ComboboxDataContext";
function hp(o) {
  let t = si(r1);
  if (t === null) {
    let e = new Error(`<${o} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(e, hp), e;
  }
  return t;
}
function wV(o, t) {
  return wn(t.type, CV, o, t);
}
let bV = yn, SV = ci(function(o, t) {
  let { name: e, value: r, onChange: n, disabled: i = !1, __demoMode: a = !1, nullable: s = !1, multiple: l = !1, ...u } = o, [c, d] = KN(wV, { dataRef: qN(), comboboxState: a ? 0 : 1, options: [], activeOptionIndex: null, activationTrigger: 1 }), f = Cr(!1), v = Cr({ static: !1, hold: !1 }), g = Cr({ displayValue: void 0 }), m = Cr(null), b = Cr(null), S = Cr(null), R = Cr(null), P = yr((ne, se) => ne === se), D = Ai((ne) => wn(x.mode, { 1: () => r.some((se) => P(se, ne)), 0: () => P(r, ne) }), [r]), x = pr(() => ({ ...c, optionsPropsRef: v, inputPropsRef: g, labelRef: m, inputRef: b, buttonRef: S, optionsRef: R, value: r, disabled: i, mode: l ? 1 : 0, get activeOptionIndex() {
    if (f.current && c.activeOptionIndex === null && c.options.length > 0) {
      let ne = c.options.findIndex((se) => !se.dataRef.current.disabled);
      if (ne !== -1) return ne;
    }
    return c.activeOptionIndex;
  }, compare: P, isSelected: D, nullable: s, __demoMode: a }), [r, i, l, s, a, c]);
  gn(() => {
    c.dataRef.current = x;
  }, [x]), sV([x.buttonRef, x.inputRef, x.optionsRef], () => d({ type: 1 }), x.comboboxState === 0);
  let M = pr(() => ({ open: x.comboboxState === 0, disabled: i, activeIndex: x.activeOptionIndex, activeOption: x.activeOptionIndex === null ? null : x.options[x.activeOptionIndex].dataRef.current.value }), [x, i]), F = Ai(() => {
    var ne;
    if (!x.inputRef.current) return;
    let se = g.current.displayValue;
    typeof se == "function" ? x.inputRef.current.value = (ne = se(r)) != null ? ne : "" : typeof r == "string" ? x.inputRef.current.value = r : x.inputRef.current.value = "";
  }, [r, x.inputRef, g]), H = yr((ne) => {
    let se = x.options.find((pe) => pe.id === ne);
    !se || (ee(se.dataRef.current.value), F());
  }), B = yr(() => {
    if (x.activeOptionIndex !== null) {
      let { dataRef: ne, id: se } = x.options[x.activeOptionIndex];
      ee(ne.current.value), F(), d({ type: 2, focus: fo.Specific, id: se });
    }
  }), j = yr(() => {
    d({ type: 0 }), f.current = !0;
  }), V = yr(() => {
    d({ type: 1 }), f.current = !1;
  }), W = yr((ne, se, pe) => (f.current = !1, ne === fo.Specific ? d({ type: 2, focus: fo.Specific, id: se, trigger: pe }) : d({ type: 2, focus: ne, trigger: pe }))), q = yr((ne, se) => (d({ type: 3, id: ne, dataRef: se }), () => d({ type: 4, id: ne }))), ee = yr((ne) => wn(x.mode, { 0() {
    return n(ne);
  }, 1() {
    let se = x.value.slice(), pe = se.indexOf(ne);
    return pe === -1 ? se.push(ne) : se.splice(pe, 1), n(se);
  } })), re = pr(() => ({ onChange: ee, registerOption: q, goToOption: W, closeCombobox: V, openCombobox: j, selectActiveOption: B, selectOption: H }), []);
  gn(() => {
    x.comboboxState === 1 && F();
  }, [F, x.comboboxState]), gn(F, [F]);
  let ie = t === null ? {} : { ref: t };
  return y.createElement(t1.Provider, { value: re }, y.createElement(r1.Provider, { value: x }, y.createElement(AM, { value: wn(x.comboboxState, { 0: Nl.Open, 1: Nl.Closed }) }, e != null && r != null && TM({ [e]: r }).map(([ne, se]) => y.createElement(DM, { features: QE.Hidden, ...km({ key: ne, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: ne, value: se }) })), ui({ ourProps: ie, theirProps: u, slot: M, defaultTag: bV, name: "Combobox" }))));
}), EV = "input", _V = ci(function(o, t) {
  var e, r;
  let { value: n, onChange: i, displayValue: a, type: s = "text", ...l } = o, u = hp("Combobox.Input"), c = Hy("Combobox.Input"), d = Wa(u.inputRef, t), f = u.inputPropsRef, v = `headlessui-combobox-input-${xs()}`, g = XE();
  gn(() => {
    f.current.displayValue = a;
  }, [a, f]);
  let m = yr((D) => {
    switch (D.key) {
      case Wn.Backspace:
      case Wn.Delete:
        if (u.mode !== 0 || !u.nullable) return;
        let x = D.currentTarget;
        g.requestAnimationFrame(() => {
          x.value === "" && (c.onChange(null), u.optionsRef.current && (u.optionsRef.current.scrollTop = 0), c.goToOption(fo.Nothing));
        });
        break;
      case Wn.Enter:
        if (u.comboboxState !== 0) return;
        if (D.preventDefault(), D.stopPropagation(), u.activeOptionIndex === null) {
          c.closeCombobox();
          return;
        }
        c.selectActiveOption(), u.mode === 0 && c.closeCombobox();
        break;
      case Wn.ArrowDown:
        return D.preventDefault(), D.stopPropagation(), wn(u.comboboxState, { 0: () => {
          c.goToOption(fo.Next);
        }, 1: () => {
          c.openCombobox();
        } });
      case Wn.ArrowUp:
        return D.preventDefault(), D.stopPropagation(), wn(u.comboboxState, { 0: () => {
          c.goToOption(fo.Previous);
        }, 1: () => {
          c.openCombobox(), g.nextFrame(() => {
            u.value || c.goToOption(fo.Last);
          });
        } });
      case Wn.Home:
      case Wn.PageUp:
        return D.preventDefault(), D.stopPropagation(), c.goToOption(fo.First);
      case Wn.End:
      case Wn.PageDown:
        return D.preventDefault(), D.stopPropagation(), c.goToOption(fo.Last);
      case Wn.Escape:
        return u.comboboxState !== 0 ? void 0 : (D.preventDefault(), u.optionsRef.current && !u.optionsPropsRef.current.static && D.stopPropagation(), c.closeCombobox());
      case Wn.Tab:
        if (u.comboboxState !== 0) return;
        c.selectActiveOption(), c.closeCombobox();
        break;
    }
  }), b = yr((D) => {
    c.openCombobox(), i == null || i(D);
  }), S = qE(() => {
    if (u.labelRef.current) return [u.labelRef.current.id].join(" ");
  }, [u.labelRef.current]), R = pr(() => ({ open: u.comboboxState === 0, disabled: u.disabled }), [u]), P = { ref: d, id: v, role: "combobox", type: s, "aria-controls": (e = u.optionsRef.current) == null ? void 0 : e.id, "aria-expanded": u.disabled ? void 0 : u.comboboxState === 0, "aria-activedescendant": u.activeOptionIndex === null || (r = u.options[u.activeOptionIndex]) == null ? void 0 : r.id, "aria-multiselectable": u.mode === 1 ? !0 : void 0, "aria-labelledby": S, disabled: u.disabled, onKeyDown: m, onChange: b };
  return ui({ ourProps: P, theirProps: l, slot: R, defaultTag: EV, name: "Combobox.Input" });
}), xV = "button", RV = ci(function(o, t) {
  var e;
  let r = hp("Combobox.Button"), n = Hy("Combobox.Button"), i = Wa(r.buttonRef, t), a = `headlessui-combobox-button-${xs()}`, s = XE(), l = yr((g) => {
    switch (g.key) {
      case Wn.ArrowDown:
        return g.preventDefault(), g.stopPropagation(), r.comboboxState === 1 && n.openCombobox(), s.nextFrame(() => {
          var m;
          return (m = r.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
      case Wn.ArrowUp:
        return g.preventDefault(), g.stopPropagation(), r.comboboxState === 1 && (n.openCombobox(), s.nextFrame(() => {
          r.value || n.goToOption(fo.Last);
        })), s.nextFrame(() => {
          var m;
          return (m = r.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
      case Wn.Escape:
        return r.comboboxState !== 0 ? void 0 : (g.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && g.stopPropagation(), n.closeCombobox(), s.nextFrame(() => {
          var m;
          return (m = r.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), u = yr((g) => {
    if (RM(g.currentTarget)) return g.preventDefault();
    r.comboboxState === 0 ? n.closeCombobox() : (g.preventDefault(), n.openCombobox()), s.nextFrame(() => {
      var m;
      return (m = r.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
    });
  }), c = qE(() => {
    if (r.labelRef.current) return [r.labelRef.current.id, a].join(" ");
  }, [r.labelRef.current, a]), d = pr(() => ({ open: r.comboboxState === 0, disabled: r.disabled }), [r]), f = o, v = { ref: i, id: a, type: _M(o, r.buttonRef), tabIndex: -1, "aria-haspopup": !0, "aria-controls": (e = r.optionsRef.current) == null ? void 0 : e.id, "aria-expanded": r.disabled ? void 0 : r.comboboxState === 0, "aria-labelledby": c, disabled: r.disabled, onClick: u, onKeyDown: l };
  return ui({ ourProps: v, theirProps: f, slot: d, defaultTag: xV, name: "Combobox.Button" });
}), TV = "label", OV = ci(function(o, t) {
  let e = hp("Combobox.Label"), r = `headlessui-combobox-label-${xs()}`, n = Wa(e.labelRef, t), i = yr(() => {
    var s;
    return (s = e.inputRef.current) == null ? void 0 : s.focus({ preventScroll: !0 });
  }), a = pr(() => ({ open: e.comboboxState === 0, disabled: e.disabled }), [e]);
  return ui({ ourProps: { ref: n, id: r, onClick: i }, theirProps: o, slot: a, defaultTag: TV, name: "Combobox.Label" });
}), PV = "ul", DV = Nm.RenderStrategy | Nm.Static, AV = ci(function(o, t) {
  var e;
  let { hold: r = !1, ...n } = o, i = hp("Combobox.Options"), a = Wa(i.optionsRef, t), s = `headlessui-combobox-options-${xs()}`, l = e1(), u = l !== null ? l === Nl.Open : i.comboboxState === 0;
  gn(() => {
    var v;
    i.optionsPropsRef.current.static = (v = o.static) != null ? v : !1;
  }, [i.optionsPropsRef, o.static]), gn(() => {
    i.optionsPropsRef.current.hold = r;
  }, [i.optionsPropsRef, r]), uV({ container: i.optionsRef.current, enabled: i.comboboxState === 0, accept(v) {
    return v.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(v) {
    v.setAttribute("role", "none");
  } });
  let c = qE(() => {
    var v, g, m;
    return (m = (v = i.labelRef.current) == null ? void 0 : v.id) != null ? m : (g = i.buttonRef.current) == null ? void 0 : g.id;
  }, [i.labelRef.current, i.buttonRef.current]), d = pr(() => ({ open: i.comboboxState === 0 }), [i]), f = { "aria-activedescendant": i.activeOptionIndex === null || (e = i.options[i.activeOptionIndex]) == null ? void 0 : e.id, "aria-labelledby": c, role: "listbox", id: s, ref: a };
  return ui({ ourProps: f, theirProps: n, slot: d, defaultTag: PV, features: DV, visible: u, name: "Combobox.Options" });
}), MV = "li", FV = ci(function(o, t) {
  var e, r;
  let { disabled: n = !1, value: i, ...a } = o, s = hp("Combobox.Option"), l = Hy("Combobox.Option"), u = `headlessui-combobox-option-${xs()}`, c = s.activeOptionIndex !== null ? s.options[s.activeOptionIndex].id === u : !1, d = s.isSelected(i), f = Cr(null), v = Ss({ disabled: n, value: i, domRef: f, textValue: (r = (e = f.current) == null ? void 0 : e.textContent) == null ? void 0 : r.toLowerCase() }), g = Wa(t, f), m = yr(() => l.selectOption(u));
  gn(() => l.registerOption(u, v), [v, u]);
  let b = Cr(!s.__demoMode);
  gn(() => {
    if (!s.__demoMode) return;
    let M = np();
    return M.requestAnimationFrame(() => {
      b.current = !0;
    }), M.dispose;
  }, []), gn(() => {
    if (s.comboboxState !== 0 || !c || !b.current || s.activationTrigger === 0) return;
    let M = np();
    return M.requestAnimationFrame(() => {
      var F, H;
      (H = (F = f.current) == null ? void 0 : F.scrollIntoView) == null || H.call(F, { block: "nearest" });
    }), M.dispose;
  }, [f, c, s.comboboxState, s.activationTrigger, s.activeOptionIndex]);
  let S = yr((M) => {
    var F;
    if (n) return M.preventDefault();
    m(), s.mode === 0 && (l.closeCombobox(), (F = s.inputRef.current) == null || F.focus({ preventScroll: !0 }));
  }), R = yr(() => {
    if (n) return l.goToOption(fo.Nothing);
    l.goToOption(fo.Specific, u);
  }), P = yr(() => {
    n || c || l.goToOption(fo.Specific, u, 0);
  }), D = yr(() => {
    n || !c || s.optionsPropsRef.current.hold || l.goToOption(fo.Nothing);
  }), x = pr(() => ({ active: c, selected: d, disabled: n }), [c, d, n]);
  return ui({ ourProps: { id: u, ref: g, role: "option", tabIndex: n === !0 ? void 0 : -1, "aria-disabled": n === !0 ? !0 : void 0, "aria-selected": d === !0 ? !0 : void 0, disabled: void 0, onClick: S, onFocus: R, onPointerMove: P, onMouseMove: P, onPointerLeave: D, onMouseLeave: D }, theirProps: a, slot: x, defaultTag: MV, name: "Combobox.Option" });
}), Tn = Object.assign(SV, { Input: _V, Button: RV, Label: OV, Options: AV, Option: FV });
function MM() {
  let o = Cr(!1);
  return gn(() => (o.current = !0, () => {
    o.current = !1;
  }), []), o;
}
function IV(o) {
  typeof queueMicrotask == "function" ? queueMicrotask(o) : Promise.resolve().then(o).catch((t) => setTimeout(() => {
    throw t;
  }));
}
let FM = Mi(null);
function IM() {
  let o = si(FM);
  if (o === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, IM), t;
  }
  return o;
}
function LV() {
  let [o, t] = er([]);
  return [o.length > 0 ? o.join(" ") : void 0, pr(() => function(e) {
    let r = yr((i) => (t((a) => [...a, i]), () => t((a) => {
      let s = a.slice(), l = s.indexOf(i);
      return l !== -1 && s.splice(l, 1), s;
    }))), n = pr(() => ({ register: r, slot: e.slot, name: e.name, props: e.props }), [r, e.slot, e.name, e.props]);
    return y.createElement(FM.Provider, { value: n }, e.children);
  }, [t])];
}
let NV = "p", kV = ci(function(o, t) {
  let e = IM(), r = `headlessui-description-${xs()}`, n = Wa(t);
  gn(() => e.register(r), [r, e.register]);
  let i = o, a = { ref: n, ...e.props, id: r };
  return ui({ ourProps: a, theirProps: i, slot: e.slot || {}, defaultTag: NV, name: e.name || "Description" });
}), LM = Mi(null);
function NM() {
  let o = si(LM);
  if (o === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, NM), t;
  }
  return o;
}
function GV() {
  let [o, t] = er([]);
  return [o.length > 0 ? o.join(" ") : void 0, pr(() => function(e) {
    let r = yr((i) => (t((a) => [...a, i]), () => t((a) => {
      let s = a.slice(), l = s.indexOf(i);
      return l !== -1 && s.splice(l, 1), s;
    }))), n = pr(() => ({ register: r, slot: e.slot, name: e.name, props: e.props }), [r, e.slot, e.name, e.props]);
    return y.createElement(LM.Provider, { value: n }, e.children);
  }, [t])];
}
let VV = "label", HV = ci(function(o, t) {
  let { passive: e = !1, ...r } = o, n = NM(), i = `headlessui-label-${xs()}`, a = Wa(t);
  gn(() => n.register(i), [i, n.register]);
  let s = { ref: a, ...n.props, id: i };
  return e && ("onClick" in s && delete s.onClick, "onClick" in r && delete r.onClick), ui({ ourProps: s, theirProps: r, slot: n.slot || {}, defaultTag: VV, name: n.name || "Label" });
}), n1 = Mi(null);
n1.displayName = "GroupContext";
let BV = yn;
function WV(o) {
  let [t, e] = er(null), [r, n] = GV(), [i, a] = LV(), s = pr(() => ({ switch: t, setSwitch: e, labelledby: r, describedby: i }), [t, e, r, i]), l = {}, u = o;
  return y.createElement(a, { name: "Switch.Description" }, y.createElement(n, { name: "Switch.Label", props: { onClick() {
    !t || (t.click(), t.focus({ preventScroll: !0 }));
  } } }, y.createElement(n1.Provider, { value: s }, ui({ ourProps: l, theirProps: u, defaultTag: BV, name: "Switch.Group" }))));
}
let jV = "button", UV = ci(function(o, t) {
  let { checked: e, onChange: r, name: n, value: i, ...a } = o, s = `headlessui-switch-${xs()}`, l = si(n1), u = Cr(null), c = Wa(u, t, l === null ? null : l.setSwitch), d = yr(() => r(!e)), f = yr((S) => {
    if (RM(S.currentTarget)) return S.preventDefault();
    S.preventDefault(), d();
  }), v = yr((S) => {
    S.key === Wn.Space ? (S.preventDefault(), d()) : S.key === Wn.Enter && fV(S.currentTarget);
  }), g = yr((S) => S.preventDefault()), m = pr(() => ({ checked: e }), [e]), b = { id: s, ref: c, role: "switch", type: _M(o, u), tabIndex: 0, "aria-checked": e, "aria-labelledby": l == null ? void 0 : l.labelledby, "aria-describedby": l == null ? void 0 : l.describedby, onClick: f, onKeyUp: v, onKeyPress: g };
  return y.createElement(y.Fragment, null, n != null && e && y.createElement(DM, { features: QE.Hidden, ...km({ as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: e, name: n, value: i }) }), ui({ ourProps: b, theirProps: a, slot: m, defaultTag: jV, name: "Switch" }));
}), $V = Object.assign(UV, { Group: WV, Label: HV, Description: kV });
function zV(o) {
  let t = { called: !1 };
  return (...e) => {
    if (!t.called) return t.called = !0, o(...e);
  };
}
function cw(o, ...t) {
  o && t.length > 0 && o.classList.add(...t);
}
function dw(o, ...t) {
  o && t.length > 0 && o.classList.remove(...t);
}
var lS = ((o) => (o.Ended = "ended", o.Cancelled = "cancelled", o))(lS || {});
function YV(o, t) {
  let e = np();
  if (!o) return e.dispose;
  let { transitionDuration: r, transitionDelay: n } = getComputedStyle(o), [i, a] = [r, n].map((s) => {
    let [l = 0] = s.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, c) => c - u);
    return l;
  });
  if (i + a !== 0) {
    let s = [];
    s.push(e.addEventListener(o, "transitionrun", (l) => {
      l.target === l.currentTarget && (s.splice(0).forEach((u) => u()), s.push(e.addEventListener(o, "transitionend", (u) => {
        u.target === u.currentTarget && (t("ended"), s.splice(0).forEach((c) => c()));
      }), e.addEventListener(o, "transitioncancel", (u) => {
        u.target === u.currentTarget && (t("cancelled"), s.splice(0).forEach((c) => c()));
      })));
    }));
  } else t("ended");
  return e.add(() => t("cancelled")), e.dispose;
}
function KV(o, t, e, r) {
  let n = e ? "enter" : "leave", i = np(), a = r !== void 0 ? zV(r) : () => {
  }, s = wn(n, { enter: () => t.enter, leave: () => t.leave }), l = wn(n, { enter: () => t.enterTo, leave: () => t.leaveTo }), u = wn(n, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return dw(o, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), cw(o, ...s, ...u), i.nextFrame(() => {
    dw(o, ...u), cw(o, ...l), YV(o, (c) => (c === "ended" && (dw(o, ...s), cw(o, ...t.entered)), a(c)));
  }), i.dispose;
}
function qV({ container: o, direction: t, classes: e, events: r, onStart: n, onStop: i }) {
  let a = MM(), s = XE(), l = Ss(t), u = yr(() => wn(l.current, { enter: () => r.current.beforeEnter(), leave: () => r.current.beforeLeave(), idle: () => {
  } })), c = yr(() => wn(l.current, { enter: () => r.current.afterEnter(), leave: () => r.current.afterLeave(), idle: () => {
  } }));
  gn(() => {
    let d = np();
    s.add(d.dispose);
    let f = o.current;
    if (f && l.current !== "idle" && a.current) return d.dispose(), u(), n.current(l.current), d.add(KV(f, e.current, l.current === "enter", (v) => {
      d.dispose(), wn(v, { [lS.Ended]() {
        c(), i.current(l.current);
      }, [lS.Cancelled]: () => {
      } });
    })), d.dispose;
  }, [t]);
}
function Ou(o = "") {
  return o.split(" ").filter((t) => t.trim().length > 1);
}
let By = Mi(null);
By.displayName = "TransitionContext";
var XV = ((o) => (o.Visible = "visible", o.Hidden = "hidden", o))(XV || {});
function ZV() {
  let o = si(By);
  if (o === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return o;
}
function QV() {
  let o = si(Wy);
  if (o === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return o;
}
let Wy = Mi(null);
Wy.displayName = "NestingContext";
function jy(o) {
  return "children" in o ? jy(o.children) : o.current.filter(({ state: t }) => t === "visible").length > 0;
}
function kM(o) {
  let t = Ss(o), e = Cr([]), r = MM(), n = yr((a, s = vs.Hidden) => {
    let l = e.current.findIndex(({ id: u }) => u === a);
    l !== -1 && (wn(s, { [vs.Unmount]() {
      e.current.splice(l, 1);
    }, [vs.Hidden]() {
      e.current[l].state = "hidden";
    } }), IV(() => {
      var u;
      !jy(e) && r.current && ((u = t.current) == null || u.call(t));
    }));
  }), i = yr((a) => {
    let s = e.current.find(({ id: l }) => l === a);
    return s ? s.state !== "visible" && (s.state = "visible") : e.current.push({ id: a, state: "visible" }), () => n(a, vs.Unmount);
  });
  return pr(() => ({ children: e, register: i, unregister: n }), [i, n, e]);
}
function JV() {
}
let e7 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ZR(o) {
  var t;
  let e = {};
  for (let r of e7) e[r] = (t = o[r]) != null ? t : JV;
  return e;
}
function t7(o) {
  let t = Cr(ZR(o));
  return wr(() => {
    t.current = ZR(o);
  }, [o]), t;
}
let r7 = "div", GM = Nm.RenderStrategy, VM = ci(function(o, t) {
  let { beforeEnter: e, afterEnter: r, beforeLeave: n, afterLeave: i, enter: a, enterFrom: s, enterTo: l, entered: u, leave: c, leaveFrom: d, leaveTo: f, ...v } = o, g = Cr(null), m = Wa(g, t), [b, S] = er("visible"), R = v.unmount ? vs.Unmount : vs.Hidden, { show: P, appear: D, initial: x } = ZV(), { register: M, unregister: F } = QV(), H = Cr(null), B = xs();
  wr(() => {
    if (B) return M(B);
  }, [M, B]), wr(() => {
    if (R === vs.Hidden && B) {
      if (P && b !== "visible") {
        S("visible");
        return;
      }
      wn(b, { hidden: () => F(B), visible: () => M(B) });
    }
  }, [b, B, M, F, P, R]);
  let j = Ss({ enter: Ou(a), enterFrom: Ou(s), enterTo: Ou(l), entered: Ou(u), leave: Ou(c), leaveFrom: Ou(d), leaveTo: Ou(f) }), V = t7({ beforeEnter: e, afterEnter: r, beforeLeave: n, afterLeave: i }), W = ZE();
  wr(() => {
    if (W && b === "visible" && g.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [g, b, W]);
  let q = x && !D, ee = !W || q || H.current === P ? "idle" : P ? "enter" : "leave", re = Cr(!1), ie = kM(() => {
    re.current || (S("hidden"), F(B));
  });
  qV({ container: g, classes: j, events: V, direction: ee, onStart: Ss(() => {
    re.current = !0;
  }), onStop: Ss((pe) => {
    re.current = !1, pe === "leave" && !jy(ie) && (S("hidden"), F(B));
  }) }), wr(() => {
    !q || (R === vs.Hidden ? H.current = null : H.current = P);
  }, [P, q, b]);
  let ne = v, se = { ref: m };
  return y.createElement(Wy.Provider, { value: ie }, y.createElement(AM, { value: wn(b, { visible: Nl.Open, hidden: Nl.Closed }) }, ui({ ourProps: se, theirProps: ne, defaultTag: r7, features: GM, visible: b === "visible", name: "Transition.Child" })));
}), uS = ci(function(o, t) {
  let { show: e, appear: r = !1, unmount: n, ...i } = o, a = Cr(null), s = Wa(a, t);
  ZE();
  let l = e1();
  if (e === void 0 && l !== null && (e = wn(l, { [Nl.Open]: !0, [Nl.Closed]: !1 })), ![!0, !1].includes(e)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, c] = er(e ? "visible" : "hidden"), d = kM(() => {
    c("hidden");
  }), [f, v] = er(!0), g = Cr([e]);
  gn(() => {
    f !== !1 && g.current[g.current.length - 1] !== e && (g.current.push(e), v(!1));
  }, [g, e]);
  let m = pr(() => ({ show: e, appear: r, initial: f }), [e, r, f]);
  wr(() => {
    if (e) c("visible");
    else if (!jy(d)) c("hidden");
    else {
      let S = a.current;
      if (!S) return;
      let R = S.getBoundingClientRect();
      R.x === 0 && R.y === 0 && R.width === 0 && R.height === 0 && c("hidden");
    }
  }, [e, d]);
  let b = { unmount: n };
  return y.createElement(Wy.Provider, { value: d }, y.createElement(By.Provider, { value: m }, ui({ ourProps: { ...b, as: yn, children: y.createElement(VM, { ref: s, ...b, ...i }) }, theirProps: {}, defaultTag: yn, features: GM, visible: u === "visible", name: "Transition" })));
}), n7 = ci(function(o, t) {
  let e = si(By) !== null, r = e1() !== null;
  return y.createElement(y.Fragment, null, !e && r ? y.createElement(uS, { ref: t, ...o }) : y.createElement(VM, { ref: t, ...o }));
}), cg = Object.assign(uS, { Child: n7, Root: uS });
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function av(o) {
  return o + 0.5 | 0;
}
const El = (o, t, e) => Math.max(Math.min(o, e), t);
function ah(o) {
  return El(av(o * 2.55), 0, 255);
}
function Dl(o) {
  return El(av(o * 255), 0, 255);
}
function fs(o) {
  return El(av(o / 2.55) / 100, 0, 1);
}
function QR(o) {
  return El(av(o * 100), 0, 100);
}
const _i = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, cS = [..."0123456789ABCDEF"], o7 = (o) => cS[o & 15], i7 = (o) => cS[(o & 240) >> 4] + cS[o & 15], dg = (o) => (o & 240) >> 4 === (o & 15), a7 = (o) => dg(o.r) && dg(o.g) && dg(o.b) && dg(o.a);
function s7(o) {
  var t = o.length, e;
  return o[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & _i[o[1]] * 17,
    g: 255 & _i[o[2]] * 17,
    b: 255 & _i[o[3]] * 17,
    a: t === 5 ? _i[o[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: _i[o[1]] << 4 | _i[o[2]],
    g: _i[o[3]] << 4 | _i[o[4]],
    b: _i[o[5]] << 4 | _i[o[6]],
    a: t === 9 ? _i[o[7]] << 4 | _i[o[8]] : 255
  })), e;
}
const l7 = (o, t) => o < 255 ? t(o) : "";
function u7(o) {
  var t = a7(o) ? o7 : i7;
  return o ? "#" + t(o.r) + t(o.g) + t(o.b) + l7(o.a, t) : void 0;
}
const c7 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function HM(o, t, e) {
  const r = t * Math.min(e, 1 - e), n = (i, a = (i + o / 30) % 12) => e - r * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [n(0), n(8), n(4)];
}
function d7(o, t, e) {
  const r = (n, i = (n + o / 60) % 6) => e - e * t * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function p7(o, t, e) {
  const r = HM(o, 1, 0.5);
  let n;
  for (t + e > 1 && (n = 1 / (t + e), t *= n, e *= n), n = 0; n < 3; n++)
    r[n] *= 1 - t - e, r[n] += t;
  return r;
}
function f7(o, t, e, r, n) {
  return o === n ? (t - e) / r + (t < e ? 6 : 0) : t === n ? (e - o) / r + 2 : (o - t) / r + 4;
}
function o1(o) {
  const e = o.r / 255, r = o.g / 255, n = o.b / 255, i = Math.max(e, r, n), a = Math.min(e, r, n), s = (i + a) / 2;
  let l, u, c;
  return i !== a && (c = i - a, u = s > 0.5 ? c / (2 - i - a) : c / (i + a), l = f7(e, r, n, c, i), l = l * 60 + 0.5), [l | 0, u || 0, s];
}
function i1(o, t, e, r) {
  return (Array.isArray(t) ? o(t[0], t[1], t[2]) : o(t, e, r)).map(Dl);
}
function a1(o, t, e) {
  return i1(HM, o, t, e);
}
function h7(o, t, e) {
  return i1(p7, o, t, e);
}
function v7(o, t, e) {
  return i1(d7, o, t, e);
}
function BM(o) {
  return (o % 360 + 360) % 360;
}
function g7(o) {
  const t = c7.exec(o);
  let e = 255, r;
  if (!t)
    return;
  t[5] !== r && (e = t[6] ? ah(+t[5]) : Dl(+t[5]));
  const n = BM(+t[2]), i = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? r = h7(n, i, a) : t[1] === "hsv" ? r = v7(n, i, a) : r = a1(n, i, a), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: e
  };
}
function m7(o, t) {
  var e = o1(o);
  e[0] = BM(e[0] + t), e = a1(e), o.r = e[0], o.g = e[1], o.b = e[2];
}
function y7(o) {
  if (!o)
    return;
  const t = o1(o), e = t[0], r = QR(t[1]), n = QR(t[2]);
  return o.a < 255 ? `hsla(${e}, ${r}%, ${n}%, ${fs(o.a)})` : `hsl(${e}, ${r}%, ${n}%)`;
}
const JR = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, eT = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function C7() {
  const o = {}, t = Object.keys(eT), e = Object.keys(JR);
  let r, n, i, a, s;
  for (r = 0; r < t.length; r++) {
    for (a = s = t[r], n = 0; n < e.length; n++)
      i = e[n], s = s.replace(i, JR[i]);
    i = parseInt(eT[a], 16), o[s] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return o;
}
let pg;
function w7(o) {
  pg || (pg = C7(), pg.transparent = [0, 0, 0, 0]);
  const t = pg[o.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const b7 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function S7(o) {
  const t = b7.exec(o);
  let e = 255, r, n, i;
  if (t) {
    if (t[7] !== r) {
      const a = +t[7];
      e = t[8] ? ah(a) : El(a * 255, 0, 255);
    }
    return r = +t[1], n = +t[3], i = +t[5], r = 255 & (t[2] ? ah(r) : El(r, 0, 255)), n = 255 & (t[4] ? ah(n) : El(n, 0, 255)), i = 255 & (t[6] ? ah(i) : El(i, 0, 255)), {
      r,
      g: n,
      b: i,
      a: e
    };
  }
}
function E7(o) {
  return o && (o.a < 255 ? `rgba(${o.r}, ${o.g}, ${o.b}, ${fs(o.a)})` : `rgb(${o.r}, ${o.g}, ${o.b})`);
}
const pw = (o) => o <= 31308e-7 ? o * 12.92 : Math.pow(o, 1 / 2.4) * 1.055 - 0.055, Od = (o) => o <= 0.04045 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4);
function _7(o, t, e) {
  const r = Od(fs(o.r)), n = Od(fs(o.g)), i = Od(fs(o.b));
  return {
    r: Dl(pw(r + e * (Od(fs(t.r)) - r))),
    g: Dl(pw(n + e * (Od(fs(t.g)) - n))),
    b: Dl(pw(i + e * (Od(fs(t.b)) - i))),
    a: o.a + e * (t.a - o.a)
  };
}
function fg(o, t, e) {
  if (o) {
    let r = o1(o);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * e, t === 0 ? 360 : 1)), r = a1(r), o.r = r[0], o.g = r[1], o.b = r[2];
  }
}
function WM(o, t) {
  return o && Object.assign(t || {}, o);
}
function tT(o) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(o) ? o.length >= 3 && (t = { r: o[0], g: o[1], b: o[2], a: 255 }, o.length > 3 && (t.a = Dl(o[3]))) : (t = WM(o, { r: 0, g: 0, b: 0, a: 1 }), t.a = Dl(t.a)), t;
}
function x7(o) {
  return o.charAt(0) === "r" ? S7(o) : g7(o);
}
class Gh {
  constructor(t) {
    if (t instanceof Gh)
      return t;
    const e = typeof t;
    let r;
    e === "object" ? r = tT(t) : e === "string" && (r = s7(t) || w7(t) || x7(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = WM(this._rgb);
    return t && (t.a = fs(t.a)), t;
  }
  set rgb(t) {
    this._rgb = tT(t);
  }
  rgbString() {
    return this._valid ? E7(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? u7(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? y7(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const r = this.rgb, n = t.rgb;
      let i;
      const a = e === i ? 0.5 : e, s = 2 * a - 1, l = r.a - n.a, u = ((s * l === -1 ? s : (s + l) / (1 + s * l)) + 1) / 2;
      i = 1 - u, r.r = 255 & u * r.r + i * n.r + 0.5, r.g = 255 & u * r.g + i * n.g + 0.5, r.b = 255 & u * r.b + i * n.b + 0.5, r.a = a * r.a + (1 - a) * n.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = _7(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new Gh(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Dl(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = av(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return fg(this._rgb, 2, t), this;
  }
  darken(t) {
    return fg(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return fg(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return fg(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return m7(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function ls() {
}
const R7 = /* @__PURE__ */ (() => {
  let o = 0;
  return () => o++;
})();
function Nt(o) {
  return o === null || typeof o > "u";
}
function Lr(o) {
  if (Array.isArray && Array.isArray(o))
    return !0;
  const t = Object.prototype.toString.call(o);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function Ht(o) {
  return o !== null && Object.prototype.toString.call(o) === "[object Object]";
}
function Zr(o) {
  return (typeof o == "number" || o instanceof Number) && isFinite(+o);
}
function Jo(o, t) {
  return Zr(o) ? o : t;
}
function xt(o, t) {
  return typeof o > "u" ? t : o;
}
const T7 = (o, t) => typeof o == "string" && o.endsWith("%") ? parseFloat(o) / 100 : +o / t, jM = (o, t) => typeof o == "string" && o.endsWith("%") ? parseFloat(o) / 100 * t : +o;
function Tr(o, t, e) {
  if (o && typeof o.call == "function")
    return o.apply(e, t);
}
function ur(o, t, e, r) {
  let n, i, a;
  if (Lr(o))
    for (i = o.length, n = 0; n < i; n++)
      t.call(e, o[n], n);
  else if (Ht(o))
    for (a = Object.keys(o), i = a.length, n = 0; n < i; n++)
      t.call(e, o[a[n]], a[n]);
}
function Gm(o, t) {
  let e, r, n, i;
  if (!o || !t || o.length !== t.length)
    return !1;
  for (e = 0, r = o.length; e < r; ++e)
    if (n = o[e], i = t[e], n.datasetIndex !== i.datasetIndex || n.index !== i.index)
      return !1;
  return !0;
}
function Vm(o) {
  if (Lr(o))
    return o.map(Vm);
  if (Ht(o)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(o), r = e.length;
    let n = 0;
    for (; n < r; ++n)
      t[e[n]] = Vm(o[e[n]]);
    return t;
  }
  return o;
}
function UM(o) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(o) === -1;
}
function O7(o, t, e, r) {
  if (!UM(o))
    return;
  const n = t[o], i = e[o];
  Ht(n) && Ht(i) ? Ha(n, i, r) : t[o] = Vm(i);
}
function Ha(o, t, e) {
  const r = Lr(t) ? t : [
    t
  ], n = r.length;
  if (!Ht(o))
    return o;
  e = e || {};
  const i = e.merger || O7;
  let a;
  for (let s = 0; s < n; ++s) {
    if (a = r[s], !Ht(a))
      continue;
    const l = Object.keys(a);
    for (let u = 0, c = l.length; u < c; ++u)
      i(l[u], o, a, e);
  }
  return o;
}
function yh(o, t) {
  return Ha(o, t, {
    merger: P7
  });
}
function P7(o, t, e) {
  if (!UM(o))
    return;
  const r = t[o], n = e[o];
  Ht(r) && Ht(n) ? yh(r, n) : Object.prototype.hasOwnProperty.call(t, o) || (t[o] = Vm(n));
}
const rT = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (o) => o,
  // default resolvers
  x: (o) => o.x,
  y: (o) => o.y
};
function D7(o) {
  const t = o.split("."), e = [];
  let r = "";
  for (const n of t)
    r += n, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (e.push(r), r = "");
  return e;
}
function A7(o) {
  const t = D7(o);
  return (e) => {
    for (const r of t) {
      if (r === "")
        break;
      e = e && e[r];
    }
    return e;
  };
}
function kl(o, t) {
  return (rT[t] || (rT[t] = A7(t)))(o);
}
function s1(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
const Vh = (o) => typeof o < "u", Gl = (o) => typeof o == "function", nT = (o, t) => {
  if (o.size !== t.size)
    return !1;
  for (const e of o)
    if (!t.has(e))
      return !1;
  return !0;
};
function M7(o) {
  return o.type === "mouseup" || o.type === "click" || o.type === "contextmenu";
}
const kr = Math.PI, Nr = 2 * kr, F7 = Nr + kr, Hm = Number.POSITIVE_INFINITY, I7 = kr / 180, an = kr / 2, Pu = kr / 4, oT = kr * 2 / 3, _l = Math.log10, Fa = Math.sign;
function Ch(o, t, e) {
  return Math.abs(o - t) < e;
}
function iT(o) {
  const t = Math.round(o);
  o = Ch(o, t, o / 1e3) ? t : o;
  const e = Math.pow(10, Math.floor(_l(o))), r = o / e;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * e;
}
function L7(o) {
  const t = [], e = Math.sqrt(o);
  let r;
  for (r = 1; r < e; r++)
    o % r === 0 && (t.push(r), t.push(o / r));
  return e === (e | 0) && t.push(e), t.sort((n, i) => n - i).pop(), t;
}
function op(o) {
  return !isNaN(parseFloat(o)) && isFinite(o);
}
function N7(o, t) {
  const e = Math.round(o);
  return e - t <= o && e + t >= o;
}
function $M(o, t, e) {
  let r, n, i;
  for (r = 0, n = o.length; r < n; r++)
    i = o[r][e], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function Qi(o) {
  return o * (kr / 180);
}
function l1(o) {
  return o * (180 / kr);
}
function aT(o) {
  if (!Zr(o))
    return;
  let t = 1, e = 0;
  for (; Math.round(o * t) / t !== o; )
    t *= 10, e++;
  return e;
}
function zM(o, t) {
  const e = t.x - o.x, r = t.y - o.y, n = Math.sqrt(e * e + r * r);
  let i = Math.atan2(r, e);
  return i < -0.5 * kr && (i += Nr), {
    angle: i,
    distance: n
  };
}
function dS(o, t) {
  return Math.sqrt(Math.pow(t.x - o.x, 2) + Math.pow(t.y - o.y, 2));
}
function k7(o, t) {
  return (o - t + F7) % Nr - kr;
}
function ei(o) {
  return (o % Nr + Nr) % Nr;
}
function Hh(o, t, e, r) {
  const n = ei(o), i = ei(t), a = ei(e), s = ei(i - n), l = ei(a - n), u = ei(n - i), c = ei(n - a);
  return n === i || n === a || r && i === a || s > l && u < c;
}
function Pn(o, t, e) {
  return Math.max(t, Math.min(e, o));
}
function G7(o) {
  return Pn(o, -32768, 32767);
}
function gs(o, t, e, r = 1e-6) {
  return o >= Math.min(t, e) - r && o <= Math.max(t, e) + r;
}
function u1(o, t, e) {
  e = e || ((a) => o[a] < t);
  let r = o.length - 1, n = 0, i;
  for (; r - n > 1; )
    i = n + r >> 1, e(i) ? n = i : r = i;
  return {
    lo: n,
    hi: r
  };
}
const ms = (o, t, e, r) => u1(o, e, r ? (n) => {
  const i = o[n][t];
  return i < e || i === e && o[n + 1][t] === e;
} : (n) => o[n][t] < e), V7 = (o, t, e) => u1(o, e, (r) => o[r][t] >= e);
function H7(o, t, e) {
  let r = 0, n = o.length;
  for (; r < n && o[r] < t; )
    r++;
  for (; n > r && o[n - 1] > e; )
    n--;
  return r > 0 || n < o.length ? o.slice(r, n) : o;
}
const YM = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function B7(o, t) {
  if (o._chartjs) {
    o._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(o, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), YM.forEach((e) => {
    const r = "_onData" + s1(e), n = o[e];
    Object.defineProperty(o, e, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const a = n.apply(this, i);
        return o._chartjs.listeners.forEach((s) => {
          typeof s[r] == "function" && s[r](...i);
        }), a;
      }
    });
  });
}
function sT(o, t) {
  const e = o._chartjs;
  if (!e)
    return;
  const r = e.listeners, n = r.indexOf(t);
  n !== -1 && r.splice(n, 1), !(r.length > 0) && (YM.forEach((i) => {
    delete o[i];
  }), delete o._chartjs);
}
function KM(o) {
  const t = new Set(o);
  return t.size === o.length ? o : Array.from(t);
}
const qM = function() {
  return typeof window > "u" ? function(o) {
    return o();
  } : window.requestAnimationFrame;
}();
function XM(o, t) {
  let e = [], r = !1;
  return function(...n) {
    e = n, r || (r = !0, qM.call(window, () => {
      r = !1, o.apply(t, e);
    }));
  };
}
function W7(o, t) {
  let e;
  return function(...r) {
    return t ? (clearTimeout(e), e = setTimeout(o, t, r)) : o.apply(this, r), t;
  };
}
const c1 = (o) => o === "start" ? "left" : o === "end" ? "right" : "center", qn = (o, t, e) => o === "start" ? t : o === "end" ? e : (t + e) / 2, j7 = (o, t, e, r) => o === (r ? "left" : "right") ? e : o === "center" ? (t + e) / 2 : t;
function ZM(o, t, e) {
  const r = t.length;
  let n = 0, i = r;
  if (o._sorted) {
    const { iScale: a, _parsed: s } = o, l = a.axis, { min: u, max: c, minDefined: d, maxDefined: f } = a.getUserBounds();
    d && (n = Pn(Math.min(
      // @ts-expect-error Need to type _parsed
      ms(s, l, u).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? r : ms(t, l, a.getPixelForValue(u)).lo
    ), 0, r - 1)), f ? i = Pn(Math.max(
      // @ts-expect-error Need to type _parsed
      ms(s, a.axis, c, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? 0 : ms(t, l, a.getPixelForValue(c), !0).hi + 1
    ), n, r) - n : i = r - n;
  }
  return {
    start: n,
    count: i
  };
}
function QM(o) {
  const { xScale: t, yScale: e, _scaleRanges: r } = o, n = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!r)
    return o._scaleRanges = n, !0;
  const i = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== e.min || r.ymax !== e.max;
  return Object.assign(r, n), i;
}
const hg = (o) => o === 0 || o === 1, lT = (o, t, e) => -(Math.pow(2, 10 * (o -= 1)) * Math.sin((o - t) * Nr / e)), uT = (o, t, e) => Math.pow(2, -10 * o) * Math.sin((o - t) * Nr / e) + 1, wh = {
  linear: (o) => o,
  easeInQuad: (o) => o * o,
  easeOutQuad: (o) => -o * (o - 2),
  easeInOutQuad: (o) => (o /= 0.5) < 1 ? 0.5 * o * o : -0.5 * (--o * (o - 2) - 1),
  easeInCubic: (o) => o * o * o,
  easeOutCubic: (o) => (o -= 1) * o * o + 1,
  easeInOutCubic: (o) => (o /= 0.5) < 1 ? 0.5 * o * o * o : 0.5 * ((o -= 2) * o * o + 2),
  easeInQuart: (o) => o * o * o * o,
  easeOutQuart: (o) => -((o -= 1) * o * o * o - 1),
  easeInOutQuart: (o) => (o /= 0.5) < 1 ? 0.5 * o * o * o * o : -0.5 * ((o -= 2) * o * o * o - 2),
  easeInQuint: (o) => o * o * o * o * o,
  easeOutQuint: (o) => (o -= 1) * o * o * o * o + 1,
  easeInOutQuint: (o) => (o /= 0.5) < 1 ? 0.5 * o * o * o * o * o : 0.5 * ((o -= 2) * o * o * o * o + 2),
  easeInSine: (o) => -Math.cos(o * an) + 1,
  easeOutSine: (o) => Math.sin(o * an),
  easeInOutSine: (o) => -0.5 * (Math.cos(kr * o) - 1),
  easeInExpo: (o) => o === 0 ? 0 : Math.pow(2, 10 * (o - 1)),
  easeOutExpo: (o) => o === 1 ? 1 : -Math.pow(2, -10 * o) + 1,
  easeInOutExpo: (o) => hg(o) ? o : o < 0.5 ? 0.5 * Math.pow(2, 10 * (o * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (o * 2 - 1)) + 2),
  easeInCirc: (o) => o >= 1 ? o : -(Math.sqrt(1 - o * o) - 1),
  easeOutCirc: (o) => Math.sqrt(1 - (o -= 1) * o),
  easeInOutCirc: (o) => (o /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - o * o) - 1) : 0.5 * (Math.sqrt(1 - (o -= 2) * o) + 1),
  easeInElastic: (o) => hg(o) ? o : lT(o, 0.075, 0.3),
  easeOutElastic: (o) => hg(o) ? o : uT(o, 0.075, 0.3),
  easeInOutElastic(o) {
    return hg(o) ? o : o < 0.5 ? 0.5 * lT(o * 2, 0.1125, 0.45) : 0.5 + 0.5 * uT(o * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(o) {
    return o * o * ((1.70158 + 1) * o - 1.70158);
  },
  easeOutBack(o) {
    return (o -= 1) * o * ((1.70158 + 1) * o + 1.70158) + 1;
  },
  easeInOutBack(o) {
    let t = 1.70158;
    return (o /= 0.5) < 1 ? 0.5 * (o * o * (((t *= 1.525) + 1) * o - t)) : 0.5 * ((o -= 2) * o * (((t *= 1.525) + 1) * o + t) + 2);
  },
  easeInBounce: (o) => 1 - wh.easeOutBounce(1 - o),
  easeOutBounce(o) {
    return o < 1 / 2.75 ? 7.5625 * o * o : o < 2 / 2.75 ? 7.5625 * (o -= 1.5 / 2.75) * o + 0.75 : o < 2.5 / 2.75 ? 7.5625 * (o -= 2.25 / 2.75) * o + 0.9375 : 7.5625 * (o -= 2.625 / 2.75) * o + 0.984375;
  },
  easeInOutBounce: (o) => o < 0.5 ? wh.easeInBounce(o * 2) * 0.5 : wh.easeOutBounce(o * 2 - 1) * 0.5 + 0.5
};
function d1(o) {
  if (o && typeof o == "object") {
    const t = o.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function cT(o) {
  return d1(o) ? o : new Gh(o);
}
function fw(o) {
  return d1(o) ? o : new Gh(o).saturate(0.5).darken(0.1).hexString();
}
const U7 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], $7 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function z7(o) {
  o.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), o.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), o.set("animations", {
    colors: {
      type: "color",
      properties: $7
    },
    numbers: {
      type: "number",
      properties: U7
    }
  }), o.describe("animations", {
    _fallback: "animation"
  }), o.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function Y7(o) {
  o.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const dT = /* @__PURE__ */ new Map();
function K7(o, t) {
  t = t || {};
  const e = o + JSON.stringify(t);
  let r = dT.get(e);
  return r || (r = new Intl.NumberFormat(o, t), dT.set(e, r)), r;
}
function sv(o, t, e) {
  return K7(t, e).format(o);
}
const JM = {
  values(o) {
    return Lr(o) ? o : "" + o;
  },
  numeric(o, t, e) {
    if (o === 0)
      return "0";
    const r = this.chart.options.locale;
    let n, i = o;
    if (e.length > 1) {
      const u = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (u < 1e-4 || u > 1e15) && (n = "scientific"), i = q7(o, e);
    }
    const a = _l(Math.abs(i)), s = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: n,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(l, this.options.ticks.format), sv(o, r, l);
  },
  logarithmic(o, t, e) {
    if (o === 0)
      return "0";
    const r = e[t].significand || o / Math.pow(10, Math.floor(_l(o)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * e.length ? JM.numeric.call(this, o, t, e) : "";
  }
};
function q7(o, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && o !== Math.floor(o) && (e = o - Math.floor(o)), e;
}
var Uy = {
  formatters: JM
};
function X7(o) {
  o.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, e) => e.lineWidth,
      tickColor: (t, e) => e.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Uy.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), o.route("scale.ticks", "color", "", "color"), o.route("scale.grid", "color", "", "borderColor"), o.route("scale.border", "color", "", "borderColor"), o.route("scale.title", "color", "", "color"), o.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), o.describe("scales", {
    _fallback: "scale"
  }), o.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const pc = /* @__PURE__ */ Object.create(null), pS = /* @__PURE__ */ Object.create(null);
function bh(o, t) {
  if (!t)
    return o;
  const e = t.split(".");
  for (let r = 0, n = e.length; r < n; ++r) {
    const i = e[r];
    o = o[i] || (o[i] = /* @__PURE__ */ Object.create(null));
  }
  return o;
}
function hw(o, t, e) {
  return typeof t == "string" ? Ha(bh(o, t), e) : Ha(bh(o, ""), t);
}
class Z7 {
  constructor(t, e) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, n) => fw(n.backgroundColor), this.hoverBorderColor = (r, n) => fw(n.borderColor), this.hoverColor = (r, n) => fw(n.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(e);
  }
  set(t, e) {
    return hw(this, t, e);
  }
  get(t) {
    return bh(this, t);
  }
  describe(t, e) {
    return hw(pS, t, e);
  }
  override(t, e) {
    return hw(pc, t, e);
  }
  route(t, e, r, n) {
    const i = bh(this, t), a = bh(this, r), s = "_" + e;
    Object.defineProperties(i, {
      [s]: {
        value: i[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const l = this[s], u = a[n];
          return Ht(l) ? Object.assign({}, u, l) : xt(l, u);
        },
        set(l) {
          this[s] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((e) => e(this));
  }
}
var Yr = /* @__PURE__ */ new Z7({
  _scriptable: (o) => !o.startsWith("on"),
  _indexable: (o) => o !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  z7,
  Y7,
  X7
]);
function Q7(o) {
  return !o || Nt(o.size) || Nt(o.family) ? null : (o.style ? o.style + " " : "") + (o.weight ? o.weight + " " : "") + o.size + "px " + o.family;
}
function Bm(o, t, e, r, n) {
  let i = t[n];
  return i || (i = t[n] = o.measureText(n).width, e.push(n)), i > r && (r = i), r;
}
function J7(o, t, e, r) {
  r = r || {};
  let n = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (n = r.data = {}, i = r.garbageCollect = [], r.font = t), o.save(), o.font = t;
  let a = 0;
  const s = e.length;
  let l, u, c, d, f;
  for (l = 0; l < s; l++)
    if (d = e[l], d != null && !Lr(d))
      a = Bm(o, n, i, a, d);
    else if (Lr(d))
      for (u = 0, c = d.length; u < c; u++)
        f = d[u], f != null && !Lr(f) && (a = Bm(o, n, i, a, f));
  o.restore();
  const v = i.length / 2;
  if (v > e.length) {
    for (l = 0; l < v; l++)
      delete n[i[l]];
    i.splice(0, v);
  }
  return a;
}
function Du(o, t, e) {
  const r = o.currentDevicePixelRatio, n = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - n) * r) / r + n;
}
function pT(o, t) {
  t = t || o.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, o.width, o.height), t.restore();
}
function fS(o, t, e, r) {
  eF(o, t, e, r, null);
}
function eF(o, t, e, r, n) {
  let i, a, s, l, u, c, d, f;
  const v = t.pointStyle, g = t.rotation, m = t.radius;
  let b = (g || 0) * I7;
  if (v && typeof v == "object" && (i = v.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    o.save(), o.translate(e, r), o.rotate(b), o.drawImage(v, -v.width / 2, -v.height / 2, v.width, v.height), o.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (o.beginPath(), v) {
      default:
        n ? o.ellipse(e, r, n / 2, m, 0, 0, Nr) : o.arc(e, r, m, 0, Nr), o.closePath();
        break;
      case "triangle":
        c = n ? n / 2 : m, o.moveTo(e + Math.sin(b) * c, r - Math.cos(b) * m), b += oT, o.lineTo(e + Math.sin(b) * c, r - Math.cos(b) * m), b += oT, o.lineTo(e + Math.sin(b) * c, r - Math.cos(b) * m), o.closePath();
        break;
      case "rectRounded":
        u = m * 0.516, l = m - u, a = Math.cos(b + Pu) * l, d = Math.cos(b + Pu) * (n ? n / 2 - u : l), s = Math.sin(b + Pu) * l, f = Math.sin(b + Pu) * (n ? n / 2 - u : l), o.arc(e - d, r - s, u, b - kr, b - an), o.arc(e + f, r - a, u, b - an, b), o.arc(e + d, r + s, u, b, b + an), o.arc(e - f, r + a, u, b + an, b + kr), o.closePath();
        break;
      case "rect":
        if (!g) {
          l = Math.SQRT1_2 * m, c = n ? n / 2 : l, o.rect(e - c, r - l, 2 * c, 2 * l);
          break;
        }
        b += Pu;
      case "rectRot":
        d = Math.cos(b) * (n ? n / 2 : m), a = Math.cos(b) * m, s = Math.sin(b) * m, f = Math.sin(b) * (n ? n / 2 : m), o.moveTo(e - d, r - s), o.lineTo(e + f, r - a), o.lineTo(e + d, r + s), o.lineTo(e - f, r + a), o.closePath();
        break;
      case "crossRot":
        b += Pu;
      case "cross":
        d = Math.cos(b) * (n ? n / 2 : m), a = Math.cos(b) * m, s = Math.sin(b) * m, f = Math.sin(b) * (n ? n / 2 : m), o.moveTo(e - d, r - s), o.lineTo(e + d, r + s), o.moveTo(e + f, r - a), o.lineTo(e - f, r + a);
        break;
      case "star":
        d = Math.cos(b) * (n ? n / 2 : m), a = Math.cos(b) * m, s = Math.sin(b) * m, f = Math.sin(b) * (n ? n / 2 : m), o.moveTo(e - d, r - s), o.lineTo(e + d, r + s), o.moveTo(e + f, r - a), o.lineTo(e - f, r + a), b += Pu, d = Math.cos(b) * (n ? n / 2 : m), a = Math.cos(b) * m, s = Math.sin(b) * m, f = Math.sin(b) * (n ? n / 2 : m), o.moveTo(e - d, r - s), o.lineTo(e + d, r + s), o.moveTo(e + f, r - a), o.lineTo(e - f, r + a);
        break;
      case "line":
        a = n ? n / 2 : Math.cos(b) * m, s = Math.sin(b) * m, o.moveTo(e - a, r - s), o.lineTo(e + a, r + s);
        break;
      case "dash":
        o.moveTo(e, r), o.lineTo(e + Math.cos(b) * (n ? n / 2 : m), r + Math.sin(b) * m);
        break;
      case !1:
        o.closePath();
        break;
    }
    o.fill(), t.borderWidth > 0 && o.stroke();
  }
}
function ys(o, t, e) {
  return e = e || 0.5, !t || o && o.x > t.left - e && o.x < t.right + e && o.y > t.top - e && o.y < t.bottom + e;
}
function $y(o, t) {
  o.save(), o.beginPath(), o.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), o.clip();
}
function zy(o) {
  o.restore();
}
function eH(o, t, e, r, n) {
  if (!t)
    return o.lineTo(e.x, e.y);
  if (n === "middle") {
    const i = (t.x + e.x) / 2;
    o.lineTo(i, t.y), o.lineTo(i, e.y);
  } else n === "after" != !!r ? o.lineTo(t.x, e.y) : o.lineTo(e.x, t.y);
  o.lineTo(e.x, e.y);
}
function tH(o, t, e, r) {
  if (!t)
    return o.lineTo(e.x, e.y);
  o.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? e.cp2x : e.cp1x, r ? e.cp2y : e.cp1y, e.x, e.y);
}
function rH(o, t) {
  t.translation && o.translate(t.translation[0], t.translation[1]), Nt(t.rotation) || o.rotate(t.rotation), t.color && (o.fillStyle = t.color), t.textAlign && (o.textAlign = t.textAlign), t.textBaseline && (o.textBaseline = t.textBaseline);
}
function nH(o, t, e, r, n) {
  if (n.strikethrough || n.underline) {
    const i = o.measureText(r), a = t - i.actualBoundingBoxLeft, s = t + i.actualBoundingBoxRight, l = e - i.actualBoundingBoxAscent, u = e + i.actualBoundingBoxDescent, c = n.strikethrough ? (l + u) / 2 : u;
    o.strokeStyle = o.fillStyle, o.beginPath(), o.lineWidth = n.decorationWidth || 2, o.moveTo(a, c), o.lineTo(s, c), o.stroke();
  }
}
function oH(o, t) {
  const e = o.fillStyle;
  o.fillStyle = t.color, o.fillRect(t.left, t.top, t.width, t.height), o.fillStyle = e;
}
function fc(o, t, e, r, n, i = {}) {
  const a = Lr(t) ? t : [
    t
  ], s = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, u;
  for (o.save(), o.font = n.string, rH(o, i), l = 0; l < a.length; ++l)
    u = a[l], i.backdrop && oH(o, i.backdrop), s && (i.strokeColor && (o.strokeStyle = i.strokeColor), Nt(i.strokeWidth) || (o.lineWidth = i.strokeWidth), o.strokeText(u, e, r, i.maxWidth)), o.fillText(u, e, r, i.maxWidth), nH(o, e, r, u, i), r += Number(n.lineHeight);
  o.restore();
}
function Bh(o, t) {
  const { x: e, y: r, w: n, h: i, radius: a } = t;
  o.arc(e + a.topLeft, r + a.topLeft, a.topLeft, 1.5 * kr, kr, !0), o.lineTo(e, r + i - a.bottomLeft), o.arc(e + a.bottomLeft, r + i - a.bottomLeft, a.bottomLeft, kr, an, !0), o.lineTo(e + n - a.bottomRight, r + i), o.arc(e + n - a.bottomRight, r + i - a.bottomRight, a.bottomRight, an, 0, !0), o.lineTo(e + n, r + a.topRight), o.arc(e + n - a.topRight, r + a.topRight, a.topRight, 0, -an, !0), o.lineTo(e + a.topLeft, r);
}
const iH = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, aH = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function sH(o, t) {
  const e = ("" + o).match(iH);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (o = +e[2], e[3]) {
    case "px":
      return o;
    case "%":
      o /= 100;
      break;
  }
  return t * o;
}
const lH = (o) => +o || 0;
function p1(o, t) {
  const e = {}, r = Ht(t), n = r ? Object.keys(t) : t, i = Ht(o) ? r ? (a) => xt(o[a], o[t[a]]) : (a) => o[a] : () => o;
  for (const a of n)
    e[a] = lH(i(a));
  return e;
}
function tF(o) {
  return p1(o, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function nc(o) {
  return p1(o, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function jn(o) {
  const t = tF(o);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function hn(o, t) {
  o = o || {}, t = t || Yr.font;
  let e = xt(o.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let r = xt(o.style, t.style);
  r && !("" + r).match(aH) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const n = {
    family: xt(o.family, t.family),
    lineHeight: sH(xt(o.lineHeight, t.lineHeight), e),
    size: e,
    style: r,
    weight: xt(o.weight, t.weight),
    string: ""
  };
  return n.string = Q7(n), n;
}
function Fr(o, t, e, r) {
  let n, i, a;
  for (n = 0, i = o.length; n < i; ++n)
    if (a = o[n], a !== void 0 && (t !== void 0 && typeof a == "function" && (a = a(t)), e !== void 0 && Lr(a) && (a = a[e % a.length]), a !== void 0))
      return a;
}
function uH(o, t, e) {
  const { min: r, max: n } = o, i = jM(t, (n - r) / 2), a = (s, l) => e && s === 0 ? 0 : s + l;
  return {
    min: a(r, -Math.abs(i)),
    max: a(n, i)
  };
}
function Wl(o, t) {
  return Object.assign(Object.create(o), t);
}
function f1(o, t = [
  ""
], e, r, n = () => o[0]) {
  const i = e || o;
  typeof r > "u" && (r = iF("_fallback", o));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: o,
    _rootScopes: i,
    _fallback: r,
    _getTarget: n,
    override: (s) => f1([
      s,
      ...o
    ], t, i, r)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, l) {
      return delete s[l], delete s._keys, delete o[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, l) {
      return nF(s, l, () => mH(l, t, o, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, l) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(o[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(s, l) {
      return hT(s).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(s) {
      return hT(s);
    },
    /**
    * A trap for setting property values.
    */
    set(s, l, u) {
      const c = s._storage || (s._storage = n());
      return s[l] = c[l] = u, delete s._keys, !0;
    }
  });
}
function ip(o, t, e, r) {
  const n = {
    _cacheable: !1,
    _proxy: o,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: rF(o, r),
    setContext: (i) => ip(o, i, e, r),
    override: (i) => ip(o.override(i), t, e, r)
  };
  return new Proxy(n, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, a) {
      return delete i[a], delete o[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, a, s) {
      return nF(i, a, () => dH(i, a, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, a) {
      return i._descriptors.allKeys ? Reflect.has(o, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(o, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(o);
    },
    /**
    * A trap for the in operator.
    */
    has(i, a) {
      return Reflect.has(o, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(o);
    },
    /**
    * A trap for setting property values.
    */
    set(i, a, s) {
      return o[a] = s, delete i[a], !0;
    }
  });
}
function rF(o, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: e = t.scriptable, _indexable: r = t.indexable, _allKeys: n = t.allKeys } = o;
  return {
    allKeys: n,
    scriptable: e,
    indexable: r,
    isScriptable: Gl(e) ? e : () => e,
    isIndexable: Gl(r) ? r : () => r
  };
}
const cH = (o, t) => o ? o + s1(t) : t, h1 = (o, t) => Ht(t) && o !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function nF(o, t, e) {
  if (Object.prototype.hasOwnProperty.call(o, t))
    return o[t];
  const r = e();
  return o[t] = r, r;
}
function dH(o, t, e) {
  const { _proxy: r, _context: n, _subProxy: i, _descriptors: a } = o;
  let s = r[t];
  return Gl(s) && a.isScriptable(t) && (s = pH(t, s, o, e)), Lr(s) && s.length && (s = fH(t, s, o, a.isIndexable)), h1(t, s) && (s = ip(s, n, i && i[t], a)), s;
}
function pH(o, t, e, r) {
  const { _proxy: n, _context: i, _subProxy: a, _stack: s } = e;
  if (s.has(o))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + o);
  s.add(o);
  let l = t(i, a || r);
  return s.delete(o), h1(o, l) && (l = v1(n._scopes, n, o, l)), l;
}
function fH(o, t, e, r) {
  const { _proxy: n, _context: i, _subProxy: a, _descriptors: s } = e;
  if (typeof i.index < "u" && r(o))
    return t[i.index % t.length];
  if (Ht(t[0])) {
    const l = t, u = n._scopes.filter((c) => c !== l);
    t = [];
    for (const c of l) {
      const d = v1(u, n, o, c);
      t.push(ip(d, i, a && a[o], s));
    }
  }
  return t;
}
function oF(o, t, e) {
  return Gl(o) ? o(t, e) : o;
}
const hH = (o, t) => o === !0 ? t : typeof o == "string" ? kl(t, o) : void 0;
function vH(o, t, e, r, n) {
  for (const i of t) {
    const a = hH(e, i);
    if (a) {
      o.add(a);
      const s = oF(a._fallback, e, n);
      if (typeof s < "u" && s !== e && s !== r)
        return s;
    } else if (a === !1 && typeof r < "u" && e !== r)
      return null;
  }
  return !1;
}
function v1(o, t, e, r) {
  const n = t._rootScopes, i = oF(t._fallback, e, r), a = [
    ...o,
    ...n
  ], s = /* @__PURE__ */ new Set();
  s.add(r);
  let l = fT(s, a, e, i || e, r);
  return l === null || typeof i < "u" && i !== e && (l = fT(s, a, i, l, r), l === null) ? !1 : f1(Array.from(s), [
    ""
  ], n, i, () => gH(t, e, r));
}
function fT(o, t, e, r, n) {
  for (; e; )
    e = vH(o, t, e, r, n);
  return e;
}
function gH(o, t, e) {
  const r = o._getTarget();
  t in r || (r[t] = {});
  const n = r[t];
  return Lr(n) && Ht(e) ? e : n || {};
}
function mH(o, t, e, r) {
  let n;
  for (const i of t)
    if (n = iF(cH(i, o), e), typeof n < "u")
      return h1(o, n) ? v1(e, r, o, n) : n;
}
function iF(o, t) {
  for (const e of t) {
    if (!e)
      continue;
    const r = e[o];
    if (typeof r < "u")
      return r;
  }
}
function hT(o) {
  let t = o._keys;
  return t || (t = o._keys = yH(o._scopes)), t;
}
function yH(o) {
  const t = /* @__PURE__ */ new Set();
  for (const e of o)
    for (const r of Object.keys(e).filter((n) => !n.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function aF(o, t, e, r) {
  const { iScale: n } = o, { key: i = "r" } = this._parsing, a = new Array(r);
  let s, l, u, c;
  for (s = 0, l = r; s < l; ++s)
    u = s + e, c = t[u], a[s] = {
      r: n.parse(kl(c, i), u)
    };
  return a;
}
const CH = Number.EPSILON || 1e-14, ap = (o, t) => t < o.length && !o[t].skip && o[t], sF = (o) => o === "x" ? "y" : "x";
function wH(o, t, e, r) {
  const n = o.skip ? t : o, i = t, a = e.skip ? t : e, s = dS(i, n), l = dS(a, i);
  let u = s / (s + l), c = l / (s + l);
  u = isNaN(u) ? 0 : u, c = isNaN(c) ? 0 : c;
  const d = r * u, f = r * c;
  return {
    previous: {
      x: i.x - d * (a.x - n.x),
      y: i.y - d * (a.y - n.y)
    },
    next: {
      x: i.x + f * (a.x - n.x),
      y: i.y + f * (a.y - n.y)
    }
  };
}
function bH(o, t, e) {
  const r = o.length;
  let n, i, a, s, l, u = ap(o, 0);
  for (let c = 0; c < r - 1; ++c)
    if (l = u, u = ap(o, c + 1), !(!l || !u)) {
      if (Ch(t[c], 0, CH)) {
        e[c] = e[c + 1] = 0;
        continue;
      }
      n = e[c] / t[c], i = e[c + 1] / t[c], s = Math.pow(n, 2) + Math.pow(i, 2), !(s <= 9) && (a = 3 / Math.sqrt(s), e[c] = n * a * t[c], e[c + 1] = i * a * t[c]);
    }
}
function SH(o, t, e = "x") {
  const r = sF(e), n = o.length;
  let i, a, s, l = ap(o, 0);
  for (let u = 0; u < n; ++u) {
    if (a = s, s = l, l = ap(o, u + 1), !s)
      continue;
    const c = s[e], d = s[r];
    a && (i = (c - a[e]) / 3, s[`cp1${e}`] = c - i, s[`cp1${r}`] = d - i * t[u]), l && (i = (l[e] - c) / 3, s[`cp2${e}`] = c + i, s[`cp2${r}`] = d + i * t[u]);
  }
}
function EH(o, t = "x") {
  const e = sF(t), r = o.length, n = Array(r).fill(0), i = Array(r);
  let a, s, l, u = ap(o, 0);
  for (a = 0; a < r; ++a)
    if (s = l, l = u, u = ap(o, a + 1), !!l) {
      if (u) {
        const c = u[t] - l[t];
        n[a] = c !== 0 ? (u[e] - l[e]) / c : 0;
      }
      i[a] = s ? u ? Fa(n[a - 1]) !== Fa(n[a]) ? 0 : (n[a - 1] + n[a]) / 2 : n[a - 1] : n[a];
    }
  bH(o, n, i), SH(o, i, t);
}
function vg(o, t, e) {
  return Math.max(Math.min(o, e), t);
}
function _H(o, t) {
  let e, r, n, i, a, s = ys(o[0], t);
  for (e = 0, r = o.length; e < r; ++e)
    a = i, i = s, s = e < r - 1 && ys(o[e + 1], t), i && (n = o[e], a && (n.cp1x = vg(n.cp1x, t.left, t.right), n.cp1y = vg(n.cp1y, t.top, t.bottom)), s && (n.cp2x = vg(n.cp2x, t.left, t.right), n.cp2y = vg(n.cp2y, t.top, t.bottom)));
}
function xH(o, t, e, r, n) {
  let i, a, s, l;
  if (t.spanGaps && (o = o.filter((u) => !u.skip)), t.cubicInterpolationMode === "monotone")
    EH(o, n);
  else {
    let u = r ? o[o.length - 1] : o[0];
    for (i = 0, a = o.length; i < a; ++i)
      s = o[i], l = wH(u, s, o[Math.min(i + 1, a - (r ? 0 : 1)) % a], t.tension), s.cp1x = l.previous.x, s.cp1y = l.previous.y, s.cp2x = l.next.x, s.cp2y = l.next.y, u = s;
  }
  t.capBezierPoints && _H(o, e);
}
function lF() {
  return typeof window < "u" && typeof document < "u";
}
function g1(o) {
  let t = o.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Wm(o, t, e) {
  let r;
  return typeof o == "string" ? (r = parseInt(o, 10), o.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[e])) : r = o, r;
}
const Yy = (o) => o.ownerDocument.defaultView.getComputedStyle(o, null);
function RH(o, t) {
  return Yy(o).getPropertyValue(t);
}
const TH = [
  "top",
  "right",
  "bottom",
  "left"
];
function oc(o, t, e) {
  const r = {};
  e = e ? "-" + e : "";
  for (let n = 0; n < 4; n++) {
    const i = TH[n];
    r[i] = parseFloat(o[t + "-" + i + e]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const OH = (o, t, e) => (o > 0 || t > 0) && (!e || !e.shadowRoot);
function PH(o, t) {
  const e = o.touches, r = e && e.length ? e[0] : o, { offsetX: n, offsetY: i } = r;
  let a = !1, s, l;
  if (OH(n, i, o.target))
    s = n, l = i;
  else {
    const u = t.getBoundingClientRect();
    s = r.clientX - u.left, l = r.clientY - u.top, a = !0;
  }
  return {
    x: s,
    y: l,
    box: a
  };
}
function $u(o, t) {
  if ("native" in o)
    return o;
  const { canvas: e, currentDevicePixelRatio: r } = t, n = Yy(e), i = n.boxSizing === "border-box", a = oc(n, "padding"), s = oc(n, "border", "width"), { x: l, y: u, box: c } = PH(o, e), d = a.left + (c && s.left), f = a.top + (c && s.top);
  let { width: v, height: g } = t;
  return i && (v -= a.width + s.width, g -= a.height + s.height), {
    x: Math.round((l - d) / v * e.width / r),
    y: Math.round((u - f) / g * e.height / r)
  };
}
function DH(o, t, e) {
  let r, n;
  if (t === void 0 || e === void 0) {
    const i = g1(o);
    if (!i)
      t = o.clientWidth, e = o.clientHeight;
    else {
      const a = i.getBoundingClientRect(), s = Yy(i), l = oc(s, "border", "width"), u = oc(s, "padding");
      t = a.width - u.width - l.width, e = a.height - u.height - l.height, r = Wm(s.maxWidth, i, "clientWidth"), n = Wm(s.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: r || Hm,
    maxHeight: n || Hm
  };
}
const gg = (o) => Math.round(o * 10) / 10;
function AH(o, t, e, r) {
  const n = Yy(o), i = oc(n, "margin"), a = Wm(n.maxWidth, o, "clientWidth") || Hm, s = Wm(n.maxHeight, o, "clientHeight") || Hm, l = DH(o, t, e);
  let { width: u, height: c } = l;
  if (n.boxSizing === "content-box") {
    const f = oc(n, "border", "width"), v = oc(n, "padding");
    u -= v.width + f.width, c -= v.height + f.height;
  }
  return u = Math.max(0, u - i.width), c = Math.max(0, r ? u / r : c - i.height), u = gg(Math.min(u, a, l.maxWidth)), c = gg(Math.min(c, s, l.maxHeight)), u && !c && (c = gg(u / 2)), (t !== void 0 || e !== void 0) && r && l.height && c > l.height && (c = l.height, u = gg(Math.floor(c * r))), {
    width: u,
    height: c
  };
}
function vT(o, t, e) {
  const r = t || 1, n = Math.floor(o.height * r), i = Math.floor(o.width * r);
  o.height = Math.floor(o.height), o.width = Math.floor(o.width);
  const a = o.canvas;
  return a.style && (e || !a.style.height && !a.style.width) && (a.style.height = `${o.height}px`, a.style.width = `${o.width}px`), o.currentDevicePixelRatio !== r || a.height !== n || a.width !== i ? (o.currentDevicePixelRatio = r, a.height = n, a.width = i, o.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const MH = function() {
  let o = !1;
  try {
    const t = {
      get passive() {
        return o = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return o;
}();
function gT(o, t) {
  const e = RH(o, t), r = e && e.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function zu(o, t, e, r) {
  return {
    x: o.x + e * (t.x - o.x),
    y: o.y + e * (t.y - o.y)
  };
}
function FH(o, t, e, r) {
  return {
    x: o.x + e * (t.x - o.x),
    y: r === "middle" ? e < 0.5 ? o.y : t.y : r === "after" ? e < 1 ? o.y : t.y : e > 0 ? t.y : o.y
  };
}
function IH(o, t, e, r) {
  const n = {
    x: o.cp2x,
    y: o.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, a = zu(o, n, e), s = zu(n, i, e), l = zu(i, t, e), u = zu(a, s, e), c = zu(s, l, e);
  return zu(u, c, e);
}
const LH = function(o, t) {
  return {
    x(e) {
      return o + o + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, r) {
      return e - r;
    },
    leftForLtr(e, r) {
      return e - r;
    }
  };
}, NH = function() {
  return {
    x(o) {
      return o;
    },
    setWidth(o) {
    },
    textAlign(o) {
      return o;
    },
    xPlus(o, t) {
      return o + t;
    },
    leftForLtr(o, t) {
      return o;
    }
  };
};
function Kd(o, t, e) {
  return o ? LH(t, e) : NH();
}
function uF(o, t) {
  let e, r;
  (t === "ltr" || t === "rtl") && (e = o.canvas.style, r = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), o.prevTextDirection = r);
}
function cF(o, t) {
  t !== void 0 && (delete o.prevTextDirection, o.canvas.style.setProperty("direction", t[0], t[1]));
}
function dF(o) {
  return o === "angle" ? {
    between: Hh,
    compare: k7,
    normalize: ei
  } : {
    between: gs,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function mT({ start: o, end: t, count: e, loop: r, style: n }) {
  return {
    start: o % e,
    end: t % e,
    loop: r && (t - o + 1) % e === 0,
    style: n
  };
}
function kH(o, t, e) {
  const { property: r, start: n, end: i } = e, { between: a, normalize: s } = dF(r), l = t.length;
  let { start: u, end: c, loop: d } = o, f, v;
  if (d) {
    for (u += l, c += l, f = 0, v = l; f < v && a(s(t[u % l][r]), n, i); ++f)
      u--, c--;
    u %= l, c %= l;
  }
  return c < u && (c += l), {
    start: u,
    end: c,
    loop: d,
    style: o.style
  };
}
function pF(o, t, e) {
  if (!e)
    return [
      o
    ];
  const { property: r, start: n, end: i } = e, a = t.length, { compare: s, between: l, normalize: u } = dF(r), { start: c, end: d, loop: f, style: v } = kH(o, t, e), g = [];
  let m = !1, b = null, S, R, P;
  const D = () => l(n, P, S) && s(n, P) !== 0, x = () => s(i, S) === 0 || l(i, P, S), M = () => m || D(), F = () => !m || x();
  for (let H = c, B = c; H <= d; ++H)
    R = t[H % a], !R.skip && (S = u(R[r]), S !== P && (m = l(S, n, i), b === null && M() && (b = s(S, n) === 0 ? H : B), b !== null && F() && (g.push(mT({
      start: b,
      end: H,
      loop: f,
      count: a,
      style: v
    })), b = null), B = H, P = S));
  return b !== null && g.push(mT({
    start: b,
    end: d,
    loop: f,
    count: a,
    style: v
  })), g;
}
function fF(o, t) {
  const e = [], r = o.segments;
  for (let n = 0; n < r.length; n++) {
    const i = pF(r[n], o.points, t);
    i.length && e.push(...i);
  }
  return e;
}
function GH(o, t, e, r) {
  let n = 0, i = t - 1;
  if (e && !r)
    for (; n < t && !o[n].skip; )
      n++;
  for (; n < t && o[n].skip; )
    n++;
  for (n %= t, e && (i += n); i > n && o[i % t].skip; )
    i--;
  return i %= t, {
    start: n,
    end: i
  };
}
function VH(o, t, e, r) {
  const n = o.length, i = [];
  let a = t, s = o[t], l;
  for (l = t + 1; l <= e; ++l) {
    const u = o[l % n];
    u.skip || u.stop ? s.skip || (r = !1, i.push({
      start: t % n,
      end: (l - 1) % n,
      loop: r
    }), t = a = u.stop ? l : null) : (a = l, s.skip && (t = l)), s = u;
  }
  return a !== null && i.push({
    start: t % n,
    end: a % n,
    loop: r
  }), i;
}
function HH(o, t) {
  const e = o.points, r = o.options.spanGaps, n = e.length;
  if (!n)
    return [];
  const i = !!o._loop, { start: a, end: s } = GH(e, n, i, r);
  if (r === !0)
    return yT(o, [
      {
        start: a,
        end: s,
        loop: i
      }
    ], e, t);
  const l = s < a ? s + n : s, u = !!o._fullLoop && a === 0 && s === n - 1;
  return yT(o, VH(e, a, l, u), e, t);
}
function yT(o, t, e, r) {
  return !r || !r.setContext || !e ? t : BH(o, t, e, r);
}
function BH(o, t, e, r) {
  const n = o._chart.getContext(), i = CT(o.options), { _datasetIndex: a, options: { spanGaps: s } } = o, l = e.length, u = [];
  let c = i, d = t[0].start, f = d;
  function v(g, m, b, S) {
    const R = s ? -1 : 1;
    if (g !== m) {
      for (g += l; e[g % l].skip; )
        g -= R;
      for (; e[m % l].skip; )
        m += R;
      g % l !== m % l && (u.push({
        start: g % l,
        end: m % l,
        loop: b,
        style: S
      }), c = S, d = m % l);
    }
  }
  for (const g of t) {
    d = s ? d : g.start;
    let m = e[d % l], b;
    for (f = d + 1; f <= g.end; f++) {
      const S = e[f % l];
      b = CT(r.setContext(Wl(n, {
        type: "segment",
        p0: m,
        p1: S,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: a
      }))), WH(b, c) && v(d, f - 1, g.loop, c), m = S, c = b;
    }
    d < f - 1 && v(d, f - 1, g.loop, c);
  }
  return u;
}
function CT(o) {
  return {
    backgroundColor: o.backgroundColor,
    borderCapStyle: o.borderCapStyle,
    borderDash: o.borderDash,
    borderDashOffset: o.borderDashOffset,
    borderJoinStyle: o.borderJoinStyle,
    borderWidth: o.borderWidth,
    borderColor: o.borderColor
  };
}
function WH(o, t) {
  if (!t)
    return !1;
  const e = [], r = function(n, i) {
    return d1(i) ? (e.includes(i) || e.push(i), e.indexOf(i)) : i;
  };
  return JSON.stringify(o, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class jH {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, r, n) {
    const i = e.listeners[n], a = e.duration;
    i.forEach((s) => s({
      chart: t,
      initial: e.initial,
      numSteps: a,
      currentStep: Math.min(r - e.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = qM.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((r, n) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let a = i.length - 1, s = !1, l;
      for (; a >= 0; --a)
        l = i[a], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), s = !0) : (i[a] = i[i.length - 1], i.pop());
      s && (n.draw(), this._notify(n, r, t, "progress")), i.length || (r.running = !1, this._notify(n, r, t, "complete"), r.initial = !1), e += i.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let r = e.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, r)), r;
  }
  listen(t, e, r) {
    this._getAnims(t).listeners[e].push(r);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((r, n) => Math.max(r, n._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const r = e.items;
    let n = r.length - 1;
    for (; n >= 0; --n)
      r[n].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ds = /* @__PURE__ */ new jH();
const wT = "transparent", UH = {
  boolean(o, t, e) {
    return e > 0.5 ? t : o;
  },
  color(o, t, e) {
    const r = cT(o || wT), n = r.valid && cT(t || wT);
    return n && n.valid ? n.mix(r, e).hexString() : t;
  },
  number(o, t, e) {
    return o + (t - o) * e;
  }
};
class $H {
  constructor(t, e, r, n) {
    const i = e[r];
    n = Fr([
      t.to,
      n,
      i,
      t.from
    ]);
    const a = Fr([
      t.from,
      i,
      n
    ]);
    this._active = !0, this._fn = t.fn || UH[t.type || typeof a], this._easing = wh[t.easing] || wh.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = r, this._from = a, this._to = n, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, r) {
    if (this._active) {
      this._notify(!1);
      const n = this._target[this._prop], i = r - this._start, a = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(a, t.duration)), this._total += i, this._loop = !!t.loop, this._to = Fr([
        t.to,
        e,
        n,
        t.from
      ]), this._from = Fr([
        t.from,
        n,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, r = this._duration, n = this._prop, i = this._from, a = this._loop, s = this._to;
    let l;
    if (this._active = i !== s && (a || e < r), !this._active) {
      this._target[n] = s, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[n] = i;
      return;
    }
    l = e / r % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[n] = this._fn(i, s, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, r) => {
      t.push({
        res: e,
        rej: r
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", r = this._promises || [];
    for (let n = 0; n < r.length; n++)
      r[n][e]();
  }
}
class hF {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!Ht(t))
      return;
    const e = Object.keys(Yr.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((n) => {
      const i = t[n];
      if (!Ht(i))
        return;
      const a = {};
      for (const s of e)
        a[s] = i[s];
      (Lr(i.properties) && i.properties || [
        n
      ]).forEach((s) => {
        (s === n || !r.has(s)) && r.set(s, a);
      });
    });
  }
  _animateOptions(t, e) {
    const r = e.options, n = YH(t, r);
    if (!n)
      return [];
    const i = this._createAnimations(n, r);
    return r.$shared && zH(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(t, e) {
    const r = this._properties, n = [], i = t.$animations || (t.$animations = {}), a = Object.keys(e), s = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const u = a[l];
      if (u.charAt(0) === "$")
        continue;
      if (u === "options") {
        n.push(...this._animateOptions(t, e));
        continue;
      }
      const c = e[u];
      let d = i[u];
      const f = r.get(u);
      if (d)
        if (f && d.active()) {
          d.update(f, c, s);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[u] = c;
        continue;
      }
      i[u] = d = new $H(f, t, u, c), n.push(d);
    }
    return n;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const r = this._createAnimations(t, e);
    if (r.length)
      return ds.add(this._chart, r), !0;
  }
}
function zH(o, t) {
  const e = [], r = Object.keys(t);
  for (let n = 0; n < r.length; n++) {
    const i = o[r[n]];
    i && i.active() && e.push(i.wait());
  }
  return Promise.all(e);
}
function YH(o, t) {
  if (!t)
    return;
  let e = o.options;
  if (!e) {
    o.options = t;
    return;
  }
  return e.$shared && (o.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function bT(o, t) {
  const e = o && o.options || {}, r = e.reverse, n = e.min === void 0 ? t : 0, i = e.max === void 0 ? t : 0;
  return {
    start: r ? i : n,
    end: r ? n : i
  };
}
function KH(o, t, e) {
  if (e === !1)
    return !1;
  const r = bT(o, e), n = bT(t, e);
  return {
    top: n.end,
    right: r.end,
    bottom: n.start,
    left: r.start
  };
}
function qH(o) {
  let t, e, r, n;
  return Ht(o) ? (t = o.top, e = o.right, r = o.bottom, n = o.left) : t = e = r = n = o, {
    top: t,
    right: e,
    bottom: r,
    left: n,
    disabled: o === !1
  };
}
function vF(o, t) {
  const e = [], r = o._getSortedDatasetMetas(t);
  let n, i;
  for (n = 0, i = r.length; n < i; ++n)
    e.push(r[n].index);
  return e;
}
function ST(o, t, e, r = {}) {
  const n = o.keys, i = r.mode === "single";
  let a, s, l, u;
  if (t !== null) {
    for (a = 0, s = n.length; a < s; ++a) {
      if (l = +n[a], l === e) {
        if (r.all)
          continue;
        break;
      }
      u = o.values[l], Zr(u) && (i || t === 0 || Fa(t) === Fa(u)) && (t += u);
    }
    return t;
  }
}
function XH(o) {
  const t = Object.keys(o), e = new Array(t.length);
  let r, n, i;
  for (r = 0, n = t.length; r < n; ++r)
    i = t[r], e[r] = {
      x: i,
      y: o[i]
    };
  return e;
}
function ET(o, t) {
  const e = o && o.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function ZH(o, t, e) {
  return `${o.id}.${t.id}.${e.stack || e.type}`;
}
function QH(o) {
  const { min: t, max: e, minDefined: r, maxDefined: n } = o.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: n ? e : Number.POSITIVE_INFINITY
  };
}
function JH(o, t, e) {
  const r = o[t] || (o[t] = {});
  return r[e] || (r[e] = {});
}
function _T(o, t, e, r) {
  for (const n of t.getMatchingVisibleMetas(r).reverse()) {
    const i = o[n.index];
    if (e && i > 0 || !e && i < 0)
      return n.index;
  }
  return null;
}
function xT(o, t) {
  const { chart: e, _cachedMeta: r } = o, n = e._stacks || (e._stacks = {}), { iScale: i, vScale: a, index: s } = r, l = i.axis, u = a.axis, c = ZH(i, a, r), d = t.length;
  let f;
  for (let v = 0; v < d; ++v) {
    const g = t[v], { [l]: m, [u]: b } = g, S = g._stacks || (g._stacks = {});
    f = S[u] = JH(n, c, m), f[s] = b, f._top = _T(f, a, !0, r.type), f._bottom = _T(f, a, !1, r.type);
    const R = f._visualValues || (f._visualValues = {});
    R[s] = b;
  }
}
function vw(o, t) {
  const e = o.scales;
  return Object.keys(e).filter((r) => e[r].axis === t).shift();
}
function eB(o, t) {
  return Wl(o, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function tB(o, t, e) {
  return Wl(o, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function gf(o, t) {
  const e = o.controller.index, r = o.vScale && o.vScale.axis;
  if (r) {
    t = t || o._parsed;
    for (const n of t) {
      const i = n._stacks;
      if (!i || i[r] === void 0 || i[r][e] === void 0)
        return;
      delete i[r][e], i[r]._visualValues !== void 0 && i[r]._visualValues[e] !== void 0 && delete i[r]._visualValues[e];
    }
  }
}
const gw = (o) => o === "reset" || o === "none", RT = (o, t) => t ? o : Object.assign({}, o), rB = (o, t, e) => o && !t.hidden && t._stacked && {
  keys: vF(e, !0),
  values: null
};
class ta {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = ET(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && gf(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, r = this.getDataset(), n = (d, f, v, g) => d === "x" ? f : d === "r" ? g : v, i = e.xAxisID = xt(r.xAxisID, vw(t, "x")), a = e.yAxisID = xt(r.yAxisID, vw(t, "y")), s = e.rAxisID = xt(r.rAxisID, vw(t, "r")), l = e.indexAxis, u = e.iAxisID = n(l, i, a, s), c = e.vAxisID = n(l, a, i, s);
    e.xScale = this.getScaleForId(i), e.yScale = this.getScaleForId(a), e.rScale = this.getScaleForId(s), e.iScale = this.getScaleForId(u), e.vScale = this.getScaleForId(c);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && sT(this._data, this), t._stacked && gf(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), r = this._data;
    if (Ht(e))
      this._data = XH(e);
    else if (r !== e) {
      if (r) {
        sT(r, this);
        const n = this._cachedMeta;
        gf(n), n._parsed = [];
      }
      e && Object.isExtensible(e) && B7(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, r = this.getDataset();
    let n = !1;
    this._dataCheck();
    const i = e._stacked;
    e._stacked = ET(e.vScale, e), e.stack !== r.stack && (n = !0, gf(e), e.stack = r.stack), this._resyncElements(t), (n || i !== e._stacked) && xT(this, e._parsed);
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: r, _data: n } = this, { iScale: i, _stacked: a } = r, s = i.axis;
    let l = t === 0 && e === n.length ? !0 : r._sorted, u = t > 0 && r._parsed[t - 1], c, d, f;
    if (this._parsing === !1)
      r._parsed = n, r._sorted = !0, f = n;
    else {
      Lr(n[t]) ? f = this.parseArrayData(r, n, t, e) : Ht(n[t]) ? f = this.parseObjectData(r, n, t, e) : f = this.parsePrimitiveData(r, n, t, e);
      const v = () => d[s] === null || u && d[s] < u[s];
      for (c = 0; c < e; ++c)
        r._parsed[c + t] = d = f[c], l && (v() && (l = !1), u = d);
      r._sorted = l;
    }
    a && xT(this, f);
  }
  parsePrimitiveData(t, e, r, n) {
    const { iScale: i, vScale: a } = t, s = i.axis, l = a.axis, u = i.getLabels(), c = i === a, d = new Array(n);
    let f, v, g;
    for (f = 0, v = n; f < v; ++f)
      g = f + r, d[f] = {
        [s]: c || i.parse(u[g], g),
        [l]: a.parse(e[g], g)
      };
    return d;
  }
  parseArrayData(t, e, r, n) {
    const { xScale: i, yScale: a } = t, s = new Array(n);
    let l, u, c, d;
    for (l = 0, u = n; l < u; ++l)
      c = l + r, d = e[c], s[l] = {
        x: i.parse(d[0], c),
        y: a.parse(d[1], c)
      };
    return s;
  }
  parseObjectData(t, e, r, n) {
    const { xScale: i, yScale: a } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, u = new Array(n);
    let c, d, f, v;
    for (c = 0, d = n; c < d; ++c)
      f = c + r, v = e[f], u[c] = {
        x: i.parse(kl(v, s), f),
        y: a.parse(kl(v, l), f)
      };
    return u;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, r) {
    const n = this.chart, i = this._cachedMeta, a = e[t.axis], s = {
      keys: vF(n, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return ST(s, a, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, e, r, n) {
    const i = r[e.axis];
    let a = i === null ? NaN : i;
    const s = n && r._stacks[e.axis];
    n && s && (n.values = s, a = ST(n, i, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, e) {
    const r = this._cachedMeta, n = r._parsed, i = r._sorted && t === r.iScale, a = n.length, s = this._getOtherScale(t), l = rB(e, r, this.chart), u = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: c, max: d } = QH(s);
    let f, v;
    function g() {
      v = n[f];
      const m = v[s.axis];
      return !Zr(v[t.axis]) || c > m || d < m;
    }
    for (f = 0; f < a && !(!g() && (this.updateRangeFromParsed(u, t, v, l), i)); ++f)
      ;
    if (i) {
      for (f = a - 1; f >= 0; --f)
        if (!g()) {
          this.updateRangeFromParsed(u, t, v, l);
          break;
        }
    }
    return u;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, r = [];
    let n, i, a;
    for (n = 0, i = e.length; n < i; ++n)
      a = e[n][t.axis], Zr(a) && r.push(a);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, r = e.iScale, n = e.vScale, i = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: n ? "" + n.getLabelForValue(i[n.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = qH(xt(this.options.clip, KH(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, r = this._cachedMeta, n = r.data || [], i = e.chartArea, a = [], s = this._drawStart || 0, l = this._drawCount || n.length - s, u = this.options.drawActiveElementsOnTop;
    let c;
    for (r.dataset && r.dataset.draw(t, i, s, l), c = s; c < s + l; ++c) {
      const d = n[c];
      d.hidden || (d.active && u ? a.push(d) : d.draw(t, i));
    }
    for (c = 0; c < a.length; ++c)
      a[c].draw(t, i);
  }
  getStyle(t, e) {
    const r = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, e, r) {
    const n = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      i = a.$context || (a.$context = tB(this.getContext(), t, a)), i.parsed = this.getParsed(t), i.raw = n.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = eB(this.chart.getContext(), this.index)), i.dataset = n, i.index = i.datasetIndex = this.index;
    return i.active = !!e, i.mode = r, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", r) {
    const n = e === "active", i = this._cachedDataOpts, a = t + "-" + e, s = i[a], l = this.enableOptionSharing && Vh(r);
    if (s)
      return RT(s, l);
    const u = this.chart.config, c = u.datasetElementScopeKeys(this._type, t), d = n ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = u.getOptionScopes(this.getDataset(), c), v = Object.keys(Yr.elements[t]), g = () => this.getContext(r, n, e), m = u.resolveNamedOptions(f, v, g, d);
    return m.$shared && (m.$shared = l, i[a] = Object.freeze(RT(m, l))), m;
  }
  _resolveAnimations(t, e, r) {
    const n = this.chart, i = this._cachedDataOpts, a = `animation-${e}`, s = i[a];
    if (s)
      return s;
    let l;
    if (n.options.animation !== !1) {
      const c = this.chart.config, d = c.datasetAnimationScopeKeys(this._type, e), f = c.getOptionScopes(this.getDataset(), d);
      l = c.createResolver(f, this.getContext(t, r, e));
    }
    const u = new hF(n, l && l.animations);
    return l && l._cacheable && (i[a] = Object.freeze(u)), u;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || gw(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const r = this.resolveDataElementOptions(t, e), n = this._sharedOptions, i = this.getSharedOptions(r), a = this.includeOptions(e, i) || i !== n;
    return this.updateSharedOptions(i, e, r), {
      sharedOptions: i,
      includeOptions: a
    };
  }
  updateElement(t, e, r, n) {
    gw(n) ? Object.assign(t, r) : this._resolveAnimations(e, n).update(t, r);
  }
  updateSharedOptions(t, e, r) {
    t && !gw(e) && this._resolveAnimations(void 0, e).update(t, r);
  }
  _setStyle(t, e, r, n) {
    t.active = n;
    const i = this.getStyle(e, n);
    this._resolveAnimations(e, r, n).update(t, {
      options: !n && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, e, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, e, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, r = this._cachedMeta.data;
    for (const [s, l, u] of this._syncList)
      this[s](l, u);
    this._syncList = [];
    const n = r.length, i = e.length, a = Math.min(i, n);
    a && this.parse(0, a), i > n ? this._insertElements(n, i - n, t) : i < n && this._removeElements(i, n - i);
  }
  _insertElements(t, e, r = !0) {
    const n = this._cachedMeta, i = n.data, a = t + e;
    let s;
    const l = (u) => {
      for (u.length += e, s = u.length - 1; s >= a; s--)
        u[s] = u[s - e];
    };
    for (l(i), s = t; s < a; ++s)
      i[s] = new this.dataElementType();
    this._parsing && l(n._parsed), this.parse(t, e), r && this.updateElements(i, t, e, "reset");
  }
  updateElements(t, e, r, n) {
  }
  _removeElements(t, e) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const n = r._parsed.splice(t, e);
      r._stacked && gf(r, n);
    }
    r.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, r, n] = t;
      this[e](r, n);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
We(ta, "defaults", {}), We(ta, "datasetElementType", null), We(ta, "dataElementType", null);
function nB(o, t) {
  if (!o._cache.$bar) {
    const e = o.getMatchingVisibleMetas(t);
    let r = [];
    for (let n = 0, i = e.length; n < i; n++)
      r = r.concat(e[n].controller.getAllParsedValues(o));
    o._cache.$bar = KM(r.sort((n, i) => n - i));
  }
  return o._cache.$bar;
}
function oB(o) {
  const t = o.iScale, e = nB(t, o.type);
  let r = t._length, n, i, a, s;
  const l = () => {
    a === 32767 || a === -32768 || (Vh(s) && (r = Math.min(r, Math.abs(a - s) || r)), s = a);
  };
  for (n = 0, i = e.length; n < i; ++n)
    a = t.getPixelForValue(e[n]), l();
  for (s = void 0, n = 0, i = t.ticks.length; n < i; ++n)
    a = t.getPixelForTick(n), l();
  return r;
}
function iB(o, t, e, r) {
  const n = e.barThickness;
  let i, a;
  return Nt(n) ? (i = t.min * e.categoryPercentage, a = e.barPercentage) : (i = n * r, a = 1), {
    chunk: i / r,
    ratio: a,
    start: t.pixels[o] - i / 2
  };
}
function aB(o, t, e, r) {
  const n = t.pixels, i = n[o];
  let a = o > 0 ? n[o - 1] : null, s = o < n.length - 1 ? n[o + 1] : null;
  const l = e.categoryPercentage;
  a === null && (a = i - (s === null ? t.end - t.start : s - i)), s === null && (s = i + i - a);
  const u = i - (i - Math.min(a, s)) / 2 * l;
  return {
    chunk: Math.abs(s - a) / 2 * l / r,
    ratio: e.barPercentage,
    start: u
  };
}
function sB(o, t, e, r) {
  const n = e.parse(o[0], r), i = e.parse(o[1], r), a = Math.min(n, i), s = Math.max(n, i);
  let l = a, u = s;
  Math.abs(a) > Math.abs(s) && (l = s, u = a), t[e.axis] = u, t._custom = {
    barStart: l,
    barEnd: u,
    start: n,
    end: i,
    min: a,
    max: s
  };
}
function gF(o, t, e, r) {
  return Lr(o) ? sB(o, t, e, r) : t[e.axis] = e.parse(o, r), t;
}
function TT(o, t, e, r) {
  const n = o.iScale, i = o.vScale, a = n.getLabels(), s = n === i, l = [];
  let u, c, d, f;
  for (u = e, c = e + r; u < c; ++u)
    f = t[u], d = {}, d[n.axis] = s || n.parse(a[u], u), l.push(gF(f, d, i, u));
  return l;
}
function mw(o) {
  return o && o.barStart !== void 0 && o.barEnd !== void 0;
}
function lB(o, t, e) {
  return o !== 0 ? Fa(o) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function uB(o) {
  let t, e, r, n, i;
  return o.horizontal ? (t = o.base > o.x, e = "left", r = "right") : (t = o.base < o.y, e = "bottom", r = "top"), t ? (n = "end", i = "start") : (n = "start", i = "end"), {
    start: e,
    end: r,
    reverse: t,
    top: n,
    bottom: i
  };
}
function cB(o, t, e, r) {
  let n = t.borderSkipped;
  const i = {};
  if (!n) {
    o.borderSkipped = i;
    return;
  }
  if (n === !0) {
    o.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: s, reverse: l, top: u, bottom: c } = uB(o);
  n === "middle" && e && (o.enableBorderRadius = !0, (e._top || 0) === r ? n = u : (e._bottom || 0) === r ? n = c : (i[OT(c, a, s, l)] = !0, n = u)), i[OT(n, a, s, l)] = !0, o.borderSkipped = i;
}
function OT(o, t, e, r) {
  return r ? (o = dB(o, t, e), o = PT(o, e, t)) : o = PT(o, t, e), o;
}
function dB(o, t, e) {
  return o === t ? e : o === e ? t : o;
}
function PT(o, t, e) {
  return o === "start" ? t : o === "end" ? e : o;
}
function pB(o, { inflateAmount: t }, e) {
  o.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class fm extends ta {
  parsePrimitiveData(t, e, r, n) {
    return TT(t, e, r, n);
  }
  parseArrayData(t, e, r, n) {
    return TT(t, e, r, n);
  }
  parseObjectData(t, e, r, n) {
    const { iScale: i, vScale: a } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, u = i.axis === "x" ? s : l, c = a.axis === "x" ? s : l, d = [];
    let f, v, g, m;
    for (f = r, v = r + n; f < v; ++f)
      m = e[f], g = {}, g[i.axis] = i.parse(kl(m, u), f), d.push(gF(kl(m, c), g, a, f));
    return d;
  }
  updateRangeFromParsed(t, e, r, n) {
    super.updateRangeFromParsed(t, e, r, n);
    const i = r._custom;
    i && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: r, vScale: n } = e, i = this.getParsed(t), a = i._custom, s = mw(a) ? "[" + a.start + ", " + a.end + "]" : "" + n.getLabelForValue(i[n.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: s
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", { index: a, _cachedMeta: { vScale: s } } = this, l = s.getBasePixel(), u = s.isHorizontal(), c = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(e, n);
    for (let v = e; v < e + r; v++) {
      const g = this.getParsed(v), m = i || Nt(g[s.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(v), b = this._calculateBarIndexPixels(v, c), S = (g._stacks || {})[s.axis], R = {
        horizontal: u,
        base: m.base,
        enableBorderRadius: !S || mw(g._custom) || a === S._top || a === S._bottom,
        x: u ? m.head : b.center,
        y: u ? b.center : m.head,
        height: u ? b.size : Math.abs(m.size),
        width: u ? Math.abs(m.size) : b.size
      };
      f && (R.options = d || this.resolveDataElementOptions(v, t[v].active ? "active" : n));
      const P = R.options || t[v].options;
      cB(R, P, S, a), pB(R, P, c.ratio), this.updateElement(t[v], v, R, n);
    }
  }
  _getStacks(t, e) {
    const { iScale: r } = this._cachedMeta, n = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), i = r.options.stacked, a = [], s = (l) => {
      const u = l.controller.getParsed(e), c = u && u[l.vScale.axis];
      if (Nt(c) || isNaN(c))
        return !0;
    };
    for (const l of n)
      if (!(e !== void 0 && s(l)) && ((i === !1 || a.indexOf(l.stack) === -1 || i === void 0 && l.stack === void 0) && a.push(l.stack), l.index === t))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, r) {
    const n = this._getStacks(t, r), i = e !== void 0 ? n.indexOf(e) : -1;
    return i === -1 ? n.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, r = e.iScale, n = [];
    let i, a;
    for (i = 0, a = e.data.length; i < a; ++i)
      n.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const s = t.barThickness;
    return {
      min: s || oB(e),
      pixels: n,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: s ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: r, index: n }, options: { base: i, minBarLength: a } } = this, s = i || 0, l = this.getParsed(t), u = l._custom, c = mw(u);
    let d = l[e.axis], f = 0, v = r ? this.applyStack(e, l, r) : d, g, m;
    v !== d && (f = v - d, v = d), c && (d = u.barStart, v = u.barEnd - u.barStart, d !== 0 && Fa(d) !== Fa(u.barEnd) && (f = 0), f += d);
    const b = !Nt(i) && !c ? i : f;
    let S = e.getPixelForValue(b);
    if (this.chart.getDataVisibility(t) ? g = e.getPixelForValue(f + v) : g = S, m = g - S, Math.abs(m) < a) {
      m = lB(m, e, s) * a, d === s && (S -= m / 2);
      const R = e.getPixelForDecimal(0), P = e.getPixelForDecimal(1), D = Math.min(R, P), x = Math.max(R, P);
      S = Math.max(Math.min(S, x), D), g = S + m, r && !c && (l._stacks[e.axis]._visualValues[n] = e.getValueForPixel(g) - e.getValueForPixel(S));
    }
    if (S === e.getPixelForValue(s)) {
      const R = Fa(m) * e.getLineWidthForValue(s) / 2;
      S += R, m -= R;
    }
    return {
      size: m,
      base: S,
      head: g,
      center: g + m / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const r = e.scale, n = this.options, i = n.skipNull, a = xt(n.maxBarThickness, 1 / 0);
    let s, l;
    if (e.grouped) {
      const u = i ? this._getStackCount(t) : e.stackCount, c = n.barThickness === "flex" ? aB(t, e, n, u) : iB(t, e, n, u), d = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0);
      s = c.start + c.chunk * d + c.chunk / 2, l = Math.min(a, c.chunk * c.ratio);
    } else
      s = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(a, e.min * e.ratio);
    return {
      base: s - l / 2,
      head: s + l / 2,
      center: s,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, r = t.data, n = r.length;
    let i = 0;
    for (; i < n; ++i)
      this.getParsed(i)[e.axis] !== null && r[i].draw(this._ctx);
  }
}
We(fm, "id", "bar"), We(fm, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), We(fm, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class hm extends ta {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, r, n) {
    const i = super.parsePrimitiveData(t, e, r, n);
    for (let a = 0; a < i.length; a++)
      i[a]._custom = this.resolveDataElementOptions(a + r).radius;
    return i;
  }
  parseArrayData(t, e, r, n) {
    const i = super.parseArrayData(t, e, r, n);
    for (let a = 0; a < i.length; a++) {
      const s = e[r + a];
      i[a]._custom = xt(s[2], this.resolveDataElementOptions(a + r).radius);
    }
    return i;
  }
  parseObjectData(t, e, r, n) {
    const i = super.parseObjectData(t, e, r, n);
    for (let a = 0; a < i.length; a++) {
      const s = e[r + a];
      i[a]._custom = xt(s && s.r && +s.r, this.resolveDataElementOptions(a + r).radius);
    }
    return i;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let r = t.length - 1; r >= 0; --r)
      e = Math.max(e, t[r].size(this.resolveDataElementOptions(r)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, r = this.chart.data.labels || [], { xScale: n, yScale: i } = e, a = this.getParsed(t), s = n.getLabelForValue(a.x), l = i.getLabelForValue(a.y), u = a._custom;
    return {
      label: r[t] || "",
      value: "(" + s + ", " + l + (u ? ", " + u : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", { iScale: a, vScale: s } = this._cachedMeta, { sharedOptions: l, includeOptions: u } = this._getSharedOptions(e, n), c = a.axis, d = s.axis;
    for (let f = e; f < e + r; f++) {
      const v = t[f], g = !i && this.getParsed(f), m = {}, b = m[c] = i ? a.getPixelForDecimal(0.5) : a.getPixelForValue(g[c]), S = m[d] = i ? s.getBasePixel() : s.getPixelForValue(g[d]);
      m.skip = isNaN(b) || isNaN(S), u && (m.options = l || this.resolveDataElementOptions(f, v.active ? "active" : n), i && (m.options.radius = 0)), this.updateElement(v, f, m, n);
    }
  }
  resolveDataElementOptions(t, e) {
    const r = this.getParsed(t);
    let n = super.resolveDataElementOptions(t, e);
    n.$shared && (n = Object.assign({}, n, {
      $shared: !1
    }));
    const i = n.radius;
    return e !== "active" && (n.radius = 0), n.radius += xt(r && r._custom, i), n;
  }
}
We(hm, "id", "bubble"), We(hm, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), We(hm, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function fB(o, t, e) {
  let r = 1, n = 1, i = 0, a = 0;
  if (t < Nr) {
    const s = o, l = s + t, u = Math.cos(s), c = Math.sin(s), d = Math.cos(l), f = Math.sin(l), v = (P, D, x) => Hh(P, s, l, !0) ? 1 : Math.max(D, D * e, x, x * e), g = (P, D, x) => Hh(P, s, l, !0) ? -1 : Math.min(D, D * e, x, x * e), m = v(0, u, d), b = v(an, c, f), S = g(kr, u, d), R = g(kr + an, c, f);
    r = (m - S) / 2, n = (b - R) / 2, i = -(m + S) / 2, a = -(b + R) / 2;
  }
  return {
    ratioX: r,
    ratioY: n,
    offsetX: i,
    offsetY: a
  };
}
class Qu extends ta {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const r = this.getDataset().data, n = this._cachedMeta;
    if (this._parsing === !1)
      n._parsed = r;
    else {
      let i = (l) => +r[l];
      if (Ht(r[t])) {
        const { key: l = "value" } = this._parsing;
        i = (u) => +kl(r[u], l);
      }
      let a, s;
      for (a = t, s = t + e; a < s; ++a)
        n._parsed[a] = i(a);
    }
  }
  _getRotation() {
    return Qi(this.options.rotation - 90);
  }
  _getCircumference() {
    return Qi(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Nr, e = -Nr;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const n = this.chart.getDatasetMeta(r).controller, i = n._getRotation(), a = n._getCircumference();
        t = Math.min(t, i), e = Math.max(e, i + a);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: r } = e, n = this._cachedMeta, i = n.data, a = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, s = Math.max((Math.min(r.width, r.height) - a) / 2, 0), l = Math.min(T7(this.options.cutout, s), 1), u = this._getRingWeight(this.index), { circumference: c, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: v, offsetX: g, offsetY: m } = fB(d, c, l), b = (r.width - a) / f, S = (r.height - a) / v, R = Math.max(Math.min(b, S) / 2, 0), P = jM(this.options.radius, R), D = Math.max(P * l, 0), x = (P - D) / this._getVisibleDatasetWeightTotal();
    this.offsetX = g * P, this.offsetY = m * P, n.total = this.calculateTotal(), this.outerRadius = P - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * u, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, e) {
    const r = this.options, n = this._cachedMeta, i = this._getCircumference();
    return e && r.animation.animateRotate || !this.chart.getDataVisibility(t) || n._parsed[t] === null || n.data[t].hidden ? 0 : this.calculateCircumference(n._parsed[t] * i / Nr);
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", a = this.chart, s = a.chartArea, u = a.options.animation, c = (s.left + s.right) / 2, d = (s.top + s.bottom) / 2, f = i && u.animateScale, v = f ? 0 : this.innerRadius, g = f ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: b } = this._getSharedOptions(e, n);
    let S = this._getRotation(), R;
    for (R = 0; R < e; ++R)
      S += this._circumference(R, i);
    for (R = e; R < e + r; ++R) {
      const P = this._circumference(R, i), D = t[R], x = {
        x: c + this.offsetX,
        y: d + this.offsetY,
        startAngle: S,
        endAngle: S + P,
        circumference: P,
        outerRadius: g,
        innerRadius: v
      };
      b && (x.options = m || this.resolveDataElementOptions(R, D.active ? "active" : n)), S += P, this.updateElement(D, R, x, n);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let r = 0, n;
    for (n = 0; n < e.length; n++) {
      const i = t._parsed[n];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(n) && !e[n].hidden && (r += Math.abs(i));
    }
    return r;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? Nr * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, r = this.chart, n = r.data.labels || [], i = sv(e._parsed[t], r.options.locale);
    return {
      label: n[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const r = this.chart;
    let n, i, a, s, l;
    if (!t) {
      for (n = 0, i = r.data.datasets.length; n < i; ++n)
        if (r.isDatasetVisible(n)) {
          a = r.getDatasetMeta(n), t = a.data, s = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (n = 0, i = t.length; n < i; ++n)
      l = s.resolveDataElementOptions(n), l.borderAlign !== "inner" && (e = Math.max(e, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let r = 0, n = t.length; r < n; ++r) {
      const i = this.resolveDataElementOptions(r);
      e = Math.max(e, i.offset || 0, i.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (e += this._getRingWeight(r));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(xt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
We(Qu, "id", "doughnut"), We(Qu, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), We(Qu, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), We(Qu, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: r, color: n } } = t.legend.options;
            return e.labels.map((i, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: n,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, r) {
        r.chart.toggleDataVisibility(e.index), r.chart.update();
      }
    }
  }
});
class vm extends ta {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: r, data: n = [], _dataset: i } = e, a = this.chart._animationsDisabled;
    let { start: s, count: l } = ZM(e, n, a);
    this._drawStart = s, this._drawCount = l, QM(e) && (s = 0, l = n.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = n;
    const u = this.resolveDatasetElementOptions(t);
    this.options.showLine || (u.borderWidth = 0), u.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !a,
      options: u
    }, t), this.updateElements(n, s, l, t);
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", { iScale: a, vScale: s, _stacked: l, _dataset: u } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(e, n), f = a.axis, v = s.axis, { spanGaps: g, segment: m } = this.options, b = op(g) ? g : Number.POSITIVE_INFINITY, S = this.chart._animationsDisabled || i || n === "none", R = e + r, P = t.length;
    let D = e > 0 && this.getParsed(e - 1);
    for (let x = 0; x < P; ++x) {
      const M = t[x], F = S ? M : {};
      if (x < e || x >= R) {
        F.skip = !0;
        continue;
      }
      const H = this.getParsed(x), B = Nt(H[v]), j = F[f] = a.getPixelForValue(H[f], x), V = F[v] = i || B ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, H, l) : H[v], x);
      F.skip = isNaN(j) || isNaN(V) || B, F.stop = x > 0 && Math.abs(H[f] - D[f]) > b, m && (F.parsed = H, F.raw = u.data[x]), d && (F.options = c || this.resolveDataElementOptions(x, M.active ? "active" : n)), S || this.updateElement(M, x, F, n), D = H;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, r = e.options && e.options.borderWidth || 0, n = t.data || [];
    if (!n.length)
      return r;
    const i = n[0].size(this.resolveDataElementOptions(0)), a = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(r, i, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
We(vm, "id", "line"), We(vm, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), We(vm, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class Sh extends ta {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, r = this.chart, n = r.data.labels || [], i = sv(e._parsed[t].r, r.options.locale);
    return {
      label: n[t] || "",
      value: i
    };
  }
  parseObjectData(t, e, r, n) {
    return aF.bind(this)(t, e, r, n);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((r, n) => {
      const i = this.getParsed(n).r;
      !isNaN(i) && this.chart.getDataVisibility(n) && (i < e.min && (e.min = i), i > e.max && (e.max = i));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, r = t.options, n = Math.min(e.right - e.left, e.bottom - e.top), i = Math.max(n / 2, 0), a = Math.max(r.cutoutPercentage ? i / 100 * r.cutoutPercentage : 1, 0), s = (i - a) / t.getVisibleDatasetCount();
    this.outerRadius = i - s * this.index, this.innerRadius = this.outerRadius - s;
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", a = this.chart, l = a.options.animation, u = this._cachedMeta.rScale, c = u.xCenter, d = u.yCenter, f = u.getIndexAngle(0) - 0.5 * kr;
    let v = f, g;
    const m = 360 / this.countVisibleElements();
    for (g = 0; g < e; ++g)
      v += this._computeAngle(g, n, m);
    for (g = e; g < e + r; g++) {
      const b = t[g];
      let S = v, R = v + this._computeAngle(g, n, m), P = a.getDataVisibility(g) ? u.getDistanceFromCenterForValue(this.getParsed(g).r) : 0;
      v = R, i && (l.animateScale && (P = 0), l.animateRotate && (S = R = f));
      const D = {
        x: c,
        y: d,
        innerRadius: 0,
        outerRadius: P,
        startAngle: S,
        endAngle: R,
        options: this.resolveDataElementOptions(g, b.active ? "active" : n)
      };
      this.updateElement(b, g, D, n);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((r, n) => {
      !isNaN(this.getParsed(n).r) && this.chart.getDataVisibility(n) && e++;
    }), e;
  }
  _computeAngle(t, e, r) {
    return this.chart.getDataVisibility(t) ? Qi(this.resolveDataElementOptions(t, e).angle || r) : 0;
  }
}
We(Sh, "id", "polarArea"), We(Sh, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), We(Sh, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: r, color: n } } = t.legend.options;
            return e.labels.map((i, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: n,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, r) {
        r.chart.toggleDataVisibility(e.index), r.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class hS extends Qu {
}
We(hS, "id", "pie"), We(hS, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class gm extends ta {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, r = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(r[e.axis])
    };
  }
  parseObjectData(t, e, r, n) {
    return aF.bind(this)(t, e, r, n);
  }
  update(t) {
    const e = this._cachedMeta, r = e.dataset, n = e.data || [], i = e.iScale.getLabels();
    if (r.points = n, t !== "resize") {
      const a = this.resolveDatasetElementOptions(t);
      this.options.showLine || (a.borderWidth = 0);
      const s = {
        _loop: !0,
        _fullLoop: i.length === n.length,
        options: a
      };
      this.updateElement(r, void 0, s, t);
    }
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, e, r, n) {
    const i = this._cachedMeta.rScale, a = n === "reset";
    for (let s = e; s < e + r; s++) {
      const l = t[s], u = this.resolveDataElementOptions(s, l.active ? "active" : n), c = i.getPointPositionForValue(s, this.getParsed(s).r), d = a ? i.xCenter : c.x, f = a ? i.yCenter : c.y, v = {
        x: d,
        y: f,
        angle: c.angle,
        skip: isNaN(d) || isNaN(f),
        options: u
      };
      this.updateElement(l, s, v, n);
    }
  }
}
We(gm, "id", "radar"), We(gm, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), We(gm, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class mm extends ta {
  getLabelAndValue(t) {
    const e = this._cachedMeta, r = this.chart.data.labels || [], { xScale: n, yScale: i } = e, a = this.getParsed(t), s = n.getLabelForValue(a.x), l = i.getLabelForValue(a.y);
    return {
      label: r[t] || "",
      value: "(" + s + ", " + l + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta, { data: r = [] } = e, n = this.chart._animationsDisabled;
    let { start: i, count: a } = ZM(e, r, n);
    if (this._drawStart = i, this._drawCount = a, QM(e) && (i = 0, a = r.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: s, _dataset: l } = e;
      s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!l._decimated, s.points = r;
      const u = this.resolveDatasetElementOptions(t);
      u.segment = this.options.segment, this.updateElement(s, void 0, {
        animated: !n,
        options: u
      }, t);
    } else this.datasetElementType && (delete e.dataset, this.datasetElementType = !1);
    this.updateElements(r, i, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, e, r, n) {
    const i = n === "reset", { iScale: a, vScale: s, _stacked: l, _dataset: u } = this._cachedMeta, c = this.resolveDataElementOptions(e, n), d = this.getSharedOptions(c), f = this.includeOptions(n, d), v = a.axis, g = s.axis, { spanGaps: m, segment: b } = this.options, S = op(m) ? m : Number.POSITIVE_INFINITY, R = this.chart._animationsDisabled || i || n === "none";
    let P = e > 0 && this.getParsed(e - 1);
    for (let D = e; D < e + r; ++D) {
      const x = t[D], M = this.getParsed(D), F = R ? x : {}, H = Nt(M[g]), B = F[v] = a.getPixelForValue(M[v], D), j = F[g] = i || H ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, M, l) : M[g], D);
      F.skip = isNaN(B) || isNaN(j) || H, F.stop = D > 0 && Math.abs(M[v] - P[v]) > S, b && (F.parsed = M, F.raw = u.data[D]), f && (F.options = d || this.resolveDataElementOptions(D, x.active ? "active" : n)), R || this.updateElement(x, D, F, n), P = M;
    }
    this.updateSharedOptions(d, n, c);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let s = 0;
      for (let l = e.length - 1; l >= 0; --l)
        s = Math.max(s, e[l].size(this.resolveDataElementOptions(l)) / 2);
      return s > 0 && s;
    }
    const r = t.dataset, n = r.options && r.options.borderWidth || 0;
    if (!e.length)
      return n;
    const i = e[0].size(this.resolveDataElementOptions(0)), a = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(n, i, a) / 2;
  }
}
We(mm, "id", "scatter"), We(mm, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), We(mm, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var hB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: fm,
  BubbleController: hm,
  DoughnutController: Qu,
  LineController: vm,
  PieController: hS,
  PolarAreaController: Sh,
  RadarController: gm,
  ScatterController: mm
});
function Au() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class m1 {
  constructor(t) {
    We(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(m1.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Au();
  }
  parse() {
    return Au();
  }
  format() {
    return Au();
  }
  add() {
    return Au();
  }
  diff() {
    return Au();
  }
  startOf() {
    return Au();
  }
  endOf() {
    return Au();
  }
}
var vB = {
  _date: m1
};
function gB(o, t, e, r) {
  const { controller: n, data: i, _sorted: a } = o, s = n._cachedMeta.iScale;
  if (s && t === s.axis && t !== "r" && a && i.length) {
    const l = s._reversePixels ? V7 : ms;
    if (r) {
      if (n._sharedOptions) {
        const u = i[0], c = typeof u.getRange == "function" && u.getRange(t);
        if (c) {
          const d = l(i, t, e - c), f = l(i, t, e + c);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else return l(i, t, e);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function lv(o, t, e, r, n) {
  const i = o.getSortedVisibleDatasetMetas(), a = e[t];
  for (let s = 0, l = i.length; s < l; ++s) {
    const { index: u, data: c } = i[s], { lo: d, hi: f } = gB(i[s], t, a, n);
    for (let v = d; v <= f; ++v) {
      const g = c[v];
      g.skip || r(g, u, v);
    }
  }
}
function mB(o) {
  const t = o.indexOf("x") !== -1, e = o.indexOf("y") !== -1;
  return function(r, n) {
    const i = t ? Math.abs(r.x - n.x) : 0, a = e ? Math.abs(r.y - n.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(a, 2));
  };
}
function yw(o, t, e, r, n) {
  const i = [];
  return !n && !o.isPointInArea(t) || lv(o, e, t, function(s, l, u) {
    !n && !ys(s, o.chartArea, 0) || s.inRange(t.x, t.y, r) && i.push({
      element: s,
      datasetIndex: l,
      index: u
    });
  }, !0), i;
}
function yB(o, t, e, r) {
  let n = [];
  function i(a, s, l) {
    const { startAngle: u, endAngle: c } = a.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = zM(a, {
      x: t.x,
      y: t.y
    });
    Hh(d, u, c) && n.push({
      element: a,
      datasetIndex: s,
      index: l
    });
  }
  return lv(o, e, t, i), n;
}
function CB(o, t, e, r, n, i) {
  let a = [];
  const s = mB(e);
  let l = Number.POSITIVE_INFINITY;
  function u(c, d, f) {
    const v = c.inRange(t.x, t.y, n);
    if (r && !v)
      return;
    const g = c.getCenterPoint(n);
    if (!(!!i || o.isPointInArea(g)) && !v)
      return;
    const b = s(t, g);
    b < l ? (a = [
      {
        element: c,
        datasetIndex: d,
        index: f
      }
    ], l = b) : b === l && a.push({
      element: c,
      datasetIndex: d,
      index: f
    });
  }
  return lv(o, e, t, u), a;
}
function Cw(o, t, e, r, n, i) {
  return !i && !o.isPointInArea(t) ? [] : e === "r" && !r ? yB(o, t, e, n) : CB(o, t, e, r, n, i);
}
function DT(o, t, e, r, n) {
  const i = [], a = e === "x" ? "inXRange" : "inYRange";
  let s = !1;
  return lv(o, e, t, (l, u, c) => {
    l[a](t[e], n) && (i.push({
      element: l,
      datasetIndex: u,
      index: c
    }), s = s || l.inRange(t.x, t.y, n));
  }), r && !s ? [] : i;
}
var wB = {
  evaluateInteractionItems: lv,
  modes: {
    index(o, t, e, r) {
      const n = $u(t, o), i = e.axis || "x", a = e.includeInvisible || !1, s = e.intersect ? yw(o, n, i, r, a) : Cw(o, n, i, !1, r, a), l = [];
      return s.length ? (o.getSortedVisibleDatasetMetas().forEach((u) => {
        const c = s[0].index, d = u.data[c];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: u.index,
          index: c
        });
      }), l) : [];
    },
    dataset(o, t, e, r) {
      const n = $u(t, o), i = e.axis || "xy", a = e.includeInvisible || !1;
      let s = e.intersect ? yw(o, n, i, r, a) : Cw(o, n, i, !1, r, a);
      if (s.length > 0) {
        const l = s[0].datasetIndex, u = o.getDatasetMeta(l).data;
        s = [];
        for (let c = 0; c < u.length; ++c)
          s.push({
            element: u[c],
            datasetIndex: l,
            index: c
          });
      }
      return s;
    },
    point(o, t, e, r) {
      const n = $u(t, o), i = e.axis || "xy", a = e.includeInvisible || !1;
      return yw(o, n, i, r, a);
    },
    nearest(o, t, e, r) {
      const n = $u(t, o), i = e.axis || "xy", a = e.includeInvisible || !1;
      return Cw(o, n, i, e.intersect, r, a);
    },
    x(o, t, e, r) {
      const n = $u(t, o);
      return DT(o, n, "x", e.intersect, r);
    },
    y(o, t, e, r) {
      const n = $u(t, o);
      return DT(o, n, "y", e.intersect, r);
    }
  }
};
const mF = [
  "left",
  "top",
  "right",
  "bottom"
];
function mf(o, t) {
  return o.filter((e) => e.pos === t);
}
function AT(o, t) {
  return o.filter((e) => mF.indexOf(e.pos) === -1 && e.box.axis === t);
}
function yf(o, t) {
  return o.sort((e, r) => {
    const n = t ? r : e, i = t ? e : r;
    return n.weight === i.weight ? n.index - i.index : n.weight - i.weight;
  });
}
function bB(o) {
  const t = [];
  let e, r, n, i, a, s;
  for (e = 0, r = (o || []).length; e < r; ++e)
    n = o[e], { position: i, options: { stack: a, stackWeight: s = 1 } } = n, t.push({
      index: e,
      box: n,
      pos: i,
      horizontal: n.isHorizontal(),
      weight: n.weight,
      stack: a && i + a,
      stackWeight: s
    });
  return t;
}
function SB(o) {
  const t = {};
  for (const e of o) {
    const { stack: r, pos: n, stackWeight: i } = e;
    if (!r || !mF.includes(n))
      continue;
    const a = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += i;
  }
  return t;
}
function EB(o, t) {
  const e = SB(o), { vBoxMaxWidth: r, hBoxMaxHeight: n } = t;
  let i, a, s;
  for (i = 0, a = o.length; i < a; ++i) {
    s = o[i];
    const { fullSize: l } = s.box, u = e[s.stack], c = u && s.stackWeight / u.weight;
    s.horizontal ? (s.width = c ? c * r : l && t.availableWidth, s.height = n) : (s.width = r, s.height = c ? c * n : l && t.availableHeight);
  }
  return e;
}
function _B(o) {
  const t = bB(o), e = yf(t.filter((u) => u.box.fullSize), !0), r = yf(mf(t, "left"), !0), n = yf(mf(t, "right")), i = yf(mf(t, "top"), !0), a = yf(mf(t, "bottom")), s = AT(t, "x"), l = AT(t, "y");
  return {
    fullSize: e,
    leftAndTop: r.concat(i),
    rightAndBottom: n.concat(l).concat(a).concat(s),
    chartArea: mf(t, "chartArea"),
    vertical: r.concat(n).concat(l),
    horizontal: i.concat(a).concat(s)
  };
}
function MT(o, t, e, r) {
  return Math.max(o[e], t[e]) + Math.max(o[r], t[r]);
}
function yF(o, t) {
  o.top = Math.max(o.top, t.top), o.left = Math.max(o.left, t.left), o.bottom = Math.max(o.bottom, t.bottom), o.right = Math.max(o.right, t.right);
}
function xB(o, t, e, r) {
  const { pos: n, box: i } = e, a = o.maxPadding;
  if (!Ht(n)) {
    e.size && (o[n] -= e.size);
    const d = r[e.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, e.horizontal ? i.height : i.width), e.size = d.size / d.count, o[n] += e.size;
  }
  i.getPadding && yF(a, i.getPadding());
  const s = Math.max(0, t.outerWidth - MT(a, o, "left", "right")), l = Math.max(0, t.outerHeight - MT(a, o, "top", "bottom")), u = s !== o.w, c = l !== o.h;
  return o.w = s, o.h = l, e.horizontal ? {
    same: u,
    other: c
  } : {
    same: c,
    other: u
  };
}
function RB(o) {
  const t = o.maxPadding;
  function e(r) {
    const n = Math.max(t[r] - o[r], 0);
    return o[r] += n, n;
  }
  o.y += e("top"), o.x += e("left"), e("right"), e("bottom");
}
function TB(o, t) {
  const e = t.maxPadding;
  function r(n) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return n.forEach((a) => {
      i[a] = Math.max(t[a], e[a]);
    }), i;
  }
  return r(o ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function sh(o, t, e, r) {
  const n = [];
  let i, a, s, l, u, c;
  for (i = 0, a = o.length, u = 0; i < a; ++i) {
    s = o[i], l = s.box, l.update(s.width || t.w, s.height || t.h, TB(s.horizontal, t));
    const { same: d, other: f } = xB(t, e, s, r);
    u |= d && n.length, c = c || f, l.fullSize || n.push(s);
  }
  return u && sh(n, t, e, r) || c;
}
function mg(o, t, e, r, n) {
  o.top = e, o.left = t, o.right = t + r, o.bottom = e + n, o.width = r, o.height = n;
}
function FT(o, t, e, r) {
  const n = e.padding;
  let { x: i, y: a } = t;
  for (const s of o) {
    const l = s.box, u = r[s.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, c = s.stackWeight / u.weight || 1;
    if (s.horizontal) {
      const d = t.w * c, f = u.size || l.height;
      Vh(u.start) && (a = u.start), l.fullSize ? mg(l, n.left, a, e.outerWidth - n.right - n.left, f) : mg(l, t.left + u.placed, a, d, f), u.start = a, u.placed += d, a = l.bottom;
    } else {
      const d = t.h * c, f = u.size || l.width;
      Vh(u.start) && (i = u.start), l.fullSize ? mg(l, i, n.top, f, e.outerHeight - n.bottom - n.top) : mg(l, i, t.top + u.placed, f, d), u.start = i, u.placed += d, i = l.right;
    }
  }
  t.x = i, t.y = a;
}
var Zn = {
  addBox(o, t) {
    o.boxes || (o.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, o.boxes.push(t);
  },
  removeBox(o, t) {
    const e = o.boxes ? o.boxes.indexOf(t) : -1;
    e !== -1 && o.boxes.splice(e, 1);
  },
  configure(o, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(o, t, e, r) {
    if (!o)
      return;
    const n = jn(o.options.layout.padding), i = Math.max(t - n.width, 0), a = Math.max(e - n.height, 0), s = _B(o.boxes), l = s.vertical, u = s.horizontal;
    ur(o.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const c = l.reduce((m, b) => b.box.options && b.box.options.display === !1 ? m : m + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: n,
      availableWidth: i,
      availableHeight: a,
      vBoxMaxWidth: i / 2 / c,
      hBoxMaxHeight: a / 2
    }), f = Object.assign({}, n);
    yF(f, jn(r));
    const v = Object.assign({
      maxPadding: f,
      w: i,
      h: a,
      x: n.left,
      y: n.top
    }, n), g = EB(l.concat(u), d);
    sh(s.fullSize, v, d, g), sh(l, v, d, g), sh(u, v, d, g) && sh(l, v, d, g), RB(v), FT(s.leftAndTop, v, d, g), v.x += v.w, v.y += v.h, FT(s.rightAndBottom, v, d, g), o.chartArea = {
      left: v.left,
      top: v.top,
      right: v.left + v.w,
      bottom: v.top + v.h,
      height: v.h,
      width: v.w
    }, ur(s.chartArea, (m) => {
      const b = m.box;
      Object.assign(b, o.chartArea), b.update(v.w, v.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class CF {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, r) {
  }
  removeEventListener(t, e, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, r, n) {
    return e = Math.max(0, e || t.width), r = r || t.height, {
      width: e,
      height: Math.max(0, n ? Math.floor(e / n) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class OB extends CF {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const ym = "$chartjs", PB = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, IT = (o) => o === null || o === "";
function DB(o, t) {
  const e = o.style, r = o.getAttribute("height"), n = o.getAttribute("width");
  if (o[ym] = {
    initial: {
      height: r,
      width: n,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", IT(n)) {
    const i = gT(o, "width");
    i !== void 0 && (o.width = i);
  }
  if (IT(r))
    if (o.style.height === "")
      o.height = o.width / (t || 2);
    else {
      const i = gT(o, "height");
      i !== void 0 && (o.height = i);
    }
  return o;
}
const wF = MH ? {
  passive: !0
} : !1;
function AB(o, t, e) {
  o.addEventListener(t, e, wF);
}
function MB(o, t, e) {
  o.canvas.removeEventListener(t, e, wF);
}
function FB(o, t) {
  const e = PB[o.type] || o.type, { x: r, y: n } = $u(o, t);
  return {
    type: e,
    chart: t,
    native: o,
    x: r !== void 0 ? r : null,
    y: n !== void 0 ? n : null
  };
}
function jm(o, t) {
  for (const e of o)
    if (e === t || e.contains(t))
      return !0;
}
function IB(o, t, e) {
  const r = o.canvas, n = new MutationObserver((i) => {
    let a = !1;
    for (const s of i)
      a = a || jm(s.addedNodes, r), a = a && !jm(s.removedNodes, r);
    a && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
function LB(o, t, e) {
  const r = o.canvas, n = new MutationObserver((i) => {
    let a = !1;
    for (const s of i)
      a = a || jm(s.removedNodes, r), a = a && !jm(s.addedNodes, r);
    a && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
const Wh = /* @__PURE__ */ new Map();
let LT = 0;
function bF() {
  const o = window.devicePixelRatio;
  o !== LT && (LT = o, Wh.forEach((t, e) => {
    e.currentDevicePixelRatio !== o && t();
  }));
}
function NB(o, t) {
  Wh.size || window.addEventListener("resize", bF), Wh.set(o, t);
}
function kB(o) {
  Wh.delete(o), Wh.size || window.removeEventListener("resize", bF);
}
function GB(o, t, e) {
  const r = o.canvas, n = r && g1(r);
  if (!n)
    return;
  const i = XM((s, l) => {
    const u = n.clientWidth;
    e(s, l), u < n.clientWidth && e();
  }, window), a = new ResizeObserver((s) => {
    const l = s[0], u = l.contentRect.width, c = l.contentRect.height;
    u === 0 && c === 0 || i(u, c);
  });
  return a.observe(n), NB(o, i), a;
}
function ww(o, t, e) {
  e && e.disconnect(), t === "resize" && kB(o);
}
function VB(o, t, e) {
  const r = o.canvas, n = XM((i) => {
    o.ctx !== null && e(FB(i, o));
  }, o);
  return AB(r, t, n), n;
}
class HB extends CF {
  acquireContext(t, e) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (DB(t, e), r) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[ym])
      return !1;
    const r = e[ym].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const a = r[i];
      Nt(a) ? e.removeAttribute(i) : e.setAttribute(i, a);
    });
    const n = r.style || {};
    return Object.keys(n).forEach((i) => {
      e.style[i] = n[i];
    }), e.width = e.width, delete e[ym], !0;
  }
  addEventListener(t, e, r) {
    this.removeEventListener(t, e);
    const n = t.$proxies || (t.$proxies = {}), a = {
      attach: IB,
      detach: LB,
      resize: GB
    }[e] || VB;
    n[e] = a(t, e, r);
  }
  removeEventListener(t, e) {
    const r = t.$proxies || (t.$proxies = {}), n = r[e];
    if (!n)
      return;
    ({
      attach: ww,
      detach: ww,
      resize: ww
    }[e] || MB)(t, e, n), r[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, r, n) {
    return AH(t, e, r, n);
  }
  isAttached(t) {
    const e = g1(t);
    return !!(e && e.isConnected);
  }
}
function BB(o) {
  return !lF() || typeof OffscreenCanvas < "u" && o instanceof OffscreenCanvas ? OB : HB;
}
var dm;
let Rs = (dm = class {
  constructor() {
    We(this, "x");
    We(this, "y");
    We(this, "active", !1);
    We(this, "options");
    We(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: e, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: r
    };
  }
  hasValue() {
    return op(this.x) && op(this.y);
  }
  getProps(t, e) {
    const r = this.$animations;
    if (!e || !r)
      return this;
    const n = {};
    return t.forEach((i) => {
      n[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), n;
  }
}, We(dm, "defaults", {}), We(dm, "defaultRoutes"), dm);
function WB(o, t) {
  const e = o.options.ticks, r = jB(o), n = Math.min(e.maxTicksLimit || r, r), i = e.major.enabled ? $B(t) : [], a = i.length, s = i[0], l = i[a - 1], u = [];
  if (a > n)
    return zB(t, u, i, a / n), u;
  const c = UB(i, t, n);
  if (a > 0) {
    let d, f;
    const v = a > 1 ? Math.round((l - s) / (a - 1)) : null;
    for (yg(t, u, c, Nt(v) ? 0 : s - v, s), d = 0, f = a - 1; d < f; d++)
      yg(t, u, c, i[d], i[d + 1]);
    return yg(t, u, c, l, Nt(v) ? t.length : l + v), u;
  }
  return yg(t, u, c), u;
}
function jB(o) {
  const t = o.options.offset, e = o._tickSize(), r = o._length / e + (t ? 0 : 1), n = o._maxLength / e;
  return Math.floor(Math.min(r, n));
}
function UB(o, t, e) {
  const r = YB(o), n = t.length / e;
  if (!r)
    return Math.max(n, 1);
  const i = L7(r);
  for (let a = 0, s = i.length - 1; a < s; a++) {
    const l = i[a];
    if (l > n)
      return l;
  }
  return Math.max(n, 1);
}
function $B(o) {
  const t = [];
  let e, r;
  for (e = 0, r = o.length; e < r; e++)
    o[e].major && t.push(e);
  return t;
}
function zB(o, t, e, r) {
  let n = 0, i = e[0], a;
  for (r = Math.ceil(r), a = 0; a < o.length; a++)
    a === i && (t.push(o[a]), n++, i = e[n * r]);
}
function yg(o, t, e, r, n) {
  const i = xt(r, 0), a = Math.min(xt(n, o.length), o.length);
  let s = 0, l, u, c;
  for (e = Math.ceil(e), n && (l = n - r, e = l / Math.floor(l / e)), c = i; c < 0; )
    s++, c = Math.round(i + s * e);
  for (u = Math.max(i, 0); u < a; u++)
    u === c && (t.push(o[u]), s++, c = Math.round(i + s * e));
}
function YB(o) {
  const t = o.length;
  let e, r;
  if (t < 2)
    return !1;
  for (r = o[0], e = 1; e < t; ++e)
    if (o[e] - o[e - 1] !== r)
      return !1;
  return r;
}
const KB = (o) => o === "left" ? "right" : o === "right" ? "left" : o, NT = (o, t, e) => t === "top" || t === "left" ? o[t] + e : o[t] - e, kT = (o, t) => Math.min(t || o, o);
function GT(o, t) {
  const e = [], r = o.length / t, n = o.length;
  let i = 0;
  for (; i < n; i += r)
    e.push(o[Math.floor(i)]);
  return e;
}
function qB(o, t, e) {
  const r = o.ticks.length, n = Math.min(t, r - 1), i = o._startPixel, a = o._endPixel, s = 1e-6;
  let l = o.getPixelForTick(n), u;
  if (!(e && (r === 1 ? u = Math.max(l - i, a - l) : t === 0 ? u = (o.getPixelForTick(1) - l) / 2 : u = (l - o.getPixelForTick(n - 1)) / 2, l += n < t ? u : -u, l < i - s || l > a + s)))
    return l;
}
function XB(o, t) {
  ur(o, (e) => {
    const r = e.gc, n = r.length / 2;
    let i;
    if (n > t) {
      for (i = 0; i < n; ++i)
        delete e.data[r[i]];
      r.splice(0, n);
    }
  });
}
function Cf(o) {
  return o.drawTicks ? o.tickLength : 0;
}
function VT(o, t) {
  if (!o.display)
    return 0;
  const e = hn(o.font, t), r = jn(o.padding);
  return (Lr(o.text) ? o.text.length : 1) * e.lineHeight + r.height;
}
function ZB(o, t) {
  return Wl(o, {
    scale: t,
    type: "scale"
  });
}
function QB(o, t, e) {
  return Wl(o, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function JB(o, t, e) {
  let r = c1(o);
  return (e && t !== "right" || !e && t === "right") && (r = KB(r)), r;
}
function eW(o, t, e, r) {
  const { top: n, left: i, bottom: a, right: s, chart: l } = o, { chartArea: u, scales: c } = l;
  let d = 0, f, v, g;
  const m = a - n, b = s - i;
  if (o.isHorizontal()) {
    if (v = qn(r, i, s), Ht(e)) {
      const S = Object.keys(e)[0], R = e[S];
      g = c[S].getPixelForValue(R) + m - t;
    } else e === "center" ? g = (u.bottom + u.top) / 2 + m - t : g = NT(o, e, t);
    f = s - i;
  } else {
    if (Ht(e)) {
      const S = Object.keys(e)[0], R = e[S];
      v = c[S].getPixelForValue(R) - b + t;
    } else e === "center" ? v = (u.left + u.right) / 2 - b + t : v = NT(o, e, t);
    g = qn(r, a, n), d = e === "left" ? -an : an;
  }
  return {
    titleX: v,
    titleY: g,
    maxWidth: f,
    rotation: d
  };
}
class Sc extends Rs {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: r, _suggestedMax: n } = this;
    return t = Jo(t, Number.POSITIVE_INFINITY), e = Jo(e, Number.NEGATIVE_INFINITY), r = Jo(r, Number.POSITIVE_INFINITY), n = Jo(n, Number.NEGATIVE_INFINITY), {
      min: Jo(t, r),
      max: Jo(e, n),
      minDefined: Zr(t),
      maxDefined: Zr(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: r, minDefined: n, maxDefined: i } = this.getUserBounds(), a;
    if (n && i)
      return {
        min: e,
        max: r
      };
    const s = this.getMatchingVisibleMetas();
    for (let l = 0, u = s.length; l < u; ++l)
      a = s[l].controller.getMinMax(this, t), n || (e = Math.min(e, a.min)), i || (r = Math.max(r, a.max));
    return e = i && e > r ? r : e, r = n && e > r ? e : r, {
      min: Jo(e, Jo(r, e)),
      max: Jo(r, Jo(e, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Tr(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, r) {
    const { beginAtZero: n, grace: i, ticks: a } = this.options, s = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = uH(this, i, n), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = s < this.ticks.length;
    this._convertTicksToLabels(l ? GT(this.ticks, s) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = WB(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, r;
    this.isHorizontal() ? (e = this.left, r = this.right) : (e = this.top, r = this.bottom, t = !t), this._startPixel = e, this._endPixel = r, this._reversePixels = t, this._length = r - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Tr(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Tr(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Tr(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Tr(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Tr(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let r, n, i;
    for (r = 0, n = t.length; r < n; r++)
      i = t[r], i.label = Tr(e.callback, [
        i.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Tr(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Tr(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, r = kT(this.ticks.length, t.ticks.maxTicksLimit), n = e.minRotation || 0, i = e.maxRotation;
    let a = n, s, l, u;
    if (!this._isVisible() || !e.display || n >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = n;
      return;
    }
    const c = this._getLabelSizes(), d = c.widest.width, f = c.highest.height, v = Pn(this.chart.width - d, 0, this.maxWidth);
    s = t.offset ? this.maxWidth / r : v / (r - 1), d + 6 > s && (s = v / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - Cf(t.grid) - e.padding - VT(t.title, this.chart.options.font), u = Math.sqrt(d * d + f * f), a = l1(Math.min(Math.asin(Pn((c.highest.height + 6) / s, -1, 1)), Math.asin(Pn(l / u, -1, 1)) - Math.asin(Pn(f / u, -1, 1)))), a = Math.max(n, Math.min(i, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    Tr(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Tr(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: r, title: n, grid: i } } = this, a = this._isVisible(), s = this.isHorizontal();
    if (a) {
      const l = VT(n, e.options.font);
      if (s ? (t.width = this.maxWidth, t.height = Cf(i) + l) : (t.height = this.maxHeight, t.width = Cf(i) + l), r.display && this.ticks.length) {
        const { first: u, last: c, widest: d, highest: f } = this._getLabelSizes(), v = r.padding * 2, g = Qi(this.labelRotation), m = Math.cos(g), b = Math.sin(g);
        if (s) {
          const S = r.mirror ? 0 : b * d.width + m * f.height;
          t.height = Math.min(this.maxHeight, t.height + S + v);
        } else {
          const S = r.mirror ? 0 : m * d.width + b * f.height;
          t.width = Math.min(this.maxWidth, t.width + S + v);
        }
        this._calculatePadding(u, c, b, m);
      }
    }
    this._handleMargins(), s ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, r, n) {
    const { ticks: { align: i, padding: a }, position: s } = this.options, l = this.labelRotation !== 0, u = s !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const c = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, v = 0;
      l ? u ? (f = n * t.width, v = r * e.height) : (f = r * t.height, v = n * e.width) : i === "start" ? v = e.width : i === "end" ? f = t.width : i !== "inner" && (f = t.width / 2, v = e.width / 2), this.paddingLeft = Math.max((f - c + a) * this.width / (this.width - c), 0), this.paddingRight = Math.max((v - d + a) * this.width / (this.width - d), 0);
    } else {
      let c = e.height / 2, d = t.height / 2;
      i === "start" ? (c = 0, d = t.height) : i === "end" && (c = e.height, d = 0), this.paddingTop = c + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Tr(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, r;
    for (e = 0, r = t.length; e < r; e++)
      Nt(t[e].label) && (t.splice(e, 1), r--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let r = this.ticks;
      e < r.length && (r = GT(r, e)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, r) {
    const { ctx: n, _longestTextCache: i } = this, a = [], s = [], l = Math.floor(e / kT(e, r));
    let u = 0, c = 0, d, f, v, g, m, b, S, R, P, D, x;
    for (d = 0; d < e; d += l) {
      if (g = t[d].label, m = this._resolveTickFontOptions(d), n.font = b = m.string, S = i[b] = i[b] || {
        data: {},
        gc: []
      }, R = m.lineHeight, P = D = 0, !Nt(g) && !Lr(g))
        P = Bm(n, S.data, S.gc, P, g), D = R;
      else if (Lr(g))
        for (f = 0, v = g.length; f < v; ++f)
          x = g[f], !Nt(x) && !Lr(x) && (P = Bm(n, S.data, S.gc, P, x), D += R);
      a.push(P), s.push(D), u = Math.max(P, u), c = Math.max(D, c);
    }
    XB(i, e);
    const M = a.indexOf(u), F = s.indexOf(c), H = (B) => ({
      width: a[B] || 0,
      height: s[B] || 0
    });
    return {
      first: H(0),
      last: H(e - 1),
      widest: H(M),
      highest: H(F),
      widths: a,
      heights: s
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return G7(this._alignToPixels ? Du(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const r = e[t];
      return r.$context || (r.$context = QB(this.getContext(), t, r));
    }
    return this.$context || (this.$context = ZB(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = Qi(this.labelRotation), r = Math.abs(Math.cos(e)), n = Math.abs(Math.sin(e)), i = this._getLabelSizes(), a = t.autoSkipPadding || 0, s = i ? i.widest.width + a : 0, l = i ? i.highest.height + a : 0;
    return this.isHorizontal() ? l * r > s * n ? s / r : l / n : l * n < s * r ? l / r : s / n;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, r = this.chart, n = this.options, { grid: i, position: a, border: s } = n, l = i.offset, u = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Cf(i), v = [], g = s.setContext(this.getContext()), m = g.display ? g.width : 0, b = m / 2, S = function(ie) {
      return Du(r, ie, m);
    };
    let R, P, D, x, M, F, H, B, j, V, W, q;
    if (a === "top")
      R = S(this.bottom), F = this.bottom - f, B = R - b, V = S(t.top) + b, q = t.bottom;
    else if (a === "bottom")
      R = S(this.top), V = t.top, q = S(t.bottom) - b, F = R + b, B = this.top + f;
    else if (a === "left")
      R = S(this.right), M = this.right - f, H = R - b, j = S(t.left) + b, W = t.right;
    else if (a === "right")
      R = S(this.left), j = t.left, W = S(t.right) - b, M = R + b, H = this.left + f;
    else if (e === "x") {
      if (a === "center")
        R = S((t.top + t.bottom) / 2 + 0.5);
      else if (Ht(a)) {
        const ie = Object.keys(a)[0], ne = a[ie];
        R = S(this.chart.scales[ie].getPixelForValue(ne));
      }
      V = t.top, q = t.bottom, F = R + b, B = F + f;
    } else if (e === "y") {
      if (a === "center")
        R = S((t.left + t.right) / 2);
      else if (Ht(a)) {
        const ie = Object.keys(a)[0], ne = a[ie];
        R = S(this.chart.scales[ie].getPixelForValue(ne));
      }
      M = R - b, H = M - f, j = t.left, W = t.right;
    }
    const ee = xt(n.ticks.maxTicksLimit, d), re = Math.max(1, Math.ceil(d / ee));
    for (P = 0; P < d; P += re) {
      const ie = this.getContext(P), ne = i.setContext(ie), se = s.setContext(ie), pe = ne.lineWidth, K = ne.color, J = se.dash || [], ue = se.dashOffset, he = ne.tickWidth, fe = ne.tickColor, ae = ne.tickBorderDash || [], oe = ne.tickBorderDashOffset;
      D = qB(this, P, l), D !== void 0 && (x = Du(r, D, pe), u ? M = H = j = W = x : F = B = V = q = x, v.push({
        tx1: M,
        ty1: F,
        tx2: H,
        ty2: B,
        x1: j,
        y1: V,
        x2: W,
        y2: q,
        width: pe,
        color: K,
        borderDash: J,
        borderDashOffset: ue,
        tickWidth: he,
        tickColor: fe,
        tickBorderDash: ae,
        tickBorderDashOffset: oe
      }));
    }
    return this._ticksLength = d, this._borderValue = R, v;
  }
  _computeLabelItems(t) {
    const e = this.axis, r = this.options, { position: n, ticks: i } = r, a = this.isHorizontal(), s = this.ticks, { align: l, crossAlign: u, padding: c, mirror: d } = i, f = Cf(r.grid), v = f + c, g = d ? -c : v, m = -Qi(this.labelRotation), b = [];
    let S, R, P, D, x, M, F, H, B, j, V, W, q = "middle";
    if (n === "top")
      M = this.bottom - g, F = this._getXAxisLabelAlignment();
    else if (n === "bottom")
      M = this.top + g, F = this._getXAxisLabelAlignment();
    else if (n === "left") {
      const re = this._getYAxisLabelAlignment(f);
      F = re.textAlign, x = re.x;
    } else if (n === "right") {
      const re = this._getYAxisLabelAlignment(f);
      F = re.textAlign, x = re.x;
    } else if (e === "x") {
      if (n === "center")
        M = (t.top + t.bottom) / 2 + v;
      else if (Ht(n)) {
        const re = Object.keys(n)[0], ie = n[re];
        M = this.chart.scales[re].getPixelForValue(ie) + v;
      }
      F = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (n === "center")
        x = (t.left + t.right) / 2 - v;
      else if (Ht(n)) {
        const re = Object.keys(n)[0], ie = n[re];
        x = this.chart.scales[re].getPixelForValue(ie);
      }
      F = this._getYAxisLabelAlignment(f).textAlign;
    }
    e === "y" && (l === "start" ? q = "top" : l === "end" && (q = "bottom"));
    const ee = this._getLabelSizes();
    for (S = 0, R = s.length; S < R; ++S) {
      P = s[S], D = P.label;
      const re = i.setContext(this.getContext(S));
      H = this.getPixelForTick(S) + i.labelOffset, B = this._resolveTickFontOptions(S), j = B.lineHeight, V = Lr(D) ? D.length : 1;
      const ie = V / 2, ne = re.color, se = re.textStrokeColor, pe = re.textStrokeWidth;
      let K = F;
      a ? (x = H, F === "inner" && (S === R - 1 ? K = this.options.reverse ? "left" : "right" : S === 0 ? K = this.options.reverse ? "right" : "left" : K = "center"), n === "top" ? u === "near" || m !== 0 ? W = -V * j + j / 2 : u === "center" ? W = -ee.highest.height / 2 - ie * j + j : W = -ee.highest.height + j / 2 : u === "near" || m !== 0 ? W = j / 2 : u === "center" ? W = ee.highest.height / 2 - ie * j : W = ee.highest.height - V * j, d && (W *= -1), m !== 0 && !re.showLabelBackdrop && (x += j / 2 * Math.sin(m))) : (M = H, W = (1 - V) * j / 2);
      let J;
      if (re.showLabelBackdrop) {
        const ue = jn(re.backdropPadding), he = ee.heights[S], fe = ee.widths[S];
        let ae = W - ue.top, oe = 0 - ue.left;
        switch (q) {
          case "middle":
            ae -= he / 2;
            break;
          case "bottom":
            ae -= he;
            break;
        }
        switch (F) {
          case "center":
            oe -= fe / 2;
            break;
          case "right":
            oe -= fe;
            break;
        }
        J = {
          left: oe,
          top: ae,
          width: fe + ue.width,
          height: he + ue.height,
          color: re.backdropColor
        };
      }
      b.push({
        label: D,
        font: B,
        textOffset: W,
        options: {
          rotation: m,
          color: ne,
          strokeColor: se,
          strokeWidth: pe,
          textAlign: K,
          textBaseline: q,
          translation: [
            x,
            M
          ],
          backdrop: J
        }
      });
    }
    return b;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-Qi(this.labelRotation))
      return t === "top" ? "left" : "right";
    let n = "center";
    return e.align === "start" ? n = "left" : e.align === "end" ? n = "right" : e.align === "inner" && (n = "inner"), n;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: r, mirror: n, padding: i } } = this.options, a = this._getLabelSizes(), s = t + i, l = a.widest.width;
    let u, c;
    return e === "left" ? n ? (c = this.right + i, r === "near" ? u = "left" : r === "center" ? (u = "center", c += l / 2) : (u = "right", c += l)) : (c = this.right - s, r === "near" ? u = "right" : r === "center" ? (u = "center", c -= l / 2) : (u = "left", c = this.left)) : e === "right" ? n ? (c = this.left + i, r === "near" ? u = "right" : r === "center" ? (u = "center", c -= l / 2) : (u = "left", c -= l)) : (c = this.left + s, r === "near" ? u = "left" : r === "center" ? (u = "center", c += l / 2) : (u = "right", c = this.right)) : u = "right", {
      textAlign: u,
      x: c
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: r, top: n, width: i, height: a } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(r, n, i, a), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const n = this.ticks.findIndex((i) => i.value === t);
    return n >= 0 ? e.setContext(this.getContext(n)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, r = this.ctx, n = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, a;
    const s = (l, u, c) => {
      !c.width || !c.color || (r.save(), r.lineWidth = c.width, r.strokeStyle = c.color, r.setLineDash(c.borderDash || []), r.lineDashOffset = c.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(u.x, u.y), r.stroke(), r.restore());
    };
    if (e.display)
      for (i = 0, a = n.length; i < a; ++i) {
        const l = n[i];
        e.drawOnChartArea && s({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), e.drawTicks && s({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: r, grid: n } } = this, i = r.setContext(this.getContext()), a = r.display ? i.width : 0;
    if (!a)
      return;
    const s = n.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let u, c, d, f;
    this.isHorizontal() ? (u = Du(t, this.left, a) - a / 2, c = Du(t, this.right, s) + s / 2, d = f = l) : (d = Du(t, this.top, a) - a / 2, f = Du(t, this.bottom, s) + s / 2, u = c = l), e.save(), e.lineWidth = i.width, e.strokeStyle = i.color, e.beginPath(), e.moveTo(u, d), e.lineTo(c, f), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, n = this._computeLabelArea();
    n && $y(r, n);
    const i = this.getLabelItems(t);
    for (const a of i) {
      const s = a.options, l = a.font, u = a.label, c = a.textOffset;
      fc(r, u, 0, c, l, s);
    }
    n && zy(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: r, reverse: n } } = this;
    if (!r.display)
      return;
    const i = hn(r.font), a = jn(r.padding), s = r.align;
    let l = i.lineHeight / 2;
    e === "bottom" || e === "center" || Ht(e) ? (l += a.bottom, Lr(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += a.top;
    const { titleX: u, titleY: c, maxWidth: d, rotation: f } = eW(this, l, e, s);
    fc(t, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: JB(s, e, n),
      textBaseline: "middle",
      translation: [
        u,
        c
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, r = xt(t.grid && t.grid.z, -1), n = xt(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Sc.prototype.draw ? [
      {
        z: e,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: n,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", n = [];
    let i, a;
    for (i = 0, a = e.length; i < a; ++i) {
      const s = e[i];
      s[r] === this.id && (!t || s.type === t) && n.push(s);
    }
    return n;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return hn(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Cg {
  constructor(t, e, r) {
    this.type = t, this.scope = e, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let r;
    nW(e) && (r = this.register(e));
    const n = this.items, i = t.id, a = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in n || (n[i] = t, tW(t, a, r), this.override && Yr.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, r = t.id, n = this.scope;
    r in e && delete e[r], n && r in Yr[n] && (delete Yr[n][r], this.override && delete pc[r]);
  }
}
function tW(o, t, e) {
  const r = Ha(/* @__PURE__ */ Object.create(null), [
    e ? Yr.get(e) : {},
    Yr.get(t),
    o.defaults
  ]);
  Yr.set(t, r), o.defaultRoutes && rW(t, o.defaultRoutes), o.descriptors && Yr.describe(t, o.descriptors);
}
function rW(o, t) {
  Object.keys(t).forEach((e) => {
    const r = e.split("."), n = r.pop(), i = [
      o
    ].concat(r).join("."), a = t[e].split("."), s = a.pop(), l = a.join(".");
    Yr.route(i, n, l, s);
  });
}
function nW(o) {
  return "id" in o && "defaults" in o;
}
class oW {
  constructor() {
    this.controllers = new Cg(ta, "datasets", !0), this.elements = new Cg(Rs, "elements"), this.plugins = new Cg(Object, "plugins"), this.scales = new Cg(Sc, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, r) {
    [
      ...e
    ].forEach((n) => {
      const i = r || this._getRegistryForType(n);
      r || i.isForType(n) || i === this.plugins && n.id ? this._exec(t, i, n) : ur(n, (a) => {
        const s = r || this._getRegistryForType(a);
        this._exec(t, s, a);
      });
    });
  }
  _exec(t, e, r) {
    const n = s1(t);
    Tr(r["before" + n], [], r), e[t](r), Tr(r["after" + n], [], r);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const r = this._typedRegistries[e];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, e, r) {
    const n = e.get(t);
    if (n === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return n;
  }
}
var Ra = /* @__PURE__ */ new oW();
class iW {
  constructor() {
    this._init = [];
  }
  notify(t, e, r, n) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = n ? this._descriptors(t).filter(n) : this._descriptors(t), a = this._notify(i, t, e, r);
    return e === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, e, r, n) {
    n = n || {};
    for (const i of t) {
      const a = i.plugin, s = a[r], l = [
        e,
        n,
        i.options
      ];
      if (Tr(s, l, a) === !1 && n.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Nt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const r = t && t.config, n = xt(r.options && r.options.plugins, {}), i = aW(r);
    return n === !1 && !e ? [] : lW(t, i, n, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], r = this._cache, n = (i, a) => i.filter((s) => !a.some((l) => s.plugin.id === l.plugin.id));
    this._notify(n(e, r), t, "stop"), this._notify(n(r, e), t, "start");
  }
}
function aW(o) {
  const t = {}, e = [], r = Object.keys(Ra.plugins.items);
  for (let i = 0; i < r.length; i++)
    e.push(Ra.getPlugin(r[i]));
  const n = o.plugins || [];
  for (let i = 0; i < n.length; i++) {
    const a = n[i];
    e.indexOf(a) === -1 && (e.push(a), t[a.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function sW(o, t) {
  return !t && o === !1 ? null : o === !0 ? {} : o;
}
function lW(o, { plugins: t, localIds: e }, r, n) {
  const i = [], a = o.getContext();
  for (const s of t) {
    const l = s.id, u = sW(r[l], n);
    u !== null && i.push({
      plugin: s,
      options: uW(o.config, {
        plugin: s,
        local: e[l]
      }, u, a)
    });
  }
  return i;
}
function uW(o, { plugin: t, local: e }, r, n) {
  const i = o.pluginScopeKeys(t), a = o.getOptionScopes(r, i);
  return e && t.defaults && a.push(t.defaults), o.createResolver(a, n, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function vS(o, t) {
  const e = Yr.datasets[o] || {};
  return ((t.datasets || {})[o] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function cW(o, t) {
  let e = o;
  return o === "_index_" ? e = t : o === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function dW(o, t) {
  return o === t ? "_index_" : "_value_";
}
function HT(o) {
  if (o === "x" || o === "y" || o === "r")
    return o;
}
function pW(o) {
  if (o === "top" || o === "bottom")
    return "x";
  if (o === "left" || o === "right")
    return "y";
}
function gS(o, ...t) {
  if (HT(o))
    return o;
  for (const e of t) {
    const r = e.axis || pW(e.position) || o.length > 1 && HT(o[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${o}' axis. Please provide 'axis' or 'position' option.`);
}
function BT(o, t, e) {
  if (e[t + "AxisID"] === o)
    return {
      axis: t
    };
}
function fW(o, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((r) => r.xAxisID === o || r.yAxisID === o);
    if (e.length)
      return BT(o, "x", e[0]) || BT(o, "y", e[0]);
  }
  return {};
}
function hW(o, t) {
  const e = pc[o.type] || {
    scales: {}
  }, r = t.scales || {}, n = vS(o.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((a) => {
    const s = r[a];
    if (!Ht(s))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (s._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = gS(a, s, fW(a, o), Yr.scales[s.type]), u = dW(l, n), c = e.scales || {};
    i[a] = yh(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      s,
      c[l],
      c[u]
    ]);
  }), o.data.datasets.forEach((a) => {
    const s = a.type || o.type, l = a.indexAxis || vS(s, t), c = (pc[s] || {}).scales || {};
    Object.keys(c).forEach((d) => {
      const f = cW(d, l), v = a[f + "AxisID"] || f;
      i[v] = i[v] || /* @__PURE__ */ Object.create(null), yh(i[v], [
        {
          axis: f
        },
        r[v],
        c[d]
      ]);
    });
  }), Object.keys(i).forEach((a) => {
    const s = i[a];
    yh(s, [
      Yr.scales[s.type],
      Yr.scale
    ]);
  }), i;
}
function SF(o) {
  const t = o.options || (o.options = {});
  t.plugins = xt(t.plugins, {}), t.scales = hW(o, t);
}
function EF(o) {
  return o = o || {}, o.datasets = o.datasets || [], o.labels = o.labels || [], o;
}
function vW(o) {
  return o = o || {}, o.data = EF(o.data), SF(o), o;
}
const WT = /* @__PURE__ */ new Map(), _F = /* @__PURE__ */ new Set();
function wg(o, t) {
  let e = WT.get(o);
  return e || (e = t(), WT.set(o, e), _F.add(e)), e;
}
const wf = (o, t, e) => {
  const r = kl(t, e);
  r !== void 0 && o.add(r);
};
class gW {
  constructor(t) {
    this._config = vW(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = EF(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), SF(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return wg(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return wg(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return wg(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, r = this.type;
    return wg(`${r}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const r = this._scopeCache;
    let n = r.get(t);
    return (!n || e) && (n = /* @__PURE__ */ new Map(), r.set(t, n)), n;
  }
  getOptionScopes(t, e, r) {
    const { options: n, type: i } = this, a = this._cachedScopes(t, r), s = a.get(e);
    if (s)
      return s;
    const l = /* @__PURE__ */ new Set();
    e.forEach((c) => {
      t && (l.add(t), c.forEach((d) => wf(l, t, d))), c.forEach((d) => wf(l, n, d)), c.forEach((d) => wf(l, pc[i] || {}, d)), c.forEach((d) => wf(l, Yr, d)), c.forEach((d) => wf(l, pS, d));
    });
    const u = Array.from(l);
    return u.length === 0 && u.push(/* @__PURE__ */ Object.create(null)), _F.has(e) && a.set(e, u), u;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      pc[e] || {},
      Yr.datasets[e] || {},
      {
        type: e
      },
      Yr,
      pS
    ];
  }
  resolveNamedOptions(t, e, r, n = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: a, subPrefixes: s } = jT(this._resolverCache, t, n);
    let l = a;
    if (yW(a, e)) {
      i.$shared = !1, r = Gl(r) ? r() : r;
      const u = this.createResolver(t, r, s);
      l = ip(a, r, u);
    }
    for (const u of e)
      i[u] = l[u];
    return i;
  }
  createResolver(t, e, r = [
    ""
  ], n) {
    const { resolver: i } = jT(this._resolverCache, t, r);
    return Ht(e) ? ip(i, e, void 0, n) : i;
  }
}
function jT(o, t, e) {
  let r = o.get(t);
  r || (r = /* @__PURE__ */ new Map(), o.set(t, r));
  const n = e.join();
  let i = r.get(n);
  return i || (i = {
    resolver: f1(t, e),
    subPrefixes: e.filter((s) => !s.toLowerCase().includes("hover"))
  }, r.set(n, i)), i;
}
const mW = (o) => Ht(o) && Object.getOwnPropertyNames(o).reduce((t, e) => t || Gl(o[e]), !1);
function yW(o, t) {
  const { isScriptable: e, isIndexable: r } = rF(o);
  for (const n of t) {
    const i = e(n), a = r(n), s = (a || i) && o[n];
    if (i && (Gl(s) || mW(s)) || a && Lr(s))
      return !0;
  }
  return !1;
}
var CW = "4.4.0";
const wW = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function UT(o, t) {
  return o === "top" || o === "bottom" || wW.indexOf(o) === -1 && t === "x";
}
function $T(o, t) {
  return function(e, r) {
    return e[o] === r[o] ? e[t] - r[t] : e[o] - r[o];
  };
}
function zT(o) {
  const t = o.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), Tr(e && e.onComplete, [
    o
  ], t);
}
function bW(o) {
  const t = o.chart, e = t.options.animation;
  Tr(e && e.onProgress, [
    o
  ], t);
}
function xF(o) {
  return lF() && typeof o == "string" ? o = document.getElementById(o) : o && o.length && (o = o[0]), o && o.canvas && (o = o.canvas), o;
}
const Cm = {}, YT = (o) => {
  const t = xF(o);
  return Object.values(Cm).filter((e) => e.canvas === t).pop();
};
function SW(o, t, e) {
  const r = Object.keys(o);
  for (const n of r) {
    const i = +n;
    if (i >= t) {
      const a = o[n];
      delete o[n], (e > 0 || i > t) && (o[i + e] = a);
    }
  }
}
function EW(o, t, e, r) {
  return !e || o.type === "mouseout" ? null : r ? t : o;
}
function bg(o, t, e) {
  return o.options.clip ? o[e] : t[e];
}
function _W(o, t) {
  const { xScale: e, yScale: r } = o;
  return e && r ? {
    left: bg(e, t, "left"),
    right: bg(e, t, "right"),
    top: bg(r, t, "top"),
    bottom: bg(r, t, "bottom")
  } : t;
}
class hs {
  static register(...t) {
    Ra.add(...t), KT();
  }
  static unregister(...t) {
    Ra.remove(...t), KT();
  }
  constructor(t, e) {
    const r = this.config = new gW(e), n = xF(t), i = YT(n);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const a = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || BB(n))(), this.platform.updateConfig(r);
    const s = this.platform.acquireContext(n, a.aspectRatio), l = s && s.canvas, u = l && l.height, c = l && l.width;
    if (this.id = R7(), this.ctx = s, this.canvas = l, this.width = c, this.height = u, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new iW(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = W7((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], Cm[this.id] = this, !s || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ds.listen(this, "complete", zT), ds.listen(this, "progress", bW), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: r, height: n, _aspectRatio: i } = this;
    return Nt(t) ? e && i ? i : n ? r / n : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Ra;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : vT(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return pT(this.canvas, this.ctx), this;
  }
  stop() {
    return ds.stop(this), this;
  }
  resize(t, e) {
    ds.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const r = this.options, n = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(n, t, e, i), s = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, vT(this, s, !0) && (this.notifyPlugins("resize", {
      size: a
    }), Tr(r.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    ur(e, (r, n) => {
      r.id = n;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, r = this.scales, n = Object.keys(r).reduce((a, s) => (a[s] = !1, a), {});
    let i = [];
    e && (i = i.concat(Object.keys(e).map((a) => {
      const s = e[a], l = gS(a, s), u = l === "r", c = l === "x";
      return {
        options: s,
        dposition: u ? "chartArea" : c ? "bottom" : "left",
        dtype: u ? "radialLinear" : c ? "category" : "linear"
      };
    }))), ur(i, (a) => {
      const s = a.options, l = s.id, u = gS(l, s), c = xt(s.type, a.dtype);
      (s.position === void 0 || UT(s.position, u) !== UT(a.dposition)) && (s.position = a.dposition), n[l] = !0;
      let d = null;
      if (l in r && r[l].type === c)
        d = r[l];
      else {
        const f = Ra.getScale(c);
        d = new f({
          id: l,
          type: c,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(s, t);
    }), ur(n, (a, s) => {
      a || delete r[s];
    }), ur(r, (a) => {
      Zn.configure(this, a, a.options), Zn.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, r = t.length;
    if (t.sort((n, i) => n.index - i.index), r > e) {
      for (let n = e; n < r; ++n)
        this._destroyDatasetMeta(n);
      t.splice(e, r - e);
    }
    this._sortedMetasets = t.slice(0).sort($T("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((r, n) => {
      e.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(n);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let r, n;
    for (this._removeUnreferencedMetasets(), r = 0, n = e.length; r < n; r++) {
      const i = e[r];
      let a = this.getDatasetMeta(r);
      const s = i.type || this.config.type;
      if (a.type && a.type !== s && (this._destroyDatasetMeta(r), a = this.getDatasetMeta(r)), a.type = s, a.indexAxis = i.indexAxis || vS(s, this.options), a.order = i.order || 0, a.index = r, a.label = "" + i.label, a.visible = this.isDatasetVisible(r), a.controller)
        a.controller.updateIndex(r), a.controller.linkScales();
      else {
        const l = Ra.getController(s), { datasetElementType: u, dataElementType: c } = Yr.datasets[s];
        Object.assign(l, {
          dataElementType: Ra.getElement(c),
          datasetElementType: u && Ra.getElement(u)
        }), a.controller = new l(this, r), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    ur(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const r = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), n = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let u = 0, c = this.data.datasets.length; u < c; u++) {
      const { controller: d } = this.getDatasetMeta(u), f = !n && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = r.layout.autoPadding ? a : 0, this._updateLayout(a), n || ur(i, (u) => {
      u.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort($T("z", "_idx"));
    const { _active: s, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : s.length && this._updateHoverStyles(s, s, !0), this.render();
  }
  _updateScales() {
    ur(this.scales, (t) => {
      Zn.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!nT(e, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: r, start: n, count: i } of e) {
      const a = r === "_removeElements" ? -i : i;
      SW(t, n, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, r = (i) => new Set(t.filter((a) => a[0] === i).map((a, s) => s + "," + a.splice(1).join(","))), n = r(0);
    for (let i = 1; i < e; i++)
      if (!nT(n, r(i)))
        return;
    return Array.from(n).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Zn.update(this, this.width, this.height, t);
    const e = this.chartArea, r = e.width <= 0 || e.height <= 0;
    this._layers = [], ur(this.boxes, (n) => {
      r && n.position === "chartArea" || (n.configure && n.configure(), this._layers.push(...n._layers()));
    }, this), this._layers.forEach((n, i) => {
      n._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, r = this.data.datasets.length; e < r; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, r = this.data.datasets.length; e < r; ++e)
        this._updateDataset(e, Gl(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const r = this.getDatasetMeta(t), n = {
      meta: r,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", n) !== !1 && (r.controller._update(e), n.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", n));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (ds.has(this) ? this.attached && !ds.running(this) && ds.start(this) : (this.draw(), zT({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: n } = this._resizeBeforeDraw;
      this._resize(r, n), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, r = [];
    let n, i;
    for (n = 0, i = e.length; n < i; ++n) {
      const a = e[n];
      (!t || a.visible) && r.push(a);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, r = t._clip, n = !r.disabled, i = _W(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (n && $y(e, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), t.controller.draw(), n && zy(e), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return ys(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, r, n) {
    const i = wB.modes[e];
    return typeof i == "function" ? i(this, t, r, n) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], r = this._metasets;
    let n = r.filter((i) => i && i._dataset === e).pop();
    return n || (n = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, r.push(n)), n;
  }
  getContext() {
    return this.$context || (this.$context = Wl(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const r = this.getDatasetMeta(t);
    r.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, r) {
    const n = r ? "show" : "hide", i = this.getDatasetMeta(t), a = i.controller._resolveAnimations(void 0, n);
    Vh(e) ? (i.data[e].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), a.update(i, {
      visible: r
    }), this.update((s) => s.datasetIndex === t ? n : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), ds.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), pT(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete Cm[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, r = (i, a) => {
      e.addEventListener(this, i, a), t[i] = a;
    }, n = (i, a, s) => {
      i.offsetX = a, i.offsetY = s, this._eventHandler(i);
    };
    ur(this.options.events, (i) => r(i, n));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, r = (l, u) => {
      e.addEventListener(this, l, u), t[l] = u;
    }, n = (l, u) => {
      t[l] && (e.removeEventListener(this, l, u), delete t[l]);
    }, i = (l, u) => {
      this.canvas && this.resize(l, u);
    };
    let a;
    const s = () => {
      n("attach", s), this.attached = !0, this.resize(), r("resize", i), r("detach", a);
    };
    a = () => {
      this.attached = !1, n("resize", i), this._stop(), this._resize(0, 0), r("attach", s);
    }, e.isAttached(this.canvas) ? s() : a();
  }
  unbindEvents() {
    ur(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, ur(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, r) {
    const n = r ? "set" : "remove";
    let i, a, s, l;
    for (e === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + n + "DatasetHoverStyle"]()), s = 0, l = t.length; s < l; ++s) {
      a = t[s];
      const u = a && this.getDatasetMeta(a.datasetIndex).controller;
      u && u[n + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], r = t.map(({ datasetIndex: i, index: a }) => {
      const s = this.getDatasetMeta(i);
      if (!s)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: s.data[a],
        index: a
      };
    });
    !Gm(r, e) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, e));
  }
  notifyPlugins(t, e, r) {
    return this._plugins.notify(this, t, e, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, r) {
    const n = this.options.hover, i = (l, u) => l.filter((c) => !u.some((d) => c.datasetIndex === d.datasetIndex && c.index === d.index)), a = i(e, t), s = r ? t : i(t, e);
    a.length && this.updateHoverStyle(a, n.mode, !1), s.length && n.mode && this.updateHoverStyle(s, n.mode, !0);
  }
  _eventHandler(t, e) {
    const r = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, n = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, n) === !1)
      return;
    const i = this._handleEvent(t, e, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, n), (i || r.changed) && this.render(), this;
  }
  _handleEvent(t, e, r) {
    const { _active: n = [], options: i } = this, a = e, s = this._getActiveElements(t, n, r, a), l = M7(t), u = EW(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, Tr(i.onHover, [
      t,
      s,
      this
    ], this), l && Tr(i.onClick, [
      t,
      s,
      this
    ], this));
    const c = !Gm(s, n);
    return (c || e) && (this._active = s, this._updateHoverStyles(s, n, e)), this._lastEvent = u, c;
  }
  _getActiveElements(t, e, r, n) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return e;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, n);
  }
}
We(hs, "defaults", Yr), We(hs, "instances", Cm), We(hs, "overrides", pc), We(hs, "registry", Ra), We(hs, "version", CW), We(hs, "getChart", YT);
function KT() {
  return ur(hs.instances, (o) => o._plugins.invalidate());
}
function xW(o, t, e) {
  const { startAngle: r, pixelMargin: n, x: i, y: a, outerRadius: s, innerRadius: l } = t;
  let u = n / s;
  o.beginPath(), o.arc(i, a, s, r - u, e + u), l > n ? (u = n / l, o.arc(i, a, l, e + u, r - u, !0)) : o.arc(i, a, n, e + an, r - an), o.closePath(), o.clip();
}
function RW(o) {
  return p1(o, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function TW(o, t, e, r) {
  const n = RW(o.options.borderRadius), i = (e - t) / 2, a = Math.min(i, r * t / 2), s = (l) => {
    const u = (e - Math.min(i, l)) * r / 2;
    return Pn(l, 0, Math.min(i, u));
  };
  return {
    outerStart: s(n.outerStart),
    outerEnd: s(n.outerEnd),
    innerStart: Pn(n.innerStart, 0, a),
    innerEnd: Pn(n.innerEnd, 0, a)
  };
}
function Pd(o, t, e, r) {
  return {
    x: e + o * Math.cos(t),
    y: r + o * Math.sin(t)
  };
}
function Um(o, t, e, r, n, i) {
  const { x: a, y: s, startAngle: l, pixelMargin: u, innerRadius: c } = t, d = Math.max(t.outerRadius + r + e - u, 0), f = c > 0 ? c + r + e + u : 0;
  let v = 0;
  const g = n - l;
  if (r) {
    const re = c > 0 ? c - r : 0, ie = d > 0 ? d - r : 0, ne = (re + ie) / 2, se = ne !== 0 ? g * ne / (ne + r) : g;
    v = (g - se) / 2;
  }
  const m = Math.max(1e-3, g * d - e / kr) / d, b = (g - m) / 2, S = l + b + v, R = n - b - v, { outerStart: P, outerEnd: D, innerStart: x, innerEnd: M } = TW(t, f, d, R - S), F = d - P, H = d - D, B = S + P / F, j = R - D / H, V = f + x, W = f + M, q = S + x / V, ee = R - M / W;
  if (o.beginPath(), i) {
    const re = (B + j) / 2;
    if (o.arc(a, s, d, B, re), o.arc(a, s, d, re, j), D > 0) {
      const pe = Pd(H, j, a, s);
      o.arc(pe.x, pe.y, D, j, R + an);
    }
    const ie = Pd(W, R, a, s);
    if (o.lineTo(ie.x, ie.y), M > 0) {
      const pe = Pd(W, ee, a, s);
      o.arc(pe.x, pe.y, M, R + an, ee + Math.PI);
    }
    const ne = (R - M / f + (S + x / f)) / 2;
    if (o.arc(a, s, f, R - M / f, ne, !0), o.arc(a, s, f, ne, S + x / f, !0), x > 0) {
      const pe = Pd(V, q, a, s);
      o.arc(pe.x, pe.y, x, q + Math.PI, S - an);
    }
    const se = Pd(F, S, a, s);
    if (o.lineTo(se.x, se.y), P > 0) {
      const pe = Pd(F, B, a, s);
      o.arc(pe.x, pe.y, P, S - an, B);
    }
  } else {
    o.moveTo(a, s);
    const re = Math.cos(B) * d + a, ie = Math.sin(B) * d + s;
    o.lineTo(re, ie);
    const ne = Math.cos(j) * d + a, se = Math.sin(j) * d + s;
    o.lineTo(ne, se);
  }
  o.closePath();
}
function OW(o, t, e, r, n) {
  const { fullCircles: i, startAngle: a, circumference: s } = t;
  let l = t.endAngle;
  if (i) {
    Um(o, t, e, r, l, n);
    for (let u = 0; u < i; ++u)
      o.fill();
    isNaN(s) || (l = a + (s % Nr || Nr));
  }
  return Um(o, t, e, r, l, n), o.fill(), l;
}
function PW(o, t, e, r, n) {
  const { fullCircles: i, startAngle: a, circumference: s, options: l } = t, { borderWidth: u, borderJoinStyle: c, borderDash: d, borderDashOffset: f } = l, v = l.borderAlign === "inner";
  if (!u)
    return;
  o.setLineDash(d || []), o.lineDashOffset = f, v ? (o.lineWidth = u * 2, o.lineJoin = c || "round") : (o.lineWidth = u, o.lineJoin = c || "bevel");
  let g = t.endAngle;
  if (i) {
    Um(o, t, e, r, g, n);
    for (let m = 0; m < i; ++m)
      o.stroke();
    isNaN(s) || (g = a + (s % Nr || Nr));
  }
  v && xW(o, t, g), i || (Um(o, t, e, r, g, n), o.stroke());
}
class Wd extends Rs {
  constructor(e) {
    super();
    We(this, "circumference");
    We(this, "endAngle");
    We(this, "fullCircles");
    We(this, "innerRadius");
    We(this, "outerRadius");
    We(this, "pixelMargin");
    We(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e);
  }
  inRange(e, r, n) {
    const i = this.getProps([
      "x",
      "y"
    ], n), { angle: a, distance: s } = zM(i, {
      x: e,
      y: r
    }), { startAngle: l, endAngle: u, innerRadius: c, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], n), v = (this.options.spacing + this.options.borderWidth) / 2, m = xt(f, u - l) >= Nr || Hh(a, l, u), b = gs(s, c + v, d + v);
    return m && b;
  }
  getCenterPoint(e) {
    const { x: r, y: n, startAngle: i, endAngle: a, innerRadius: s, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], e), { offset: u, spacing: c } = this.options, d = (i + a) / 2, f = (s + l + c + u) / 2;
    return {
      x: r + Math.cos(d) * f,
      y: n + Math.sin(d) * f
    };
  }
  tooltipPosition(e) {
    return this.getCenterPoint(e);
  }
  draw(e) {
    const { options: r, circumference: n } = this, i = (r.offset || 0) / 4, a = (r.spacing || 0) / 2, s = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = n > Nr ? Math.floor(n / Nr) : 0, n === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    e.save();
    const l = (this.startAngle + this.endAngle) / 2;
    e.translate(Math.cos(l) * i, Math.sin(l) * i);
    const u = 1 - Math.sin(Math.min(kr, n || 0)), c = i * u;
    e.fillStyle = r.backgroundColor, e.strokeStyle = r.borderColor, OW(e, this, c, a, s), PW(e, this, c, a, s), e.restore();
  }
}
We(Wd, "id", "arc"), We(Wd, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), We(Wd, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), We(Wd, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash"
});
function RF(o, t, e = t) {
  o.lineCap = xt(e.borderCapStyle, t.borderCapStyle), o.setLineDash(xt(e.borderDash, t.borderDash)), o.lineDashOffset = xt(e.borderDashOffset, t.borderDashOffset), o.lineJoin = xt(e.borderJoinStyle, t.borderJoinStyle), o.lineWidth = xt(e.borderWidth, t.borderWidth), o.strokeStyle = xt(e.borderColor, t.borderColor);
}
function DW(o, t, e) {
  o.lineTo(e.x, e.y);
}
function AW(o) {
  return o.stepped ? eH : o.tension || o.cubicInterpolationMode === "monotone" ? tH : DW;
}
function TF(o, t, e = {}) {
  const r = o.length, { start: n = 0, end: i = r - 1 } = e, { start: a, end: s } = t, l = Math.max(n, a), u = Math.min(i, s), c = n < a && i < a || n > s && i > s;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: u < l && !c ? r + u - l : u - l
  };
}
function MW(o, t, e, r) {
  const { points: n, options: i } = t, { count: a, start: s, loop: l, ilen: u } = TF(n, e, r), c = AW(i);
  let { move: d = !0, reverse: f } = r || {}, v, g, m;
  for (v = 0; v <= u; ++v)
    g = n[(s + (f ? u - v : v)) % a], !g.skip && (d ? (o.moveTo(g.x, g.y), d = !1) : c(o, m, g, f, i.stepped), m = g);
  return l && (g = n[(s + (f ? u : 0)) % a], c(o, m, g, f, i.stepped)), !!l;
}
function FW(o, t, e, r) {
  const n = t.points, { count: i, start: a, ilen: s } = TF(n, e, r), { move: l = !0, reverse: u } = r || {};
  let c = 0, d = 0, f, v, g, m, b, S;
  const R = (D) => (a + (u ? s - D : D)) % i, P = () => {
    m !== b && (o.lineTo(c, b), o.lineTo(c, m), o.lineTo(c, S));
  };
  for (l && (v = n[R(0)], o.moveTo(v.x, v.y)), f = 0; f <= s; ++f) {
    if (v = n[R(f)], v.skip)
      continue;
    const D = v.x, x = v.y, M = D | 0;
    M === g ? (x < m ? m = x : x > b && (b = x), c = (d * c + D) / ++d) : (P(), o.lineTo(D, x), g = M, d = 0, m = b = x), S = x;
  }
  P();
}
function mS(o) {
  const t = o.options, e = t.borderDash && t.borderDash.length;
  return !o._decimated && !o._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? FW : MW;
}
function IW(o) {
  return o.stepped ? FH : o.tension || o.cubicInterpolationMode === "monotone" ? IH : zu;
}
function LW(o, t, e, r) {
  let n = t._path;
  n || (n = t._path = new Path2D(), t.path(n, e, r) && n.closePath()), RF(o, t.options), o.stroke(n);
}
function NW(o, t, e, r) {
  const { segments: n, options: i } = t, a = mS(t);
  for (const s of n)
    RF(o, i, s.style), o.beginPath(), a(o, t, s, {
      start: e,
      end: e + r - 1
    }) && o.closePath(), o.stroke();
}
const kW = typeof Path2D == "function";
function GW(o, t, e, r) {
  kW && !t.options.segment ? LW(o, t, e, r) : NW(o, t, e, r);
}
class xl extends Rs {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const n = r.spanGaps ? this._loop : this._fullLoop;
      xH(this._points, r, t, n, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = HH(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, r = t.length;
    return r && e[t[r - 1].end];
  }
  interpolate(t, e) {
    const r = this.options, n = t[e], i = this.points, a = fF(this, {
      property: e,
      start: n,
      end: n
    });
    if (!a.length)
      return;
    const s = [], l = IW(r);
    let u, c;
    for (u = 0, c = a.length; u < c; ++u) {
      const { start: d, end: f } = a[u], v = i[d], g = i[f];
      if (v === g) {
        s.push(v);
        continue;
      }
      const m = Math.abs((n - v[e]) / (g[e] - v[e])), b = l(v, g, m, r.stepped);
      b[e] = t[e], s.push(b);
    }
    return s.length === 1 ? s[0] : s;
  }
  pathSegment(t, e, r) {
    return mS(this)(t, this, e, r);
  }
  path(t, e, r) {
    const n = this.segments, i = mS(this);
    let a = this._loop;
    e = e || 0, r = r || this.points.length - e;
    for (const s of n)
      a &= i(t, this, s, {
        start: e,
        end: e + r - 1
      });
    return !!a;
  }
  draw(t, e, r, n) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), GW(t, this, r, n), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
We(xl, "id", "line"), We(xl, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), We(xl, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), We(xl, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function qT(o, t, e, r) {
  const n = o.options, { [e]: i } = o.getProps([
    e
  ], r);
  return Math.abs(t - i) < n.radius + n.hitRadius;
}
class Eh extends Rs {
  constructor(e) {
    super();
    We(this, "parsed");
    We(this, "skip");
    We(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, r, n) {
    const i = this.options, { x: a, y: s } = this.getProps([
      "x",
      "y"
    ], n);
    return Math.pow(e - a, 2) + Math.pow(r - s, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(e, r) {
    return qT(this, e, "x", r);
  }
  inYRange(e, r) {
    return qT(this, e, "y", r);
  }
  getCenterPoint(e) {
    const { x: r, y: n } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: r,
      y: n
    };
  }
  size(e) {
    e = e || this.options || {};
    let r = e.radius || 0;
    r = Math.max(r, r && e.hoverRadius || 0);
    const n = r && e.borderWidth || 0;
    return (r + n) * 2;
  }
  draw(e, r) {
    const n = this.options;
    this.skip || n.radius < 0.1 || !ys(this, r, this.size(n) / 2) || (e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.fillStyle = n.backgroundColor, fS(e, n, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
We(Eh, "id", "point"), /**
* @type {any}
*/
We(Eh, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
We(Eh, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function OF(o, t) {
  const { x: e, y: r, base: n, width: i, height: a } = o.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let s, l, u, c, d;
  return o.horizontal ? (d = a / 2, s = Math.min(e, n), l = Math.max(e, n), u = r - d, c = r + d) : (d = i / 2, s = e - d, l = e + d, u = Math.min(r, n), c = Math.max(r, n)), {
    left: s,
    top: u,
    right: l,
    bottom: c
  };
}
function Rl(o, t, e, r) {
  return o ? 0 : Pn(t, e, r);
}
function VW(o, t, e) {
  const r = o.options.borderWidth, n = o.borderSkipped, i = tF(r);
  return {
    t: Rl(n.top, i.top, 0, e),
    r: Rl(n.right, i.right, 0, t),
    b: Rl(n.bottom, i.bottom, 0, e),
    l: Rl(n.left, i.left, 0, t)
  };
}
function HW(o, t, e) {
  const { enableBorderRadius: r } = o.getProps([
    "enableBorderRadius"
  ]), n = o.options.borderRadius, i = nc(n), a = Math.min(t, e), s = o.borderSkipped, l = r || Ht(n);
  return {
    topLeft: Rl(!l || s.top || s.left, i.topLeft, 0, a),
    topRight: Rl(!l || s.top || s.right, i.topRight, 0, a),
    bottomLeft: Rl(!l || s.bottom || s.left, i.bottomLeft, 0, a),
    bottomRight: Rl(!l || s.bottom || s.right, i.bottomRight, 0, a)
  };
}
function BW(o) {
  const t = OF(o), e = t.right - t.left, r = t.bottom - t.top, n = VW(o, e / 2, r / 2), i = HW(o, e / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: r,
      radius: i
    },
    inner: {
      x: t.left + n.l,
      y: t.top + n.t,
      w: e - n.l - n.r,
      h: r - n.t - n.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(n.t, n.l)),
        topRight: Math.max(0, i.topRight - Math.max(n.t, n.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(n.b, n.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(n.b, n.r))
      }
    }
  };
}
function bw(o, t, e, r) {
  const n = t === null, i = e === null, s = o && !(n && i) && OF(o, r);
  return s && (n || gs(t, s.left, s.right)) && (i || gs(e, s.top, s.bottom));
}
function WW(o) {
  return o.topLeft || o.topRight || o.bottomLeft || o.bottomRight;
}
function jW(o, t) {
  o.rect(t.x, t.y, t.w, t.h);
}
function Sw(o, t, e = {}) {
  const r = o.x !== e.x ? -t : 0, n = o.y !== e.y ? -t : 0, i = (o.x + o.w !== e.x + e.w ? t : 0) - r, a = (o.y + o.h !== e.y + e.h ? t : 0) - n;
  return {
    x: o.x + r,
    y: o.y + n,
    w: o.w + i,
    h: o.h + a,
    radius: o.radius
  };
}
class _h extends Rs {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: r, backgroundColor: n } } = this, { inner: i, outer: a } = BW(this), s = WW(a.radius) ? Bh : jW;
    t.save(), (a.w !== i.w || a.h !== i.h) && (t.beginPath(), s(t, Sw(a, e, i)), t.clip(), s(t, Sw(i, -e, a)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), s(t, Sw(i, e)), t.fillStyle = n, t.fill(), t.restore();
  }
  inRange(t, e, r) {
    return bw(this, t, e, r);
  }
  inXRange(t, e) {
    return bw(this, t, null, e);
  }
  inYRange(t, e) {
    return bw(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: r, base: n, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (e + n) / 2 : e,
      y: i ? r : (r + n) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
We(_h, "id", "bar"), We(_h, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), We(_h, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var UW = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Wd,
  BarElement: _h,
  LineElement: xl,
  PointElement: Eh
});
const yS = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], XT = /* @__PURE__ */ yS.map((o) => o.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function PF(o) {
  return yS[o % yS.length];
}
function DF(o) {
  return XT[o % XT.length];
}
function $W(o, t) {
  return o.borderColor = PF(t), o.backgroundColor = DF(t), ++t;
}
function zW(o, t) {
  return o.backgroundColor = o.data.map(() => PF(t++)), t;
}
function YW(o, t) {
  return o.backgroundColor = o.data.map(() => DF(t++)), t;
}
function KW(o) {
  let t = 0;
  return (e, r) => {
    const n = o.getDatasetMeta(r).controller;
    n instanceof Qu ? t = zW(e, t) : n instanceof Sh ? t = YW(e, t) : n && (t = $W(e, t));
  };
}
function ZT(o) {
  let t;
  for (t in o)
    if (o[t].borderColor || o[t].backgroundColor)
      return !0;
  return !1;
}
function qW(o) {
  return o && (o.borderColor || o.backgroundColor);
}
var XW = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(o, t, e) {
    if (!e.enabled)
      return;
    const { data: { datasets: r }, options: n } = o.config, { elements: i } = n;
    if (!e.forceOverride && (ZT(r) || qW(n) || i && ZT(i)))
      return;
    const a = KW(o);
    r.forEach(a);
  }
};
function ZW(o, t, e, r, n) {
  const i = n.samples || r;
  if (i >= e)
    return o.slice(t, t + e);
  const a = [], s = (e - 2) / (i - 2);
  let l = 0;
  const u = t + e - 1;
  let c = t, d, f, v, g, m;
  for (a[l++] = o[c], d = 0; d < i - 2; d++) {
    let b = 0, S = 0, R;
    const P = Math.floor((d + 1) * s) + 1 + t, D = Math.min(Math.floor((d + 2) * s) + 1, e) + t, x = D - P;
    for (R = P; R < D; R++)
      b += o[R].x, S += o[R].y;
    b /= x, S /= x;
    const M = Math.floor(d * s) + 1 + t, F = Math.min(Math.floor((d + 1) * s) + 1, e) + t, { x: H, y: B } = o[c];
    for (v = g = -1, R = M; R < F; R++)
      g = 0.5 * Math.abs((H - b) * (o[R].y - B) - (H - o[R].x) * (S - B)), g > v && (v = g, f = o[R], m = R);
    a[l++] = f, c = m;
  }
  return a[l++] = o[u], a;
}
function QW(o, t, e, r) {
  let n = 0, i = 0, a, s, l, u, c, d, f, v, g, m;
  const b = [], S = t + e - 1, R = o[t].x, D = o[S].x - R;
  for (a = t; a < t + e; ++a) {
    s = o[a], l = (s.x - R) / D * r, u = s.y;
    const x = l | 0;
    if (x === c)
      u < g ? (g = u, d = a) : u > m && (m = u, f = a), n = (i * n + s.x) / ++i;
    else {
      const M = a - 1;
      if (!Nt(d) && !Nt(f)) {
        const F = Math.min(d, f), H = Math.max(d, f);
        F !== v && F !== M && b.push({
          ...o[F],
          x: n
        }), H !== v && H !== M && b.push({
          ...o[H],
          x: n
        });
      }
      a > 0 && M !== v && b.push(o[M]), b.push(s), c = x, i = 0, g = m = u, d = f = v = a;
    }
  }
  return b;
}
function AF(o) {
  if (o._decimated) {
    const t = o._data;
    delete o._decimated, delete o._data, Object.defineProperty(o, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function QT(o) {
  o.data.datasets.forEach((t) => {
    AF(t);
  });
}
function JW(o, t) {
  const e = t.length;
  let r = 0, n;
  const { iScale: i } = o, { min: a, max: s, minDefined: l, maxDefined: u } = i.getUserBounds();
  return l && (r = Pn(ms(t, i.axis, a).lo, 0, e - 1)), u ? n = Pn(ms(t, i.axis, s).hi + 1, r, e) - r : n = e - r, {
    start: r,
    count: n
  };
}
var ej = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (o, t, e) => {
    if (!e.enabled) {
      QT(o);
      return;
    }
    const r = o.width;
    o.data.datasets.forEach((n, i) => {
      const { _data: a, indexAxis: s } = n, l = o.getDatasetMeta(i), u = a || n.data;
      if (Fr([
        s,
        o.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const c = o.scales[l.xAxisID];
      if (c.type !== "linear" && c.type !== "time" || o.options.parsing)
        return;
      let { start: d, count: f } = JW(l, u);
      const v = e.threshold || 4 * r;
      if (f <= v) {
        AF(n);
        return;
      }
      Nt(a) && (n._data = u, delete n.data, Object.defineProperty(n, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(m) {
          this._data = m;
        }
      }));
      let g;
      switch (e.algorithm) {
        case "lttb":
          g = ZW(u, d, f, r, e);
          break;
        case "min-max":
          g = QW(u, d, f, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${e.algorithm}'`);
      }
      n._decimated = g;
    });
  },
  destroy(o) {
    QT(o);
  }
};
function tj(o, t, e) {
  const r = o.segments, n = o.points, i = t.points, a = [];
  for (const s of r) {
    let { start: l, end: u } = s;
    u = y1(l, u, n);
    const c = CS(e, n[l], n[u], s.loop);
    if (!t.segments) {
      a.push({
        source: s,
        target: c,
        start: n[l],
        end: n[u]
      });
      continue;
    }
    const d = fF(t, c);
    for (const f of d) {
      const v = CS(e, i[f.start], i[f.end], f.loop), g = pF(s, n, v);
      for (const m of g)
        a.push({
          source: m,
          target: f,
          start: {
            [e]: JT(c, v, "start", Math.max)
          },
          end: {
            [e]: JT(c, v, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function CS(o, t, e, r) {
  if (r)
    return;
  let n = t[o], i = e[o];
  return o === "angle" && (n = ei(n), i = ei(i)), {
    property: o,
    start: n,
    end: i
  };
}
function rj(o, t) {
  const { x: e = null, y: r = null } = o || {}, n = t.points, i = [];
  return t.segments.forEach(({ start: a, end: s }) => {
    s = y1(a, s, n);
    const l = n[a], u = n[s];
    r !== null ? (i.push({
      x: l.x,
      y: r
    }), i.push({
      x: u.x,
      y: r
    })) : e !== null && (i.push({
      x: e,
      y: l.y
    }), i.push({
      x: e,
      y: u.y
    }));
  }), i;
}
function y1(o, t, e) {
  for (; t > o; t--) {
    const r = e[t];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return t;
}
function JT(o, t, e, r) {
  return o && t ? r(o[e], t[e]) : o ? o[e] : t ? t[e] : 0;
}
function MF(o, t) {
  let e = [], r = !1;
  return Lr(o) ? (r = !0, e = o) : e = rj(o, t), e.length ? new xl({
    points: e,
    options: {
      tension: 0
    },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function eO(o) {
  return o && o.fill !== !1;
}
function nj(o, t, e) {
  let n = o[t].fill;
  const i = [
    t
  ];
  let a;
  if (!e)
    return n;
  for (; n !== !1 && i.indexOf(n) === -1; ) {
    if (!Zr(n))
      return n;
    if (a = o[n], !a)
      return !1;
    if (a.visible)
      return n;
    i.push(n), n = a.fill;
  }
  return !1;
}
function oj(o, t, e) {
  const r = lj(o);
  if (Ht(r))
    return isNaN(r.value) ? !1 : r;
  let n = parseFloat(r);
  return Zr(n) && Math.floor(n) === n ? ij(r[0], t, n, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(r) >= 0 && r;
}
function ij(o, t, e, r) {
  return (o === "-" || o === "+") && (e = t + e), e === t || e < 0 || e >= r ? !1 : e;
}
function aj(o, t) {
  let e = null;
  return o === "start" ? e = t.bottom : o === "end" ? e = t.top : Ht(o) ? e = t.getPixelForValue(o.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function sj(o, t, e) {
  let r;
  return o === "start" ? r = e : o === "end" ? r = t.options.reverse ? t.min : t.max : Ht(o) ? r = o.value : r = t.getBaseValue(), r;
}
function lj(o) {
  const t = o.options, e = t.fill;
  let r = xt(e && e.target, e);
  return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function uj(o) {
  const { scale: t, index: e, line: r } = o, n = [], i = r.segments, a = r.points, s = cj(t, e);
  s.push(MF({
    x: null,
    y: t.bottom
  }, r));
  for (let l = 0; l < i.length; l++) {
    const u = i[l];
    for (let c = u.start; c <= u.end; c++)
      dj(n, a[c], s);
  }
  return new xl({
    points: n,
    options: {}
  });
}
function cj(o, t) {
  const e = [], r = o.getMatchingVisibleMetas("line");
  for (let n = 0; n < r.length; n++) {
    const i = r[n];
    if (i.index === t)
      break;
    i.hidden || e.unshift(i.dataset);
  }
  return e;
}
function dj(o, t, e) {
  const r = [];
  for (let n = 0; n < e.length; n++) {
    const i = e[n], { first: a, last: s, point: l } = pj(i, t, "x");
    if (!(!l || a && s)) {
      if (a)
        r.unshift(l);
      else if (o.push(l), !s)
        break;
    }
  }
  o.push(...r);
}
function pj(o, t, e) {
  const r = o.interpolate(t, e);
  if (!r)
    return {};
  const n = r[e], i = o.segments, a = o.points;
  let s = !1, l = !1;
  for (let u = 0; u < i.length; u++) {
    const c = i[u], d = a[c.start][e], f = a[c.end][e];
    if (gs(n, d, f)) {
      s = n === d, l = n === f;
      break;
    }
  }
  return {
    first: s,
    last: l,
    point: r
  };
}
class FF {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, r) {
    const { x: n, y: i, radius: a } = this;
    return e = e || {
      start: 0,
      end: Nr
    }, t.arc(n, i, a, e.end, e.start, !0), !r.bounds;
  }
  interpolate(t) {
    const { x: e, y: r, radius: n } = this, i = t.angle;
    return {
      x: e + Math.cos(i) * n,
      y: r + Math.sin(i) * n,
      angle: i
    };
  }
}
function fj(o) {
  const { chart: t, fill: e, line: r } = o;
  if (Zr(e))
    return hj(t, e);
  if (e === "stack")
    return uj(o);
  if (e === "shape")
    return !0;
  const n = vj(o);
  return n instanceof FF ? n : MF(n, r);
}
function hj(o, t) {
  const e = o.getDatasetMeta(t);
  return e && o.isDatasetVisible(t) ? e.dataset : null;
}
function vj(o) {
  return (o.scale || {}).getPointPositionForValue ? mj(o) : gj(o);
}
function gj(o) {
  const { scale: t = {}, fill: e } = o, r = aj(e, t);
  if (Zr(r)) {
    const n = t.isHorizontal();
    return {
      x: n ? r : null,
      y: n ? null : r
    };
  }
  return null;
}
function mj(o) {
  const { scale: t, fill: e } = o, r = t.options, n = t.getLabels().length, i = r.reverse ? t.max : t.min, a = sj(e, t, i), s = [];
  if (r.grid.circular) {
    const l = t.getPointPositionForValue(0, i);
    return new FF({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(a)
    });
  }
  for (let l = 0; l < n; ++l)
    s.push(t.getPointPositionForValue(l, a));
  return s;
}
function Ew(o, t, e) {
  const r = fj(t), { line: n, scale: i, axis: a } = t, s = n.options, l = s.fill, u = s.backgroundColor, { above: c = u, below: d = u } = l || {};
  r && n.points.length && ($y(o, e), yj(o, {
    line: n,
    target: r,
    above: c,
    below: d,
    area: e,
    scale: i,
    axis: a
  }), zy(o));
}
function yj(o, t) {
  const { line: e, target: r, above: n, below: i, area: a, scale: s } = t, l = e._loop ? "angle" : t.axis;
  o.save(), l === "x" && i !== n && (tO(o, r, a.top), rO(o, {
    line: e,
    target: r,
    color: n,
    scale: s,
    property: l
  }), o.restore(), o.save(), tO(o, r, a.bottom)), rO(o, {
    line: e,
    target: r,
    color: i,
    scale: s,
    property: l
  }), o.restore();
}
function tO(o, t, e) {
  const { segments: r, points: n } = t;
  let i = !0, a = !1;
  o.beginPath();
  for (const s of r) {
    const { start: l, end: u } = s, c = n[l], d = n[y1(l, u, n)];
    i ? (o.moveTo(c.x, c.y), i = !1) : (o.lineTo(c.x, e), o.lineTo(c.x, c.y)), a = !!t.pathSegment(o, s, {
      move: a
    }), a ? o.closePath() : o.lineTo(d.x, e);
  }
  o.lineTo(t.first().x, e), o.closePath(), o.clip();
}
function rO(o, t) {
  const { line: e, target: r, property: n, color: i, scale: a } = t, s = tj(e, r, n);
  for (const { source: l, target: u, start: c, end: d } of s) {
    const { style: { backgroundColor: f = i } = {} } = l, v = r !== !0;
    o.save(), o.fillStyle = f, Cj(o, a, v && CS(n, c, d)), o.beginPath();
    const g = !!e.pathSegment(o, l);
    let m;
    if (v) {
      g ? o.closePath() : nO(o, r, d, n);
      const b = !!r.pathSegment(o, u, {
        move: g,
        reverse: !0
      });
      m = g && b, m || nO(o, r, c, n);
    }
    o.closePath(), o.fill(m ? "evenodd" : "nonzero"), o.restore();
  }
}
function Cj(o, t, e) {
  const { top: r, bottom: n } = t.chart.chartArea, { property: i, start: a, end: s } = e || {};
  i === "x" && (o.beginPath(), o.rect(a, r, s - a, n - r), o.clip());
}
function nO(o, t, e, r) {
  const n = t.interpolate(e, r);
  n && o.lineTo(n.x, n.y);
}
var wj = {
  id: "filler",
  afterDatasetsUpdate(o, t, e) {
    const r = (o.data.datasets || []).length, n = [];
    let i, a, s, l;
    for (a = 0; a < r; ++a)
      i = o.getDatasetMeta(a), s = i.dataset, l = null, s && s.options && s instanceof xl && (l = {
        visible: o.isDatasetVisible(a),
        index: a,
        fill: oj(s, a, r),
        chart: o,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: s
      }), i.$filler = l, n.push(l);
    for (a = 0; a < r; ++a)
      l = n[a], !(!l || l.fill === !1) && (l.fill = nj(n, a, e.propagate));
  },
  beforeDraw(o, t, e) {
    const r = e.drawTime === "beforeDraw", n = o.getSortedVisibleDatasetMetas(), i = o.chartArea;
    for (let a = n.length - 1; a >= 0; --a) {
      const s = n[a].$filler;
      s && (s.line.updateControlPoints(i, s.axis), r && s.fill && Ew(o.ctx, s, i));
    }
  },
  beforeDatasetsDraw(o, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const r = o.getSortedVisibleDatasetMetas();
    for (let n = r.length - 1; n >= 0; --n) {
      const i = r[n].$filler;
      eO(i) && Ew(o.ctx, i, o.chartArea);
    }
  },
  beforeDatasetDraw(o, t, e) {
    const r = t.meta.$filler;
    !eO(r) || e.drawTime !== "beforeDatasetDraw" || Ew(o.ctx, r, o.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const oO = (o, t) => {
  let { boxHeight: e = t, boxWidth: r = t } = o;
  return o.usePointStyle && (e = Math.min(e, t), r = o.pointStyleWidth || Math.min(r, t)), {
    boxWidth: r,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, bj = (o, t) => o !== null && t !== null && o.datasetIndex === t.datasetIndex && o.index === t.index;
class iO extends Rs {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, r) {
    this.maxWidth = t, this.maxHeight = e, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = Tr(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((r) => t.filter(r, this.chart.data))), t.sort && (e = e.sort((r, n) => t.sort(r, n, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const r = t.labels, n = hn(r.font), i = n.size, a = this._computeTitleHeight(), { boxWidth: s, itemHeight: l } = oO(r, i);
    let u, c;
    e.font = n.string, this.isHorizontal() ? (u = this.maxWidth, c = this._fitRows(a, i, s, l) + 10) : (c = this.maxHeight, u = this._fitCols(a, n, s, l) + 10), this.width = Math.min(u, t.maxWidth || this.maxWidth), this.height = Math.min(c, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, r, n) {
    const { ctx: i, maxWidth: a, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], u = this.lineWidths = [
      0
    ], c = n + s;
    let d = t;
    i.textAlign = "left", i.textBaseline = "middle";
    let f = -1, v = -c;
    return this.legendItems.forEach((g, m) => {
      const b = r + e / 2 + i.measureText(g.text).width;
      (m === 0 || u[u.length - 1] + b + 2 * s > a) && (d += c, u[u.length - (m > 0 ? 0 : 1)] = 0, v += c, f++), l[m] = {
        left: 0,
        top: v,
        row: f,
        width: b,
        height: n
      }, u[u.length - 1] += b + s;
    }), d;
  }
  _fitCols(t, e, r, n) {
    const { ctx: i, maxHeight: a, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], u = this.columnSizes = [], c = a - t;
    let d = s, f = 0, v = 0, g = 0, m = 0;
    return this.legendItems.forEach((b, S) => {
      const { itemWidth: R, itemHeight: P } = Sj(r, e, i, b, n);
      S > 0 && v + P + 2 * s > c && (d += f + s, u.push({
        width: f,
        height: v
      }), g += f + s, m++, f = v = 0), l[S] = {
        left: g,
        top: v,
        col: m,
        width: R,
        height: P
      }, f = Math.max(f, R), v += P + s;
    }), d += f, u.push({
      width: f,
      height: v
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: r, labels: { padding: n }, rtl: i } } = this, a = Kd(i, this.left, this.width);
    if (this.isHorizontal()) {
      let s = 0, l = qn(r, this.left + n, this.right - this.lineWidths[s]);
      for (const u of e)
        s !== u.row && (s = u.row, l = qn(r, this.left + n, this.right - this.lineWidths[s])), u.top += this.top + t + n, u.left = a.leftForLtr(a.x(l), u.width), l += u.width + n;
    } else {
      let s = 0, l = qn(r, this.top + t + n, this.bottom - this.columnSizes[s].height);
      for (const u of e)
        u.col !== s && (s = u.col, l = qn(r, this.top + t + n, this.bottom - this.columnSizes[s].height)), u.top = l, u.left += this.left + n, u.left = a.leftForLtr(a.x(u.left), u.width), l += u.height + n;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      $y(t, this), this._draw(), zy(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: r, ctx: n } = this, { align: i, labels: a } = t, s = Yr.color, l = Kd(t.rtl, this.left, this.width), u = hn(a.font), { padding: c } = a, d = u.size, f = d / 2;
    let v;
    this.drawTitle(), n.textAlign = l.textAlign("left"), n.textBaseline = "middle", n.lineWidth = 0.5, n.font = u.string;
    const { boxWidth: g, boxHeight: m, itemHeight: b } = oO(a, d), S = function(M, F, H) {
      if (isNaN(g) || g <= 0 || isNaN(m) || m < 0)
        return;
      n.save();
      const B = xt(H.lineWidth, 1);
      if (n.fillStyle = xt(H.fillStyle, s), n.lineCap = xt(H.lineCap, "butt"), n.lineDashOffset = xt(H.lineDashOffset, 0), n.lineJoin = xt(H.lineJoin, "miter"), n.lineWidth = B, n.strokeStyle = xt(H.strokeStyle, s), n.setLineDash(xt(H.lineDash, [])), a.usePointStyle) {
        const j = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: H.pointStyle,
          rotation: H.rotation,
          borderWidth: B
        }, V = l.xPlus(M, g / 2), W = F + f;
        eF(n, j, V, W, a.pointStyleWidth && g);
      } else {
        const j = F + Math.max((d - m) / 2, 0), V = l.leftForLtr(M, g), W = nc(H.borderRadius);
        n.beginPath(), Object.values(W).some((q) => q !== 0) ? Bh(n, {
          x: V,
          y: j,
          w: g,
          h: m,
          radius: W
        }) : n.rect(V, j, g, m), n.fill(), B !== 0 && n.stroke();
      }
      n.restore();
    }, R = function(M, F, H) {
      fc(n, H.text, M, F + b / 2, u, {
        strikethrough: H.hidden,
        textAlign: l.textAlign(H.textAlign)
      });
    }, P = this.isHorizontal(), D = this._computeTitleHeight();
    P ? v = {
      x: qn(i, this.left + c, this.right - r[0]),
      y: this.top + c + D,
      line: 0
    } : v = {
      x: this.left + c,
      y: qn(i, this.top + D + c, this.bottom - e[0].height),
      line: 0
    }, uF(this.ctx, t.textDirection);
    const x = b + c;
    this.legendItems.forEach((M, F) => {
      n.strokeStyle = M.fontColor, n.fillStyle = M.fontColor;
      const H = n.measureText(M.text).width, B = l.textAlign(M.textAlign || (M.textAlign = a.textAlign)), j = g + f + H;
      let V = v.x, W = v.y;
      l.setWidth(this.width), P ? F > 0 && V + j + c > this.right && (W = v.y += x, v.line++, V = v.x = qn(i, this.left + c, this.right - r[v.line])) : F > 0 && W + x > this.bottom && (V = v.x = V + e[v.line].width + c, v.line++, W = v.y = qn(i, this.top + D + c, this.bottom - e[v.line].height));
      const q = l.x(V);
      if (S(q, W, M), V = j7(B, V + g + f, P ? V + j : this.right, t.rtl), R(l.x(V), W, M), P)
        v.x += j + c;
      else if (typeof M.text != "string") {
        const ee = u.lineHeight;
        v.y += IF(M, ee) + c;
      } else
        v.y += x;
    }), cF(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, r = hn(e.font), n = jn(e.padding);
    if (!e.display)
      return;
    const i = Kd(t.rtl, this.left, this.width), a = this.ctx, s = e.position, l = r.size / 2, u = n.top + l;
    let c, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), c = this.top + u, d = qn(t.align, d, this.right - f);
    else {
      const g = this.columnSizes.reduce((m, b) => Math.max(m, b.height), 0);
      c = u + qn(t.align, this.top, this.bottom - g - t.labels.padding - this._computeTitleHeight());
    }
    const v = qn(s, d, d + f);
    a.textAlign = i.textAlign(c1(s)), a.textBaseline = "middle", a.strokeStyle = e.color, a.fillStyle = e.color, a.font = r.string, fc(a, e.text, v, c, r);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = hn(t.font), r = jn(t.padding);
    return t.display ? e.lineHeight + r.height : 0;
  }
  _getLegendItemAt(t, e) {
    let r, n, i;
    if (gs(t, this.left, this.right) && gs(e, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, r = 0; r < i.length; ++r)
        if (n = i[r], gs(t, n.left, n.left + n.width) && gs(e, n.top, n.top + n.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!xj(t.type, e))
      return;
    const r = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const n = this._hoveredItem, i = bj(n, r);
      n && !i && Tr(e.onLeave, [
        t,
        n,
        this
      ], this), this._hoveredItem = r, r && !i && Tr(e.onHover, [
        t,
        r,
        this
      ], this);
    } else r && Tr(e.onClick, [
      t,
      r,
      this
    ], this);
  }
}
function Sj(o, t, e, r, n) {
  const i = Ej(r, o, t, e), a = _j(n, r, t.lineHeight);
  return {
    itemWidth: i,
    itemHeight: a
  };
}
function Ej(o, t, e, r) {
  let n = o.text;
  return n && typeof n != "string" && (n = n.reduce((i, a) => i.length > a.length ? i : a)), t + e.size / 2 + r.measureText(n).width;
}
function _j(o, t, e) {
  let r = o;
  return typeof t.text != "string" && (r = IF(t, e)), r;
}
function IF(o, t) {
  const e = o.text ? o.text.length : 0;
  return t * e;
}
function xj(o, t) {
  return !!((o === "mousemove" || o === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (o === "click" || o === "mouseup"));
}
var Rj = {
  id: "legend",
  _element: iO,
  start(o, t, e) {
    const r = o.legend = new iO({
      ctx: o.ctx,
      options: e,
      chart: o
    });
    Zn.configure(o, r, e), Zn.addBox(o, r);
  },
  stop(o) {
    Zn.removeBox(o, o.legend), delete o.legend;
  },
  beforeUpdate(o, t, e) {
    const r = o.legend;
    Zn.configure(o, r, e), r.options = e;
  },
  afterUpdate(o) {
    const t = o.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(o, t) {
    t.replay || o.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(o, t, e) {
      const r = t.datasetIndex, n = e.chart;
      n.isDatasetVisible(r) ? (n.hide(r), t.hidden = !0) : (n.show(r), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (o) => o.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(o) {
        const t = o.data.datasets, { labels: { usePointStyle: e, pointStyle: r, textAlign: n, color: i, useBorderRadius: a, borderRadius: s } } = o.legend.options;
        return o._getSortedDatasetMetas().map((l) => {
          const u = l.controller.getStyle(e ? 0 : void 0), c = jn(u.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: u.backgroundColor,
            fontColor: i,
            hidden: !l.visible,
            lineCap: u.borderCapStyle,
            lineDash: u.borderDash,
            lineDashOffset: u.borderDashOffset,
            lineJoin: u.borderJoinStyle,
            lineWidth: (c.width + c.height) / 4,
            strokeStyle: u.borderColor,
            pointStyle: r || u.pointStyle,
            rotation: u.rotation,
            textAlign: n || u.textAlign,
            borderRadius: a && (s || u.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (o) => o.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (o) => !o.startsWith("on"),
    labels: {
      _scriptable: (o) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(o)
    }
  }
};
class C1 extends Rs {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const n = Lr(r.text) ? r.text.length : 1;
    this._padding = jn(r.padding);
    const i = n * hn(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: r, bottom: n, right: i, options: a } = this, s = a.align;
    let l = 0, u, c, d;
    return this.isHorizontal() ? (c = qn(s, r, i), d = e + t, u = i - r) : (a.position === "left" ? (c = r + t, d = qn(s, n, e), l = kr * -0.5) : (c = i - t, d = qn(s, e, n), l = kr * 0.5), u = n - e), {
      titleX: c,
      titleY: d,
      maxWidth: u,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const r = hn(e.font), i = r.lineHeight / 2 + this._padding.top, { titleX: a, titleY: s, maxWidth: l, rotation: u } = this._drawArgs(i);
    fc(t, e.text, 0, 0, r, {
      color: e.color,
      maxWidth: l,
      rotation: u,
      textAlign: c1(e.align),
      textBaseline: "middle",
      translation: [
        a,
        s
      ]
    });
  }
}
function Tj(o, t) {
  const e = new C1({
    ctx: o.ctx,
    options: t,
    chart: o
  });
  Zn.configure(o, e, t), Zn.addBox(o, e), o.titleBlock = e;
}
var Oj = {
  id: "title",
  _element: C1,
  start(o, t, e) {
    Tj(o, e);
  },
  stop(o) {
    const t = o.titleBlock;
    Zn.removeBox(o, t), delete o.titleBlock;
  },
  beforeUpdate(o, t, e) {
    const r = o.titleBlock;
    Zn.configure(o, r, e), r.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Sg = /* @__PURE__ */ new WeakMap();
var Pj = {
  id: "subtitle",
  start(o, t, e) {
    const r = new C1({
      ctx: o.ctx,
      options: e,
      chart: o
    });
    Zn.configure(o, r, e), Zn.addBox(o, r), Sg.set(o, r);
  },
  stop(o) {
    Zn.removeBox(o, Sg.get(o)), Sg.delete(o);
  },
  beforeUpdate(o, t, e) {
    const r = Sg.get(o);
    Zn.configure(o, r, e), r.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const lh = {
  average(o) {
    if (!o.length)
      return !1;
    let t, e, r = 0, n = 0, i = 0;
    for (t = 0, e = o.length; t < e; ++t) {
      const a = o[t].element;
      if (a && a.hasValue()) {
        const s = a.tooltipPosition();
        r += s.x, n += s.y, ++i;
      }
    }
    return {
      x: r / i,
      y: n / i
    };
  },
  nearest(o, t) {
    if (!o.length)
      return !1;
    let e = t.x, r = t.y, n = Number.POSITIVE_INFINITY, i, a, s;
    for (i = 0, a = o.length; i < a; ++i) {
      const l = o[i].element;
      if (l && l.hasValue()) {
        const u = l.getCenterPoint(), c = dS(t, u);
        c < n && (n = c, s = l);
      }
    }
    if (s) {
      const l = s.tooltipPosition();
      e = l.x, r = l.y;
    }
    return {
      x: e,
      y: r
    };
  }
};
function xa(o, t) {
  return t && (Lr(t) ? Array.prototype.push.apply(o, t) : o.push(t)), o;
}
function ps(o) {
  return (typeof o == "string" || o instanceof String) && o.indexOf(`
`) > -1 ? o.split(`
`) : o;
}
function Dj(o, t) {
  const { element: e, datasetIndex: r, index: n } = t, i = o.getDatasetMeta(r).controller, { label: a, value: s } = i.getLabelAndValue(n);
  return {
    chart: o,
    label: a,
    parsed: i.getParsed(n),
    raw: o.data.datasets[r].data[n],
    formattedValue: s,
    dataset: i.getDataset(),
    dataIndex: n,
    datasetIndex: r,
    element: e
  };
}
function aO(o, t) {
  const e = o.chart.ctx, { body: r, footer: n, title: i } = o, { boxWidth: a, boxHeight: s } = t, l = hn(t.bodyFont), u = hn(t.titleFont), c = hn(t.footerFont), d = i.length, f = n.length, v = r.length, g = jn(t.padding);
  let m = g.height, b = 0, S = r.reduce((D, x) => D + x.before.length + x.lines.length + x.after.length, 0);
  if (S += o.beforeBody.length + o.afterBody.length, d && (m += d * u.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), S) {
    const D = t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight;
    m += v * D + (S - v) * l.lineHeight + (S - 1) * t.bodySpacing;
  }
  f && (m += t.footerMarginTop + f * c.lineHeight + (f - 1) * t.footerSpacing);
  let R = 0;
  const P = function(D) {
    b = Math.max(b, e.measureText(D).width + R);
  };
  return e.save(), e.font = u.string, ur(o.title, P), e.font = l.string, ur(o.beforeBody.concat(o.afterBody), P), R = t.displayColors ? a + 2 + t.boxPadding : 0, ur(r, (D) => {
    ur(D.before, P), ur(D.lines, P), ur(D.after, P);
  }), R = 0, e.font = c.string, ur(o.footer, P), e.restore(), b += g.width, {
    width: b,
    height: m
  };
}
function Aj(o, t) {
  const { y: e, height: r } = t;
  return e < r / 2 ? "top" : e > o.height - r / 2 ? "bottom" : "center";
}
function Mj(o, t, e, r) {
  const { x: n, width: i } = r, a = e.caretSize + e.caretPadding;
  if (o === "left" && n + i + a > t.width || o === "right" && n - i - a < 0)
    return !0;
}
function Fj(o, t, e, r) {
  const { x: n, width: i } = e, { width: a, chartArea: { left: s, right: l } } = o;
  let u = "center";
  return r === "center" ? u = n <= (s + l) / 2 ? "left" : "right" : n <= i / 2 ? u = "left" : n >= a - i / 2 && (u = "right"), Mj(u, o, t, e) && (u = "center"), u;
}
function sO(o, t, e) {
  const r = e.yAlign || t.yAlign || Aj(o, e);
  return {
    xAlign: e.xAlign || t.xAlign || Fj(o, t, e, r),
    yAlign: r
  };
}
function Ij(o, t) {
  let { x: e, width: r } = o;
  return t === "right" ? e -= r : t === "center" && (e -= r / 2), e;
}
function Lj(o, t, e) {
  let { y: r, height: n } = o;
  return t === "top" ? r += e : t === "bottom" ? r -= n + e : r -= n / 2, r;
}
function lO(o, t, e, r) {
  const { caretSize: n, caretPadding: i, cornerRadius: a } = o, { xAlign: s, yAlign: l } = e, u = n + i, { topLeft: c, topRight: d, bottomLeft: f, bottomRight: v } = nc(a);
  let g = Ij(t, s);
  const m = Lj(t, l, u);
  return l === "center" ? s === "left" ? g += u : s === "right" && (g -= u) : s === "left" ? g -= Math.max(c, f) + n : s === "right" && (g += Math.max(d, v) + n), {
    x: Pn(g, 0, r.width - t.width),
    y: Pn(m, 0, r.height - t.height)
  };
}
function Eg(o, t, e) {
  const r = jn(e.padding);
  return t === "center" ? o.x + o.width / 2 : t === "right" ? o.x + o.width - r.right : o.x + r.left;
}
function uO(o) {
  return xa([], ps(o));
}
function Nj(o, t, e) {
  return Wl(o, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function cO(o, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? o.override(e) : o;
}
const LF = {
  beforeTitle: ls,
  title(o) {
    if (o.length > 0) {
      const t = o[0], e = t.chart.data.labels, r = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: ls,
  beforeBody: ls,
  beforeLabel: ls,
  label(o) {
    if (this && this.options && this.options.mode === "dataset")
      return o.label + ": " + o.formattedValue || o.formattedValue;
    let t = o.dataset.label || "";
    t && (t += ": ");
    const e = o.formattedValue;
    return Nt(e) || (t += e), t;
  },
  labelColor(o) {
    const e = o.chart.getDatasetMeta(o.datasetIndex).controller.getStyle(o.dataIndex);
    return {
      borderColor: e.borderColor,
      backgroundColor: e.backgroundColor,
      borderWidth: e.borderWidth,
      borderDash: e.borderDash,
      borderDashOffset: e.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(o) {
    const e = o.chart.getDatasetMeta(o.datasetIndex).controller.getStyle(o.dataIndex);
    return {
      pointStyle: e.pointStyle,
      rotation: e.rotation
    };
  },
  afterLabel: ls,
  afterBody: ls,
  beforeFooter: ls,
  footer: ls,
  afterFooter: ls
};
function _o(o, t, e, r) {
  const n = o[t].call(e, r);
  return typeof n > "u" ? LF[t].call(e, r) : n;
}
var kb;
let dO = (kb = class extends Rs {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, r = this.options.setContext(this.getContext()), n = r.enabled && e.options.animation && r.animations, i = new hF(this.chart, n);
    return n._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Nj(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: r } = e, n = _o(r, "beforeTitle", this, t), i = _o(r, "title", this, t), a = _o(r, "afterTitle", this, t);
    let s = [];
    return s = xa(s, ps(n)), s = xa(s, ps(i)), s = xa(s, ps(a)), s;
  }
  getBeforeBody(t, e) {
    return uO(_o(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: r } = e, n = [];
    return ur(t, (i) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, s = cO(r, i);
      xa(a.before, ps(_o(s, "beforeLabel", this, i))), xa(a.lines, _o(s, "label", this, i)), xa(a.after, ps(_o(s, "afterLabel", this, i))), n.push(a);
    }), n;
  }
  getAfterBody(t, e) {
    return uO(_o(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: r } = e, n = _o(r, "beforeFooter", this, t), i = _o(r, "footer", this, t), a = _o(r, "afterFooter", this, t);
    let s = [];
    return s = xa(s, ps(n)), s = xa(s, ps(i)), s = xa(s, ps(a)), s;
  }
  _createItems(t) {
    const e = this._active, r = this.chart.data, n = [], i = [], a = [];
    let s = [], l, u;
    for (l = 0, u = e.length; l < u; ++l)
      s.push(Dj(this.chart, e[l]));
    return t.filter && (s = s.filter((c, d, f) => t.filter(c, d, f, r))), t.itemSort && (s = s.sort((c, d) => t.itemSort(c, d, r))), ur(s, (c) => {
      const d = cO(t.callbacks, c);
      n.push(_o(d, "labelColor", this, c)), i.push(_o(d, "labelPointStyle", this, c)), a.push(_o(d, "labelTextColor", this, c));
    }), this.labelColors = n, this.labelPointStyles = i, this.labelTextColors = a, this.dataPoints = s, s;
  }
  update(t, e) {
    const r = this.options.setContext(this.getContext()), n = this._active;
    let i, a = [];
    if (!n.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const s = lh[r.position].call(this, n, this._eventPosition);
      a = this._createItems(r), this.title = this.getTitle(a, r), this.beforeBody = this.getBeforeBody(a, r), this.body = this.getBody(a, r), this.afterBody = this.getAfterBody(a, r), this.footer = this.getFooter(a, r);
      const l = this._size = aO(this, r), u = Object.assign({}, s, l), c = sO(this.chart, r, u), d = lO(r, u, c, this.chart);
      this.xAlign = c.xAlign, this.yAlign = c.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: s.x,
        caretY: s.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, r, n) {
    const i = this.getCaretPosition(t, r, n);
    e.lineTo(i.x1, i.y1), e.lineTo(i.x2, i.y2), e.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, e, r) {
    const { xAlign: n, yAlign: i } = this, { caretSize: a, cornerRadius: s } = r, { topLeft: l, topRight: u, bottomLeft: c, bottomRight: d } = nc(s), { x: f, y: v } = t, { width: g, height: m } = e;
    let b, S, R, P, D, x;
    return i === "center" ? (D = v + m / 2, n === "left" ? (b = f, S = b - a, P = D + a, x = D - a) : (b = f + g, S = b + a, P = D - a, x = D + a), R = b) : (n === "left" ? S = f + Math.max(l, c) + a : n === "right" ? S = f + g - Math.max(u, d) - a : S = this.caretX, i === "top" ? (P = v, D = P - a, b = S - a, R = S + a) : (P = v + m, D = P + a, b = S + a, R = S - a), x = P), {
      x1: b,
      x2: S,
      x3: R,
      y1: P,
      y2: D,
      y3: x
    };
  }
  drawTitle(t, e, r) {
    const n = this.title, i = n.length;
    let a, s, l;
    if (i) {
      const u = Kd(r.rtl, this.x, this.width);
      for (t.x = Eg(this, r.titleAlign, r), e.textAlign = u.textAlign(r.titleAlign), e.textBaseline = "middle", a = hn(r.titleFont), s = r.titleSpacing, e.fillStyle = r.titleColor, e.font = a.string, l = 0; l < i; ++l)
        e.fillText(n[l], u.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + s, l + 1 === i && (t.y += r.titleMarginBottom - s);
    }
  }
  _drawColorBox(t, e, r, n, i) {
    const a = this.labelColors[r], s = this.labelPointStyles[r], { boxHeight: l, boxWidth: u } = i, c = hn(i.bodyFont), d = Eg(this, "left", i), f = n.x(d), v = l < c.lineHeight ? (c.lineHeight - l) / 2 : 0, g = e.y + v;
    if (i.usePointStyle) {
      const m = {
        radius: Math.min(u, l) / 2,
        pointStyle: s.pointStyle,
        rotation: s.rotation,
        borderWidth: 1
      }, b = n.leftForLtr(f, u) + u / 2, S = g + l / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, fS(t, m, b, S), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, fS(t, m, b, S);
    } else {
      t.lineWidth = Ht(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const m = n.leftForLtr(f, u), b = n.leftForLtr(n.xPlus(f, 1), u - 2), S = nc(a.borderRadius);
      Object.values(S).some((R) => R !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, Bh(t, {
        x: m,
        y: g,
        w: u,
        h: l,
        radius: S
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), Bh(t, {
        x: b,
        y: g + 1,
        w: u - 2,
        h: l - 2,
        radius: S
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(m, g, u, l), t.strokeRect(m, g, u, l), t.fillStyle = a.backgroundColor, t.fillRect(b, g + 1, u - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, e, r) {
    const { body: n } = this, { bodySpacing: i, bodyAlign: a, displayColors: s, boxHeight: l, boxWidth: u, boxPadding: c } = r, d = hn(r.bodyFont);
    let f = d.lineHeight, v = 0;
    const g = Kd(r.rtl, this.x, this.width), m = function(H) {
      e.fillText(H, g.x(t.x + v), t.y + f / 2), t.y += f + i;
    }, b = g.textAlign(a);
    let S, R, P, D, x, M, F;
    for (e.textAlign = a, e.textBaseline = "middle", e.font = d.string, t.x = Eg(this, b, r), e.fillStyle = r.bodyColor, ur(this.beforeBody, m), v = s && b !== "right" ? a === "center" ? u / 2 + c : u + 2 + c : 0, D = 0, M = n.length; D < M; ++D) {
      for (S = n[D], R = this.labelTextColors[D], e.fillStyle = R, ur(S.before, m), P = S.lines, s && P.length && (this._drawColorBox(e, t, D, g, r), f = Math.max(d.lineHeight, l)), x = 0, F = P.length; x < F; ++x)
        m(P[x]), f = d.lineHeight;
      ur(S.after, m);
    }
    v = 0, f = d.lineHeight, ur(this.afterBody, m), t.y -= i;
  }
  drawFooter(t, e, r) {
    const n = this.footer, i = n.length;
    let a, s;
    if (i) {
      const l = Kd(r.rtl, this.x, this.width);
      for (t.x = Eg(this, r.footerAlign, r), t.y += r.footerMarginTop, e.textAlign = l.textAlign(r.footerAlign), e.textBaseline = "middle", a = hn(r.footerFont), e.fillStyle = r.footerColor, e.font = a.string, s = 0; s < i; ++s)
        e.fillText(n[s], l.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, e, r, n) {
    const { xAlign: i, yAlign: a } = this, { x: s, y: l } = t, { width: u, height: c } = r, { topLeft: d, topRight: f, bottomLeft: v, bottomRight: g } = nc(n.cornerRadius);
    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.beginPath(), e.moveTo(s + d, l), a === "top" && this.drawCaret(t, e, r, n), e.lineTo(s + u - f, l), e.quadraticCurveTo(s + u, l, s + u, l + f), a === "center" && i === "right" && this.drawCaret(t, e, r, n), e.lineTo(s + u, l + c - g), e.quadraticCurveTo(s + u, l + c, s + u - g, l + c), a === "bottom" && this.drawCaret(t, e, r, n), e.lineTo(s + v, l + c), e.quadraticCurveTo(s, l + c, s, l + c - v), a === "center" && i === "left" && this.drawCaret(t, e, r, n), e.lineTo(s, l + d), e.quadraticCurveTo(s, l, s + d, l), e.closePath(), e.fill(), n.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, r = this.$animations, n = r && r.x, i = r && r.y;
    if (n || i) {
      const a = lh[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const s = this._size = aO(this, t), l = Object.assign({}, a, this._size), u = sO(e, t, l), c = lO(t, l, u, e);
      (n._to !== c.x || i._to !== c.y) && (this.xAlign = u.xAlign, this.yAlign = u.yAlign, this.width = s.width, this.height = s.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, c));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(e);
    const n = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const a = jn(e.padding), s = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && s && (t.save(), t.globalAlpha = r, this.drawBackground(i, t, n, e), uF(t, e.textDirection), i.y += a.top, this.drawTitle(i, t, e), this.drawBody(i, t, e), this.drawFooter(i, t, e), cF(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const r = this._active, n = t.map(({ datasetIndex: s, index: l }) => {
      const u = this.chart.getDatasetMeta(s);
      if (!u)
        throw new Error("Cannot find a dataset at index " + s);
      return {
        datasetIndex: s,
        element: u.data[l],
        index: l
      };
    }), i = !Gm(r, n), a = this._positionChanged(n, e);
    (i || a) && (this._active = n, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, r = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const n = this.options, i = this._active || [], a = this._getActiveElements(t, i, e, r), s = this._positionChanged(a, t), l = e || !Gm(a, i) || s;
    return l && (this._active = a, (n.enabled || n.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), l;
  }
  _getActiveElements(t, e, r, n) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e;
    const a = this.chart.getElementsAtEventForMode(t, i.mode, i, r);
    return i.reverse && a.reverse(), a;
  }
  _positionChanged(t, e) {
    const { caretX: r, caretY: n, options: i } = this, a = lh[i.position].call(this, t, e);
    return a !== !1 && (r !== a.x || n !== a.y);
  }
}, We(kb, "positioners", lh), kb);
var kj = {
  id: "tooltip",
  _element: dO,
  positioners: lh,
  afterInit(o, t, e) {
    e && (o.tooltip = new dO({
      chart: o,
      options: e
    }));
  },
  beforeUpdate(o, t, e) {
    o.tooltip && o.tooltip.initialize(e);
  },
  reset(o, t, e) {
    o.tooltip && o.tooltip.initialize(e);
  },
  afterDraw(o) {
    const t = o.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (o.notifyPlugins("beforeTooltipDraw", {
        ...e,
        cancelable: !0
      }) === !1)
        return;
      t.draw(o.ctx), o.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(o, t) {
    if (o.tooltip) {
      const e = t.replay;
      o.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (o, t) => t.bodyFont.size,
    boxWidth: (o, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: LF
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (o) => o !== "filter" && o !== "itemSort" && o !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, Gj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: XW,
  Decimation: ej,
  Filler: wj,
  Legend: Rj,
  SubTitle: Pj,
  Title: Oj,
  Tooltip: kj
});
const Vj = (o, t, e, r) => (typeof t == "string" ? (e = o.push(t) - 1, r.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function Hj(o, t, e, r) {
  const n = o.indexOf(t);
  if (n === -1)
    return Vj(o, t, e, r);
  const i = o.lastIndexOf(t);
  return n !== i ? e : n;
}
const Bj = (o, t) => o === null ? null : Pn(Math.round(o), 0, t);
function pO(o) {
  const t = this.getLabels();
  return o >= 0 && o < t.length ? t[o] : o;
}
class wS extends Sc {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const r = this.getLabels();
      for (const { index: n, label: i } of e)
        r[n] === i && r.splice(n, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (Nt(t))
      return null;
    const r = this.getLabels();
    return e = isFinite(e) && r[e] === t ? e : Hj(r, t, xt(e, t), this._addedLabels), Bj(e, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: r, max: n } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), e || (n = this.getLabels().length - 1)), this.min = r, this.max = n;
  }
  buildTicks() {
    const t = this.min, e = this.max, r = this.options.offset, n = [];
    let i = this.getLabels();
    i = t === 0 && e === i.length - 1 ? i : i.slice(t, e + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let a = t; a <= e; a++)
      n.push({
        value: a
      });
    return n;
  }
  getLabelForValue(t) {
    return pO.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
We(wS, "id", "category"), We(wS, "defaults", {
  ticks: {
    callback: pO
  }
});
function Wj(o, t) {
  const e = [], { bounds: n, step: i, min: a, max: s, precision: l, count: u, maxTicks: c, maxDigits: d, includeBounds: f } = o, v = i || 1, g = c - 1, { min: m, max: b } = t, S = !Nt(a), R = !Nt(s), P = !Nt(u), D = (b - m) / (d + 1);
  let x = iT((b - m) / g / v) * v, M, F, H, B;
  if (x < 1e-14 && !S && !R)
    return [
      {
        value: m
      },
      {
        value: b
      }
    ];
  B = Math.ceil(b / x) - Math.floor(m / x), B > g && (x = iT(B * x / g / v) * v), Nt(l) || (M = Math.pow(10, l), x = Math.ceil(x * M) / M), n === "ticks" ? (F = Math.floor(m / x) * x, H = Math.ceil(b / x) * x) : (F = m, H = b), S && R && i && N7((s - a) / i, x / 1e3) ? (B = Math.round(Math.min((s - a) / x, c)), x = (s - a) / B, F = a, H = s) : P ? (F = S ? a : F, H = R ? s : H, B = u - 1, x = (H - F) / B) : (B = (H - F) / x, Ch(B, Math.round(B), x / 1e3) ? B = Math.round(B) : B = Math.ceil(B));
  const j = Math.max(aT(x), aT(F));
  M = Math.pow(10, Nt(l) ? j : l), F = Math.round(F * M) / M, H = Math.round(H * M) / M;
  let V = 0;
  for (S && (f && F !== a ? (e.push({
    value: a
  }), F < a && V++, Ch(Math.round((F + V * x) * M) / M, a, fO(a, D, o)) && V++) : F < a && V++); V < B; ++V) {
    const W = Math.round((F + V * x) * M) / M;
    if (R && W > s)
      break;
    e.push({
      value: W
    });
  }
  return R && f && H !== s ? e.length && Ch(e[e.length - 1].value, s, fO(s, D, o)) ? e[e.length - 1].value = s : e.push({
    value: s
  }) : (!R || H === s) && e.push({
    value: H
  }), e;
}
function fO(o, t, { horizontal: e, minRotation: r }) {
  const n = Qi(r), i = (e ? Math.sin(n) : Math.cos(n)) || 1e-3, a = 0.75 * t * ("" + o).length;
  return Math.min(t / i, a);
}
class $m extends Sc {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return Nt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: r } = this.getUserBounds();
    let { min: n, max: i } = this;
    const a = (l) => n = e ? n : l, s = (l) => i = r ? i : l;
    if (t) {
      const l = Fa(n), u = Fa(i);
      l < 0 && u < 0 ? s(0) : l > 0 && u > 0 && a(0);
    }
    if (n === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      s(i + l), t || a(n - l);
    }
    this.min = n, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: r } = t, n;
    return r ? (n = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, n > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${n} ticks. Limiting to 1000.`), n = 1e3)) : (n = this.computeTickLimit(), e = e || 11), e && (n = Math.min(e, n)), n;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const n = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, i = this._range || this, a = Wj(n, i);
    return t.bounds === "ticks" && $M(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const n = (r - e) / Math.max(t.length - 1, 1) / 2;
      e -= n, r += n;
    }
    this._startValue = e, this._endValue = r, this._valueRange = r - e;
  }
  getLabelForValue(t) {
    return sv(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class bS extends $m {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = Zr(t) ? t : 0, this.max = Zr(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, r = Qi(this.options.ticks.minRotation), n = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, i.lineHeight / n));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
We(bS, "id", "linear"), We(bS, "defaults", {
  ticks: {
    callback: Uy.formatters.numeric
  }
});
const jh = (o) => Math.floor(_l(o)), Mu = (o, t) => Math.pow(10, jh(o) + t);
function hO(o) {
  return o / Math.pow(10, jh(o)) === 1;
}
function vO(o, t, e) {
  const r = Math.pow(10, e), n = Math.floor(o / r);
  return Math.ceil(t / r) - n;
}
function jj(o, t) {
  const e = t - o;
  let r = jh(e);
  for (; vO(o, t, r) > 10; )
    r++;
  for (; vO(o, t, r) < 10; )
    r--;
  return Math.min(r, jh(o));
}
function Uj(o, { min: t, max: e }) {
  t = Jo(o.min, t);
  const r = [], n = jh(t);
  let i = jj(t, e), a = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const s = Math.pow(10, i), l = n > i ? Math.pow(10, n) : 0, u = Math.round((t - l) * a) / a, c = Math.floor((t - l) / s / 10) * s * 10;
  let d = Math.floor((u - c) / Math.pow(10, i)), f = Jo(o.min, Math.round((l + c + d * Math.pow(10, i)) * a) / a);
  for (; f < e; )
    r.push({
      value: f,
      major: hO(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (i++, d = 2, a = i >= 0 ? 1 : a), f = Math.round((l + c + d * Math.pow(10, i)) * a) / a;
  const v = Jo(o.max, f);
  return r.push({
    value: v,
    major: hO(v),
    significand: d
  }), r;
}
class SS extends Sc {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const r = $m.prototype.parse.apply(this, [
      t,
      e
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return Zr(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = Zr(t) ? Math.max(0, t) : null, this.max = Zr(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Zr(this._userMin) && (this.min = t === Mu(this.min, 0) ? Mu(this.min, -1) : Mu(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let r = this.min, n = this.max;
    const i = (s) => r = t ? r : s, a = (s) => n = e ? n : s;
    r === n && (r <= 0 ? (i(1), a(10)) : (i(Mu(r, -1)), a(Mu(n, 1)))), r <= 0 && i(Mu(n, -1)), n <= 0 && a(Mu(r, 1)), this.min = r, this.max = n;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, r = Uj(e, this);
    return t.bounds === "ticks" && $M(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : sv(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = _l(t), this._valueRange = _l(this.max) - _l(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (_l(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
We(SS, "id", "logarithmic"), We(SS, "defaults", {
  ticks: {
    callback: Uy.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function ES(o) {
  const t = o.ticks;
  if (t.display && o.display) {
    const e = jn(t.backdropPadding);
    return xt(t.font && t.font.size, Yr.font.size) + e.height;
  }
  return 0;
}
function $j(o, t, e) {
  return e = Lr(e) ? e : [
    e
  ], {
    w: J7(o, t.string, e),
    h: e.length * t.lineHeight
  };
}
function gO(o, t, e, r, n) {
  return o === r || o === n ? {
    start: t - e / 2,
    end: t + e / 2
  } : o < r || o > n ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function zj(o) {
  const t = {
    l: o.left + o._padding.left,
    r: o.right - o._padding.right,
    t: o.top + o._padding.top,
    b: o.bottom - o._padding.bottom
  }, e = Object.assign({}, t), r = [], n = [], i = o._pointLabels.length, a = o.options.pointLabels, s = a.centerPointLabels ? kr / i : 0;
  for (let l = 0; l < i; l++) {
    const u = a.setContext(o.getPointLabelContext(l));
    n[l] = u.padding;
    const c = o.getPointPosition(l, o.drawingArea + n[l], s), d = hn(u.font), f = $j(o.ctx, d, o._pointLabels[l]);
    r[l] = f;
    const v = ei(o.getIndexAngle(l) + s), g = Math.round(l1(v)), m = gO(g, c.x, f.w, 0, 180), b = gO(g, c.y, f.h, 90, 270);
    Yj(e, t, v, m, b);
  }
  o.setCenterPoint(t.l - e.l, e.r - t.r, t.t - e.t, e.b - t.b), o._pointLabelItems = Xj(o, r, n);
}
function Yj(o, t, e, r, n) {
  const i = Math.abs(Math.sin(e)), a = Math.abs(Math.cos(e));
  let s = 0, l = 0;
  r.start < t.l ? (s = (t.l - r.start) / i, o.l = Math.min(o.l, t.l - s)) : r.end > t.r && (s = (r.end - t.r) / i, o.r = Math.max(o.r, t.r + s)), n.start < t.t ? (l = (t.t - n.start) / a, o.t = Math.min(o.t, t.t - l)) : n.end > t.b && (l = (n.end - t.b) / a, o.b = Math.max(o.b, t.b + l));
}
function Kj(o, t, e) {
  const r = o.drawingArea, { extra: n, additionalAngle: i, padding: a, size: s } = e, l = o.getPointPosition(t, r + n + a, i), u = Math.round(l1(ei(l.angle + an))), c = Jj(l.y, s.h, u), d = Zj(u), f = Qj(l.x, s.w, d);
  return {
    visible: !0,
    x: l.x,
    y: c,
    textAlign: d,
    left: f,
    top: c,
    right: f + s.w,
    bottom: c + s.h
  };
}
function qj(o, t) {
  if (!t)
    return !0;
  const { left: e, top: r, right: n, bottom: i } = o;
  return !(ys({
    x: e,
    y: r
  }, t) || ys({
    x: e,
    y: i
  }, t) || ys({
    x: n,
    y: r
  }, t) || ys({
    x: n,
    y: i
  }, t));
}
function Xj(o, t, e) {
  const r = [], n = o._pointLabels.length, i = o.options, { centerPointLabels: a, display: s } = i.pointLabels, l = {
    extra: ES(i) / 2,
    additionalAngle: a ? kr / n : 0
  };
  let u;
  for (let c = 0; c < n; c++) {
    l.padding = e[c], l.size = t[c];
    const d = Kj(o, c, l);
    r.push(d), s === "auto" && (d.visible = qj(d, u), d.visible && (u = d));
  }
  return r;
}
function Zj(o) {
  return o === 0 || o === 180 ? "center" : o < 180 ? "left" : "right";
}
function Qj(o, t, e) {
  return e === "right" ? o -= t : e === "center" && (o -= t / 2), o;
}
function Jj(o, t, e) {
  return e === 90 || e === 270 ? o -= t / 2 : (e > 270 || e < 90) && (o -= t), o;
}
function eU(o, t, e) {
  const { left: r, top: n, right: i, bottom: a } = e, { backdropColor: s } = t;
  if (!Nt(s)) {
    const l = nc(t.borderRadius), u = jn(t.backdropPadding);
    o.fillStyle = s;
    const c = r - u.left, d = n - u.top, f = i - r + u.width, v = a - n + u.height;
    Object.values(l).some((g) => g !== 0) ? (o.beginPath(), Bh(o, {
      x: c,
      y: d,
      w: f,
      h: v,
      radius: l
    }), o.fill()) : o.fillRect(c, d, f, v);
  }
}
function tU(o, t) {
  const { ctx: e, options: { pointLabels: r } } = o;
  for (let n = t - 1; n >= 0; n--) {
    const i = o._pointLabelItems[n];
    if (!i.visible)
      continue;
    const a = r.setContext(o.getPointLabelContext(n));
    eU(e, a, i);
    const s = hn(a.font), { x: l, y: u, textAlign: c } = i;
    fc(e, o._pointLabels[n], l, u + s.lineHeight / 2, s, {
      color: a.color,
      textAlign: c,
      textBaseline: "middle"
    });
  }
}
function NF(o, t, e, r) {
  const { ctx: n } = o;
  if (e)
    n.arc(o.xCenter, o.yCenter, t, 0, Nr);
  else {
    let i = o.getPointPosition(0, t);
    n.moveTo(i.x, i.y);
    for (let a = 1; a < r; a++)
      i = o.getPointPosition(a, t), n.lineTo(i.x, i.y);
  }
}
function rU(o, t, e, r, n) {
  const i = o.ctx, a = t.circular, { color: s, lineWidth: l } = t;
  !a && !r || !s || !l || e < 0 || (i.save(), i.strokeStyle = s, i.lineWidth = l, i.setLineDash(n.dash), i.lineDashOffset = n.dashOffset, i.beginPath(), NF(o, e, a, r), i.closePath(), i.stroke(), i.restore());
}
function nU(o, t, e) {
  return Wl(o, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class uh extends $m {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = jn(ES(this.options) / 2), e = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = Zr(t) && !isNaN(t) ? t : 0, this.max = Zr(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / ES(this.options));
  }
  generateTickLabels(t) {
    $m.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, r) => {
      const n = Tr(this.options.pointLabels.callback, [
        e,
        r
      ], this);
      return n || n === 0 ? n : "";
    }).filter((e, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? zj(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, r, n) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((r - n) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, r, n));
  }
  getIndexAngle(t) {
    const e = Nr / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return ei(t * e + Qi(r));
  }
  getDistanceFromCenterForValue(t) {
    if (Nt(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if (Nt(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const r = e[t];
      return nU(this.getContext(), t, r);
    }
  }
  getPointPosition(t, e, r = 0) {
    const n = this.getIndexAngle(t) - an + r;
    return {
      x: Math.cos(n) * e + this.xCenter,
      y: Math.sin(n) * e + this.yCenter,
      angle: n
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: r, right: n, bottom: i } = this._pointLabelItems[t];
    return {
      left: e,
      top: r,
      right: n,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), NF(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: r, grid: n, border: i } = e, a = this._pointLabels.length;
    let s, l, u;
    if (e.pointLabels.display && tU(this, a), n.display && this.ticks.forEach((c, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(c.value);
        const f = this.getContext(d), v = n.setContext(f), g = i.setContext(f);
        rU(this, v, l, a, g);
      }
    }), r.display) {
      for (t.save(), s = a - 1; s >= 0; s--) {
        const c = r.setContext(this.getPointLabelContext(s)), { color: d, lineWidth: f } = c;
        !f || !d || (t.lineWidth = f, t.strokeStyle = d, t.setLineDash(c.borderDash), t.lineDashOffset = c.borderDashOffset, l = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), u = this.getPointPosition(s, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(u.x, u.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, r = e.ticks;
    if (!r.display)
      return;
    const n = this.getIndexAngle(0);
    let i, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(n), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((s, l) => {
      if (l === 0 && !e.reverse)
        return;
      const u = r.setContext(this.getContext(l)), c = hn(u.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), u.showLabelBackdrop) {
        t.font = c.string, a = t.measureText(s.label).width, t.fillStyle = u.backdropColor;
        const d = jn(u.backdropPadding);
        t.fillRect(-a / 2 - d.left, -i - c.size / 2 - d.top, a + d.width, c.size + d.height);
      }
      fc(t, s.label, 0, -i, c, {
        color: u.color,
        strokeColor: u.textStrokeColor,
        strokeWidth: u.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
We(uh, "id", "radialLinear"), We(uh, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Uy.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), We(uh, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), We(uh, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Ky = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Lo = /* @__PURE__ */ Object.keys(Ky);
function mO(o, t) {
  return o - t;
}
function yO(o, t) {
  if (Nt(t))
    return null;
  const e = o._adapter, { parser: r, round: n, isoWeekday: i } = o._parseOpts;
  let a = t;
  return typeof r == "function" && (a = r(a)), Zr(a) || (a = typeof r == "string" ? e.parse(a, r) : e.parse(a)), a === null ? null : (n && (a = n === "week" && (op(i) || i === !0) ? e.startOf(a, "isoWeek", i) : e.startOf(a, n)), +a);
}
function CO(o, t, e, r) {
  const n = Lo.length;
  for (let i = Lo.indexOf(o); i < n - 1; ++i) {
    const a = Ky[Lo[i]], s = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((e - t) / (s * a.size)) <= r)
      return Lo[i];
  }
  return Lo[n - 1];
}
function oU(o, t, e, r, n) {
  for (let i = Lo.length - 1; i >= Lo.indexOf(e); i--) {
    const a = Lo[i];
    if (Ky[a].common && o._adapter.diff(n, r, a) >= t - 1)
      return a;
  }
  return Lo[e ? Lo.indexOf(e) : 0];
}
function iU(o) {
  for (let t = Lo.indexOf(o) + 1, e = Lo.length; t < e; ++t)
    if (Ky[Lo[t]].common)
      return Lo[t];
}
function wO(o, t, e) {
  if (!e)
    o[t] = !0;
  else if (e.length) {
    const { lo: r, hi: n } = u1(e, t), i = e[r] >= t ? e[r] : e[n];
    o[i] = !0;
  }
}
function aU(o, t, e, r) {
  const n = o._adapter, i = +n.startOf(t[0].value, r), a = t[t.length - 1].value;
  let s, l;
  for (s = i; s <= a; s = +n.add(s, 1, r))
    l = e[s], l >= 0 && (t[l].major = !0);
  return t;
}
function bO(o, t, e) {
  const r = [], n = {}, i = t.length;
  let a, s;
  for (a = 0; a < i; ++a)
    s = t[a], n[s] = a, r.push({
      value: s,
      major: !1
    });
  return i === 0 || !e ? r : aU(o, r, n, e);
}
class Uh extends Sc {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e = {}) {
    const r = t.time || (t.time = {}), n = this._adapter = new vB._date(t.adapters.date);
    n.init(e), yh(r.displayFormats, n.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : yO(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, r = t.time.unit || "day";
    let { min: n, max: i, minDefined: a, maxDefined: s } = this.getUserBounds();
    function l(u) {
      !a && !isNaN(u.min) && (n = Math.min(n, u.min)), !s && !isNaN(u.max) && (i = Math.max(i, u.max));
    }
    (!a || !s) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), n = Zr(n) && !isNaN(n) ? n : +e.startOf(Date.now(), r), i = Zr(i) && !isNaN(i) ? i : +e.endOf(Date.now(), r) + 1, this.min = Math.min(n, i - 1), this.max = Math.max(n + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], r = t[t.length - 1]), {
      min: e,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, e = t.time, r = t.ticks, n = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && n.length && (this.min = this._userMin || n[0], this.max = this._userMax || n[n.length - 1]);
    const i = this.min, a = this.max, s = H7(n, i, a);
    return this._unit = e.unit || (r.autoSkip ? CO(e.minUnit, this.min, this.max, this._getLabelCapacity(i)) : oU(this, s.length, e.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : iU(this._unit), this.initOffsets(n), t.reverse && s.reverse(), bO(this, s, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let e = 0, r = 0, n, i;
    this.options.offset && t.length && (n = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - n : e = (this.getDecimalForValue(t[1]) - n) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = i : r = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    e = Pn(e, 0, a), r = Pn(r, 0, a), this._offsets = {
      start: e,
      end: r,
      factor: 1 / (e + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, e = this.min, r = this.max, n = this.options, i = n.time, a = i.unit || CO(i.minUnit, e, r, this._getLabelCapacity(e)), s = xt(n.ticks.stepSize, 1), l = a === "week" ? i.isoWeekday : !1, u = op(l) || l === !0, c = {};
    let d = e, f, v;
    if (u && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, u ? "day" : a), t.diff(r, e, a) > 1e5 * s)
      throw new Error(e + " and " + r + " are too far apart with stepSize of " + s + " " + a);
    const g = n.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, v = 0; f < r; f = +t.add(f, s, a), v++)
      wO(c, f, g);
    return (f === r || n.bounds === "ticks" || v === 1) && wO(c, f, g), Object.keys(c).sort(mO).map((m) => +m);
  }
  getLabelForValue(t) {
    const e = this._adapter, r = this.options.time;
    return r.tooltipFormat ? e.format(t, r.tooltipFormat) : e.format(t, r.displayFormats.datetime);
  }
  format(t, e) {
    const n = this.options.time.displayFormats, i = this._unit, a = e || n[i];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, e, r, n) {
    const i = this.options, a = i.ticks.callback;
    if (a)
      return Tr(a, [
        t,
        e,
        r
      ], this);
    const s = i.time.displayFormats, l = this._unit, u = this._majorUnit, c = l && s[l], d = u && s[u], f = r[e], v = u && d && f && f.major;
    return this._adapter.format(t, n || (v ? d : c));
  }
  generateTickLabels(t) {
    let e, r, n;
    for (e = 0, r = t.length; e < r; ++e)
      n = t[e], n.label = this._tickFormatFunction(n.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + r) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, r = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, r = this.ctx.measureText(t).width, n = Qi(this.isHorizontal() ? e.maxRotation : e.minRotation), i = Math.cos(n), a = Math.sin(n), s = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + s * a,
      h: r * a + s * i
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, r = e.displayFormats, n = r[e.unit] || r.millisecond, i = this._tickFormatFunction(t, 0, bO(this, [
      t
    ], this._majorUnit), n), a = this._getLabelSize(i), s = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return s > 0 ? s : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, r;
    if (t.length)
      return t;
    const n = this.getMatchingVisibleMetas();
    if (this._normalized && n.length)
      return this._cache.data = n[0].controller.getAllParsedValues(this);
    for (e = 0, r = n.length; e < r; ++e)
      t = t.concat(n[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, r;
    if (t.length)
      return t;
    const n = this.getLabels();
    for (e = 0, r = n.length; e < r; ++e)
      t.push(yO(this, n[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return KM(t.sort(mO));
  }
}
We(Uh, "id", "time"), We(Uh, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function _g(o, t, e) {
  let r = 0, n = o.length - 1, i, a, s, l;
  e ? (t >= o[r].pos && t <= o[n].pos && ({ lo: r, hi: n } = ms(o, "pos", t)), { pos: i, time: s } = o[r], { pos: a, time: l } = o[n]) : (t >= o[r].time && t <= o[n].time && ({ lo: r, hi: n } = ms(o, "time", t)), { time: i, pos: s } = o[r], { time: a, pos: l } = o[n]);
  const u = a - i;
  return u ? s + (l - s) * (t - i) / u : s;
}
class _S extends Uh {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = _g(e, this.min), this._tableRange = _g(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: r } = this, n = [], i = [];
    let a, s, l, u, c;
    for (a = 0, s = t.length; a < s; ++a)
      u = t[a], u >= e && u <= r && n.push(u);
    if (n.length < 2)
      return [
        {
          time: e,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (a = 0, s = n.length; a < s; ++a)
      c = n[a + 1], l = n[a - 1], u = n[a], Math.round((c + l) / 2) !== u && i.push({
        time: u,
        pos: a / (s - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, e = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(e) || r.length === 1) && r.push(e), r.sort((n, i) => n - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return e.length && r.length ? t = this.normalize(e.concat(r)) : t = e.length ? e : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (_g(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, r = this.getDecimalForPixel(t) / e.factor - e.end;
    return _g(this._table, r * this._tableRange + this._minPos, !0);
  }
}
We(_S, "id", "timeseries"), We(_S, "defaults", Uh.defaults);
var sU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: wS,
  LinearScale: bS,
  LogarithmicScale: SS,
  RadialLinearScale: uh,
  TimeScale: Uh,
  TimeSeriesScale: _S
});
const lU = [
  hB,
  UW,
  Gj,
  sU
];
hs.register(...lU);
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var SO = function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var o = window.screen;
    if (o)
      return (o.deviceXDPI || 1) / (o.logicalXDPI || 1);
  }
  return 1;
}(), xh = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(o) {
    var t = [], e;
    for (o = [].concat(o); o.length; )
      e = o.pop(), typeof e == "string" ? t.unshift.apply(t, e.split(`
`)) : Array.isArray(e) ? o.push.apply(o, e) : Nt(o) || t.unshift("" + e);
    return t;
  },
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(o, t, e) {
    var r = [].concat(t), n = r.length, i = o.font, a = 0, s;
    for (o.font = e.string, s = 0; s < n; ++s)
      a = Math.max(o.measureText(r[s]).width, a);
    return o.font = i, {
      height: n * e.lineHeight,
      width: a
    };
  },
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(o, t, e) {
    return Math.max(o, Math.min(t, e));
  },
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(o, t) {
    var e = o.slice(), r = [], n, i, a, s;
    for (n = 0, a = t.length; n < a; ++n)
      s = t[n], i = e.indexOf(s), i === -1 ? r.push([s, 1]) : e.splice(i, 1);
    for (n = 0, a = e.length; n < a; ++n)
      r.push([e[n], -1]);
    return r;
  },
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(o) {
    return Math.round(o * SO) / SO;
  }
};
function _w(o, t) {
  var e = t.x, r = t.y;
  if (e === null)
    return { x: 0, y: -1 };
  if (r === null)
    return { x: 1, y: 0 };
  var n = o.x - e, i = o.y - r, a = Math.sqrt(n * n + i * i);
  return {
    x: a ? n / a : 0,
    y: a ? i / a : -1
  };
}
function uU(o, t, e, r, n) {
  switch (n) {
    case "center":
      e = r = 0;
      break;
    case "bottom":
      e = 0, r = 1;
      break;
    case "right":
      e = 1, r = 0;
      break;
    case "left":
      e = -1, r = 0;
      break;
    case "top":
      e = 0, r = -1;
      break;
    case "start":
      e = -e, r = -r;
      break;
    case "end":
      break;
    default:
      n *= Math.PI / 180, e = Math.cos(n), r = Math.sin(n);
      break;
  }
  return {
    x: o,
    y: t,
    vx: e,
    vy: r
  };
}
var cU = 0, kF = 1, GF = 2, VF = 4, HF = 8;
function xg(o, t, e) {
  var r = cU;
  return o < e.left ? r |= kF : o > e.right && (r |= GF), t < e.top ? r |= HF : t > e.bottom && (r |= VF), r;
}
function dU(o, t) {
  for (var e = o.x0, r = o.y0, n = o.x1, i = o.y1, a = xg(e, r, t), s = xg(n, i, t), l, u, c; !(!(a | s) || a & s); )
    l = a || s, l & HF ? (u = e + (n - e) * (t.top - r) / (i - r), c = t.top) : l & VF ? (u = e + (n - e) * (t.bottom - r) / (i - r), c = t.bottom) : l & GF ? (c = r + (i - r) * (t.right - e) / (n - e), u = t.right) : l & kF && (c = r + (i - r) * (t.left - e) / (n - e), u = t.left), l === a ? (e = u, r = c, a = xg(e, r, t)) : (n = u, i = c, s = xg(n, i, t));
  return {
    x0: e,
    x1: n,
    y0: r,
    y1: i
  };
}
function Rg(o, t) {
  var e = t.anchor, r = o, n, i;
  return t.clamp && (r = dU(r, t.area)), e === "start" ? (n = r.x0, i = r.y0) : e === "end" ? (n = r.x1, i = r.y1) : (n = (r.x0 + r.x1) / 2, i = (r.y0 + r.y1) / 2), uU(n, i, o.vx, o.vy, t.align);
}
var Tg = {
  arc: function(o, t) {
    var e = (o.startAngle + o.endAngle) / 2, r = Math.cos(e), n = Math.sin(e), i = o.innerRadius, a = o.outerRadius;
    return Rg({
      x0: o.x + r * i,
      y0: o.y + n * i,
      x1: o.x + r * a,
      y1: o.y + n * a,
      vx: r,
      vy: n
    }, t);
  },
  point: function(o, t) {
    var e = _w(o, t.origin), r = e.x * o.options.radius, n = e.y * o.options.radius;
    return Rg({
      x0: o.x - r,
      y0: o.y - n,
      x1: o.x + r,
      y1: o.y + n,
      vx: e.x,
      vy: e.y
    }, t);
  },
  bar: function(o, t) {
    var e = _w(o, t.origin), r = o.x, n = o.y, i = 0, a = 0;
    return o.horizontal ? (r = Math.min(o.x, o.base), i = Math.abs(o.base - o.x)) : (n = Math.min(o.y, o.base), a = Math.abs(o.base - o.y)), Rg({
      x0: r,
      y0: n + a,
      x1: r + i,
      y1: n,
      vx: e.x,
      vy: e.y
    }, t);
  },
  fallback: function(o, t) {
    var e = _w(o, t.origin);
    return Rg({
      x0: o.x,
      y0: o.y,
      x1: o.x + (o.width || 0),
      y1: o.y + (o.height || 0),
      vx: e.x,
      vy: e.y
    }, t);
  }
}, Cs = xh.rasterize;
function pU(o) {
  var t = o.borderWidth || 0, e = o.padding, r = o.size.height, n = o.size.width, i = -n / 2, a = -r / 2;
  return {
    frame: {
      x: i - e.left - t,
      y: a - e.top - t,
      w: n + e.width + t * 2,
      h: r + e.height + t * 2
    },
    text: {
      x: i,
      y: a,
      w: n,
      h: r
    }
  };
}
function fU(o, t) {
  var e = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!e)
    return null;
  if (e.xCenter !== void 0 && e.yCenter !== void 0)
    return { x: e.xCenter, y: e.yCenter };
  var r = e.getBasePixel();
  return o.horizontal ? { x: r, y: null } : { x: null, y: r };
}
function hU(o) {
  return o instanceof Wd ? Tg.arc : o instanceof Eh ? Tg.point : o instanceof _h ? Tg.bar : Tg.fallback;
}
function vU(o, t, e, r, n, i) {
  var a = Math.PI / 2;
  if (i) {
    var s = Math.min(i, n / 2, r / 2), l = t + s, u = e + s, c = t + r - s, d = e + n - s;
    o.moveTo(t, u), l < c && u < d ? (o.arc(l, u, s, -Math.PI, -a), o.arc(c, u, s, -a, 0), o.arc(c, d, s, 0, a), o.arc(l, d, s, a, Math.PI)) : l < c ? (o.moveTo(l, e), o.arc(c, u, s, -a, a), o.arc(l, u, s, a, Math.PI + a)) : u < d ? (o.arc(l, u, s, -Math.PI, 0), o.arc(l, d, s, 0, Math.PI)) : o.arc(l, u, s, -Math.PI, Math.PI), o.closePath(), o.moveTo(t, e);
  } else
    o.rect(t, e, r, n);
}
function gU(o, t, e) {
  var r = e.backgroundColor, n = e.borderColor, i = e.borderWidth;
  !r && (!n || !i) || (o.beginPath(), vU(
    o,
    Cs(t.x) + i / 2,
    Cs(t.y) + i / 2,
    Cs(t.w) - i,
    Cs(t.h) - i,
    e.borderRadius
  ), o.closePath(), r && (o.fillStyle = r, o.fill()), n && i && (o.strokeStyle = n, o.lineWidth = i, o.lineJoin = "miter", o.stroke()));
}
function mU(o, t, e) {
  var r = e.lineHeight, n = o.w, i = o.x, a = o.y + r / 2;
  return t === "center" ? i += n / 2 : (t === "end" || t === "right") && (i += n), {
    h: r,
    w: n,
    x: i,
    y: a
  };
}
function yU(o, t, e) {
  var r = o.shadowBlur, n = e.stroked, i = Cs(e.x), a = Cs(e.y), s = Cs(e.w);
  n && o.strokeText(t, i, a, s), e.filled && (r && n && (o.shadowBlur = 0), o.fillText(t, i, a, s), r && n && (o.shadowBlur = r));
}
function CU(o, t, e, r) {
  var n = r.textAlign, i = r.color, a = !!i, s = r.font, l = t.length, u = r.textStrokeColor, c = r.textStrokeWidth, d = u && c, f;
  if (!(!l || !a && !d))
    for (e = mU(e, n, s), o.font = s.string, o.textAlign = n, o.textBaseline = "middle", o.shadowBlur = r.textShadowBlur, o.shadowColor = r.textShadowColor, a && (o.fillStyle = i), d && (o.lineJoin = "round", o.lineWidth = c, o.strokeStyle = u), f = 0, l = t.length; f < l; ++f)
      yU(o, t[f], {
        stroked: d,
        filled: a,
        w: e.w,
        x: e.x,
        y: e.y + e.h * f
      });
}
var BF = function(o, t, e, r) {
  var n = this;
  n._config = o, n._index = r, n._model = null, n._rects = null, n._ctx = t, n._el = e;
};
Ha(BF.prototype, {
  /**
   * @private
   */
  _modelize: function(o, t, e, r) {
    var n = this, i = n._index, a = hn(Fr([e.font, {}], r, i)), s = Fr([e.color, Yr.color], r, i);
    return {
      align: Fr([e.align, "center"], r, i),
      anchor: Fr([e.anchor, "center"], r, i),
      area: r.chart.chartArea,
      backgroundColor: Fr([e.backgroundColor, null], r, i),
      borderColor: Fr([e.borderColor, null], r, i),
      borderRadius: Fr([e.borderRadius, 0], r, i),
      borderWidth: Fr([e.borderWidth, 0], r, i),
      clamp: Fr([e.clamp, !1], r, i),
      clip: Fr([e.clip, !1], r, i),
      color: s,
      display: o,
      font: a,
      lines: t,
      offset: Fr([e.offset, 4], r, i),
      opacity: Fr([e.opacity, 1], r, i),
      origin: fU(n._el, r),
      padding: jn(Fr([e.padding, 4], r, i)),
      positioner: hU(n._el),
      rotation: Fr([e.rotation, 0], r, i) * (Math.PI / 180),
      size: xh.textSize(n._ctx, t, a),
      textAlign: Fr([e.textAlign, "start"], r, i),
      textShadowBlur: Fr([e.textShadowBlur, 0], r, i),
      textShadowColor: Fr([e.textShadowColor, s], r, i),
      textStrokeColor: Fr([e.textStrokeColor, s], r, i),
      textStrokeWidth: Fr([e.textStrokeWidth, 0], r, i)
    };
  },
  update: function(o) {
    var t = this, e = null, r = null, n = t._index, i = t._config, a, s, l, u = Fr([i.display, !0], o, n);
    u && (a = o.dataset.data[n], s = xt(Tr(i.formatter, [a, o]), a), l = Nt(s) ? [] : xh.toTextLines(s), l.length && (e = t._modelize(u, l, i, o), r = pU(e))), t._model = e, t._rects = r;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(o, t) {
    var e = this, r = o.ctx, n = e._model, i = e._rects, a;
    this.visible() && (r.save(), n.clip && (a = n.area, r.beginPath(), r.rect(
      a.left,
      a.top,
      a.right - a.left,
      a.bottom - a.top
    ), r.clip()), r.globalAlpha = xh.bound(0, n.opacity, 1), r.translate(Cs(t.x), Cs(t.y)), r.rotate(n.rotation), gU(r, i.frame, n), CU(r, n.lines, i.text, n), r.restore());
  }
});
var wU = Number.MIN_SAFE_INTEGER || -9007199254740991, bU = Number.MAX_SAFE_INTEGER || 9007199254740991;
function bf(o, t, e) {
  var r = Math.cos(e), n = Math.sin(e), i = t.x, a = t.y;
  return {
    x: i + r * (o.x - i) - n * (o.y - a),
    y: a + n * (o.x - i) + r * (o.y - a)
  };
}
function EO(o, t) {
  var e = bU, r = wU, n = t.origin, i, a, s, l, u;
  for (i = 0; i < o.length; ++i)
    a = o[i], s = a.x - n.x, l = a.y - n.y, u = t.vx * s + t.vy * l, e = Math.min(e, u), r = Math.max(r, u);
  return {
    min: e,
    max: r
  };
}
function Og(o, t) {
  var e = t.x - o.x, r = t.y - o.y, n = Math.sqrt(e * e + r * r);
  return {
    vx: (t.x - o.x) / n,
    vy: (t.y - o.y) / n,
    origin: o,
    ln: n
  };
}
var WF = function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
Ha(WF.prototype, {
  center: function() {
    var o = this._rect;
    return {
      x: o.x + o.w / 2,
      y: o.y + o.h / 2
    };
  },
  update: function(o, t, e) {
    this._rotation = e, this._rect = {
      x: t.x + o.x,
      y: t.y + o.y,
      w: t.w,
      h: t.h
    };
  },
  contains: function(o) {
    var t = this, e = 1, r = t._rect;
    return o = bf(o, t.center(), -t._rotation), !(o.x < r.x - e || o.y < r.y - e || o.x > r.x + r.w + e * 2 || o.y > r.y + r.h + e * 2);
  },
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(o) {
    var t = this._points(), e = o._points(), r = [
      Og(t[0], t[1]),
      Og(t[0], t[3])
    ], n, i, a;
    for (this._rotation !== o._rotation && r.push(
      Og(e[0], e[1]),
      Og(e[0], e[3])
    ), n = 0; n < r.length; ++n)
      if (i = EO(t, r[n]), a = EO(e, r[n]), i.max < a.min || a.max < i.min)
        return !1;
    return !0;
  },
  /**
   * @private
   */
  _points: function() {
    var o = this, t = o._rect, e = o._rotation, r = o.center();
    return [
      bf({ x: t.x, y: t.y }, r, e),
      bf({ x: t.x + t.w, y: t.y }, r, e),
      bf({ x: t.x + t.w, y: t.y + t.h }, r, e),
      bf({ x: t.x, y: t.y + t.h }, r, e)
    ];
  }
});
function jF(o, t, e) {
  var r = t.positioner(o, t), n = r.vx, i = r.vy;
  if (!n && !i)
    return { x: r.x, y: r.y };
  var a = e.w, s = e.h, l = t.rotation, u = Math.abs(a / 2 * Math.cos(l)) + Math.abs(s / 2 * Math.sin(l)), c = Math.abs(a / 2 * Math.sin(l)) + Math.abs(s / 2 * Math.cos(l)), d = 1 / Math.max(Math.abs(n), Math.abs(i));
  return u *= n * d, c *= i * d, u += t.offset * n, c += t.offset * i, {
    x: r.x + u,
    y: r.y + c
  };
}
function SU(o, t) {
  var e, r, n, i;
  for (e = o.length - 1; e >= 0; --e)
    for (n = o[e].$layout, r = e - 1; r >= 0 && n._visible; --r)
      i = o[r].$layout, i._visible && n._box.intersects(i._box) && t(n, i);
  return o;
}
function EU(o) {
  var t, e, r, n, i, a, s;
  for (t = 0, e = o.length; t < e; ++t)
    r = o[t], n = r.$layout, n._visible && (s = new Proxy(r._el, { get: (l, u) => l.getProps([u], !0)[u] }), i = r.geometry(), a = jF(s, r.model(), i), n._box.update(a, i, r.rotation()));
  return SU(o, function(l, u) {
    var c = l._hidable, d = u._hidable;
    c && d || d ? u._visible = !1 : c && (l._visible = !1);
  });
}
var Rh = {
  prepare: function(o) {
    var t = [], e, r, n, i, a;
    for (e = 0, n = o.length; e < n; ++e)
      for (r = 0, i = o[e].length; r < i; ++r)
        a = o[e][r], t.push(a), a.$layout = {
          _box: new WF(),
          _hidable: !1,
          _visible: !0,
          _set: e,
          _idx: a._index
        };
    return t.sort(function(s, l) {
      var u = s.$layout, c = l.$layout;
      return u._idx === c._idx ? c._set - u._set : c._idx - u._idx;
    }), this.update(t), t;
  },
  update: function(o) {
    var t = !1, e, r, n, i, a;
    for (e = 0, r = o.length; e < r; ++e)
      n = o[e], i = n.model(), a = n.$layout, a._hidable = i && i.display === "auto", a._visible = n.visible(), t |= a._hidable;
    t && EU(o);
  },
  lookup: function(o, t) {
    var e, r;
    for (e = o.length - 1; e >= 0; --e)
      if (r = o[e].$layout, r && r._visible && r._box.contains(t))
        return o[e];
    return null;
  },
  draw: function(o, t) {
    var e, r, n, i, a, s;
    for (e = 0, r = t.length; e < r; ++e)
      n = t[e], i = n.$layout, i._visible && (a = n.geometry(), s = jF(n._el, n.model(), a), i._box.update(s, a, n.rotation()), n.draw(o, s));
  }
}, _U = function(o) {
  if (Nt(o))
    return null;
  var t = o, e, r, n;
  if (Ht(o))
    if (!Nt(o.label))
      t = o.label;
    else if (!Nt(o.r))
      t = o.r;
    else
      for (t = "", e = Object.keys(o), n = 0, r = e.length; n < r; ++n)
        t += (n !== 0 ? ", " : "") + e[n] + ": " + o[e[n]];
  return "" + t;
}, xU = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: _U,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, Io = "$datalabels", UF = "$default";
function RU(o, t) {
  var e = o.datalabels, r = {}, n = [], i, a;
  return e === !1 ? null : (e === !0 && (e = {}), t = Ha({}, [t, e]), i = t.labels || {}, a = Object.keys(i), delete t.labels, a.length ? a.forEach(function(s) {
    i[s] && n.push(Ha({}, [
      t,
      i[s],
      { _key: s }
    ]));
  }) : n.push(t), r = n.reduce(function(s, l) {
    return ur(l.listeners || {}, function(u, c) {
      s[c] = s[c] || {}, s[c][l._key || UF] = u;
    }), delete l.listeners, s;
  }, {}), {
    labels: n,
    listeners: r
  });
}
function xS(o, t, e, r) {
  if (t) {
    var n = e.$context, i = e.$groups, a;
    t[i._set] && (a = t[i._set][i._key], a && Tr(a, [n, r]) === !0 && (o[Io]._dirty = !0, e.update(n)));
  }
}
function TU(o, t, e, r, n) {
  var i, a;
  !e && !r || (e ? r ? e !== r && (a = i = !0) : a = !0 : i = !0, a && xS(o, t.leave, e, n), i && xS(o, t.enter, r, n));
}
function OU(o, t) {
  var e = o[Io], r = e._listeners, n, i;
  if (!(!r.enter && !r.leave)) {
    if (t.type === "mousemove")
      i = Rh.lookup(e._labels, t);
    else if (t.type !== "mouseout")
      return;
    n = e._hovered, e._hovered = i, TU(o, r, n, i, t);
  }
}
function PU(o, t) {
  var e = o[Io], r = e._listeners.click, n = r && Rh.lookup(e._labels, t);
  n && xS(o, r, n, t);
}
var DU = {
  id: "datalabels",
  defaults: xU,
  beforeInit: function(o) {
    o[Io] = {
      _actives: []
    };
  },
  beforeUpdate: function(o) {
    var t = o[Io];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  },
  afterDatasetUpdate: function(o, t, e) {
    var r = t.index, n = o[Io], i = n._datasets[r] = [], a = o.isDatasetVisible(r), s = o.data.datasets[r], l = RU(s, e), u = t.meta.data || [], c = o.ctx, d, f, v, g, m, b, S, R;
    for (c.save(), d = 0, v = u.length; d < v; ++d)
      if (S = u[d], S[Io] = [], a && S && o.getDataVisibility(d) && !S.skip)
        for (f = 0, g = l.labels.length; f < g; ++f)
          m = l.labels[f], b = m._key, R = new BF(m, c, S, d), R.$groups = {
            _set: r,
            _key: b || UF
          }, R.$context = {
            active: !1,
            chart: o,
            dataIndex: d,
            dataset: s,
            datasetIndex: r
          }, R.update(R.$context), S[Io].push(R), i.push(R);
    c.restore(), Ha(n._listeners, l.listeners, {
      merger: function(P, D, x) {
        D[P] = D[P] || {}, D[P][t.index] = x[P], n._listened = !0;
      }
    });
  },
  afterUpdate: function(o) {
    o[Io]._labels = Rh.prepare(o[Io]._datasets);
  },
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(o) {
    Rh.draw(o, o[Io]._labels);
  },
  beforeEvent: function(o, t) {
    if (o[Io]._listened) {
      var e = t.event;
      switch (e.type) {
        case "mousemove":
        case "mouseout":
          OU(o, e);
          break;
        case "click":
          PU(o, e);
          break;
      }
    }
  },
  afterEvent: function(o) {
    var t = o[Io], e = t._actives, r = t._actives = o.getActiveElements(), n = xh.arrayDiff(e, r), i, a, s, l, u, c, d;
    for (i = 0, a = n.length; i < a; ++i)
      if (u = n[i], u[1])
        for (d = u[0].element[Io] || [], s = 0, l = d.length; s < l; ++s)
          c = d[s], c.$context.active = u[1] === 1, c.update(c.$context);
    (t._dirty || n.length) && (Rh.update(t._labels), o.render()), delete t._dirty;
  }
}, AU = {}, qy = {}, $F = {};
/**
          * @ag-grid-community/all-modules - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue * @version v31.0.3
          * @link https://www.ag-grid.com/
          * @license MIT
          */
function Ia(o) {
  return o == null || o === "" ? null : o;
}
function Oe(o, t) {
  return t === void 0 && (t = !1), o != null && (o !== "" || t);
}
function tt(o) {
  return !Oe(o);
}
function ri(o) {
  return o == null || o.length === 0;
}
function $h(o) {
  return o != null && typeof o.toString == "function" ? o.toString() : null;
}
function Al(o) {
  if (o !== void 0) {
    if (o === null || o === "")
      return null;
    if (typeof o == "number")
      return isNaN(o) ? void 0 : o;
    var t = parseInt(o, 10);
    return isNaN(t) ? void 0 : t;
  }
}
function zm(o) {
  if (o !== void 0)
    return o === null || o === "" ? !1 : typeof o == "boolean" ? o : /true/i.test(o);
}
function MU(o) {
  if (!(o == null || o === ""))
    return o;
}
function RS(o, t) {
  var e = o ? JSON.stringify(o) : null, r = t ? JSON.stringify(t) : null;
  return e === r;
}
function FU(o, t, e) {
  e === void 0 && (e = !1);
  var r = o == null, n = t == null;
  if (o && o.toNumber && (o = o.toNumber()), t && t.toNumber && (t = t.toNumber()), r && n)
    return 0;
  if (r)
    return -1;
  if (n)
    return 1;
  function i(a, s) {
    return a > s ? 1 : a < s ? -1 : 0;
  }
  if (typeof o != "string" || !e)
    return i(o, t);
  try {
    return o.localeCompare(t);
  } catch {
    return i(o, t);
  }
}
function ic(o) {
  if (o instanceof Set || o instanceof Map) {
    var t = [];
    return o.forEach(function(e) {
      return t.push(e);
    }), t;
  }
  return Object.values(o);
}
var IU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  makeNull: Ia,
  exists: Oe,
  missing: tt,
  missingOrEmpty: ri,
  toStringOrNull: $h,
  attrToNumber: Al,
  attrToBoolean: zm,
  attrToString: MU,
  jsonEquals: RS,
  defaultComparator: FU,
  values: ic
}), zF = (
  /** @class */
  function() {
    function o() {
      this.existingKeys = {};
    }
    return o.prototype.addExistingKeys = function(t) {
      for (var e = 0; e < t.length; e++)
        this.existingKeys[t[e]] = !0;
    }, o.prototype.getUniqueKey = function(t, e) {
      t = $h(t);
      for (var r = 0; ; ) {
        var n = void 0;
        if (t ? (n = t, r !== 0 && (n += "_" + r)) : e ? (n = e, r !== 0 && (n += "_" + r)) : n = r, !this.existingKeys[n])
          return this.existingKeys[n] = !0, String(n);
        r++;
      }
    }, o;
  }()
), LU = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, NU = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
};
function Xn(o, t) {
  var e, r;
  if (o != null) {
    if (Array.isArray(o)) {
      for (var n = 0; n < o.length; n++)
        t(n.toString(), o[n]);
      return;
    }
    try {
      for (var i = LU(Object.entries(o)), a = i.next(); !a.done; a = i.next()) {
        var s = NU(a.value, 2), l = s[0], u = s[1];
        t(l, u);
      }
    } catch (c) {
      e = { error: c };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
  }
}
function w1(o) {
  for (var t = {}, e = Object.keys(o), r = 0; r < e.length; r++) {
    var n = e[r], i = o[n];
    t[n] = i;
  }
  return t;
}
function kU(o) {
  return JSON.parse(JSON.stringify(o));
}
function Ym(o, t) {
  if (o) {
    var e = o, r = {};
    return Object.keys(e).forEach(function(n) {
      if (!(t && t.indexOf(n) >= 0)) {
        var i = e[n], a = Km(i) && i.constructor === Object;
        a ? r[n] = Ym(i) : r[n] = i;
      }
    }), r;
  }
}
function YF(o, t) {
  return o[t];
}
function KF(o, t, e) {
  o[t] = e;
}
function GU(o, t) {
  for (var e = [], r = 2; r < arguments.length; r++)
    e[r - 2] = arguments[r];
  e.forEach(function(n) {
    return qF(o, t, n);
  });
}
function qF(o, t, e, r) {
  var n = YF(o, e);
  n !== void 0 && KF(t, e, r ? r(n) : n);
}
function XF(o) {
  var t = {};
  return o.filter(function(e) {
    return e != null;
  }).forEach(function(e) {
    Object.keys(e).forEach(function(r) {
      return t[r] = null;
    });
  }), Object.keys(t);
}
function Vl(o) {
  if (!o)
    return [];
  var t = Object;
  if (typeof t.values == "function")
    return t.values(o);
  var e = [];
  for (var r in o)
    o.hasOwnProperty(r) && o.propertyIsEnumerable(r) && e.push(o[r]);
  return e;
}
function oi(o, t, e, r) {
  e === void 0 && (e = !0), r === void 0 && (r = !1), Oe(t) && Xn(t, function(n, i) {
    var a = o[n];
    if (a !== i) {
      if (r) {
        var s = a == null && i != null;
        if (s) {
          var l = typeof i == "object" && i.constructor === Object, u = l;
          u && (a = {}, o[n] = a);
        }
      }
      Km(i) && Km(a) && !Array.isArray(a) ? oi(a, i, e, r) : (e || i !== void 0) && (o[n] = i);
    }
  });
}
function VU(o) {
  return tt(o) || Object.keys(o).length === 0;
}
function HU(o, t, e) {
  if (o == null)
    return e;
  for (var r = t.split("."), n = o; r.length > 1; )
    if (n = n[r.shift()], n == null)
      return e;
  var i = n[r[0]];
  return i ?? e;
}
function BU(o, t, e) {
  if (o != null) {
    var r = t.split("."), n = o;
    r.forEach(function(i, a) {
      n[i] || (n[i] = {}), a < r.length - 1 && (n = n[i]);
    }), n[r[r.length - 1]] = e;
  }
}
function qd(o, t, e) {
  if (!(!t || !o)) {
    if (!e)
      return o[t];
    for (var r = t.split("."), n = o, i = 0; i < r.length; i++) {
      if (n == null)
        return;
      n = n[r[i]];
    }
    return n;
  }
}
function ZF(o, t, e) {
  t === void 0 && (t = []), Object.keys(o).forEach(function(a) {
    var s = o[a];
    typeof s == "object" && !t.includes(a) && (o[a] = void 0);
  });
  var r = Object.getPrototypeOf(o), n = {}, i = function(a) {
    return "AG Grid: Grid API function ".concat(a, `() cannot be called as the grid has been destroyed.
    It is recommended to remove local references to the grid api. Alternatively, check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
    To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: `).concat(e);
  };
  Object.getOwnPropertyNames(r).forEach(function(a) {
    var s = r[a];
    if (typeof s == "function" && !t.includes(a)) {
      var l = function() {
        console.warn(i(a));
      };
      n[a] = { value: l, writable: !0 };
    }
  }), Object.defineProperties(o, n);
}
function Km(o) {
  return typeof o == "object" && o !== null;
}
var WU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  iterateObject: Xn,
  cloneObject: w1,
  deepCloneObject: kU,
  deepCloneDefinition: Ym,
  getProperty: YF,
  setProperty: KF,
  copyPropertiesIfPresent: GU,
  copyPropertyIfPresent: qF,
  getAllKeysInObjects: XF,
  getAllValuesInObject: Vl,
  mergeDeep: oi,
  missingOrEmptyObject: VU,
  get: HU,
  set: BU,
  getValueUsingField: qd,
  removeAllReferences: ZF,
  isNonNullObject: Km
}), _O = {};
function sp(o, t) {
  _O[t] || (o(), _O[t] = !0);
}
function ht(o) {
  sp(function() {
    return console.warn("AG Grid: " + o);
  }, o);
}
function Ji(o) {
  sp(function() {
    return console.error("AG Grid: " + o);
  }, o);
}
function Xy(o) {
  if (o.name)
    return o.name;
  var t = /function\s+([^\(]+)/.exec(o.toString());
  return t && t.length === 2 ? t[1].trim() : null;
}
function Zy(o) {
  return !!(o && o.constructor && o.call && o.apply);
}
function QF(o) {
  JF(o, 400);
}
var xw = [], Rw = !1;
function TS(o) {
  xw.push(o), !Rw && (Rw = !0, window.setTimeout(function() {
    var t = xw.slice();
    xw.length = 0, Rw = !1, t.forEach(function(e) {
      return e();
    });
  }, 0));
}
function JF(o, t) {
  t === void 0 && (t = 0), o.length > 0 && window.setTimeout(function() {
    return o.forEach(function(e) {
      return e();
    });
  }, t);
}
function Oi(o, t) {
  var e;
  return function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var i = this;
    window.clearTimeout(e), e = window.setTimeout(function() {
      o.apply(i, r);
    }, t);
  };
}
function OS(o, t) {
  var e = 0;
  return function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var i = this, a = (/* @__PURE__ */ new Date()).getTime();
    a - e < t || (e = a, o.apply(i, r));
  };
}
function b1(o, t, e, r) {
  e === void 0 && (e = 100);
  var n = (/* @__PURE__ */ new Date()).getTime(), i = null, a = !1, s = function() {
    var l = (/* @__PURE__ */ new Date()).getTime() - n > e;
    (o() || l) && (t(), a = !0, i != null && (window.clearInterval(i), i = null), l && r && console.warn(r));
  };
  s(), a || (i = window.setInterval(s, 10));
}
function jU() {
  for (var o = [], t = 0; t < arguments.length; t++)
    o[t] = arguments[t];
  return function(e) {
    return o.reduce(function(r, n) {
      return n(r);
    }, e);
  };
}
function e2(o) {
  o && o();
}
var UU = function() {
}, $U = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  doOnce: sp,
  warnOnce: ht,
  errorOnce: Ji,
  getFunctionName: Xy,
  isFunction: Zy,
  executeInAWhile: QF,
  executeNextVMTurn: TS,
  executeAfter: JF,
  debounce: Oi,
  throttle: OS,
  waitUntil: b1,
  compose: jU,
  callIfPresent: e2,
  noop: UU
}), Ye;
(function(o) {
  o.CommunityCoreModule = "@ag-grid-community/core", o.InfiniteRowModelModule = "@ag-grid-community/infinite-row-model", o.ClientSideRowModelModule = "@ag-grid-community/client-side-row-model", o.CsvExportModule = "@ag-grid-community/csv-export", o.EnterpriseCoreModule = "@ag-grid-enterprise/core", o.RowGroupingModule = "@ag-grid-enterprise/row-grouping", o.ColumnsToolPanelModule = "@ag-grid-enterprise/column-tool-panel", o.FiltersToolPanelModule = "@ag-grid-enterprise/filter-tool-panel", o.MenuModule = "@ag-grid-enterprise/menu", o.SetFilterModule = "@ag-grid-enterprise/set-filter", o.MultiFilterModule = "@ag-grid-enterprise/multi-filter", o.StatusBarModule = "@ag-grid-enterprise/status-bar", o.SideBarModule = "@ag-grid-enterprise/side-bar", o.RangeSelectionModule = "@ag-grid-enterprise/range-selection", o.MasterDetailModule = "@ag-grid-enterprise/master-detail", o.RichSelectModule = "@ag-grid-enterprise/rich-select", o.GridChartsModule = "@ag-grid-enterprise/charts", o.ViewportRowModelModule = "@ag-grid-enterprise/viewport-row-model", o.ServerSideRowModelModule = "@ag-grid-enterprise/server-side-row-model", o.ExcelExportModule = "@ag-grid-enterprise/excel-export", o.ClipboardModule = "@ag-grid-enterprise/clipboard", o.SparklinesModule = "@ag-grid-enterprise/sparklines", o.AdvancedFilterModule = "@ag-grid-enterprise/advanced-filter", o.AngularModule = "@ag-grid-community/angular", o.ReactModule = "@ag-grid-community/react", o.VueModule = "@ag-grid-community/vue";
})(Ye || (Ye = {}));
var Sf = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, xO = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, Xt = (
  /** @class */
  function() {
    function o() {
    }
    return o.register = function(t) {
      o.__register(t, !0, void 0);
    }, o.registerModules = function(t) {
      o.__registerModules(t, !0, void 0);
    }, o.__register = function(t, e, r) {
      o.runVersionChecks(t), r !== void 0 ? (o.areGridScopedModules = !0, o.gridModulesMap[r] === void 0 && (o.gridModulesMap[r] = {}), o.gridModulesMap[r][t.moduleName] = t) : o.globalModulesMap[t.moduleName] = t, o.setModuleBased(e);
    }, o.__unRegisterGridModules = function(t) {
      delete o.gridModulesMap[t];
    }, o.__registerModules = function(t, e, r) {
      o.setModuleBased(e), t && t.forEach(function(n) {
        return o.__register(n, e, r);
      });
    }, o.isValidModuleVersion = function(t) {
      var e = Sf(t.version.split(".") || [], 2), r = e[0], n = e[1], i = Sf(o.currentModuleVersion.split(".") || [], 2), a = i[0], s = i[1];
      return r === a && n === s;
    }, o.runVersionChecks = function(t) {
      if (o.currentModuleVersion || (o.currentModuleVersion = t.version), t.version ? o.isValidModuleVersion(t) || console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '".concat(t.moduleName, "' is version ").concat(t.version, " but the other modules are version ").concat(this.currentModuleVersion, ". Please update all modules to the same version.")) : console.error("AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '".concat(t.moduleName, "' is incompatible. Please update all modules to the same version.")), t.validate) {
        var e = t.validate();
        if (!e.isValid) {
          var r = e;
          console.error("AG Grid: ".concat(r.message));
        }
      }
    }, o.setModuleBased = function(t) {
      o.moduleBased === void 0 ? o.moduleBased = t : o.moduleBased !== t && sp(function() {
        console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms."), console.warn("Please see https://www.ag-grid.com/javascript-grid/packages-modules/ for more information.");
      }, "ModulePackageCheck");
    }, o.__setIsBundled = function() {
      o.isBundled = !0;
    }, o.__assertRegistered = function(t, e, r) {
      var n;
      if (this.__isRegistered(t, r))
        return !0;
      var i = e + t, a;
      if (o.isBundled)
        a = "AG Grid: unable to use ".concat(e, ` as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`);
      else if (o.moduleBased || o.moduleBased === void 0) {
        var s = (n = Object.entries(Ye).find(function(l) {
          var u = Sf(l, 2);
          u[0];
          var c = u[1];
          return c === t;
        })) === null || n === void 0 ? void 0 : n[0];
        a = "AG Grid: unable to use ".concat(e, " as the ").concat(s, " is not registered").concat(o.areGridScopedModules ? " for gridId: ".concat(r) : "", `. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { `).concat(s, " } from '").concat(t, `';
    
    ModuleRegistry.registerModules([ `).concat(s, ` ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`);
      } else
        a = "AG Grid: unable to use ".concat(e, ` as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';
            
For more info see: https://www.ag-grid.com/javascript-grid/packages/`);
      return sp(function() {
        console.warn(a);
      }, i), !1;
    }, o.__isRegistered = function(t, e) {
      var r;
      return !!o.globalModulesMap[t] || !!(!((r = o.gridModulesMap[e]) === null || r === void 0) && r[t]);
    }, o.__getRegisteredModules = function(t) {
      return xO(xO([], Sf(ic(o.globalModulesMap)), !1), Sf(ic(o.gridModulesMap[t] || {})), !1);
    }, o.__getGridRegisteredModules = function(t) {
      var e;
      return ic((e = o.gridModulesMap[t]) !== null && e !== void 0 ? e : {}) || [];
    }, o.__isPackageBased = function() {
      return !o.moduleBased;
    }, o.globalModulesMap = {}, o.gridModulesMap = {}, o.areGridScopedModules = !1, o;
  }()
), zU = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, YU = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, t2 = (
  /** @class */
  function() {
    function o(t, e) {
      if (this.beanWrappers = {}, this.destroyed = !1, !(!t || !t.beanClasses)) {
        this.contextParams = t, this.logger = e, this.logger.log(">> creating ag-Application Context"), this.createBeans();
        var r = this.getBeanInstances();
        this.wireBeans(r), this.logger.log(">> ag-Application Context ready - component is alive");
      }
    }
    return o.prototype.getBeanInstances = function() {
      return ic(this.beanWrappers).map(function(t) {
        return t.beanInstance;
      });
    }, o.prototype.createBean = function(t, e) {
      if (!t)
        throw Error("Can't wire to bean since it is null");
      return this.wireBeans([t], e), t;
    }, o.prototype.wireBeans = function(t, e) {
      this.autoWireBeans(t), this.methodWireBeans(t), this.callLifeCycleMethods(t, "preConstructMethods"), Oe(e) && t.forEach(e), this.callLifeCycleMethods(t, "postConstructMethods");
    }, o.prototype.createBeans = function() {
      var t = this;
      this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this)), Xn(this.beanWrappers, function(r, n) {
        var i;
        n.bean.__agBeanMetaData && n.bean.__agBeanMetaData.autowireMethods && n.bean.__agBeanMetaData.autowireMethods.agConstructor && (i = n.bean.__agBeanMetaData.autowireMethods.agConstructor);
        var a = t.getBeansForParameters(i, n.bean.name), s = new (n.bean.bind.apply(n.bean, YU([null], zU(a), !1)))();
        n.beanInstance = s;
      });
      var e = Object.keys(this.beanWrappers).join(", ");
      this.logger.log("created beans: ".concat(e));
    }, o.prototype.createBeanWrapper = function(t) {
      var e = t.__agBeanMetaData;
      if (!e) {
        var r = void 0;
        t.prototype.constructor ? r = Xy(t.prototype.constructor) : r = "" + t, console.error("Context item ".concat(r, " is not a bean"));
        return;
      }
      var n = {
        bean: t,
        beanInstance: null,
        beanName: e.beanName
      };
      this.beanWrappers[e.beanName] = n;
    }, o.prototype.autoWireBeans = function(t) {
      var e = this;
      t.forEach(function(r) {
        e.forEachMetaDataInHierarchy(r, function(n, i) {
          var a = n.agClassAttributes;
          a && a.forEach(function(s) {
            var l = e.lookupBeanInstance(i, s.beanName, s.optional);
            r[s.attributeName] = l;
          });
        });
      });
    }, o.prototype.methodWireBeans = function(t) {
      var e = this;
      t.forEach(function(r) {
        e.forEachMetaDataInHierarchy(r, function(n, i) {
          Xn(n.autowireMethods, function(a, s) {
            if (a !== "agConstructor") {
              var l = e.getBeansForParameters(s, i);
              r[a].apply(r, l);
            }
          });
        });
      });
    }, o.prototype.forEachMetaDataInHierarchy = function(t, e) {
      for (var r = Object.getPrototypeOf(t); r != null; ) {
        var n = r.constructor;
        if (n.hasOwnProperty("__agBeanMetaData")) {
          var i = n.__agBeanMetaData, a = this.getBeanName(n);
          e(i, a);
        }
        r = Object.getPrototypeOf(r);
      }
    }, o.prototype.getBeanName = function(t) {
      if (t.__agBeanMetaData && t.__agBeanMetaData.beanName)
        return t.__agBeanMetaData.beanName;
      var e = t.toString(), r = e.substring(9, e.indexOf("("));
      return r;
    }, o.prototype.getBeansForParameters = function(t, e) {
      var r = this, n = [];
      return t && Xn(t, function(i, a) {
        var s = r.lookupBeanInstance(e, a);
        n[Number(i)] = s;
      }), n;
    }, o.prototype.lookupBeanInstance = function(t, e, r) {
      if (r === void 0 && (r = !1), this.destroyed)
        return this.logger.log("AG Grid: bean reference ".concat(e, " is used after the grid is destroyed!")), null;
      if (e === "context")
        return this;
      if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(e))
        return this.contextParams.providedBeanInstances[e];
      var n = this.beanWrappers[e];
      return n ? n.beanInstance : (r || console.error("AG Grid: unable to find bean reference ".concat(e, " while initialising ").concat(t)), null);
    }, o.prototype.callLifeCycleMethods = function(t, e) {
      var r = this;
      t.forEach(function(n) {
        return r.callLifeCycleMethodsOnBean(n, e);
      });
    }, o.prototype.callLifeCycleMethodsOnBean = function(t, e, r) {
      var n = {};
      this.forEachMetaDataInHierarchy(t, function(a) {
        var s = a[e];
        s && s.forEach(function(l) {
          l != r && (n[l] = !0);
        });
      });
      var i = Object.keys(n);
      i.forEach(function(a) {
        return t[a]();
      });
    }, o.prototype.getBean = function(t) {
      return this.lookupBeanInstance("getBean", t, !0);
    }, o.prototype.destroy = function() {
      if (!this.destroyed) {
        this.destroyed = !0, this.logger.log(">> Shutting down ag-Application Context");
        var t = this.getBeanInstances();
        this.destroyBeans(t), this.contextParams.providedBeanInstances = null, Xt.__unRegisterGridModules(this.contextParams.gridId), this.logger.log(">> ag-Application Context shut down - component is dead");
      }
    }, o.prototype.destroyBean = function(t) {
      t && this.destroyBeans([t]);
    }, o.prototype.destroyBeans = function(t) {
      var e = this;
      return t ? (t.forEach(function(r) {
        e.callLifeCycleMethodsOnBean(r, "preDestroyMethods", "destroy");
        var n = r;
        typeof n.destroy == "function" && n.destroy();
      }), []) : [];
    }, o.prototype.isDestroyed = function() {
      return this.destroyed;
    }, o.prototype.getGridId = function() {
      return this.contextParams.gridId;
    }, o;
  }()
);
function PS(o, t, e) {
  var r = hc(o.constructor);
  r.preConstructMethods || (r.preConstructMethods = []), r.preConstructMethods.push(t);
}
function Fe(o, t, e) {
  var r = hc(o.constructor);
  r.postConstructMethods || (r.postConstructMethods = []), r.postConstructMethods.push(t);
}
function eo(o, t, e) {
  var r = hc(o.constructor);
  r.preDestroyMethods || (r.preDestroyMethods = []), r.preDestroyMethods.push(t);
}
function Be(o) {
  return function(t) {
    var e = hc(t);
    e.beanName = o;
  };
}
function N(o) {
  return function(t, e, r) {
    r2(t, o, !1, t, e);
  };
}
function Lt(o) {
  return function(t, e, r) {
    r2(t, o, !0, t, e);
  };
}
function r2(o, t, e, r, n, i) {
  if (t === null) {
    console.error("AG Grid: Autowired name should not be null");
    return;
  }
  var a = hc(o.constructor);
  a.agClassAttributes || (a.agClassAttributes = []), a.agClassAttributes.push({
    attributeName: n,
    beanName: t,
    optional: e
  });
}
function ii(o) {
  return function(t, e, r) {
    var n = typeof t == "function" ? t : t.constructor, i;
    if (typeof r == "number") {
      var a = void 0;
      e ? (i = hc(n), a = e) : (i = hc(n), a = "agConstructor"), i.autowireMethods || (i.autowireMethods = {}), i.autowireMethods[a] || (i.autowireMethods[a] = {}), i.autowireMethods[a][r] = o;
    }
  };
}
function hc(o) {
  return o.hasOwnProperty("__agBeanMetaData") || (o.__agBeanMetaData = {}), o.__agBeanMetaData;
}
var RO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Pg = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, Ts = (
  /** @class */
  function() {
    function o() {
      this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
    }
    return o.prototype.setBeans = function(t, e, r, n) {
      if (r === void 0 && (r = null), n === void 0 && (n = null), this.frameworkOverrides = e, this.gridOptionsService = t, r) {
        var i = t.useAsyncEvents();
        this.addGlobalListener(r, i);
      }
      n && this.addGlobalListener(n, !1);
    }, o.prototype.setFrameworkOverrides = function(t) {
      this.frameworkOverrides = t;
    }, o.prototype.getListeners = function(t, e, r) {
      var n = e ? this.allAsyncListeners : this.allSyncListeners, i = n.get(t);
      return !i && r && (i = /* @__PURE__ */ new Set(), n.set(t, i)), i;
    }, o.prototype.noRegisteredListenersExist = function() {
      return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }, o.prototype.addEventListener = function(t, e, r) {
      r === void 0 && (r = !1), this.getListeners(t, r, !0).add(e);
    }, o.prototype.removeEventListener = function(t, e, r) {
      r === void 0 && (r = !1);
      var n = this.getListeners(t, r, !1);
      if (n && (n.delete(e), n.size === 0)) {
        var i = r ? this.allAsyncListeners : this.allSyncListeners;
        i.delete(t);
      }
    }, o.prototype.addGlobalListener = function(t, e) {
      e === void 0 && (e = !1), (e ? this.globalAsyncListeners : this.globalSyncListeners).add(t);
    }, o.prototype.removeGlobalListener = function(t, e) {
      e === void 0 && (e = !1), (e ? this.globalAsyncListeners : this.globalSyncListeners).delete(t);
    }, o.prototype.dispatchEvent = function(t) {
      var e = t;
      this.gridOptionsService && this.gridOptionsService.addGridCommonParams(e), this.dispatchToListeners(e, !0), this.dispatchToListeners(e, !1), this.firedEvents[e.type] = !0;
    }, o.prototype.dispatchEventOnce = function(t) {
      this.firedEvents[t.type] || this.dispatchEvent(t);
    }, o.prototype.dispatchToListeners = function(t, e) {
      var r = this, n, i = t.type;
      if (e && "event" in t) {
        var a = t.event;
        a instanceof Event && (t.eventPath = a.composedPath());
      }
      var s = function(d, f) {
        return d.forEach(function(v) {
          if (f.has(v)) {
            var g = r.frameworkOverrides ? function() {
              return r.frameworkOverrides.wrapIncoming(function() {
                return v(t);
              });
            } : function() {
              return v(t);
            };
            e ? r.dispatchAsync(g) : g();
          }
        });
      }, l = (n = this.getListeners(i, e, !1)) !== null && n !== void 0 ? n : /* @__PURE__ */ new Set(), u = new Set(l);
      u.size > 0 && s(u, l);
      var c = new Set(e ? this.globalAsyncListeners : this.globalSyncListeners);
      c.forEach(function(d) {
        var f = r.frameworkOverrides ? function() {
          return r.frameworkOverrides.wrapIncoming(function() {
            return d(i, t);
          });
        } : function() {
          return d(i, t);
        };
        e ? r.dispatchAsync(f) : f();
      });
    }, o.prototype.dispatchAsync = function(t) {
      var e = this;
      this.asyncFunctionsQueue.push(t), this.scheduled || (this.frameworkOverrides.wrapIncoming(function() {
        window.setTimeout(e.flushAsyncQueue.bind(e), 0);
      }), this.scheduled = !0);
    }, o.prototype.flushAsyncQueue = function() {
      this.scheduled = !1;
      var t = this.asyncFunctionsQueue.slice();
      this.asyncFunctionsQueue = [], t.forEach(function(e) {
        return e();
      });
    }, RO([
      Pg(0, ii("gridOptionsService")),
      Pg(1, ii("frameworkOverrides")),
      Pg(2, ii("globalEventListener")),
      Pg(3, ii("globalSyncEventListener"))
    ], o.prototype, "setBeans", null), o = RO([
      Be("eventService")
    ], o), o;
  }()
), S1 = (
  /** @class */
  function() {
    function o(t) {
      this.frameworkOverrides = t, this.wrappedListeners = /* @__PURE__ */ new Map(), this.wrappedGlobalListeners = /* @__PURE__ */ new Map();
    }
    return o.prototype.wrap = function(t) {
      var e = this, r = t;
      return this.frameworkOverrides.shouldWrapOutgoing && (r = function(n) {
        e.frameworkOverrides.wrapOutgoing(function() {
          return t(n);
        });
      }, this.wrappedListeners.set(t, r)), r;
    }, o.prototype.wrapGlobal = function(t) {
      var e = this, r = t;
      return this.frameworkOverrides.shouldWrapOutgoing && (r = function(n, i) {
        e.frameworkOverrides.wrapOutgoing(function() {
          return t(n, i);
        });
      }, this.wrappedGlobalListeners.set(t, r)), r;
    }, o.prototype.unwrap = function(t) {
      var e;
      return (e = this.wrappedListeners.get(t)) !== null && e !== void 0 ? e : t;
    }, o.prototype.unwrapGlobal = function(t) {
      var e;
      return (e = this.wrappedGlobalListeners.get(t)) !== null && e !== void 0 ? e : t;
    }, o;
  }()
), Ef = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, KU = {
  resizable: !0,
  sortable: !0
}, qU = 0;
function n2() {
  return qU++;
}
var cr = (
  /** @class */
  function() {
    function o(t, e, r, n) {
      this.instanceId = n2(), this.autoHeaderHeight = null, this.moving = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.eventService = new Ts(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.colDef = t, this.userProvidedColDef = e, this.colId = r, this.primary = n, this.setState(t);
    }
    return o.prototype.getInstanceId = function() {
      return this.instanceId;
    }, o.prototype.setState = function(t) {
      t.sort !== void 0 ? (t.sort === "asc" || t.sort === "desc") && (this.sort = t.sort) : (t.initialSort === "asc" || t.initialSort === "desc") && (this.sort = t.initialSort);
      var e = t.sortIndex, r = t.initialSortIndex;
      e !== void 0 ? e !== null && (this.sortIndex = e) : r !== null && (this.sortIndex = r);
      var n = t.hide, i = t.initialHide;
      n !== void 0 ? this.visible = !n : this.visible = !i, t.pinned !== void 0 ? this.setPinned(t.pinned) : this.setPinned(t.initialPinned);
      var a = t.flex, s = t.initialFlex;
      a !== void 0 ? this.flex = a : s !== void 0 && (this.flex = s);
    }, o.prototype.setColDef = function(t, e, r) {
      r === void 0 && (r = "api"), this.colDef = t, this.userProvidedColDef = e, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", r));
    }, o.prototype.getUserProvidedColDef = function() {
      return this.userProvidedColDef;
    }, o.prototype.setParent = function(t) {
      this.parent = t;
    }, o.prototype.getParent = function() {
      return this.parent;
    }, o.prototype.setOriginalParent = function(t) {
      this.originalParent = t;
    }, o.prototype.getOriginalParent = function() {
      return this.originalParent;
    }, o.prototype.initialise = function() {
      this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip();
    }, o.prototype.initDotNotation = function() {
      var t = this.gridOptionsService.get("suppressFieldDotNotation");
      this.fieldContainsDots = Oe(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !t, this.tooltipFieldContainsDots = Oe(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !t;
    }, o.prototype.initMinAndMaxWidths = function() {
      var t = this.colDef;
      this.minWidth = this.columnUtils.calculateColMinWidth(t), this.maxWidth = this.columnUtils.calculateColMaxWidth(t);
    }, o.prototype.initTooltip = function() {
      this.tooltipEnabled = Oe(this.colDef.tooltipField) || Oe(this.colDef.tooltipValueGetter) || Oe(this.colDef.tooltipComponent);
    }, o.prototype.resetActualWidth = function(t) {
      t === void 0 && (t = "api");
      var e = this.columnUtils.calculateColInitialWidth(this.colDef);
      this.setActualWidth(e, t, !0);
    }, o.prototype.isEmptyGroup = function() {
      return !1;
    }, o.prototype.isRowGroupDisplayed = function(t) {
      if (tt(this.colDef) || tt(this.colDef.showRowGroup))
        return !1;
      var e = this.colDef.showRowGroup === !0, r = this.colDef.showRowGroup === t;
      return e || r;
    }, o.prototype.isPrimary = function() {
      return this.primary;
    }, o.prototype.isFilterAllowed = function() {
      var t = !!this.colDef.filter;
      return t;
    }, o.prototype.isFieldContainsDots = function() {
      return this.fieldContainsDots;
    }, o.prototype.isTooltipEnabled = function() {
      return this.tooltipEnabled;
    }, o.prototype.isTooltipFieldContainsDots = function() {
      return this.tooltipFieldContainsDots;
    }, o.prototype.addEventListener = function(t, e) {
      var r, n;
      this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.eventService.setFrameworkOverrides(this.frameworkOverrides), this.frameworkEventListenerService = new S1(this.frameworkOverrides));
      var i = (n = (r = this.frameworkEventListenerService) === null || r === void 0 ? void 0 : r.wrap(e)) !== null && n !== void 0 ? n : e;
      this.eventService.addEventListener(t, i);
    }, o.prototype.removeEventListener = function(t, e) {
      var r, n, i = (n = (r = this.frameworkEventListenerService) === null || r === void 0 ? void 0 : r.unwrap(e)) !== null && n !== void 0 ? n : e;
      this.eventService.removeEventListener(t, i);
    }, o.prototype.createColumnFunctionCallbackParams = function(t) {
      return this.gridOptionsService.addGridCommonParams({
        node: t,
        data: t.data,
        column: this,
        colDef: this.colDef
      });
    }, o.prototype.isSuppressNavigable = function(t) {
      if (typeof this.colDef.suppressNavigable == "boolean")
        return this.colDef.suppressNavigable;
      if (typeof this.colDef.suppressNavigable == "function") {
        var e = this.createColumnFunctionCallbackParams(t), r = this.colDef.suppressNavigable;
        return r(e);
      }
      return !1;
    }, o.prototype.isCellEditable = function(t) {
      return t.group && !this.gridOptionsService.get("enableGroupEdit") ? !1 : this.isColumnFunc(t, this.colDef.editable);
    }, o.prototype.isSuppressFillHandle = function() {
      return !!this.colDef.suppressFillHandle;
    }, o.prototype.isAutoHeight = function() {
      return !!this.colDef.autoHeight;
    }, o.prototype.isAutoHeaderHeight = function() {
      return !!this.colDef.autoHeaderHeight;
    }, o.prototype.isRowDrag = function(t) {
      return this.isColumnFunc(t, this.colDef.rowDrag);
    }, o.prototype.isDndSource = function(t) {
      return this.isColumnFunc(t, this.colDef.dndSource);
    }, o.prototype.isCellCheckboxSelection = function(t) {
      return this.isColumnFunc(t, this.colDef.checkboxSelection);
    }, o.prototype.isSuppressPaste = function(t) {
      return this.isColumnFunc(t, this.colDef ? this.colDef.suppressPaste : null);
    }, o.prototype.isResizable = function() {
      return !!this.getColDefValue("resizable");
    }, o.prototype.getColDefValue = function(t) {
      var e;
      return (e = this.colDef[t]) !== null && e !== void 0 ? e : KU[t];
    }, o.prototype.isColumnFunc = function(t, e) {
      if (typeof e == "boolean")
        return e;
      if (typeof e == "function") {
        var r = this.createColumnFunctionCallbackParams(t), n = e;
        return n(r);
      }
      return !1;
    }, o.prototype.setMoving = function(t, e) {
      e === void 0 && (e = "api"), this.moving = t, this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", e));
    }, o.prototype.createColumnEvent = function(t, e) {
      return this.gridOptionsService.addGridCommonParams({
        type: t,
        column: this,
        columns: [this],
        source: e
      });
    }, o.prototype.isMoving = function() {
      return this.moving;
    }, o.prototype.getSort = function() {
      return this.sort;
    }, o.prototype.setSort = function(t, e) {
      e === void 0 && (e = "api"), this.sort !== t && (this.sort = t, this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", e))), this.dispatchStateUpdatedEvent("sort");
    }, o.prototype.setMenuVisible = function(t, e) {
      e === void 0 && (e = "api"), this.menuVisible !== t && (this.menuVisible = t, this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", e)));
    }, o.prototype.isMenuVisible = function() {
      return this.menuVisible;
    }, o.prototype.isSortable = function() {
      return !!this.getColDefValue("sortable");
    }, o.prototype.isSortAscending = function() {
      return this.sort === "asc";
    }, o.prototype.isSortDescending = function() {
      return this.sort === "desc";
    }, o.prototype.isSortNone = function() {
      return tt(this.sort);
    }, o.prototype.isSorting = function() {
      return Oe(this.sort);
    }, o.prototype.getSortIndex = function() {
      return this.sortIndex;
    }, o.prototype.setSortIndex = function(t) {
      this.sortIndex = t, this.dispatchStateUpdatedEvent("sortIndex");
    }, o.prototype.setAggFunc = function(t) {
      this.aggFunc = t, this.dispatchStateUpdatedEvent("aggFunc");
    }, o.prototype.getAggFunc = function() {
      return this.aggFunc;
    }, o.prototype.getLeft = function() {
      return this.left;
    }, o.prototype.getOldLeft = function() {
      return this.oldLeft;
    }, o.prototype.getRight = function() {
      return this.left + this.actualWidth;
    }, o.prototype.setLeft = function(t, e) {
      e === void 0 && (e = "api"), this.oldLeft = this.left, this.left !== t && (this.left = t, this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", e)));
    }, o.prototype.isFilterActive = function() {
      return this.filterActive;
    }, o.prototype.setFilterActive = function(t, e, r) {
      e === void 0 && (e = "api"), this.filterActive !== t && (this.filterActive = t, this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", e)));
      var n = this.createColumnEvent("filterChanged", e);
      r && oi(n, r), this.eventService.dispatchEvent(n);
    }, o.prototype.isHovered = function() {
      return this.columnHoverService.isHovered(this);
    }, o.prototype.setPinned = function(t) {
      t === !0 || t === "left" ? this.pinned = "left" : t === "right" ? this.pinned = "right" : this.pinned = null, this.dispatchStateUpdatedEvent("pinned");
    }, o.prototype.setFirstRightPinned = function(t, e) {
      e === void 0 && (e = "api"), this.firstRightPinned !== t && (this.firstRightPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", e)));
    }, o.prototype.setLastLeftPinned = function(t, e) {
      e === void 0 && (e = "api"), this.lastLeftPinned !== t && (this.lastLeftPinned = t, this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", e)));
    }, o.prototype.isFirstRightPinned = function() {
      return this.firstRightPinned;
    }, o.prototype.isLastLeftPinned = function() {
      return this.lastLeftPinned;
    }, o.prototype.isPinned = function() {
      return this.pinned === "left" || this.pinned === "right";
    }, o.prototype.isPinnedLeft = function() {
      return this.pinned === "left";
    }, o.prototype.isPinnedRight = function() {
      return this.pinned === "right";
    }, o.prototype.getPinned = function() {
      return this.pinned;
    }, o.prototype.setVisible = function(t, e) {
      e === void 0 && (e = "api");
      var r = t === !0;
      this.visible !== r && (this.visible = r, this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", e))), this.dispatchStateUpdatedEvent("hide");
    }, o.prototype.isVisible = function() {
      return this.visible;
    }, o.prototype.isSpanHeaderHeight = function() {
      var t = this.getColDef();
      return !t.suppressSpanHeaderHeight && !t.autoHeaderHeight;
    }, o.prototype.getColDef = function() {
      return this.colDef;
    }, o.prototype.getColumnGroupShow = function() {
      return this.colDef.columnGroupShow;
    }, o.prototype.getColId = function() {
      return this.colId;
    }, o.prototype.getId = function() {
      return this.colId;
    }, o.prototype.getUniqueId = function() {
      return this.colId;
    }, o.prototype.getDefinition = function() {
      return this.colDef;
    }, o.prototype.getActualWidth = function() {
      return this.actualWidth;
    }, o.prototype.getAutoHeaderHeight = function() {
      return this.autoHeaderHeight;
    }, o.prototype.setAutoHeaderHeight = function(t) {
      var e = t !== this.autoHeaderHeight;
      return this.autoHeaderHeight = t, e;
    }, o.prototype.createBaseColDefParams = function(t) {
      var e = this.gridOptionsService.addGridCommonParams({
        node: t,
        data: t.data,
        colDef: this.colDef,
        column: this
      });
      return e;
    }, o.prototype.getColSpan = function(t) {
      if (tt(this.colDef.colSpan))
        return 1;
      var e = this.createBaseColDefParams(t), r = this.colDef.colSpan(e);
      return Math.max(r, 1);
    }, o.prototype.getRowSpan = function(t) {
      if (tt(this.colDef.rowSpan))
        return 1;
      var e = this.createBaseColDefParams(t), r = this.colDef.rowSpan(e);
      return Math.max(r, 1);
    }, o.prototype.setActualWidth = function(t, e, r) {
      e === void 0 && (e = "api"), r === void 0 && (r = !1), this.minWidth != null && (t = Math.max(t, this.minWidth)), this.maxWidth != null && (t = Math.min(t, this.maxWidth)), this.actualWidth !== t && (this.actualWidth = t, this.flex && e !== "flex" && e !== "gridInitializing" && (this.flex = null), r || this.fireColumnWidthChangedEvent(e)), this.dispatchStateUpdatedEvent("width");
    }, o.prototype.fireColumnWidthChangedEvent = function(t) {
      this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", t));
    }, o.prototype.isGreaterThanMax = function(t) {
      return this.maxWidth != null ? t > this.maxWidth : !1;
    }, o.prototype.getMinWidth = function() {
      return this.minWidth;
    }, o.prototype.getMaxWidth = function() {
      return this.maxWidth;
    }, o.prototype.getFlex = function() {
      return this.flex || 0;
    }, o.prototype.setFlex = function(t) {
      this.flex !== t && (this.flex = t), this.dispatchStateUpdatedEvent("flex");
    }, o.prototype.setMinimum = function(t) {
      t === void 0 && (t = "api"), Oe(this.minWidth) && this.setActualWidth(this.minWidth, t);
    }, o.prototype.setRowGroupActive = function(t, e) {
      e === void 0 && (e = "api"), this.rowGroupActive !== t && (this.rowGroupActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", e))), this.dispatchStateUpdatedEvent("rowGroup");
    }, o.prototype.isRowGroupActive = function() {
      return this.rowGroupActive;
    }, o.prototype.setPivotActive = function(t, e) {
      e === void 0 && (e = "api"), this.pivotActive !== t && (this.pivotActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", e))), this.dispatchStateUpdatedEvent("pivot");
    }, o.prototype.isPivotActive = function() {
      return this.pivotActive;
    }, o.prototype.isAnyFunctionActive = function() {
      return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }, o.prototype.isAnyFunctionAllowed = function() {
      return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }, o.prototype.setValueActive = function(t, e) {
      e === void 0 && (e = "api"), this.aggregationActive !== t && (this.aggregationActive = t, this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", e)));
    }, o.prototype.isValueActive = function() {
      return this.aggregationActive;
    }, o.prototype.isAllowPivot = function() {
      return this.colDef.enablePivot === !0;
    }, o.prototype.isAllowValue = function() {
      return this.colDef.enableValue === !0;
    }, o.prototype.isAllowRowGroup = function() {
      return this.colDef.enableRowGroup === !0;
    }, o.prototype.getMenuTabs = function(t) {
      var e = this.getColDef().menuTabs;
      return e == null && (e = t), e;
    }, o.prototype.dispatchStateUpdatedEvent = function(t) {
      this.eventService.dispatchEvent({
        type: o.EVENT_STATE_UPDATED,
        key: t
      });
    }, o.EVENT_MOVING_CHANGED = "movingChanged", o.EVENT_LEFT_CHANGED = "leftChanged", o.EVENT_WIDTH_CHANGED = "widthChanged", o.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged", o.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged", o.EVENT_VISIBLE_CHANGED = "visibleChanged", o.EVENT_FILTER_CHANGED = "filterChanged", o.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged", o.EVENT_SORT_CHANGED = "sortChanged", o.EVENT_COL_DEF_CHANGED = "colDefChanged", o.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged", o.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged", o.EVENT_PIVOT_CHANGED = "columnPivotChanged", o.EVENT_VALUE_CHANGED = "columnValueChanged", o.EVENT_STATE_UPDATED = "columnStateUpdated", Ef([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), Ef([
      N("columnUtils")
    ], o.prototype, "columnUtils", void 0), Ef([
      N("columnHoverService")
    ], o.prototype, "columnHoverService", void 0), Ef([
      N("frameworkOverrides")
    ], o.prototype, "frameworkOverrides", void 0), Ef([
      Fe
    ], o.prototype, "initialise", null), o;
  }()
), XU = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Ur = (
  /** @class */
  function() {
    function o(t, e, r, n) {
      this.localEventService = new Ts(), this.expandable = !1, this.instanceId = n2(), this.expandableListenerRemoveCallback = null, this.colGroupDef = t, this.groupId = e, this.expanded = !!t && !!t.openByDefault, this.padding = r, this.level = n;
    }
    return o.prototype.destroy = function() {
      this.expandableListenerRemoveCallback && this.reset(null, void 0);
    }, o.prototype.reset = function(t, e) {
      this.colGroupDef = t, this.level = e, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
    }, o.prototype.getInstanceId = function() {
      return this.instanceId;
    }, o.prototype.setOriginalParent = function(t) {
      this.originalParent = t;
    }, o.prototype.getOriginalParent = function() {
      return this.originalParent;
    }, o.prototype.getLevel = function() {
      return this.level;
    }, o.prototype.isVisible = function() {
      return this.children ? this.children.some(function(t) {
        return t.isVisible();
      }) : !1;
    }, o.prototype.isPadding = function() {
      return this.padding;
    }, o.prototype.setExpanded = function(t) {
      this.expanded = t === void 0 ? !1 : t;
      var e = {
        type: o.EVENT_EXPANDED_CHANGED
      };
      this.localEventService.dispatchEvent(e);
    }, o.prototype.isExpandable = function() {
      return this.expandable;
    }, o.prototype.isExpanded = function() {
      return this.expanded;
    }, o.prototype.getGroupId = function() {
      return this.groupId;
    }, o.prototype.getId = function() {
      return this.getGroupId();
    }, o.prototype.setChildren = function(t) {
      this.children = t;
    }, o.prototype.getChildren = function() {
      return this.children;
    }, o.prototype.getColGroupDef = function() {
      return this.colGroupDef;
    }, o.prototype.getLeafColumns = function() {
      var t = [];
      return this.addLeafColumns(t), t;
    }, o.prototype.addLeafColumns = function(t) {
      this.children && this.children.forEach(function(e) {
        e instanceof cr ? t.push(e) : e instanceof o && e.addLeafColumns(t);
      });
    }, o.prototype.getColumnGroupShow = function() {
      var t = this.colGroupDef;
      if (t)
        return t.columnGroupShow;
    }, o.prototype.setupExpandable = function() {
      var t = this;
      this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
      var e = this.onColumnVisibilityChanged.bind(this);
      this.getLeafColumns().forEach(function(r) {
        return r.addEventListener("visibleChanged", e);
      }), this.expandableListenerRemoveCallback = function() {
        t.getLeafColumns().forEach(function(r) {
          return r.removeEventListener("visibleChanged", e);
        }), t.expandableListenerRemoveCallback = null;
      };
    }, o.prototype.setExpandable = function() {
      if (!this.isPadding()) {
        for (var t = !1, e = !1, r = !1, n = this.findChildrenRemovingPadding(), i = 0, a = n.length; i < a; i++) {
          var s = n[i];
          if (s.isVisible()) {
            var l = s.getColumnGroupShow();
            l === "open" ? (t = !0, r = !0) : l === "closed" ? (e = !0, r = !0) : (t = !0, e = !0);
          }
        }
        var u = t && e && r;
        if (this.expandable !== u) {
          this.expandable = u;
          var c = {
            type: o.EVENT_EXPANDABLE_CHANGED
          };
          this.localEventService.dispatchEvent(c);
        }
      }
    }, o.prototype.findChildrenRemovingPadding = function() {
      var t = [], e = function(r) {
        r.forEach(function(n) {
          var i = n instanceof o && n.isPadding();
          i ? e(n.children) : t.push(n);
        });
      };
      return e(this.children), t;
    }, o.prototype.onColumnVisibilityChanged = function() {
      this.setExpandable();
    }, o.prototype.addEventListener = function(t, e) {
      this.localEventService.addEventListener(t, e);
    }, o.prototype.removeEventListener = function(t, e) {
      this.localEventService.removeEventListener(t, e);
    }, o.EVENT_EXPANDED_CHANGED = "expandedChanged", o.EVENT_EXPANDABLE_CHANGED = "expandableChanged", XU([
      eo
    ], o.prototype, "destroy", null), o;
  }()
), ZU = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
};
function o2() {
  for (var o = [], t = 0; t < arguments.length; t++)
    o[t] = arguments[t];
  for (var e = 0; e < o.length; e++) {
    var r = o[e];
    if (Oe(r))
      return r;
  }
  return null;
}
function QU(o) {
  return o != null && o.length > 0;
}
function Kt(o) {
  if (!(!o || !o.length))
    return o[o.length - 1];
}
function ws(o, t, e) {
  return o == null && t == null ? !0 : o != null && t != null && o.length === t.length && o.every(function(r, n) {
    return e ? e(r, t[n]) : t[n] === r;
  });
}
function JU(o, t) {
  return ws(o, t);
}
function i2(o) {
  return o.sort(function(t, e) {
    return t - e;
  });
}
function e$(o, t) {
  if (o)
    for (var e = o.length - 2; e >= 0; e--) {
      var r = o[e] === t, n = o[e + 1] === t;
      r && n && o.splice(e + 1, 1);
    }
}
function E1(o, t) {
  var e = o.indexOf(t);
  e >= 0 && (o[e] = o[o.length - 1], o.pop());
}
function ti(o, t) {
  var e = o.indexOf(t);
  e >= 0 && o.splice(e, 1);
}
function a2(o, t) {
  for (var e = 0; e < t.length; e++)
    E1(o, t[e]);
}
function s2(o, t) {
  for (var e = 0; e < t.length; e++)
    ti(o, t[e]);
}
function zh(o, t, e) {
  o.splice(e, 0, t);
}
function t$(o, t, e) {
  if (!(o == null || t == null))
    for (var r = t.length - 1; r >= 0; r--) {
      var n = t[r];
      zh(o, n, e);
    }
}
function DS(o, t, e) {
  s2(o, t), t.slice().reverse().forEach(function(r) {
    return zh(o, r, e);
  });
}
function ra(o, t) {
  return o.indexOf(t) > -1;
}
function l2(o) {
  return [].concat.apply([], o);
}
function AS(o, t) {
  t == null || o == null || t.forEach(function(e) {
    return o.push(e);
  });
}
function r$(o) {
  return o.map($h);
}
function n$(o, t) {
  if (o != null)
    for (var e = o.length - 1; e >= 0; e--)
      t(o[e], e);
}
var o$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstExistingValue: o2,
  existsAndNotEmpty: QU,
  last: Kt,
  areEqual: ws,
  shallowCompare: JU,
  sortNumerically: i2,
  removeRepeatsFromArray: e$,
  removeFromUnorderedArray: E1,
  removeFromArray: ti,
  removeAllFromUnorderedArray: a2,
  removeAllFromArray: s2,
  insertIntoArray: zh,
  insertArrayIntoArray: t$,
  moveInArray: DS,
  includes: ra,
  flatten: l2,
  pushAll: AS,
  toStrings: r$,
  forEachReverse: n$
}), u2 = "__ag_Grid_Stop_Propagation", i$ = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], Tw = {};
function Ba(o) {
  o[u2] = !0;
}
function na(o) {
  return o[u2] === !0;
}
var _1 = /* @__PURE__ */ function() {
  var o = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  }, t = function(e) {
    if (typeof Tw[e] == "boolean")
      return Tw[e];
    var r = document.createElement(o[e] || "div");
    return e = "on" + e, Tw[e] = e in r;
  };
  return t;
}();
function qm(o, t, e) {
  for (var r = t; r; ) {
    var n = o.getDomData(r, e);
    if (n)
      return n;
    r = r.parentElement;
  }
  return null;
}
function Xm(o, t) {
  return !t || !o ? !1 : d2(t).indexOf(o) >= 0;
}
function c2(o) {
  for (var t = [], e = o.target; e; )
    t.push(e), e = e.parentElement;
  return t;
}
function d2(o) {
  var t = o;
  return t.path ? t.path : t.composedPath ? t.composedPath() : c2(t);
}
function p2(o, t, e, r) {
  var n = ra(i$, e), i = n ? { passive: !0 } : void 0;
  o && o.addEventListener && o.addEventListener(t, e, r, i);
}
var a$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  stopPropagationForAgGrid: Ba,
  isStopPropagationForAgGrid: na,
  isEventSupported: _1,
  getCtrlForEventTarget: qm,
  isElementInEventPath: Xm,
  createEventPath: c2,
  getEventPath: d2,
  addSafePassiveEventListener: p2
}), Fu = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Me = (
  /** @class */
  function() {
    function o() {
      var t = this;
      this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.lastChangeSetIdLookup = {}, this.propertyListenerId = 0, this.isAlive = function() {
        return !t.destroyed;
      };
    }
    return o.prototype.getFrameworkOverrides = function() {
      return this.frameworkOverrides;
    }, o.prototype.getContext = function() {
      return this.context;
    }, o.prototype.destroy = function() {
      this.destroyFunctions.forEach(function(t) {
        return t();
      }), this.destroyFunctions.length = 0, this.destroyed = !0, this.dispatchEvent({ type: o.EVENT_DESTROYED });
    }, o.prototype.addEventListener = function(t, e) {
      this.localEventService || (this.localEventService = new Ts()), this.localEventService.addEventListener(t, e);
    }, o.prototype.removeEventListener = function(t, e) {
      this.localEventService && this.localEventService.removeEventListener(t, e);
    }, o.prototype.dispatchEvent = function(t) {
      this.localEventService && this.localEventService.dispatchEvent(t);
    }, o.prototype.addManagedListener = function(t, e, r) {
      var n = this;
      if (!this.destroyed) {
        t instanceof HTMLElement ? p2(this.getFrameworkOverrides(), t, e, r) : t.addEventListener(e, r);
        var i = function() {
          return t.removeEventListener(e, r), n.destroyFunctions = n.destroyFunctions.filter(function(a) {
            return a !== i;
          }), null;
        };
        return this.destroyFunctions.push(i), i;
      }
    }, o.prototype.setupGridOptionListener = function(t, e) {
      var r = this;
      this.gridOptionsService.addEventListener(t, e);
      var n = function() {
        return r.gridOptionsService.removeEventListener(t, e), r.destroyFunctions = r.destroyFunctions.filter(function(i) {
          return i !== n;
        }), null;
      };
      return this.destroyFunctions.push(n), n;
    }, o.prototype.addManagedPropertyListener = function(t, e) {
      return this.destroyed ? function() {
        return null;
      } : this.setupGridOptionListener(t, e);
    }, o.prototype.addManagedPropertyListeners = function(t, e) {
      var r = this;
      if (!this.destroyed) {
        var n = t.join("-") + this.propertyListenerId++, i = function(a) {
          if (a.changeSet) {
            if (a.changeSet && a.changeSet.id === r.lastChangeSetIdLookup[n])
              return;
            r.lastChangeSetIdLookup[n] = a.changeSet.id;
          }
          var s = {
            type: "gridPropertyChanged",
            changeSet: a.changeSet
          };
          e(s);
        };
        t.forEach(function(a) {
          return r.setupGridOptionListener(a, i);
        });
      }
    }, o.prototype.addDestroyFunc = function(t) {
      this.isAlive() ? this.destroyFunctions.push(t) : t();
    }, o.prototype.createManagedBean = function(t, e) {
      var r = this.createBean(t, e);
      return this.addDestroyFunc(this.destroyBean.bind(this, t, e)), r;
    }, o.prototype.createBean = function(t, e, r) {
      return (e || this.getContext()).createBean(t, r);
    }, o.prototype.destroyBean = function(t, e) {
      return (e || this.getContext()).destroyBean(t);
    }, o.prototype.destroyBeans = function(t, e) {
      var r = this;
      return t && t.forEach(function(n) {
        return r.destroyBean(n, e);
      }), [];
    }, o.EVENT_DESTROYED = "destroyed", Fu([
      N("frameworkOverrides")
    ], o.prototype, "frameworkOverrides", void 0), Fu([
      N("context")
    ], o.prototype, "context", void 0), Fu([
      N("eventService")
    ], o.prototype, "eventService", void 0), Fu([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), Fu([
      N("localeService")
    ], o.prototype, "localeService", void 0), Fu([
      N("environment")
    ], o.prototype, "environment", void 0), Fu([
      eo
    ], o.prototype, "destroy", null), o;
  }()
), s$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Dg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, l$ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, f2 = (
  /** @class */
  function(o) {
    s$(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("ColumnFactory");
    }, t.prototype.createColumnTree = function(e, r, n) {
      var i = new zF(), a = this.extractExistingTreeData(n), s = a.existingCols, l = a.existingGroups, u = a.existingColKeys;
      i.addExistingKeys(u);
      var c = this.recursivelyCreateColumns(e, 0, r, s, i, l), d = this.findMaxDept(c, 0);
      this.logger.log("Number of levels for grouped columns is " + d);
      var f = this.balanceColumnTree(c, 0, d, i), v = function(g, m) {
        g instanceof Ur && g.setupExpandable(), g.setOriginalParent(m);
      };
      return this.columnUtils.depthFirstOriginalTreeSearch(null, f, v), {
        columnTree: f,
        treeDept: d
      };
    }, t.prototype.extractExistingTreeData = function(e) {
      var r = [], n = [], i = [];
      return e && this.columnUtils.depthFirstOriginalTreeSearch(null, e, function(a) {
        if (a instanceof Ur) {
          var s = a;
          n.push(s);
        } else {
          var l = a;
          i.push(l.getId()), r.push(l);
        }
      }), { existingCols: r, existingGroups: n, existingColKeys: i };
    }, t.prototype.createForAutoGroups = function(e, r) {
      var n = this;
      return e.map(function(i) {
        return n.createAutoGroupTreeItem(r, i);
      });
    }, t.prototype.createAutoGroupTreeItem = function(e, r) {
      for (var n = this.findDepth(e), i = r, a = n - 1; a >= 0; a--) {
        var s = new Ur(null, "FAKE_PATH_".concat(r.getId(), "}_").concat(a), !0, a);
        this.createBean(s), s.setChildren([i]), i.setOriginalParent(s), i = s;
      }
      return n === 0 && r.setOriginalParent(null), i;
    }, t.prototype.findDepth = function(e) {
      for (var r = 0, n = e; n && n[0] && n[0] instanceof Ur; )
        r++, n = n[0].getChildren();
      return r;
    }, t.prototype.balanceColumnTree = function(e, r, n, i) {
      for (var a = [], s = 0; s < e.length; s++) {
        var l = e[s];
        if (l instanceof Ur) {
          var u = l, c = this.balanceColumnTree(u.getChildren(), r + 1, n, i);
          u.setChildren(c), a.push(u);
        } else {
          for (var d = void 0, f = void 0, v = n - 1; v >= r; v--) {
            var g = i.getUniqueKey(null, null), m = this.createMergedColGroupDef(null), b = new Ur(m, g, !0, r);
            this.createBean(b), f && f.setChildren([b]), f = b, d || (d = f);
          }
          if (d && f) {
            a.push(d);
            var S = e.some(function(R) {
              return R instanceof Ur;
            });
            if (S) {
              f.setChildren([l]);
              continue;
            } else {
              f.setChildren(e);
              break;
            }
          }
          a.push(l);
        }
      }
      return a;
    }, t.prototype.findMaxDept = function(e, r) {
      for (var n = r, i = 0; i < e.length; i++) {
        var a = e[i];
        if (a instanceof Ur) {
          var s = a, l = this.findMaxDept(s.getChildren(), r + 1);
          n < l && (n = l);
        }
      }
      return n;
    }, t.prototype.recursivelyCreateColumns = function(e, r, n, i, a, s) {
      if (!e)
        return [];
      for (var l = new Array(e.length), u = 0; u < l.length; u++) {
        var c = e[u];
        this.isColumnGroup(c) ? l[u] = this.createColumnGroup(n, c, r, i, a, s) : l[u] = this.createColumn(n, c, i, a);
      }
      return l;
    }, t.prototype.createColumnGroup = function(e, r, n, i, a, s) {
      var l = this.createMergedColGroupDef(r), u = a.getUniqueKey(l.groupId || null, null), c = new Ur(l, u, !1, n);
      this.createBean(c);
      var d = this.findExistingGroup(r, s);
      d && s.splice(d.idx, 1);
      var f = d == null ? void 0 : d.group;
      f && c.setExpanded(f.isExpanded());
      var v = this.recursivelyCreateColumns(l.children, n + 1, e, i, a, s);
      return c.setChildren(v), c;
    }, t.prototype.createMergedColGroupDef = function(e) {
      var r = {};
      return Object.assign(r, this.gridOptionsService.get("defaultColGroupDef")), Object.assign(r, e), r;
    }, t.prototype.createColumn = function(e, r, n, i) {
      var a = this.findExistingColumn(r, n);
      a && (n == null || n.splice(a.idx, 1));
      var s = a == null ? void 0 : a.column;
      if (s) {
        var u = this.addColumnDefaultAndTypes(r, s.getColId());
        s.setColDef(u, r), this.applyColumnState(s, u);
      } else {
        var l = i.getUniqueKey(r.colId, r.field), u = this.addColumnDefaultAndTypes(r, l);
        s = new cr(u, r, l, e), this.context.createBean(s);
      }
      return this.dataTypeService.addColumnListeners(s), s;
    }, t.prototype.applyColumnState = function(e, r) {
      var n = Al(r.flex);
      n !== void 0 && e.setFlex(n);
      var i = e.getFlex() <= 0;
      if (i) {
        var a = Al(r.width);
        if (a != null)
          e.setActualWidth(a);
        else {
          var s = e.getActualWidth();
          e.setActualWidth(s);
        }
      }
      r.sort !== void 0 && (r.sort == "asc" || r.sort == "desc" ? e.setSort(r.sort) : e.setSort(void 0));
      var l = Al(r.sortIndex);
      l !== void 0 && e.setSortIndex(l);
      var u = zm(r.hide);
      u !== void 0 && e.setVisible(!u), r.pinned !== void 0 && e.setPinned(r.pinned);
    }, t.prototype.findExistingColumn = function(e, r) {
      if (r)
        for (var n = 0; n < r.length; n++) {
          var i = r[n].getUserProvidedColDef();
          if (i) {
            var a = e.colId != null;
            if (a) {
              if (r[n].getId() === e.colId)
                return { idx: n, column: r[n] };
              continue;
            }
            var s = e.field != null;
            if (s) {
              if (i.field === e.field)
                return { idx: n, column: r[n] };
              continue;
            }
            if (i === e)
              return { idx: n, column: r[n] };
          }
        }
    }, t.prototype.findExistingGroup = function(e, r) {
      var n = e.groupId != null;
      if (n)
        for (var i = 0; i < r.length; i++) {
          var a = r[i], s = a.getColGroupDef();
          if (s && a.getId() === e.groupId)
            return { idx: i, group: a };
        }
    }, t.prototype.addColumnDefaultAndTypes = function(e, r) {
      var n = {}, i = this.gridOptionsService.get("defaultColDef");
      oi(n, i, !1, !0);
      var a = this.dataTypeService.updateColDefAndGetColumnType(n, e, r);
      a && this.assignColumnTypes(a, n), oi(n, e, !1, !0);
      var s = this.gridOptionsService.get("autoGroupColumnDef"), l = this.gridOptionsService.isColumnsSortingCoupledToGroup();
      return e.rowGroup && s && l && oi(n, { sort: s.sort, initialSort: s.initialSort }, !1, !0), this.dataTypeService.validateColDef(n), n;
    }, t.prototype.assignColumnTypes = function(e, r) {
      if (e.length) {
        var n = Object.assign({}, ZU), i = this.gridOptionsService.get("columnTypes") || {};
        Xn(i, function(a, s) {
          if (a in n)
            console.warn("AG Grid: the column type '".concat(a, "' is a default column type and cannot be overridden."));
          else {
            var l = s;
            l.type && ht("Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type."), n[a] = s;
          }
        }), e.forEach(function(a) {
          var s = n[a.trim()];
          s ? oi(r, s, !1, !0) : console.warn("AG Grid: colDef.type '" + a + "' does not correspond to defined gridOptions.columnTypes");
        });
      }
    }, t.prototype.isColumnGroup = function(e) {
      return e.children !== void 0;
    }, Dg([
      N("columnUtils")
    ], t.prototype, "columnUtils", void 0), Dg([
      N("dataTypeService")
    ], t.prototype, "dataTypeService", void 0), Dg([
      l$(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), t = Dg([
      Be("columnFactory")
    ], t), t;
  }(Me)
), u$ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, pn = (
  /** @class */
  function() {
    function o(t, e, r, n) {
      this.displayedChildren = [], this.localEventService = new Ts(), this.groupId = e, this.partId = r, this.providedColumnGroup = t, this.pinned = n;
    }
    return o.createUniqueId = function(t, e) {
      return t + "_" + e;
    }, o.prototype.reset = function() {
      this.parent = null, this.children = null, this.displayedChildren = null;
    }, o.prototype.getParent = function() {
      return this.parent;
    }, o.prototype.setParent = function(t) {
      this.parent = t;
    }, o.prototype.getUniqueId = function() {
      return o.createUniqueId(this.groupId, this.partId);
    }, o.prototype.isEmptyGroup = function() {
      return this.displayedChildren.length === 0;
    }, o.prototype.isMoving = function() {
      var t = this.getProvidedColumnGroup().getLeafColumns();
      return !t || t.length === 0 ? !1 : t.every(function(e) {
        return e.isMoving();
      });
    }, o.prototype.checkLeft = function() {
      if (this.displayedChildren.forEach(function(n) {
        n instanceof o && n.checkLeft();
      }), this.displayedChildren.length > 0)
        if (this.gridOptionsService.get("enableRtl")) {
          var t = Kt(this.displayedChildren), e = t.getLeft();
          this.setLeft(e);
        } else {
          var r = this.displayedChildren[0].getLeft();
          this.setLeft(r);
        }
      else
        this.setLeft(null);
    }, o.prototype.getLeft = function() {
      return this.left;
    }, o.prototype.getOldLeft = function() {
      return this.oldLeft;
    }, o.prototype.setLeft = function(t) {
      this.oldLeft = this.left, this.left !== t && (this.left = t, this.localEventService.dispatchEvent(this.createAgEvent(o.EVENT_LEFT_CHANGED)));
    }, o.prototype.getPinned = function() {
      return this.pinned;
    }, o.prototype.createAgEvent = function(t) {
      return { type: t };
    }, o.prototype.addEventListener = function(t, e) {
      this.localEventService.addEventListener(t, e);
    }, o.prototype.removeEventListener = function(t, e) {
      this.localEventService.removeEventListener(t, e);
    }, o.prototype.getGroupId = function() {
      return this.groupId;
    }, o.prototype.getPartId = function() {
      return this.partId;
    }, o.prototype.isChildInThisGroupDeepSearch = function(t) {
      var e = !1;
      return this.children.forEach(function(r) {
        t === r && (e = !0), r instanceof o && r.isChildInThisGroupDeepSearch(t) && (e = !0);
      }), e;
    }, o.prototype.getActualWidth = function() {
      var t = 0;
      return this.displayedChildren && this.displayedChildren.forEach(function(e) {
        t += e.getActualWidth();
      }), t;
    }, o.prototype.isResizable = function() {
      if (!this.displayedChildren)
        return !1;
      var t = !1;
      return this.displayedChildren.forEach(function(e) {
        e.isResizable() && (t = !0);
      }), t;
    }, o.prototype.getMinWidth = function() {
      var t = 0;
      return this.displayedChildren.forEach(function(e) {
        t += e.getMinWidth() || 0;
      }), t;
    }, o.prototype.addChild = function(t) {
      this.children || (this.children = []), this.children.push(t);
    }, o.prototype.getDisplayedChildren = function() {
      return this.displayedChildren;
    }, o.prototype.getLeafColumns = function() {
      var t = [];
      return this.addLeafColumns(t), t;
    }, o.prototype.getDisplayedLeafColumns = function() {
      var t = [];
      return this.addDisplayedLeafColumns(t), t;
    }, o.prototype.getDefinition = function() {
      return this.providedColumnGroup.getColGroupDef();
    }, o.prototype.getColGroupDef = function() {
      return this.providedColumnGroup.getColGroupDef();
    }, o.prototype.isPadding = function() {
      return this.providedColumnGroup.isPadding();
    }, o.prototype.isExpandable = function() {
      return this.providedColumnGroup.isExpandable();
    }, o.prototype.isExpanded = function() {
      return this.providedColumnGroup.isExpanded();
    }, o.prototype.setExpanded = function(t) {
      this.providedColumnGroup.setExpanded(t);
    }, o.prototype.addDisplayedLeafColumns = function(t) {
      this.displayedChildren.forEach(function(e) {
        e instanceof cr ? t.push(e) : e instanceof o && e.addDisplayedLeafColumns(t);
      });
    }, o.prototype.addLeafColumns = function(t) {
      this.children.forEach(function(e) {
        e instanceof cr ? t.push(e) : e instanceof o && e.addLeafColumns(t);
      });
    }, o.prototype.getChildren = function() {
      return this.children;
    }, o.prototype.getColumnGroupShow = function() {
      return this.providedColumnGroup.getColumnGroupShow();
    }, o.prototype.getProvidedColumnGroup = function() {
      return this.providedColumnGroup;
    }, o.prototype.getPaddingLevel = function() {
      var t = this.getParent();
      return !this.isPadding() || !t || !t.isPadding() ? 0 : 1 + t.getPaddingLevel();
    }, o.prototype.calculateDisplayedColumns = function() {
      var t = this;
      this.displayedChildren = [];
      for (var e = this; e != null && e.isPadding(); )
        e = e.getParent();
      var r = e ? e.providedColumnGroup.isExpandable() : !1;
      if (!r) {
        this.displayedChildren = this.children, this.localEventService.dispatchEvent(this.createAgEvent(o.EVENT_DISPLAYED_CHILDREN_CHANGED));
        return;
      }
      this.children.forEach(function(n) {
        var i = n instanceof o && (!n.displayedChildren || !n.displayedChildren.length);
        if (!i) {
          var a = n.getColumnGroupShow();
          switch (a) {
            case "open":
              e.providedColumnGroup.isExpanded() && t.displayedChildren.push(n);
              break;
            case "closed":
              e.providedColumnGroup.isExpanded() || t.displayedChildren.push(n);
              break;
            default:
              t.displayedChildren.push(n);
              break;
          }
        }
      }), this.localEventService.dispatchEvent(this.createAgEvent(o.EVENT_DISPLAYED_CHILDREN_CHANGED));
    }, o.EVENT_LEFT_CHANGED = "leftChanged", o.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged", u$([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), o;
  }()
), G = (
  /** @class */
  function() {
    function o() {
    }
    return o.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged", o.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded", o.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged", o.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged", o.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll", o.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged", o.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged", o.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged", o.EVENT_COLUMN_MOVED = "columnMoved", o.EVENT_COLUMN_VISIBLE = "columnVisible", o.EVENT_COLUMN_PINNED = "columnPinned", o.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened", o.EVENT_COLUMN_RESIZED = "columnResized", o.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged", o.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED = "suppressMovableColumns", o.EVENT_SUPPRESS_MENU_HIDE_CHANGED = "suppressMenuHide", o.EVENT_SUPPRESS_FIELD_DOT_NOTATION = "suppressFieldDotNotation", o.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged", o.EVENT_COLUMN_HEADER_MOUSE_OVER = "columnHeaderMouseOver", o.EVENT_COLUMN_HEADER_MOUSE_LEAVE = "columnHeaderMouseLeave", o.EVENT_COLUMN_HEADER_CLICKED = "columnHeaderClicked", o.EVENT_COLUMN_HEADER_CONTEXT_MENU = "columnHeaderContextMenu", o.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed", o.EVENT_ROW_GROUP_OPENED = "rowGroupOpened", o.EVENT_ROW_DATA_UPDATED = "rowDataUpdated", o.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged", o.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged", o.EVENT_CHART_CREATED = "chartCreated", o.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged", o.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged", o.EVENT_CHART_DESTROYED = "chartDestroyed", o.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged", o.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged", o.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart", o.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd", o.EVENT_MODEL_UPDATED = "modelUpdated", o.EVENT_CUT_START = "cutStart", o.EVENT_CUT_END = "cutEnd", o.EVENT_PASTE_START = "pasteStart", o.EVENT_PASTE_END = "pasteEnd", o.EVENT_FILL_START = "fillStart", o.EVENT_FILL_END = "fillEnd", o.EVENT_RANGE_DELETE_START = "rangeDeleteStart", o.EVENT_RANGE_DELETE_END = "rangeDeleteEnd", o.EVENT_UNDO_STARTED = "undoStarted", o.EVENT_UNDO_ENDED = "undoEnded", o.EVENT_REDO_STARTED = "redoStarted", o.EVENT_REDO_ENDED = "redoEnded", o.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart", o.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd", o.EVENT_CELL_CLICKED = "cellClicked", o.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked", o.EVENT_CELL_MOUSE_DOWN = "cellMouseDown", o.EVENT_CELL_CONTEXT_MENU = "cellContextMenu", o.EVENT_CELL_VALUE_CHANGED = "cellValueChanged", o.EVENT_CELL_EDIT_REQUEST = "cellEditRequest", o.EVENT_ROW_VALUE_CHANGED = "rowValueChanged", o.EVENT_CELL_FOCUSED = "cellFocused", o.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared", o.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused", o.EVENT_ROW_SELECTED = "rowSelected", o.EVENT_SELECTION_CHANGED = "selectionChanged", o.EVENT_TOOLTIP_SHOW = "tooltipShow", o.EVENT_TOOLTIP_HIDE = "tooltipHide", o.EVENT_CELL_KEY_DOWN = "cellKeyDown", o.EVENT_CELL_MOUSE_OVER = "cellMouseOver", o.EVENT_CELL_MOUSE_OUT = "cellMouseOut", o.EVENT_FILTER_CHANGED = "filterChanged", o.EVENT_FILTER_MODIFIED = "filterModified", o.EVENT_FILTER_OPENED = "filterOpened", o.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED = "advancedFilterBuilderVisibleChanged", o.EVENT_SORT_CHANGED = "sortChanged", o.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved", o.EVENT_ROW_CLICKED = "rowClicked", o.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked", o.EVENT_GRID_READY = "gridReady", o.EVENT_GRID_PRE_DESTROYED = "gridPreDestroyed", o.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged", o.EVENT_VIEWPORT_CHANGED = "viewportChanged", o.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged", o.EVENT_FIRST_DATA_RENDERED = "firstDataRendered", o.EVENT_DRAG_STARTED = "dragStarted", o.EVENT_DRAG_STOPPED = "dragStopped", o.EVENT_CHECKBOX_CHANGED = "checkboxChanged", o.EVENT_ROW_EDITING_STARTED = "rowEditingStarted", o.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped", o.EVENT_CELL_EDITING_STARTED = "cellEditingStarted", o.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped", o.EVENT_BODY_SCROLL = "bodyScroll", o.EVENT_BODY_SCROLL_END = "bodyScrollEnd", o.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged", o.EVENT_PAGINATION_CHANGED = "paginationChanged", o.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged", o.EVENT_STORE_REFRESHED = "storeRefreshed", o.EVENT_STATE_UPDATED = "stateUpdated", o.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged", o.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged", o.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged", o.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged", o.EVENT_FLASH_CELLS = "flashCells", o.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged", o.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged", o.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged", o.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged", o.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged", o.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged", o.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged", o.EVENT_ROW_DRAG_ENTER = "rowDragEnter", o.EVENT_ROW_DRAG_MOVE = "rowDragMove", o.EVENT_ROW_DRAG_LEAVE = "rowDragLeave", o.EVENT_ROW_DRAG_END = "rowDragEnd", o.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged", o.EVENT_POPUP_TO_FRONT = "popupToFront", o.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest", o.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest", o.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest", o.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest", o.EVENT_STORE_UPDATED = "storeUpdated", o.EVENT_FILTER_DESTROYED = "filterDestroyed", o.EVENT_ROW_DATA_UPDATE_STARTED = "rowDataUpdateStarted", o.EVENT_ROW_COUNT_READY = "rowCountReady", o.EVENT_ADVANCED_FILTER_ENABLED_CHANGED = "advancedFilterEnabledChanged", o.EVENT_DATA_TYPES_INFERRED = "dataTypesInferred", o.EVENT_FIELD_VALUE_CHANGED = "fieldValueChanged", o.EVENT_FIELD_PICKER_VALUE_SELECTED = "fieldPickerValueSelected", o.EVENT_SIDE_BAR_UPDATED = "sideBarUpdated", o;
  }()
), x1 = (
  /** @class */
  function() {
    function o() {
      this.existingIds = {};
    }
    return o.prototype.getInstanceIdForKey = function(t) {
      var e = this.existingIds[t], r;
      return typeof e != "number" ? r = 0 : r = e + 1, this.existingIds[t] = r, r;
    }, o;
  }()
), c$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ow = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, vc = "ag-Grid-AutoColumn", d$ = (
  /** @class */
  function(o) {
    c$(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.createAutoGroupColumns = function(e) {
      var r = this, n = [], i = this.gridOptionsService.get("treeData"), a = this.gridOptionsService.isGroupMultiAutoColumn();
      return i && a && (console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data'), a = !1), a ? e.forEach(function(s, l) {
        n.push(r.createOneAutoGroupColumn(s, l));
      }) : n.push(this.createOneAutoGroupColumn()), n;
    }, t.prototype.updateAutoGroupColumns = function(e) {
      var r = this;
      e.forEach(function(n, i) {
        return r.updateOneAutoGroupColumn(n, i);
      });
    }, t.prototype.createOneAutoGroupColumn = function(e, r) {
      var n;
      e ? n = "".concat(vc, "-").concat(e.getId()) : n = vc;
      var i = this.createAutoGroupColDef(n, e, r);
      i.colId = n;
      var a = new cr(i, null, n, !0);
      return this.context.createBean(a), a;
    }, t.prototype.updateOneAutoGroupColumn = function(e, r) {
      var n = e.getColDef(), i = typeof n.showRowGroup == "string" ? n.showRowGroup : void 0, a = i != null ? this.columnModel.getPrimaryColumn(i) : void 0, s = this.createAutoGroupColDef(e.getId(), a ?? void 0, r);
      e.setColDef(s, null), this.columnFactory.applyColumnState(e, s);
    }, t.prototype.createAutoGroupColDef = function(e, r, n) {
      var i = this.createBaseColDef(r), a = this.gridOptionsService.get("autoGroupColumnDef");
      if (oi(i, a), i = this.columnFactory.addColumnDefaultAndTypes(i, e), !this.gridOptionsService.get("treeData")) {
        var s = tt(i.field) && tt(i.valueGetter) && tt(i.filterValueGetter) && i.filter !== "agGroupColumnFilter";
        s && (i.filter = !1);
      }
      n && n > 0 && (i.headerCheckboxSelection = !1);
      var l = this.gridOptionsService.isColumnsSortingCoupledToGroup(), u = i.valueGetter || i.field != null;
      return l && !u && (i.sortIndex = void 0, i.initialSort = void 0), i;
    }, t.prototype.createBaseColDef = function(e) {
      var r = this.gridOptionsService.get("autoGroupColumnDef"), n = this.localeService.getLocaleTextFunc(), i = {
        headerName: n("group", "Group")
      }, a = r && (r.cellRenderer || r.cellRendererSelector);
      if (a || (i.cellRenderer = "agGroupCellRenderer"), e) {
        var s = e.getColDef();
        Object.assign(i, {
          // cellRendererParams.groupKey: colDefToCopy.field;
          headerName: this.columnModel.getDisplayNameForColumn(e, "header"),
          headerValueGetter: s.headerValueGetter
        }), s.cellRenderer && Object.assign(i, {
          cellRendererParams: {
            innerRenderer: s.cellRenderer,
            innerRendererParams: s.cellRendererParams
          }
        }), i.showRowGroup = e.getColId();
      } else
        i.showRowGroup = !0;
      return i;
    }, Ow([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ow([
      N("columnFactory")
    ], t.prototype, "columnFactory", void 0), t = Ow([
      Be("autoGroupColService")
    ], t), t;
  }(Me)
), p$ = /[&<>"']/g, f$ = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function h$(o) {
  var t = String.fromCharCode;
  function e(d) {
    var f = [];
    if (!d)
      return [];
    for (var v = d.length, g = 0, m, b; g < v; )
      m = d.charCodeAt(g++), m >= 55296 && m <= 56319 && g < v ? (b = d.charCodeAt(g++), (b & 64512) == 56320 ? f.push(((m & 1023) << 10) + (b & 1023) + 65536) : (f.push(m), g--)) : f.push(m);
    return f;
  }
  function r(d) {
    if (d >= 55296 && d <= 57343)
      throw Error("Lone surrogate U+" + d.toString(16).toUpperCase() + " is not a scalar value");
  }
  function n(d, f) {
    return t(d >> f & 63 | 128);
  }
  function i(d) {
    if (d >= 0 && d <= 31 && d !== 10) {
      var f = d.toString(16).toUpperCase(), v = f.padStart(4, "0");
      return "_x".concat(v, "_");
    }
    if (!(d & 4294967168))
      return t(d);
    var g = "";
    return d & 4294965248 ? d & 4294901760 ? d & 4292870144 || (g = t(d >> 18 & 7 | 240), g += n(d, 12), g += n(d, 6)) : (r(d), g = t(d >> 12 & 15 | 224), g += n(d, 6)) : g = t(d >> 6 & 31 | 192), g += t(d & 63 | 128), g;
  }
  for (var a = e(o), s = a.length, l = -1, u, c = ""; ++l < s; )
    u = a[l], c += i(u);
  return c;
}
function v$(o) {
  return o[0].toUpperCase() + o.substring(1).toLowerCase();
}
function vn(o, t) {
  if (o == null)
    return null;
  var e = o.toString().toString();
  return t ? e : e.replace(p$, function(r) {
    return f$[r];
  });
}
function h2(o) {
  if (!o || o == null)
    return null;
  var t = /([a-z])([A-Z])/g, e = /([A-Z]+)([A-Z])([a-z])/g, r = o.replace(t, "$1 $2").replace(e, "$1 $2$3").replace(/\./g, " ").split(" ");
  return r.map(function(n) {
    return n.substring(0, 1).toUpperCase() + (n.length > 1 ? n.substring(1, n.length) : "");
  }).join(" ");
}
function v2(o) {
  return o.replace(/[A-Z]/g, function(t) {
    return "-".concat(t.toLocaleLowerCase());
  });
}
var g$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  utf8_encode: h$,
  capitalise: v$,
  escapeString: vn,
  camelCaseToHumanText: h2,
  camelCaseToHyphenated: v2
});
function Sl(o) {
  var t = /* @__PURE__ */ new Map();
  return o.forEach(function(e) {
    return t.set(e[0], e[1]);
  }), t;
}
function m$(o, t) {
  var e = /* @__PURE__ */ new Map();
  return o.forEach(function(r) {
    return e.set(t(r), r);
  }), e;
}
function y$(o) {
  var t = [];
  return o.forEach(function(e, r) {
    return t.push(r);
  }), t;
}
var C$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  convertToMap: Sl,
  mapById: m$,
  keys: y$
}), w$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hn = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, b$ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, S$ = function(o, t) {
  var e = {};
  for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && t.indexOf(r) < 0 && (e[r] = o[r]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(o); n < r.length; n++)
      t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(o, r[n]) && (e[r[n]] = o[r[n]]);
  return e;
}, $o = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, zo = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, Pw = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, g2 = (
  /** @class */
  function(o) {
    w$(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.primaryHeaderRowCount = 0, e.secondaryHeaderRowCount = 0, e.gridHeaderRowCount = 0, e.displayedColumnsLeft = [], e.displayedColumnsRight = [], e.displayedColumnsCenter = [], e.displayedColumns = [], e.displayedColumnsAndGroupsMap = {}, e.viewportColumns = [], e.viewportColumnsHash = "", e.headerViewportColumns = [], e.viewportColumnsCenter = [], e.headerViewportColumnsCenter = [], e.viewportRowLeft = {}, e.viewportRowRight = {}, e.viewportRowCenter = {}, e.autoHeightActiveAtLeastOnce = !1, e.rowGroupColumns = [], e.valueColumns = [], e.pivotColumns = [], e.ready = !1, e.autoGroupsNeedBuilding = !1, e.forceRecreateAutoGroups = !1, e.pivotMode = !1, e.bodyWidth = 0, e.leftWidth = 0, e.rightWidth = 0, e.bodyWidthDirty = !0, e.shouldQueueResizeOperations = !1, e.resizeOperationQueue = [], e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.suppressColumnVirtualisation = this.gridOptionsService.get("suppressColumnVirtualisation");
      var r = this.gridOptionsService.get("pivotMode");
      this.isPivotSettingAllowed(r) && (this.pivotMode = r), this.addManagedPropertyListeners(["groupDisplayType", "treeData", "treeDataDisplayType", "groupHideOpenParents"], function() {
        return e.buildAutoGroupColumns();
      }), this.addManagedPropertyListener("autoGroupColumnDef", function() {
        return e.onAutoGroupColumnDefChanged();
      }), this.addManagedPropertyListeners(["defaultColDef", "columnTypes", "suppressFieldDotNotation"], function(n) {
        return e.onSharedColDefChanged(n.source);
      }), this.addManagedPropertyListener("pivotMode", function(n) {
        return e.setPivotMode(e.gridOptionsService.get("pivotMode"), n.source);
      }), this.addManagedListener(this.eventService, G.EVENT_FIRST_DATA_RENDERED, function() {
        return e.onFirstDataRendered();
      });
    }, t.prototype.buildAutoGroupColumns = function() {
      this.columnDefs && (this.autoGroupsNeedBuilding = !0, this.forceRecreateAutoGroups = !0, this.updateGridColumns(), this.updateDisplayedColumns("gridOptionsChanged"));
    }, t.prototype.onAutoGroupColumnDefChanged = function() {
      this.groupAutoColumns && this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns);
    }, t.prototype.onSharedColDefChanged = function(e) {
      e === void 0 && (e = "api"), this.gridColumns && (this.groupAutoColumns && this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns), this.createColumnsFromColumnDefs(!0, e));
    }, t.prototype.setColumnDefs = function(e, r) {
      r === void 0 && (r = "api");
      var n = !!this.columnDefs;
      this.columnDefs = e, this.createColumnsFromColumnDefs(n, r);
    }, t.prototype.recreateColumnDefs = function(e) {
      e === void 0 && (e = "api"), this.onSharedColDefChanged(e);
    }, t.prototype.destroyOldColumns = function(e, r) {
      var n = {};
      if (e) {
        this.columnUtils.depthFirstOriginalTreeSearch(null, e, function(a) {
          n[a.getInstanceId()] = a;
        }), r && this.columnUtils.depthFirstOriginalTreeSearch(null, r, function(a) {
          n[a.getInstanceId()] = null;
        });
        var i = Object.values(n).filter(function(a) {
          return a != null;
        });
        this.destroyBeans(i);
      }
    }, t.prototype.destroyColumns = function() {
      this.destroyOldColumns(this.primaryColumnTree), this.destroyOldColumns(this.secondaryBalancedTree), this.destroyOldColumns(this.groupAutoColsBalancedTree);
    }, t.prototype.createColumnsFromColumnDefs = function(e, r) {
      var n = this;
      r === void 0 && (r = "api");
      var i = e ? this.compareColumnStatesAndDispatchEvents(r) : void 0;
      this.valueCache.expire(), this.autoGroupsNeedBuilding = !0;
      var a = this.primaryColumns, s = this.primaryColumnTree, l = this.columnFactory.createColumnTree(this.columnDefs, !0, s);
      this.destroyOldColumns(this.primaryColumnTree, l.columnTree), this.primaryColumnTree = l.columnTree, this.primaryHeaderRowCount = l.treeDept + 1, this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree), this.primaryColumnsMap = {}, this.primaryColumns.forEach(function(d) {
        return n.primaryColumnsMap[d.getId()] = d;
      }), this.extractRowGroupColumns(r, a), this.extractPivotColumns(r, a), this.extractValueColumns(r, a), this.ready = !0;
      var u = this.gridColsArePrimary === void 0, c = this.gridColsArePrimary || u || this.autoGroupsNeedBuilding;
      c && (this.updateGridColumns(), e && this.gridColsArePrimary && !this.gridOptionsService.get("maintainColumnOrder") && this.orderGridColumnsLikePrimary(), this.updateDisplayedColumns(r), this.checkViewportColumns()), this.dispatchEverythingChanged(r), i && i(), this.dispatchNewColumnsLoaded(r);
    }, t.prototype.dispatchNewColumnsLoaded = function(e) {
      var r = {
        type: G.EVENT_NEW_COLUMNS_LOADED,
        source: e
      };
      this.eventService.dispatchEvent(r), e === "gridInitializing" && this.onColumnsReady();
    }, t.prototype.dispatchEverythingChanged = function(e) {
      e === void 0 && (e = "api");
      var r = {
        type: G.EVENT_COLUMN_EVERYTHING_CHANGED,
        source: e
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.orderGridColumnsLikePrimary = function() {
      var e = this, r = this.primaryColumns;
      if (r) {
        var n = r.filter(function(a) {
          return e.gridColumns.indexOf(a) >= 0;
        }), i = this.gridColumns.filter(function(a) {
          return n.indexOf(a) < 0;
        });
        this.gridColumns = zo(zo([], $o(i), !1), $o(n), !1), this.gridColumns = this.placeLockedColumns(this.gridColumns);
      }
    }, t.prototype.getAllDisplayedAutoHeightCols = function() {
      return this.displayedAutoHeightCols;
    }, t.prototype.setViewport = function() {
      this.gridOptionsService.get("enableRtl") ? (this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth, this.viewportRight = this.bodyWidth - this.scrollPosition) : (this.viewportLeft = this.scrollPosition, this.viewportRight = this.scrollWidth + this.scrollPosition);
    }, t.prototype.getDisplayedColumnsStartingAt = function(e) {
      for (var r = e, n = []; r != null; )
        n.push(r), r = this.getDisplayedColAfter(r);
      return n;
    }, t.prototype.checkViewportColumns = function(e) {
      if (e === void 0 && (e = !1), this.displayedColumnsCenter != null) {
        var r = this.extractViewport();
        if (r) {
          var n = {
            type: G.EVENT_VIRTUAL_COLUMNS_CHANGED,
            afterScroll: e
          };
          this.eventService.dispatchEvent(n);
        }
      }
    }, t.prototype.setViewportPosition = function(e, r, n) {
      n === void 0 && (n = !1), (e !== this.scrollWidth || r !== this.scrollPosition || this.bodyWidthDirty) && (this.scrollWidth = e, this.scrollPosition = r, this.bodyWidthDirty = !0, this.setViewport(), this.ready && this.checkViewportColumns(n));
    }, t.prototype.isPivotMode = function() {
      return this.pivotMode;
    }, t.prototype.isPivotSettingAllowed = function(e) {
      return e && this.gridOptionsService.get("treeData") ? (console.warn("AG Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'"), !1) : !0;
    }, t.prototype.setPivotMode = function(e, r) {
      if (r === void 0 && (r = "api"), !(e === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) && (this.pivotMode = e, !!this.gridColumns)) {
        this.autoGroupsNeedBuilding = !0, this.updateGridColumns(), this.updateDisplayedColumns(r);
        var n = {
          type: G.EVENT_COLUMN_PIVOT_MODE_CHANGED
        };
        this.eventService.dispatchEvent(n);
      }
    }, t.prototype.getSecondaryPivotColumn = function(e, r) {
      if (tt(this.secondaryColumns))
        return null;
      var n = this.getPrimaryColumn(r), i = null;
      return this.secondaryColumns.forEach(function(a) {
        var s = a.getColDef().pivotKeys, l = a.getColDef().pivotValueColumn, u = ws(s, e), c = l === n;
        u && c && (i = a);
      }), i;
    }, t.prototype.setBeans = function(e) {
      this.logger = e.create("columnModel");
    }, t.prototype.setFirstRightAndLastLeftPinned = function(e) {
      var r, n;
      this.gridOptionsService.get("enableRtl") ? (r = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null, n = this.displayedColumnsRight ? Kt(this.displayedColumnsRight) : null) : (r = this.displayedColumnsLeft ? Kt(this.displayedColumnsLeft) : null, n = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null), this.gridColumns.forEach(function(i) {
        i.setLastLeftPinned(i === r, e), i.setFirstRightPinned(i === n, e);
      });
    }, t.prototype.autoSizeColumns = function(e) {
      var r = this;
      if (this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function() {
          return r.autoSizeColumns(e);
        });
        return;
      }
      var n = e.columns, i = e.skipHeader, a = e.skipHeaderGroups, s = e.stopAtGroup, l = e.source, u = l === void 0 ? "api" : l;
      this.animationFrameService.flushAllFrames();
      for (var c = [], d = -1, f = i ?? this.gridOptionsService.get("skipHeaderOnAutoSize"), v = a ?? f; d !== 0; )
        d = 0, this.actionOnGridColumns(n, function(g) {
          if (c.indexOf(g) >= 0)
            return !1;
          var m = r.autoWidthCalculator.getPreferredWidthForColumn(g, f);
          if (m > 0) {
            var b = r.normaliseColumnWidth(g, m);
            g.setActualWidth(b, u), c.push(g), d++;
          }
          return !0;
        }, u);
      v || this.autoSizeColumnGroupsByColumns(n, u, s), this.dispatchColumnResizedEvent(c, !0, "autosizeColumns");
    }, t.prototype.dispatchColumnResizedEvent = function(e, r, n, i) {
      if (i === void 0 && (i = null), e && e.length) {
        var a = {
          type: G.EVENT_COLUMN_RESIZED,
          columns: e,
          column: e.length === 1 ? e[0] : null,
          flexColumns: i,
          finished: r,
          source: n
        };
        this.eventService.dispatchEvent(a);
      }
    }, t.prototype.dispatchColumnChangedEvent = function(e, r, n) {
      var i = {
        type: e,
        columns: r,
        column: r && r.length == 1 ? r[0] : null,
        source: n
      };
      this.eventService.dispatchEvent(i);
    }, t.prototype.dispatchColumnMovedEvent = function(e) {
      var r = e.movedColumns, n = e.source, i = e.toIndex, a = e.finished, s = {
        type: G.EVENT_COLUMN_MOVED,
        columns: r,
        column: r && r.length === 1 ? r[0] : null,
        toIndex: i,
        finished: a,
        source: n
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.dispatchColumnPinnedEvent = function(e, r) {
      if (e.length) {
        var n = e.length === 1 ? e[0] : null, i = this.getCommonValue(e, function(s) {
          return s.getPinned();
        }), a = {
          type: G.EVENT_COLUMN_PINNED,
          // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
          pinned: i ?? null,
          columns: e,
          column: n,
          source: r
        };
        this.eventService.dispatchEvent(a);
      }
    }, t.prototype.dispatchColumnVisibleEvent = function(e, r) {
      if (e.length) {
        var n = e.length === 1 ? e[0] : null, i = this.getCommonValue(e, function(s) {
          return s.isVisible();
        }), a = {
          type: G.EVENT_COLUMN_VISIBLE,
          visible: i,
          columns: e,
          column: n,
          source: r
        };
        this.eventService.dispatchEvent(a);
      }
    }, t.prototype.autoSizeColumn = function(e, r, n) {
      n === void 0 && (n = "api"), e && this.autoSizeColumns({ columns: [e], skipHeader: r, skipHeaderGroups: !0, source: n });
    }, t.prototype.autoSizeColumnGroupsByColumns = function(e, r, n) {
      var i, a, s, l, u = /* @__PURE__ */ new Set(), c = this.getGridColumns(e);
      c.forEach(function(P) {
        for (var D = P.getParent(); D && D != n; )
          D.isPadding() || u.add(D), D = D.getParent();
      });
      var d, f = [];
      try {
        for (var v = Pw(u), g = v.next(); !g.done; g = v.next()) {
          var m = g.value;
          try {
            for (var b = (s = void 0, Pw(this.ctrlsService.getHeaderRowContainerCtrls())), S = b.next(); !S.done; S = b.next()) {
              var R = S.value;
              if (d = R.getHeaderCtrlForColumn(m), d)
                break;
            }
          } catch (P) {
            s = { error: P };
          } finally {
            try {
              S && !S.done && (l = b.return) && l.call(b);
            } finally {
              if (s) throw s.error;
            }
          }
          d && d.resizeLeafColumnsToFit(r);
        }
      } catch (P) {
        i = { error: P };
      } finally {
        try {
          g && !g.done && (a = v.return) && a.call(v);
        } finally {
          if (i) throw i.error;
        }
      }
      return f;
    }, t.prototype.autoSizeAllColumns = function(e, r) {
      var n = this;
      if (r === void 0 && (r = "api"), this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function() {
          return n.autoSizeAllColumns(e, r);
        });
        return;
      }
      var i = this.getAllDisplayedColumns();
      this.autoSizeColumns({ columns: i, skipHeader: e, source: r });
    }, t.prototype.getColumnsFromTree = function(e) {
      var r = [], n = function(i) {
        for (var a = 0; a < i.length; a++) {
          var s = i[a];
          s instanceof cr ? r.push(s) : s instanceof Ur && n(s.getChildren());
        }
      };
      return n(e), r;
    }, t.prototype.getAllDisplayedTrees = function() {
      return this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre ? this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight) : null;
    }, t.prototype.getPrimaryColumnTree = function() {
      return this.primaryColumnTree;
    }, t.prototype.getHeaderRowCount = function() {
      return this.gridHeaderRowCount;
    }, t.prototype.getDisplayedTreeLeft = function() {
      return this.displayedTreeLeft;
    }, t.prototype.getDisplayedTreeRight = function() {
      return this.displayedTreeRight;
    }, t.prototype.getDisplayedTreeCentre = function() {
      return this.displayedTreeCentre;
    }, t.prototype.isColumnDisplayed = function(e) {
      return this.getAllDisplayedColumns().indexOf(e) >= 0;
    }, t.prototype.getAllDisplayedColumns = function() {
      return this.displayedColumns;
    }, t.prototype.getViewportColumns = function() {
      return this.viewportColumns;
    }, t.prototype.getDisplayedLeftColumnsForRow = function(e) {
      return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsLeft) : this.displayedColumnsLeft;
    }, t.prototype.getDisplayedRightColumnsForRow = function(e) {
      return this.colSpanActive ? this.getDisplayedColumnsForRow(e, this.displayedColumnsRight) : this.displayedColumnsRight;
    }, t.prototype.isColSpanActive = function() {
      return this.colSpanActive;
    }, t.prototype.getDisplayedColumnsForRow = function(e, r, n, i) {
      for (var a = [], s = null, l = function(d) {
        var f = r[d], v = r.length - d, g = Math.min(f.getColSpan(e), v), m = [f];
        if (g > 1) {
          for (var b = g - 1, S = 1; S <= b; S++)
            m.push(r[d + S]);
          d += b;
        }
        var R;
        if (n ? (R = !1, m.forEach(function(D) {
          n(D) && (R = !0);
        })) : R = !0, R) {
          if (a.length === 0 && s) {
            var P = i ? i(f) : !1;
            P && a.push(s);
          }
          a.push(f);
        }
        s = f, u = d;
      }, u, c = 0; c < r.length; c++)
        l(c), c = u;
      return a;
    }, t.prototype.getViewportCenterColumnsForRow = function(e) {
      var r = this;
      if (!this.colSpanActive)
        return this.viewportColumnsCenter;
      var n = function(a) {
        var s = a.getLeft();
        return Oe(s) && s > r.viewportLeft;
      }, i = this.suppressColumnVirtualisation ? null : this.isColumnInRowViewport.bind(this);
      return this.getDisplayedColumnsForRow(e, this.displayedColumnsCenter, i, n);
    }, t.prototype.isColumnAtEdge = function(e, r) {
      var n = this.getAllDisplayedColumns();
      if (!n.length)
        return !1;
      var i = r === "first", a;
      if (e instanceof pn) {
        var s = e.getDisplayedLeafColumns();
        if (!s.length)
          return !1;
        a = i ? s[0] : Kt(s);
      } else
        a = e;
      return (i ? n[0] : Kt(n)) === a;
    }, t.prototype.getAriaColumnIndex = function(e) {
      var r;
      return e instanceof pn ? r = e.getLeafColumns()[0] : r = e, this.ariaOrderColumns.indexOf(r) + 1;
    }, t.prototype.isColumnInHeaderViewport = function(e) {
      return e.isAutoHeaderHeight() ? !0 : this.isColumnInRowViewport(e);
    }, t.prototype.isColumnInRowViewport = function(e) {
      if (e.isAutoHeight() || this.viewportRight === 0)
        return !0;
      var r = e.getLeft() || 0, n = r + e.getActualWidth(), i = this.viewportLeft - 200, a = this.viewportRight + 200, s = r < i && n < i, l = r > a && n > a;
      return !s && !l;
    }, t.prototype.getDisplayedColumnsLeftWidth = function() {
      return this.getWidthOfColsInList(this.displayedColumnsLeft);
    }, t.prototype.getDisplayedColumnsRightWidth = function() {
      return this.getWidthOfColsInList(this.displayedColumnsRight);
    }, t.prototype.updatePrimaryColumnList = function(e, r, n, i, a, s) {
      var l = this;
      if (s === void 0 && (s = "api"), !(!e || ri(e))) {
        var u = !1;
        if (e.forEach(function(d) {
          var f = l.getPrimaryColumn(d);
          if (f) {
            if (n) {
              if (r.indexOf(f) >= 0)
                return;
              r.push(f);
            } else {
              if (r.indexOf(f) < 0)
                return;
              ti(r, f);
            }
            i(f), u = !0;
          }
        }), !!u) {
          this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(s);
          var c = {
            type: a,
            columns: r,
            column: r.length === 1 ? r[0] : null,
            source: s
          };
          this.eventService.dispatchEvent(c);
        }
      }
    }, t.prototype.setRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.setPrimaryColumnList(e, this.rowGroupColumns, G.EVENT_COLUMN_ROW_GROUP_CHANGED, !0, this.setRowGroupActive.bind(this), r);
    }, t.prototype.setRowGroupActive = function(e, r, n) {
      e !== r.isRowGroupActive() && (r.setRowGroupActive(e, n), e && !this.gridOptionsService.get("suppressRowGroupHidesColumns") && this.setColumnVisible(r, !1, n), !e && !this.gridOptionsService.get("suppressMakeColumnVisibleAfterUnGroup") && this.setColumnVisible(r, !0, n));
    }, t.prototype.addRowGroupColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.addRowGroupColumns([e], r);
    }, t.prototype.addRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(e, this.rowGroupColumns, !0, this.setRowGroupActive.bind(this, !0), G.EVENT_COLUMN_ROW_GROUP_CHANGED, r);
    }, t.prototype.removeRowGroupColumns = function(e, r) {
      r === void 0 && (r = "api"), this.autoGroupsNeedBuilding = !0, this.updatePrimaryColumnList(e, this.rowGroupColumns, !1, this.setRowGroupActive.bind(this, !1), G.EVENT_COLUMN_ROW_GROUP_CHANGED, r);
    }, t.prototype.removeRowGroupColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.removeRowGroupColumns([e], r);
    }, t.prototype.addPivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.pivotColumns, !0, function(n) {
        return n.setPivotActive(!0, r);
      }, G.EVENT_COLUMN_PIVOT_CHANGED, r);
    }, t.prototype.setPivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.setPrimaryColumnList(e, this.pivotColumns, G.EVENT_COLUMN_PIVOT_CHANGED, !0, function(n, i) {
        i.setPivotActive(n, r);
      }, r);
    }, t.prototype.addPivotColumn = function(e, r) {
      r === void 0 && (r = "api"), this.addPivotColumns([e], r);
    }, t.prototype.removePivotColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.pivotColumns, !1, function(n) {
        return n.setPivotActive(!1, r);
      }, G.EVENT_COLUMN_PIVOT_CHANGED, r);
    }, t.prototype.removePivotColumn = function(e, r) {
      r === void 0 && (r = "api"), this.removePivotColumns([e], r);
    }, t.prototype.setPrimaryColumnList = function(e, r, n, i, a, s) {
      var l = this;
      if (this.gridColumns) {
        var u = /* @__PURE__ */ new Map();
        r.forEach(function(c, d) {
          return u.set(c, d);
        }), r.length = 0, Oe(e) && e.forEach(function(c) {
          var d = l.getPrimaryColumn(c);
          d && r.push(d);
        }), r.forEach(function(c, d) {
          var f = u.get(c);
          if (f === void 0) {
            u.set(c, 0);
            return;
          }
          i && f !== d || u.delete(c);
        }), (this.primaryColumns || []).forEach(function(c) {
          var d = r.indexOf(c) >= 0;
          a(d, c);
        }), this.autoGroupsNeedBuilding && this.updateGridColumns(), this.updateDisplayedColumns(s), this.dispatchColumnChangedEvent(n, zo([], $o(u.keys()), !1), s);
      }
    }, t.prototype.setValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.setPrimaryColumnList(e, this.valueColumns, G.EVENT_COLUMN_VALUE_CHANGED, !1, this.setValueActive.bind(this), r);
    }, t.prototype.setValueActive = function(e, r, n) {
      if (e !== r.isValueActive() && (r.setValueActive(e, n), e && !r.getAggFunc())) {
        var i = this.aggFuncService.getDefaultAggFunc(r);
        r.setAggFunc(i);
      }
    }, t.prototype.addValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.valueColumns, !0, this.setValueActive.bind(this, !0), G.EVENT_COLUMN_VALUE_CHANGED, r);
    }, t.prototype.addValueColumn = function(e, r) {
      r === void 0 && (r = "api"), e && this.addValueColumns([e], r);
    }, t.prototype.removeValueColumn = function(e, r) {
      r === void 0 && (r = "api"), this.removeValueColumns([e], r);
    }, t.prototype.removeValueColumns = function(e, r) {
      r === void 0 && (r = "api"), this.updatePrimaryColumnList(e, this.valueColumns, !1, this.setValueActive.bind(this, !1), G.EVENT_COLUMN_VALUE_CHANGED, r);
    }, t.prototype.normaliseColumnWidth = function(e, r) {
      var n = e.getMinWidth();
      Oe(n) && r < n && (r = n);
      var i = e.getMaxWidth();
      return Oe(i) && e.isGreaterThanMax(r) && (r = i), r;
    }, t.prototype.getPrimaryOrGridColumn = function(e) {
      var r = this.getPrimaryColumn(e);
      return r || this.getGridColumn(e);
    }, t.prototype.setColumnWidths = function(e, r, n, i) {
      var a = this;
      i === void 0 && (i = "api");
      var s = [];
      e.forEach(function(l) {
        var u = a.getPrimaryOrGridColumn(l.key);
        if (u) {
          s.push({
            width: l.newWidth,
            ratios: [1],
            columns: [u]
          });
          var c = a.gridOptionsService.get("colResizeDefault") === "shift";
          if (c && (r = !r), r) {
            var d = a.getDisplayedColAfter(u);
            if (!d)
              return;
            var f = u.getActualWidth() - l.newWidth, v = d.getActualWidth() + f;
            s.push({
              width: v,
              ratios: [1],
              columns: [d]
            });
          }
        }
      }), s.length !== 0 && this.resizeColumnSets({
        resizeSets: s,
        finished: n,
        source: i
      });
    }, t.prototype.checkMinAndMaxWidthsForSet = function(e) {
      var r = e.columns, n = e.width, i = 0, a = 0, s = !0;
      r.forEach(function(c) {
        var d = c.getMinWidth();
        i += d || 0;
        var f = c.getMaxWidth();
        Oe(f) && f > 0 ? a += f : s = !1;
      });
      var l = n >= i, u = !s || n <= a;
      return l && u;
    }, t.prototype.resizeColumnSets = function(e) {
      var r = this, n = e.resizeSets, i = e.finished, a = e.source, s = !n || n.every(function(g) {
        return r.checkMinAndMaxWidthsForSet(g);
      });
      if (!s) {
        if (i) {
          var l = n && n.length > 0 ? n[0].columns : null;
          this.dispatchColumnResizedEvent(l, i, a);
        }
        return;
      }
      var u = [], c = [];
      n.forEach(function(g) {
        var m = g.width, b = g.columns, S = g.ratios, R = {}, P = {};
        b.forEach(function(H) {
          return c.push(H);
        });
        for (var D = !0, x = 0, M = function() {
          if (x++, x > 1e3)
            return console.error("AG Grid: infinite loop in resizeColumnSets"), "break";
          D = !1;
          var H = [], B = 0, j = m;
          b.forEach(function(W, q) {
            var ee = P[W.getId()];
            if (ee)
              j -= R[W.getId()];
            else {
              H.push(W);
              var re = S[q];
              B += re;
            }
          });
          var V = 1 / B;
          H.forEach(function(W, q) {
            var ee = q === H.length - 1, re;
            ee ? re = j : (re = Math.round(S[q] * m * V), j -= re);
            var ie = W.getMinWidth(), ne = W.getMaxWidth();
            Oe(ie) && re < ie ? (re = ie, P[W.getId()] = !0, D = !0) : Oe(ne) && ne > 0 && re > ne && (re = ne, P[W.getId()] = !0, D = !0), R[W.getId()] = re;
          });
        }; D; ) {
          var F = M();
          if (F === "break")
            break;
        }
        b.forEach(function(H) {
          var B = R[H.getId()], j = H.getActualWidth();
          j !== B && (H.setActualWidth(B, a), u.push(H));
        });
      });
      var d = u.length > 0, f = [];
      d && (f = this.refreshFlexedColumns({ resizingCols: c, skipSetLeft: !0 }), this.setLeftValues(a), this.updateBodyWidths(), this.checkViewportColumns());
      var v = c.concat(f);
      (d || i) && this.dispatchColumnResizedEvent(v, i, a, f);
    }, t.prototype.setColumnAggFunc = function(e, r, n) {
      if (n === void 0 && (n = "api"), !!e) {
        var i = this.getPrimaryColumn(e);
        i && (i.setAggFunc(r), this.dispatchColumnChangedEvent(G.EVENT_COLUMN_VALUE_CHANGED, [i], n));
      }
    }, t.prototype.moveRowGroupColumn = function(e, r, n) {
      if (n === void 0 && (n = "api"), !this.isRowGroupEmpty()) {
        var i = this.rowGroupColumns[e], a = this.rowGroupColumns.slice(e, r);
        this.rowGroupColumns.splice(e, 1), this.rowGroupColumns.splice(r, 0, i);
        var s = {
          type: G.EVENT_COLUMN_ROW_GROUP_CHANGED,
          columns: a,
          column: a.length === 1 ? a[0] : null,
          source: n
        };
        this.eventService.dispatchEvent(s);
      }
    }, t.prototype.moveColumns = function(e, r, n, i) {
      if (n === void 0 && (n = "api"), i === void 0 && (i = !0), !!this.gridColumns) {
        if (this.columnAnimationService.start(), r > this.gridColumns.length - e.length) {
          console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + r), console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
          return;
        }
        var a = this.getGridColumns(e), s = !this.doesMovePassRules(a, r);
        s || (DS(this.gridColumns, a, r), this.updateDisplayedColumns(n), this.dispatchColumnMovedEvent({ movedColumns: a, source: n, toIndex: r, finished: i }), this.columnAnimationService.finish());
      }
    }, t.prototype.doesMovePassRules = function(e, r) {
      var n = this.getProposedColumnOrder(e, r);
      return this.doesOrderPassRules(n);
    }, t.prototype.doesOrderPassRules = function(e) {
      return !(!this.doesMovePassMarryChildren(e) || !this.doesMovePassLockedPositions(e));
    }, t.prototype.getProposedColumnOrder = function(e, r) {
      var n = this.gridColumns.slice();
      return DS(n, e, r), n;
    }, t.prototype.sortColumnsLikeGridColumns = function(e) {
      var r = this;
      if (!(!e || e.length <= 1)) {
        var n = e.filter(function(i) {
          return r.gridColumns.indexOf(i) < 0;
        }).length > 0;
        n || e.sort(function(i, a) {
          var s = r.gridColumns.indexOf(i), l = r.gridColumns.indexOf(a);
          return s - l;
        });
      }
    }, t.prototype.doesMovePassLockedPositions = function(e) {
      var r = 0, n = !0, i = function(a) {
        return a ? a === !0 || a === "left" ? 0 : 2 : 1;
      };
      return e.forEach(function(a) {
        var s = i(a.getColDef().lockPosition);
        s < r && (n = !1), r = s;
      }), n;
    }, t.prototype.doesMovePassMarryChildren = function(e) {
      var r = !0;
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(n) {
        if (n instanceof Ur) {
          var i = n, a = i.getColGroupDef(), s = a && a.marryChildren;
          if (s) {
            var l = [];
            i.getLeafColumns().forEach(function(v) {
              var g = e.indexOf(v);
              l.push(g);
            });
            var u = Math.max.apply(Math, l), c = Math.min.apply(Math, l), d = u - c, f = i.getLeafColumns().length - 1;
            d > f && (r = !1);
          }
        }
      }), r;
    }, t.prototype.moveColumn = function(e, r, n) {
      n === void 0 && (n = "api"), this.moveColumns([e], r, n);
    }, t.prototype.moveColumnByIndex = function(e, r, n) {
      if (n === void 0 && (n = "api"), !!this.gridColumns) {
        var i = this.gridColumns[e];
        this.moveColumn(i, r, n);
      }
    }, t.prototype.getColumnDefs = function() {
      var e = this;
      if (this.primaryColumns) {
        var r = this.primaryColumns.slice();
        return this.gridColsArePrimary ? r.sort(function(n, i) {
          return e.gridColumns.indexOf(n) - e.gridColumns.indexOf(i);
        }) : this.lastPrimaryOrder && r.sort(function(n, i) {
          return e.lastPrimaryOrder.indexOf(n) - e.lastPrimaryOrder.indexOf(i);
        }), this.columnDefFactory.buildColumnDefs(r, this.rowGroupColumns, this.pivotColumns);
      }
    }, t.prototype.getBodyContainerWidth = function() {
      return this.bodyWidth;
    }, t.prototype.getContainerWidth = function(e) {
      switch (e) {
        case "left":
          return this.leftWidth;
        case "right":
          return this.rightWidth;
        default:
          return this.bodyWidth;
      }
    }, t.prototype.updateBodyWidths = function() {
      var e = this.getWidthOfColsInList(this.displayedColumnsCenter), r = this.getWidthOfColsInList(this.displayedColumnsLeft), n = this.getWidthOfColsInList(this.displayedColumnsRight);
      this.bodyWidthDirty = this.bodyWidth !== e;
      var i = this.bodyWidth !== e || this.leftWidth !== r || this.rightWidth !== n;
      if (i) {
        this.bodyWidth = e, this.leftWidth = r, this.rightWidth = n;
        var a = {
          type: G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
        };
        this.eventService.dispatchEvent(a);
      }
    }, t.prototype.getValueColumns = function() {
      return this.valueColumns ? this.valueColumns : [];
    }, t.prototype.getPivotColumns = function() {
      return this.pivotColumns ? this.pivotColumns : [];
    }, t.prototype.isPivotActive = function() {
      return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    }, t.prototype.getRowGroupColumns = function() {
      return this.rowGroupColumns ? this.rowGroupColumns : [];
    }, t.prototype.getDisplayedCenterColumns = function() {
      return this.displayedColumnsCenter;
    }, t.prototype.getDisplayedLeftColumns = function() {
      return this.displayedColumnsLeft;
    }, t.prototype.getDisplayedRightColumns = function() {
      return this.displayedColumnsRight;
    }, t.prototype.getDisplayedColumns = function(e) {
      switch (e) {
        case "left":
          return this.getDisplayedLeftColumns();
        case "right":
          return this.getDisplayedRightColumns();
        default:
          return this.getDisplayedCenterColumns();
      }
    }, t.prototype.getAllPrimaryColumns = function() {
      return this.primaryColumns ? this.primaryColumns.slice() : null;
    }, t.prototype.getSecondaryColumns = function() {
      return this.secondaryColumns ? this.secondaryColumns.slice() : null;
    }, t.prototype.getAllColumnsForQuickFilter = function() {
      return this.columnsForQuickFilter;
    }, t.prototype.getAllGridColumns = function() {
      var e;
      return (e = this.gridColumns) !== null && e !== void 0 ? e : [];
    }, t.prototype.isEmpty = function() {
      return ri(this.gridColumns);
    }, t.prototype.isRowGroupEmpty = function() {
      return ri(this.rowGroupColumns);
    }, t.prototype.setColumnVisible = function(e, r, n) {
      n === void 0 && (n = "api"), this.setColumnsVisible([e], r, n);
    }, t.prototype.setColumnsVisible = function(e, r, n) {
      r === void 0 && (r = !1), n === void 0 && (n = "api"), this.applyColumnState({
        state: e.map(function(i) {
          return {
            colId: typeof i == "string" ? i : i.getColId(),
            hide: !r
          };
        })
      }, n);
    }, t.prototype.setColumnPinned = function(e, r, n) {
      n === void 0 && (n = "api"), e && this.setColumnsPinned([e], r, n);
    }, t.prototype.setColumnsPinned = function(e, r, n) {
      if (n === void 0 && (n = "api"), !!this.gridColumns) {
        if (this.gridOptionsService.isDomLayout("print")) {
          console.warn("AG Grid: Changing the column pinning status is not allowed with domLayout='print'");
          return;
        }
        this.columnAnimationService.start();
        var i;
        r === !0 || r === "left" ? i = "left" : r === "right" ? i = "right" : i = null, this.actionOnGridColumns(e, function(a) {
          return a.getPinned() !== i ? (a.setPinned(i), !0) : !1;
        }, n, function() {
          var a = {
            type: G.EVENT_COLUMN_PINNED,
            pinned: i,
            column: null,
            columns: null,
            source: n
          };
          return a;
        }), this.columnAnimationService.finish();
      }
    }, t.prototype.actionOnGridColumns = function(e, r, n, i) {
      var a = this;
      if (!ri(e)) {
        var s = [];
        if (e.forEach(function(u) {
          var c = a.getGridColumn(u);
          if (c) {
            var d = r(c);
            d !== !1 && s.push(c);
          }
        }), !!s.length && (this.updateDisplayedColumns(n), Oe(i) && i)) {
          var l = i();
          l.columns = s, l.column = s.length === 1 ? s[0] : null, this.eventService.dispatchEvent(l);
        }
      }
    }, t.prototype.getDisplayedColBefore = function(e) {
      var r = this.getAllDisplayedColumns(), n = r.indexOf(e);
      return n > 0 ? r[n - 1] : null;
    }, t.prototype.getDisplayedColAfter = function(e) {
      var r = this.getAllDisplayedColumns(), n = r.indexOf(e);
      return n < r.length - 1 ? r[n + 1] : null;
    }, t.prototype.getDisplayedGroupAfter = function(e) {
      return this.getDisplayedGroupAtDirection(e, "After");
    }, t.prototype.getDisplayedGroupBefore = function(e) {
      return this.getDisplayedGroupAtDirection(e, "Before");
    }, t.prototype.getDisplayedGroupAtDirection = function(e, r) {
      for (var n = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), i = e.getDisplayedLeafColumns(), a = r === "After" ? Kt(i) : i[0], s = "getDisplayedCol".concat(r); ; ) {
        var l = this[s](a);
        if (!l)
          return null;
        var u = this.getColumnGroupAtLevel(l, n);
        if (u !== e)
          return u;
      }
    }, t.prototype.getColumnGroupAtLevel = function(e, r) {
      for (var n = e.getParent(), i, a; ; ) {
        var s = n.getProvidedColumnGroup();
        if (i = s.getLevel(), a = n.getPaddingLevel(), i + a <= r)
          break;
        n = n.getParent();
      }
      return n;
    }, t.prototype.isPinningLeft = function() {
      return this.displayedColumnsLeft.length > 0;
    }, t.prototype.isPinningRight = function() {
      return this.displayedColumnsRight.length > 0;
    }, t.prototype.getPrimaryAndSecondaryAndAutoColumns = function() {
      var e;
      return (e = []).concat.apply(e, [
        this.primaryColumns || [],
        this.groupAutoColumns || [],
        this.secondaryColumns || []
      ]);
    }, t.prototype.createStateItemFromColumn = function(e) {
      var r = e.isRowGroupActive() ? this.rowGroupColumns.indexOf(e) : null, n = e.isPivotActive() ? this.pivotColumns.indexOf(e) : null, i = e.isValueActive() ? e.getAggFunc() : null, a = e.getSort() != null ? e.getSort() : null, s = e.getSortIndex() != null ? e.getSortIndex() : null, l = e.getFlex() != null && e.getFlex() > 0 ? e.getFlex() : null, u = {
        colId: e.getColId(),
        width: e.getActualWidth(),
        hide: !e.isVisible(),
        pinned: e.getPinned(),
        sort: a,
        sortIndex: s,
        aggFunc: i,
        rowGroup: e.isRowGroupActive(),
        rowGroupIndex: r,
        pivot: e.isPivotActive(),
        pivotIndex: n,
        flex: l
      };
      return u;
    }, t.prototype.getColumnState = function() {
      if (tt(this.primaryColumns) || !this.isAlive())
        return [];
      var e = this.getPrimaryAndSecondaryAndAutoColumns(), r = e.map(this.createStateItemFromColumn.bind(this));
      return this.orderColumnStateList(r), r;
    }, t.prototype.orderColumnStateList = function(e) {
      var r = Sl(this.gridColumns.map(function(n, i) {
        return [n.getColId(), i];
      }));
      e.sort(function(n, i) {
        var a = r.has(n.colId) ? r.get(n.colId) : -1, s = r.has(i.colId) ? r.get(i.colId) : -1;
        return a - s;
      });
    }, t.prototype.resetColumnState = function(e) {
      var r = this;
      if (e === void 0 && (e = "api"), !ri(this.primaryColumns)) {
        var n = this.getColumnsFromTree(this.primaryColumnTree), i = [], a = 1e3, s = 1e3, l = [];
        this.groupAutoColumns && (l = l.concat(this.groupAutoColumns)), n && (l = l.concat(n)), l.forEach(function(u) {
          var c = r.getColumnStateFromColDef(u);
          tt(c.rowGroupIndex) && c.rowGroup && (c.rowGroupIndex = a++), tt(c.pivotIndex) && c.pivot && (c.pivotIndex = s++), i.push(c);
        }), this.applyColumnState({ state: i, applyOrder: !0 }, e);
      }
    }, t.prototype.getColumnStateFromColDef = function(e) {
      var r = function(b, S) {
        return b ?? S ?? null;
      }, n = e.getColDef(), i = r(n.sort, n.initialSort), a = r(n.sortIndex, n.initialSortIndex), s = r(n.hide, n.initialHide), l = r(n.pinned, n.initialPinned), u = r(n.width, n.initialWidth), c = r(n.flex, n.initialFlex), d = r(n.rowGroupIndex, n.initialRowGroupIndex), f = r(n.rowGroup, n.initialRowGroup);
      d == null && (f == null || f == !1) && (d = null, f = null);
      var v = r(n.pivotIndex, n.initialPivotIndex), g = r(n.pivot, n.initialPivot);
      v == null && (g == null || g == !1) && (v = null, g = null);
      var m = r(n.aggFunc, n.initialAggFunc);
      return {
        colId: e.getColId(),
        sort: i,
        sortIndex: a,
        hide: s,
        pinned: l,
        width: u,
        flex: c,
        rowGroup: f,
        rowGroupIndex: d,
        pivot: g,
        pivotIndex: v,
        aggFunc: m
      };
    }, t.prototype.applyColumnState = function(e, r) {
      var n = this;
      if (ri(this.primaryColumns))
        return !1;
      if (e && e.state && !e.state.forEach)
        return console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state."), !1;
      var i = function(u, c, d) {
        var f = n.compareColumnStatesAndDispatchEvents(r);
        n.autoGroupsNeedBuilding = !0;
        var v = c.slice(), g = {}, m = {}, b = [], S = [], R = 0, P = n.rowGroupColumns.slice(), D = n.pivotColumns.slice();
        u.forEach(function(H) {
          var B = H.colId || "", j = B.startsWith(vc);
          if (j) {
            b.push(H), S.push(H);
            return;
          }
          var V = d(B);
          V ? (n.syncColumnWithStateItem(V, H, e.defaultState, g, m, !1, r), ti(v, V)) : (S.push(H), R += 1);
        });
        var x = function(H) {
          return n.syncColumnWithStateItem(H, null, e.defaultState, g, m, !1, r);
        };
        v.forEach(x);
        var M = function(H, B, j, V) {
          var W = H[j.getId()], q = H[V.getId()], ee = W != null, re = q != null;
          if (ee && re)
            return W - q;
          if (ee)
            return -1;
          if (re)
            return 1;
          var ie = B.indexOf(j), ne = B.indexOf(V), se = ie >= 0, pe = ne >= 0;
          return se && pe ? ie - ne : se ? -1 : 1;
        };
        n.rowGroupColumns.sort(M.bind(n, g, P)), n.pivotColumns.sort(M.bind(n, m, D)), n.updateGridColumns();
        var F = n.groupAutoColumns ? n.groupAutoColumns.slice() : [];
        return b.forEach(function(H) {
          var B = n.getAutoColumn(H.colId);
          ti(F, B), n.syncColumnWithStateItem(B, H, e.defaultState, null, null, !0, r);
        }), F.forEach(x), n.applyOrderAfterApplyState(e), n.updateDisplayedColumns(r), n.dispatchEverythingChanged(r), f(), { unmatchedAndAutoStates: S, unmatchedCount: R };
      };
      this.columnAnimationService.start();
      var a = i(e.state || [], this.primaryColumns || [], function(u) {
        return n.getPrimaryColumn(u);
      }), s = a.unmatchedAndAutoStates, l = a.unmatchedCount;
      return (s.length > 0 || Oe(e.defaultState)) && (l = i(s, this.secondaryColumns || [], function(u) {
        return n.getSecondaryColumn(u);
      }).unmatchedCount), this.columnAnimationService.finish(), l === 0;
    }, t.prototype.applyOrderAfterApplyState = function(e) {
      var r = this;
      if (!(!e.applyOrder || !e.state)) {
        var n = [], i = {};
        e.state.forEach(function(s) {
          if (!(!s.colId || i[s.colId])) {
            var l = r.gridColumnsMap[s.colId];
            l && (n.push(l), i[s.colId] = !0);
          }
        });
        var a = 0;
        if (this.gridColumns.forEach(function(s) {
          var l = s.getColId(), u = i[l] != null;
          if (!u) {
            var c = l.startsWith(vc);
            c ? zh(n, s, a++) : n.push(s);
          }
        }), n = this.placeLockedColumns(n), !this.doesMovePassMarryChildren(n)) {
          console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
          return;
        }
        this.gridColumns = n;
      }
    }, t.prototype.compareColumnStatesAndDispatchEvents = function(e) {
      var r = this, n = {
        rowGroupColumns: this.rowGroupColumns.slice(),
        pivotColumns: this.pivotColumns.slice(),
        valueColumns: this.valueColumns.slice()
      }, i = this.getColumnState(), a = {};
      return i.forEach(function(s) {
        a[s.colId] = s;
      }), function() {
        var s = r.getPrimaryAndSecondaryAndAutoColumns(), l = function(R, P, D, x) {
          var M = P.map(x), F = D.map(x), H = ws(M, F);
          if (!H) {
            var B = new Set(P);
            D.forEach(function(W) {
              B.delete(W) || B.add(W);
            });
            var j = zo([], $o(B), !1), V = {
              type: R,
              columns: j,
              column: j.length === 1 ? j[0] : null,
              source: e
            };
            r.eventService.dispatchEvent(V);
          }
        }, u = function(R) {
          var P = [];
          return s.forEach(function(D) {
            var x = a[D.getColId()];
            x && R(x, D) && P.push(D);
          }), P;
        }, c = function(R) {
          return R.getColId();
        };
        l(G.EVENT_COLUMN_ROW_GROUP_CHANGED, n.rowGroupColumns, r.rowGroupColumns, c), l(G.EVENT_COLUMN_PIVOT_CHANGED, n.pivotColumns, r.pivotColumns, c);
        var d = function(R, P) {
          var D = R.aggFunc != null, x = D != P.isValueActive(), M = D && R.aggFunc != P.getAggFunc();
          return x || M;
        }, f = u(d);
        f.length > 0 && r.dispatchColumnChangedEvent(G.EVENT_COLUMN_VALUE_CHANGED, f, e);
        var v = function(R, P) {
          return R.width != P.getActualWidth();
        };
        r.dispatchColumnResizedEvent(u(v), !0, e);
        var g = function(R, P) {
          return R.pinned != P.getPinned();
        };
        r.dispatchColumnPinnedEvent(u(g), e);
        var m = function(R, P) {
          return R.hide == P.isVisible();
        };
        r.dispatchColumnVisibleEvent(u(m), e);
        var b = function(R, P) {
          return R.sort != P.getSort() || R.sortIndex != P.getSortIndex();
        }, S = u(b);
        S.length > 0 && r.sortController.dispatchSortChangedEvents(e, S), r.normaliseColumnMovedEventForColumnState(i, e);
      };
    }, t.prototype.getCommonValue = function(e, r) {
      if (!(!e || e.length == 0)) {
        for (var n = r(e[0]), i = 1; i < e.length; i++)
          if (n !== r(e[i]))
            return;
        return n;
      }
    }, t.prototype.normaliseColumnMovedEventForColumnState = function(e, r) {
      var n = this, i = this.getColumnState(), a = {};
      i.forEach(function(d) {
        return a[d.colId] = d;
      });
      var s = {};
      e.forEach(function(d) {
        a[d.colId] && (s[d.colId] = !0);
      });
      var l = e.filter(function(d) {
        return s[d.colId];
      }), u = i.filter(function(d) {
        return s[d.colId];
      }), c = [];
      u.forEach(function(d, f) {
        var v = l && l[f];
        if (v && v.colId !== d.colId) {
          var g = n.getGridColumn(v.colId);
          g && c.push(g);
        }
      }), c.length && this.dispatchColumnMovedEvent({ movedColumns: c, source: r, finished: !0 });
    }, t.prototype.syncColumnWithStateItem = function(e, r, n, i, a, s, l) {
      if (e) {
        var u = function(H, B) {
          var j = { value1: void 0, value2: void 0 }, V = !1;
          return r && (r[H] !== void 0 && (j.value1 = r[H], V = !0), Oe(B) && r[B] !== void 0 && (j.value2 = r[B], V = !0)), !V && n && (n[H] !== void 0 && (j.value1 = n[H]), Oe(B) && n[B] !== void 0 && (j.value2 = n[B])), j;
        }, c = u("hide").value1;
        c !== void 0 && e.setVisible(!c, l);
        var d = u("pinned").value1;
        d !== void 0 && e.setPinned(d);
        var f = this.columnUtils.calculateColMinWidth(e.getColDef()), v = u("flex").value1;
        if (v !== void 0)
          e.setFlex(v);
        else {
          var g = u("width").value1;
          g != null && f != null && g >= f && e.setActualWidth(g, l);
        }
        var m = u("sort").value1;
        m !== void 0 && (m === "desc" || m === "asc" ? e.setSort(m, l) : e.setSort(void 0, l));
        var b = u("sortIndex").value1;
        if (b !== void 0 && e.setSortIndex(b), !(s || !e.isPrimary())) {
          var S = u("aggFunc").value1;
          S !== void 0 && (typeof S == "string" ? (e.setAggFunc(S), e.isValueActive() || (e.setValueActive(!0, l), this.valueColumns.push(e))) : (Oe(S) && console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON."), e.isValueActive() && (e.setValueActive(!1, l), ti(this.valueColumns, e))));
          var R = u("rowGroup", "rowGroupIndex"), P = R.value1, D = R.value2;
          (P !== void 0 || D !== void 0) && (typeof D == "number" || P ? (e.isRowGroupActive() || (e.setRowGroupActive(!0, l), this.rowGroupColumns.push(e)), i && typeof D == "number" && (i[e.getId()] = D)) : e.isRowGroupActive() && (e.setRowGroupActive(!1, l), ti(this.rowGroupColumns, e)));
          var x = u("pivot", "pivotIndex"), M = x.value1, F = x.value2;
          (M !== void 0 || F !== void 0) && (typeof F == "number" || M ? (e.isPivotActive() || (e.setPivotActive(!0, l), this.pivotColumns.push(e)), a && typeof F == "number" && (a[e.getId()] = F)) : e.isPivotActive() && (e.setPivotActive(!1, l), ti(this.pivotColumns, e)));
        }
      }
    }, t.prototype.getGridColumns = function(e) {
      return this.getColumns(e, this.getGridColumn.bind(this));
    }, t.prototype.getColumns = function(e, r) {
      var n = [];
      return e && e.forEach(function(i) {
        var a = r(i);
        a && n.push(a);
      }), n;
    }, t.prototype.getColumnWithValidation = function(e) {
      if (e == null)
        return null;
      var r = this.getGridColumn(e);
      return r || console.warn("AG Grid: could not find column " + e), r;
    }, t.prototype.getPrimaryColumn = function(e) {
      return this.primaryColumns ? this.getColumn(e, this.primaryColumns, this.primaryColumnsMap) : null;
    }, t.prototype.getGridColumn = function(e) {
      return this.getColumn(e, this.gridColumns, this.gridColumnsMap);
    }, t.prototype.lookupGridColumn = function(e) {
      return this.gridColumnsMap[e];
    }, t.prototype.getSecondaryColumn = function(e) {
      return this.secondaryColumns ? this.getColumn(e, this.secondaryColumns, this.secondaryColumnsMap) : null;
    }, t.prototype.getColumn = function(e, r, n) {
      if (!e || !n)
        return null;
      if (typeof e == "string" && n[e])
        return n[e];
      for (var i = 0; i < r.length; i++)
        if (this.columnsMatch(r[i], e))
          return r[i];
      return this.getAutoColumn(e);
    }, t.prototype.getSourceColumnsForGroupColumn = function(e) {
      var r = e.getColDef().showRowGroup;
      if (!r)
        return null;
      if (r === !0)
        return this.rowGroupColumns.slice(0);
      var n = this.getPrimaryColumn(r);
      return n ? [n] : null;
    }, t.prototype.getAutoColumn = function(e) {
      var r = this;
      return !this.groupAutoColumns || !Oe(this.groupAutoColumns) || tt(this.groupAutoColumns) ? null : this.groupAutoColumns.find(function(n) {
        return r.columnsMatch(n, e);
      }) || null;
    }, t.prototype.columnsMatch = function(e, r) {
      var n = e === r, i = e.getColDef() === r, a = e.getColId() == r;
      return n || i || a;
    }, t.prototype.getDisplayNameForColumn = function(e, r, n) {
      if (n === void 0 && (n = !1), !e)
        return null;
      var i = this.getHeaderName(e.getColDef(), e, null, null, r);
      return n ? this.wrapHeaderNameWithAggFunc(e, i) : i;
    }, t.prototype.getDisplayNameForProvidedColumnGroup = function(e, r, n) {
      var i = r ? r.getColGroupDef() : null;
      return i ? this.getHeaderName(i, null, e, r, n) : null;
    }, t.prototype.getDisplayNameForColumnGroup = function(e, r) {
      return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), r);
    }, t.prototype.getHeaderName = function(e, r, n, i, a) {
      var s = e.headerValueGetter;
      if (s) {
        var l = this.gridOptionsService.addGridCommonParams({
          colDef: e,
          column: r,
          columnGroup: n,
          providedColumnGroup: i,
          location: a
        });
        return typeof s == "function" ? s(l) : typeof s == "string" ? this.expressionService.evaluate(s, l) : (console.warn("AG Grid: headerValueGetter must be a function or a string"), "");
      } else {
        if (e.headerName != null)
          return e.headerName;
        if (e.field)
          return h2(e.field);
      }
      return "";
    }, t.prototype.wrapHeaderNameWithAggFunc = function(e, r) {
      if (this.gridOptionsService.get("suppressAggFuncInHeader"))
        return r;
      var n = e.getColDef().pivotValueColumn, i = Oe(n), a = null, s;
      if (i) {
        var l = this.gridOptionsService.get("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1, u = e.getColDef().pivotTotalColumnIds !== void 0;
        if (l && !u)
          return r;
        a = n ? n.getAggFunc() : null, s = !0;
      } else {
        var c = e.isValueActive(), d = this.pivotMode || !this.isRowGroupEmpty();
        c && d ? (a = e.getAggFunc(), s = !0) : s = !1;
      }
      if (s) {
        var f = typeof a == "string" ? a : "func", v = this.localeService.getLocaleTextFunc(), g = v(f, f);
        return "".concat(g, "(").concat(r, ")");
      }
      return r;
    }, t.prototype.getColumnGroup = function(e, r) {
      if (!e)
        return null;
      if (e instanceof pn)
        return e;
      var n = this.getAllDisplayedTrees(), i = typeof r == "number", a = null;
      return this.columnUtils.depthFirstAllColumnTreeSearch(n, function(s) {
        if (s instanceof pn) {
          var l = s, u = void 0;
          i ? u = e === l.getGroupId() && r === l.getPartId() : u = e === l.getGroupId(), u && (a = l);
        }
      }), a;
    }, t.prototype.isReady = function() {
      return this.ready;
    }, t.prototype.extractValueColumns = function(e, r) {
      this.valueColumns = this.extractColumns(
        r,
        this.valueColumns,
        function(n, i) {
          return n.setValueActive(i, e);
        },
        // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
        function() {
        },
        function() {
        },
        // aggFunc is a string, so return it's existence
        function(n) {
          var i = n.aggFunc;
          if (i === null || i === "")
            return null;
          if (i !== void 0)
            return !!i;
        },
        function(n) {
          return n.initialAggFunc != null && n.initialAggFunc != "";
        }
      ), this.valueColumns.forEach(function(n) {
        var i = n.getColDef();
        i.aggFunc != null && i.aggFunc != "" ? n.setAggFunc(i.aggFunc) : n.getAggFunc() || n.setAggFunc(i.initialAggFunc);
      });
    }, t.prototype.extractRowGroupColumns = function(e, r) {
      this.rowGroupColumns = this.extractColumns(r, this.rowGroupColumns, function(n, i) {
        return n.setRowGroupActive(i, e);
      }, function(n) {
        return n.rowGroupIndex;
      }, function(n) {
        return n.initialRowGroupIndex;
      }, function(n) {
        return n.rowGroup;
      }, function(n) {
        return n.initialRowGroup;
      });
    }, t.prototype.extractColumns = function(e, r, n, i, a, s, l) {
      e === void 0 && (e = []), r === void 0 && (r = []);
      var u = [], c = [];
      (this.primaryColumns || []).forEach(function(v) {
        var g = e.indexOf(v) < 0, m = v.getColDef(), b = zm(s(m)), S = zm(l(m)), R = Al(i(m)), P = Al(a(m)), D, x = b !== void 0, M = R !== void 0, F = S !== void 0, H = P !== void 0;
        if (x ? D = b : M ? R === null ? D = !1 : D = R >= 0 : g ? F ? D = S : H ? D = P != null && P >= 0 : D = !1 : D = r.indexOf(v) >= 0, D) {
          var B = g ? R != null || P != null : R != null;
          B ? u.push(v) : c.push(v);
        }
      });
      var d = function(v) {
        var g = i(v.getColDef()), m = a(v.getColDef());
        return g ?? m;
      };
      u.sort(function(v, g) {
        var m = d(v), b = d(g);
        return m === b ? 0 : m < b ? -1 : 1;
      });
      var f = [].concat(u);
      return r.forEach(function(v) {
        c.indexOf(v) >= 0 && f.push(v);
      }), c.forEach(function(v) {
        f.indexOf(v) < 0 && f.push(v);
      }), r.forEach(function(v) {
        f.indexOf(v) < 0 && n(v, !1);
      }), f.forEach(function(v) {
        r.indexOf(v) < 0 && n(v, !0);
      }), f;
    }, t.prototype.extractPivotColumns = function(e, r) {
      this.pivotColumns = this.extractColumns(r, this.pivotColumns, function(n, i) {
        return n.setPivotActive(i, e);
      }, function(n) {
        return n.pivotIndex;
      }, function(n) {
        return n.initialPivotIndex;
      }, function(n) {
        return n.pivot;
      }, function(n) {
        return n.initialPivot;
      });
    }, t.prototype.resetColumnGroupState = function(e) {
      if (e === void 0 && (e = "api"), !!this.primaryColumnTree) {
        var r = [];
        this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function(n) {
          if (n instanceof Ur) {
            var i = n.getColGroupDef(), a = {
              groupId: n.getGroupId(),
              open: i ? i.openByDefault : void 0
            };
            r.push(a);
          }
        }), this.setColumnGroupState(r, e);
      }
    }, t.prototype.getColumnGroupState = function() {
      var e = [];
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(r) {
        r instanceof Ur && e.push({
          groupId: r.getGroupId(),
          open: r.isExpanded()
        });
      }), e;
    }, t.prototype.setColumnGroupState = function(e, r) {
      var n = this;
      if (r === void 0 && (r = "api"), !!this.gridBalancedTree) {
        this.columnAnimationService.start();
        var i = [];
        if (e.forEach(function(s) {
          var l = s.groupId, u = s.open, c = n.getProvidedColumnGroup(l);
          c && c.isExpanded() !== u && (n.logger.log("columnGroupOpened(" + c.getGroupId() + "," + u + ")"), c.setExpanded(u), i.push(c));
        }), this.updateGroupsAndDisplayedColumns(r), this.setFirstRightAndLastLeftPinned(r), i.length) {
          var a = {
            type: G.EVENT_COLUMN_GROUP_OPENED,
            columnGroup: Ur.length === 1 ? i[0] : void 0,
            columnGroups: i
          };
          this.eventService.dispatchEvent(a);
        }
        this.columnAnimationService.finish();
      }
    }, t.prototype.setColumnGroupOpened = function(e, r, n) {
      n === void 0 && (n = "api");
      var i;
      e instanceof Ur ? i = e.getId() : i = e || "", this.setColumnGroupState([{ groupId: i, open: r }], n);
    }, t.prototype.getProvidedColumnGroup = function(e) {
      typeof e != "string" && console.error("AG Grid: group key must be a string");
      var r = null;
      return this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function(n) {
        n instanceof Ur && n.getId() === e && (r = n);
      }), r;
    }, t.prototype.calculateColumnsForDisplay = function() {
      var e = this, r;
      return this.pivotMode && tt(this.secondaryColumns) ? r = this.gridColumns.filter(function(n) {
        var i = e.groupAutoColumns && ra(e.groupAutoColumns, n), a = e.valueColumns && ra(e.valueColumns, n);
        return i || a;
      }) : r = this.gridColumns.filter(function(n) {
        var i = e.groupAutoColumns && ra(e.groupAutoColumns, n);
        return i || n.isVisible();
      }), r;
    }, t.prototype.checkColSpanActiveInCols = function(e) {
      var r = !1;
      return e.forEach(function(n) {
        Oe(n.getColDef().colSpan) && (r = !0);
      }), r;
    }, t.prototype.calculateColumnsForGroupDisplay = function() {
      var e = this;
      this.groupDisplayColumns = [], this.groupDisplayColumnsMap = {};
      var r = function(n) {
        var i = n.getColDef(), a = i.showRowGroup;
        i && Oe(a) && (e.groupDisplayColumns.push(n), typeof a == "string" ? e.groupDisplayColumnsMap[a] = n : a === !0 && e.getRowGroupColumns().forEach(function(s) {
          e.groupDisplayColumnsMap[s.getId()] = n;
        }));
      };
      this.gridColumns.forEach(r);
    }, t.prototype.getGroupDisplayColumns = function() {
      return this.groupDisplayColumns;
    }, t.prototype.getGroupDisplayColumnForGroup = function(e) {
      return this.groupDisplayColumnsMap[e];
    }, t.prototype.updateDisplayedColumns = function(e) {
      var r = this.calculateColumnsForDisplay();
      this.buildDisplayedTrees(r), this.updateGroupsAndDisplayedColumns(e), this.setFirstRightAndLastLeftPinned(e);
    }, t.prototype.isSecondaryColumnsPresent = function() {
      return Oe(this.secondaryColumns);
    }, t.prototype.setSecondaryColumns = function(e, r) {
      var n = this;
      if (r === void 0 && (r = "api"), !!this.gridColumns) {
        var i = e && e.length > 0;
        if (!(!i && tt(this.secondaryColumns))) {
          if (i) {
            this.processSecondaryColumnDefinitions(e);
            var a = this.columnFactory.createColumnTree(e, !1, this.secondaryBalancedTree || this.previousSecondaryColumns || void 0);
            this.destroyOldColumns(this.secondaryBalancedTree, a.columnTree), this.secondaryBalancedTree = a.columnTree, this.secondaryHeaderRowCount = a.treeDept + 1, this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree), this.secondaryColumnsMap = {}, this.secondaryColumns.forEach(function(s) {
              return n.secondaryColumnsMap[s.getId()] = s;
            }), this.previousSecondaryColumns = null;
          } else
            this.previousSecondaryColumns = this.secondaryBalancedTree, this.secondaryBalancedTree = null, this.secondaryHeaderRowCount = -1, this.secondaryColumns = null, this.secondaryColumnsMap = {};
          this.updateGridColumns(), this.updateDisplayedColumns(r);
        }
      }
    }, t.prototype.processSecondaryColumnDefinitions = function(e) {
      var r = this.gridOptionsService.get("processPivotResultColDef"), n = this.gridOptionsService.get("processPivotResultColGroupDef");
      if (!(!r && !n)) {
        var i = function(a) {
          a.forEach(function(s) {
            var l = Oe(s.children);
            if (l) {
              var u = s;
              n && n(u), i(u.children);
            } else {
              var c = s;
              r && r(c);
            }
          });
        };
        e && i(e);
      }
    }, t.prototype.updateGridColumns = function() {
      var e = this, r = this.gridBalancedTree;
      this.gridColsArePrimary ? this.lastPrimaryOrder = this.gridColumns : this.lastSecondaryOrder = this.gridColumns;
      var n = this.createGroupAutoColumnsIfNeeded();
      if (n) {
        var i = Sl(this.groupAutoColumns.map(function(u) {
          return [u, !0];
        }));
        this.lastPrimaryOrder && (this.lastPrimaryOrder = this.lastPrimaryOrder.filter(function(u) {
          return !i.has(u);
        }), this.lastPrimaryOrder = zo(zo([], $o(this.groupAutoColumns), !1), $o(this.lastPrimaryOrder), !1)), this.lastSecondaryOrder && (this.lastSecondaryOrder = this.lastSecondaryOrder.filter(function(u) {
          return !i.has(u);
        }), this.lastSecondaryOrder = zo(zo([], $o(this.groupAutoColumns), !1), $o(this.lastSecondaryOrder), !1));
      }
      var a;
      if (this.secondaryColumns && this.secondaryBalancedTree) {
        var s = this.secondaryColumns.some(function(u) {
          return e.gridColumnsMap[u.getColId()] !== void 0;
        });
        this.gridBalancedTree = this.secondaryBalancedTree.slice(), this.gridHeaderRowCount = this.secondaryHeaderRowCount, this.gridColumns = this.secondaryColumns.slice(), this.gridColsArePrimary = !1, s && (a = this.lastSecondaryOrder);
      } else this.primaryColumns && (this.gridBalancedTree = this.primaryColumnTree.slice(), this.gridHeaderRowCount = this.primaryHeaderRowCount, this.gridColumns = this.primaryColumns.slice(), this.gridColsArePrimary = !0, a = this.lastPrimaryOrder);
      if (this.addAutoGroupToGridColumns(), this.orderGridColsLike(a), this.gridColumns = this.placeLockedColumns(this.gridColumns), this.calculateColumnsForGroupDisplay(), this.refreshQuickFilterColumns(), this.clearDisplayedAndViewportColumns(), this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns), this.gridColumnsMap = {}, this.gridColumns.forEach(function(u) {
        return e.gridColumnsMap[u.getId()] = u;
      }), this.setAutoHeightActive(), !ws(r, this.gridBalancedTree)) {
        var l = {
          type: G.EVENT_GRID_COLUMNS_CHANGED
        };
        this.eventService.dispatchEvent(l);
      }
    }, t.prototype.setAutoHeightActive = function() {
      if (this.autoHeightActive = this.gridColumns.filter(function(r) {
        return r.isAutoHeight();
      }).length > 0, this.autoHeightActive) {
        this.autoHeightActiveAtLeastOnce = !0;
        var e = this.gridOptionsService.isRowModelType("clientSide") || this.gridOptionsService.isRowModelType("serverSide");
        e || ht("autoHeight columns only work with Client Side Row Model and Server Side Row Model.");
      }
    }, t.prototype.orderGridColsLike = function(e) {
      if (!tt(e)) {
        var r = Sl(e.map(function(c, d) {
          return [c, d];
        })), n = !0;
        if (this.gridColumns.forEach(function(c) {
          r.has(c) && (n = !1);
        }), !n) {
          var i = Sl(this.gridColumns.map(function(c) {
            return [c, !0];
          })), a = e.filter(function(c) {
            return i.has(c);
          }), s = Sl(a.map(function(c) {
            return [c, !0];
          })), l = this.gridColumns.filter(function(c) {
            return !s.has(c);
          }), u = a.slice();
          l.forEach(function(c) {
            var d = c.getOriginalParent();
            if (!d) {
              u.push(c);
              return;
            }
            for (var f = []; !f.length && d; ) {
              var v = d.getLeafColumns();
              v.forEach(function(b) {
                var S = u.indexOf(b) >= 0, R = f.indexOf(b) < 0;
                S && R && f.push(b);
              }), d = d.getOriginalParent();
            }
            if (!f.length) {
              u.push(c);
              return;
            }
            var g = f.map(function(b) {
              return u.indexOf(b);
            }), m = Math.max.apply(Math, zo([], $o(g), !1));
            zh(u, c, m + 1);
          }), this.gridColumns = u;
        }
      }
    }, t.prototype.isPrimaryColumnGroupsPresent = function() {
      return this.primaryHeaderRowCount > 1;
    }, t.prototype.refreshQuickFilterColumns = function() {
      var e, r = (e = this.isPivotMode() ? this.secondaryColumns : this.primaryColumns) !== null && e !== void 0 ? e : [];
      this.groupAutoColumns && (r = r.concat(this.groupAutoColumns)), this.columnsForQuickFilter = this.gridOptionsService.get("includeHiddenColumnsInQuickFilter") ? r : r.filter(function(n) {
        return n.isVisible() || n.isRowGroupActive();
      });
    }, t.prototype.placeLockedColumns = function(e) {
      var r = [], n = [], i = [];
      return e.forEach(function(a) {
        var s = a.getColDef().lockPosition;
        s === "right" ? i.push(a) : s === "left" || s === !0 ? r.push(a) : n.push(a);
      }), zo(zo(zo([], $o(r), !1), $o(n), !1), $o(i), !1);
    }, t.prototype.addAutoGroupToGridColumns = function() {
      if (tt(this.groupAutoColumns)) {
        this.destroyOldColumns(this.groupAutoColsBalancedTree), this.groupAutoColsBalancedTree = null;
        return;
      }
      this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
      var e = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
      this.destroyOldColumns(this.groupAutoColsBalancedTree, e), this.groupAutoColsBalancedTree = e, this.gridBalancedTree = e.concat(this.gridBalancedTree);
    }, t.prototype.clearDisplayedAndViewportColumns = function() {
      this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {}, this.displayedColumnsLeft = [], this.displayedColumnsRight = [], this.displayedColumnsCenter = [], this.displayedColumns = [], this.ariaOrderColumns = [], this.viewportColumns = [], this.headerViewportColumns = [], this.viewportColumnsHash = "";
    }, t.prototype.updateGroupsAndDisplayedColumns = function(e) {
      this.updateOpenClosedVisibilityInColumnGroups(), this.deriveDisplayedColumns(e), this.refreshFlexedColumns(), this.extractViewport(), this.updateBodyWidths();
      var r = {
        type: G.EVENT_DISPLAYED_COLUMNS_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.deriveDisplayedColumns = function(e) {
      this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter), this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight), this.joinColumnsAriaOrder(), this.joinDisplayedColumns(), this.setLeftValues(e), this.displayedAutoHeightCols = this.displayedColumns.filter(function(r) {
        return r.isAutoHeight();
      });
    }, t.prototype.isAutoRowHeightActive = function() {
      return this.autoHeightActive;
    }, t.prototype.wasAutoRowHeightEverActive = function() {
      return this.autoHeightActiveAtLeastOnce;
    }, t.prototype.joinColumnsAriaOrder = function() {
      var e, r, n = this.getAllGridColumns(), i = [], a = [], s = [];
      try {
        for (var l = Pw(n), u = l.next(); !u.done; u = l.next()) {
          var c = u.value, d = c.getPinned();
          d ? d === !0 || d === "left" ? i.push(c) : s.push(c) : a.push(c);
        }
      } catch (f) {
        e = { error: f };
      } finally {
        try {
          u && !u.done && (r = l.return) && r.call(l);
        } finally {
          if (e) throw e.error;
        }
      }
      this.ariaOrderColumns = i.concat(a).concat(s);
    }, t.prototype.joinDisplayedColumns = function() {
      this.gridOptionsService.get("enableRtl") ? this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft) : this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
    }, t.prototype.setLeftValues = function(e) {
      this.setLeftValuesOfColumns(e), this.setLeftValuesOfGroups();
    }, t.prototype.setLeftValuesOfColumns = function(e) {
      var r = this;
      if (this.primaryColumns) {
        var n = this.getPrimaryAndSecondaryAndAutoColumns().slice(0), i = this.gridOptionsService.get("enableRtl");
        [
          this.displayedColumnsLeft,
          this.displayedColumnsRight,
          this.displayedColumnsCenter
        ].forEach(function(a) {
          if (i) {
            var s = r.getWidthOfColsInList(a);
            a.forEach(function(u) {
              s -= u.getActualWidth(), u.setLeft(s, e);
            });
          } else {
            var l = 0;
            a.forEach(function(u) {
              u.setLeft(l, e), l += u.getActualWidth();
            });
          }
          a2(n, a);
        }), n.forEach(function(a) {
          a.setLeft(null, e);
        });
      }
    }, t.prototype.setLeftValuesOfGroups = function() {
      [
        this.displayedTreeLeft,
        this.displayedTreeRight,
        this.displayedTreeCentre
      ].forEach(function(e) {
        e.forEach(function(r) {
          if (r instanceof pn) {
            var n = r;
            n.checkLeft();
          }
        });
      });
    }, t.prototype.derivedDisplayedColumnsFromDisplayedTree = function(e, r) {
      r.length = 0, this.columnUtils.depthFirstDisplayedColumnTreeSearch(e, function(n) {
        n instanceof cr && r.push(n);
      });
    }, t.prototype.extractViewportColumns = function() {
      this.suppressColumnVirtualisation ? (this.viewportColumnsCenter = this.displayedColumnsCenter, this.headerViewportColumnsCenter = this.displayedColumnsCenter) : (this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this)), this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this))), this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight), this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
    }, t.prototype.getVirtualHeaderGroupRow = function(e, r) {
      var n;
      switch (e) {
        case "left":
          n = this.viewportRowLeft[r];
          break;
        case "right":
          n = this.viewportRowRight[r];
          break;
        default:
          n = this.viewportRowCenter[r];
          break;
      }
      return tt(n) && (n = []), n;
    }, t.prototype.calculateHeaderRows = function() {
      this.viewportRowLeft = {}, this.viewportRowRight = {}, this.viewportRowCenter = {};
      var e = {};
      this.headerViewportColumns.forEach(function(n) {
        return e[n.getId()] = !0;
      });
      var r = function(n, i, a) {
        for (var s = !1, l = 0; l < n.length; l++) {
          var u = n[l], c = !1;
          if (u instanceof cr)
            c = e[u.getId()] === !0;
          else {
            var d = u, f = d.getDisplayedChildren();
            f && (c = r(f, i, a + 1));
          }
          c && (s = !0, i[a] || (i[a] = []), i[a].push(u));
        }
        return s;
      };
      r(this.displayedTreeLeft, this.viewportRowLeft, 0), r(this.displayedTreeRight, this.viewportRowRight, 0), r(this.displayedTreeCentre, this.viewportRowCenter, 0);
    }, t.prototype.extractViewport = function() {
      var e = function(i) {
        return "".concat(i.getId(), "-").concat(i.getPinned() || "normal");
      };
      this.extractViewportColumns();
      var r = this.viewportColumns.map(e).join("#"), n = this.viewportColumnsHash !== r;
      return n && (this.viewportColumnsHash = r, this.calculateHeaderRows()), n;
    }, t.prototype.refreshFlexedColumns = function(e) {
      var r;
      e === void 0 && (e = {});
      var n = e.source ? e.source : "flex";
      if (e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth), !this.flexViewportWidth)
        return [];
      var i = -1;
      if (e.resizingCols) {
        for (var a = new Set(e.resizingCols), s = this.displayedColumnsCenter, l = s.length - 1; l >= 0; l--)
          if (a.has(s[l])) {
            i = l;
            break;
          }
      }
      for (var u = 0, c = [], d = 0, f = 0, l = 0; l < this.displayedColumnsCenter.length; l++) {
        var v = this.displayedColumnsCenter[l].getFlex() && l > i;
        v ? (c.push(this.displayedColumnsCenter[l]), f += this.displayedColumnsCenter[l].getFlex(), d += (r = this.displayedColumnsCenter[l].getMinWidth()) !== null && r !== void 0 ? r : 0) : u += this.displayedColumnsCenter[l].getActualWidth();
      }
      if (!c.length)
        return [];
      var g = [];
      u + d > this.flexViewportWidth && (c.forEach(function(H) {
        var B;
        return H.setActualWidth((B = H.getMinWidth()) !== null && B !== void 0 ? B : 0, n);
      }), g = c, c = []);
      var m = [], b;
      e: for (; ; ) {
        b = this.flexViewportWidth - u;
        for (var S = b / f, l = 0; l < c.length; l++) {
          var R = c[l], P = S * R.getFlex(), D = 0, x = R.getMinWidth(), M = R.getMaxWidth();
          if (Oe(x) && P < x ? D = x : Oe(M) && P > M && (D = M), D) {
            R.setActualWidth(D, n), E1(c, R), f -= R.getFlex(), g.push(R), u += R.getActualWidth();
            continue e;
          }
          m[l] = Math.round(P);
        }
        break;
      }
      var F = b;
      return c.forEach(function(H, B) {
        H.setActualWidth(Math.min(m[B], F), n), g.push(H), F -= m[B];
      }), e.skipSetLeft || this.setLeftValues(n), e.updateBodyWidths && this.updateBodyWidths(), e.fireResizedEvent && this.dispatchColumnResizedEvent(g, !0, n, c), c;
    }, t.prototype.sizeColumnsToFit = function(e, r, n, i) {
      var a = this, s, l, u, c, d;
      if (r === void 0 && (r = "sizeColumnsToFit"), this.shouldQueueResizeOperations) {
        this.resizeOperationQueue.push(function() {
          return a.sizeColumnsToFit(e, r, n, i);
        });
        return;
      }
      var f = {};
      i && ((s = i == null ? void 0 : i.columnLimits) === null || s === void 0 || s.forEach(function(ne) {
        var se = ne.key, pe = S$(ne, ["key"]);
        f[typeof se == "string" ? se : se.getColId()] = pe;
      }));
      var v = this.getAllDisplayedColumns(), g = e === this.getWidthOfColsInList(v);
      if (!(e <= 0 || !v.length || g)) {
        var m = [], b = [];
        v.forEach(function(ne) {
          ne.getColDef().suppressSizeToFit === !0 ? b.push(ne) : m.push(ne);
        });
        var S = m.slice(0), R = !1, P = function(ne) {
          ti(m, ne), b.push(ne);
        };
        for (m.forEach(function(ne) {
          var se, pe;
          ne.resetActualWidth(r);
          var K = f == null ? void 0 : f[ne.getId()], J = (se = K == null ? void 0 : K.minWidth) !== null && se !== void 0 ? se : i == null ? void 0 : i.defaultMinWidth, ue = (pe = K == null ? void 0 : K.maxWidth) !== null && pe !== void 0 ? pe : i == null ? void 0 : i.defaultMaxWidth, he = ne.getActualWidth();
          typeof J == "number" && he < J ? ne.setActualWidth(J, r, !0) : typeof ue == "number" && he > ue && ne.setActualWidth(ue, r, !0);
        }); !R; ) {
          R = !0;
          var D = e - this.getWidthOfColsInList(b);
          if (D <= 0)
            m.forEach(function(ne) {
              var se, pe, K = (pe = (se = f == null ? void 0 : f[ne.getId()]) === null || se === void 0 ? void 0 : se.minWidth) !== null && pe !== void 0 ? pe : i == null ? void 0 : i.defaultMinWidth;
              if (typeof K == "number") {
                ne.setActualWidth(K, r, !0);
                return;
              }
              ne.setMinimum(r);
            });
          else
            for (var x = D / this.getWidthOfColsInList(m), M = D, F = m.length - 1; F >= 0; F--) {
              var H = m[F], B = f == null ? void 0 : f[H.getId()], j = (l = B == null ? void 0 : B.minWidth) !== null && l !== void 0 ? l : i == null ? void 0 : i.defaultMinWidth, V = (u = B == null ? void 0 : B.maxWidth) !== null && u !== void 0 ? u : i == null ? void 0 : i.defaultMaxWidth, W = (c = H.getMinWidth()) !== null && c !== void 0 ? c : 0, q = (d = H.getMaxWidth()) !== null && d !== void 0 ? d : Number.MAX_VALUE, ee = typeof j == "number" && j > W ? j : H.getMinWidth(), re = typeof V == "number" && V < q ? V : H.getMaxWidth(), ie = Math.round(H.getActualWidth() * x);
              Oe(ee) && ie < ee ? (ie = ee, P(H), R = !1) : Oe(re) && ie > re ? (ie = re, P(H), R = !1) : F === 0 && (ie = M), H.setActualWidth(ie, r, !0), M -= ie;
            }
        }
        S.forEach(function(ne) {
          ne.fireColumnWidthChangedEvent(r);
        }), this.setLeftValues(r), this.updateBodyWidths(), !n && this.dispatchColumnResizedEvent(S, !0, r);
      }
    }, t.prototype.buildDisplayedTrees = function(e) {
      var r = [], n = [], i = [];
      e.forEach(function(s) {
        switch (s.getPinned()) {
          case "left":
            r.push(s);
            break;
          case "right":
            n.push(s);
            break;
          default:
            i.push(s);
            break;
        }
      });
      var a = new x1();
      this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(r, a, "left", this.displayedTreeLeft), this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(n, a, "right", this.displayedTreeRight), this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(i, a, null, this.displayedTreeCentre), this.updateDisplayedMap();
    }, t.prototype.updateDisplayedMap = function() {
      var e = this;
      this.displayedColumnsAndGroupsMap = {};
      var r = function(n) {
        e.displayedColumnsAndGroupsMap[n.getUniqueId()] = n;
      };
      this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeCentre, r), this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeLeft, r), this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeRight, r);
    }, t.prototype.isDisplayed = function(e) {
      var r = this.displayedColumnsAndGroupsMap[e.getUniqueId()];
      return r === e;
    }, t.prototype.updateOpenClosedVisibilityInColumnGroups = function() {
      var e = this.getAllDisplayedTrees();
      this.columnUtils.depthFirstAllColumnTreeSearch(e, function(r) {
        r instanceof pn && r.calculateDisplayedColumns();
      });
    }, t.prototype.getGroupAutoColumns = function() {
      return this.groupAutoColumns;
    }, t.prototype.createGroupAutoColumnsIfNeeded = function() {
      var e = this.forceRecreateAutoGroups;
      if (this.forceRecreateAutoGroups = !1, !this.autoGroupsNeedBuilding)
        return !1;
      this.autoGroupsNeedBuilding = !1;
      var r = this.gridOptionsService.isGroupUseEntireRow(this.pivotMode), n = this.pivotMode ? this.gridOptionsService.get("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn(), i = this.rowGroupColumns.length > 0 || this.gridOptionsService.get("treeData"), a = i && !n && !r;
      if (a) {
        var s = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns), l = !this.autoColsEqual(s, this.groupAutoColumns);
        if (l || e)
          return this.groupAutoColumns = s, !0;
      } else
        this.groupAutoColumns = null;
      return !1;
    }, t.prototype.isGroupSuppressAutoColumn = function() {
      var e = this.gridOptionsService.get("groupDisplayType"), r = e === "custom";
      if (r)
        return !0;
      var n = this.gridOptionsService.get("treeDataDisplayType");
      return n === "custom";
    }, t.prototype.autoColsEqual = function(e, r) {
      return ws(e, r, function(n, i) {
        return n.getColId() === i.getColId();
      });
    }, t.prototype.getWidthOfColsInList = function(e) {
      return e.reduce(function(r, n) {
        return r + n.getActualWidth();
      }, 0);
    }, t.prototype.getFirstDisplayedColumn = function() {
      var e = this.gridOptionsService.get("enableRtl"), r = [
        "getDisplayedLeftColumns",
        "getDisplayedCenterColumns",
        "getDisplayedRightColumns"
      ];
      e && r.reverse();
      for (var n = 0; n < r.length; n++) {
        var i = this[r[n]]();
        if (i.length)
          return e ? Kt(i) : i[0];
      }
      return null;
    }, t.prototype.setColumnHeaderHeight = function(e, r) {
      var n = e.setAutoHeaderHeight(r);
      if (n) {
        var i = {
          type: G.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
          column: e,
          columns: [e],
          source: "autosizeColumnHeaderHeight"
        };
        this.eventService.dispatchEvent(i);
      }
    }, t.prototype.getColumnGroupHeaderRowHeight = function() {
      return this.isPivotMode() ? this.getPivotGroupHeaderHeight() : this.getGroupHeaderHeight();
    }, t.prototype.getColumnHeaderRowHeight = function() {
      var e = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight(), r = this.getAllDisplayedColumns().filter(function(n) {
        return n.isAutoHeaderHeight();
      }).map(function(n) {
        return n.getAutoHeaderHeight() || 0;
      });
      return Math.max.apply(Math, zo([e], $o(r), !1));
    }, t.prototype.getHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.get("headerHeight")) !== null && e !== void 0 ? e : this.environment.getFromTheme(25, "headerHeight");
    }, t.prototype.getFloatingFiltersHeight = function() {
      var e;
      return (e = this.gridOptionsService.get("floatingFiltersHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getGroupHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.get("groupHeaderHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getPivotHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.get("pivotHeaderHeight")) !== null && e !== void 0 ? e : this.getHeaderHeight();
    }, t.prototype.getPivotGroupHeaderHeight = function() {
      var e;
      return (e = this.gridOptionsService.get("pivotGroupHeaderHeight")) !== null && e !== void 0 ? e : this.getGroupHeaderHeight();
    }, t.prototype.queueResizeOperations = function() {
      this.shouldQueueResizeOperations = !0;
    }, t.prototype.processResizeOperations = function() {
      this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach(function(e) {
        return e();
      }), this.resizeOperationQueue = [];
    }, t.prototype.resetColumnDefIntoColumn = function(e, r) {
      var n = e.getUserProvidedColDef();
      if (!n)
        return !1;
      var i = this.columnFactory.addColumnDefaultAndTypes(n, e.getColId());
      return e.setColDef(i, n, r), !0;
    }, t.prototype.isColumnGroupingLocked = function(e) {
      var r = this.gridOptionsService.get("groupLockGroupColumns");
      if (!e.isRowGroupActive() || r === 0)
        return !1;
      if (r === -1)
        return !0;
      var n = this.rowGroupColumns.findIndex(function(i) {
        return i.getColId() === e.getColId();
      });
      return r > n;
    }, t.prototype.generateColumnStateForRowGroupAndPivotIndexes = function(e, r) {
      var n = this, i = {}, a = function(s, l, u, c, d, f) {
        if (!l.length || !n.primaryColumns)
          return [];
        for (var v = Object.keys(s), g = new Set(v), m = new Set(v), b = new Set(l.map(function(j) {
          var V = j.getColId();
          return m.delete(V), V;
        }).concat(v)), S = [], R = {}, P = 0, D = 0; D < n.primaryColumns.length; D++) {
          var x = n.primaryColumns[D].getColId();
          b.has(x) && (S.push(x), R[x] = P++);
        }
        var M = 1e3, F = !1, H = 0, B = function(j) {
          for (var V = R[j], W = H; W < V; W++) {
            var q = S[W];
            m.has(q) && (s[q][d] = M++, m.delete(q));
          }
          H = V;
        };
        l.forEach(function(j) {
          var V = j.getColId();
          if (g.has(V))
            B(V), s[V][d] = M++;
          else {
            var W = j.getColDef(), q = W[d] === null || W[d] === void 0 && W[f] == null;
            if (q) {
              if (!F) {
                var ee = W[u] || W[u] === void 0 && W[c];
                ee ? B(V) : (m.forEach(function(re) {
                  s[re][d] = M + R[re];
                }), M += S.length, F = !0);
              }
              i[V] || (i[V] = { colId: V }), i[V][d] = M++;
            }
          }
        });
      };
      return a(e, this.rowGroupColumns, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex"), a(r, this.pivotColumns, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex"), Object.values(i);
    }, t.prototype.onColumnsReady = function() {
      var e = this, r = this.gridOptionsService.get("autoSizeStrategy");
      if (r) {
        var n = r.type;
        setTimeout(function() {
          if (n === "fitGridWidth") {
            var i = r.columnLimits, a = r.defaultMinWidth, s = r.defaultMaxWidth, l = i == null ? void 0 : i.map(function(u) {
              var c = u.colId, d = u.minWidth, f = u.maxWidth;
              return {
                key: c,
                minWidth: d,
                maxWidth: f
              };
            });
            e.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({
              defaultMinWidth: a,
              defaultMaxWidth: s,
              columnLimits: l
            });
          } else n === "fitProvidedWidth" && e.sizeColumnsToFit(r.width, "sizeColumnsToFit");
        });
      }
    }, t.prototype.onFirstDataRendered = function() {
      var e = this, r = this.gridOptionsService.get("autoSizeStrategy");
      if ((r == null ? void 0 : r.type) === "fitCellContents") {
        var n = r.colIds, i = r.skipHeader;
        setTimeout(function() {
          n ? e.autoSizeColumns({
            columns: n,
            skipHeader: i,
            source: "autosizeColumns"
          }) : e.autoSizeAllColumns(i, "autosizeColumns");
        });
      }
    }, Hn([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), Hn([
      N("columnFactory")
    ], t.prototype, "columnFactory", void 0), Hn([
      N("displayedGroupCreator")
    ], t.prototype, "displayedGroupCreator", void 0), Hn([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Hn([
      N("autoWidthCalculator")
    ], t.prototype, "autoWidthCalculator", void 0), Hn([
      N("columnUtils")
    ], t.prototype, "columnUtils", void 0), Hn([
      N("columnAnimationService")
    ], t.prototype, "columnAnimationService", void 0), Hn([
      N("autoGroupColService")
    ], t.prototype, "autoGroupColService", void 0), Hn([
      Lt("aggFuncService")
    ], t.prototype, "aggFuncService", void 0), Hn([
      Lt("valueCache")
    ], t.prototype, "valueCache", void 0), Hn([
      Lt("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Hn([
      N("sortController")
    ], t.prototype, "sortController", void 0), Hn([
      N("columnDefFactory")
    ], t.prototype, "columnDefFactory", void 0), Hn([
      Fe
    ], t.prototype, "init", null), Hn([
      eo
    ], t.prototype, "destroyColumns", null), Hn([
      b$(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), t = Hn([
      Be("columnModel")
    ], t), t;
  }(Me)
), E$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _$ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, m2 = (
  /** @class */
  function(o) {
    E$(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.calculateColMinWidth = function(e) {
      return e.minWidth != null ? e.minWidth : this.environment.getMinColWidth();
    }, t.prototype.calculateColMaxWidth = function(e) {
      return e.maxWidth != null ? e.maxWidth : Number.MAX_SAFE_INTEGER;
    }, t.prototype.calculateColInitialWidth = function(e) {
      var r = this.calculateColMinWidth(e), n = this.calculateColMaxWidth(e), i, a = Al(e.width), s = Al(e.initialWidth);
      return a != null ? i = a : s != null ? i = s : i = 200, Math.max(Math.min(i, n), r);
    }, t.prototype.getOriginalPathForColumn = function(e, r) {
      var n = [], i = !1, a = function(s, l) {
        for (var u = 0; u < s.length; u++) {
          if (i)
            return;
          var c = s[u];
          if (c instanceof Ur) {
            var d = c;
            a(d.getChildren(), l + 1), n[l] = c;
          } else c === e && (i = !0);
        }
      };
      return a(r, 0), i ? n : null;
    }, t.prototype.depthFirstOriginalTreeSearch = function(e, r, n) {
      var i = this;
      r && r.forEach(function(a) {
        a instanceof Ur && i.depthFirstOriginalTreeSearch(a, a.getChildren(), n), n(a, e);
      });
    }, t.prototype.depthFirstAllColumnTreeSearch = function(e, r) {
      var n = this;
      e && e.forEach(function(i) {
        i instanceof pn && n.depthFirstAllColumnTreeSearch(i.getChildren(), r), r(i);
      });
    }, t.prototype.depthFirstDisplayedColumnTreeSearch = function(e, r) {
      var n = this;
      e && e.forEach(function(i) {
        i instanceof pn && n.depthFirstDisplayedColumnTreeSearch(i.getDisplayedChildren(), r), r(i);
      });
    }, t = _$([
      Be("columnUtils")
    ], t), t;
  }(Me)
), x$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), R$ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, y2 = (
  /** @class */
  function(o) {
    x$(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.createDisplayedGroups = function(e, r, n, i) {
      for (var a = this, s = this.mapOldGroupsById(i), l = [], u = e, c = function() {
        var d = u;
        u = [];
        for (var f = 0, v = function(x) {
          var M = f;
          f = x;
          var F = d[M], H = F instanceof pn ? F.getProvidedColumnGroup() : F, B = H.getOriginalParent();
          if (B == null) {
            for (var j = M; j < x; j++)
              l.push(d[j]);
            return;
          }
          for (var V = a.createColumnGroup(B, r, s, n), j = M; j < x; j++)
            V.addChild(d[j]);
          u.push(V);
        }, g = 1; g < d.length; g++) {
          var m = d[g], b = m instanceof pn ? m.getProvidedColumnGroup() : m, S = b.getOriginalParent(), R = d[f], P = R instanceof pn ? R.getProvidedColumnGroup() : R, D = P.getOriginalParent();
          S !== D && v(g);
        }
        f < d.length && v(d.length);
      }; u.length; )
        c();
      return this.setupParentsIntoColumns(l, null), l;
    }, t.prototype.createColumnGroup = function(e, r, n, i) {
      var a = e.getGroupId(), s = r.getInstanceIdForKey(a), l = pn.createUniqueId(a, s), u = n[l];
      return u && u.getProvidedColumnGroup() !== e && (u = null), Oe(u) ? u.reset() : (u = new pn(e, a, s, i), this.context.createBean(u)), u;
    }, t.prototype.mapOldGroupsById = function(e) {
      var r = {}, n = function(i) {
        i.forEach(function(a) {
          if (a instanceof pn) {
            var s = a;
            r[a.getUniqueId()] = s, n(s.getChildren());
          }
        });
      };
      return e && n(e), r;
    }, t.prototype.setupParentsIntoColumns = function(e, r) {
      var n = this;
      e.forEach(function(i) {
        if (i.setParent(r), i instanceof pn) {
          var a = i;
          n.setupParentsIntoColumns(a.getChildren(), a);
        }
      });
    }, t = R$([
      Be("displayedGroupCreator")
    ], t), t;
  }(Me)
), al = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, sl = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, T$ = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  excludeHiddenColumnsFromQuickFilter: !0,
  advancedFilterModel: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  enableChartToolPanelsButton: !0,
  suppressChartToolPanelsButton: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressParentsInRowNodes: !0,
  suppressTouch: !0,
  suppressAsyncEvents: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  suppressAggFuncInHeader: !0,
  suppressAggAtRootLevel: !0,
  removePivotHeaderRowWhenSingleValueColumn: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  suppressGroupMaintainValueType: !0,
  groupLockGroupColumns: !0,
  rowGroupPanelSuppressSort: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  suppressServerSideInfiniteScroll: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  functionsPassive: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0
}, qi = (
  /** @class */
  function() {
    function o() {
    }
    return o.STRING_PROPERTIES = [
      "rowSelection",
      "overlayLoadingTemplate",
      "overlayNoRowsTemplate",
      "gridId",
      "quickFilterText",
      "rowModelType",
      "editType",
      "domLayout",
      "clipboardDelimiter",
      "rowGroupPanelShow",
      "multiSortKey",
      "pivotColumnGroupTotals",
      "pivotRowTotals",
      "pivotPanelShow",
      "fillHandleDirection",
      "groupDisplayType",
      "treeDataDisplayType",
      "colResizeDefault",
      "tooltipTrigger",
      "serverSidePivotResultFieldSeparator"
    ], o.OBJECT_PROPERTIES = [
      "components",
      "rowStyle",
      "context",
      "autoGroupColumnDef",
      "localeText",
      "icons",
      "datasource",
      "serverSideDatasource",
      "viewportDatasource",
      "groupRowRendererParams",
      "aggFuncs",
      "fullWidthCellRendererParams",
      "defaultColGroupDef",
      "defaultColDef",
      "defaultCsvExportParams",
      "defaultExcelExportParams",
      "columnTypes",
      "rowClassRules",
      "detailCellRendererParams",
      "loadingCellRendererParams",
      "loadingOverlayComponentParams",
      "noRowsOverlayComponentParams",
      "popupParent",
      "statusBar",
      "sideBar",
      "chartThemeOverrides",
      "customChartThemes",
      "chartToolPanelsDef",
      "dataTypeDefinitions",
      "advancedFilterModel",
      "advancedFilterParent",
      "advancedFilterBuilderParams",
      "initialState",
      "autoSizeStrategy"
    ], o.ARRAY_PROPERTIES = [
      "sortingOrder",
      "alignedGrids",
      "rowData",
      "columnDefs",
      "excelStyles",
      "pinnedTopRowData",
      "pinnedBottomRowData",
      "chartThemes",
      "rowClass",
      "paginationPageSizeSelector"
    ], o.NUMBER_PROPERTIES = [
      "rowHeight",
      "detailRowHeight",
      "rowBuffer",
      "headerHeight",
      "groupHeaderHeight",
      "groupLockGroupColumns",
      "floatingFiltersHeight",
      "pivotHeaderHeight",
      "pivotGroupHeaderHeight",
      "groupDefaultExpanded",
      "pivotDefaultExpanded",
      "viewportRowModelPageSize",
      "viewportRowModelBufferSize",
      "autoSizePadding",
      "maxBlocksInCache",
      "maxConcurrentDatasourceRequests",
      "tooltipShowDelay",
      "tooltipHideDelay",
      "cacheOverflowSize",
      "paginationPageSize",
      "cacheBlockSize",
      "infiniteInitialRowCount",
      "serverSideInitialRowCount",
      "scrollbarWidth",
      "asyncTransactionWaitMillis",
      "blockLoadDebounceMillis",
      "keepDetailRowsCount",
      "undoRedoCellEditingLimit",
      "cellFlashDelay",
      "cellFadeDelay",
      "tabIndex"
    ], o.BOOLEAN_PROPERTIES = [
      "suppressMakeColumnVisibleAfterUnGroup",
      "suppressRowClickSelection",
      "suppressCellFocus",
      "suppressHorizontalScroll",
      "groupSelectsChildren",
      "alwaysShowHorizontalScroll",
      "alwaysShowVerticalScroll",
      "debug",
      "enableBrowserTooltips",
      "enableCellExpressions",
      "groupIncludeTotalFooter",
      "groupSuppressBlankHeader",
      "suppressMenuHide",
      "suppressRowDeselection",
      "unSortIcon",
      "suppressMultiSort",
      "alwaysMultiSort",
      "singleClickEdit",
      "suppressLoadingOverlay",
      "suppressNoRowsOverlay",
      "suppressAutoSize",
      "skipHeaderOnAutoSize",
      "suppressParentsInRowNodes",
      "suppressColumnMoveAnimation",
      "suppressMovableColumns",
      "suppressFieldDotNotation",
      "enableRangeSelection",
      "enableRangeHandle",
      "enableFillHandle",
      "suppressClearOnFillReduction",
      "deltaSort",
      "suppressTouch",
      "suppressAsyncEvents",
      "allowContextMenuWithControlKey",
      "suppressContextMenu",
      "enableCellChangeFlash",
      "suppressDragLeaveHidesColumns",
      "suppressRowGroupHidesColumns",
      "suppressMiddleClickScrolls",
      "suppressPreventDefaultOnMouseWheel",
      "suppressCopyRowsToClipboard",
      "copyHeadersToClipboard",
      "copyGroupHeadersToClipboard",
      "pivotMode",
      "suppressAggFuncInHeader",
      "suppressColumnVirtualisation",
      "alwaysAggregateAtRootLevel",
      "suppressAggAtRootLevel",
      "suppressFocusAfterRefresh",
      "functionsPassive",
      "functionsReadOnly",
      "animateRows",
      "groupSelectsFiltered",
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "enableRtl",
      "suppressClickEdit",
      "rowDragEntireRow",
      "rowDragManaged",
      "suppressRowDrag",
      "suppressMoveWhenRowDragging",
      "rowDragMultiRow",
      "enableGroupEdit",
      "embedFullWidthRows",
      "suppressPaginationPanel",
      "groupHideOpenParents",
      "groupAllowUnbalanced",
      "pagination",
      "paginationAutoPageSize",
      "suppressScrollOnNewData",
      "suppressScrollWhenPopupsAreOpen",
      "purgeClosedRowNodes",
      "cacheQuickFilter",
      "includeHiddenColumnsInQuickFilter",
      "excludeHiddenColumnsFromQuickFilter",
      "ensureDomOrder",
      "accentedSort",
      "suppressChangeDetection",
      "valueCache",
      "valueCacheNeverExpires",
      "aggregateOnlyChangedColumns",
      "suppressAnimationFrame",
      "suppressExcelExport",
      "suppressCsvExport",
      "includeHiddenColumnsInAdvancedFilter",
      "suppressMultiRangeSelection",
      "enterMovesDown",
      "enterMovesDownAfterEdit",
      "enterNavigatesVerticallyAfterEdit",
      "enterNavigatesVertically",
      "suppressPropertyNamesCheck",
      "rowMultiSelectWithClick",
      "suppressRowHoverHighlight",
      "suppressRowTransform",
      "suppressClipboardPaste",
      "suppressLastEmptyLineOnPaste",
      "enableCharts",
      "enableChartToolPanelsButton",
      "suppressChartToolPanelsButton",
      "suppressMaintainUnsortedOrder",
      "enableCellTextSelection",
      "suppressBrowserResizeObserver",
      "suppressMaxRenderedRowRestriction",
      "excludeChildrenWhenTreeDataFiltering",
      "tooltipMouseTrack",
      "tooltipInteraction",
      "keepDetailRows",
      "paginateChildRows",
      "preventDefaultOnContextMenu",
      "undoRedoCellEditing",
      "allowDragFromColumnsToolPanel",
      "pivotSuppressAutoColumn",
      "suppressExpandablePivotGroups",
      "debounceVerticalScrollbar",
      "detailRowAutoHeight",
      "serverSideFilterAllLevels",
      "serverSideSortAllLevels",
      "serverSideOnlyRefreshFilteredGroups",
      "serverSideSortOnServer",
      "serverSideFilterOnServer",
      "suppressAggFilteredOnly",
      "showOpenedGroup",
      "suppressClipboardApi",
      "suppressModelUpdateAfterUpdateTransaction",
      "stopEditingWhenCellsLoseFocus",
      "maintainColumnOrder",
      "groupMaintainOrder",
      "columnHoverHighlight",
      "readOnlyEdit",
      "suppressRowVirtualisation",
      "enableCellEditingOnBackspace",
      "resetRowDataOnUpdate",
      "removePivotHeaderRowWhenSingleValueColumn",
      "suppressCopySingleCellRanges",
      "suppressGroupRowsSticky",
      "suppressCutToClipboard",
      "suppressServerSideInfiniteScroll",
      "rowGroupPanelSuppressSort",
      "allowShowChangeAfterFilter",
      "enableAdvancedFilter",
      "masterDetail",
      "treeData",
      "suppressGroupMaintainValueType",
      "reactiveCustomComponents"
    ], o.FUNCTIONAL_PROPERTIES = [
      "doesExternalFilterPass",
      "processPivotResultColDef",
      "processPivotResultColGroupDef",
      "getBusinessKeyForNode",
      "isRowSelectable",
      "rowDragText",
      "groupRowRenderer",
      "fullWidthCellRenderer",
      "loadingCellRenderer",
      "loadingOverlayComponent",
      "noRowsOverlayComponent",
      "detailCellRenderer",
      "quickFilterParser",
      "quickFilterMatcher"
    ], o.CALLBACK_PROPERTIES = [
      "getLocaleText",
      "isExternalFilterPresent",
      "getRowHeight",
      "getRowClass",
      "getRowStyle",
      "getContextMenuItems",
      "getMainMenuItems",
      "processRowPostCreate",
      "processCellForClipboard",
      "getGroupRowAgg",
      "isFullWidthRow",
      "sendToClipboard",
      "navigateToNextHeader",
      "tabToNextHeader",
      "navigateToNextCell",
      "tabToNextCell",
      "processCellFromClipboard",
      "getDocument",
      "postProcessPopup",
      "getChildCount",
      "getDataPath",
      "isRowMaster",
      "postSortRows",
      "processHeaderForClipboard",
      "processUnpinnedColumns",
      "processGroupHeaderForClipboard",
      "paginationNumberFormatter",
      "processDataFromClipboard",
      "getServerSideGroupKey",
      "isServerSideGroup",
      "createChartContainer",
      "getChartToolbarItems",
      "fillOperation",
      "isApplyServerSideTransaction",
      "getServerSideGroupLevelParams",
      "isServerSideGroupOpenByDefault",
      "isGroupOpenByDefault",
      "initialGroupOrderComparator",
      "groupIncludeFooter",
      "loadingCellRendererSelector",
      "getRowId",
      "groupAggFiltering"
    ], o.FUNCTION_PROPERTIES = sl(sl([], al(o.FUNCTIONAL_PROPERTIES), !1), al(o.CALLBACK_PROPERTIES), !1), o.ALL_PROPERTIES = sl(sl(sl(sl(sl(sl([], al(o.ARRAY_PROPERTIES), !1), al(o.OBJECT_PROPERTIES), !1), al(o.STRING_PROPERTIES), !1), al(o.NUMBER_PROPERTIES), !1), al(o.FUNCTION_PROPERTIES), !1), al(o.BOOLEAN_PROPERTIES), !1), o;
  }()
), MS = function() {
  return MS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, MS.apply(this, arguments);
}, TO = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, OO = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, R1 = (
  /** @class */
  function() {
    function o() {
    }
    o.getCallbackForEvent = function(e) {
      return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
    }, o.getGridOptionKeys = function() {
      return this.ALL_PROPERTIES_AND_CALLBACKS;
    }, o.combineAttributesAndGridOptions = function(e, r) {
      typeof e != "object" && (e = {});
      var n = MS({}, e), i = o.getGridOptionKeys();
      return i.forEach(function(a) {
        var s = r[a];
        typeof s < "u" && s !== o.VUE_OMITTED_PROPERTY && (n[a] = s);
      }), n;
    }, o.processOnChange = function(e, r) {
      if (e) {
        var n = {}, i = !1;
        if (Object.keys(e).filter(function(s) {
          return o.ALL_PROPERTIES_AND_CALLBACKS_SET.has(s);
        }).forEach(function(s) {
          n[s] = e[s], i = !0;
        }), !!i) {
          r.__internalUpdateGridOptions(n);
          var a = {
            type: G.EVENT_COMPONENT_STATE_CHANGED
          };
          Xn(n, function(s, l) {
            a[s] = l;
          }), r.dispatchEvent(a);
        }
      }
    };
    var t;
    return t = o, o.EVENTS = ic(G), o.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY", o.EXCLUDED_INTERNAL_EVENTS = [
      G.EVENT_SCROLLBAR_WIDTH_CHANGED,
      G.EVENT_CHECKBOX_CHANGED,
      G.EVENT_HEIGHT_SCALE_CHANGED,
      G.EVENT_BODY_HEIGHT_CHANGED,
      G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
      G.EVENT_SCROLL_VISIBILITY_CHANGED,
      G.EVENT_COLUMN_HOVER_CHANGED,
      G.EVENT_FLASH_CELLS,
      G.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED,
      G.EVENT_DISPLAYED_ROWS_CHANGED,
      G.EVENT_LEFT_PINNED_WIDTH_CHANGED,
      G.EVENT_RIGHT_PINNED_WIDTH_CHANGED,
      G.EVENT_ROW_CONTAINER_HEIGHT_CHANGED,
      G.EVENT_POPUP_TO_FRONT,
      G.EVENT_STORE_UPDATED,
      G.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
      G.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
      G.EVENT_FILL_START,
      G.EVENT_FILL_END,
      G.EVENT_KEY_SHORTCUT_CHANGED_CELL_START,
      G.EVENT_KEY_SHORTCUT_CHANGED_CELL_END,
      G.EVENT_FULL_WIDTH_ROW_FOCUSED,
      G.EVENT_HEADER_HEIGHT_CHANGED,
      G.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
      G.EVENT_CELL_FOCUS_CLEARED,
      G.EVENT_GRID_STYLES_CHANGED,
      G.EVENT_FILTER_DESTROYED,
      G.EVENT_ROW_DATA_UPDATE_STARTED,
      G.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
      G.EVENT_DATA_TYPES_INFERRED,
      G.EVENT_FIELD_VALUE_CHANGED,
      G.EVENT_FIELD_PICKER_VALUE_SELECTED,
      G.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED,
      G.EVENT_SUPPRESS_MENU_HIDE_CHANGED,
      G.EVENT_SUPPRESS_FIELD_DOT_NOTATION,
      G.EVENT_ROW_COUNT_READY,
      G.EVENT_SIDE_BAR_UPDATED
    ], o.PUBLIC_EVENTS = o.EVENTS.filter(function(e) {
      return !ra(o.EXCLUDED_INTERNAL_EVENTS, e);
    }), o.EVENT_CALLBACKS = o.EVENTS.map(function(e) {
      return o.getCallbackForEvent(e);
    }), o.STRING_PROPERTIES = qi.STRING_PROPERTIES, o.OBJECT_PROPERTIES = qi.OBJECT_PROPERTIES, o.ARRAY_PROPERTIES = qi.ARRAY_PROPERTIES, o.NUMBER_PROPERTIES = qi.NUMBER_PROPERTIES, o.BOOLEAN_PROPERTIES = qi.BOOLEAN_PROPERTIES, o.FUNCTION_PROPERTIES = qi.FUNCTION_PROPERTIES, o.ALL_PROPERTIES = qi.ALL_PROPERTIES, o.ALL_PROPERTIES_AND_CALLBACKS = OO(OO([], TO(t.ALL_PROPERTIES), !1), TO(t.EVENT_CALLBACKS), !1), o.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set(o.ALL_PROPERTIES_AND_CALLBACKS), o;
  }()
), O$ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), P$ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, C2 = (
  /** @class */
  function(o) {
    O$(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.componentsMappedByName = {}, e;
    }
    return t.prototype.setupComponents = function(e) {
      var r = this;
      e && e.forEach(function(n) {
        return r.addComponent(n);
      });
    }, t.prototype.addComponent = function(e) {
      var r = e.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), n = r.toUpperCase();
      this.componentsMappedByName[n] = e.componentClass;
    }, t.prototype.getComponentClass = function(e) {
      return this.componentsMappedByName[e];
    }, t = P$([
      Be("agStackComponentsRegistry")
    ], t), t;
  }(Me)
);
function di(o, t, e) {
  e == null || typeof e == "string" && e == "" ? T1(o, t) : Li(o, t, e);
}
function Li(o, t, e) {
  o.setAttribute(w2(t), e.toString());
}
function T1(o, t) {
  o.removeAttribute(w2(t));
}
function w2(o) {
  return "aria-".concat(o);
}
function bn(o, t) {
  t ? o.setAttribute("role", t) : o.removeAttribute("role");
}
function b2(o) {
  var t;
  return o === "asc" ? t = "ascending" : o === "desc" ? t = "descending" : o === "mixed" ? t = "other" : t = "none", t;
}
function S2(o) {
  return parseInt(o.getAttribute("aria-level"), 10);
}
function E2(o) {
  return parseInt(o.getAttribute("aria-posinset"), 10);
}
function _2(o) {
  return o.getAttribute("aria-label");
}
function Os(o, t) {
  di(o, "label", t);
}
function Zm(o, t) {
  di(o, "labelledby", t);
}
function x2(o, t) {
  di(o, "description", t);
}
function D$(o, t) {
  di(o, "describedby", t);
}
function O1(o, t) {
  di(o, "live", t);
}
function A$(o, t) {
  di(o, "atomic", t);
}
function R2(o, t) {
  di(o, "relevant", t);
}
function T2(o, t) {
  di(o, "level", t);
}
function P1(o, t) {
  di(o, "disabled", t);
}
function Qy(o, t) {
  di(o, "hidden", t);
}
function D1(o, t) {
  di(o, "activedescendant", t);
}
function ea(o, t) {
  Li(o, "expanded", t);
}
function O2(o) {
  T1(o, "expanded");
}
function A1(o, t) {
  Li(o, "setsize", t);
}
function M1(o, t) {
  Li(o, "posinset", t);
}
function P2(o, t) {
  Li(o, "multiselectable", t);
}
function D2(o, t) {
  Li(o, "rowcount", t);
}
function F1(o, t) {
  Li(o, "rowindex", t);
}
function A2(o, t) {
  Li(o, "colcount", t);
}
function I1(o, t) {
  Li(o, "colindex", t);
}
function M2(o, t) {
  Li(o, "colspan", t);
}
function F2(o, t) {
  Li(o, "sort", t);
}
function I2(o) {
  T1(o, "sort");
}
function lp(o, t) {
  di(o, "selected", t);
}
function M$(o, t) {
  Li(o, "checked", t === void 0 ? "mixed" : t);
}
function L1(o, t) {
  di(o, "controls", t.id), Zm(t, o.id);
}
function Jy(o, t) {
  return t === void 0 ? o("ariaIndeterminate", "indeterminate") : t === !0 ? o("ariaChecked", "checked") : o("ariaUnchecked", "unchecked");
}
var F$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  setAriaRole: bn,
  getAriaSortState: b2,
  getAriaLevel: S2,
  getAriaPosInSet: E2,
  getAriaLabel: _2,
  setAriaLabel: Os,
  setAriaLabelledBy: Zm,
  setAriaDescription: x2,
  setAriaDescribedBy: D$,
  setAriaLive: O1,
  setAriaAtomic: A$,
  setAriaRelevant: R2,
  setAriaLevel: T2,
  setAriaDisabled: P1,
  setAriaHidden: Qy,
  setAriaActiveDescendant: D1,
  setAriaExpanded: ea,
  removeAriaExpanded: O2,
  setAriaSetSize: A1,
  setAriaPosInSet: M1,
  setAriaMultiSelectable: P2,
  setAriaRowCount: D2,
  setAriaRowIndex: F1,
  setAriaColCount: A2,
  setAriaColIndex: I1,
  setAriaColSpan: M2,
  setAriaSort: F2,
  removeAriaSort: I2,
  setAriaSelected: lp,
  setAriaChecked: M$,
  setAriaControls: L1,
  getAriaCheckboxStateName: Jy
}), Dw, Ag, Aw, Mw, Fw, Iw, FS, IS;
function oa() {
  return Dw === void 0 && (Dw = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), Dw;
}
function N1() {
  if (Ag === void 0)
    if (oa()) {
      var o = navigator.userAgent.match(/version\/(\d+)/i);
      o && (Ag = o[1] != null ? parseFloat(o[1]) : 0);
    } else
      Ag = 0;
  return Ag;
}
function eC() {
  if (Aw === void 0) {
    var o = window;
    Aw = !!o.chrome && (!!o.chrome.webstore || !!o.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return Aw;
}
function k1() {
  return Mw === void 0 && (Mw = /(firefox)/i.test(navigator.userAgent)), Mw;
}
function G1() {
  return Fw === void 0 && (Fw = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), Fw;
}
function jl() {
  return Iw === void 0 && (Iw = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
  navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), Iw;
}
function V1() {
  return !oa() || N1() >= 15;
}
function Qm(o) {
  if (!o)
    return null;
  var t = o.tabIndex, e = o.getAttribute("tabIndex");
  return t === -1 && (e === null || e === "" && !k1()) ? null : t.toString();
}
function L2() {
  if (!document.body)
    return -1;
  var o = 1e6, t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, e = document.createElement("div");
  for (document.body.appendChild(e); ; ) {
    var r = o * 2;
    if (e.style.height = r + "px", r > t || e.clientHeight !== r)
      break;
    o = r;
  }
  return document.body.removeChild(e), o;
}
function N2() {
  var o, t, e;
  return (t = (o = document.body) === null || o === void 0 ? void 0 : o.clientWidth) !== null && t !== void 0 ? t : window.innerHeight || ((e = document.documentElement) === null || e === void 0 ? void 0 : e.clientWidth) || -1;
}
function k2() {
  var o, t, e;
  return (t = (o = document.body) === null || o === void 0 ? void 0 : o.clientHeight) !== null && t !== void 0 ? t : window.innerHeight || ((e = document.documentElement) === null || e === void 0 ? void 0 : e.clientHeight) || -1;
}
function G2() {
  return IS == null && V2(), IS;
}
function V2() {
  var o = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", o.appendChild(t);
  var e = t.offsetWidth - t.clientWidth;
  e === 0 && t.clientWidth === 0 && (e = null), t.parentNode && t.parentNode.removeChild(t), e != null && (IS = e, FS = e === 0);
}
function H1() {
  return FS == null && V2(), FS;
}
var I$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isBrowserSafari: oa,
  getSafariVersion: N1,
  isBrowserChrome: eC,
  isBrowserFirefox: k1,
  isMacOsUserAgent: G1,
  isIOSUserAgent: jl,
  browserSupportsPreventScroll: V1,
  getTabIndex: Qm,
  getMaxDivHeight: L2,
  getBodyWidth: N2,
  getBodyHeight: k2,
  getScrollbarWidth: G2,
  isInvisibleScrollbar: H1
});
function Xd(o, t) {
  return o.toString().padStart(t, "0");
}
function H2(o, t) {
  for (var e = [], r = o; r <= t; r++)
    e.push(r);
  return e;
}
function L$(o) {
  return typeof o == "string" && (o = parseInt(o, 10)), typeof o == "number" ? Math.floor(o) : null;
}
function N$(o, t) {
  for (var e = "", r = 0; r < t; r++)
    e += String.fromCharCode(o & 255), o >>>= 8;
  return e;
}
function k$(o, t, e) {
  return typeof o != "number" ? "" : B1(Math.round(o * 100) / 100, t, e);
}
function B1(o, t, e) {
  return typeof o != "number" ? "" : o.toString().replace(".", e).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1".concat(t));
}
function G$(o) {
  return o == null ? null : o.reduce(function(t, e) {
    return t + e;
  }, 0);
}
var V$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  padStartWidthZeros: Xd,
  createArrayOfNumbers: H2,
  cleanNumber: L$,
  decToHex: N$,
  formatNumberTwoDecimalPlacesAndCommas: k$,
  formatNumberCommas: B1,
  sum: G$
}), Lw = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
};
function Pi(o, t, e) {
  if (t === void 0 && (t = !0), e === void 0 && (e = "-"), !o)
    return null;
  var r = [o.getFullYear(), o.getMonth() + 1, o.getDate()].map(function(n) {
    return Xd(n, 2);
  }).join(e);
  return t && (r += " " + [o.getHours(), o.getMinutes(), o.getSeconds()].map(function(n) {
    return Xd(n, 2);
  }).join(":")), r;
}
var Nw = function(o) {
  if (o > 3 && o < 21)
    return "th";
  var t = o % 10;
  switch (t) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
};
function Zd(o, t) {
  t === void 0 && (t = "YYYY-MM-DD");
  var e = Xd(o.getFullYear(), 4), r = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], n = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ], i = {
    YYYY: function() {
      return e.slice(e.length - 4, e.length);
    },
    YY: function() {
      return e.slice(e.length - 2, e.length);
    },
    Y: function() {
      return "".concat(o.getFullYear());
    },
    MMMM: function() {
      return r[o.getMonth()];
    },
    MMM: function() {
      return r[o.getMonth()].slice(0, 3);
    },
    MM: function() {
      return Xd(o.getMonth() + 1, 2);
    },
    Mo: function() {
      return "".concat(o.getMonth() + 1).concat(Nw(o.getMonth() + 1));
    },
    M: function() {
      return "".concat(o.getMonth() + 1);
    },
    Do: function() {
      return "".concat(o.getDate()).concat(Nw(o.getDate()));
    },
    DD: function() {
      return Xd(o.getDate(), 2);
    },
    D: function() {
      return "".concat(o.getDate());
    },
    dddd: function() {
      return n[o.getDay()];
    },
    ddd: function() {
      return n[o.getDay()].slice(0, 3);
    },
    dd: function() {
      return n[o.getDay()].slice(0, 2);
    },
    do: function() {
      return "".concat(o.getDay()).concat(Nw(o.getDay()));
    },
    d: function() {
      return "".concat(o.getDay());
    }
  }, a = new RegExp(Object.keys(i).join("|"), "g");
  return t.replace(a, function(s) {
    return s in i ? i[s]() : s;
  });
}
function ko(o) {
  if (!o)
    return null;
  var t = Lw(o.split(" "), 2), e = t[0], r = t[1];
  if (!e)
    return null;
  var n = e.split("-").map(function(g) {
    return parseInt(g, 10);
  });
  if (n.filter(function(g) {
    return !isNaN(g);
  }).length !== 3)
    return null;
  var i = Lw(n, 3), a = i[0], s = i[1], l = i[2], u = new Date(a, s - 1, l);
  if (u.getFullYear() !== a || u.getMonth() !== s - 1 || u.getDate() !== l)
    return null;
  if (!r || r === "00:00:00")
    return u;
  var c = Lw(r.split(":").map(function(g) {
    return parseInt(g, 10);
  }), 3), d = c[0], f = c[1], v = c[2];
  return d >= 0 && d < 24 && u.setHours(d), f >= 0 && f < 60 && u.setMinutes(f), v >= 0 && v < 60 && u.setSeconds(v), u;
}
var H$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  serialiseDate: Pi,
  dateToFormattedString: Zd,
  parseDateTimeFromString: ko
}), B$ = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, W$ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Mg;
function LS(o, t, e) {
  for (var r = o.parentElement, n = r && r.firstChild; n; )
    t && n.classList.toggle(t, n === o), e && n.classList.toggle(e, n !== o), n = n.nextSibling;
}
var B2 = "[tabindex], input, select, button, textarea, [href]", W1 = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function j1(o) {
  var t = Element.prototype.matches || Element.prototype.msMatchesSelector, e = "input, select, button, textarea", r = t.call(o, e), n = t.call(o, W1), i = ai(o), a = r && !n && i;
  return a;
}
function Vt(o, t, e) {
  e === void 0 && (e = {});
  var r = e.skipAriaHidden;
  o.classList.toggle("ag-hidden", !t), r || Qy(o, !t);
}
function W2(o, t, e) {
  e === void 0 && (e = {});
  var r = e.skipAriaHidden;
  o.classList.toggle("ag-invisible", !t), r || Qy(o, !t);
}
function up(o, t) {
  var e = "disabled", r = t ? function(n) {
    return n.setAttribute(e, "");
  } : function(n) {
    return n.removeAttribute(e);
  };
  r(o), X1(o.querySelectorAll("input"), function(n) {
    return r(n);
  });
}
function ac(o, t, e) {
  for (var r = 0; o; ) {
    if (o.classList.contains(t))
      return !0;
    if (o = o.parentElement, typeof e == "number") {
      if (++r > e)
        break;
    } else if (o === e)
      break;
  }
  return !1;
}
function Ul(o) {
  var t = window.getComputedStyle(o), e = t.height, r = t.width, n = t.borderTopWidth, i = t.borderRightWidth, a = t.borderBottomWidth, s = t.borderLeftWidth, l = t.paddingTop, u = t.paddingRight, c = t.paddingBottom, d = t.paddingLeft, f = t.marginTop, v = t.marginRight, g = t.marginBottom, m = t.marginLeft, b = t.boxSizing;
  return {
    height: parseFloat(e || "0"),
    width: parseFloat(r || "0"),
    borderTopWidth: parseFloat(n || "0"),
    borderRightWidth: parseFloat(i || "0"),
    borderBottomWidth: parseFloat(a || "0"),
    borderLeftWidth: parseFloat(s || "0"),
    paddingTop: parseFloat(l || "0"),
    paddingRight: parseFloat(u || "0"),
    paddingBottom: parseFloat(c || "0"),
    paddingLeft: parseFloat(d || "0"),
    marginTop: parseFloat(f || "0"),
    marginRight: parseFloat(v || "0"),
    marginBottom: parseFloat(g || "0"),
    marginLeft: parseFloat(m || "0"),
    boxSizing: b
  };
}
function uv(o) {
  var t = Ul(o);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function Ec(o) {
  var t = Ul(o);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function U1(o) {
  var t = Ul(o), e = t.marginBottom + t.marginTop;
  return Math.ceil(o.offsetHeight + e);
}
function Yh(o) {
  var t = Ul(o), e = t.marginLeft + t.marginRight;
  return Math.ceil(o.offsetWidth + e);
}
function $1(o) {
  var t = o.getBoundingClientRect(), e = Ul(o), r = e.borderTopWidth, n = e.borderLeftWidth, i = e.borderRightWidth, a = e.borderBottomWidth;
  return {
    top: t.top + (r || 0),
    left: t.left + (n || 0),
    right: t.right + (i || 0),
    bottom: t.bottom + (a || 0)
  };
}
function Kh() {
  if (typeof Mg == "boolean")
    return Mg;
  var o = document.createElement("div");
  return o.style.direction = "rtl", o.style.width = "1px", o.style.height = "1px", o.style.position = "fixed", o.style.top = "0px", o.style.overflow = "hidden", o.dir = "rtl", o.innerHTML = /* html */
  `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`, document.body.appendChild(o), o.scrollLeft = 1, Mg = Math.floor(o.scrollLeft) === 0, document.body.removeChild(o), Mg;
}
function qh(o, t) {
  var e = o.scrollLeft;
  return t && (e = Math.abs(e), eC() && !Kh() && (e = o.scrollWidth - o.clientWidth - e)), e;
}
function Xh(o, t, e) {
  e && (Kh() ? t *= -1 : (oa() || eC()) && (t = o.scrollWidth - o.clientWidth - t)), o.scrollLeft = t;
}
function An(o) {
  for (; o && o.firstChild; )
    o.removeChild(o.firstChild);
}
function bs(o) {
  o && o.parentNode && o.parentNode.removeChild(o);
}
function z1(o) {
  return !!o.offsetParent;
}
function ai(o) {
  var t = o;
  if (t.checkVisibility)
    return t.checkVisibility({ checkVisibilityCSS: !0 });
  var e = !z1(o) || window.getComputedStyle(o).visibility !== "visible";
  return !e;
}
function No(o) {
  var t = document.createElement("div");
  return t.innerHTML = (o || "").trim(), t.firstChild;
}
function Y1(o, t, e) {
  e && e.nextSibling === t || (e ? e.nextSibling ? o.insertBefore(t, e.nextSibling) : o.appendChild(t) : o.firstChild && o.firstChild !== t && o.insertAdjacentElement("afterbegin", t));
}
function K1(o, t) {
  for (var e = 0; e < t.length; e++) {
    var r = t[e], n = o.children[e];
    n !== r && o.insertBefore(r, n);
  }
}
function j2(o, t, e) {
  e ? e.insertAdjacentElement("afterend", t) : o.firstChild ? o.insertAdjacentElement("afterbegin", t) : o.appendChild(t);
}
function q1(o, t) {
  var e, r;
  if (t)
    try {
      for (var n = B$(Object.entries(t)), i = n.next(); !i.done; i = n.next()) {
        var a = W$(i.value, 2), s = a[0], l = a[1];
        if (!(!s || !s.length || l == null)) {
          var u = v2(s), c = l.toString(), d = c.replace(/\s*!important/g, ""), f = d.length != c.length ? "important" : void 0;
          o.style.setProperty(u, d, f);
        }
      }
    } catch (v) {
      e = { error: v };
    } finally {
      try {
        i && !i.done && (r = n.return) && r.call(n);
      } finally {
        if (e) throw e.error;
      }
    }
}
function U2(o) {
  return o.clientWidth < o.scrollWidth;
}
function $2(o) {
  return o.clientHeight < o.scrollHeight;
}
function Zh(o, t) {
  t === "flex" ? (o.style.removeProperty("width"), o.style.removeProperty("minWidth"), o.style.removeProperty("maxWidth"), o.style.flex = "1 1 auto") : Di(o, t);
}
function Di(o, t) {
  t = tC(t), o.style.width = t.toString(), o.style.maxWidth = t.toString(), o.style.minWidth = t.toString();
}
function j$(o, t) {
  t === "flex" ? (o.style.removeProperty("height"), o.style.removeProperty("minHeight"), o.style.removeProperty("maxHeight"), o.style.flex = "1 1 auto") : sc(o, t);
}
function sc(o, t) {
  t = tC(t), o.style.height = t.toString(), o.style.maxHeight = t.toString(), o.style.minHeight = t.toString();
}
function tC(o) {
  return typeof o == "number" ? "".concat(o, "px") : o;
}
function cv(o) {
  return o instanceof Node || o instanceof HTMLElement;
}
function z2(o) {
  if (o == null)
    return [];
  var t = [];
  return X1(o, function(e) {
    return t.push(e);
  }), t;
}
function Y2(o, t) {
  if (o)
    for (var e = 0; e < o.length; e++) {
      var r = o[e];
      t(r.name, r.value);
    }
}
function La(o, t, e) {
  e == null ? o.removeAttribute(t) : o.setAttribute(t, e.toString());
}
function X1(o, t) {
  if (o != null)
    for (var e = 0; e < o.length; e++)
      t(o[e]);
}
function Z1(o, t) {
  o.then(function(e) {
    var r = e.getGui();
    r != null && (typeof r == "object" ? t.appendChild(r) : t.innerHTML = r);
  });
}
var U$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  radioCssClass: LS,
  FOCUSABLE_SELECTOR: B2,
  FOCUSABLE_EXCLUDE: W1,
  isFocusableFormField: j1,
  setDisplayed: Vt,
  setVisible: W2,
  setDisabled: up,
  isElementChildOfClass: ac,
  getElementSize: Ul,
  getInnerHeight: uv,
  getInnerWidth: Ec,
  getAbsoluteHeight: U1,
  getAbsoluteWidth: Yh,
  getElementRectWithOffset: $1,
  isRtlNegativeScroll: Kh,
  getScrollLeft: qh,
  setScrollLeft: Xh,
  clearElement: An,
  removeFromParent: bs,
  isInDOM: z1,
  isVisible: ai,
  loadTemplate: No,
  ensureDomOrder: Y1,
  setDomChildOrder: K1,
  insertWithDomOrder: j2,
  addStylesToElement: q1,
  isHorizontalScrollShowing: U2,
  isVerticalScrollShowing: $2,
  setElementWidth: Zh,
  setFixedWidth: Di,
  setElementHeight: j$,
  setFixedHeight: sc,
  formatSize: tC,
  isNodeOrElement: cv,
  copyNodeList: z2,
  iterateNamedNodeMap: Y2,
  addOrRemoveAttribute: La,
  nodeListForEach: X1,
  bindCellRendererToHtmlElement: Z1
}), $$ = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function K2(o, t, e) {
  var r = {}, n = o.filter(function(i) {
    return !t.some(function(a) {
      return a === i;
    });
  });
  return n.length > 0 && n.forEach(function(i) {
    return r[i] = dv(i, e).values;
  }), r;
}
function dv(o, t, e, r) {
  var n, i, a = t.map(function(g, m) {
    return {
      value: g,
      relevance: z$(o.toLowerCase(), g.toLocaleLowerCase()),
      idx: m
    };
  });
  if (a.sort(function(g, m) {
    return m.relevance - g.relevance;
  }), e && (a = a.filter(function(g) {
    return g.relevance !== 0;
  })), a.length > 0 && r && r > 0) {
    var s = a[0].relevance, l = s * r;
    a = a.filter(function(g) {
      return l - g.relevance < 0;
    });
  }
  var u = [], c = [];
  try {
    for (var d = $$(a), f = d.next(); !f.done; f = d.next()) {
      var v = f.value;
      u.push(v.value), c.push(v.idx);
    }
  } catch (g) {
    n = { error: g };
  } finally {
    try {
      f && !f.done && (i = d.return) && i.call(d);
    } finally {
      if (n) throw n.error;
    }
  }
  return { values: u, indices: c };
}
function z$(o, t) {
  for (var e = o.replace(/\s/g, ""), r = t.replace(/\s/g, ""), n = 0, i = -1, a = 0; a < e.length; a++) {
    var s = r.indexOf(e[a], i + 1);
    s !== -1 && (i = s, n += 100 - i * 100 / 1e4 * 100);
  }
  return n;
}
var Y$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fuzzyCheckStrings: K2,
  fuzzySuggestions: dv
}), q2 = {
  // header column group shown when expanded (click to contract)
  columnGroupOpened: "expanded",
  // header column group shown when contracted (click to expand)
  columnGroupClosed: "contracted",
  // tool panel column group contracted (click to expand)
  columnSelectClosed: "tree-closed",
  // tool panel column group expanded (click to contract)
  columnSelectOpen: "tree-open",
  // column tool panel header expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  columnSelectIndeterminate: "tree-indeterminate",
  // shown on ghost icon while dragging column to the side of the grid to pin
  columnMovePin: "pin",
  // shown on ghost icon while dragging over part of the page that is not a drop zone
  columnMoveHide: "eye-slash",
  // shown on ghost icon while dragging columns to reorder
  columnMoveMove: "arrows",
  // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
  columnMoveLeft: "left",
  // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
  columnMoveRight: "right",
  // shown on ghost icon while dragging over Row Groups drop zone
  columnMoveGroup: "group",
  // shown on ghost icon while dragging over Values drop zone
  columnMoveValue: "aggregation",
  // shown on ghost icon while dragging over pivot drop zone
  columnMovePivot: "pivot",
  // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
  //     string column over aggregation drop zone
  dropNotAllowed: "not-allowed",
  // shown on row group when contracted (click to expand)
  groupContracted: "tree-closed",
  // shown on row group when expanded (click to contract)
  groupExpanded: "tree-open",
  // set filter tree list group contracted (click to expand)
  setFilterGroupClosed: "tree-closed",
  // set filter tree list group expanded (click to contract)
  setFilterGroupOpen: "tree-open",
  // set filter tree list expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  setFilterGroupIndeterminate: "tree-indeterminate",
  // context menu chart item
  chart: "chart",
  // chart window title bar
  close: "cross",
  // X (remove) on column 'pill' after adding it to a drop zone list
  cancel: "cancel",
  // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
  check: "tick",
  // "go to first" button in pagination controls
  first: "first",
  // "go to previous" button in pagination controls
  previous: "previous",
  // "go to next" button in pagination controls
  next: "next",
  // "go to last" button in pagination controls
  last: "last",
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: "linked",
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: "unlinked",
  // "Choose colour" button on chart settings tab
  colorPicker: "color-picker",
  // rotating spinner shown by the loading cell renderer
  groupLoading: "loading",
  // button to launch enterprise column menu
  menu: "menu",
  // filter tool panel tab
  filter: "filter",
  // column tool panel tab
  columns: "columns",
  // button in chart regular size window title bar (click to maximise)
  maximize: "maximize",
  // button in chart maximised window title bar (click to make regular size)
  minimize: "minimize",
  // "Pin column" item in column header menu
  menuPin: "pin",
  // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
  menuValue: "aggregation",
  // "Group by {column-name}" item in column header menu
  menuAddRowGroup: "group",
  // "Un-Group by {column-name}" item in column header menu
  menuRemoveRowGroup: "group",
  // context menu copy item
  clipboardCopy: "copy",
  // context menu cut item
  clipboardCut: "cut",
  // context menu paste item
  clipboardPaste: "paste",
  // identifies the pivot drop zone
  pivotPanel: "pivot",
  // "Row groups" drop zone in column tool panel
  rowGroupPanel: "group",
  // columns tool panel Values drop zone
  valuePanel: "aggregation",
  // drag handle used to pick up draggable columns
  columnDrag: "grip",
  // drag handle used to pick up draggable rows
  rowDrag: "grip",
  // context menu export item
  save: "save",
  // csv export
  csvExport: "csv",
  // excel export,
  excelExport: "excel",
  // icon on dropdown editors
  smallDown: "small-down",
  // version of small-right used in RTL mode
  smallLeft: "small-left",
  // separater between column 'pills' when you add multiple columns to the header drop zone
  smallRight: "small-right",
  smallUp: "small-up",
  // show on column header when column is sorted ascending
  sortAscending: "asc",
  // show on column header when column is sorted descending
  sortDescending: "desc",
  // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
  sortUnSort: "none",
  // Builder button in Advanced Filter
  advancedFilterBuilder: "group",
  // drag handle used to pick up Advanced Filter Builder rows
  advancedFilterBuilderDrag: "grip",
  // Advanced Filter Builder row validation error
  advancedFilterBuilderInvalid: "not-allowed",
  // shown on Advanced Filter Builder rows to move them up
  advancedFilterBuilderMoveUp: "up",
  // shown on Advanced Filter Builder rows to move them down
  advancedFilterBuilderMoveDown: "down",
  // shown on Advanced Filter Builder rows to add new rows
  advancedFilterBuilderAdd: "plus",
  // shown on Advanced Filter Builder rows to remove row
  advancedFilterBuilderRemove: "minus"
};
function Ti(o, t, e) {
  var r = sn(o, t, e);
  if (r) {
    var n = r.className;
    if (typeof n == "string" && n.indexOf("ag-icon") > -1 || typeof n == "object" && n["ag-icon"])
      return r;
  }
  var i = document.createElement("span");
  return i.appendChild(r), i;
}
function sn(o, t, e, r) {
  var n = null, i = e && e.getColDef().icons;
  if (i && (n = i[o]), t && !n) {
    var a = t.get("icons");
    a && (n = a[o]);
  }
  if (n) {
    var s = void 0;
    if (typeof n == "function")
      s = n();
    else if (typeof n == "string")
      s = n;
    else
      throw new Error("icon from grid options needs to be a string or a function");
    if (typeof s == "string")
      return No(s);
    if (cv(s))
      return s;
    console.warn("AG Grid: iconRenderer should return back a string or a dom object");
  } else {
    var l = document.createElement("span"), u = q2[o];
    return u || (r ? u = o : (console.warn("AG Grid: Did not find icon ".concat(o)), u = "")), l.setAttribute("class", "ag-icon ag-icon-".concat(u)), l.setAttribute("unselectable", "on"), bn(l, "presentation"), l;
  }
}
var K$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  iconNameClassMap: q2,
  createIcon: Ti,
  createIconNoSpan: sn
}), we = (
  /** @class */
  function() {
    function o() {
    }
    return o.BACKSPACE = "Backspace", o.TAB = "Tab", o.ENTER = "Enter", o.ESCAPE = "Escape", o.SPACE = " ", o.LEFT = "ArrowLeft", o.UP = "ArrowUp", o.RIGHT = "ArrowRight", o.DOWN = "ArrowDown", o.DELETE = "Delete", o.F2 = "F2", o.PAGE_UP = "PageUp", o.PAGE_DOWN = "PageDown", o.PAGE_HOME = "Home", o.PAGE_END = "End", o.A = "KeyA", o.C = "KeyC", o.D = "KeyD", o.V = "KeyV", o.X = "KeyX", o.Y = "KeyY", o.Z = "KeyZ", o;
  }()
), q$ = 65, X$ = 67, Z$ = 86, Q$ = 68, J$ = 90, ez = 89;
function rC(o) {
  if (o.altKey || o.ctrlKey || o.metaKey)
    return !1;
  var t = o.key.length === 1;
  return t;
}
function Jm(o, t, e, r, n) {
  var i = r ? r.getColDef().suppressKeyboardEvent : void 0;
  if (!i)
    return !1;
  var a = o.addGridCommonParams({
    event: t,
    editing: n,
    column: r,
    node: e,
    data: e.data,
    colDef: r.getColDef()
  });
  if (i) {
    var s = i(a);
    if (s)
      return !0;
  }
  return !1;
}
function X2(o, t, e, r) {
  var n = r.getDefinition(), i = n && n.suppressHeaderKeyboardEvent;
  if (!Oe(i))
    return !1;
  var a = o.addGridCommonParams({
    colDef: n,
    column: r,
    headerRowIndex: e,
    event: t
  });
  return !!i(a);
}
function Z2(o) {
  var t = o.keyCode, e;
  switch (t) {
    case q$:
      e = we.A;
      break;
    case X$:
      e = we.C;
      break;
    case Z$:
      e = we.V;
      break;
    case Q$:
      e = we.D;
      break;
    case J$:
      e = we.Z;
      break;
    case ez:
      e = we.Y;
      break;
    default:
      e = o.code;
  }
  return e;
}
function Q2(o, t) {
  return t === void 0 && (t = !1), o === we.DELETE ? !0 : !t && o === we.BACKSPACE ? G1() : !1;
}
var tz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isEventFromPrintableCharacter: rC,
  isUserSuppressingKeyboardEvent: Jm,
  isUserSuppressingHeaderKeyboardEvent: X2,
  normaliseQwertyAzerty: Z2,
  isDeleteKey: Q2
});
function Q1(o, t, e) {
  if (e === 0)
    return !1;
  var r = Math.abs(o.clientX - t.clientX), n = Math.abs(o.clientY - t.clientY);
  return Math.max(r, n) <= e;
}
var rz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  areEventsNear: Q1
});
function nz(o, t) {
  if (!o)
    return !1;
  for (var e = function(s, l) {
    var u = t[s.id], c = t[l.id], d = u !== void 0, f = c !== void 0, v = d && f, g = !d && !f;
    return v ? u - c : g ? s.__objectId - l.__objectId : d ? 1 : -1;
  }, r, n, i = !1, a = 0; a < o.length - 1; a++)
    if (r = o[a], n = o[a + 1], e(r, n) > 0) {
      i = !0;
      break;
    }
  return i ? (o.sort(e), !0) : !1;
}
var oz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sortRowNodesByOrder: nz
});
function J1(o) {
  var t = /* @__PURE__ */ new Set();
  return o.forEach(function(e) {
    return t.add(e);
  }), t;
}
var iz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  convertToSet: J1
}), cn = function() {
  return cn = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, cn.apply(this, arguments);
}, az = cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn(cn({}, F$), o$), I$), H$), U$), a$), $U), Y$), IU), K$), tz), C$), rz), V$), WU), oz), iz), g$), yt = az, gc = (
  /** @class */
  function() {
    function o(t, e) {
      t === void 0 && (t = 0), e === void 0 && (e = 1), this.nextValue = t, this.step = e;
    }
    return o.prototype.next = function() {
      var t = this.nextValue;
      return this.nextValue += this.step, t;
    }, o.prototype.peek = function() {
      return this.nextValue;
    }, o.prototype.skip = function(t) {
      this.nextValue += t;
    }, o;
  }()
), Ju;
(function(o) {
  o[o.IN_PROGRESS = 0] = "IN_PROGRESS", o[o.RESOLVED = 1] = "RESOLVED";
})(Ju || (Ju = {}));
var Zi = (
  /** @class */
  function() {
    function o(t) {
      var e = this;
      this.status = Ju.IN_PROGRESS, this.resolution = null, this.waiters = [], t(function(r) {
        return e.onDone(r);
      }, function(r) {
        return e.onReject(r);
      });
    }
    return o.all = function(t) {
      return new o(function(e) {
        var r = t.length, n = new Array(r);
        t.forEach(function(i, a) {
          i.then(function(s) {
            n[a] = s, r--, r === 0 && e(n);
          });
        });
      });
    }, o.resolve = function(t) {
      return t === void 0 && (t = null), new o(function(e) {
        return e(t);
      });
    }, o.prototype.then = function(t) {
      var e = this;
      return new o(function(r) {
        e.status === Ju.RESOLVED ? r(t(e.resolution)) : e.waiters.push(function(n) {
          return r(t(n));
        });
      });
    }, o.prototype.resolveNow = function(t, e) {
      return this.status === Ju.RESOLVED ? e(this.resolution) : t;
    }, o.prototype.onDone = function(t) {
      this.status = Ju.RESOLVED, this.resolution = t, this.waiters.forEach(function(e) {
        return e(t);
      });
    }, o.prototype.onReject = function(t) {
      console.warn("TBI");
    }, o;
  }()
), sz = (
  /** @class */
  function() {
    function o() {
      this.timestamp = (/* @__PURE__ */ new Date()).getTime();
    }
    return o.prototype.print = function(t) {
      var e = (/* @__PURE__ */ new Date()).getTime() - this.timestamp;
      console.info("".concat(t, " = ").concat(e)), this.timestamp = (/* @__PURE__ */ new Date()).getTime();
    }, o;
  }()
), lz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ku = function() {
  return Ku = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Ku.apply(this, arguments);
}, kw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Yi;
(function(o) {
  o[o.NOTHING = 0] = "NOTHING", o[o.WAITING_TO_SHOW = 1] = "WAITING_TO_SHOW", o[o.SHOWING = 2] = "SHOWING";
})(Yi || (Yi = {}));
var Ta;
(function(o) {
  o[o.HOVER = 0] = "HOVER", o[o.FOCUS = 1] = "FOCUS";
})(Ta || (Ta = {}));
var nC = (
  /** @class */
  function(o) {
    lz(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      return i.parentComp = e, i.tooltipShowDelayOverride = r, i.tooltipHideDelayOverride = n, i.SHOW_QUICK_TOOLTIP_DIFF = 1e3, i.FADE_OUT_TOOLTIP_TIMEOUT = 1e3, i.INTERACTIVE_HIDE_DELAY = 100, i.interactionEnabled = !1, i.isInteractingWithTooltip = !1, i.state = Yi.NOTHING, i.tooltipInstanceCount = 0, i.tooltipMouseTrack = !1, i;
    }
    return t.prototype.postConstruct = function() {
      this.gridOptionsService.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gridOptionsService.get("tooltipMouseTrack");
      var e = this.parentComp.getGui();
      this.tooltipTrigger === Ta.HOVER && (this.addManagedListener(e, "mouseenter", this.onMouseEnter.bind(this)), this.addManagedListener(e, "mouseleave", this.onMouseLeave.bind(this))), this.tooltipTrigger === Ta.FOCUS && (this.addManagedListener(e, "focusin", this.onFocusIn.bind(this)), this.addManagedListener(e, "focusout", this.onFocusOut.bind(this))), this.addManagedListener(e, "mousemove", this.onMouseMove.bind(this)), this.interactionEnabled || (this.addManagedListener(e, "mousedown", this.onMouseDown.bind(this)), this.addManagedListener(e, "keydown", this.onKeyDown.bind(this)));
    }, t.prototype.getGridOptionsTooltipDelay = function(e) {
      var r = this.gridOptionsService.get(e);
      return r < 0 && ht("".concat(e, " should not be lower than 0")), Math.max(200, r);
    }, t.prototype.getTooltipDelay = function(e) {
      var r, n;
      return e === "show" ? (r = this.tooltipShowDelayOverride) !== null && r !== void 0 ? r : this.getGridOptionsTooltipDelay("tooltipShowDelay") : (n = this.tooltipHideDelayOverride) !== null && n !== void 0 ? n : this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }, t.prototype.destroy = function() {
      this.setToDoNothing(), o.prototype.destroy.call(this);
    }, t.prototype.getTooltipTrigger = function() {
      var e = this.gridOptionsService.get("tooltipTrigger");
      return !e || e === "hover" ? Ta.HOVER : Ta.FOCUS;
    }, t.prototype.onMouseEnter = function(e) {
      var r = this;
      this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), !jl() && (t.isLocked ? this.showTooltipTimeoutId = window.setTimeout(function() {
        r.prepareToShowTooltip(e);
      }, this.INTERACTIVE_HIDE_DELAY) : this.prepareToShowTooltip(e));
    }, t.prototype.onMouseMove = function(e) {
      this.lastMouseEvent && (this.lastMouseEvent = e), this.tooltipMouseTrack && this.state === Yi.SHOWING && this.tooltipComp && this.positionTooltip();
    }, t.prototype.onMouseDown = function() {
      this.setToDoNothing();
    }, t.prototype.onMouseLeave = function() {
      this.interactionEnabled ? this.lockService() : this.setToDoNothing();
    }, t.prototype.onFocusIn = function() {
      this.prepareToShowTooltip();
    }, t.prototype.onFocusOut = function(e) {
      var r, n = e.relatedTarget, i = this.parentComp.getGui(), a = (r = this.tooltipComp) === null || r === void 0 ? void 0 : r.getGui();
      this.isInteractingWithTooltip || i.contains(n) || this.interactionEnabled && (a != null && a.contains(n)) || this.setToDoNothing();
    }, t.prototype.onKeyDown = function() {
      this.setToDoNothing();
    }, t.prototype.prepareToShowTooltip = function(e) {
      if (this.state != Yi.NOTHING || t.isLocked)
        return !1;
      var r = 0;
      return e && (r = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = e || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), r), this.state = Yi.WAITING_TO_SHOW, !0;
    }, t.prototype.isLastTooltipHiddenRecently = function() {
      var e = (/* @__PURE__ */ new Date()).getTime(), r = t.lastTooltipHideTime;
      return e - r < this.SHOW_QUICK_TOOLTIP_DIFF;
    }, t.prototype.setToDoNothing = function() {
      this.state === Yi.SHOWING && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.onColumnMovedEventCallback && (this.onColumnMovedEventCallback(), this.onColumnMovedEventCallback = void 0), this.clearTimeouts(), this.state = Yi.NOTHING, this.lastMouseEvent = null;
    }, t.prototype.showTooltip = function() {
      var e = Ku({}, this.parentComp.getTooltipParams());
      if (!Oe(e.value)) {
        this.setToDoNothing();
        return;
      }
      this.state = Yi.SHOWING, this.tooltipInstanceCount++;
      var r = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount), n = this.userComponentFactory.getTooltipCompDetails(e);
      n.newAgStackInstance().then(r);
    }, t.prototype.hideTooltip = function(e) {
      if (!(!e && this.isInteractingWithTooltip)) {
        this.tooltipComp && (this.destroyTooltipComp(), t.lastTooltipHideTime = (/* @__PURE__ */ new Date()).getTime());
        var r = {
          type: G.EVENT_TOOLTIP_HIDE,
          parentGui: this.parentComp.getGui()
        };
        this.eventService.dispatchEvent(r), this.state = Yi.NOTHING;
      }
    }, t.prototype.newTooltipComponentCallback = function(e, r) {
      var n = this.state !== Yi.SHOWING || this.tooltipInstanceCount !== e;
      if (n) {
        this.getContext().destroyBean(r);
        return;
      }
      var i = r.getGui();
      this.tooltipComp = r, i.classList.contains("ag-tooltip") || i.classList.add("ag-tooltip-custom"), this.tooltipTrigger === Ta.HOVER && i.classList.add("ag-tooltip-animate"), this.interactionEnabled && i.classList.add("ag-tooltip-interactive");
      var a = this.localeService.getLocaleTextFunc(), s = this.popupService.addPopup({
        eChild: i,
        ariaLabel: a("ariaLabelTooltip", "Tooltip")
      });
      s && (this.tooltipPopupDestroyFunc = s.hideFunc), this.positionTooltip(), this.tooltipTrigger === Ta.FOCUS && (this.onBodyScrollEventCallback = this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL, this.setToDoNothing.bind(this)), this.onColumnMovedEventCallback = this.addManagedListener(this.eventService, G.EVENT_COLUMN_MOVED, this.setToDoNothing.bind(this))), this.interactionEnabled && (this.tooltipTrigger === Ta.HOVER ? (this.tooltipMouseEnterListener = this.addManagedListener(i, "mouseenter", this.onTooltipMouseEnter.bind(this)) || null, this.tooltipMouseLeaveListener = this.addManagedListener(i, "mouseleave", this.onTooltipMouseLeave.bind(this)) || null) : (this.tooltipFocusInListener = this.addManagedListener(i, "focusin", this.onTooltipFocusIn.bind(this)) || null, this.tooltipFocusOutListener = this.addManagedListener(i, "focusout", this.onTooltipFocusOut.bind(this)) || null));
      var l = {
        type: G.EVENT_TOOLTIP_SHOW,
        tooltipGui: i,
        parentGui: this.parentComp.getGui()
      };
      this.eventService.dispatchEvent(l), this.startHideTimeout();
    }, t.prototype.onTooltipMouseEnter = function() {
      this.isInteractingWithTooltip = !0, this.unlockService();
    }, t.prototype.onTooltipMouseLeave = function() {
      this.isInteractingWithTooltip = !1, this.lockService();
    }, t.prototype.onTooltipFocusIn = function() {
      this.isInteractingWithTooltip = !0;
    }, t.prototype.onTooltipFocusOut = function(e) {
      var r, n = this.parentComp.getGui(), i = (r = this.tooltipComp) === null || r === void 0 ? void 0 : r.getGui(), a = e.relatedTarget;
      i != null && i.contains(a) || (this.isInteractingWithTooltip = !1, n.contains(a) ? this.startHideTimeout() : this.hideTooltip());
    }, t.prototype.positionTooltip = function() {
      var e = {
        type: "tooltip",
        ePopup: this.tooltipComp.getGui(),
        nudgeY: 18,
        skipObserver: this.tooltipMouseTrack
      };
      this.lastMouseEvent ? this.popupService.positionPopupUnderMouseEvent(Ku(Ku({}, e), { mouseEvent: this.lastMouseEvent })) : this.popupService.positionPopupByComponent(Ku(Ku({}, e), { eventSource: this.parentComp.getGui(), position: "under", keepWithinBounds: !0, nudgeY: 5 }));
    }, t.prototype.destroyTooltipComp = function() {
      var e = this;
      this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
      var r = this.tooltipPopupDestroyFunc, n = this.tooltipComp, i = this.tooltipTrigger === Ta.HOVER ? this.FADE_OUT_TOOLTIP_TIMEOUT : 0;
      window.setTimeout(function() {
        r(), e.getContext().destroyBean(n);
      }, i), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
    }, t.prototype.clearTooltipListeners = function() {
      [
        this.tooltipMouseEnterListener,
        this.tooltipMouseLeaveListener,
        this.tooltipFocusInListener,
        this.tooltipFocusOutListener
      ].forEach(function(e) {
        e && e();
      }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }, t.prototype.lockService = function() {
      var e = this;
      t.isLocked = !0, this.interactiveTooltipTimeoutId = window.setTimeout(function() {
        e.unlockService(), e.setToDoNothing();
      }, this.INTERACTIVE_HIDE_DELAY);
    }, t.prototype.unlockService = function() {
      t.isLocked = !1, this.clearInteractiveTimeout();
    }, t.prototype.startHideTimeout = function() {
      this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }, t.prototype.clearShowTimeout = function() {
      this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
    }, t.prototype.clearHideTimeout = function() {
      this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
    }, t.prototype.clearInteractiveTimeout = function() {
      this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
    }, t.prototype.clearTimeouts = function() {
      this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
    }, t.isLocked = !1, kw([
      N("popupService")
    ], t.prototype, "popupService", void 0), kw([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), kw([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), J2 = (
  /** @class */
  function() {
    function o(t) {
      this.cssClassStates = {}, this.getGui = t;
    }
    return o.prototype.addCssClass = function(t) {
      var e = this, r = (t || "").split(" ");
      if (r.length > 1) {
        r.forEach(function(a) {
          return e.addCssClass(a);
        });
        return;
      }
      var n = this.cssClassStates[t] !== !0;
      if (n && t.length) {
        var i = this.getGui();
        i && i.classList.add(t), this.cssClassStates[t] = !0;
      }
    }, o.prototype.removeCssClass = function(t) {
      var e = this, r = (t || "").split(" ");
      if (r.length > 1) {
        r.forEach(function(a) {
          return e.removeCssClass(a);
        });
        return;
      }
      var n = this.cssClassStates[t] !== !1;
      if (n && t.length) {
        var i = this.getGui();
        i && i.classList.remove(t), this.cssClassStates[t] = !1;
      }
    }, o.prototype.containsCssClass = function(t) {
      var e = this.getGui();
      return e ? e.classList.contains(t) : !1;
    }, o.prototype.addOrRemoveCssClass = function(t, e) {
      var r = this;
      if (t) {
        if (t.indexOf(" ") >= 0) {
          var n = (t || "").split(" ");
          if (n.length > 1) {
            n.forEach(function(s) {
              return r.addOrRemoveCssClass(s, e);
            });
            return;
          }
        }
        var i = this.cssClassStates[t] !== e;
        if (i && t.length) {
          var a = this.getGui();
          a && a.classList.toggle(t, e), this.cssClassStates[t] = e;
        }
      }
    }, o;
  }()
), uz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Gw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, cz = new gc(), gt = (
  /** @class */
  function(o) {
    uz(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.displayed = !0, r.visible = !0, r.compId = cz.next(), r.cssClassManager = new J2(function() {
        return r.eGui;
      }), e && r.setTemplate(e), r;
    }
    return t.prototype.preConstructOnComponent = function() {
      this.usingBrowserTooltips = this.gridOptionsService.get("enableBrowserTooltips");
    }, t.prototype.getCompId = function() {
      return this.compId;
    }, t.prototype.getTooltipParams = function() {
      return {
        value: this.tooltipText,
        location: "UNKNOWN"
      };
    }, t.prototype.setTooltip = function(e, r, n) {
      var i = this, a = function() {
        i.usingBrowserTooltips ? i.getGui().removeAttribute("title") : i.tooltipFeature = i.destroyBean(i.tooltipFeature);
      }, s = function() {
        i.usingBrowserTooltips ? i.getGui().setAttribute("title", i.tooltipText) : i.tooltipFeature = i.createBean(new nC(i, r, n));
      };
      this.tooltipText != e && (this.tooltipText && a(), e != null && (this.tooltipText = e, this.tooltipText && s()));
    }, t.prototype.createChildComponentsFromTags = function(e, r) {
      var n = this, i = z2(e.childNodes);
      i.forEach(function(a) {
        if (a instanceof HTMLElement) {
          var s = n.createComponentFromElement(a, function(u) {
            var c = u.getGui();
            c && n.copyAttributesFromNode(a, u.getGui());
          }, r);
          if (s) {
            if (s.addItems && a.children.length) {
              n.createChildComponentsFromTags(a, r);
              var l = Array.prototype.slice.call(a.children);
              s.addItems(l);
            }
            n.swapComponentForNode(s, e, a);
          } else a.childNodes && n.createChildComponentsFromTags(a, r);
        }
      });
    }, t.prototype.createComponentFromElement = function(e, r, n) {
      var i = e.nodeName, a = n ? n[e.getAttribute("ref")] : void 0, s = this.agStackComponentsRegistry.getComponentClass(i);
      if (s) {
        t.elementGettingCreated = e;
        var l = new s(a);
        return l.setParentComponent(this), this.createBean(l, null, r), l;
      }
      return null;
    }, t.prototype.copyAttributesFromNode = function(e, r) {
      Y2(e.attributes, function(n, i) {
        return r.setAttribute(n, i);
      });
    }, t.prototype.swapComponentForNode = function(e, r, n) {
      var i = e.getGui();
      r.replaceChild(i, n), r.insertBefore(document.createComment(n.nodeName), i), this.addDestroyFunc(this.destroyBean.bind(this, e)), this.swapInComponentForQuerySelectors(e, n);
    }, t.prototype.swapInComponentForQuerySelectors = function(e, r) {
      var n = this;
      this.iterateOverQuerySelectors(function(i) {
        n[i.attributeName] === r && (n[i.attributeName] = e);
      });
    }, t.prototype.iterateOverQuerySelectors = function(e) {
      for (var r = Object.getPrototypeOf(this); r != null; ) {
        var n = r.__agComponentMetaData, i = Xy(r.constructor);
        n && n[i] && n[i].querySelectors && n[i].querySelectors.forEach(function(a) {
          return e(a);
        }), r = Object.getPrototypeOf(r);
      }
    }, t.prototype.activateTabIndex = function(e) {
      var r = this.gridOptionsService.get("tabIndex");
      e || (e = []), e.length || e.push(this.getGui()), e.forEach(function(n) {
        return n.setAttribute("tabindex", r.toString());
      });
    }, t.prototype.setTemplate = function(e, r) {
      var n = No(e);
      this.setTemplateFromElement(n, r);
    }, t.prototype.setTemplateFromElement = function(e, r) {
      this.eGui = e, this.eGui.__agComponent = this, this.wireQuerySelectors(), this.getContext() && this.createChildComponentsFromTags(this.getGui(), r);
    }, t.prototype.createChildComponentsPreConstruct = function() {
      this.getGui() && this.createChildComponentsFromTags(this.getGui());
    }, t.prototype.wireQuerySelectors = function() {
      var e = this;
      if (this.eGui) {
        var r = this;
        this.iterateOverQuerySelectors(function(n) {
          var i = function(l) {
            return r[n.attributeName] = l;
          }, a = n.refSelector && e.getAttribute("ref") === n.refSelector;
          if (a)
            i(e.eGui);
          else {
            var s = e.eGui.querySelector(n.querySelector);
            s && i(s.__agComponent || s);
          }
        });
      }
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.getFocusableElement = function() {
      return this.eGui;
    }, t.prototype.getAriaElement = function() {
      return this.getFocusableElement();
    }, t.prototype.setParentComponent = function(e) {
      this.parentComponent = e;
    }, t.prototype.getParentComponent = function() {
      return this.parentComponent;
    }, t.prototype.setGui = function(e) {
      this.eGui = e;
    }, t.prototype.queryForHtmlElement = function(e) {
      return this.eGui.querySelector(e);
    }, t.prototype.queryForHtmlInputElement = function(e) {
      return this.eGui.querySelector(e);
    }, t.prototype.appendChild = function(e, r) {
      if (e != null)
        if (r || (r = this.eGui), cv(e))
          r.appendChild(e);
        else {
          var n = e;
          r.appendChild(n.getGui());
        }
    }, t.prototype.isDisplayed = function() {
      return this.displayed;
    }, t.prototype.setVisible = function(e, r) {
      if (r === void 0 && (r = {}), e !== this.visible) {
        this.visible = e;
        var n = r.skipAriaHidden;
        W2(this.eGui, e, { skipAriaHidden: n });
      }
    }, t.prototype.setDisplayed = function(e, r) {
      if (r === void 0 && (r = {}), e !== this.displayed) {
        this.displayed = e;
        var n = r.skipAriaHidden;
        Vt(this.eGui, e, { skipAriaHidden: n });
        var i = {
          type: t.EVENT_DISPLAYED_CHANGED,
          visible: this.displayed
        };
        this.dispatchEvent(i);
      }
    }, t.prototype.destroy = function() {
      this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), this.parentComponent && (this.parentComponent = void 0);
      var e = this.eGui;
      e && e.__agComponent && (e.__agComponent = void 0), o.prototype.destroy.call(this);
    }, t.prototype.addGuiEventListener = function(e, r, n) {
      var i = this;
      this.eGui.addEventListener(e, r, n), this.addDestroyFunc(function() {
        return i.eGui.removeEventListener(e, r);
      });
    }, t.prototype.addCssClass = function(e) {
      this.cssClassManager.addCssClass(e);
    }, t.prototype.removeCssClass = function(e) {
      this.cssClassManager.removeCssClass(e);
    }, t.prototype.containsCssClass = function(e) {
      return this.cssClassManager.containsCssClass(e);
    }, t.prototype.addOrRemoveCssClass = function(e, r) {
      this.cssClassManager.addOrRemoveCssClass(e, r);
    }, t.prototype.getAttribute = function(e) {
      var r = this.eGui;
      return r ? r.getAttribute(e) : null;
    }, t.prototype.getRefElement = function(e) {
      return this.queryForHtmlElement('[ref="'.concat(e, '"]'));
    }, t.EVENT_DISPLAYED_CHANGED = "displayedChanged", Gw([
      N("agStackComponentsRegistry")
    ], t.prototype, "agStackComponentsRegistry", void 0), Gw([
      PS
    ], t.prototype, "preConstructOnComponent", null), Gw([
      PS
    ], t.prototype, "createChildComponentsPreConstruct", null), t;
  }(Me)
);
function dz(o) {
  return eI.bind(this, o, void 0);
}
function ke(o) {
  return eI.bind(this, "[ref=".concat(o, "]"), o);
}
function eI(o, t, e, r, n) {
  if (o === null) {
    console.error("AG Grid: QuerySelector selector should not be null");
    return;
  }
  if (typeof n == "number") {
    console.error("AG Grid: QuerySelector should be on an attribute");
    return;
  }
  pz(e, "querySelectors", {
    attributeName: r,
    querySelector: o,
    refSelector: t
  });
}
function pz(o, t, e) {
  var r = fz(o, Xy(o.constructor));
  r[t] || (r[t] = []), r[t].push(e);
}
function fz(o, t) {
  return o.__agComponentMetaData || (o.__agComponentMetaData = {}), o.__agComponentMetaData[t] || (o.__agComponentMetaData[t] = {}), o.__agComponentMetaData[t];
}
var hz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), PO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, vz = (
  /** @class */
  function(o) {
    hz(t, o);
    function t() {
      return o.call(
        this,
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`
      ) || this;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      this.params = e;
      var r = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), n = this.localeService.getLocaleTextFunc();
      this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel("".concat(r, " ").concat(n("ariaFilterInput", "Filter Input")));
    }, t.prototype.onParentModelChanged = function(e) {
      var r = this;
      if (e == null) {
        this.eFloatingFilterText.setValue("");
        return;
      }
      this.params.parentFilterInstance(function(n) {
        if (n.getModelAsString) {
          var i = n.getModelAsString(e);
          r.eFloatingFilterText.setValue(i);
        }
      });
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      this.init(e);
    }, PO([
      ke("eFloatingFilterText")
    ], t.prototype, "eFloatingFilterText", void 0), PO([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), t;
  }(gt)
), tI = (
  /** @class */
  function() {
    function o(t, e, r, n) {
      var i = this;
      this.alive = !0, this.context = t, this.eParent = n;
      var a = e.getDateCompDetails(r), s = a.newAgStackInstance();
      s.then(function(l) {
        if (!i.alive) {
          t.destroyBean(l);
          return;
        }
        i.dateComp = l, l && (n.appendChild(l.getGui()), l.afterGuiAttached && l.afterGuiAttached(), i.tempValue && l.setDate(i.tempValue), i.disabled != null && i.setDateCompDisabled(i.disabled));
      });
    }
    return o.prototype.destroy = function() {
      this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
    }, o.prototype.getDate = function() {
      return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }, o.prototype.setDate = function(t) {
      this.dateComp ? this.dateComp.setDate(t) : this.tempValue = t;
    }, o.prototype.setDisabled = function(t) {
      this.dateComp ? this.setDateCompDisabled(t) : this.disabled = t;
    }, o.prototype.setDisplayed = function(t) {
      Vt(this.eParent, t);
    }, o.prototype.setInputPlaceholder = function(t) {
      this.dateComp && this.dateComp.setInputPlaceholder && this.dateComp.setInputPlaceholder(t);
    }, o.prototype.setInputAriaLabel = function(t) {
      this.dateComp && this.dateComp.setInputAriaLabel && this.dateComp.setInputAriaLabel(t);
    }, o.prototype.afterGuiAttached = function(t) {
      this.dateComp && typeof this.dateComp.afterGuiAttached == "function" && this.dateComp.afterGuiAttached(t);
    }, o.prototype.updateParams = function(t) {
      var e, r, n = !1;
      if (!((e = this.dateComp) === null || e === void 0) && e.refresh && typeof this.dateComp.refresh == "function") {
        var i = this.dateComp.refresh(t);
        i !== null && (n = !0);
      }
      !n && (!((r = this.dateComp) === null || r === void 0) && r.onParamsUpdated) && typeof this.dateComp.onParamsUpdated == "function" && this.dateComp.onParamsUpdated(t);
    }, o.prototype.setDateCompDisabled = function(t) {
      this.dateComp != null && this.dateComp.setDisabled != null && this.dateComp.setDisabled(t);
    }, o;
  }()
), rI = (
  /** @class */
  function() {
    function o() {
      this.customFilterOptions = {};
    }
    return o.prototype.init = function(t, e) {
      this.filterOptions = t.filterOptions || e, this.mapCustomOptions(), this.selectDefaultItem(t);
    }, o.prototype.getFilterOptions = function() {
      return this.filterOptions;
    }, o.prototype.mapCustomOptions = function() {
      var t = this;
      this.filterOptions && this.filterOptions.forEach(function(e) {
        if (typeof e != "string") {
          var r = [["displayKey"], ["displayName"], ["predicate", "test"]], n = function(i) {
            return i.some(function(a) {
              return e[a] != null;
            }) ? !0 : (console.warn("AG Grid: ignoring FilterOptionDef as it doesn't contain one of '".concat(i, "'")), !1);
          };
          if (!r.every(n)) {
            t.filterOptions = t.filterOptions.filter(function(i) {
              return i === e;
            }) || [];
            return;
          }
          t.customFilterOptions[e.displayKey] = e;
        }
      });
    }, o.prototype.selectDefaultItem = function(t) {
      if (t.defaultOption)
        this.defaultOption = t.defaultOption;
      else if (this.filterOptions.length >= 1) {
        var e = this.filterOptions[0];
        typeof e == "string" ? this.defaultOption = e : e.displayKey ? this.defaultOption = e.displayKey : console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
      } else
        console.warn("AG Grid: no filter options for filter");
    }, o.prototype.getDefaultOption = function() {
      return this.defaultOption;
    }, o.prototype.getCustomOption = function(t) {
      return this.customFilterOptions[t];
    }, o;
  }()
), nI = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd"
}, gz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), NS = function() {
  return NS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, NS.apply(this, arguments);
}, DO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, $l = (
  /** @class */
  function(o) {
    gz(t, o);
    function t(e, r) {
      r === void 0 && (r = {});
      var n = o.call(this) || this;
      return n.eFocusableElement = e, n.callbacks = r, n.callbacks = NS({ shouldStopEventPropagation: function() {
        return !1;
      }, onTabKeyDown: function(i) {
        if (!i.defaultPrevented) {
          var a = n.focusService.findNextFocusableElement(n.eFocusableElement, !1, i.shiftKey);
          a && (a.focus(), i.preventDefault());
        }
      } }, r), n;
    }
    return t.prototype.postConstruct = function() {
      this.eFocusableElement.classList.add(t.FOCUS_MANAGED_CLASS), this.addKeyDownListeners(this.eFocusableElement), this.callbacks.onFocusIn && this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn), this.callbacks.onFocusOut && this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
    }, t.prototype.addKeyDownListeners = function(e) {
      var r = this;
      this.addManagedListener(e, "keydown", function(n) {
        if (!(n.defaultPrevented || na(n))) {
          if (r.callbacks.shouldStopEventPropagation(n)) {
            Ba(n);
            return;
          }
          n.key === we.TAB ? r.callbacks.onTabKeyDown(n) : r.callbacks.handleKeyDown && r.callbacks.handleKeyDown(n);
        }
      });
    }, t.FOCUS_MANAGED_CLASS = "ag-focus-managed", DO([
      N("focusService")
    ], t.prototype, "focusService", void 0), DO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), mz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Vw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, oI = "ag-resizer-wrapper", yz = (
  /* html */
  '<div class="'.concat(oI, `">
        <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`)
), e_ = (
  /** @class */
  function(o) {
    mz(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.element = e, n.dragStartPosition = {
        x: 0,
        y: 0
      }, n.position = {
        x: 0,
        y: 0
      }, n.lastSize = {
        width: -1,
        height: -1
      }, n.positioned = !1, n.resizersAdded = !1, n.resizeListeners = [], n.boundaryEl = null, n.isResizing = !1, n.isMoving = !1, n.resizable = {}, n.movable = !1, n.currentResizer = null, n.config = Object.assign({}, { popup: !1 }, r), n;
    }
    return t.prototype.center = function() {
      var e = this.offsetParent, r = e.clientHeight, n = e.clientWidth, i = n / 2 - this.getWidth() / 2, a = r / 2 - this.getHeight() / 2;
      this.offsetElement(i, a);
    }, t.prototype.initialisePosition = function() {
      if (!this.positioned) {
        var e = this.config, r = e.centered, n = e.forcePopupParentAsOffsetParent, i = e.minWidth, a = e.width, s = e.minHeight, l = e.height, u = e.x, c = e.y;
        this.offsetParent || this.setOffsetParent();
        var d = 0, f = 0, v = ai(this.element);
        if (v) {
          var g = this.findBoundaryElement(), m = window.getComputedStyle(g);
          if (m.minWidth != null) {
            var b = g.offsetWidth - this.element.offsetWidth;
            f = parseInt(m.minWidth, 10) - b;
          }
          if (m.minHeight != null) {
            var S = g.offsetHeight - this.element.offsetHeight;
            d = parseInt(m.minHeight, 10) - S;
          }
        }
        if (this.minHeight = s || d, this.minWidth = i || f, a && this.setWidth(a), l && this.setHeight(l), (!a || !l) && this.refreshSize(), r)
          this.center();
        else if (u || c)
          this.offsetElement(u, c);
        else if (v && n) {
          var g = this.boundaryEl, R = !0;
          if (g || (g = this.findBoundaryElement(), R = !1), g) {
            var P = parseFloat(g.style.top), D = parseFloat(g.style.left);
            R ? this.offsetElement(isNaN(D) ? 0 : D, isNaN(P) ? 0 : P) : this.setPosition(D, P);
          }
        }
        this.positioned = !!this.offsetParent;
      }
    }, t.prototype.isPositioned = function() {
      return this.positioned;
    }, t.prototype.getPosition = function() {
      return this.position;
    }, t.prototype.setMovable = function(e, r) {
      if (!(!this.config.popup || e === this.movable)) {
        this.movable = e;
        var n = this.moveElementDragListener || {
          eElement: r,
          onDragStart: this.onMoveStart.bind(this),
          onDragging: this.onMove.bind(this),
          onDragStop: this.onMoveEnd.bind(this)
        };
        e ? (this.dragService.addDragSource(n), this.moveElementDragListener = n) : (this.dragService.removeDragSource(n), this.moveElementDragListener = void 0);
      }
    }, t.prototype.setResizable = function(e) {
      var r = this;
      if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
        if (e === !1)
          return;
        e = {
          topLeft: e,
          top: e,
          topRight: e,
          right: e,
          bottomRight: e,
          bottom: e,
          bottomLeft: e,
          left: e
        };
      }
      Object.keys(e).forEach(function(n) {
        var i = e, a = !!i[n], s = r.getResizerElement(n), l = {
          dragStartPixels: 0,
          eElement: s,
          onDragStart: function(u) {
            return r.onResizeStart(u, n);
          },
          onDragging: r.onResize.bind(r),
          onDragStop: function(u) {
            return r.onResizeEnd(u, n);
          }
        };
        (a || !r.isAlive() && !a) && (a ? (r.dragService.addDragSource(l), r.resizeListeners.push(l), s.style.pointerEvents = "all") : s.style.pointerEvents = "none", r.resizable[n] = a);
      });
    }, t.prototype.removeSizeFromEl = function() {
      this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
    }, t.prototype.restoreLastSize = function() {
      this.element.style.flex = "0 0 auto";
      var e = this.lastSize, r = e.height, n = e.width;
      n !== -1 && (this.element.style.width = "".concat(n, "px")), r !== -1 && (this.element.style.height = "".concat(r, "px"));
    }, t.prototype.getHeight = function() {
      return this.element.offsetHeight;
    }, t.prototype.setHeight = function(e) {
      var r = this.config.popup, n = this.element, i = !1;
      if (typeof e == "string" && e.indexOf("%") !== -1)
        sc(n, e), e = U1(n), i = !0;
      else if (e = Math.max(this.minHeight, e), this.positioned) {
        var a = this.getAvailableHeight();
        a && e > a && (e = a);
      }
      this.getHeight() !== e && (i ? (n.style.maxHeight = "unset", n.style.minHeight = "unset") : r ? sc(n, e) : (n.style.height = "".concat(e, "px"), n.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
    }, t.prototype.getAvailableHeight = function() {
      var e = this.config, r = e.popup, n = e.forcePopupParentAsOffsetParent;
      this.positioned || this.initialisePosition();
      var i = this.offsetParent.clientHeight;
      if (!i)
        return null;
      var a = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), l = r ? this.position.y : a.top, u = r ? 0 : s.top, c = 0;
      if (n) {
        var d = this.element.parentElement;
        if (d) {
          var f = d.getBoundingClientRect().bottom;
          c = f - a.bottom;
        }
      }
      var v = i + u - l - c;
      return v;
    }, t.prototype.getWidth = function() {
      return this.element.offsetWidth;
    }, t.prototype.setWidth = function(e) {
      var r = this.element, n = this.config.popup, i = !1;
      if (typeof e == "string" && e.indexOf("%") !== -1)
        Di(r, e), e = Yh(r), i = !0;
      else if (this.positioned) {
        e = Math.max(this.minWidth, e);
        var a = this.offsetParent.clientWidth, s = n ? this.position.x : this.element.getBoundingClientRect().left;
        a && e + s > a && (e = a - s);
      }
      this.getWidth() !== e && (i ? (r.style.maxWidth = "unset", r.style.minWidth = "unset") : this.config.popup ? Di(r, e) : (r.style.width = "".concat(e, "px"), r.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
    }, t.prototype.offsetElement = function(e, r) {
      e === void 0 && (e = 0), r === void 0 && (r = 0);
      var n = this.config.forcePopupParentAsOffsetParent, i = n ? this.boundaryEl : this.element;
      i && (this.popupService.positionPopup({
        ePopup: i,
        keepWithinBounds: !0,
        skipObserver: this.movable || this.isResizable(),
        updatePosition: function() {
          return { x: e, y: r };
        }
      }), this.setPosition(parseFloat(i.style.left), parseFloat(i.style.top)));
    }, t.prototype.constrainSizeToAvailableHeight = function(e) {
      var r = this;
      if (this.config.forcePopupParentAsOffsetParent) {
        var n = function() {
          var i = r.getAvailableHeight();
          r.element.style.setProperty("max-height", "".concat(i, "px"));
        };
        e ? this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), n) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
      }
    }, t.prototype.setPosition = function(e, r) {
      this.position.x = e, this.position.y = r;
    }, t.prototype.updateDragStartPosition = function(e, r) {
      this.dragStartPosition = { x: e, y: r };
    }, t.prototype.calculateMouseMovement = function(e) {
      var r = e.e, n = e.isLeft, i = e.isTop, a = e.anywhereWithin, s = e.topBuffer, l = r.clientX - this.dragStartPosition.x, u = r.clientY - this.dragStartPosition.y, c = this.shouldSkipX(r, !!n, !!a, l) ? 0 : l, d = this.shouldSkipY(r, !!i, s, u) ? 0 : u;
      return { movementX: c, movementY: d };
    }, t.prototype.shouldSkipX = function(e, r, n, i) {
      var a = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), l = this.boundaryEl.getBoundingClientRect(), u = this.config.popup ? this.position.x : a.left, c = u <= 0 && s.left >= e.clientX || s.right <= e.clientX && s.right <= l.right;
      return c ? !0 : (r ? c = // skip if we are moving to the left and the cursor
      // is positioned to the right of the left side anchor
      i < 0 && e.clientX > u + s.left || // skip if we are moving to the right and the cursor
      // is positioned to the left of the dialog
      i > 0 && e.clientX < u + s.left : n ? c = i < 0 && e.clientX > l.right || i > 0 && e.clientX < u + s.left : c = // if the movement is bound to the right side of the dialog
      // we skip if we are moving to the left and the cursor
      // is to the right of the dialog
      i < 0 && e.clientX > l.right || // or skip if we are moving to the right and the cursor
      // is to the left of the right side anchor
      i > 0 && e.clientX < l.right, c);
    }, t.prototype.shouldSkipY = function(e, r, n, i) {
      n === void 0 && (n = 0);
      var a = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), l = this.boundaryEl.getBoundingClientRect(), u = this.config.popup ? this.position.y : a.top, c = u <= 0 && s.top >= e.clientY || s.bottom <= e.clientY && s.bottom <= l.bottom;
      return c ? !0 : (r ? c = // skip if we are moving to towards top and the cursor is
      // below the top anchor + topBuffer
      // note: topBuffer is used when moving the dialog using the title bar
      i < 0 && e.clientY > u + s.top + n || // skip if we are moving to the bottom and the cursor is
      // above the top anchor
      i > 0 && e.clientY < u + s.top : c = // skip if we are moving towards the top and the cursor
      // is below the bottom anchor
      i < 0 && e.clientY > l.bottom || // skip if we are moving towards the bottom and the cursor
      // is above the bottom anchor
      i > 0 && e.clientY < l.bottom, c);
    }, t.prototype.createResizeMap = function() {
      var e = this.element;
      this.resizerMap = {
        topLeft: { element: e.querySelector("[ref=eTopLeftResizer]") },
        top: { element: e.querySelector("[ref=eTopResizer]") },
        topRight: { element: e.querySelector("[ref=eTopRightResizer]") },
        right: { element: e.querySelector("[ref=eRightResizer]") },
        bottomRight: { element: e.querySelector("[ref=eBottomRightResizer]") },
        bottom: { element: e.querySelector("[ref=eBottomResizer]") },
        bottomLeft: { element: e.querySelector("[ref=eBottomLeftResizer]") },
        left: { element: e.querySelector("[ref=eLeftResizer]") }
      };
    }, t.prototype.addResizers = function() {
      if (!this.resizersAdded) {
        var e = this.element;
        if (e) {
          var r = new DOMParser(), n = r.parseFromString(yz, "text/html").body;
          e.appendChild(n.firstChild), this.createResizeMap(), this.resizersAdded = !0;
        }
      }
    }, t.prototype.removeResizers = function() {
      this.resizerMap = void 0;
      var e = this.element.querySelector(".".concat(oI));
      e && this.element.removeChild(e), this.resizersAdded = !1;
    }, t.prototype.getResizerElement = function(e) {
      return this.resizerMap[e].element;
    }, t.prototype.onResizeStart = function(e, r) {
      this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
        isTop: !!r.match(/top/i),
        isRight: !!r.match(/right/i),
        isBottom: !!r.match(/bottom/i),
        isLeft: !!r.match(/left/i)
      }, this.element.classList.add("ag-resizing"), this.resizerMap[r].element.classList.add("ag-active");
      var n = this.config, i = n.popup, a = n.forcePopupParentAsOffsetParent;
      !i && !a && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
    }, t.prototype.getSiblings = function() {
      var e = this.element, r = e.parentElement;
      return r ? Array.prototype.slice.call(r.children).filter(function(n) {
        return !n.classList.contains("ag-hidden");
      }) : null;
    }, t.prototype.getMinSizeOfSiblings = function() {
      for (var e = this.getSiblings() || [], r = 0, n = 0, i = 0; i < e.length; i++) {
        var a = e[i], s = !!a.style.flex && a.style.flex !== "0 0 auto";
        if (a !== this.element) {
          var l = this.minHeight || 0, u = this.minWidth || 0;
          if (s) {
            var c = window.getComputedStyle(a);
            c.minHeight && (l = parseInt(c.minHeight, 10)), c.minWidth && (u = parseInt(c.minWidth, 10));
          } else
            l = a.offsetHeight, u = a.offsetWidth;
          r += l, n += u;
        }
      }
      return { height: r, width: n };
    }, t.prototype.applySizeToSiblings = function(e) {
      var r = null, n = this.getSiblings();
      if (n) {
        for (var i = 0; i < n.length; i++) {
          var a = n[i];
          a !== r && (e ? a.style.height = "".concat(a.offsetHeight, "px") : a.style.width = "".concat(a.offsetWidth, "px"), a.style.flex = "0 0 auto", a === this.element && (r = n[i + 1]));
        }
        r && (r.style.removeProperty("height"), r.style.removeProperty("min-height"), r.style.removeProperty("max-height"), r.style.flex = "1 1 auto");
      }
    }, t.prototype.isResizable = function() {
      return Object.values(this.resizable).some(function(e) {
        return e;
      });
    }, t.prototype.onResize = function(e) {
      if (!(!this.isResizing || !this.currentResizer)) {
        var r = this.config, n = r.popup, i = r.forcePopupParentAsOffsetParent, a = this.currentResizer, s = a.isTop, l = a.isRight, u = a.isBottom, c = a.isLeft, d = l || c, f = u || s, v = this.calculateMouseMovement({ e, isLeft: c, isTop: s }), g = v.movementX, m = v.movementY, b = this.position.x, S = this.position.y, R = 0, P = 0;
        if (d && g) {
          var D = c ? -1 : 1, x = this.getWidth(), M = x + g * D, F = !1;
          c && (R = x - M, (b + R <= 0 || M <= this.minWidth) && (F = !0, R = 0)), F || this.setWidth(M);
        }
        if (f && m) {
          var D = s ? -1 : 1, H = this.getHeight(), B = H + m * D, j = !1;
          s ? (P = H - B, (S + P <= 0 || B <= this.minHeight) && (j = !0, P = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && H < B && this.getMinSizeOfSiblings().height + B > this.element.parentElement.offsetHeight && (j = !0), j || this.setHeight(B);
        }
        this.updateDragStartPosition(e.clientX, e.clientY), ((n || i) && R || P) && this.offsetElement(b + R, S + P);
      }
    }, t.prototype.onResizeEnd = function(e, r) {
      this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null;
      var n = {
        type: "resize"
      };
      this.element.classList.remove("ag-resizing"), this.resizerMap[r].element.classList.remove("ag-active"), this.dispatchEvent(n);
    }, t.prototype.refreshSize = function() {
      var e = this.element;
      this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
    }, t.prototype.onMoveStart = function(e) {
      this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
    }, t.prototype.onMove = function(e) {
      if (this.isMoving) {
        var r = this.position, n = r.x, i = r.y, a;
        this.config.calculateTopBuffer && (a = this.config.calculateTopBuffer());
        var s = this.calculateMouseMovement({
          e,
          isTop: !0,
          anywhereWithin: !0,
          topBuffer: a
        }), l = s.movementX, u = s.movementY;
        this.offsetElement(n + l, i + u), this.updateDragStartPosition(e.clientX, e.clientY);
      }
    }, t.prototype.onMoveEnd = function() {
      this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
    }, t.prototype.setOffsetParent = function() {
      this.config.forcePopupParentAsOffsetParent ? this.offsetParent = this.popupService.getPopupParent() : this.offsetParent = this.element.offsetParent;
    }, t.prototype.findBoundaryElement = function() {
      for (var e = this.element; e; ) {
        if (window.getComputedStyle(e).position !== "static")
          return e;
        e = e.parentElement;
      }
      return this.element;
    }, t.prototype.clearResizeListeners = function() {
      for (; this.resizeListeners.length; ) {
        var e = this.resizeListeners.pop();
        this.dragService.removeDragSource(e);
      }
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.moveElementDragListener && this.dragService.removeDragSource(this.moveElementDragListener), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
    }, Vw([
      N("popupService")
    ], t.prototype, "popupService", void 0), Vw([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Vw([
      N("dragService")
    ], t.prototype, "dragService", void 0), t;
  }(Me)
), Cz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Qh = (
  /** @class */
  function(o) {
    Cz(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.filterNameKey = e, r.applyActive = !1, r.hidePopup = null, r.debouncePending = !1, r.appliedModel = null, r.buttonListeners = [], r;
    }
    return t.prototype.postConstruct = function() {
      this.resetTemplate(), this.createManagedBean(new $l(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      })), this.positionableFeature = new e_(this.getPositionableElement(), {
        forcePopupParentAsOffsetParent: !0
      }), this.createBean(this.positionableFeature);
    }, t.prototype.handleKeyDown = function(e) {
    }, t.prototype.getFilterTitle = function() {
      return this.translate(this.filterNameKey);
    }, t.prototype.isFilterActive = function() {
      return !!this.appliedModel;
    }, t.prototype.resetTemplate = function(e) {
      var r = this.getGui();
      r && r.removeEventListener("submit", this.onFormSubmit);
      var n = (
        /* html */
        `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-`.concat(this.getCssIdentifier(), `-body-wrapper" ref="eFilterBody">
                    `).concat(this.createBodyTemplate(), `
                </div>
            </form>`)
      );
      this.setTemplate(n, e), r = this.getGui(), r && r.addEventListener("submit", this.onFormSubmit);
    }, t.prototype.isReadOnly = function() {
      return !!this.providedFilterParams.readOnly;
    }, t.prototype.init = function(e) {
      var r = this;
      this.setParams(e), this.resetUiToDefaults(!0).then(function() {
        r.updateUiVisibility(), r.setupOnBtApplyDebounce();
      });
    }, t.prototype.setParams = function(e) {
      this.providedFilterParams = e, this.applyActive = t.isUseApplyButton(e), this.resetButtonsPanel();
    }, t.prototype.updateParams = function(e) {
      var r = this;
      this.providedFilterParams = e, this.applyActive = t.isUseApplyButton(e), this.resetUiToActiveModel(this.getModel(), function() {
        r.updateUiVisibility(), r.setupOnBtApplyDebounce();
      });
    }, t.prototype.resetButtonsPanel = function() {
      var e = this, r = this.providedFilterParams.buttons, n = r && r.length > 0 && !this.isReadOnly();
      if (this.eButtonsPanel ? (An(this.eButtonsPanel), this.buttonListeners.forEach(function(s) {
        return s == null ? void 0 : s();
      }), this.buttonListeners = []) : n && (this.eButtonsPanel = document.createElement("div"), this.eButtonsPanel.classList.add("ag-filter-apply-panel")), !n) {
        this.eButtonsPanel && bs(this.eButtonsPanel);
        return;
      }
      var i = document.createDocumentFragment(), a = function(s) {
        var l, u;
        switch (s) {
          case "apply":
            l = e.translate("applyFilter"), u = function(f) {
              return e.onBtApply(!1, !1, f);
            };
            break;
          case "clear":
            l = e.translate("clearFilter"), u = function() {
              return e.onBtClear();
            };
            break;
          case "reset":
            l = e.translate("resetFilter"), u = function() {
              return e.onBtReset();
            };
            break;
          case "cancel":
            l = e.translate("cancelFilter"), u = function(f) {
              e.onBtCancel(f);
            };
            break;
          default:
            console.warn("AG Grid: Unknown button type specified");
            return;
        }
        var c = s === "apply" ? "submit" : "button", d = No(
          /* html */
          `<button
                    type="`.concat(c, `"
                    ref="`).concat(s, `FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >`).concat(l, `
                </button>`)
        );
        e.buttonListeners.push(e.addManagedListener(d, "click", u)), i.append(d);
      };
      J1(r).forEach(function(s) {
        return a(s);
      }), this.eButtonsPanel.append(i), this.getGui().appendChild(this.eButtonsPanel);
    }, t.prototype.getDefaultDebounceMs = function() {
      return 0;
    }, t.prototype.setupOnBtApplyDebounce = function() {
      var e = this, r = t.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs()), n = Oi(this.checkApplyDebounce.bind(this), r);
      this.onBtApplyDebounce = function() {
        e.debouncePending = !0, n();
      };
    }, t.prototype.checkApplyDebounce = function() {
      this.debouncePending && (this.debouncePending = !1, this.onBtApply());
    }, t.prototype.getModel = function() {
      return this.appliedModel ? this.appliedModel : null;
    }, t.prototype.setModel = function(e) {
      var r = this, n = e != null ? this.setModelIntoUi(e) : this.resetUiToDefaults();
      return n.then(function() {
        r.updateUiVisibility(), r.applyModel("api");
      });
    }, t.prototype.onBtCancel = function(e) {
      var r = this;
      this.resetUiToActiveModel(this.getModel(), function() {
        r.handleCancelEnd(e);
      });
    }, t.prototype.handleCancelEnd = function(e) {
      this.providedFilterParams.closeOnApply && this.close(e);
    }, t.prototype.resetUiToActiveModel = function(e, r) {
      var n = this, i = function() {
        n.onUiChanged(!1, "prevent"), r == null || r();
      };
      e != null ? this.setModelIntoUi(e).then(i) : this.resetUiToDefaults().then(i);
    }, t.prototype.onBtClear = function() {
      var e = this;
      this.resetUiToDefaults().then(function() {
        return e.onUiChanged();
      });
    }, t.prototype.onBtReset = function() {
      this.onBtClear(), this.onBtApply();
    }, t.prototype.applyModel = function(e) {
      var r = this.getModelFromUi();
      if (!this.isModelValid(r))
        return !1;
      var n = this.appliedModel;
      return this.appliedModel = r, !this.areModelsEqual(n, r);
    }, t.prototype.isModelValid = function(e) {
      return !0;
    }, t.prototype.onFormSubmit = function(e) {
      e.preventDefault();
    }, t.prototype.onBtApply = function(e, r, n) {
      if (e === void 0 && (e = !1), r === void 0 && (r = !1), n && n.preventDefault(), this.applyModel(r ? "rowDataUpdated" : "ui")) {
        var i = "columnFilter";
        this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: e, afterDataChange: r, source: i });
      }
      var a = this.providedFilterParams.closeOnApply;
      a && this.applyActive && !e && !r && this.close(n);
    }, t.prototype.onNewRowsLoaded = function() {
    }, t.prototype.close = function(e) {
      if (this.hidePopup) {
        var r = e, n = r && r.key, i;
        (n === "Enter" || n === "Space") && (i = { keyboardEvent: r }), this.hidePopup(i), this.hidePopup = null;
      }
    }, t.prototype.onUiChanged = function(e, r) {
      if (e === void 0 && (e = !1), this.updateUiVisibility(), this.providedFilterParams.filterModifiedCallback(), this.applyActive && !this.isReadOnly()) {
        var n = this.isModelValid(this.getModelFromUi()), i = this.getRefElement("applyFilterButton");
        i && up(i, !n);
      }
      e && !r || r === "immediately" ? this.onBtApply(e) : (!this.applyActive && !r || r === "debounce") && this.onBtApplyDebounce();
    }, t.prototype.afterGuiAttached = function(e) {
      e && (this.hidePopup = e.hidePopup), this.refreshFilterResizer(e == null ? void 0 : e.container);
    }, t.prototype.refreshFilterResizer = function(e) {
      if (!(!this.positionableFeature || e === "toolPanel")) {
        var r = e === "floatingFilter", n = this, i = n.positionableFeature, a = n.gridOptionsService;
        r ? (i.restoreLastSize(), i.setResizable(a.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 })) : (this.positionableFeature.removeSizeFromEl(), this.positionableFeature.setResizable(!1)), this.positionableFeature.constrainSizeToAvailableHeight(!0);
      }
    }, t.prototype.afterGuiDetached = function() {
      this.checkApplyDebounce(), this.positionableFeature && this.positionableFeature.constrainSizeToAvailableHeight(!1);
    }, t.getDebounceMs = function(e, r) {
      return t.isUseApplyButton(e) ? (e.debounceMs != null && console.warn("AG Grid: debounceMs is ignored when apply button is present"), 0) : e.debounceMs != null ? e.debounceMs : r;
    }, t.isUseApplyButton = function(e) {
      return !!e.buttons && e.buttons.indexOf("apply") >= 0;
    }, t.prototype.refresh = function(e) {
      return this.providedFilterParams = e, !0;
    }, t.prototype.destroy = function() {
      var e = this.getGui();
      e && e.removeEventListener("submit", this.onFormSubmit), this.hidePopup = null, this.positionableFeature && (this.positionableFeature = this.destroyBean(this.positionableFeature)), this.appliedModel = null, o.prototype.destroy.call(this);
    }, t.prototype.translate = function(e) {
      var r = this.localeService.getLocaleTextFunc();
      return r(e, nI[e]);
    }, t.prototype.getCellValue = function(e) {
      return this.providedFilterParams.getValue(e);
    }, t.prototype.getPositionableElement = function() {
      return this.eFilterBody;
    }, Hw([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Hw([
      ke("eFilterBody")
    ], t.prototype, "eFilterBody", void 0), Hw([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), wz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bz = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, t_ = (
  /** @class */
  function(o) {
    wz(t, o);
    function t(e, r) {
      var n = o.call(this, r) || this;
      return n.labelSeparator = "", n.labelAlignment = "left", n.disabled = !1, n.label = "", n.config = e || {}, n;
    }
    return t.prototype.postConstruct = function() {
      this.addCssClass("ag-labeled"), this.eLabel.classList.add("ag-label");
      var e = this.config, r = e.labelSeparator, n = e.label, i = e.labelWidth, a = e.labelAlignment;
      r != null && this.setLabelSeparator(r), n != null && this.setLabel(n), i != null && this.setLabelWidth(i), this.setLabelAlignment(a || this.labelAlignment), this.refreshLabel();
    }, t.prototype.refreshLabel = function() {
      An(this.eLabel), typeof this.label == "string" ? this.eLabel.innerText = this.label + this.labelSeparator : this.label && this.eLabel.appendChild(this.label), this.label === "" ? (Vt(this.eLabel, !1), bn(this.eLabel, "presentation")) : (Vt(this.eLabel, !0), bn(this.eLabel, null));
    }, t.prototype.setLabelSeparator = function(e) {
      return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
    }, t.prototype.getLabelId = function() {
      return this.eLabel.id = this.eLabel.id || "ag-".concat(this.getCompId(), "-label"), this.eLabel.id;
    }, t.prototype.getLabel = function() {
      return this.label;
    }, t.prototype.setLabel = function(e) {
      return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
    }, t.prototype.setLabelAlignment = function(e) {
      var r = this.getGui(), n = r.classList;
      return n.toggle("ag-label-align-left", e === "left"), n.toggle("ag-label-align-right", e === "right"), n.toggle("ag-label-align-top", e === "top"), this;
    }, t.prototype.setLabelEllipsis = function(e) {
      return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
    }, t.prototype.setLabelWidth = function(e) {
      return this.label == null ? this : (Zh(this.eLabel, e), this);
    }, t.prototype.setDisabled = function(e) {
      e = !!e;
      var r = this.getGui();
      return up(r, e), r.classList.toggle("ag-disabled", e), this.disabled = e, this;
    }, t.prototype.isDisabled = function() {
      return !!this.disabled;
    }, bz([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), Sz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), r_ = (
  /** @class */
  function(o) {
    Sz(t, o);
    function t(e, r, n) {
      var i = o.call(this, e, r) || this;
      return i.className = n, i;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.className && this.addCssClass(this.className), this.refreshAriaLabelledBy();
    }, t.prototype.refreshAriaLabelledBy = function() {
      var e = this.getAriaElement(), r = this.getLabelId();
      _2(e) !== null ? Zm(e, "") : Zm(e, r ?? "");
    }, t.prototype.setAriaLabel = function(e) {
      return Os(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
    }, t.prototype.onValueChange = function(e) {
      var r = this;
      return this.addManagedListener(this, G.EVENT_FIELD_VALUE_CHANGED, function() {
        return e(r.getValue());
      }), this;
    }, t.prototype.getWidth = function() {
      return this.getGui().clientWidth;
    }, t.prototype.setWidth = function(e) {
      return Di(this.getGui(), e), this;
    }, t.prototype.getPreviousValue = function() {
      return this.previousValue;
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.setValue = function(e, r) {
      return this.value === e ? this : (this.previousValue = this.value, this.value = e, r || this.dispatchEvent({ type: G.EVENT_FIELD_VALUE_CHANGED }), this);
    }, t;
  }(t_)
), Ez = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _f = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, _z = (
  /* html */
  `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`
), n_ = (
  /** @class */
  function(o) {
    Ez(t, o);
    function t(e) {
      var r = o.call(this, e, (e == null ? void 0 : e.template) || _z, e == null ? void 0 : e.className) || this;
      if (r.isPickerDisplayed = !1, r.skipClick = !1, r.pickerGap = 4, r.hideCurrentPicker = null, r.ariaRole = e == null ? void 0 : e.ariaRole, r.onPickerFocusIn = r.onPickerFocusIn.bind(r), r.onPickerFocusOut = r.onPickerFocusOut.bind(r), !e)
        return r;
      var n = e.pickerGap, i = e.maxPickerHeight, a = e.variableWidth, s = e.minPickerWidth, l = e.maxPickerWidth;
      return n != null && (r.pickerGap = n), r.variableWidth = !!a, i != null && r.setPickerMaxHeight(i), s != null && r.setPickerMinWidth(s), l != null && r.setPickerMaxWidth(l), r;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.setupAria();
      var e = "ag-".concat(this.getCompId(), "-display");
      this.eDisplayField.setAttribute("id", e);
      var r = this.getAriaElement();
      this.addManagedListener(r, "keydown", this.onKeyDown.bind(this)), this.addManagedListener(this.eLabel, "mousedown", this.onLabelOrWrapperMouseDown.bind(this)), this.addManagedListener(this.eWrapper, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
      var n = this.config.pickerIcon;
      if (n) {
        var i = sn(n, this.gridOptionsService);
        i && this.eIcon.appendChild(i);
      }
    }, t.prototype.setupAria = function() {
      var e = this.getAriaElement();
      e.setAttribute("tabindex", this.gridOptionsService.get("tabIndex").toString()), ea(e, !1), this.ariaRole && bn(e, this.ariaRole);
    }, t.prototype.onLabelOrWrapperMouseDown = function(e) {
      if (e) {
        var r = this.getFocusableElement();
        if (r !== this.eWrapper && (e == null ? void 0 : e.target) === r)
          return;
        e.preventDefault(), this.getFocusableElement().focus();
      }
      if (this.skipClick) {
        this.skipClick = !1;
        return;
      }
      this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
    }, t.prototype.onKeyDown = function(e) {
      switch (e.key) {
        case we.UP:
        case we.DOWN:
        case we.ENTER:
        case we.SPACE:
          e.preventDefault(), this.onLabelOrWrapperMouseDown();
          break;
        case we.ESCAPE:
          this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
          break;
      }
    }, t.prototype.showPicker = function() {
      this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
      var e = this.pickerComponent.getGui();
      e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
    }, t.prototype.renderAndPositionPicker = function() {
      var e = this, r = this.gridOptionsService.getDocument(), n = this.pickerComponent.getGui();
      this.gridOptionsService.get("suppressScrollWhenPopupsAreOpen") || (this.destroyMouseWheelFunc = this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL, function() {
        e.hidePicker();
      }));
      var i = this.localeService.getLocaleTextFunc(), a = this.config, s = a.pickerAriaLabelKey, l = a.pickerAriaLabelValue, u = a.modalPicker, c = u === void 0 ? !0 : u, d = {
        modal: c,
        eChild: n,
        closeOnEsc: !0,
        closedCallback: function() {
          var P = r.activeElement === r.body;
          e.beforeHidePicker(), P && e.isAlive() && e.getFocusableElement().focus();
        },
        ariaLabel: i(s, l)
      }, f = this.popupService.addPopup(d), v = this, g = v.maxPickerHeight, m = v.minPickerWidth, b = v.maxPickerWidth, S = v.variableWidth;
      S ? (m && (n.style.minWidth = m), n.style.width = tC(Yh(this.eWrapper)), b && (n.style.maxWidth = b)) : Zh(n, b ?? Yh(this.eWrapper));
      var R = g ?? "".concat(uv(this.popupService.getPopupParent()), "px");
      return n.style.setProperty("max-height", R), n.style.position = "absolute", this.alignPickerToComponent(), f.hideFunc;
    }, t.prototype.alignPickerToComponent = function() {
      if (this.pickerComponent) {
        var e = this.config.pickerType, r = this.pickerGap, n = this.gridOptionsService.get("enableRtl") ? "right" : "left";
        this.popupService.positionPopupByComponent({
          type: e,
          eventSource: this.eWrapper,
          ePopup: this.pickerComponent.getGui(),
          position: "under",
          alignSide: n,
          keepWithinBounds: !0,
          nudgeY: r
        });
      }
    }, t.prototype.beforeHidePicker = function() {
      this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
      var e = this.pickerComponent.getGui();
      e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
    }, t.prototype.toggleExpandedStyles = function(e) {
      if (this.isAlive()) {
        var r = this.getAriaElement();
        ea(r, e), this.eWrapper.classList.toggle("ag-picker-expanded", e), this.eWrapper.classList.toggle("ag-picker-collapsed", !e);
      }
    }, t.prototype.onPickerFocusIn = function() {
      this.togglePickerHasFocus(!0);
    }, t.prototype.onPickerFocusOut = function(e) {
      var r;
      !((r = this.pickerComponent) === null || r === void 0) && r.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
    }, t.prototype.togglePickerHasFocus = function(e) {
      this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
    }, t.prototype.hidePicker = function() {
      this.hideCurrentPicker && this.hideCurrentPicker();
    }, t.prototype.setInputWidth = function(e) {
      return Zh(this.eWrapper, e), this;
    }, t.prototype.getFocusableElement = function() {
      return this.eWrapper;
    }, t.prototype.setPickerGap = function(e) {
      return this.pickerGap = e, this;
    }, t.prototype.setPickerMinWidth = function(e) {
      return typeof e == "number" && (e = "".concat(e, "px")), this.minPickerWidth = e ?? void 0, this;
    }, t.prototype.setPickerMaxWidth = function(e) {
      return typeof e == "number" && (e = "".concat(e, "px")), this.maxPickerWidth = e ?? void 0, this;
    }, t.prototype.setPickerMaxHeight = function(e) {
      return typeof e == "number" && (e = "".concat(e, "px")), this.maxPickerHeight = e ?? void 0, this;
    }, t.prototype.destroy = function() {
      this.hidePicker(), o.prototype.destroy.call(this);
    }, _f([
      N("popupService")
    ], t.prototype, "popupService", void 0), _f([
      ke("eLabel")
    ], t.prototype, "eLabel", void 0), _f([
      ke("eWrapper")
    ], t.prototype, "eWrapper", void 0), _f([
      ke("eDisplayField")
    ], t.prototype, "eDisplayField", void 0), _f([
      ke("eIcon")
    ], t.prototype, "eIcon", void 0), t;
  }(r_)
), xz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Rz = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, AO = (
  /** @class */
  function(o) {
    xz(t, o);
    function t(e) {
      e === void 0 && (e = "default");
      var r = o.call(
        this,
        /* html */
        '<div class="ag-list ag-'.concat(e, '-list" role="listbox"></div>')
      ) || this;
      return r.cssIdentifier = e, r.options = [], r.itemEls = [], r;
    }
    return t.prototype.init = function() {
      this.addManagedListener(this.getGui(), "keydown", this.handleKeyDown.bind(this));
    }, t.prototype.handleKeyDown = function(e) {
      var r = e.key;
      switch (r) {
        case we.ENTER:
          if (!this.highlightedEl)
            this.setValue(this.getValue());
          else {
            var n = this.itemEls.indexOf(this.highlightedEl);
            this.setValueByIndex(n);
          }
          break;
        case we.DOWN:
        case we.UP:
          var i = r === we.DOWN, a = void 0;
          if (e.preventDefault(), !this.highlightedEl)
            a = this.itemEls[i ? 0 : this.itemEls.length - 1];
          else {
            var s = this.itemEls.indexOf(this.highlightedEl), l = s + (i ? 1 : -1);
            l = Math.min(Math.max(l, 0), this.itemEls.length - 1), a = this.itemEls[l];
          }
          this.highlightItem(a);
          break;
      }
    }, t.prototype.addOptions = function(e) {
      var r = this;
      return e.forEach(function(n) {
        return r.addOption(n);
      }), this;
    }, t.prototype.addOption = function(e) {
      var r = e.value, n = e.text, i = vn(n || r);
      return this.options.push({ value: r, text: i }), this.renderOption(r, i), this.updateIndices(), this;
    }, t.prototype.updateIndices = function() {
      var e = this.getGui().querySelectorAll(".ag-list-item");
      e.forEach(function(r, n) {
        M1(r, n + 1), A1(r, e.length);
      });
    }, t.prototype.renderOption = function(e, r) {
      var n = this, i = document.createElement("div");
      bn(i, "option"), i.classList.add("ag-list-item", "ag-".concat(this.cssIdentifier, "-list-item")), i.innerHTML = "<span>".concat(r, "</span>"), i.tabIndex = -1, this.itemEls.push(i), this.addManagedListener(i, "mouseover", function() {
        return n.highlightItem(i);
      }), this.addManagedListener(i, "mouseleave", function() {
        return n.clearHighlighted();
      }), this.addManagedListener(i, "click", function() {
        return n.setValue(e);
      }), this.getGui().appendChild(i);
    }, t.prototype.setValue = function(e, r) {
      if (this.value === e)
        return this.fireItemSelected(), this;
      if (e == null)
        return this.reset(), this;
      var n = this.options.findIndex(function(a) {
        return a.value === e;
      });
      if (n !== -1) {
        var i = this.options[n];
        this.value = i.value, this.displayValue = i.text != null ? i.text : i.value, this.highlightItem(this.itemEls[n]), r || this.fireChangeEvent();
      }
      return this;
    }, t.prototype.setValueByIndex = function(e) {
      return this.setValue(this.options[e].value);
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getDisplayValue = function() {
      return this.displayValue;
    }, t.prototype.refreshHighlighted = function() {
      var e = this;
      this.clearHighlighted();
      var r = this.options.findIndex(function(n) {
        return n.value === e.value;
      });
      r !== -1 && this.highlightItem(this.itemEls[r]);
    }, t.prototype.reset = function() {
      this.value = null, this.displayValue = null, this.clearHighlighted(), this.fireChangeEvent();
    }, t.prototype.highlightItem = function(e) {
      ai(e) && (this.clearHighlighted(), this.highlightedEl = e, this.highlightedEl.classList.add(t.ACTIVE_CLASS), lp(this.highlightedEl, !0), this.highlightedEl.focus());
    }, t.prototype.clearHighlighted = function() {
      !this.highlightedEl || !ai(this.highlightedEl) || (this.highlightedEl.classList.remove(t.ACTIVE_CLASS), lp(this.highlightedEl, !1), this.highlightedEl = null);
    }, t.prototype.fireChangeEvent = function() {
      this.dispatchEvent({ type: G.EVENT_FIELD_VALUE_CHANGED }), this.fireItemSelected();
    }, t.prototype.fireItemSelected = function() {
      this.dispatchEvent({ type: t.EVENT_ITEM_SELECTED });
    }, t.EVENT_ITEM_SELECTED = "selectedItem", t.ACTIVE_CLASS = "ag-active-item", Rz([
      Fe
    ], t.prototype, "init", null), t;
  }(gt)
), Tz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kS = function() {
  return kS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, kS.apply(this, arguments);
}, pv = (
  /** @class */
  function(o) {
    Tz(t, o);
    function t(e) {
      return o.call(this, kS({ pickerAriaLabelKey: "ariaLabelSelectField", pickerAriaLabelValue: "Select Field", pickerType: "ag-list", className: "ag-select", pickerIcon: "smallDown", ariaRole: "combobox" }, e)) || this;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.createListComponent(), this.eWrapper.tabIndex = this.gridOptionsService.get("tabIndex");
    }, t.prototype.createListComponent = function() {
      var e = this;
      this.listComponent = this.createBean(new AO("select")), this.listComponent.setParentComponent(this);
      var r = this.listComponent.getAriaElement(), n = "ag-select-list-".concat(this.listComponent.getCompId());
      r.setAttribute("id", n), L1(this.getAriaElement(), r), this.listComponent.addGuiEventListener("keydown", function(i) {
        i.key === we.TAB && (i.preventDefault(), i.stopImmediatePropagation(), e.getGui().dispatchEvent(new KeyboardEvent("keydown", {
          key: i.key,
          shiftKey: i.shiftKey,
          ctrlKey: i.ctrlKey,
          bubbles: !0
        })));
      }), this.listComponent.addManagedListener(this.listComponent, AO.EVENT_ITEM_SELECTED, function() {
        e.hidePicker(), e.dispatchEvent({ type: t.EVENT_ITEM_SELECTED });
      }), this.listComponent.addManagedListener(this.listComponent, G.EVENT_FIELD_VALUE_CHANGED, function() {
        e.listComponent && (e.setValue(e.listComponent.getValue(), !1, !0), e.hidePicker());
      });
    }, t.prototype.createPickerComponent = function() {
      return this.listComponent;
    }, t.prototype.showPicker = function() {
      this.listComponent && (o.prototype.showPicker.call(this), this.listComponent.refreshHighlighted());
    }, t.prototype.addOptions = function(e) {
      var r = this;
      return e.forEach(function(n) {
        return r.addOption(n);
      }), this;
    }, t.prototype.addOption = function(e) {
      return this.listComponent.addOption(e), this;
    }, t.prototype.setValue = function(e, r, n) {
      if (this.value === e || !this.listComponent)
        return this;
      n || this.listComponent.setValue(e, !0);
      var i = this.listComponent.getValue();
      return i === this.getValue() ? this : (this.eDisplayField.innerHTML = this.listComponent.getDisplayValue(), o.prototype.setValue.call(this, e, r));
    }, t.prototype.destroy = function() {
      this.listComponent && (this.destroyBean(this.listComponent), this.listComponent = void 0), o.prototype.destroy.call(this);
    }, t.EVENT_ITEM_SELECTED = "selectedItem", t;
  }(n_)
), Oz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Bw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Tl = (
  /** @class */
  function(o) {
    Oz(t, o);
    function t(e, r, n, i) {
      n === void 0 && (n = "text"), i === void 0 && (i = "input");
      var a = o.call(
        this,
        e,
        /* html */
        `
            <div role="presentation">
                <div ref="eLabel" class="ag-input-field-label"></div>
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <`.concat(i, ' ref="eInput" class="ag-input-field-input"></').concat(i, `>
                </div>
            </div>`),
        r
      ) || this;
      return a.inputType = n, a.displayFieldTag = i, a;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.setInputType(), this.eLabel.classList.add("".concat(this.className, "-label")), this.eWrapper.classList.add("".concat(this.className, "-input-wrapper")), this.eInput.classList.add("".concat(this.className, "-input")), this.addCssClass("ag-input-field"), this.eInput.id = this.eInput.id || "ag-".concat(this.getCompId(), "-input");
      var e = this.config, r = e.width, n = e.value;
      r != null && this.setWidth(r), n != null && this.setValue(n), this.addInputListeners(), this.activateTabIndex([this.eInput]);
    }, t.prototype.addInputListeners = function() {
      var e = this;
      this.addManagedListener(this.eInput, "input", function(r) {
        return e.setValue(r.target.value);
      });
    }, t.prototype.setInputType = function() {
      this.displayFieldTag === "input" && this.eInput.setAttribute("type", this.inputType);
    }, t.prototype.getInputElement = function() {
      return this.eInput;
    }, t.prototype.setInputWidth = function(e) {
      return Zh(this.eWrapper, e), this;
    }, t.prototype.setInputName = function(e) {
      return this.getInputElement().setAttribute("name", e), this;
    }, t.prototype.getFocusableElement = function() {
      return this.eInput;
    }, t.prototype.setMaxLength = function(e) {
      var r = this.eInput;
      return r.maxLength = e, this;
    }, t.prototype.setInputPlaceholder = function(e) {
      return La(this.eInput, "placeholder", e), this;
    }, t.prototype.setInputAriaLabel = function(e) {
      return Os(this.eInput, e), this.refreshAriaLabelledBy(), this;
    }, t.prototype.setDisabled = function(e) {
      return up(this.eInput, e), o.prototype.setDisabled.call(this, e);
    }, t.prototype.setAutoComplete = function(e) {
      if (e === !0)
        La(this.eInput, "autocomplete", null);
      else {
        var r = typeof e == "string" ? e : "off";
        La(this.eInput, "autocomplete", r);
      }
      return this;
    }, Bw([
      ke("eLabel")
    ], t.prototype, "eLabel", void 0), Bw([
      ke("eWrapper")
    ], t.prototype, "eWrapper", void 0), Bw([
      ke("eInput")
    ], t.prototype, "eInput", void 0), t;
  }(r_)
), Pz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fv = (
  /** @class */
  function(o) {
    Pz(t, o);
    function t(e, r, n) {
      r === void 0 && (r = "ag-checkbox"), n === void 0 && (n = "checkbox");
      var i = o.call(this, e, r, n) || this;
      return i.labelAlignment = "right", i.selected = !1, i.readOnly = !1, i.passive = !1, i;
    }
    return t.prototype.addInputListeners = function() {
      this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this)), this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
    }, t.prototype.getNextValue = function() {
      return this.selected === void 0 ? !0 : !this.selected;
    }, t.prototype.setPassive = function(e) {
      this.passive = e;
    }, t.prototype.isReadOnly = function() {
      return this.readOnly;
    }, t.prototype.setReadOnly = function(e) {
      this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
    }, t.prototype.setDisabled = function(e) {
      return this.eWrapper.classList.toggle("ag-disabled", e), o.prototype.setDisabled.call(this, e);
    }, t.prototype.toggle = function() {
      if (!this.eInput.disabled) {
        var e = this.isSelected(), r = this.getNextValue();
        this.passive ? this.dispatchChange(r, e) : this.setValue(r);
      }
    }, t.prototype.getValue = function() {
      return this.isSelected();
    }, t.prototype.setValue = function(e, r) {
      return this.refreshSelectedClass(e), this.setSelected(e, r), this;
    }, t.prototype.setName = function(e) {
      var r = this.getInputElement();
      return r.name = e, this;
    }, t.prototype.isSelected = function() {
      return this.selected;
    }, t.prototype.setSelected = function(e, r) {
      this.isSelected() !== e && (this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0, this.eInput.checked = e, this.eInput.indeterminate = e === void 0, r || this.dispatchChange(this.selected, this.previousValue));
    }, t.prototype.dispatchChange = function(e, r, n) {
      this.dispatchEvent({ type: G.EVENT_FIELD_VALUE_CHANGED, selected: e, previousValue: r, event: n });
      var i = this.getInputElement(), a = {
        type: G.EVENT_CHECKBOX_CHANGED,
        id: i.id,
        name: i.name,
        selected: e,
        previousValue: r
      };
      this.eventService.dispatchEvent(a);
    }, t.prototype.onCheckboxClick = function(e) {
      if (!(this.passive || this.eInput.disabled)) {
        var r = this.isSelected(), n = this.selected = e.target.checked;
        this.refreshSelectedClass(n), this.dispatchChange(n, r, e);
      }
    }, t.prototype.refreshSelectedClass = function(e) {
      this.eWrapper.classList.toggle("ag-checked", e === !0), this.eWrapper.classList.toggle("ag-indeterminate", e == null);
    }, t;
  }(Tl)
), Dz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), o_ = (
  /** @class */
  function(o) {
    Dz(t, o);
    function t(e) {
      return o.call(this, e, "ag-radio-button", "radio") || this;
    }
    return t.prototype.isSelected = function() {
      return this.eInput.checked;
    }, t.prototype.toggle = function() {
      this.eInput.disabled || this.isSelected() || this.setValue(!0);
    }, t.prototype.addInputListeners = function() {
      o.prototype.addInputListeners.call(this), this.addManagedListener(this.eventService, G.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
    }, t.prototype.onChange = function(e) {
      e.selected && e.name && this.eInput.name && this.eInput.name === e.name && e.id && this.eInput.id !== e.id && this.setValue(!1, !0);
    }, t;
  }(fv)
), Az = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Mz = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Fz = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, i_ = (
  /** @class */
  function() {
    function o(t, e, r) {
      this.localeService = t, this.optionsFactory = e, this.valueFormatter = r;
    }
    return o.prototype.getModelAsString = function(t) {
      var e = this;
      if (!t)
        return null;
      var r = t.operator != null, n = this.localeService.getLocaleTextFunc();
      if (r) {
        var i = t, a = i.conditions;
        if (!a) {
          var s = i.condition1, l = i.condition2;
          a = [s, l];
        }
        var u = a.map(function(S) {
          return e.getModelAsString(S);
        }), c = i.operator === "AND" ? "andCondition" : "orCondition";
        return u.join(" ".concat(n(c, nI[c]), " "));
      } else {
        if (t.type === Ir.BLANK || t.type === Ir.NOT_BLANK)
          return n(t.type, t.type);
        var d = t, f = this.optionsFactory.getCustomOption(d.type), v = f || {}, g = v.displayKey, m = v.displayName, b = v.numberOfInputs;
        return g && m && b === 0 ? (n(g, m), m) : this.conditionToString(d, f);
      }
    }, o.prototype.updateParams = function(t) {
      this.optionsFactory = t.optionsFactory;
    }, o.prototype.formatValue = function(t) {
      var e;
      return this.valueFormatter ? (e = this.valueFormatter(t ?? null)) !== null && e !== void 0 ? e : "" : String(t);
    }, o;
  }()
), Ir = (
  /** @class */
  function(o) {
    Az(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.eTypes = [], e.eJoinOperatorPanels = [], e.eJoinOperatorsAnd = [], e.eJoinOperatorsOr = [], e.eConditionBodies = [], e.listener = function() {
        return e.onUiChanged();
      }, e.lastUiCompletePosition = null, e.joinOperatorId = 0, e;
    }
    return t.prototype.getNumberOfInputs = function(e) {
      var r = this.optionsFactory.getCustomOption(e);
      if (r) {
        var n = r.numberOfInputs;
        return n ?? 1;
      }
      var i = [
        t.EMPTY,
        t.NOT_BLANK,
        t.BLANK
      ];
      return e && i.indexOf(e) >= 0 ? 0 : e === t.IN_RANGE ? 2 : 1;
    }, t.prototype.onFloatingFilterChanged = function(e, r) {
      this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(r), this.onUiChanged(!0);
    }, t.prototype.setTypeFromFloatingFilter = function(e) {
      var r = this;
      this.eTypes.forEach(function(n, i) {
        i === 0 ? n.setValue(e, !0) : n.setValue(r.optionsFactory.getDefaultOption(), !0);
      });
    }, t.prototype.getModelFromUi = function() {
      var e = this.getUiCompleteConditions();
      return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? {
        filterType: this.getFilterType(),
        operator: this.getJoinOperator(),
        condition1: e[0],
        condition2: e[1],
        conditions: e
      } : e[0];
    }, t.prototype.getConditionTypes = function() {
      return this.eTypes.map(function(e) {
        return e.getValue();
      });
    }, t.prototype.getConditionType = function(e) {
      return this.eTypes[e].getValue();
    }, t.prototype.getJoinOperator = function() {
      return this.eJoinOperatorsOr.length === 0 ? this.defaultJoinOperator : this.eJoinOperatorsOr[0].getValue() === !0 ? "OR" : "AND";
    }, t.prototype.areModelsEqual = function(e, r) {
      var n = this;
      if (!e && !r)
        return !0;
      if (!e && r || e && !r)
        return !1;
      var i = !e.operator, a = !r.operator, s = !i && a || i && !a;
      if (s)
        return !1;
      var l;
      if (i) {
        var u = e, c = r;
        l = this.areSimpleModelsEqual(u, c);
      } else {
        var d = e, f = r;
        l = d.operator === f.operator && ws(d.conditions, f.conditions, function(v, g) {
          return n.areSimpleModelsEqual(v, g);
        });
      }
      return l;
    }, t.prototype.shouldRefresh = function(e) {
      var r, n, i, a = this.getModel(), s = a ? (r = a.conditions) !== null && r !== void 0 ? r : [a] : null, l = (i = (n = e.filterOptions) === null || n === void 0 ? void 0 : n.map(function(c) {
        return typeof c == "string" ? c : c.displayKey;
      })) !== null && i !== void 0 ? i : this.getDefaultFilterOptions(), u = !s || s.every(function(c) {
        return l.find(function(d) {
          return d === c.type;
        }) !== void 0;
      });
      return !(!u || typeof e.maxNumConditions == "number" && s && s.length > e.maxNumConditions);
    }, t.prototype.refresh = function(e) {
      if (!this.shouldRefresh(e))
        return !1;
      var r = o.prototype.refresh.call(this, e);
      return r ? (this.setParams(e), this.removeConditionsAndOperators(0), this.createOption(), this.setModel(this.getModel()), !0) : !1;
    }, t.prototype.setModelIntoUi = function(e) {
      var r = this, n = e.operator;
      if (n) {
        var i = e;
        i.conditions || (i.conditions = [
          i.condition1,
          i.condition2
        ]);
        var a = this.validateAndUpdateConditions(i.conditions), s = this.getNumConditions();
        if (a < s)
          this.removeConditionsAndOperators(a);
        else if (a > s)
          for (var l = s; l < a; l++)
            this.createJoinOperatorPanel(), this.createOption();
        var u = i.operator === "OR";
        this.eJoinOperatorsAnd.forEach(function(d) {
          return d.setValue(!u, !0);
        }), this.eJoinOperatorsOr.forEach(function(d) {
          return d.setValue(u, !0);
        }), i.conditions.forEach(function(d, f) {
          r.eTypes[f].setValue(d.type, !0), r.setConditionIntoUi(d, f);
        });
      } else {
        var c = e;
        this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(c.type, !0), this.setConditionIntoUi(c, 0);
      }
      return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.onUiChanged(), Zi.resolve();
    }, t.prototype.validateAndUpdateConditions = function(e) {
      var r = e.length;
      return r > this.maxNumConditions && (e.splice(this.maxNumConditions), ht('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.'), r = this.maxNumConditions), r;
    }, t.prototype.doesFilterPass = function(e) {
      var r = this, n, i = this.getModel();
      if (i == null)
        return !0;
      var a = i.operator, s = [];
      if (a) {
        var l = i;
        s.push.apply(s, Fz([], Mz((n = l.conditions) !== null && n !== void 0 ? n : []), !1));
      } else
        s.push(i);
      var u = a && a === "OR" ? "some" : "every";
      return s[u](function(c) {
        return r.individualConditionPasses(e, c);
      });
    }, t.prototype.setParams = function(e) {
      o.prototype.setParams.call(this, e), this.setNumConditions(e), this.defaultJoinOperator = this.getDefaultJoinOperator(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.optionsFactory = new rI(), this.optionsFactory.init(e, this.getDefaultFilterOptions()), this.createFilterListOptions(), this.createOption(), this.createMissingConditionsAndOperators(), this.isReadOnly() && this.eFilterBody.setAttribute("tabindex", "-1");
    }, t.prototype.setNumConditions = function(e) {
      var r, n;
      e.suppressAndOrCondition != null && ht('Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.'), e.alwaysShowBothConditions != null && ht('Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.'), this.maxNumConditions = (r = e.maxNumConditions) !== null && r !== void 0 ? r : e.suppressAndOrCondition ? 1 : 2, this.maxNumConditions < 1 && (ht('"filterParams.maxNumConditions" must be greater than or equal to zero.'), this.maxNumConditions = 1), this.numAlwaysVisibleConditions = (n = e.numAlwaysVisibleConditions) !== null && n !== void 0 ? n : e.alwaysShowBothConditions ? 2 : 1, this.numAlwaysVisibleConditions < 1 && (ht('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.'), this.numAlwaysVisibleConditions = 1), this.numAlwaysVisibleConditions > this.maxNumConditions && (ht('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".'), this.numAlwaysVisibleConditions = this.maxNumConditions);
    }, t.prototype.createOption = function() {
      var e = this, r = this.createManagedBean(new pv());
      this.eTypes.push(r), r.addCssClass("ag-filter-select"), this.eFilterBody.appendChild(r.getGui());
      var n = this.createValueElement();
      this.eConditionBodies.push(n), this.eFilterBody.appendChild(n), this.putOptionsIntoDropdown(r), this.resetType(r);
      var i = this.getNumConditions() - 1;
      this.forEachPositionInput(i, function(a) {
        return e.resetInput(a);
      }), this.addChangedListeners(r, i);
    }, t.prototype.createJoinOperatorPanel = function() {
      var e = document.createElement("div");
      this.eJoinOperatorPanels.push(e), e.classList.add("ag-filter-condition");
      var r = this.createJoinOperator(this.eJoinOperatorsAnd, e, "and"), n = this.createJoinOperator(this.eJoinOperatorsOr, e, "or");
      this.eFilterBody.appendChild(e);
      var i = this.eJoinOperatorPanels.length - 1, a = this.joinOperatorId++;
      this.resetJoinOperatorAnd(r, i, a), this.resetJoinOperatorOr(n, i, a), this.isReadOnly() || (r.onValueChange(this.listener), n.onValueChange(this.listener));
    }, t.prototype.createJoinOperator = function(e, r, n) {
      var i = this.createManagedBean(new o_());
      return e.push(i), i.addCssClass("ag-filter-condition-operator"), i.addCssClass("ag-filter-condition-operator-".concat(n)), r.appendChild(i.getGui()), i;
    }, t.prototype.getDefaultJoinOperator = function(e) {
      return e === "AND" || e === "OR" ? e : "AND";
    }, t.prototype.createFilterListOptions = function() {
      var e = this, r = this.optionsFactory.getFilterOptions();
      this.filterListOptions = r.map(function(n) {
        return typeof n == "string" ? e.createBoilerplateListOption(n) : e.createCustomListOption(n);
      });
    }, t.prototype.putOptionsIntoDropdown = function(e) {
      this.filterListOptions.forEach(function(r) {
        e.addOption(r);
      }), e.setDisabled(this.filterListOptions.length <= 1);
    }, t.prototype.createBoilerplateListOption = function(e) {
      return { value: e, text: this.translate(e) };
    }, t.prototype.createCustomListOption = function(e) {
      var r = e.displayKey, n = this.optionsFactory.getCustomOption(e.displayKey);
      return {
        value: r,
        text: n ? this.localeService.getLocaleTextFunc()(n.displayKey, n.displayName) : this.translate(r)
      };
    }, t.prototype.isAllowTwoConditions = function() {
      return this.maxNumConditions >= 2;
    }, t.prototype.createBodyTemplate = function() {
      return "";
    }, t.prototype.getCssIdentifier = function() {
      return "simple-filter";
    }, t.prototype.updateUiVisibility = function() {
      var e = this.getJoinOperator();
      this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
    }, t.prototype.updateNumConditions = function() {
      for (var e, r = -1, n = !0, i = 0; i < this.getNumConditions(); i++)
        this.isConditionUiComplete(i) ? r = i : n = !1;
      if (this.shouldAddNewConditionAtEnd(n))
        this.createJoinOperatorPanel(), this.createOption();
      else {
        var a = (e = this.lastUiCompletePosition) !== null && e !== void 0 ? e : this.getNumConditions() - 2;
        if (r < a) {
          this.removeConditionsAndOperators(a + 1);
          var s = r + 1, l = a - s;
          l > 0 && this.removeConditionsAndOperators(s, l), this.createMissingConditionsAndOperators();
        }
      }
      this.lastUiCompletePosition = r;
    }, t.prototype.updateConditionStatusesAndValues = function(e, r) {
      var n = this;
      this.eTypes.forEach(function(a, s) {
        var l = n.isConditionDisabled(s, e);
        a.setDisabled(l || n.filterListOptions.length <= 1), s === 1 && (up(n.eJoinOperatorPanels[0], l), n.eJoinOperatorsAnd[0].setDisabled(l), n.eJoinOperatorsOr[0].setDisabled(l));
      }), this.eConditionBodies.forEach(function(a, s) {
        Vt(a, n.isConditionBodyVisible(s));
      });
      var i = (r ?? this.getJoinOperator()) === "OR";
      this.eJoinOperatorsAnd.forEach(function(a, s) {
        a.setValue(!i, !0);
      }), this.eJoinOperatorsOr.forEach(function(a, s) {
        a.setValue(i, !0);
      }), this.forEachInput(function(a, s, l, u) {
        n.setElementDisplayed(a, s < u), n.setElementDisabled(a, n.isConditionDisabled(l, e));
      }), this.resetPlaceholder();
    }, t.prototype.shouldAddNewConditionAtEnd = function(e) {
      return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }, t.prototype.removeConditionsAndOperators = function(e, r) {
      if (!(e >= this.getNumConditions())) {
        this.removeComponents(this.eTypes, e, r), this.removeElements(this.eConditionBodies, e, r), this.removeValueElements(e, r);
        var n = Math.max(e - 1, 0);
        this.removeElements(this.eJoinOperatorPanels, n, r), this.removeComponents(this.eJoinOperatorsAnd, n, r), this.removeComponents(this.eJoinOperatorsOr, n, r);
      }
    }, t.prototype.removeElements = function(e, r, n) {
      var i = this.removeItems(e, r, n);
      i.forEach(function(a) {
        return bs(a);
      });
    }, t.prototype.removeComponents = function(e, r, n) {
      var i = this, a = this.removeItems(e, r, n);
      a.forEach(function(s) {
        bs(s.getGui()), i.destroyBean(s);
      });
    }, t.prototype.removeItems = function(e, r, n) {
      return n == null ? e.splice(r) : e.splice(r, n);
    }, t.prototype.afterGuiAttached = function(e) {
      if (o.prototype.afterGuiAttached.call(this, e), this.resetPlaceholder(), !(e != null && e.suppressFocus))
        if (this.isReadOnly())
          this.eFilterBody.focus();
        else {
          var r = this.getInputs(0)[0];
          if (!r)
            return;
          r instanceof Tl && r.getInputElement().focus();
        }
    }, t.prototype.afterGuiDetached = function() {
      o.prototype.afterGuiDetached.call(this);
      var e = this.getModel();
      this.resetUiToActiveModel(e);
      for (var r = -1, n = -1, i = !1, a = this.getJoinOperator(), s = this.getNumConditions() - 1; s >= 0; s--)
        if (this.isConditionUiComplete(s))
          r === -1 && (r = s, n = s);
        else {
          var l = s >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(s - 1), u = s < r;
          (l || u) && (this.removeConditionsAndOperators(s, 1), i = !0, u && n--);
        }
      var c = !1;
      this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), c = !0), this.shouldAddNewConditionAtEnd(n === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), c = !0), c && this.updateConditionStatusesAndValues(n, a), i && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = n;
    }, t.prototype.getPlaceholderText = function(e, r) {
      var n = this.translate(e);
      if (Zy(this.filterPlaceholder)) {
        var i = this.filterPlaceholder, a = this.eTypes[r].getValue(), s = this.translate(a);
        n = i({
          filterOptionKey: a,
          filterOption: s,
          placeholder: n
        });
      } else typeof this.filterPlaceholder == "string" && (n = this.filterPlaceholder);
      return n;
    }, t.prototype.resetPlaceholder = function() {
      var e = this, r = this.localeService.getLocaleTextFunc();
      this.forEachInput(function(n, i, a, s) {
        if (n instanceof Tl) {
          var l = i === 0 && s > 1 ? "inRangeStart" : i === 0 ? "filterOoo" : "inRangeEnd", u = i === 0 && s > 1 ? r("ariaFilterFromValue", "Filter from value") : i === 0 ? r("ariaFilterValue", "Filter Value") : r("ariaFilterToValue", "Filter to Value");
          n.setInputPlaceholder(e.getPlaceholderText(l, a)), n.setInputAriaLabel(u);
        }
      });
    }, t.prototype.setElementValue = function(e, r, n) {
      e instanceof Tl && e.setValue(r != null ? String(r) : null, !0);
    }, t.prototype.setElementDisplayed = function(e, r) {
      e instanceof gt && Vt(e.getGui(), r);
    }, t.prototype.setElementDisabled = function(e, r) {
      e instanceof gt && up(e.getGui(), r);
    }, t.prototype.attachElementOnChange = function(e, r) {
      e instanceof Tl && e.onValueChange(r);
    }, t.prototype.forEachInput = function(e) {
      var r = this;
      this.getConditionTypes().forEach(function(n, i) {
        r.forEachPositionTypeInput(i, n, e);
      });
    }, t.prototype.forEachPositionInput = function(e, r) {
      var n = this.getConditionType(e);
      this.forEachPositionTypeInput(e, n, r);
    }, t.prototype.forEachPositionTypeInput = function(e, r, n) {
      for (var i = this.getNumberOfInputs(r), a = this.getInputs(e), s = 0; s < a.length; s++) {
        var l = a[s];
        l != null && n(l, s, e, i);
      }
    }, t.prototype.isConditionDisabled = function(e, r) {
      return this.isReadOnly() ? !0 : e === 0 ? !1 : e > r + 1;
    }, t.prototype.isConditionBodyVisible = function(e) {
      var r = this.getConditionType(e), n = this.getNumberOfInputs(r);
      return n > 0;
    }, t.prototype.isConditionUiComplete = function(e) {
      if (e >= this.getNumConditions())
        return !1;
      var r = this.getConditionType(e);
      return !(r === t.EMPTY || this.getValues(e).some(function(n) {
        return n == null;
      }));
    }, t.prototype.getNumConditions = function() {
      return this.eTypes.length;
    }, t.prototype.getUiCompleteConditions = function() {
      for (var e = [], r = 0; r < this.getNumConditions(); r++)
        this.isConditionUiComplete(r) && e.push(this.createCondition(r));
      return e;
    }, t.prototype.createMissingConditionsAndOperators = function() {
      if (!this.isReadOnly())
        for (var e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
          this.createJoinOperatorPanel(), this.createOption();
    }, t.prototype.resetUiToDefaults = function(e) {
      var r = this;
      return this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach(function(n) {
        return r.resetType(n);
      }), this.eJoinOperatorsAnd.forEach(function(n, i) {
        return r.resetJoinOperatorAnd(n, i, r.joinOperatorId + i);
      }), this.eJoinOperatorsOr.forEach(function(n, i) {
        return r.resetJoinOperatorOr(n, i, r.joinOperatorId + i);
      }), this.joinOperatorId++, this.forEachInput(function(n) {
        return r.resetInput(n);
      }), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, e || this.onUiChanged(), Zi.resolve();
    }, t.prototype.resetType = function(e) {
      var r = this.localeService.getLocaleTextFunc(), n = r("ariaFilteringOperator", "Filtering operator");
      e.setValue(this.optionsFactory.getDefaultOption(), !0).setAriaLabel(n).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }, t.prototype.resetJoinOperatorAnd = function(e, r, n) {
      this.resetJoinOperator(e, r, this.isDefaultOperator("AND"), this.translate("andCondition"), n);
    }, t.prototype.resetJoinOperatorOr = function(e, r, n) {
      this.resetJoinOperator(e, r, this.isDefaultOperator("OR"), this.translate("orCondition"), n);
    }, t.prototype.resetJoinOperator = function(e, r, n, i, a) {
      this.updateJoinOperatorDisabled(e.setValue(n, !0).setName("ag-simple-filter-and-or-".concat(this.getCompId(), "-").concat(a)).setLabel(i), r);
    }, t.prototype.updateJoinOperatorsDisabled = function() {
      var e = this;
      this.eJoinOperatorsAnd.forEach(function(r, n) {
        return e.updateJoinOperatorDisabled(r, n);
      }), this.eJoinOperatorsOr.forEach(function(r, n) {
        return e.updateJoinOperatorDisabled(r, n);
      });
    }, t.prototype.updateJoinOperatorDisabled = function(e, r) {
      e.setDisabled(this.isReadOnly() || r > 0);
    }, t.prototype.resetInput = function(e) {
      this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
    }, t.prototype.setConditionIntoUi = function(e, r) {
      var n = this, i = this.mapValuesFromModel(e);
      this.forEachInput(function(a, s, l, u) {
        l === r && n.setElementValue(a, i[s] != null ? i[s] : null);
      });
    }, t.prototype.setValueFromFloatingFilter = function(e) {
      var r = this;
      this.forEachInput(function(n, i, a, s) {
        r.setElementValue(n, i === 0 && a === 0 ? e : null, !0);
      });
    }, t.prototype.isDefaultOperator = function(e) {
      return e === this.defaultJoinOperator;
    }, t.prototype.addChangedListeners = function(e, r) {
      var n = this;
      this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(r, function(i) {
        n.attachElementOnChange(i, n.listener);
      }));
    }, t.prototype.individualConditionPasses = function(e, r) {
      var n = this.getCellValue(e.node), i = this.mapValuesFromModel(r), a = this.optionsFactory.getCustomOption(r.type), s = this.evaluateCustomFilter(a, i, n);
      return s ?? (n == null ? this.evaluateNullValue(r.type) : this.evaluateNonNullValue(i, n, r, e));
    }, t.prototype.evaluateCustomFilter = function(e, r, n) {
      if (e != null) {
        var i = e.predicate;
        if (i != null && !r.some(function(a) {
          return a == null;
        }))
          return i(r, n);
      }
    }, t.prototype.isBlank = function(e) {
      return e == null || typeof e == "string" && e.trim().length === 0;
    }, t.prototype.hasInvalidInputs = function() {
      return !1;
    }, t.EMPTY = "empty", t.BLANK = "blank", t.NOT_BLANK = "notBlank", t.EQUALS = "equals", t.NOT_EQUAL = "notEqual", t.LESS_THAN = "lessThan", t.LESS_THAN_OR_EQUAL = "lessThanOrEqual", t.GREATER_THAN = "greaterThan", t.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual", t.IN_RANGE = "inRange", t.CONTAINS = "contains", t.NOT_CONTAINS = "notContains", t.STARTS_WITH = "startsWith", t.ENDS_WITH = "endsWith", t;
  }(Qh)
), Iz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tn = (
  /** @class */
  function(o) {
    Iz(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setParams = function(e) {
      o.prototype.setParams.call(this, e), this.scalarFilterParams = e;
    }, t.prototype.evaluateNullValue = function(e) {
      switch (e) {
        case t.EQUALS:
        case t.NOT_EQUAL:
          if (this.scalarFilterParams.includeBlanksInEquals)
            return !0;
          break;
        case t.GREATER_THAN:
        case t.GREATER_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInGreaterThan)
            return !0;
          break;
        case t.LESS_THAN:
        case t.LESS_THAN_OR_EQUAL:
          if (this.scalarFilterParams.includeBlanksInLessThan)
            return !0;
          break;
        case t.IN_RANGE:
          if (this.scalarFilterParams.includeBlanksInRange)
            return !0;
          break;
        case t.BLANK:
          return !0;
        case t.NOT_BLANK:
          return !1;
      }
      return !1;
    }, t.prototype.evaluateNonNullValue = function(e, r, n) {
      var i = this.comparator(), a = e[0] != null ? i(e[0], r) : 0;
      switch (n.type) {
        case t.EQUALS:
          return a === 0;
        case t.NOT_EQUAL:
          return a !== 0;
        case t.GREATER_THAN:
          return a > 0;
        case t.GREATER_THAN_OR_EQUAL:
          return a >= 0;
        case t.LESS_THAN:
          return a < 0;
        case t.LESS_THAN_OR_EQUAL:
          return a <= 0;
        case t.IN_RANGE: {
          var s = i(e[1], r);
          return this.scalarFilterParams.inRangeInclusive ? a >= 0 && s <= 0 : a > 0 && s < 0;
        }
        case t.BLANK:
          return this.isBlank(r);
        case t.NOT_BLANK:
          return !this.isBlank(r);
        default:
          return console.warn('AG Grid: Unexpected type of filter "' + n.type + '", it looks like the filter was configured with incorrect Filter Options'), !0;
      }
    }, t;
  }(Ir)
), iI = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), GS = function() {
  return GS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, GS.apply(this, arguments);
}, Lz = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, MO = 1e3, FO = 1 / 0, aI = (
  /** @class */
  function(o) {
    iI(t, o);
    function t(e, r, n) {
      var i = o.call(this, r, n) || this;
      return i.dateFilterParams = e, i;
    }
    return t.prototype.conditionToString = function(e, r) {
      var n = e.type, i = (r || {}).numberOfInputs, a = n == Ir.IN_RANGE || i === 2, s = ko(e.dateFrom), l = ko(e.dateTo), u = this.dateFilterParams.inRangeFloatingFilterDateFormat;
      if (a) {
        var c = s !== null ? Zd(s, u) : "null", d = l !== null ? Zd(l, u) : "null";
        return "".concat(c, "-").concat(d);
      }
      return s != null ? Zd(s, u) : "".concat(n);
    }, t.prototype.updateParams = function(e) {
      o.prototype.updateParams.call(this, e), this.dateFilterParams = e.dateFilterParams;
    }, t;
  }(i_)
), a_ = (
  /** @class */
  function(o) {
    iI(t, o);
    function t() {
      var e = o.call(this, "dateFilter") || this;
      return e.eConditionPanelsFrom = [], e.eConditionPanelsTo = [], e.dateConditionFromComps = [], e.dateConditionToComps = [], e.minValidYear = MO, e.maxValidYear = FO, e.minValidDate = null, e.maxValidDate = null, e;
    }
    return t.prototype.afterGuiAttached = function(e) {
      o.prototype.afterGuiAttached.call(this, e), this.dateConditionFromComps[0].afterGuiAttached(e);
    }, t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, n = r.dateFrom, i = r.dateTo, a = r.type;
      return [
        n && ko(n) || null,
        i && ko(i) || null
      ].slice(0, this.getNumberOfInputs(a));
    }, t.prototype.comparator = function() {
      return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
    }, t.prototype.defaultComparator = function(e, r) {
      var n = r;
      return r == null || n < e ? -1 : n > e ? 1 : 0;
    }, t.prototype.setParams = function(e) {
      this.dateFilterParams = e, o.prototype.setParams.call(this, e);
      var r = function(n, i) {
        if (e[n] != null)
          if (isNaN(e[n]))
            console.warn("AG Grid: DateFilter ".concat(n, " is not a number"));
          else
            return e[n] == null ? i : Number(e[n]);
        return i;
      };
      this.minValidYear = r("minValidYear", MO), this.maxValidYear = r("maxValidYear", FO), this.minValidYear > this.maxValidYear && console.warn("AG Grid: DateFilter minValidYear should be <= maxValidYear"), e.minValidDate ? this.minValidDate = e.minValidDate instanceof Date ? e.minValidDate : ko(e.minValidDate) : this.minValidDate = null, e.maxValidDate ? this.maxValidDate = e.maxValidDate instanceof Date ? e.maxValidDate : ko(e.maxValidDate) : this.maxValidDate = null, this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate && console.warn("AG Grid: DateFilter minValidDate should be <= maxValidDate"), this.filterModelFormatter = new aI(this.dateFilterParams, this.localeService, this.optionsFactory);
    }, t.prototype.createDateCompWrapper = function(e) {
      var r = this, n = new tI(this.getContext(), this.userComponentFactory, {
        onDateChanged: function() {
          return r.onUiChanged();
        },
        filterParams: this.dateFilterParams
      }, e);
      return this.addDestroyFunc(function() {
        return n.destroy();
      }), n;
    }, t.prototype.setElementValue = function(e, r) {
      e.setDate(r);
    }, t.prototype.setElementDisplayed = function(e, r) {
      e.setDisplayed(r);
    }, t.prototype.setElementDisabled = function(e, r) {
      e.setDisabled(r);
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.createValueElement = function() {
      var e = document.createElement("div");
      return e.classList.add("ag-filter-body"), this.createFromToElement(e, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(e, this.eConditionPanelsTo, this.dateConditionToComps, "to"), e;
    }, t.prototype.createFromToElement = function(e, r, n, i) {
      var a = document.createElement("div");
      a.classList.add("ag-filter-".concat(i)), a.classList.add("ag-filter-date-".concat(i)), r.push(a), e.appendChild(a), n.push(this.createDateCompWrapper(a));
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeDateComps(this.dateConditionFromComps, e, r), this.removeDateComps(this.dateConditionToComps, e, r), this.removeItems(this.eConditionPanelsFrom, e, r), this.removeItems(this.eConditionPanelsTo, e, r);
    }, t.prototype.removeDateComps = function(e, r, n) {
      var i = this.removeItems(e, r, n);
      i.forEach(function(a) {
        return a.destroy();
      });
    }, t.prototype.isValidDateValue = function(e) {
      if (e === null)
        return !1;
      if (this.minValidDate) {
        if (e < this.minValidDate)
          return !1;
      } else if (e.getUTCFullYear() < this.minValidYear)
        return !1;
      if (this.maxValidDate) {
        if (e > this.maxValidDate)
          return !1;
      } else if (e.getUTCFullYear() > this.maxValidYear)
        return !1;
      return !0;
    }, t.prototype.isConditionUiComplete = function(e) {
      var r = this;
      if (!o.prototype.isConditionUiComplete.call(this, e))
        return !1;
      var n = !0;
      return this.forEachInput(function(i, a, s, l) {
        s !== e || !n || a >= l || (n = n && r.isValidDateValue(i.getDate()));
      }), n;
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.dateFrom === r.dateFrom && e.dateTo === r.dateTo && e.type === r.type;
    }, t.prototype.getFilterType = function() {
      return "date";
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), n = {}, i = this.getValues(e);
      return i.length > 0 && (n.dateFrom = Pi(i[0])), i.length > 1 && (n.dateTo = Pi(i[1])), GS({ dateFrom: null, dateTo: null, filterType: this.getFilterType(), type: r }, n);
    }, t.prototype.resetPlaceholder = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.translate("dateFormatOoo"), n = e("ariaFilterValue", "Filter Value");
      this.forEachInput(function(i) {
        i.setInputPlaceholder(r), i.setInputAriaLabel(n);
      });
    }, t.prototype.getInputs = function(e) {
      return e >= this.dateConditionFromComps.length ? [null, null] : [this.dateConditionFromComps[e], this.dateConditionToComps[e]];
    }, t.prototype.getValues = function(e) {
      var r = [];
      return this.forEachPositionInput(e, function(n, i, a, s) {
        i < s && r.push(n.getDate());
      }), r;
    }, t.prototype.translate = function(e) {
      return e === tn.LESS_THAN ? o.prototype.translate.call(this, "before") : e === tn.GREATER_THAN ? o.prototype.translate.call(this, "after") : o.prototype.translate.call(this, e);
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.DEFAULT_FILTER_OPTIONS = [
      tn.EQUALS,
      tn.NOT_EQUAL,
      tn.LESS_THAN,
      tn.GREATER_THAN,
      tn.IN_RANGE,
      tn.BLANK,
      tn.NOT_BLANK
    ], Lz([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), t;
  }(tn)
), Nz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), sI = (
  /** @class */
  function(o) {
    Nz(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getDefaultDebounceMs = function() {
      return 0;
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.isEventFromFloatingFilter = function(e) {
      return e && e.afterFloatingFilter;
    }, t.prototype.isEventFromDataChange = function(e) {
      return e == null ? void 0 : e.afterDataChange;
    }, t.prototype.getLastType = function() {
      return this.lastType;
    }, t.prototype.isReadOnly = function() {
      return this.readOnly;
    }, t.prototype.setLastTypeFromModel = function(e) {
      if (!e) {
        this.lastType = this.optionsFactory.getDefaultOption();
        return;
      }
      var r = e.operator, n;
      if (r) {
        var i = e;
        n = i.conditions[0];
      } else
        n = e;
      this.lastType = n.type;
    }, t.prototype.canWeEditAfterModelFromParentFilter = function(e) {
      if (!e)
        return this.isTypeEditable(this.lastType);
      var r = e.operator;
      if (r)
        return !1;
      var n = e;
      return this.isTypeEditable(n.type);
    }, t.prototype.init = function(e) {
      this.setSimpleParams(e, !1);
    }, t.prototype.setSimpleParams = function(e, r) {
      r === void 0 && (r = !0), this.optionsFactory = new rI(), this.optionsFactory.init(e.filterParams, this.getDefaultFilterOptions()), r || (this.lastType = this.optionsFactory.getDefaultOption()), this.readOnly = !!e.filterParams.readOnly;
      var n = this.isTypeEditable(this.lastType);
      this.setEditable(n);
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      this.setSimpleParams(e);
    }, t.prototype.doesFilterHaveSingleInput = function(e) {
      var r = this.optionsFactory.getCustomOption(e), n = (r || {}).numberOfInputs;
      return n == null || n == 1;
    }, t.prototype.isTypeEditable = function(e) {
      var r = [
        Ir.IN_RANGE,
        Ir.EMPTY,
        Ir.BLANK,
        Ir.NOT_BLANK
      ];
      return !!e && !this.isReadOnly() && this.doesFilterHaveSingleInput(e) && r.indexOf(e) < 0;
    }, t;
  }(gt)
), kz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ww = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Gz = (
  /** @class */
  function(o) {
    kz(t, o);
    function t() {
      return o.call(
        this,
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eReadOnlyText"></ag-input-text-field>
                <div ref="eDateWrapper" style="display: flex;"></div>
            </div>`
      ) || this;
    }
    return t.prototype.getDefaultFilterOptions = function() {
      return a_.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.init = function(e) {
      o.prototype.init.call(this, e), this.params = e, this.filterParams = e.filterParams, this.createDateComponent(), this.filterModelFormatter = new aI(this.filterParams, this.localeService, this.optionsFactory);
      var r = this.localeService.getLocaleTextFunc();
      this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(r("ariaDateFilterInput", "Date Filter Input"));
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      o.prototype.refresh.call(this, e), this.params = e, this.filterParams = e.filterParams, this.updateDateComponent(), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory, dateFilterParams: this.filterParams }), this.updateCompOnModelChange(e.currentParentModel());
    }, t.prototype.updateCompOnModelChange = function(e) {
      var r = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(e);
      if (this.setEditable(r), r) {
        if (e) {
          var n = e;
          this.dateComp.setDate(ko(n.dateFrom));
        } else
          this.dateComp.setDate(null);
        this.eReadOnlyText.setValue("");
      } else
        this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
    }, t.prototype.setEditable = function(e) {
      Vt(this.eDateWrapper, e), Vt(this.eReadOnlyText.getGui(), !e);
    }, t.prototype.onParentModelChanged = function(e, r) {
      this.isEventFromFloatingFilter(r) || this.isEventFromDataChange(r) || (o.prototype.setLastTypeFromModel.call(this, e), this.updateCompOnModelChange(e));
    }, t.prototype.onDateChanged = function() {
      var e = this, r = this.dateComp.getDate(), n = Pi(r);
      this.params.parentFilterInstance(function(i) {
        if (i) {
          var a = ko(n);
          i.onFloatingFilterChanged(e.getLastType() || null, a);
        }
      });
    }, t.prototype.getDateComponentParams = function() {
      var e = Qh.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
      return {
        onDateChanged: Oi(this.onDateChanged.bind(this), e),
        filterParams: this.params.column.getColDef().filterParams
      };
    }, t.prototype.createDateComponent = function() {
      var e = this;
      this.dateComp = new tI(this.getContext(), this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper), this.addDestroyFunc(function() {
        return e.dateComp.destroy();
      });
    }, t.prototype.updateDateComponent = function() {
      var e = this.gridOptionsService.addGridCommonParams(this.getDateComponentParams());
      this.dateComp.updateParams(e);
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, Ww([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), Ww([
      ke("eReadOnlyText")
    ], t.prototype, "eReadOnlyText", void 0), Ww([
      ke("eDateWrapper")
    ], t.prototype, "eDateWrapper", void 0), t;
  }(sI)
), Vz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hz = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Bz = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Wz = (
  /** @class */
  function(o) {
    Vz(t, o);
    function t() {
      return o.call(
        this,
        /* html */
        `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" ref="eDateInput"></ag-input-text-field>
            </div>`
      ) || this;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r = this;
      this.params = e, this.setParams(e);
      var n = this.gridOptionsService.getDocument(), i = this.eDateInput.getInputElement();
      this.addManagedListener(i, "mousedown", function() {
        r.eDateInput.isDisabled() || r.usingSafariDatePicker || i.focus();
      }), this.addManagedListener(i, "input", function(a) {
        a.target === n.activeElement && (r.eDateInput.isDisabled() || r.params.onDateChanged());
      });
    }, t.prototype.setParams = function(e) {
      var r = this.eDateInput.getInputElement(), n = this.shouldUseBrowserDatePicker(e);
      this.usingSafariDatePicker = n && oa(), r.type = n ? "date" : "text";
      var i = e.filterParams || {}, a = i.minValidYear, s = i.maxValidYear, l = i.minValidDate, u = i.maxValidDate;
      if (l && a && ht("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored."), u && s && ht("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored."), l && u) {
        var c = Bz([l, u].map(function(v) {
          return v instanceof Date ? v : ko(v);
        }), 2), d = c[0], f = c[1];
        d && f && d.getTime() > f.getTime() && ht("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
      }
      l ? l instanceof Date ? r.min = Zd(l) : r.min = l : a && (r.min = "".concat(a, "-01-01")), u ? u instanceof Date ? r.max = Zd(u) : r.max = u : s && (r.max = "".concat(s, "-12-31"));
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      this.params = e, this.setParams(e);
    }, t.prototype.getDate = function() {
      return ko(this.eDateInput.getValue());
    }, t.prototype.setDate = function(e) {
      this.eDateInput.setValue(Pi(e, !1));
    }, t.prototype.setInputPlaceholder = function(e) {
      this.eDateInput.setInputPlaceholder(e);
    }, t.prototype.setDisabled = function(e) {
      this.eDateInput.setDisabled(e);
    }, t.prototype.afterGuiAttached = function(e) {
      (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus();
    }, t.prototype.shouldUseBrowserDatePicker = function(e) {
      return e.filterParams && e.filterParams.browserDatePicker != null ? e.filterParams.browserDatePicker : eC() || k1() || oa() && N1() >= 14.1;
    }, Hz([
      ke("eDateInput")
    ], t.prototype, "eDateInput", void 0), t;
  }(gt)
), jz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zl = (
  /** @class */
  function(o) {
    jz(t, o);
    function t(e, r, n) {
      return r === void 0 && (r = "ag-text-field"), n === void 0 && (n = "text"), o.call(this, e, r, n) || this;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.config.allowedCharPattern && this.preventDisallowedCharacters();
    }, t.prototype.setValue = function(e, r) {
      return this.eInput.value !== e && (this.eInput.value = Oe(e) ? e : ""), o.prototype.setValue.call(this, e, r);
    }, t.prototype.setStartValue = function(e) {
      this.setValue(e, !0);
    }, t.prototype.preventDisallowedCharacters = function() {
      var e = new RegExp("[".concat(this.config.allowedCharPattern, "]")), r = function(n) {
        rC(n) && n.key && !e.test(n.key) && n.preventDefault();
      };
      this.addManagedListener(this.eInput, "keydown", r), this.addManagedListener(this.eInput, "paste", function(n) {
        var i, a = (i = n.clipboardData) === null || i === void 0 ? void 0 : i.getData("text");
        a && a.split("").some(function(s) {
          return !e.test(s);
        }) && n.preventDefault();
      });
    }, t;
  }(Tl)
), Uz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), oC = (
  /** @class */
  function(o) {
    Uz(t, o);
    function t(e) {
      return o.call(this, e, "ag-number-field", "number") || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      o.prototype.postConstruct.call(this), this.addManagedListener(this.eInput, "blur", function() {
        var r = parseFloat(e.eInput.value), n = isNaN(r) ? "" : e.normalizeValue(r.toString());
        e.value !== n && e.setValue(n);
      }), this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this)), this.eInput.step = "any";
    }, t.prototype.onWheel = function(e) {
      document.activeElement === this.eInput && e.preventDefault();
    }, t.prototype.normalizeValue = function(e) {
      if (e === "")
        return "";
      this.precision != null && (e = this.adjustPrecision(e));
      var r = parseFloat(e);
      return this.min != null && r < this.min ? e = this.min.toString() : this.max != null && r > this.max && (e = this.max.toString()), e;
    }, t.prototype.adjustPrecision = function(e, r) {
      if (this.precision == null)
        return e;
      if (r) {
        var n = parseFloat(e).toFixed(this.precision);
        return parseFloat(n).toString();
      }
      var i = String(e).split(".");
      if (i.length > 1) {
        if (i[1].length <= this.precision)
          return e;
        if (this.precision > 0)
          return "".concat(i[0], ".").concat(i[1].slice(0, this.precision));
      }
      return i[0];
    }, t.prototype.setMin = function(e) {
      return this.min === e ? this : (this.min = e, La(this.eInput, "min", e), this);
    }, t.prototype.setMax = function(e) {
      return this.max === e ? this : (this.max = e, La(this.eInput, "max", e), this);
    }, t.prototype.setPrecision = function(e) {
      return this.precision = e, this;
    }, t.prototype.setStep = function(e) {
      return this.step === e ? this : (this.step = e, La(this.eInput, "step", e), this);
    }, t.prototype.setValue = function(e, r) {
      var n = this;
      return this.setValueOrInputValue(function(i) {
        return o.prototype.setValue.call(n, i, r);
      }, function() {
        return n;
      }, e);
    }, t.prototype.setStartValue = function(e) {
      var r = this;
      return this.setValueOrInputValue(function(n) {
        return o.prototype.setValue.call(r, n, !0);
      }, function(n) {
        r.eInput.value = n;
      }, e);
    }, t.prototype.setValueOrInputValue = function(e, r, n) {
      if (Oe(n)) {
        var i = this.isScientificNotation(n);
        if (i && this.eInput.validity.valid)
          return e(n);
        if (!i) {
          n = this.adjustPrecision(n);
          var a = this.normalizeValue(n);
          i = n != a;
        }
        if (i)
          return r(n);
      }
      return e(n);
    }, t.prototype.getValue = function() {
      if (this.eInput.validity.valid) {
        var e = this.eInput.value;
        return this.isScientificNotation(e) ? this.adjustPrecision(e, !0) : o.prototype.getValue.call(this);
      }
    }, t.prototype.isScientificNotation = function(e) {
      return typeof e == "string" && e.includes("e");
    }, t;
  }(zl)
), lI = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uI = (
  /** @class */
  function(o) {
    lI(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.conditionToString = function(e, r) {
      var n = (r || {}).numberOfInputs, i = e.type == Ir.IN_RANGE || n === 2;
      return i ? "".concat(this.formatValue(e.filter), "-").concat(this.formatValue(e.filterTo)) : e.filter != null ? this.formatValue(e.filter) : "".concat(e.type);
    }, t;
  }(i_)
);
function VS(o) {
  var t = (o ?? {}).allowedCharPattern;
  return t ?? null;
}
var s_ = (
  /** @class */
  function(o) {
    lI(t, o);
    function t() {
      var e = o.call(this, "numberFilter") || this;
      return e.eValuesFrom = [], e.eValuesTo = [], e;
    }
    return t.prototype.refresh = function(e) {
      return this.numberFilterParams.allowedCharPattern !== e.allowedCharPattern ? !1 : o.prototype.refresh.call(this, e);
    }, t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, n = r.filter, i = r.filterTo, a = r.type;
      return [
        this.processValue(n),
        this.processValue(i)
      ].slice(0, this.getNumberOfInputs(a));
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.comparator = function() {
      return function(e, r) {
        return e === r ? 0 : e < r ? 1 : -1;
      };
    }, t.prototype.setParams = function(e) {
      this.numberFilterParams = e, o.prototype.setParams.call(this, e), this.filterModelFormatter = new uI(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.setElementValue = function(e, r, n) {
      var i = !n && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(r ?? null) : r;
      o.prototype.setElementValue.call(this, e, i);
    }, t.prototype.createValueElement = function() {
      var e = VS(this.numberFilterParams), r = document.createElement("div");
      return r.classList.add("ag-filter-body"), bn(r, "presentation"), this.createFromToElement(r, this.eValuesFrom, "from", e), this.createFromToElement(r, this.eValuesTo, "to", e), r;
    }, t.prototype.createFromToElement = function(e, r, n, i) {
      var a = this.createManagedBean(i ? new zl({ allowedCharPattern: i }) : new oC());
      a.addCssClass("ag-filter-".concat(n)), a.addCssClass("ag-filter-filter"), r.push(a), e.appendChild(a.getGui());
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeComponents(this.eValuesFrom, e, r), this.removeComponents(this.eValuesTo, e, r);
    }, t.prototype.getValues = function(e) {
      var r = this, n = [];
      return this.forEachPositionInput(e, function(i, a, s, l) {
        a < l && n.push(r.processValue(r.stringToFloat(i.getValue())));
      }), n;
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.filter === r.filter && e.filterTo === r.filterTo && e.type === r.type;
    }, t.prototype.getFilterType = function() {
      return "number";
    }, t.prototype.processValue = function(e) {
      return e == null || isNaN(e) ? null : e;
    }, t.prototype.stringToFloat = function(e) {
      if (typeof e == "number")
        return e;
      var r = Ia(e);
      return r != null && r.trim() === "" && (r = null), this.numberFilterParams.numberParser ? this.numberFilterParams.numberParser(r) : r == null || r.trim() === "-" ? null : parseFloat(r);
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), n = {
        filterType: this.getFilterType(),
        type: r
      }, i = this.getValues(e);
      return i.length > 0 && (n.filter = i[0]), i.length > 1 && (n.filterTo = i[1]), n;
    }, t.prototype.getInputs = function(e) {
      return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.prototype.hasInvalidInputs = function() {
      var e = !1;
      return this.forEachInput(function(r) {
        if (!r.getInputElement().validity.valid) {
          e = !0;
          return;
        }
      }), e;
    }, t.DEFAULT_FILTER_OPTIONS = [
      tn.EQUALS,
      tn.NOT_EQUAL,
      tn.GREATER_THAN,
      tn.GREATER_THAN_OR_EQUAL,
      tn.LESS_THAN,
      tn.LESS_THAN_OR_EQUAL,
      tn.IN_RANGE,
      tn.BLANK,
      tn.NOT_BLANK
    ], t;
  }(tn)
), cI = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ey = function() {
  return ey = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, ey.apply(this, arguments);
}, dI = (
  /** @class */
  function(o) {
    cI(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.conditionToString = function(e, r) {
      var n = (r || {}).numberOfInputs, i = e.type == Ir.IN_RANGE || n === 2;
      return i ? "".concat(e.filter, "-").concat(e.filterTo) : e.filter != null ? "".concat(e.filter) : "".concat(e.type);
    }, t;
  }(i_)
), iC = (
  /** @class */
  function(o) {
    cI(t, o);
    function t() {
      var e = o.call(this, "textFilter") || this;
      return e.eValuesFrom = [], e.eValuesTo = [], e;
    }
    return t.trimInput = function(e) {
      var r = e && e.trim();
      return r === "" ? e : r;
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.setParams = function(e) {
      this.textFilterParams = e, o.prototype.setParams.call(this, e), this.matcher = this.getTextMatcher(), this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? t.DEFAULT_FORMATTER : t.DEFAULT_LOWERCASE_FORMATTER), this.filterModelFormatter = new dI(this.localeService, this.optionsFactory);
    }, t.prototype.getTextMatcher = function() {
      var e = this.textFilterParams.textCustomComparator;
      return e ? (yt.warnOnce("textCustomComparator is deprecated, use textMatcher instead."), function(r) {
        var n = r.filterOption, i = r.value, a = r.filterText;
        return e(n, i, a);
      }) : this.textFilterParams.textMatcher || t.DEFAULT_MATCHER;
    }, t.prototype.createCondition = function(e) {
      var r = this.getConditionType(e), n = {
        filterType: this.getFilterType(),
        type: r
      }, i = this.getValuesWithSideEffects(e, !0);
      return i.length > 0 && (n.filter = i[0]), i.length > 1 && (n.filterTo = i[1]), n;
    }, t.prototype.getFilterType = function() {
      return "text";
    }, t.prototype.areSimpleModelsEqual = function(e, r) {
      return e.filter === r.filter && e.filterTo === r.filterTo && e.type === r.type;
    }, t.prototype.getInputs = function(e) {
      return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
    }, t.prototype.getValues = function(e) {
      return this.getValuesWithSideEffects(e, !1);
    }, t.prototype.getValuesWithSideEffects = function(e, r) {
      var n = this, i = [];
      return this.forEachPositionInput(e, function(a, s, l, u) {
        var c;
        if (s < u) {
          var d = Ia(a.getValue());
          r && n.textFilterParams.trimInput && (d = (c = t.trimInput(d)) !== null && c !== void 0 ? c : null, a.setValue(d, !0)), i.push(d);
        }
      }), i;
    }, t.prototype.getDefaultFilterOptions = function() {
      return t.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.createValueElement = function() {
      var e = document.createElement("div");
      return e.classList.add("ag-filter-body"), bn(e, "presentation"), this.createFromToElement(e, this.eValuesFrom, "from"), this.createFromToElement(e, this.eValuesTo, "to"), e;
    }, t.prototype.createFromToElement = function(e, r, n) {
      var i = this.createManagedBean(new zl());
      i.addCssClass("ag-filter-".concat(n)), i.addCssClass("ag-filter-filter"), r.push(i), e.appendChild(i.getGui());
    }, t.prototype.removeValueElements = function(e, r) {
      this.removeComponents(this.eValuesFrom, e, r), this.removeComponents(this.eValuesTo, e, r);
    }, t.prototype.mapValuesFromModel = function(e) {
      var r = e || {}, n = r.filter, i = r.filterTo, a = r.type;
      return [
        n || null,
        i || null
      ].slice(0, this.getNumberOfInputs(a));
    }, t.prototype.evaluateNullValue = function(e) {
      var r = [
        Ir.NOT_EQUAL,
        Ir.NOT_CONTAINS,
        Ir.BLANK
      ];
      return e ? r.indexOf(e) >= 0 : !1;
    }, t.prototype.evaluateNonNullValue = function(e, r, n, i) {
      var a = this, s = e.map(function(S) {
        return a.formatter(S);
      }) || [], l = this.formatter(r), u = this.textFilterParams, c = u.api, d = u.colDef, f = u.column, v = u.columnApi, g = u.context, m = u.textFormatter;
      if (n.type === Ir.BLANK)
        return this.isBlank(r);
      if (n.type === Ir.NOT_BLANK)
        return !this.isBlank(r);
      var b = {
        api: c,
        colDef: d,
        column: f,
        columnApi: v,
        context: g,
        node: i.node,
        data: i.data,
        filterOption: n.type,
        value: l,
        textFormatter: m
      };
      return s.some(function(S) {
        return a.matcher(ey(ey({}, b), { filterText: S }));
      });
    }, t.prototype.getModelAsString = function(e) {
      var r;
      return (r = this.filterModelFormatter.getModelAsString(e)) !== null && r !== void 0 ? r : "";
    }, t.DEFAULT_FILTER_OPTIONS = [
      Ir.CONTAINS,
      Ir.NOT_CONTAINS,
      Ir.EQUALS,
      Ir.NOT_EQUAL,
      Ir.STARTS_WITH,
      Ir.ENDS_WITH,
      Ir.BLANK,
      Ir.NOT_BLANK
    ], t.DEFAULT_FORMATTER = function(e) {
      return e;
    }, t.DEFAULT_LOWERCASE_FORMATTER = function(e) {
      return e == null ? null : e.toString().toLowerCase();
    }, t.DEFAULT_MATCHER = function(e) {
      var r = e.filterOption, n = e.value, i = e.filterText;
      if (i == null)
        return !1;
      switch (r) {
        case t.CONTAINS:
          return n.indexOf(i) >= 0;
        case t.NOT_CONTAINS:
          return n.indexOf(i) < 0;
        case t.EQUALS:
          return n === i;
        case t.NOT_EQUAL:
          return n != i;
        case t.STARTS_WITH:
          return n.indexOf(i) === 0;
        case t.ENDS_WITH:
          var a = n.lastIndexOf(i);
          return a >= 0 && a === n.length - i.length;
        default:
          return !1;
      }
    }, t;
  }(Ir)
), pI = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, fI = (
  /** @class */
  function(o) {
    pI(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.params = e, r.valueChangedListener = function() {
      }, r;
    }
    return t.prototype.setupGui = function(e) {
      var r = this, n;
      this.eFloatingFilterTextInput = this.createManagedBean(new zl((n = this.params) === null || n === void 0 ? void 0 : n.config));
      var i = this.eFloatingFilterTextInput.getGui();
      e.appendChild(i), this.addManagedListener(i, "input", function(a) {
        return r.valueChangedListener(a);
      }), this.addManagedListener(i, "keydown", function(a) {
        return r.valueChangedListener(a);
      });
    }, t.prototype.setEditable = function(e) {
      this.eFloatingFilterTextInput.setDisabled(!e);
    }, t.prototype.setAutoComplete = function(e) {
      this.eFloatingFilterTextInput.setAutoComplete(e);
    }, t.prototype.getValue = function() {
      return this.eFloatingFilterTextInput.getValue();
    }, t.prototype.setValue = function(e, r) {
      this.eFloatingFilterTextInput.setValue(e, r);
    }, t.prototype.setValueChangedListener = function(e) {
      this.valueChangedListener = e;
    }, t.prototype.setParams = function(e) {
      this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
    }, t.prototype.setAriaLabel = function(e) {
      this.eFloatingFilterTextInput.setInputAriaLabel(e);
    }, t;
  }(Me)
), hI = (
  /** @class */
  function(o) {
    pI(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.setTemplate(
        /* html */
        `
            <div class="ag-floating-filter-input" role="presentation" ref="eFloatingFilterInputContainer"></div>
        `
      );
    }, t.prototype.getDefaultDebounceMs = function() {
      return 500;
    }, t.prototype.onParentModelChanged = function(e, r) {
      this.isEventFromFloatingFilter(r) || this.isEventFromDataChange(r) || (this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(e)));
    }, t.prototype.init = function(e) {
      this.setupFloatingFilterInputService(e), o.prototype.init.call(this, e), this.setTextInputParams(e);
    }, t.prototype.setupFloatingFilterInputService = function(e) {
      this.floatingFilterInputService = this.createFloatingFilterInputService(e), this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
    }, t.prototype.setTextInputParams = function(e) {
      var r;
      this.params = e;
      var n = (r = e.browserAutoComplete) !== null && r !== void 0 ? r : !1;
      if (this.floatingFilterInputService.setParams({
        ariaLabel: this.getAriaLabel(e),
        autoComplete: n
      }), this.applyActive = Qh.isUseApplyButton(this.params.filterParams), !this.isReadOnly()) {
        var i = Qh.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs()), a = Oi(this.syncUpWithParentFilter.bind(this), i);
        this.floatingFilterInputService.setValueChangedListener(a);
      }
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      o.prototype.refresh.call(this, e), this.setTextInputParams(e);
    }, t.prototype.recreateFloatingFilterInputService = function(e) {
      var r = this.floatingFilterInputService.getValue();
      An(this.eFloatingFilterInputContainer), this.destroyBean(this.floatingFilterInputService), this.setupFloatingFilterInputService(e), this.floatingFilterInputService.setValue(r, !0);
    }, t.prototype.getAriaLabel = function(e) {
      var r = this.columnModel.getDisplayNameForColumn(e.column, "header", !0), n = this.localeService.getLocaleTextFunc();
      return "".concat(r, " ").concat(n("ariaFilterInput", "Filter Input"));
    }, t.prototype.syncUpWithParentFilter = function(e) {
      var r = this, n = e.key === we.ENTER;
      if (!(this.applyActive && !n)) {
        var i = this.floatingFilterInputService.getValue();
        this.params.filterParams.trimInput && (i = iC.trimInput(i), this.floatingFilterInputService.setValue(i, !0)), this.params.parentFilterInstance(function(a) {
          a && a.onFloatingFilterChanged(r.getLastType() || null, i || null);
        });
      }
    }, t.prototype.setEditable = function(e) {
      this.floatingFilterInputService.setEditable(e);
    }, jw([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), jw([
      ke("eFloatingFilterInputContainer")
    ], t.prototype, "eFloatingFilterInputContainer", void 0), jw([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(sI)
), vI = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $z = (
  /** @class */
  function(o) {
    vI(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.valueChangedListener = function() {
      }, e.numberInputActive = !0, e;
    }
    return t.prototype.setupGui = function(e) {
      var r = this;
      this.eFloatingFilterNumberInput = this.createManagedBean(new oC()), this.eFloatingFilterTextInput = this.createManagedBean(new zl()), this.eFloatingFilterTextInput.setDisabled(!0);
      var n = this.eFloatingFilterNumberInput.getGui(), i = this.eFloatingFilterTextInput.getGui();
      e.appendChild(n), e.appendChild(i), this.setupListeners(n, function(a) {
        return r.valueChangedListener(a);
      }), this.setupListeners(i, function(a) {
        return r.valueChangedListener(a);
      });
    }, t.prototype.setEditable = function(e) {
      this.numberInputActive = e, this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive), this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
    }, t.prototype.setAutoComplete = function(e) {
      this.eFloatingFilterNumberInput.setAutoComplete(e), this.eFloatingFilterTextInput.setAutoComplete(e);
    }, t.prototype.getValue = function() {
      return this.getActiveInputElement().getValue();
    }, t.prototype.setValue = function(e, r) {
      this.getActiveInputElement().setValue(e, r);
    }, t.prototype.getActiveInputElement = function() {
      return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
    }, t.prototype.setValueChangedListener = function(e) {
      this.valueChangedListener = e;
    }, t.prototype.setupListeners = function(e, r) {
      this.addManagedListener(e, "input", r), this.addManagedListener(e, "keydown", r);
    }, t.prototype.setParams = function(e) {
      this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
    }, t.prototype.setAriaLabel = function(e) {
      this.eFloatingFilterNumberInput.setInputAriaLabel(e), this.eFloatingFilterTextInput.setInputAriaLabel(e);
    }, t;
  }(Me)
), zz = (
  /** @class */
  function(o) {
    vI(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e) {
      var r;
      o.prototype.init.call(this, e), this.filterModelFormatter = new uI(this.localeService, this.optionsFactory, (r = e.filterParams) === null || r === void 0 ? void 0 : r.numberFormatter);
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      var r = VS(e.filterParams);
      r !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), o.prototype.refresh.call(this, e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
    }, t.prototype.getDefaultFilterOptions = function() {
      return s_.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, t.prototype.createFloatingFilterInputService = function(e) {
      return this.allowedCharPattern = VS(e.filterParams), this.allowedCharPattern ? this.createManagedBean(new fI({
        config: { allowedCharPattern: this.allowedCharPattern }
      })) : this.createManagedBean(new $z());
    }, t;
  }(hI)
), Yz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gI = (
  /** @class */
  function(o) {
    Yz(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e) {
      o.prototype.init.call(this, e), this.filterModelFormatter = new dI(this.localeService, this.optionsFactory);
    }, t.prototype.onParamsUpdated = function(e) {
      this.refresh(e);
    }, t.prototype.refresh = function(e) {
      o.prototype.refresh.call(this, e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
    }, t.prototype.getDefaultFilterOptions = function() {
      return iC.DEFAULT_FILTER_OPTIONS;
    }, t.prototype.getFilterModelFormatter = function() {
      return this.filterModelFormatter;
    }, t.prototype.createFloatingFilterInputService = function() {
      return this.createManagedBean(new fI());
    }, t;
  }(hI)
), Go = (
  /** @class */
  function() {
    function o(t, e) {
      e === void 0 && (e = !1);
      var r = this;
      this.destroyFuncs = [], this.touching = !1, this.eventService = new Ts(), this.eElement = t, this.preventMouseClick = e;
      var n = this.onTouchStart.bind(this), i = this.onTouchMove.bind(this), a = this.onTouchEnd.bind(this);
      this.eElement.addEventListener("touchstart", n, { passive: !0 }), this.eElement.addEventListener("touchmove", i, { passive: !0 }), this.eElement.addEventListener("touchend", a, { passive: !1 }), this.destroyFuncs.push(function() {
        r.eElement.removeEventListener("touchstart", n, { passive: !0 }), r.eElement.removeEventListener("touchmove", i, { passive: !0 }), r.eElement.removeEventListener("touchend", a, { passive: !1 });
      });
    }
    return o.prototype.getActiveTouch = function(t) {
      for (var e = 0; e < t.length; e++) {
        var r = t[e].identifier === this.touchStart.identifier;
        if (r)
          return t[e];
      }
      return null;
    }, o.prototype.addEventListener = function(t, e) {
      this.eventService.addEventListener(t, e);
    }, o.prototype.removeEventListener = function(t, e) {
      this.eventService.removeEventListener(t, e);
    }, o.prototype.onTouchStart = function(t) {
      var e = this;
      if (!this.touching) {
        this.touchStart = t.touches[0], this.touching = !0, this.moved = !1;
        var r = this.touchStart;
        window.setTimeout(function() {
          var n = e.touchStart === r;
          if (e.touching && n && !e.moved) {
            e.moved = !0;
            var i = {
              type: o.EVENT_LONG_TAP,
              touchStart: e.touchStart,
              touchEvent: t
            };
            e.eventService.dispatchEvent(i);
          }
        }, 500);
      }
    }, o.prototype.onTouchMove = function(t) {
      if (this.touching) {
        var e = this.getActiveTouch(t.touches);
        if (e) {
          var r = !Q1(e, this.touchStart, 4);
          r && (this.moved = !0);
        }
      }
    }, o.prototype.onTouchEnd = function(t) {
      if (this.touching) {
        if (!this.moved) {
          var e = {
            type: o.EVENT_TAP,
            touchStart: this.touchStart
          };
          this.eventService.dispatchEvent(e), this.checkForDoubleTap();
        }
        this.preventMouseClick && t.cancelable && t.preventDefault(), this.touching = !1;
      }
    }, o.prototype.checkForDoubleTap = function() {
      var t = (/* @__PURE__ */ new Date()).getTime();
      if (this.lastTapTime && this.lastTapTime > 0) {
        var e = t - this.lastTapTime;
        if (e > o.DOUBLE_TAP_MILLIS) {
          var r = {
            type: o.EVENT_DOUBLE_TAP,
            touchStart: this.touchStart
          };
          this.eventService.dispatchEvent(r), this.lastTapTime = null;
        } else
          this.lastTapTime = t;
      } else
        this.lastTapTime = t;
    }, o.prototype.destroy = function() {
      this.destroyFuncs.forEach(function(t) {
        return t();
      });
    }, o.EVENT_TAP = "tap", o.EVENT_DOUBLE_TAP = "doubleTap", o.EVENT_LONG_TAP = "longTap", o.DOUBLE_TAP_MILLIS = 500, o;
  }()
), Kz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Iu = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, aC = (
  /** @class */
  function(o) {
    Kz(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return e || r.setTemplate(t.TEMPLATE), r;
    }
    return t.prototype.attachCustomElements = function(e, r, n, i, a) {
      this.eSortOrder = e, this.eSortAsc = r, this.eSortDesc = n, this.eSortMixed = i, this.eSortNone = a;
    }, t.prototype.setupSort = function(e, r) {
      var n = this;
      r === void 0 && (r = !1), this.column = e, this.suppressOrder = r, this.setupMultiSortIndicator(), this.column.isSortable() && (this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e), this.addManagedPropertyListener("unSortIcon", function() {
        return n.updateIcons();
      }), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return n.updateIcons();
      }), this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, function() {
        return n.onSortChanged();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return n.onSortChanged();
      }), this.onSortChanged());
    }, t.prototype.addInIcon = function(e, r, n) {
      if (r != null) {
        var i = sn(e, this.gridOptionsService, n);
        i && r.appendChild(i);
      }
    }, t.prototype.onSortChanged = function() {
      this.updateIcons(), this.suppressOrder || this.updateSortOrder();
    }, t.prototype.updateIcons = function() {
      var e = this.sortController.getDisplaySortForColumn(this.column);
      if (this.eSortAsc) {
        var r = e === "asc";
        Vt(this.eSortAsc, r, { skipAriaHidden: !0 });
      }
      if (this.eSortDesc) {
        var n = e === "desc";
        Vt(this.eSortDesc, n, { skipAriaHidden: !0 });
      }
      if (this.eSortNone) {
        var i = !this.column.getColDef().unSortIcon && !this.gridOptionsService.get("unSortIcon"), a = e == null;
        Vt(this.eSortNone, !i && a, { skipAriaHidden: !0 });
      }
    }, t.prototype.setupMultiSortIndicator = function() {
      var e = this;
      this.addInIcon("sortUnSort", this.eSortMixed, this.column);
      var r = this.column.getColDef().showRowGroup, n = this.gridOptionsService.isColumnsSortingCoupledToGroup();
      n && r && (this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, function() {
        return e.updateMultiSortIndicator();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return e.updateMultiSortIndicator();
      }), this.updateMultiSortIndicator());
    }, t.prototype.updateMultiSortIndicator = function() {
      if (this.eSortMixed) {
        var e = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
        Vt(this.eSortMixed, e, { skipAriaHidden: !0 });
      }
    }, t.prototype.updateSortOrder = function() {
      var e = this, r;
      if (this.eSortOrder) {
        var n = this.sortController.getColumnsWithSortingOrdered(), i = (r = this.sortController.getDisplaySortIndexForColumn(this.column)) !== null && r !== void 0 ? r : -1, a = n.some(function(l) {
          var u;
          return (u = e.sortController.getDisplaySortIndexForColumn(l)) !== null && u !== void 0 ? u : !1;
        }), s = i >= 0 && a;
        Vt(this.eSortOrder, s, { skipAriaHidden: !0 }), i >= 0 ? this.eSortOrder.textContent = (i + 1).toString() : An(this.eSortOrder);
      }
    }, t.TEMPLATE = `<span class="ag-sort-indicator-container">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        </span>`, Iu([
      ke("eSortOrder")
    ], t.prototype, "eSortOrder", void 0), Iu([
      ke("eSortAsc")
    ], t.prototype, "eSortAsc", void 0), Iu([
      ke("eSortDesc")
    ], t.prototype, "eSortDesc", void 0), Iu([
      ke("eSortMixed")
    ], t.prototype, "eSortMixed", void 0), Iu([
      ke("eSortNone")
    ], t.prototype, "eSortNone", void 0), Iu([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Iu([
      N("sortController")
    ], t.prototype, "sortController", void 0), t;
  }(gt)
), qz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xo = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Xz = (
  /** @class */
  function(o) {
    qz(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.lastMovingChanged = 0, e;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.refresh = function(e) {
      return this.params = e, this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort || this.shouldSuppressMenuHide() != this.currentSuppressMenuHide ? !1 : (this.setDisplayName(e), !0);
    }, t.prototype.workOutTemplate = function() {
      var e = o2(this.params.template, t.TEMPLATE);
      return e = e && e.trim ? e.trim() : e, e;
    }, t.prototype.init = function(e) {
      this.params = e, this.currentTemplate = this.workOutTemplate(), this.setTemplate(this.currentTemplate), this.setupTap(), this.setupIcons(e.column), this.setMenu(), this.setupSort(), this.setupFilterIcon(), this.setDisplayName(e);
    }, t.prototype.setDisplayName = function(e) {
      if (this.currentDisplayName != e.displayName) {
        this.currentDisplayName = e.displayName;
        var r = vn(this.currentDisplayName, !0);
        this.eText && (this.eText.textContent = r);
      }
    }, t.prototype.setupIcons = function(e) {
      this.addInIcon("menu", this.eMenu, e), this.addInIcon("filter", this.eFilter, e);
    }, t.prototype.addInIcon = function(e, r, n) {
      if (r != null) {
        var i = sn(e, this.gridOptionsService, n);
        i && r.appendChild(i);
      }
    }, t.prototype.setupTap = function() {
      var e = this, r = this, n = r.gridOptionsService, i = r.api;
      if (!n.get("suppressTouch")) {
        var a = new Go(this.getGui(), !0), s = n.get("suppressMenuHide"), l = s && Oe(this.eMenu), u = l ? new Go(this.eMenu, !0) : a;
        if (this.params.enableMenu) {
          var c = l ? "EVENT_TAP" : "EVENT_LONG_TAP", d = function(v) {
            i.showColumnMenuAfterMouseClick(e.params.column, v.touchStart);
          };
          this.addManagedListener(u, Go[c], d);
        }
        if (this.params.enableSorting) {
          var f = function(v) {
            var g = v.touchStart.target;
            s && e.eMenu.contains(g) || e.sortController.progressSort(e.params.column, !1, "uiColumnSorted");
          };
          this.addManagedListener(a, Go.EVENT_TAP, f);
        }
        this.addDestroyFunc(function() {
          return a.destroy();
        }), l && this.addDestroyFunc(function() {
          return u.destroy();
        });
      }
    }, t.prototype.workOutShowMenu = function() {
      var e = !this.gridOptionsService.get("suppressMenuHide"), r = jl() && e, n = this.params.enableMenu && !r;
      return n;
    }, t.prototype.shouldSuppressMenuHide = function() {
      return this.gridOptionsService.get("suppressMenuHide");
    }, t.prototype.setMenu = function() {
      var e = this;
      if (this.eMenu) {
        if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
          bs(this.eMenu);
          return;
        }
        this.currentSuppressMenuHide = this.shouldSuppressMenuHide(), this.addManagedListener(this.eMenu, "click", function() {
          return e.showMenu(e.eMenu);
        }), this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
      }
    }, t.prototype.showMenu = function(e) {
      e || (e = this.eMenu), this.menuFactory.showMenuAfterButtonClick(this.params.column, e, "columnMenu");
    }, t.prototype.workOutSort = function() {
      return this.params.enableSorting;
    }, t.prototype.setupSort = function() {
      var e = this;
      if (this.currentSort = this.params.enableSorting, this.eSortIndicator || (this.eSortIndicator = this.context.createBean(new aC(!0)), this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone)), this.eSortIndicator.setupSort(this.params.column), !!this.currentSort) {
        this.addManagedListener(this.params.column, cr.EVENT_MOVING_CHANGED, function() {
          e.lastMovingChanged = (/* @__PURE__ */ new Date()).getTime();
        }), this.eLabel && this.addManagedListener(this.eLabel, "click", function(n) {
          var i = e.params.column.isMoving(), a = (/* @__PURE__ */ new Date()).getTime(), s = a - e.lastMovingChanged < 50, l = i || s;
          if (!l) {
            var u = e.gridOptionsService.get("multiSortKey") === "ctrl", c = u ? n.ctrlKey || n.metaKey : n.shiftKey;
            e.params.progressSort(c);
          }
        });
        var r = function() {
          if (e.addOrRemoveCssClass("ag-header-cell-sorted-asc", e.params.column.isSortAscending()), e.addOrRemoveCssClass("ag-header-cell-sorted-desc", e.params.column.isSortDescending()), e.addOrRemoveCssClass("ag-header-cell-sorted-none", e.params.column.isSortNone()), e.params.column.getColDef().showRowGroup) {
            var n = e.columnModel.getSourceColumnsForGroupColumn(e.params.column), i = n == null ? void 0 : n.every(function(s) {
              return e.params.column.getSort() == s.getSort();
            }), a = !i;
            e.addOrRemoveCssClass("ag-header-cell-sorted-mixed", a);
          }
        };
        this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, r), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, r);
      }
    }, t.prototype.setupFilterIcon = function() {
      this.eFilter && (this.addManagedListener(this.params.column, cr.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.onFilterChanged());
    }, t.prototype.onFilterChanged = function() {
      var e = this.params.column.isFilterActive();
      Vt(this.eFilter, e, { skipAriaHidden: !0 });
    }, t.TEMPLATE = `<div class="ag-cell-label-container" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span ref="eText" class="ag-header-cell-text"></span>
                <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
            </div>
        </div>`, xo([
      N("sortController")
    ], t.prototype, "sortController", void 0), xo([
      N("menuFactory")
    ], t.prototype, "menuFactory", void 0), xo([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), xo([
      N("gridApi")
    ], t.prototype, "api", void 0), xo([
      ke("eFilter")
    ], t.prototype, "eFilter", void 0), xo([
      ke("eSortIndicator")
    ], t.prototype, "eSortIndicator", void 0), xo([
      ke("eMenu")
    ], t.prototype, "eMenu", void 0), xo([
      ke("eLabel")
    ], t.prototype, "eLabel", void 0), xo([
      ke("eText")
    ], t.prototype, "eText", void 0), xo([
      ke("eSortOrder")
    ], t.prototype, "eSortOrder", void 0), xo([
      ke("eSortAsc")
    ], t.prototype, "eSortAsc", void 0), xo([
      ke("eSortDesc")
    ], t.prototype, "eSortDesc", void 0), xo([
      ke("eSortMixed")
    ], t.prototype, "eSortMixed", void 0), xo([
      ke("eSortNone")
    ], t.prototype, "eSortNone", void 0), t;
  }(gt)
), Zz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Uw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Qz = (
  /** @class */
  function(o) {
    Zz(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      this.params = e, this.checkWarnings(), this.setupLabel(), this.addGroupExpandIcon(), this.setupExpandIcons();
    }, t.prototype.checkWarnings = function() {
      var e = this.params;
      e.template && ht("A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)");
    }, t.prototype.setupExpandIcons = function() {
      var e = this;
      this.addInIcon("columnGroupOpened", "agOpened"), this.addInIcon("columnGroupClosed", "agClosed");
      var r = function(a) {
        if (!na(a)) {
          var s = !e.params.columnGroup.isExpanded();
          e.columnModel.setColumnGroupOpened(e.params.columnGroup.getProvidedColumnGroup(), s, "uiColumnExpanded");
        }
      };
      this.addTouchAndClickListeners(this.eCloseIcon, r), this.addTouchAndClickListeners(this.eOpenIcon, r);
      var n = function(a) {
        Ba(a);
      };
      this.addManagedListener(this.eCloseIcon, "dblclick", n), this.addManagedListener(this.eOpenIcon, "dblclick", n), this.addManagedListener(this.getGui(), "dblclick", r), this.updateIconVisibility();
      var i = this.params.columnGroup.getProvidedColumnGroup();
      this.addManagedListener(i, Ur.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this)), this.addManagedListener(i, Ur.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    }, t.prototype.addTouchAndClickListeners = function(e, r) {
      var n = new Go(e, !0);
      this.addManagedListener(n, Go.EVENT_TAP, r), this.addDestroyFunc(function() {
        return n.destroy();
      }), this.addManagedListener(e, "click", r);
    }, t.prototype.updateIconVisibility = function() {
      var e = this.params.columnGroup;
      if (e.isExpandable()) {
        var r = this.params.columnGroup.isExpanded();
        Vt(this.eOpenIcon, r), Vt(this.eCloseIcon, !r);
      } else
        Vt(this.eOpenIcon, !1), Vt(this.eCloseIcon, !1);
    }, t.prototype.addInIcon = function(e, r) {
      var n = sn(e, this.gridOptionsService, null);
      n && this.getRefElement(r).appendChild(n);
    }, t.prototype.addGroupExpandIcon = function() {
      if (!this.params.columnGroup.isExpandable()) {
        Vt(this.eOpenIcon, !1), Vt(this.eCloseIcon, !1);
        return;
      }
    }, t.prototype.setupLabel = function() {
      var e, r = this.params, n = r.displayName, i = r.columnGroup;
      if (Oe(n)) {
        var a = vn(n, !0);
        this.getRefElement("agLabel").textContent = a;
      }
      this.addOrRemoveCssClass("ag-sticky-label", !(!((e = i.getColGroupDef()) === null || e === void 0) && e.suppressStickyLabel));
    }, t.TEMPLATE = `<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`, Uw([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Uw([
      ke("agOpened")
    ], t.prototype, "eOpenIcon", void 0), Uw([
      ke("agClosed")
    ], t.prototype, "eCloseIcon", void 0), t;
  }(gt)
), Jz = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yl = (
  /** @class */
  function(o) {
    Jz(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.isPopup = function() {
      return !0;
    }, t.prototype.setParentComponent = function(e) {
      e.addCssClass("ag-has-popup"), o.prototype.setParentComponent.call(this, e);
    }, t.prototype.destroy = function() {
      var e = this.parentComponent, r = e && e.isAlive();
      r && e.getGui().classList.remove("ag-has-popup"), o.prototype.destroy.call(this);
    }, t;
  }(gt)
), eY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, mI = (
  /** @class */
  function(o) {
    eY(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      this.params = e, this.focusAfterAttached = e.cellStartedEdit, this.eTextArea.setMaxLength(e.maxLength || 200).setCols(e.cols || 60).setRows(e.rows || 10), Oe(e.value, !0) && this.eTextArea.setValue(e.value.toString(), !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key;
      (r === we.LEFT || r === we.UP || r === we.RIGHT || r === we.DOWN || e.shiftKey && r === we.ENTER) && e.stopPropagation();
    }, t.prototype.afterGuiAttached = function() {
      var e = this.localeService.getLocaleTextFunc();
      this.eTextArea.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), this.focusAfterAttached && this.eTextArea.getFocusableElement().focus();
    }, t.prototype.getValue = function() {
      var e = this.eTextArea.getValue();
      return !Oe(e) && !Oe(this.params.value) ? this.params.value : this.params.parseValue(e);
    }, t.TEMPLATE = `<div class="ag-large-text">
            <ag-input-text-area ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`, tY([
      ke("eTextArea")
    ], t.prototype, "eTextArea", void 0), t;
  }(Yl)
), rY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), IO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, yI = (
  /** @class */
  function(o) {
    rY(t, o);
    function t() {
      var e = o.call(
        this,
        /* html */
        `<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" ref="eSelect"></ag-select>
            </div>`
      ) || this;
      return e.startedByEnter = !1, e;
    }
    return t.prototype.init = function(e) {
      this.focusAfterAttached = e.cellStartedEdit;
      var r = this, n = r.eSelect, i = r.valueFormatterService, a = r.gridOptionsService, s = e.values, l = e.value, u = e.eventKey;
      if (tt(s)) {
        console.warn("AG Grid: no values found for select cellEditor");
        return;
      }
      this.startedByEnter = u != null ? u === we.ENTER : !1;
      var c = !1;
      s.forEach(function(g) {
        var m = { value: g }, b = i.formatValue(e.column, null, g), S = b != null;
        m.text = S ? b : g, n.addOption(m), c = c || l === g;
      }), c ? n.setValue(e.value, !0) : e.values.length && n.setValue(e.values[0], !0);
      var d = e.valueListGap, f = e.valueListMaxWidth, v = e.valueListMaxHeight;
      d != null && n.setPickerGap(d), v != null && n.setPickerMaxHeight(v), f != null && n.setPickerMaxWidth(f), a.get("editType") !== "fullRow" && this.addManagedListener(this.eSelect, pv.EVENT_ITEM_SELECTED, function() {
        return e.stopEditing();
      });
    }, t.prototype.afterGuiAttached = function() {
      var e = this;
      this.focusAfterAttached && this.eSelect.getFocusableElement().focus(), this.startedByEnter && setTimeout(function() {
        e.isAlive() && e.eSelect.showPicker();
      });
    }, t.prototype.focusIn = function() {
      this.eSelect.getFocusableElement().focus();
    }, t.prototype.getValue = function() {
      return this.eSelect.getValue();
    }, t.prototype.isPopup = function() {
      return !1;
    }, IO([
      N("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), IO([
      ke("eSelect")
    ], t.prototype, "eSelect", void 0), t;
  }(Yl)
), nY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), oY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, sC = (
  /** @class */
  function(o) {
    nY(t, o);
    function t(e) {
      var r = o.call(
        this,
        /* html */
        `
            <div class="ag-cell-edit-wrapper">
                `.concat(e.getTemplate(), `
            </div>`)
      ) || this;
      return r.cellEditorInput = e, r;
    }
    return t.prototype.init = function(e) {
      this.params = e;
      var r = this.eInput;
      this.cellEditorInput.init(r, e);
      var n;
      if (e.cellStartedEdit) {
        this.focusAfterAttached = !0;
        var i = e.eventKey;
        i === we.BACKSPACE || e.eventKey === we.DELETE ? n = "" : i && i.length === 1 ? n = i : (n = this.cellEditorInput.getStartValue(), i !== we.F2 && (this.highlightAllOnFocus = !0));
      } else
        this.focusAfterAttached = !1, n = this.cellEditorInput.getStartValue();
      n != null && r.setStartValue(n), this.addManagedListener(r.getGui(), "keydown", function(a) {
        var s = a.key;
        (s === we.PAGE_UP || s === we.PAGE_DOWN) && a.preventDefault();
      });
    }, t.prototype.afterGuiAttached = function() {
      var e, r, n = this.localeService.getLocaleTextFunc(), i = this.eInput;
      if (i.setInputAriaLabel(n("ariaInputEditor", "Input Editor")), !!this.focusAfterAttached) {
        oa() || i.getFocusableElement().focus();
        var a = i.getInputElement();
        this.highlightAllOnFocus ? a.select() : (r = (e = this.cellEditorInput).setCaret) === null || r === void 0 || r.call(e);
      }
    }, t.prototype.focusIn = function() {
      var e = this.eInput, r = e.getFocusableElement(), n = e.getInputElement();
      r.focus(), n.select();
    }, t.prototype.getValue = function() {
      return this.cellEditorInput.getValue();
    }, t.prototype.isPopup = function() {
      return !1;
    }, oY([
      ke("eInput")
    ], t.prototype, "eInput", void 0), t;
  }(Yl)
), iY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), aY = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.getTemplate = function() {
      return (
        /* html */
        '<ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field>'
      );
    }, o.prototype.init = function(t, e) {
      this.eInput = t, this.params = e, e.maxLength != null && t.setMaxLength(e.maxLength);
    }, o.prototype.getValue = function() {
      var t = this.eInput.getValue();
      return !Oe(t) && !Oe(this.params.value) ? this.params.value : this.params.parseValue(t);
    }, o.prototype.getStartValue = function() {
      var t = this.params.useFormatter || this.params.column.getColDef().refData;
      return t ? this.params.formatValue(this.params.value) : this.params.value;
    }, o.prototype.setCaret = function() {
      var t = this.eInput.getValue(), e = Oe(t) && t.length || 0;
      e && this.eInput.getInputElement().setSelectionRange(e, e);
    }, o;
  }()
), HS = (
  /** @class */
  function(o) {
    iY(t, o);
    function t() {
      return o.call(this, new aY()) || this;
    }
    return t;
  }(sC)
), sY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), lY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, uY = "↑", cY = "↓", CI = (
  /** @class */
  function(o) {
    sY(t, o);
    function t() {
      var e = o.call(this) || this;
      e.refreshCount = 0;
      var r = document.createElement("span"), n = document.createElement("span");
      n.setAttribute("class", "ag-value-change-delta");
      var i = document.createElement("span");
      return i.setAttribute("class", "ag-value-change-value"), r.appendChild(n), r.appendChild(i), e.setTemplateFromElement(r), e;
    }
    return t.prototype.init = function(e) {
      this.eValue = this.queryForHtmlElement(".ag-value-change-value"), this.eDelta = this.queryForHtmlElement(".ag-value-change-delta"), this.refresh(e, !0);
    }, t.prototype.showDelta = function(e, r) {
      var n = Math.abs(r), i = e.formatValue(n), a = Oe(i) ? i : n, s = r >= 0;
      s ? this.eDelta.textContent = uY + a : this.eDelta.textContent = cY + a, this.eDelta.classList.toggle("ag-value-change-delta-up", s), this.eDelta.classList.toggle("ag-value-change-delta-down", !s);
    }, t.prototype.setTimerToRemoveDelta = function() {
      var e = this;
      this.refreshCount++;
      var r = this.refreshCount;
      this.getFrameworkOverrides().wrapIncoming(function() {
        window.setTimeout(function() {
          r === e.refreshCount && e.hideDeltaValue();
        }, 2e3);
      });
    }, t.prototype.hideDeltaValue = function() {
      this.eValue.classList.remove("ag-value-change-value-highlight"), An(this.eDelta);
    }, t.prototype.refresh = function(e, r) {
      r === void 0 && (r = !1);
      var n = e.value;
      if (n === this.lastValue || (Oe(e.valueFormatted) ? this.eValue.textContent = e.valueFormatted : Oe(e.value) ? this.eValue.textContent = n : An(this.eValue), this.filterManager.isSuppressFlashingCellsBecauseFiltering()))
        return !1;
      if (typeof n == "number" && typeof this.lastValue == "number") {
        var i = n - this.lastValue;
        this.showDelta(e, i);
      }
      return this.lastValue && this.eValue.classList.add("ag-value-change-value-highlight"), r || this.setTimerToRemoveDelta(), this.lastValue = n, !0;
    }, lY([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(gt)
), dY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wI = (
  /** @class */
  function(o) {
    dY(t, o);
    function t() {
      var e = o.call(this) || this;
      e.refreshCount = 0;
      var r = document.createElement("span"), n = document.createElement("span");
      return n.setAttribute("class", "ag-value-slide-current"), r.appendChild(n), e.setTemplateFromElement(r), e.eCurrent = e.queryForHtmlElement(".ag-value-slide-current"), e;
    }
    return t.prototype.init = function(e) {
      this.refresh(e, !0);
    }, t.prototype.addSlideAnimation = function() {
      var e = this;
      this.refreshCount++;
      var r = this.refreshCount;
      this.ePrevious && this.getGui().removeChild(this.ePrevious);
      var n = document.createElement("span");
      n.setAttribute("class", "ag-value-slide-previous ag-value-slide-out"), this.ePrevious = n, this.ePrevious.textContent = this.eCurrent.textContent, this.getGui().insertBefore(this.ePrevious, this.eCurrent), this.getFrameworkOverrides().wrapIncoming(function() {
        window.setTimeout(function() {
          r === e.refreshCount && e.ePrevious.classList.add("ag-value-slide-out-end");
        }, 50), window.setTimeout(function() {
          r === e.refreshCount && (e.getGui().removeChild(e.ePrevious), e.ePrevious = null);
        }, 3e3);
      });
    }, t.prototype.refresh = function(e, r) {
      r === void 0 && (r = !1);
      var n = e.value;
      return tt(n) && (n = ""), n === this.lastValue || this.filterManager.isSuppressFlashingCellsBecauseFiltering() ? !1 : (r || this.addSlideAnimation(), this.lastValue = n, Oe(e.valueFormatted) ? this.eCurrent.textContent = e.valueFormatted : Oe(e.value) ? this.eCurrent.textContent = n : An(this.eCurrent), !0);
    }, pY([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(gt)
), jd = function() {
  return jd = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, jd.apply(this, arguments);
}, St = (
  /** @class */
  function() {
    function o(t) {
      this.rowIndex = null, this.key = null, this.childrenMapped = {}, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = o.OBJECT_ID_SEQUENCE++, this.__autoHeights = {}, this.alreadyRendered = !1, this.highlighted = null, this.hovered = !1, this.selected = !1, this.beans = t;
    }
    return o.prototype.setData = function(t) {
      this.setDataCommon(t, !1);
    }, o.prototype.updateData = function(t) {
      this.setDataCommon(t, !0);
    }, o.prototype.setDataCommon = function(t, e) {
      var r = this.data;
      this.data = t, this.beans.valueCache.onDataChanged(), this.updateDataOnDetailNode(), this.checkRowSelectable(), this.resetQuickFilterAggregateText();
      var n = this.createDataChangedEvent(t, r, e);
      this.dispatchLocalEvent(n);
    }, o.prototype.updateDataOnDetailNode = function() {
      this.detailNode && (this.detailNode.data = this.data);
    }, o.prototype.createDataChangedEvent = function(t, e, r) {
      return {
        type: o.EVENT_DATA_CHANGED,
        node: this,
        oldData: e,
        newData: t,
        update: r
      };
    }, o.prototype.createLocalRowEvent = function(t) {
      return {
        type: t,
        node: this
      };
    }, o.prototype.getRowIndexString = function() {
      return this.rowPinned === "top" ? "t-" + this.rowIndex : this.rowPinned === "bottom" ? "b-" + this.rowIndex : this.rowIndex.toString();
    }, o.prototype.createDaemonNode = function() {
      var t = new o(this.beans);
      return t.id = this.id, t.data = this.data, t.__daemon = !0, t.selected = this.selected, t.level = this.level, t;
    }, o.prototype.setDataAndId = function(t, e) {
      var r = Oe(this.id) ? this.createDaemonNode() : null, n = this.data;
      this.data = t, this.updateDataOnDetailNode(), this.setId(e), this.checkRowSelectable(), this.beans.selectionService.syncInRowNode(this, r);
      var i = this.createDataChangedEvent(t, n, !1);
      this.dispatchLocalEvent(i);
    }, o.prototype.checkRowSelectable = function() {
      var t = this.beans.gridOptionsService.get("isRowSelectable");
      this.setRowSelectable(t ? t(this) : !0);
    }, o.prototype.setRowSelectable = function(t, e) {
      if (this.selectable !== t) {
        if (this.selectable = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_SELECTABLE_CHANGED)), e)
          return;
        var r = this.beans.gridOptionsService.get("groupSelectsChildren");
        if (r) {
          var n = this.calculateSelectedFromChildren();
          this.setSelectedParams({
            newValue: n ?? !1,
            source: "selectableChanged"
          });
          return;
        }
        this.isSelected() && !this.selectable && this.setSelectedParams({
          newValue: !1,
          source: "selectableChanged"
        });
      }
    }, o.prototype.setId = function(t) {
      var e = this.beans.gridOptionsService.getCallback("getRowId");
      if (e)
        if (this.data) {
          var r = this.getGroupKeys(!0);
          this.id = e({
            data: this.data,
            parentKeys: r.length > 0 ? r : void 0,
            level: this.level
          }), this.id !== null && typeof this.id == "string" && this.id.startsWith(o.ID_PREFIX_ROW_GROUP) && console.error("AG Grid: Row IDs cannot start with ".concat(o.ID_PREFIX_ROW_GROUP, ", this is a reserved prefix for AG Grid's row grouping feature.")), this.id !== null && typeof this.id != "string" && (this.id = "" + this.id);
        } else
          this.id = void 0;
      else
        this.id = t;
    }, o.prototype.getGroupKeys = function(t) {
      t === void 0 && (t = !1);
      var e = [], r = this;
      for (t && (r = r.parent); r && r.level >= 0; )
        e.push(r.key), r = r.parent;
      return e.reverse(), e;
    }, o.prototype.isPixelInRange = function(t) {
      return !Oe(this.rowTop) || !Oe(this.rowHeight) ? !1 : t >= this.rowTop && t < this.rowTop + this.rowHeight;
    }, o.prototype.setFirstChild = function(t) {
      this.firstChild !== t && (this.firstChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_FIRST_CHILD_CHANGED)));
    }, o.prototype.setLastChild = function(t) {
      this.lastChild !== t && (this.lastChild = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_LAST_CHILD_CHANGED)));
    }, o.prototype.setChildIndex = function(t) {
      this.childIndex !== t && (this.childIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_CHILD_INDEX_CHANGED)));
    }, o.prototype.setRowTop = function(t) {
      this.oldRowTop = this.rowTop, this.rowTop !== t && (this.rowTop = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_TOP_CHANGED)), this.setDisplayed(t !== null));
    }, o.prototype.clearRowTopAndRowIndex = function() {
      this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
    }, o.prototype.setDisplayed = function(t) {
      this.displayed !== t && (this.displayed = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_DISPLAYED_CHANGED)));
    }, o.prototype.setDragging = function(t) {
      this.dragging !== t && (this.dragging = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_DRAGGING_CHANGED)));
    }, o.prototype.setHighlighted = function(t) {
      t !== this.highlighted && (this.highlighted = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_HIGHLIGHT_CHANGED)));
    }, o.prototype.setHovered = function(t) {
      this.hovered !== t && (this.hovered = t);
    }, o.prototype.isHovered = function() {
      return this.hovered;
    }, o.prototype.setAllChildrenCount = function(t) {
      this.allChildrenCount !== t && (this.allChildrenCount = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_ALL_CHILDREN_COUNT_CHANGED)));
    }, o.prototype.setMaster = function(t) {
      this.master !== t && (this.master && !t && (this.expanded = !1), this.master = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_MASTER_CHANGED)));
    }, o.prototype.setGroup = function(t) {
      this.group !== t && (this.group && !t && (this.expanded = !1), this.group = t, this.updateHasChildren(), this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_GROUP_CHANGED)));
    }, o.prototype.setRowHeight = function(t, e) {
      e === void 0 && (e = !1), this.rowHeight = t, this.rowHeightEstimated = e, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_HEIGHT_CHANGED));
    }, o.prototype.setRowAutoHeight = function(t, e) {
      this.__autoHeights || (this.__autoHeights = {}), this.__autoHeights[e.getId()] = t, t != null && (this.checkAutoHeightsDebounced == null && (this.checkAutoHeightsDebounced = Oi(this.checkAutoHeights.bind(this), 1)), this.checkAutoHeightsDebounced());
    }, o.prototype.checkAutoHeights = function() {
      var t = this, e = !1, r = !0, n = 0, i = this.__autoHeights;
      if (i != null) {
        var a = this.beans.columnModel.getAllDisplayedAutoHeightCols();
        if (a.forEach(function(l) {
          var u = i[l.getId()];
          if (u == null)
            if (t.beans.columnModel.isColSpanActive()) {
              var c = [];
              switch (l.getPinned()) {
                case "left":
                  c = t.beans.columnModel.getDisplayedLeftColumnsForRow(t);
                  break;
                case "right":
                  c = t.beans.columnModel.getDisplayedRightColumnsForRow(t);
                  break;
                case null:
                  c = t.beans.columnModel.getViewportCenterColumnsForRow(t);
                  break;
              }
              if (c.includes(l)) {
                e = !0;
                return;
              }
              u = -1;
            } else {
              e = !0;
              return;
            }
          else
            r = !1;
          u > n && (n = u);
        }), !e && ((r || n < 10) && (n = this.beans.gridOptionsService.getRowHeightForNode(this).height), n != this.rowHeight)) {
          this.setRowHeight(n);
          var s = this.beans.rowModel;
          s.onRowHeightChangedDebounced && s.onRowHeightChangedDebounced();
        }
      }
    }, o.prototype.setRowIndex = function(t) {
      this.rowIndex !== t && (this.rowIndex = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_ROW_INDEX_CHANGED)));
    }, o.prototype.setUiLevel = function(t) {
      this.uiLevel !== t && (this.uiLevel = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_UI_LEVEL_CHANGED)));
    }, o.prototype.setExpanded = function(t, e) {
      if (this.expanded !== t) {
        this.expanded = t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_EXPANDED_CHANGED));
        var r = Object.assign({}, this.createGlobalRowEvent(G.EVENT_ROW_GROUP_OPENED), {
          expanded: t,
          event: e || null
        });
        this.beans.rowNodeEventThrottle.dispatchExpanded(r), this.sibling && this.beans.rowRenderer.refreshCells({ rowNodes: [this] });
      }
    }, o.prototype.createGlobalRowEvent = function(t) {
      return this.beans.gridOptionsService.addGridCommonParams({
        type: t,
        node: this,
        data: this.data,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned
      });
    }, o.prototype.dispatchLocalEvent = function(t) {
      this.eventService && this.eventService.dispatchEvent(t);
    }, o.prototype.setDataValue = function(t, e, r) {
      var n = this, i = function() {
        var u;
        return typeof t != "string" ? t : (u = n.beans.columnModel.getGridColumn(t)) !== null && u !== void 0 ? u : n.beans.columnModel.getPrimaryColumn(t);
      }, a = i(), s = this.getValueFromValueService(a);
      if (this.beans.gridOptionsService.get("readOnlyEdit"))
        return this.dispatchEventForSaveValueReadOnly(a, s, e, r), !1;
      var l = this.beans.valueService.setValue(this, a, e, r);
      return this.dispatchCellChangedEvent(a, e, s), this.checkRowSelectable(), l;
    }, o.prototype.getValueFromValueService = function(t) {
      var e = this.leafGroup && this.beans.columnModel.isPivotMode(), r = this.group && this.expanded && !this.footer && !e, n = this.beans.gridOptionsService.getGroupIncludeFooter(), i = n({ node: this }), a = this.beans.gridOptionsService.get("groupSuppressBlankHeader"), s = r && i && !a, l = this.beans.valueService.getValue(t, this, !1, s);
      return l;
    }, o.prototype.dispatchEventForSaveValueReadOnly = function(t, e, r, n) {
      var i = this.beans.gridOptionsService.addGridCommonParams({
        type: G.EVENT_CELL_EDIT_REQUEST,
        event: null,
        rowIndex: this.rowIndex,
        rowPinned: this.rowPinned,
        column: t,
        colDef: t.getColDef(),
        data: this.data,
        node: this,
        oldValue: e,
        newValue: r,
        value: r,
        source: n
      });
      this.beans.eventService.dispatchEvent(i);
    }, o.prototype.setGroupValue = function(t, e) {
      var r = this.beans.columnModel.getGridColumn(t);
      tt(this.groupData) && (this.groupData = {});
      var n = r.getColId(), i = this.groupData[n];
      i !== e && (this.groupData[n] = e, this.dispatchCellChangedEvent(r, e, i));
    }, o.prototype.setAggData = function(t) {
      var e = this, r = XF([this.aggData, t]), n = this.aggData;
      this.aggData = t, this.eventService && r.forEach(function(i) {
        var a = e.aggData ? e.aggData[i] : void 0, s = n ? n[i] : void 0;
        if (a !== s) {
          var l = e.beans.columnModel.lookupGridColumn(i);
          l && e.dispatchCellChangedEvent(l, a, s);
        }
      });
    }, o.prototype.updateHasChildren = function() {
      var t = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0, e = this.beans.gridOptionsService.isRowModelType("serverSide");
      if (e) {
        var r = this.beans.gridOptionsService.get("treeData"), n = this.beans.gridOptionsService.get("isServerSideGroup");
        t = !this.stub && !this.footer && (r ? !!n && n(this.data) : !!this.group);
      }
      t !== this.__hasChildren && (this.__hasChildren = !!t, this.eventService && this.eventService.dispatchEvent(this.createLocalRowEvent(o.EVENT_HAS_CHILDREN_CHANGED)));
    }, o.prototype.hasChildren = function() {
      return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
    }, o.prototype.isEmptyRowGroupNode = function() {
      return this.group && ri(this.childrenAfterGroup);
    }, o.prototype.dispatchCellChangedEvent = function(t, e, r) {
      var n = {
        type: o.EVENT_CELL_CHANGED,
        node: this,
        column: t,
        newValue: e,
        oldValue: r
      };
      this.dispatchLocalEvent(n);
    }, o.prototype.resetQuickFilterAggregateText = function() {
      this.quickFilterAggregateText = null;
    }, o.prototype.isExpandable = function() {
      return this.footer ? !1 : this.beans.columnModel.isPivotMode() ? this.hasChildren() && !this.leafGroup : this.hasChildren() || !!this.master;
    }, o.prototype.isSelected = function() {
      return this.footer ? this.sibling.isSelected() : this.selected;
    }, o.prototype.depthFirstSearch = function(t) {
      this.childrenAfterGroup && this.childrenAfterGroup.forEach(function(e) {
        return e.depthFirstSearch(t);
      }), t(this);
    }, o.prototype.calculateSelectedFromChildren = function() {
      var t, e = !1, r = !1, n = !1;
      if (!(!((t = this.childrenAfterGroup) === null || t === void 0) && t.length))
        return this.selectable ? this.selected : null;
      for (var i = 0; i < this.childrenAfterGroup.length; i++) {
        var a = this.childrenAfterGroup[i], s = a.isSelected();
        if (!a.selectable) {
          var l = a.calculateSelectedFromChildren();
          if (l === null)
            continue;
          s = l;
        }
        switch (s) {
          case !0:
            e = !0;
            break;
          case !1:
            r = !0;
            break;
          default:
            n = !0;
            break;
        }
      }
      if (!(n || e && r))
        return e ? !0 : r ? !1 : this.selectable ? this.selected : null;
    }, o.prototype.setSelectedInitialValue = function(t) {
      this.selected = t;
    }, o.prototype.selectThisNode = function(t, e, r) {
      r === void 0 && (r = "api");
      var n = !this.selectable && t, i = this.selected === t;
      if (n || i)
        return !1;
      if (this.selected = t, this.eventService) {
        this.dispatchLocalEvent(this.createLocalRowEvent(o.EVENT_ROW_SELECTED));
        var a = this.sibling;
        a && a.footer && a.dispatchLocalEvent(a.createLocalRowEvent(o.EVENT_ROW_SELECTED));
      }
      var s = jd(jd({}, this.createGlobalRowEvent(G.EVENT_ROW_SELECTED)), { event: e || null, source: r });
      return this.beans.eventService.dispatchEvent(s), !0;
    }, o.prototype.setSelected = function(t, e, r) {
      if (e === void 0 && (e = !1), r === void 0 && (r = "api"), typeof r == "boolean") {
        console.warn("AG Grid: since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
        return;
      }
      this.setSelectedParams({
        newValue: t,
        clearSelection: e,
        rangeSelect: !1,
        source: r
      });
    }, o.prototype.setSelectedParams = function(t) {
      return this.rowPinned ? (console.warn("AG Grid: cannot select pinned rows"), 0) : this.id === void 0 ? (console.warn("AG Grid: cannot select node until id for node is known"), 0) : this.beans.selectionService.setNodesSelected(jd(jd({}, t), { nodes: [this.footer ? this.sibling : this] }));
    }, o.prototype.isRowPinned = function() {
      return this.rowPinned === "top" || this.rowPinned === "bottom";
    }, o.prototype.isParentOfNode = function(t) {
      for (var e = this.parent; e; ) {
        if (e === t)
          return !0;
        e = e.parent;
      }
      return !1;
    }, o.prototype.addEventListener = function(t, e) {
      var r, n;
      this.eventService || (this.eventService = new Ts()), this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.eventService.setFrameworkOverrides(this.beans.frameworkOverrides), this.frameworkEventListenerService = new S1(this.beans.frameworkOverrides));
      var i = (n = (r = this.frameworkEventListenerService) === null || r === void 0 ? void 0 : r.wrap(e)) !== null && n !== void 0 ? n : e;
      this.eventService.addEventListener(t, i);
    }, o.prototype.removeEventListener = function(t, e) {
      var r, n;
      if (this.eventService) {
        var i = (n = (r = this.frameworkEventListenerService) === null || r === void 0 ? void 0 : r.unwrap(e)) !== null && n !== void 0 ? n : e;
        this.eventService.removeEventListener(t, i), this.eventService.noRegisteredListenersExist() && (this.eventService = null);
      }
    }, o.prototype.onMouseEnter = function() {
      this.dispatchLocalEvent(this.createLocalRowEvent(o.EVENT_MOUSE_ENTER));
    }, o.prototype.onMouseLeave = function() {
      this.dispatchLocalEvent(this.createLocalRowEvent(o.EVENT_MOUSE_LEAVE));
    }, o.prototype.getFirstChildOfFirstChild = function(t) {
      for (var e = this, r = !0, n = !1, i = null; r && !n; ) {
        var a = e.parent, s = Oe(a) && e.firstChild;
        s ? a.rowGroupColumn === t && (n = !0, i = a) : r = !1, e = a;
      }
      return n ? i : null;
    }, o.prototype.isFullWidthCell = function() {
      if (this.detail)
        return !0;
      var t = this.beans.gridOptionsService.getCallback("isFullWidthRow");
      return t ? t({ rowNode: this }) : !1;
    }, o.prototype.getRoute = function() {
      if (this.key != null) {
        for (var t = [], e = this; e.key != null; )
          t.push(e.key), e = e.parent;
        return t.reverse();
      }
    }, o.prototype.createFooter = function() {
      var t = this;
      if (!this.sibling) {
        var e = /* @__PURE__ */ new Set([
          "eventService",
          "__objectId",
          "sticky"
        ]), r = new o(this.beans);
        Object.keys(this).forEach(function(n) {
          e.has(n) || (r[n] = t[n]);
        }), r.footer = !0, r.setRowTop(null), r.setRowIndex(null), r.oldRowTop = null, r.id = "rowGroupFooter_" + this.id, r.sibling = this, this.sibling = r;
      }
    }, o.prototype.destroyFooter = function() {
      this.sibling && (this.sibling.setRowTop(null), this.sibling.setRowIndex(null), this.sibling = void 0);
    }, o.ID_PREFIX_ROW_GROUP = "row-group-", o.ID_PREFIX_TOP_PINNED = "t-", o.ID_PREFIX_BOTTOM_PINNED = "b-", o.OBJECT_ID_SEQUENCE = 0, o.EVENT_ROW_SELECTED = "rowSelected", o.EVENT_DATA_CHANGED = "dataChanged", o.EVENT_CELL_CHANGED = "cellChanged", o.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged", o.EVENT_MASTER_CHANGED = "masterChanged", o.EVENT_GROUP_CHANGED = "groupChanged", o.EVENT_MOUSE_ENTER = "mouseEnter", o.EVENT_MOUSE_LEAVE = "mouseLeave", o.EVENT_HEIGHT_CHANGED = "heightChanged", o.EVENT_TOP_CHANGED = "topChanged", o.EVENT_DISPLAYED_CHANGED = "displayedChanged", o.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged", o.EVENT_LAST_CHILD_CHANGED = "lastChildChanged", o.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged", o.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged", o.EVENT_EXPANDED_CHANGED = "expandedChanged", o.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged", o.EVENT_SELECTABLE_CHANGED = "selectableChanged", o.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged", o.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged", o.EVENT_DRAGGING_CHANGED = "draggingChanged", o;
  }()
), fY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ty = function() {
  return ty = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, ty.apply(this, arguments);
}, LO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, l_ = (
  /** @class */
  function(o) {
    fY(t, o);
    function t() {
      return o.call(
        this,
        /* html*/
        `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`
      ) || this;
    }
    return t.prototype.postConstruct = function() {
      this.eCheckbox.setPassive(!0);
      var e = this.eCheckbox.getInputElement();
      O1(e, "polite"), R2(e, "text");
    }, t.prototype.getCheckboxId = function() {
      return this.eCheckbox.getInputElement().id;
    }, t.prototype.onDataChanged = function() {
      this.onSelectionChanged();
    }, t.prototype.onSelectableChanged = function() {
      this.showOrHideSelect();
    }, t.prototype.onSelectionChanged = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.rowNode.isSelected(), n = Jy(e, r), i = e("ariaRowToggleSelection", "Press Space to toggle row selection");
      this.eCheckbox.setValue(r, !0), this.eCheckbox.setInputAriaLabel("".concat(i, " (").concat(n, ")"));
    }, t.prototype.onClicked = function(e, r, n) {
      return this.rowNode.setSelectedParams({ newValue: e, rangeSelect: n.shiftKey, groupSelectsFiltered: r, event: n, source: "checkboxSelected" });
    }, t.prototype.init = function(e) {
      var r = this;
      this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", function(s) {
        Ba(s);
      }), this.addManagedListener(this.eCheckbox.getInputElement(), "click", function(s) {
        Ba(s);
        var l = r.gridOptionsService.get("groupSelectsFiltered"), u = r.eCheckbox.getValue();
        if (r.shouldHandleIndeterminateState(u, l)) {
          var c = r.onClicked(!0, l, s || {});
          c === 0 && r.onClicked(!1, l, s);
        } else u ? r.onClicked(!1, l, s) : r.onClicked(!0, l, s || {});
      }), this.addManagedListener(this.rowNode, St.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_DATA_CHANGED, this.onDataChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
      var n = this.gridOptionsService.get("isRowSelectable"), i = n || typeof this.getIsVisible() == "function";
      if (i) {
        var a = this.showOrHideSelect.bind(this);
        this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, a), this.addManagedListener(this.rowNode, St.EVENT_DATA_CHANGED, a), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, a), this.showOrHideSelect();
      }
      this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }, t.prototype.shouldHandleIndeterminateState = function(e, r) {
      return r && (this.eCheckbox.getPreviousValue() === void 0 || e === void 0) && this.gridOptionsService.isRowModelType("clientSide");
    }, t.prototype.showOrHideSelect = function() {
      var e, r, n, i, a = this.rowNode.selectable, s = this.getIsVisible();
      if (a)
        if (typeof s == "function") {
          var l = (e = this.overrides) === null || e === void 0 ? void 0 : e.callbackParams, u = (r = this.column) === null || r === void 0 ? void 0 : r.createColumnFunctionCallbackParams(this.rowNode);
          a = u ? s(ty(ty({}, l), u)) : !1;
        } else
          a = s ?? !1;
      var c = (n = this.column) === null || n === void 0 ? void 0 : n.getColDef().showDisabledCheckboxes;
      if (c) {
        this.eCheckbox.setDisabled(!a), this.setVisible(!0), this.setDisplayed(!0);
        return;
      }
      if (!((i = this.overrides) === null || i === void 0) && i.removeHidden) {
        this.setDisplayed(a);
        return;
      }
      this.setVisible(a);
    }, t.prototype.getIsVisible = function() {
      var e, r;
      return this.overrides ? this.overrides.isVisible : (r = (e = this.column) === null || e === void 0 ? void 0 : e.getColDef()) === null || r === void 0 ? void 0 : r.checkboxSelection;
    }, LO([
      ke("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), LO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), mc;
(function(o) {
  o[o.Up = 0] = "Up", o[o.Down = 1] = "Down";
})(mc || (mc = {}));
var Qn;
(function(o) {
  o[o.Left = 0] = "Left", o[o.Right = 1] = "Right";
})(Qn || (Qn = {}));
var hY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Lu = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Fg = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ho;
(function(o) {
  o[o.ToolPanel = 0] = "ToolPanel", o[o.HeaderCell = 1] = "HeaderCell", o[o.RowDrag = 2] = "RowDrag", o[o.ChartPanel = 3] = "ChartPanel", o[o.AdvancedFilterBuilder = 4] = "AdvancedFilterBuilder";
})(ho || (ho = {}));
var fn = (
  /** @class */
  function(o) {
    hY(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.dragSourceAndParamsList = [], r.dropTargets = [], r;
    }
    e = t, t.prototype.init = function() {
      this.ePinnedIcon = Ti("columnMovePin", this.gridOptionsService, null), this.eHideIcon = Ti("columnMoveHide", this.gridOptionsService, null), this.eMoveIcon = Ti("columnMoveMove", this.gridOptionsService, null), this.eLeftIcon = Ti("columnMoveLeft", this.gridOptionsService, null), this.eRightIcon = Ti("columnMoveRight", this.gridOptionsService, null), this.eGroupIcon = Ti("columnMoveGroup", this.gridOptionsService, null), this.eAggregateIcon = Ti("columnMoveValue", this.gridOptionsService, null), this.ePivotIcon = Ti("columnMovePivot", this.gridOptionsService, null), this.eDropNotAllowedIcon = Ti("dropNotAllowed", this.gridOptionsService, null);
    }, t.prototype.addDragSource = function(r, n) {
      n === void 0 && (n = !1);
      var i = {
        eElement: r.eElement,
        dragStartPixels: r.dragStartPixels,
        onDragStart: this.onDragStart.bind(this, r),
        onDragStop: this.onDragStop.bind(this),
        onDragging: this.onDragging.bind(this),
        includeTouch: n
      };
      this.dragSourceAndParamsList.push({ params: i, dragSource: r }), this.dragService.addDragSource(i);
    }, t.prototype.removeDragSource = function(r) {
      var n = this.dragSourceAndParamsList.find(function(i) {
        return i.dragSource === r;
      });
      n && (this.dragService.removeDragSource(n.params), ti(this.dragSourceAndParamsList, n));
    }, t.prototype.clearDragSourceParamsList = function() {
      var r = this;
      this.dragSourceAndParamsList.forEach(function(n) {
        return r.dragService.removeDragSource(n.params);
      }), this.dragSourceAndParamsList.length = 0, this.dropTargets.length = 0;
    }, t.prototype.nudge = function() {
      this.dragging && this.onDragging(this.eventLastTime, !0);
    }, t.prototype.onDragStart = function(r, n) {
      this.dragging = !0, this.dragSource = r, this.eventLastTime = n, this.dragItem = this.dragSource.getDragItem(), this.dragSource.onDragStarted && this.dragSource.onDragStarted(), this.createGhost();
    }, t.prototype.onDragStop = function(r) {
      if (this.eventLastTime = null, this.dragging = !1, this.dragSource.onDragStopped && this.dragSource.onDragStopped(), this.lastDropTarget && this.lastDropTarget.onDragStop) {
        var n = this.createDropTargetEvent(this.lastDropTarget, r, null, null, !1);
        this.lastDropTarget.onDragStop(n);
      }
      this.lastDropTarget = null, this.dragItem = null, this.removeGhost();
    }, t.prototype.onDragging = function(r, n) {
      var i = this, a, s, l, u, c = this.getHorizontalDirection(r), d = this.getVerticalDirection(r);
      this.eventLastTime = r, this.positionGhost(r);
      var f = this.dropTargets.filter(function(m) {
        return i.isMouseOnDropTarget(r, m);
      }), v = this.findCurrentDropTarget(r, f);
      if (v !== this.lastDropTarget)
        this.leaveLastTargetIfExists(r, c, d, n), this.lastDropTarget !== null && v === null && ((s = (a = this.dragSource).onGridExit) === null || s === void 0 || s.call(a, this.dragItem)), this.lastDropTarget === null && v !== null && ((u = (l = this.dragSource).onGridEnter) === null || u === void 0 || u.call(l, this.dragItem)), this.enterDragTargetIfExists(v, r, c, d, n), this.lastDropTarget = v;
      else if (v && v.onDragging) {
        var g = this.createDropTargetEvent(v, r, c, d, n);
        v.onDragging(g);
      }
    }, t.prototype.getAllContainersFromDropTarget = function(r) {
      var n = r.getSecondaryContainers ? r.getSecondaryContainers() : null, i = [[r.getContainer()]];
      return n ? i.concat(n) : i;
    }, t.prototype.allContainersIntersect = function(r, n) {
      var i, a;
      try {
        for (var s = Fg(n), l = s.next(); !l.done; l = s.next()) {
          var u = l.value, c = u.getBoundingClientRect();
          if (c.width === 0 || c.height === 0)
            return !1;
          var d = r.clientX >= c.left && r.clientX < c.right, f = r.clientY >= c.top && r.clientY < c.bottom;
          if (!d || !f)
            return !1;
        }
      } catch (v) {
        i = { error: v };
      } finally {
        try {
          l && !l.done && (a = s.return) && a.call(s);
        } finally {
          if (i) throw i.error;
        }
      }
      return !0;
    }, t.prototype.isMouseOnDropTarget = function(r, n) {
      var i, a, s = this.getAllContainersFromDropTarget(n), l = !1;
      try {
        for (var u = Fg(s), c = u.next(); !c.done; c = u.next()) {
          var d = c.value;
          if (this.allContainersIntersect(r, d)) {
            l = !0;
            break;
          }
        }
      } catch (f) {
        i = { error: f };
      } finally {
        try {
          c && !c.done && (a = u.return) && a.call(u);
        } finally {
          if (i) throw i.error;
        }
      }
      return n.targetContainsSource && !n.getContainer().contains(this.dragSource.eElement) ? !1 : l && n.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
    }, t.prototype.findCurrentDropTarget = function(r, n) {
      var i, a, s, l, u = n.length;
      if (u === 0)
        return null;
      if (u === 1)
        return n[0];
      var c = this.gridOptionsService.getRootNode(), d = c.elementsFromPoint(r.clientX, r.clientY);
      try {
        for (var f = Fg(d), v = f.next(); !v.done; v = f.next()) {
          var g = v.value;
          try {
            for (var m = (s = void 0, Fg(n)), b = m.next(); !b.done; b = m.next()) {
              var S = b.value, R = l2(this.getAllContainersFromDropTarget(S));
              if (R.indexOf(g) !== -1)
                return S;
            }
          } catch (P) {
            s = { error: P };
          } finally {
            try {
              b && !b.done && (l = m.return) && l.call(m);
            } finally {
              if (s) throw s.error;
            }
          }
        }
      } catch (P) {
        i = { error: P };
      } finally {
        try {
          v && !v.done && (a = f.return) && a.call(f);
        } finally {
          if (i) throw i.error;
        }
      }
      return null;
    }, t.prototype.enterDragTargetIfExists = function(r, n, i, a, s) {
      if (r) {
        if (r.onDragEnter) {
          var l = this.createDropTargetEvent(r, n, i, a, s);
          r.onDragEnter(l);
        }
        this.setGhostIcon(r.getIconName ? r.getIconName() : null);
      }
    }, t.prototype.leaveLastTargetIfExists = function(r, n, i, a) {
      if (this.lastDropTarget) {
        if (this.lastDropTarget.onDragLeave) {
          var s = this.createDropTargetEvent(this.lastDropTarget, r, n, i, a);
          this.lastDropTarget.onDragLeave(s);
        }
        this.setGhostIcon(null);
      }
    }, t.prototype.addDropTarget = function(r) {
      this.dropTargets.push(r);
    }, t.prototype.removeDropTarget = function(r) {
      this.dropTargets = this.dropTargets.filter(function(n) {
        return n.getContainer() !== r.getContainer();
      });
    }, t.prototype.hasExternalDropZones = function() {
      return this.dropTargets.some(function(r) {
        return r.external;
      });
    }, t.prototype.findExternalZone = function(r) {
      var n = this.dropTargets.filter(function(i) {
        return i.external;
      });
      return n.find(function(i) {
        return i.getContainer() === r.getContainer();
      }) || null;
    }, t.prototype.getHorizontalDirection = function(r) {
      var n = this.eventLastTime && this.eventLastTime.clientX, i = r.clientX;
      return n === i ? null : n > i ? Qn.Left : Qn.Right;
    }, t.prototype.getVerticalDirection = function(r) {
      var n = this.eventLastTime && this.eventLastTime.clientY, i = r.clientY;
      return n === i ? null : n > i ? mc.Up : mc.Down;
    }, t.prototype.createDropTargetEvent = function(r, n, i, a, s) {
      var l = r.getContainer(), u = l.getBoundingClientRect(), c = this, d = c.gridApi, f = c.columnApi, v = c.dragItem, g = c.dragSource, m = n.clientX - u.left, b = n.clientY - u.top;
      return { event: n, x: m, y: b, vDirection: a, hDirection: i, dragSource: g, fromNudge: s, dragItem: v, api: d, columnApi: f, dropZoneTarget: l };
    }, t.prototype.positionGhost = function(r) {
      var n = this.eGhost;
      if (n) {
        var i = n.getBoundingClientRect(), a = i.height, s = N2() - 2, l = k2() - 2, u = $1(n.offsetParent), c = r.clientY, d = r.clientX, f = c - u.top - a / 2, v = d - u.left - 10, g = this.gridOptionsService.getDocument(), m = g.defaultView || window, b = m.pageYOffset || g.documentElement.scrollTop, S = m.pageXOffset || g.documentElement.scrollLeft;
        s > 0 && v + n.clientWidth > s + S && (v = s + S - n.clientWidth), v < 0 && (v = 0), l > 0 && f + n.clientHeight > l + b && (f = l + b - n.clientHeight), f < 0 && (f = 0), n.style.left = "".concat(v, "px"), n.style.top = "".concat(f, "px");
      }
    }, t.prototype.removeGhost = function() {
      this.eGhost && this.eGhostParent && this.eGhostParent.removeChild(this.eGhost), this.eGhost = null;
    }, t.prototype.createGhost = function() {
      this.eGhost = No(e.GHOST_TEMPLATE), this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);
      var r = this.environment.getTheme().theme;
      r && this.eGhost.classList.add(r), this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon"), this.setGhostIcon(null);
      var n = this.eGhost.querySelector(".ag-dnd-ghost-label"), i = this.dragSource.dragItemName;
      Zy(i) && (i = i()), n.innerHTML = vn(i) || "", this.eGhost.style.height = "25px", this.eGhost.style.top = "20px", this.eGhost.style.left = "20px";
      var a = this.gridOptionsService.getDocument(), s = null, l = null;
      try {
        s = a.fullscreenElement;
      } catch {
      } finally {
        s || (s = this.gridOptionsService.getRootNode());
        var u = s.querySelector("body");
        u ? l = u : s instanceof ShadowRoot ? l = s : s instanceof Document ? l = s == null ? void 0 : s.documentElement : l = s;
      }
      this.eGhostParent = l, this.eGhostParent ? this.eGhostParent.appendChild(this.eGhost) : console.warn("AG Grid: could not find document body, it is needed for dragging columns");
    }, t.prototype.setGhostIcon = function(r, n) {
      n === void 0 && (n = !1), An(this.eGhostIcon);
      var i = null;
      switch (r || (r = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : e.ICON_NOT_ALLOWED), r) {
        case e.ICON_PINNED:
          i = this.ePinnedIcon;
          break;
        case e.ICON_MOVE:
          i = this.eMoveIcon;
          break;
        case e.ICON_LEFT:
          i = this.eLeftIcon;
          break;
        case e.ICON_RIGHT:
          i = this.eRightIcon;
          break;
        case e.ICON_GROUP:
          i = this.eGroupIcon;
          break;
        case e.ICON_AGGREGATE:
          i = this.eAggregateIcon;
          break;
        case e.ICON_PIVOT:
          i = this.ePivotIcon;
          break;
        case e.ICON_NOT_ALLOWED:
          i = this.eDropNotAllowedIcon;
          break;
        case e.ICON_HIDE:
          i = this.eHideIcon;
          break;
      }
      this.eGhostIcon.classList.toggle("ag-shake-left-to-right", n), !(i === this.eHideIcon && this.gridOptionsService.get("suppressDragLeaveHidesColumns")) && i && this.eGhostIcon.appendChild(i);
    };
    var e;
    return t.ICON_PINNED = "pinned", t.ICON_MOVE = "move", t.ICON_LEFT = "left", t.ICON_RIGHT = "right", t.ICON_GROUP = "group", t.ICON_AGGREGATE = "aggregate", t.ICON_PIVOT = "pivot", t.ICON_NOT_ALLOWED = "notAllowed", t.ICON_HIDE = "hide", t.GHOST_TEMPLATE = `<div class="ag-dnd-ghost ag-unselectable">
            <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
            <div class="ag-dnd-ghost-label"></div>
        </div>`, Lu([
      N("dragService")
    ], t.prototype, "dragService", void 0), Lu([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Lu([
      N("columnApi")
    ], t.prototype, "columnApi", void 0), Lu([
      N("gridApi")
    ], t.prototype, "gridApi", void 0), Lu([
      Fe
    ], t.prototype, "init", null), Lu([
      eo
    ], t.prototype, "clearDragSourceParamsList", null), t = e = Lu([
      Be("dragAndDropService")
    ], t), t;
  }(Me)
), lC = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Th = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ry = (
  /** @class */
  function(o) {
    lC(t, o);
    function t(e, r, n, i, a, s) {
      var l = o.call(this) || this;
      return l.cellValueFn = e, l.rowNode = r, l.column = n, l.customGui = i, l.dragStartPixels = a, l.suppressVisibilityChange = s, l.dragSource = null, l;
    }
    return t.prototype.isCustomGui = function() {
      return this.customGui != null;
    }, t.prototype.postConstruct = function() {
      if (this.customGui ? this.setDragElement(this.customGui, this.dragStartPixels) : (this.setTemplate(
        /* html */
        '<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>'
      ), this.getGui().appendChild(sn("rowDrag", this.gridOptionsService, null)), this.addDragSource()), this.checkCompatibility(), !this.suppressVisibilityChange) {
        var e = this.gridOptionsService.get("rowDragManaged") ? new gY(this, this.beans, this.rowNode, this.column) : new vY(this, this.beans, this.rowNode, this.column);
        this.createManagedBean(e, this.beans.context);
      }
    }, t.prototype.setDragElement = function(e, r) {
      this.setTemplateFromElement(e), this.addDragSource(r);
    }, t.prototype.getSelectedNodes = function() {
      var e = this.gridOptionsService.get("rowDragMultiRow");
      if (!e)
        return [this.rowNode];
      var r = this.beans.selectionService.getSelectedNodes();
      return r.indexOf(this.rowNode) !== -1 ? r : [this.rowNode];
    }, t.prototype.checkCompatibility = function() {
      var e = this.gridOptionsService.get("rowDragManaged"), r = this.gridOptionsService.get("treeData");
      r && e && ht("If using row drag with tree data, you cannot have rowDragManaged=true");
    }, t.prototype.getDragItem = function() {
      return {
        rowNode: this.rowNode,
        rowNodes: this.getSelectedNodes(),
        columns: this.column ? [this.column] : void 0,
        defaultTextValue: this.cellValueFn()
      };
    }, t.prototype.getRowDragText = function(e) {
      if (e) {
        var r = e.getColDef();
        if (r.rowDragText)
          return r.rowDragText;
      }
      return this.gridOptionsService.get("rowDragText");
    }, t.prototype.addDragSource = function(e) {
      var r = this;
      e === void 0 && (e = 4), this.dragSource && this.removeDragSource();
      var n = this.localeService.getLocaleTextFunc();
      this.dragSource = {
        type: ho.RowDrag,
        eElement: this.getGui(),
        dragItemName: function() {
          var i, a = r.getDragItem(), s = ((i = a.rowNodes) === null || i === void 0 ? void 0 : i.length) || 1, l = r.getRowDragText(r.column);
          return l ? l(a, s) : s === 1 ? r.cellValueFn() : "".concat(s, " ").concat(n("rowDragRows", "rows"));
        },
        getDragItem: function() {
          return r.getDragItem();
        },
        dragStartPixels: e,
        dragSourceDomDataKey: this.gridOptionsService.getDomDataKey()
      }, this.beans.dragAndDropService.addDragSource(this.dragSource, !0);
    }, t.prototype.removeDragSource = function() {
      this.dragSource && this.beans.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null;
    }, Th([
      N("beans")
    ], t.prototype, "beans", void 0), Th([
      Fe
    ], t.prototype, "postConstruct", null), Th([
      eo
    ], t.prototype, "removeDragSource", null), t;
  }(gt)
), bI = (
  /** @class */
  function(o) {
    lC(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      return i.parent = e, i.rowNode = r, i.column = n, i;
    }
    return t.prototype.setDisplayedOrVisible = function(e) {
      var r = { skipAriaHidden: !0 };
      if (e)
        this.parent.setDisplayed(!1, r);
      else {
        var n = !0, i = !1;
        this.column && (n = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui(), i = Zy(this.column.getColDef().rowDrag)), i ? (this.parent.setDisplayed(!0, r), this.parent.setVisible(n, r)) : (this.parent.setDisplayed(n, r), this.parent.setVisible(!0, r));
      }
    }, t;
  }(Me)
), vY = (
  /** @class */
  function(o) {
    lC(t, o);
    function t(e, r, n, i) {
      var a = o.call(this, e, n, i) || this;
      return a.beans = r, a;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.workOutVisibility();
    }, t.prototype.onSuppressRowDrag = function() {
      this.workOutVisibility();
    }, t.prototype.workOutVisibility = function() {
      var e = this.gridOptionsService.get("suppressRowDrag");
      this.setDisplayedOrVisible(e);
    }, Th([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(bI)
), gY = (
  /** @class */
  function(o) {
    lC(t, o);
    function t(e, r, n, i) {
      var a = o.call(this, e, n, i) || this;
      return a.beans = r, a;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.beans.eventService, G.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, G.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.beans.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this)), this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.workOutVisibility();
    }, t.prototype.onSuppressRowDrag = function() {
      this.workOutVisibility();
    }, t.prototype.workOutVisibility = function() {
      var e = this.beans.ctrlsService.getGridBodyCtrl(), r = e.getRowDragFeature(), n = r && r.shouldPreventRowMove(), i = this.gridOptionsService.get("suppressRowDrag"), a = this.beans.dragAndDropService.hasExternalDropZones(), s = n && !a || i;
      this.setDisplayedOrVisible(s);
    }, Th([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(bI)
), mY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ny = function() {
  return ny = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, ny.apply(this, arguments);
}, xf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, SI = (
  /** @class */
  function(o) {
    mY(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function(e, r, n, i, a, s, l) {
      var u, c, d, f;
      this.params = l, this.eGui = r, this.eCheckbox = n, this.eExpanded = i, this.eContracted = a, this.comp = e, this.compClass = s;
      var v = l.node;
      l.value;
      var g = l.colDef, m = this.isTopLevelFooter();
      if (!m) {
        var b = this.isEmbeddedRowMismatch();
        if (b)
          return;
        if (v.footer && this.gridOptionsService.get("groupHideOpenParents")) {
          var S = g && g.showRowGroup, R = v.rowGroupColumn && v.rowGroupColumn.getColId();
          if (S !== R)
            return;
        }
      }
      if (this.setupShowingValueForOpenedParent(), this.findDisplayedGroupNode(), !m) {
        var P = l.node.footer && l.node.rowGroupIndex === this.columnModel.getRowGroupColumns().findIndex(function(j) {
          var V;
          return j.getColId() === ((V = l.colDef) === null || V === void 0 ? void 0 : V.showRowGroup);
        }), D = this.gridOptionsService.get("groupDisplayType") != "multipleColumns" || this.gridOptionsService.get("treeData"), x = D || this.gridOptionsService.get("showOpenedGroup") && !l.node.footer && (!l.node.group || l.node.rowGroupIndex != null && l.node.rowGroupIndex > this.columnModel.getRowGroupColumns().findIndex(function(j) {
          var V;
          return j.getColId() === ((V = l.colDef) === null || V === void 0 ? void 0 : V.showRowGroup);
        })), M = !v.group && (((u = this.params.colDef) === null || u === void 0 ? void 0 : u.field) || ((c = this.params.colDef) === null || c === void 0 ? void 0 : c.valueGetter)), F = this.isExpandable(), H = this.columnModel.isPivotMode() && v.leafGroup && ((d = v.rowGroupColumn) === null || d === void 0 ? void 0 : d.getColId()) === ((f = l.column) === null || f === void 0 ? void 0 : f.getColDef().showRowGroup), B = !this.showingValueForOpenedParent && !F && !M && !x && !P && !H;
        if (B)
          return;
      }
      this.addExpandAndContract(), this.addFullWidthRowDraggerIfNeeded(), this.addCheckboxIfNeeded(), this.addValueElement(), this.setupIndent(), this.refreshAriaExpanded();
    }, t.prototype.getCellAriaRole = function() {
      var e, r, n = (e = this.params.colDef) === null || e === void 0 ? void 0 : e.cellAriaRole, i = (r = this.params.column) === null || r === void 0 ? void 0 : r.getColDef().cellAriaRole;
      return n || i || "gridcell";
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.expandListener = null;
    }, t.prototype.refreshAriaExpanded = function() {
      var e = this.params, r = e.node, n = e.eGridCell;
      if (this.expandListener && (this.expandListener = this.expandListener()), !this.isExpandable()) {
        O2(n);
        return;
      }
      var i = function() {
        ea(n, !!r.expanded);
      };
      this.expandListener = this.addManagedListener(r, St.EVENT_EXPANDED_CHANGED, i) || null, i();
    }, t.prototype.isTopLevelFooter = function() {
      if (!this.gridOptionsService.get("groupIncludeTotalFooter") || this.params.value != null || this.params.node.level != -1)
        return !1;
      var e = this.params.colDef, r = e == null;
      if (r || e.showRowGroup === !0)
        return !0;
      var n = this.columnModel.getRowGroupColumns();
      if (!n || n.length === 0)
        return !0;
      var i = n[0];
      return i.getId() === e.showRowGroup;
    }, t.prototype.isEmbeddedRowMismatch = function() {
      if (!this.params.fullWidth || !this.gridOptionsService.get("embedFullWidthRows"))
        return !1;
      var e = this.params.pinned === "left", r = this.params.pinned === "right", n = !e && !r;
      return this.gridOptionsService.get("enableRtl") ? this.columnModel.isPinningLeft() ? !r : !n : this.columnModel.isPinningLeft() ? !e : !n;
    }, t.prototype.findDisplayedGroupNode = function() {
      var e = this.params.column, r = this.params.node;
      if (this.showingValueForOpenedParent)
        for (var n = r.parent; n != null; ) {
          if (n.rowGroupColumn && e.isRowGroupDisplayed(n.rowGroupColumn.getId())) {
            this.displayedGroupNode = n;
            break;
          }
          n = n.parent;
        }
      tt(this.displayedGroupNode) && (this.displayedGroupNode = r);
    }, t.prototype.setupShowingValueForOpenedParent = function() {
      var e = this.params.node, r = this.params.column;
      if (!this.gridOptionsService.get("groupHideOpenParents")) {
        this.showingValueForOpenedParent = !1;
        return;
      }
      if (!e.groupData) {
        this.showingValueForOpenedParent = !1;
        return;
      }
      var n = e.rowGroupColumn != null;
      if (n) {
        var i = e.rowGroupColumn.getId(), a = r.isRowGroupDisplayed(i);
        if (a) {
          this.showingValueForOpenedParent = !1;
          return;
        }
      }
      var s = e.groupData[r.getId()] != null;
      this.showingValueForOpenedParent = s;
    }, t.prototype.addValueElement = function() {
      this.displayedGroupNode.footer ? this.addFooterValue() : (this.addGroupValue(), this.addChildCount());
    }, t.prototype.addGroupValue = function() {
      var e, r = this.adjustParamsWithDetailsFromRelatedColumn(), n = this.getInnerCompDetails(r), i = r.valueFormatted, a = r.value, s = i;
      if (s == null) {
        var l = this.displayedGroupNode.rowGroupColumn && ((e = this.params.column) === null || e === void 0 ? void 0 : e.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));
        if (this.displayedGroupNode.key === "" && this.displayedGroupNode.group && l) {
          var u = this.localeService.getLocaleTextFunc();
          s = u("blanks", "(Blanks)");
        } else
          s = a ?? null;
      }
      this.comp.setInnerRenderer(n, s);
    }, t.prototype.adjustParamsWithDetailsFromRelatedColumn = function() {
      var e = this.displayedGroupNode.rowGroupColumn, r = this.params.column;
      if (!e)
        return this.params;
      var n = r != null;
      if (n) {
        var i = r.isRowGroupDisplayed(e.getId());
        if (!i)
          return this.params;
      }
      var a = this.params, s = this.params, l = s.value, u = s.node, c = this.valueFormatterService.formatValue(e, u, l), d = ny(ny({}, a), { valueFormatted: c });
      return d;
    }, t.prototype.addFooterValue = function() {
      var e = this.params.footerValueGetter, r = "";
      if (e) {
        var n = w1(this.params);
        n.value = this.params.value, typeof e == "function" ? r = e(n) : typeof e == "string" ? r = this.expressionService.evaluate(e, n) : console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
      } else {
        var i = this.localeService.getLocaleTextFunc(), a = i("footerTotal", "Total");
        r = a + " " + (this.params.value != null ? this.params.value : "");
      }
      var s = this.getInnerCompDetails(this.params);
      this.comp.setInnerRenderer(s, r);
    }, t.prototype.getInnerCompDetails = function(e) {
      var r = this;
      if (e.fullWidth)
        return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gridOptionsService.get("groupRowRendererParams"), e);
      var n = this.userComponentFactory.getInnerRendererDetails(e, e), i = function(c) {
        return c && c.componentClass == r.compClass;
      };
      if (n && !i(n))
        return n;
      var a = this.displayedGroupNode.rowGroupColumn, s = a ? a.getColDef() : void 0;
      if (s) {
        var l = this.userComponentFactory.getCellRendererDetails(s, e);
        if (l && !i(l))
          return l;
        if (i(l) && s.cellRendererParams && s.cellRendererParams.innerRenderer) {
          var u = this.userComponentFactory.getInnerRendererDetails(s.cellRendererParams, e);
          return u;
        }
      }
    }, t.prototype.addChildCount = function() {
      this.params.suppressCount || (this.addManagedListener(this.displayedGroupNode, St.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this)), this.updateChildCount());
    }, t.prototype.updateChildCount = function() {
      var e = this.displayedGroupNode.allChildrenCount, r = this.isShowRowGroupForThisRow(), n = r && e != null && e >= 0, i = n ? "(".concat(e, ")") : "";
      this.comp.setChildCount(i);
    }, t.prototype.isShowRowGroupForThisRow = function() {
      if (this.gridOptionsService.get("treeData"))
        return !0;
      var e = this.displayedGroupNode.rowGroupColumn;
      if (!e)
        return !1;
      var r = this.params.column, n = r == null || r.isRowGroupDisplayed(e.getId());
      return n;
    }, t.prototype.addExpandAndContract = function() {
      var e, r = this.params, n = sn("groupExpanded", this.gridOptionsService, null), i = sn("groupContracted", this.gridOptionsService, null);
      n && this.eExpanded.appendChild(n), i && this.eContracted.appendChild(i);
      var a = r.eGridCell, s = ((e = this.params.column) === null || e === void 0 ? void 0 : e.isCellEditable(r.node)) && this.gridOptionsService.get("enableGroupEdit");
      !s && this.isExpandable() && !r.suppressDoubleClickExpand && this.addManagedListener(a, "dblclick", this.onCellDblClicked.bind(this)), this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this)), this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this)), this.addManagedListener(a, "keydown", this.onKeyDown.bind(this)), this.addManagedListener(r.node, St.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this)), this.showExpandAndContractIcons();
      var l = this.onRowNodeIsExpandableChanged.bind(this);
      this.addManagedListener(this.displayedGroupNode, St.EVENT_ALL_CHILDREN_COUNT_CHANGED, l), this.addManagedListener(this.displayedGroupNode, St.EVENT_MASTER_CHANGED, l), this.addManagedListener(this.displayedGroupNode, St.EVENT_GROUP_CHANGED, l), this.addManagedListener(this.displayedGroupNode, St.EVENT_HAS_CHILDREN_CHANGED, l);
    }, t.prototype.onExpandClicked = function(e) {
      na(e) || (Ba(e), this.onExpandOrContract(e));
    }, t.prototype.onExpandOrContract = function(e) {
      var r = this.displayedGroupNode, n = !r.expanded;
      !n && r.sticky && this.scrollToStickyNode(r), r.setExpanded(n, e);
    }, t.prototype.scrollToStickyNode = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), n = r.getScrollFeature();
      n.setVerticalScrollPosition(e.rowTop - e.stickyRowTop);
    }, t.prototype.isExpandable = function() {
      if (this.showingValueForOpenedParent)
        return !0;
      var e = this.displayedGroupNode, r = this.columnModel.isPivotMode() && e.leafGroup, n = e.isExpandable() && !e.footer && !r;
      if (!n)
        return !1;
      var i = this.params.column, a = i != null && typeof i.getColDef().showRowGroup == "string";
      if (a) {
        var s = this.isShowRowGroupForThisRow();
        return s;
      }
      return !0;
    }, t.prototype.showExpandAndContractIcons = function() {
      var e = this, r = e.params, n = e.displayedGroupNode, i = e.columnModel, a = r.node, s = this.isExpandable();
      if (s) {
        var l = this.showingValueForOpenedParent ? !0 : a.expanded;
        this.comp.setExpandedDisplayed(l), this.comp.setContractedDisplayed(!l);
      } else
        this.comp.setExpandedDisplayed(!1), this.comp.setContractedDisplayed(!1);
      var u = i.isPivotMode(), c = u && n.leafGroup, d = s && !c, f = a.footer && a.level === -1;
      this.comp.addOrRemoveCssClass("ag-cell-expandable", d), this.comp.addOrRemoveCssClass("ag-row-group", d), u ? this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", c) : f || this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !d);
    }, t.prototype.onRowNodeIsExpandableChanged = function() {
      this.showExpandAndContractIcons(), this.setIndent(), this.refreshAriaExpanded();
    }, t.prototype.setupIndent = function() {
      var e = this.params.node, r = this.params.suppressPadding;
      r || (this.addManagedListener(e, St.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this)), this.setIndent());
    }, t.prototype.setIndent = function() {
      if (!this.gridOptionsService.get("groupHideOpenParents")) {
        var e = this.params, r = e.node, n = !!e.colDef, i = this.gridOptionsService.get("treeData"), a = !n || i || e.colDef.showRowGroup === !0, s = a ? r.uiLevel : 0;
        this.indentClass && this.comp.addOrRemoveCssClass(this.indentClass, !1), this.indentClass = "ag-row-group-indent-" + s, this.comp.addOrRemoveCssClass(this.indentClass, !0);
      }
    }, t.prototype.addFullWidthRowDraggerIfNeeded = function() {
      var e = this;
      if (!(!this.params.fullWidth || !this.params.rowDrag)) {
        var r = new ry(function() {
          return e.params.value;
        }, this.params.node);
        this.createManagedBean(r, this.context), this.eGui.insertAdjacentElement("afterbegin", r.getGui());
      }
    }, t.prototype.isUserWantsSelected = function() {
      var e = this.params.checkbox;
      return typeof e == "function" || e === !0;
    }, t.prototype.addCheckboxIfNeeded = function() {
      var e = this, r = this.displayedGroupNode, n = this.isUserWantsSelected() && // footers cannot be selected
      !r.footer && // pinned rows cannot be selected
      !r.rowPinned && // details cannot be selected
      !r.detail;
      if (n) {
        var i = new l_();
        this.getContext().createBean(i), i.init({
          rowNode: this.params.node,
          column: this.params.column,
          overrides: {
            isVisible: this.params.checkbox,
            callbackParams: this.params,
            removeHidden: !0
          }
        }), this.eCheckbox.appendChild(i.getGui()), this.addDestroyFunc(function() {
          return e.getContext().destroyBean(i);
        });
      }
      this.comp.setCheckboxVisible(n);
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key === we.ENTER;
      if (!(!r || this.params.suppressEnterExpand)) {
        var n = this.params.column && this.params.column.isCellEditable(this.params.node);
        n || this.onExpandOrContract(e);
      }
    }, t.prototype.onCellDblClicked = function(e) {
      if (!na(e)) {
        var r = Xm(this.eExpanded, e) || Xm(this.eContracted, e);
        r || this.onExpandOrContract(e);
      }
    }, xf([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), xf([
      N("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), xf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), xf([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), xf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t;
  }(Me)
), yY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Rf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, BS = (
  /** @class */
  function(o) {
    yY(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      var r = this, n = {
        setInnerRenderer: function(l, u) {
          return r.setRenderDetails(l, u);
        },
        setChildCount: function(l) {
          return r.eChildCount.textContent = l;
        },
        addOrRemoveCssClass: function(l, u) {
          return r.addOrRemoveCssClass(l, u);
        },
        setContractedDisplayed: function(l) {
          return Vt(r.eContracted, l);
        },
        setExpandedDisplayed: function(l) {
          return Vt(r.eExpanded, l);
        },
        setCheckboxVisible: function(l) {
          return r.eCheckbox.classList.toggle("ag-invisible", !l);
        }
      }, i = this.createManagedBean(new SI()), a = !e.colDef, s = this.getGui();
      i.init(n, s, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, e), a && bn(s, i.getCellAriaRole());
    }, t.prototype.setRenderDetails = function(e, r) {
      var n = this;
      if (e) {
        var i = e.newAgStackInstance();
        if (!i)
          return;
        i.then(function(a) {
          if (a) {
            var s = function() {
              return n.context.destroyBean(a);
            };
            n.isAlive() ? (n.eValue.appendChild(a.getGui()), n.addDestroyFunc(s)) : s();
          }
        });
      } else
        this.eValue.innerText = r;
    }, t.prototype.destroy = function() {
      this.getContext().destroyBean(this.innerCellRenderer), o.prototype.destroy.call(this);
    }, t.prototype.refresh = function() {
      return !1;
    }, t.TEMPLATE = `<span class="ag-cell-wrapper">
            <span class="ag-group-expanded" ref="eExpanded"></span>
            <span class="ag-group-contracted" ref="eContracted"></span>
            <span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>
            <span class="ag-group-value" ref="eValue"></span>
            <span class="ag-group-child-count" ref="eChildCount"></span>
        </span>`, Rf([
      ke("eExpanded")
    ], t.prototype, "eExpanded", void 0), Rf([
      ke("eContracted")
    ], t.prototype, "eContracted", void 0), Rf([
      ke("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), Rf([
      ke("eValue")
    ], t.prototype, "eValue", void 0), Rf([
      ke("eChildCount")
    ], t.prototype, "eChildCount", void 0), t;
  }(gt)
), CY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), NO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wY = (
  /** @class */
  function(o) {
    CY(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      e.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }, t.prototype.setupFailed = function() {
      var e = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = e("loadingError", "ERR");
    }, t.prototype.setupLoading = function() {
      var e = sn("groupLoading", this.gridOptionsService, null);
      e && this.eLoadingIcon.appendChild(e);
      var r = this.localeService.getLocaleTextFunc();
      this.eLoadingText.innerText = r("loadingOoo", "Loading");
    }, t.prototype.refresh = function(e) {
      return !1;
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.TEMPLATE = `<div class="ag-loading">
            <span class="ag-loading-icon" ref="eLoadingIcon"></span>
            <span class="ag-loading-text" ref="eLoadingText"></span>
        </div>`, NO([
      ke("eLoadingIcon")
    ], t.prototype, "eLoadingIcon", void 0), NO([
      ke("eLoadingText")
    ], t.prototype, "eLoadingText", void 0), t;
  }(gt)
), bY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), SY = (
  /** @class */
  function(o) {
    bY(t, o);
    function t() {
      return o.call(this) || this;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r = this, n = this.gridOptionsService.get("overlayLoadingTemplate");
      if (this.setTemplate(n ?? t.DEFAULT_LOADING_OVERLAY_TEMPLATE), !n) {
        var i = this.localeService.getLocaleTextFunc();
        setTimeout(function() {
          r.getGui().textContent = i("loadingOoo", "Loading...");
        });
      }
    }, t.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>', t;
  }(gt)
), EY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), _Y = (
  /** @class */
  function(o) {
    EY(t, o);
    function t() {
      return o.call(this) || this;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function(e) {
      var r = this, n = this.gridOptionsService.get("overlayNoRowsTemplate");
      if (this.setTemplate(n ?? t.DEFAULT_NO_ROWS_TEMPLATE), !n) {
        var i = this.localeService.getLocaleTextFunc();
        setTimeout(function() {
          r.getGui().textContent = i("noRowsToShow", "No Rows To Show");
        });
      }
    }, t.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center"></span>', t;
  }(gt)
), xY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), RY = (
  /** @class */
  function(o) {
    xY(t, o);
    function t() {
      return o.call(
        this,
        /* html */
        '<div class="ag-tooltip"></div>'
      ) || this;
    }
    return t.prototype.init = function(e) {
      var r = e.value;
      this.getGui().textContent = vn(r, !0);
    }, t;
  }(Yl)
), TY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), OY = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.getTemplate = function() {
      return (
        /* html */
        '<ag-input-number-field class="ag-cell-editor" ref="eInput"></ag-input-number-field>'
      );
    }, o.prototype.init = function(t, e) {
      this.eInput = t, this.params = e, e.max != null && t.setMax(e.max), e.min != null && t.setMin(e.min), e.precision != null && t.setPrecision(e.precision), e.step != null && t.setStep(e.step);
      var r = t.getInputElement();
      e.preventStepping ? t.addManagedListener(r, "keydown", this.preventStepping) : e.showStepperButtons && r.classList.add("ag-number-field-input-stepper");
    }, o.prototype.preventStepping = function(t) {
      (t.key === we.UP || t.key === we.DOWN) && t.preventDefault();
    }, o.prototype.getValue = function() {
      var t = this.eInput.getValue();
      if (!Oe(t) && !Oe(this.params.value))
        return this.params.value;
      var e = this.params.parseValue(t);
      if (e == null)
        return e;
      if (typeof e == "string") {
        if (e === "")
          return null;
        e = Number(e);
      }
      return isNaN(e) ? null : e;
    }, o.prototype.getStartValue = function() {
      return this.params.value;
    }, o;
  }()
), EI = (
  /** @class */
  function(o) {
    TY(t, o);
    function t() {
      return o.call(this, new OY()) || this;
    }
    return t;
  }(sC)
), PY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), DY = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.getTemplate = function() {
      return (
        /* html */
        '<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>'
      );
    }, o.prototype.init = function(t, e) {
      this.eInput = t, this.params = e, e.min != null && t.setMin(e.min), e.max != null && t.setMax(e.max), e.step != null && t.setStep(e.step);
    }, o.prototype.getValue = function() {
      var t = this.eInput.getDate();
      return !Oe(t) && !Oe(this.params.value) ? this.params.value : t ?? null;
    }, o.prototype.getStartValue = function() {
      var t = this.params.value;
      if (t instanceof Date)
        return Pi(t, !1);
    }, o;
  }()
), _I = (
  /** @class */
  function(o) {
    PY(t, o);
    function t() {
      return o.call(this, new DY()) || this;
    }
    return t;
  }(sC)
), AY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), MY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, FY = (
  /** @class */
  function() {
    function o(t) {
      this.getDataTypeService = t;
    }
    return o.prototype.getTemplate = function() {
      return (
        /* html */
        '<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>'
      );
    }, o.prototype.init = function(t, e) {
      this.eInput = t, this.params = e, e.min != null && t.setMin(e.min), e.max != null && t.setMax(e.max), e.step != null && t.setStep(e.step);
    }, o.prototype.getValue = function() {
      var t = this.formatDate(this.eInput.getDate());
      return !Oe(t) && !Oe(this.params.value) ? this.params.value : this.params.parseValue(t ?? "");
    }, o.prototype.getStartValue = function() {
      var t, e;
      return Pi((e = this.parseDate((t = this.params.value) !== null && t !== void 0 ? t : void 0)) !== null && e !== void 0 ? e : null, !1);
    }, o.prototype.parseDate = function(t) {
      return this.getDataTypeService().getDateParserFunction()(t);
    }, o.prototype.formatDate = function(t) {
      return this.getDataTypeService().getDateFormatterFunction()(t);
    }, o;
  }()
), xI = (
  /** @class */
  function(o) {
    AY(t, o);
    function t() {
      var e = o.call(this, new FY(function() {
        return e.dataTypeService;
      })) || this;
      return e;
    }
    return MY([
      N("dataTypeService")
    ], t.prototype, "dataTypeService", void 0), t;
  }(sC)
), IY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), LY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, RI = (
  /** @class */
  function(o) {
    IY(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.init = function(e) {
      var r = this;
      this.params = e, this.updateCheckbox(e);
      var n = this.eCheckbox.getInputElement();
      n.setAttribute("tabindex", "-1"), O1(n, "polite"), this.addManagedListener(n, "click", function(a) {
        if (Ba(a), !r.eCheckbox.isDisabled()) {
          var s = r.eCheckbox.getValue();
          r.onCheckboxChanged(s);
        }
      }), this.addManagedListener(n, "dblclick", function(a) {
        Ba(a);
      });
      var i = this.gridOptionsService.getDocument();
      this.addManagedListener(this.params.eGridCell, "keydown", function(a) {
        if (a.key === we.SPACE && !r.eCheckbox.isDisabled()) {
          r.params.eGridCell === i.activeElement && r.eCheckbox.toggle();
          var s = r.eCheckbox.getValue();
          r.onCheckboxChanged(s), a.preventDefault();
        }
      });
    }, t.prototype.refresh = function(e) {
      return this.params = e, this.updateCheckbox(e), !0;
    }, t.prototype.updateCheckbox = function(e) {
      var r, n, i, a, s = !0;
      if (e.node.group && e.column) {
        var l = e.column.getColId();
        l.startsWith(vc) ? a = e.value == null || e.value === "" ? void 0 : e.value === "true" : e.node.aggData && e.node.aggData[l] !== void 0 ? a = (r = e.value) !== null && r !== void 0 ? r : void 0 : s = !1;
      } else
        a = (n = e.value) !== null && n !== void 0 ? n : void 0;
      if (!s) {
        this.eCheckbox.setDisplayed(!1);
        return;
      }
      this.eCheckbox.setValue(a);
      var u = e.disabled != null ? e.disabled : !(!((i = e.column) === null || i === void 0) && i.isCellEditable(e.node));
      this.eCheckbox.setDisabled(u);
      var c = this.localeService.getLocaleTextFunc(), d = Jy(c, a), f = u ? d : "".concat(c("ariaToggleCellValue", "Press SPACE to toggle cell value"), " (").concat(d, ")");
      this.eCheckbox.setInputAriaLabel(f);
    }, t.prototype.onCheckboxChanged = function(e) {
      var r = this.params, n = r.column, i = r.node, a = r.rowIndex, s = r.value, l = {
        type: G.EVENT_CELL_EDITING_STARTED,
        column: n,
        colDef: n == null ? void 0 : n.getColDef(),
        data: i.data,
        node: i,
        rowIndex: a,
        rowPinned: i.rowPinned,
        value: s
      };
      this.eventService.dispatchEvent(l);
      var u = this.params.node.setDataValue(this.params.column, e, "edit"), c = {
        type: G.EVENT_CELL_EDITING_STOPPED,
        column: n,
        colDef: n == null ? void 0 : n.getColDef(),
        data: i.data,
        node: i,
        rowIndex: a,
        rowPinned: i.rowPinned,
        value: s,
        oldValue: s,
        newValue: e,
        valueChanged: u
      };
      this.eventService.dispatchEvent(c);
    }, t.TEMPLATE = `
        <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
        </div>`, LY([
      ke("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), t;
  }(gt)
), NY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kY = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, TI = (
  /** @class */
  function(o) {
    NY(t, o);
    function t() {
      return o.call(
        this,
        /* html */
        `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`
      ) || this;
    }
    return t.prototype.init = function(e) {
      var r = this, n;
      this.params = e;
      var i = (n = e.value) !== null && n !== void 0 ? n : void 0;
      this.eCheckbox.setValue(i);
      var a = this.eCheckbox.getInputElement();
      a.setAttribute("tabindex", "-1"), this.setAriaLabel(i), this.addManagedListener(this.eCheckbox, G.EVENT_FIELD_VALUE_CHANGED, function(s) {
        return r.setAriaLabel(s.selected);
      });
    }, t.prototype.getValue = function() {
      return this.eCheckbox.getValue();
    }, t.prototype.focusIn = function() {
      this.eCheckbox.getFocusableElement().focus();
    }, t.prototype.afterGuiAttached = function() {
      this.params.cellStartedEdit && this.focusIn();
    }, t.prototype.isPopup = function() {
      return !1;
    }, t.prototype.setAriaLabel = function(e) {
      var r = this.localeService.getLocaleTextFunc(), n = Jy(r, e), i = r("ariaToggleCellValue", "Press SPACE to toggle cell value");
      this.eCheckbox.setInputAriaLabel("".concat(i, " (").concat(n, ")"));
    }, kY([
      ke("eCheckbox")
    ], t.prototype, "eCheckbox", void 0), t;
  }(Yl)
), GY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $w = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, kO = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, GO = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, OI = (
  /** @class */
  function(o) {
    GY(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.agGridDefaults = {
        //date
        agDateInput: Wz,
        //header
        agColumnHeader: Xz,
        agColumnGroupHeader: Qz,
        agSortIndicator: aC,
        //floating filters
        agTextColumnFloatingFilter: gI,
        agNumberColumnFloatingFilter: zz,
        agDateColumnFloatingFilter: Gz,
        agReadOnlyFloatingFilter: vz,
        // renderers
        agAnimateShowChangeCellRenderer: CI,
        agAnimateSlideCellRenderer: wI,
        agGroupCellRenderer: BS,
        agGroupRowRenderer: BS,
        agLoadingCellRenderer: wY,
        agCheckboxCellRenderer: RI,
        //editors
        agCellEditor: HS,
        agTextCellEditor: HS,
        agNumberCellEditor: EI,
        agDateCellEditor: _I,
        agDateStringCellEditor: xI,
        agSelectCellEditor: yI,
        agLargeTextCellEditor: mI,
        agCheckboxCellEditor: TI,
        //filter
        agTextColumnFilter: iC,
        agNumberColumnFilter: s_,
        agDateColumnFilter: a_,
        //overlays
        agLoadingOverlay: SY,
        agNoRowsOverlay: _Y,
        // tooltips
        agTooltipComponent: RY
      }, e.enterpriseAgDefaultCompsModule = {
        agSetColumnFilter: Ye.SetFilterModule,
        agSetColumnFloatingFilter: Ye.SetFilterModule,
        agMultiColumnFilter: Ye.MultiFilterModule,
        agMultiColumnFloatingFilter: Ye.MultiFilterModule,
        agGroupColumnFilter: Ye.RowGroupingModule,
        agGroupColumnFloatingFilter: Ye.RowGroupingModule,
        agRichSelect: Ye.RichSelectModule,
        agRichSelectCellEditor: Ye.RichSelectModule,
        agDetailCellRenderer: Ye.MasterDetailModule,
        agSparklineCellRenderer: Ye.SparklinesModule
      }, e.jsComps = {}, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.gridOptions.components != null && Xn(this.gridOptions.components, function(r, n) {
        return e.registerJsComponent(r, n);
      });
    }, t.prototype.registerDefaultComponent = function(e, r) {
      if (this.agGridDefaults[e]) {
        console.error("Trying to overwrite a default component. You should call registerComponent");
        return;
      }
      this.agGridDefaults[e] = r;
    }, t.prototype.registerJsComponent = function(e, r) {
      this.jsComps[e] = r;
    }, t.prototype.retrieve = function(e, r) {
      var n = this, i = function(d, f) {
        return { componentFromFramework: f, component: d };
      }, a = this.getFrameworkOverrides().frameworkComponent(r, this.gridOptions.components);
      if (a != null)
        return i(a, !0);
      var s = this.jsComps[r];
      if (s) {
        var l = this.getFrameworkOverrides().isFrameworkComponent(s);
        return i(s, l);
      }
      var u = this.agGridDefaults[r];
      if (u)
        return i(u, !1);
      var c = this.enterpriseAgDefaultCompsModule[r];
      return c ? Xt.__assertRegistered(c, "AG Grid '".concat(e, "' component: ").concat(r), this.context.getGridId()) : sp(function() {
        n.warnAboutMissingComponent(e, r);
      }, "MissingComp" + r), null;
    }, t.prototype.warnAboutMissingComponent = function(e, r) {
      var n = GO(GO([], kO(Object.keys(this.agGridDefaults).filter(function(a) {
        return !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(a);
      })), !1), kO(Object.keys(this.jsComps)), !1), i = dv(r, n, !0, 0.8).values;
      console.warn("AG Grid: Could not find '".concat(r, `' component. It was configured as "`).concat(e, ": '").concat(r, `'" but it wasn't found in the list of registered components.`)), i.length > 0 && console.warn("         Did you mean: [".concat(i.slice(0, 3), "]?")), console.warn("If using a custom component check it has been registered as described in: ".concat(this.getFrameworkOverrides().getDocLink("components/")));
    }, $w([
      N("gridOptions")
    ], t.prototype, "gridOptions", void 0), $w([
      Fe
    ], t.prototype, "init", null), t = $w([
      Be("userComponentRegistry")
    ], t), t;
  }(Me)
), VY = {
  propertyName: "dateComponent",
  cellRenderer: !1
}, HY = {
  propertyName: "headerComponent",
  cellRenderer: !1
}, BY = {
  propertyName: "headerGroupComponent",
  cellRenderer: !1
}, VO = {
  propertyName: "cellRenderer",
  cellRenderer: !0
}, WY = {
  propertyName: "cellEditor",
  cellRenderer: !1
}, HO = {
  propertyName: "innerRenderer",
  cellRenderer: !0
}, jY = {
  propertyName: "loadingOverlayComponent",
  cellRenderer: !1
}, UY = {
  propertyName: "noRowsOverlayComponent",
  cellRenderer: !1
}, $Y = {
  propertyName: "tooltipComponent",
  cellRenderer: !1
}, WS = {
  propertyName: "filter",
  cellRenderer: !1
}, zY = {
  propertyName: "floatingFilterComponent",
  cellRenderer: !1
}, YY = {
  propertyName: "toolPanel",
  cellRenderer: !1
}, KY = {
  propertyName: "statusPanel",
  cellRenderer: !1
}, qY = {
  propertyName: "fullWidthCellRenderer",
  cellRenderer: !0
}, XY = {
  propertyName: "loadingCellRenderer",
  cellRenderer: !0
}, ZY = {
  propertyName: "groupRowRenderer",
  cellRenderer: !0
}, QY = {
  propertyName: "detailCellRenderer",
  cellRenderer: !0
}, PI = (
  /** @class */
  function() {
    function o() {
    }
    return o.getFloatingFilterType = function(t) {
      return this.filterToFloatingFilterMapping[t];
    }, o.filterToFloatingFilterMapping = {
      set: "agSetColumnFloatingFilter",
      agSetColumnFilter: "agSetColumnFloatingFilter",
      multi: "agMultiColumnFloatingFilter",
      agMultiColumnFilter: "agMultiColumnFloatingFilter",
      group: "agGroupColumnFloatingFilter",
      agGroupColumnFilter: "agGroupColumnFloatingFilter",
      number: "agNumberColumnFloatingFilter",
      agNumberColumnFilter: "agNumberColumnFloatingFilter",
      date: "agDateColumnFloatingFilter",
      agDateColumnFilter: "agDateColumnFloatingFilter",
      text: "agTextColumnFloatingFilter",
      agTextColumnFilter: "agTextColumnFloatingFilter"
    }, o;
  }()
), JY = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Dd = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, DI = (
  /** @class */
  function(o) {
    JY(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getHeaderCompDetails = function(e, r) {
      return this.getCompDetails(e, HY, "agColumnHeader", r);
    }, t.prototype.getHeaderGroupCompDetails = function(e) {
      var r = e.columnGroup.getColGroupDef();
      return this.getCompDetails(r, BY, "agColumnGroupHeader", e);
    }, t.prototype.getFullWidthCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, qY, null, e, !0);
    }, t.prototype.getFullWidthLoadingCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, XY, "agLoadingCellRenderer", e, !0);
    }, t.prototype.getFullWidthGroupCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, ZY, "agGroupRowRenderer", e, !0);
    }, t.prototype.getFullWidthDetailCellRendererDetails = function(e) {
      return this.getCompDetails(this.gridOptions, QY, "agDetailCellRenderer", e, !0);
    }, t.prototype.getInnerRendererDetails = function(e, r) {
      return this.getCompDetails(e, HO, null, r);
    }, t.prototype.getFullWidthGroupRowInnerCellRenderer = function(e, r) {
      return this.getCompDetails(e, HO, null, r);
    }, t.prototype.getCellRendererDetails = function(e, r) {
      return this.getCompDetails(e, VO, null, r);
    }, t.prototype.getCellEditorDetails = function(e, r) {
      return this.getCompDetails(e, WY, "agCellEditor", r, !0);
    }, t.prototype.getFilterDetails = function(e, r, n) {
      return this.getCompDetails(e, WS, n, r, !0);
    }, t.prototype.getDateCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, VY, "agDateInput", e, !0);
    }, t.prototype.getLoadingOverlayCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, jY, "agLoadingOverlay", e, !0);
    }, t.prototype.getNoRowsOverlayCompDetails = function(e) {
      return this.getCompDetails(this.gridOptions, UY, "agNoRowsOverlay", e, !0);
    }, t.prototype.getTooltipCompDetails = function(e) {
      return this.getCompDetails(e.colDef, $Y, "agTooltipComponent", e, !0);
    }, t.prototype.getSetFilterCellRendererDetails = function(e, r) {
      return this.getCompDetails(e, VO, null, r);
    }, t.prototype.getFloatingFilterCompDetails = function(e, r, n) {
      return this.getCompDetails(e, zY, n, r);
    }, t.prototype.getToolPanelCompDetails = function(e, r) {
      return this.getCompDetails(e, YY, null, r, !0);
    }, t.prototype.getStatusPanelCompDetails = function(e, r) {
      return this.getCompDetails(e, KY, null, r, !0);
    }, t.prototype.getCompDetails = function(e, r, n, i, a) {
      var s = this;
      a === void 0 && (a = !1);
      var l = r.propertyName, u = r.cellRenderer, c = this.getCompKeys(e, r, i), d = c.compName, f = c.jsComp, v = c.fwComp, g = c.paramsFromSelector, m = c.popupFromSelector, b = c.popupPositionFromSelector, S = function(x) {
        var M = s.userComponentRegistry.retrieve(l, x);
        M && (f = M.componentFromFramework ? void 0 : M.component, v = M.componentFromFramework ? M.component : void 0);
      };
      if (d != null && S(d), f == null && v == null && n != null && S(n), f && u && !this.agComponentUtils.doesImplementIComponent(f) && (f = this.agComponentUtils.adaptFunction(l, f)), !f && !v) {
        a && console.error("AG Grid: Could not find component ".concat(d, ", did you forget to configure this component?"));
        return;
      }
      var R = this.mergeParamsWithApplicationProvidedParams(e, r, i, g), P = f == null, D = f || v;
      return {
        componentFromFramework: P,
        componentClass: D,
        params: R,
        type: r,
        popupFromSelector: m,
        popupPositionFromSelector: b,
        newAgStackInstance: function() {
          return s.newAgStackInstance(D, P, R, r);
        }
      };
    }, t.prototype.getCompKeys = function(e, r, n) {
      var i = this, a = r.propertyName, s, l, u, c, d, f;
      if (e) {
        var v = e, g = v[a + "Selector"], m = g ? g(n) : null, b = function(S) {
          if (typeof S == "string")
            s = S;
          else if (S != null && S !== !0) {
            var R = i.getFrameworkOverrides().isFrameworkComponent(S);
            R ? u = S : l = S;
          }
        };
        m ? (b(m.component), c = m.params, d = m.popup, f = m.popupPosition) : b(v[a]);
      }
      return { compName: s, jsComp: l, fwComp: u, paramsFromSelector: c, popupFromSelector: d, popupPositionFromSelector: f };
    }, t.prototype.newAgStackInstance = function(e, r, n, i) {
      var a = i.propertyName, s = !r, l;
      if (s)
        l = new e();
      else {
        var u = this.componentMetadataProvider.retrieve(a);
        l = this.frameworkComponentWrapper.wrap(e, u.mandatoryMethodList, u.optionalMethodList, i);
      }
      var c = this.initComponent(l, n);
      return c == null ? Zi.resolve(l) : c.then(function() {
        return l;
      });
    }, t.prototype.mergeParamsWithApplicationProvidedParams = function(e, r, n, i) {
      i === void 0 && (i = null);
      var a = this.gridOptionsService.getGridCommonParams();
      oi(a, n);
      var s = e, l = s && s[r.propertyName + "Params"];
      if (typeof l == "function") {
        var u = l(n);
        oi(a, u);
      } else typeof l == "object" && oi(a, l);
      return oi(a, i), a;
    }, t.prototype.initComponent = function(e, r) {
      if (this.context.createBean(e), e.init != null)
        return e.init(r);
    }, t.prototype.getDefaultFloatingFilterType = function(e, r) {
      if (e == null)
        return null;
      var n = null, i = this.getCompKeys(e, WS), a = i.compName, s = i.jsComp, l = i.fwComp;
      if (a)
        n = PI.getFloatingFilterType(a);
      else {
        var u = s == null && l == null && e.filter === !0;
        u && (n = r());
      }
      return n;
    }, Dd([
      N("gridOptions")
    ], t.prototype, "gridOptions", void 0), Dd([
      N("agComponentUtils")
    ], t.prototype, "agComponentUtils", void 0), Dd([
      N("componentMetadataProvider")
    ], t.prototype, "componentMetadataProvider", void 0), Dd([
      N("userComponentRegistry")
    ], t.prototype, "userComponentRegistry", void 0), Dd([
      Lt("frameworkComponentWrapper")
    ], t.prototype, "frameworkComponentWrapper", void 0), t = Dd([
      Be("userComponentFactory")
    ], t), t;
  }(Me)
), AI = (
  /** @class */
  function() {
    function o() {
    }
    return o.ColDefPropertyMap = {
      headerName: void 0,
      columnGroupShow: void 0,
      headerClass: void 0,
      toolPanelClass: void 0,
      headerValueGetter: void 0,
      pivotKeys: void 0,
      groupId: void 0,
      colId: void 0,
      sort: void 0,
      initialSort: void 0,
      field: void 0,
      type: void 0,
      cellDataType: void 0,
      tooltipComponent: void 0,
      tooltipField: void 0,
      headerTooltip: void 0,
      cellClass: void 0,
      showRowGroup: void 0,
      filter: void 0,
      initialAggFunc: void 0,
      defaultAggFunc: void 0,
      aggFunc: void 0,
      pinned: void 0,
      initialPinned: void 0,
      chartDataType: void 0,
      cellAriaRole: void 0,
      cellEditorPopupPosition: void 0,
      headerGroupComponent: void 0,
      headerGroupComponentParams: void 0,
      cellStyle: void 0,
      cellRenderer: void 0,
      cellRendererParams: void 0,
      cellEditor: void 0,
      cellEditorParams: void 0,
      filterParams: void 0,
      pivotValueColumn: void 0,
      headerComponent: void 0,
      headerComponentParams: void 0,
      floatingFilterComponent: void 0,
      floatingFilterComponentParams: void 0,
      tooltipComponentParams: void 0,
      refData: void 0,
      columnsMenuParams: void 0,
      children: void 0,
      sortingOrder: void 0,
      allowedAggFuncs: void 0,
      menuTabs: void 0,
      pivotTotalColumnIds: void 0,
      cellClassRules: void 0,
      icons: void 0,
      sortIndex: void 0,
      initialSortIndex: void 0,
      flex: void 0,
      initialFlex: void 0,
      width: void 0,
      initialWidth: void 0,
      minWidth: void 0,
      maxWidth: void 0,
      rowGroupIndex: void 0,
      initialRowGroupIndex: void 0,
      pivotIndex: void 0,
      initialPivotIndex: void 0,
      suppressCellFlash: void 0,
      suppressColumnsToolPanel: void 0,
      suppressFiltersToolPanel: void 0,
      openByDefault: void 0,
      marryChildren: void 0,
      suppressStickyLabel: void 0,
      hide: void 0,
      initialHide: void 0,
      rowGroup: void 0,
      initialRowGroup: void 0,
      pivot: void 0,
      initialPivot: void 0,
      checkboxSelection: void 0,
      showDisabledCheckboxes: void 0,
      headerCheckboxSelection: void 0,
      headerCheckboxSelectionFilteredOnly: void 0,
      headerCheckboxSelectionCurrentPageOnly: void 0,
      suppressMenu: void 0,
      suppressMovable: void 0,
      lockPosition: void 0,
      lockVisible: void 0,
      lockPinned: void 0,
      unSortIcon: void 0,
      suppressSizeToFit: void 0,
      suppressAutoSize: void 0,
      enableRowGroup: void 0,
      enablePivot: void 0,
      enableValue: void 0,
      editable: void 0,
      suppressPaste: void 0,
      suppressNavigable: void 0,
      enableCellChangeFlash: void 0,
      rowDrag: void 0,
      dndSource: void 0,
      autoHeight: void 0,
      wrapText: void 0,
      sortable: void 0,
      resizable: void 0,
      singleClickEdit: void 0,
      floatingFilter: void 0,
      cellEditorPopup: void 0,
      suppressFillHandle: void 0,
      wrapHeaderText: void 0,
      autoHeaderHeight: void 0,
      dndSourceOnRowDrag: void 0,
      valueGetter: void 0,
      valueSetter: void 0,
      filterValueGetter: void 0,
      keyCreator: void 0,
      valueFormatter: void 0,
      valueParser: void 0,
      comparator: void 0,
      equals: void 0,
      pivotComparator: void 0,
      suppressKeyboardEvent: void 0,
      suppressHeaderKeyboardEvent: void 0,
      colSpan: void 0,
      rowSpan: void 0,
      getQuickFilterText: void 0,
      onCellValueChanged: void 0,
      onCellClicked: void 0,
      onCellDoubleClicked: void 0,
      onCellContextMenu: void 0,
      rowDragText: void 0,
      tooltipValueGetter: void 0,
      cellRendererSelector: void 0,
      cellEditorSelector: void 0,
      suppressSpanHeaderHeight: void 0,
      useValueFormatterForExport: void 0,
      useValueParserForImport: void 0
    }, o.ALL_PROPERTIES = Object.keys(o.ColDefPropertyMap), o;
  }()
), Jh;
(function(o) {
  o[o.SINGLE_SHEET = 0] = "SINGLE_SHEET", o[o.MULTI_SHEET = 1] = "MULTI_SHEET";
})(Jh || (Jh = {}));
var eK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, MI = (
  /** @class */
  function(o) {
    eK(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.dragEndFunctions = [], e.dragSources = [], e;
    }
    return t.prototype.removeAllListeners = function() {
      this.dragSources.forEach(this.removeListener.bind(this)), this.dragSources.length = 0;
    }, t.prototype.removeListener = function(e) {
      var r = e.dragSource.eElement, n = e.mouseDownListener;
      if (r.removeEventListener("mousedown", n), e.touchEnabled) {
        var i = e.touchStartListener;
        r.removeEventListener("touchstart", i, { passive: !0 });
      }
    }, t.prototype.removeDragSource = function(e) {
      var r = this.dragSources.find(function(n) {
        return n.dragSource === e;
      });
      r && (this.removeListener(r), ti(this.dragSources, r));
    }, t.prototype.isDragging = function() {
      return this.dragging;
    }, t.prototype.addDragSource = function(e) {
      var r = this, n = this.onMouseDown.bind(this, e), i = e.eElement, a = e.includeTouch, s = e.stopPropagationForTouch;
      i.addEventListener("mousedown", n);
      var l = null, u = this.gridOptionsService.get("suppressTouch");
      a && !u && (l = function(c) {
        j1(c.target) || (c.cancelable && (c.preventDefault(), s && c.stopPropagation()), r.onTouchStart(e, c));
      }, i.addEventListener("touchstart", l, { passive: !1 })), this.dragSources.push({
        dragSource: e,
        mouseDownListener: n,
        touchStartListener: l,
        touchEnabled: !!a
      });
    }, t.prototype.getStartTarget = function() {
      return this.startTarget;
    }, t.prototype.onTouchStart = function(e, r) {
      var n = this;
      this.currentDragParams = e, this.dragging = !1;
      var i = r.touches[0];
      this.touchLastTime = i, this.touchStart = i;
      var a = function(d) {
        return n.onTouchMove(d, e.eElement);
      }, s = function(d) {
        return n.onTouchUp(d, e.eElement);
      }, l = function(d) {
        d.cancelable && d.preventDefault();
      }, u = r.target, c = [
        // Prevents the page document from moving while we are dragging items around.
        // preventDefault needs to be called in the touchmove listener and never inside the
        // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
        { target: this.gridOptionsService.getRootNode(), type: "touchmove", listener: l, options: { passive: !1 } },
        { target: u, type: "touchmove", listener: a, options: { passive: !0 } },
        { target: u, type: "touchend", listener: s, options: { passive: !0 } },
        { target: u, type: "touchcancel", listener: s, options: { passive: !0 } }
      ];
      this.addTemporaryEvents(c), e.dragStartPixels === 0 && this.onCommonMove(i, this.touchStart, e.eElement);
    }, t.prototype.onMouseDown = function(e, r) {
      var n = this, i = r;
      if (!(e.skipMouseEvent && e.skipMouseEvent(r)) && !i._alreadyProcessedByDragService && (i._alreadyProcessedByDragService = !0, r.button === 0)) {
        this.shouldPreventMouseEvent(r) && r.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = r, this.startTarget = r.target;
        var a = function(d) {
          return n.onMouseMove(d, e.eElement);
        }, s = function(d) {
          return n.onMouseUp(d, e.eElement);
        }, l = function(d) {
          return d.preventDefault();
        }, u = this.gridOptionsService.getRootNode(), c = [
          { target: u, type: "mousemove", listener: a },
          { target: u, type: "mouseup", listener: s },
          { target: u, type: "contextmenu", listener: l }
        ];
        this.addTemporaryEvents(c), e.dragStartPixels === 0 && this.onMouseMove(r, e.eElement);
      }
    }, t.prototype.addTemporaryEvents = function(e) {
      e.forEach(function(r) {
        var n = r.target, i = r.type, a = r.listener, s = r.options;
        n.addEventListener(i, a, s);
      }), this.dragEndFunctions.push(function() {
        e.forEach(function(r) {
          var n = r.target, i = r.type, a = r.listener, s = r.options;
          n.removeEventListener(i, a, s);
        });
      });
    }, t.prototype.isEventNearStartEvent = function(e, r) {
      var n = this.currentDragParams.dragStartPixels, i = Oe(n) ? n : 4;
      return Q1(e, r, i);
    }, t.prototype.getFirstActiveTouch = function(e) {
      for (var r = 0; r < e.length; r++)
        if (e[r].identifier === this.touchStart.identifier)
          return e[r];
      return null;
    }, t.prototype.onCommonMove = function(e, r, n) {
      if (!this.dragging) {
        if (!this.dragging && this.isEventNearStartEvent(e, r))
          return;
        this.dragging = !0;
        var i = {
          type: G.EVENT_DRAG_STARTED,
          target: n
        };
        this.eventService.dispatchEvent(i), this.currentDragParams.onDragStart(r), this.currentDragParams.onDragging(r);
      }
      this.currentDragParams.onDragging(e);
    }, t.prototype.onTouchMove = function(e, r) {
      var n = this.getFirstActiveTouch(e.touches);
      n && this.onCommonMove(n, this.touchStart, r);
    }, t.prototype.onMouseMove = function(e, r) {
      var n;
      if (oa()) {
        var i = this.gridOptionsService.getDocument();
        (n = i.getSelection()) === null || n === void 0 || n.removeAllRanges();
      }
      this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, r);
    }, t.prototype.shouldPreventMouseEvent = function(e) {
      var r = this.gridOptionsService.get("enableCellTextSelection"), n = e.type === "mousemove";
      return (
        // when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        r && n && e.cancelable && this.mouseEventService.isEventFromThisGrid(e) && !this.isOverFormFieldElement(e)
      );
    }, t.prototype.isOverFormFieldElement = function(e) {
      var r = e.target, n = r == null ? void 0 : r.tagName.toLocaleLowerCase();
      return !!(n != null && n.match("^a$|textarea|input|select|button"));
    }, t.prototype.onTouchUp = function(e, r) {
      var n = this.getFirstActiveTouch(e.changedTouches);
      n || (n = this.touchLastTime), this.onUpCommon(n, r);
    }, t.prototype.onMouseUp = function(e, r) {
      this.onUpCommon(e, r);
    }, t.prototype.onUpCommon = function(e, r) {
      if (this.dragging) {
        this.dragging = !1, this.currentDragParams.onDragStop(e);
        var n = {
          type: G.EVENT_DRAG_STOPPED,
          target: r
        };
        this.eventService.dispatchEvent(n);
      }
      this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null, this.dragEndFunctions.forEach(function(i) {
        return i();
      }), this.dragEndFunctions.length = 0;
    }, zw([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), zw([
      eo
    ], t.prototype, "removeAllListeners", null), t = zw([
      Be("dragService")
    ], t), t;
  }(Me)
), u_ = (
  /** @class */
  function() {
    function o(t) {
      this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = t.scrollContainer, this.scrollHorizontally = t.scrollAxis.indexOf("x") !== -1, this.scrollVertically = t.scrollAxis.indexOf("y") !== -1, this.scrollByTick = t.scrollByTick != null ? t.scrollByTick : 20, t.onScrollCallback && (this.onScrollCallback = t.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = t.getVerticalPosition, this.setVerticalPosition = t.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = t.getHorizontalPosition, this.setHorizontalPosition = t.setHorizontalPosition), this.shouldSkipVerticalScroll = t.shouldSkipVerticalScroll || function() {
        return !1;
      }, this.shouldSkipHorizontalScroll = t.shouldSkipHorizontalScroll || function() {
        return !1;
      };
    }
    return o.prototype.check = function(t, e) {
      e === void 0 && (e = !1);
      var r = e || this.shouldSkipVerticalScroll();
      if (!(r && this.shouldSkipHorizontalScroll())) {
        var n = this.scrollContainer.getBoundingClientRect(), i = this.scrollByTick;
        this.tickLeft = t.clientX < n.left + i, this.tickRight = t.clientX > n.right - i, this.tickUp = t.clientY < n.top + i && !r, this.tickDown = t.clientY > n.bottom - i && !r, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
      }
    }, o.prototype.ensureTickingStarted = function() {
      this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
    }, o.prototype.doTick = function() {
      this.tickCount++;
      var t;
      if (t = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40, this.scrollVertically) {
        var e = this.getVerticalPosition();
        this.tickUp && this.setVerticalPosition(e - t), this.tickDown && this.setVerticalPosition(e + t);
      }
      if (this.scrollHorizontally) {
        var r = this.getHorizontalPosition();
        this.tickLeft && this.setHorizontalPosition(r - t), this.tickRight && this.setHorizontalPosition(r + t);
      }
      this.onScrollCallback && this.onScrollCallback();
    }, o.prototype.ensureCleared = function() {
      this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
    }, o;
  }()
), tK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), BO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Yw = "ag-list-item-hovered", rK = (
  /** @class */
  function(o) {
    tK(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      return i.comp = e, i.virtualList = r, i.params = n, i.currentDragValue = null, i.lastHoveredListItem = null, i;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.params.eventSource, this.params.listItemDragStartEvent, this.listItemDragStart.bind(this)), this.addManagedListener(this.params.eventSource, this.params.listItemDragEndEvent, this.listItemDragEnd.bind(this)), this.createDropTarget(), this.createAutoScrollService();
    }, t.prototype.listItemDragStart = function(e) {
      this.currentDragValue = this.params.getCurrentDragValue(e), this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }, t.prototype.listItemDragEnd = function() {
      var e = this;
      window.setTimeout(function() {
        e.currentDragValue = null, e.moveBlocked = !1;
      }, 10);
    }, t.prototype.createDropTarget = function() {
      var e = this, r = {
        isInterestedIn: function(n) {
          return n === e.params.dragSourceType;
        },
        getIconName: function() {
          return e.moveBlocked ? fn.ICON_PINNED : fn.ICON_MOVE;
        },
        getContainer: function() {
          return e.comp.getGui();
        },
        onDragging: function(n) {
          return e.onDragging(n);
        },
        onDragStop: function() {
          return e.onDragStop();
        },
        onDragLeave: function() {
          return e.onDragLeave();
        }
      };
      this.dragAndDropService.addDropTarget(r);
    }, t.prototype.createAutoScrollService = function() {
      var e = this.virtualList.getGui();
      this.autoScrollService = new u_({
        scrollContainer: e,
        scrollAxis: "y",
        getVerticalPosition: function() {
          return e.scrollTop;
        },
        setVerticalPosition: function(r) {
          return e.scrollTop = r;
        }
      });
    }, t.prototype.onDragging = function(e) {
      if (!(!this.currentDragValue || this.moveBlocked)) {
        var r = this.getListDragItem(e), n = this.virtualList.getComponentAt(r.rowIndex);
        if (n) {
          var i = n.getGui().parentElement;
          this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === r.rowIndex && this.lastHoveredListItem.position === r.position || (this.autoScrollService.check(e.event), this.clearHoveredItems(), this.lastHoveredListItem = r, LS(i, Yw), LS(i, "ag-item-highlight-".concat(r.position)));
        }
      }
    }, t.prototype.getListDragItem = function(e) {
      var r = this.virtualList.getGui(), n = parseFloat(window.getComputedStyle(r).paddingTop), i = this.virtualList.getRowHeight(), a = this.virtualList.getScrollTop(), s = Math.max(0, (e.y - n + a) / i), l = this.params.getNumRows(this.comp) - 1, u = Math.min(l, s) | 0;
      return {
        rowIndex: u,
        position: Math.round(s) > s || s > l ? "bottom" : "top",
        component: this.virtualList.getComponentAt(u)
      };
    }, t.prototype.onDragStop = function() {
      this.moveBlocked || (this.params.moveItem(this.currentDragValue, this.lastHoveredListItem), this.clearHoveredItems(), this.autoScrollService.ensureCleared());
    }, t.prototype.onDragLeave = function() {
      this.clearHoveredItems(), this.autoScrollService.ensureCleared();
    }, t.prototype.clearHoveredItems = function() {
      var e = this.virtualList.getGui();
      e.querySelectorAll(".".concat(Yw)).forEach(function(r) {
        [
          Yw,
          "ag-item-highlight-top",
          "ag-item-highlight-bottom"
        ].forEach(function(n) {
          r.classList.remove(n);
        });
      }), this.lastHoveredListItem = null;
    }, BO([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), BO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), Na;
(function(o) {
  o[o.Above = 0] = "Above", o[o.Below = 1] = "Below";
})(Na || (Na = {}));
var At = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
};
function ec(o) {
  var t = o, e = t != null && t.getFrameworkComponentInstance != null;
  return e ? t.getFrameworkComponentInstance() : o;
}
var c_ = (
  /** @class */
  function() {
    function o() {
      this.detailGridInfoMap = {}, this.destroyCalled = !1;
    }
    return o.prototype.init = function() {
      var t = this;
      switch (this.rowModel.getType()) {
        case "clientSide":
          this.clientSideRowModel = this.rowModel;
          break;
        case "infinite":
          this.infiniteRowModel = this.rowModel;
          break;
        case "serverSide":
          this.serverSideRowModel = this.rowModel;
          break;
      }
      this.ctrlsService.whenReady(function() {
        t.gridBodyCtrl = t.ctrlsService.getGridBodyCtrl();
      });
    }, o.prototype.__getAlignedGridService = function() {
      return this.alignedGridsService;
    }, o.prototype.__getContext = function() {
      return this.context;
    }, o.prototype.getGridId = function() {
      return this.context.getGridId();
    }, o.prototype.addDetailGridInfo = function(t, e) {
      this.detailGridInfoMap[t] = e;
    }, o.prototype.removeDetailGridInfo = function(t) {
      this.detailGridInfoMap[t] = void 0;
    }, o.prototype.getDetailGridInfo = function(t) {
      return this.detailGridInfoMap[t];
    }, o.prototype.forEachDetailGridInfo = function(t) {
      var e = 0;
      Xn(this.detailGridInfoMap, function(r, n) {
        Oe(n) && (t(n, e), e++);
      });
    }, o.prototype.getDataAsCsv = function(t) {
      if (Xt.__assertRegistered(Ye.CsvExportModule, "api.getDataAsCsv", this.context.getGridId()))
        return this.csvCreator.getDataAsCsv(t);
    }, o.prototype.exportDataAsCsv = function(t) {
      Xt.__assertRegistered(Ye.CsvExportModule, "api.exportDataAsCSv", this.context.getGridId()) && this.csvCreator.exportDataAsCsv(t);
    }, o.prototype.assertNotExcelMultiSheet = function(t, e) {
      return Xt.__assertRegistered(Ye.ExcelExportModule, "api." + t, this.context.getGridId()) ? this.excelCreator.getFactoryMode() === Jh.MULTI_SHEET ? (console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'"), !1) : !0 : !1;
    }, o.prototype.getDataAsExcel = function(t) {
      if (this.assertNotExcelMultiSheet("getDataAsExcel", t))
        return this.excelCreator.getDataAsExcel(t);
    }, o.prototype.exportDataAsExcel = function(t) {
      this.assertNotExcelMultiSheet("exportDataAsExcel", t) && this.excelCreator.exportDataAsExcel(t);
    }, o.prototype.getSheetDataForExcel = function(t) {
      if (Xt.__assertRegistered(Ye.ExcelExportModule, "api.getSheetDataForExcel", this.context.getGridId()))
        return this.excelCreator.setFactoryMode(Jh.MULTI_SHEET), this.excelCreator.getSheetDataForExcel(t);
    }, o.prototype.getMultipleSheetsAsExcel = function(t) {
      if (Xt.__assertRegistered(Ye.ExcelExportModule, "api.getMultipleSheetsAsExcel", this.context.getGridId()))
        return this.excelCreator.getMultipleSheetsAsExcel(t);
    }, o.prototype.exportMultipleSheetsAsExcel = function(t) {
      if (Xt.__assertRegistered(Ye.ExcelExportModule, "api.exportMultipleSheetsAsExcel", this.context.getGridId()))
        return this.excelCreator.exportMultipleSheetsAsExcel(t);
    }, o.prototype.setGridAriaProperty = function(t, e) {
      if (t) {
        var r = this.ctrlsService.getGridBodyCtrl().getGui(), n = "aria-".concat(t);
        e === null ? r.removeAttribute(n) : r.setAttribute(n, e);
      }
    }, o.prototype.logMissingRowModel = function(t) {
      for (var e = [], r = 1; r < arguments.length; r++)
        e[r - 1] = arguments[r];
      console.error("AG Grid: api.".concat(t, " can only be called when gridOptions.rowModelType is ").concat(e.join(" or ")));
    }, o.prototype.getPinnedTopRowCount = function() {
      return this.pinnedRowModel.getPinnedTopRowCount();
    }, o.prototype.getPinnedBottomRowCount = function() {
      return this.pinnedRowModel.getPinnedBottomRowCount();
    }, o.prototype.getPinnedTopRow = function(t) {
      return this.pinnedRowModel.getPinnedTopRow(t);
    }, o.prototype.getPinnedBottomRow = function(t) {
      return this.pinnedRowModel.getPinnedBottomRow(t);
    }, o.prototype.expireValueCache = function() {
      this.valueCache.expire();
    }, o.prototype.getVerticalPixelRange = function() {
      return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
    }, o.prototype.getHorizontalPixelRange = function() {
      return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
    }, o.prototype.refreshCells = function(t) {
      var e = this;
      t === void 0 && (t = {}), this.frameworkOverrides.wrapIncoming(function() {
        return e.rowRenderer.refreshCells(t);
      });
    }, o.prototype.flashCells = function(t) {
      var e = this;
      t === void 0 && (t = {}), this.frameworkOverrides.wrapIncoming(function() {
        return e.rowRenderer.flashCells(t);
      });
    }, o.prototype.redrawRows = function(t) {
      var e = this;
      t === void 0 && (t = {});
      var r = t ? t.rowNodes : void 0;
      this.frameworkOverrides.wrapIncoming(function() {
        return e.rowRenderer.redrawRows(r);
      });
    }, o.prototype.refreshHeader = function() {
      var t = this;
      this.frameworkOverrides.wrapIncoming(function() {
        return t.ctrlsService.getHeaderRowContainerCtrls().forEach(function(e) {
          return e.refresh();
        });
      });
    }, o.prototype.isAnyFilterPresent = function() {
      return this.filterManager.isAnyFilterPresent();
    }, o.prototype.isColumnFilterPresent = function() {
      return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
    }, o.prototype.isQuickFilterPresent = function() {
      return this.filterManager.isQuickFilterPresent();
    }, o.prototype.getModel = function() {
      return this.rowModel;
    }, o.prototype.setRowNodeExpanded = function(t, e, r) {
      this.expansionService.setRowNodeExpanded(t, e, r);
    }, o.prototype.onGroupExpandedOrCollapsed = function() {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
        return;
      }
      this.expansionService.onGroupExpandedOrCollapsed();
    }, o.prototype.refreshClientSideRowModel = function(t) {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
        return;
      }
      this.clientSideRowModel.refreshModel(t);
    }, o.prototype.isAnimationFrameQueueEmpty = function() {
      return this.animationFrameService.isQueueEmpty();
    }, o.prototype.flushAllAnimationFrames = function() {
      this.animationFrameService.flushAllFrames();
    }, o.prototype.getRowNode = function(t) {
      return this.rowModel.getRowNode(t);
    }, o.prototype.getSizesForCurrentTheme = function() {
      return {
        rowHeight: this.gos.getRowHeightAsNumber(),
        headerHeight: this.columnModel.getHeaderHeight()
      };
    }, o.prototype.expandAll = function() {
      this.clientSideRowModel || this.serverSideRowModel ? this.expansionService.expandAll(!0) : this.logMissingRowModel("expandAll", "clientSide", "serverSide");
    }, o.prototype.collapseAll = function() {
      this.clientSideRowModel || this.serverSideRowModel ? this.expansionService.expandAll(!1) : this.logMissingRowModel("collapseAll", "clientSide", "serverSide");
    }, o.prototype.addRenderedRowListener = function(t, e, r) {
      this.rowRenderer.addRenderedRowListener(t, e, r);
    }, o.prototype.getQuickFilter = function() {
      return this.gos.get("quickFilterText");
    }, o.prototype.getAdvancedFilterModel = function() {
      return Xt.__assertRegistered(Ye.AdvancedFilterModule, "api.getAdvancedFilterModel", this.context.getGridId()) ? this.filterManager.getAdvancedFilterModel() : null;
    }, o.prototype.setAdvancedFilterModel = function(t) {
      this.filterManager.setAdvancedFilterModel(t);
    }, o.prototype.showAdvancedFilterBuilder = function() {
      Xt.__assertRegistered(Ye.AdvancedFilterModule, "api.setAdvancedFilterModel", this.context.getGridId()) && this.filterManager.showAdvancedFilterBuilder("api");
    }, o.prototype.setNodesSelected = function(t) {
      var e = t.nodes.every(function(s) {
        return s.rowPinned ? (console.warn("AG Grid: cannot select pinned rows"), !1) : s.id === void 0 ? (console.warn("AG Grid: cannot select node until id for node is known"), !1) : !0;
      });
      if (e) {
        var r = t.nodes, n = t.source, i = t.newValue, a = r;
        this.selectionService.setNodesSelected({ nodes: a, source: n ?? "api", newValue: i });
      }
    }, o.prototype.selectAll = function(t) {
      t === void 0 && (t = "apiSelectAll"), this.selectionService.selectAllRowNodes({ source: t });
    }, o.prototype.deselectAll = function(t) {
      t === void 0 && (t = "apiSelectAll"), this.selectionService.deselectAllRowNodes({ source: t });
    }, o.prototype.selectAllFiltered = function(t) {
      t === void 0 && (t = "apiSelectAllFiltered"), this.selectionService.selectAllRowNodes({ source: t, justFiltered: !0 });
    }, o.prototype.deselectAllFiltered = function(t) {
      t === void 0 && (t = "apiSelectAllFiltered"), this.selectionService.deselectAllRowNodes({ source: t, justFiltered: !0 });
    }, o.prototype.getServerSideSelectionState = function() {
      return tt(this.serverSideRowModel) ? (this.logMissingRowModel("getServerSideSelectionState", "serverSide"), null) : this.selectionService.getSelectionState();
    }, o.prototype.setServerSideSelectionState = function(t) {
      if (tt(this.serverSideRowModel)) {
        this.logMissingRowModel("setServerSideSelectionState", "serverSide");
        return;
      }
      this.selectionService.setSelectionState(t, "api");
    }, o.prototype.selectAllOnCurrentPage = function(t) {
      t === void 0 && (t = "apiSelectAllCurrentPage"), this.selectionService.selectAllRowNodes({ source: t, justCurrentPage: !0 });
    }, o.prototype.deselectAllOnCurrentPage = function(t) {
      t === void 0 && (t = "apiSelectAllCurrentPage"), this.selectionService.deselectAllRowNodes({ source: t, justCurrentPage: !0 });
    }, o.prototype.showLoadingOverlay = function() {
      this.overlayService.showLoadingOverlay();
    }, o.prototype.showNoRowsOverlay = function() {
      this.overlayService.showNoRowsOverlay();
    }, o.prototype.hideOverlay = function() {
      this.overlayService.hideOverlay();
    }, o.prototype.getSelectedNodes = function() {
      return this.selectionService.getSelectedNodes();
    }, o.prototype.getSelectedRows = function() {
      return this.selectionService.getSelectedRows();
    }, o.prototype.getBestCostNodeSelection = function() {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
        return;
      }
      return this.selectionService.getBestCostNodeSelection();
    }, o.prototype.getRenderedNodes = function() {
      return this.rowRenderer.getRenderedNodes();
    }, o.prototype.ensureColumnVisible = function(t, e) {
      var r = this;
      e === void 0 && (e = "auto"), this.frameworkOverrides.wrapIncoming(function() {
        return r.gridBodyCtrl.getScrollFeature().ensureColumnVisible(t, e);
      });
    }, o.prototype.ensureIndexVisible = function(t, e) {
      var r = this;
      this.frameworkOverrides.wrapIncoming(function() {
        return r.gridBodyCtrl.getScrollFeature().ensureIndexVisible(t, e);
      });
    }, o.prototype.ensureNodeVisible = function(t, e) {
      var r = this;
      e === void 0 && (e = null), this.frameworkOverrides.wrapIncoming(function() {
        return r.gridBodyCtrl.getScrollFeature().ensureNodeVisible(t, e);
      });
    }, o.prototype.forEachLeafNode = function(t) {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachLeafNode", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachLeafNode(t);
    }, o.prototype.forEachNode = function(t, e) {
      this.rowModel.forEachNode(t, e);
    }, o.prototype.forEachNodeAfterFilter = function(t) {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachNodeAfterFilter(t);
    }, o.prototype.forEachNodeAfterFilterAndSort = function(t) {
      if (tt(this.clientSideRowModel)) {
        this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
        return;
      }
      this.clientSideRowModel.forEachNodeAfterFilterAndSort(t);
    }, o.prototype.getFilterInstance = function(t, e) {
      return this.filterManager.getFilterInstance(t, e);
    }, o.prototype.getColumnFilterInstance = function(t) {
      return this.filterManager.getColumnFilterInstance(t);
    }, o.prototype.destroyFilter = function(t) {
      var e = this.columnModel.getPrimaryColumn(t);
      if (e)
        return this.filterManager.destroyFilter(e, "api");
    }, o.prototype.getStatusPanel = function(t) {
      if (Xt.__assertRegistered(Ye.StatusBarModule, "api.getStatusPanel", this.context.getGridId())) {
        var e = this.statusBarService.getStatusPanel(t);
        return ec(e);
      }
    }, o.prototype.getColumnDef = function(t) {
      var e = this.columnModel.getPrimaryColumn(t);
      return e ? e.getColDef() : null;
    }, o.prototype.getColumnDefs = function() {
      return this.columnModel.getColumnDefs();
    }, o.prototype.onFilterChanged = function(t) {
      t === void 0 && (t = "api"), this.filterManager.onFilterChanged({ source: t });
    }, o.prototype.onSortChanged = function() {
      this.sortController.onSortChanged("api");
    }, o.prototype.setFilterModel = function(t) {
      var e = this;
      this.frameworkOverrides.wrapIncoming(function() {
        return e.filterManager.setFilterModel(t);
      });
    }, o.prototype.getFilterModel = function() {
      return this.filterManager.getFilterModel();
    }, o.prototype.getColumnFilterModel = function(t) {
      return this.filterManager.getColumnFilterModel(t);
    }, o.prototype.setColumnFilterModel = function(t, e) {
      return this.filterManager.setColumnFilterModel(t, e);
    }, o.prototype.getFocusedCell = function() {
      return this.focusService.getFocusedCell();
    }, o.prototype.clearFocusedCell = function() {
      return this.focusService.clearFocusedCell();
    }, o.prototype.setFocusedCell = function(t, e, r) {
      this.focusService.setFocusedCell({ rowIndex: t, column: e, rowPinned: r, forceBrowserFocus: !0 });
    }, o.prototype.addRowDropZone = function(t) {
      this.gridBodyCtrl.getRowDragFeature().addRowDropZone(t);
    }, o.prototype.removeRowDropZone = function(t) {
      var e = this.dragAndDropService.findExternalZone(t);
      e && this.dragAndDropService.removeDropTarget(e);
    }, o.prototype.getRowDropZoneParams = function(t) {
      return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(t);
    }, o.prototype.assertSideBarLoaded = function(t) {
      return Xt.__assertRegistered(Ye.SideBarModule, "api." + t, this.context.getGridId());
    }, o.prototype.isSideBarVisible = function() {
      return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarService.getSideBarComp().isDisplayed();
    }, o.prototype.setSideBarVisible = function(t) {
      this.assertSideBarLoaded("setSideBarVisible") && this.sideBarService.getSideBarComp().setDisplayed(t);
    }, o.prototype.setSideBarPosition = function(t) {
      this.assertSideBarLoaded("setSideBarPosition") && this.sideBarService.getSideBarComp().setSideBarPosition(t);
    }, o.prototype.openToolPanel = function(t) {
      this.assertSideBarLoaded("openToolPanel") && this.sideBarService.getSideBarComp().openToolPanel(t, "api");
    }, o.prototype.closeToolPanel = function() {
      this.assertSideBarLoaded("closeToolPanel") && this.sideBarService.getSideBarComp().close("api");
    }, o.prototype.getOpenedToolPanel = function() {
      return this.assertSideBarLoaded("getOpenedToolPanel") ? this.sideBarService.getSideBarComp().openedItem() : null;
    }, o.prototype.refreshToolPanel = function() {
      this.assertSideBarLoaded("refreshToolPanel") && this.sideBarService.getSideBarComp().refresh();
    }, o.prototype.isToolPanelShowing = function() {
      return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarService.getSideBarComp().isToolPanelShowing();
    }, o.prototype.getToolPanelInstance = function(t) {
      if (this.assertSideBarLoaded("getToolPanelInstance")) {
        var e = this.sideBarService.getSideBarComp().getToolPanelInstance(t);
        return ec(e);
      }
    }, o.prototype.getSideBar = function() {
      if (this.assertSideBarLoaded("getSideBar"))
        return this.sideBarService.getSideBarComp().getDef();
    }, o.prototype.resetRowHeights = function() {
      if (Oe(this.clientSideRowModel)) {
        if (this.columnModel.isAutoRowHeightActive()) {
          console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
          return;
        }
        this.clientSideRowModel.resetRowHeights();
      }
    }, o.prototype.setRowCount = function(t, e) {
      if (this.serverSideRowModel) {
        if (this.columnModel.isRowGroupEmpty()) {
          this.serverSideRowModel.setRowCount(t, e);
          return;
        }
        console.error("AG Grid: setRowCount cannot be used while using row grouping.");
        return;
      }
      if (this.infiniteRowModel) {
        this.infiniteRowModel.setRowCount(t, e);
        return;
      }
      this.logMissingRowModel("setRowCount", "infinite", "serverSide");
    }, o.prototype.onRowHeightChanged = function() {
      this.clientSideRowModel ? this.clientSideRowModel.onRowHeightChanged() : this.serverSideRowModel && this.serverSideRowModel.onRowHeightChanged();
    }, o.prototype.getValue = function(t, e) {
      var r = this.columnModel.getPrimaryColumn(t);
      return tt(r) && (r = this.columnModel.getGridColumn(t)), tt(r) ? null : this.valueService.getValue(r, e);
    }, o.prototype.addEventListener = function(t, e) {
      this.apiEventService.addEventListener(t, e);
    }, o.prototype.addGlobalListener = function(t) {
      this.apiEventService.addGlobalListener(t);
    }, o.prototype.removeEventListener = function(t, e) {
      this.apiEventService.removeEventListener(t, e);
    }, o.prototype.removeGlobalListener = function(t) {
      this.apiEventService.removeGlobalListener(t);
    }, o.prototype.dispatchEvent = function(t) {
      this.eventService.dispatchEvent(t);
    }, o.prototype.destroy = function() {
      var t = "See ".concat(this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed"));
      if (!this.destroyCalled) {
        var e = {
          type: G.EVENT_GRID_PRE_DESTROYED,
          state: this.getState()
        };
        this.dispatchEvent(e), this.destroyCalled = !0;
        var r = this.ctrlsService.getGridCtrl();
        r && r.destroyGridUi(), this.context.destroy(), ZF(this, ["isDestroyed"], t);
      }
    }, o.prototype.isDestroyed = function() {
      return this.destroyCalled;
    }, o.prototype.resetQuickFilter = function() {
      this.filterManager.resetQuickFilterCache();
    }, o.prototype.getCellRanges = function() {
      return this.rangeService ? this.rangeService.getCellRanges() : (Xt.__assertRegistered(Ye.RangeSelectionModule, "api.getCellRanges", this.context.getGridId()), null);
    }, o.prototype.addCellRange = function(t) {
      if (this.rangeService) {
        this.rangeService.addCellRange(t);
        return;
      }
      Xt.__assertRegistered(Ye.RangeSelectionModule, "api.addCellRange", this.context.getGridId());
    }, o.prototype.clearRangeSelection = function() {
      this.rangeService && this.rangeService.removeAllCellRanges(), Xt.__assertRegistered(Ye.RangeSelectionModule, "gridApi.clearRangeSelection", this.context.getGridId());
    }, o.prototype.undoCellEditing = function() {
      this.undoRedoService.undo("api");
    }, o.prototype.redoCellEditing = function() {
      this.undoRedoService.redo("api");
    }, o.prototype.getCurrentUndoSize = function() {
      return this.undoRedoService.getCurrentUndoStackSize();
    }, o.prototype.getCurrentRedoSize = function() {
      return this.undoRedoService.getCurrentRedoStackSize();
    }, o.prototype.assertChart = function(t, e) {
      if (Xt.__assertRegistered(Ye.GridChartsModule, "api." + t, this.context.getGridId()))
        return this.frameworkOverrides.wrapIncoming(function() {
          return e();
        });
    }, o.prototype.getChartModels = function() {
      var t = this;
      return this.assertChart("getChartModels", function() {
        return t.chartService.getChartModels();
      });
    }, o.prototype.getChartRef = function(t) {
      var e = this;
      return this.assertChart("getChartRef", function() {
        return e.chartService.getChartRef(t);
      });
    }, o.prototype.getChartImageDataURL = function(t) {
      var e = this;
      return this.assertChart("getChartImageDataURL", function() {
        return e.chartService.getChartImageDataURL(t);
      });
    }, o.prototype.downloadChart = function(t) {
      var e = this;
      return this.assertChart("downloadChart", function() {
        return e.chartService.downloadChart(t);
      });
    }, o.prototype.openChartToolPanel = function(t) {
      var e = this;
      return this.assertChart("openChartToolPanel", function() {
        return e.chartService.openChartToolPanel(t);
      });
    }, o.prototype.closeChartToolPanel = function(t) {
      var e = this;
      return this.assertChart("closeChartToolPanel", function() {
        return e.chartService.closeChartToolPanel(t.chartId);
      });
    }, o.prototype.createRangeChart = function(t) {
      var e = this;
      return this.assertChart("createRangeChart", function() {
        return e.chartService.createRangeChart(t);
      });
    }, o.prototype.createPivotChart = function(t) {
      var e = this;
      return this.assertChart("createPivotChart", function() {
        return e.chartService.createPivotChart(t);
      });
    }, o.prototype.createCrossFilterChart = function(t) {
      var e = this;
      return this.assertChart("createCrossFilterChart", function() {
        return e.chartService.createCrossFilterChart(t);
      });
    }, o.prototype.updateChart = function(t) {
      var e = this;
      return this.assertChart("updateChart", function() {
        return e.chartService.updateChart(t);
      });
    }, o.prototype.restoreChart = function(t, e) {
      var r = this;
      return this.assertChart("restoreChart", function() {
        return r.chartService.restoreChart(t, e);
      });
    }, o.prototype.assertClipboard = function(t, e) {
      Xt.__assertRegistered(Ye.ClipboardModule, "api" + t, this.context.getGridId()) && e();
    }, o.prototype.copyToClipboard = function(t) {
      var e = this;
      this.assertClipboard("copyToClipboard", function() {
        return e.clipboardService.copyToClipboard(t);
      });
    }, o.prototype.cutToClipboard = function(t) {
      var e = this;
      this.assertClipboard("cutToClipboard", function() {
        return e.clipboardService.cutToClipboard(t);
      });
    }, o.prototype.copySelectedRowsToClipboard = function(t) {
      var e = this;
      this.assertClipboard("copySelectedRowsToClipboard", function() {
        return e.clipboardService.copySelectedRowsToClipboard(t);
      });
    }, o.prototype.copySelectedRangeToClipboard = function(t) {
      var e = this;
      this.assertClipboard("copySelectedRangeToClipboard", function() {
        return e.clipboardService.copySelectedRangeToClipboard(t);
      });
    }, o.prototype.copySelectedRangeDown = function() {
      var t = this;
      this.assertClipboard("copySelectedRangeDown", function() {
        return t.clipboardService.copyRangeDown();
      });
    }, o.prototype.pasteFromClipboard = function() {
      var t = this;
      this.assertClipboard("pasteFromClipboard", function() {
        return t.clipboardService.pasteFromClipboard();
      });
    }, o.prototype.showColumnMenuAfterButtonClick = function(t, e) {
      var r = this.columnModel.getGridColumn(t);
      this.menuFactory.showMenuAfterButtonClick(r, e, "columnMenu");
    }, o.prototype.showColumnMenuAfterMouseClick = function(t, e) {
      var r = this.columnModel.getGridColumn(t);
      if (r || (r = this.columnModel.getPrimaryColumn(t)), !r) {
        console.error("AG Grid: column '".concat(t, "' not found"));
        return;
      }
      this.menuFactory.showMenuAfterMouseEvent(r, e);
    }, o.prototype.hidePopupMenu = function() {
      this.contextMenuFactory && this.contextMenuFactory.hideActiveMenu(), this.menuFactory.hideActiveMenu();
    }, o.prototype.tabToNextCell = function(t) {
      return this.navigationService.tabToNextCell(!1, t);
    }, o.prototype.tabToPreviousCell = function(t) {
      return this.navigationService.tabToNextCell(!0, t);
    }, o.prototype.getCellRendererInstances = function(t) {
      t === void 0 && (t = {});
      var e = this.rowRenderer.getCellRendererInstances(t), r = e.map(ec);
      return r;
    }, o.prototype.getCellEditorInstances = function(t) {
      t === void 0 && (t = {});
      var e = this.rowRenderer.getCellEditorInstances(t), r = e.map(ec);
      return r;
    }, o.prototype.getEditingCells = function() {
      return this.rowRenderer.getEditingCells();
    }, o.prototype.stopEditing = function(t) {
      t === void 0 && (t = !1), this.rowRenderer.stopEditing(t);
    }, o.prototype.startEditingCell = function(t) {
      var e = this.columnModel.getGridColumn(t.colKey);
      if (!e) {
        console.warn("AG Grid: no column found for ".concat(t.colKey));
        return;
      }
      var r = {
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned || null,
        column: e
      }, n = t.rowPinned == null;
      n && this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(t.rowIndex);
      var i = this.navigationService.getCellByPosition(r);
      i && (this.focusService.isCellFocused(r) || this.focusService.setFocusedCell(r), i.startRowOrCellEdit(t.key));
    }, o.prototype.addAggFunc = function(t, e) {
      this.aggFuncService && this.aggFuncService.addAggFunc(t, e);
    }, o.prototype.addAggFuncs = function(t) {
      this.aggFuncService && this.aggFuncService.addAggFuncs(t);
    }, o.prototype.clearAggFuncs = function() {
      this.aggFuncService && this.aggFuncService.clear();
    }, o.prototype.applyServerSideTransaction = function(t) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransaction", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.applyTransaction(t);
    }, o.prototype.applyServerSideTransactionAsync = function(t, e) {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.applyTransactionAsync(t, e);
    }, o.prototype.applyServerSideRowData = function(t) {
      var e, r, n = (e = t.startRow) !== null && e !== void 0 ? e : 0, i = (r = t.route) !== null && r !== void 0 ? r : [];
      if (n < 0) {
        console.warn("AG Grid: invalid value ".concat(t.startRow, " for startRow, the value should be >= 0"));
        return;
      }
      this.serverSideRowModel ? this.serverSideRowModel.applyRowData(t.successParams, n, i) : this.logMissingRowModel("setServerSideDatasource", "serverSide");
    }, o.prototype.retryServerSideLoads = function() {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("retryServerSideLoads", "serverSide");
        return;
      }
      this.serverSideRowModel.retryLoads();
    }, o.prototype.flushServerSideAsyncTransactions = function() {
      if (!this.serverSideTransactionManager) {
        this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
        return;
      }
      return this.serverSideTransactionManager.flushAsyncTransactions();
    }, o.prototype.applyTransaction = function(t) {
      var e = this;
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransaction", "clientSide");
        return;
      }
      return this.frameworkOverrides.wrapIncoming(function() {
        return e.clientSideRowModel.updateRowData(t);
      });
    }, o.prototype.applyTransactionAsync = function(t, e) {
      var r = this;
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("applyTransactionAsync", "clientSide");
        return;
      }
      this.frameworkOverrides.wrapIncoming(function() {
        return r.clientSideRowModel.batchUpdateRowData(t, e);
      });
    }, o.prototype.flushAsyncTransactions = function() {
      var t = this;
      if (!this.clientSideRowModel) {
        this.logMissingRowModel("flushAsyncTransactions", "clientSide");
        return;
      }
      this.frameworkOverrides.wrapIncoming(function() {
        return t.clientSideRowModel.flushAsyncTransactions();
      });
    }, o.prototype.refreshInfiniteCache = function() {
      this.infiniteRowModel ? this.infiniteRowModel.refreshCache() : this.logMissingRowModel("refreshInfiniteCache", "infinite");
    }, o.prototype.purgeInfiniteCache = function() {
      this.infiniteRowModel ? this.infiniteRowModel.purgeCache() : this.logMissingRowModel("purgeInfiniteCache", "infinite");
    }, o.prototype.refreshServerSide = function(t) {
      if (!this.serverSideRowModel) {
        this.logMissingRowModel("refreshServerSide", "serverSide");
        return;
      }
      this.serverSideRowModel.refreshStore(t);
    }, o.prototype.getServerSideGroupLevelState = function() {
      return this.serverSideRowModel ? this.serverSideRowModel.getStoreState() : (this.logMissingRowModel("getServerSideGroupLevelState", "serverSide"), []);
    }, o.prototype.getInfiniteRowCount = function() {
      if (this.infiniteRowModel)
        return this.infiniteRowModel.getRowCount();
      this.logMissingRowModel("getInfiniteRowCount", "infinite");
    }, o.prototype.isLastRowIndexKnown = function() {
      if (this.infiniteRowModel)
        return this.infiniteRowModel.isLastRowIndexKnown();
      this.logMissingRowModel("isLastRowIndexKnown", "infinite");
    }, o.prototype.getCacheBlockState = function() {
      return this.rowNodeBlockLoader.getBlockState();
    }, o.prototype.getFirstDisplayedRow = function() {
      return this.rowRenderer.getFirstVirtualRenderedRow();
    }, o.prototype.getLastDisplayedRow = function() {
      return this.rowRenderer.getLastVirtualRenderedRow();
    }, o.prototype.getDisplayedRowAtIndex = function(t) {
      return this.rowModel.getRow(t);
    }, o.prototype.getDisplayedRowCount = function() {
      return this.rowModel.getRowCount();
    }, o.prototype.paginationIsLastPageFound = function() {
      return this.paginationProxy.isLastPageFound();
    }, o.prototype.paginationGetPageSize = function() {
      return this.paginationProxy.getPageSize();
    }, o.prototype.paginationGetCurrentPage = function() {
      return this.paginationProxy.getCurrentPage();
    }, o.prototype.paginationGetTotalPages = function() {
      return this.paginationProxy.getTotalPages();
    }, o.prototype.paginationGetRowCount = function() {
      return this.paginationProxy.getMasterRowCount();
    }, o.prototype.paginationGoToNextPage = function() {
      this.paginationProxy.goToNextPage();
    }, o.prototype.paginationGoToPreviousPage = function() {
      this.paginationProxy.goToPreviousPage();
    }, o.prototype.paginationGoToFirstPage = function() {
      this.paginationProxy.goToFirstPage();
    }, o.prototype.paginationGoToLastPage = function() {
      this.paginationProxy.goToLastPage();
    }, o.prototype.paginationGoToPage = function(t) {
      this.paginationProxy.goToPage(t);
    }, o.prototype.sizeColumnsToFit = function(t) {
      typeof t == "number" ? this.columnModel.sizeColumnsToFit(t, "api") : this.gridBodyCtrl.sizeColumnsToFit(t);
    }, o.prototype.setColumnGroupOpened = function(t, e) {
      this.columnModel.setColumnGroupOpened(t, e, "api");
    }, o.prototype.getColumnGroup = function(t, e) {
      return this.columnModel.getColumnGroup(t, e);
    }, o.prototype.getProvidedColumnGroup = function(t) {
      return this.columnModel.getProvidedColumnGroup(t);
    }, o.prototype.getDisplayNameForColumn = function(t, e) {
      return this.columnModel.getDisplayNameForColumn(t, e) || "";
    }, o.prototype.getDisplayNameForColumnGroup = function(t, e) {
      return this.columnModel.getDisplayNameForColumnGroup(t, e) || "";
    }, o.prototype.getColumn = function(t) {
      return this.columnModel.getPrimaryColumn(t);
    }, o.prototype.getColumns = function() {
      return this.columnModel.getAllPrimaryColumns();
    }, o.prototype.applyColumnState = function(t) {
      return this.columnModel.applyColumnState(t, "api");
    }, o.prototype.getColumnState = function() {
      return this.columnModel.getColumnState();
    }, o.prototype.resetColumnState = function() {
      this.columnModel.resetColumnState("api");
    }, o.prototype.getColumnGroupState = function() {
      return this.columnModel.getColumnGroupState();
    }, o.prototype.setColumnGroupState = function(t) {
      this.columnModel.setColumnGroupState(t, "api");
    }, o.prototype.resetColumnGroupState = function() {
      this.columnModel.resetColumnGroupState("api");
    }, o.prototype.isPinning = function() {
      return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
    }, o.prototype.isPinningLeft = function() {
      return this.columnModel.isPinningLeft();
    }, o.prototype.isPinningRight = function() {
      return this.columnModel.isPinningRight();
    }, o.prototype.getDisplayedColAfter = function(t) {
      return this.columnModel.getDisplayedColAfter(t);
    }, o.prototype.getDisplayedColBefore = function(t) {
      return this.columnModel.getDisplayedColBefore(t);
    }, o.prototype.setColumnVisible = function(t, e) {
      this.columnModel.setColumnVisible(t, e, "api");
    }, o.prototype.setColumnsVisible = function(t, e) {
      this.columnModel.setColumnsVisible(t, e, "api");
    }, o.prototype.setColumnPinned = function(t, e) {
      this.columnModel.setColumnPinned(t, e, "api");
    }, o.prototype.setColumnsPinned = function(t, e) {
      this.columnModel.setColumnsPinned(t, e, "api");
    }, o.prototype.getAllGridColumns = function() {
      return this.columnModel.getAllGridColumns();
    }, o.prototype.getDisplayedLeftColumns = function() {
      return this.columnModel.getDisplayedLeftColumns();
    }, o.prototype.getDisplayedCenterColumns = function() {
      return this.columnModel.getDisplayedCenterColumns();
    }, o.prototype.getDisplayedRightColumns = function() {
      return this.columnModel.getDisplayedRightColumns();
    }, o.prototype.getAllDisplayedColumns = function() {
      return this.columnModel.getAllDisplayedColumns();
    }, o.prototype.getAllDisplayedVirtualColumns = function() {
      return this.columnModel.getViewportColumns();
    }, o.prototype.moveColumn = function(t, e) {
      this.columnModel.moveColumn(t, e, "api");
    }, o.prototype.moveColumnByIndex = function(t, e) {
      this.columnModel.moveColumnByIndex(t, e, "api");
    }, o.prototype.moveColumns = function(t, e) {
      this.columnModel.moveColumns(t, e, "api");
    }, o.prototype.moveRowGroupColumn = function(t, e) {
      this.columnModel.moveRowGroupColumn(t, e);
    }, o.prototype.setColumnAggFunc = function(t, e) {
      this.columnModel.setColumnAggFunc(t, e);
    }, o.prototype.setColumnWidth = function(t, e, r, n) {
      r === void 0 && (r = !0), this.columnModel.setColumnWidths([{ key: t, newWidth: e }], !1, r, n);
    }, o.prototype.setColumnWidths = function(t, e, r) {
      e === void 0 && (e = !0), this.columnModel.setColumnWidths(t, !1, e, r);
    }, o.prototype.isPivotMode = function() {
      return this.columnModel.isPivotMode();
    }, o.prototype.getPivotResultColumn = function(t, e) {
      return this.columnModel.getSecondaryPivotColumn(t, e);
    }, o.prototype.setValueColumns = function(t) {
      this.columnModel.setValueColumns(t, "api");
    }, o.prototype.getValueColumns = function() {
      return this.columnModel.getValueColumns();
    }, o.prototype.removeValueColumn = function(t) {
      this.columnModel.removeValueColumn(t, "api");
    }, o.prototype.removeValueColumns = function(t) {
      this.columnModel.removeValueColumns(t, "api");
    }, o.prototype.addValueColumn = function(t) {
      this.columnModel.addValueColumn(t, "api");
    }, o.prototype.addValueColumns = function(t) {
      this.columnModel.addValueColumns(t, "api");
    }, o.prototype.setRowGroupColumns = function(t) {
      this.columnModel.setRowGroupColumns(t, "api");
    }, o.prototype.removeRowGroupColumn = function(t) {
      this.columnModel.removeRowGroupColumn(t, "api");
    }, o.prototype.removeRowGroupColumns = function(t) {
      this.columnModel.removeRowGroupColumns(t, "api");
    }, o.prototype.addRowGroupColumn = function(t) {
      this.columnModel.addRowGroupColumn(t, "api");
    }, o.prototype.addRowGroupColumns = function(t) {
      this.columnModel.addRowGroupColumns(t, "api");
    }, o.prototype.getRowGroupColumns = function() {
      return this.columnModel.getRowGroupColumns();
    }, o.prototype.setPivotColumns = function(t) {
      this.columnModel.setPivotColumns(t, "api");
    }, o.prototype.removePivotColumn = function(t) {
      this.columnModel.removePivotColumn(t, "api");
    }, o.prototype.removePivotColumns = function(t) {
      this.columnModel.removePivotColumns(t, "api");
    }, o.prototype.addPivotColumn = function(t) {
      this.columnModel.addPivotColumn(t, "api");
    }, o.prototype.addPivotColumns = function(t) {
      this.columnModel.addPivotColumns(t, "api");
    }, o.prototype.getPivotColumns = function() {
      return this.columnModel.getPivotColumns();
    }, o.prototype.getLeftDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeLeft();
    }, o.prototype.getCenterDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeCentre();
    }, o.prototype.getRightDisplayedColumnGroups = function() {
      return this.columnModel.getDisplayedTreeRight();
    }, o.prototype.getAllDisplayedColumnGroups = function() {
      return this.columnModel.getAllDisplayedTrees();
    }, o.prototype.autoSizeColumn = function(t, e) {
      return this.columnModel.autoSizeColumn(t, e, "api");
    }, o.prototype.autoSizeColumns = function(t, e) {
      this.columnModel.autoSizeColumns({ columns: t, skipHeader: e });
    }, o.prototype.autoSizeAllColumns = function(t) {
      this.columnModel.autoSizeAllColumns(t, "api");
    }, o.prototype.setPivotResultColumns = function(t) {
      this.columnModel.setSecondaryColumns(t, "api");
    }, o.prototype.getPivotResultColumns = function() {
      return this.columnModel.getSecondaryColumns();
    }, o.prototype.getState = function() {
      return this.stateService.getState();
    }, o.prototype.getGridOption = function(t) {
      return this.gos.get(t);
    }, o.prototype.setGridOption = function(t, e) {
      var r;
      this.updateGridOptions((r = {}, r[t] = e, r));
    }, o.prototype.updateGridOptions = function(t) {
      this.gos.updateGridOptions({ options: t });
    }, o.prototype.__internalUpdateGridOptions = function(t) {
      this.gos.updateGridOptions({ options: t, source: "gridOptionsUpdated" });
    }, o.prototype.deprecatedUpdateGridOption = function(t, e) {
      ht("set".concat(t.charAt(0).toUpperCase()).concat(t.slice(1, t.length), " is deprecated. Please use 'api.setGridOption('").concat(t, "', newValue)' or 'api.updateGridOptions({ ").concat(t, ": newValue })' instead.")), this.setGridOption(t, e);
    }, o.prototype.setPivotMode = function(t) {
      this.deprecatedUpdateGridOption("pivotMode", t);
    }, o.prototype.setPinnedTopRowData = function(t) {
      this.deprecatedUpdateGridOption("pinnedTopRowData", t);
    }, o.prototype.setPinnedBottomRowData = function(t) {
      this.deprecatedUpdateGridOption("pinnedBottomRowData", t);
    }, o.prototype.setPopupParent = function(t) {
      this.deprecatedUpdateGridOption("popupParent", t);
    }, o.prototype.setSuppressModelUpdateAfterUpdateTransaction = function(t) {
      this.deprecatedUpdateGridOption("suppressModelUpdateAfterUpdateTransaction", t);
    }, o.prototype.setDataTypeDefinitions = function(t) {
      this.deprecatedUpdateGridOption("dataTypeDefinitions", t);
    }, o.prototype.setPagination = function(t) {
      this.deprecatedUpdateGridOption("pagination", t);
    }, o.prototype.paginationSetPageSize = function(t) {
      this.deprecatedUpdateGridOption("paginationPageSize", t);
    }, o.prototype.setSideBar = function(t) {
      this.deprecatedUpdateGridOption("sideBar", t);
    }, o.prototype.setSuppressClipboardPaste = function(t) {
      this.deprecatedUpdateGridOption("suppressClipboardPaste", t);
    }, o.prototype.setGroupRemoveSingleChildren = function(t) {
      this.deprecatedUpdateGridOption("groupRemoveSingleChildren", t);
    }, o.prototype.setGroupRemoveLowestSingleChildren = function(t) {
      this.deprecatedUpdateGridOption("groupRemoveLowestSingleChildren", t);
    }, o.prototype.setGroupDisplayType = function(t) {
      this.deprecatedUpdateGridOption("groupDisplayType", t);
    }, o.prototype.setGroupIncludeFooter = function(t) {
      this.deprecatedUpdateGridOption("groupIncludeFooter", t);
    }, o.prototype.setGroupIncludeTotalFooter = function(t) {
      this.deprecatedUpdateGridOption("groupIncludeTotalFooter", t);
    }, o.prototype.setRowClass = function(t) {
      this.deprecatedUpdateGridOption("rowClass", t);
    }, o.prototype.setDeltaSort = function(t) {
      this.deprecatedUpdateGridOption("deltaSort", t);
    }, o.prototype.setSuppressRowDrag = function(t) {
      this.deprecatedUpdateGridOption("suppressRowDrag", t);
    }, o.prototype.setSuppressMoveWhenRowDragging = function(t) {
      this.deprecatedUpdateGridOption("suppressMoveWhenRowDragging", t);
    }, o.prototype.setSuppressRowClickSelection = function(t) {
      this.deprecatedUpdateGridOption("suppressRowClickSelection", t);
    }, o.prototype.setEnableAdvancedFilter = function(t) {
      this.deprecatedUpdateGridOption("enableAdvancedFilter", t);
    }, o.prototype.setIncludeHiddenColumnsInAdvancedFilter = function(t) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInAdvancedFilter", t);
    }, o.prototype.setAdvancedFilterParent = function(t) {
      this.deprecatedUpdateGridOption("advancedFilterParent", t);
    }, o.prototype.setAdvancedFilterBuilderParams = function(t) {
      this.deprecatedUpdateGridOption("advancedFilterBuilderParams", t);
    }, o.prototype.setQuickFilter = function(t) {
      ht("setQuickFilter is deprecated. Please use 'api.setGridOption('quickFilterText', newValue)' or 'api.updateGridOptions({ quickFilterText: newValue })' instead."), this.gos.updateGridOptions({ options: { quickFilterText: t } });
    }, o.prototype.setExcludeHiddenColumnsFromQuickFilter = function(t) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", !t);
    }, o.prototype.setIncludeHiddenColumnsInQuickFilter = function(t) {
      this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", t);
    }, o.prototype.setQuickFilterParser = function(t) {
      this.deprecatedUpdateGridOption("quickFilterParser", t);
    }, o.prototype.setQuickFilterMatcher = function(t) {
      this.deprecatedUpdateGridOption("quickFilterMatcher", t);
    }, o.prototype.setAlwaysShowHorizontalScroll = function(t) {
      this.deprecatedUpdateGridOption("alwaysShowHorizontalScroll", t);
    }, o.prototype.setAlwaysShowVerticalScroll = function(t) {
      this.deprecatedUpdateGridOption("alwaysShowVerticalScroll", t);
    }, o.prototype.setFunctionsReadOnly = function(t) {
      this.deprecatedUpdateGridOption("functionsReadOnly", t);
    }, o.prototype.setColumnDefs = function(t, e) {
      e === void 0 && (e = "api"), ht("setColumnDefs is deprecated. Please use 'api.setGridOption('columnDefs', newValue)' or 'api.updateGridOptions({ columnDefs: newValue })' instead."), this.gos.updateGridOptions({
        options: { columnDefs: t },
        source: e
      });
    }, o.prototype.setAutoGroupColumnDef = function(t, e) {
      e === void 0 && (e = "api"), ht("setAutoGroupColumnDef is deprecated. Please use 'api.setGridOption('autoGroupColumnDef', newValue)' or 'api.updateGridOptions({ autoGroupColumnDef: newValue })' instead."), this.gos.updateGridOptions({
        options: { autoGroupColumnDef: t },
        source: e
      });
    }, o.prototype.setDefaultColDef = function(t, e) {
      e === void 0 && (e = "api"), ht("setDefaultColDef is deprecated. Please use 'api.setGridOption('defaultColDef', newValue)' or 'api.updateGridOptions({ defaultColDef: newValue })' instead."), this.gos.updateGridOptions({
        options: { defaultColDef: t },
        source: e
      });
    }, o.prototype.setColumnTypes = function(t, e) {
      e === void 0 && (e = "api"), ht("setColumnTypes is deprecated. Please use 'api.setGridOption('columnTypes', newValue)' or 'api.updateGridOptions({ columnTypes: newValue })' instead."), this.gos.updateGridOptions({
        options: { columnTypes: t },
        source: e
      });
    }, o.prototype.setTreeData = function(t) {
      this.deprecatedUpdateGridOption("treeData", t);
    }, o.prototype.setServerSideDatasource = function(t) {
      this.deprecatedUpdateGridOption("serverSideDatasource", t);
    }, o.prototype.setCacheBlockSize = function(t) {
      this.deprecatedUpdateGridOption("cacheBlockSize", t);
    }, o.prototype.setDatasource = function(t) {
      this.deprecatedUpdateGridOption("datasource", t);
    }, o.prototype.setViewportDatasource = function(t) {
      this.deprecatedUpdateGridOption("viewportDatasource", t);
    }, o.prototype.setRowData = function(t) {
      this.deprecatedUpdateGridOption("rowData", t);
    }, o.prototype.setEnableCellTextSelection = function(t) {
      this.deprecatedUpdateGridOption("enableCellTextSelection", t);
    }, o.prototype.setHeaderHeight = function(t) {
      this.deprecatedUpdateGridOption("headerHeight", t);
    }, o.prototype.setDomLayout = function(t) {
      this.deprecatedUpdateGridOption("domLayout", t);
    }, o.prototype.setFillHandleDirection = function(t) {
      this.deprecatedUpdateGridOption("fillHandleDirection", t);
    }, o.prototype.setGroupHeaderHeight = function(t) {
      this.deprecatedUpdateGridOption("groupHeaderHeight", t);
    }, o.prototype.setFloatingFiltersHeight = function(t) {
      this.deprecatedUpdateGridOption("floatingFiltersHeight", t);
    }, o.prototype.setPivotHeaderHeight = function(t) {
      this.deprecatedUpdateGridOption("pivotHeaderHeight", t);
    }, o.prototype.setPivotGroupHeaderHeight = function(t) {
      this.deprecatedUpdateGridOption("pivotGroupHeaderHeight", t);
    }, o.prototype.setAnimateRows = function(t) {
      this.deprecatedUpdateGridOption("animateRows", t);
    }, o.prototype.setIsExternalFilterPresent = function(t) {
      this.deprecatedUpdateGridOption("isExternalFilterPresent", t);
    }, o.prototype.setDoesExternalFilterPass = function(t) {
      this.deprecatedUpdateGridOption("doesExternalFilterPass", t);
    }, o.prototype.setNavigateToNextCell = function(t) {
      this.deprecatedUpdateGridOption("navigateToNextCell", t);
    }, o.prototype.setTabToNextCell = function(t) {
      this.deprecatedUpdateGridOption("tabToNextCell", t);
    }, o.prototype.setTabToNextHeader = function(t) {
      this.deprecatedUpdateGridOption("tabToNextHeader", t);
    }, o.prototype.setNavigateToNextHeader = function(t) {
      this.deprecatedUpdateGridOption("navigateToNextHeader", t);
    }, o.prototype.setRowGroupPanelShow = function(t) {
      this.deprecatedUpdateGridOption("rowGroupPanelShow", t);
    }, o.prototype.setGetGroupRowAgg = function(t) {
      this.deprecatedUpdateGridOption("getGroupRowAgg", t);
    }, o.prototype.setGetBusinessKeyForNode = function(t) {
      this.deprecatedUpdateGridOption("getBusinessKeyForNode", t);
    }, o.prototype.setGetChildCount = function(t) {
      this.deprecatedUpdateGridOption("getChildCount", t);
    }, o.prototype.setProcessRowPostCreate = function(t) {
      this.deprecatedUpdateGridOption("processRowPostCreate", t);
    }, o.prototype.setGetRowId = function(t) {
      ht("getRowId is a static property and can no longer be updated.");
    }, o.prototype.setGetRowClass = function(t) {
      this.deprecatedUpdateGridOption("getRowClass", t);
    }, o.prototype.setIsFullWidthRow = function(t) {
      this.deprecatedUpdateGridOption("isFullWidthRow", t);
    }, o.prototype.setIsRowSelectable = function(t) {
      this.deprecatedUpdateGridOption("isRowSelectable", t);
    }, o.prototype.setIsRowMaster = function(t) {
      this.deprecatedUpdateGridOption("isRowMaster", t);
    }, o.prototype.setPostSortRows = function(t) {
      this.deprecatedUpdateGridOption("postSortRows", t);
    }, o.prototype.setGetDocument = function(t) {
      this.deprecatedUpdateGridOption("getDocument", t);
    }, o.prototype.setGetContextMenuItems = function(t) {
      this.deprecatedUpdateGridOption("getContextMenuItems", t);
    }, o.prototype.setGetMainMenuItems = function(t) {
      this.deprecatedUpdateGridOption("getMainMenuItems", t);
    }, o.prototype.setProcessCellForClipboard = function(t) {
      this.deprecatedUpdateGridOption("processCellForClipboard", t);
    }, o.prototype.setSendToClipboard = function(t) {
      this.deprecatedUpdateGridOption("sendToClipboard", t);
    }, o.prototype.setProcessCellFromClipboard = function(t) {
      this.deprecatedUpdateGridOption("processCellFromClipboard", t);
    }, o.prototype.setProcessPivotResultColDef = function(t) {
      this.deprecatedUpdateGridOption("processPivotResultColDef", t);
    }, o.prototype.setProcessPivotResultColGroupDef = function(t) {
      this.deprecatedUpdateGridOption("processPivotResultColGroupDef", t);
    }, o.prototype.setPostProcessPopup = function(t) {
      this.deprecatedUpdateGridOption("postProcessPopup", t);
    }, o.prototype.setInitialGroupOrderComparator = function(t) {
      this.deprecatedUpdateGridOption("initialGroupOrderComparator", t);
    }, o.prototype.setGetChartToolbarItems = function(t) {
      this.deprecatedUpdateGridOption("getChartToolbarItems", t);
    }, o.prototype.setPaginationNumberFormatter = function(t) {
      this.deprecatedUpdateGridOption("paginationNumberFormatter", t);
    }, o.prototype.setGetServerSideGroupLevelParams = function(t) {
      this.deprecatedUpdateGridOption("getServerSideGroupLevelParams", t);
    }, o.prototype.setIsServerSideGroupOpenByDefault = function(t) {
      this.deprecatedUpdateGridOption("isServerSideGroupOpenByDefault", t);
    }, o.prototype.setIsApplyServerSideTransaction = function(t) {
      this.deprecatedUpdateGridOption("isApplyServerSideTransaction", t);
    }, o.prototype.setIsServerSideGroup = function(t) {
      this.deprecatedUpdateGridOption("isServerSideGroup", t);
    }, o.prototype.setGetServerSideGroupKey = function(t) {
      this.deprecatedUpdateGridOption("getServerSideGroupKey", t);
    }, o.prototype.setGetRowStyle = function(t) {
      this.deprecatedUpdateGridOption("getRowStyle", t);
    }, o.prototype.setGetRowHeight = function(t) {
      this.deprecatedUpdateGridOption("getRowHeight", t);
    }, At([
      Lt("csvCreator")
    ], o.prototype, "csvCreator", void 0), At([
      Lt("excelCreator")
    ], o.prototype, "excelCreator", void 0), At([
      N("rowRenderer")
    ], o.prototype, "rowRenderer", void 0), At([
      N("navigationService")
    ], o.prototype, "navigationService", void 0), At([
      N("filterManager")
    ], o.prototype, "filterManager", void 0), At([
      N("columnModel")
    ], o.prototype, "columnModel", void 0), At([
      N("selectionService")
    ], o.prototype, "selectionService", void 0), At([
      N("gridOptionsService")
    ], o.prototype, "gos", void 0), At([
      N("valueService")
    ], o.prototype, "valueService", void 0), At([
      N("alignedGridsService")
    ], o.prototype, "alignedGridsService", void 0), At([
      N("eventService")
    ], o.prototype, "eventService", void 0), At([
      N("pinnedRowModel")
    ], o.prototype, "pinnedRowModel", void 0), At([
      N("context")
    ], o.prototype, "context", void 0), At([
      N("rowModel")
    ], o.prototype, "rowModel", void 0), At([
      N("sortController")
    ], o.prototype, "sortController", void 0), At([
      N("paginationProxy")
    ], o.prototype, "paginationProxy", void 0), At([
      N("focusService")
    ], o.prototype, "focusService", void 0), At([
      N("dragAndDropService")
    ], o.prototype, "dragAndDropService", void 0), At([
      Lt("rangeService")
    ], o.prototype, "rangeService", void 0), At([
      Lt("clipboardService")
    ], o.prototype, "clipboardService", void 0), At([
      Lt("aggFuncService")
    ], o.prototype, "aggFuncService", void 0), At([
      N("menuFactory")
    ], o.prototype, "menuFactory", void 0), At([
      Lt("contextMenuFactory")
    ], o.prototype, "contextMenuFactory", void 0), At([
      N("valueCache")
    ], o.prototype, "valueCache", void 0), At([
      N("animationFrameService")
    ], o.prototype, "animationFrameService", void 0), At([
      Lt("statusBarService")
    ], o.prototype, "statusBarService", void 0), At([
      Lt("chartService")
    ], o.prototype, "chartService", void 0), At([
      Lt("undoRedoService")
    ], o.prototype, "undoRedoService", void 0), At([
      Lt("rowNodeBlockLoader")
    ], o.prototype, "rowNodeBlockLoader", void 0), At([
      Lt("ssrmTransactionManager")
    ], o.prototype, "serverSideTransactionManager", void 0), At([
      N("ctrlsService")
    ], o.prototype, "ctrlsService", void 0), At([
      N("overlayService")
    ], o.prototype, "overlayService", void 0), At([
      Lt("sideBarService")
    ], o.prototype, "sideBarService", void 0), At([
      N("stateService")
    ], o.prototype, "stateService", void 0), At([
      N("expansionService")
    ], o.prototype, "expansionService", void 0), At([
      N("apiEventService")
    ], o.prototype, "apiEventService", void 0), At([
      N("frameworkOverrides")
    ], o.prototype, "frameworkOverrides", void 0), At([
      Fe
    ], o.prototype, "init", null), o = At([
      Be("gridApi")
    ], o), o;
  }()
), nK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Tf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, FI = (
  /** @class */
  function(o) {
    nK(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.quickFilter = null, r.quickFilterParts = null, r;
    }
    e = t, t.prototype.postConstruct = function() {
      var r = this;
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, function() {
        return r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return r.resetQuickFilterCache();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VISIBLE, function() {
        r.gridOptionsService.get("includeHiddenColumnsInQuickFilter") || r.resetQuickFilterCache();
      }), this.addManagedPropertyListener("quickFilterText", function(n) {
        return r.setQuickFilter(n.currentValue);
      }), this.addManagedPropertyListener("includeHiddenColumnsInQuickFilter", function() {
        return r.onIncludeHiddenColumnsInQuickFilterChanged();
      }), this.quickFilter = this.parseQuickFilter(this.gridOptionsService.get("quickFilterText")), this.parser = this.gridOptionsService.get("quickFilterParser"), this.matcher = this.gridOptionsService.get("quickFilterMatcher"), this.setQuickFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], function() {
        return r.setQuickFilterParserAndMatcher();
      });
    }, t.prototype.isQuickFilterPresent = function() {
      return this.quickFilter !== null;
    }, t.prototype.doesRowPassQuickFilter = function(r) {
      var n = this, i = this.gridOptionsService.get("cacheQuickFilter");
      return this.matcher ? this.doesRowPassQuickFilterMatcher(i, r) : this.quickFilterParts.every(function(a) {
        return i ? n.doesRowPassQuickFilterCache(r, a) : n.doesRowPassQuickFilterNoCache(r, a);
      });
    }, t.prototype.resetQuickFilterCache = function() {
      this.rowModel.forEachNode(function(r) {
        return r.quickFilterAggregateText = null;
      });
    }, t.prototype.setQuickFilterParts = function() {
      var r = this, n = r.quickFilter, i = r.parser;
      n ? this.quickFilterParts = i ? i(n) : n.split(" ") : this.quickFilterParts = null;
    }, t.prototype.parseQuickFilter = function(r) {
      return Oe(r) ? this.gridOptionsService.isRowModelType("clientSide") ? r.toUpperCase() : (console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model"), null) : null;
    }, t.prototype.setQuickFilter = function(r) {
      if (r != null && typeof r != "string") {
        console.warn("AG Grid - Grid option quickFilterText only supports string inputs, received: ".concat(typeof r));
        return;
      }
      var n = this.parseQuickFilter(r);
      this.quickFilter !== n && (this.quickFilter = n, this.setQuickFilterParts(), this.dispatchEvent({ type: e.EVENT_QUICK_FILTER_CHANGED }));
    }, t.prototype.setQuickFilterParserAndMatcher = function() {
      var r = this.gridOptionsService.get("quickFilterParser"), n = this.gridOptionsService.get("quickFilterMatcher"), i = r !== this.parser || n !== this.matcher;
      this.parser = r, this.matcher = n, i && (this.setQuickFilterParts(), this.dispatchEvent({ type: e.EVENT_QUICK_FILTER_CHANGED }));
    }, t.prototype.onIncludeHiddenColumnsInQuickFilterChanged = function() {
      this.columnModel.refreshQuickFilterColumns(), this.resetQuickFilterCache(), this.isQuickFilterPresent() && this.dispatchEvent({ type: e.EVENT_QUICK_FILTER_CHANGED });
    }, t.prototype.doesRowPassQuickFilterNoCache = function(r, n) {
      var i = this, a = this.columnModel.getAllColumnsForQuickFilter();
      return a.some(function(s) {
        var l = i.getQuickFilterTextForColumn(s, r);
        return Oe(l) && l.indexOf(n) >= 0;
      });
    }, t.prototype.doesRowPassQuickFilterCache = function(r, n) {
      return this.checkGenerateQuickFilterAggregateText(r), r.quickFilterAggregateText.indexOf(n) >= 0;
    }, t.prototype.doesRowPassQuickFilterMatcher = function(r, n) {
      var i;
      r ? (this.checkGenerateQuickFilterAggregateText(n), i = n.quickFilterAggregateText) : i = this.getQuickFilterAggregateText(n);
      var a = this, s = a.quickFilterParts, l = a.matcher;
      return l(s, i);
    }, t.prototype.checkGenerateQuickFilterAggregateText = function(r) {
      r.quickFilterAggregateText || (r.quickFilterAggregateText = this.getQuickFilterAggregateText(r));
    }, t.prototype.getQuickFilterTextForColumn = function(r, n) {
      var i = this.valueService.getValue(r, n, !0), a = r.getColDef();
      if (a.getQuickFilterText) {
        var s = this.gridOptionsService.addGridCommonParams({
          value: i,
          node: n,
          data: n.data,
          column: r,
          colDef: a
        });
        i = a.getQuickFilterText(s);
      }
      return Oe(i) ? i.toString().toUpperCase() : null;
    }, t.prototype.getQuickFilterAggregateText = function(r) {
      var n = this, i = [], a = this.columnModel.getAllColumnsForQuickFilter();
      return a.forEach(function(s) {
        var l = n.getQuickFilterTextForColumn(s, r);
        Oe(l) && i.push(l);
      }), i.join(e.QUICK_FILTER_SEPARATOR);
    };
    var e;
    return t.EVENT_QUICK_FILTER_CHANGED = "quickFilterChanged", t.QUICK_FILTER_SEPARATOR = `
`, Tf([
      N("valueService")
    ], t.prototype, "valueService", void 0), Tf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Tf([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Tf([
      Fe
    ], t.prototype, "postConstruct", null), t = e = Tf([
      Be("quickFilterService")
    ], t), t;
  }(Me)
), oK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Oa = function() {
  return Oa = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Oa.apply(this, arguments);
}, wa = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, II = (
  /** @class */
  function(o) {
    oK(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.allColumnFilters = /* @__PURE__ */ new Map(), e.allColumnListeners = /* @__PURE__ */ new Map(), e.activeAggregateFilters = [], e.activeColumnFilters = [], e.processingFilterChange = !1, e.filterModelUpdateQueue = [], e.columnFilterModelUpdateQueue = [], e.advancedFilterModelUpdateQueue = [], e;
    }
    return t.prototype.init = function() {
      var e = this, r, n, i;
      this.addManagedListener(this.eventService, G.EVENT_GRID_COLUMNS_CHANGED, function() {
        return e.onColumnsChanged();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VALUE_CHANGED, function() {
        return e.refreshFiltersForAggregations();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_CHANGED, function() {
        return e.refreshFiltersForAggregations();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, function() {
        return e.refreshFiltersForAggregations();
      }), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return e.updateAdvancedFilterColumns();
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VISIBLE, function() {
        return e.updateAdvancedFilterColumns();
      }), this.addManagedListener(this.eventService, G.EVENT_ROW_DATA_UPDATED, function() {
        return e.onNewRowsLoaded("rowDataUpdated");
      }), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], function() {
        e.onFilterChanged({ source: "api" });
      }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", function() {
        e.updateAggFiltering(), e.onFilterChanged();
      }), this.addManagedPropertyListener("advancedFilterModel", function(a) {
        return e.setAdvancedFilterModel(a.currentValue);
      }), this.addManagedListener(this.eventService, G.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, function(a) {
        var s = a.enabled;
        return e.onAdvancedFilterEnabledChanged(s);
      }), this.addManagedListener(this.eventService, G.EVENT_DATA_TYPES_INFERRED, function() {
        return e.processFilterModelUpdateQueue();
      }), this.addManagedListener(this.quickFilterService, FI.EVENT_QUICK_FILTER_CHANGED, function() {
        return e.onFilterChanged({ source: "quickFilter" });
      }), this.initialFilterModel = Oa({}, (i = (n = (r = this.gridOptionsService.get("initialState")) === null || r === void 0 ? void 0 : r.filter) === null || n === void 0 ? void 0 : n.filterModel) !== null && i !== void 0 ? i : {});
    }, t.prototype.isExternalFilterPresentCallback = function() {
      var e = this.gridOptionsService.getCallback("isExternalFilterPresent");
      return typeof e == "function" ? e({}) : !1;
    }, t.prototype.doesExternalFilterPass = function(e) {
      var r = this.gridOptionsService.get("doesExternalFilterPass");
      return typeof r == "function" ? r(e) : !1;
    }, t.prototype.setFilterModel = function(e, r) {
      var n = this;
      if (r === void 0 && (r = "api"), this.isAdvancedFilterEnabled()) {
        this.warnAdvancedFilters();
        return;
      }
      if (this.dataTypeService.isPendingInference()) {
        this.filterModelUpdateQueue.push({ model: e, source: r });
        return;
      }
      var i = [], a = this.getFilterModel();
      if (e) {
        var s = J1(Object.keys(e));
        this.allColumnFilters.forEach(function(l, u) {
          var c = e[u];
          i.push(n.setModelOnFilterWrapper(l.filterPromise, c)), s.delete(u);
        }), s.forEach(function(l) {
          var u = n.columnModel.getPrimaryColumn(l) || n.columnModel.getGridColumn(l);
          if (!u) {
            console.warn("AG Grid: setFilterModel() - no column found for colId: " + l);
            return;
          }
          if (!u.isFilterAllowed()) {
            console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + l);
            return;
          }
          var c = n.getOrCreateFilterWrapper(u, "NO_UI");
          if (!c) {
            console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + l);
            return;
          }
          i.push(n.setModelOnFilterWrapper(c.filterPromise, e[l]));
        });
      } else
        this.allColumnFilters.forEach(function(l) {
          i.push(n.setModelOnFilterWrapper(l.filterPromise, null));
        });
      Zi.all(i).then(function() {
        var l = n.getFilterModel(), u = [];
        n.allColumnFilters.forEach(function(c, d) {
          var f = a ? a[d] : null, v = l ? l[d] : null;
          yt.jsonEquals(f, v) || u.push(c.column);
        }), u.length > 0 && n.onFilterChanged({ columns: u, source: r });
      });
    }, t.prototype.setModelOnFilterWrapper = function(e, r) {
      return new Zi(function(n) {
        e.then(function(i) {
          typeof i.setModel != "function" && (console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel"), n()), (i.setModel(r) || Zi.resolve()).then(function() {
            return n();
          });
        });
      });
    }, t.prototype.getFilterModel = function() {
      var e = this, r = {};
      return this.allColumnFilters.forEach(function(n, i) {
        var a = e.getModelFromFilterWrapper(n);
        Oe(a) && (r[i] = a);
      }), r;
    }, t.prototype.getModelFromFilterWrapper = function(e) {
      var r, n = e.filterPromise, i = n.resolveNow(null, function(a) {
        return a;
      });
      return i == null ? (r = this.initialFilterModel[e.column.getColId()]) !== null && r !== void 0 ? r : null : typeof i.getModel != "function" ? (console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel"), null) : i.getModel();
    }, t.prototype.isColumnFilterPresent = function() {
      return this.activeColumnFilters.length > 0;
    }, t.prototype.isAggregateFilterPresent = function() {
      return !!this.activeAggregateFilters.length;
    }, t.prototype.isExternalFilterPresent = function() {
      return this.externalFilterPresent;
    }, t.prototype.isChildFilterPresent = function() {
      return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }, t.prototype.isAdvancedFilterPresent = function() {
      return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
    }, t.prototype.onAdvancedFilterEnabledChanged = function(e) {
      var r = this, n;
      e ? this.allColumnFilters.size && (this.allColumnFilters.forEach(function(i) {
        return r.disposeFilterWrapper(i, "advancedFilterEnabled");
      }), this.onFilterChanged({ source: "advancedFilter" })) : !((n = this.advancedFilterService) === null || n === void 0) && n.isFilterPresent() && (this.advancedFilterService.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
    }, t.prototype.isAdvancedFilterEnabled = function() {
      var e;
      return (e = this.advancedFilterService) === null || e === void 0 ? void 0 : e.isEnabled();
    }, t.prototype.isAdvancedFilterHeaderActive = function() {
      return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
    }, t.prototype.doAggregateFiltersPass = function(e, r) {
      return this.doColumnFiltersPass(e, r, !0);
    }, t.prototype.updateActiveFilters = function() {
      var e = this;
      this.activeColumnFilters.length = 0, this.activeAggregateFilters.length = 0;
      var r = function(a) {
        return a ? a.isFilterActive ? a.isFilterActive() : (console.warn("AG Grid: Filter is missing isFilterActive() method"), !1) : !1;
      }, n = !!this.gridOptionsService.getGroupAggFiltering(), i = function(a) {
        var s = !a.isPrimary();
        if (s)
          return !0;
        var l = !e.columnModel.isPivotActive(), u = a.isValueActive();
        return !u || !l ? !1 : e.columnModel.isPivotMode() ? !0 : n;
      };
      this.allColumnFilters.forEach(function(a) {
        if (a.filterPromise.resolveNow(!1, r)) {
          var s = a.filterPromise.resolveNow(null, function(l) {
            return l;
          });
          i(a.column) ? e.activeAggregateFilters.push(s) : e.activeColumnFilters.push(s);
        }
      });
    }, t.prototype.updateFilterFlagInColumns = function(e, r) {
      this.allColumnFilters.forEach(function(n) {
        var i = n.filterPromise.resolveNow(!1, function(a) {
          return a.isFilterActive();
        });
        n.column.setFilterActive(i, e, r);
      });
    }, t.prototype.isAnyFilterPresent = function() {
      return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent();
    }, t.prototype.doColumnFiltersPass = function(e, r, n) {
      for (var i = e.data, a = e.aggData, s = n ? this.activeAggregateFilters : this.activeColumnFilters, l = n ? a : i, u = 0; u < s.length; u++) {
        var c = s[u];
        if (!(c == null || c === r)) {
          if (typeof c.doesFilterPass != "function")
            throw new Error("Filter is missing method doesFilterPass");
          if (!c.doesFilterPass({ node: e, data: l }))
            return !1;
        }
      }
      return !0;
    }, t.prototype.resetQuickFilterCache = function() {
      this.quickFilterService.resetQuickFilterCache();
    }, t.prototype.refreshFiltersForAggregations = function() {
      var e = this.gridOptionsService.getGroupAggFiltering();
      e && this.onFilterChanged();
    }, t.prototype.callOnFilterChangedOutsideRenderCycle = function(e) {
      var r = this, n = function() {
        return r.onFilterChanged(e);
      };
      this.rowRenderer.isRefreshInProgress() ? setTimeout(n, 0) : n();
    }, t.prototype.onFilterChanged = function(e) {
      e === void 0 && (e = {});
      var r = e.source, n = e.filterInstance, i = e.additionalEventAttributes, a = e.columns;
      this.updateDependantFilters(), this.updateActiveFilters(), this.updateFilterFlagInColumns("filterChanged", i), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.allColumnFilters.forEach(function(l) {
        l.filterPromise && l.filterPromise.then(function(u) {
          u && u !== n && u.onAnyFilterChanged && u.onAnyFilterChanged();
        });
      });
      var s = {
        source: r,
        type: G.EVENT_FILTER_CHANGED,
        columns: a || []
      };
      i && oi(s, i), this.processingFilterChange = !0, this.eventService.dispatchEvent(s), this.processingFilterChange = !1;
    }, t.prototype.isSuppressFlashingCellsBecauseFiltering = function() {
      var e, r = (e = this.gridOptionsService.get("allowShowChangeAfterFilter")) !== null && e !== void 0 ? e : !1;
      return !r && this.processingFilterChange;
    }, t.prototype.isQuickFilterPresent = function() {
      return this.quickFilterService.isQuickFilterPresent();
    }, t.prototype.updateAggFiltering = function() {
      this.aggFiltering = !!this.gridOptionsService.getGroupAggFiltering();
    }, t.prototype.isAggregateQuickFilterPresent = function() {
      return this.isQuickFilterPresent() && (this.aggFiltering || this.columnModel.isPivotMode());
    }, t.prototype.isNonAggregateQuickFilterPresent = function() {
      return this.isQuickFilterPresent() && !(this.aggFiltering || this.columnModel.isPivotMode());
    }, t.prototype.doesRowPassOtherFilters = function(e, r) {
      return this.doesRowPassFilter({ rowNode: r, filterInstanceToSkip: e });
    }, t.prototype.doesRowPassAggregateFilters = function(e) {
      return !(this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(e.rowNode, e.filterInstanceToSkip));
    }, t.prototype.doesRowPassFilter = function(e) {
      return !(this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isExternalFilterPresent() && !this.doesExternalFilterPass(e.rowNode) || this.isColumnFilterPresent() && !this.doColumnFiltersPass(e.rowNode, e.filterInstanceToSkip) || this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(e.rowNode));
    }, t.prototype.onNewRowsLoaded = function(e) {
      this.allColumnFilters.forEach(function(r) {
        r.filterPromise.then(function(n) {
          n.onNewRowsLoaded && n.onNewRowsLoaded();
        });
      }), this.updateFilterFlagInColumns(e, { afterDataChange: !0 }), this.updateActiveFilters();
    }, t.prototype.createValueGetter = function(e) {
      var r = this;
      return function(n) {
        var i = n.node;
        return r.valueService.getValue(e, i, !0);
      };
    }, t.prototype.createGetValue = function(e) {
      var r = this;
      return function(n, i) {
        var a = i ? r.columnModel.getGridColumn(i) : e;
        return a ? r.valueService.getValue(a, n, !0) : void 0;
      };
    }, t.prototype.getFilterComponent = function(e, r, n) {
      var i;
      if (n === void 0 && (n = !0), n)
        return ((i = this.getOrCreateFilterWrapper(e, r)) === null || i === void 0 ? void 0 : i.filterPromise) || null;
      var a = this.cachedFilter(e);
      return a ? a.filterPromise : null;
    }, t.prototype.isFilterActive = function(e) {
      var r = this.cachedFilter(e);
      return !!r && r.filterPromise.resolveNow(!1, function(n) {
        return n.isFilterActive();
      });
    }, t.prototype.getOrCreateFilterWrapper = function(e, r) {
      if (!e.isFilterAllowed())
        return null;
      var n = this.cachedFilter(e);
      return n ? r !== "NO_UI" && this.putIntoGui(n, r) : (n = this.createFilterWrapper(e, r), this.setColumnFilterWrapper(e, n)), n;
    }, t.prototype.cachedFilter = function(e) {
      return this.allColumnFilters.get(e.getColId());
    }, t.prototype.getDefaultFilter = function(e) {
      var r;
      if (Xt.__isRegistered(Ye.SetFilterModule, this.context.getGridId()))
        r = "agSetColumnFilter";
      else {
        var n = this.dataTypeService.getBaseDataType(e);
        n === "number" ? r = "agNumberColumnFilter" : n === "date" || n === "dateString" ? r = "agDateColumnFilter" : r = "agTextColumnFilter";
      }
      return r;
    }, t.prototype.getDefaultFloatingFilter = function(e) {
      var r;
      if (Xt.__isRegistered(Ye.SetFilterModule, this.context.getGridId()))
        r = "agSetColumnFloatingFilter";
      else {
        var n = this.dataTypeService.getBaseDataType(e);
        n === "number" ? r = "agNumberColumnFloatingFilter" : n === "date" || n === "dateString" ? r = "agDateColumnFloatingFilter" : r = "agTextColumnFloatingFilter";
      }
      return r;
    }, t.prototype.createFilterInstance = function(e) {
      var r = this, n = this.getDefaultFilter(e), i = e.getColDef(), a, s = Oa(Oa({}, this.createFilterParams(e, i)), { filterModifiedCallback: function() {
        return r.filterModifiedCallbackFactory(a, e)();
      }, filterChangedCallback: function(u) {
        return r.filterChangedCallbackFactory(a, e)(u);
      }, doesRowPassOtherFilter: function(u) {
        return r.doesRowPassOtherFilters(a, u);
      } }), l = this.userComponentFactory.getFilterDetails(i, s, n);
      return l ? {
        filterPromise: function() {
          var u = l.newAgStackInstance();
          return u && u.then(function(c) {
            return a = c;
          }), u;
        },
        compDetails: l
      } : { filterPromise: null, compDetails: null };
    }, t.prototype.createFilterParams = function(e, r) {
      var n = this.gridOptionsService.addGridCommonParams({
        column: e,
        colDef: w1(r),
        rowModel: this.rowModel,
        filterChangedCallback: function() {
        },
        filterModifiedCallback: function() {
        },
        valueGetter: this.createValueGetter(e),
        getValue: this.createGetValue(e),
        doesRowPassOtherFilter: function() {
          return !0;
        }
      });
      return n;
    }, t.prototype.createFilterWrapper = function(e, r) {
      var n, i = {
        column: e,
        filterPromise: null,
        compiledElement: null,
        guiPromise: Zi.resolve(null),
        compDetails: null
      }, a = this.createFilterInstance(e), s = a.filterPromise, l = a.compDetails;
      return i.filterPromise = (n = s == null ? void 0 : s()) !== null && n !== void 0 ? n : null, i.compDetails = l, s && this.putIntoGui(i, r), i;
    }, t.prototype.putIntoGui = function(e, r) {
      var n = this, i = document.createElement("div");
      i.className = "ag-filter", e.guiPromise = new Zi(function(a) {
        e.filterPromise.then(function(s) {
          var l = s.getGui();
          Oe(l) || console.warn("AG Grid: getGui method from filter returned ".concat(l, ", it should be a DOM element or an HTML template string.")), typeof l == "string" && (l = No(l)), i.appendChild(l), a(i);
          var u = {
            type: G.EVENT_FILTER_OPENED,
            column: e.column,
            source: r,
            eGui: i
          };
          n.eventService.dispatchEvent(u);
        });
      });
    }, t.prototype.onColumnsChanged = function() {
      var e = this, r = [];
      this.allColumnFilters.forEach(function(n, i) {
        var a;
        n.column.isPrimary() ? a = e.columnModel.getPrimaryColumn(i) : a = e.columnModel.getGridColumn(i), !a && (r.push(n.column), e.disposeFilterWrapper(n, "columnChanged"), e.disposeColumnListener(i));
      }), r.length > 0 ? this.onFilterChanged({ columns: r, source: "api" }) : this.updateDependantFilters();
    }, t.prototype.updateDependantFilters = function() {
      var e = this, r = this.columnModel.getGroupAutoColumns();
      r == null || r.forEach(function(n) {
        n.getColDef().filter === "agGroupColumnFilter" && e.getOrCreateFilterWrapper(n, "NO_UI");
      });
    }, t.prototype.isFilterAllowed = function(e) {
      var r, n;
      if (this.isAdvancedFilterEnabled())
        return !1;
      var i = e.isFilterAllowed();
      if (!i)
        return !1;
      var a = this.allColumnFilters.get(e.getColId());
      return (n = (r = a == null ? void 0 : a.filterPromise) === null || r === void 0 ? void 0 : r.resolveNow(
        !0,
        // defer to filter component isFilterAllowed if it exists
        function(s) {
          return typeof (s == null ? void 0 : s.isFilterAllowed) == "function" ? s == null ? void 0 : s.isFilterAllowed() : !0;
        }
      )) !== null && n !== void 0 ? n : !0;
    }, t.prototype.getFloatingFilterCompDetails = function(e, r) {
      var n = this, i = function(d) {
        var f = n.getFilterComponent(e, "NO_UI");
        f != null && f.then(function(v) {
          d(ec(v));
        });
      }, a = e.getColDef(), s = Oa(Oa({}, this.createFilterParams(e, a)), { filterChangedCallback: function() {
        return i(function(d) {
          return n.filterChangedCallbackFactory(d, e)();
        });
      } }), l = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(a, WS, s), u = this.userComponentFactory.getDefaultFloatingFilterType(a, function() {
        return n.getDefaultFloatingFilter(e);
      });
      u == null && (u = "agReadOnlyFloatingFilter");
      var c = {
        column: e,
        filterParams: l,
        currentParentModel: function() {
          return n.getCurrentFloatingFilterParentModel(e);
        },
        parentFilterInstance: i,
        showParentFilter: r,
        suppressFilterButton: !1
        // This one might be overridden from the colDef
      };
      return this.userComponentFactory.getFloatingFilterCompDetails(a, c, u);
    }, t.prototype.getCurrentFloatingFilterParentModel = function(e) {
      var r = this.getFilterComponent(e, "NO_UI", !1);
      return r ? r.resolveNow(null, function(n) {
        return n && n.getModel();
      }) : null;
    }, t.prototype.destroyFilter = function(e, r) {
      r === void 0 && (r = "api");
      var n = e.getColId(), i = this.allColumnFilters.get(n);
      this.disposeColumnListener(n), delete this.initialFilterModel[n], i && (this.disposeFilterWrapper(i, r), this.onFilterChanged({
        columns: [e],
        source: "api"
      }));
    }, t.prototype.disposeColumnListener = function(e) {
      var r = this.allColumnListeners.get(e);
      r && (this.allColumnListeners.delete(e), r());
    }, t.prototype.disposeFilterWrapper = function(e, r) {
      var n = this;
      e.filterPromise.then(function(i) {
        n.getContext().destroyBean(i), e.column.setFilterActive(!1, "filterDestroyed"), n.allColumnFilters.delete(e.column.getColId());
        var a = {
          type: G.EVENT_FILTER_DESTROYED,
          source: r,
          column: e.column
        };
        n.eventService.dispatchEvent(a);
      });
    }, t.prototype.filterModifiedCallbackFactory = function(e, r) {
      var n = this;
      return function() {
        var i = {
          type: G.EVENT_FILTER_MODIFIED,
          column: r,
          filterInstance: e
        };
        n.eventService.dispatchEvent(i);
      };
    }, t.prototype.filterChangedCallbackFactory = function(e, r) {
      var n = this;
      return function(i) {
        var a, s = (a = i == null ? void 0 : i.source) !== null && a !== void 0 ? a : "api", l = {
          filter: e,
          additionalEventAttributes: i,
          columns: [r],
          source: s
        };
        n.callOnFilterChangedOutsideRenderCycle(l);
      };
    }, t.prototype.checkDestroyFilter = function(e) {
      var r = this, n = this.allColumnFilters.get(e);
      if (n) {
        var i = n.column, a = (i.isFilterAllowed() ? this.createFilterInstance(i) : { compDetails: null }).compDetails;
        if (this.areFilterCompsDifferent(n.compDetails, a)) {
          this.destroyFilter(i, "columnChanged");
          return;
        }
        var s = i.getColDef().filterParams;
        if (!n.filterPromise) {
          this.destroyFilter(i, "columnChanged");
          return;
        }
        n.filterPromise.then(function(l) {
          var u = l != null && l.refresh ? l.refresh(Oa(Oa(Oa({}, r.createFilterParams(i, i.getColDef())), { filterModifiedCallback: r.filterModifiedCallbackFactory(l, i), filterChangedCallback: r.filterChangedCallbackFactory(l, i), doesRowPassOtherFilter: function(c) {
            return r.doesRowPassOtherFilters(l, c);
          } }), s)) : !0;
          u === !1 && r.destroyFilter(i, "columnChanged");
        });
      }
    }, t.prototype.setColumnFilterWrapper = function(e, r) {
      var n = this, i = e.getColId();
      this.allColumnFilters.set(i, r), this.allColumnListeners.set(i, this.addManagedListener(e, cr.EVENT_COL_DEF_CHANGED, function() {
        return n.checkDestroyFilter(i);
      }));
    }, t.prototype.areFilterCompsDifferent = function(e, r) {
      if (!r || !e)
        return !0;
      var n = e.componentClass, i = r.componentClass, a = n === i || // react hooks returns new wrappers, so check nested render method
      (n == null ? void 0 : n.render) && (i == null ? void 0 : i.render) && n.render === i.render;
      return !a;
    }, t.prototype.getAdvancedFilterModel = function() {
      return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
    }, t.prototype.setAdvancedFilterModel = function(e) {
      if (this.isAdvancedFilterEnabled()) {
        if (this.dataTypeService.isPendingInference()) {
          this.advancedFilterModelUpdateQueue.push(e);
          return;
        }
        this.advancedFilterService.setModel(e ?? null), this.onFilterChanged({ source: "advancedFilter" });
      }
    }, t.prototype.showAdvancedFilterBuilder = function(e) {
      this.isAdvancedFilterEnabled() && this.advancedFilterService.getCtrl().toggleFilterBuilder(e, !0);
    }, t.prototype.updateAdvancedFilterColumns = function() {
      this.isAdvancedFilterEnabled() && this.advancedFilterService.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
    }, t.prototype.hasFloatingFilters = function() {
      if (this.isAdvancedFilterEnabled())
        return !1;
      var e = this.columnModel.getAllGridColumns();
      return e.some(function(r) {
        return r.getColDef().floatingFilter;
      });
    }, t.prototype.getFilterInstance = function(e, r) {
      if (this.isAdvancedFilterEnabled()) {
        this.warnAdvancedFilters();
        return;
      }
      var n = this.getFilterInstanceImpl(e, function(a) {
        if (r) {
          var s = ec(a);
          r(s);
        }
      }), i = ec(n);
      return i;
    }, t.prototype.getColumnFilterInstance = function(e) {
      var r = this;
      return new Promise(function(n) {
        r.getFilterInstance(e, function(i) {
          n(i);
        });
      });
    }, t.prototype.getFilterInstanceImpl = function(e, r) {
      var n = this.columnModel.getPrimaryColumn(e);
      if (n) {
        var i = this.getFilterComponent(n, "NO_UI"), a = i && i.resolveNow(null, function(s) {
          return s;
        });
        return a ? setTimeout(r, 0, a) : i && i.then(function(s) {
          r(s);
        }), a;
      }
    }, t.prototype.warnAdvancedFilters = function() {
      ht("Column Filter API methods have been disabled as Advanced Filters are enabled.");
    }, t.prototype.setupAdvancedFilterHeaderComp = function(e) {
      var r;
      (r = this.advancedFilterService) === null || r === void 0 || r.getCtrl().setupHeaderComp(e);
    }, t.prototype.getHeaderRowCount = function() {
      return this.isAdvancedFilterHeaderActive() ? 1 : 0;
    }, t.prototype.getHeaderHeight = function() {
      return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
    }, t.prototype.processFilterModelUpdateQueue = function() {
      var e = this;
      this.filterModelUpdateQueue.forEach(function(r) {
        var n = r.model, i = r.source;
        return e.setFilterModel(n, i);
      }), this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue.forEach(function(r) {
        var n = r.key, i = r.model, a = r.resolve;
        e.setColumnFilterModel(n, i).then(function() {
          return a();
        });
      }), this.columnFilterModelUpdateQueue = [], this.advancedFilterModelUpdateQueue.forEach(function(r) {
        return e.setAdvancedFilterModel(r);
      }), this.advancedFilterModelUpdateQueue = [];
    }, t.prototype.getColumnFilterModel = function(e) {
      var r = this.getFilterWrapper(e);
      return r ? this.getModelFromFilterWrapper(r) : null;
    }, t.prototype.setColumnFilterModel = function(e, r) {
      if (this.isAdvancedFilterEnabled())
        return this.warnAdvancedFilters(), Promise.resolve();
      if (this.dataTypeService.isPendingInference()) {
        var n = function() {
        }, i = new Promise(function(u) {
          n = u;
        });
        return this.columnFilterModelUpdateQueue.push({ key: e, model: r, resolve: n }), i;
      }
      var a = this.columnModel.getPrimaryColumn(e), s = a ? this.getOrCreateFilterWrapper(a, "NO_UI") : null, l = function(u) {
        return new Promise(function(c) {
          u.then(function(d) {
            return c(d);
          });
        });
      };
      return s ? l(this.setModelOnFilterWrapper(s.filterPromise, r)) : Promise.resolve();
    }, t.prototype.getFilterWrapper = function(e) {
      var r, n = this.columnModel.getPrimaryColumn(e);
      return n && (r = this.cachedFilter(n)) !== null && r !== void 0 ? r : null;
    }, t.prototype.destroy = function() {
      var e = this;
      o.prototype.destroy.call(this), this.allColumnFilters.forEach(function(r) {
        return e.disposeFilterWrapper(r, "gridDestroyed");
      }), this.allColumnListeners.clear();
    }, wa([
      N("valueService")
    ], t.prototype, "valueService", void 0), wa([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), wa([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), wa([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), wa([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), wa([
      N("dataTypeService")
    ], t.prototype, "dataTypeService", void 0), wa([
      N("quickFilterService")
    ], t.prototype, "quickFilterService", void 0), wa([
      Lt("advancedFilterService")
    ], t.prototype, "advancedFilterService", void 0), wa([
      Fe
    ], t.prototype, "init", null), t = wa([
      Be("filterManager")
    ], t), t;
  }(Me)
), iK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), d_ = (
  /** @class */
  function(o) {
    iK(t, o);
    function t(e, r) {
      var n = o.call(this, e) || this;
      return n.ctrl = r, n;
    }
    return t.prototype.getCtrl = function() {
      return this.ctrl;
    }, t;
  }(gt)
), aK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Of = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, LI = (
  /** @class */
  function(o) {
    aK(t, o);
    function t(e) {
      return o.call(this, t.TEMPLATE, e) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), n = {
        addOrRemoveCssClass: function(i, a) {
          return e.addOrRemoveCssClass(i, a);
        },
        addOrRemoveBodyCssClass: function(i, a) {
          return e.eFloatingFilterBody.classList.toggle(i, a);
        },
        setButtonWrapperDisplayed: function(i) {
          return Vt(e.eButtonWrapper, i);
        },
        setCompDetails: function(i) {
          return e.setCompDetails(i);
        },
        getFloatingFilterComp: function() {
          return e.compPromise;
        },
        setWidth: function(i) {
          return r.style.width = i;
        },
        setMenuIcon: function(i) {
          return e.eButtonShowMainFilter.appendChild(i);
        }
      };
      this.ctrl.setComp(n, r, this.eButtonShowMainFilter, this.eFloatingFilterBody);
    }, t.prototype.setCompDetails = function(e) {
      var r = this;
      if (!e) {
        this.destroyFloatingFilterComp(), this.compPromise = null;
        return;
      }
      this.compPromise = e.newAgStackInstance(), this.compPromise.then(function(n) {
        return r.afterCompCreated(n);
      });
    }, t.prototype.destroyFloatingFilterComp = function() {
      this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
    }, t.prototype.afterCompCreated = function(e) {
      if (e) {
        if (!this.isAlive()) {
          this.destroyBean(e);
          return;
        }
        this.destroyFloatingFilterComp(), this.floatingFilterComp = e, this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached();
      }
    }, t.TEMPLATE = `<div class="ag-header-cell ag-floating-filter" role="gridcell" tabindex="-1">
            <div ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`, Of([
      ke("eFloatingFilterBody")
    ], t.prototype, "eFloatingFilterBody", void 0), Of([
      ke("eButtonWrapper")
    ], t.prototype, "eButtonWrapper", void 0), Of([
      ke("eButtonShowMainFilter")
    ], t.prototype, "eButtonShowMainFilter", void 0), Of([
      Fe
    ], t.prototype, "postConstruct", null), Of([
      eo
    ], t.prototype, "destroyFloatingFilterComp", null), t;
  }(d_)
), sK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), lK = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, rn;
(function(o) {
  o.AUTO_HEIGHT = "ag-layout-auto-height", o.NORMAL = "ag-layout-normal", o.PRINT = "ag-layout-print";
})(rn || (rn = {}));
var p_ = (
  /** @class */
  function(o) {
    sK(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.view = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
    }, t.prototype.updateLayoutClasses = function() {
      var e = this.getDomLayout(), r = {
        autoHeight: e === "autoHeight",
        normal: e === "normal",
        print: e === "print"
      }, n = r.autoHeight ? rn.AUTO_HEIGHT : r.print ? rn.PRINT : rn.NORMAL;
      this.view.updateLayoutClasses(n, r);
    }, t.prototype.getDomLayout = function() {
      var e, r = (e = this.gridOptionsService.get("domLayout")) !== null && e !== void 0 ? e : "normal", n = ["normal", "print", "autoHeight"];
      return n.indexOf(r) === -1 ? (ht("".concat(r, " is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.")), "normal") : r;
    }, lK([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), uK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), oy = function() {
  return oy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, oy.apply(this, arguments);
}, ll = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Kn;
(function(o) {
  o[o.Vertical = 0] = "Vertical", o[o.Horizontal = 1] = "Horizontal";
})(Kn || (Kn = {}));
var po;
(function(o) {
  o[o.Container = 0] = "Container", o[o.FakeContainer = 1] = "FakeContainer";
})(po || (po = {}));
var cK = (
  /** @class */
  function(o) {
    uK(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.lastScrollSource = [null, null], r.scrollLeft = -1, r.nextScrollTop = -1, r.scrollTop = -1, r.lastOffsetHeight = -1, r.lastScrollTop = -1, r.eBodyViewport = e, r.resetLastHScrollDebounced = Oi(function() {
        return r.lastScrollSource[Kn.Horizontal] = null;
      }, 500), r.resetLastVScrollDebounced = Oi(function() {
        return r.lastScrollSource[Kn.Vertical] = null;
      }, 500), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.enableRtl = this.gridOptionsService.get("enableRtl"), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this)), this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCtrl = r.centerRowContainerCtrl, e.onDisplayedColumnsWidthChanged(), e.addScrollListener();
      });
    }, t.prototype.addScrollListener = function() {
      var e = this.ctrlsService.getFakeHScrollComp(), r = this.ctrlsService.getFakeVScrollComp();
      this.addManagedListener(this.centerRowContainerCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this)), e.onScrollCallback(this.onFakeHScroll.bind(this));
      var n = this.gridOptionsService.get("debounceVerticalScrollbar"), i = n ? Oi(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this), a = n ? Oi(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
      this.addManagedListener(this.eBodyViewport, "scroll", i), r.onScrollCallback(a);
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }, t.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function(e) {
      var r = this.centerRowContainerCtrl == null;
      if (!r) {
        e === void 0 && (e = this.centerRowContainerCtrl.getCenterViewportScrollLeft());
        var n = this.enableRtl ? e : -e, i = this.ctrlsService.getTopCenterRowContainerCtrl(), a = this.ctrlsService.getStickyTopCenterRowContainerCtrl(), s = this.ctrlsService.getBottomCenterRowContainerCtrl(), l = this.ctrlsService.getFakeHScrollComp(), u = this.ctrlsService.getHeaderRowContainerCtrl();
        u.setHorizontalScroll(-n), s.setContainerTranslateX(n), i.setContainerTranslateX(n), a.setContainerTranslateX(n);
        var c = this.centerRowContainerCtrl.getViewportElement(), d = this.lastScrollSource[Kn.Horizontal] === po.Container;
        e = Math.abs(e), d ? l.setScrollPosition(e) : Xh(c, e, this.enableRtl);
      }
    }, t.prototype.isControllingScroll = function(e, r) {
      return this.lastScrollSource[r] == null ? (this.lastScrollSource[r] = e, !0) : this.lastScrollSource[r] === e;
    }, t.prototype.onFakeHScroll = function() {
      this.isControllingScroll(po.FakeContainer, Kn.Horizontal) && this.onHScrollCommon(po.FakeContainer);
    }, t.prototype.onHScroll = function() {
      this.isControllingScroll(po.Container, Kn.Horizontal) && this.onHScrollCommon(po.Container);
    }, t.prototype.onHScrollCommon = function(e) {
      var r = this.centerRowContainerCtrl.getViewportElement(), n = r.scrollLeft;
      if (!this.shouldBlockScrollUpdate(Kn.Horizontal, n, !0)) {
        var i;
        e === po.Container ? i = qh(r, this.enableRtl) : i = this.ctrlsService.getFakeHScrollComp().getScrollPosition(), this.doHorizontalScroll(Math.round(i)), this.resetLastHScrollDebounced();
      }
    }, t.prototype.onFakeVScroll = function() {
      this.isControllingScroll(po.FakeContainer, Kn.Vertical) && this.onVScrollCommon(po.FakeContainer);
    }, t.prototype.onVScroll = function() {
      this.isControllingScroll(po.Container, Kn.Vertical) && this.onVScrollCommon(po.Container);
    }, t.prototype.onVScrollCommon = function(e) {
      var r;
      e === po.Container ? r = this.eBodyViewport.scrollTop : r = this.ctrlsService.getFakeVScrollComp().getScrollPosition(), !this.shouldBlockScrollUpdate(Kn.Vertical, r, !0) && (this.animationFrameService.setScrollTop(r), this.nextScrollTop = r, e === po.Container ? this.ctrlsService.getFakeVScrollComp().setScrollPosition(r) : this.eBodyViewport.scrollTop = r, this.gridOptionsService.get("suppressAnimationFrame") ? this.scrollGridIfNeeded() : this.animationFrameService.schedule(), this.resetLastVScrollDebounced());
    }, t.prototype.doHorizontalScroll = function(e) {
      var r = this.ctrlsService.getFakeHScrollComp().getScrollPosition();
      this.scrollLeft === e && e === r || (this.scrollLeft = e, this.fireScrollEvent(Kn.Horizontal), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowContainerCtrl.onHorizontalViewportChanged(!0));
    }, t.prototype.fireScrollEvent = function(e) {
      var r = this, n = {
        type: G.EVENT_BODY_SCROLL,
        direction: e === Kn.Horizontal ? "horizontal" : "vertical",
        left: this.scrollLeft,
        top: this.scrollTop
      };
      this.eventService.dispatchEvent(n), window.clearTimeout(this.scrollTimer), this.scrollTimer = void 0, this.scrollTimer = window.setTimeout(function() {
        var i = oy(oy({}, n), { type: G.EVENT_BODY_SCROLL_END });
        r.eventService.dispatchEvent(i);
      }, 100);
    }, t.prototype.shouldBlockScrollUpdate = function(e, r, n) {
      return n === void 0 && (n = !1), n && !jl() ? !1 : e === Kn.Vertical ? this.shouldBlockVerticalScroll(r) : this.shouldBlockHorizontalScroll(r);
    }, t.prototype.shouldBlockVerticalScroll = function(e) {
      var r = uv(this.eBodyViewport), n = this.eBodyViewport.scrollHeight;
      return e < 0 || e + r > n;
    }, t.prototype.shouldBlockHorizontalScroll = function(e) {
      var r = this.centerRowContainerCtrl.getCenterWidth(), n = this.centerRowContainerCtrl.getViewportElement().scrollWidth;
      if (this.enableRtl && Kh()) {
        if (e > 0)
          return !0;
      } else if (e < 0)
        return !0;
      return Math.abs(e) + r > n;
    }, t.prototype.redrawRowsAfterScroll = function() {
      this.fireScrollEvent(Kn.Vertical);
    }, t.prototype.checkScrollLeft = function() {
      this.scrollLeft !== this.centerRowContainerCtrl.getCenterViewportScrollLeft() && this.onHScrollCommon(po.Container);
    }, t.prototype.scrollGridIfNeeded = function() {
      var e = this.scrollTop != this.nextScrollTop;
      return e && (this.scrollTop = this.nextScrollTop, this.redrawRowsAfterScroll()), e;
    }, t.prototype.setHorizontalScrollPosition = function(e, r) {
      r === void 0 && (r = !1);
      var n = 0, i = this.centerRowContainerCtrl.getViewportElement().scrollWidth - this.centerRowContainerCtrl.getCenterWidth();
      !r && this.shouldBlockScrollUpdate(Kn.Horizontal, e) && (this.enableRtl && Kh() ? e = e > 0 ? 0 : i : e = Math.min(Math.max(e, n), i)), Xh(this.centerRowContainerCtrl.getViewportElement(), Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
    }, t.prototype.setVerticalScrollPosition = function(e) {
      this.eBodyViewport.scrollTop = e;
    }, t.prototype.getVScrollPosition = function() {
      this.lastScrollTop = this.eBodyViewport.scrollTop, this.lastOffsetHeight = this.eBodyViewport.offsetHeight;
      var e = {
        top: this.lastScrollTop,
        bottom: this.lastScrollTop + this.lastOffsetHeight
      };
      return e;
    }, t.prototype.getApproximateVScollPosition = function() {
      return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
        top: this.scrollTop,
        bottom: this.scrollTop + this.lastOffsetHeight
      } : this.getVScrollPosition();
    }, t.prototype.getHScrollPosition = function() {
      return this.centerRowContainerCtrl.getHScrollPosition();
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.centerRowContainerCtrl.isHorizontalScrollShowing();
    }, t.prototype.scrollHorizontally = function(e) {
      var r = this.centerRowContainerCtrl.getViewportElement().scrollLeft;
      return this.setHorizontalScrollPosition(r + e), this.centerRowContainerCtrl.getViewportElement().scrollLeft - r;
    }, t.prototype.scrollToTop = function() {
      this.eBodyViewport.scrollTop = 0;
    }, t.prototype.ensureNodeVisible = function(e, r) {
      r === void 0 && (r = null);
      for (var n = this.rowModel.getRowCount(), i = -1, a = 0; a < n; a++) {
        var s = this.rowModel.getRow(a);
        if (typeof e == "function") {
          var l = e;
          if (s && l(s)) {
            i = a;
            break;
          }
        } else if (e === s || e === s.data) {
          i = a;
          break;
        }
      }
      i >= 0 && this.ensureIndexVisible(i, r);
    }, t.prototype.ensureIndexVisible = function(e, r) {
      var n = this;
      if (!this.gridOptionsService.isDomLayout("print")) {
        var i = this.paginationProxy.getRowCount();
        if (typeof e != "number" || e < 0 || e >= i) {
          console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + e);
          return;
        }
        var a = this.gridOptionsService.get("pagination"), s = a && !this.gridOptionsService.get("suppressPaginationPanel");
        this.getFrameworkOverrides().wrapIncoming(function() {
          s || n.paginationProxy.goToPageWithIndex(e);
          var l = n.ctrlsService.getGridBodyCtrl(), u = l.getStickyTopHeight(), c = n.paginationProxy.getRow(e), d;
          do {
            var f = c.rowTop, v = c.rowHeight, g = n.paginationProxy.getPixelOffset(), m = c.rowTop - g, b = m + c.rowHeight, S = n.getVScrollPosition(), R = n.heightScaler.getDivStretchOffset(), P = S.top + R, D = S.bottom + R, x = D - P, M = n.heightScaler.getScrollPositionForPixel(m), F = n.heightScaler.getScrollPositionForPixel(b - x), H = Math.min((M + F) / 2, m), B = P + u > m, j = D < b, V = null;
            r === "top" ? V = M : r === "bottom" ? V = F : r === "middle" ? V = H : B ? V = M - u : j && (V = F), V !== null && (n.setVerticalScrollPosition(V), n.rowRenderer.redraw({ afterScroll: !0 })), d = f !== c.rowTop || v !== c.rowHeight;
          } while (d);
          n.animationFrameService.flushAllFrames();
        });
      }
    }, t.prototype.ensureColumnVisible = function(e, r) {
      var n = this;
      r === void 0 && (r = "auto");
      var i = this.columnModel.getGridColumn(e);
      if (i && !i.isPinned() && this.columnModel.isColumnDisplayed(i)) {
        var a = this.getPositionedHorizontalScroll(i, r);
        this.getFrameworkOverrides().wrapIncoming(function() {
          a !== null && n.centerRowContainerCtrl.setCenterViewportScrollLeft(a), n.centerRowContainerCtrl.onHorizontalViewportChanged(), n.animationFrameService.flushAllFrames();
        });
      }
    }, t.prototype.setScrollPosition = function(e, r) {
      var n = this;
      this.getFrameworkOverrides().wrapIncoming(function() {
        n.centerRowContainerCtrl.setCenterViewportScrollLeft(r), n.setVerticalScrollPosition(e), n.rowRenderer.redraw({ afterScroll: !0 }), n.animationFrameService.flushAllFrames();
      });
    }, t.prototype.getPositionedHorizontalScroll = function(e, r) {
      var n = this.isColumnOutsideViewport(e), i = n.columnBeforeStart, a = n.columnAfterEnd, s = this.centerRowContainerCtrl.getCenterWidth() < e.getActualWidth(), l = this.centerRowContainerCtrl.getCenterWidth(), u = this.enableRtl, c = (u ? i : a) || s, d = u ? a : i;
      r !== "auto" && (c = r === "start", d = r === "end");
      var f = r === "middle";
      if (c || d || f) {
        var v = this.getColumnBounds(e), g = v.colLeft, m = v.colMiddle, b = v.colRight;
        return f ? m - l / 2 : c ? u ? b : g : u ? g - l : b - l;
      }
      return null;
    }, t.prototype.isColumnOutsideViewport = function(e) {
      var r = this.getViewportBounds(), n = r.start, i = r.end, a = this.getColumnBounds(e), s = a.colLeft, l = a.colRight, u = this.enableRtl, c = u ? n > l : i < l, d = u ? i < s : n > s;
      return { columnBeforeStart: c, columnAfterEnd: d };
    }, t.prototype.getColumnBounds = function(e) {
      var r = this.enableRtl, n = this.columnModel.getBodyContainerWidth(), i = e.getActualWidth(), a = e.getLeft(), s = r ? -1 : 1, l = r ? n - a : a, u = l + i * s, c = l + i / 2 * s;
      return { colLeft: l, colMiddle: c, colRight: u };
    }, t.prototype.getViewportBounds = function() {
      var e = this.centerRowContainerCtrl.getCenterWidth(), r = this.centerRowContainerCtrl.getCenterViewportScrollLeft(), n = r, i = e + r;
      return { start: n, end: i, width: e };
    }, ll([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ll([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), ll([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), ll([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), ll([
      N("rowContainerHeightService")
    ], t.prototype, "heightScaler", void 0), ll([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), ll([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), ll([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), dK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jS = function() {
  return jS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, jS.apply(this, arguments);
}, xi = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, pK = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, fK = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, hK = (
  /** @class */
  function(o) {
    dK(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.isMultiRowDrag = !1, r.eContainer = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.gridOptionsService.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.ctrlsService.whenReady(function() {
        var r = e.ctrlsService.getGridBodyCtrl();
        e.autoScrollService = new u_({
          scrollContainer: r.getBodyViewportElement(),
          scrollAxis: "y",
          getVerticalPosition: function() {
            return r.getScrollFeature().getVScrollPosition().top;
          },
          setVerticalPosition: function(n) {
            return r.getScrollFeature().setVerticalScrollPosition(n);
          },
          onScrollCallback: function() {
            e.onDragging(e.lastDraggingEvent);
          }
        });
      });
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, t.prototype.isInterestedIn = function(e) {
      return e === ho.RowDrag;
    }, t.prototype.getIconName = function() {
      var e = this.gridOptionsService.get("rowDragManaged");
      return e && this.shouldPreventRowMove() ? fn.ICON_NOT_ALLOWED : fn.ICON_MOVE;
    }, t.prototype.shouldPreventRowMove = function() {
      var e = this.columnModel.getRowGroupColumns();
      if (e.length)
        return !0;
      var r = this.filterManager.isAnyFilterPresent();
      if (r)
        return !0;
      var n = this.sortController.isSortActive();
      return !!n;
    }, t.prototype.getRowNodes = function(e) {
      var r = this;
      if (!this.isFromThisGrid(e))
        return e.dragItem.rowNodes || [];
      var n = this.gridOptionsService.get("rowDragMultiRow"), i = fK([], pK(this.selectionService.getSelectedNodes()), !1).sort(function(s, l) {
        return s.rowIndex == null || l.rowIndex == null ? 0 : r.getRowIndexNumber(s) - r.getRowIndexNumber(l);
      }), a = e.dragItem.rowNode;
      return n && i.indexOf(a) !== -1 ? (this.isMultiRowDrag = !0, i) : (this.isMultiRowDrag = !1, [a]);
    }, t.prototype.onDragEnter = function(e) {
      e.dragItem.rowNodes = this.getRowNodes(e), this.dispatchGridEvent(G.EVENT_ROW_DRAG_ENTER, e), this.getRowNodes(e).forEach(function(r) {
        r.setDragging(!0);
      }), this.onEnterOrDragging(e);
    }, t.prototype.onDragging = function(e) {
      this.onEnterOrDragging(e);
    }, t.prototype.isFromThisGrid = function(e) {
      var r = e.dragSource.dragSourceDomDataKey;
      return r === this.gridOptionsService.getDomDataKey();
    }, t.prototype.isDropZoneWithinThisGrid = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), n = r.getGui(), i = e.dropZoneTarget;
      return !n.contains(i);
    }, t.prototype.onEnterOrDragging = function(e) {
      this.dispatchGridEvent(G.EVENT_ROW_DRAG_MOVE, e), this.lastDraggingEvent = e;
      var r = this.mouseEventService.getNormalisedPosition(e).y, n = this.gridOptionsService.get("rowDragManaged");
      n && this.doManagedDrag(e, r), this.autoScrollService.check(e.event);
    }, t.prototype.doManagedDrag = function(e, r) {
      var n = this.isFromThisGrid(e), i = this.gridOptionsService.get("rowDragManaged"), a = e.dragItem.rowNodes;
      i && this.shouldPreventRowMove() || (this.gridOptionsService.get("suppressMoveWhenRowDragging") || !n ? this.isDropZoneWithinThisGrid(e) || this.clientSideRowModel.highlightRowAtPixel(a[0], r) : this.moveRows(a, r));
    }, t.prototype.getRowIndexNumber = function(e) {
      return parseInt(Kt(e.getRowIndexString().split("-")), 10);
    }, t.prototype.moveRowAndClearHighlight = function(e) {
      var r = this, n = this.clientSideRowModel.getLastHighlightedRowNode(), i = n && n.highlighted === Na.Below, a = this.mouseEventService.getNormalisedPosition(e).y, s = e.dragItem.rowNodes, l = i ? 1 : 0;
      if (this.isFromThisGrid(e))
        s.forEach(function(d) {
          d.rowTop < a && (l -= 1);
        }), this.moveRows(s, a, l);
      else {
        var u = this.gridOptionsService.getCallback("getRowId"), c = this.clientSideRowModel.getRowIndexAtPixel(a) + 1;
        this.clientSideRowModel.getHighlightPosition(a) === Na.Above && c--, this.clientSideRowModel.updateRowData({
          add: s.map(function(d) {
            return d.data;
          }).filter(function(d) {
            return !r.clientSideRowModel.getRowNode(u ? u({ data: d, level: 0 }) : d.id);
          }),
          addIndex: c
        });
      }
      this.clearRowHighlight();
    }, t.prototype.clearRowHighlight = function() {
      this.clientSideRowModel.highlightRowAtPixel(null);
    }, t.prototype.moveRows = function(e, r, n) {
      n === void 0 && (n = 0);
      var i = this.clientSideRowModel.ensureRowsAtPixel(e, r, n);
      i && (this.focusService.clearFocusedCell(), this.rangeService && this.rangeService.removeAllCellRanges());
    }, t.prototype.addRowDropZone = function(e) {
      var r = this;
      if (!e.getContainer()) {
        ht("addRowDropZone - A container target needs to be provided");
        return;
      }
      if (this.dragAndDropService.findExternalZone(e)) {
        console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
        return;
      }
      var n = {
        getContainer: e.getContainer
      };
      e.fromGrid ? (e.fromGrid = void 0, n = e) : (e.onDragEnter && (n.onDragEnter = function(i) {
        e.onDragEnter(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_ENTER, i));
      }), e.onDragLeave && (n.onDragLeave = function(i) {
        e.onDragLeave(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_LEAVE, i));
      }), e.onDragging && (n.onDragging = function(i) {
        e.onDragging(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_MOVE, i));
      }), e.onDragStop && (n.onDragStop = function(i) {
        e.onDragStop(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_END, i));
      })), this.dragAndDropService.addDropTarget(jS({ isInterestedIn: function(i) {
        return i === ho.RowDrag;
      }, getIconName: function() {
        return fn.ICON_MOVE;
      }, external: !0 }, n));
    }, t.prototype.getRowDropZone = function(e) {
      var r = this, n = this.getContainer.bind(this), i = this.onDragEnter.bind(this), a = this.onDragLeave.bind(this), s = this.onDragging.bind(this), l = this.onDragStop.bind(this);
      return e ? {
        getContainer: n,
        onDragEnter: e.onDragEnter ? function(u) {
          i(u), e.onDragEnter(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_ENTER, u));
        } : i,
        onDragLeave: e.onDragLeave ? function(u) {
          a(u), e.onDragLeave(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_LEAVE, u));
        } : a,
        onDragging: e.onDragging ? function(u) {
          s(u), e.onDragging(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_MOVE, u));
        } : s,
        onDragStop: e.onDragStop ? function(u) {
          l(u), e.onDragStop(r.draggingToRowDragEvent(G.EVENT_ROW_DRAG_END, u));
        } : l,
        fromGrid: !0
        /* @private */
      } : {
        getContainer: n,
        onDragEnter: i,
        onDragLeave: a,
        onDragging: s,
        onDragStop: l,
        /* @private */
        fromGrid: !0
      };
    }, t.prototype.draggingToRowDragEvent = function(e, r) {
      var n = this.mouseEventService.getNormalisedPosition(r).y, i = n > this.paginationProxy.getCurrentPageHeight(), a = -1, s;
      i || (a = this.rowModel.getRowIndexAtPixel(n), s = this.rowModel.getRow(a));
      var l;
      switch (r.vDirection) {
        case mc.Down:
          l = "down";
          break;
        case mc.Up:
          l = "up";
          break;
        default:
          l = null;
          break;
      }
      var u = this.gridOptionsService.addGridCommonParams({
        type: e,
        event: r.event,
        node: r.dragItem.rowNode,
        nodes: r.dragItem.rowNodes,
        overIndex: a,
        overNode: s,
        y: n,
        vDirection: l
      });
      return u;
    }, t.prototype.dispatchGridEvent = function(e, r) {
      var n = this.draggingToRowDragEvent(e, r);
      this.eventService.dispatchEvent(n);
    }, t.prototype.onDragLeave = function(e) {
      this.dispatchGridEvent(G.EVENT_ROW_DRAG_LEAVE, e), this.stopDragging(e), this.gridOptionsService.get("rowDragManaged") && this.clearRowHighlight(), this.isFromThisGrid(e) && (this.isMultiRowDrag = !1);
    }, t.prototype.onDragStop = function(e) {
      this.dispatchGridEvent(G.EVENT_ROW_DRAG_END, e), this.stopDragging(e), this.gridOptionsService.get("rowDragManaged") && (this.gridOptionsService.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(e)) && !this.isDropZoneWithinThisGrid(e) && this.moveRowAndClearHighlight(e);
    }, t.prototype.stopDragging = function(e) {
      this.autoScrollService.ensureCleared(), this.getRowNodes(e).forEach(function(r) {
        r.setDragging(!1);
      });
    }, xi([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), xi([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), xi([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), xi([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), xi([
      N("focusService")
    ], t.prototype, "focusService", void 0), xi([
      N("sortController")
    ], t.prototype, "sortController", void 0), xi([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), xi([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), xi([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), xi([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), xi([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), xi([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), vK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ro = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, yc;
(function(o) {
  o.ANIMATION_ON = "ag-row-animation", o.ANIMATION_OFF = "ag-row-no-animation";
})(yc || (yc = {}));
var NI = "ag-force-vertical-scroll", gK = "ag-selectable", mK = "ag-column-moving", kI = (
  /** @class */
  function(o) {
    vK(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.stickyTopHeight = 0, e;
    }
    return t.prototype.getScrollFeature = function() {
      return this.bodyScrollFeature;
    }, t.prototype.getBodyViewportElement = function() {
      return this.eBodyViewport;
    }, t.prototype.setComp = function(e, r, n, i, a, s) {
      var l = this;
      this.comp = e, this.eGridBody = r, this.eBodyViewport = n, this.eTop = i, this.eBottom = a, this.eStickyTop = s, this.setCellTextSelection(this.gridOptionsService.get("enableCellTextSelection")), this.addManagedPropertyListener("enableCellTextSelection", function(u) {
        return l.setCellTextSelection(u.currentValue);
      }), this.createManagedBean(new p_(this.comp)), this.bodyScrollFeature = this.createManagedBean(new cK(this.eBodyViewport)), this.addRowDragListener(), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([i, n, a, s]), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.filterManager.setupAdvancedFilterHeaderComp(i), this.ctrlsService.registerGridBodyCtrl(this);
    }, t.prototype.getComp = function() {
      return this.comp;
    }, t.prototype.addEventListeners = function() {
      this.addManagedListener(this.eventService, G.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }, t.prototype.addFocusListeners = function(e) {
      var r = this;
      e.forEach(function(n) {
        r.addManagedListener(n, "focusin", function(i) {
          var a = i.target, s = ac(a, "ag-root", n);
          n.classList.toggle("ag-has-focus", !s);
        }), r.addManagedListener(n, "focusout", function(i) {
          var a = i.target, s = i.relatedTarget, l = n.contains(s), u = ac(s, "ag-root", n), c = ac(a, "ag-root", n);
          c || (!l || u) && n.classList.remove("ag-has-focus");
        });
      });
    }, t.prototype.setColumnMovingCss = function(e) {
      this.comp.setColumnMovingCss(mK, e);
    }, t.prototype.setCellTextSelection = function(e) {
      e === void 0 && (e = !1), this.comp.setCellSelectableCss(gK, e);
    }, t.prototype.onScrollVisibilityChanged = function() {
      var e = this, r = this.scrollVisibleService.isVerticalScrollShowing();
      this.setVerticalScrollPaddingVisible(r), this.setStickyTopWidth(r);
      var n = r && this.gridOptionsService.getScrollbarWidth() || 0, i = H1() ? 16 : 0, a = "calc(100% + ".concat(n + i, "px)");
      this.animationFrameService.requestAnimationFrame(function() {
        return e.comp.setBodyViewportWidth(a);
      });
    }, t.prototype.onGridColumnsChanged = function() {
      var e = this.columnModel.getAllGridColumns();
      this.comp.setColumnCount(e.length);
    }, t.prototype.disableBrowserDragging = function() {
      this.addManagedListener(this.eGridBody, "dragstart", function(e) {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      });
    }, t.prototype.addStopEditingWhenGridLosesFocus = function() {
      var e = this;
      if (this.gridOptionsService.get("stopEditingWhenCellsLoseFocus")) {
        var r = function(i) {
          var a = i.relatedTarget;
          if (Qm(a) === null) {
            e.rowRenderer.stopEditing();
            return;
          }
          var s = (
            // see if click came from inside the viewports
            n.some(function(u) {
              return u.contains(a);
            }) && e.mouseEventService.isElementInThisGrid(a)
          );
          if (!s) {
            var l = e.popupService;
            s = l.getActivePopups().some(function(u) {
              return u.contains(a);
            }) || l.isElementWithinCustomPopup(a);
          }
          s || e.rowRenderer.stopEditing();
        }, n = [this.eBodyViewport, this.eBottom, this.eTop, this.eStickyTop];
        n.forEach(function(i) {
          return e.addManagedListener(i, "focusout", r);
        });
      }
    }, t.prototype.updateRowCount = function() {
      var e = this.headerNavigationService.getHeaderRowCount() + this.filterManager.getHeaderRowCount(), r = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1, n = r === -1 ? -1 : e + r;
      this.comp.setRowCount(n);
    }, t.prototype.registerBodyViewportResizeListener = function(e) {
      this.comp.registerBodyViewportResizeListener(e);
    }, t.prototype.setVerticalScrollPaddingVisible = function(e) {
      var r = e ? "scroll" : "hidden";
      this.comp.setPinnedTopBottomOverflowY(r);
    }, t.prototype.isVerticalScrollShowing = function() {
      var e = this.gridOptionsService.get("alwaysShowVerticalScroll"), r = e ? NI : null, n = this.gridOptionsService.isDomLayout("normal");
      return this.comp.setAlwaysVerticalScrollClass(r, e), e || n && $2(this.eBodyViewport);
    }, t.prototype.setupRowAnimationCssClass = function() {
      var e = this, r = function() {
        var n = e.gridOptionsService.isAnimateRows() && !e.rowContainerHeightService.isStretching(), i = n ? yc.ANIMATION_ON : yc.ANIMATION_OFF;
        e.comp.setRowAnimationCssOnBodyViewport(i, n);
      };
      r(), this.addManagedListener(this.eventService, G.EVENT_HEIGHT_SCALE_CHANGED, r), this.addManagedPropertyListener("animateRows", r);
    }, t.prototype.getGridBodyElement = function() {
      return this.eGridBody;
    }, t.prototype.addBodyViewportListener = function() {
      var e = this.onBodyViewportContextMenu.bind(this);
      this.addManagedListener(this.eBodyViewport, "contextmenu", e), this.mockContextMenuForIPad(e), this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this)), this.addManagedListener(this.eStickyTop, "wheel", this.onStickyTopWheel.bind(this)), this.addFullWidthContainerWheelListener();
    }, t.prototype.addFullWidthContainerWheelListener = function() {
      var e = this, r = this.eBodyViewport.querySelector(".ag-full-width-container"), n = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
      r && n && this.addManagedListener(r, "wheel", function(i) {
        return e.onFullWidthContainerWheel(i, n);
      });
    }, t.prototype.onFullWidthContainerWheel = function(e, r) {
      !e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e) || (e.preventDefault(), r.scrollBy({ left: e.deltaX }));
    }, t.prototype.onBodyViewportContextMenu = function(e, r, n) {
      if (!(!e && !n)) {
        if (this.gridOptionsService.get("preventDefaultOnContextMenu")) {
          var i = e || n;
          i.preventDefault();
        }
        var a = (e || r).target;
        if (a === this.eBodyViewport || a === this.ctrlsService.getCenterRowContainerCtrl().getViewportElement()) {
          if (!this.contextMenuFactory)
            return;
          e ? this.contextMenuFactory.onContextMenu(e, null, null, null, null, this.eGridBody) : n && this.contextMenuFactory.onContextMenu(null, n, null, null, null, this.eGridBody);
        }
      }
    }, t.prototype.mockContextMenuForIPad = function(e) {
      if (jl()) {
        var r = new Go(this.eBodyViewport), n = function(i) {
          e(void 0, i.touchStart, i.touchEvent);
        };
        this.addManagedListener(r, Go.EVENT_LONG_TAP, n), this.addDestroyFunc(function() {
          return r.destroy();
        });
      }
    }, t.prototype.onBodyViewportWheel = function(e) {
      this.gridOptionsService.get("suppressScrollWhenPopupsAreOpen") && this.popupService.hasAnchoredPopup() && e.preventDefault();
    }, t.prototype.onStickyTopWheel = function(e) {
      e.preventDefault(), e.offsetY && this.scrollVertically(e.deltaY);
    }, t.prototype.getGui = function() {
      return this.eGridBody;
    }, t.prototype.scrollVertically = function(e) {
      var r = this.eBodyViewport.scrollTop;
      return this.bodyScrollFeature.setVerticalScrollPosition(r + e), this.eBodyViewport.scrollTop - r;
    }, t.prototype.addRowDragListener = function() {
      this.rowDragFeature = this.createManagedBean(new hK(this.eBodyViewport)), this.dragAndDropService.addDropTarget(this.rowDragFeature);
    }, t.prototype.getRowDragFeature = function() {
      return this.rowDragFeature;
    }, t.prototype.onPinnedRowDataChanged = function() {
      this.setFloatingHeights();
    }, t.prototype.setFloatingHeights = function() {
      var e = this.pinnedRowModel, r = e.getPinnedTopTotalHeight(), n = e.getPinnedBottomTotalHeight();
      this.comp.setTopHeight(r), this.comp.setBottomHeight(n), this.comp.setTopDisplay(r ? "inherit" : "none"), this.comp.setBottomDisplay(n ? "inherit" : "none"), this.setStickyTopOffsetTop();
    }, t.prototype.setStickyTopHeight = function(e) {
      e === void 0 && (e = 0), this.comp.setStickyTopHeight("".concat(e, "px")), this.stickyTopHeight = e;
    }, t.prototype.getStickyTopHeight = function() {
      return this.stickyTopHeight;
    }, t.prototype.setStickyTopWidth = function(e) {
      if (!e)
        this.comp.setStickyTopWidth("100%");
      else {
        var r = this.gridOptionsService.getScrollbarWidth();
        this.comp.setStickyTopWidth("calc(100% - ".concat(r, "px)"));
      }
    }, t.prototype.onHeaderHeightChanged = function() {
      this.setStickyTopOffsetTop();
    }, t.prototype.setStickyTopOffsetTop = function() {
      var e = this.ctrlsService.getGridHeaderCtrl(), r = e.getHeaderHeight() + this.filterManager.getHeaderHeight(), n = this.pinnedRowModel.getPinnedTopTotalHeight(), i = 0;
      r > 0 && (i += r + 1), n > 0 && (i += n + 1), this.comp.setStickyTopTop("".concat(i, "px"));
    }, t.prototype.sizeColumnsToFit = function(e, r) {
      var n = this, i = this.isVerticalScrollShowing(), a = i ? this.gridOptionsService.getScrollbarWidth() : 0, s = Ec(this.eGridBody), l = s - a;
      if (l > 0) {
        this.columnModel.sizeColumnsToFit(l, "sizeColumnsToFit", !1, e);
        return;
      }
      r === void 0 ? window.setTimeout(function() {
        n.sizeColumnsToFit(e, 100);
      }, 0) : r === 100 ? window.setTimeout(function() {
        n.sizeColumnsToFit(e, 500);
      }, 100) : r === 500 ? window.setTimeout(function() {
        n.sizeColumnsToFit(e, -1);
      }, 500) : console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
    }, t.prototype.addScrollEventListener = function(e) {
      this.eBodyViewport.addEventListener("scroll", e, { passive: !0 });
    }, t.prototype.removeScrollEventListener = function(e) {
      this.eBodyViewport.removeEventListener("scroll", e);
    }, Ro([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Ro([
      N("rowContainerHeightService")
    ], t.prototype, "rowContainerHeightService", void 0), Ro([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ro([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ro([
      N("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Ro([
      Lt("contextMenuFactory")
    ], t.prototype, "contextMenuFactory", void 0), Ro([
      N("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), Ro([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), Ro([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Ro([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Ro([
      N("popupService")
    ], t.prototype, "popupService", void 0), Ro([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Ro([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Ro([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(Me)
), ev;
(function(o) {
  o[o.FILL = 0] = "FILL", o[o.RANGE = 1] = "RANGE";
})(ev || (ev = {}));
var tc;
(function(o) {
  o[o.VALUE = 0] = "VALUE", o[o.DIMENSION = 1] = "DIMENSION";
})(tc || (tc = {}));
var Pf = "ag-cell-range-selected", yK = "ag-cell-range-chart", CK = "ag-cell-range-single-cell", wK = "ag-cell-range-chart-category", bK = "ag-cell-range-handle", SK = "ag-cell-range-top", EK = "ag-cell-range-right", _K = "ag-cell-range-bottom", xK = "ag-cell-range-left", RK = (
  /** @class */
  function() {
    function o(t, e) {
      this.beans = t, this.cellCtrl = e;
    }
    return o.prototype.setComp = function(t, e) {
      this.cellComp = t, this.eGui = e, this.onRangeSelectionChanged();
    }, o.prototype.onRangeSelectionChanged = function() {
      this.cellComp && (this.rangeCount = this.beans.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()), this.hasChartRange = this.getHasChartRange(), this.cellComp.addOrRemoveCssClass(Pf, this.rangeCount !== 0), this.cellComp.addOrRemoveCssClass("".concat(Pf, "-1"), this.rangeCount === 1), this.cellComp.addOrRemoveCssClass("".concat(Pf, "-2"), this.rangeCount === 2), this.cellComp.addOrRemoveCssClass("".concat(Pf, "-3"), this.rangeCount === 3), this.cellComp.addOrRemoveCssClass("".concat(Pf, "-4"), this.rangeCount >= 4), this.cellComp.addOrRemoveCssClass(yK, this.hasChartRange), lp(this.eGui, this.rangeCount > 0 ? !0 : void 0), this.cellComp.addOrRemoveCssClass(CK, this.isSingleCell()), this.updateRangeBorders(), this.refreshHandle());
    }, o.prototype.updateRangeBorders = function() {
      var t = this.getRangeBorders(), e = this.isSingleCell(), r = !e && t.top, n = !e && t.right, i = !e && t.bottom, a = !e && t.left;
      this.cellComp.addOrRemoveCssClass(SK, r), this.cellComp.addOrRemoveCssClass(EK, n), this.cellComp.addOrRemoveCssClass(_K, i), this.cellComp.addOrRemoveCssClass(xK, a);
    }, o.prototype.isSingleCell = function() {
      var t = this.beans.rangeService;
      return this.rangeCount === 1 && t && !t.isMoreThanOneCell();
    }, o.prototype.getHasChartRange = function() {
      var t = this.beans.rangeService;
      if (!this.rangeCount || !t)
        return !1;
      var e = t.getCellRanges();
      return e.length > 0 && e.every(function(r) {
        return ra([tc.DIMENSION, tc.VALUE], r.type);
      });
    }, o.prototype.updateRangeBordersIfRangeCount = function() {
      this.rangeCount > 0 && (this.updateRangeBorders(), this.refreshHandle());
    }, o.prototype.getRangeBorders = function() {
      var t = this, e = this.beans.gridOptionsService.get("enableRtl"), r = !1, n = !1, i = !1, a = !1, s = this.cellCtrl.getCellPosition().column, l = this.beans, u = l.rangeService, c = l.columnModel, d, f;
      e ? (d = c.getDisplayedColAfter(s), f = c.getDisplayedColBefore(s)) : (d = c.getDisplayedColBefore(s), f = c.getDisplayedColAfter(s));
      var v = u.getCellRanges().filter(function(R) {
        return u.isCellInSpecificRange(t.cellCtrl.getCellPosition(), R);
      });
      d || (a = !0), f || (n = !0);
      for (var g = 0; g < v.length && !(r && n && i && a); g++) {
        var m = v[g], b = u.getRangeStartRow(m), S = u.getRangeEndRow(m);
        !r && this.beans.rowPositionUtils.sameRow(b, this.cellCtrl.getCellPosition()) && (r = !0), !i && this.beans.rowPositionUtils.sameRow(S, this.cellCtrl.getCellPosition()) && (i = !0), !a && d && m.columns.indexOf(d) < 0 && (a = !0), !n && f && m.columns.indexOf(f) < 0 && (n = !0);
      }
      return { top: r, right: n, bottom: i, left: a };
    }, o.prototype.refreshHandle = function() {
      if (this.beans.rangeService) {
        var t = this.shouldHaveSelectionHandle();
        this.selectionHandle && !t && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), t && this.addSelectionHandle(), this.cellComp.addOrRemoveCssClass(bK, !!this.selectionHandle);
      }
    }, o.prototype.shouldHaveSelectionHandle = function() {
      var t = this.beans, e = t.gridOptionsService, r = t.rangeService, n = r.getCellRanges(), i = n.length;
      if (this.rangeCount < 1 || i < 1)
        return !1;
      var a = Kt(n), s = this.cellCtrl.getCellPosition(), l = e.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle(), u = e.get("enableRangeHandle"), c = i === 1 && !this.cellCtrl.isEditing() && (l || u);
      if (this.hasChartRange) {
        var d = n[0].type === tc.DIMENSION, f = d && r.isCellInSpecificRange(s, n[0]);
        this.cellComp.addOrRemoveCssClass(wK, f), c = a.type === tc.VALUE;
      }
      return c && a.endRow != null && r.isContiguousRange(a) && r.isBottomRightCell(a, s);
    }, o.prototype.addSelectionHandle = function() {
      var t = this.beans, e = t.gridOptionsService, r = t.rangeService, n = Kt(r.getCellRanges()).type, i = e.get("enableFillHandle") && tt(n), a = i ? ev.FILL : ev.RANGE;
      this.selectionHandle && this.selectionHandle.getType() !== a && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), this.selectionHandle || (this.selectionHandle = this.beans.selectionHandleFactory.createSelectionHandle(a)), this.selectionHandle.refresh(this.cellCtrl);
    }, o.prototype.destroy = function() {
      this.beans.context.destroyBean(this.selectionHandle);
    }, o;
  }()
), TK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), OK = (
  /** @class */
  function(o) {
    TK(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.cellCtrl = e, n.beans = r, n.column = e.getColumn(), n.rowNode = e.getRowNode(), n.setupColSpan(), n.setupRowSpan(), n;
    }
    return t.prototype.setupRowSpan = function() {
      var e = this;
      this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListener(this.beans.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return e.onNewColumnsLoaded();
      });
    }, t.prototype.setComp = function(e) {
      this.eGui = e, this.onLeftChanged(), this.onWidthChanged(), this.applyRowSpan();
    }, t.prototype.onNewColumnsLoaded = function() {
      var e = this.column.getRowSpan(this.rowNode);
      this.rowSpan !== e && (this.rowSpan = e, this.applyRowSpan(!0));
    }, t.prototype.onDisplayColumnsChanged = function() {
      var e = this.getColSpanningList();
      ws(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
    }, t.prototype.setupColSpan = function() {
      this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListener(this.beans.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this)), this.addManagedListener(this.beans.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this)));
    }, t.prototype.onWidthChanged = function() {
      if (this.eGui) {
        var e = this.getCellWidth();
        this.eGui.style.width = "".concat(e, "px");
      }
    }, t.prototype.getCellWidth = function() {
      return this.colsSpanning ? this.colsSpanning.reduce(function(e, r) {
        return e + r.getActualWidth();
      }, 0) : this.column.getActualWidth();
    }, t.prototype.getColSpanningList = function() {
      var e = this.column.getColSpan(this.rowNode), r = [];
      if (e === 1)
        r.push(this.column);
      else
        for (var n = this.column, i = this.column.getPinned(), a = 0; n && a < e && (r.push(n), n = this.beans.columnModel.getDisplayedColAfter(n), !(!n || tt(n) || i !== n.getPinned())); a++)
          ;
      return r;
    }, t.prototype.onLeftChanged = function() {
      if (this.eGui) {
        var e = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eGui.style.left = e + "px";
      }
    }, t.prototype.getCellLeft = function() {
      var e;
      return this.beans.gridOptionsService.get("enableRtl") && this.colsSpanning ? e = Kt(this.colsSpanning) : e = this.column, e.getLeft();
    }, t.prototype.modifyLeftForPrintLayout = function(e) {
      if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left")
        return e;
      var r = this.beans.columnModel.getDisplayedColumnsLeftWidth();
      if (this.column.getPinned() === "right") {
        var n = this.beans.columnModel.getBodyContainerWidth();
        return r + n + (e || 0);
      }
      return r + (e || 0);
    }, t.prototype.applyRowSpan = function(e) {
      if (!(this.rowSpan === 1 && !e)) {
        var r = this.beans.gridOptionsService.getRowHeightAsNumber(), n = r * this.rowSpan;
        this.eGui.style.height = "".concat(n, "px"), this.eGui.style.zIndex = "1";
      }
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t;
  }(Me)
), PK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), DK = (
  /** @class */
  function(o) {
    PK(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.staticClasses = [], n.cellCtrl = e, n.beans = r, n.column = e.getColumn(), n.rowNode = e.getRowNode(), n;
    }
    return t.prototype.setComp = function(e) {
      this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
    }, t.prototype.applyCellClassRules = function() {
      var e = this, r = this.column.getColDef(), n = r.cellClassRules, i = this.beans.gridOptionsService.addGridCommonParams({
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        colDef: r,
        column: this.column,
        rowIndex: this.rowNode.rowIndex
      });
      this.beans.stylingService.processClassRules(
        // if current was previous, skip
        n === this.cellClassRules ? void 0 : this.cellClassRules,
        n,
        i,
        function(a) {
          return e.cellComp.addOrRemoveCssClass(a, !0);
        },
        function(a) {
          return e.cellComp.addOrRemoveCssClass(a, !1);
        }
      ), this.cellClassRules = n;
    }, t.prototype.applyUserStyles = function() {
      var e = this.column.getColDef();
      if (e.cellStyle) {
        var r;
        if (typeof e.cellStyle == "function") {
          var n = this.beans.gridOptionsService.addGridCommonParams({
            column: this.column,
            value: this.cellCtrl.getValue(),
            colDef: e,
            data: this.rowNode.data,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex
          }), i = e.cellStyle;
          r = i(n);
        } else
          r = e.cellStyle;
        r && this.cellComp.setUserStyles(r);
      }
    }, t.prototype.applyClassesFromColDef = function() {
      var e = this, r = this.column.getColDef(), n = this.beans.gridOptionsService.addGridCommonParams({
        value: this.cellCtrl.getValue(),
        data: this.rowNode.data,
        node: this.rowNode,
        column: this.column,
        colDef: r,
        rowIndex: this.rowNode.rowIndex
      });
      this.staticClasses.length && this.staticClasses.forEach(function(i) {
        return e.cellComp.addOrRemoveCssClass(i, !1);
      }), this.staticClasses = this.beans.stylingService.getStaticCellClasses(r, n), this.staticClasses.length && this.staticClasses.forEach(function(i) {
        return e.cellComp.addOrRemoveCssClass(i, !0);
      });
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t;
  }(Me)
), AK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uC = (
  /** @class */
  function(o) {
    AK(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.ctrl = e, n.beans = r, n;
    }
    return t.prototype.setComp = function(e) {
      this.eGui = e, this.setupTooltip();
    }, t.prototype.setBrowserTooltip = function(e) {
      var r = "title";
      e != null && e != "" ? this.eGui.setAttribute(r, e) : this.eGui.removeAttribute(r);
    }, t.prototype.setupTooltip = function() {
      this.browserTooltips = this.beans.gridOptionsService.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? this.setBrowserTooltip(this.tooltip) : this.createTooltipFeatureIfNeeded();
    }, t.prototype.updateTooltipText = function() {
      this.tooltip = this.ctrl.getTooltipValue();
    }, t.prototype.createTooltipFeatureIfNeeded = function() {
      var e = this, r, n, i, a;
      if (this.genericTooltipFeature == null) {
        var s = {
          getTooltipParams: function() {
            return e.getTooltipParams();
          },
          getGui: function() {
            return e.ctrl.getGui();
          }
        };
        this.genericTooltipFeature = this.createManagedBean(new nC(s, (n = (r = this.ctrl).getTooltipShowDelayOverride) === null || n === void 0 ? void 0 : n.call(r), (a = (i = this.ctrl).getTooltipHideDelayOverride) === null || a === void 0 ? void 0 : a.call(i)), this.beans.context);
      }
    }, t.prototype.refreshToolTip = function() {
      this.updateTooltipText(), this.browserTooltips && this.setBrowserTooltip(this.tooltip);
    }, t.prototype.getTooltipParams = function() {
      var e = this, r = this.ctrl, n = r.getColumn ? r.getColumn() : void 0, i = r.getColDef ? r.getColDef() : void 0, a = r.getRowNode ? r.getRowNode() : void 0;
      return {
        location: r.getLocation(),
        colDef: i,
        column: n,
        rowIndex: r.getRowIndex ? r.getRowIndex() : void 0,
        node: a,
        data: a ? a.data : void 0,
        value: this.getTooltipText(),
        valueFormatted: r.getValueFormatted ? r.getValueFormatted() : void 0,
        hideTooltipCallback: function() {
          return e.genericTooltipFeature.hideTooltip(!0);
        }
      };
    }, t.prototype.getTooltipText = function() {
      return this.tooltip;
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t;
  }(Me)
), ft = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, f_ = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.postConstruct = function() {
      this.gridOptionsService.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.gridOptionsService.isRowModelType("serverSide") && (this.serverSideRowModel = this.rowModel);
    }, ft([
      N("resizeObserverService")
    ], o.prototype, "resizeObserverService", void 0), ft([
      N("paginationProxy")
    ], o.prototype, "paginationProxy", void 0), ft([
      N("context")
    ], o.prototype, "context", void 0), ft([
      N("columnApi")
    ], o.prototype, "columnApi", void 0), ft([
      N("gridApi")
    ], o.prototype, "gridApi", void 0), ft([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), ft([
      N("expressionService")
    ], o.prototype, "expressionService", void 0), ft([
      N("environment")
    ], o.prototype, "environment", void 0), ft([
      N("rowRenderer")
    ], o.prototype, "rowRenderer", void 0), ft([
      N("templateService")
    ], o.prototype, "templateService", void 0), ft([
      N("valueService")
    ], o.prototype, "valueService", void 0), ft([
      N("eventService")
    ], o.prototype, "eventService", void 0), ft([
      N("columnModel")
    ], o.prototype, "columnModel", void 0), ft([
      N("headerNavigationService")
    ], o.prototype, "headerNavigationService", void 0), ft([
      N("navigationService")
    ], o.prototype, "navigationService", void 0), ft([
      N("columnAnimationService")
    ], o.prototype, "columnAnimationService", void 0), ft([
      Lt("rangeService")
    ], o.prototype, "rangeService", void 0), ft([
      N("focusService")
    ], o.prototype, "focusService", void 0), ft([
      Lt("contextMenuFactory")
    ], o.prototype, "contextMenuFactory", void 0), ft([
      N("popupService")
    ], o.prototype, "popupService", void 0), ft([
      N("valueFormatterService")
    ], o.prototype, "valueFormatterService", void 0), ft([
      N("stylingService")
    ], o.prototype, "stylingService", void 0), ft([
      N("columnHoverService")
    ], o.prototype, "columnHoverService", void 0), ft([
      N("userComponentFactory")
    ], o.prototype, "userComponentFactory", void 0), ft([
      N("userComponentRegistry")
    ], o.prototype, "userComponentRegistry", void 0), ft([
      N("animationFrameService")
    ], o.prototype, "animationFrameService", void 0), ft([
      N("dragService")
    ], o.prototype, "dragService", void 0), ft([
      N("dragAndDropService")
    ], o.prototype, "dragAndDropService", void 0), ft([
      N("sortController")
    ], o.prototype, "sortController", void 0), ft([
      N("filterManager")
    ], o.prototype, "filterManager", void 0), ft([
      N("rowContainerHeightService")
    ], o.prototype, "rowContainerHeightService", void 0), ft([
      N("frameworkOverrides")
    ], o.prototype, "frameworkOverrides", void 0), ft([
      N("cellPositionUtils")
    ], o.prototype, "cellPositionUtils", void 0), ft([
      N("rowPositionUtils")
    ], o.prototype, "rowPositionUtils", void 0), ft([
      N("selectionService")
    ], o.prototype, "selectionService", void 0), ft([
      Lt("selectionHandleFactory")
    ], o.prototype, "selectionHandleFactory", void 0), ft([
      N("rowCssClassCalculator")
    ], o.prototype, "rowCssClassCalculator", void 0), ft([
      N("rowModel")
    ], o.prototype, "rowModel", void 0), ft([
      N("ctrlsService")
    ], o.prototype, "ctrlsService", void 0), ft([
      N("ctrlsFactory")
    ], o.prototype, "ctrlsFactory", void 0), ft([
      N("agStackComponentsRegistry")
    ], o.prototype, "agStackComponentsRegistry", void 0), ft([
      N("valueCache")
    ], o.prototype, "valueCache", void 0), ft([
      N("rowNodeEventThrottle")
    ], o.prototype, "rowNodeEventThrottle", void 0), ft([
      N("localeService")
    ], o.prototype, "localeService", void 0), ft([
      N("valueParserService")
    ], o.prototype, "valueParserService", void 0), ft([
      N("syncService")
    ], o.prototype, "syncService", void 0), ft([
      Fe
    ], o.prototype, "postConstruct", null), o = ft([
      Be("beans")
    ], o), o;
  }()
), MK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), FK = (
  /** @class */
  function(o) {
    MK(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      return i.cellCtrl = e, i.beans = r, i.column = n, i;
    }
    return t.prototype.onMouseEvent = function(e, r) {
      if (!na(r))
        switch (e) {
          case "click":
            this.onCellClicked(r);
            break;
          case "mousedown":
          case "touchstart":
            this.onMouseDown(r);
            break;
          case "dblclick":
            this.onCellDoubleClicked(r);
            break;
          case "mouseout":
            this.onMouseOut(r);
            break;
          case "mouseover":
            this.onMouseOver(r);
            break;
        }
    }, t.prototype.onCellClicked = function(e) {
      if (this.isDoubleClickOnIPad()) {
        this.onCellDoubleClicked(e), e.preventDefault();
        return;
      }
      var r = this.beans, n = r.eventService, i = r.rangeService, a = r.gridOptionsService, s = e.ctrlKey || e.metaKey;
      i && s && i.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1 && i.intersectLastRange(!0);
      var l = this.cellCtrl.createEvent(e, G.EVENT_CELL_CLICKED);
      n.dispatchEvent(l);
      var u = this.column.getColDef();
      u.onCellClicked && window.setTimeout(function() {
        return u.onCellClicked(l);
      }, 0);
      var c = (a.get("singleClickEdit") || u.singleClickEdit) && !a.get("suppressClickEdit");
      c && !(e.shiftKey && (i == null ? void 0 : i.getCellRanges().length) != 0) && this.cellCtrl.startRowOrCellEdit();
    }, t.prototype.isDoubleClickOnIPad = function() {
      if (!jl() || _1("dblclick"))
        return !1;
      var e = (/* @__PURE__ */ new Date()).getTime(), r = e - this.lastIPadMouseClickEvent < 200;
      return this.lastIPadMouseClickEvent = e, r;
    }, t.prototype.onCellDoubleClicked = function(e) {
      var r = this.column.getColDef(), n = this.cellCtrl.createEvent(e, G.EVENT_CELL_DOUBLE_CLICKED);
      this.beans.eventService.dispatchEvent(n), typeof r.onCellDoubleClicked == "function" && window.setTimeout(function() {
        return r.onCellDoubleClicked(n);
      }, 0);
      var i = !this.beans.gridOptionsService.get("singleClickEdit") && !this.beans.gridOptionsService.get("suppressClickEdit");
      i && this.cellCtrl.startRowOrCellEdit(null, e);
    }, t.prototype.onMouseDown = function(e) {
      var r = e.ctrlKey, n = e.metaKey, i = e.shiftKey, a = e.target, s = this, l = s.cellCtrl, u = s.beans, c = u.eventService, d = u.rangeService, f = u.focusService;
      if (!this.isRightClickInExistingRange(e)) {
        var v = d && d.getCellRanges().length != 0;
        if (!i || !v) {
          var g = oa() && !l.isEditing() && !j1(a);
          l.focusCell(g);
        }
        if (i && v && !f.isCellFocused(l.getCellPosition())) {
          e.preventDefault();
          var m = f.getFocusedCell();
          if (m) {
            var b = m.column, S = m.rowIndex, R = m.rowPinned, P = u.rowRenderer.getRowByPosition({ rowIndex: S, rowPinned: R }), D = P == null ? void 0 : P.getCellCtrl(b);
            D != null && D.isEditing() && D.stopEditing(), f.setFocusedCell({
              column: b,
              rowIndex: S,
              rowPinned: R,
              forceBrowserFocus: !0,
              preventScrollOnBrowserFocus: !0
            });
          }
        }
        if (!this.containsWidget(a)) {
          if (d) {
            var x = this.cellCtrl.getCellPosition();
            if (i)
              d.extendLatestRangeToCell(x);
            else {
              var M = r || n;
              d.setRangeToCell(x, M);
            }
          }
          c.dispatchEvent(this.cellCtrl.createEvent(e, G.EVENT_CELL_MOUSE_DOWN));
        }
      }
    }, t.prototype.isRightClickInExistingRange = function(e) {
      var r = this.beans.rangeService;
      if (r) {
        var n = r.isCellInAnyRange(this.cellCtrl.getCellPosition()), i = e.button === 2 || e.ctrlKey && this.beans.gridOptionsService.get("allowContextMenuWithControlKey");
        if (n && i)
          return !0;
      }
      return !1;
    }, t.prototype.containsWidget = function(e) {
      return ac(e, "ag-selection-checkbox", 3);
    }, t.prototype.onMouseOut = function(e) {
      if (!this.mouseStayingInsideCell(e)) {
        var r = this.cellCtrl.createEvent(e, G.EVENT_CELL_MOUSE_OUT);
        this.beans.eventService.dispatchEvent(r), this.beans.columnHoverService.clearMouseOver();
      }
    }, t.prototype.onMouseOver = function(e) {
      if (!this.mouseStayingInsideCell(e)) {
        var r = this.cellCtrl.createEvent(e, G.EVENT_CELL_MOUSE_OVER);
        this.beans.eventService.dispatchEvent(r), this.beans.columnHoverService.setMouseOver([this.column]);
      }
    }, t.prototype.mouseStayingInsideCell = function(e) {
      if (!e.target || !e.relatedTarget)
        return !1;
      var r = this.cellCtrl.getGui(), n = r.contains(e.target), i = r.contains(e.relatedTarget);
      return n && i;
    }, t.prototype.destroy = function() {
    }, t;
  }(f_)
), IK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), LK = (
  /** @class */
  function(o) {
    IK(t, o);
    function t(e, r, n, i, a) {
      var s = o.call(this) || this;
      return s.cellCtrl = e, s.beans = r, s.rowNode = i, s.rowCtrl = a, s;
    }
    return t.prototype.setComp = function(e) {
      this.eGui = e;
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key;
      switch (r) {
        case we.ENTER:
          this.onEnterKeyDown(e);
          break;
        case we.F2:
          this.onF2KeyDown(e);
          break;
        case we.ESCAPE:
          this.onEscapeKeyDown(e);
          break;
        case we.TAB:
          this.onTabKeyDown(e);
          break;
        case we.BACKSPACE:
        case we.DELETE:
          this.onBackspaceOrDeleteKeyDown(r, e);
          break;
        case we.DOWN:
        case we.UP:
        case we.RIGHT:
        case we.LEFT:
          this.onNavigationKeyDown(e, r);
          break;
      }
    }, t.prototype.onNavigationKeyDown = function(e, r) {
      this.cellCtrl.isEditing() || (e.shiftKey && this.cellCtrl.isRangeSelectionEnabled() ? this.onShiftRangeSelect(e) : this.beans.navigationService.navigateToNextCell(e, r, this.cellCtrl.getCellPosition(), !0), e.preventDefault());
    }, t.prototype.onShiftRangeSelect = function(e) {
      if (this.beans.rangeService) {
        var r = this.beans.rangeService.extendLatestRangeInDirection(e);
        r && this.beans.navigationService.ensureCellVisible(r);
      }
    }, t.prototype.onTabKeyDown = function(e) {
      this.beans.navigationService.onTabKeyDown(this.cellCtrl, e);
    }, t.prototype.onBackspaceOrDeleteKeyDown = function(e, r) {
      var n = this, i = n.cellCtrl, a = n.beans, s = n.rowNode, l = a.gridOptionsService, u = a.rangeService, c = a.eventService;
      i.isEditing() || (c.dispatchEvent({ type: G.EVENT_KEY_SHORTCUT_CHANGED_CELL_START }), Q2(e, l.get("enableCellEditingOnBackspace")) ? u && l.get("enableRangeSelection") ? u.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" }) : i.isCellEditable() && s.setDataValue(i.getColumn(), null, "cellClear") : i.startRowOrCellEdit(e, r), c.dispatchEvent({ type: G.EVENT_KEY_SHORTCUT_CHANGED_CELL_END }));
    }, t.prototype.onEnterKeyDown = function(e) {
      if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing())
        this.cellCtrl.stopEditingAndFocus(!1, e.shiftKey);
      else if (this.beans.gridOptionsService.get("enterNavigatesVertically")) {
        var r = e.shiftKey ? we.UP : we.DOWN;
        this.beans.navigationService.navigateToNextCell(null, r, this.cellCtrl.getCellPosition(), !1);
      } else
        this.cellCtrl.startRowOrCellEdit(we.ENTER, e), this.cellCtrl.isEditing() && e.preventDefault();
    }, t.prototype.onF2KeyDown = function(e) {
      this.cellCtrl.isEditing() || this.cellCtrl.startRowOrCellEdit(we.F2, e);
    }, t.prototype.onEscapeKeyDown = function(e) {
      this.cellCtrl.isEditing() && (this.cellCtrl.stopRowOrCellEdit(!0), this.cellCtrl.focusCell(!0));
    }, t.prototype.processCharacter = function(e) {
      var r = e.target, n = r !== this.eGui;
      if (!(n || this.cellCtrl.isEditing())) {
        var i = e.key;
        i === " " ? this.onSpaceKeyDown(e) : (this.cellCtrl.startRowOrCellEdit(i, e), e.preventDefault());
      }
    }, t.prototype.onSpaceKeyDown = function(e) {
      var r = this.beans.gridOptionsService;
      if (!this.cellCtrl.isEditing() && r.isRowSelection()) {
        var n = this.rowNode.isSelected(), i = !n;
        if (i || !r.get("suppressRowDeselection")) {
          var a = this.beans.gridOptionsService.get("groupSelectsFiltered"), s = this.rowNode.setSelectedParams({
            newValue: i,
            rangeSelect: e.shiftKey,
            groupSelectsFiltered: a,
            event: e,
            source: "spaceKey"
          });
          n === void 0 && s === 0 && this.rowNode.setSelectedParams({
            newValue: !1,
            rangeSelect: e.shiftKey,
            groupSelectsFiltered: a,
            event: e,
            source: "spaceKey"
          });
        }
      }
      e.preventDefault();
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t;
  }(Me)
), NK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kK = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, GK = (
  /** @class */
  function(o) {
    NK(t, o);
    function t(e, r, n) {
      var i = o.call(
        this,
        /* html */
        '<div class="ag-drag-handle ag-row-drag" draggable="true"></div>'
      ) || this;
      return i.rowNode = e, i.column = r, i.eCell = n, i;
    }
    return t.prototype.postConstruct = function() {
      var e = this.getGui();
      e.appendChild(sn("rowDrag", this.gridOptionsService, null)), this.addGuiEventListener("mousedown", function(r) {
        r.stopPropagation();
      }), this.addDragSource(), this.checkVisibility();
    }, t.prototype.addDragSource = function() {
      this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }, t.prototype.onDragStart = function(e) {
      var r = this, n = this.column.getColDef().dndSourceOnRowDrag;
      e.dataTransfer.setDragImage(this.eCell, 0, 0);
      var i = function() {
        try {
          var s = JSON.stringify(r.rowNode.data);
          e.dataTransfer.setData("application/json", s), e.dataTransfer.setData("text/plain", s);
        } catch {
        }
      };
      if (n) {
        var a = this.gridOptionsService.addGridCommonParams({
          rowNode: this.rowNode,
          dragEvent: e
        });
        n(a);
      } else
        i();
    }, t.prototype.checkVisibility = function() {
      var e = this.column.isDndSource(this.rowNode);
      this.setDisplayed(e);
    }, kK([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), VK = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, HK = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, BK = "ag-column-first", WK = "ag-column-last", hv = (
  /** @class */
  function() {
    function o() {
    }
    return o.getHeaderClassesFromColDef = function(t, e, r, n) {
      return tt(t) ? [] : this.getColumnClassesFromCollDef(t.headerClass, t, e, r, n);
    }, o.getToolPanelClassesFromColDef = function(t, e, r, n) {
      return tt(t) ? [] : this.getColumnClassesFromCollDef(t.toolPanelClass, t, e, r, n);
    }, o.refreshFirstAndLastStyles = function(t, e, r) {
      t.addOrRemoveCssClass(BK, r.isColumnAtEdge(e, "first")), t.addOrRemoveCssClass(WK, r.isColumnAtEdge(e, "last"));
    }, o.getClassParams = function(t, e, r, n) {
      return e.addGridCommonParams({
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: t,
        column: r,
        columnGroup: n
      });
    }, o.getColumnClassesFromCollDef = function(t, e, r, n, i) {
      if (tt(t))
        return [];
      var a;
      if (typeof t == "function") {
        var s = this.getClassParams(e, r, n, i);
        a = t(s);
      } else
        a = t;
      return typeof a == "string" ? [a] : Array.isArray(a) ? HK([], VK(a), !1) : [];
    }, o;
  }()
), jK = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), iy = function() {
  return iy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, iy.apply(this, arguments);
}, UK = "ag-cell", $K = "ag-cell-auto-height", zK = "ag-cell-normal-height", YK = "ag-cell-focus", KK = "ag-cell-first-right-pinned", qK = "ag-cell-last-left-pinned", XK = "ag-cell-not-inline-editing", ZK = "ag-column-hover", QK = "ag-cell-wrap-text", JK = 0, Ml = (
  /** @class */
  function(o) {
    jK(t, o);
    function t(e, r, n, i) {
      var a = o.call(this) || this;
      return a.cellRangeFeature = null, a.cellPositionFeature = null, a.cellCustomStyleFeature = null, a.tooltipFeature = null, a.cellMouseListenerFeature = null, a.cellKeyboardListenerFeature = null, a.suppressRefreshCell = !1, a.onCellCompAttachedFuncs = [], a.column = e, a.rowNode = r, a.beans = n, a.rowCtrl = i, a.instanceId = e.getId() + "-" + JK++, a.column.getColDef(), a.colIdSanitised = vn(a.column.getId()), a.beans.gridOptionsService.get("suppressCellFocus") || (a.tabIndex = -1), a.createCellPosition(), a.addFeatures(), a.updateAndFormatValue(!1), a;
    }
    return t.prototype.shouldRestoreFocus = function() {
      return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
    }, t.prototype.addFeatures = function() {
      var e = this;
      this.cellPositionFeature = new OK(this, this.beans), this.addDestroyFunc(function() {
        var n;
        (n = e.cellPositionFeature) === null || n === void 0 || n.destroy(), e.cellPositionFeature = null;
      }), this.cellCustomStyleFeature = new DK(this, this.beans), this.addDestroyFunc(function() {
        var n;
        (n = e.cellCustomStyleFeature) === null || n === void 0 || n.destroy(), e.cellCustomStyleFeature = null;
      }), this.cellMouseListenerFeature = new FK(this, this.beans, this.column), this.addDestroyFunc(function() {
        var n;
        (n = e.cellMouseListenerFeature) === null || n === void 0 || n.destroy(), e.cellMouseListenerFeature = null;
      }), this.cellKeyboardListenerFeature = new LK(this, this.beans, this.column, this.rowNode, this.rowCtrl), this.addDestroyFunc(function() {
        var n;
        (n = e.cellKeyboardListenerFeature) === null || n === void 0 || n.destroy(), e.cellKeyboardListenerFeature = null;
      }), this.column.isTooltipEnabled() && (this.enableTooltipFeature(), this.addDestroyFunc(function() {
        e.disableTooltipFeature();
      }));
      var r = this.beans.rangeService && this.beans.gridOptionsService.get("enableRangeSelection");
      r && (this.cellRangeFeature = new RK(this.beans, this), this.addDestroyFunc(function() {
        var n;
        (n = e.cellRangeFeature) === null || n === void 0 || n.destroy(), e.cellRangeFeature = null;
      }));
    }, t.prototype.enableTooltipFeature = function() {
      var e = this, r = function() {
        var i = e.column.getColDef(), a = e.rowNode.data;
        if (i.tooltipField && Oe(a))
          return qd(a, i.tooltipField, e.column.isTooltipFieldContainsDots());
        var s = i.tooltipValueGetter;
        return s ? s(e.beans.gridOptionsService.addGridCommonParams({
          location: "cell",
          colDef: e.column.getColDef(),
          column: e.column,
          rowIndex: e.cellPosition.rowIndex,
          node: e.rowNode,
          data: e.rowNode.data,
          value: e.value,
          valueFormatted: e.valueFormatted
        })) : null;
      }, n = {
        getColumn: function() {
          return e.column;
        },
        getColDef: function() {
          return e.column.getColDef();
        },
        getRowIndex: function() {
          return e.cellPosition.rowIndex;
        },
        getRowNode: function() {
          return e.rowNode;
        },
        getGui: function() {
          return e.getGui();
        },
        getLocation: function() {
          return "cell";
        },
        getTooltipValue: r,
        // this makes no sense, why is the cell formatted value passed to the tooltip???
        getValueFormatted: function() {
          return e.valueFormatted;
        }
      };
      this.tooltipFeature = new uC(n, this.beans);
    }, t.prototype.disableTooltipFeature = function() {
      this.tooltipFeature && (this.tooltipFeature.destroy(), this.tooltipFeature = null);
    }, t.prototype.setComp = function(e, r, n, i, a) {
      var s, l, u, c;
      this.cellComp = e, this.eGui = r, this.printLayout = i, this.addDomData(), this.onCellFocused(this.focusEventToRestore), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(n), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (s = this.cellPositionFeature) === null || s === void 0 || s.setComp(r), (l = this.cellCustomStyleFeature) === null || l === void 0 || l.setComp(e), (u = this.tooltipFeature) === null || u === void 0 || u.setComp(r), (c = this.cellKeyboardListenerFeature) === null || c === void 0 || c.setComp(this.eGui), this.cellRangeFeature && this.cellRangeFeature.setComp(e, r), a && this.isCellEditable() ? this.startEditing() : this.showValue(), this.onCellCompAttachedFuncs.length && (this.onCellCompAttachedFuncs.forEach(function(d) {
        return d();
      }), this.onCellCompAttachedFuncs = []);
    }, t.prototype.setupAutoHeight = function(e) {
      var r = this;
      if (this.isAutoHeight = this.column.isAutoHeight(), !(!this.isAutoHeight || !e)) {
        var n = e.parentElement, i = this.beans.gridOptionsService.getRowHeightForNode(this.rowNode).height, a = function(u) {
          if (!r.editing && r.isAlive()) {
            var c = Ul(n), d = c.paddingTop, f = c.paddingBottom, v = c.borderBottomWidth, g = c.borderTopWidth, m = d + f + v + g, b = e.offsetHeight, S = b + m;
            if (u < 5) {
              var R = r.beans.gridOptionsService.getDocument(), P = !R || !R.contains(e), D = S == 0;
              if (P || D) {
                window.setTimeout(function() {
                  return a(u + 1);
                }, 0);
                return;
              }
            }
            var x = Math.max(S, i);
            r.rowNode.setRowAutoHeight(x, r.column);
          }
        }, s = function() {
          return a(0);
        };
        s();
        var l = this.beans.resizeObserverService.observeResize(e, s);
        this.addDestroyFunc(function() {
          l(), r.rowNode.setRowAutoHeight(void 0, r.column);
        });
      }
    }, t.prototype.getCellAriaRole = function() {
      var e;
      return (e = this.column.getColDef().cellAriaRole) !== null && e !== void 0 ? e : "gridcell";
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.getIncludeSelection = function() {
      return this.includeSelection;
    }, t.prototype.getIncludeRowDrag = function() {
      return this.includeRowDrag;
    }, t.prototype.getIncludeDndSource = function() {
      return this.includeDndSource;
    }, t.prototype.getColumnIdSanitised = function() {
      return this.colIdSanitised;
    }, t.prototype.getTabIndex = function() {
      return this.tabIndex;
    }, t.prototype.isCellRenderer = function() {
      var e = this.column.getColDef();
      return e.cellRenderer != null || e.cellRendererSelector != null;
    }, t.prototype.getValueToDisplay = function() {
      return this.valueFormatted != null ? this.valueFormatted : this.value;
    }, t.prototype.showValue = function(e) {
      e === void 0 && (e = !1);
      var r = this.getValueToDisplay(), n;
      if (this.isCellRenderer()) {
        var i = this.createCellRendererParams();
        n = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), i);
      }
      this.cellComp.setRenderDetails(n, r, e), this.refreshHandle();
    }, t.prototype.setupControlComps = function() {
      var e = this.column.getColDef();
      this.includeSelection = this.isIncludeControl(e.checkboxSelection), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.cellComp.setIncludeSelection(this.includeSelection), this.cellComp.setIncludeDndSource(this.includeDndSource), this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    }, t.prototype.isForceWrapper = function() {
      var e = this.beans.gridOptionsService.get("enableCellTextSelection") || this.column.isAutoHeight();
      return e;
    }, t.prototype.isIncludeControl = function(e) {
      var r = this.rowNode.rowPinned != null, n = typeof e == "function", i = r ? !1 : n || e === !0;
      return i;
    }, t.prototype.refreshShouldDestroy = function() {
      var e = this.column.getColDef(), r = this.includeSelection != this.isIncludeControl(e.checkboxSelection), n = this.includeRowDrag != this.isIncludeControl(e.rowDrag), i = this.includeDndSource != this.isIncludeControl(e.dndSource);
      return r || n || i;
    }, t.prototype.startEditing = function(e, r, n) {
      var i = this;
      if (e === void 0 && (e = null), r === void 0 && (r = !1), n === void 0 && (n = null), !(!this.isCellEditable() || this.editing)) {
        if (!this.cellComp) {
          this.onCellCompAttachedFuncs.push(function() {
            i.startEditing(e, r, n);
          });
          return;
        }
        var a = this.createCellEditorParams(e, r), s = this.column.getColDef(), l = this.beans.userComponentFactory.getCellEditorDetails(s, a);
        this.editCompDetails = l;
        var u = (l == null ? void 0 : l.popupFromSelector) != null ? l.popupFromSelector : !!s.cellEditorPopup, c = (l == null ? void 0 : l.popupPositionFromSelector) != null ? l.popupPositionFromSelector : s.cellEditorPopupPosition;
        this.setEditing(!0), this.cellComp.setEditDetails(l, u, c, this.beans.gridOptionsService.get("reactiveCustomComponents"));
        var d = this.createEvent(n, G.EVENT_CELL_EDITING_STARTED);
        this.beans.eventService.dispatchEvent(d);
      }
    }, t.prototype.setEditing = function(e) {
      this.editing !== e && (this.editing = e, this.refreshHandle());
    }, t.prototype.stopRowOrCellEdit = function(e) {
      e === void 0 && (e = !1), this.beans.gridOptionsService.get("editType") === "fullRow" ? this.rowCtrl.stopEditing(e) : this.stopEditing(e);
    }, t.prototype.onPopupEditorClosed = function() {
      this.isEditing() && this.stopEditingAndFocus();
    }, t.prototype.takeValueFromCellEditor = function(e) {
      var r = { newValueExists: !1 };
      if (e)
        return r;
      var n = this.cellComp.getCellEditor();
      if (!n)
        return r;
      var i = n.isCancelAfterEnd && n.isCancelAfterEnd();
      if (i)
        return r;
      var a = n.getValue();
      return {
        newValue: a,
        newValueExists: !0
      };
    }, t.prototype.saveNewValue = function(e, r) {
      if (r === e)
        return !1;
      this.suppressRefreshCell = !0;
      var n = this.rowNode.setDataValue(this.column, r, "edit");
      return this.suppressRefreshCell = !1, n;
    }, t.prototype.stopEditing = function(e) {
      if (e === void 0 && (e = !1), !this.editing)
        return !1;
      var r = this.takeValueFromCellEditor(e), n = r.newValue, i = r.newValueExists, a = this.rowNode.getValueFromValueService(this.column), s = !1;
      return i && (s = this.saveNewValue(a, n)), this.setEditing(!1), this.cellComp.setEditDetails(), this.editCompDetails = void 0, this.updateAndFormatValue(!1), this.refreshCell({ forceRefresh: !0, suppressFlash: !0 }), this.dispatchEditingStoppedEvent(a, n, !e && !!s), s;
    }, t.prototype.dispatchEditingStoppedEvent = function(e, r, n) {
      var i = iy(iy({}, this.createEvent(null, G.EVENT_CELL_EDITING_STOPPED)), { oldValue: e, newValue: r, valueChanged: n });
      this.beans.eventService.dispatchEvent(i);
    }, t.prototype.createCellEditorParams = function(e, r) {
      return this.beans.gridOptionsService.addGridCommonParams({
        value: this.rowNode.getValueFromValueService(this.column),
        eventKey: e,
        column: this.column,
        colDef: this.column.getColDef(),
        rowIndex: this.getCellPosition().rowIndex,
        node: this.rowNode,
        data: this.rowNode.data,
        cellStartedEdit: r,
        onKeyDown: this.onKeyDown.bind(this),
        stopEditing: this.stopEditingAndFocus.bind(this),
        eGridCell: this.getGui(),
        parseValue: this.parseValue.bind(this),
        formatValue: this.formatValue.bind(this)
      });
    }, t.prototype.createCellRendererParams = function() {
      var e = this, r = this.beans.gridOptionsService.addGridCommonParams({
        value: this.value,
        valueFormatted: this.valueFormatted,
        getValue: function() {
          return e.rowNode.getValueFromValueService(e.column);
        },
        setValue: function(n) {
          return e.beans.valueService.setValue(e.rowNode, e.column, n);
        },
        formatValue: this.formatValue.bind(this),
        data: this.rowNode.data,
        node: this.rowNode,
        pinned: this.column.getPinned(),
        colDef: this.column.getColDef(),
        column: this.column,
        rowIndex: this.getCellPosition().rowIndex,
        refreshCell: this.refreshCell.bind(this),
        eGridCell: this.getGui(),
        eParentOfValue: this.cellComp.getParentOfValue(),
        registerRowDragger: function(n, i, a, s) {
          return e.registerRowDragger(n, i, s);
        }
      });
      return r;
    }, t.prototype.parseValue = function(e) {
      return this.beans.valueParserService.parseValue(this.column, this.rowNode, e, this.getValue());
    }, t.prototype.setFocusOutOnEditor = function() {
      if (this.editing) {
        var e = this.cellComp.getCellEditor();
        e && e.focusOut && e.focusOut();
      }
    }, t.prototype.setFocusInOnEditor = function() {
      if (this.editing) {
        var e = this.cellComp.getCellEditor();
        e && e.focusIn ? e.focusIn() : this.focusCell(!0);
      }
    }, t.prototype.onCellChanged = function(e) {
      var r = e.column === this.column;
      r && this.refreshCell({});
    }, t.prototype.refreshOrDestroyCell = function(e) {
      var r;
      this.refreshShouldDestroy() ? (r = this.rowCtrl) === null || r === void 0 || r.refreshCell(this) : this.refreshCell(e);
    }, t.prototype.refreshCell = function(e) {
      var r, n, i;
      if (!(this.suppressRefreshCell || this.editing)) {
        var a = this.column.getColDef(), s = e != null && !!e.newData, l = e != null && !!e.suppressFlash || !!a.suppressCellFlash, u = a.field == null && a.valueGetter == null && a.showRowGroup == null, c = e && e.forceRefresh || u || s, d = !!this.cellComp, f = this.updateAndFormatValue(d), v = c || f;
        if (d) {
          if (v) {
            this.showValue(s);
            var g = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering(), m = !l && !g && (this.beans.gridOptionsService.get("enableCellChangeFlash") || a.enableCellChangeFlash);
            m && this.flashCell(), (r = this.cellCustomStyleFeature) === null || r === void 0 || r.applyUserStyles(), (n = this.cellCustomStyleFeature) === null || n === void 0 || n.applyClassesFromColDef();
          }
          this.refreshToolTip(), (i = this.cellCustomStyleFeature) === null || i === void 0 || i.applyCellClassRules();
        }
      }
    }, t.prototype.stopEditingAndFocus = function(e, r) {
      e === void 0 && (e = !1), r === void 0 && (r = !1), this.stopRowOrCellEdit(), this.focusCell(!0), e || this.navigateAfterEdit(r);
    }, t.prototype.navigateAfterEdit = function(e) {
      var r = this.beans.gridOptionsService.get("enterNavigatesVerticallyAfterEdit");
      if (r) {
        var n = e ? we.UP : we.DOWN;
        this.beans.navigationService.navigateToNextCell(null, n, this.getCellPosition(), !1);
      }
    }, t.prototype.flashCell = function(e) {
      var r = e && e.flashDelay, n = e && e.fadeDelay;
      this.animateCell("data-changed", r, n);
    }, t.prototype.animateCell = function(e, r, n) {
      var i = this;
      if (this.cellComp) {
        var a = "ag-cell-".concat(e), s = "ag-cell-".concat(e, "-animation"), l = this.beans.gridOptionsService;
        r || (r = l.get("cellFlashDelay")), Oe(n) || (n = l.get("cellFadeDelay")), this.cellComp.addOrRemoveCssClass(a, !0), this.cellComp.addOrRemoveCssClass(s, !1), this.beans.frameworkOverrides.wrapIncoming(function() {
          window.setTimeout(function() {
            i.isAlive() && (i.cellComp.addOrRemoveCssClass(a, !1), i.cellComp.addOrRemoveCssClass(s, !0), i.eGui.style.transition = "background-color ".concat(n, "ms"), window.setTimeout(function() {
              i.isAlive() && (i.cellComp.addOrRemoveCssClass(s, !1), i.eGui.style.transition = "");
            }, n));
          }, r);
        });
      }
    }, t.prototype.onFlashCells = function(e) {
      if (this.cellComp) {
        var r = this.beans.cellPositionUtils.createId(this.getCellPosition()), n = e.cells[r];
        n && this.animateCell("highlight");
      }
    }, t.prototype.isCellEditable = function() {
      return this.column.isCellEditable(this.rowNode);
    }, t.prototype.isSuppressFillHandle = function() {
      return this.column.isSuppressFillHandle();
    }, t.prototype.formatValue = function(e) {
      var r;
      return (r = this.callValueFormatter(e)) !== null && r !== void 0 ? r : e;
    }, t.prototype.callValueFormatter = function(e) {
      return this.beans.valueFormatterService.formatValue(this.column, this.rowNode, e);
    }, t.prototype.updateAndFormatValue = function(e) {
      var r = this.value, n = this.valueFormatted;
      return this.value = this.rowNode.getValueFromValueService(this.column), this.valueFormatted = this.callValueFormatter(this.value), e ? !this.valuesAreEqual(r, this.value) || this.valueFormatted != n : !0;
    }, t.prototype.valuesAreEqual = function(e, r) {
      var n = this.column.getColDef();
      return n.equals ? n.equals(e, r) : e === r;
    }, t.prototype.getComp = function() {
      return this.cellComp;
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getValueFormatted = function() {
      return this.valueFormatted;
    }, t.prototype.addDomData = function() {
      var e = this, r = this.getGui();
      this.beans.gridOptionsService.setDomData(r, t.DOM_DATA_KEY_CELL_CTRL, this), this.addDestroyFunc(function() {
        return e.beans.gridOptionsService.setDomData(r, t.DOM_DATA_KEY_CELL_CTRL, null);
      });
    }, t.prototype.createEvent = function(e, r) {
      var n = this.beans.gridOptionsService.addGridCommonParams({
        type: r,
        node: this.rowNode,
        data: this.rowNode.data,
        value: this.value,
        column: this.column,
        colDef: this.column.getColDef(),
        rowPinned: this.rowNode.rowPinned,
        event: e,
        rowIndex: this.rowNode.rowIndex
      });
      return n;
    }, t.prototype.processCharacter = function(e) {
      var r;
      (r = this.cellKeyboardListenerFeature) === null || r === void 0 || r.processCharacter(e);
    }, t.prototype.onKeyDown = function(e) {
      var r;
      (r = this.cellKeyboardListenerFeature) === null || r === void 0 || r.onKeyDown(e);
    }, t.prototype.onMouseEvent = function(e, r) {
      var n;
      (n = this.cellMouseListenerFeature) === null || n === void 0 || n.onMouseEvent(e, r);
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.refreshToolTip = function() {
      var e;
      (e = this.tooltipFeature) === null || e === void 0 || e.refreshToolTip();
    }, t.prototype.getColSpanningList = function() {
      return this.cellPositionFeature.getColSpanningList();
    }, t.prototype.onLeftChanged = function() {
      var e;
      this.cellComp && ((e = this.cellPositionFeature) === null || e === void 0 || e.onLeftChanged());
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
    }, t.prototype.refreshFirstAndLastStyles = function() {
      var e = this, r = e.cellComp, n = e.column, i = e.beans;
      hv.refreshFirstAndLastStyles(r, n, i.columnModel);
    }, t.prototype.refreshAriaColIndex = function() {
      var e = this.beans.columnModel.getAriaColumnIndex(this.column);
      I1(this.getGui(), e);
    }, t.prototype.isSuppressNavigable = function() {
      return this.column.isSuppressNavigable(this.rowNode);
    }, t.prototype.onWidthChanged = function() {
      var e;
      return (e = this.cellPositionFeature) === null || e === void 0 ? void 0 : e.onWidthChanged();
    }, t.prototype.getColumn = function() {
      return this.column;
    }, t.prototype.getRowNode = function() {
      return this.rowNode;
    }, t.prototype.getBeans = function() {
      return this.beans;
    }, t.prototype.isPrintLayout = function() {
      return this.printLayout;
    }, t.prototype.appendChild = function(e) {
      this.eGui.appendChild(e);
    }, t.prototype.refreshHandle = function() {
      this.cellRangeFeature && this.cellRangeFeature.refreshHandle();
    }, t.prototype.getCellPosition = function() {
      return this.cellPosition;
    }, t.prototype.isEditing = function() {
      return this.editing;
    }, t.prototype.startRowOrCellEdit = function(e, r) {
      r === void 0 && (r = null), this.cellComp && (this.beans.gridOptionsService.get("editType") === "fullRow" ? this.rowCtrl.startRowEditing(e, this) : this.startEditing(e, !0, r));
    }, t.prototype.getRowCtrl = function() {
      return this.rowCtrl;
    }, t.prototype.getRowPosition = function() {
      return {
        rowIndex: this.cellPosition.rowIndex,
        rowPinned: this.cellPosition.rowPinned
      };
    }, t.prototype.updateRangeBordersIfRangeCount = function() {
      this.cellComp && this.cellRangeFeature && this.cellRangeFeature.updateRangeBordersIfRangeCount();
    }, t.prototype.onRangeSelectionChanged = function() {
      this.cellComp && this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
    }, t.prototype.isRangeSelectionEnabled = function() {
      return this.cellRangeFeature != null;
    }, t.prototype.focusCell = function(e) {
      e === void 0 && (e = !1), this.beans.focusService.setFocusedCell({
        rowIndex: this.getCellPosition().rowIndex,
        column: this.column,
        rowPinned: this.rowNode.rowPinned,
        forceBrowserFocus: e
      });
    }, t.prototype.onRowIndexChanged = function() {
      this.createCellPosition(), this.onCellFocused(), this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
    }, t.prototype.onFirstRightPinnedChanged = function() {
      if (this.cellComp) {
        var e = this.column.isFirstRightPinned();
        this.cellComp.addOrRemoveCssClass(KK, e);
      }
    }, t.prototype.onLastLeftPinnedChanged = function() {
      if (this.cellComp) {
        var e = this.column.isLastLeftPinned();
        this.cellComp.addOrRemoveCssClass(qK, e);
      }
    }, t.prototype.onCellFocused = function(e) {
      if (!this.beans.gridOptionsService.get("suppressCellFocus")) {
        var r = this.beans.focusService.isCellFocused(this.cellPosition);
        if (!this.cellComp) {
          r && (e != null && e.forceBrowserFocus) && (this.focusEventToRestore = e);
          return;
        }
        if (this.focusEventToRestore = void 0, this.cellComp.addOrRemoveCssClass(YK, r), r && e && e.forceBrowserFocus) {
          var n = this.cellComp.getFocusableElement();
          n.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
        }
        var i = this.beans.gridOptionsService.get("editType") === "fullRow";
        !r && !i && this.editing && this.stopRowOrCellEdit();
      }
    }, t.prototype.createCellPosition = function() {
      this.cellPosition = {
        rowIndex: this.rowNode.rowIndex,
        rowPinned: Ia(this.rowNode.rowPinned),
        column: this.column
      };
    }, t.prototype.applyStaticCssClasses = function() {
      this.cellComp.addOrRemoveCssClass(UK, !0), this.cellComp.addOrRemoveCssClass(XK, !0);
      var e = this.column.isAutoHeight() == !0;
      this.cellComp.addOrRemoveCssClass($K, e), this.cellComp.addOrRemoveCssClass(zK, !e);
    }, t.prototype.onColumnHover = function() {
      if (this.cellComp && this.beans.gridOptionsService.get("columnHoverHighlight")) {
        var e = this.beans.columnHoverService.isHovered(this.column);
        this.cellComp.addOrRemoveCssClass(ZK, e);
      }
    }, t.prototype.onColDefChanged = function() {
      var e, r;
      if (this.cellComp) {
        var n = this.column.isAutoHeight();
        n !== this.isAutoHeight && ((e = this.rowCtrl) === null || e === void 0 || e.refreshCell(this));
        var i = this.column.isTooltipEnabled();
        if (i ? (this.disableTooltipFeature(), this.enableTooltipFeature(), (r = this.tooltipFeature) === null || r === void 0 || r.setComp(this.eGui)) : this.disableTooltipFeature(), this.setWrapText(), !this.editing)
          this.refreshOrDestroyCell({ forceRefresh: !0, suppressFlash: !0 });
        else {
          var a = this.getCellEditor();
          if (a != null && a.refresh) {
            var s = this.editCompDetails.params, l = s.eventKey, u = s.cellStartedEdit, c = this.createCellEditorParams(l, u), d = this.column.getColDef(), f = this.beans.userComponentFactory.getCellEditorDetails(d, c);
            a.refresh(f.params);
          }
        }
      }
    }, t.prototype.setWrapText = function() {
      var e = this.column.getColDef().wrapText == !0;
      this.cellComp.addOrRemoveCssClass(QK, e);
    }, t.prototype.dispatchCellContextMenuEvent = function(e) {
      var r = this.column.getColDef(), n = this.createEvent(e, G.EVENT_CELL_CONTEXT_MENU);
      this.beans.eventService.dispatchEvent(n), r.onCellContextMenu && window.setTimeout(function() {
        return r.onCellContextMenu(n);
      }, 0);
    }, t.prototype.getCellRenderer = function() {
      return this.cellComp ? this.cellComp.getCellRenderer() : null;
    }, t.prototype.getCellEditor = function() {
      return this.cellComp ? this.cellComp.getCellEditor() : null;
    }, t.prototype.destroy = function() {
      this.onCellCompAttachedFuncs = [], o.prototype.destroy.call(this);
    }, t.prototype.createSelectionCheckbox = function() {
      var e = new l_();
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
    }, t.prototype.createDndSource = function() {
      var e = new GK(this.rowNode, this.column, this.eGui);
      return this.beans.context.createBean(e), e;
    }, t.prototype.registerRowDragger = function(e, r, n) {
      var i = this;
      if (this.customRowDragComp) {
        this.customRowDragComp.setDragElement(e, r);
        return;
      }
      var a = this.createRowDragComp(e, r, n);
      a && (this.customRowDragComp = a, this.addDestroyFunc(function() {
        i.beans.context.destroyBean(a), i.customRowDragComp = null;
      }));
    }, t.prototype.createRowDragComp = function(e, r, n) {
      var i = this, a = this.beans.gridOptionsService.get("pagination"), s = this.beans.gridOptionsService.get("rowDragManaged"), l = this.beans.gridOptionsService.isRowModelType("clientSide");
      if (s) {
        if (!l) {
          ht("managed row dragging is only allowed in the Client Side Row Model");
          return;
        }
        if (a) {
          ht("managed row dragging is not possible when doing pagination");
          return;
        }
      }
      var u = new ry(function() {
        return i.value;
      }, this.rowNode, this.column, e, r, n);
      return this.beans.context.createBean(u), u;
    }, t.DOM_DATA_KEY_CELL_CTRL = "cellCtrl", t;
  }(Me)
), eq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tq = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Kw = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, qw = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, Mo;
(function(o) {
  o.Normal = "Normal", o.FullWidth = "FullWidth", o.FullWidthLoading = "FullWidthLoading", o.FullWidthGroup = "FullWidthGroup", o.FullWidthDetail = "FullWidthDetail";
})(Mo || (Mo = {}));
var rq = 0, Fl = (
  /** @class */
  function(o) {
    eq(t, o);
    function t(e, r, n, i, a) {
      var s = o.call(this) || this;
      return s.allRowGuis = [], s.active = !0, s.centerCellCtrls = { list: [], map: {} }, s.leftCellCtrls = { list: [], map: {} }, s.rightCellCtrls = { list: [], map: {} }, s.slideInAnimation = {
        left: !1,
        center: !1,
        right: !1,
        fullWidth: !1
      }, s.fadeInAnimation = {
        left: !1,
        center: !1,
        right: !1,
        fullWidth: !1
      }, s.rowDragComps = [], s.lastMouseDownOnDragger = !1, s.emptyStyle = {}, s.updateColumnListsPending = !1, s.rowId = null, s.businessKeySanitised = null, s.beans = r, s.gridOptionsService = r.gridOptionsService, s.rowNode = e, s.paginationPage = r.paginationProxy.getCurrentPage(), s.useAnimationFrameForCreate = i, s.printLayout = a, s.suppressRowTransform = s.gridOptionsService.get("suppressRowTransform"), s.instanceId = e.id + "-" + rq++, s.rowId = vn(e.id), s.initRowBusinessKey(), s.rowFocused = r.focusService.isRowFocused(s.rowNode.rowIndex, s.rowNode.rowPinned), s.rowLevel = r.rowCssClassCalculator.calculateRowLevel(s.rowNode), s.setRowType(), s.setAnimateFlags(n), s.rowStyles = s.processStylesFromGridOptions(), s.isFullWidth() && !s.gridOptionsService.get("suppressCellFocus") && (s.tabIndex = -1), s.addListeners(), s;
    }
    return t.prototype.initRowBusinessKey = function() {
      this.businessKeyForNodeFunc = this.gridOptionsService.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
    }, t.prototype.updateRowBusinessKey = function() {
      if (typeof this.businessKeyForNodeFunc == "function") {
        var e = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKeySanitised = vn(e);
      }
    }, t.prototype.getRowId = function() {
      return this.rowId;
    }, t.prototype.getRowStyles = function() {
      return this.rowStyles;
    }, t.prototype.getTabIndex = function() {
      return this.tabIndex;
    }, t.prototype.isSticky = function() {
      return this.rowNode.sticky;
    }, t.prototype.getBeans = function() {
      return this.beans;
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.setComp = function(e, r, n) {
      var i = { rowComp: e, element: r, containerType: n };
      this.allRowGuis.push(i), n === dn.LEFT ? this.leftGui = i : n === dn.RIGHT ? this.rightGui = i : n === dn.FULL_WIDTH ? this.fullWidthGui = i : this.centerGui = i, this.initialiseRowComp(i), this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    }, t.prototype.unsetComp = function(e) {
      switch (this.allRowGuis = this.allRowGuis.filter(function(r) {
        return r.containerType !== e;
      }), e) {
        case dn.LEFT:
          this.leftGui = void 0;
          break;
        case dn.RIGHT:
          this.rightGui = void 0;
          break;
        case dn.FULL_WIDTH:
          this.fullWidthGui = void 0;
          break;
        case dn.CENTER:
          this.centerGui = void 0;
          break;
      }
    }, t.prototype.isCacheable = function() {
      return this.rowType === Mo.FullWidthDetail && this.gridOptionsService.get("keepDetailRows");
    }, t.prototype.setCached = function(e) {
      var r = e ? "none" : "";
      this.allRowGuis.forEach(function(n) {
        return n.element.style.display = r;
      });
    }, t.prototype.initialiseRowComp = function(e) {
      var r = this, n = this.gridOptionsService;
      this.listenOnDomOrder(e), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights(), this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(!1, e), n.isRowSelection() && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
      var i = e.rowComp, a = this.getInitialRowClasses(e.containerType);
      a.forEach(function(s) {
        return i.addOrRemoveCssClass(s, !0);
      }), this.executeSlideAndFadeAnimations(e), this.rowNode.group && ea(e.element, this.rowNode.expanded == !0), this.setRowCompRowId(i), this.setRowCompRowBusinessKey(i), n.setDomData(e.element, t.DOM_DATA_KEY_ROW_CTRL, this), this.addDestroyFunc(function() {
        return n.setDomData(e.element, t.DOM_DATA_KEY_ROW_CTRL, null);
      }), this.useAnimationFrameForCreate ? this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, e.element), this.rowNode.rowIndex, "createTasksP2") : this.addHoverFunctionality(e.element), this.isFullWidth() && this.setupFullWidth(e), n.get("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameService.addDestroyTask(function() {
        r.isAlive() && e.rowComp.addOrRemoveCssClass("ag-after-created", !0);
      }), this.executeProcessRowPostCreateFunc();
    }, t.prototype.setRowCompRowBusinessKey = function(e) {
      this.businessKeySanitised != null && e.setRowBusinessKey(this.businessKeySanitised);
    }, t.prototype.getBusinessKey = function() {
      return this.businessKeySanitised;
    }, t.prototype.setRowCompRowId = function(e) {
      this.rowId = vn(this.rowNode.id), this.rowId != null && e.setRowId(this.rowId);
    }, t.prototype.executeSlideAndFadeAnimations = function(e) {
      var r = this, n = e.containerType, i = this.slideInAnimation[n];
      i && (TS(function() {
        r.onTopChanged();
      }), this.slideInAnimation[n] = !1);
      var a = this.fadeInAnimation[n];
      a && (TS(function() {
        e.rowComp.addOrRemoveCssClass("ag-opacity-zero", !1);
      }), this.fadeInAnimation[n] = !1);
    }, t.prototype.addRowDraggerToRow = function(e) {
      if (this.gridOptionsService.get("enableRangeSelection")) {
        ht("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
        return;
      }
      var r = this.beans.localeService.getLocaleTextFunc(), n = new ry(function() {
        return "1 ".concat(r("rowDragRow", "row"));
      }, this.rowNode, void 0, e.element, void 0, !0), i = this.createBean(n, this.beans.context);
      this.rowDragComps.push(i);
    }, t.prototype.setupFullWidth = function(e) {
      var r = this.getPinnedForContainer(e.containerType), n = this.createFullWidthParams(e.element, r);
      if (!(this.rowType == Mo.FullWidthDetail && !Xt.__assertRegistered(Ye.MasterDetailModule, "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId()))) {
        var i;
        switch (this.rowType) {
          case Mo.FullWidthDetail:
            i = this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(n);
            break;
          case Mo.FullWidthGroup:
            i = this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(n);
            break;
          case Mo.FullWidthLoading:
            i = this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(n);
            break;
          default:
            i = this.beans.userComponentFactory.getFullWidthCellRendererDetails(n);
            break;
        }
        e.rowComp.showFullWidth(i);
      }
    }, t.prototype.isPrintLayout = function() {
      return this.printLayout;
    }, t.prototype.getFullWidthCellRenderers = function() {
      var e, r;
      return this.gridOptionsService.get("embedFullWidthRows") ? this.allRowGuis.map(function(n) {
        var i;
        return (i = n == null ? void 0 : n.rowComp) === null || i === void 0 ? void 0 : i.getFullWidthCellRenderer();
      }) : [(r = (e = this.fullWidthGui) === null || e === void 0 ? void 0 : e.rowComp) === null || r === void 0 ? void 0 : r.getFullWidthCellRenderer()];
    }, t.prototype.getCellElement = function(e) {
      var r = this.getCellCtrl(e);
      return r ? r.getGui() : null;
    }, t.prototype.executeProcessRowPostCreateFunc = function() {
      var e = this.gridOptionsService.getCallback("processRowPostCreate");
      if (!(!e || !this.areAllContainersReady())) {
        var r = {
          // areAllContainersReady asserts that centerGui is not null
          eRow: this.centerGui.element,
          ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
          ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex,
          addRenderedRowListener: this.addEventListener.bind(this)
        };
        e(r);
      }
    }, t.prototype.areAllContainersReady = function() {
      var e = !!this.leftGui || !this.beans.columnModel.isPinningLeft(), r = !!this.centerGui, n = !!this.rightGui || !this.beans.columnModel.isPinningRight();
      return e && r && n;
    }, t.prototype.setRowType = function() {
      var e = this.rowNode.stub, r = this.rowNode.isFullWidthCell(), n = this.gridOptionsService.get("masterDetail") && this.rowNode.detail, i = this.beans.columnModel.isPivotMode(), a = !!this.rowNode.group && !this.rowNode.footer, s = a && this.gridOptionsService.isGroupUseEntireRow(i);
      e ? this.rowType = Mo.FullWidthLoading : n ? this.rowType = Mo.FullWidthDetail : r ? this.rowType = Mo.FullWidth : s ? this.rowType = Mo.FullWidthGroup : this.rowType = Mo.Normal;
    }, t.prototype.updateColumnLists = function(e, r) {
      var n = this;
      if (e === void 0 && (e = !1), r === void 0 && (r = !1), !this.isFullWidth()) {
        var i = e || this.gridOptionsService.get("suppressAnimationFrame") || this.printLayout;
        if (i) {
          this.updateColumnListsImpl(r);
          return;
        }
        this.updateColumnListsPending || (this.beans.animationFrameService.createTask(function() {
          n.active && n.updateColumnListsImpl(!0);
        }, this.rowNode.rowIndex, "createTasksP1"), this.updateColumnListsPending = !0);
      }
    }, t.prototype.createCellCtrls = function(e, r, n) {
      var i = this;
      n === void 0 && (n = null);
      var a = {
        list: [],
        map: {}
      }, s = function(l, u) {
        a.list.push(u), a.map[l] = u;
      };
      return r.forEach(function(l) {
        var u = l.getInstanceId(), c = e.map[u];
        c || (c = new Ml(l, i.rowNode, i.beans, i)), s(u, c);
      }), e.list.forEach(function(l) {
        var u = a.map[l.getColumn().getInstanceId()] != null;
        if (!u) {
          var c = !i.isCellEligibleToBeRemoved(l, n);
          if (c) {
            s(l.getColumn().getInstanceId(), l);
            return;
          }
          l.destroy();
        }
      }), a;
    }, t.prototype.updateColumnListsImpl = function(e) {
      this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(e);
    }, t.prototype.setCellCtrls = function(e) {
      var r = this;
      this.allRowGuis.forEach(function(n) {
        var i = r.getCellCtrlsForContainer(n.containerType);
        n.rowComp.setCellCtrls(i, e);
      });
    }, t.prototype.getCellCtrlsForContainer = function(e) {
      switch (e) {
        case dn.LEFT:
          return this.leftCellCtrls.list;
        case dn.RIGHT:
          return this.rightCellCtrls.list;
        case dn.FULL_WIDTH:
          return [];
        case dn.CENTER:
          return this.centerCellCtrls.list;
        default:
          var r = e;
          throw new Error("Unhandled case: ".concat(r));
      }
    }, t.prototype.createAllCellCtrls = function() {
      var e = this.beans.columnModel;
      if (this.printLayout)
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, e.getAllDisplayedColumns()), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
      else {
        var r = e.getViewportCenterColumnsForRow(this.rowNode);
        this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, r);
        var n = e.getDisplayedLeftColumnsForRow(this.rowNode);
        this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, n, "left");
        var i = e.getDisplayedRightColumnsForRow(this.rowNode);
        this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, i, "right");
      }
    }, t.prototype.isCellEligibleToBeRemoved = function(e, r) {
      var n = !0, i = !1, a = e.getColumn();
      if (a.getPinned() != r)
        return n;
      var s = e.isEditing(), l = this.beans.focusService.isCellFocused(e.getCellPosition()), u = s || l;
      if (u) {
        var c = e.getColumn(), d = this.beans.columnModel.getAllDisplayedColumns(), f = d.indexOf(c) >= 0;
        return f ? i : n;
      }
      return n;
    }, t.prototype.getDomOrder = function() {
      var e = this.gridOptionsService.get("ensureDomOrder");
      return e || this.gridOptionsService.isDomLayout("print");
    }, t.prototype.listenOnDomOrder = function(e) {
      var r = this, n = function() {
        e.rowComp.setDomOrder(r.getDomOrder());
      };
      this.addManagedPropertyListener("domLayout", n), this.addManagedPropertyListener("ensureDomOrder", n);
    }, t.prototype.setAnimateFlags = function(e) {
      if (!(this.isSticky() || !e)) {
        var r = Oe(this.rowNode.oldRowTop), n = this.beans.columnModel.isPinningLeft(), i = this.beans.columnModel.isPinningRight();
        if (r) {
          if (this.isFullWidth() && !this.gridOptionsService.get("embedFullWidthRows")) {
            this.slideInAnimation.fullWidth = !0;
            return;
          }
          this.slideInAnimation.center = !0, this.slideInAnimation.left = n, this.slideInAnimation.right = i;
        } else {
          if (this.isFullWidth() && !this.gridOptionsService.get("embedFullWidthRows")) {
            this.fadeInAnimation.fullWidth = !0;
            return;
          }
          this.fadeInAnimation.center = !0, this.fadeInAnimation.left = n, this.fadeInAnimation.right = i;
        }
      }
    }, t.prototype.isEditing = function() {
      return this.editingRow;
    }, t.prototype.isFullWidth = function() {
      return this.rowType !== Mo.Normal;
    }, t.prototype.getRowType = function() {
      return this.rowType;
    }, t.prototype.refreshFullWidth = function() {
      var e = this, r = function(u, c) {
        return u ? u.rowComp.refreshFullWidth(function() {
          return e.createFullWidthParams(u.element, c);
        }) : !0;
      }, n = r(this.fullWidthGui, null), i = r(this.centerGui, null), a = r(this.leftGui, "left"), s = r(this.rightGui, "right"), l = n && i && a && s;
      return l;
    }, t.prototype.addListeners = function() {
      var e = this;
      this.addManagedListener(this.rowNode, St.EVENT_HEIGHT_CHANGED, function() {
        return e.onRowHeightChanged();
      }), this.addManagedListener(this.rowNode, St.EVENT_ROW_SELECTED, function() {
        return e.onRowSelected();
      }), this.addManagedListener(this.rowNode, St.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_TOP_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this)), this.rowNode.detail && this.addManagedListener(this.rowNode.parent, St.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, this.postProcessCss.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_DRAGGING_CHANGED, this.postProcessRowDragging.bind(this)), this.addManagedListener(this.rowNode, St.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
      var r = this.beans.eventService;
      this.addManagedListener(r, G.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this)), this.addManagedListener(r, G.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this)), this.addManagedListener(r, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(r, G.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this)), this.addManagedListener(r, G.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this)), this.addManagedListener(r, G.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusChanged.bind(this)), this.addManagedListener(r, G.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), this.addManagedListener(r, G.EVENT_MODEL_UPDATED, this.refreshFirstAndLastRowStyles.bind(this)), this.addManagedListener(r, G.EVENT_COLUMN_MOVED, this.updateColumnLists.bind(this)), this.addDestroyFunc(function() {
        e.destroyBeans(e.rowDragComps, e.beans.context);
      }), this.addManagedPropertyListeners(["rowDragEntireRow"], function() {
        var n = e.gridOptionsService.get("rowDragEntireRow");
        if (n) {
          e.allRowGuis.forEach(function(i) {
            e.addRowDraggerToRow(i);
          });
          return;
        }
        e.destroyBeans(e.rowDragComps, e.beans.context), e.rowDragComps = [];
      }), this.addListenersForCellComps();
    }, t.prototype.addListenersForCellComps = function() {
      var e = this;
      this.addManagedListener(this.rowNode, St.EVENT_ROW_INDEX_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(r) {
          return r.onRowIndexChanged();
        });
      }), this.addManagedListener(this.rowNode, St.EVENT_CELL_CHANGED, function(r) {
        e.getAllCellCtrls().forEach(function(n) {
          return n.onCellChanged(r);
        });
      });
    }, t.prototype.onRowNodeDataChanged = function(e) {
      var r = this, n = this.isFullWidth() !== !!this.rowNode.isFullWidthCell();
      if (n) {
        this.beans.rowRenderer.redrawRow(this.rowNode);
        return;
      }
      if (this.isFullWidth()) {
        var i = this.refreshFullWidth();
        i || this.beans.rowRenderer.redrawRow(this.rowNode);
        return;
      }
      this.getAllCellCtrls().forEach(function(a) {
        return a.refreshCell({
          suppressFlash: !e.update,
          newData: !e.update
        });
      }), this.allRowGuis.forEach(function(a) {
        r.setRowCompRowId(a.rowComp), r.updateRowBusinessKey(), r.setRowCompRowBusinessKey(a.rowComp);
      }), this.onRowSelected(), this.postProcessCss();
    }, t.prototype.postProcessCss = function() {
      this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.postProcessRowDragging();
    }, t.prototype.onRowNodeHighlightChanged = function() {
      var e = this.rowNode.highlighted;
      this.allRowGuis.forEach(function(r) {
        var n = e === Na.Above, i = e === Na.Below;
        r.rowComp.addOrRemoveCssClass("ag-row-highlight-above", n), r.rowComp.addOrRemoveCssClass("ag-row-highlight-below", i);
      });
    }, t.prototype.postProcessRowDragging = function() {
      var e = this.rowNode.dragging;
      this.allRowGuis.forEach(function(r) {
        return r.rowComp.addOrRemoveCssClass("ag-row-dragging", e);
      });
    }, t.prototype.updateExpandedCss = function() {
      var e = this.rowNode.isExpandable(), r = this.rowNode.expanded == !0;
      this.allRowGuis.forEach(function(n) {
        n.rowComp.addOrRemoveCssClass("ag-row-group", e), n.rowComp.addOrRemoveCssClass("ag-row-group-expanded", e && r), n.rowComp.addOrRemoveCssClass("ag-row-group-contracted", e && !r), ea(n.element, e && r);
      });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.updateColumnLists(!0), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights();
    }, t.prototype.onVirtualColumnsChanged = function() {
      this.updateColumnLists(!1, !0);
    }, t.prototype.getRowPosition = function() {
      return {
        rowPinned: Ia(this.rowNode.rowPinned),
        rowIndex: this.rowNode.rowIndex
      };
    }, t.prototype.onKeyboardNavigate = function(e) {
      var r = this.allRowGuis.find(function(u) {
        return u.element.contains(e.target);
      }), n = r ? r.element : null, i = n === e.target;
      if (i) {
        var a = this.rowNode, s = this.beans.focusService.getFocusedCell(), l = {
          rowIndex: a.rowIndex,
          rowPinned: a.rowPinned,
          column: s && s.column
        };
        this.beans.navigationService.navigateToNextCell(e, e.key, l, !0), e.preventDefault();
      }
    }, t.prototype.onTabKeyDown = function(e) {
      if (!(e.defaultPrevented || na(e))) {
        var r = this.allRowGuis.find(function(s) {
          return s.element.contains(e.target);
        }), n = r ? r.element : null, i = n === e.target, a = null;
        i || (a = this.beans.focusService.findNextFocusableElement(n, !1, e.shiftKey)), (this.isFullWidth() && i || !a) && this.beans.navigationService.onTabKeyDown(this, e);
      }
    }, t.prototype.onFullWidthRowFocused = function(e) {
      var r, n = this.rowNode, i = e ? this.isFullWidth() && e.rowIndex === n.rowIndex && e.rowPinned == n.rowPinned : !1, a = this.fullWidthGui ? this.fullWidthGui.element : (r = this.centerGui) === null || r === void 0 ? void 0 : r.element;
      a && (a.classList.toggle("ag-full-width-focus", i), i && a.focus({ preventScroll: !0 }));
    }, t.prototype.refreshCell = function(e) {
      this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), this.updateColumnLists();
    }, t.prototype.removeCellCtrl = function(e, r) {
      var n = {
        list: [],
        map: {}
      };
      return e.list.forEach(function(i) {
        i !== r && (n.list.push(i), n.map[i.getInstanceId()] = i);
      }), n;
    }, t.prototype.onMouseEvent = function(e, r) {
      switch (e) {
        case "dblclick":
          this.onRowDblClick(r);
          break;
        case "click":
          this.onRowClick(r);
          break;
        case "touchstart":
        case "mousedown":
          this.onRowMouseDown(r);
          break;
      }
    }, t.prototype.createRowEvent = function(e, r) {
      return this.gridOptionsService.addGridCommonParams({
        type: e,
        node: this.rowNode,
        data: this.rowNode.data,
        rowIndex: this.rowNode.rowIndex,
        rowPinned: this.rowNode.rowPinned,
        event: r
      });
    }, t.prototype.createRowEventWithSource = function(e, r) {
      var n = this.createRowEvent(e, r);
      return n.source = this, n;
    }, t.prototype.onRowDblClick = function(e) {
      if (!na(e)) {
        var r = this.createRowEventWithSource(G.EVENT_ROW_DOUBLE_CLICKED, e);
        this.beans.eventService.dispatchEvent(r);
      }
    }, t.prototype.onRowMouseDown = function(e) {
      if (this.lastMouseDownOnDragger = ac(e.target, "ag-row-drag", 3), !!this.isFullWidth()) {
        var r = this.rowNode, n = this.beans.columnModel;
        this.beans.rangeService && this.beans.rangeService.removeAllCellRanges(), this.beans.focusService.setFocusedCell({
          rowIndex: r.rowIndex,
          column: n.getAllDisplayedColumns()[0],
          rowPinned: r.rowPinned,
          forceBrowserFocus: !0
        });
      }
    }, t.prototype.onRowClick = function(e) {
      var r = na(e) || this.lastMouseDownOnDragger;
      if (!r) {
        var n = this.createRowEventWithSource(G.EVENT_ROW_CLICKED, e);
        this.beans.eventService.dispatchEvent(n);
        var i = e.ctrlKey || e.metaKey, a = e.shiftKey, s = this.gridOptionsService.get("groupSelectsChildren");
        if (
          // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
          // so return if it's a group row
          !(s && this.rowNode.group || // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
          // and we click it, the selection should not change (ie any currently selected row should stay selected)
          !this.rowNode.selectable || // we also don't allow selection of pinned rows
          this.rowNode.rowPinned || // if no selection method enabled, do nothing
          !this.gridOptionsService.isRowSelection() || // if click selection suppressed, do nothing
          this.gridOptionsService.get("suppressRowClickSelection"))
        ) {
          var l = this.gridOptionsService.get("rowMultiSelectWithClick"), u = !this.gridOptionsService.get("suppressRowDeselection"), c = "rowClicked";
          if (this.rowNode.isSelected())
            l ? this.rowNode.setSelectedParams({ newValue: !1, event: e, source: c }) : i ? u && this.rowNode.setSelectedParams({ newValue: !1, event: e, source: c }) : this.rowNode.setSelectedParams({ newValue: !0, clearSelection: !a, rangeSelect: a, event: e, source: c });
          else {
            var d = l ? !1 : !i;
            this.rowNode.setSelectedParams({ newValue: !0, clearSelection: d, rangeSelect: a, event: e, source: c });
          }
        }
      }
    }, t.prototype.setupDetailRowAutoHeight = function(e) {
      var r = this;
      if (this.rowType === Mo.FullWidthDetail && this.gridOptionsService.get("detailRowAutoHeight")) {
        var n = function() {
          var a = e.clientHeight;
          if (a != null && a > 0) {
            var s = function() {
              r.rowNode.setRowHeight(a), r.beans.clientSideRowModel ? r.beans.clientSideRowModel.onRowHeightChanged() : r.beans.serverSideRowModel && r.beans.serverSideRowModel.onRowHeightChanged();
            };
            window.setTimeout(s, 0);
          }
        }, i = this.beans.resizeObserverService.observeResize(e, n);
        this.addDestroyFunc(i), n();
      }
    }, t.prototype.createFullWidthParams = function(e, r) {
      var n = this, i = this.gridOptionsService.addGridCommonParams({
        fullWidth: !0,
        data: this.rowNode.data,
        node: this.rowNode,
        value: this.rowNode.key,
        valueFormatted: this.rowNode.key,
        rowIndex: this.rowNode.rowIndex,
        // these need to be taken out, as part of 'afterAttached' now
        eGridCell: e,
        eParentOfValue: e,
        pinned: r,
        addRenderedRowListener: this.addEventListener.bind(this),
        registerRowDragger: function(a, s, l, u) {
          return n.addFullWidthRowDragging(a, s, l, u);
        }
      });
      return i;
    }, t.prototype.addFullWidthRowDragging = function(e, r, n, i) {
      if (n === void 0 && (n = ""), !!this.isFullWidth()) {
        var a = new ry(function() {
          return n;
        }, this.rowNode, void 0, e, r, i);
        this.createManagedBean(a, this.beans.context);
      }
    }, t.prototype.onUiLevelChanged = function() {
      var e = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
      if (this.rowLevel != e) {
        var r = "ag-row-level-" + e, n = "ag-row-level-" + this.rowLevel;
        this.allRowGuis.forEach(function(i) {
          i.rowComp.addOrRemoveCssClass(r, !0), i.rowComp.addOrRemoveCssClass(n, !1);
        });
      }
      this.rowLevel = e;
    }, t.prototype.isFirstRowOnPage = function() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
    }, t.prototype.isLastRowOnPage = function() {
      return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
    }, t.prototype.refreshFirstAndLastRowStyles = function() {
      var e = this.isFirstRowOnPage(), r = this.isLastRowOnPage();
      this.firstRowOnPage !== e && (this.firstRowOnPage = e, this.allRowGuis.forEach(function(n) {
        return n.rowComp.addOrRemoveCssClass("ag-row-first", e);
      })), this.lastRowOnPage !== r && (this.lastRowOnPage = r, this.allRowGuis.forEach(function(n) {
        return n.rowComp.addOrRemoveCssClass("ag-row-last", r);
      }));
    }, t.prototype.stopEditing = function(e) {
      var r, n;
      if (e === void 0 && (e = !1), !this.stoppingRowEdit) {
        var i = this.getAllCellCtrls(), a = this.editingRow;
        this.stoppingRowEdit = !0;
        var s = !1;
        try {
          for (var l = tq(i), u = l.next(); !u.done; u = l.next()) {
            var c = u.value, d = c.stopEditing(e);
            a && !e && !s && d && (s = !0);
          }
        } catch (v) {
          r = { error: v };
        } finally {
          try {
            u && !u.done && (n = l.return) && n.call(l);
          } finally {
            if (r) throw r.error;
          }
        }
        if (s) {
          var f = this.createRowEvent(G.EVENT_ROW_VALUE_CHANGED);
          this.beans.eventService.dispatchEvent(f);
        }
        a && this.setEditingRow(!1), this.stoppingRowEdit = !1;
      }
    }, t.prototype.setInlineEditingCss = function(e) {
      this.allRowGuis.forEach(function(r) {
        r.rowComp.addOrRemoveCssClass("ag-row-inline-editing", e), r.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !e);
      });
    }, t.prototype.setEditingRow = function(e) {
      this.editingRow = e, this.allRowGuis.forEach(function(n) {
        return n.rowComp.addOrRemoveCssClass("ag-row-editing", e);
      });
      var r = e ? this.createRowEvent(G.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(G.EVENT_ROW_EDITING_STOPPED);
      this.beans.eventService.dispatchEvent(r);
    }, t.prototype.startRowEditing = function(e, r, n) {
      if (e === void 0 && (e = null), r === void 0 && (r = null), n === void 0 && (n = null), !this.editingRow) {
        var i = this.getAllCellCtrls().reduce(function(a, s) {
          var l = s === r;
          return l ? s.startEditing(e, l, n) : s.startEditing(null, l, n), a ? !0 : s.isEditing();
        }, !1);
        i && this.setEditingRow(!0);
      }
    }, t.prototype.getAllCellCtrls = function() {
      if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0)
        return this.centerCellCtrls.list;
      var e = qw(qw(qw([], Kw(this.centerCellCtrls.list), !1), Kw(this.leftCellCtrls.list), !1), Kw(this.rightCellCtrls.list), !1);
      return e;
    }, t.prototype.postProcessClassesFromGridOptions = function() {
      var e = this, r = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
      !r || !r.length || r.forEach(function(n) {
        e.allRowGuis.forEach(function(i) {
          return i.rowComp.addOrRemoveCssClass(n, !0);
        });
      });
    }, t.prototype.postProcessRowClassRules = function() {
      var e = this;
      this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, function(r) {
        e.allRowGuis.forEach(function(n) {
          return n.rowComp.addOrRemoveCssClass(r, !0);
        });
      }, function(r) {
        e.allRowGuis.forEach(function(n) {
          return n.rowComp.addOrRemoveCssClass(r, !1);
        });
      });
    }, t.prototype.setStylesFromGridOptions = function(e, r) {
      var n = this;
      e && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(r, function(i) {
        return i.rowComp.setUserStyles(n.rowStyles);
      });
    }, t.prototype.getPinnedForContainer = function(e) {
      var r = e === dn.LEFT ? "left" : e === dn.RIGHT ? "right" : null;
      return r;
    }, t.prototype.getInitialRowClasses = function(e) {
      var r = this.getPinnedForContainer(e), n = {
        rowNode: this.rowNode,
        rowFocused: this.rowFocused,
        fadeRowIn: this.fadeInAnimation[e],
        rowIsEven: this.rowNode.rowIndex % 2 === 0,
        rowLevel: this.rowLevel,
        fullWidthRow: this.isFullWidth(),
        firstRowOnPage: this.isFirstRowOnPage(),
        lastRowOnPage: this.isLastRowOnPage(),
        printLayout: this.printLayout,
        expandable: this.rowNode.isExpandable(),
        pinned: r
      };
      return this.beans.rowCssClassCalculator.getInitialRowClasses(n);
    }, t.prototype.processStylesFromGridOptions = function() {
      var e = this.gridOptionsService.get("rowStyle");
      if (e && typeof e == "function") {
        console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
        return;
      }
      var r = this.gridOptionsService.getCallback("getRowStyle"), n;
      if (r) {
        var i = {
          data: this.rowNode.data,
          node: this.rowNode,
          rowIndex: this.rowNode.rowIndex
        };
        n = r(i);
      }
      return n || e ? Object.assign({}, e, n) : this.emptyStyle;
    }, t.prototype.onRowSelected = function(e) {
      var r = this, n = !!this.rowNode.isSelected();
      this.forEachGui(e, function(i) {
        i.rowComp.addOrRemoveCssClass("ag-row-selected", n), lp(i.element, n ? !0 : void 0);
        var a = r.createAriaLabel();
        Os(i.element, a ?? "");
      });
    }, t.prototype.createAriaLabel = function() {
      var e = this.rowNode.isSelected();
      if (!(e && this.gridOptionsService.get("suppressRowDeselection"))) {
        var r = this.beans.localeService.getLocaleTextFunc(), n = r(e ? "ariaRowDeselect" : "ariaRowSelect", "Press SPACE to ".concat(e ? "deselect" : "select", " this row."));
        return n;
      }
    }, t.prototype.isUseAnimationFrameForCreate = function() {
      return this.useAnimationFrameForCreate;
    }, t.prototype.addHoverFunctionality = function(e) {
      var r = this;
      this.active && (this.addManagedListener(e, "mouseenter", function() {
        return r.rowNode.onMouseEnter();
      }), this.addManagedListener(e, "mouseleave", function() {
        return r.rowNode.onMouseLeave();
      }), this.addManagedListener(this.rowNode, St.EVENT_MOUSE_ENTER, function() {
        !r.beans.dragService.isDragging() && !r.gridOptionsService.get("suppressRowHoverHighlight") && (e.classList.add("ag-row-hover"), r.rowNode.setHovered(!0));
      }), this.addManagedListener(this.rowNode, St.EVENT_MOUSE_LEAVE, function() {
        e.classList.remove("ag-row-hover"), r.rowNode.setHovered(!1);
      }));
    }, t.prototype.roundRowTopToBounds = function(e) {
      var r = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition(), n = this.applyPaginationOffset(r.top, !0) - 100, i = this.applyPaginationOffset(r.bottom, !0) + 100;
      return Math.min(Math.max(n, e), i);
    }, t.prototype.getFrameworkOverrides = function() {
      return this.beans.frameworkOverrides;
    }, t.prototype.forEachGui = function(e, r) {
      e ? r(e) : this.allRowGuis.forEach(r);
    }, t.prototype.onRowHeightChanged = function(e) {
      if (this.rowNode.rowHeight != null) {
        var r = this.rowNode.rowHeight, n = this.beans.environment.getDefaultRowHeight(), i = this.gridOptionsService.isGetRowHeightFunction(), a = i ? this.gridOptionsService.getRowHeightForNode(this.rowNode).height : void 0, s = a ? "".concat(Math.min(n, a) - 2, "px") : void 0;
        this.forEachGui(e, function(l) {
          l.element.style.height = "".concat(r, "px"), s && l.element.style.setProperty("--ag-line-height", s);
        });
      }
    }, t.prototype.addEventListener = function(e, r) {
      o.prototype.addEventListener.call(this, e, r);
    }, t.prototype.removeEventListener = function(e, r) {
      o.prototype.removeEventListener.call(this, e, r);
    }, t.prototype.destroyFirstPass = function(e) {
      if (e === void 0 && (e = !1), this.active = !1, !e && this.gridOptionsService.isAnimateRows() && !this.isSticky()) {
        var r = this.rowNode.rowTop != null;
        if (r) {
          var n = this.roundRowTopToBounds(this.rowNode.rowTop);
          this.setRowTop(n);
        } else
          this.allRowGuis.forEach(function(a) {
            return a.rowComp.addOrRemoveCssClass("ag-opacity-zero", !0);
          });
      }
      this.rowNode.setHovered(!1);
      var i = this.createRowEvent(G.EVENT_VIRTUAL_ROW_REMOVED);
      this.dispatchEvent(i), this.beans.eventService.dispatchEvent(i), o.prototype.destroy.call(this);
    }, t.prototype.destroySecondPass = function() {
      this.allRowGuis.length = 0, this.stopEditing();
      var e = function(r) {
        return r.list.forEach(function(n) {
          return n.destroy();
        }), { list: [], map: {} };
      };
      this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
    }, t.prototype.setFocusedClasses = function(e) {
      var r = this;
      this.forEachGui(e, function(n) {
        n.rowComp.addOrRemoveCssClass("ag-row-focus", r.rowFocused), n.rowComp.addOrRemoveCssClass("ag-row-no-focus", !r.rowFocused);
      });
    }, t.prototype.onCellFocusChanged = function() {
      var e = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
      e !== this.rowFocused && (this.rowFocused = e, this.setFocusedClasses()), !e && this.editingRow && this.stopEditing(!1);
    }, t.prototype.onPaginationChanged = function() {
      var e = this.beans.paginationProxy.getCurrentPage();
      this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
    }, t.prototype.onTopChanged = function() {
      this.setRowTop(this.rowNode.rowTop);
    }, t.prototype.onPaginationPixelOffsetChanged = function() {
      this.onTopChanged();
    }, t.prototype.applyPaginationOffset = function(e, r) {
      if (r === void 0 && (r = !1), this.rowNode.isRowPinned() || this.rowNode.sticky)
        return e;
      var n = this.beans.paginationProxy.getPixelOffset(), i = r ? 1 : -1;
      return e + n * i;
    }, t.prototype.setRowTop = function(e) {
      if (!this.printLayout && Oe(e)) {
        var r = this.applyPaginationOffset(e), n = this.rowNode.isRowPinned() || this.rowNode.sticky, i = n ? r : this.beans.rowContainerHeightService.getRealPixelPosition(r), a = "".concat(i, "px");
        this.setRowTopStyle(a);
      }
    }, t.prototype.getInitialRowTop = function(e) {
      return this.suppressRowTransform ? this.getInitialRowTopShared(e) : void 0;
    }, t.prototype.getInitialTransform = function(e) {
      return this.suppressRowTransform ? void 0 : "translateY(".concat(this.getInitialRowTopShared(e), ")");
    }, t.prototype.getInitialRowTopShared = function(e) {
      if (this.printLayout)
        return "";
      var r;
      if (this.isSticky())
        r = this.rowNode.stickyRowTop;
      else {
        var n = this.slideInAnimation[e] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop, i = this.applyPaginationOffset(n);
        r = this.rowNode.isRowPinned() ? i : this.beans.rowContainerHeightService.getRealPixelPosition(i);
      }
      return r + "px";
    }, t.prototype.setRowTopStyle = function(e) {
      var r = this;
      this.allRowGuis.forEach(function(n) {
        return r.suppressRowTransform ? n.rowComp.setTop(e) : n.rowComp.setTransform("translateY(".concat(e, ")"));
      });
    }, t.prototype.getRowNode = function() {
      return this.rowNode;
    }, t.prototype.getCellCtrl = function(e) {
      var r = null;
      return this.getAllCellCtrls().forEach(function(n) {
        n.getColumn() == e && (r = n);
      }), r != null || this.getAllCellCtrls().forEach(function(n) {
        n.getColSpanningList().indexOf(e) >= 0 && (r = n);
      }), r;
    }, t.prototype.onRowIndexChanged = function() {
      this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
    }, t.prototype.getRowIndex = function() {
      return this.rowNode.getRowIndexString();
    }, t.prototype.updateRowIndexes = function(e) {
      var r = this.rowNode.getRowIndexString(), n = this.beans.headerNavigationService.getHeaderRowCount() + this.beans.filterManager.getHeaderRowCount(), i = this.rowNode.rowIndex % 2 === 0, a = n + this.rowNode.rowIndex + 1;
      this.forEachGui(e, function(s) {
        s.rowComp.setRowIndex(r), s.rowComp.addOrRemoveCssClass("ag-row-even", i), s.rowComp.addOrRemoveCssClass("ag-row-odd", !i), F1(s.element, a);
      });
    }, t.DOM_DATA_KEY_ROW_CTRL = "renderedRow", t;
  }(Me)
), nq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yo = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, oq = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, iq = (
  /** @class */
  function(o) {
    nq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addKeyboardListeners(), this.addMouseListeners(), this.mockContextMenuForIPad();
    }, t.prototype.addKeyboardListeners = function() {
      var e = "keydown", r = this.processKeyboardEvent.bind(this, e);
      this.addManagedListener(this.element, e, r);
    }, t.prototype.addMouseListeners = function() {
      var e = this, r = _1("touchstart") ? "touchstart" : "mousedown", n = ["dblclick", "contextmenu", "mouseover", "mouseout", "click", r];
      n.forEach(function(i) {
        var a = e.processMouseEvent.bind(e, i);
        e.addManagedListener(e.element, i, a);
      });
    }, t.prototype.processMouseEvent = function(e, r) {
      if (!(!this.mouseEventService.isEventFromThisGrid(r) || na(r))) {
        var n = this.getRowForEvent(r), i = this.mouseEventService.getRenderedCellForEvent(r);
        e === "contextmenu" ? this.handleContextMenuMouseEvent(r, null, n, i) : (i && i.onMouseEvent(e, r), n && n.onMouseEvent(e, r));
      }
    }, t.prototype.mockContextMenuForIPad = function() {
      var e = this;
      if (jl()) {
        var r = new Go(this.element), n = function(i) {
          var a = e.getRowForEvent(i.touchEvent), s = e.mouseEventService.getRenderedCellForEvent(i.touchEvent);
          e.handleContextMenuMouseEvent(null, i.touchEvent, a, s);
        };
        this.addManagedListener(r, Go.EVENT_LONG_TAP, n), this.addDestroyFunc(function() {
          return r.destroy();
        });
      }
    }, t.prototype.getRowForEvent = function(e) {
      for (var r = e.target; r; ) {
        var n = this.gridOptionsService.getDomData(r, Fl.DOM_DATA_KEY_ROW_CTRL);
        if (n)
          return n;
        r = r.parentElement;
      }
      return null;
    }, t.prototype.handleContextMenuMouseEvent = function(e, r, n, i) {
      var a = n ? n.getRowNode() : null, s = i ? i.getColumn() : null, l = null;
      if (s) {
        var u = e || r;
        i.dispatchCellContextMenuEvent(u), l = this.valueService.getValue(s, a);
      }
      var c = this.ctrlsService.getGridBodyCtrl(), d = i ? i.getGui() : c.getGridBodyElement();
      this.contextMenuFactory && this.contextMenuFactory.onContextMenu(e, r, a, s, l, d);
    }, t.prototype.getControlsForEventTarget = function(e) {
      return {
        cellCtrl: qm(this.gridOptionsService, e, Ml.DOM_DATA_KEY_CELL_CTRL),
        rowCtrl: qm(this.gridOptionsService, e, Fl.DOM_DATA_KEY_ROW_CTRL)
      };
    }, t.prototype.processKeyboardEvent = function(e, r) {
      var n = this.getControlsForEventTarget(r.target), i = n.cellCtrl, a = n.rowCtrl;
      r.defaultPrevented || (i ? this.processCellKeyboardEvent(i, e, r) : a && a.isFullWidth() && this.processFullWidthRowKeyboardEvent(a, e, r));
    }, t.prototype.processCellKeyboardEvent = function(e, r, n) {
      var i = e.getRowNode(), a = e.getColumn(), s = e.isEditing(), l = !Jm(this.gridOptionsService, n, i, a, s);
      if (l && r === "keydown") {
        var u = !s && this.navigationService.handlePageScrollingKey(n);
        u || e.onKeyDown(n), this.doGridOperations(n, e.isEditing()), rC(n) && e.processCharacter(n);
      }
      if (r === "keydown") {
        var c = e.createEvent(n, G.EVENT_CELL_KEY_DOWN);
        this.eventService.dispatchEvent(c);
      }
    }, t.prototype.processFullWidthRowKeyboardEvent = function(e, r, n) {
      var i = e.getRowNode(), a = this.focusService.getFocusedCell(), s = a && a.column, l = !Jm(this.gridOptionsService, n, i, s, !1);
      if (l) {
        var u = n.key;
        if (r === "keydown")
          switch (u) {
            case we.PAGE_HOME:
            case we.PAGE_END:
            case we.PAGE_UP:
            case we.PAGE_DOWN:
              this.navigationService.handlePageScrollingKey(n, !0);
              break;
            case we.UP:
            case we.DOWN:
              e.onKeyboardNavigate(n);
              break;
            case we.TAB:
              e.onTabKeyDown(n);
              break;
          }
      }
      if (r === "keydown") {
        var c = e.createRowEvent(G.EVENT_CELL_KEY_DOWN, n);
        this.eventService.dispatchEvent(c);
      }
    }, t.prototype.doGridOperations = function(e, r) {
      if (!(!e.ctrlKey && !e.metaKey) && !r && this.mouseEventService.isEventFromThisGrid(e)) {
        var n = Z2(e);
        if (n === we.A)
          return this.onCtrlAndA(e);
        if (n === we.C)
          return this.onCtrlAndC(e);
        if (n === we.D)
          return this.onCtrlAndD(e);
        if (n === we.V)
          return this.onCtrlAndV(e);
        if (n === we.X)
          return this.onCtrlAndX(e);
        if (n === we.Y)
          return this.onCtrlAndY();
        if (n === we.Z)
          return this.onCtrlAndZ(e);
      }
    }, t.prototype.onCtrlAndA = function(e) {
      var r = this, n = r.pinnedRowModel, i = r.paginationProxy, a = r.rangeService;
      if (a && i.isRowsToRender()) {
        var s = oq([
          n.isEmpty("top"),
          n.isEmpty("bottom")
        ], 2), l = s[0], u = s[1], c = l ? null : "top", d = void 0, f = void 0;
        u ? (d = null, f = this.paginationProxy.getRowCount() - 1) : (d = "bottom", f = n.getPinnedBottomRowData().length - 1);
        var v = this.columnModel.getAllDisplayedColumns();
        if (ri(v))
          return;
        a.setCellRange({
          rowStartIndex: 0,
          rowStartPinned: c,
          rowEndIndex: f,
          rowEndPinned: d,
          columnStart: v[0],
          columnEnd: Kt(v)
        });
      }
      e.preventDefault();
    }, t.prototype.onCtrlAndC = function(e) {
      if (!(!this.clipboardService || this.gridOptionsService.get("enableCellTextSelection"))) {
        var r = this.getControlsForEventTarget(e.target), n = r.cellCtrl, i = r.rowCtrl;
        n != null && n.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.copyToClipboard());
      }
    }, t.prototype.onCtrlAndX = function(e) {
      if (!(!this.clipboardService || this.gridOptionsService.get("enableCellTextSelection") || this.gridOptionsService.get("suppressCutToClipboard"))) {
        var r = this.getControlsForEventTarget(e.target), n = r.cellCtrl, i = r.rowCtrl;
        n != null && n.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.cutToClipboard(void 0, "ui"));
      }
    }, t.prototype.onCtrlAndV = function(e) {
      var r = this.getControlsForEventTarget(e.target), n = r.cellCtrl, i = r.rowCtrl;
      n != null && n.isEditing() || i != null && i.isEditing() || this.clipboardService && !this.gridOptionsService.get("suppressClipboardPaste") && this.clipboardService.pasteFromClipboard();
    }, t.prototype.onCtrlAndD = function(e) {
      this.clipboardService && !this.gridOptionsService.get("suppressClipboardPaste") && this.clipboardService.copyRangeDown(), e.preventDefault();
    }, t.prototype.onCtrlAndZ = function(e) {
      this.gridOptionsService.get("undoRedoCellEditing") && (e.preventDefault(), e.shiftKey ? this.undoRedoService.redo("ui") : this.undoRedoService.undo("ui"));
    }, t.prototype.onCtrlAndY = function() {
      this.undoRedoService.redo("ui");
    }, Yo([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Yo([
      N("valueService")
    ], t.prototype, "valueService", void 0), Yo([
      Lt("contextMenuFactory")
    ], t.prototype, "contextMenuFactory", void 0), Yo([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Yo([
      N("navigationService")
    ], t.prototype, "navigationService", void 0), Yo([
      N("focusService")
    ], t.prototype, "focusService", void 0), Yo([
      N("undoRedoService")
    ], t.prototype, "undoRedoService", void 0), Yo([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Yo([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Yo([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Yo([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), Yo([
      Lt("clipboardService")
    ], t.prototype, "clipboardService", void 0), Yo([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), aq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Df = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, WO = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, jO = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, sq = (
  /** @class */
  function(o) {
    aq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.centerContainerCtrl = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function() {
        e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl(), e.listenForResize();
      }), this.addManagedListener(this.eventService, G.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this)), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], function() {
        e.checkViewportAndScrolls();
      });
    }, t.prototype.listenForResize = function() {
      var e = this, r = function() {
        return e.onCenterViewportResized();
      };
      this.centerContainerCtrl.registerViewportResizeListener(r), this.gridBodyCtrl.registerBodyViewportResizeListener(r);
    }, t.prototype.onScrollbarWidthChanged = function() {
      this.checkViewportAndScrolls();
    }, t.prototype.onCenterViewportResized = function() {
      if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
        this.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
        var e = this.centerContainerCtrl.getCenterWidth();
        e !== this.centerWidth && (this.centerWidth = e, this.columnModel.refreshFlexedColumns({ viewportWidth: this.centerWidth, updateBodyWidths: !0, fireResizedEvent: !0 }));
      } else
        this.bodyHeight = 0;
    }, t.prototype.keepPinnedColumnsNarrowerThanViewport = function() {
      var e = this.gridBodyCtrl.getBodyViewportElement(), r = Ec(e);
      if (!(r <= 50)) {
        var n = this.getPinnedColumnsOverflowingViewport(r - 50), i = this.gridOptionsService.getCallback("processUnpinnedColumns");
        if (n.length) {
          if (i) {
            var a = {
              columns: n,
              viewportWidth: r
            };
            n = i(a);
          }
          this.columnModel.setColumnsPinned(n, null, "viewportSizeFeature");
        }
      }
    }, t.prototype.getPinnedColumnsOverflowingViewport = function(e) {
      var r = this.pinnedWidthService.getPinnedRightWidth(), n = this.pinnedWidthService.getPinnedLeftWidth(), i = r + n;
      if (i < e)
        return [];
      for (var a = jO([], WO(this.columnModel.getDisplayedLeftColumns()), !1), s = jO([], WO(this.columnModel.getDisplayedRightColumns()), !1), l = 0, u = 0, c = 0, d = [], f = i - c - e; (u < a.length || l < s.length) && f > 0; ) {
        if (l < s.length) {
          var v = s[l++];
          f -= v.getActualWidth(), d.push(v);
        }
        if (u < a.length && f > 0) {
          var v = a[u++];
          f -= v.getActualWidth(), d.push(v);
        }
      }
      return d;
    }, t.prototype.checkViewportAndScrolls = function() {
      this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
    }, t.prototype.getBodyHeight = function() {
      return this.bodyHeight;
    }, t.prototype.checkBodyHeight = function() {
      var e = this.gridBodyCtrl.getBodyViewportElement(), r = uv(e);
      if (this.bodyHeight !== r) {
        this.bodyHeight = r;
        var n = {
          type: G.EVENT_BODY_HEIGHT_CHANGED
        };
        this.eventService.dispatchEvent(n);
      }
    }, t.prototype.updateScrollVisibleService = function() {
      this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }, t.prototype.updateScrollVisibleServiceImpl = function() {
      var e = {
        horizontalScrollShowing: this.isHorizontalScrollShowing(),
        verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
      };
      this.scrollVisibleService.setScrollsVisible(e);
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.centerContainerCtrl.isHorizontalScrollShowing();
    }, t.prototype.onHorizontalViewportChanged = function() {
      var e = this.centerContainerCtrl.getCenterWidth(), r = this.centerContainerCtrl.getViewportScrollLeft();
      this.columnModel.setViewportPosition(e, r);
    }, Df([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Df([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Df([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Df([
      N("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Df([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), lq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), UO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, uq = (
  /** @class */
  function(o) {
    lq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
    }, t.prototype.onPinnedLeftWidthChanged = function() {
      var e = this.pinnedWidthService.getPinnedLeftWidth(), r = e > 0;
      Vt(this.element, r), Di(this.element, e);
    }, t.prototype.getWidth = function() {
      return this.pinnedWidthService.getPinnedLeftWidth();
    }, UO([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), UO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), cq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $O = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, dq = (
  /** @class */
  function(o) {
    cq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.element = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
    }, t.prototype.onPinnedRightWidthChanged = function() {
      var e = this.pinnedWidthService.getPinnedRightWidth(), r = e > 0;
      Vt(this.element, r), Di(this.element, e);
    }, t.prototype.getWidth = function() {
      return this.pinnedWidthService.getPinnedRightWidth();
    }, $O([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), $O([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), pq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, GI = (
  /** @class */
  function(o) {
    pq(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.eContainer = e, n.eViewport = r, n;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
    }, t.prototype.onHeightChanged = function() {
      var e = this.maxDivHeightScaler.getUiContainerHeight(), r = e != null ? "".concat(e, "px") : "";
      this.eContainer.style.height = r, this.eViewport && (this.eViewport.style.height = r);
    }, zO([
      N("rowContainerHeightService")
    ], t.prototype, "maxDivHeightScaler", void 0), zO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), fq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Xw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, hq = (
  /** @class */
  function(o) {
    fq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.eContainer = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      if (!tt(this.rangeService)) {
        this.params = {
          eElement: this.eContainer,
          onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
          onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
          onDragging: this.rangeService.onDragging.bind(this.rangeService)
        }, this.addManagedPropertyListener("enableRangeSelection", function(n) {
          var i = n.currentValue;
          if (i) {
            e.enableFeature();
            return;
          }
          e.disableFeature();
        }), this.addDestroyFunc(function() {
          return e.disableFeature();
        });
        var r = this.gridOptionsService.get("enableRangeSelection");
        r && this.enableFeature();
      }
    }, t.prototype.enableFeature = function() {
      this.dragService.addDragSource(this.params);
    }, t.prototype.disableFeature = function() {
      this.dragService.removeDragSource(this.params);
    }, Xw([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), Xw([
      N("dragService")
    ], t.prototype, "dragService", void 0), Xw([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), vq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Zw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, h_ = (
  /** @class */
  function(o) {
    vq(t, o);
    function t(e, r) {
      r === void 0 && (r = !1);
      var n = o.call(this) || this;
      return n.callback = e, n.addSpacer = r, n;
    }
    return t.prototype.postConstruct = function() {
      var e = this.setWidth.bind(this);
      this.addManagedPropertyListener("domLayout", e), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_LEFT_PINNED_WIDTH_CHANGED, e), this.addSpacer && (this.addManagedListener(this.eventService, G.EVENT_RIGHT_PINNED_WIDTH_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_SCROLL_VISIBILITY_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_SCROLLBAR_WIDTH_CHANGED, e)), this.setWidth();
    }, t.prototype.setWidth = function() {
      var e = this.columnModel, r = this.gridOptionsService.isDomLayout("print"), n = e.getBodyContainerWidth(), i = e.getDisplayedColumnsLeftWidth(), a = e.getDisplayedColumnsRightWidth(), s;
      if (r)
        s = n + i + a;
      else if (s = n, this.addSpacer) {
        var l = this.gridOptionsService.get("enableRtl") ? i : a;
        l === 0 && this.scrollVisibleService.isVerticalScrollShowing() && (s += this.gridOptionsService.getScrollbarWidth());
      }
      this.callback(s);
    }, Zw([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Zw([
      N("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Zw([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), gq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ad = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Ig = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Lg = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, Te;
(function(o) {
  o.LEFT = "left", o.RIGHT = "right", o.CENTER = "center", o.FULL_WIDTH = "fullWidth", o.TOP_LEFT = "topLeft", o.TOP_RIGHT = "topRight", o.TOP_CENTER = "topCenter", o.TOP_FULL_WIDTH = "topFullWidth", o.STICKY_TOP_LEFT = "stickyTopLeft", o.STICKY_TOP_RIGHT = "stickyTopRight", o.STICKY_TOP_CENTER = "stickyTopCenter", o.STICKY_TOP_FULL_WIDTH = "stickyTopFullWidth", o.BOTTOM_LEFT = "bottomLeft", o.BOTTOM_RIGHT = "bottomRight", o.BOTTOM_CENTER = "bottomCenter", o.BOTTOM_FULL_WIDTH = "bottomFullWidth";
})(Te || (Te = {}));
var dn;
(function(o) {
  o.LEFT = "left", o.RIGHT = "right", o.CENTER = "center", o.FULL_WIDTH = "fullWidth";
})(dn || (dn = {}));
function VI(o) {
  switch (o) {
    case Te.CENTER:
    case Te.TOP_CENTER:
    case Te.STICKY_TOP_CENTER:
    case Te.BOTTOM_CENTER:
      return dn.CENTER;
    case Te.LEFT:
    case Te.TOP_LEFT:
    case Te.STICKY_TOP_LEFT:
    case Te.BOTTOM_LEFT:
      return dn.LEFT;
    case Te.RIGHT:
    case Te.TOP_RIGHT:
    case Te.STICKY_TOP_RIGHT:
    case Te.BOTTOM_RIGHT:
      return dn.RIGHT;
    case Te.FULL_WIDTH:
    case Te.TOP_FULL_WIDTH:
    case Te.STICKY_TOP_FULL_WIDTH:
    case Te.BOTTOM_FULL_WIDTH:
      return dn.FULL_WIDTH;
    default:
      throw Error("Invalid Row Container Type");
  }
}
var mq = Sl([
  [Te.CENTER, "ag-center-cols-container"],
  [Te.LEFT, "ag-pinned-left-cols-container"],
  [Te.RIGHT, "ag-pinned-right-cols-container"],
  [Te.FULL_WIDTH, "ag-full-width-container"],
  [Te.TOP_CENTER, "ag-floating-top-container"],
  [Te.TOP_LEFT, "ag-pinned-left-floating-top"],
  [Te.TOP_RIGHT, "ag-pinned-right-floating-top"],
  [Te.TOP_FULL_WIDTH, "ag-floating-top-full-width-container"],
  [Te.STICKY_TOP_CENTER, "ag-sticky-top-container"],
  [Te.STICKY_TOP_LEFT, "ag-pinned-left-sticky-top"],
  [Te.STICKY_TOP_RIGHT, "ag-pinned-right-sticky-top"],
  [Te.STICKY_TOP_FULL_WIDTH, "ag-sticky-top-full-width-container"],
  [Te.BOTTOM_CENTER, "ag-floating-bottom-container"],
  [Te.BOTTOM_LEFT, "ag-pinned-left-floating-bottom"],
  [Te.BOTTOM_RIGHT, "ag-pinned-right-floating-bottom"],
  [Te.BOTTOM_FULL_WIDTH, "ag-floating-bottom-full-width-container"]
]), yq = Sl([
  [Te.CENTER, "ag-center-cols-viewport"],
  [Te.TOP_CENTER, "ag-floating-top-viewport"],
  [Te.STICKY_TOP_CENTER, "ag-sticky-top-viewport"],
  [Te.BOTTOM_CENTER, "ag-floating-bottom-viewport"]
]), v_ = (
  /** @class */
  function(o) {
    gq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.visible = !0, r.EMPTY_CTRLS = [], r.name = e, r.isFullWithContainer = r.name === Te.TOP_FULL_WIDTH || r.name === Te.STICKY_TOP_FULL_WIDTH || r.name === Te.BOTTOM_FULL_WIDTH || r.name === Te.FULL_WIDTH, r;
    }
    return t.getRowContainerCssClasses = function(e) {
      var r = mq.get(e), n = yq.get(e);
      return { container: r, viewport: n };
    }, t.getPinned = function(e) {
      switch (e) {
        case Te.BOTTOM_LEFT:
        case Te.TOP_LEFT:
        case Te.STICKY_TOP_LEFT:
        case Te.LEFT:
          return "left";
        case Te.BOTTOM_RIGHT:
        case Te.TOP_RIGHT:
        case Te.STICKY_TOP_RIGHT:
        case Te.RIGHT:
          return "right";
        default:
          return null;
      }
    }, t.prototype.postConstruct = function() {
      var e = this;
      this.enableRtl = this.gridOptionsService.get("enableRtl"), this.forContainers([Te.CENTER], function() {
        return e.viewportSizeFeature = e.createManagedBean(new sq(e));
      });
    }, t.prototype.registerWithCtrlsService = function() {
      switch (this.name) {
        case Te.CENTER:
          this.ctrlsService.registerCenterRowContainerCtrl(this);
          break;
        case Te.LEFT:
          this.ctrlsService.registerLeftRowContainerCtrl(this);
          break;
        case Te.RIGHT:
          this.ctrlsService.registerRightRowContainerCtrl(this);
          break;
        case Te.TOP_CENTER:
          this.ctrlsService.registerTopCenterRowContainerCtrl(this);
          break;
        case Te.TOP_LEFT:
          this.ctrlsService.registerTopLeftRowContainerCon(this);
          break;
        case Te.TOP_RIGHT:
          this.ctrlsService.registerTopRightRowContainerCtrl(this);
          break;
        case Te.STICKY_TOP_CENTER:
          this.ctrlsService.registerStickyTopCenterRowContainerCtrl(this);
          break;
        case Te.STICKY_TOP_LEFT:
          this.ctrlsService.registerStickyTopLeftRowContainerCon(this);
          break;
        case Te.STICKY_TOP_RIGHT:
          this.ctrlsService.registerStickyTopRightRowContainerCtrl(this);
          break;
        case Te.BOTTOM_CENTER:
          this.ctrlsService.registerBottomCenterRowContainerCtrl(this);
          break;
        case Te.BOTTOM_LEFT:
          this.ctrlsService.registerBottomLeftRowContainerCtrl(this);
          break;
        case Te.BOTTOM_RIGHT:
          this.ctrlsService.registerBottomRightRowContainerCtrl(this);
          break;
      }
    }, t.prototype.forContainers = function(e, r) {
      e.indexOf(this.name) >= 0 && r();
    }, t.prototype.getContainerElement = function() {
      return this.eContainer;
    }, t.prototype.getViewportSizeFeature = function() {
      return this.viewportSizeFeature;
    }, t.prototype.setComp = function(e, r, n) {
      var i = this;
      this.comp = e, this.eContainer = r, this.eViewport = n, this.createManagedBean(new iq(this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder(), this.stopHScrollOnPinnedRows();
      var a = [Te.TOP_CENTER, Te.TOP_LEFT, Te.TOP_RIGHT], s = [Te.STICKY_TOP_CENTER, Te.STICKY_TOP_LEFT, Te.STICKY_TOP_RIGHT], l = [Te.BOTTOM_CENTER, Te.BOTTOM_LEFT, Te.BOTTOM_RIGHT], u = [Te.CENTER, Te.LEFT, Te.RIGHT], c = Lg(Lg(Lg(Lg([], Ig(a), !1), Ig(l), !1), Ig(u), !1), Ig(s), !1), d = [Te.CENTER, Te.LEFT, Te.RIGHT, Te.FULL_WIDTH], f = [Te.CENTER, Te.TOP_CENTER, Te.STICKY_TOP_CENTER, Te.BOTTOM_CENTER], v = [Te.LEFT, Te.BOTTOM_LEFT, Te.TOP_LEFT, Te.STICKY_TOP_LEFT], g = [Te.RIGHT, Te.BOTTOM_RIGHT, Te.TOP_RIGHT, Te.STICKY_TOP_RIGHT];
      this.forContainers(v, function() {
        i.pinnedWidthFeature = i.createManagedBean(new uq(i.eContainer)), i.addManagedListener(i.eventService, G.EVENT_LEFT_PINNED_WIDTH_CHANGED, function() {
          return i.onPinnedWidthChanged();
        });
      }), this.forContainers(g, function() {
        i.pinnedWidthFeature = i.createManagedBean(new dq(i.eContainer)), i.addManagedListener(i.eventService, G.EVENT_RIGHT_PINNED_WIDTH_CHANGED, function() {
          return i.onPinnedWidthChanged();
        });
      }), this.forContainers(d, function() {
        return i.createManagedBean(new GI(i.eContainer, i.name === Te.CENTER ? n : void 0));
      }), this.forContainers(c, function() {
        return i.createManagedBean(new hq(i.eContainer));
      }), this.forContainers(f, function() {
        return i.createManagedBean(new h_(function(m) {
          return i.comp.setContainerWidth("".concat(m, "px"));
        }));
      }), this.addListeners(), this.registerWithCtrlsService();
    }, t.prototype.addListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, function() {
        return e.onDisplayedColumnsChanged();
      }), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function() {
        return e.onDisplayedColumnsWidthChanged();
      }), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_ROWS_CHANGED, function(r) {
        return e.onDisplayedRowsChanged(r.afterScroll);
      }), this.onDisplayedColumnsChanged(), this.onDisplayedColumnsWidthChanged(), this.onDisplayedRowsChanged();
    }, t.prototype.listenOnDomOrder = function() {
      var e = this, r = [Te.STICKY_TOP_CENTER, Te.STICKY_TOP_LEFT, Te.STICKY_TOP_RIGHT, Te.STICKY_TOP_FULL_WIDTH], n = r.indexOf(this.name) >= 0;
      if (n) {
        this.comp.setDomOrder(!0);
        return;
      }
      var i = function() {
        var a = e.gridOptionsService.get("ensureDomOrder"), s = e.gridOptionsService.isDomLayout("print");
        e.comp.setDomOrder(a || s);
      };
      this.addManagedPropertyListener("domLayout", i), i();
    }, t.prototype.stopHScrollOnPinnedRows = function() {
      var e = this;
      this.forContainers([Te.TOP_CENTER, Te.STICKY_TOP_CENTER, Te.BOTTOM_CENTER], function() {
        var r = function() {
          return e.eViewport.scrollLeft = 0;
        };
        e.addManagedListener(e.eViewport, "scroll", r);
      });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this;
      this.forContainers([Te.CENTER], function() {
        return e.onHorizontalViewportChanged();
      });
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      var e = this;
      this.forContainers([Te.CENTER], function() {
        return e.onHorizontalViewportChanged();
      });
    }, t.prototype.addPreventScrollWhileDragging = function() {
      var e = this, r = function(n) {
        e.dragService.isDragging() && n.cancelable && n.preventDefault();
      };
      this.eContainer.addEventListener("touchmove", r, { passive: !1 }), this.addDestroyFunc(function() {
        return e.eContainer.removeEventListener("touchmove", r);
      });
    }, t.prototype.onHorizontalViewportChanged = function(e) {
      e === void 0 && (e = !1);
      var r = this.getCenterWidth(), n = this.getCenterViewportScrollLeft();
      this.columnModel.setViewportPosition(r, n, e);
    }, t.prototype.getCenterWidth = function() {
      return Ec(this.eViewport);
    }, t.prototype.getCenterViewportScrollLeft = function() {
      return qh(this.eViewport, this.enableRtl);
    }, t.prototype.registerViewportResizeListener = function(e) {
      var r = this.resizeObserverService.observeResize(this.eViewport, e);
      this.addDestroyFunc(function() {
        return r();
      });
    }, t.prototype.isViewportInTheDOMTree = function() {
      return z1(this.eViewport);
    }, t.prototype.getViewportScrollLeft = function() {
      return qh(this.eViewport, this.enableRtl);
    }, t.prototype.isHorizontalScrollShowing = function() {
      var e = this.gridOptionsService.get("alwaysShowHorizontalScroll");
      return e || U2(this.eViewport);
    }, t.prototype.getViewportElement = function() {
      return this.eViewport;
    }, t.prototype.setContainerTranslateX = function(e) {
      this.eContainer.style.transform = "translateX(".concat(e, "px)");
    }, t.prototype.getHScrollPosition = function() {
      var e = {
        left: this.eViewport.scrollLeft,
        right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
      };
      return e;
    }, t.prototype.setCenterViewportScrollLeft = function(e) {
      Xh(this.eViewport, e, this.enableRtl);
    }, t.prototype.isContainerVisible = function() {
      var e = t.getPinned(this.name);
      return !e || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }, t.prototype.onPinnedWidthChanged = function() {
      var e = this.isContainerVisible();
      this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
    }, t.prototype.onDisplayedRowsChanged = function(e) {
      var r = this;
      if (e === void 0 && (e = !1), !this.visible) {
        this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
        return;
      }
      var n = this.gridOptionsService.isDomLayout("print"), i = this.gridOptionsService.get("embedFullWidthRows"), a = i || n, s = this.getRowCtrls().filter(function(l) {
        var u = l.isFullWidth(), c = r.isFullWithContainer ? !a && u : a || !u;
        return c;
      });
      this.comp.setRowCtrls({ rowCtrls: s, useFlushSync: e });
    }, t.prototype.getRowCtrls = function() {
      switch (this.name) {
        case Te.TOP_CENTER:
        case Te.TOP_LEFT:
        case Te.TOP_RIGHT:
        case Te.TOP_FULL_WIDTH:
          return this.rowRenderer.getTopRowCtrls();
        case Te.STICKY_TOP_CENTER:
        case Te.STICKY_TOP_LEFT:
        case Te.STICKY_TOP_RIGHT:
        case Te.STICKY_TOP_FULL_WIDTH:
          return this.rowRenderer.getStickyTopRowCtrls();
        case Te.BOTTOM_CENTER:
        case Te.BOTTOM_LEFT:
        case Te.BOTTOM_RIGHT:
        case Te.BOTTOM_FULL_WIDTH:
          return this.rowRenderer.getBottomRowCtrls();
        default:
          return this.rowRenderer.getCentreRowCtrls();
      }
    }, Ad([
      N("dragService")
    ], t.prototype, "dragService", void 0), Ad([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ad([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ad([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Ad([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Ad([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), Cq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), us = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wq = (
  /* html */
  `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root ref="gridHeader"></ag-header-root>
        <div class="ag-floating-top" ref="eTop" role="presentation">
            <ag-row-container ref="topLeftContainer" name="`.concat(Te.TOP_LEFT, `"></ag-row-container>
            <ag-row-container ref="topCenterContainer" name="`).concat(Te.TOP_CENTER, `"></ag-row-container>
            <ag-row-container ref="topRightContainer" name="`).concat(Te.TOP_RIGHT, `"></ag-row-container>
            <ag-row-container ref="topFullWidthContainer" name="`).concat(Te.TOP_FULL_WIDTH, `"></ag-row-container>
        </div>
        <div class="ag-body" ref="eBody" role="presentation">
            <div class="ag-body-viewport" ref="eBodyViewport" role="presentation">
                <ag-row-container ref="leftContainer" name="`).concat(Te.LEFT, `"></ag-row-container>
                <ag-row-container ref="centerContainer" name="`).concat(Te.CENTER, `"></ag-row-container>
                <ag-row-container ref="rightContainer" name="`).concat(Te.RIGHT, `"></ag-row-container>
                <ag-row-container ref="fullWidthContainer" name="`).concat(Te.FULL_WIDTH, `"></ag-row-container>
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" ref="eStickyTop" role="presentation">
            <ag-row-container ref="stickyTopLeftContainer" name="`).concat(Te.STICKY_TOP_LEFT, `"></ag-row-container>
            <ag-row-container ref="stickyTopCenterContainer" name="`).concat(Te.STICKY_TOP_CENTER, `"></ag-row-container>
            <ag-row-container ref="stickyTopRightContainer" name="`).concat(Te.STICKY_TOP_RIGHT, `"></ag-row-container>
            <ag-row-container ref="stickyTopFullWidthContainer" name="`).concat(Te.STICKY_TOP_FULL_WIDTH, `"></ag-row-container>
        </div>
        <div class="ag-floating-bottom" ref="eBottom" role="presentation">
            <ag-row-container ref="bottomLeftContainer" name="`).concat(Te.BOTTOM_LEFT, `"></ag-row-container>
            <ag-row-container ref="bottomCenterContainer" name="`).concat(Te.BOTTOM_CENTER, `"></ag-row-container>
            <ag-row-container ref="bottomRightContainer" name="`).concat(Te.BOTTOM_RIGHT, `"></ag-row-container>
            <ag-row-container ref="bottomFullWidthContainer" name="`).concat(Te.BOTTOM_FULL_WIDTH, `"></ag-row-container>
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`)
), HI = (
  /** @class */
  function(o) {
    Cq(t, o);
    function t() {
      return o.call(this, wq) || this;
    }
    return t.prototype.init = function() {
      var e = this, r = function(i, a) {
        var s = "".concat(i, "px");
        a.style.minHeight = s, a.style.height = s;
      }, n = {
        setRowAnimationCssOnBodyViewport: function(i, a) {
          return e.setRowAnimationCssOnBodyViewport(i, a);
        },
        setColumnCount: function(i) {
          return A2(e.getGui(), i);
        },
        setRowCount: function(i) {
          return D2(e.getGui(), i);
        },
        setTopHeight: function(i) {
          return r(i, e.eTop);
        },
        setBottomHeight: function(i) {
          return r(i, e.eBottom);
        },
        setTopDisplay: function(i) {
          return e.eTop.style.display = i;
        },
        setBottomDisplay: function(i) {
          return e.eBottom.style.display = i;
        },
        setStickyTopHeight: function(i) {
          return e.eStickyTop.style.height = i;
        },
        setStickyTopTop: function(i) {
          return e.eStickyTop.style.top = i;
        },
        setStickyTopWidth: function(i) {
          return e.eStickyTop.style.width = i;
        },
        setColumnMovingCss: function(i, a) {
          return e.addOrRemoveCssClass(i, a);
        },
        updateLayoutClasses: function(i, a) {
          var s = [
            e.eBodyViewport.classList,
            e.eBody.classList
          ];
          s.forEach(function(l) {
            l.toggle(rn.AUTO_HEIGHT, a.autoHeight), l.toggle(rn.NORMAL, a.normal), l.toggle(rn.PRINT, a.print);
          }), e.addOrRemoveCssClass(rn.AUTO_HEIGHT, a.autoHeight), e.addOrRemoveCssClass(rn.NORMAL, a.normal), e.addOrRemoveCssClass(rn.PRINT, a.print);
        },
        setAlwaysVerticalScrollClass: function(i, a) {
          return e.eBodyViewport.classList.toggle(NI, a);
        },
        registerBodyViewportResizeListener: function(i) {
          var a = e.resizeObserverService.observeResize(e.eBodyViewport, i);
          e.addDestroyFunc(function() {
            return a();
          });
        },
        setPinnedTopBottomOverflowY: function(i) {
          return e.eTop.style.overflowY = e.eBottom.style.overflowY = i;
        },
        setCellSelectableCss: function(i, a) {
          [e.eTop, e.eBodyViewport, e.eBottom].forEach(function(s) {
            return s.classList.toggle(i, a);
          });
        },
        setBodyViewportWidth: function(i) {
          return e.eBodyViewport.style.width = i;
        }
      };
      this.ctrl = this.createManagedBean(new kI()), this.ctrl.setComp(n, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop), (this.rangeService && this.gridOptionsService.get("enableRangeSelection") || this.gridOptionsService.get("rowSelection") === "multiple") && P2(this.getGui(), !0);
    }, t.prototype.setRowAnimationCssOnBodyViewport = function(e, r) {
      var n = this.eBodyViewport.classList;
      n.toggle(yc.ANIMATION_ON, r), n.toggle(yc.ANIMATION_OFF, !r);
    }, t.prototype.getFloatingTopBottom = function() {
      return [this.eTop, this.eBottom];
    }, us([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), us([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), us([
      ke("eBodyViewport")
    ], t.prototype, "eBodyViewport", void 0), us([
      ke("eStickyTop")
    ], t.prototype, "eStickyTop", void 0), us([
      ke("eTop")
    ], t.prototype, "eTop", void 0), us([
      ke("eBottom")
    ], t.prototype, "eBottom", void 0), us([
      ke("gridHeader")
    ], t.prototype, "headerRootComp", void 0), us([
      ke("eBody")
    ], t.prototype, "eBody", void 0), us([
      Fe
    ], t.prototype, "init", null), t;
  }(gt)
), bq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Qw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, BI = (
  /** @class */
  function(o) {
    bq(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.update();
    }, t.prototype.onDisplayedColumnsWidthChanged = function() {
      this.update();
    }, t.prototype.update = function() {
      this.updateImpl(), setTimeout(this.updateImpl.bind(this), 500);
    }, t.prototype.updateImpl = function() {
      var e = this.ctrlsService.getCenterRowContainerCtrl();
      if (e) {
        var r = {
          horizontalScrollShowing: e.isHorizontalScrollShowing(),
          verticalScrollShowing: this.isVerticalScrollShowing()
        };
        this.setScrollsVisible(r);
      }
    }, t.prototype.setScrollsVisible = function(e) {
      var r = this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing;
      if (r) {
        this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing;
        var n = {
          type: G.EVENT_SCROLL_VISIBILITY_CHANGED
        };
        this.eventService.dispatchEvent(n);
      }
    }, t.prototype.isHorizontalScrollShowing = function() {
      return this.horizontalScrollShowing;
    }, t.prototype.isVerticalScrollShowing = function() {
      return this.verticalScrollShowing;
    }, Qw([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Qw([
      Fe
    ], t.prototype, "postConstruct", null), t = Qw([
      Be("scrollVisibleService")
    ], t), t;
  }(Me)
), Sq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), YO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, WI = (
  /** @class */
  function(o) {
    Sq(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.gridInstanceId = e.gridInstanceSequence.next(), r;
    }
    e = t, t.prototype.stampTopLevelGridCompWithGridInstance = function(r) {
      r[e.GRID_DOM_KEY] = this.gridInstanceId;
    }, t.prototype.getRenderedCellForEvent = function(r) {
      return qm(this.gridOptionsService, r.target, Ml.DOM_DATA_KEY_CELL_CTRL);
    }, t.prototype.isEventFromThisGrid = function(r) {
      var n = this.isElementInThisGrid(r.target);
      return n;
    }, t.prototype.isElementInThisGrid = function(r) {
      for (var n = r; n; ) {
        var i = n[e.GRID_DOM_KEY];
        if (Oe(i)) {
          var a = i === this.gridInstanceId;
          return a;
        }
        n = n.parentElement;
      }
      return !1;
    }, t.prototype.getCellPositionForEvent = function(r) {
      var n = this.getRenderedCellForEvent(r);
      return n ? n.getCellPosition() : null;
    }, t.prototype.getNormalisedPosition = function(r) {
      var n = this.gridOptionsService.isDomLayout("normal"), i = r, a, s;
      if (i.clientX != null || i.clientY != null ? (a = i.clientX, s = i.clientY) : (a = i.x, s = i.y), n) {
        var l = this.ctrlsService.getGridBodyCtrl(), u = l.getScrollFeature().getVScrollPosition(), c = l.getScrollFeature().getHScrollPosition();
        a += c.left, s += u.top;
      }
      return { x: a, y: s };
    };
    var e;
    return t.gridInstanceSequence = new gc(), t.GRID_DOM_KEY = "__ag_grid_instance", YO([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = e = YO([
      Be("mouseEventService")
    ], t), t;
  }(Me)
), Eq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ay = function() {
  return ay = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, ay.apply(this, arguments);
}, To = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, jI = (
  /** @class */
  function(o) {
    Eq(t, o);
    function t() {
      var e = o.call(this) || this;
      return e.onPageDown = OS(e.onPageDown, 100), e.onPageUp = OS(e.onPageUp, 100), e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.gridBodyCon = r.gridBodyCtrl;
      });
    }, t.prototype.handlePageScrollingKey = function(e, r) {
      r === void 0 && (r = !1);
      var n = e.key, i = e.altKey, a = e.ctrlKey || e.metaKey, s = !!this.rangeService && e.shiftKey, l = this.mouseEventService.getCellPositionForEvent(e), u = !1;
      switch (n) {
        case we.PAGE_HOME:
        case we.PAGE_END:
          !a && !i && (this.onHomeOrEndKey(n), u = !0);
          break;
        case we.LEFT:
        case we.RIGHT:
        case we.UP:
        case we.DOWN:
          if (!l)
            return !1;
          a && !i && !s && (this.onCtrlUpDownLeftRight(n, l), u = !0);
          break;
        case we.PAGE_DOWN:
        case we.PAGE_UP:
          !a && !i && (u = this.handlePageUpDown(n, l, r));
          break;
      }
      return u && e.preventDefault(), u;
    }, t.prototype.handlePageUpDown = function(e, r, n) {
      return n && (r = this.focusService.getFocusedCell()), r ? (e === we.PAGE_UP ? this.onPageUp(r) : this.onPageDown(r), !0) : !1;
    }, t.prototype.navigateTo = function(e) {
      var r = e.scrollIndex, n = e.scrollType, i = e.scrollColumn, a = e.focusIndex, s = e.focusColumn;
      if (Oe(i) && !i.isPinned() && this.gridBodyCon.getScrollFeature().ensureColumnVisible(i), Oe(r) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(r, n), e.isAsync || this.gridBodyCon.getScrollFeature().ensureIndexVisible(a), this.focusService.setFocusedCell({ rowIndex: a, column: s, rowPinned: null, forceBrowserFocus: !0 }), this.rangeService) {
        var l = { rowIndex: a, rowPinned: null, column: s };
        this.rangeService.setRangeToCell(l);
      }
    }, t.prototype.onPageDown = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), n = r.getScrollFeature().getVScrollPosition(), i = this.getViewportHeight(), a = this.paginationProxy.getPixelOffset(), s = n.top + i, l = this.paginationProxy.getRowIndexAtPixel(s + a);
      this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, l) : this.navigateToNextPage(e, l);
    }, t.prototype.onPageUp = function(e) {
      var r = this.ctrlsService.getGridBodyCtrl(), n = r.getScrollFeature().getVScrollPosition(), i = this.paginationProxy.getPixelOffset(), a = n.top, s = this.paginationProxy.getRowIndexAtPixel(a + i);
      this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, s, !0) : this.navigateToNextPage(e, s, !0);
    }, t.prototype.navigateToNextPage = function(e, r, n) {
      n === void 0 && (n = !1);
      var i = this.getViewportHeight(), a = this.paginationProxy.getPageFirstRow(), s = this.paginationProxy.getPageLastRow(), l = this.paginationProxy.getPixelOffset(), u = this.paginationProxy.getRow(e.rowIndex), c = n ? (u == null ? void 0 : u.rowHeight) - i - l : i - l, d = (u == null ? void 0 : u.rowTop) + c, f = this.paginationProxy.getRowIndexAtPixel(d + l);
      if (f === e.rowIndex) {
        var v = n ? -1 : 1;
        r = f = e.rowIndex + v;
      }
      var g;
      n ? (g = "bottom", f < a && (f = a), r < a && (r = a)) : (g = "top", f > s && (f = s), r > s && (r = s)), this.isRowTallerThanView(f) && (r = f, g = "top"), this.navigateTo({
        scrollIndex: r,
        scrollType: g,
        scrollColumn: null,
        focusIndex: f,
        focusColumn: e.column
      });
    }, t.prototype.navigateToNextPageWithAutoHeight = function(e, r, n) {
      var i = this;
      n === void 0 && (n = !1), this.navigateTo({
        scrollIndex: r,
        scrollType: n ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: r,
        focusColumn: e.column
      }), setTimeout(function() {
        var a = i.getNextFocusIndexForAutoHeight(e, n);
        i.navigateTo({
          scrollIndex: r,
          scrollType: n ? "bottom" : "top",
          scrollColumn: null,
          focusIndex: a,
          focusColumn: e.column,
          isAsync: !0
        });
      }, 50);
    }, t.prototype.getNextFocusIndexForAutoHeight = function(e, r) {
      var n;
      r === void 0 && (r = !1);
      for (var i = r ? -1 : 1, a = this.getViewportHeight(), s = this.paginationProxy.getPageLastRow(), l = 0, u = e.rowIndex; u >= 0 && u <= s; ) {
        var c = this.paginationProxy.getRow(u);
        if (c) {
          var d = (n = c.rowHeight) !== null && n !== void 0 ? n : 0;
          if (l + d > a)
            break;
          l += d;
        }
        u += i;
      }
      return Math.max(0, Math.min(u, s));
    }, t.prototype.getViewportHeight = function() {
      var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition(), n = this.gridOptionsService.getScrollbarWidth(), i = r.bottom - r.top;
      return this.ctrlsService.getCenterRowContainerCtrl().isHorizontalScrollShowing() && (i -= n), i;
    }, t.prototype.isRowTallerThanView = function(e) {
      var r = this.paginationProxy.getRow(e);
      if (!r)
        return !1;
      var n = r.rowHeight;
      return typeof n != "number" ? !1 : n > this.getViewportHeight();
    }, t.prototype.onCtrlUpDownLeftRight = function(e, r) {
      var n = this.cellNavigationService.getNextCellToFocus(e, r, !0), i = n.rowIndex, a = n.column;
      this.navigateTo({
        scrollIndex: i,
        scrollType: null,
        scrollColumn: a,
        focusIndex: i,
        focusColumn: a
      });
    }, t.prototype.onHomeOrEndKey = function(e) {
      var r = e === we.PAGE_HOME, n = this.columnModel.getAllDisplayedColumns(), i = r ? n[0] : Kt(n), a = r ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
      this.navigateTo({
        scrollIndex: a,
        scrollType: null,
        scrollColumn: i,
        focusIndex: a,
        focusColumn: i
      });
    }, t.prototype.onTabKeyDown = function(e, r) {
      var n = r.shiftKey, i = this.tabToNextCellCommon(e, n, r);
      if (i) {
        r.preventDefault();
        return;
      }
      if (n) {
        var a = e.getRowPosition(), s = a.rowIndex, l = a.rowPinned, u = l ? s === 0 : s === this.paginationProxy.getPageFirstRow();
        u && (this.gridOptionsService.get("headerHeight") === 0 ? this.focusService.focusNextGridCoreContainer(!0, !0) : (r.preventDefault(), this.focusService.focusPreviousFromFirstCell(r)));
      } else
        e instanceof Ml && e.focusCell(!0), this.focusService.focusNextGridCoreContainer(n) && r.preventDefault();
    }, t.prototype.tabToNextCell = function(e, r) {
      var n = this.focusService.getFocusedCell();
      if (!n)
        return !1;
      var i = this.getCellByPosition(n);
      return !i && (i = this.rowRenderer.getRowByPosition(n), !i || !i.isFullWidth()) ? !1 : this.tabToNextCellCommon(i, e, r);
    }, t.prototype.tabToNextCellCommon = function(e, r, n) {
      var i = e.isEditing();
      if (!i && e instanceof Ml) {
        var a = e, s = a.getRowCtrl();
        s && (i = s.isEditing());
      }
      var l;
      return i ? this.gridOptionsService.get("editType") === "fullRow" ? l = this.moveToNextEditingRow(e, r, n) : l = this.moveToNextEditingCell(e, r, n) : l = this.moveToNextCellNotEditing(e, r), l || !!this.focusService.getFocusedHeader();
    }, t.prototype.moveToNextEditingCell = function(e, r, n) {
      n === void 0 && (n = null);
      var i = e.getCellPosition();
      e.getGui().focus(), e.stopEditing();
      var a = this.findNextCellToFocusOn(i, r, !0);
      return a == null ? !1 : (a.startEditing(null, !0, n), a.focusCell(!1), !0);
    }, t.prototype.moveToNextEditingRow = function(e, r, n) {
      n === void 0 && (n = null);
      var i = e.getCellPosition(), a = this.findNextCellToFocusOn(i, r, !0);
      if (a == null)
        return !1;
      var s = a.getCellPosition(), l = this.isCellEditable(i), u = this.isCellEditable(s), c = s && i.rowIndex === s.rowIndex && i.rowPinned === s.rowPinned;
      if (l && e.setFocusOutOnEditor(), !c) {
        var d = e.getRowCtrl();
        d.stopEditing();
        var f = a.getRowCtrl();
        f.startRowEditing(void 0, void 0, n);
      }
      return u ? (a.setFocusInOnEditor(), a.focusCell()) : a.focusCell(!0), !0;
    }, t.prototype.moveToNextCellNotEditing = function(e, r) {
      var n = this.columnModel.getAllDisplayedColumns(), i;
      e instanceof Fl ? i = ay(ay({}, e.getRowPosition()), { column: r ? n[0] : Kt(n) }) : i = e.getCellPosition();
      var a = this.findNextCellToFocusOn(i, r, !1);
      if (a instanceof Ml)
        a.focusCell(!0);
      else if (a)
        return this.tryToFocusFullWidthRow(a.getRowPosition(), r);
      return Oe(a);
    }, t.prototype.findNextCellToFocusOn = function(e, r, n) {
      for (var i = e; ; ) {
        e !== i && (e = i), r || (i = this.getLastCellOfColSpan(i)), i = this.cellNavigationService.getNextTabbedCell(i, r);
        var a = this.gridOptionsService.getCallback("tabToNextCell");
        if (Oe(a)) {
          var s = {
            backwards: r,
            editing: n,
            previousCellPosition: e,
            nextCellPosition: i || null
          }, l = a(s);
          Oe(l) ? (l.floating && (ht("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"), l.rowPinned = l.floating), i = {
            rowIndex: l.rowIndex,
            column: l.column,
            rowPinned: l.rowPinned
          }) : i = null;
        }
        if (!i)
          return null;
        if (i.rowIndex < 0) {
          var u = this.headerNavigationService.getHeaderRowCount();
          return this.focusService.focusHeaderPosition({
            headerPosition: {
              headerRowIndex: u + i.rowIndex,
              column: i.column
            },
            fromCell: !0
          }), null;
        }
        var c = this.gridOptionsService.get("editType") === "fullRow";
        if (n && !c) {
          var d = this.isCellEditable(i);
          if (!d)
            continue;
        }
        this.ensureCellVisible(i);
        var f = this.getCellByPosition(i);
        if (!f) {
          var v = this.rowRenderer.getRowByPosition(i);
          if (!v || !v.isFullWidth() || n)
            continue;
          return v;
        }
        if (!f.isSuppressNavigable())
          return this.rangeService && this.rangeService.setRangeToCell(i), f;
      }
    }, t.prototype.isCellEditable = function(e) {
      var r = this.lookupRowNodeForCell(e);
      return r ? e.column.isCellEditable(r) : !1;
    }, t.prototype.getCellByPosition = function(e) {
      var r = this.rowRenderer.getRowByPosition(e);
      return r ? r.getCellCtrl(e.column) : null;
    }, t.prototype.lookupRowNodeForCell = function(e) {
      return e.rowPinned === "top" ? this.pinnedRowModel.getPinnedTopRow(e.rowIndex) : e.rowPinned === "bottom" ? this.pinnedRowModel.getPinnedBottomRow(e.rowIndex) : this.paginationProxy.getRow(e.rowIndex);
    }, t.prototype.navigateToNextCell = function(e, r, n, i) {
      for (var a = n, s = !1; a && (a === n || !this.isValidNavigateCell(a)); )
        this.gridOptionsService.get("enableRtl") ? r === we.LEFT && (a = this.getLastCellOfColSpan(a)) : r === we.RIGHT && (a = this.getLastCellOfColSpan(a)), a = this.cellNavigationService.getNextCellToFocus(r, a), s = tt(a);
      if (s && e && e.key === we.UP && (a = {
        rowIndex: -1,
        rowPinned: null,
        column: n.column
      }), i) {
        var l = this.gridOptionsService.getCallback("navigateToNextCell");
        if (Oe(l)) {
          var u = {
            key: r,
            previousCellPosition: n,
            nextCellPosition: a || null,
            event: e
          }, c = l(u);
          Oe(c) ? (c.floating && (ht("tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"), c.rowPinned = c.floating), a = {
            rowPinned: c.rowPinned,
            rowIndex: c.rowIndex,
            column: c.column
          }) : a = null;
        }
      }
      if (a) {
        if (a.rowIndex < 0) {
          var d = this.headerNavigationService.getHeaderRowCount();
          this.focusService.focusHeaderPosition({
            headerPosition: { headerRowIndex: d + a.rowIndex, column: n.column },
            event: e || void 0,
            fromCell: !0
          });
          return;
        }
        var f = this.getNormalisedPosition(a);
        f ? this.focusPosition(f) : this.tryToFocusFullWidthRow(a);
      }
    }, t.prototype.getNormalisedPosition = function(e) {
      this.ensureCellVisible(e);
      var r = this.getCellByPosition(e);
      return r ? (e = r.getCellPosition(), this.ensureCellVisible(e), e) : null;
    }, t.prototype.tryToFocusFullWidthRow = function(e, r) {
      r === void 0 && (r = !1);
      var n = this.columnModel.getAllDisplayedColumns(), i = this.rowRenderer.getRowByPosition(e);
      if (!i || !i.isFullWidth())
        return !1;
      var a = this.focusService.getFocusedCell(), s = {
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned,
        column: e.column || (r ? Kt(n) : n[0])
      };
      this.focusPosition(s);
      var l = a != null ? this.rowPositionUtils.before(s, a) : !1, u = {
        type: G.EVENT_FULL_WIDTH_ROW_FOCUSED,
        rowIndex: s.rowIndex,
        rowPinned: s.rowPinned,
        column: s.column,
        isFullWidthCell: !0,
        floating: s.rowPinned,
        fromBelow: l
      };
      return this.eventService.dispatchEvent(u), !0;
    }, t.prototype.focusPosition = function(e) {
      this.focusService.setFocusedCell({
        rowIndex: e.rowIndex,
        column: e.column,
        rowPinned: e.rowPinned,
        forceBrowserFocus: !0
      }), this.rangeService && this.rangeService.setRangeToCell(e);
    }, t.prototype.isValidNavigateCell = function(e) {
      var r = this.rowPositionUtils.getRowNode(e);
      return !!r;
    }, t.prototype.getLastCellOfColSpan = function(e) {
      var r = this.getCellByPosition(e);
      if (!r)
        return e;
      var n = r.getColSpanningList();
      return n.length === 1 ? e : {
        rowIndex: e.rowIndex,
        column: Kt(n),
        rowPinned: e.rowPinned
      };
    }, t.prototype.ensureCellVisible = function(e) {
      var r = this.gridOptionsService.isGroupRowsSticky(), n = this.rowModel.getRow(e.rowIndex), i = r && (n == null ? void 0 : n.sticky);
      !i && tt(e.rowPinned) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(e.rowIndex), e.column.isPinned() || this.gridBodyCon.getScrollFeature().ensureColumnVisible(e.column);
    }, To([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), To([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), To([
      N("focusService")
    ], t.prototype, "focusService", void 0), To([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), To([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), To([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), To([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), To([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), To([
      N("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), To([
      N("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), To([
      N("cellNavigationService")
    ], t.prototype, "cellNavigationService", void 0), To([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), To([
      Fe
    ], t.prototype, "postConstruct", null), t = To([
      Be("navigationService")
    ], t), t;
  }(Me)
), _q = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xq = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, UI = (
  /** @class */
  function(o) {
    _q(t, o);
    function t(e) {
      var r = o.call(
        this,
        /* html */
        '<div class="ag-popup-editor" tabindex="-1"/>'
      ) || this;
      return r.params = e, r;
    }
    return t.prototype.postConstruct = function() {
      this.gridOptionsService.setDomData(this.getGui(), t.DOM_KEY_POPUP_EDITOR_WRAPPER, !0), this.addKeyDownListener();
    }, t.prototype.addKeyDownListener = function() {
      var e = this, r = this.getGui(), n = this.params, i = function(a) {
        Jm(e.gridOptionsService, a, n.node, n.column, !0) || n.onKeyDown(a);
      };
      this.addManagedListener(r, "keydown", i);
    }, t.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper", xq([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Yl)
), Rq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $I = (
  /** @class */
  function(o) {
    Rq(t, o);
    function t(e, r, n, i, a) {
      var s = o.call(this) || this;
      s.rendererVersion = 0, s.editorVersion = 0, s.beans = e, s.column = r.getColumn(), s.rowNode = r.getRowNode(), s.rowCtrl = r.getRowCtrl(), s.eRow = i, s.cellCtrl = r;
      var l = document.createElement("div");
      l.setAttribute("comp-id", "".concat(s.getCompId())), s.setTemplateFromElement(l);
      var u = s.getGui();
      s.forceWrapper = r.isForceWrapper(), s.refreshWrapper(!1);
      var c = function(v, g) {
        g != null && g != "" ? u.setAttribute(v, g) : u.removeAttribute(v);
      };
      bn(u, r.getCellAriaRole()), c("col-id", r.getColumnIdSanitised());
      var d = r.getTabIndex();
      d !== void 0 && c("tabindex", d.toString());
      var f = {
        addOrRemoveCssClass: function(v, g) {
          return s.addOrRemoveCssClass(v, g);
        },
        setUserStyles: function(v) {
          return q1(u, v);
        },
        getFocusableElement: function() {
          return s.getFocusableElement();
        },
        setIncludeSelection: function(v) {
          return s.includeSelection = v;
        },
        setIncludeRowDrag: function(v) {
          return s.includeRowDrag = v;
        },
        setIncludeDndSource: function(v) {
          return s.includeDndSource = v;
        },
        setRenderDetails: function(v, g, m) {
          return s.setRenderDetails(v, g, m);
        },
        setEditDetails: function(v, g, m) {
          return s.setEditDetails(v, g, m);
        },
        getCellEditor: function() {
          return s.cellEditor || null;
        },
        getCellRenderer: function() {
          return s.cellRenderer || null;
        },
        getParentOfValue: function() {
          return s.getParentOfValue();
        }
      };
      return r.setComp(f, s.getGui(), s.eCellWrapper, n, a), s;
    }
    return t.prototype.getParentOfValue = function() {
      return this.eCellValue ? this.eCellValue : this.eCellWrapper ? this.eCellWrapper : this.getGui();
    }, t.prototype.setRenderDetails = function(e, r, n) {
      var i = this.cellEditor && !this.cellEditorPopupWrapper;
      if (!i) {
        this.firstRender = this.firstRender == null;
        var a = this.refreshWrapper(!1);
        if (this.refreshEditStyles(!1), e) {
          var s = n || a, l = s ? !1 : this.refreshCellRenderer(e);
          l || (this.destroyRenderer(), this.createCellRendererInstance(e));
        } else
          this.destroyRenderer(), this.insertValueWithoutCellRenderer(r);
      }
    }, t.prototype.setEditDetails = function(e, r, n) {
      e ? this.createCellEditorInstance(e, r, n) : this.destroyEditor();
    }, t.prototype.removeControls = function() {
      this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp), this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
    }, t.prototype.refreshWrapper = function(e) {
      var r = this.includeRowDrag || this.includeDndSource || this.includeSelection, n = r || this.forceWrapper, i = n && this.eCellWrapper == null;
      if (i) {
        var a = document.createElement("div");
        a.setAttribute("role", "presentation"), a.setAttribute("class", "ag-cell-wrapper"), this.eCellWrapper = a, this.getGui().appendChild(this.eCellWrapper);
      }
      var s = !n && this.eCellWrapper != null;
      s && (bs(this.eCellWrapper), this.eCellWrapper = void 0), this.addOrRemoveCssClass("ag-cell-value", !n);
      var l = !e && n, u = l && this.eCellValue == null;
      if (u) {
        var c = document.createElement("span");
        c.setAttribute("role", "presentation"), c.setAttribute("class", "ag-cell-value"), this.eCellValue = c, this.eCellWrapper.appendChild(this.eCellValue);
      }
      var d = !l && this.eCellValue != null;
      d && (bs(this.eCellValue), this.eCellValue = void 0);
      var f = i || s || u || d;
      return f && this.removeControls(), e || r && this.addControls(), f;
    }, t.prototype.addControls = function() {
      this.includeRowDrag && this.rowDraggingComp == null && (this.rowDraggingComp = this.cellCtrl.createRowDragComp(), this.rowDraggingComp && this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue)), this.includeDndSource && this.dndSourceComp == null && (this.dndSourceComp = this.cellCtrl.createDndSource(), this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue)), this.includeSelection && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox(), this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue));
    }, t.prototype.createCellEditorInstance = function(e, r, n) {
      var i = this, a = this.editorVersion, s = e.newAgStackInstance();
      if (s) {
        var l = e.params;
        s.then(function(c) {
          return i.afterCellEditorCreated(a, c, l, r, n);
        });
        var u = tt(this.cellEditor);
        u && l.cellStartedEdit && this.cellCtrl.focusCell(!0);
      }
    }, t.prototype.insertValueWithoutCellRenderer = function(e) {
      var r = this.getParentOfValue();
      An(r);
      var n = e != null ? vn(e, !0) : null;
      n != null && (r.textContent = n);
    }, t.prototype.destroyEditorAndRenderer = function() {
      this.destroyRenderer(), this.destroyEditor();
    }, t.prototype.destroyRenderer = function() {
      var e = this.beans.context;
      this.cellRenderer = e.destroyBean(this.cellRenderer), bs(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
    }, t.prototype.destroyEditor = function() {
      var e = this.beans.context;
      this.hideEditorPopup && this.hideEditorPopup(), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), bs(this.cellEditorGui), this.cellEditorGui = null, this.editorVersion++;
    }, t.prototype.refreshCellRenderer = function(e) {
      if (this.cellRenderer == null || this.cellRenderer.refresh == null || this.cellRendererClass !== e.componentClass)
        return !1;
      var r = this.cellRenderer.refresh(e.params);
      return r === !0 || r === void 0;
    }, t.prototype.createCellRendererInstance = function(e) {
      var r = this, n = this.beans.gridOptionsService.get("suppressAnimationFrame"), i = !n, a = this.rendererVersion, s = e.componentClass, l = function() {
        var u = r.rendererVersion !== a || !r.isAlive();
        if (!u) {
          var c = e.newAgStackInstance(), d = r.afterCellRendererCreated.bind(r, a, s);
          c && c.then(d);
        }
      };
      i && this.firstRender ? this.beans.animationFrameService.createTask(l, this.rowNode.rowIndex, "createTasksP2") : l();
    }, t.prototype.getCtrl = function() {
      return this.cellCtrl;
    }, t.prototype.getRowCtrl = function() {
      return this.rowCtrl;
    }, t.prototype.getCellRenderer = function() {
      return this.cellRenderer;
    }, t.prototype.getCellEditor = function() {
      return this.cellEditor;
    }, t.prototype.afterCellRendererCreated = function(e, r, n) {
      var i = !this.isAlive() || e !== this.rendererVersion;
      if (i) {
        this.beans.context.destroyBean(n);
        return;
      }
      if (this.cellRenderer = n, this.cellRendererClass = r, this.cellRendererGui = this.cellRenderer.getGui(), this.cellRendererGui != null) {
        var a = this.getParentOfValue();
        An(a), a.appendChild(this.cellRendererGui);
      }
    }, t.prototype.afterCellEditorCreated = function(e, r, n, i, a) {
      var s = e !== this.editorVersion;
      if (s) {
        this.beans.context.destroyBean(r);
        return;
      }
      var l = r.isCancelBeforeStart && r.isCancelBeforeStart();
      if (l) {
        this.beans.context.destroyBean(r), this.cellCtrl.stopEditing(!0);
        return;
      }
      if (!r.getGui) {
        console.warn("AG Grid: cellEditor for column ".concat(this.column.getId(), " is missing getGui() method")), this.beans.context.destroyBean(r);
        return;
      }
      this.cellEditor = r, this.cellEditorGui = r.getGui();
      var u = i || r.isPopup !== void 0 && r.isPopup();
      u ? this.addPopupCellEditor(n, a) : this.addInCellEditor(), this.refreshEditStyles(!0, u), r.afterGuiAttached && r.afterGuiAttached();
    }, t.prototype.refreshEditStyles = function(e, r) {
      var n;
      this.addOrRemoveCssClass("ag-cell-inline-editing", e && !r), this.addOrRemoveCssClass("ag-cell-popup-editing", e && !!r), this.addOrRemoveCssClass("ag-cell-not-inline-editing", !e || !!r), (n = this.rowCtrl) === null || n === void 0 || n.setInlineEditingCss(e);
    }, t.prototype.addInCellEditor = function() {
      var e = this.getGui(), r = this.beans.gridOptionsService.getDocument();
      if (e.contains(r.activeElement) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), this.clearParentOfValue(), this.cellEditorGui) {
        var n = this.getParentOfValue();
        n.appendChild(this.cellEditorGui);
      }
    }, t.prototype.addPopupCellEditor = function(e, r) {
      var n = this;
      this.beans.gridOptionsService.get("editType") === "fullRow" && console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
      var i = this.cellEditor;
      this.cellEditorPopupWrapper = this.beans.context.createBean(new UI(e));
      var a = this.cellEditorPopupWrapper.getGui();
      this.cellEditorGui && a.appendChild(this.cellEditorGui);
      var s = this.beans.popupService, l = this.beans.gridOptionsService.get("stopEditingWhenCellsLoseFocus"), u = r ?? (i.getPopupPosition ? i.getPopupPosition() : "over"), c = this.beans.gridOptionsService.get("enableRtl"), d = {
        ePopup: a,
        column: this.column,
        rowNode: this.rowNode,
        type: "popupCellEditor",
        eventSource: this.getGui(),
        position: u,
        alignSide: c ? "right" : "left",
        keepWithinBounds: !0
      }, f = s.positionPopupByComponent.bind(s, d), v = this.beans.localeService.getLocaleTextFunc(), g = s.addPopup({
        modal: l,
        eChild: a,
        closeOnEsc: !0,
        closedCallback: function() {
          n.cellCtrl.onPopupEditorClosed();
        },
        anchorToElement: this.getGui(),
        positionCallback: f,
        ariaLabel: v("ariaLabelCellEditor", "Cell Editor")
      });
      g && (this.hideEditorPopup = g.hideFunc);
    }, t.prototype.detach = function() {
      this.eRow.removeChild(this.getGui());
    }, t.prototype.destroy = function() {
      this.cellCtrl.stopEditing(), this.destroyEditorAndRenderer(), this.removeControls(), o.prototype.destroy.call(this);
    }, t.prototype.clearParentOfValue = function() {
      var e = this.getGui(), r = this.beans.gridOptionsService.getDocument();
      e.contains(r.activeElement) && V1() && e.focus({ preventScroll: !0 }), An(this.getParentOfValue());
    }, t;
  }(gt)
), Tq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Oq = (
  /** @class */
  function(o) {
    Tq(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      i.cellComps = {}, i.beans = r, i.rowCtrl = e;
      var a = document.createElement("div");
      a.setAttribute("comp-id", "".concat(i.getCompId())), a.setAttribute("style", i.getInitialStyle(n)), i.setTemplateFromElement(a);
      var s = i.getGui(), l = s.style;
      i.domOrder = i.rowCtrl.getDomOrder(), bn(s, "row");
      var u = i.rowCtrl.getTabIndex();
      u != null && s.setAttribute("tabindex", u.toString());
      var c = {
        setDomOrder: function(d) {
          return i.domOrder = d;
        },
        setCellCtrls: function(d) {
          return i.setCellCtrls(d);
        },
        showFullWidth: function(d) {
          return i.showFullWidth(d);
        },
        getFullWidthCellRenderer: function() {
          return i.getFullWidthCellRenderer();
        },
        addOrRemoveCssClass: function(d, f) {
          return i.addOrRemoveCssClass(d, f);
        },
        setUserStyles: function(d) {
          return q1(s, d);
        },
        setTop: function(d) {
          return l.top = d;
        },
        setTransform: function(d) {
          return l.transform = d;
        },
        setRowIndex: function(d) {
          return s.setAttribute("row-index", d);
        },
        setRowId: function(d) {
          return s.setAttribute("row-id", d);
        },
        setRowBusinessKey: function(d) {
          return s.setAttribute("row-business-key", d);
        },
        refreshFullWidth: function(d) {
          return i.refreshFullWidth(d);
        }
      };
      return e.setComp(c, i.getGui(), n), i.addDestroyFunc(function() {
        e.unsetComp(n);
      }), i;
    }
    return t.prototype.getInitialStyle = function(e) {
      var r = this.rowCtrl.getInitialTransform(e);
      return r ? "transform: ".concat(r) : "top: ".concat(this.rowCtrl.getInitialRowTop(e));
    }, t.prototype.showFullWidth = function(e) {
      var r = this, n = function(a) {
        if (r.isAlive()) {
          var s = a.getGui();
          r.getGui().appendChild(s), r.rowCtrl.setupDetailRowAutoHeight(s), r.setFullWidthRowComp(a);
        } else
          r.beans.context.destroyBean(a);
      }, i = e.newAgStackInstance();
      i && i.then(n);
    }, t.prototype.setCellCtrls = function(e) {
      var r = this, n = Object.assign({}, this.cellComps);
      e.forEach(function(a) {
        var s = a.getInstanceId(), l = r.cellComps[s];
        l == null ? r.newCellComp(a) : n[s] = null;
      });
      var i = Vl(n).filter(function(a) {
        return a != null;
      });
      this.destroyCells(i), this.ensureDomOrder(e);
    }, t.prototype.ensureDomOrder = function(e) {
      var r = this;
      if (this.domOrder) {
        var n = [];
        e.forEach(function(i) {
          var a = r.cellComps[i.getInstanceId()];
          a && n.push(a.getGui());
        }), K1(this.getGui(), n);
      }
    }, t.prototype.newCellComp = function(e) {
      var r = new $I(this.beans, e, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
      this.cellComps[e.getInstanceId()] = r, this.getGui().appendChild(r.getGui());
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.destroyAllCells();
    }, t.prototype.destroyAllCells = function() {
      var e = Vl(this.cellComps).filter(function(r) {
        return r != null;
      });
      this.destroyCells(e);
    }, t.prototype.setFullWidthRowComp = function(e) {
      var r = this;
      this.fullWidthCellRenderer && console.error("AG Grid - should not be setting fullWidthRowComponent twice"), this.fullWidthCellRenderer = e, this.addDestroyFunc(function() {
        r.fullWidthCellRenderer = r.beans.context.destroyBean(r.fullWidthCellRenderer);
      });
    }, t.prototype.getFullWidthCellRenderer = function() {
      return this.fullWidthCellRenderer;
    }, t.prototype.destroyCells = function(e) {
      var r = this;
      e.forEach(function(n) {
        if (n) {
          var i = n.getCtrl().getInstanceId();
          r.cellComps[i] === n && (n.detach(), n.destroy(), r.cellComps[i] = null);
        }
      });
    }, t.prototype.refreshFullWidth = function(e) {
      var r = this.fullWidthCellRenderer;
      if (!r || !r.refresh)
        return !1;
      var n = e();
      return r.refresh(n);
    }, t;
  }(gt)
), Pq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), US = function() {
  return US = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, US.apply(this, arguments);
}, Af = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
};
function Dq() {
  var o = gt.elementGettingCreated.getAttribute("name"), t = v_.getRowContainerCssClasses(o), e, r = o === Te.CENTER || o === Te.TOP_CENTER || o === Te.STICKY_TOP_CENTER || o === Te.BOTTOM_CENTER;
  return r ? e = /* html */
  '<div class="'.concat(t.viewport, `" ref="eViewport" role="presentation">
                <div class="`).concat(t.container, `" ref="eContainer"></div>
            </div>`) : e = /* html */
  '<div class="'.concat(t.container, '" ref="eContainer"></div>'), e;
}
var zI = (
  /** @class */
  function(o) {
    Pq(t, o);
    function t() {
      var e = o.call(this, Dq()) || this;
      return e.rowComps = {}, e.name = gt.elementGettingCreated.getAttribute("name"), e.type = VI(e.name), e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = {
        setViewportHeight: function(i) {
          return e.eViewport.style.height = i;
        },
        setRowCtrls: function(i) {
          var a = i.rowCtrls;
          return e.setRowCtrls(a);
        },
        setDomOrder: function(i) {
          e.domOrder = i;
        },
        setContainerWidth: function(i) {
          return e.eContainer.style.width = i;
        }
      }, n = this.createManagedBean(new v_(this.name));
      n.setComp(r, this.eContainer, this.eViewport);
    }, t.prototype.preDestroy = function() {
      this.setRowCtrls([]);
    }, t.prototype.setRowCtrls = function(e) {
      var r = this, n = US({}, this.rowComps);
      this.rowComps = {}, this.lastPlacedElement = null;
      var i = function(a) {
        var s = a.getInstanceId(), l = n[s];
        if (l)
          r.rowComps[s] = l, delete n[s], r.ensureDomOrder(l.getGui());
        else {
          if (!a.getRowNode().displayed)
            return;
          var u = new Oq(a, r.beans, r.type);
          r.rowComps[s] = u, r.appendRow(u.getGui());
        }
      };
      e.forEach(i), Vl(n).forEach(function(a) {
        r.eContainer.removeChild(a.getGui()), a.destroy();
      }), bn(this.eContainer, "rowgroup");
    }, t.prototype.appendRow = function(e) {
      this.domOrder ? j2(this.eContainer, e, this.lastPlacedElement) : this.eContainer.appendChild(e), this.lastPlacedElement = e;
    }, t.prototype.ensureDomOrder = function(e) {
      this.domOrder && (Y1(this.eContainer, e, this.lastPlacedElement), this.lastPlacedElement = e);
    }, Af([
      N("beans")
    ], t.prototype, "beans", void 0), Af([
      ke("eViewport")
    ], t.prototype, "eViewport", void 0), Af([
      ke("eContainer")
    ], t.prototype, "eContainer", void 0), Af([
      Fe
    ], t.prototype, "postConstruct", null), Af([
      eo
    ], t.prototype, "preDestroy", null), t;
  }(gt)
), KO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, YI = (
  /** @class */
  function() {
    function o(t) {
      this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [], this.pinned = t;
    }
    return o.prototype.onDragEnter = function(t) {
      var e = this;
      if (this.clearColumnsList(), !this.gridOptionsService.get("functionsReadOnly")) {
        var r = t.dragItem.columns;
        r && r.forEach(function(n) {
          n.isPrimary() && (n.isAnyFunctionActive() || (n.isAllowValue() ? e.columnsToAggregate.push(n) : n.isAllowRowGroup() ? e.columnsToGroup.push(n) : n.isAllowPivot() && e.columnsToPivot.push(n)));
        });
      }
    }, o.prototype.getIconName = function() {
      var t = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
      return t > 0 ? this.pinned ? fn.ICON_PINNED : fn.ICON_MOVE : null;
    }, o.prototype.onDragLeave = function(t) {
      this.clearColumnsList();
    }, o.prototype.clearColumnsList = function() {
      this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
    }, o.prototype.onDragging = function(t) {
    }, o.prototype.onDragStop = function(t) {
      this.columnsToAggregate.length > 0 && this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop"), this.columnsToGroup.length > 0 && this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop"), this.columnsToPivot.length > 0 && this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }, KO([
      N("columnModel")
    ], o.prototype, "columnModel", void 0), KO([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), o;
  }()
), Aq = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, lc = (
  /** @class */
  function() {
    function o() {
    }
    return o.attemptMoveColumns = function(t) {
      var e = t.isFromHeader, r = t.hDirection, n = t.xPosition, i = t.fromEnter, a = t.fakeEvent, s = t.pinned, l = t.gridOptionsService, u = t.columnModel, c = r === Qn.Left, d = r === Qn.Right, f = t.allMovingColumns;
      if (e) {
        var v = [];
        f.forEach(function(V) {
          for (var W, q = null, ee = V.getParent(); ee != null && ee.getDisplayedLeafColumns().length === 1; )
            q = ee, ee = ee.getParent();
          if (q != null) {
            var re = !!(!((W = q.getColGroupDef()) === null || W === void 0) && W.marryChildren), ie = re ? q.getProvidedColumnGroup().getLeafColumns() : q.getLeafColumns();
            ie.forEach(function(ne) {
              v.includes(ne) || v.push(ne);
            });
          } else v.includes(V) || v.push(V);
        }), f = v;
      }
      var g = f.slice();
      u.sortColumnsLikeGridColumns(g);
      var m = this.calculateValidMoves({
        movingCols: g,
        draggingRight: d,
        xPosition: n,
        pinned: s,
        gridOptionsService: l,
        columnModel: u
      }), b = this.calculateOldIndex(g, u);
      if (m.length !== 0) {
        var S = m[0], R = b !== null && !i;
        if (e && (R = b !== null), !(R && !a && (c && S >= b || d && S <= b))) {
          for (var P = u.getAllDisplayedColumns(), D = [], x = null, M = 0; M < m.length; M++) {
            var F = m[M], H = u.getProposedColumnOrder(g, F);
            if (u.doesOrderPassRules(H)) {
              var B = H.filter(function(V) {
                return P.includes(V);
              });
              if (x === null)
                x = B;
              else if (!ws(B, x))
                break;
              var j = this.groupFragCount(H);
              D.push({ move: F, fragCount: j });
            }
          }
          if (D.length !== 0)
            return D.sort(function(V, W) {
              return V.fragCount - W.fragCount;
            }), this.moveColumns(f, D[0].move, "uiColumnMoved", !1, u);
        }
      }
    }, o.moveColumns = function(t, e, r, n, i) {
      return i.moveColumns(t, e, r, n), n ? null : { columns: t, toIndex: e };
    }, o.calculateOldIndex = function(t, e) {
      var r = e.getAllGridColumns(), n = i2(t.map(function(u) {
        return r.indexOf(u);
      })), i = n[0], a = Kt(n), s = a - i, l = s !== n.length - 1;
      return l ? null : i;
    }, o.groupFragCount = function(t) {
      function e(a) {
        for (var s = [], l = a.getOriginalParent(); l != null; )
          s.push(l), l = l.getOriginalParent();
        return s;
      }
      for (var r = 0, n = function(a) {
        var s, l = e(t[a]), u = e(t[a + 1]);
        s = Aq(l.length > u.length ? [l, u] : [u, l], 2), l = s[0], u = s[1], l.forEach(function(c) {
          u.indexOf(c) === -1 && r++;
        });
      }, i = 0; i < t.length - 1; i++)
        n(i);
      return r;
    }, o.calculateValidMoves = function(t) {
      var e = t.movingCols, r = t.draggingRight, n = t.xPosition, i = t.pinned, a = t.gridOptionsService, s = t.columnModel, l = a.get("suppressMovableColumns") || e.some(function(V) {
        return V.getColDef().suppressMovable;
      });
      if (l)
        return [];
      var u = s.getDisplayedColumns(i), c = s.getAllGridColumns(), d = u.filter(function(V) {
        return ra(e, V);
      }), f = u.filter(function(V) {
        return !ra(e, V);
      }), v = c.filter(function(V) {
        return !ra(e, V);
      }), g = 0, m = n;
      if (r) {
        var b = 0;
        d.forEach(function(V) {
          return b += V.getActualWidth();
        }), m -= b;
      }
      if (m > 0) {
        for (var S = 0; S < f.length; S++) {
          var R = f[S];
          if (m -= R.getActualWidth(), m < 0)
            break;
          g++;
        }
        r && g++;
      }
      var P;
      if (g > 0) {
        var D = f[g - 1];
        P = v.indexOf(D) + 1;
      } else
        P = v.indexOf(f[0]), P === -1 && (P = 0);
      var x = [P], M = function(V, W) {
        return V - W;
      };
      if (r) {
        for (var F = P + 1, H = c.length - 1; F <= H; )
          x.push(F), F++;
        x.sort(M);
      } else {
        for (var F = P, H = c.length - 1, B = c[F]; F <= H && u.indexOf(B) < 0; )
          F++, x.push(F), B = c[F];
        F = P - 1;
        for (var j = 0; F >= j; )
          x.push(F), F--;
        x.sort(M).reverse();
      }
      return x;
    }, o.normaliseX = function(t, e, r, n, i) {
      var a = i.getHeaderRowContainerCtrl(e).getViewport();
      if (r && (t -= a.getBoundingClientRect().left), n.get("enableRtl")) {
        var s = a.clientWidth;
        t = s - t;
      }
      return e == null && (t += i.getCenterRowContainerCtrl().getCenterViewportScrollLeft()), t;
    }, o;
  }()
), Mf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, KI = (
  /** @class */
  function() {
    function o(t, e) {
      this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.pinned = t, this.eContainer = e, this.centerContainer = !Oe(t);
    }
    return o.prototype.init = function() {
      var t = this;
      this.ctrlsService.whenReady(function() {
        t.gridBodyCon = t.ctrlsService.getGridBodyCtrl();
      });
    }, o.prototype.getIconName = function() {
      return this.pinned ? fn.ICON_PINNED : fn.ICON_MOVE;
    }, o.prototype.onDragEnter = function(t) {
      var e = t.dragItem.columns, r = t.dragSource.type === ho.ToolPanel;
      if (r)
        this.setColumnsVisible(e, !0, "uiColumnDragged");
      else {
        var n = t.dragItem.visibleState, i = (e || []).filter(function(a) {
          return n[a.getId()];
        });
        this.setColumnsVisible(i, !0, "uiColumnDragged");
      }
      this.setColumnsPinned(e, this.pinned, "uiColumnDragged"), this.onDragging(t, !0, !0);
    }, o.prototype.onDragLeave = function() {
      this.ensureIntervalCleared(), this.lastMovedInfo = null;
    }, o.prototype.setColumnsVisible = function(t, e, r) {
      if (r === void 0 && (r = "api"), t) {
        var n = t.filter(function(i) {
          return !i.getColDef().lockVisible;
        });
        this.columnModel.setColumnsVisible(n, e, r);
      }
    }, o.prototype.setColumnsPinned = function(t, e, r) {
      if (r === void 0 && (r = "api"), t) {
        var n = t.filter(function(i) {
          return !i.getColDef().lockPinned;
        });
        this.columnModel.setColumnsPinned(n, e, r);
      }
    }, o.prototype.onDragStop = function() {
      this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
    }, o.prototype.checkCenterForScrolling = function(t) {
      if (this.centerContainer) {
        var e = this.ctrlsService.getCenterRowContainerCtrl().getCenterViewportScrollLeft(), r = e + this.ctrlsService.getCenterRowContainerCtrl().getCenterWidth();
        this.gridOptionsService.get("enableRtl") ? (this.needToMoveRight = t < e + 50, this.needToMoveLeft = t > r - 50) : (this.needToMoveLeft = t < e + 50, this.needToMoveRight = t > r - 50), this.needToMoveLeft || this.needToMoveRight ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
      }
    }, o.prototype.onDragging = function(t, e, r, n) {
      var i = this, a;
      if (t === void 0 && (t = this.lastDraggingEvent), e === void 0 && (e = !1), r === void 0 && (r = !1), n === void 0 && (n = !1), n) {
        if (this.lastMovedInfo) {
          var s = this.lastMovedInfo, l = s.columns, u = s.toIndex;
          lc.moveColumns(l, u, "uiColumnMoved", !0, this.columnModel);
        }
        return;
      }
      if (this.lastDraggingEvent = t, !tt(t.hDirection)) {
        var c = lc.normaliseX(t.x, this.pinned, !1, this.gridOptionsService, this.ctrlsService);
        e || this.checkCenterForScrolling(c);
        var d = this.normaliseDirection(t.hDirection), f = t.dragSource.type, v = ((a = t.dragSource.getDragItem().columns) === null || a === void 0 ? void 0 : a.filter(function(m) {
          return m.getColDef().lockPinned ? m.getPinned() == i.pinned : !0;
        })) || [], g = lc.attemptMoveColumns({
          allMovingColumns: v,
          isFromHeader: f === ho.HeaderCell,
          hDirection: d,
          xPosition: c,
          pinned: this.pinned,
          fromEnter: e,
          fakeEvent: r,
          gridOptionsService: this.gridOptionsService,
          columnModel: this.columnModel
        });
        g && (this.lastMovedInfo = g);
      }
    }, o.prototype.normaliseDirection = function(t) {
      if (this.gridOptionsService.get("enableRtl"))
        switch (t) {
          case Qn.Left:
            return Qn.Right;
          case Qn.Right:
            return Qn.Left;
          default:
            console.error("AG Grid: Unknown direction ".concat(t));
        }
      else
        return t;
    }, o.prototype.ensureIntervalStarted = function() {
      this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100), this.needToMoveLeft ? this.dragAndDropService.setGhostIcon(fn.ICON_LEFT, !0) : this.dragAndDropService.setGhostIcon(fn.ICON_RIGHT, !0));
    }, o.prototype.ensureIntervalCleared = function() {
      this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.dragAndDropService.setGhostIcon(fn.ICON_MOVE));
    }, o.prototype.moveInterval = function() {
      var t;
      this.intervalCount++, t = 10 + this.intervalCount * 5, t > 100 && (t = 100);
      var e = null, r = this.gridBodyCon.getScrollFeature();
      if (this.needToMoveLeft ? e = r.scrollHorizontally(-t) : this.needToMoveRight && (e = r.scrollHorizontally(t)), e !== 0)
        this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
      else {
        this.failedMoveAttempts++;
        var n = this.lastDraggingEvent.dragItem.columns, i = n.filter(function(s) {
          return !s.getColDef().lockPinned;
        });
        if (i.length > 0 && (this.dragAndDropService.setGhostIcon(fn.ICON_PINNED), this.failedMoveAttempts > 7)) {
          var a = this.needToMoveLeft ? "left" : "right";
          this.setColumnsPinned(i, a, "uiColumnDragged"), this.dragAndDropService.nudge();
        }
      }
    }, Mf([
      N("columnModel")
    ], o.prototype, "columnModel", void 0), Mf([
      N("dragAndDropService")
    ], o.prototype, "dragAndDropService", void 0), Mf([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), Mf([
      N("ctrlsService")
    ], o.prototype, "ctrlsService", void 0), Mf([
      Fe
    ], o.prototype, "init", null), o;
  }()
), Mq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ff = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, qI = (
  /** @class */
  function(o) {
    Mq(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.pinned = e, n.eContainer = r, n;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        switch (e.pinned) {
          case "left":
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.leftRowContainerCtrl.getContainerElement()],
              [r.bottomLeftRowContainerCtrl.getContainerElement()],
              [r.topLeftRowContainerCtrl.getContainerElement()]
            ];
            break;
          case "right":
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.rightRowContainerCtrl.getContainerElement()],
              [r.bottomRightRowContainerCtrl.getContainerElement()],
              [r.topRightRowContainerCtrl.getContainerElement()]
            ];
            break;
          default:
            e.eSecondaryContainers = [
              [r.gridBodyCtrl.getBodyViewportElement(), r.centerRowContainerCtrl.getViewportElement()],
              [r.bottomCenterRowContainerCtrl.getViewportElement()],
              [r.topCenterRowContainerCtrl.getViewportElement()]
            ];
            break;
        }
      });
    }, t.prototype.isInterestedIn = function(e) {
      return e === ho.HeaderCell || e === ho.ToolPanel && this.gridOptionsService.get("allowDragFromColumnsToolPanel");
    }, t.prototype.getSecondaryContainers = function() {
      return this.eSecondaryContainers;
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, t.prototype.init = function() {
      this.moveColumnFeature = this.createManagedBean(new KI(this.pinned, this.eContainer)), this.bodyDropPivotTarget = this.createManagedBean(new YI(this.pinned)), this.dragAndDropService.addDropTarget(this);
    }, t.prototype.getIconName = function() {
      return this.currentDropListener.getIconName();
    }, t.prototype.isDropColumnInPivotMode = function(e) {
      return this.columnModel.isPivotMode() && e.dragSource.type === ho.ToolPanel;
    }, t.prototype.onDragEnter = function(e) {
      this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
    }, t.prototype.onDragLeave = function(e) {
      this.currentDropListener.onDragLeave(e);
    }, t.prototype.onDragging = function(e) {
      this.currentDropListener.onDragging(e);
    }, t.prototype.onDragStop = function(e) {
      this.currentDropListener.onDragStop(e);
    }, Ff([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), Ff([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ff([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ff([
      Fe
    ], t.prototype, "postConstruct", null), Ff([
      Fe
    ], t.prototype, "init", null), t;
  }(Me)
), Fq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ng = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Iq = (
  /** @class */
  function(o) {
    Fq(t, o);
    function t(e) {
      var r = o.call(this, t.TEMPLATE, e) || this;
      return r.headerCompVersion = 0, r.column = e.getColumnGroupChild(), r.pinned = e.getPinned(), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), n = function(s, l) {
        l != null && l != "" ? r.setAttribute(s, l) : r.removeAttribute(s);
      };
      n("col-id", this.column.getColId());
      var i = {
        setWidth: function(s) {
          return r.style.width = s;
        },
        addOrRemoveCssClass: function(s, l) {
          return e.addOrRemoveCssClass(s, l);
        },
        setAriaDescription: function(s) {
          return x2(r, s);
        },
        setAriaSort: function(s) {
          return s ? F2(r, s) : I2(r);
        },
        setUserCompDetails: function(s) {
          return e.setUserCompDetails(s);
        },
        getUserCompInstance: function() {
          return e.headerComp;
        }
      };
      this.ctrl.setComp(i, this.getGui(), this.eResize, this.eHeaderCompWrapper);
      var a = this.ctrl.getSelectAllGui();
      this.eResize.insertAdjacentElement("afterend", a);
    }, t.prototype.destroyHeaderComp = function() {
      this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
    }, t.prototype.setUserCompDetails = function(e) {
      var r = this;
      this.headerCompVersion++;
      var n = this.headerCompVersion;
      e.newAgStackInstance().then(function(i) {
        return r.afterCompCreated(n, i);
      });
    }, t.prototype.afterCompCreated = function(e, r) {
      if (e != this.headerCompVersion || !this.isAlive()) {
        this.destroyBean(r);
        return;
      }
      this.destroyHeaderComp(), this.headerComp = r, this.headerCompGui = r.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
    }, t.TEMPLATE = `<div class="ag-header-cell" role="columnheader" tabindex="-1">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`, Ng([
      ke("eResize")
    ], t.prototype, "eResize", void 0), Ng([
      ke("eHeaderCompWrapper")
    ], t.prototype, "eHeaderCompWrapper", void 0), Ng([
      Fe
    ], t.prototype, "postConstruct", null), Ng([
      eo
    ], t.prototype, "destroyHeaderComp", null), t;
  }(d_)
), Lq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), qO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Nq = (
  /** @class */
  function(o) {
    Lq(t, o);
    function t(e) {
      return o.call(this, t.TEMPLATE, e) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), n = function(a, s) {
        return s != null ? r.setAttribute(a, s) : r.removeAttribute(a);
      };
      r.setAttribute("col-id", this.ctrl.getColId());
      var i = {
        addOrRemoveCssClass: function(a, s) {
          return e.addOrRemoveCssClass(a, s);
        },
        setResizableDisplayed: function(a) {
          return Vt(e.eResize, a);
        },
        setWidth: function(a) {
          return r.style.width = a;
        },
        setAriaExpanded: function(a) {
          return n("aria-expanded", a);
        },
        setUserCompDetails: function(a) {
          return e.setUserCompDetails(a);
        },
        getUserCompInstance: function() {
          return e.headerGroupComp;
        }
      };
      this.ctrl.setComp(i, r, this.eResize);
    }, t.prototype.setUserCompDetails = function(e) {
      var r = this;
      e.newAgStackInstance().then(function(n) {
        return r.afterHeaderCompCreated(n);
      });
    }, t.prototype.afterHeaderCompCreated = function(e) {
      var r = this, n = function() {
        return r.destroyBean(e);
      };
      if (!this.isAlive()) {
        n();
        return;
      }
      var i = this.getGui(), a = e.getGui();
      i.appendChild(a), this.addDestroyFunc(n), this.headerGroupComp = e, this.ctrl.setDragSource(i);
    }, t.TEMPLATE = `<div class="ag-header-group-cell" role="columnheader" tabindex="-1">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`, qO([
      ke("eResize")
    ], t.prototype, "eResize", void 0), qO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(d_)
), kq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), XO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, On;
(function(o) {
  o.COLUMN_GROUP = "group", o.COLUMN = "column", o.FLOATING_FILTER = "filter";
})(On || (On = {}));
var XI = (
  /** @class */
  function(o) {
    kq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.headerComps = {}, r.ctrl = e, r.setTemplate(
        /* html */
        '<div class="'.concat(r.ctrl.getHeaderRowClass(), '" role="row"></div>')
      ), r;
    }
    return t.prototype.init = function() {
      var e = this;
      this.getGui().style.transform = this.ctrl.getTransform(), F1(this.getGui(), this.ctrl.getAriaRowIndex());
      var r = {
        setHeight: function(n) {
          return e.getGui().style.height = n;
        },
        setTop: function(n) {
          return e.getGui().style.top = n;
        },
        setHeaderCtrls: function(n, i) {
          return e.setHeaderCtrls(n, i);
        },
        setWidth: function(n) {
          return e.getGui().style.width = n;
        }
      };
      this.ctrl.setComp(r);
    }, t.prototype.destroyHeaderCtrls = function() {
      this.setHeaderCtrls([], !1);
    }, t.prototype.setHeaderCtrls = function(e, r) {
      var n = this;
      if (this.isAlive()) {
        var i = this.headerComps;
        if (this.headerComps = {}, e.forEach(function(l) {
          var u = l.getInstanceId(), c = i[u];
          delete i[u], c == null && (c = n.createHeaderComp(l), n.getGui().appendChild(c.getGui())), n.headerComps[u] = c;
        }), Xn(i, function(l, u) {
          n.getGui().removeChild(u.getGui()), n.destroyBean(u);
        }), r) {
          var a = Vl(this.headerComps);
          a.sort(function(l, u) {
            var c = l.getCtrl().getColumnGroupChild().getLeft(), d = u.getCtrl().getColumnGroupChild().getLeft();
            return c - d;
          });
          var s = a.map(function(l) {
            return l.getGui();
          });
          K1(this.getGui(), s);
        }
      }
    }, t.prototype.createHeaderComp = function(e) {
      var r;
      switch (this.ctrl.getType()) {
        case On.COLUMN_GROUP:
          r = new Nq(e);
          break;
        case On.FLOATING_FILTER:
          r = new LI(e);
          break;
        default:
          r = new Iq(e);
          break;
      }
      return this.createBean(r), r.setParentComponent(this), r;
    }, XO([
      Fe
    ], t.prototype, "init", null), XO([
      eo
    ], t.prototype, "destroyHeaderCtrls", null), t;
  }(gt)
), Gq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), If = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Vq = 0, vv = (
  /** @class */
  function(o) {
    Gq(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.resizeToggleTimeout = 0, n.resizeMultiplier = 1, n.resizeFeature = null, n.lastFocusEvent = null, n.dragSource = null, n.columnGroupChild = e, n.parentRowCtrl = r, n.instanceId = e.getUniqueId() + "-" + Vq++, n;
    }
    return t.prototype.shouldStopEventPropagation = function(e) {
      var r = this.focusService.getFocusedHeader(), n = r.headerRowIndex, i = r.column;
      return X2(this.gridOptionsService, e, n, i);
    }, t.prototype.getWrapperHasFocus = function() {
      var e = this.gridOptionsService.getDocument(), r = e.activeElement;
      return r === this.eGui;
    }, t.prototype.setGui = function(e) {
      this.eGui = e, this.addDomData(), this.addManagedListener(this.beans.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.onDisplayedColumnsChanged();
    }, t.prototype.onDisplayedColumnsChanged = function() {
      !this.comp || !this.column || (this.refreshFirstAndLastStyles(), this.refreshAriaColIndex());
    }, t.prototype.refreshFirstAndLastStyles = function() {
      var e = this, r = e.comp, n = e.column, i = e.beans;
      hv.refreshFirstAndLastStyles(r, n, i.columnModel);
    }, t.prototype.refreshAriaColIndex = function() {
      var e = this, r = e.beans, n = e.column, i = r.columnModel.getAriaColumnIndex(n);
      I1(this.eGui, i);
    }, t.prototype.addResizeAndMoveKeyboardListeners = function() {
      this.resizeFeature && (this.addManagedListener(this.eGui, "keydown", this.onGuiKeyDown.bind(this)), this.addManagedListener(this.eGui, "keyup", this.onGuiKeyUp.bind(this)));
    }, t.prototype.onGuiKeyDown = function(e) {
      var r, n = this.gridOptionsService.getDocument(), i = n.activeElement, a = e.key === we.LEFT || e.key === we.RIGHT;
      if (this.isResizing && (e.preventDefault(), e.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
      !(i !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
      !e.shiftKey && !e.altKey) && ((this.isResizing || a) && (e.preventDefault(), e.stopImmediatePropagation()), !!a)) {
        var s = e.key === we.LEFT !== this.gridOptionsService.get("enableRtl"), l = Qn[s ? "Left" : "Right"];
        e.altKey ? (this.isResizing = !0, this.resizeMultiplier += 1, this.resizeHeader(l, e.shiftKey), (r = this.resizeFeature) === null || r === void 0 || r.toggleColumnResizing(!0)) : this.moveHeader(l);
      }
    }, t.prototype.onGuiKeyUp = function() {
      var e = this;
      this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = setTimeout(function() {
        var r;
        (r = e.resizeFeature) === null || r === void 0 || r.toggleColumnResizing(!1);
      }, 150));
    }, t.prototype.handleKeyDown = function(e) {
      var r = this.getWrapperHasFocus();
      switch (e.key) {
        case we.PAGE_DOWN:
        case we.PAGE_UP:
        case we.PAGE_HOME:
        case we.PAGE_END:
          r && e.preventDefault();
      }
    }, t.prototype.addDomData = function() {
      var e = this, r = t.DOM_DATA_KEY_HEADER_CTRL;
      this.gridOptionsService.setDomData(this.eGui, r, this), this.addDestroyFunc(function() {
        return e.gridOptionsService.setDomData(e.eGui, r, null);
      });
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.focus = function(e) {
      return this.eGui ? (this.lastFocusEvent = e || null, this.eGui.focus(), !0) : !1;
    }, t.prototype.getRowIndex = function() {
      return this.parentRowCtrl.getRowIndex();
    }, t.prototype.getParentRowCtrl = function() {
      return this.parentRowCtrl;
    }, t.prototype.getPinned = function() {
      return this.parentRowCtrl.getPinned();
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.getColumnGroupChild = function() {
      return this.columnGroupChild;
    }, t.prototype.removeDragSource = function() {
      this.dragSource && (this.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null);
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.removeDragSource(), this.comp = null, this.column = null, this.resizeFeature = null, this.lastFocusEvent = null, this.columnGroupChild = null, this.parentRowCtrl = null, this.eGui = null;
    }, t.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl", If([
      N("focusService")
    ], t.prototype, "focusService", void 0), If([
      N("beans")
    ], t.prototype, "beans", void 0), If([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), If([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), If([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), t;
  }(Me)
), Hq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Bq = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, cC = (
  /** @class */
  function(o) {
    Hq(t, o);
    function t(e, r, n, i) {
      var a = o.call(this) || this;
      return a.columnOrGroup = e, a.eCell = r, a.ariaEl = a.eCell.querySelector("[role=columnheader]") || a.eCell, a.colsSpanning = i, a.beans = n, a;
    }
    return t.prototype.setColsSpanning = function(e) {
      this.colsSpanning = e, this.onLeftChanged();
    }, t.prototype.getColumnOrGroup = function() {
      return this.beans.gridOptionsService.get("enableRtl") && this.colsSpanning ? Kt(this.colsSpanning) : this.columnOrGroup;
    }, t.prototype.postConstruct = function() {
      this.addManagedListener(this.columnOrGroup, cr.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this)), this.setLeftFirstTime(), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
    }, t.prototype.setLeftFirstTime = function() {
      var e = this.beans.gridOptionsService.get("suppressColumnMoveAnimation"), r = Oe(this.columnOrGroup.getOldLeft()), n = this.beans.columnAnimationService.isActive() && r && !e;
      n ? this.animateInLeft() : this.onLeftChanged();
    }, t.prototype.animateInLeft = function() {
      var e = this, r = this.getColumnOrGroup(), n = r.getLeft(), i = r.getOldLeft(), a = this.modifyLeftForPrintLayout(r, i), s = this.modifyLeftForPrintLayout(r, n);
      this.setLeft(a), this.actualLeft = s, this.beans.columnAnimationService.executeNextVMTurn(function() {
        e.actualLeft === s && e.setLeft(s);
      });
    }, t.prototype.onLeftChanged = function() {
      var e = this.getColumnOrGroup(), r = e.getLeft();
      this.actualLeft = this.modifyLeftForPrintLayout(e, r), this.setLeft(this.actualLeft);
    }, t.prototype.modifyLeftForPrintLayout = function(e, r) {
      var n = this.beans.gridOptionsService.isDomLayout("print");
      if (!n || e.getPinned() === "left")
        return r;
      var i = this.beans.columnModel.getDisplayedColumnsLeftWidth();
      if (e.getPinned() === "right") {
        var a = this.beans.columnModel.getBodyContainerWidth();
        return i + a + r;
      }
      return i + r;
    }, t.prototype.setLeft = function(e) {
      if (Oe(e) && (this.eCell.style.left = "".concat(e, "px")), this.columnOrGroup instanceof cr)
        this.columnOrGroup;
      else {
        var r = this.columnOrGroup, n = r.getLeafColumns();
        if (!n.length)
          return;
        n.length > 1 && M2(this.ariaEl, n.length), n[0];
      }
    }, Bq([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), Wq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ZO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, g_ = (
  /** @class */
  function(o) {
    Wq(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.columns = e, n.element = r, n;
    }
    return t.prototype.postConstruct = function() {
      this.gridOptionsService.get("columnHoverHighlight") && this.addMouseHoverListeners();
    }, t.prototype.addMouseHoverListeners = function() {
      this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this)), this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
    }, t.prototype.onMouseOut = function() {
      this.columnHoverService.clearMouseOver();
    }, t.prototype.onMouseOver = function() {
      this.columnHoverService.setMouseOver(this.columns);
    }, ZO([
      N("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), ZO([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), jq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Jw = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ZI = (
  /** @class */
  function(o) {
    jq(t, o);
    function t(e, r) {
      var n = o.call(this, e, r) || this;
      return n.iconCreated = !1, n.column = e, n;
    }
    return t.prototype.setComp = function(e, r, n, i) {
      this.comp = e, this.eButtonShowMainFilter = n, this.eFloatingFilterBody = i, this.setGui(r), this.setupActive(), this.setupWidth(), this.setupLeft(), this.setupHover(), this.setupFocus(), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(), this.setupUi(), this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this)), this.setupFilterChangedListener(), this.addManagedListener(this.column, cr.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
    }, t.prototype.resizeHeader = function() {
    }, t.prototype.moveHeader = function() {
    }, t.prototype.setupActive = function() {
      var e = this.column.getColDef(), r = !!e.filter, n = !!e.floatingFilter;
      this.active = r && n;
    }, t.prototype.setupUi = function() {
      if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !(!this.active || this.iconCreated)) {
        var e = sn("filter", this.gridOptionsService, this.column);
        e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
      }
    }, t.prototype.setupFocus = function() {
      this.createManagedBean(new $l(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      }));
    }, t.prototype.setupAria = function() {
      var e = this.localeService.getLocaleTextFunc();
      Os(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.gridOptionsService.getDocument(), n = r.activeElement, i = n === this.eGui;
      if (!i) {
        var a = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
        if (a) {
          this.beans.headerNavigationService.scrollToColumn(this.column), e.preventDefault(), a.focus();
          return;
        }
        var s = this.findNextColumnWithFloatingFilter(e.shiftKey);
        s && this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: this.getParentRowCtrl().getRowIndex(),
            column: s
          },
          event: e
        }) && e.preventDefault();
      }
    }, t.prototype.findNextColumnWithFloatingFilter = function(e) {
      var r = this.beans.columnModel, n = this.column;
      do
        if (n = e ? r.getDisplayedColBefore(n) : r.getDisplayedColAfter(n), !n)
          break;
      while (!n.getColDef().filter || !n.getColDef().floatingFilter);
      return n;
    }, t.prototype.handleKeyDown = function(e) {
      o.prototype.handleKeyDown.call(this, e);
      var r = this.getWrapperHasFocus();
      switch (e.key) {
        case we.UP:
        case we.DOWN:
          r || e.preventDefault();
        case we.LEFT:
        case we.RIGHT:
          if (r)
            return;
          e.stopPropagation();
        case we.ENTER:
          r && this.focusService.focusInto(this.eGui) && e.preventDefault();
          break;
        case we.ESCAPE:
          r || this.eGui.focus();
      }
    }, t.prototype.onFocusIn = function(e) {
      var r = this.eGui.contains(e.relatedTarget);
      if (!r) {
        var n = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), i = !!e.relatedTarget && ac(e.relatedTarget, "ag-floating-filter");
        if (n && i && e.target === this.eGui) {
          var a = this.lastFocusEvent, s = !!(a && a.key === we.TAB);
          if (a && s) {
            var l = a.shiftKey;
            this.focusService.focusInto(this.eGui, l);
          }
        }
        var u = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(u, this.column);
      }
    }, t.prototype.setupHover = function() {
      var e = this;
      this.createManagedBean(new g_([this.column], this.eGui));
      var r = function() {
        if (e.gridOptionsService.get("columnHoverHighlight")) {
          var n = e.columnHoverService.isHovered(e.column);
          e.comp.addOrRemoveCssClass("ag-column-hover", n);
        }
      };
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_HOVER_CHANGED, r), r();
    }, t.prototype.setupLeft = function() {
      var e = new cC(this.column, this.eGui, this.beans);
      this.createManagedBean(e);
    }, t.prototype.setupFilterButton = function() {
      var e = this.column.getColDef();
      this.suppressFilterButton = e.floatingFilterComponentParams ? !!e.floatingFilterComponentParams.suppressFilterButton : !1;
    }, t.prototype.setupUserComp = function() {
      var e = this;
      if (this.active) {
        var r = this.filterManager.getFloatingFilterCompDetails(this.column, function() {
          return e.showParentFilter();
        });
        r && this.setCompDetails(r);
      }
    }, t.prototype.setCompDetails = function(e) {
      this.userCompDetails = e, this.comp.setCompDetails(e);
    }, t.prototype.showParentFilter = function() {
      var e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
      this.menuFactory.showMenuAfterButtonClick(this.column, e, "floatingFilter", "filterMenuTab", ["filterMenuTab"]);
    }, t.prototype.setupSyncWithFilter = function() {
      var e = this;
      if (this.active) {
        var r = function(n) {
          var i = e.comp.getFloatingFilterComp();
          i && i.then(function(a) {
            if (a) {
              var s = e.filterManager.getCurrentFloatingFilterParentModel(e.column);
              a.onParentModelChanged(s, n);
            }
          });
        };
        this.destroySyncListener = this.addManagedListener(this.column, cr.EVENT_FILTER_CHANGED, r), this.filterManager.isFilterActive(this.column) && r(null);
      }
    }, t.prototype.setupWidth = function() {
      var e = this, r = function() {
        var n = "".concat(e.column.getActualWidth(), "px");
        e.comp.setWidth(n);
      };
      this.addManagedListener(this.column, cr.EVENT_WIDTH_CHANGED, r), r();
    }, t.prototype.setupFilterChangedListener = function() {
      this.active && (this.destroyFilterChangedListener = this.addManagedListener(this.column, cr.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this)));
    }, t.prototype.updateFilterButton = function() {
      !this.suppressFilterButton && this.comp && this.comp.setButtonWrapperDisplayed(this.filterManager.isFilterAllowed(this.column));
    }, t.prototype.onColDefChanged = function() {
      var e = this, r, n, i = this.active;
      this.setupActive();
      var a = !i && this.active;
      i && !this.active && ((r = this.destroySyncListener) === null || r === void 0 || r.call(this), (n = this.destroyFilterChangedListener) === null || n === void 0 || n.call(this));
      var s = this.active ? this.filterManager.getFloatingFilterCompDetails(this.column, function() {
        return e.showParentFilter();
      }) : null, l = this.comp.getFloatingFilterComp();
      !l || !s ? this.updateCompDetails(s, a) : l.then(function(u) {
        var c;
        !u || e.filterManager.areFilterCompsDifferent((c = e.userCompDetails) !== null && c !== void 0 ? c : null, s) ? e.updateCompDetails(s, a) : e.updateFloatingFilterParams(s);
      });
    }, t.prototype.updateCompDetails = function(e, r) {
      this.isAlive() && (this.setCompDetails(e), this.setupFilterButton(), this.setupUi(), r && (this.setupSyncWithFilter(), this.setupFilterChangedListener()));
    }, t.prototype.updateFloatingFilterParams = function(e) {
      var r;
      if (e) {
        var n = e.params;
        (r = this.comp.getFloatingFilterComp()) === null || r === void 0 || r.then(function(i) {
          var a = !1;
          if (i != null && i.refresh && typeof i.refresh == "function") {
            var s = i.refresh(n);
            s !== null && (a = !0);
          }
          !a && (i != null && i.onParamsUpdated) && typeof i.onParamsUpdated == "function" && i.onParamsUpdated(n);
        });
      }
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.destroySyncListener = null, this.destroyFilterChangedListener = null;
    }, Jw([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Jw([
      N("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), Jw([
      N("menuFactory")
    ], t.prototype, "menuFactory", void 0), t;
  }(vv)
), Uq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Lf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, $q = (
  /** @class */
  function(o) {
    Uq(t, o);
    function t(e, r, n, i, a) {
      var s = o.call(this) || this;
      return s.pinned = e, s.column = r, s.eResize = n, s.comp = i, s.ctrl = a, s;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = [], n, i, a = function() {
        if (Vt(e.eResize, n), !!n) {
          var u = e.horizontalResizeService.addResizeBar({
            eResizeBar: e.eResize,
            onResizeStart: e.onResizeStart.bind(e),
            onResizing: e.onResizing.bind(e, !1),
            onResizeEnd: e.onResizing.bind(e, !0)
          });
          if (r.push(u), i) {
            var c = e.gridOptionsService.get("skipHeaderOnAutoSize"), d = function() {
              e.columnModel.autoSizeColumn(e.column, c, "uiColumnResized");
            };
            e.eResize.addEventListener("dblclick", d);
            var f = new Go(e.eResize);
            f.addEventListener(Go.EVENT_DOUBLE_TAP, d), r.push(function() {
              e.eResize.removeEventListener("dblclick", d), f.removeEventListener(Go.EVENT_DOUBLE_TAP, d), f.destroy();
            });
          }
        }
      }, s = function() {
        r.forEach(function(u) {
          return u();
        }), r.length = 0;
      }, l = function() {
        var u = e.column.isResizable(), c = !e.gridOptionsService.get("suppressAutoSize") && !e.column.getColDef().suppressAutoSize, d = u !== n || c !== i;
        d && (n = u, i = c, s(), a());
      };
      l(), this.addDestroyFunc(s), this.ctrl.addRefreshFunction(l);
    }, t.prototype.onResizing = function(e, r) {
      var n = this, i = n.column, a = n.lastResizeAmount, s = n.resizeStartWidth, l = this.normaliseResizeAmount(r), u = s + l, c = [{ key: i, newWidth: u }];
      if (this.column.getPinned()) {
        var d = this.pinnedWidthService.getPinnedLeftWidth(), f = this.pinnedWidthService.getPinnedRightWidth(), v = Ec(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
        if (d + f + (l - a) > v)
          return;
      }
      this.lastResizeAmount = l, this.columnModel.setColumnWidths(c, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
    }, t.prototype.onResizeStart = function(e) {
      this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
    }, t.prototype.toggleColumnResizing = function(e) {
      this.comp.addOrRemoveCssClass("ag-column-resizing", e);
    }, t.prototype.normaliseResizeAmount = function(e) {
      var r = e, n = this.pinned !== "left", i = this.pinned === "right";
      return this.gridOptionsService.get("enableRtl") ? n && (r *= -1) : i && (r *= -1), r;
    }, Lf([
      N("horizontalResizeService")
    ], t.prototype, "horizontalResizeService", void 0), Lf([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Lf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Lf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Lf([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), zq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), QO = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Yq = (
  /** @class */
  function(o) {
    zq(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.cbSelectAllVisible = !1, r.processingEventFromCheckbox = !1, r.column = e, r;
    }
    return t.prototype.onSpaceKeyDown = function(e) {
      var r = this.cbSelectAll, n = this.gridOptionsService.getDocument();
      r.isDisplayed() && !r.getGui().contains(n.activeElement) && (e.preventDefault(), r.setValue(!r.getValue()));
    }, t.prototype.getCheckboxGui = function() {
      return this.cbSelectAll.getGui();
    }, t.prototype.setComp = function(e) {
      this.headerCellCtrl = e, this.cbSelectAll = this.createManagedBean(new fv()), this.cbSelectAll.addCssClass("ag-header-select-all"), bn(this.cbSelectAll.getGui(), "presentation"), this.showOrHideSelectAll(), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this)), this.addManagedListener(this.cbSelectAll, G.EVENT_FIELD_VALUE_CHANGED, this.onCbSelectAll.bind(this)), Qy(this.cbSelectAll.getGui(), !0), this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
    }, t.prototype.onNewColumnsLoaded = function() {
      this.showOrHideSelectAll();
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.isAlive() && this.showOrHideSelectAll();
    }, t.prototype.showOrHideSelectAll = function() {
      this.cbSelectAllVisible = this.isCheckboxSelection(), this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, { skipAriaHidden: !0 }), this.cbSelectAllVisible && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel();
    }, t.prototype.onModelChanged = function() {
      this.cbSelectAllVisible && this.updateStateOfCheckbox();
    }, t.prototype.onSelectionChanged = function() {
      this.cbSelectAllVisible && this.updateStateOfCheckbox();
    }, t.prototype.updateStateOfCheckbox = function() {
      if (!this.processingEventFromCheckbox) {
        this.processingEventFromCheckbox = !0;
        var e = this.selectionService.getSelectAllState(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setValue(e);
        var r = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setDisabled(!r), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
      }
    }, t.prototype.refreshSelectAllLabel = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.cbSelectAll.getValue(), n = r ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), i = e("ariaRowSelectAll", "Press Space to toggle all rows selection");
      this.cbSelectAllVisible ? this.headerCellCtrl.setAriaDescriptionProperty("selectAll", "".concat(i, " (").concat(n, ")")) : this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null), this.cbSelectAll.setInputAriaLabel("".concat(i, " (").concat(n, ")")), this.headerCellCtrl.refreshAriaDescription();
    }, t.prototype.checkSelectionType = function(e) {
      var r = this.gridOptionsService.get("rowSelection") === "multiple";
      return r ? !0 : (console.warn("AG Grid: ".concat(e, " is only available if using 'multiple' rowSelection.")), !1);
    }, t.prototype.checkRightRowModelType = function(e) {
      var r = this.rowModel.getType(), n = r === "clientSide" || r === "serverSide";
      return n ? !0 : (console.warn("AG Grid: ".concat(e, " is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ").concat(r, ".")), !1);
    }, t.prototype.onCbSelectAll = function() {
      if (!this.processingEventFromCheckbox && this.cbSelectAllVisible) {
        var e = this.cbSelectAll.getValue(), r = this.isFilteredOnly(), n = this.isCurrentPageOnly(), i = "uiSelectAll";
        n ? i = "uiSelectAllCurrentPage" : r && (i = "uiSelectAllFiltered");
        var a = {
          source: i,
          justFiltered: r,
          justCurrentPage: n
        };
        e ? this.selectionService.selectAllRowNodes(a) : this.selectionService.deselectAllRowNodes(a);
      }
    }, t.prototype.isCheckboxSelection = function() {
      var e = this.column.getColDef().headerCheckboxSelection;
      if (typeof e == "function") {
        var r = e, n = this.gridOptionsService.addGridCommonParams({
          column: this.column,
          colDef: this.column.getColDef()
        });
        e = r(n);
      }
      return e ? this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection") : !1;
    }, t.prototype.isFilteredOnly = function() {
      return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
    }, t.prototype.isCurrentPageOnly = function() {
      return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
    }, QO([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), QO([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), t;
  }(Me)
), Kq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Nu = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, QI = (
  /** @class */
  function(o) {
    Kq(t, o);
    function t(e, r) {
      var n = o.call(this, e, r) || this;
      return n.refreshFunctions = [], n.userHeaderClasses = /* @__PURE__ */ new Set(), n.ariaDescriptionProperties = /* @__PURE__ */ new Map(), n.column = e, n;
    }
    return t.prototype.setComp = function(e, r, n, i) {
      var a = this;
      this.comp = e, this.setGui(r), this.updateState(), this.setupWidth(), this.setupMovingCss(), this.setupMenuClass(), this.setupSortableClass(), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight(i), this.addColumnHoverListener(), this.setupFilterClass(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(), this.setupSelectAll(), this.setupUserComp(), this.refreshAria(), this.resizeFeature = this.createManagedBean(new $q(this.getPinned(), this.column, n, e, this)), this.createManagedBean(new g_([this.column], r)), this.createManagedBean(new cC(this.column, r, this.beans)), this.createManagedBean(new $l(r, {
        shouldStopEventPropagation: function(s) {
          return a.shouldStopEventPropagation(s);
        },
        onTabKeyDown: function() {
          return null;
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })), this.addResizeAndMoveKeyboardListeners(), this.addManagedPropertyListeners(["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader"], this.refresh.bind(this)), this.addManagedListener(this.column, cr.EVENT_COL_DEF_CHANGED, this.refresh.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }, t.prototype.resizeHeader = function(e, r) {
      var n, i;
      if (this.column.isResizable()) {
        var a = this.column.getPinned(), s = this.gridOptionsService.get("enableRtl"), l = this.column.getActualWidth(), u = (n = this.column.getMinWidth()) !== null && n !== void 0 ? n : 0, c = (i = this.column.getMaxWidth()) !== null && i !== void 0 ? i : Number.MAX_SAFE_INTEGER, d = e === Qn.Left;
        a && s !== (a === "right") && (d = !d);
        var f = (d ? -1 : 1) * this.resizeMultiplier, v = Math.min(Math.max(l + f, u), c);
        if (a) {
          var g = this.pinnedWidthService.getPinnedLeftWidth(), m = this.pinnedWidthService.getPinnedRightWidth(), b = Ec(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
          if (g + m + f > b)
            return;
        }
        this.columnModel.setColumnWidths([{ key: this.column, newWidth: v }], r, !0);
      }
    }, t.prototype.moveHeader = function(e) {
      var r = this, n = r.eGui, i = r.column, a = r.columnModel, s = r.gridOptionsService, l = r.ctrlsService, u = this.getPinned(), c = n.getBoundingClientRect().left, d = i.getActualWidth(), f = s.get("enableRtl"), v = e === Qn.Left !== f, g = lc.normaliseX(v ? c - 20 : c + d + 20, u, !0, s, l);
      lc.attemptMoveColumns({
        allMovingColumns: [i],
        isFromHeader: !0,
        hDirection: e,
        xPosition: g,
        pinned: u,
        fromEnter: !1,
        fakeEvent: !1,
        gridOptionsService: s,
        columnModel: a
      }), l.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(i, "auto");
    }, t.prototype.setupUserComp = function() {
      var e = this.lookupUserCompDetails();
      this.setCompDetails(e);
    }, t.prototype.setCompDetails = function(e) {
      this.userCompDetails = e, this.comp.setUserCompDetails(e);
    }, t.prototype.lookupUserCompDetails = function() {
      var e = this.createParams(), r = this.column.getColDef();
      return this.userComponentFactory.getHeaderCompDetails(r, e);
    }, t.prototype.createParams = function() {
      var e = this, r = this.gridOptionsService.addGridCommonParams({
        column: this.column,
        displayName: this.displayName,
        enableSorting: this.column.isSortable(),
        enableMenu: this.menuEnabled,
        showColumnMenu: function(n) {
          e.gridApi.showColumnMenuAfterButtonClick(e.column, n);
        },
        progressSort: function(n) {
          e.sortController.progressSort(e.column, !!n, "uiColumnSorted");
        },
        setSort: function(n, i) {
          e.sortController.setSortForColumn(e.column, n, !!i, "uiColumnSorted");
        },
        eGridHeader: this.getGui()
      });
      return r;
    }, t.prototype.setupSelectAll = function() {
      this.selectAllFeature = this.createManagedBean(new Yq(this.column)), this.selectAllFeature.setComp(this);
    }, t.prototype.getSelectAllGui = function() {
      return this.selectAllFeature.getCheckboxGui();
    }, t.prototype.handleKeyDown = function(e) {
      o.prototype.handleKeyDown.call(this, e), e.key === we.SPACE && this.selectAllFeature.onSpaceKeyDown(e), e.key === we.ENTER && this.onEnterKeyDown(e);
    }, t.prototype.onEnterKeyDown = function(e) {
      var r = this.comp.getUserCompInstance();
      if (r) {
        if (e.ctrlKey || e.metaKey)
          this.menuEnabled && r.showMenu && (e.preventDefault(), r.showMenu());
        else if (this.sortable) {
          var n = e.shiftKey;
          this.sortController.progressSort(this.column, n, "uiColumnSorted");
        }
      }
    }, t.prototype.isMenuEnabled = function() {
      return this.menuEnabled;
    }, t.prototype.onFocusIn = function(e) {
      if (!this.getGui().contains(e.relatedTarget)) {
        var r = this.getRowIndex();
        this.focusService.setFocusedHeader(r, this.column);
      }
      this.setActiveHeader(!0);
    }, t.prototype.onFocusOut = function(e) {
      this.getGui().contains(e.relatedTarget) || this.setActiveHeader(!1);
    }, t.prototype.setupTooltip = function() {
      var e = this, r = {
        getColumn: function() {
          return e.column;
        },
        getColDef: function() {
          return e.column.getColDef();
        },
        getGui: function() {
          return e.eGui;
        },
        getLocation: function() {
          return "header";
        },
        getTooltipValue: function() {
          var i = e.column.getColDef().headerTooltip;
          return i;
        }
      }, n = this.createManagedBean(new uC(r, this.beans));
      n.setComp(this.eGui), this.refreshFunctions.push(function() {
        return n.refreshToolTip();
      });
    }, t.prototype.setupClassesFromColDef = function() {
      var e = this, r = function() {
        var n = e.column.getColDef(), i = hv.getHeaderClassesFromColDef(n, e.gridOptionsService, e.column, null), a = e.userHeaderClasses;
        e.userHeaderClasses = new Set(i), i.forEach(function(s) {
          a.has(s) ? a.delete(s) : e.comp.addOrRemoveCssClass(s, !0);
        }), a.forEach(function(s) {
          return e.comp.addOrRemoveCssClass(s, !1);
        });
      };
      this.refreshFunctions.push(r), r();
    }, t.prototype.setDragSource = function(e) {
      var r = this;
      if (this.dragSourceElement = e, this.removeDragSource(), !(!e || !this.draggable)) {
        var n = this, i = n.column, a = n.columnModel, s = n.displayName, l = n.dragAndDropService, u = n.gridOptionsService, c = !this.gridOptionsService.get("suppressDragLeaveHidesColumns"), d = this.dragSource = {
          type: ho.HeaderCell,
          eElement: e,
          getDefaultIconName: function() {
            return c ? fn.ICON_HIDE : fn.ICON_NOT_ALLOWED;
          },
          getDragItem: function() {
            return r.createDragItem(i);
          },
          dragItemName: s,
          onDragStarted: function() {
            c = !u.get("suppressDragLeaveHidesColumns"), i.setMoving(!0, "uiColumnMoved");
          },
          onDragStopped: function() {
            return i.setMoving(!1, "uiColumnMoved");
          },
          onGridEnter: function(f) {
            var v;
            if (c) {
              var g = ((v = f == null ? void 0 : f.columns) === null || v === void 0 ? void 0 : v.filter(function(m) {
                return !m.getColDef().lockVisible;
              })) || [];
              a.setColumnsVisible(g, !0, "uiColumnMoved");
            }
          },
          onGridExit: function(f) {
            var v;
            if (c) {
              var g = ((v = f == null ? void 0 : f.columns) === null || v === void 0 ? void 0 : v.filter(function(m) {
                return !m.getColDef().lockVisible;
              })) || [];
              a.setColumnsVisible(g, !1, "uiColumnMoved");
            }
          }
        };
        l.addDragSource(d, !0);
      }
    }, t.prototype.createDragItem = function(e) {
      var r = {};
      return r[e.getId()] = e.isVisible(), {
        columns: [e],
        visibleState: r
      };
    }, t.prototype.updateState = function() {
      var e = this.column.getColDef();
      this.menuEnabled = this.menuFactory.isMenuEnabled(this.column) && !e.suppressMenu, this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
    }, t.prototype.addRefreshFunction = function(e) {
      this.refreshFunctions.push(e);
    }, t.prototype.refresh = function() {
      this.updateState(), this.refreshHeaderComp(), this.refreshAria(), this.refreshFunctions.forEach(function(e) {
        return e();
      });
    }, t.prototype.refreshHeaderComp = function() {
      var e = this.lookupUserCompDetails(), r = this.comp.getUserCompInstance(), n = r != null && this.userCompDetails.componentClass == e.componentClass, i = n ? this.attemptHeaderCompRefresh(e.params) : !1;
      i ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
    }, t.prototype.attemptHeaderCompRefresh = function(e) {
      var r = this.comp.getUserCompInstance();
      if (!r || !r.refresh)
        return !1;
      var n = r.refresh(e);
      return n;
    }, t.prototype.calculateDisplayName = function() {
      return this.columnModel.getDisplayNameForColumn(this.column, "header", !0);
    }, t.prototype.checkDisplayName = function() {
      this.displayName !== this.calculateDisplayName() && this.refresh();
    }, t.prototype.workOutDraggable = function() {
      var e = this.column.getColDef(), r = this.gridOptionsService.get("suppressMovableColumns"), n = !r && !e.suppressMovable && !e.lockPosition;
      return !!n || !!e.enableRowGroup || !!e.enablePivot;
    }, t.prototype.onColumnRowGroupChanged = function() {
      this.checkDisplayName();
    }, t.prototype.onColumnPivotChanged = function() {
      this.checkDisplayName();
    }, t.prototype.onColumnValueChanged = function() {
      this.checkDisplayName();
    }, t.prototype.setupWidth = function() {
      var e = this, r = function() {
        var n = e.column.getActualWidth();
        e.comp.setWidth("".concat(n, "px"));
      };
      this.addManagedListener(this.column, cr.EVENT_WIDTH_CHANGED, r), r();
    }, t.prototype.setupMovingCss = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-header-cell-moving", e.column.isMoving());
      };
      this.addManagedListener(this.column, cr.EVENT_MOVING_CHANGED, r), r();
    }, t.prototype.setupMenuClass = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-column-menu-visible", e.column.isMenuVisible());
      };
      this.addManagedListener(this.column, cr.EVENT_MENU_VISIBLE_CHANGED, r), r();
    }, t.prototype.setupSortableClass = function() {
      var e = this, r = function() {
        e.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!e.sortable);
      };
      r(), this.addRefreshFunction(r), this.addManagedListener(this.eventService, cr.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
    }, t.prototype.setupFilterClass = function() {
      var e = this, r = function() {
        var n = e.column.isFilterActive();
        e.comp.addOrRemoveCssClass("ag-header-cell-filtered", n), e.refreshAria();
      };
      this.addManagedListener(this.column, cr.EVENT_FILTER_ACTIVE_CHANGED, r), r();
    }, t.prototype.setupWrapTextClass = function() {
      var e = this, r = function() {
        var n = !!e.column.getColDef().wrapHeaderText;
        e.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", n);
      };
      r(), this.addRefreshFunction(r);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      o.prototype.onDisplayedColumnsChanged.call(this), this.isAlive() && this.onHeaderHeightChanged();
    }, t.prototype.onHeaderHeightChanged = function() {
      this.refreshSpanHeaderHeight();
    }, t.prototype.refreshSpanHeaderHeight = function() {
      var e = this, r = e.eGui, n = e.column, i = e.comp, a = e.columnModel;
      if (e.gridOptionsService, !n.isSpanHeaderHeight()) {
        r.style.removeProperty("top"), r.style.removeProperty("height"), i.addOrRemoveCssClass("ag-header-span-height", !1), i.addOrRemoveCssClass("ag-header-span-total", !1);
        return;
      }
      var s = this.getColumnGroupPaddingInfo(), l = s.numberOfParents, u = s.isSpanningTotal;
      i.addOrRemoveCssClass("ag-header-span-height", l > 0);
      var c = a.getColumnHeaderRowHeight();
      if (l === 0) {
        i.addOrRemoveCssClass("ag-header-span-total", !1), r.style.setProperty("top", "0px"), r.style.setProperty("height", "".concat(c, "px"));
        return;
      }
      i.addOrRemoveCssClass("ag-header-span-total", u);
      var d = a.isPivotMode(), f = d ? a.getPivotGroupHeaderHeight() : a.getGroupHeaderHeight(), v = l * f;
      r.style.setProperty("top", "".concat(-v, "px")), r.style.setProperty("height", "".concat(c + v, "px"));
    }, t.prototype.getColumnGroupPaddingInfo = function() {
      var e = this.column.getParent();
      if (!e || !e.isPadding())
        return { numberOfParents: 0, isSpanningTotal: !1 };
      for (var r = e.getPaddingLevel() + 1, n = !0; e; ) {
        if (!e.isPadding()) {
          n = !1;
          break;
        }
        e = e.getParent();
      }
      return { numberOfParents: r, isSpanningTotal: n };
    }, t.prototype.setupAutoHeight = function(e) {
      var r = this, n = function(c) {
        if (r.isAlive()) {
          var d = Ul(r.getGui()), f = d.paddingTop, v = d.paddingBottom, g = d.borderBottomWidth, m = d.borderTopWidth, b = f + v + g + m, S = e.offsetHeight, R = S + b;
          if (c < 5) {
            var P = r.beans.gridOptionsService.getDocument(), D = !P || !P.contains(e), x = R == 0;
            if (D || x) {
              window.setTimeout(function() {
                return n(c + 1);
              }, 0);
              return;
            }
          }
          r.columnModel.setColumnHeaderHeight(r.column, R);
        }
      }, i = !1, a, s = function() {
        var c = r.column.isAutoHeaderHeight();
        c && !i && l(), !c && i && u();
      }, l = function() {
        i = !0, n(0), r.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !0), a = r.resizeObserverService.observeResize(e, function() {
          return n(0);
        });
      }, u = function() {
        i = !1, a && a(), r.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !1), a = void 0;
      };
      s(), this.addDestroyFunc(function() {
        return u();
      }), this.addManagedListener(this.column, cr.EVENT_WIDTH_CHANGED, function() {
        return i && n(0);
      }), this.addManagedListener(this.eventService, cr.EVENT_SORT_CHANGED, function() {
        i && window.setTimeout(function() {
          return n(0);
        });
      }), this.addRefreshFunction(s);
    }, t.prototype.refreshAriaSort = function() {
      if (this.sortable) {
        var e = this.localeService.getLocaleTextFunc(), r = this.sortController.getDisplaySortForColumn(this.column) || null;
        this.comp.setAriaSort(b2(r)), this.setAriaDescriptionProperty("sort", e("ariaSortableColumn", "Press ENTER to sort"));
      } else
        this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
    }, t.prototype.refreshAriaMenu = function() {
      if (this.menuEnabled) {
        var e = this.localeService.getLocaleTextFunc();
        this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press CTRL ENTER to open column menu"));
      } else
        this.setAriaDescriptionProperty("menu", null);
    }, t.prototype.refreshAriaFiltered = function() {
      var e = this.localeService.getLocaleTextFunc(), r = this.column.isFilterActive();
      r ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
    }, t.prototype.setAriaDescriptionProperty = function(e, r) {
      r != null ? this.ariaDescriptionProperties.set(e, r) : this.ariaDescriptionProperties.delete(e);
    }, t.prototype.refreshAriaDescription = function() {
      var e = this, r = Array.from(this.ariaDescriptionProperties.keys()).sort(function(n, i) {
        return n === "filter" ? -1 : i.charCodeAt(0) - n.charCodeAt(0);
      }).map(function(n) {
        return e.ariaDescriptionProperties.get(n);
      }).join(". ");
      this.comp.setAriaDescription(r ?? void 0);
    }, t.prototype.refreshAria = function() {
      this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFiltered(), this.refreshAriaDescription();
    }, t.prototype.addColumnHoverListener = function() {
      var e = this, r = function() {
        if (e.gridOptionsService.get("columnHoverHighlight")) {
          var n = e.columnHoverService.isHovered(e.column);
          e.comp.addOrRemoveCssClass("ag-column-hover", n);
        }
      };
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_HOVER_CHANGED, r), r();
    }, t.prototype.getColId = function() {
      return this.column.getColId();
    }, t.prototype.addActiveHeaderMouseListeners = function() {
      var e = this, r = function(a) {
        return e.handleMouseOverChange(a.type === "mouseenter");
      }, n = function(a) {
        return e.handleColumnClick(a, !1);
      }, i = function(a) {
        return e.handleColumnClick(a, !0);
      };
      this.addManagedListener(this.getGui(), "mouseenter", r), this.addManagedListener(this.getGui(), "mouseleave", r), this.addManagedListener(this.getGui(), "click", n), this.addManagedListener(this.getGui(), "contextmenu", i);
    }, t.prototype.handleMouseOverChange = function(e) {
      this.setActiveHeader(e);
      var r = e ? G.EVENT_COLUMN_HEADER_MOUSE_OVER : G.EVENT_COLUMN_HEADER_MOUSE_LEAVE, n = {
        type: r,
        column: this.column
      };
      this.eventService.dispatchEvent(n);
    }, t.prototype.handleColumnClick = function(e, r) {
      var n = r ? G.EVENT_COLUMN_HEADER_CONTEXT_MENU : G.EVENT_COLUMN_HEADER_CLICKED;
      r && this.gridOptionsService.get("preventDefaultOnContextMenu") && e.preventDefault();
      var i = {
        type: n,
        column: this.column
      };
      this.eventService.dispatchEvent(i);
    }, t.prototype.setActiveHeader = function(e) {
      this.comp.addOrRemoveCssClass("ag-header-active", e);
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.refreshFunctions = null, this.selectAllFeature = null, this.dragSourceElement = null, this.userCompDetails = null, this.userHeaderClasses = null, this.ariaDescriptionProperties = null;
    }, Nu([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Nu([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Nu([
      N("columnHoverService")
    ], t.prototype, "columnHoverService", void 0), Nu([
      N("sortController")
    ], t.prototype, "sortController", void 0), Nu([
      N("menuFactory")
    ], t.prototype, "menuFactory", void 0), Nu([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Nu([
      N("gridApi")
    ], t.prototype, "gridApi", void 0), t;
  }(vv)
), qq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Xq = (
  /** @class */
  function(o) {
    qq(t, o);
    function t(e, r, n, i) {
      var a = o.call(this) || this;
      return a.eResize = r, a.comp = e, a.pinned = n, a.columnGroup = i, a;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      if (!this.columnGroup.isResizable()) {
        this.comp.setResizableDisplayed(!1);
        return;
      }
      var r = this.horizontalResizeService.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      if (this.addDestroyFunc(r), !this.gridOptionsService.get("suppressAutoSize")) {
        var n = this.gridOptionsService.get("skipHeaderOnAutoSize");
        this.eResize.addEventListener("dblclick", function() {
          var i = [], a = e.columnGroup.getDisplayedLeafColumns();
          a.forEach(function(s) {
            s.getColDef().suppressAutoSize || i.push(s.getColId());
          }), i.length > 0 && e.columnModel.autoSizeColumns({
            columns: i,
            skipHeader: n,
            stopAtGroup: e.columnGroup,
            source: "uiColumnResized"
          }), e.resizeLeafColumnsToFit("uiColumnResized");
        });
      }
    }, t.prototype.onResizeStart = function(e) {
      var r = this.getInitialValues(e);
      this.storeLocalValues(r), this.toggleColumnResizing(!0);
    }, t.prototype.onResizing = function(e, r, n) {
      n === void 0 && (n = "uiColumnResized");
      var i = this.normaliseDragChange(r), a = this.resizeStartWidth + i;
      this.resizeColumnsFromLocalValues(a, n, e);
    }, t.prototype.getInitialValues = function(e) {
      var r = this.getColumnsToResize(), n = this.getInitialSizeOfColumns(r), i = this.getSizeRatiosOfColumns(r, n), a = {
        columnsToResize: r,
        resizeStartWidth: n,
        resizeRatios: i
      }, s = null;
      if (e && (s = this.columnModel.getDisplayedGroupAfter(this.columnGroup)), s) {
        var l = s.getDisplayedLeafColumns(), u = a.groupAfterColumns = l.filter(function(d) {
          return d.isResizable();
        }), c = a.groupAfterStartWidth = this.getInitialSizeOfColumns(u);
        a.groupAfterRatios = this.getSizeRatiosOfColumns(u, c);
      } else
        a.groupAfterColumns = void 0, a.groupAfterStartWidth = void 0, a.groupAfterRatios = void 0;
      return a;
    }, t.prototype.storeLocalValues = function(e) {
      var r = e.columnsToResize, n = e.resizeStartWidth, i = e.resizeRatios, a = e.groupAfterColumns, s = e.groupAfterStartWidth, l = e.groupAfterRatios;
      this.resizeCols = r, this.resizeStartWidth = n, this.resizeRatios = i, this.resizeTakeFromCols = a, this.resizeTakeFromStartWidth = s, this.resizeTakeFromRatios = l;
    }, t.prototype.clearLocalValues = function() {
      this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
    }, t.prototype.resizeLeafColumnsToFit = function(e) {
      var r = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup), n = this.getInitialValues();
      r > n.resizeStartWidth && this.resizeColumns(n, r, e, !0);
    }, t.prototype.resizeColumnsFromLocalValues = function(e, r, n) {
      var i, a, s;
      if (n === void 0 && (n = !0), !(!this.resizeCols || !this.resizeRatios)) {
        var l = {
          columnsToResize: this.resizeCols,
          resizeStartWidth: this.resizeStartWidth,
          resizeRatios: this.resizeRatios,
          groupAfterColumns: (i = this.resizeTakeFromCols) !== null && i !== void 0 ? i : void 0,
          groupAfterStartWidth: (a = this.resizeTakeFromStartWidth) !== null && a !== void 0 ? a : void 0,
          groupAfterRatios: (s = this.resizeTakeFromRatios) !== null && s !== void 0 ? s : void 0
        };
        this.resizeColumns(l, e, r, n);
      }
    }, t.prototype.resizeColumns = function(e, r, n, i) {
      i === void 0 && (i = !0);
      var a = e.columnsToResize, s = e.resizeStartWidth, l = e.resizeRatios, u = e.groupAfterColumns, c = e.groupAfterStartWidth, d = e.groupAfterRatios, f = [];
      if (f.push({
        columns: a,
        ratios: l,
        width: r
      }), u) {
        var v = r - s;
        f.push({
          columns: u,
          ratios: d,
          width: c - v
        });
      }
      this.columnModel.resizeColumnSets({
        resizeSets: f,
        finished: i,
        source: n
      }), i && this.toggleColumnResizing(!1);
    }, t.prototype.toggleColumnResizing = function(e) {
      this.comp.addOrRemoveCssClass("ag-column-resizing", e);
    }, t.prototype.getColumnsToResize = function() {
      var e = this.columnGroup.getDisplayedLeafColumns();
      return e.filter(function(r) {
        return r.isResizable();
      });
    }, t.prototype.getInitialSizeOfColumns = function(e) {
      return e.reduce(function(r, n) {
        return r + n.getActualWidth();
      }, 0);
    }, t.prototype.getSizeRatiosOfColumns = function(e, r) {
      return e.map(function(n) {
        return n.getActualWidth() / r;
      });
    }, t.prototype.normaliseDragChange = function(e) {
      var r = e;
      return this.gridOptionsService.get("enableRtl") ? this.pinned !== "left" && (r *= -1) : this.pinned === "right" && (r *= -1), r;
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.clearLocalValues();
    }, kg([
      N("horizontalResizeService")
    ], t.prototype, "horizontalResizeService", void 0), kg([
      N("autoWidthCalculator")
    ], t.prototype, "autoWidthCalculator", void 0), kg([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), kg([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), Zq = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Qq = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Jq = (
  /** @class */
  function(o) {
    Zq(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.removeChildListenersFuncs = [], n.columnGroup = r, n.comp = e, n;
    }
    return t.prototype.postConstruct = function() {
      this.addListenersToChildrenColumns(), this.addManagedListener(this.columnGroup, pn.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this)), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }, t.prototype.addListenersToChildrenColumns = function() {
      var e = this;
      this.removeListenersOnChildrenColumns();
      var r = this.onWidthChanged.bind(this);
      this.columnGroup.getLeafColumns().forEach(function(n) {
        n.addEventListener("widthChanged", r), n.addEventListener("visibleChanged", r), e.removeChildListenersFuncs.push(function() {
          n.removeEventListener("widthChanged", r), n.removeEventListener("visibleChanged", r);
        });
      });
    }, t.prototype.removeListenersOnChildrenColumns = function() {
      this.removeChildListenersFuncs.forEach(function(e) {
        return e();
      }), this.removeChildListenersFuncs = [];
    }, t.prototype.onDisplayedChildrenChanged = function() {
      this.addListenersToChildrenColumns(), this.onWidthChanged();
    }, t.prototype.onWidthChanged = function() {
      var e = this.columnGroup.getActualWidth();
      this.comp.setWidth("".concat(e, "px")), this.comp.addOrRemoveCssClass("ag-hidden", e === 0);
    }, Qq([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), eX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), sy = function() {
  return sy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, sy.apply(this, arguments);
}, tX = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, JI = (
  /** @class */
  function(o) {
    eX(t, o);
    function t(e, r) {
      var n = o.call(this, e, r) || this;
      return n.onSuppressColMoveChange = function() {
        if (!n.isAlive() || n.isSuppressMoving())
          n.removeDragSource();
        else if (!n.dragSource) {
          var i = n.getGui();
          n.setDragSource(i);
        }
      }, n.column = e, n;
    }
    return t.prototype.setComp = function(e, r, n) {
      this.comp = e, this.setGui(r), this.displayName = this.columnModel.getDisplayNameForColumnGroup(this.column, "header"), this.addClasses(), this.setupMovingCss(), this.setupExpandable(), this.setupTooltip(), this.setupUserComp(), this.addHeaderMouseListeners();
      var i = this.getParentRowCtrl().getPinned(), a = this.column.getProvidedColumnGroup().getLeafColumns();
      this.createManagedBean(new g_(a, r)), this.createManagedBean(new cC(this.column, r, this.beans)), this.createManagedBean(new Jq(e, this.column)), this.resizeFeature = this.createManagedBean(new Xq(e, n, i, this.column)), this.createManagedBean(new $l(r, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: function() {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })), this.addManagedPropertyListener(G.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners();
    }, t.prototype.resizeHeader = function(e, r) {
      if (this.resizeFeature) {
        var n = e === Qn.Left, i = (n ? -1 : 1) * this.resizeMultiplier, a = this.resizeFeature.getInitialValues(r);
        this.resizeFeature.resizeColumns(a, a.resizeStartWidth + i, "uiColumnResized", !0);
      }
    }, t.prototype.moveHeader = function(e) {
      var r = this, n = r.eGui, i = r.column, a = r.columnModel, s = r.gridOptionsService, l = r.ctrlsService, u = s.get("enableRtl"), c = e === Qn.Left, d = this.getPinned(), f = n.getBoundingClientRect(), v = f.left, g = f.width, m = lc.normaliseX(c !== u ? v - 20 : v + g + 20, d, !0, s, l), b = i.getGroupId(), S = this.focusService.getFocusedHeader();
      lc.attemptMoveColumns({
        allMovingColumns: this.column.getLeafColumns(),
        isFromHeader: !0,
        hDirection: e,
        xPosition: m,
        pinned: d,
        fromEnter: !1,
        fakeEvent: !1,
        gridOptionsService: s,
        columnModel: a
      });
      var R = i.getDisplayedLeafColumns(), P = c ? R[0] : Kt(R);
      this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(P, "auto"), !this.isAlive() && S && this.restoreFocus(b, i, S);
    }, t.prototype.restoreFocus = function(e, r, n) {
      var i = r.getLeafColumns();
      if (i.length) {
        var a = i[0].getParent();
        if (a) {
          var s = this.findGroupWidthId(a, e);
          s && this.focusService.focusHeaderPosition({
            headerPosition: sy(sy({}, n), { column: s })
          });
        }
      }
    }, t.prototype.findGroupWidthId = function(e, r) {
      for (; e; ) {
        if (e.getGroupId() === r)
          return e;
        e = e.getParent();
      }
      return null;
    }, t.prototype.resizeLeafColumnsToFit = function(e) {
      this.resizeFeature && this.resizeFeature.resizeLeafColumnsToFit(e);
    }, t.prototype.setupUserComp = function() {
      var e = this, r = this.gridOptionsService.addGridCommonParams({
        displayName: this.displayName,
        columnGroup: this.column,
        setExpanded: function(i) {
          e.columnModel.setColumnGroupOpened(e.column.getProvidedColumnGroup(), i, "gridInitializing");
        }
      }), n = this.userComponentFactory.getHeaderGroupCompDetails(r);
      this.comp.setUserCompDetails(n);
    }, t.prototype.addHeaderMouseListeners = function() {
      var e = this, r = function(a) {
        return e.handleMouseOverChange(a.type === "mouseenter");
      }, n = function(a) {
        return e.handleColumnClick(a, !1);
      }, i = function(a) {
        return e.handleColumnClick(a, !0);
      };
      this.addManagedListener(this.getGui(), "mouseenter", r), this.addManagedListener(this.getGui(), "mouseleave", r), this.addManagedListener(this.getGui(), "click", n), this.addManagedListener(this.getGui(), "contextmenu", i);
    }, t.prototype.handleMouseOverChange = function(e) {
      var r = e ? G.EVENT_COLUMN_HEADER_MOUSE_OVER : G.EVENT_COLUMN_HEADER_MOUSE_LEAVE, n = {
        type: r,
        column: this.column.getProvidedColumnGroup()
      };
      this.eventService.dispatchEvent(n);
    }, t.prototype.handleColumnClick = function(e, r) {
      var n = r ? G.EVENT_COLUMN_HEADER_CONTEXT_MENU : G.EVENT_COLUMN_HEADER_CLICKED;
      r && this.gridOptionsService.get("preventDefaultOnContextMenu") && e.preventDefault();
      var i = {
        type: n,
        column: this.column.getProvidedColumnGroup()
      };
      this.eventService.dispatchEvent(i);
    }, t.prototype.setupTooltip = function() {
      var e = this, r = this.column.getColGroupDef(), n = {
        getColumn: function() {
          return e.column;
        },
        getGui: function() {
          return e.eGui;
        },
        getLocation: function() {
          return "headerGroup";
        },
        getTooltipValue: function() {
          return r && r.headerTooltip;
        }
      };
      r && (n.getColDef = function() {
        return r;
      });
      var i = this.createManagedBean(new uC(n, this.beans));
      i.setComp(this.eGui);
    }, t.prototype.setupExpandable = function() {
      var e = this.column.getProvidedColumnGroup();
      this.refreshExpanded(), this.addManagedListener(e, Ur.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this)), this.addManagedListener(e, Ur.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
    }, t.prototype.refreshExpanded = function() {
      var e = this.column;
      this.expandable = e.isExpandable();
      var r = e.isExpanded();
      this.expandable ? this.comp.setAriaExpanded(r ? "true" : "false") : this.comp.setAriaExpanded(void 0);
    }, t.prototype.getColId = function() {
      return this.column.getUniqueId();
    }, t.prototype.addClasses = function() {
      var e = this, r = this.column.getColGroupDef(), n = hv.getHeaderClassesFromColDef(r, this.gridOptionsService, null, this.column);
      if (this.column.isPadding()) {
        n.push("ag-header-group-cell-no-group");
        var i = this.column.getLeafColumns();
        i.every(function(a) {
          return a.isSpanHeaderHeight();
        }) && n.push("ag-header-span-height");
      } else
        n.push("ag-header-group-cell-with-group");
      n.forEach(function(a) {
        return e.comp.addOrRemoveCssClass(a, !0);
      });
    }, t.prototype.setupMovingCss = function() {
      var e = this, r = this.column.getProvidedColumnGroup(), n = r.getLeafColumns(), i = function() {
        return e.comp.addOrRemoveCssClass("ag-header-cell-moving", e.column.isMoving());
      };
      n.forEach(function(a) {
        e.addManagedListener(a, cr.EVENT_MOVING_CHANGED, i);
      }), i();
    }, t.prototype.onFocusIn = function(e) {
      if (!this.eGui.contains(e.relatedTarget)) {
        var r = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(r, this.column);
      }
    }, t.prototype.handleKeyDown = function(e) {
      o.prototype.handleKeyDown.call(this, e);
      var r = this.getWrapperHasFocus();
      if (!(!this.expandable || !r) && e.key === we.ENTER) {
        var n = this.column, i = !n.isExpanded();
        this.columnModel.setColumnGroupOpened(n.getProvidedColumnGroup(), i, "uiColumnExpanded");
      }
    }, t.prototype.setDragSource = function(e) {
      var r = this;
      if (!(!this.isAlive() || this.isSuppressMoving()) && (this.removeDragSource(), !!e)) {
        var n = this, i = n.column, a = n.columnModel, s = n.displayName, l = n.gridOptionsService, u = n.dragAndDropService, c = i.getProvidedColumnGroup().getLeafColumns(), d = !l.get("suppressDragLeaveHidesColumns"), f = this.dragSource = {
          type: ho.HeaderCell,
          eElement: e,
          getDefaultIconName: function() {
            return d ? fn.ICON_HIDE : fn.ICON_NOT_ALLOWED;
          },
          dragItemName: s,
          // we add in the original group leaf columns, so we move both visible and non-visible items
          getDragItem: function() {
            return r.getDragItemForGroup(i);
          },
          onDragStarted: function() {
            d = !l.get("suppressDragLeaveHidesColumns"), c.forEach(function(v) {
              return v.setMoving(!0, "uiColumnDragged");
            });
          },
          onDragStopped: function() {
            return c.forEach(function(v) {
              return v.setMoving(!1, "uiColumnDragged");
            });
          },
          onGridEnter: function(v) {
            var g;
            if (d) {
              var m = ((g = v == null ? void 0 : v.columns) === null || g === void 0 ? void 0 : g.filter(function(b) {
                return !b.getColDef().lockVisible;
              })) || [];
              a.setColumnsVisible(m, !0, "uiColumnMoved");
            }
          },
          onGridExit: function(v) {
            var g;
            if (d) {
              var m = ((g = v == null ? void 0 : v.columns) === null || g === void 0 ? void 0 : g.filter(function(b) {
                return !b.getColDef().lockVisible;
              })) || [];
              a.setColumnsVisible(m, !1, "uiColumnMoved");
            }
          }
        };
        u.addDragSource(f, !0);
      }
    }, t.prototype.getDragItemForGroup = function(e) {
      var r = e.getProvidedColumnGroup().getLeafColumns(), n = {};
      r.forEach(function(a) {
        return n[a.getId()] = a.isVisible();
      });
      var i = [];
      return this.columnModel.getAllDisplayedColumns().forEach(function(a) {
        r.indexOf(a) >= 0 && (i.push(a), ti(r, a));
      }), r.forEach(function(a) {
        return i.push(a);
      }), {
        columns: i,
        visibleState: n
      };
    }, t.prototype.isSuppressMoving = function() {
      var e = !1;
      this.column.getLeafColumns().forEach(function(n) {
        (n.getColDef().suppressMovable || n.getColDef().lockPosition) && (e = !0);
      });
      var r = e || this.gridOptionsService.get("suppressMovableColumns");
      return r;
    }, tX([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), t;
  }(vv)
), rX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Gg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, JO = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, nX = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, oX = 0, wm = (
  /** @class */
  function(o) {
    rX(t, o);
    function t(e, r, n) {
      var i = o.call(this) || this;
      i.instanceId = oX++, i.rowIndex = e, i.pinned = r, i.type = n;
      var a = n == On.COLUMN_GROUP ? "ag-header-row-column-group" : n == On.FLOATING_FILTER ? "ag-header-row-column-filter" : "ag-header-row-column";
      return i.headerRowClass = "ag-header-row ".concat(a), i;
    }
    return t.prototype.postConstruct = function() {
      this.isPrintLayout = this.gridOptionsService.isDomLayout("print"), this.isEnsureDomOrder = this.gridOptionsService.get("ensureDomOrder");
    }, t.prototype.getInstanceId = function() {
      return this.instanceId;
    }, t.prototype.setComp = function(e, r) {
      r === void 0 && (r = !0), this.comp = e, r && (this.onRowHeightChanged(), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners();
    }, t.prototype.getHeaderRowClass = function() {
      return this.headerRowClass;
    }, t.prototype.getAriaRowIndex = function() {
      return this.rowIndex + 1;
    }, t.prototype.getTransform = function() {
      if (oa())
        return "translateZ(0)";
    }, t.prototype.addEventListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_VIRTUAL_COLUMNS_CHANGED, function(r) {
        return e.onVirtualColumnsChanged(r.afterScroll);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this)), this.addManagedPropertyListener("ensureDomOrder", function(r) {
        return e.isEnsureDomOrder = r.currentValue;
      }), this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this)), this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
    }, t.prototype.getHeaderCellCtrl = function(e) {
      if (this.headerCellCtrls)
        return ic(this.headerCellCtrls).find(function(r) {
          return r.getColumnGroupChild() === e;
        });
    }, t.prototype.onDisplayedColumnsChanged = function() {
      this.isPrintLayout = this.gridOptionsService.isDomLayout("print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
    }, t.prototype.getType = function() {
      return this.type;
    }, t.prototype.onColumnResized = function() {
      this.setWidth();
    }, t.prototype.setWidth = function() {
      var e = this.getWidthForRow();
      this.comp.setWidth("".concat(e, "px"));
    }, t.prototype.getWidthForRow = function() {
      if (this.isPrintLayout) {
        var e = this.pinned != null;
        return e ? 0 : this.columnModel.getContainerWidth("right") + this.columnModel.getContainerWidth("left") + this.columnModel.getContainerWidth(null);
      }
      return this.columnModel.getContainerWidth(this.pinned);
    }, t.prototype.onRowHeightChanged = function() {
      var e = this.getTopAndHeight(), r = e.topOffset, n = e.rowHeight;
      this.comp.setTop(r + "px"), this.comp.setHeight(n + "px");
    }, t.prototype.getTopAndHeight = function() {
      var e = this.columnModel.getHeaderRowCount(), r = [], n = 0;
      this.filterManager.hasFloatingFilters() && (e++, n = 1);
      for (var i = this.columnModel.getColumnGroupHeaderRowHeight(), a = this.columnModel.getColumnHeaderRowHeight(), s = 1 + n, l = e - s, u = 0; u < l; u++)
        r.push(i);
      r.push(a);
      for (var u = 0; u < n; u++)
        r.push(this.columnModel.getFloatingFiltersHeight());
      for (var c = 0, u = 0; u < this.rowIndex; u++)
        c += r[u];
      var d = r[this.rowIndex];
      return { topOffset: c, rowHeight: d };
    }, t.prototype.getPinned = function() {
      return this.pinned;
    }, t.prototype.getRowIndex = function() {
      return this.rowIndex;
    }, t.prototype.onVirtualColumnsChanged = function(e) {
      e === void 0 && (e = !1);
      var r = this.getHeaderCtrls(), n = this.isEnsureDomOrder || this.isPrintLayout;
      this.comp.setHeaderCtrls(r, n, e);
    }, t.prototype.getHeaderCtrls = function() {
      var e, r, n, i, a = this, s = this.headerCellCtrls;
      this.headerCellCtrls = /* @__PURE__ */ new Map();
      var l = this.getColumnsInViewport();
      try {
        for (var u = JO(l), c = u.next(); !c.done; c = u.next()) {
          var d = c.value;
          this.recycleAndCreateHeaderCtrls(d, s);
        }
      } catch (D) {
        e = { error: D };
      } finally {
        try {
          c && !c.done && (r = u.return) && r.call(u);
        } finally {
          if (e) throw e.error;
        }
      }
      var f = function(D) {
        var x = a.focusService.isHeaderWrapperFocused(D);
        if (!x)
          return !1;
        var M = a.columnModel.isDisplayed(D.getColumnGroupChild());
        return M;
      };
      if (s)
        try {
          for (var v = JO(s), g = v.next(); !g.done; g = v.next()) {
            var m = nX(g.value, 2), b = m[0], S = m[1], R = f(S);
            R ? this.headerCellCtrls.set(b, S) : this.destroyBean(S);
          }
        } catch (D) {
          n = { error: D };
        } finally {
          try {
            g && !g.done && (i = v.return) && i.call(v);
          } finally {
            if (n) throw n.error;
          }
        }
      var P = Array.from(this.headerCellCtrls.values());
      return P;
    }, t.prototype.recycleAndCreateHeaderCtrls = function(e, r) {
      if (this.headerCellCtrls && !e.isEmptyGroup()) {
        var n = e.getUniqueId(), i;
        r && (i = r.get(n), r.delete(n));
        var a = i && i.getColumnGroupChild() != e;
        if (a && (this.destroyBean(i), i = void 0), i == null)
          switch (this.type) {
            case On.FLOATING_FILTER:
              i = this.createBean(new ZI(e, this));
              break;
            case On.COLUMN_GROUP:
              i = this.createBean(new JI(e, this));
              break;
            default:
              i = this.createBean(new QI(e, this));
              break;
          }
        this.headerCellCtrls.set(n, i);
      }
    }, t.prototype.getColumnsInViewport = function() {
      return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }, t.prototype.getColumnsInViewportPrintLayout = function() {
      var e = this;
      if (this.pinned != null)
        return [];
      var r = [], n = this.getActualDepth();
      return ["left", null, "right"].forEach(function(i) {
        var a = e.columnModel.getVirtualHeaderGroupRow(i, n);
        r = r.concat(a);
      }), r;
    }, t.prototype.getActualDepth = function() {
      return this.type == On.FLOATING_FILTER ? this.rowIndex - 1 : this.rowIndex;
    }, t.prototype.getColumnsInViewportNormalLayout = function() {
      return this.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
    }, t.prototype.focusHeader = function(e, r) {
      if (!this.headerCellCtrls)
        return !1;
      var n = Array.from(this.headerCellCtrls.values()), i = n.find(function(a) {
        return a.getColumnGroupChild() == e;
      });
      return i ? i.focus(r) : !1;
    }, t.prototype.destroy = function() {
      var e = this;
      this.headerCellCtrls && this.headerCellCtrls.forEach(function(r) {
        e.destroyBean(r);
      }), this.headerCellCtrls = void 0, o.prototype.destroy.call(this);
    }, Gg([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Gg([
      N("focusService")
    ], t.prototype, "focusService", void 0), Gg([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Gg([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), iX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Md = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, aX = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, sX = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, eL = (
  /** @class */
  function(o) {
    iX(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.hidden = !1, r.includeFloatingFilter = !1, r.groupsRowCtrls = [], r.pinned = e, r;
    }
    return t.prototype.setComp = function(e, r) {
      this.comp = e, this.eViewport = r, this.setupCenterWidth(), this.setupPinnedWidth(), this.setupDragAndDrop(this.eViewport), this.addManagedListener(this.eventService, G.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.ctrlsService.registerHeaderContainer(this, this.pinned), this.columnModel.isReady() && this.refresh();
    }, t.prototype.setupDragAndDrop = function(e) {
      var r = new qI(this.pinned, e);
      this.createManagedBean(r);
    }, t.prototype.refresh = function(e) {
      var r = this;
      e === void 0 && (e = !1);
      var n = new gc(), i = this.focusService.getFocusHeaderToUseAfterRefresh(), a = function() {
        var c = r.columnModel.getHeaderRowCount() - 1;
        r.groupsRowCtrls = r.destroyBeans(r.groupsRowCtrls);
        for (var d = 0; d < c; d++) {
          var f = r.createBean(new wm(n.next(), r.pinned, On.COLUMN_GROUP));
          r.groupsRowCtrls.push(f);
        }
      }, s = function() {
        var c = n.next(), d = !r.hidden && (r.columnsRowCtrl == null || !e || r.columnsRowCtrl.getRowIndex() !== c), f = d || r.hidden;
        f && (r.columnsRowCtrl = r.destroyBean(r.columnsRowCtrl)), d && (r.columnsRowCtrl = r.createBean(new wm(c, r.pinned, On.COLUMN)));
      }, l = function() {
        r.includeFloatingFilter = r.filterManager.hasFloatingFilters() && !r.hidden;
        var c = function() {
          r.filtersRowCtrl = r.destroyBean(r.filtersRowCtrl);
        };
        if (!r.includeFloatingFilter) {
          c();
          return;
        }
        var d = n.next();
        if (r.filtersRowCtrl) {
          var f = r.filtersRowCtrl.getRowIndex() !== d;
          (!e || f) && c();
        }
        r.filtersRowCtrl || (r.filtersRowCtrl = r.createBean(new wm(d, r.pinned, On.FLOATING_FILTER)));
      };
      a(), s(), l();
      var u = this.getAllCtrls();
      this.comp.setCtrls(u), this.restoreFocusOnHeader(i);
    }, t.prototype.restoreFocusOnHeader = function(e) {
      e == null || e.column.getPinned() != this.pinned || this.focusService.focusHeaderPosition({ headerPosition: e });
    }, t.prototype.getAllCtrls = function() {
      var e = sX([], aX(this.groupsRowCtrls), !1);
      return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
    }, t.prototype.onGridColumnsChanged = function() {
      this.refresh(!0);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this.filterManager.hasFloatingFilters() && !this.hidden;
      this.includeFloatingFilter !== e && this.refresh(!0);
    }, t.prototype.setupCenterWidth = function() {
      var e = this;
      this.pinned == null && this.createManagedBean(new h_(function(r) {
        return e.comp.setCenterWidth("".concat(r, "px"));
      }, !0));
    }, t.prototype.setHorizontalScroll = function(e) {
      this.comp.setViewportScrollLeft(e);
    }, t.prototype.setupPinnedWidth = function() {
      var e = this;
      if (this.pinned != null) {
        var r = this.pinned === "left", n = this.pinned === "right";
        this.hidden = !0;
        var i = function() {
          var a = r ? e.pinnedWidthService.getPinnedLeftWidth() : e.pinnedWidthService.getPinnedRightWidth();
          if (a != null) {
            var s = a == 0, l = e.hidden !== s, u = e.gridOptionsService.get("enableRtl"), c = e.gridOptionsService.getScrollbarWidth(), d = e.scrollVisibleService.isVerticalScrollShowing() && (u && r || !u && n), f = d ? a + c : a;
            e.comp.setPinnedContainerWidth("".concat(f, "px")), e.comp.setDisplayed(!s), l && (e.hidden = s, e.refresh());
          }
        };
        this.addManagedListener(this.eventService, G.EVENT_LEFT_PINNED_WIDTH_CHANGED, i), this.addManagedListener(this.eventService, G.EVENT_RIGHT_PINNED_WIDTH_CHANGED, i), this.addManagedListener(this.eventService, G.EVENT_SCROLL_VISIBILITY_CHANGED, i), this.addManagedListener(this.eventService, G.EVENT_SCROLLBAR_WIDTH_CHANGED, i);
      }
    }, t.prototype.getHeaderCtrlForColumn = function(e) {
      if (e instanceof cr)
        return this.columnsRowCtrl ? this.columnsRowCtrl.getHeaderCellCtrl(e) : void 0;
      if (this.groupsRowCtrls.length !== 0)
        for (var r = 0; r < this.groupsRowCtrls.length; r++) {
          var n = this.groupsRowCtrls[r].getHeaderCellCtrl(e);
          if (n)
            return n;
        }
    }, t.prototype.getHtmlElementForColumnHeader = function(e) {
      var r = this.getHeaderCtrlForColumn(e);
      return r ? r.getGui() : null;
    }, t.prototype.getRowType = function(e) {
      var r = this.getAllCtrls(), n = r[e];
      return n ? n.getType() : void 0;
    }, t.prototype.focusHeader = function(e, r, n) {
      var i = this.getAllCtrls(), a = i[e];
      return a ? a.focusHeader(r, n) : !1;
    }, t.prototype.getViewport = function() {
      return this.eViewport;
    }, t.prototype.getRowCount = function() {
      return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }, t.prototype.destroy = function() {
      this.filtersRowCtrl && (this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl)), this.columnsRowCtrl && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), this.groupsRowCtrls && this.groupsRowCtrls.length && (this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls)), o.prototype.destroy.call(this);
    }, Md([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Md([
      N("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Md([
      N("pinnedWidthService")
    ], t.prototype, "pinnedWidthService", void 0), Md([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Md([
      N("focusService")
    ], t.prototype, "focusService", void 0), Md([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(Me)
), lX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), eb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, bm = (
  /** @class */
  function(o) {
    lX(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.headerRowComps = {}, r.rowCompsList = [], r.pinned = e, r;
    }
    return t.prototype.init = function() {
      var e = this;
      this.selectAndSetTemplate();
      var r = {
        setDisplayed: function(i) {
          return e.setDisplayed(i);
        },
        setCtrls: function(i) {
          return e.setCtrls(i);
        },
        // only gets called for center section
        setCenterWidth: function(i) {
          return e.eCenterContainer.style.width = i;
        },
        setViewportScrollLeft: function(i) {
          return e.getGui().scrollLeft = i;
        },
        // only gets called for pinned sections
        setPinnedContainerWidth: function(i) {
          var a = e.getGui();
          a.style.width = i, a.style.maxWidth = i, a.style.minWidth = i;
        }
      }, n = this.createManagedBean(new eL(this.pinned));
      n.setComp(r, this.getGui());
    }, t.prototype.selectAndSetTemplate = function() {
      var e = this.pinned == "left", r = this.pinned == "right", n = e ? t.PINNED_LEFT_TEMPLATE : r ? t.PINNED_RIGHT_TEMPLATE : t.CENTER_TEMPLATE;
      this.setTemplate(n), this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
    }, t.prototype.destroyRowComps = function() {
      this.setCtrls([]);
    }, t.prototype.destroyRowComp = function(e) {
      this.destroyBean(e), this.eRowContainer.removeChild(e.getGui());
    }, t.prototype.setCtrls = function(e) {
      var r = this, n = this.headerRowComps;
      this.headerRowComps = {}, this.rowCompsList = [];
      var i, a = function(s) {
        var l = s.getGui(), u = l.parentElement != r.eRowContainer;
        u && r.eRowContainer.appendChild(l), i && Y1(r.eRowContainer, l, i), i = l;
      };
      e.forEach(function(s) {
        var l = s.getInstanceId(), u = n[l];
        delete n[l];
        var c = u || r.createBean(new XI(s));
        r.headerRowComps[l] = c, r.rowCompsList.push(c), a(c);
      }), Vl(n).forEach(function(s) {
        return r.destroyRowComp(s);
      });
    }, t.PINNED_LEFT_TEMPLATE = '<div class="ag-pinned-left-header" role="rowgroup"></div>', t.PINNED_RIGHT_TEMPLATE = '<div class="ag-pinned-right-header" role="rowgroup"></div>', t.CENTER_TEMPLATE = `<div class="ag-header-viewport" role="presentation">
            <div class="ag-header-container" ref="eCenterContainer" role="rowgroup"></div>
        </div>`, eb([
      ke("eCenterContainer")
    ], t.prototype, "eCenterContainer", void 0), eb([
      Fe
    ], t.prototype, "init", null), eb([
      eo
    ], t.prototype, "destroyRowComps", null), t;
  }(gt)
), uX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Nf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Xi;
(function(o) {
  o[o.UP = 0] = "UP", o[o.DOWN = 1] = "DOWN", o[o.LEFT = 2] = "LEFT", o[o.RIGHT = 3] = "RIGHT";
})(Xi || (Xi = {}));
var tL = (
  /** @class */
  function(o) {
    uX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.gridBodyCon = r.gridBodyCtrl;
      });
    }, t.prototype.getHeaderRowCount = function() {
      var e = this.ctrlsService.getHeaderRowContainerCtrl();
      return e ? e.getRowCount() : 0;
    }, t.prototype.navigateVertically = function(e, r, n) {
      if (r || (r = this.focusService.getFocusedHeader()), !r)
        return !1;
      var i = r.headerRowIndex, a = r.column, s = this.getHeaderRowCount(), l = e === Xi.UP, u = l ? this.headerPositionUtils.getColumnVisibleParent(a, i) : this.headerPositionUtils.getColumnVisibleChild(a, i), c = u.nextRow, d = u.nextFocusColumn, f = !1;
      return c < 0 && (c = 0, d = a, f = !0), c >= s && (c = -1), !f && !d ? !1 : this.focusService.focusHeaderPosition({
        headerPosition: { headerRowIndex: c, column: d },
        allowUserOverride: !0,
        event: n
      });
    }, t.prototype.navigateHorizontally = function(e, r, n) {
      r === void 0 && (r = !1);
      var i = this.focusService.getFocusedHeader(), a = e === Xi.LEFT, s = this.gridOptionsService.get("enableRtl"), l, u;
      return a !== s ? (u = "Before", l = this.headerPositionUtils.findHeader(i, u)) : (u = "After", l = this.headerPositionUtils.findHeader(i, u)), l || !r ? this.focusService.focusHeaderPosition({
        headerPosition: l,
        direction: u,
        fromTab: r,
        allowUserOverride: !0,
        event: n
      }) : this.focusNextHeaderRow(i, u, n);
    }, t.prototype.focusNextHeaderRow = function(e, r, n) {
      var i = e.headerRowIndex, a = null, s;
      return r === "Before" ? i > 0 && (s = i - 1, a = this.headerPositionUtils.findColAtEdgeForHeaderRow(s, "end")) : (s = i + 1, a = this.headerPositionUtils.findColAtEdgeForHeaderRow(s, "start")), this.focusService.focusHeaderPosition({
        headerPosition: a,
        direction: r,
        fromTab: !0,
        allowUserOverride: !0,
        event: n
      });
    }, t.prototype.scrollToColumn = function(e, r) {
      if (r === void 0 && (r = "After"), !e.getPinned()) {
        var n;
        if (e instanceof pn) {
          var i = e.getDisplayedLeafColumns();
          n = r === "Before" ? Kt(i) : i[0];
        } else
          n = e;
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(n);
      }
    }, Nf([
      N("focusService")
    ], t.prototype, "focusService", void 0), Nf([
      N("headerPositionUtils")
    ], t.prototype, "headerPositionUtils", void 0), Nf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Nf([
      Fe
    ], t.prototype, "postConstruct", null), t = Nf([
      Be("headerNavigationService")
    ], t), t;
  }(Me)
), cX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), kf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, rL = (
  /** @class */
  function(o) {
    cX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setComp = function(e, r, n) {
      this.comp = e, this.eGui = r, this.createManagedBean(new $l(n, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.onPivotModeChanged(), this.setupHeaderHeight(), this.ctrlsService.registerGridHeaderCtrl(this);
    }, t.prototype.setupHeaderHeight = function() {
      var e = this.setHeaderHeight.bind(this);
      e(), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("pivotHeaderHeight", e), this.addManagedPropertyListener("groupHeaderHeight", e), this.addManagedPropertyListener("pivotGroupHeaderHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_GRID_STYLES_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, e);
    }, t.prototype.getHeaderHeight = function() {
      return this.headerHeight;
    }, t.prototype.setHeaderHeight = function() {
      var e = this.columnModel, r = 0, n = e.getHeaderRowCount(), i, a = this.filterManager.hasFloatingFilters();
      a && (n++, r = 1);
      var s = this.columnModel.getColumnGroupHeaderRowHeight(), l = this.columnModel.getColumnHeaderRowHeight(), u = 1 + r, c = n - u;
      if (i = r * e.getFloatingFiltersHeight(), i += c * s, i += l, this.headerHeight !== i) {
        this.headerHeight = i;
        var d = "".concat(i + 1, "px");
        this.comp.setHeightAndMinHeight(d), this.eventService.dispatchEvent({
          type: G.EVENT_HEADER_HEIGHT_CHANGED
        });
      }
    }, t.prototype.onPivotModeChanged = function() {
      var e = this.columnModel.isPivotMode();
      this.comp.addOrRemoveCssClass("ag-pivot-on", e), this.comp.addOrRemoveCssClass("ag-pivot-off", !e);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this.columnModel.getAllDisplayedColumns(), r = e.some(function(n) {
        return n.isSpanHeaderHeight();
      });
      this.comp.addOrRemoveCssClass("ag-header-allow-overflow", r);
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.gridOptionsService.get("enableRtl"), n = e.shiftKey !== r ? Xi.LEFT : Xi.RIGHT;
      (this.headerNavigationService.navigateHorizontally(n, !0, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) && e.preventDefault();
    }, t.prototype.handleKeyDown = function(e) {
      var r = null;
      switch (e.key) {
        case we.LEFT:
          r = Xi.LEFT;
        case we.RIGHT:
          Oe(r) || (r = Xi.RIGHT), this.headerNavigationService.navigateHorizontally(r, !1, e);
          break;
        case we.UP:
          r = Xi.UP;
        case we.DOWN:
          Oe(r) || (r = Xi.DOWN), this.headerNavigationService.navigateVertically(r, null, e) && e.preventDefault();
          break;
        default:
          return;
      }
    }, t.prototype.onFocusOut = function(e) {
      var r = this.gridOptionsService.getDocument(), n = e.relatedTarget;
      !n && this.eGui.contains(r.activeElement) || this.eGui.contains(n) || this.focusService.clearFocusedHeader();
    }, kf([
      N("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), kf([
      N("focusService")
    ], t.prototype, "focusService", void 0), kf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), kf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), kf([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t;
  }(Me)
), dX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pX = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, nL = (
  /** @class */
  function(o) {
    dX(t, o);
    function t() {
      return o.call(this, t.TEMPLATE) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = {
        addOrRemoveCssClass: function(a, s) {
          return e.addOrRemoveCssClass(a, s);
        },
        setHeightAndMinHeight: function(a) {
          e.getGui().style.height = a, e.getGui().style.minHeight = a;
        }
      }, n = this.createManagedBean(new rL());
      n.setComp(r, this.getGui(), this.getFocusableElement());
      var i = function(a) {
        e.createManagedBean(a), e.appendChild(a);
      };
      i(new bm("left")), i(new bm(null)), i(new bm("right"));
    }, t.TEMPLATE = '<div class="ag-header" role="presentation"/>', pX([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), fX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, oL = (
  /** @class */
  function(o) {
    fX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.addResizeBar = function(e) {
      var r = this, n = {
        dragStartPixels: e.dragStartPixels || 0,
        eElement: e.eResizeBar,
        onDragStart: this.onDragStart.bind(this, e),
        onDragStop: this.onDragStop.bind(this, e),
        onDragging: this.onDragging.bind(this, e),
        includeTouch: !0,
        stopPropagationForTouch: !0
      };
      this.dragService.addDragSource(n);
      var i = function() {
        return r.dragService.removeDragSource(n);
      };
      return i;
    }, t.prototype.onDragStart = function(e, r) {
      this.dragStartX = r.clientX, this.setResizeIcons();
      var n = r instanceof MouseEvent && r.shiftKey === !0;
      e.onResizeStart(n);
    }, t.prototype.setResizeIcons = function() {
      var e = this.ctrlsService.getGridCtrl();
      e.setResizeCursor(!0), e.disableUserSelect(!0);
    }, t.prototype.onDragStop = function(e, r) {
      e.onResizeEnd(this.resizeAmount), this.resetIcons();
    }, t.prototype.resetIcons = function() {
      var e = this.ctrlsService.getGridCtrl();
      e.setResizeCursor(!1), e.disableUserSelect(!1);
    }, t.prototype.onDragging = function(e, r) {
      this.resizeAmount = r.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
    }, tb([
      N("dragService")
    ], t.prototype, "dragService", void 0), tb([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = tb([
      Be("horizontalResizeService")
    ], t), t;
  }(Me)
), hX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Gf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, iL = (
  /** @class */
  function(o) {
    hX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.hideActiveMenu = function() {
      this.hidePopup && this.hidePopup();
    }, t.prototype.showMenuAfterMouseEvent = function(e, r) {
      var n = this;
      this.showPopup(e, function(i) {
        n.popupService.positionPopupUnderMouseEvent({
          column: e,
          type: "columnMenu",
          mouseEvent: r,
          ePopup: i
        });
      }, "columnMenu", r.target);
    }, t.prototype.showMenuAfterButtonClick = function(e, r, n) {
      var i = this;
      this.showPopup(e, function(a) {
        i.popupService.positionPopupByComponent({
          type: n,
          eventSource: r,
          ePopup: a,
          keepWithinBounds: !0,
          position: "under",
          column: e
        });
      }, n, r);
    }, t.prototype.showPopup = function(e, r, n, i) {
      var a = this, s = this.filterManager.getOrCreateFilterWrapper(e, "COLUMN_MENU");
      if (!s)
        throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
      var l = document.createElement("div");
      bn(l, "presentation"), l.classList.add("ag-menu"), this.tabListener = this.addManagedListener(l, "keydown", function(m) {
        return a.trapFocusWithin(m, l);
      }), s.guiPromise.then(function(m) {
        return l.appendChild(m);
      });
      var u, c = function() {
        var m;
        return (m = s.filterPromise) === null || m === void 0 ? void 0 : m.then(function(b) {
          var S;
          return (S = b == null ? void 0 : b.afterGuiDetached) === null || S === void 0 ? void 0 : S.call(b);
        });
      }, d = i || this.ctrlsService.getGridBodyCtrl().getGui(), f = function(m) {
        e.setMenuVisible(!1, "contextMenu");
        var b = m instanceof KeyboardEvent;
        if (a.tabListener && (a.tabListener = a.tabListener()), b && i && ai(i)) {
          var S = a.focusService.findTabbableParent(i);
          S && S.focus();
        }
        c();
      }, v = this.localeService.getLocaleTextFunc(), g = this.popupService.addPopup({
        modal: !0,
        eChild: l,
        closeOnEsc: !0,
        closedCallback: f,
        positionCallback: function() {
          return r(l);
        },
        anchorToElement: d,
        ariaLabel: v("ariaLabelColumnMenu", "Column Menu")
      });
      g && (this.hidePopup = u = g.hideFunc), s.filterPromise.then(function(m) {
        r(l), m.afterGuiAttached && m.afterGuiAttached({ container: n, hidePopup: u });
      }), e.setMenuVisible(!0, "contextMenu");
    }, t.prototype.trapFocusWithin = function(e, r) {
      e.key !== we.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(r, !1, e.shiftKey) || (e.preventDefault(), this.focusService.focusInto(r, e.shiftKey));
    }, t.prototype.isMenuEnabled = function(e) {
      return e.isFilterAllowed() && e.getMenuTabs(["filterMenuTab"]).includes("filterMenuTab");
    }, Gf([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Gf([
      N("popupService")
    ], t.prototype, "popupService", void 0), Gf([
      N("focusService")
    ], t.prototype, "focusService", void 0), Gf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = Gf([
      Be("menuFactory")
    ], t), t;
  }(Me)
), vX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), eP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, uc;
(function(o) {
  o.TAB_GUARD = "ag-tab-guard", o.TAB_GUARD_TOP = "ag-tab-guard-top", o.TAB_GUARD_BOTTOM = "ag-tab-guard-bottom";
})(uc || (uc = {}));
var aL = (
  /** @class */
  function(o) {
    vX(t, o);
    function t(e) {
      var r = o.call(this) || this;
      r.skipTabGuardFocus = !1;
      var n = e.comp, i = e.eTopGuard, a = e.eBottomGuard, s = e.focusTrapActive, l = e.focusInnerElement, u = e.onFocusIn, c = e.onFocusOut, d = e.shouldStopEventPropagation, f = e.onTabKeyDown, v = e.handleKeyDown, g = e.eFocusableElement;
      return r.comp = n, r.eTopGuard = i, r.eBottomGuard = a, r.providedFocusInnerElement = l, r.eFocusableElement = g, r.focusTrapActive = !!s, r.providedFocusIn = u, r.providedFocusOut = c, r.providedShouldStopEventPropagation = d, r.providedOnTabKeyDown = f, r.providedHandleKeyDown = v, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.createManagedBean(new $l(this.eFocusableElement, {
        shouldStopEventPropagation: function() {
          return e.shouldStopEventPropagation();
        },
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        },
        onFocusIn: function(r) {
          return e.onFocusIn(r);
        },
        onFocusOut: function(r) {
          return e.onFocusOut(r);
        }
      })), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(function(r) {
        return e.addManagedListener(r, "focus", e.onFocus.bind(e));
      });
    }, t.prototype.handleKeyDown = function(e) {
      this.providedHandleKeyDown && this.providedHandleKeyDown(e);
    }, t.prototype.tabGuardsAreActive = function() {
      return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }, t.prototype.shouldStopEventPropagation = function() {
      return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
    }, t.prototype.activateTabGuards = function() {
      var e = this.gridOptionsService.get("tabIndex");
      this.comp.setTabIndex(e.toString());
    }, t.prototype.deactivateTabGuards = function() {
      this.comp.setTabIndex();
    }, t.prototype.onFocus = function(e) {
      if (this.skipTabGuardFocus) {
        this.skipTabGuardFocus = !1;
        return;
      }
      var r = e.target === this.eBottomGuard;
      this.providedFocusInnerElement ? this.providedFocusInnerElement(r) : this.focusInnerElement(r);
    }, t.prototype.onFocusIn = function(e) {
      this.focusTrapActive || (this.providedFocusIn && this.providedFocusIn(e), this.deactivateTabGuards());
    }, t.prototype.onFocusOut = function(e) {
      this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this;
      if (this.providedOnTabKeyDown) {
        this.providedOnTabKeyDown(e);
        return;
      }
      if (!this.focusTrapActive && !e.defaultPrevented) {
        var n = this.tabGuardsAreActive();
        n && this.deactivateTabGuards();
        var i = this.getNextFocusableElement(e.shiftKey);
        n && setTimeout(function() {
          return r.activateTabGuards();
        }, 0), i && (i.focus(), e.preventDefault());
      }
    }, t.prototype.focusInnerElement = function(e) {
      e === void 0 && (e = !1);
      var r = this.focusService.findFocusableElements(this.eFocusableElement);
      this.tabGuardsAreActive() && (r.splice(0, 1), r.splice(r.length - 1, 1)), r.length && r[e ? r.length - 1 : 0].focus({ preventScroll: !0 });
    }, t.prototype.getNextFocusableElement = function(e) {
      return this.focusService.findNextFocusableElement(this.eFocusableElement, !1, e);
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      var r = this;
      e === void 0 && (e = !1);
      var n = e ? this.eTopGuard : this.eBottomGuard;
      this.activateTabGuards(), this.skipTabGuardFocus = !0, n.focus(), window.setTimeout(function() {
        r.activateTabGuards();
      });
    }, eP([
      N("focusService")
    ], t.prototype, "focusService", void 0), eP([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), gX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mX = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, yX = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, vp = (
  /** @class */
  function(o) {
    gX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.initialiseTabGuard = function(e) {
      this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.getFocusableElement();
      var r = [this.eTopGuard, this.eBottomGuard], n = {
        setTabIndex: function(i) {
          r.forEach(function(a) {
            return i != null ? a.setAttribute("tabindex", i) : a.removeAttribute("tabindex");
          });
        }
      };
      this.addTabGuards(this.eTopGuard, this.eBottomGuard), this.tabGuardCtrl = this.createManagedBean(new aL({
        comp: n,
        focusTrapActive: !!e.focusTrapActive,
        eTopGuard: this.eTopGuard,
        eBottomGuard: this.eBottomGuard,
        eFocusableElement: this.eFocusableElement,
        onFocusIn: e.onFocusIn,
        onFocusOut: e.onFocusOut,
        focusInnerElement: e.focusInnerElement,
        handleKeyDown: e.handleKeyDown,
        onTabKeyDown: e.onTabKeyDown,
        shouldStopEventPropagation: e.shouldStopEventPropagation
      }));
    }, t.prototype.createTabGuard = function(e) {
      var r = document.createElement("div"), n = e === "top" ? uc.TAB_GUARD_TOP : uc.TAB_GUARD_BOTTOM;
      return r.classList.add(uc.TAB_GUARD, n), bn(r, "presentation"), r;
    }, t.prototype.addTabGuards = function(e, r) {
      this.eFocusableElement.insertAdjacentElement("afterbegin", e), this.eFocusableElement.insertAdjacentElement("beforeend", r);
    }, t.prototype.removeAllChildrenExceptTabGuards = function() {
      var e = [this.eTopGuard, this.eBottomGuard];
      An(this.getFocusableElement()), this.addTabGuards.apply(this, yX([], mX(e), !1));
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      e === void 0 && (e = !1), this.tabGuardCtrl.forceFocusOutOfContainer(e);
    }, t.prototype.appendChild = function(e, r) {
      cv(e) || (e = e.getGui());
      var n = this.eBottomGuard;
      n ? n.insertAdjacentElement("beforebegin", e) : o.prototype.appendChild.call(this, e, r);
    }, t;
  }(gt)
), CX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Vg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wX = (
  /** @class */
  function(o) {
    CX(t, o);
    function t(e) {
      var r = o.call(this, t.getTemplate(e.cssClass)) || this;
      return r.items = [], r.tabbedItemScrollMap = /* @__PURE__ */ new Map(), r.params = e, e.items && e.items.forEach(function(n) {
        return r.addItem(n);
      }), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.initialiseTabGuard({
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        focusInnerElement: this.focusInnerElement.bind(this),
        focusTrapActive: !0
      }), this.addDestroyFunc(function() {
        var r, n, i;
        return (i = (n = (r = e.activeItem) === null || r === void 0 ? void 0 : r.tabbedItem) === null || n === void 0 ? void 0 : n.afterDetachedCallback) === null || i === void 0 ? void 0 : i.call(n);
      });
    }, t.getTemplate = function(e) {
      return (
        /* html */
        '<div class="ag-tabs '.concat(e, `">
            <div ref="eHeader" role="tablist" class="ag-tabs-header `).concat(e ? "".concat(e, "-header") : "", `"></div>
            <div ref="eBody" role="presentation" class="ag-tabs-body `).concat(e ? "".concat(e, "-body") : "", `"></div>
        </div>`)
      );
    }, t.prototype.handleKeyDown = function(e) {
      var r = this.gridOptionsService.getDocument();
      switch (e.key) {
        case we.RIGHT:
        case we.LEFT:
          if (!this.eHeader.contains(r.activeElement))
            return;
          var n = e.key === we.RIGHT, i = this.gridOptionsService.get("enableRtl"), a = this.items.indexOf(this.activeItem), s = n !== i ? Math.min(a + 1, this.items.length - 1) : Math.max(a - 1, 0);
          if (a === s)
            return;
          e.preventDefault();
          var l = this.items[s];
          this.showItemWrapper(l), l.eHeaderButton.focus();
          break;
        case we.UP:
        case we.DOWN:
          e.stopPropagation();
          break;
      }
    }, t.prototype.onTabKeyDown = function(e) {
      if (!e.defaultPrevented) {
        var r = this, n = r.focusService, i = r.eHeader, a = r.eBody, s = r.activeItem, l = this.gridOptionsService.getDocument(), u = l.activeElement, c = e.target;
        if (e.preventDefault(), i.contains(u)) {
          this.focusBody(e.shiftKey);
          return;
        }
        var d = null;
        n.isTargetUnderManagedComponent(a, c) && (e.shiftKey && (d = this.focusService.findFocusableElementBeforeTabGuard(a, c)), d || (d = s.eHeaderButton)), !d && a.contains(u) && (d = n.findNextFocusableElement(a, !1, e.shiftKey), d || this.focusHeader()), d && d.focus();
      }
    }, t.prototype.focusInnerElement = function(e) {
      e ? this.focusHeader() : this.focusBody(!0);
    }, t.prototype.focusHeader = function() {
      this.activeItem.eHeaderButton.focus();
    }, t.prototype.focusBody = function(e) {
      this.focusService.focusInto(this.eBody, e);
    }, t.prototype.setAfterAttachedParams = function(e) {
      this.afterAttachedParams = e;
    }, t.prototype.showFirstItem = function() {
      this.items.length > 0 && this.showItemWrapper(this.items[0]);
    }, t.prototype.addItem = function(e) {
      var r = document.createElement("span");
      bn(r, "tab"), r.setAttribute("tabindex", "-1"), r.appendChild(e.title), r.classList.add("ag-tab"), this.eHeader.appendChild(r), Os(r, e.titleLabel);
      var n = {
        tabbedItem: e,
        eHeaderButton: r
      };
      this.items.push(n), r.addEventListener("click", this.showItemWrapper.bind(this, n));
    }, t.prototype.showItem = function(e) {
      var r = this.items.find(function(n) {
        return n.tabbedItem === e;
      });
      r && this.showItemWrapper(r);
    }, t.prototype.showItemWrapper = function(e) {
      var r = this, n, i, a = e.tabbedItem, s = e.eHeaderButton;
      if (this.params.onItemClicked && this.params.onItemClicked({ item: a }), this.activeItem === e) {
        e2(this.params.onActiveItemClicked);
        return;
      }
      this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), An(this.eBody), a.bodyPromise.then(function(l) {
        r.eBody.appendChild(l);
        var u = !r.focusService.isKeyboardMode();
        if (r.focusService.focusInto(r.eBody, !1, u), a.afterAttachedCallback && a.afterAttachedCallback(r.afterAttachedParams), r.params.keepScrollPosition) {
          var c = a.getScrollableContainer && a.getScrollableContainer() || l;
          r.lastScrollListener = r.addManagedListener(c, "scroll", function() {
            r.tabbedItemScrollMap.set(a.name, c.scrollTop);
          });
          var d = r.tabbedItemScrollMap.get(a.name);
          d !== void 0 && setTimeout(function() {
            c.scrollTop = d;
          }, 0);
        }
      }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (i = (n = this.activeItem.tabbedItem).afterDetachedCallback) === null || i === void 0 || i.call(n)), s.classList.add("ag-tab-selected"), this.activeItem = e;
    }, Vg([
      N("focusService")
    ], t.prototype, "focusService", void 0), Vg([
      ke("eHeader")
    ], t.prototype, "eHeader", void 0), Vg([
      ke("eBody")
    ], t.prototype, "eBody", void 0), Vg([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(vp)
), bX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), SX = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, EX = 50, sL = (
  /** @class */
  function(o) {
    bX(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.polyfillFunctions = [], e;
    }
    return t.prototype.observeResize = function(e, r) {
      var n = this, i = this.gridOptionsService.getWindow(), a = function() {
        var c = new i.ResizeObserver(r);
        return c.observe(e), function() {
          return c.disconnect();
        };
      }, s = function() {
        var c, d, f = (c = e == null ? void 0 : e.clientWidth) !== null && c !== void 0 ? c : 0, v = (d = e == null ? void 0 : e.clientHeight) !== null && d !== void 0 ? d : 0, g = !0, m = function() {
          var b, S;
          if (g) {
            var R = (b = e == null ? void 0 : e.clientWidth) !== null && b !== void 0 ? b : 0, P = (S = e == null ? void 0 : e.clientHeight) !== null && S !== void 0 ? S : 0, D = R !== f || P !== v;
            D && (f = R, v = P, r()), n.doNextPolyfillTurn(m);
          }
        };
        return m(), function() {
          return g = !1;
        };
      }, l = this.gridOptionsService.get("suppressBrowserResizeObserver"), u = !!i.ResizeObserver;
      return u && !l ? a() : this.getFrameworkOverrides().wrapIncoming(function() {
        return s();
      }, "resize-observer");
    }, t.prototype.doNextPolyfillTurn = function(e) {
      this.polyfillFunctions.push(e), this.schedulePolyfill();
    }, t.prototype.schedulePolyfill = function() {
      var e = this;
      if (!this.polyfillScheduled) {
        var r = function() {
          var n = e.polyfillFunctions;
          e.polyfillScheduled = !1, e.polyfillFunctions = [], n.forEach(function(i) {
            return i();
          });
        };
        this.polyfillScheduled = !0, window.setTimeout(r, EX);
      }
    }, t = SX([
      Be("resizeObserverService")
    ], t), t;
  }(Me)
), _X = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, lL = (
  /** @class */
  function(o) {
    _X(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.createTasksP1 = { list: [], sorted: !1 }, e.createTasksP2 = { list: [], sorted: !1 }, e.destroyTasks = [], e.ticking = !1, e.scrollGoingDown = !0, e.lastPage = 0, e.lastScrollTop = 0, e.taskCount = 0, e.cancelledTasks = /* @__PURE__ */ new Set(), e;
    }
    return t.prototype.setScrollTop = function(e) {
      var r = this.gridOptionsService.get("pagination");
      if (this.scrollGoingDown = e >= this.lastScrollTop, r && e === 0) {
        var n = this.paginationProxy.getCurrentPage();
        n !== this.lastPage && (this.lastPage = n, this.scrollGoingDown = !0);
      }
      this.lastScrollTop = e;
    }, t.prototype.init = function() {
      this.useAnimationFrame = !this.gridOptionsService.get("suppressAnimationFrame");
    }, t.prototype.isOn = function() {
      return this.useAnimationFrame;
    }, t.prototype.verifyAnimationFrameOn = function(e) {
      this.useAnimationFrame === !1 && console.warn("AG Grid: AnimationFrameService.".concat(e, " called but animation frames are off"));
    }, t.prototype.createTask = function(e, r, n) {
      this.verifyAnimationFrameOn(n);
      var i = { task: e, index: r, createOrder: ++this.taskCount };
      this.addTaskToList(this[n], i), this.schedule();
    }, t.prototype.cancelTask = function(e) {
      this.cancelledTasks.add(e);
    }, t.prototype.addTaskToList = function(e, r) {
      e.list.push(r), e.sorted = !1;
    }, t.prototype.sortTaskList = function(e) {
      if (!e.sorted) {
        var r = this.scrollGoingDown ? 1 : -1;
        e.list.sort(function(n, i) {
          return n.index !== i.index ? r * (i.index - n.index) : i.createOrder - n.createOrder;
        }), e.sorted = !0;
      }
    }, t.prototype.addDestroyTask = function(e) {
      this.verifyAnimationFrameOn("createTasksP3"), this.destroyTasks.push(e), this.schedule();
    }, t.prototype.executeFrame = function(e) {
      this.verifyAnimationFrameOn("executeFrame");
      for (var r = this.createTasksP1, n = r.list, i = this.createTasksP2, a = i.list, s = this.destroyTasks, l = (/* @__PURE__ */ new Date()).getTime(), u = (/* @__PURE__ */ new Date()).getTime() - l, c = e <= 0, d = this.ctrlsService.getGridBodyCtrl(); c || u < e; ) {
        var f = d.getScrollFeature().scrollGridIfNeeded();
        if (!f) {
          var v = void 0;
          if (n.length)
            this.sortTaskList(r), v = n.pop().task;
          else if (a.length)
            this.sortTaskList(i), v = a.pop().task;
          else if (s.length)
            v = s.pop();
          else {
            this.cancelledTasks.clear();
            break;
          }
          this.cancelledTasks.has(v) || v();
        }
        u = (/* @__PURE__ */ new Date()).getTime() - l;
      }
      n.length || a.length || s.length ? this.requestFrame() : this.stopTicking();
    }, t.prototype.stopTicking = function() {
      this.ticking = !1;
    }, t.prototype.flushAllFrames = function() {
      this.useAnimationFrame && this.executeFrame(-1);
    }, t.prototype.schedule = function() {
      this.useAnimationFrame && (this.ticking || (this.ticking = !0, this.requestFrame()));
    }, t.prototype.requestFrame = function() {
      var e = this.executeFrame.bind(this, 60);
      this.requestAnimationFrame(e);
    }, t.prototype.requestAnimationFrame = function(e) {
      var r = this.gridOptionsService.getWindow();
      r.requestAnimationFrame ? r.requestAnimationFrame(e) : r.webkitRequestAnimationFrame ? r.webkitRequestAnimationFrame(e) : r.setTimeout(e, 0);
    }, t.prototype.isQueueEmpty = function() {
      return !this.ticking;
    }, t.prototype.debounce = function(e) {
      var r = this, n = !1;
      return function() {
        if (!r.isOn()) {
          window.setTimeout(e, 0);
          return;
        }
        n || (n = !0, r.addDestroyTask(function() {
          n = !1, e();
        }));
      };
    }, Hg([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Hg([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Hg([
      Fe
    ], t.prototype, "init", null), t = Hg([
      Be("animationFrameService")
    ], t), t;
  }(Me)
), Pt;
(function(o) {
  o.EVERYTHING = "group", o.FILTER = "filter", o.SORT = "sort", o.MAP = "map", o.AGGREGATE = "aggregate", o.FILTER_AGGREGATES = "filter_aggregates", o.PIVOT = "pivot", o.NOTHING = "nothing";
})(Pt || (Pt = {}));
var xX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, uL = (
  /** @class */
  function(o) {
    xX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
    }, t.prototype.expandRows = function(e) {
      if (this.isClientSideRowModel) {
        var r = new Set(e);
        this.rowModel.forEachNode(function(n) {
          n.id && r.has(n.id) && (n.expanded = !0);
        }), this.onGroupExpandedOrCollapsed();
      }
    }, t.prototype.getExpandedRows = function() {
      var e = [];
      return this.rowModel.forEachNode(function(r) {
        var n = r.expanded, i = r.id;
        n && i && e.push(i);
      }), e;
    }, t.prototype.expandAll = function(e) {
      this.isClientSideRowModel && this.rowModel.expandOrCollapseAll(e);
    }, t.prototype.setRowNodeExpanded = function(e, r, n) {
      e && (n && e.parent && e.parent.level !== -1 && this.setRowNodeExpanded(e.parent, r, n), e.setExpanded(r));
    }, t.prototype.onGroupExpandedOrCollapsed = function() {
      this.isClientSideRowModel && this.rowModel.refreshModel({ step: Pt.MAP });
    }, rb([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), rb([
      Fe
    ], t.prototype, "postConstruct", null), t = rb([
      Be("expansionService")
    ], t), t;
  }(Me)
), RX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Vf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, cL = (
  /** @class */
  function(o) {
    RX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCtrl = r.centerRowContainerCtrl;
      });
    }, t.prototype.getPreferredWidthForColumn = function(e, r) {
      var n = this.getHeaderCellForColumn(e);
      if (!n)
        return -1;
      var i = this.rowRenderer.getAllCellsForColumn(e);
      return r || i.push(n), this.addElementsToContainerAndGetWidth(i);
    }, t.prototype.getPreferredWidthForColumnGroup = function(e) {
      var r = this.getHeaderCellForColumn(e);
      return r ? this.addElementsToContainerAndGetWidth([r]) : -1;
    }, t.prototype.addElementsToContainerAndGetWidth = function(e) {
      var r = this, n = document.createElement("form");
      n.style.position = "fixed";
      var i = this.centerRowContainerCtrl.getContainerElement();
      e.forEach(function(l) {
        return r.cloneItemIntoDummy(l, n);
      }), i.appendChild(n);
      var a = n.offsetWidth;
      i.removeChild(n);
      var s = this.getAutoSizePadding();
      return a + s;
    }, t.prototype.getAutoSizePadding = function() {
      return this.gridOptionsService.get("autoSizePadding");
    }, t.prototype.getHeaderCellForColumn = function(e) {
      var r = null;
      return this.ctrlsService.getHeaderRowContainerCtrls().forEach(function(n) {
        var i = n.getHtmlElementForColumnHeader(e);
        i != null && (r = i);
      }), r;
    }, t.prototype.cloneItemIntoDummy = function(e, r) {
      var n = e.cloneNode(!0);
      n.style.width = "", n.style.position = "static", n.style.left = "";
      var i = document.createElement("div"), a = i.classList, s = ["ag-header-cell", "ag-header-group-cell"].some(function(f) {
        return n.classList.contains(f);
      });
      s ? (a.add("ag-header", "ag-header-row"), i.style.position = "static") : a.add("ag-row");
      for (var l = e.parentElement; l; ) {
        var u = ["ag-header-row", "ag-row"].some(function(f) {
          return l.classList.contains(f);
        });
        if (u) {
          for (var c = 0; c < l.classList.length; c++) {
            var d = l.classList[c];
            d != "ag-row-position-absolute" && a.add(d);
          }
          break;
        }
        l = l.parentElement;
      }
      i.appendChild(n), r.appendChild(i);
    }, Vf([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Vf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Vf([
      N("rowCssClassCalculator")
    ], t.prototype, "rowCssClassCalculator", void 0), Vf([
      Fe
    ], t.prototype, "postConstruct", null), t = Vf([
      Be("autoWidthCalculator")
    ], t), t;
  }(Me)
), TX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Bg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, OX = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, PX = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, DX = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, AX = (
  /** @class */
  function(o) {
    TX(t, o);
    function t(e, r) {
      var n = o.call(this) || this;
      return n.createRowCon = e, n.destroyRowCtrls = r, n.stickyRowCtrls = [], n.containerHeight = 0, n;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.isClientSide = this.rowModel.getType() === "clientSide", this.ctrlsService.whenReady(function(r) {
        e.gridBodyCtrl = r.gridBodyCtrl;
      });
    }, t.prototype.getStickyRowCtrls = function() {
      return this.stickyRowCtrls;
    }, t.prototype.checkStickyRows = function() {
      var e = this, r = 0;
      if (!this.gridOptionsService.isGroupRowsSticky())
        return this.refreshNodesAndContainerHeight([], r);
      for (var n = [], i = this.rowRenderer.getFirstVisibleVerticalPixel(), a = function(g) {
        var m, b, S;
        n.push(g);
        var R;
        if (e.isClientSide) {
          for (var P = g; P.isExpandable() && P.expanded; )
            if (P.master)
              P = P.detailNode;
            else if (P.childrenAfterSort) {
              if (P.childrenAfterSort.length === 0)
                break;
              P = Kt(P.childrenAfterSort);
            }
          R = P.rowTop + P.rowHeight;
        } else if (g.master)
          R = g.detailNode.rowTop + g.detailNode.rowHeight;
        else {
          var D = (m = g.childStore) === null || m === void 0 ? void 0 : m.getStoreBounds();
          R = ((b = D == null ? void 0 : D.heightPx) !== null && b !== void 0 ? b : 0) + ((S = D == null ? void 0 : D.topPx) !== null && S !== void 0 ? S : 0);
        }
        var x = i + r + g.rowHeight;
        R < x ? g.stickyRowTop = r + (R - x) : g.stickyRowTop = r, r = 0, n.forEach(function(M) {
          var F = M.stickyRowTop + M.rowHeight;
          r < F && (r = F);
        });
      }, s = 0; ; ) {
        var l = i + r, u = this.rowModel.getRowIndexAtPixel(l), c = this.rowModel.getRow(u);
        if (c == null || c.level < 0 || s++ === 100)
          break;
        for (var d = [], f = c.parent; f.level >= 0; )
          d.push(f), f = f.parent;
        var v = d.reverse().find(function(g) {
          return n.indexOf(g) < 0 && g.displayed;
        });
        if (v) {
          a(v);
          continue;
        }
        if (c.isExpandable() && c.expanded && c.rowTop < l) {
          a(c);
          continue;
        }
        break;
      }
      return this.refreshNodesAndContainerHeight(n, r);
    }, t.prototype.refreshStickyNode = function(e) {
      for (var r = [], n = 0; n < this.stickyRowCtrls.length; n++) {
        var i = this.stickyRowCtrls[n].getRowNode();
        i !== e && r.push(i);
      }
      this.refreshNodesAndContainerHeight(r, this.containerHeight) && this.checkStickyRows();
    }, t.prototype.refreshNodesAndContainerHeight = function(e, r) {
      var n, i, a, s = this, l = !1, u = this.stickyRowCtrls.filter(function(b) {
        return e.indexOf(b.getRowNode()) === -1;
      }), c = e.filter(function(b) {
        return s.stickyRowCtrls.findIndex(function(S) {
          return S.getRowNode() === b;
        }) === -1;
      });
      (u.length || c.length) && (l = !0);
      var d = {};
      u.forEach(function(b) {
        d[b.getRowNode().id] = b, s.stickyRowCtrls = s.stickyRowCtrls.filter(function(S) {
          return S !== b;
        });
      });
      try {
        for (var f = OX(Object.values(d)), v = f.next(); !v.done; v = f.next()) {
          var g = v.value;
          g.getRowNode().sticky = !1;
        }
      } catch (b) {
        n = { error: b };
      } finally {
        try {
          v && !v.done && (i = f.return) && i.call(f);
        } finally {
          if (n) throw n.error;
        }
      }
      this.destroyRowCtrls(d, !1);
      var m = c.map(function(b) {
        return b.sticky = !0, s.createRowCon(b, !1, !1);
      });
      return (a = this.stickyRowCtrls).push.apply(a, DX([], PX(m), !1)), this.stickyRowCtrls.forEach(function(b) {
        return b.setRowTop(b.getRowNode().stickyRowTop);
      }), this.stickyRowCtrls.sort(function(b, S) {
        return S.getRowNode().rowIndex - b.getRowNode().rowIndex;
      }), this.containerHeight !== r && (this.containerHeight = r, this.gridBodyCtrl.setStickyTopHeight(r), l = !0), l;
    }, Bg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Bg([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Bg([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Bg([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(Me)
), MX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zi = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ul = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, cl = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, FX = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, dL = (
  /** @class */
  function(o) {
    MX(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.destroyFuncsForColumnListeners = [], e.rowCtrlsByRowIndex = {}, e.zombieRowCtrls = {}, e.allRowCtrls = [], e.topRowCtrls = [], e.bottomRowCtrls = [], e.refreshInProgress = !1, e.dataFirstRenderedFired = !1, e.setupRangeSelectionListeners = function() {
        var r = function() {
          e.getAllCellCtrls().forEach(function(l) {
            return l.onRangeSelectionChanged();
          });
        }, n = function() {
          e.getAllCellCtrls().forEach(function(l) {
            return l.updateRangeBordersIfRangeCount();
          });
        }, i = function() {
          e.eventService.addEventListener(G.EVENT_RANGE_SELECTION_CHANGED, r), e.eventService.addEventListener(G.EVENT_COLUMN_MOVED, n), e.eventService.addEventListener(G.EVENT_COLUMN_PINNED, n), e.eventService.addEventListener(G.EVENT_COLUMN_VISIBLE, n);
        }, a = function() {
          e.eventService.removeEventListener(G.EVENT_RANGE_SELECTION_CHANGED, r), e.eventService.removeEventListener(G.EVENT_COLUMN_MOVED, n), e.eventService.removeEventListener(G.EVENT_COLUMN_PINNED, n), e.eventService.removeEventListener(G.EVENT_COLUMN_VISIBLE, n);
        };
        e.addDestroyFunc(function() {
          return a();
        }), e.addManagedPropertyListener("enableRangeSelection", function(l) {
          var u = l.currentValue;
          u ? i() : a();
        });
        var s = e.gridOptionsService.get("enableRangeSelection");
        s && i();
      }, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function() {
        e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl(), e.initialise();
      });
    }, t.prototype.initialise = function() {
      var e = this;
      if (this.addManagedListener(this.eventService, G.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this)), this.addManagedListener(this.eventService, G.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this)), this.addManagedListener(this.eventService, G.EVENT_BODY_HEIGHT_CHANGED, this.redraw.bind(this)), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], function() {
        return e.onDomLayoutChanged();
      }), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], function() {
        return e.redraw();
      }), this.addManagedPropertyListeners([
        "suppressCellFocus",
        "getBusinessKeyForNode",
        "fullWidthCellRenderer",
        "fullWidthCellRendererParams",
        "rowStyle",
        "getRowStyle",
        "rowClass",
        "getRowClass",
        "rowClassRules",
        "groupRowRenderer",
        "groupRowRendererParams",
        "loadingCellRenderer",
        "loadingCellRendererParams",
        "detailCellRenderer",
        "detailCellRendererParams",
        "enableRangeSelection",
        "enableCellTextSelection"
      ], function() {
        return e.redrawRows();
      }), this.gridOptionsService.isGroupRowsSticky()) {
        var r = this.rowModel.getType();
        (r === "clientSide" || r === "serverSide") && (this.stickyRowFeature = this.createManagedBean(new AX(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this))));
      }
      this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = this.gridOptionsService.isDomLayout("print"), this.embedFullWidthRows = this.printLayout || this.gridOptionsService.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
    }, t.prototype.initialiseCache = function() {
      if (this.gridOptionsService.get("keepDetailRows")) {
        var e = this.getKeepDetailRowsCount(), r = e ?? 3;
        this.cachedRowCtrls = new IX(r);
      }
    }, t.prototype.getKeepDetailRowsCount = function() {
      return this.gridOptionsService.get("keepDetailRowsCount");
    }, t.prototype.getStickyTopRowCtrls = function() {
      return this.stickyRowFeature ? this.stickyRowFeature.getStickyRowCtrls() : [];
    }, t.prototype.updateAllRowCtrls = function() {
      var e = Vl(this.rowCtrlsByRowIndex), r = Vl(this.zombieRowCtrls), n = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
      r.length > 0 || n.length > 0 ? this.allRowCtrls = cl(cl(cl([], ul(e), !1), ul(r), !1), ul(n), !1) : this.allRowCtrls = e;
    }, t.prototype.onCellFocusChanged = function(e) {
      this.getAllCellCtrls().forEach(function(r) {
        return r.onCellFocused(e);
      }), this.getFullWidthRowCtrls().forEach(function(r) {
        return r.onFullWidthRowFocused(e);
      });
    }, t.prototype.registerCellEventListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_CELL_FOCUSED, function(r) {
        e.onCellFocusChanged(r);
      }), this.addManagedListener(this.eventService, G.EVENT_CELL_FOCUS_CLEARED, function() {
        e.onCellFocusChanged();
      }), this.addManagedListener(this.eventService, G.EVENT_FLASH_CELLS, function(r) {
        e.getAllCellCtrls().forEach(function(n) {
          return n.onFlashCells(r);
        });
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_HOVER_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(r) {
          return r.onColumnHover();
        });
      }), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, function() {
        e.getAllCellCtrls().forEach(function(r) {
          return r.onDisplayedColumnsChanged();
        });
      }), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function() {
        e.printLayout && e.getAllCellCtrls().forEach(function(r) {
          return r.onLeftChanged();
        });
      }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedListener(this.eventService, G.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this)), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }, t.prototype.removeGridColumnListeners = function() {
      this.destroyFuncsForColumnListeners.forEach(function(e) {
        return e();
      }), this.destroyFuncsForColumnListeners.length = 0;
    }, t.prototype.refreshListenersToColumnsForCellComps = function() {
      var e = this;
      this.removeGridColumnListeners();
      var r = this.columnModel.getAllGridColumns();
      r.forEach(function(n) {
        var i = function(d) {
          e.getAllCellCtrls().forEach(function(f) {
            f.getColumn() === n && d(f);
          });
        }, a = function() {
          i(function(d) {
            return d.onLeftChanged();
          });
        }, s = function() {
          i(function(d) {
            return d.onWidthChanged();
          });
        }, l = function() {
          i(function(d) {
            return d.onFirstRightPinnedChanged();
          });
        }, u = function() {
          i(function(d) {
            return d.onLastLeftPinnedChanged();
          });
        }, c = function() {
          i(function(d) {
            return d.onColDefChanged();
          });
        };
        n.addEventListener("leftChanged", a), n.addEventListener("widthChanged", s), n.addEventListener("firstRightPinnedChanged", l), n.addEventListener("lastLeftPinnedChanged", u), n.addEventListener("colDefChanged", c), e.destroyFuncsForColumnListeners.push(function() {
          n.removeEventListener("leftChanged", a), n.removeEventListener("widthChanged", s), n.removeEventListener("firstRightPinnedChanged", l), n.removeEventListener("lastLeftPinnedChanged", u), n.removeEventListener("colDefChanged", c);
        });
      });
    }, t.prototype.onDomLayoutChanged = function() {
      var e = this.gridOptionsService.isDomLayout("print"), r = e || this.gridOptionsService.get("embedFullWidthRows"), n = r !== this.embedFullWidthRows || this.printLayout !== e;
      this.printLayout = e, this.embedFullWidthRows = r, n && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
    }, t.prototype.datasourceChanged = function() {
      this.firstRenderedRow = 0, this.lastRenderedRow = -1;
      var e = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(e);
    }, t.prototype.onPageLoaded = function(e) {
      var r = {
        recycleRows: e.keepRenderedRows,
        animate: e.animate,
        newData: e.newData,
        newPage: e.newPage,
        // because this is a model updated event (not pinned rows), we
        // can skip updating the pinned rows. this is needed so that if user
        // is doing transaction updates, the pinned rows are not getting constantly
        // trashed - or editing cells in pinned rows are not refreshed and put into read mode
        onlyBody: !0
      };
      this.redrawAfterModelUpdate(r);
    }, t.prototype.getAllCellsForColumn = function(e) {
      var r = [];
      return this.getAllRowCtrls().forEach(function(n) {
        var i = n.getCellElement(e);
        i && r.push(i);
      }), r;
    }, t.prototype.refreshFloatingRowComps = function() {
      this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData()), this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
    }, t.prototype.getTopRowCtrls = function() {
      return this.topRowCtrls;
    }, t.prototype.getCentreRowCtrls = function() {
      return this.allRowCtrls;
    }, t.prototype.getBottomRowCtrls = function() {
      return this.bottomRowCtrls;
    }, t.prototype.refreshFloatingRows = function(e, r) {
      var n = this;
      e.forEach(function(i) {
        i.destroyFirstPass(), i.destroySecondPass();
      }), e.length = 0, r && r.forEach(function(i) {
        var a = new Fl(i, n.beans, !1, !1, n.printLayout);
        e.push(a);
      });
    }, t.prototype.onPinnedRowDataChanged = function() {
      var e = {
        recycleRows: !0
      };
      this.redrawAfterModelUpdate(e);
    }, t.prototype.redrawRow = function(e, r) {
      var n = this;
      if (r === void 0 && (r = !1), e.sticky)
        this.stickyRowFeature.refreshStickyNode(e);
      else {
        var i = function(a) {
          var s = a[e.rowIndex];
          s && s.getRowNode() === e && (s.destroyFirstPass(), s.destroySecondPass(), a[e.rowIndex] = n.createRowCon(e, !1, !1));
        };
        switch (e.rowPinned) {
          case "top":
            i(this.topRowCtrls);
          case "bottom":
            i(this.bottomRowCtrls);
          default:
            i(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
        }
      }
      r || this.dispatchDisplayedRowsChanged(!1);
    }, t.prototype.redrawRows = function(e) {
      var r = this, n = e != null;
      if (n) {
        e == null || e.forEach(function(i) {
          return r.redrawRow(i, !0);
        }), this.dispatchDisplayedRowsChanged(!1);
        return;
      }
      this.redrawAfterModelUpdate();
    }, t.prototype.getCellToRestoreFocusToAfterRefresh = function(e) {
      var r = e != null && e.suppressKeepFocus ? null : this.focusService.getFocusCellToUseAfterRefresh();
      if (r == null)
        return null;
      var n = this.gridOptionsService.getDocument(), i = n.activeElement, a = this.gridOptionsService.getDomData(i, Ml.DOM_DATA_KEY_CELL_CTRL), s = this.gridOptionsService.getDomData(i, Fl.DOM_DATA_KEY_ROW_CTRL), l = a || s;
      return l ? r : null;
    }, t.prototype.redrawAfterModelUpdate = function(e) {
      e === void 0 && (e = {}), this.getLockOnRefresh();
      var r = this.getCellToRestoreFocusToAfterRefresh(e);
      this.updateContainerHeights(), this.scrollToTopIfNewData(e);
      var n = !e.domLayoutChanged && !!e.recycleRows, i = e.animate && this.gridOptionsService.isAnimateRows(), a = n ? this.getRowsToRecycle() : null;
      n || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender(), this.stickyRowFeature && this.stickyRowFeature.checkStickyRows(), this.recycleRows(a, i), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(), this.dispatchDisplayedRowsChanged(), r != null && this.restoreFocusedCell(r), this.releaseLockOnRefresh();
    }, t.prototype.scrollToTopIfNewData = function(e) {
      var r = e.newData || e.newPage, n = this.gridOptionsService.get("suppressScrollOnNewData");
      r && !n && this.gridBodyCtrl.getScrollFeature().scrollToTop();
    }, t.prototype.updateContainerHeights = function() {
      if (this.printLayout) {
        this.rowContainerHeightService.setModelHeight(null);
        return;
      }
      var e = this.paginationProxy.getCurrentPageHeight();
      e === 0 && (e = 1), this.rowContainerHeightService.setModelHeight(e);
    }, t.prototype.getLockOnRefresh = function() {
      if (this.refreshInProgress)
        throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.");
      this.refreshInProgress = !0;
    }, t.prototype.releaseLockOnRefresh = function() {
      this.refreshInProgress = !1;
    }, t.prototype.isRefreshInProgress = function() {
      return this.refreshInProgress;
    }, t.prototype.restoreFocusedCell = function(e) {
      e && (this.focusService.setRestoreFocusedCell(e), this.onCellFocusChanged(this.beans.gridOptionsService.addGridCommonParams({
        rowIndex: e.rowIndex,
        column: e.column,
        rowPinned: e.rowPinned,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !0,
        type: "mock"
      })));
    }, t.prototype.stopEditing = function(e) {
      e === void 0 && (e = !1), this.getAllRowCtrls().forEach(function(r) {
        r.stopEditing(e);
      });
    }, t.prototype.getAllCellCtrls = function() {
      for (var e = [], r = this.getAllRowCtrls(), n = r.length, i = 0; i < n; i++)
        for (var a = r[i].getAllCellCtrls(), s = a.length, l = 0; l < s; l++)
          e.push(a[l]);
      return e;
    }, t.prototype.getAllRowCtrls = function() {
      var e, r, n = this.stickyRowFeature && this.stickyRowFeature.getStickyRowCtrls() || [], i = cl(cl(cl([], ul(this.topRowCtrls), !1), ul(this.bottomRowCtrls), !1), ul(n), !1);
      try {
        for (var a = FX(Object.keys(this.rowCtrlsByRowIndex)), s = a.next(); !s.done; s = a.next()) {
          var l = s.value;
          i.push(this.rowCtrlsByRowIndex[l]);
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (e) throw e.error;
        }
      }
      return i;
    }, t.prototype.addRenderedRowListener = function(e, r, n) {
      var i = this.rowCtrlsByRowIndex[r];
      i && i.addEventListener(e, n);
    }, t.prototype.flashCells = function(e) {
      e === void 0 && (e = {});
      var r = e.flashDelay, n = e.fadeDelay;
      this.getCellCtrls(e.rowNodes, e.columns).forEach(function(i) {
        return i.flashCell({ flashDelay: r, fadeDelay: n });
      });
    }, t.prototype.refreshCells = function(e) {
      var r = this;
      e === void 0 && (e = {});
      var n = {
        forceRefresh: e.force,
        newData: !1,
        suppressFlash: e.suppressFlash
      };
      this.getCellCtrls(e.rowNodes, e.columns).forEach(function(i) {
        return i.refreshOrDestroyCell(n);
      }), e.rowNodes && (this.getRowCtrls(e.rowNodes).forEach(function(i) {
        if (i.isFullWidth()) {
          var a = i.refreshFullWidth();
          a || r.redrawRow(i.getRowNode(), !0);
        }
      }), this.dispatchDisplayedRowsChanged(!1));
    }, t.prototype.getCellRendererInstances = function(e) {
      var r = this, n, i = this.getCellCtrls(e.rowNodes, e.columns).map(function(l) {
        return l.getCellRenderer();
      }).filter(function(l) {
        return l != null;
      });
      if (!((n = e.columns) === null || n === void 0) && n.length)
        return i;
      var a = [], s = this.mapRowNodes(e.rowNodes);
      return this.getAllRowCtrls().forEach(function(l) {
        if (!(s && !r.isRowInMap(l.getRowNode(), s)) && l.isFullWidth())
          for (var u = l.getFullWidthCellRenderers(), c = 0; c < u.length; c++) {
            var d = u[c];
            d != null && a.push(d);
          }
      }), cl(cl([], ul(a), !1), ul(i), !1);
    }, t.prototype.getCellEditorInstances = function(e) {
      var r = [];
      return this.getCellCtrls(e.rowNodes, e.columns).forEach(function(n) {
        var i = n.getCellEditor();
        i && r.push(i);
      }), r;
    }, t.prototype.getEditingCells = function() {
      var e = [];
      return this.getAllCellCtrls().forEach(function(r) {
        if (r.isEditing()) {
          var n = r.getCellPosition();
          e.push(n);
        }
      }), e;
    }, t.prototype.mapRowNodes = function(e) {
      if (e) {
        var r = {
          top: {},
          bottom: {},
          normal: {}
        };
        return e.forEach(function(n) {
          var i = n.id;
          n.rowPinned === "top" ? r.top[i] = n : n.rowPinned === "bottom" ? r.bottom[i] = n : r.normal[i] = n;
        }), r;
      }
    }, t.prototype.isRowInMap = function(e, r) {
      var n = e.id, i = e.rowPinned;
      return i === "bottom" ? r.bottom[n] != null : i === "top" ? r.top[n] != null : r.normal[n] != null;
    }, t.prototype.getRowCtrls = function(e) {
      var r = this, n = this.mapRowNodes(e), i = this.getAllRowCtrls();
      return !e || !n ? i : i.filter(function(a) {
        var s = a.getRowNode();
        return r.isRowInMap(s, n);
      });
    }, t.prototype.getCellCtrls = function(e, r) {
      var n = this, i;
      Oe(r) && (i = {}, r.forEach(function(s) {
        var l = n.columnModel.getGridColumn(s);
        Oe(l) && (i[l.getId()] = !0);
      }));
      var a = [];
      return this.getRowCtrls(e).forEach(function(s) {
        s.getAllCellCtrls().forEach(function(l) {
          var u = l.getColumn().getId(), c = i && !i[u];
          c || a.push(l);
        });
      }), a;
    }, t.prototype.destroy = function() {
      this.removeAllRowComps(), o.prototype.destroy.call(this);
    }, t.prototype.removeAllRowComps = function() {
      var e = Object.keys(this.rowCtrlsByRowIndex);
      this.removeRowCtrls(e);
    }, t.prototype.getRowsToRecycle = function() {
      var e = [];
      Xn(this.rowCtrlsByRowIndex, function(n, i) {
        var a = i.getRowNode().id == null;
        a && e.push(n);
      }), this.removeRowCtrls(e);
      var r = {};
      return Xn(this.rowCtrlsByRowIndex, function(n, i) {
        var a = i.getRowNode();
        r[a.id] = i;
      }), this.rowCtrlsByRowIndex = {}, r;
    }, t.prototype.removeRowCtrls = function(e, r) {
      var n = this;
      r === void 0 && (r = !1), e.forEach(function(i) {
        var a = n.rowCtrlsByRowIndex[i];
        a && (a.destroyFirstPass(r), a.destroySecondPass()), delete n.rowCtrlsByRowIndex[i];
      });
    }, t.prototype.onBodyScroll = function(e) {
      e.direction === "vertical" && this.redraw({ afterScroll: !0 });
    }, t.prototype.redraw = function(e) {
      e === void 0 && (e = {});
      var r = e.afterScroll, n;
      this.stickyRowFeature && V1() && (n = this.getCellToRestoreFocusToAfterRefresh() || void 0);
      var i = this.firstRenderedRow, a = this.lastRenderedRow;
      this.workOutFirstAndLastRowsToRender();
      var s = !1;
      this.stickyRowFeature && (s = this.stickyRowFeature.checkStickyRows());
      var l = this.firstRenderedRow !== i || this.lastRenderedRow !== a;
      if (!(r && !s && !l) && (this.getLockOnRefresh(), this.recycleRows(null, !1, r), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(r && !s), n != null)) {
        var u = this.getCellToRestoreFocusToAfterRefresh();
        n != null && u == null && (this.animationFrameService.flushAllFrames(), this.restoreFocusedCell(n));
      }
    }, t.prototype.removeRowCompsNotToDraw = function(e, r) {
      var n = {};
      e.forEach(function(s) {
        return n[s] = !0;
      });
      var i = Object.keys(this.rowCtrlsByRowIndex), a = i.filter(function(s) {
        return !n[s];
      });
      this.removeRowCtrls(a, r);
    }, t.prototype.calculateIndexesToDraw = function(e) {
      var r = this, n = H2(this.firstRenderedRow, this.lastRenderedRow), i = function(c, d) {
        var f = d.getRowNode().rowIndex;
        f != null && (f < r.firstRenderedRow || f > r.lastRenderedRow) && r.doNotUnVirtualiseRow(d) && n.push(f);
      };
      Xn(this.rowCtrlsByRowIndex, i), Xn(e, i), n.sort(function(c, d) {
        return c - d;
      });
      for (var a = [], s = 0; s < n.length; s++) {
        var l = n[s], u = this.paginationProxy.getRow(l);
        u && !u.sticky && a.push(l);
      }
      return a;
    }, t.prototype.recycleRows = function(e, r, n) {
      var i = this;
      r === void 0 && (r = !1), n === void 0 && (n = !1);
      var a = this.calculateIndexesToDraw(e);
      if ((this.printLayout || n) && (r = !1), this.removeRowCompsNotToDraw(a, !r), a.forEach(function(l) {
        var u = i.createOrUpdateRowCtrl(l, e, r, n);
        Oe(u);
      }), e) {
        var s = n && !this.gridOptionsService.get("suppressAnimationFrame") && !this.printLayout;
        s ? this.beans.animationFrameService.addDestroyTask(function() {
          i.destroyRowCtrls(e, r), i.updateAllRowCtrls(), i.dispatchDisplayedRowsChanged();
        }) : this.destroyRowCtrls(e, r);
      }
      this.updateAllRowCtrls();
    }, t.prototype.dispatchDisplayedRowsChanged = function(e) {
      e === void 0 && (e = !1);
      var r = { type: G.EVENT_DISPLAYED_ROWS_CHANGED, afterScroll: e };
      this.eventService.dispatchEvent(r);
    }, t.prototype.onDisplayedColumnsChanged = function() {
      var e = this.columnModel.isPinningLeft(), r = this.columnModel.isPinningRight(), n = this.pinningLeft !== e || r !== this.pinningRight;
      n && (this.pinningLeft = e, this.pinningRight = r, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
    }, t.prototype.redrawFullWidthEmbeddedRows = function() {
      var e = [];
      this.getFullWidthRowCtrls().forEach(function(r) {
        var n = r.getRowNode().rowIndex;
        e.push(n.toString());
      }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
    }, t.prototype.getFullWidthRowCtrls = function(e) {
      var r = this, n = this.mapRowNodes(e);
      return this.getAllRowCtrls().filter(function(i) {
        if (!i.isFullWidth())
          return !1;
        var a = i.getRowNode();
        return !(n != null && !r.isRowInMap(a, n));
      });
    }, t.prototype.createOrUpdateRowCtrl = function(e, r, n, i) {
      var a, s = this.rowCtrlsByRowIndex[e];
      s || (a = this.paginationProxy.getRow(e), Oe(a) && Oe(r) && r[a.id] && a.alreadyRendered && (s = r[a.id], r[a.id] = null));
      var l = !s;
      if (l)
        if (a || (a = this.paginationProxy.getRow(e)), Oe(a))
          s = this.createRowCon(a, n, i);
        else
          return;
      return a && (a.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = s, s;
    }, t.prototype.destroyRowCtrls = function(e, r) {
      var n = this, i = [];
      Xn(e, function(a, s) {
        if (s) {
          if (n.cachedRowCtrls && s.isCacheable()) {
            n.cachedRowCtrls.addRow(s);
            return;
          }
          s.destroyFirstPass(!r), r ? (n.zombieRowCtrls[s.getInstanceId()] = s, i.push(function() {
            s.destroySecondPass(), delete n.zombieRowCtrls[s.getInstanceId()];
          })) : s.destroySecondPass();
        }
      }), r && (i.push(function() {
        n.updateAllRowCtrls(), n.dispatchDisplayedRowsChanged();
      }), QF(i));
    }, t.prototype.getRowBuffer = function() {
      return this.gridOptionsService.get("rowBuffer");
    }, t.prototype.getRowBufferInPixels = function() {
      var e = this.getRowBuffer(), r = this.gridOptionsService.getRowHeightAsNumber();
      return e * r;
    }, t.prototype.workOutFirstAndLastRowsToRender = function() {
      this.rowContainerHeightService.updateOffset();
      var e, r;
      if (!this.paginationProxy.isRowsToRender())
        e = 0, r = -1;
      else if (this.printLayout)
        this.environment.refreshRowHeightVariable(), e = this.paginationProxy.getPageFirstRow(), r = this.paginationProxy.getPageLastRow();
      else {
        var n = this.getRowBufferInPixels(), i = this.ctrlsService.getGridBodyCtrl(), a = this.gridOptionsService.get("suppressRowVirtualisation"), s = !1, l = void 0, u = void 0;
        do {
          var c = this.paginationProxy.getPixelOffset(), d = this.paginationProxy.getCurrentPagePixelRange(), f = d.pageFirstPixel, v = d.pageLastPixel, g = this.rowContainerHeightService.getDivStretchOffset(), m = i.getScrollFeature().getVScrollPosition(), b = m.top, S = m.bottom;
          a ? (l = f + g, u = v + g) : (l = Math.max(b + c - n, f) + g, u = Math.min(S + c + n, v) + g), this.firstVisibleVPixel = Math.max(b + c, f) + g, s = this.ensureAllRowsInRangeHaveHeightsCalculated(l, u);
        } while (s);
        var R = this.paginationProxy.getRowIndexAtPixel(l), P = this.paginationProxy.getRowIndexAtPixel(u), D = this.paginationProxy.getPageFirstRow(), x = this.paginationProxy.getPageLastRow();
        R < D && (R = D), P > x && (P = x), e = R, r = P;
      }
      var M = this.gridOptionsService.isDomLayout("normal"), F = this.gridOptionsService.get("suppressMaxRenderedRowRestriction"), H = Math.max(this.getRowBuffer(), 500);
      M && !F && r - e > H && (r = e + H);
      var B = e !== this.firstRenderedRow, j = r !== this.lastRenderedRow;
      if (B || j) {
        this.firstRenderedRow = e, this.lastRenderedRow = r;
        var V = {
          type: G.EVENT_VIEWPORT_CHANGED,
          firstRow: e,
          lastRow: r
        };
        this.eventService.dispatchEvent(V);
      }
    }, t.prototype.dispatchFirstDataRenderedEvent = function() {
      var e = this;
      if (!this.dataFirstRenderedFired) {
        this.dataFirstRenderedFired = !0;
        var r = {
          type: G.EVENT_FIRST_DATA_RENDERED,
          firstRow: this.firstRenderedRow,
          lastRow: this.lastRenderedRow
        };
        window.requestAnimationFrame(function() {
          e.beans.eventService.dispatchEvent(r);
        });
      }
    }, t.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function(e, r) {
      var n = this.paginationProxy.ensureRowHeightsValid(e, r, -1, -1);
      return n && this.updateContainerHeights(), n;
    }, t.prototype.getFirstVisibleVerticalPixel = function() {
      return this.firstVisibleVPixel;
    }, t.prototype.getFirstVirtualRenderedRow = function() {
      return this.firstRenderedRow;
    }, t.prototype.getLastVirtualRenderedRow = function() {
      return this.lastRenderedRow;
    }, t.prototype.doNotUnVirtualiseRow = function(e) {
      var r = !1, n = !0, i = e.getRowNode(), a = this.focusService.isRowNodeFocused(i), s = e.isEditing(), l = i.detail, u = a || s || l;
      if (!u)
        return r;
      var c = this.paginationProxy.isRowPresent(i);
      return c ? n : r;
    }, t.prototype.createRowCon = function(e, r, n) {
      var i = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(e) : null;
      if (i)
        return i;
      var a = this.gridOptionsService.get("suppressAnimationFrame"), s = n && !a && !this.printLayout, l = new Fl(e, this.beans, r, s, this.printLayout);
      return l;
    }, t.prototype.getRenderedNodes = function() {
      var e = this.rowCtrlsByRowIndex;
      return Object.keys(e).map(function(r) {
        return e[r].getRowNode();
      });
    }, t.prototype.getRowByPosition = function(e) {
      var r, n = e.rowIndex;
      switch (e.rowPinned) {
        case "top":
          r = this.topRowCtrls[n];
          break;
        case "bottom":
          r = this.bottomRowCtrls[n];
          break;
        default:
          r = this.rowCtrlsByRowIndex[n], r || (r = this.getStickyTopRowCtrls().find(function(i) {
            return i.getRowNode().rowIndex === n;
          }) || null);
          break;
      }
      return r;
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, t.prototype.isRangeInRenderedViewport = function(e, r) {
      var n = e == null || r == null;
      if (n)
        return !1;
      var i = e > this.lastRenderedRow, a = r < this.firstRenderedRow, s = !a && !i;
      return s;
    }, zi([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), zi([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), zi([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), zi([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), zi([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), zi([
      N("focusService")
    ], t.prototype, "focusService", void 0), zi([
      N("beans")
    ], t.prototype, "beans", void 0), zi([
      N("rowContainerHeightService")
    ], t.prototype, "rowContainerHeightService", void 0), zi([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), zi([
      Fe
    ], t.prototype, "postConstruct", null), t = zi([
      Be("rowRenderer")
    ], t), t;
  }(Me)
), IX = (
  /** @class */
  function() {
    function o(t) {
      this.entriesMap = {}, this.entriesList = [], this.maxCount = t;
    }
    return o.prototype.addRow = function(t) {
      if (this.entriesMap[t.getRowNode().id] = t, this.entriesList.push(t), t.setCached(!0), this.entriesList.length > this.maxCount) {
        var e = this.entriesList[0];
        e.destroyFirstPass(), e.destroySecondPass(), this.removeFromCache(e);
      }
    }, o.prototype.getRow = function(t) {
      if (t == null || t.id == null)
        return null;
      var e = this.entriesMap[t.id];
      if (!e)
        return null;
      this.removeFromCache(e), e.setCached(!1);
      var r = e.getRowNode() != t;
      return r ? null : e;
    }, o.prototype.removeFromCache = function(t) {
      var e = t.getRowNode().id;
      delete this.entriesMap[e], ti(this.entriesList, t);
    }, o.prototype.getEntries = function() {
      return this.entriesList;
    }, o;
  }()
), LX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, pL = (
  /** @class */
  function(o) {
    LX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.formatValue = function(e, r, n, i, a) {
      a === void 0 && (a = !0);
      var s = null, l, u = e.getColDef();
      if (i ? l = i : a && (l = u.valueFormatter), l) {
        var c = this.gridOptionsService.addGridCommonParams({
          value: n,
          node: r,
          data: r ? r.data : null,
          colDef: u,
          column: e
        });
        typeof l == "function" ? s = l(c) : s = this.expressionService.evaluate(l, c);
      } else if (u.refData)
        return u.refData[n] || "";
      return s == null && Array.isArray(n) && (s = n.join(", ")), s;
    }, tP([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), t = tP([
      Be("valueFormatterService")
    ], t), t;
  }(Me)
), NX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), nb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, fL = (
  /** @class */
  function(o) {
    NX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.setPinnedTopRowData(), this.setPinnedBottomRowData(), this.addManagedPropertyListener("pinnedTopRowData", function() {
        return e.setPinnedTopRowData();
      }), this.addManagedPropertyListener("pinnedBottomRowData", function() {
        return e.setPinnedBottomRowData();
      });
    }, t.prototype.isEmpty = function(e) {
      var r = e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
      return ri(r);
    }, t.prototype.isRowsToRender = function(e) {
      return !this.isEmpty(e);
    }, t.prototype.getRowAtPixel = function(e, r) {
      var n = r === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
      if (ri(n))
        return 0;
      for (var i = 0; i < n.length; i++) {
        var a = n[i], s = a.rowTop + a.rowHeight - 1;
        if (s >= e)
          return i;
      }
      return n.length - 1;
    }, t.prototype.setPinnedTopRowData = function() {
      var e = this.gridOptionsService.get("pinnedTopRowData");
      this.pinnedTopRows = this.createNodesFromData(e, !0);
      var r = {
        type: G.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.setPinnedBottomRowData = function() {
      var e = this.gridOptionsService.get("pinnedBottomRowData");
      this.pinnedBottomRows = this.createNodesFromData(e, !1);
      var r = {
        type: G.EVENT_PINNED_ROW_DATA_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.createNodesFromData = function(e, r) {
      var n = this, i = [];
      if (e) {
        var a = 0;
        e.forEach(function(s, l) {
          var u = new St(n.beans);
          u.data = s;
          var c = r ? St.ID_PREFIX_TOP_PINNED : St.ID_PREFIX_BOTTOM_PINNED;
          u.id = c + l, u.rowPinned = r ? "top" : "bottom", u.setRowTop(a), u.setRowHeight(n.gridOptionsService.getRowHeightForNode(u).height), u.setRowIndex(l), a += u.rowHeight, i.push(u);
        });
      }
      return i;
    }, t.prototype.getPinnedTopRowData = function() {
      return this.pinnedTopRows;
    }, t.prototype.getPinnedBottomRowData = function() {
      return this.pinnedBottomRows;
    }, t.prototype.getPinnedTopTotalHeight = function() {
      return this.getTotalHeight(this.pinnedTopRows);
    }, t.prototype.getPinnedTopRowCount = function() {
      return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    }, t.prototype.getPinnedBottomRowCount = function() {
      return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    }, t.prototype.getPinnedTopRow = function(e) {
      return this.pinnedTopRows[e];
    }, t.prototype.getPinnedBottomRow = function(e) {
      return this.pinnedBottomRows[e];
    }, t.prototype.forEachPinnedTopRow = function(e) {
      ri(this.pinnedTopRows) || this.pinnedTopRows.forEach(e);
    }, t.prototype.forEachPinnedBottomRow = function(e) {
      ri(this.pinnedBottomRows) || this.pinnedBottomRows.forEach(e);
    }, t.prototype.getPinnedBottomTotalHeight = function() {
      return this.getTotalHeight(this.pinnedBottomRows);
    }, t.prototype.getTotalHeight = function(e) {
      if (!e || e.length === 0)
        return 0;
      var r = Kt(e);
      return r.rowTop + r.rowHeight;
    }, nb([
      N("beans")
    ], t.prototype, "beans", void 0), nb([
      Fe
    ], t.prototype, "init", null), t = nb([
      Be("pinnedRowModel")
    ], t), t;
  }(Me)
), $S;
(function(o) {
  o.Applied = "Applied", o.StoreNotFound = "StoreNotFound", o.StoreLoading = "StoreLoading", o.StoreWaitingToLoad = "StoreWaitingToLoad", o.StoreLoadingFailed = "StoreLoadingFailed", o.StoreWrongType = "StoreWrongType", o.Cancelled = "Cancelled", o.StoreNotStarted = "StoreNotStarted";
})($S || ($S = {}));
var gv = (
  /** @class */
  function() {
    function o(t, e) {
      this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = t, this.pathRoot = {
        rowNode: e,
        children: null
      }, this.mapToItems[e.id] = this.pathRoot;
    }
    return o.prototype.setInactive = function() {
      this.active = !1;
    }, o.prototype.isActive = function() {
      return this.active;
    }, o.prototype.depthFirstSearchChangedPath = function(t, e) {
      if (t.children)
        for (var r = 0; r < t.children.length; r++)
          this.depthFirstSearchChangedPath(t.children[r], e);
      e(t.rowNode);
    }, o.prototype.depthFirstSearchEverything = function(t, e, r) {
      if (t.childrenAfterGroup)
        for (var n = 0; n < t.childrenAfterGroup.length; n++) {
          var i = t.childrenAfterGroup[n];
          i.childrenAfterGroup ? this.depthFirstSearchEverything(t.childrenAfterGroup[n], e, r) : r && e(i);
        }
      e(t);
    }, o.prototype.forEachChangedNodeDepthFirst = function(t, e, r) {
      e === void 0 && (e = !1), r === void 0 && (r = !1), this.active && !r ? this.depthFirstSearchChangedPath(this.pathRoot, t) : this.depthFirstSearchEverything(this.pathRoot.rowNode, t, e);
    }, o.prototype.executeFromRootNode = function(t) {
      t(this.pathRoot.rowNode);
    }, o.prototype.createPathItems = function(t) {
      for (var e = t, r = 0; !this.mapToItems[e.id]; ) {
        var n = {
          rowNode: e,
          children: null
        };
        this.mapToItems[e.id] = n, r++, e = e.parent;
      }
      return r;
    }, o.prototype.populateColumnsMap = function(t, e) {
      var r = this;
      if (!(!this.keepingColumns || !e))
        for (var n = t; n; )
          this.nodeIdsToColumns[n.id] || (this.nodeIdsToColumns[n.id] = {}), e.forEach(function(i) {
            return r.nodeIdsToColumns[n.id][i.getId()] = !0;
          }), n = n.parent;
    }, o.prototype.linkPathItems = function(t, e) {
      for (var r = t, n = 0; n < e; n++) {
        var i = this.mapToItems[r.id], a = this.mapToItems[r.parent.id];
        a.children || (a.children = []), a.children.push(i), r = r.parent;
      }
    }, o.prototype.addParentNode = function(t, e) {
      if (!(!t || t.isRowPinned())) {
        var r = this.createPathItems(t);
        this.linkPathItems(t, r), this.populateColumnsMap(t, e);
      }
    }, o.prototype.canSkip = function(t) {
      return this.active && !this.mapToItems[t.id];
    }, o.prototype.getValueColumnsForNode = function(t, e) {
      if (!this.keepingColumns)
        return e;
      var r = this.nodeIdsToColumns[t.id], n = e.filter(function(i) {
        return r[i.getId()];
      });
      return n;
    }, o.prototype.getNotValueColumnsForNode = function(t, e) {
      if (!this.keepingColumns)
        return null;
      var r = this.nodeIdsToColumns[t.id], n = e.filter(function(i) {
        return !r[i.getId()];
      });
      return n;
    }, o;
  }()
), kX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ly = (
  /** @class */
  function(o) {
    kX(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.state = t.STATE_WAITING_TO_LOAD, r.version = 0, r.id = e, r;
    }
    return t.prototype.getId = function() {
      return this.id;
    }, t.prototype.load = function() {
      this.state = t.STATE_LOADING, this.loadFromDatasource();
    }, t.prototype.getVersion = function() {
      return this.version;
    }, t.prototype.setStateWaitingToLoad = function() {
      this.version++, this.state = t.STATE_WAITING_TO_LOAD;
    }, t.prototype.getState = function() {
      return this.state;
    }, t.prototype.pageLoadFailed = function(e) {
      var r = this.isRequestMostRecentAndLive(e);
      r && (this.state = t.STATE_FAILED, this.processServerFail()), this.dispatchLoadCompleted(!1);
    }, t.prototype.success = function(e, r) {
      this.successCommon(e, r);
    }, t.prototype.pageLoaded = function(e, r, n) {
      this.successCommon(e, { rowData: r, rowCount: n });
    }, t.prototype.isRequestMostRecentAndLive = function(e) {
      var r = e === this.version, n = this.isAlive();
      return r && n;
    }, t.prototype.successCommon = function(e, r) {
      this.dispatchLoadCompleted();
      var n = this.isRequestMostRecentAndLive(e);
      n && (this.state = t.STATE_LOADED, this.processServerResult(r));
    }, t.prototype.dispatchLoadCompleted = function(e) {
      e === void 0 && (e = !0);
      var r = {
        type: t.EVENT_LOAD_COMPLETE,
        success: e,
        block: this
      };
      this.dispatchEvent(r);
    }, t.EVENT_LOAD_COMPLETE = "loadComplete", t.STATE_WAITING_TO_LOAD = "needsLoading", t.STATE_LOADING = "loading", t.STATE_LOADED = "loaded", t.STATE_FAILED = "failed", t;
  }(Me)
), GX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Wg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, VX = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, hL = (
  /** @class */
  function(o) {
    GX(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.activeBlockLoadsCount = 0, r.blocks = [], r.active = !0, r;
    }
    e = t, t.prototype.postConstruct = function() {
      this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
      var r = this.gridOptionsService.get("blockLoadDebounceMillis");
      r && r > 0 && (this.checkBlockToLoadDebounce = yt.debounce(this.performCheckBlocksToLoad.bind(this), r));
    }, t.prototype.setBeans = function(r) {
      this.logger = r.create("RowNodeBlockLoader");
    }, t.prototype.getMaxConcurrentDatasourceRequests = function() {
      var r = this.gridOptionsService.get("maxConcurrentDatasourceRequests");
      if (r == null)
        return 2;
      if (!(r <= 0))
        return r;
    }, t.prototype.addBlock = function(r) {
      this.blocks.push(r), r.addEventListener(ly.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this)), this.checkBlockToLoad();
    }, t.prototype.removeBlock = function(r) {
      yt.removeFromArray(this.blocks, r);
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.active = !1;
    }, t.prototype.loadComplete = function() {
      this.activeBlockLoadsCount--, this.checkBlockToLoad(), this.dispatchEvent({ type: e.BLOCK_LOADED_EVENT }), this.activeBlockLoadsCount == 0 && this.dispatchEvent({ type: e.BLOCK_LOADER_FINISHED_EVENT });
    }, t.prototype.checkBlockToLoad = function() {
      this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
    }, t.prototype.performCheckBlocksToLoad = function() {
      if (this.active) {
        if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
          this.logger.log("checkBlockToLoad: max loads exceeded");
          return;
        }
        var r = this.getAvailableLoadingCount(), n = this.blocks.filter(function(i) {
          return i.getState() === ly.STATE_WAITING_TO_LOAD;
        }).slice(0, r);
        this.registerLoads(n.length), n.forEach(function(i) {
          return i.load();
        }), this.printCacheStatus();
      }
    }, t.prototype.getBlockState = function() {
      if (this.gridOptionsService.isRowModelType("serverSide")) {
        var r = this.rowModel;
        return r.getBlockStates();
      }
      var n = {};
      return this.blocks.forEach(function(i) {
        var a = i.getBlockStateJson(), s = a.id, l = a.state;
        n[s] = l;
      }), n;
    }, t.prototype.printCacheStatus = function() {
      this.logger.isLogging() && this.logger.log("printCacheStatus: activePageLoadsCount = ".concat(this.activeBlockLoadsCount, ",") + " blocks = ".concat(JSON.stringify(this.getBlockState())));
    }, t.prototype.isLoading = function() {
      return this.activeBlockLoadsCount > 0;
    }, t.prototype.registerLoads = function(r) {
      this.activeBlockLoadsCount += r;
    }, t.prototype.getAvailableLoadingCount = function() {
      return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
    };
    var e;
    return t.BLOCK_LOADED_EVENT = "blockLoaded", t.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished", Wg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Wg([
      Fe
    ], t.prototype, "postConstruct", null), Wg([
      VX(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), t = e = Wg([
      Be("rowNodeBlockLoader")
    ], t), t;
  }(Me)
), HX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ob = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, vL = (
  /** @class */
  function(o) {
    HX(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.currentPage = 0, e.topDisplayedRowIndex = 0, e.bottomDisplayedRowIndex = 0, e.pixelOffset = 0, e.masterRowCount = 0, e;
    }
    return t.prototype.postConstruct = function() {
      this.active = this.gridOptionsService.get("pagination"), this.pageSizeFromGridOptions = this.gridOptionsService.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedListener(this.eventService, G.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this)), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this)), this.onModelUpdated();
    }, t.prototype.ensureRowHeightsValid = function(e, r, n, i) {
      var a = this.rowModel.ensureRowHeightsValid(e, r, this.getPageFirstRow(), this.getPageLastRow());
      return a && this.calculatePages(), a;
    }, t.prototype.isPaginateChildRows = function() {
      var e = this.gridOptionsService.get("groupRemoveSingleChildren") || this.gridOptionsService.get("groupRemoveLowestSingleChildren");
      return e ? !0 : this.gridOptionsService.get("paginateChildRows");
    }, t.prototype.onModelUpdated = function(e) {
      this.calculatePages();
      var r = {
        type: G.EVENT_PAGINATION_CHANGED,
        animate: e ? e.animate : !1,
        newData: e ? e.newData : !1,
        newPage: e ? e.newPage : !1,
        newPageSize: e ? e.newPageSize : !1,
        keepRenderedRows: e ? e.keepRenderedRows : !1
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.onPaginationGridOptionChanged = function() {
      this.active = this.gridOptionsService.get("pagination"), this.calculatePages();
      var e = {
        type: G.EVENT_PAGINATION_CHANGED,
        animate: !1,
        newData: !1,
        newPage: !1,
        newPageSize: !1,
        // important to keep rendered rows, otherwise every time grid is resized,
        // we would destroy all the rows.
        keepRenderedRows: !0
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.onPageSizeGridOptionChanged = function() {
      this.setPageSize(this.gridOptionsService.get("paginationPageSize"), "gridOptions");
    }, t.prototype.goToPage = function(e) {
      if (!(!this.active || this.currentPage === e || typeof this.currentPage != "number")) {
        this.currentPage = e;
        var r = {
          type: G.EVENT_MODEL_UPDATED,
          animate: !1,
          keepRenderedRows: !1,
          newData: !1,
          newPage: !0,
          newPageSize: !1
        };
        this.onModelUpdated(r);
      }
    }, t.prototype.getPixelOffset = function() {
      return this.pixelOffset;
    }, t.prototype.getRow = function(e) {
      return this.rowModel.getRow(e);
    }, t.prototype.getRowNode = function(e) {
      return this.rowModel.getRowNode(e);
    }, t.prototype.getRowIndexAtPixel = function(e) {
      return this.rowModel.getRowIndexAtPixel(e);
    }, t.prototype.getCurrentPageHeight = function() {
      return tt(this.topRowBounds) || tt(this.bottomRowBounds) ? 0 : Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
    }, t.prototype.getCurrentPagePixelRange = function() {
      var e = this.topRowBounds ? this.topRowBounds.rowTop : 0, r = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
      return { pageFirstPixel: e, pageLastPixel: r };
    }, t.prototype.isRowPresent = function(e) {
      if (!this.rowModel.isRowPresent(e))
        return !1;
      var r = e.rowIndex >= this.topDisplayedRowIndex && e.rowIndex <= this.bottomDisplayedRowIndex;
      return r;
    }, t.prototype.isEmpty = function() {
      return this.rowModel.isEmpty();
    }, t.prototype.isRowsToRender = function() {
      return this.rowModel.isRowsToRender();
    }, t.prototype.forEachNode = function(e) {
      return this.rowModel.forEachNode(e);
    }, t.prototype.forEachNodeOnPage = function(e) {
      for (var r = this.getPageFirstRow(), n = this.getPageLastRow(), i = r; i <= n; i++) {
        var a = this.getRow(i);
        a && e(a);
      }
    }, t.prototype.getType = function() {
      return this.rowModel.getType();
    }, t.prototype.getRowBounds = function(e) {
      var r = this.rowModel.getRowBounds(e);
      return r.rowIndex = e, r;
    }, t.prototype.getPageFirstRow = function() {
      return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
    }, t.prototype.getPageLastRow = function() {
      return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
    }, t.prototype.getRowCount = function() {
      return this.rowModel.getRowCount();
    }, t.prototype.getPageForIndex = function(e) {
      return Math.floor(e / this.pageSize);
    }, t.prototype.goToPageWithIndex = function(e) {
      if (this.active) {
        var r = this.getPageForIndex(e);
        this.goToPage(r);
      }
    }, t.prototype.isRowInPage = function(e) {
      if (!this.active)
        return !0;
      var r = this.getPageForIndex(e.rowIndex);
      return r === this.currentPage;
    }, t.prototype.isLastPageFound = function() {
      return this.rowModel.isLastRowIndexKnown();
    }, t.prototype.getCurrentPage = function() {
      return this.currentPage;
    }, t.prototype.goToNextPage = function() {
      this.goToPage(this.currentPage + 1);
    }, t.prototype.goToPreviousPage = function() {
      this.goToPage(this.currentPage - 1);
    }, t.prototype.goToFirstPage = function() {
      this.goToPage(0);
    }, t.prototype.goToLastPage = function() {
      var e = this.rowModel.getRowCount(), r = Math.floor(e / this.pageSize);
      this.goToPage(r);
    }, t.prototype.getPageSize = function() {
      return this.pageSize;
    }, t.prototype.getTotalPages = function() {
      return this.totalPages;
    }, t.prototype.setPage = function(e) {
      this.currentPage = e;
    }, Object.defineProperty(t.prototype, "pageSize", {
      get: function() {
        return Oe(this.pageSizeAutoCalculated) ? this.pageSizeAutoCalculated : Oe(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : Oe(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : Oe(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.unsetAutoCalculatedPageSize = function() {
      if (this.pageSizeAutoCalculated !== void 0) {
        var e = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0, this.pageSize !== e && this.onModelUpdated({
          type: G.EVENT_MODEL_UPDATED,
          animate: !1,
          keepRenderedRows: !1,
          newData: !1,
          newPage: !1,
          newPageSize: !0
        });
      }
    }, t.prototype.setPageSize = function(e, r) {
      var n = this.pageSize;
      switch (r) {
        case "autoCalculated":
          this.pageSizeAutoCalculated = e;
          break;
        case "pageSizeSelector":
          this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
          break;
        case "initialState":
          this.pageSizeFromInitialState = e;
          break;
        case "gridOptions":
          this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
          break;
      }
      if (n !== this.pageSize) {
        var i = {
          type: G.EVENT_MODEL_UPDATED,
          animate: !1,
          keepRenderedRows: !1,
          newData: !1,
          newPage: !1,
          newPageSize: !0
        };
        this.onModelUpdated(i);
      }
    }, t.prototype.calculatePages = function() {
      this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex), this.topRowBounds && (this.topRowBounds.rowIndex = this.topDisplayedRowIndex), this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex), this.bottomRowBounds && (this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex), this.setPixelOffset(Oe(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
    }, t.prototype.setPixelOffset = function(e) {
      this.pixelOffset !== e && (this.pixelOffset = e, this.eventService.dispatchEvent({ type: G.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED }));
    }, t.prototype.setZeroRows = function() {
      this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
    }, t.prototype.adjustCurrentPageIfInvalid = function() {
      this.currentPage >= this.totalPages && (this.currentPage = this.totalPages - 1), (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) && (this.currentPage = 0);
    }, t.prototype.calculatePagesMasterRowsOnly = function() {
      if (this.masterRowCount = this.rowModel.getTopLevelRowCount(), this.masterRowCount <= 0) {
        this.setZeroRows();
        return;
      }
      var e = this.masterRowCount - 1;
      this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid();
      var r = this.pageSize * this.currentPage, n = this.pageSize * (this.currentPage + 1) - 1;
      if (n > e && (n = e), this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(r), n === e)
        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
      else {
        var i = this.rowModel.getTopLevelRowDisplayedIndex(n + 1);
        this.bottomDisplayedRowIndex = i - 1;
      }
    }, t.prototype.getMasterRowCount = function() {
      return this.masterRowCount;
    }, t.prototype.calculatePagesAllRows = function() {
      if (this.masterRowCount = this.rowModel.getRowCount(), this.masterRowCount === 0) {
        this.setZeroRows();
        return;
      }
      var e = this.masterRowCount - 1;
      this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = this.pageSize * this.currentPage, this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1, this.bottomDisplayedRowIndex > e && (this.bottomDisplayedRowIndex = e);
    }, t.prototype.calculatedPagesNotActive = function() {
      this.setPageSize(this.masterRowCount, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    }, ob([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), ob([
      Fe
    ], t.prototype, "postConstruct", null), t = ob([
      Be("paginationProxy")
    ], t), t;
  }(Me)
), BX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), rP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, gL = (
  /** @class */
  function(o) {
    BX(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.processAllCellClasses = function(e, r, n, i) {
      this.processClassRules(void 0, e.cellClassRules, r, n, i), this.processStaticCellClasses(e, r, n);
    }, t.prototype.processClassRules = function(e, r, n, i, a) {
      if (!(r == null && e == null)) {
        var s = {}, l = {}, u = function(g, m) {
          g.split(" ").forEach(function(b) {
            b.trim() != "" && m(b);
          });
        };
        if (r)
          for (var c = Object.keys(r), d = function(g) {
            var m = c[g], b = r[m], S;
            typeof b == "string" ? S = f.expressionService.evaluate(b, n) : typeof b == "function" && (S = b(n)), u(m, function(R) {
              S ? s[R] = !0 : l[R] = !0;
            });
          }, f = this, v = 0; v < c.length; v++)
            d(v);
        e && a && Object.keys(e).forEach(function(g) {
          return u(g, function(m) {
            s[m] || (l[m] = !0);
          });
        }), a && Object.keys(l).forEach(a), Object.keys(s).forEach(i);
      }
    }, t.prototype.getStaticCellClasses = function(e, r) {
      var n = e.cellClass;
      if (!n)
        return [];
      var i;
      if (typeof n == "function") {
        var a = n;
        i = a(r);
      } else
        i = n;
      return typeof i == "string" && (i = [i]), i || [];
    }, t.prototype.processStaticCellClasses = function(e, r, n) {
      var i = this.getStaticCellClasses(e, r);
      i.forEach(function(a) {
        n(a);
      });
    }, rP([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), t = rP([
      Be("stylingService")
    ], t), t;
  }(Me)
), WX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mL = (
  /** @class */
  function(o) {
    WX(t, o);
    function t(e) {
      return o.call(this, e, "ag-toggle-button") || this;
    }
    return t.prototype.setValue = function(e, r) {
      return o.prototype.setValue.call(this, e, r), this.addOrRemoveCssClass("ag-selected", this.getValue()), this;
    }, t;
  }(fv)
), jX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), yL = (
  /** @class */
  function(o) {
    jX(t, o);
    function t(e) {
      return o.call(this, e, "ag-text-area", null, "textarea") || this;
    }
    return t.prototype.setValue = function(e, r) {
      var n = o.prototype.setValue.call(this, e, r);
      return this.eInput.value = e, n;
    }, t.prototype.setCols = function(e) {
      return this.eInput.cols = e, this;
    }, t.prototype.setRows = function(e) {
      return this.eInput.rows = e, this;
    }, t;
  }(Tl)
), UX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), CL = (
  /** @class */
  function(o) {
    UX(t, o);
    function t(e) {
      return o.call(this, e, "ag-date-field", "date") || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      o.prototype.postConstruct.call(this), this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
      var r = oa();
      this.addManagedListener(this.eInput, "mousedown", function() {
        e.isDisabled() || r || e.eInput.focus();
      }), this.eInput.step = "any";
    }, t.prototype.onWheel = function(e) {
      document.activeElement === this.eInput && e.preventDefault();
    }, t.prototype.setMin = function(e) {
      var r, n = e instanceof Date ? (r = Pi(e ?? null, !1)) !== null && r !== void 0 ? r : void 0 : e;
      return this.min === n ? this : (this.min = n, La(this.eInput, "min", n), this);
    }, t.prototype.setMax = function(e) {
      var r, n = e instanceof Date ? (r = Pi(e ?? null, !1)) !== null && r !== void 0 ? r : void 0 : e;
      return this.max === n ? this : (this.max = n, La(this.eInput, "max", n), this);
    }, t.prototype.setStep = function(e) {
      return this.step === e ? this : (this.step = e, La(this.eInput, "step", e), this);
    }, t.prototype.getDate = function() {
      var e;
      if (this.eInput.validity.valid)
        return (e = ko(this.getValue())) !== null && e !== void 0 ? e : void 0;
    }, t.prototype.setDate = function(e, r) {
      this.setValue(Pi(e ?? null, !1), r);
    }, t;
  }(zl)
), $X = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), wL = (
  /** @class */
  function(o) {
    $X(t, o);
    function t(e) {
      return o.call(this, e, "ag-range-field", "range") || this;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this);
      var e = this.config, r = e.min, n = e.max, i = e.step;
      r != null && this.setMinValue(r), n != null && this.setMaxValue(n), this.setStep(i || 1);
    }, t.prototype.addInputListeners = function() {
      var e = this;
      this.addManagedListener(this.eInput, "input", function(r) {
        var n = r.target.value;
        e.setValue(n);
      });
    }, t.prototype.setMinValue = function(e) {
      return this.min = e, this.eInput.setAttribute("min", e.toString()), this;
    }, t.prototype.setMaxValue = function(e) {
      return this.max = e, this.eInput.setAttribute("max", e.toString()), this;
    }, t.prototype.setStep = function(e) {
      return this.eInput.setAttribute("step", e.toString()), this;
    }, t.prototype.setValue = function(e, r) {
      this.min != null && (e = Math.max(parseFloat(e), this.min).toString()), this.max != null && (e = Math.min(parseFloat(e), this.max).toString());
      var n = o.prototype.setValue.call(this, e, r);
      return this.eInput.value = e, n;
    }, t;
  }(Tl)
), zX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), nP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, YX = (
  /** @class */
  function(o) {
    zX(t, o);
    function t(e, r) {
      var n = o.call(
        this,
        /* html */
        '<div class="ag-rich-select-row" role="presentation"></div>'
      ) || this;
      return n.params = e, n.wrapperEl = r, n;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.getGui(), "click", this.onClick.bind(this));
    }, t.prototype.setState = function(e) {
      var r = "";
      this.params.valueFormatter && (r = this.params.valueFormatter(e));
      var n = this.populateWithRenderer(e, r);
      n || this.populateWithoutRenderer(e, r), this.value = e;
    }, t.prototype.highlightString = function(e) {
      var r = this.parsedValue;
      if (!(this.params.cellRenderer || !Oe(r))) {
        var n = Oe(e);
        if (n) {
          var i = r == null ? void 0 : r.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
          if (i >= 0) {
            var a = i + e.length, s = vn(r.slice(0, i), !0), l = vn(r.slice(i, a), !0), u = vn(r.slice(a));
            this.renderValueWithoutRenderer("".concat(s, '<span class="ag-rich-select-row-text-highlight">').concat(l, "</span>").concat(u));
          } else
            n = !1;
        }
        n || this.renderValueWithoutRenderer(r);
      }
    }, t.prototype.updateHighlighted = function(e) {
      var r, n = this.getGui(), i = "ag-rich-select-row-".concat(this.getCompId());
      if ((r = n.parentElement) === null || r === void 0 || r.setAttribute("id", i), e) {
        var a = this.getParentComponent().getAriaElement();
        D1(a, i), this.wrapperEl.setAttribute("data-active-option", i);
      }
      lp(n.parentElement, e), this.addOrRemoveCssClass("ag-rich-select-row-selected", e);
    }, t.prototype.populateWithoutRenderer = function(e, r) {
      var n = this.gridOptionsService.getDocument(), i = this.getGui(), a = n.createElement("span");
      a.style.overflow = "hidden", a.style.textOverflow = "ellipsis";
      var s = vn(Oe(r) ? r : e, !0);
      this.parsedValue = Oe(s) ? s : null, i.appendChild(a), this.renderValueWithoutRenderer(s);
    }, t.prototype.renderValueWithoutRenderer = function(e) {
      var r = this.getGui().querySelector("span");
      r && (r.innerHTML = Oe(e) ? e : "&nbsp;");
    }, t.prototype.populateWithRenderer = function(e, r) {
      var n = this, i, a;
      return this.params.cellRenderer && (a = this.userComponentFactory.getCellRendererDetails(this.params, {
        value: e,
        valueFormatted: r
      })), a && (i = a.newAgStackInstance()), i && Z1(i, this.getGui()), i ? (i.then(function(s) {
        n.addDestroyFunc(function() {
          n.getContext().destroyBean(s);
        });
      }), !0) : !1;
    }, t.prototype.onClick = function() {
      var e = this.getParentComponent(), r = {
        type: G.EVENT_FIELD_PICKER_VALUE_SELECTED,
        fromEnterKey: !1,
        value: this.value
      };
      e == null || e.dispatchEvent(r);
    }, nP([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), nP([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), KX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, m_ = (
  /** @class */
  function(o) {
    KX(t, o);
    function t(e) {
      var r = o.call(this, t.getTemplate((e == null ? void 0 : e.cssIdentifier) || "default")) || this;
      r.renderedRows = /* @__PURE__ */ new Map(), r.rowHeight = 20;
      var n = e || {}, i = n.cssIdentifier, a = i === void 0 ? "default" : i, s = n.ariaRole, l = s === void 0 ? "listbox" : s, u = n.listName;
      return r.cssIdentifier = a, r.ariaRole = l, r.listName = u, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
        onFocusIn: function(r) {
          return e.onFocusIn(r);
        },
        onFocusOut: function(r) {
          return e.onFocusOut(r);
        },
        focusInnerElement: function(r) {
          return e.focusInnerElement(r);
        },
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      }), this.setAriaProperties(), this.addManagedListener(this.eventService, G.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
    }, t.prototype.onGridStylesChanged = function() {
      this.rowHeight = this.getItemHeight(), this.refresh();
    }, t.prototype.setAriaProperties = function() {
      var e = this.localeService.getLocaleTextFunc(), r = e("ariaDefaultListName", this.listName || "List"), n = this.eContainer;
      bn(n, this.ariaRole), Os(n, r);
    }, t.prototype.addResizeObserver = function() {
      var e = this, r = function() {
        return e.animationFrameService.requestAnimationFrame(function() {
          return e.drawVirtualRows();
        });
      }, n = this.resizeObserverService.observeResize(this.getGui(), r);
      this.addDestroyFunc(n);
    }, t.prototype.focusInnerElement = function(e) {
      this.focusRow(e ? this.model.getRowCount() - 1 : 0);
    }, t.prototype.onFocusIn = function(e) {
      var r = e.target;
      r.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = E2(r) - 1);
    }, t.prototype.onFocusOut = function(e) {
      this.getFocusableElement().contains(e.relatedTarget) || (this.lastFocusedRowIndex = null);
    }, t.prototype.handleKeyDown = function(e) {
      switch (e.key) {
        case we.UP:
        case we.DOWN:
          this.navigate(e.key === we.UP) && e.preventDefault();
          break;
      }
    }, t.prototype.onTabKeyDown = function(e) {
      this.navigate(e.shiftKey) ? e.preventDefault() : (Ba(e), this.forceFocusOutOfContainer(e.shiftKey));
    }, t.prototype.navigate = function(e) {
      if (this.lastFocusedRowIndex == null)
        return !1;
      var r = this.lastFocusedRowIndex + (e ? -1 : 1);
      return r < 0 || r >= this.model.getRowCount() ? !1 : (this.focusRow(r), !0);
    }, t.prototype.getLastFocusedRow = function() {
      return this.lastFocusedRowIndex;
    }, t.prototype.focusRow = function(e) {
      var r = this;
      this.ensureIndexVisible(e), window.setTimeout(function() {
        if (r.isAlive()) {
          var n = r.renderedRows.get(e);
          n && n.eDiv.focus();
        }
      }, 10);
    }, t.prototype.getComponentAt = function(e) {
      var r = this.renderedRows.get(e);
      return r && r.rowComponent;
    }, t.prototype.forEachRenderedRow = function(e) {
      this.renderedRows.forEach(function(r, n) {
        return e(r.rowComponent, n);
      });
    }, t.getTemplate = function(e) {
      return (
        /* html */
        '<div class="ag-virtual-list-viewport ag-'.concat(e, `-virtual-list-viewport" role="presentation">
                <div class="ag-virtual-list-container ag-`).concat(e, `-virtual-list-container" ref="eContainer"></div>
            </div>`)
      );
    }, t.prototype.getItemHeight = function() {
      return this.environment.getListItemHeight();
    }, t.prototype.ensureIndexVisible = function(e, r) {
      r === void 0 && (r = !0);
      var n = this.model.getRowCount();
      if (typeof e != "number" || e < 0 || e >= n)
        return console.warn("AG Grid: invalid row index for ensureIndexVisible: " + e), !1;
      var i = e * this.rowHeight, a = i + this.rowHeight, s = this.getGui(), l = s.scrollTop, u = s.offsetHeight, c = l + u, d = r ? 0 : this.rowHeight, f = l > i + d, v = c < a - d;
      if (f)
        return s.scrollTop = i, !0;
      if (v) {
        var g = a - u;
        return s.scrollTop = g, !0;
      }
      return !1;
    }, t.prototype.setComponentCreator = function(e) {
      this.componentCreator = e;
    }, t.prototype.setComponentUpdater = function(e) {
      this.componentUpdater = e;
    }, t.prototype.getRowHeight = function() {
      return this.rowHeight;
    }, t.prototype.getScrollTop = function() {
      return this.getGui().scrollTop;
    }, t.prototype.setRowHeight = function(e) {
      this.rowHeight = e, this.refresh();
    }, t.prototype.refresh = function(e) {
      var r = this;
      if (!(this.model == null || !this.isAlive())) {
        var n = this.model.getRowCount();
        this.eContainer.style.height = "".concat(n * this.rowHeight, "px"), b1(function() {
          return r.eContainer.clientHeight >= n * r.rowHeight;
        }, function() {
          r.isAlive() && (r.canSoftRefresh(e) ? r.drawVirtualRows(!0) : (r.clearVirtualRows(), r.drawVirtualRows()));
        });
      }
    }, t.prototype.canSoftRefresh = function(e) {
      return !!(e && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
    }, t.prototype.clearVirtualRows = function() {
      var e = this;
      this.renderedRows.forEach(function(r, n) {
        return e.removeRow(n);
      });
    }, t.prototype.drawVirtualRows = function(e) {
      if (!(!this.isAlive() || !this.model)) {
        var r = this.getGui(), n = r.scrollTop, i = n + r.offsetHeight, a = Math.floor(n / this.rowHeight), s = Math.floor(i / this.rowHeight);
        this.ensureRowsRendered(a, s, e);
      }
    }, t.prototype.ensureRowsRendered = function(e, r, n) {
      var i = this;
      this.renderedRows.forEach(function(s, l) {
        (l < e || l > r) && l !== i.lastFocusedRowIndex && i.removeRow(l);
      }), n && this.refreshRows();
      for (var a = e; a <= r; a++)
        this.renderedRows.has(a) || a < this.model.getRowCount() && this.insertRow(a);
    }, t.prototype.insertRow = function(e) {
      var r = this, n = this.model.getRow(e), i = document.createElement("div");
      i.classList.add("ag-virtual-list-item", "ag-".concat(this.cssIdentifier, "-virtual-list-item")), bn(i, this.ariaRole === "tree" ? "treeitem" : "option"), A1(i, this.model.getRowCount()), M1(i, e + 1), i.setAttribute("tabindex", "-1"), i.style.height = "".concat(this.rowHeight, "px"), i.style.top = "".concat(this.rowHeight * e, "px");
      var a = this.componentCreator(n, i);
      a.addGuiEventListener("focusin", function() {
        return r.lastFocusedRowIndex = e;
      }), i.appendChild(a.getGui()), this.renderedRows.has(e - 1) ? this.renderedRows.get(e - 1).eDiv.insertAdjacentElement("afterend", i) : this.renderedRows.has(e + 1) ? this.renderedRows.get(e + 1).eDiv.insertAdjacentElement("beforebegin", i) : this.eContainer.appendChild(i), this.renderedRows.set(e, { rowComponent: a, eDiv: i, value: n });
    }, t.prototype.removeRow = function(e) {
      var r = this.renderedRows.get(e);
      this.eContainer.removeChild(r.eDiv), this.destroyBean(r.rowComponent), this.renderedRows.delete(e);
    }, t.prototype.refreshRows = function() {
      var e = this, r = this.model.getRowCount();
      this.renderedRows.forEach(function(n, i) {
        var a, s;
        if (i >= r)
          e.removeRow(i);
        else {
          var l = e.model.getRow(i);
          !((s = (a = e.model).areRowsEqual) === null || s === void 0) && s.call(a, n.value, l) ? e.componentUpdater(l, n.rowComponent) : e.removeRow(i);
        }
      });
    }, t.prototype.addScrollListener = function() {
      var e = this;
      this.addGuiEventListener("scroll", function() {
        return e.drawVirtualRows();
      }, { passive: !0 });
    }, t.prototype.setModel = function(e) {
      this.model = e;
    }, t.prototype.getAriaElement = function() {
      return this.eContainer;
    }, t.prototype.destroy = function() {
      this.isAlive() && (this.clearVirtualRows(), o.prototype.destroy.call(this));
    }, jg([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), jg([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), jg([
      ke("eContainer")
    ], t.prototype, "eContainer", void 0), jg([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(vp)
), qX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uy = function() {
  return uy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, uy.apply(this, arguments);
}, oP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, XX = (
  /* html */
  `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`
), bL = (
  /** @class */
  function(o) {
    qX(t, o);
    function t(e) {
      var r = this, n, i;
      r = o.call(this, uy(uy({ pickerAriaLabelKey: "ariaLabelRichSelectField", pickerAriaLabelValue: "Rich Select Field", pickerType: "ag-list", className: "ag-rich-select", pickerIcon: "smallDown", ariaRole: "combobox", template: (n = e == null ? void 0 : e.template) !== null && n !== void 0 ? n : XX, modalPicker: !1 }, e), {
        // maxPickerHeight needs to be set after expanding `config`
        maxPickerHeight: (i = e == null ? void 0 : e.maxPickerHeight) !== null && i !== void 0 ? i : "calc(var(--ag-row-height) * 6.5)"
      })) || this, r.searchString = "", r.highlightedItem = -1, r.lastRowHovered = -1, r.searchStringCreator = null;
      var a = e || {}, s = a.cellRowHeight, l = a.value, u = a.valueList, c = a.searchStringCreator;
      return s != null && (r.cellRowHeight = s), l !== void 0 && (r.value = l), u != null && (r.values = u), c && (r.searchStringCreator = c), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      o.prototype.postConstruct.call(this), this.createLoadingElement(), this.createListComponent();
      var r = this.config, n = r.allowTyping, i = r.placeholder;
      n ? (this.eInput.setAutoComplete(!1).setInputPlaceholder(i), this.eDisplayField.classList.add("ag-hidden")) : this.eInput.setDisplayed(!1), this.eWrapper.tabIndex = this.gridOptionsService.get("tabIndex");
      var a = this.config.searchDebounceDelay, s = a === void 0 ? 300 : a;
      this.clearSearchString = Oi(this.clearSearchString, s), this.renderSelectedValue(), n && (this.eInput.onValueChange(function(l) {
        return e.searchTextFromString(l);
      }), this.addManagedListener(this.eWrapper, "focus", this.onWrapperFocus.bind(this))), this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }, t.prototype.createLoadingElement = function() {
      var e = this.gridOptionsService.getDocument(), r = this.localeService.getLocaleTextFunc(), n = e.createElement("div");
      n.classList.add("ag-loading-text"), n.innerText = r("loadingOoo", "Loading..."), this.eLoading = n;
    }, t.prototype.createListComponent = function() {
      var e = this;
      this.listComponent = this.createBean(new m_({ cssIdentifier: "rich-select" })), this.listComponent.setComponentCreator(this.createRowComponent.bind(this));
      var r = function(c, d) {
      };
      this.listComponent.setComponentUpdater(r), this.listComponent.setParentComponent(this), this.addManagedListener(this.listComponent, G.EVENT_FIELD_PICKER_VALUE_SELECTED, function(c) {
        e.onListValueSelected(c.value, c.fromEnterKey);
      });
      var n = this.cellRowHeight;
      n && this.listComponent.setRowHeight(n);
      var i = this.listComponent.getGui(), a = this.listComponent.getAriaElement();
      this.addManagedListener(i, "mousemove", this.onPickerMouseMove.bind(this)), this.addManagedListener(i, "mousedown", function(c) {
        return c.preventDefault();
      }), i.classList.add("ag-rich-select-list");
      var s = "ag-rich-select-list-".concat(this.listComponent.getCompId());
      a.setAttribute("id", s);
      var l = this.localeService.getLocaleTextFunc(), u = l(this.config.pickerAriaLabelKey, this.config.pickerAriaLabelValue);
      Os(a, u), L1(this.eWrapper, a);
    }, t.prototype.renderSelectedValue = function() {
      var e = this, r = this, n = r.value, i = r.eDisplayField, a = r.config, s = this.config, l = s.allowTyping, u = s.initialInputValue, c = this.config.valueFormatter ? this.config.valueFormatter(n) : n;
      if (l) {
        this.eInput.setValue(u ?? c);
        return;
      }
      var d;
      a.cellRenderer && (d = this.userComponentFactory.getCellRendererDetails(this.config, {
        value: n,
        valueFormatted: c
      }));
      var f;
      if (d && (f = d.newAgStackInstance()), f)
        An(i), Z1(f, i), f.then(function(g) {
          e.addDestroyFunc(function() {
            return e.getContext().destroyBean(g);
          });
        });
      else if (Oe(this.value))
        i.innerText = c, i.classList.remove("ag-display-as-placeholder");
      else {
        var v = a.placeholder;
        Oe(v) ? (i.innerHTML = "".concat(vn(v)), i.classList.add("ag-display-as-placeholder")) : An(i);
      }
    }, t.prototype.getCurrentValueIndex = function() {
      var e = this, r = e.currentList, n = e.value;
      if (n == null || !r)
        return -1;
      for (var i = 0; i < r.length; i++)
        if (r[i] === n)
          return i;
      return -1;
    }, t.prototype.highlightFilterMatch = function() {
      var e = this, r;
      (r = this.listComponent) === null || r === void 0 || r.forEachRenderedRow(function(n, i) {
        n.highlightString(e.searchString);
      });
    }, t.prototype.highlightSelectedValue = function(e) {
      var r = this, n;
      e == null && (e = this.getCurrentValueIndex()), this.highlightedItem = e, (n = this.listComponent) === null || n === void 0 || n.forEachRenderedRow(function(i, a) {
        var s = e === -1 ? !1 : r.highlightedItem === a;
        i.updateHighlighted(s);
      });
    }, t.prototype.setRowHeight = function(e) {
      e !== this.cellRowHeight && (this.cellRowHeight = e), this.listComponent && this.listComponent.setRowHeight(e);
    }, t.prototype.createPickerComponent = function() {
      var e = this.values;
      return e && this.setValueList({ valueList: e }), this.listComponent;
    }, t.prototype.setSearchStringCreator = function(e) {
      this.searchStringCreator = e;
    }, t.prototype.setValueList = function(e) {
      var r = e.valueList, n = e.refresh;
      this.listComponent && this.currentList !== r && (this.currentList = r, this.listComponent.setModel({
        getRowCount: function() {
          return r.length;
        },
        getRow: function(i) {
          return r[i];
        },
        areRowsEqual: function(i, a) {
          return i === a;
        }
      }), n && (this.values ? this.listComponent.refresh(!0) : (this.values = r, this.isPickerDisplayed && this.showCurrentValueInPicker())));
    }, t.prototype.showPicker = function() {
      o.prototype.showPicker.call(this), this.showCurrentValueInPicker(), this.displayOrHidePicker();
    }, t.prototype.showCurrentValueInPicker = function() {
      var e, r;
      if (this.listComponent) {
        if (!this.currentList) {
          this.isPickerDisplayed && this.eLoading && this.listComponent.appendChild(this.eLoading);
          return;
        }
        !((e = this.eLoading) === null || e === void 0) && e.offsetParent && ((r = this.eLoading.parentElement) === null || r === void 0 || r.removeChild(this.eLoading));
        var n = this.getCurrentValueIndex();
        n !== -1 ? (this.listComponent.refresh(), this.listComponent.ensureIndexVisible(n), this.listComponent.refresh(!0), this.highlightSelectedValue(n)) : this.listComponent.refresh();
      }
    }, t.prototype.beforeHidePicker = function() {
      this.highlightedItem = -1, o.prototype.beforeHidePicker.call(this);
    }, t.prototype.onWrapperFocus = function() {
      if (this.eInput) {
        var e = this.eInput.getFocusableElement();
        e.focus(), e.select();
      }
    }, t.prototype.onWrapperFocusOut = function(e) {
      this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
    }, t.prototype.buildSearchStringFromKeyboardEvent = function(e) {
      var r = e.key;
      if (r === we.BACKSPACE)
        this.searchString = this.searchString.slice(0, -1), r = "";
      else if (!rC(e))
        return;
      e.preventDefault(), this.searchTextFromCharacter(r);
    }, t.prototype.searchTextFromCharacter = function(e) {
      this.searchString += e, this.runSearch(), this.clearSearchString();
    }, t.prototype.searchTextFromString = function(e) {
      e == null && (e = ""), this.searchString = e, this.runSearch();
    }, t.prototype.buildSearchStrings = function(e) {
      var r = this.config.valueFormatter, n = r === void 0 ? function(a) {
        return a;
      } : r, i;
      return typeof e[0] == "number" || typeof e[0] == "string" ? i = e.map(function(a) {
        return n(a);
      }) : typeof e[0] == "object" && this.searchStringCreator && (i = this.searchStringCreator(e)), i;
    }, t.prototype.getSuggestionsAndFilteredValues = function(e, r) {
      var n = this, i = [], a = [];
      if (!e.length)
        return { suggestions: i, filteredValues: a };
      var s = this.config, l = s.searchType, u = l === void 0 ? "fuzzy" : l, c = s.filterList;
      if (u === "fuzzy") {
        var d = dv(this.searchString, r, !0);
        i = d.values;
        var f = d.indices;
        if (c && f.length)
          for (var v = 0; v < f.length; v++)
            a.push(this.values[f[v]]);
      } else
        i = r.filter(function(g, m) {
          var b = g.toLocaleLowerCase(), S = n.searchString.toLocaleLowerCase(), R = u === "match" ? b.startsWith(S) : b.indexOf(S) !== -1;
          return c && R && a.push(n.values[m]), R;
        });
      return { suggestions: i, filteredValues: a };
    }, t.prototype.filterListModel = function(e) {
      var r = this.config.filterList;
      r && (this.setValueList({ valueList: e, refresh: !0 }), this.alignPickerToComponent());
    }, t.prototype.runSearch = function() {
      var e, r, n = this.values, i = this.buildSearchStrings(n);
      if (!i) {
        this.highlightSelectedValue(-1);
        return;
      }
      var a = this.getSuggestionsAndFilteredValues(this.searchString, i), s = a.suggestions, l = a.filteredValues, u = this.config, c = u.filterList, d = u.highlightMatch, f = u.searchType, v = f === void 0 ? "fuzzy" : f, g = l.length, m = !!(c && this.searchString !== "");
      if (this.filterListModel(m ? l : n), s.length) {
        var b = m ? 0 : i.indexOf(s[0]);
        this.selectListItem(b);
      } else if (this.highlightSelectedValue(-1), !m || g)
        (e = this.listComponent) === null || e === void 0 || e.ensureIndexVisible(0);
      else if (m) {
        this.getAriaElement().removeAttribute("data-active-option");
        var S = (r = this.listComponent) === null || r === void 0 ? void 0 : r.getAriaElement();
        S && D1(S, null);
      }
      d && v !== "fuzzy" && this.highlightFilterMatch(), this.displayOrHidePicker();
    }, t.prototype.displayOrHidePicker = function() {
      var e, r = (e = this.listComponent) === null || e === void 0 ? void 0 : e.getGui(), n = this.currentList ? this.currentList.length === 0 : !1;
      r == null || r.classList.toggle("ag-hidden", n);
    }, t.prototype.clearSearchString = function() {
      this.searchString = "";
    }, t.prototype.selectListItem = function(e, r) {
      if (!(!this.isPickerDisplayed || !this.currentList || !this.listComponent || e < 0 || e >= this.currentList.length)) {
        var n = this.listComponent.ensureIndexVisible(e, !r);
        n && !r && this.listComponent.refresh(!0), this.highlightSelectedValue(e);
      }
    }, t.prototype.setValue = function(e, r, n) {
      var i = this.currentList ? this.currentList.indexOf(e) : -1;
      return i === -1 ? this : (this.value = e, n || this.selectListItem(i), this.renderSelectedValue(), o.prototype.setValue.call(this, e, r));
    }, t.prototype.createRowComponent = function(e) {
      var r = new YX(this.config, this.eWrapper);
      r.setParentComponent(this.listComponent), this.getContext().createBean(r), r.setState(e);
      var n = this.config, i = n.highlightMatch, a = n.searchType, s = a === void 0 ? "fuzzy" : a;
      return i && s !== "fuzzy" && r.highlightString(this.searchString), r;
    }, t.prototype.getRowForMouseEvent = function(e) {
      var r = this.listComponent;
      if (!r)
        return -1;
      var n = r == null ? void 0 : r.getGui(), i = n.getBoundingClientRect(), a = r.getScrollTop(), s = e.clientY - i.top + a;
      return Math.floor(s / r.getRowHeight());
    }, t.prototype.onPickerMouseMove = function(e) {
      if (this.listComponent) {
        var r = this.getRowForMouseEvent(e);
        r !== -1 && r != this.lastRowHovered && (this.lastRowHovered = r, this.selectListItem(r, !0));
      }
    }, t.prototype.onNavigationKeyDown = function(e, r) {
      e.preventDefault();
      var n = r === we.DOWN;
      if (!this.isPickerDisplayed && n) {
        this.showPicker();
        return;
      }
      var i = this.highlightedItem, a = n ? 1 : -1, s = i === -1 ? 0 : i + a;
      this.selectListItem(s);
    }, t.prototype.onEnterKeyDown = function(e) {
      this.isPickerDisplayed && (e.preventDefault(), this.currentList && this.onListValueSelected(this.currentList[this.highlightedItem], !0));
    }, t.prototype.onTabKeyDown = function() {
      !this.isPickerDisplayed || !this.currentList || this.setValue(this.currentList[this.highlightedItem], !1, !0);
    }, t.prototype.onListValueSelected = function(e, r) {
      this.setValue(e, !1, !0), this.dispatchPickerEvent(e, r), this.hidePicker();
    }, t.prototype.dispatchPickerEvent = function(e, r) {
      var n = {
        type: G.EVENT_FIELD_PICKER_VALUE_SELECTED,
        fromEnterKey: r,
        value: e
      };
      this.dispatchEvent(n);
    }, t.prototype.getFocusableElement = function() {
      var e = this.config.allowTyping;
      return e ? this.eInput.getFocusableElement() : o.prototype.getFocusableElement.call(this);
    }, t.prototype.onKeyDown = function(e) {
      var r = e.key, n = this.config.allowTyping;
      switch (r) {
        case we.LEFT:
        case we.RIGHT:
        case we.PAGE_HOME:
        case we.PAGE_END:
          n || e.preventDefault();
          break;
        case we.PAGE_UP:
        case we.PAGE_DOWN:
          e.preventDefault();
          break;
        case we.DOWN:
        case we.UP:
          this.onNavigationKeyDown(e, r);
          break;
        case we.ESCAPE:
          this.isPickerDisplayed && (ai(this.listComponent.getGui()) && (e.preventDefault(), Ba(e)), this.hidePicker());
          break;
        case we.ENTER:
          this.onEnterKeyDown(e);
          break;
        case we.TAB:
          this.onTabKeyDown();
          break;
        default:
          n || this.buildSearchStringFromKeyboardEvent(e);
      }
    }, t.prototype.destroy = function() {
      this.listComponent && (this.destroyBean(this.listComponent), this.listComponent = void 0), this.eLoading = void 0, o.prototype.destroy.call(this);
    }, oP([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), oP([
      ke("eInput")
    ], t.prototype, "eInput", void 0), t;
  }(n_)
), ZX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ug = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, SL = (
  /** @class */
  function(o) {
    ZX(t, o);
    function t(e) {
      var r = o.call(this, e, t.TEMPLATE) || this;
      return r.labelAlignment = "top", r;
    }
    return t.prototype.init = function() {
      this.eSlider.addCssClass("ag-slider-field");
    }, t.prototype.onValueChange = function(e) {
      var r = this, n = G.EVENT_FIELD_VALUE_CHANGED;
      return this.addManagedListener(this.eText, n, function() {
        var i = parseFloat(r.eText.getValue());
        r.eSlider.setValue(i.toString(), !0), e(i || 0);
      }), this.addManagedListener(this.eSlider, n, function() {
        var i = r.eSlider.getValue();
        r.eText.setValue(i, !0), e(parseFloat(i));
      }), this;
    }, t.prototype.setSliderWidth = function(e) {
      return this.eSlider.setWidth(e), this;
    }, t.prototype.setTextFieldWidth = function(e) {
      return this.eText.setWidth(e), this;
    }, t.prototype.setMinValue = function(e) {
      return this.eSlider.setMinValue(e), this.eText.setMin(e), this;
    }, t.prototype.setMaxValue = function(e) {
      return this.eSlider.setMaxValue(e), this.eText.setMax(e), this;
    }, t.prototype.getValue = function() {
      return this.eText.getValue();
    }, t.prototype.setValue = function(e) {
      return this.getValue() === e ? this : (this.eText.setValue(e, !0), this.eSlider.setValue(e, !0), this.dispatchEvent({ type: G.EVENT_FIELD_VALUE_CHANGED }), this);
    }, t.prototype.setStep = function(e) {
      return this.eSlider.setStep(e), this.eText.setStep(e), this;
    }, t.TEMPLATE = `<div class="ag-slider">
            <label ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range ref="eSlider"></ag-input-range>
                <ag-input-number-field ref="eText"></ag-input-number-field>
            </div>
        </div>`, Ug([
      ke("eLabel")
    ], t.prototype, "eLabel", void 0), Ug([
      ke("eSlider")
    ], t.prototype, "eSlider", void 0), Ug([
      ke("eText")
    ], t.prototype, "eText", void 0), Ug([
      Fe
    ], t.prototype, "init", null), t;
  }(t_)
), QX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), dl = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, EL = (
  /** @class */
  function(o) {
    QX(t, o);
    function t(e) {
      e === void 0 && (e = {});
      var r = o.call(this, t.getTemplate(e)) || this;
      r.suppressEnabledCheckbox = !0, r.suppressOpenCloseIcons = !1;
      var n = e.title, i = e.enabled, a = e.items, s = e.suppressEnabledCheckbox, l = e.suppressOpenCloseIcons;
      return r.title = n, r.cssIdentifier = e.cssIdentifier || "default", r.enabled = i ?? !0, r.items = a || [], r.alignItems = e.alignItems || "center", s != null && (r.suppressEnabledCheckbox = s), l != null && (r.suppressOpenCloseIcons = l), r;
    }
    return t.getTemplate = function(e) {
      var r = e.cssIdentifier || "default", n = e.direction || "vertical";
      return (
        /* html */
        '<div class="ag-group ag-'.concat(r, `-group" role="presentation">
            <div class="ag-group-title-bar ag-`).concat(r, `-group-title-bar ag-unselectable" ref="eTitleBar" role="button">
                <span class="ag-group-title-bar-icon ag-`).concat(r, `-group-title-bar-icon" ref="eGroupOpenedIcon" role="presentation"></span>
                <span class="ag-group-title-bar-icon ag-`).concat(r, `-group-title-bar-icon" ref="eGroupClosedIcon" role="presentation"></span>
                <span ref="eTitle" class="ag-group-title ag-`).concat(r, `-group-title"></span>
            </div>
            <div ref="eToolbar" class="ag-group-toolbar ag-`).concat(r, `-group-toolbar">
                <ag-checkbox ref="cbGroupEnabled"></ag-checkbox>
            </div>
            <div ref="eContainer" class="ag-group-container ag-group-container-`).concat(n, " ag-").concat(r, `-group-container"></div>
        </div>`)
      );
    }, t.prototype.postConstruct = function() {
      if (this.items.length) {
        var e = this.items;
        this.items = [], this.addItems(e);
      }
      var r = this.localeService.getLocaleTextFunc();
      this.cbGroupEnabled.setLabel(r("enabled", "Enabled")), this.title && this.setTitle(this.title), this.enabled && this.setEnabled(this.enabled), this.setAlignItems(this.alignItems), this.hideEnabledCheckbox(this.suppressEnabledCheckbox), this.hideOpenCloseIcons(this.suppressOpenCloseIcons), this.setupExpandContract(), this.refreshAriaStatus(), this.refreshChildDisplay();
    }, t.prototype.setupExpandContract = function() {
      var e = this;
      this.eGroupClosedIcon.appendChild(Ti("columnSelectClosed", this.gridOptionsService, null)), this.eGroupOpenedIcon.appendChild(Ti("columnSelectOpen", this.gridOptionsService, null)), this.addManagedListener(this.eTitleBar, "click", function() {
        return e.toggleGroupExpand();
      }), this.addManagedListener(this.eTitleBar, "keydown", function(r) {
        switch (r.key) {
          case we.ENTER:
          case we.SPACE:
            r.preventDefault(), e.toggleGroupExpand();
            break;
          case we.RIGHT:
          case we.LEFT:
            r.preventDefault(), e.toggleGroupExpand(r.key === we.RIGHT);
            break;
        }
      });
    }, t.prototype.refreshAriaStatus = function() {
      this.suppressOpenCloseIcons || ea(this.eTitleBar, this.expanded);
    }, t.prototype.refreshChildDisplay = function() {
      var e = !this.suppressOpenCloseIcons;
      Vt(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox), Vt(this.eGroupOpenedIcon, e && this.expanded), Vt(this.eGroupClosedIcon, e && !this.expanded);
    }, t.prototype.isExpanded = function() {
      return this.expanded;
    }, t.prototype.setAlignItems = function(e) {
      this.alignItems !== e && this.removeCssClass("ag-group-item-alignment-".concat(this.alignItems)), this.alignItems = e;
      var r = "ag-group-item-alignment-".concat(this.alignItems);
      return this.addCssClass(r), this;
    }, t.prototype.toggleGroupExpand = function(e) {
      return this.suppressOpenCloseIcons ? (this.expanded = !0, this.refreshChildDisplay(), Vt(this.eContainer, !0), this) : (e = e ?? !this.expanded, this.expanded === e ? this : (this.expanded = e, this.refreshAriaStatus(), this.refreshChildDisplay(), Vt(this.eContainer, e), this.dispatchEvent({ type: this.expanded ? t.EVENT_EXPANDED : t.EVENT_COLLAPSED }), this));
    }, t.prototype.addItems = function(e) {
      var r = this;
      e.forEach(function(n) {
        return r.addItem(n);
      });
    }, t.prototype.addItem = function(e) {
      var r = this.eContainer, n = e instanceof gt ? e.getGui() : e;
      n.classList.add("ag-group-item", "ag-".concat(this.cssIdentifier, "-group-item")), r.appendChild(n), this.items.push(n);
    }, t.prototype.hideItem = function(e, r) {
      var n = this.items[r];
      Vt(n, !e);
    }, t.prototype.setTitle = function(e) {
      return this.eTitle.innerText = e, this;
    }, t.prototype.addCssClassToTitleBar = function(e) {
      this.eTitleBar.classList.add(e);
    }, t.prototype.setEnabled = function(e, r) {
      return this.enabled = e, this.refreshDisabledStyles(), this.toggleGroupExpand(e), r || this.cbGroupEnabled.setValue(e), this;
    }, t.prototype.isEnabled = function() {
      return this.enabled;
    }, t.prototype.onEnableChange = function(e) {
      var r = this;
      return this.cbGroupEnabled.onValueChange(function(n) {
        r.setEnabled(n, !0), e(n);
      }), this;
    }, t.prototype.hideEnabledCheckbox = function(e) {
      return this.suppressEnabledCheckbox = e, this.refreshChildDisplay(), this.refreshDisabledStyles(), this;
    }, t.prototype.hideOpenCloseIcons = function(e) {
      return this.suppressOpenCloseIcons = e, e && this.toggleGroupExpand(!0), this;
    }, t.prototype.refreshDisabledStyles = function() {
      this.addOrRemoveCssClass("ag-disabled", !this.enabled), this.suppressEnabledCheckbox && !this.enabled ? (this.eTitleBar.classList.add("ag-disabled-group-title-bar"), this.eTitleBar.removeAttribute("tabindex")) : (this.eTitleBar.classList.remove("ag-disabled-group-title-bar"), this.eTitleBar.setAttribute("tabindex", "0")), this.eContainer.classList.toggle("ag-disabled-group-container", !this.enabled);
    }, t.EVENT_EXPANDED = "expanded", t.EVENT_COLLAPSED = "collapsed", dl([
      ke("eTitleBar")
    ], t.prototype, "eTitleBar", void 0), dl([
      ke("eGroupOpenedIcon")
    ], t.prototype, "eGroupOpenedIcon", void 0), dl([
      ke("eGroupClosedIcon")
    ], t.prototype, "eGroupClosedIcon", void 0), dl([
      ke("eToolbar")
    ], t.prototype, "eToolbar", void 0), dl([
      ke("cbGroupEnabled")
    ], t.prototype, "cbGroupEnabled", void 0), dl([
      ke("eTitle")
    ], t.prototype, "eTitle", void 0), dl([
      ke("eContainer")
    ], t.prototype, "eContainer", void 0), dl([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), JX = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), cy = function() {
  return cy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, cy.apply(this, arguments);
}, iP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, _L = (
  /** @class */
  function(o) {
    JX(t, o);
    function t(e) {
      e === void 0 && (e = 1);
      var r = o.call(
        this,
        /* html */
        '<div class="ag-menu-list" role="tree"></div>'
      ) || this;
      return r.level = e, r.menuItems = [], r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.initialiseTabGuard({
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      });
    }, t.prototype.onTabKeyDown = function(e) {
      var r = this.getParentComponent(), n = r && r.getGui(), i = n && n.classList.contains("ag-focus-managed");
      i || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
    }, t.prototype.handleKeyDown = function(e) {
      switch (e.key) {
        case we.UP:
        case we.RIGHT:
        case we.DOWN:
        case we.LEFT:
          e.preventDefault(), this.handleNavKey(e.key);
          break;
        case we.ESCAPE:
          var r = this.findTopMenu();
          r && this.focusService.focusInto(r.getGui());
          break;
      }
    }, t.prototype.clearActiveItem = function() {
      this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
    }, t.prototype.addMenuItems = function(e) {
      var r = this;
      e != null && e.forEach(function(n) {
        n === "separator" ? r.addSeparator() : typeof n == "string" ? console.warn("AG Grid: unrecognised menu item ".concat(n)) : r.addItem(n);
      });
    }, t.prototype.addItem = function(e) {
      var r = this, n = this.createManagedBean(new Hd(cy(cy({}, e), { isAnotherSubMenuOpen: function() {
        return r.menuItems.some(function(i) {
          return i.isSubMenuOpen();
        });
      } })));
      n.setParentComponent(this), T2(n.getGui(), this.level), this.menuItems.push(n), this.appendChild(n.getGui()), this.addManagedListener(n, Hd.EVENT_MENU_ITEM_SELECTED, function(i) {
        r.dispatchEvent(i);
      }), this.addManagedListener(n, Hd.EVENT_MENU_ITEM_ACTIVATED, function(i) {
        r.activeMenuItem && r.activeMenuItem !== i.menuItem && r.activeMenuItem.deactivate(), r.activeMenuItem = i.menuItem;
      });
    }, t.prototype.activateFirstItem = function() {
      var e = this.menuItems.filter(function(r) {
        return !r.isDisabled();
      })[0];
      e && e.activate();
    }, t.prototype.addSeparator = function() {
      var e = (
        /* html */
        `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`
      );
      this.appendChild(No(e));
    }, t.prototype.findTopMenu = function() {
      var e = this.getParentComponent();
      if (!e && this instanceof t)
        return this;
      for (; ; ) {
        var r = e && e.getParentComponent && e.getParentComponent();
        if (!r || !(r instanceof t || r instanceof Hd))
          break;
        e = r;
      }
      return e instanceof t ? e : void 0;
    }, t.prototype.handleNavKey = function(e) {
      switch (e) {
        case we.UP:
        case we.DOWN:
          var r = this.findNextItem(e === we.UP);
          r && r !== this.activeMenuItem && r.activate();
          return;
      }
      var n = this.gridOptionsService.get("enableRtl") ? we.RIGHT : we.LEFT;
      e === n ? this.closeIfIsChild() : this.openChild();
    }, t.prototype.closeIfIsChild = function(e) {
      var r = this.getParentComponent();
      r && r instanceof Hd && (e && e.preventDefault(), r.closeSubMenu(), r.getGui().focus());
    }, t.prototype.openChild = function() {
      this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
    }, t.prototype.findNextItem = function(e) {
      var r = this.menuItems.filter(function(l) {
        return !l.isDisabled();
      });
      if (r.length) {
        if (!this.activeMenuItem)
          return e ? Kt(r) : r[0];
        e && r.reverse();
        for (var n, i = !1, a = 0; a < r.length; a++) {
          var s = r[a];
          if (!i) {
            s === this.activeMenuItem && (i = !0);
            continue;
          }
          n = s;
          break;
        }
        return n || this.activeMenuItem;
      }
    }, t.prototype.destroy = function() {
      this.clearActiveItem(), o.prototype.destroy.call(this);
    }, iP([
      N("focusService")
    ], t.prototype, "focusService", void 0), iP([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(vp)
), eZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tZ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, xL = (
  /** @class */
  function(o) {
    eZ(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.wrappedComponent = e, r.setTemplateFromElement(e.getGui()), r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.initialiseTabGuard({
        onTabKeyDown: function(r) {
          return e.onTabKeyDown(r);
        },
        handleKeyDown: function(r) {
          return e.handleKeyDown(r);
        }
      });
    }, t.prototype.handleKeyDown = function(e) {
      e.key === we.ESCAPE && this.closePanel();
    }, t.prototype.onTabKeyDown = function(e) {
      e.defaultPrevented || (this.closePanel(), e.preventDefault());
    }, t.prototype.closePanel = function() {
      var e = this.parentComponent;
      e.closeSubMenu(), setTimeout(function() {
        return e.getGui().focus();
      }, 0);
    }, tZ([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(vp)
), rZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), aP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Hd = (
  /** @class */
  function(o) {
    rZ(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.params = e, r.isActive = !1, r.subMenuIsOpen = !1, r.setTemplate(
        /* html */
        '<div class="'.concat(r.getClassName(), '" tabindex="-1" role="treeitem"></div>')
      ), r;
    }
    return t.prototype.init = function() {
      var e = this;
      this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu(), this.addTooltip();
      var r = this.getGui();
      this.params.disabled ? (this.addCssClass(this.getClassName("disabled")), P1(r, !0)) : (this.addGuiEventListener("click", function(n) {
        return e.onItemSelected(n);
      }), this.addGuiEventListener("keydown", function(n) {
        (n.key === we.ENTER || n.key === we.SPACE) && (n.preventDefault(), e.onItemSelected(n));
      }), this.addGuiEventListener("mousedown", function(n) {
        n.stopPropagation(), n.preventDefault();
      }), this.addGuiEventListener("mouseenter", function() {
        return e.onMouseEnter();
      }), this.addGuiEventListener("mouseleave", function() {
        return e.onMouseLeave();
      })), this.params.cssClasses && this.params.cssClasses.forEach(function(n) {
        return e.addCssClass(n);
      });
    }, t.prototype.isDisabled = function() {
      return !!this.params.disabled;
    }, t.prototype.openSubMenu = function(e) {
      var r = this;
      if (e === void 0 && (e = !1), this.closeSubMenu(), !!this.params.subMenu) {
        var n = No(
          /* html */
          '<div class="ag-menu" role="presentation"></div>'
        ), i;
        if (this.params.subMenu instanceof Array) {
          var a = S2(this.getGui()), s = isNaN(a) ? 1 : a + 1, l = this.createBean(new _L(s));
          l.setParentComponent(this), l.addMenuItems(this.params.subMenu), n.appendChild(l.getGui()), this.addManagedListener(l, t.EVENT_MENU_ITEM_SELECTED, function(R) {
            return r.dispatchEvent(R);
          }), l.addGuiEventListener("mouseenter", function() {
            return r.cancelDeactivate();
          }), i = function() {
            return r.destroyBean(l);
          }, e && setTimeout(function() {
            return l.activateFirstItem();
          }, 0);
        } else {
          var u = this.params.subMenu, c = this.createBean(new xL(u));
          c.setParentComponent(this);
          var d = c.getGui(), f = "mouseenter", v = function() {
            return r.cancelDeactivate();
          };
          d.addEventListener(f, v), i = function() {
            return d.removeEventListener(f, v);
          }, n.appendChild(d), u.afterGuiAttached && setTimeout(function() {
            return u.afterGuiAttached();
          }, 0);
        }
        var g = this.getGui(), m = this.popupService.positionPopupForMenu.bind(this.popupService, { eventSource: g, ePopup: n }), b = this.localeService.getLocaleTextFunc(), S = this.popupService.addPopup({
          modal: !0,
          eChild: n,
          positionCallback: m,
          anchorToElement: g,
          ariaLabel: b("ariaLabelSubMenu", "SubMenu")
        });
        this.subMenuIsOpen = !0, ea(g, !0), this.hideSubMenu = function() {
          S && S.hideFunc(), r.subMenuIsOpen = !1, ea(g, !1), i();
        };
      }
    }, t.prototype.closeSubMenu = function() {
      this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, ea(this.getGui(), !1));
    }, t.prototype.isSubMenuOpen = function() {
      return this.subMenuIsOpen;
    }, t.prototype.activate = function(e) {
      var r = this;
      this.cancelActivate(), !this.params.disabled && (this.isActive = !0, this.addCssClass(this.getClassName("active")), this.getGui().focus(), e && this.params.subMenu && window.setTimeout(function() {
        r.isAlive() && r.isActive && r.openSubMenu();
      }, 300), this.onItemActivated());
    }, t.prototype.deactivate = function() {
      this.cancelDeactivate(), this.removeCssClass(this.getClassName("active")), this.isActive = !1, this.subMenuIsOpen && this.hideSubMenu();
    }, t.prototype.addIcon = function() {
      if (!(!this.params.checked && !this.params.icon && this.params.isCompact)) {
        var e = No(
          /* html */
          '<span ref="eIcon" class="'.concat(this.getClassName("part"), " ").concat(this.getClassName("icon"), '" role="presentation"></span>')
        );
        this.params.checked ? e.appendChild(sn("check", this.gridOptionsService)) : this.params.icon && (cv(this.params.icon) ? e.appendChild(this.params.icon) : typeof this.params.icon == "string" ? e.innerHTML = this.params.icon : console.warn("AG Grid: menu item icon must be DOM node or string")), this.getGui().appendChild(e);
      }
    }, t.prototype.addName = function() {
      if (!(!this.params.name && this.params.isCompact)) {
        var e = No(
          /* html */
          '<span ref="eName" class="'.concat(this.getClassName("part"), " ").concat(this.getClassName("text"), '">').concat(this.params.name || "", "</span>")
        );
        this.getGui().appendChild(e);
      }
    }, t.prototype.addTooltip = function() {
      this.params.tooltip && (this.tooltip = this.params.tooltip, this.gridOptionsService.get("enableBrowserTooltips") ? this.getGui().setAttribute("title", this.tooltip) : this.createManagedBean(new nC(this)));
    }, t.prototype.getTooltipParams = function() {
      return {
        location: "menu",
        value: this.tooltip
      };
    }, t.prototype.addShortcut = function() {
      if (!(!this.params.shortcut && this.params.isCompact)) {
        var e = No(
          /* html */
          '<span ref="eShortcut" class="'.concat(this.getClassName("part"), " ").concat(this.getClassName("shortcut"), '">').concat(this.params.shortcut || "", "</span>")
        );
        this.getGui().appendChild(e);
      }
    }, t.prototype.addSubMenu = function() {
      if (!(!this.params.subMenu && this.params.isCompact)) {
        var e = No(
          /* html */
          '<span ref="ePopupPointer" class="'.concat(this.getClassName("part"), " ").concat(this.getClassName("popup-pointer"), '"></span>')
        ), r = this.getGui();
        if (this.params.subMenu) {
          var n = this.gridOptionsService.get("enableRtl") ? "smallLeft" : "smallRight";
          ea(r, !1), e.appendChild(sn(n, this.gridOptionsService));
        }
        r.appendChild(e);
      }
    }, t.prototype.onItemSelected = function(e) {
      if (this.params.action ? this.params.action() : this.openSubMenu(e && e.type === "keydown"), !(this.params.subMenu && !this.params.action)) {
        var r = {
          type: t.EVENT_MENU_ITEM_SELECTED,
          action: this.params.action,
          checked: this.params.checked,
          cssClasses: this.params.cssClasses,
          disabled: this.params.disabled,
          icon: this.params.icon,
          name: this.params.name,
          shortcut: this.params.shortcut,
          subMenu: this.params.subMenu,
          tooltip: this.params.tooltip,
          event: e
        };
        this.dispatchEvent(r);
      }
    }, t.prototype.onItemActivated = function() {
      var e = {
        type: t.EVENT_MENU_ITEM_ACTIVATED,
        menuItem: this
      };
      this.dispatchEvent(e);
    }, t.prototype.cancelActivate = function() {
      this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
    }, t.prototype.cancelDeactivate = function() {
      this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
    }, t.prototype.onMouseEnter = function() {
      var e = this;
      this.cancelDeactivate(), this.params.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(function() {
        return e.activate(!0);
      }, t.ACTIVATION_DELAY) : this.activate(!0);
    }, t.prototype.onMouseLeave = function() {
      var e = this;
      this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(function() {
        return e.deactivate();
      }, t.ACTIVATION_DELAY) : this.deactivate();
    }, t.prototype.getClassName = function(e) {
      var r = this.params.isCompact ? "ag-compact-menu-option" : "ag-menu-option";
      return e ? "".concat(r, "-").concat(e) : r;
    }, t.EVENT_MENU_ITEM_SELECTED = "menuItemSelected", t.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated", t.ACTIVATION_DELAY = 80, aP([
      N("popupService")
    ], t.prototype, "popupService", void 0), aP([
      Fe
    ], t.prototype, "init", null), t;
  }(gt)
), nZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Hf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, y_ = (
  /** @class */
  function(o) {
    nZ(t, o);
    function t(e) {
      var r = o.call(this, t.getTemplate(e)) || this;
      return r.closable = !0, r.config = e, r;
    }
    return t.getTemplate = function(e) {
      var r = e && e.cssIdentifier || "default";
      return (
        /* html */
        '<div class="ag-panel ag-'.concat(r, `-panel" tabindex="-1">
            <div ref="eTitleBar" class="ag-panel-title-bar ag-`).concat(r, `-panel-title-bar ag-unselectable">
                <span ref="eTitle" class="ag-panel-title-bar-title ag-`).concat(r, `-panel-title-bar-title"></span>
                <div ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-`).concat(r, `-panel-title-bar-buttons"></div>
            </div>
            <div ref="eContentWrapper" class="ag-panel-content-wrapper ag-`).concat(r, `-panel-content-wrapper"></div>
        </div>`)
      );
    }, t.prototype.postConstruct = function() {
      var e = this, r = this.config, n = r.component, i = r.closable, a = r.hideTitleBar, s = r.title, l = r.minWidth, u = l === void 0 ? 250 : l, c = r.width, d = r.minHeight, f = d === void 0 ? 250 : d, v = r.height, g = r.centered, m = r.popup, b = r.x, S = r.y;
      this.positionableFeature = new e_(this.getGui(), {
        minWidth: u,
        width: c,
        minHeight: f,
        height: v,
        centered: g,
        x: b,
        y: S,
        popup: m,
        calculateTopBuffer: function() {
          return e.positionableFeature.getHeight() - e.getBodyHeight();
        }
      }), this.createManagedBean(this.positionableFeature);
      var R = this.getGui();
      n && this.setBodyComponent(n), a ? Vt(this.eTitleBar, !1) : (s && this.setTitle(s), this.setClosable(i ?? this.closable)), this.addManagedListener(this.eTitleBar, "mousedown", function(P) {
        var D = e.gridOptionsService.getDocument();
        if (R.contains(P.relatedTarget) || R.contains(D.activeElement) || e.eTitleBarButtons.contains(P.target)) {
          P.preventDefault();
          return;
        }
        var x = e.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
        x && x.focus();
      }), !(m && this.positionableFeature.isPositioned()) && (this.renderComponent && this.renderComponent(), this.positionableFeature.initialisePosition(), this.eContentWrapper.style.height = "0");
    }, t.prototype.renderComponent = function() {
      var e = this, r = this.getGui();
      r.focus(), this.close = function() {
        r.parentElement.removeChild(r), e.destroy();
      };
    }, t.prototype.getHeight = function() {
      return this.positionableFeature.getHeight();
    }, t.prototype.setHeight = function(e) {
      this.positionableFeature.setHeight(e);
    }, t.prototype.getWidth = function() {
      return this.positionableFeature.getWidth();
    }, t.prototype.setWidth = function(e) {
      this.positionableFeature.setWidth(e);
    }, t.prototype.setClosable = function(e) {
      if (e !== this.closable && (this.closable = e), e) {
        var r = this.closeButtonComp = new gt(t.CLOSE_BTN_TEMPLATE);
        this.getContext().createBean(r);
        var n = r.getGui(), i = sn("close", this.gridOptionsService);
        i.classList.add("ag-panel-title-bar-button-icon"), n.appendChild(i), this.addTitleBarButton(r), r.addManagedListener(n, "click", this.onBtClose.bind(this));
      } else if (this.closeButtonComp) {
        var n = this.closeButtonComp.getGui();
        n.parentElement.removeChild(n), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
      }
    }, t.prototype.setBodyComponent = function(e) {
      e.setParentComponent(this), this.eContentWrapper.appendChild(e.getGui());
    }, t.prototype.addTitleBarButton = function(e, r) {
      var n = this.eTitleBarButtons, i = n.children, a = i.length;
      r == null && (r = a), r = Math.max(0, Math.min(r, a)), e.addCssClass("ag-panel-title-bar-button");
      var s = e.getGui();
      r === 0 ? n.insertAdjacentElement("afterbegin", s) : r === a ? n.insertAdjacentElement("beforeend", s) : i[r - 1].insertAdjacentElement("afterend", s), e.setParentComponent(this);
    }, t.prototype.getBodyHeight = function() {
      return uv(this.eContentWrapper);
    }, t.prototype.getBodyWidth = function() {
      return Ec(this.eContentWrapper);
    }, t.prototype.setTitle = function(e) {
      this.eTitle.innerText = e;
    }, t.prototype.onBtClose = function() {
      this.close();
    }, t.prototype.destroy = function() {
      this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
      var e = this.getGui();
      e && ai(e) && this.close(), o.prototype.destroy.call(this);
    }, t.CLOSE_BTN_TEMPLATE = '<div class="ag-button"></div>', Hf([
      ke("eContentWrapper")
    ], t.prototype, "eContentWrapper", void 0), Hf([
      ke("eTitleBar")
    ], t.prototype, "eTitleBar", void 0), Hf([
      ke("eTitleBarButtons")
    ], t.prototype, "eTitleBarButtons", void 0), Hf([
      ke("eTitle")
    ], t.prototype, "eTitle", void 0), Hf([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), oZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), dy = function() {
  return dy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, dy.apply(this, arguments);
}, iZ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, RL = (
  /** @class */
  function(o) {
    oZ(t, o);
    function t(e) {
      var r = o.call(this, dy(dy({}, e), { popup: !0 })) || this;
      return r.isMaximizable = !1, r.isMaximized = !1, r.maximizeListeners = [], r.resizeListenerDestroy = null, r.lastPosition = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.getGui(), n = this.config, i = n.movable, a = n.resizable, s = n.maximizable;
      this.addCssClass("ag-dialog"), o.prototype.postConstruct.call(this), this.addManagedListener(r, "focusin", function(l) {
        r.contains(l.relatedTarget) || e.popupService.bringPopupToFront(r);
      }), i && this.setMovable(i), s && this.setMaximizable(s), a && this.setResizable(a);
    }, t.prototype.renderComponent = function() {
      var e = this.getGui(), r = this.config, n = r.alwaysOnTop, i = r.modal, a = r.title, s = r.afterGuiAttached, l = this.localeService.getLocaleTextFunc(), u = this.popupService.addPopup({
        modal: i,
        eChild: e,
        closeOnEsc: !0,
        closedCallback: this.destroy.bind(this),
        alwaysOnTop: n,
        ariaLabel: a || l("ariaLabelDialog", "Dialog"),
        afterGuiAttached: s
      });
      u && (this.close = u.hideFunc);
    }, t.prototype.toggleMaximize = function() {
      var e = this.positionableFeature.getPosition();
      if (this.isMaximized) {
        var r = this.lastPosition, n = r.x, i = r.y, a = r.width, s = r.height;
        this.setWidth(a), this.setHeight(s), this.positionableFeature.offsetElement(n, i);
      } else
        this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
      this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
    }, t.prototype.refreshMaximizeIcon = function() {
      Vt(this.maximizeIcon, !this.isMaximized), Vt(this.minimizeIcon, this.isMaximized);
    }, t.prototype.clearMaximizebleListeners = function() {
      this.maximizeListeners.length && (this.maximizeListeners.forEach(function(e) {
        return e();
      }), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
    }, t.prototype.destroy = function() {
      this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), o.prototype.destroy.call(this);
    }, t.prototype.setResizable = function(e) {
      this.positionableFeature.setResizable(e);
    }, t.prototype.setMovable = function(e) {
      this.positionableFeature.setMovable(e, this.eTitleBar);
    }, t.prototype.setMaximizable = function(e) {
      var r = this;
      if (!e) {
        this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
        return;
      }
      var n = this.eTitleBar;
      if (!(!n || e === this.isMaximizable)) {
        var i = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon(), i.addManagedListener(i.getGui(), "click", this.toggleMaximize.bind(this)), this.addTitleBarButton(i, 0), this.maximizeListeners.push(this.addManagedListener(n, "dblclick", this.toggleMaximize.bind(this))), this.resizeListenerDestroy = this.addManagedListener(this, "resize", function() {
          r.isMaximized = !1, r.refreshMaximizeIcon();
        });
      }
    }, t.prototype.buildMaximizeAndMinimizeElements = function() {
      var e = this.maximizeButtonComp = this.createBean(new gt(
        /* html */
        '<div class="ag-dialog-button"></span>'
      )), r = e.getGui();
      return this.maximizeIcon = sn("maximize", this.gridOptionsService), r.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = sn("minimize", this.gridOptionsService), r.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
    }, iZ([
      N("popupService")
    ], t.prototype, "popupService", void 0), t;
  }(y_)
), aZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), py = function() {
  return py = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, py.apply(this, arguments);
}, Bf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, sP = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, lP = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, uP = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, wl;
(function(o) {
  o[o.vertical = 0] = "vertical", o[o.horizontal = 1] = "horizontal";
})(wl || (wl = {}));
var sZ = 0, TL = (
  /** @class */
  function(o) {
    aZ(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.popupList = [], r;
    }
    e = t, t.prototype.postConstruct = function() {
      var r = this;
      this.ctrlsService.whenReady(function(n) {
        r.gridCtrl = n.gridCtrl;
      }), this.addManagedListener(this.eventService, G.EVENT_GRID_STYLES_CHANGED, this.handleThemeChange.bind(this));
    }, t.prototype.getPopupParent = function() {
      var r = this.gridOptionsService.get("popupParent");
      return r || this.gridCtrl.getGui();
    }, t.prototype.positionPopupForMenu = function(r) {
      var n = r.eventSource, i = r.ePopup, a = this.getPopupIndex(i);
      if (a !== -1) {
        var s = this.popupList[a];
        s.alignedToElement = n;
      }
      var l = n.getBoundingClientRect(), u = this.getParentRect(), c = this.keepXYWithinBounds(i, l.top - u.top, wl.vertical), d = i.clientWidth > 0 ? i.clientWidth : 200;
      i.style.minWidth = "".concat(d, "px");
      var f = u.right - u.left, v = f - d, g;
      this.gridOptionsService.get("enableRtl") ? (g = b(), g < 0 && (g = m(), this.setAlignedStyles(i, "left")), g > v && (g = 0, this.setAlignedStyles(i, "right"))) : (g = m(), g > v && (g = b(), this.setAlignedStyles(i, "right")), g < 0 && (g = 0, this.setAlignedStyles(i, "left"))), i.style.left = "".concat(g, "px"), i.style.top = "".concat(c, "px");
      function m() {
        return l.right - u.left - 2;
      }
      function b() {
        return l.left - u.left - d;
      }
    }, t.prototype.positionPopupUnderMouseEvent = function(r) {
      var n = this, i = r.ePopup, a = r.nudgeX, s = r.nudgeY, l = r.skipObserver;
      this.positionPopup({
        ePopup: i,
        nudgeX: a,
        nudgeY: s,
        keepWithinBounds: !0,
        skipObserver: l,
        updatePosition: function() {
          return n.calculatePointerAlign(r.mouseEvent);
        },
        postProcessCallback: function() {
          return n.callPostProcessPopup(r.type, r.ePopup, null, r.mouseEvent, r.column, r.rowNode);
        }
      });
    }, t.prototype.calculatePointerAlign = function(r) {
      var n = this.getParentRect();
      return {
        x: r.clientX - n.left,
        y: r.clientY - n.top
      };
    }, t.prototype.positionPopupByComponent = function(r) {
      var n = this, i = r.ePopup, a = r.nudgeX, s = r.nudgeY, l = r.keepWithinBounds, u = r.eventSource, c = r.alignSide, d = c === void 0 ? "left" : c, f = r.position, v = f === void 0 ? "over" : f, g = r.column, m = r.rowNode, b = r.type, S = u.getBoundingClientRect(), R = this.getParentRect(), P = this.getPopupIndex(i);
      if (P !== -1) {
        var D = this.popupList[P];
        D.alignedToElement = u;
      }
      var x = function() {
        var M = S.left - R.left;
        d === "right" && (M -= i.offsetWidth - S.width);
        var F;
        if (v === "over")
          F = S.top - R.top, n.setAlignedStyles(i, "over");
        else {
          n.setAlignedStyles(i, "under");
          var H = n.shouldRenderUnderOrAbove(i, S, R, r.nudgeY || 0);
          H === "under" ? F = S.top - R.top + S.height : F = S.top - i.offsetHeight - (s || 0) * 2 - R.top;
        }
        return { x: M, y: F };
      };
      this.positionPopup({
        ePopup: i,
        nudgeX: a,
        nudgeY: s,
        keepWithinBounds: l,
        updatePosition: x,
        postProcessCallback: function() {
          return n.callPostProcessPopup(b, i, u, null, g, m);
        }
      });
    }, t.prototype.shouldRenderUnderOrAbove = function(r, n, i, a) {
      var s = i.bottom - n.bottom, l = n.top - i.top, u = r.offsetHeight + a;
      return s > u ? "under" : l > u || l > s ? "above" : "under";
    }, t.prototype.setAlignedStyles = function(r, n) {
      var i = this.getPopupIndex(r);
      if (i !== -1) {
        var a = this.popupList[i], s = a.alignedToElement;
        if (s) {
          var l = ["right", "left", "over", "above", "under"];
          l.forEach(function(u) {
            s.classList.remove("ag-has-popup-positioned-".concat(u)), r.classList.remove("ag-popup-positioned-".concat(u));
          }), n && (s.classList.add("ag-has-popup-positioned-".concat(n)), r.classList.add("ag-popup-positioned-".concat(n)));
        }
      }
    }, t.prototype.callPostProcessPopup = function(r, n, i, a, s, l) {
      var u = this.gridOptionsService.getCallback("postProcessPopup");
      if (u) {
        var c = {
          column: s,
          rowNode: l,
          ePopup: n,
          type: r,
          eventSource: i,
          mouseEvent: a
        };
        u(c);
      }
    }, t.prototype.positionPopup = function(r) {
      var n = this, i = r.ePopup, a = r.keepWithinBounds, s = r.nudgeX, l = r.nudgeY, u = r.skipObserver, c = r.updatePosition, d = { width: 0, height: 0 }, f = function(g) {
        g === void 0 && (g = !1);
        var m = c(), b = m.x, S = m.y;
        g && i.clientWidth === d.width && i.clientHeight === d.height || (d.width = i.clientWidth, d.height = i.clientHeight, s && (b += s), l && (S += l), a && (b = n.keepXYWithinBounds(i, b, wl.horizontal), S = n.keepXYWithinBounds(i, S, wl.vertical)), i.style.left = "".concat(b, "px"), i.style.top = "".concat(S, "px"), r.postProcessCallback && r.postProcessCallback());
      };
      if (f(), !u) {
        var v = this.resizeObserverService.observeResize(i, function() {
          return f(!0);
        });
        setTimeout(function() {
          return v();
        }, e.WAIT_FOR_POPUP_CONTENT_RESIZE);
      }
    }, t.prototype.getActivePopups = function() {
      return this.popupList.map(function(r) {
        return r.element;
      });
    }, t.prototype.getPopupList = function() {
      return this.popupList;
    }, t.prototype.getParentRect = function() {
      var r = this.gridOptionsService.getDocument(), n = this.getPopupParent();
      return n === r.body ? n = r.documentElement : getComputedStyle(n).position === "static" && (n = n.offsetParent), $1(n);
    }, t.prototype.keepXYWithinBounds = function(r, n, i) {
      var a = i === wl.vertical, s = a ? "clientHeight" : "clientWidth", l = a ? "top" : "left", u = a ? "offsetHeight" : "offsetWidth", c = a ? "scrollTop" : "scrollLeft", d = this.gridOptionsService.getDocument(), f = d.documentElement, v = this.getPopupParent(), g = v.getBoundingClientRect(), m = d.documentElement.getBoundingClientRect(), b = v === d.body, S = r[u], R = a ? U1 : Yh, P = b ? R(f) + f[c] : v[s];
      b && (P -= Math.abs(m[l] - g[l]));
      var D = P - S;
      return Math.min(Math.max(n, 0), Math.abs(D));
    }, t.prototype.addPopup = function(r) {
      var n = this.gridOptionsService.getDocument(), i = r.eChild, a = r.ariaLabel, s = r.alwaysOnTop, l = r.positionCallback, u = r.anchorToElement;
      if (!n)
        return console.warn("AG Grid: could not find the document, document is empty"), { hideFunc: function() {
        } };
      var c = this.getPopupIndex(i);
      if (c !== -1) {
        var d = this.popupList[c];
        return { hideFunc: d.hideFunc };
      }
      this.initialisePopupPosition(i);
      var f = this.createPopupWrapper(i, a, !!s), v = this.addEventListenersToPopup(py(py({}, r), { wrapperEl: f }));
      return l && l(), this.addPopupToPopupList(i, f, v, u), {
        hideFunc: v
      };
    }, t.prototype.initialisePopupPosition = function(r) {
      var n = this.getPopupParent(), i = n.getBoundingClientRect();
      Oe(r.style.top) || (r.style.top = "".concat(i.top * -1, "px")), Oe(r.style.left) || (r.style.left = "".concat(i.left * -1, "px"));
    }, t.prototype.createPopupWrapper = function(r, n, i) {
      var a, s = this.getPopupParent(), l = document.createElement("div"), u = this.environment.getTheme().allThemes;
      return u.length && (a = l.classList).add.apply(a, lP([], sP(u), !1)), l.classList.add("ag-popup"), r.classList.add(this.gridOptionsService.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), r.hasAttribute("role") || bn(r, "dialog"), Os(r, n), l.appendChild(r), s.appendChild(l), i ? this.setAlwaysOnTop(r, !0) : this.bringPopupToFront(r), l;
    }, t.prototype.handleThemeChange = function() {
      var r, n, i, a, s, l = this.environment.getTheme().allThemes;
      try {
        for (var u = uP(this.popupList), c = u.next(); !c.done; c = u.next()) {
          var d = c.value;
          try {
            for (var f = (i = void 0, uP(Array.from(d.wrapper.classList))), v = f.next(); !v.done; v = f.next()) {
              var g = v.value;
              g.startsWith("ag-theme-") && d.wrapper.classList.remove(g);
            }
          } catch (m) {
            i = { error: m };
          } finally {
            try {
              v && !v.done && (a = f.return) && a.call(f);
            } finally {
              if (i) throw i.error;
            }
          }
          l.length && (s = d.wrapper.classList).add.apply(s, lP([], sP(l), !1));
        }
      } catch (m) {
        r = { error: m };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.addEventListenersToPopup = function(r) {
      var n = this, i = this.gridOptionsService.getDocument(), a = this.getPopupParent(), s = r.wrapperEl, l = r.eChild;
      r.click;
      var u = r.closedCallback, c = r.afterGuiAttached, d = r.closeOnEsc, f = r.modal, v = !1, g = function(R) {
        if (s.contains(i.activeElement)) {
          var P = R.key;
          P === we.ESCAPE && !na(R) && S({ keyboardEvent: R });
        }
      }, m = function(R) {
        return S({ mouseEvent: R });
      }, b = function(R) {
        return S({ touchEvent: R });
      }, S = function(R) {
        R === void 0 && (R = {});
        var P = R.mouseEvent, D = R.touchEvent, x = R.keyboardEvent;
        // we don't hide popup if the event was on the child, or any
        // children of this child
        n.isEventFromCurrentPopup({ mouseEvent: P, touchEvent: D }, l) || // this method should only be called once. the client can have different
        // paths, each one wanting to close, so this method may be called multiple times.
        v || (v = !0, a.removeChild(s), i.removeEventListener("keydown", g), i.removeEventListener("mousedown", m), i.removeEventListener("touchstart", b), i.removeEventListener("contextmenu", m), n.eventService.removeEventListener(G.EVENT_DRAG_STARTED, m), u && u(P || D || x), n.removePopupFromPopupList(l));
      };
      return c && c({ hidePopup: S }), window.setTimeout(function() {
        d && i.addEventListener("keydown", g), f && (i.addEventListener("mousedown", m), n.eventService.addEventListener(G.EVENT_DRAG_STARTED, m), i.addEventListener("touchstart", b), i.addEventListener("contextmenu", m));
      }, 0), S;
    }, t.prototype.addPopupToPopupList = function(r, n, i, a) {
      this.popupList.push({
        element: r,
        wrapper: n,
        hideFunc: i,
        instanceId: sZ++,
        isAnchored: !!a
      }), a && this.setPopupPositionRelatedToElement(r, a);
    }, t.prototype.getPopupIndex = function(r) {
      return this.popupList.findIndex(function(n) {
        return n.element === r;
      });
    }, t.prototype.setPopupPositionRelatedToElement = function(r, n) {
      var i = this.getPopupIndex(r);
      if (i !== -1) {
        var a = this.popupList[i];
        if (a.stopAnchoringPromise && a.stopAnchoringPromise.then(function(l) {
          return l && l();
        }), a.stopAnchoringPromise = void 0, a.isAnchored = !1, !!n) {
          var s = this.keepPopupPositionedRelativeTo({
            element: n,
            ePopup: r,
            hidePopup: a.hideFunc
          });
          return a.stopAnchoringPromise = s, a.isAnchored = !0, s;
        }
      }
    }, t.prototype.removePopupFromPopupList = function(r) {
      this.setAlignedStyles(r, null), this.setPopupPositionRelatedToElement(r, null), this.popupList = this.popupList.filter(function(n) {
        return n.element !== r;
      });
    }, t.prototype.keepPopupPositionedRelativeTo = function(r) {
      var n = this, i = this.getPopupParent(), a = i.getBoundingClientRect(), s = r.element, l = r.ePopup, u = s.getBoundingClientRect(), c = a.top - u.top, d = a.left - u.left, f = c, v = d, g = l.style.top, m = parseInt(g.substring(0, g.length - 1), 10), b = l.style.left, S = parseInt(b.substring(0, b.length - 1), 10);
      return new Zi(function(R) {
        n.getFrameworkOverrides().setInterval(function() {
          var P = i.getBoundingClientRect(), D = s.getBoundingClientRect(), x = D.top == 0 && D.left == 0 && D.height == 0 && D.width == 0;
          if (x) {
            r.hidePopup();
            return;
          }
          var M = P.top - D.top;
          if (M != f) {
            var F = n.keepXYWithinBounds(l, m + c - M, wl.vertical);
            l.style.top = "".concat(F, "px");
          }
          f = M;
          var H = P.left - D.left;
          if (H != v) {
            var B = n.keepXYWithinBounds(l, S + d - H, wl.horizontal);
            l.style.left = "".concat(B, "px");
          }
          v = H;
        }, 200).then(function(P) {
          var D = function() {
            P != null && window.clearInterval(P);
          };
          R(D);
        });
      });
    }, t.prototype.hasAnchoredPopup = function() {
      return this.popupList.some(function(r) {
        return r.isAnchored;
      });
    }, t.prototype.isEventFromCurrentPopup = function(r, n) {
      var i = r.mouseEvent, a = r.touchEvent, s = i || a;
      if (!s)
        return !1;
      var l = this.getPopupIndex(n);
      if (l === -1)
        return !1;
      for (var u = l; u < this.popupList.length; u++) {
        var c = this.popupList[u];
        if (Xm(c.element, s))
          return !0;
      }
      return this.isElementWithinCustomPopup(s.target);
    }, t.prototype.isElementWithinCustomPopup = function(r) {
      for (var n = this.gridOptionsService.getDocument(); r && r !== n.body; ) {
        if (r.classList.contains("ag-custom-component-popup") || r.parentElement === null)
          return !0;
        r = r.parentElement;
      }
      return !1;
    }, t.prototype.getWrapper = function(r) {
      for (; !r.classList.contains("ag-popup") && r.parentElement; )
        r = r.parentElement;
      return r.classList.contains("ag-popup") ? r : null;
    }, t.prototype.setAlwaysOnTop = function(r, n) {
      var i = this.getWrapper(r);
      i && (i.classList.toggle("ag-always-on-top", !!n), n && this.bringPopupToFront(i));
    }, t.prototype.bringPopupToFront = function(r) {
      var n = this.getPopupParent(), i = Array.prototype.slice.call(n.querySelectorAll(".ag-popup")), a = i.length, s = Array.prototype.slice.call(n.querySelectorAll(".ag-popup.ag-always-on-top")), l = s.length, u = this.getWrapper(r);
      if (!(!u || a <= 1 || !n.contains(r))) {
        var c = i.indexOf(u), d = u.querySelectorAll("div"), f = [];
        if (d.forEach(function(b) {
          b.scrollTop !== 0 && f.push([b, b.scrollTop]);
        }), l) {
          var v = u.classList.contains("ag-always-on-top");
          v ? c !== a - 1 && Kt(s).insertAdjacentElement("afterend", u) : c !== a - l - 1 && s[0].insertAdjacentElement("beforebegin", u);
        } else c !== a - 1 && Kt(i).insertAdjacentElement("afterend", u);
        for (; f.length; ) {
          var g = f.pop();
          g[0].scrollTop = g[1];
        }
        var m = {
          type: "popupToFront",
          eWrapper: u
        };
        this.eventService.dispatchEvent(m);
      }
    };
    var e;
    return t.WAIT_FOR_POPUP_CONTENT_RESIZE = 200, Bf([
      N("focusService")
    ], t.prototype, "focusService", void 0), Bf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Bf([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Bf([
      Fe
    ], t.prototype, "postConstruct", null), t = e = Bf([
      Be("popupService")
    ], t), t;
  }(Me)
), lZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), uZ = (
  /** @class */
  function(o) {
    lZ(t, o);
    function t() {
      var e = o.call(
        this,
        /* html */
        `
        <div class="ag-autocomplete-row" role="presentation">
            <div class="ag-autocomplete-row-label"></div>
        </div>`
      ) || this;
      return e.hasHighlighting = !1, e;
    }
    return t.prototype.setState = function(e, r) {
      this.value = e, this.render(), this.updateSelected(r);
    }, t.prototype.updateSelected = function(e) {
      this.addOrRemoveCssClass("ag-autocomplete-row-selected", e);
    }, t.prototype.setSearchString = function(e) {
      var r, n = !1;
      if (Oe(e)) {
        var i = (r = this.value) === null || r === void 0 ? void 0 : r.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
        if (i >= 0) {
          n = !0, this.hasHighlighting = !0;
          var a = i + e.length, s = vn(this.value.slice(0, i)), l = vn(this.value.slice(i, a)), u = vn(this.value.slice(a));
          this.getGui().lastElementChild.innerHTML = "".concat(s, "<b>").concat(l, "</b>").concat(u);
        }
      }
      !n && this.hasHighlighting && (this.hasHighlighting = !1, this.render());
    }, t.prototype.render = function() {
      var e;
      this.getGui().lastElementChild.innerHTML = (e = vn(this.value)) !== null && e !== void 0 ? e : "&nbsp;";
    }, t;
  }(gt)
), cZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), cP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, dZ = (
  /** @class */
  function(o) {
    cZ(t, o);
    function t(e) {
      var r = o.call(this, t.TEMPLATE) || this;
      return r.params = e, r.searchString = "", r;
    }
    return t.prototype.destroy = function() {
      o.prototype.destroy.call(this);
    }, t.prototype.init = function() {
      var e = this;
      this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList = this.createManagedBean(new m_({ cssIdentifier: "autocomplete" })), this.virtualList.setComponentCreator(this.createRowComponent.bind(this)), this.eList.appendChild(this.virtualList.getGui()), this.virtualList.setModel({
        getRowCount: function() {
          return e.autocompleteEntries.length;
        },
        getRow: function(n) {
          return e.autocompleteEntries[n];
        }
      });
      var r = this.virtualList.getGui();
      this.addManagedListener(r, "click", function() {
        return e.params.onConfirmed();
      }), this.addManagedListener(r, "mousemove", this.onMouseMove.bind(this)), this.addManagedListener(r, "mousedown", function(n) {
        return n.preventDefault();
      }), this.setSelectedValue(0);
    }, t.prototype.onNavigationKeyDown = function(e, r) {
      e.preventDefault();
      var n = this.autocompleteEntries.indexOf(this.selectedValue), i = r === we.UP ? n - 1 : n + 1;
      this.checkSetSelectedValue(i);
    }, t.prototype.setSearch = function(e) {
      this.searchString = e, Oe(e) ? this.runSearch() : (this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList.refresh(), this.checkSetSelectedValue(0)), this.updateSearchInList();
    }, t.prototype.runContainsSearch = function(e, r) {
      var n, i = !1, a = e.toLocaleLowerCase(), s = r.filter(function(l) {
        var u = l.toLocaleLowerCase(), c = u.indexOf(a), d = c === 0, f = c >= 0;
        return f && (!n || !i && d || i === d && l.length < n.length) && (n = l, i = d), f;
      });
      return !n && s.length && (n = s[0]), { topMatch: n, allMatches: s };
    }, t.prototype.runSearch = function() {
      var e, r, n = this.params.autocompleteEntries, i = n.map(function(d) {
        var f;
        return (f = d.displayValue) !== null && f !== void 0 ? f : d.key;
      }), a, s;
      if (this.params.useFuzzySearch)
        a = dv(this.searchString, i, !0).values, s = a.length ? a[0] : void 0;
      else {
        var l = this.runContainsSearch(this.searchString, i);
        a = l.allMatches, s = l.topMatch;
      }
      var u = n.filter(function(d) {
        var f = d.key, v = d.displayValue;
        return a.includes(v ?? f);
      });
      if (!u.length && this.selectedValue && (!((r = (e = this.params) === null || e === void 0 ? void 0 : e.forceLastSelection) === null || r === void 0) && r.call(e, this.selectedValue, this.searchString)) && (u = [this.selectedValue]), this.autocompleteEntries = u, this.virtualList.refresh(), !!s) {
        var c = a.indexOf(s);
        this.checkSetSelectedValue(c);
      }
    }, t.prototype.updateSearchInList = function() {
      var e = this;
      this.virtualList.forEachRenderedRow(function(r) {
        return r.setSearchString(e.searchString);
      });
    }, t.prototype.checkSetSelectedValue = function(e) {
      e >= 0 && e < this.autocompleteEntries.length && this.setSelectedValue(e);
    }, t.prototype.setSelectedValue = function(e) {
      var r = this.autocompleteEntries[e];
      this.selectedValue !== r && (this.selectedValue = r, this.virtualList.ensureIndexVisible(e), this.virtualList.forEachRenderedRow(function(n, i) {
        n.updateSelected(e === i);
      }));
    }, t.prototype.createRowComponent = function(e) {
      var r, n = new uZ();
      return this.getContext().createBean(n), n.setState((r = e.displayValue) !== null && r !== void 0 ? r : e.key, e === this.selectedValue), n;
    }, t.prototype.onMouseMove = function(e) {
      var r = this.virtualList.getGui().getBoundingClientRect(), n = this.virtualList.getScrollTop(), i = e.clientY - r.top + n, a = Math.floor(i / this.virtualList.getRowHeight());
      this.checkSetSelectedValue(a);
    }, t.prototype.afterGuiAttached = function() {
      this.virtualList.refresh();
    }, t.prototype.getSelectedValue = function() {
      var e;
      return this.autocompleteEntries.length && (e = this.selectedValue) !== null && e !== void 0 ? e : null;
    }, t.TEMPLATE = `<div class="ag-autocomplete-list-popup">
            <div ref="eList" class="ag-autocomplete-list"></div>
        <div>`, cP([
      ke("eList")
    ], t.prototype, "eList", void 0), cP([
      Fe
    ], t.prototype, "init", null), t;
  }(Yl)
), pZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ib = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, OL = (
  /** @class */
  function(o) {
    pZ(t, o);
    function t() {
      var e = o.call(
        this,
        /* html */
        `
            <div class="ag-autocomplete" role="presentation">
                <ag-input-text-field ref="eAutocompleteInput"></ag-input-text-field>
            </div>`
      ) || this;
      return e.isListOpen = !1, e.lastPosition = 0, e.valid = !0, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.eAutocompleteInput.onValueChange(function(r) {
        return e.onValueChanged(r);
      }), this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off"), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.addGuiEventListener("click", this.updatePositionAndList.bind(this)), this.addDestroyFunc(function() {
        e.destroyBean(e.autocompleteList);
      }), this.addGuiEventListener("focusout", function() {
        return e.onFocusOut();
      });
    }, t.prototype.onValueChanged = function(e) {
      var r = Ia(e);
      this.updateValue(r), this.updateAutocompleteList(r);
    }, t.prototype.updateValue = function(e) {
      this.updateLastPosition(), this.dispatchEvent({
        type: t.EVENT_VALUE_CHANGED,
        value: e
      }), this.validate(e);
    }, t.prototype.updateAutocompleteList = function(e) {
      var r, n, i, a, s = (n = (r = this.listGenerator) === null || r === void 0 ? void 0 : r.call(this, e, this.lastPosition)) !== null && n !== void 0 ? n : { enabled: !1 };
      if ((!s.type || s.type !== ((i = this.autocompleteListParams) === null || i === void 0 ? void 0 : i.type)) && this.isListOpen && this.closeList(), this.autocompleteListParams = s, !((a = this.autocompleteListParams) === null || a === void 0) && a.enabled) {
        this.isListOpen || this.openList();
        var l = this.autocompleteListParams.searchString;
        this.autocompleteList.setSearch(l ?? "");
      } else
        this.isListOpen && this.closeList();
    }, t.prototype.onKeyDown = function(e) {
      var r = this, n = e.key;
      switch (this.updateLastPosition(), n) {
        case we.ENTER:
          this.onEnterKeyDown(e);
          break;
        case we.TAB:
          this.onTabKeyDown(e);
          break;
        case we.DOWN:
        case we.UP:
          this.onUpDownKeyDown(e, n);
          break;
        case we.LEFT:
        case we.RIGHT:
        case we.PAGE_HOME:
        case we.PAGE_END:
          setTimeout(function() {
            r.updatePositionAndList();
          });
          break;
        case we.ESCAPE:
          this.onEscapeKeyDown(e);
          break;
        case we.SPACE:
          e.ctrlKey && !this.isListOpen && (e.preventDefault(), this.forceOpenList());
          break;
      }
    }, t.prototype.confirmSelection = function() {
      var e, r = (e = this.autocompleteList) === null || e === void 0 ? void 0 : e.getSelectedValue();
      r && (this.closeList(), this.dispatchEvent({
        type: t.EVENT_OPTION_SELECTED,
        value: this.getValue(),
        position: this.lastPosition,
        updateEntry: r,
        autocompleteType: this.autocompleteListParams.type
      }));
    }, t.prototype.onTabKeyDown = function(e) {
      this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.confirmSelection());
    }, t.prototype.onEnterKeyDown = function(e) {
      e.preventDefault(), this.isListOpen ? this.confirmSelection() : this.onCompleted();
    }, t.prototype.onUpDownKeyDown = function(e, r) {
      var n;
      e.preventDefault(), this.isListOpen ? (n = this.autocompleteList) === null || n === void 0 || n.onNavigationKeyDown(e, r) : this.forceOpenList();
    }, t.prototype.onEscapeKeyDown = function(e) {
      this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.closeList(), this.setCaret(this.lastPosition, !0));
    }, t.prototype.onFocusOut = function() {
      this.isListOpen && this.closeList();
    }, t.prototype.updatePositionAndList = function() {
      var e;
      this.updateLastPosition(), this.updateAutocompleteList((e = this.eAutocompleteInput.getValue()) !== null && e !== void 0 ? e : null);
    }, t.prototype.setCaret = function(e, r) {
      var n = this.gridOptionsService.getDocument();
      r && n.activeElement === n.body && this.eAutocompleteInput.getFocusableElement().focus();
      var i = this.eAutocompleteInput.getInputElement();
      i.setSelectionRange(e, e), e === i.value.length && (i.scrollLeft = i.scrollWidth);
    }, t.prototype.forceOpenList = function() {
      this.onValueChanged(this.eAutocompleteInput.getValue());
    }, t.prototype.updateLastPosition = function() {
      var e;
      this.lastPosition = (e = this.eAutocompleteInput.getInputElement().selectionStart) !== null && e !== void 0 ? e : 0;
    }, t.prototype.validate = function(e) {
      var r;
      this.validator && (this.validationMessage = this.validator(e), this.eAutocompleteInput.getInputElement().setCustomValidity((r = this.validationMessage) !== null && r !== void 0 ? r : ""), this.valid = !this.validationMessage, this.dispatchEvent({
        type: t.EVENT_VALID_CHANGED,
        isValid: this.valid,
        validationMessage: this.validationMessage
      }));
    }, t.prototype.openList = function() {
      var e = this;
      this.isListOpen = !0, this.autocompleteList = this.createBean(new dZ({
        autocompleteEntries: this.autocompleteListParams.entries,
        onConfirmed: function() {
          return e.confirmSelection();
        },
        forceLastSelection: this.forceLastSelection
      }));
      var r = this.autocompleteList.getGui(), n = {
        ePopup: r,
        type: "autocomplete",
        eventSource: this.getGui(),
        position: "under",
        alignSide: this.gridOptionsService.get("enableRtl") ? "right" : "left",
        keepWithinBounds: !0
      }, i = this.popupService.addPopup({
        eChild: r,
        anchorToElement: this.getGui(),
        positionCallback: function() {
          return e.popupService.positionPopupByComponent(n);
        },
        ariaLabel: this.listAriaLabel
      });
      this.hidePopup = i.hideFunc, this.autocompleteList.afterGuiAttached();
    }, t.prototype.closeList = function() {
      this.isListOpen = !1, this.hidePopup(), this.destroyBean(this.autocompleteList), this.autocompleteList = null;
    }, t.prototype.onCompleted = function() {
      this.isListOpen && this.closeList(), this.dispatchEvent({
        type: t.EVENT_VALUE_CONFIRMED,
        value: this.getValue(),
        isValid: this.isValid()
      });
    }, t.prototype.getValue = function() {
      return Ia(this.eAutocompleteInput.getValue());
    }, t.prototype.setInputPlaceholder = function(e) {
      return this.eAutocompleteInput.setInputPlaceholder(e), this;
    }, t.prototype.setInputAriaLabel = function(e) {
      return this.eAutocompleteInput.setInputAriaLabel(e), this;
    }, t.prototype.setListAriaLabel = function(e) {
      return this.listAriaLabel = e, this;
    }, t.prototype.setListGenerator = function(e) {
      return this.listGenerator = e, this;
    }, t.prototype.setValidator = function(e) {
      return this.validator = e, this;
    }, t.prototype.isValid = function() {
      return this.valid;
    }, t.prototype.setValue = function(e) {
      var r = e.value, n = e.position, i = e.silent, a = e.updateListOnlyIfOpen, s = e.restoreFocus;
      this.eAutocompleteInput.setValue(r, !0), this.setCaret(n ?? this.lastPosition, s), i || this.updateValue(r), (!a || this.isListOpen) && this.updateAutocompleteList(r);
    }, t.prototype.setForceLastSelection = function(e) {
      return this.forceLastSelection = e, this;
    }, t.prototype.setInputDisabled = function(e) {
      return this.eAutocompleteInput.setDisabled(e), this;
    }, t.EVENT_VALUE_CHANGED = "eventValueChanged", t.EVENT_VALUE_CONFIRMED = "eventValueConfirmed", t.EVENT_OPTION_SELECTED = "eventOptionSelected", t.EVENT_VALID_CHANGED = "eventValidChanged", ib([
      N("popupService")
    ], t.prototype, "popupService", void 0), ib([
      ke("eAutocompleteInput")
    ], t.prototype, "eAutocompleteInput", void 0), ib([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), fZ = ["touchstart", "touchend", "touchmove", "touchcancel"], PL = (
  /** @class */
  function() {
    function o(t) {
      t === void 0 && (t = "javascript"), this.frameworkName = t, this.renderingEngine = "vanilla", this.wrapIncoming = function(e) {
        return e();
      }, this.wrapOutgoing = function(e) {
        return e();
      };
    }
    return o.prototype.setInterval = function(t, e) {
      return new Zi(function(r) {
        r(window.setInterval(t, e));
      });
    }, o.prototype.addEventListener = function(t, e, r, n) {
      var i = ra(fZ, e);
      t.addEventListener(e, r, { capture: !!n, passive: i });
    }, Object.defineProperty(o.prototype, "shouldWrapOutgoing", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), o.prototype.frameworkComponent = function(t) {
      return null;
    }, o.prototype.isFrameworkComponent = function(t) {
      return !1;
    }, o.prototype.getDocLink = function(t) {
      var e = this.frameworkName === "solid" ? "react" : this.frameworkName;
      return "https://www.ag-grid.com/".concat(e, "-data-grid").concat(t ? "/".concat(t) : "");
    }, o;
  }()
), hZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fd = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, vZ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, gZ = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, DL = (
  /** @class */
  function(o) {
    hZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getNextCellToFocus = function(e, r, n) {
      return n === void 0 && (n = !1), n ? this.getNextCellToFocusWithCtrlPressed(e, r) : this.getNextCellToFocusWithoutCtrlPressed(e, r);
    }, t.prototype.getNextCellToFocusWithCtrlPressed = function(e, r) {
      var n = e === we.UP, i = e === we.DOWN, a = e === we.LEFT, s, l;
      if (n || i)
        l = n ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow(), s = r.column;
      else {
        var u = this.columnModel.getAllDisplayedColumns(), c = this.gridOptionsService.get("enableRtl");
        l = r.rowIndex, s = a !== c ? u[0] : Kt(u);
      }
      return {
        rowIndex: l,
        rowPinned: null,
        column: s
      };
    }, t.prototype.getNextCellToFocusWithoutCtrlPressed = function(e, r) {
      for (var n = r, i = !1; !i; ) {
        switch (e) {
          case we.UP:
            n = this.getCellAbove(n);
            break;
          case we.DOWN:
            n = this.getCellBelow(n);
            break;
          case we.RIGHT:
            this.gridOptionsService.get("enableRtl") ? n = this.getCellToLeft(n) : n = this.getCellToRight(n);
            break;
          case we.LEFT:
            this.gridOptionsService.get("enableRtl") ? n = this.getCellToRight(n) : n = this.getCellToLeft(n);
            break;
          default:
            n = null, console.warn("AG Grid: unknown key for navigation " + e);
            break;
        }
        n ? i = this.isCellGoodToFocusOn(n) : i = !0;
      }
      return n;
    }, t.prototype.isCellGoodToFocusOn = function(e) {
      var r = e.column, n;
      switch (e.rowPinned) {
        case "top":
          n = this.pinnedRowModel.getPinnedTopRow(e.rowIndex);
          break;
        case "bottom":
          n = this.pinnedRowModel.getPinnedBottomRow(e.rowIndex);
          break;
        default:
          n = this.rowModel.getRow(e.rowIndex);
          break;
      }
      if (!n)
        return !1;
      var i = r.isSuppressNavigable(n);
      return !i;
    }, t.prototype.getCellToLeft = function(e) {
      if (!e)
        return null;
      var r = this.columnModel.getDisplayedColBefore(e.column);
      return r ? {
        rowIndex: e.rowIndex,
        column: r,
        rowPinned: e.rowPinned
      } : null;
    }, t.prototype.getCellToRight = function(e) {
      if (!e)
        return null;
      var r = this.columnModel.getDisplayedColAfter(e.column);
      return r ? {
        rowIndex: e.rowIndex,
        column: r,
        rowPinned: e.rowPinned
      } : null;
    }, t.prototype.getRowBelow = function(e) {
      var r = e.rowIndex, n = e.rowPinned;
      if (this.isLastRowInContainer(e))
        switch (n) {
          case "bottom":
            return null;
          case "top":
            return this.rowModel.isRowsToRender() ? { rowIndex: this.paginationProxy.getPageFirstRow(), rowPinned: null } : this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
          default:
            return this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
        }
      var i = this.rowModel.getRow(e.rowIndex), a = this.getNextStickyPosition(i);
      return a || { rowIndex: r + 1, rowPinned: n };
    }, t.prototype.getNextStickyPosition = function(e, r) {
      if (!(!this.gridOptionsService.isGroupRowsSticky() || !e || !e.sticky)) {
        var n = gZ([], vZ(this.rowRenderer.getStickyTopRowCtrls()), !1).sort(function(l, u) {
          return l.getRowNode().rowIndex - u.getRowNode().rowIndex;
        }), i = r ? -1 : 1, a = n.findIndex(function(l) {
          return l.getRowNode().rowIndex === e.rowIndex;
        }), s = n[a + i];
        if (s)
          return { rowIndex: s.getRowNode().rowIndex, rowPinned: null };
      }
    }, t.prototype.getCellBelow = function(e) {
      if (!e)
        return null;
      var r = this.getRowBelow(e);
      return r ? {
        rowIndex: r.rowIndex,
        column: e.column,
        rowPinned: r.rowPinned
      } : null;
    }, t.prototype.isLastRowInContainer = function(e) {
      var r = e.rowPinned, n = e.rowIndex;
      if (r === "top") {
        var i = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return i <= n;
      }
      if (r === "bottom") {
        var a = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
        return a <= n;
      }
      var s = this.paginationProxy.getPageLastRow();
      return s <= n;
    }, t.prototype.getRowAbove = function(e) {
      var r = e.rowIndex, n = e.rowPinned, i = n ? r === 0 : r === this.paginationProxy.getPageFirstRow();
      if (i)
        return n === "top" ? null : n ? this.rowModel.isRowsToRender() ? this.getLastBodyCell() : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null;
      var a = this.rowModel.getRow(e.rowIndex), s = this.getNextStickyPosition(a, !0);
      return s || { rowIndex: r - 1, rowPinned: n };
    }, t.prototype.getCellAbove = function(e) {
      if (!e)
        return null;
      var r = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
      return r ? {
        rowIndex: r.rowIndex,
        column: e.column,
        rowPinned: r.rowPinned
      } : null;
    }, t.prototype.getLastBodyCell = function() {
      var e = this.paginationProxy.getPageLastRow();
      return { rowIndex: e, rowPinned: null };
    }, t.prototype.getLastFloatingTopRow = function() {
      var e = this.pinnedRowModel.getPinnedTopRowData().length - 1;
      return { rowIndex: e, rowPinned: "top" };
    }, t.prototype.getNextTabbedCell = function(e, r) {
      return r ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
    }, t.prototype.getNextTabbedCellForwards = function(e) {
      var r = this.columnModel.getAllDisplayedColumns(), n = e.rowIndex, i = e.rowPinned, a = this.columnModel.getDisplayedColAfter(e.column);
      if (!a) {
        a = r[0];
        var s = this.getRowBelow(e);
        if (tt(s) || !s.rowPinned && !this.paginationProxy.isRowInPage(s))
          return null;
        n = s ? s.rowIndex : null, i = s ? s.rowPinned : null;
      }
      return { rowIndex: n, column: a, rowPinned: i };
    }, t.prototype.getNextTabbedCellBackwards = function(e) {
      var r = this.columnModel.getAllDisplayedColumns(), n = e.rowIndex, i = e.rowPinned, a = this.columnModel.getDisplayedColBefore(e.column);
      if (!a) {
        a = Kt(r);
        var s = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
        if (tt(s) || !s.rowPinned && !this.paginationProxy.isRowInPage(s))
          return null;
        n = s ? s.rowIndex : null, i = s ? s.rowPinned : null;
      }
      return { rowIndex: n, column: a, rowPinned: i };
    }, Fd([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Fd([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Fd([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Fd([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Fd([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), t = Fd([
      Be("cellNavigationService")
    ], t), t;
  }(Me)
), mZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Wf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, yZ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, AL = (
  /** @class */
  function(o) {
    mZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.consuming = !1, e;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("AlignedGridsService");
    }, t.prototype.getAlignedGridApis = function() {
      var e = this, r, n = (r = this.gridOptionsService.get("alignedGrids")) !== null && r !== void 0 ? r : [], i = typeof n == "function";
      typeof n == "function" && (n = n());
      var a = function() {
        return "See ".concat(e.getFrameworkOverrides().getDocLink("aligned-grids"));
      }, s = n.map(function(l) {
        var u;
        if (!l) {
          Ji("alignedGrids contains an undefined option."), i || Ji(`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`), Ji(a());
          return;
        }
        if (l instanceof c_)
          return l;
        var c = l;
        return "current" in c ? (u = c.current) === null || u === void 0 ? void 0 : u.api : (c.api || Ji("alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ".concat(a())), c.api);
      }).filter(function(l) {
        return !!l && !l.isDestroyed();
      });
      return s;
    }, t.prototype.init = function() {
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this)), this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    }, t.prototype.fireEvent = function(e) {
      this.consuming || this.getAlignedGridApis().forEach(function(r) {
        var n = r.__getAlignedGridService();
        e(n);
      });
    }, t.prototype.onEvent = function(e) {
      this.consuming = !0, e(), this.consuming = !1;
    }, t.prototype.fireColumnEvent = function(e) {
      this.fireEvent(function(r) {
        r.onColumnEvent(e);
      });
    }, t.prototype.fireScrollEvent = function(e) {
      e.direction === "horizontal" && this.fireEvent(function(r) {
        r.onScrollEvent(e);
      });
    }, t.prototype.onScrollEvent = function(e) {
      var r = this;
      this.onEvent(function() {
        var n = r.ctrlsService.getGridBodyCtrl();
        n.getScrollFeature().setHorizontalScrollPosition(e.left, !0);
      });
    }, t.prototype.getMasterColumns = function(e) {
      var r = [];
      return e.columns ? e.columns.forEach(function(n) {
        r.push(n);
      }) : e.column && r.push(e.column), r;
    }, t.prototype.getColumnIds = function(e) {
      var r = [];
      return e.columns ? e.columns.forEach(function(n) {
        r.push(n.getColId());
      }) : e.column && r.push(e.column.getColId()), r;
    }, t.prototype.onColumnEvent = function(e) {
      var r = this;
      this.onEvent(function() {
        switch (e.type) {
          case G.EVENT_COLUMN_MOVED:
          case G.EVENT_COLUMN_VISIBLE:
          case G.EVENT_COLUMN_PINNED:
          case G.EVENT_COLUMN_RESIZED:
            var n = e;
            r.processColumnEvent(n);
            break;
          case G.EVENT_COLUMN_GROUP_OPENED:
            var i = e;
            r.processGroupOpenedEvent(i);
            break;
          case G.EVENT_COLUMN_PIVOT_CHANGED:
            console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
            break;
        }
      });
    }, t.prototype.processGroupOpenedEvent = function(e) {
      var r = this;
      e.columnGroups.forEach(function(n) {
        var i = null;
        if (n) {
          var a = n.getGroupId();
          i = r.columnModel.getProvidedColumnGroup(a);
        }
        n && !i || (r.logger.log("onColumnEvent-> processing " + e + " expanded = " + n.isExpanded()), r.columnModel.setColumnGroupOpened(i, n.isExpanded(), "alignedGridChanged"));
      });
    }, t.prototype.processColumnEvent = function(e) {
      var r = this, n, i = e.column, a = null;
      if (i && (a = this.columnModel.getPrimaryColumn(i.getColId())), !(i && !a)) {
        var s = this.getMasterColumns(e);
        switch (e.type) {
          case G.EVENT_COLUMN_MOVED:
            {
              var l = e, u = e.api.getColumnState(), c = u.map(function(S) {
                return { colId: S.colId };
              });
              this.columnModel.applyColumnState({ state: c, applyOrder: !0 }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing ".concat(e.type, " toIndex = ").concat(l.toIndex));
            }
            break;
          case G.EVENT_COLUMN_VISIBLE:
            {
              var d = e, u = e.api.getColumnState(), c = u.map(function(P) {
                return { colId: P.colId, hide: P.hide };
              });
              this.columnModel.applyColumnState({ state: c }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing ".concat(e.type, " visible = ").concat(d.visible));
            }
            break;
          case G.EVENT_COLUMN_PINNED:
            {
              var f = e, u = e.api.getColumnState(), c = u.map(function(P) {
                return { colId: P.colId, pinned: P.pinned };
              });
              this.columnModel.applyColumnState({ state: c }, "alignedGridChanged"), this.logger.log("onColumnEvent-> processing ".concat(e.type, " pinned = ").concat(f.pinned));
            }
            break;
          case G.EVENT_COLUMN_RESIZED:
            var v = e, g = {};
            s.forEach(function(S) {
              r.logger.log("onColumnEvent-> processing ".concat(e.type, " actualWidth = ").concat(S.getActualWidth())), g[S.getId()] = { key: S.getColId(), newWidth: S.getActualWidth() };
            }), (n = v.flexColumns) === null || n === void 0 || n.forEach(function(S) {
              g[S.getId()] && delete g[S.getId()];
            }), this.columnModel.setColumnWidths(Object.values(g), !1, v.finished, "alignedGridChanged");
            break;
        }
        var m = this.ctrlsService.getGridBodyCtrl(), b = m.isVerticalScrollShowing();
        this.getAlignedGridApis().forEach(function(S) {
          S.setGridOption("alwaysShowVerticalScroll", b);
        });
      }
    }, Wf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Wf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Wf([
      yZ(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), Wf([
      Fe
    ], t.prototype, "init", null), t = Wf([
      Be("alignedGridsService")
    ], t), t;
  }(Me)
), CZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $g = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ML = (
  /** @class */
  function(o) {
    CZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.selectedNodes = /* @__PURE__ */ new Map(), e.lastRowNode = null, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.rowSelection = this.gridOptionsService.get("rowSelection"), this.groupSelectsChildren = this.gridOptionsService.get("groupSelectsChildren"), this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], function() {
        e.groupSelectsChildren = e.gridOptionsService.get("groupSelectsChildren"), e.rowSelection = e.gridOptionsService.get("rowSelection"), e.deselectAllRowNodes({ source: "api" });
      }), this.addManagedListener(this.eventService, G.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.resetNodes(), this.lastRowNode = null;
    }, t.prototype.isMultiselect = function() {
      return this.rowSelection === "multiple";
    }, t.prototype.setNodesSelected = function(e) {
      var r, n = e.newValue, i = e.clearSelection, a = e.suppressFinishActions, s = e.rangeSelect, l = e.nodes, u = e.event, c = e.source, d = c === void 0 ? "api" : c;
      if (l.length === 0)
        return 0;
      if (l.length > 1 && !this.isMultiselect())
        return console.warn("AG Grid: cannot multi select while rowSelection='single'"), 0;
      var f = this.groupSelectsChildren && e.groupSelectsFiltered === !0, v = l.map(function(H) {
        return H.footer ? H.sibling : H;
      });
      if (s) {
        if (l.length > 1)
          return console.warn("AG Grid: cannot range select while selecting multiple rows"), 0;
        var g = null;
        if (d === "checkboxSelected" && n === !1 && this.lastRowNode && (this.lastRowNode.id ? g = this.lastRowNode : this.lastRowNode = null), g == null && (g = this.getLastSelectedNode()), g) {
          var m = v[0], b = m !== g;
          if (b && this.isMultiselect())
            return this.selectRange(m, g, n, d);
        }
      }
      this.lastRowNode = n ? null : v[0];
      for (var S = 0, R = 0; R < v.length; R++) {
        var P = v[R], D = f && P.group;
        if (!D) {
          var x = P.selectThisNode(n, u, d);
          x && S++;
        }
        this.groupSelectsChildren && (!((r = P.childrenAfterGroup) === null || r === void 0) && r.length) && (S += this.selectChildren(P, n, f, d));
      }
      if (!a) {
        var M = n && (i || !this.isMultiselect());
        if (M && (S += this.clearOtherNodes(v[0], d)), S > 0) {
          this.updateGroupsFromChildrenSelections(d);
          var F = {
            type: G.EVENT_SELECTION_CHANGED,
            source: d
          };
          this.eventService.dispatchEvent(F);
        }
      }
      return S;
    }, t.prototype.selectRange = function(e, r, n, i) {
      var a = this;
      n === void 0 && (n = !0);
      var s = this.rowModel.getNodesInRangeForSelection(e, r), l = 0;
      s.forEach(function(c) {
        if (!(c.group && a.groupSelectsChildren)) {
          var d = c.selectThisNode(n, void 0, i);
          d && l++;
        }
      }), this.updateGroupsFromChildrenSelections(i);
      var u = {
        type: G.EVENT_SELECTION_CHANGED,
        source: i
      };
      return this.eventService.dispatchEvent(u), l;
    }, t.prototype.selectChildren = function(e, r, n, i) {
      var a = n ? e.childrenAfterAggFilter : e.childrenAfterGroup;
      return tt(a) ? 0 : this.setNodesSelected({
        newValue: r,
        clearSelection: !1,
        suppressFinishActions: !0,
        groupSelectsFiltered: n,
        source: i,
        nodes: a
      });
    }, t.prototype.getLastSelectedNode = function() {
      var e = Array.from(this.selectedNodes.keys());
      if (e.length == 0)
        return null;
      var r = this.selectedNodes.get(Kt(e));
      return r || null;
    }, t.prototype.getSelectedNodes = function() {
      var e = [];
      return this.selectedNodes.forEach(function(r) {
        r && e.push(r);
      }), e;
    }, t.prototype.getSelectedRows = function() {
      var e = [];
      return this.selectedNodes.forEach(function(r) {
        r && r.data && e.push(r.data);
      }), e;
    }, t.prototype.getSelectionCount = function() {
      return this.selectedNodes.size;
    }, t.prototype.filterFromSelection = function(e) {
      var r = /* @__PURE__ */ new Map();
      this.selectedNodes.forEach(function(n, i) {
        var a = n && e(n);
        a && r.set(i, n);
      }), this.selectedNodes = r;
    }, t.prototype.updateGroupsFromChildrenSelections = function(e, r) {
      if (!this.groupSelectsChildren || this.rowModel.getType() !== "clientSide")
        return !1;
      var n = this.rowModel, i = n.getRootNode();
      r || (r = new gv(!0, i), r.setInactive());
      var a = !1;
      return r.forEachChangedNodeDepthFirst(function(s) {
        if (s !== i) {
          var l = s.calculateSelectedFromChildren();
          a = s.selectThisNode(l === null ? !1 : l, void 0, e) || a;
        }
      }), a;
    }, t.prototype.clearOtherNodes = function(e, r) {
      var n = this, i = /* @__PURE__ */ new Map(), a = 0;
      return this.selectedNodes.forEach(function(s) {
        if (s && s.id !== e.id) {
          var l = n.selectedNodes.get(s.id);
          a += l.setSelectedParams({
            newValue: !1,
            clearSelection: !1,
            suppressFinishActions: !0,
            source: r
          }), n.groupSelectsChildren && s.parent && i.set(s.parent.id, s.parent);
        }
      }), i.forEach(function(s) {
        var l = s.calculateSelectedFromChildren();
        s.selectThisNode(l === null ? !1 : l, void 0, r);
      }), a;
    }, t.prototype.onRowSelected = function(e) {
      var r = e.node;
      this.groupSelectsChildren && r.group || (r.isSelected() ? this.selectedNodes.set(r.id, r) : this.selectedNodes.delete(r.id));
    }, t.prototype.syncInRowNode = function(e, r) {
      this.syncInOldRowNode(e, r), this.syncInNewRowNode(e);
    }, t.prototype.syncInOldRowNode = function(e, r) {
      var n = Oe(r) && e.id !== r.id;
      if (n && r) {
        var i = r.id, a = this.selectedNodes.get(i) == e;
        a && this.selectedNodes.set(r.id, r);
      }
    }, t.prototype.syncInNewRowNode = function(e) {
      this.selectedNodes.has(e.id) ? (e.setSelectedInitialValue(!0), this.selectedNodes.set(e.id, e)) : e.setSelectedInitialValue(!1);
    }, t.prototype.reset = function(e) {
      var r = this.getSelectionCount();
      if (this.resetNodes(), r) {
        var n = {
          type: G.EVENT_SELECTION_CHANGED,
          source: e
        };
        this.eventService.dispatchEvent(n);
      }
    }, t.prototype.resetNodes = function() {
      var e;
      (e = this.selectedNodes) === null || e === void 0 || e.clear();
    }, t.prototype.getBestCostNodeSelection = function() {
      if (this.rowModel.getType() !== "clientSide")
        return;
      var e = this.rowModel, r = e.getTopLevelNodes();
      if (r === null)
        return;
      var n = [];
      function i(a) {
        for (var s = 0, l = a.length; s < l; s++) {
          var u = a[s];
          if (u.isSelected())
            n.push(u);
          else {
            var c = u;
            c.group && c.children && i(c.children);
          }
        }
      }
      return i(r), n;
    }, t.prototype.isEmpty = function() {
      var e = 0;
      return this.selectedNodes.forEach(function(r) {
        r && e++;
      }), e === 0;
    }, t.prototype.deselectAllRowNodes = function(e) {
      var r = function(u) {
        return u.selectThisNode(!1, void 0, i);
      }, n = this.rowModel.getType() === "clientSide", i = e.source, a = e.justFiltered, s = e.justCurrentPage;
      if (s || a) {
        if (!n) {
          console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
          return;
        }
        this.getNodesToSelect(a, s).forEach(r);
      } else
        this.selectedNodes.forEach(function(u) {
          u && r(u);
        }), this.reset(i);
      n && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(i);
      var l = {
        type: G.EVENT_SELECTION_CHANGED,
        source: i
      };
      this.eventService.dispatchEvent(l);
    }, t.prototype.getSelectedCounts = function(e, r) {
      var n = this, i = 0, a = 0, s = function(l) {
        n.groupSelectsChildren && l.group || (l.isSelected() ? i++ : l.selectable && a++);
      };
      return this.getNodesToSelect(e, r).forEach(s), { selectedCount: i, notSelectedCount: a };
    }, t.prototype.getSelectAllState = function(e, r) {
      var n = this.getSelectedCounts(e, r), i = n.selectedCount, a = n.notSelectedCount;
      return i === 0 && a === 0 ? !1 : i > 0 && a > 0 ? null : i > 0;
    }, t.prototype.hasNodesToSelect = function(e, r) {
      return e === void 0 && (e = !1), r === void 0 && (r = !1), this.getNodesToSelect(e, r).filter(function(n) {
        return n.selectable;
      }).length > 0;
    }, t.prototype.getNodesToSelect = function(e, r) {
      var n = this;
      if (e === void 0 && (e = !1), r === void 0 && (r = !1), this.rowModel.getType() !== "clientSide")
        throw new Error("selectAll only available when rowModelType='clientSide', ie not ".concat(this.rowModel.getType()));
      var i = [];
      if (r)
        return this.paginationProxy.forEachNodeOnPage(function(s) {
          if (!s.group) {
            i.push(s);
            return;
          }
          if (!s.expanded) {
            var l = function(u) {
              var c;
              i.push(u), !((c = u.childrenAfterFilter) === null || c === void 0) && c.length && u.childrenAfterFilter.forEach(l);
            };
            l(s);
            return;
          }
          n.groupSelectsChildren || i.push(s);
        }), i;
      var a = this.rowModel;
      return e ? (a.forEachNodeAfterFilter(function(s) {
        i.push(s);
      }), i) : (a.forEachNode(function(s) {
        i.push(s);
      }), i);
    }, t.prototype.selectAllRowNodes = function(e) {
      if (this.rowModel.getType() !== "clientSide")
        throw new Error("selectAll only available when rowModelType='clientSide', ie not ".concat(this.rowModel.getType()));
      var r = e.source, n = e.justFiltered, i = e.justCurrentPage, a = function(l) {
        return l.selectThisNode(!0, void 0, r);
      };
      this.getNodesToSelect(n, i).forEach(a), this.rowModel.getType() === "clientSide" && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(r);
      var s = {
        type: G.EVENT_SELECTION_CHANGED,
        source: r
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.getSelectionState = function() {
      var e = [];
      return this.selectedNodes.forEach(function(r) {
        r != null && r.id && e.push(r.id);
      }), e.length ? e : null;
    }, t.prototype.setSelectionState = function(e, r) {
      if (Array.isArray(e)) {
        var n = new Set(e), i = [];
        this.rowModel.forEachNode(function(a) {
          n.has(a.id) && i.push(a);
        }), this.setNodesSelected({
          newValue: !0,
          nodes: i,
          source: r
        });
      }
    }, $g([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), $g([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), $g([
      Fe
    ], t.prototype, "init", null), t = $g([
      Be("selectionService")
    ], t), t;
  }(Me)
), dP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wZ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, bZ = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, dC = (
  /** @class */
  function() {
    function o(t) {
      var e = this;
      this.viaApi = function(r) {
        for (var n, i = [], a = 1; a < arguments.length; a++)
          i[a - 1] = arguments[a];
        return ht("Since v31, 'columnApi.".concat(r, "' is deprecated and moved to 'api.").concat(r, "'.")), (n = e.api)[r].apply(n, bZ([], wZ(i), !1));
      }, this.api = t;
    }
    return o.prototype.sizeColumnsToFit = function(t) {
      this.viaApi("sizeColumnsToFit", t);
    }, o.prototype.setColumnGroupOpened = function(t, e) {
      this.viaApi("setColumnGroupOpened", t, e);
    }, o.prototype.getColumnGroup = function(t, e) {
      return this.viaApi("getColumnGroup", t, e);
    }, o.prototype.getProvidedColumnGroup = function(t) {
      return this.viaApi("getProvidedColumnGroup", t);
    }, o.prototype.getDisplayNameForColumn = function(t, e) {
      return this.viaApi("getDisplayNameForColumn", t, e);
    }, o.prototype.getDisplayNameForColumnGroup = function(t, e) {
      return this.viaApi("getDisplayNameForColumnGroup", t, e);
    }, o.prototype.getColumn = function(t) {
      return this.viaApi("getColumn", t);
    }, o.prototype.getColumns = function() {
      return this.viaApi("getColumns");
    }, o.prototype.applyColumnState = function(t) {
      return this.viaApi("applyColumnState", t);
    }, o.prototype.getColumnState = function() {
      return this.viaApi("getColumnState");
    }, o.prototype.resetColumnState = function() {
      this.viaApi("resetColumnState");
    }, o.prototype.getColumnGroupState = function() {
      return this.viaApi("getColumnGroupState");
    }, o.prototype.setColumnGroupState = function(t) {
      this.viaApi("setColumnGroupState", t);
    }, o.prototype.resetColumnGroupState = function() {
      this.viaApi("resetColumnGroupState");
    }, o.prototype.isPinning = function() {
      return this.viaApi("isPinning");
    }, o.prototype.isPinningLeft = function() {
      return this.viaApi("isPinningLeft");
    }, o.prototype.isPinningRight = function() {
      return this.viaApi("isPinningRight");
    }, o.prototype.getDisplayedColAfter = function(t) {
      return this.viaApi("getDisplayedColAfter", t);
    }, o.prototype.getDisplayedColBefore = function(t) {
      return this.viaApi("getDisplayedColBefore", t);
    }, o.prototype.setColumnVisible = function(t, e) {
      this.viaApi("setColumnVisible", t, e);
    }, o.prototype.setColumnsVisible = function(t, e) {
      this.viaApi("setColumnsVisible", t, e);
    }, o.prototype.setColumnPinned = function(t, e) {
      this.viaApi("setColumnPinned", t, e);
    }, o.prototype.setColumnsPinned = function(t, e) {
      this.viaApi("setColumnsPinned", t, e);
    }, o.prototype.getAllGridColumns = function() {
      return this.viaApi("getAllGridColumns");
    }, o.prototype.getDisplayedLeftColumns = function() {
      return this.viaApi("getDisplayedLeftColumns");
    }, o.prototype.getDisplayedCenterColumns = function() {
      return this.viaApi("getDisplayedCenterColumns");
    }, o.prototype.getDisplayedRightColumns = function() {
      return this.viaApi("getDisplayedRightColumns");
    }, o.prototype.getAllDisplayedColumns = function() {
      return this.viaApi("getAllDisplayedColumns");
    }, o.prototype.getAllDisplayedVirtualColumns = function() {
      return this.viaApi("getAllDisplayedVirtualColumns");
    }, o.prototype.moveColumn = function(t, e) {
      this.viaApi("moveColumn", t, e);
    }, o.prototype.moveColumnByIndex = function(t, e) {
      this.viaApi("moveColumnByIndex", t, e);
    }, o.prototype.moveColumns = function(t, e) {
      this.viaApi("moveColumns", t, e);
    }, o.prototype.moveRowGroupColumn = function(t, e) {
      this.viaApi("moveRowGroupColumn", t, e);
    }, o.prototype.setColumnAggFunc = function(t, e) {
      this.viaApi("setColumnAggFunc", t, e);
    }, o.prototype.setColumnWidth = function(t, e, r, n) {
      r === void 0 && (r = !0), this.viaApi("setColumnWidth", t, e, r, n);
    }, o.prototype.setColumnWidths = function(t, e, r) {
      e === void 0 && (e = !0), this.viaApi("setColumnWidths", t, e, r);
    }, o.prototype.setPivotMode = function(t) {
      this.viaApi("setPivotMode", t);
    }, o.prototype.isPivotMode = function() {
      return this.viaApi("isPivotMode");
    }, o.prototype.getPivotResultColumn = function(t, e) {
      return this.viaApi("getPivotResultColumn", t, e);
    }, o.prototype.setValueColumns = function(t) {
      this.viaApi("setValueColumns", t);
    }, o.prototype.getValueColumns = function() {
      return this.viaApi("getValueColumns");
    }, o.prototype.removeValueColumn = function(t) {
      this.viaApi("removeValueColumn", t);
    }, o.prototype.removeValueColumns = function(t) {
      this.viaApi("removeValueColumns", t);
    }, o.prototype.addValueColumn = function(t) {
      this.viaApi("addValueColumn", t);
    }, o.prototype.addValueColumns = function(t) {
      this.viaApi("addValueColumns", t);
    }, o.prototype.setRowGroupColumns = function(t) {
      this.viaApi("setRowGroupColumns", t);
    }, o.prototype.removeRowGroupColumn = function(t) {
      this.viaApi("removeRowGroupColumn", t);
    }, o.prototype.removeRowGroupColumns = function(t) {
      this.viaApi("removeRowGroupColumns", t);
    }, o.prototype.addRowGroupColumn = function(t) {
      this.viaApi("addRowGroupColumn", t);
    }, o.prototype.addRowGroupColumns = function(t) {
      this.viaApi("addRowGroupColumns", t);
    }, o.prototype.getRowGroupColumns = function() {
      return this.viaApi("getRowGroupColumns");
    }, o.prototype.setPivotColumns = function(t) {
      this.viaApi("setPivotColumns", t);
    }, o.prototype.removePivotColumn = function(t) {
      this.viaApi("removePivotColumn", t);
    }, o.prototype.removePivotColumns = function(t) {
      this.viaApi("removePivotColumns", t);
    }, o.prototype.addPivotColumn = function(t) {
      this.viaApi("addPivotColumn", t);
    }, o.prototype.addPivotColumns = function(t) {
      this.viaApi("addPivotColumns", t);
    }, o.prototype.getPivotColumns = function() {
      return this.viaApi("getPivotColumns");
    }, o.prototype.getLeftDisplayedColumnGroups = function() {
      return this.viaApi("getLeftDisplayedColumnGroups");
    }, o.prototype.getCenterDisplayedColumnGroups = function() {
      return this.viaApi("getCenterDisplayedColumnGroups");
    }, o.prototype.getRightDisplayedColumnGroups = function() {
      return this.viaApi("getRightDisplayedColumnGroups");
    }, o.prototype.getAllDisplayedColumnGroups = function() {
      return this.viaApi("getAllDisplayedColumnGroups");
    }, o.prototype.autoSizeColumn = function(t, e) {
      return this.viaApi("autoSizeColumn", t, e);
    }, o.prototype.autoSizeColumns = function(t, e) {
      this.viaApi("autoSizeColumns", t, e);
    }, o.prototype.autoSizeAllColumns = function(t) {
      this.viaApi("autoSizeAllColumns", t);
    }, o.prototype.setPivotResultColumns = function(t) {
      this.viaApi("setPivotResultColumns", t);
    }, o.prototype.getPivotResultColumns = function() {
      return this.viaApi("getPivotResultColumns");
    }, dP([
      N("gridApi")
    ], o.prototype, "api", void 0), o = dP([
      Be("columnApi")
    ], o), o;
  }()
), SZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Id = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, FL = (
  /** @class */
  function(o) {
    SZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.initialised = !1, e.isSsrm = !1, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.isSsrm = this.gridOptionsService.isRowModelType("serverSide"), this.cellExpressions = this.gridOptionsService.get("enableCellExpressions"), this.isTreeData = this.gridOptionsService.get("treeData"), this.initialised = !0;
      var r = function(i) {
        return e.callColumnCellValueChangedHandler(i);
      }, n = this.gridOptionsService.useAsyncEvents();
      this.eventService.addEventListener(G.EVENT_CELL_VALUE_CHANGED, r, n), this.addDestroyFunc(function() {
        return e.eventService.removeEventListener(G.EVENT_CELL_VALUE_CHANGED, r, n);
      }), this.addManagedPropertyListener("treeData", function(i) {
        return e.isTreeData = i.currentValue;
      });
    }, t.prototype.getValue = function(e, r, n, i) {
      if (n === void 0 && (n = !1), i === void 0 && (i = !1), this.initialised || this.init(), !!r) {
        var a = e.getColDef(), s = a.field, l = e.getColId(), u = r.data, c, d = r.groupData && r.groupData[l] !== void 0, f = !i && r.aggData && r.aggData[l] !== void 0, v = this.isSsrm && i && !!e.getColDef().aggFunc, g = this.isSsrm && r.footer && r.field && (e.getColDef().showRowGroup === !0 || e.getColDef().showRowGroup === r.field);
        if (n && a.filterValueGetter ? c = this.executeFilterValueGetter(a.filterValueGetter, u, e, r) : this.isTreeData && f ? c = r.aggData[l] : this.isTreeData && a.valueGetter ? c = this.executeValueGetter(a.valueGetter, u, e, r) : this.isTreeData && s && u ? c = qd(u, s, e.isFieldContainsDots()) : d ? c = r.groupData[l] : f ? c = r.aggData[l] : a.valueGetter ? c = this.executeValueGetter(a.valueGetter, u, e, r) : g ? c = qd(u, r.field, e.isFieldContainsDots()) : s && u && !v && (c = qd(u, s, e.isFieldContainsDots())), this.cellExpressions && typeof c == "string" && c.indexOf("=") === 0) {
          var m = c.substring(1);
          c = this.executeValueGetter(m, u, e, r);
        }
        if (c == null) {
          var b = this.getOpenedGroup(r, e);
          if (b != null)
            return b;
        }
        return c;
      }
    }, t.prototype.getOpenedGroup = function(e, r) {
      if (this.gridOptionsService.get("showOpenedGroup")) {
        var n = r.getColDef();
        if (n.showRowGroup)
          for (var i = r.getColDef().showRowGroup, a = e.parent; a != null; ) {
            if (a.rowGroupColumn && (i === !0 || i === a.rowGroupColumn.getColId()))
              return a.key;
            a = a.parent;
          }
      }
    }, t.prototype.setValue = function(e, r, n, i) {
      var a = this.columnModel.getPrimaryColumn(r);
      if (!e || !a)
        return !1;
      tt(e.data) && (e.data = {});
      var s = a.getColDef(), l = s.field, u = s.valueSetter;
      if (tt(l) && tt(u))
        return console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work"), !1;
      if (!this.dataTypeService.checkType(a, n))
        return console.warn("AG Grid: Data type of the new value does not match the cell data type of the column"), !1;
      var c = this.gridOptionsService.addGridCommonParams({
        node: e,
        data: e.data,
        oldValue: this.getValue(a, e),
        newValue: n,
        colDef: a.getColDef(),
        column: a
      });
      c.newValue = n;
      var d;
      if (Oe(u) ? typeof u == "function" ? d = u(c) : d = this.expressionService.evaluate(u, c) : d = this.setValueUsingField(e.data, l, n, a.isFieldContainsDots()), d === void 0 && (d = !0), !d)
        return !1;
      e.resetQuickFilterAggregateText(), this.valueCache.onDataChanged(), c.newValue = this.getValue(a, e);
      var f = {
        type: G.EVENT_CELL_VALUE_CHANGED,
        event: null,
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned,
        column: c.column,
        api: c.api,
        columnApi: c.columnApi,
        colDef: c.colDef,
        context: c.context,
        data: e.data,
        node: e,
        oldValue: c.oldValue,
        newValue: c.newValue,
        value: c.newValue,
        source: i
      };
      return this.eventService.dispatchEvent(f), !0;
    }, t.prototype.callColumnCellValueChangedHandler = function(e) {
      var r = e.colDef.onCellValueChanged;
      typeof r == "function" && r({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        columnApi: e.columnApi,
        context: e.context
      });
    }, t.prototype.setValueUsingField = function(e, r, n, i) {
      if (!r)
        return !1;
      var a = !1;
      if (!i)
        a = e[r] === n, a || (e[r] = n);
      else
        for (var s = r.split("."), l = e; s.length > 0 && l; ) {
          var u = s.shift();
          s.length === 0 ? (a = l[u] === n, a || (l[u] = n)) : l = l[u];
        }
      return !a;
    }, t.prototype.executeFilterValueGetter = function(e, r, n, i) {
      var a = this.gridOptionsService.addGridCommonParams({
        data: r,
        node: i,
        column: n,
        colDef: n.getColDef(),
        getValue: this.getValueCallback.bind(this, i)
      });
      return typeof e == "function" ? e(a) : this.expressionService.evaluate(e, a);
    }, t.prototype.executeValueGetter = function(e, r, n, i) {
      var a = n.getColId(), s = this.valueCache.getValue(i, a);
      if (s !== void 0)
        return s;
      var l = this.gridOptionsService.addGridCommonParams({
        data: r,
        node: i,
        column: n,
        colDef: n.getColDef(),
        getValue: this.getValueCallback.bind(this, i)
      }), u;
      return typeof e == "function" ? u = e(l) : u = this.expressionService.evaluate(e, l), this.valueCache.setValue(i, a, u), u;
    }, t.prototype.getValueCallback = function(e, r) {
      var n = this.columnModel.getPrimaryColumn(r);
      return n ? this.getValue(n, e) : null;
    }, t.prototype.getKeyForNode = function(e, r) {
      var n = this.getValue(e, r), i = e.getColDef().keyCreator, a = n;
      if (i) {
        var s = this.gridOptionsService.addGridCommonParams({
          value: n,
          colDef: e.getColDef(),
          column: e,
          node: r,
          data: r.data
        });
        a = i(s);
      }
      return typeof a == "string" || a == null || (a = String(a), a === "[object Object]" && ht("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key")), a;
    }, Id([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), Id([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Id([
      N("valueCache")
    ], t.prototype, "valueCache", void 0), Id([
      N("dataTypeService")
    ], t.prototype, "dataTypeService", void 0), Id([
      Fe
    ], t.prototype, "init", null), t = Id([
      Be("valueService")
    ], t), t;
  }(Me)
), EZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), pP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, _Z = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, IL = (
  /** @class */
  function(o) {
    EZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.expressionToFunctionCache = {}, e;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("ExpressionService");
    }, t.prototype.evaluate = function(e, r) {
      if (typeof e == "string")
        return this.evaluateExpression(e, r);
      console.error("AG Grid: value should be either a string or a function", e);
    }, t.prototype.evaluateExpression = function(e, r) {
      try {
        var n = this.createExpressionFunction(e), i = n(r.value, r.context, r.oldValue, r.newValue, r.value, r.node, r.data, r.colDef, r.rowIndex, r.api, r.columnApi, r.getValue, r.column, r.columnGroup);
        return i;
      } catch (a) {
        return console.log("Processing of the expression failed"), console.log("Expression = " + e), console.log("Params =", r), console.log("Exception = " + a), null;
      }
    }, t.prototype.createExpressionFunction = function(e) {
      if (this.expressionToFunctionCache[e])
        return this.expressionToFunctionCache[e];
      var r = this.createFunctionBody(e), n = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", r);
      return this.expressionToFunctionCache[e] = n, n;
    }, t.prototype.createFunctionBody = function(e) {
      return e.indexOf("return") >= 0 ? e : "return " + e + ";";
    }, pP([
      _Z(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), t = pP([
      Be("expressionService")
    ], t), t;
  }(Me)
), xZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), RZ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, LL = (
  /** @class */
  function(o) {
    xZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.templateCache = {}, e.waitingCallbacks = {}, e;
    }
    return t.prototype.getTemplate = function(e, r) {
      var n = this.templateCache[e];
      if (n)
        return n;
      var i = this.waitingCallbacks[e], a = this;
      if (!i) {
        i = [], this.waitingCallbacks[e] = i;
        var s = new XMLHttpRequest();
        s.onload = function() {
          a.handleHttpResult(this, e);
        }, s.open("GET", e), s.send();
      }
      return r && i.push(r), null;
    }, t.prototype.handleHttpResult = function(e, r) {
      if (e.status !== 200 || e.response === null) {
        console.warn("AG Grid: Unable to get template error ".concat(e.status, " - ").concat(r));
        return;
      }
      this.templateCache[r] = e.response || e.responseText;
      for (var n = this.waitingCallbacks[r], i = 0; i < n.length; i++) {
        var a = n[i];
        a();
      }
    }, t = RZ([
      Be("templateService")
    ], t), t;
  }(Me)
), TZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, OZ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, NL = (
  /** @class */
  function(o) {
    TZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setBeans = function(e) {
      this.logging = e.get("debug");
    }, t.prototype.create = function(e) {
      return new pC(e, this.isLogging.bind(this));
    }, t.prototype.isLogging = function() {
      return this.logging;
    }, fP([
      OZ(0, ii("gridOptionsService"))
    ], t.prototype, "setBeans", null), t = fP([
      Be("loggerFactory")
    ], t), t;
  }(Me)
), pC = (
  /** @class */
  function() {
    function o(t, e) {
      this.name = t, this.isLoggingFunc = e;
    }
    return o.prototype.isLogging = function() {
      return this.isLoggingFunc();
    }, o.prototype.log = function(t) {
      this.isLoggingFunc() && console.log("AG Grid." + this.name + ": " + t);
    }, o;
  }()
), PZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Ld = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, kL = (
  /** @class */
  function(o) {
    PZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setComp = function(e, r, n) {
      var i = this;
      this.view = e, this.eGridHostDiv = r, this.eGui = n, this.eGui.setAttribute("grid-id", this.context.getGridId()), this.dragAndDropService.addDropTarget({
        getContainer: function() {
          return i.eGui;
        },
        isInterestedIn: function(s) {
          return s === ho.HeaderCell || s === ho.ToolPanel;
        },
        getIconName: function() {
          return fn.ICON_NOT_ALLOWED;
        }
      }), this.mouseEventService.stampTopLevelGridCompWithGridInstance(r), this.createManagedBean(new p_(this.view)), this.addRtlSupport();
      var a = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
      this.addDestroyFunc(function() {
        return a();
      }), this.ctrlsService.registerGridCtrl(this);
    }, t.prototype.isDetailGrid = function() {
      var e, r = this.focusService.findTabbableParent(this.getGui());
      return ((e = r == null ? void 0 : r.getAttribute("row-id")) === null || e === void 0 ? void 0 : e.startsWith("detail")) || !1;
    }, t.prototype.showDropZones = function() {
      return Xt.__isRegistered(Ye.RowGroupingModule, this.context.getGridId());
    }, t.prototype.showSideBar = function() {
      return Xt.__isRegistered(Ye.SideBarModule, this.context.getGridId());
    }, t.prototype.showStatusBar = function() {
      return Xt.__isRegistered(Ye.StatusBarModule, this.context.getGridId());
    }, t.prototype.showWatermark = function() {
      return Xt.__isRegistered(Ye.EnterpriseCoreModule, this.context.getGridId());
    }, t.prototype.onGridSizeChanged = function() {
      var e = {
        type: G.EVENT_GRID_SIZE_CHANGED,
        clientWidth: this.eGridHostDiv.clientWidth,
        clientHeight: this.eGridHostDiv.clientHeight
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.addRtlSupport = function() {
      var e = this.gridOptionsService.get("enableRtl") ? "ag-rtl" : "ag-ltr";
      this.view.setRtlClass(e);
    }, t.prototype.destroyGridUi = function() {
      this.view.destroyGridUi();
    }, t.prototype.getGui = function() {
      return this.eGui;
    }, t.prototype.setResizeCursor = function(e) {
      this.view.setCursor(e ? "ew-resize" : null);
    }, t.prototype.disableUserSelect = function(e) {
      this.view.setUserSelect(e ? "none" : null);
    }, t.prototype.focusNextInnerContainer = function(e) {
      var r = this.gridOptionsService.getDocument(), n = this.view.getFocusableContainers(), i = n.findIndex(function(s) {
        return s.contains(r.activeElement);
      }), a = i + (e ? -1 : 1);
      return a <= 0 || a >= n.length ? !1 : this.focusService.focusInto(n[a]);
    }, t.prototype.focusInnerElement = function(e) {
      var r = this.view.getFocusableContainers(), n = this.columnModel.getAllDisplayedColumns();
      if (e) {
        if (r.length > 1)
          return this.focusService.focusInto(Kt(r), !0);
        var i = Kt(n);
        if (this.focusService.focusGridView(i, !0))
          return !0;
      }
      return this.gridOptionsService.get("headerHeight") === 0 ? this.focusService.focusGridView(n[0]) : this.focusService.focusFirstHeader();
    }, t.prototype.forceFocusOutOfContainer = function(e) {
      e === void 0 && (e = !1), this.view.forceFocusOutOfContainer(e);
    }, Ld([
      N("focusService")
    ], t.prototype, "focusService", void 0), Ld([
      N("resizeObserverService")
    ], t.prototype, "resizeObserverService", void 0), Ld([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ld([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ld([
      N("mouseEventService")
    ], t.prototype, "mouseEventService", void 0), Ld([
      N("dragAndDropService")
    ], t.prototype, "dragAndDropService", void 0), t;
  }(Me)
), DZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, C_ = (
  /** @class */
  function(o) {
    DZ(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.eGridDiv = e, r;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.logger = this.loggerFactory.create("GridComp");
      var r = {
        destroyGridUi: function() {
          return e.destroyBean(e);
        },
        setRtlClass: function(i) {
          return e.addCssClass(i);
        },
        forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
        updateLayoutClasses: this.updateLayoutClasses.bind(this),
        getFocusableContainers: this.getFocusableContainers.bind(this),
        setUserSelect: function(i) {
          e.getGui().style.userSelect = i ?? "", e.getGui().style.webkitUserSelect = i ?? "";
        },
        setCursor: function(i) {
          e.getGui().style.cursor = i ?? "";
        }
      };
      this.ctrl = this.createManagedBean(new kL());
      var n = this.createTemplate();
      this.setTemplate(n), this.ctrl.setComp(r, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
        // we want to override the default behaviour to do nothing for onTabKeyDown
        onTabKeyDown: function() {
        },
        focusInnerElement: function(i) {
          return e.ctrl.focusInnerElement(i);
        }
      });
    }, t.prototype.insertGridIntoDom = function() {
      var e = this, r = this.getGui();
      this.eGridDiv.appendChild(r), this.addDestroyFunc(function() {
        e.eGridDiv.removeChild(r), e.logger.log("Grid removed from DOM");
      });
    }, t.prototype.updateLayoutClasses = function(e, r) {
      var n = this.eRootWrapperBody.classList;
      n.toggle(rn.AUTO_HEIGHT, r.autoHeight), n.toggle(rn.NORMAL, r.normal), n.toggle(rn.PRINT, r.print), this.addOrRemoveCssClass(rn.AUTO_HEIGHT, r.autoHeight), this.addOrRemoveCssClass(rn.NORMAL, r.normal), this.addOrRemoveCssClass(rn.PRINT, r.print);
    }, t.prototype.createTemplate = function() {
      var e = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "", r = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "", n = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "", i = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "", a = (
        /* html */
        `<div class="ag-root-wrapper" role="presentation">
                `.concat(e, `
                <div class="ag-root-wrapper-body" ref="rootWrapperBody" role="presentation">
                    <ag-grid-body ref="gridBody"></ag-grid-body>
                    `).concat(r, `
                </div>
                `).concat(n, `
                <ag-pagination></ag-pagination>
                `).concat(i, `
            </div>`)
      );
      return a;
    }, t.prototype.getFocusableElement = function() {
      return this.eRootWrapperBody;
    }, t.prototype.getFocusableContainers = function() {
      var e = [
        this.gridBodyComp.getGui()
      ];
      return this.sideBarComp && e.push(this.sideBarComp.getGui()), e.filter(function(r) {
        return ai(r);
      });
    }, jf([
      N("loggerFactory")
    ], t.prototype, "loggerFactory", void 0), jf([
      ke("gridBody")
    ], t.prototype, "gridBodyComp", void 0), jf([
      ke("sideBar")
    ], t.prototype, "sideBarComp", void 0), jf([
      ke("rootWrapperBody")
    ], t.prototype, "eRootWrapperBody", void 0), jf([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(vp)
), AZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ba = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, pl = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, GL = (
  /** @class */
  function(o) {
    AZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    e = t, t.prototype.progressSort = function(r, n, i) {
      var a = this.getNextSortDirection(r);
      this.setSortForColumn(r, a, n, i);
    }, t.prototype.setSortForColumn = function(r, n, i, a) {
      n !== "asc" && n !== "desc" && (n = null);
      var s = this.gridOptionsService.isColumnsSortingCoupledToGroup(), l = [r];
      if (s && r.getColDef().showRowGroup) {
        var u = this.columnModel.getSourceColumnsForGroupColumn(r), c = u == null ? void 0 : u.filter(function(g) {
          return g.isSortable();
        });
        c && (l = pl([r], ba(c), !1));
      }
      l.forEach(function(g) {
        return g.setSort(n, a);
      });
      var d = (i || this.gridOptionsService.get("alwaysMultiSort")) && !this.gridOptionsService.get("suppressMultiSort"), f = [];
      if (!d) {
        var v = this.clearSortBarTheseColumns(l, a);
        f.push.apply(f, pl([], ba(v), !1));
      }
      this.updateSortIndex(r), f.push.apply(f, pl([], ba(l), !1)), this.dispatchSortChangedEvents(a, f);
    }, t.prototype.updateSortIndex = function(r) {
      var n = this.gridOptionsService.isColumnsSortingCoupledToGroup(), i = this.columnModel.getGroupDisplayColumnForGroup(r.getId()), a = n && i || r, s = this.getColumnsWithSortingOrdered();
      this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function(c) {
        return c.setSortIndex(null);
      });
      var l = s.filter(function(c) {
        return c !== a;
      }), u = a.getSort() ? pl(pl([], ba(l), !1), [a], !1) : l;
      u.forEach(function(c, d) {
        return c.setSortIndex(d);
      });
    }, t.prototype.onSortChanged = function(r, n) {
      this.dispatchSortChangedEvents(r, n);
    }, t.prototype.isSortActive = function() {
      var r = this.columnModel.getPrimaryAndSecondaryAndAutoColumns(), n = r.filter(function(i) {
        return !!i.getSort();
      });
      return n && n.length > 0;
    }, t.prototype.dispatchSortChangedEvents = function(r, n) {
      var i = {
        type: G.EVENT_SORT_CHANGED,
        source: r
      };
      n && (i.columns = n), this.eventService.dispatchEvent(i);
    }, t.prototype.clearSortBarTheseColumns = function(r, n) {
      var i = [];
      return this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function(a) {
        r.includes(a) || (a.getSort() && i.push(a), a.setSort(void 0, n));
      }), i;
    }, t.prototype.getNextSortDirection = function(r) {
      var n;
      if (r.getColDef().sortingOrder ? n = r.getColDef().sortingOrder : this.gridOptionsService.get("sortingOrder") ? n = this.gridOptionsService.get("sortingOrder") : n = e.DEFAULT_SORTING_ORDER, !Array.isArray(n) || n.length <= 0)
        return console.warn("AG Grid: sortingOrder must be an array with at least one element, currently it's ".concat(n)), null;
      var i = n.indexOf(r.getSort()), a = i < 0, s = i == n.length - 1, l;
      return a || s ? l = n[0] : l = n[i + 1], e.DEFAULT_SORTING_ORDER.indexOf(l) < 0 ? (console.warn("AG Grid: invalid sort type " + l), null) : l;
    }, t.prototype.getIndexedSortMap = function() {
      var r = this, n = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter(function(c) {
        return !!c.getSort();
      });
      if (this.columnModel.isPivotMode()) {
        var i = this.gridOptionsService.isColumnsSortingCoupledToGroup();
        n = n.filter(function(c) {
          var d = !!c.getAggFunc(), f = !c.isPrimary(), v = i ? r.columnModel.getGroupDisplayColumnForGroup(c.getId()) : c.getColDef().showRowGroup;
          return d || f || v;
        });
      }
      var a = this.columnModel.getRowGroupColumns().filter(function(c) {
        return !!c.getSort();
      }), s = this.gridOptionsService.isColumnsSortingCoupledToGroup() && !!a.length;
      s && (n = pl([], ba(new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        n.map(function(c) {
          var d;
          return (d = r.columnModel.getGroupDisplayColumnForGroup(c.getId())) !== null && d !== void 0 ? d : c;
        })
      )), !1));
      var l = {};
      n.forEach(function(c, d) {
        return l[c.getId()] = d;
      }), n.sort(function(c, d) {
        var f = c.getSortIndex(), v = d.getSortIndex();
        if (f != null && v != null)
          return f - v;
        if (f == null && v == null) {
          var g = l[c.getId()], m = l[d.getId()];
          return g > m ? 1 : -1;
        } else return v == null ? -1 : 1;
      });
      var u = /* @__PURE__ */ new Map();
      return n.forEach(function(c, d) {
        return u.set(c, d);
      }), s && a.forEach(function(c) {
        var d = r.columnModel.getGroupDisplayColumnForGroup(c.getId());
        u.set(c, u.get(d));
      }), u;
    }, t.prototype.getColumnsWithSortingOrdered = function() {
      return pl([], ba(this.getIndexedSortMap().entries()), !1).sort(function(r, n) {
        var i = ba(r, 2);
        i[0];
        var a = i[1], s = ba(n, 2);
        s[0];
        var l = s[1];
        return a - l;
      }).map(function(r) {
        var n = ba(r, 1), i = n[0];
        return i;
      });
    }, t.prototype.getSortModel = function() {
      return this.getColumnsWithSortingOrdered().filter(function(r) {
        return r.getSort();
      }).map(function(r) {
        return {
          sort: r.getSort(),
          colId: r.getId()
        };
      });
    }, t.prototype.getSortOptions = function() {
      return this.getColumnsWithSortingOrdered().filter(function(r) {
        return r.getSort();
      }).map(function(r) {
        return {
          sort: r.getSort(),
          column: r
        };
      });
    }, t.prototype.canColumnDisplayMixedSort = function(r) {
      var n = this.gridOptionsService.isColumnsSortingCoupledToGroup(), i = !!r.getColDef().showRowGroup;
      return n && i;
    }, t.prototype.getDisplaySortForColumn = function(r) {
      var n = this.columnModel.getSourceColumnsForGroupColumn(r);
      if (!this.canColumnDisplayMixedSort(r) || !(n != null && n.length))
        return r.getSort();
      var i = r.getColDef().field != null || !!r.getColDef().valueGetter, a = i ? pl([r], ba(n), !1) : n, s = a[0].getSort(), l = a.every(function(u) {
        return u.getSort() == s;
      });
      return l ? s : "mixed";
    }, t.prototype.getDisplaySortIndexForColumn = function(r) {
      return this.getIndexedSortMap().get(r);
    };
    var e;
    return t.DEFAULT_SORTING_ORDER = ["asc", "desc", null], hP([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), t = e = hP([
      Be("sortController")
    ], t), t;
  }(Me)
), MZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Oh = function() {
  return Oh = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Oh.apply(this, arguments);
}, Ko = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, VL = (
  /** @class */
  function(o) {
    MZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    e = t, t.addKeyboardModeEvents = function(r) {
      this.instanceCount > 0 || (r.addEventListener("keydown", e.toggleKeyboardMode), r.addEventListener("mousedown", e.toggleKeyboardMode));
    }, t.removeKeyboardModeEvents = function(r) {
      this.instanceCount > 0 || (r.addEventListener("keydown", e.toggleKeyboardMode), r.addEventListener("mousedown", e.toggleKeyboardMode));
    }, t.toggleKeyboardMode = function(r) {
      var n = e.keyboardModeActive, i = r.type === "keydown";
      i && (r.ctrlKey || r.metaKey || r.altKey) || n !== i && (e.keyboardModeActive = i);
    }, t.unregisterGridCompController = function(r) {
      e.removeKeyboardModeEvents(r);
    }, t.prototype.init = function() {
      var r = this, n = this.clearFocusedCell.bind(this);
      this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, n), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_GROUP_OPENED, n), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, n), this.registerKeyboardFocusEvents(), this.ctrlsService.whenReady(function(i) {
        r.gridCtrl = i.gridCtrl;
      });
    }, t.prototype.registerKeyboardFocusEvents = function() {
      var r = this.gridOptionsService.getDocument();
      e.addKeyboardModeEvents(r), e.instanceCount++, this.addDestroyFunc(function() {
        e.instanceCount--, e.unregisterGridCompController(r);
      });
    }, t.prototype.onColumnEverythingChanged = function() {
      if (this.focusedCellPosition) {
        var r = this.focusedCellPosition.column, n = this.columnModel.getGridColumn(r.getId());
        r !== n && this.clearFocusedCell();
      }
    }, t.prototype.isKeyboardMode = function() {
      return e.keyboardModeActive;
    }, t.prototype.getFocusCellToUseAfterRefresh = function() {
      var r = this.gridOptionsService.getDocument();
      return this.gridOptionsService.get("suppressFocusAfterRefresh") || !this.focusedCellPosition || this.isDomDataMissingInHierarchy(r.activeElement, Fl.DOM_DATA_KEY_ROW_CTRL) ? null : this.focusedCellPosition;
    }, t.prototype.getFocusHeaderToUseAfterRefresh = function() {
      var r = this.gridOptionsService.getDocument();
      return this.gridOptionsService.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition || this.isDomDataMissingInHierarchy(r.activeElement, vv.DOM_DATA_KEY_HEADER_CTRL) ? null : this.focusedHeaderPosition;
    }, t.prototype.isDomDataMissingInHierarchy = function(r, n) {
      for (var i = r; i; ) {
        var a = this.gridOptionsService.getDomData(i, n);
        if (a)
          return !1;
        i = i.parentNode;
      }
      return !0;
    }, t.prototype.getFocusedCell = function() {
      return this.focusedCellPosition;
    }, t.prototype.shouldRestoreFocus = function(r) {
      var n = this;
      return this.isCellRestoreFocused(r) ? (setTimeout(function() {
        n.restoredFocusedCellPosition = null;
      }, 0), !0) : !1;
    }, t.prototype.isCellRestoreFocused = function(r) {
      return this.restoredFocusedCellPosition == null ? !1 : this.cellPositionUtils.equals(r, this.restoredFocusedCellPosition);
    }, t.prototype.setRestoreFocusedCell = function(r) {
      this.getFrameworkOverrides().renderingEngine === "react" && (this.restoredFocusedCellPosition = r);
    }, t.prototype.getFocusEventParams = function() {
      var r = this.focusedCellPosition, n = r.rowIndex, i = r.rowPinned, a = r.column, s = {
        rowIndex: n,
        rowPinned: i,
        column: a,
        isFullWidthCell: !1
      }, l = this.rowRenderer.getRowByPosition({ rowIndex: n, rowPinned: i });
      return l && (s.isFullWidthCell = l.isFullWidth()), s;
    }, t.prototype.clearFocusedCell = function() {
      if (this.restoredFocusedCellPosition = null, this.focusedCellPosition != null) {
        var r = Oh({ type: G.EVENT_CELL_FOCUS_CLEARED }, this.getFocusEventParams());
        this.focusedCellPosition = null, this.eventService.dispatchEvent(r);
      }
    }, t.prototype.setFocusedCell = function(r) {
      var n = r.column, i = r.rowIndex, a = r.rowPinned, s = r.forceBrowserFocus, l = s === void 0 ? !1 : s, u = r.preventScrollOnBrowserFocus, c = u === void 0 ? !1 : u, d = this.columnModel.getGridColumn(n);
      if (!d) {
        this.focusedCellPosition = null;
        return;
      }
      this.focusedCellPosition = d ? {
        rowIndex: i,
        rowPinned: Ia(a),
        column: d
      } : null;
      var f = Oh(Oh({ type: G.EVENT_CELL_FOCUSED }, this.getFocusEventParams()), { forceBrowserFocus: l, preventScrollOnBrowserFocus: c, floating: null });
      this.eventService.dispatchEvent(f);
    }, t.prototype.isCellFocused = function(r) {
      return this.focusedCellPosition == null ? !1 : this.cellPositionUtils.equals(r, this.focusedCellPosition);
    }, t.prototype.isRowNodeFocused = function(r) {
      return this.isRowFocused(r.rowIndex, r.rowPinned);
    }, t.prototype.isHeaderWrapperFocused = function(r) {
      if (this.focusedHeaderPosition == null)
        return !1;
      var n = r.getColumnGroupChild(), i = r.getRowIndex(), a = r.getPinned(), s = this.focusedHeaderPosition, l = s.column, u = s.headerRowIndex;
      return n === l && i === u && a == l.getPinned();
    }, t.prototype.clearFocusedHeader = function() {
      this.focusedHeaderPosition = null;
    }, t.prototype.getFocusedHeader = function() {
      return this.focusedHeaderPosition;
    }, t.prototype.setFocusedHeader = function(r, n) {
      this.focusedHeaderPosition = { headerRowIndex: r, column: n };
    }, t.prototype.focusHeaderPosition = function(r) {
      var n = r.direction, i = r.fromTab, a = r.allowUserOverride, s = r.event, l = r.fromCell, u = r.headerPosition;
      if (l && this.filterManager.isAdvancedFilterHeaderActive())
        return this.focusAdvancedFilter(u);
      if (a) {
        var c = this.getFocusedHeader(), d = this.headerNavigationService.getHeaderRowCount();
        if (i) {
          var f = this.gridOptionsService.getCallback("tabToNextHeader");
          if (f) {
            var v = {
              backwards: n === "Before",
              previousHeaderPosition: c,
              nextHeaderPosition: u,
              headerRowCount: d
            };
            u = f(v);
          }
        } else {
          var f = this.gridOptionsService.getCallback("navigateToNextHeader");
          if (f && s) {
            var g = {
              key: s.key,
              previousHeaderPosition: c,
              nextHeaderPosition: u,
              headerRowCount: d,
              event: s
            };
            u = f(g);
          }
        }
      }
      if (!u)
        return !1;
      if (u.headerRowIndex === -1)
        return this.filterManager.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(u) : this.focusGridView(u.column);
      this.headerNavigationService.scrollToColumn(u.column, n);
      var m = this.ctrlsService.getHeaderRowContainerCtrl(u.column.getPinned()), b = m.focusHeader(u.headerRowIndex, u.column, s);
      return b;
    }, t.prototype.focusFirstHeader = function() {
      var r = this.columnModel.getAllDisplayedColumns()[0];
      return r ? (r.getParent() && (r = this.columnModel.getColumnGroupAtLevel(r, 0)), this.focusHeaderPosition({
        headerPosition: { headerRowIndex: 0, column: r }
      })) : !1;
    }, t.prototype.focusLastHeader = function(r) {
      var n = this.headerNavigationService.getHeaderRowCount() - 1, i = Kt(this.columnModel.getAllDisplayedColumns());
      return this.focusHeaderPosition({
        headerPosition: { headerRowIndex: n, column: i },
        event: r
      });
    }, t.prototype.focusPreviousFromFirstCell = function(r) {
      return this.filterManager.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(r);
    }, t.prototype.isAnyCellFocused = function() {
      return !!this.focusedCellPosition;
    }, t.prototype.isRowFocused = function(r, n) {
      return this.focusedCellPosition == null ? !1 : this.focusedCellPosition.rowIndex === r && this.focusedCellPosition.rowPinned === Ia(n);
    }, t.prototype.findFocusableElements = function(r, n, i) {
      i === void 0 && (i = !1);
      var a = B2, s = W1;
      n && (s += ", " + n), i && (s += ', [tabindex="-1"]');
      var l = Array.prototype.slice.apply(r.querySelectorAll(a)).filter(function(d) {
        return ai(d);
      }), u = Array.prototype.slice.apply(r.querySelectorAll(s));
      if (!u.length)
        return l;
      var c = function(d, f) {
        return d.filter(function(v) {
          return f.indexOf(v) === -1;
        });
      };
      return c(l, u);
    }, t.prototype.focusInto = function(r, n, i) {
      n === void 0 && (n = !1), i === void 0 && (i = !1);
      var a = this.findFocusableElements(r, null, i), s = n ? Kt(a) : a[0];
      return s ? (s.focus({ preventScroll: !0 }), !0) : !1;
    }, t.prototype.findFocusableElementBeforeTabGuard = function(r, n) {
      if (!n)
        return null;
      var i = this.findFocusableElements(r), a = i.indexOf(n);
      if (a === -1)
        return null;
      for (var s = -1, l = a - 1; l >= 0; l--)
        if (i[l].classList.contains(uc.TAB_GUARD_TOP)) {
          s = l;
          break;
        }
      return s <= 0 ? null : i[s - 1];
    }, t.prototype.findNextFocusableElement = function(r, n, i) {
      r === void 0 && (r = this.eGridDiv);
      var a = this.findFocusableElements(r, n ? ':not([tabindex="-1"])' : null), s = this.gridOptionsService.getDocument(), l = s.activeElement, u;
      n ? u = a.findIndex(function(d) {
        return d.contains(l);
      }) : u = a.indexOf(l);
      var c = u + (i ? -1 : 1);
      return c < 0 || c >= a.length ? null : a[c];
    }, t.prototype.isTargetUnderManagedComponent = function(r, n) {
      if (!n)
        return !1;
      var i = r.querySelectorAll(".".concat($l.FOCUS_MANAGED_CLASS));
      if (!i.length)
        return !1;
      for (var a = 0; a < i.length; a++)
        if (i[a].contains(n))
          return !0;
      return !1;
    }, t.prototype.findTabbableParent = function(r, n) {
      n === void 0 && (n = 5);
      for (var i = 0; r && Qm(r) === null && ++i <= n; )
        r = r.parentElement;
      return Qm(r) === null ? null : r;
    }, t.prototype.focusGridView = function(r, n) {
      if (this.gridOptionsService.get("suppressCellFocus"))
        return n ? this.focusLastHeader() : this.focusNextGridCoreContainer(!1);
      var i = n ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
      if (!i)
        return !1;
      var a = i.rowIndex, s = i.rowPinned, l = this.getFocusedHeader();
      if (!r && l && (r = l.column), a == null || !r)
        return !1;
      if (this.navigationService.ensureCellVisible({ rowIndex: a, column: r, rowPinned: s }), this.setFocusedCell({
        rowIndex: a,
        column: r,
        rowPinned: Ia(s),
        forceBrowserFocus: !0
      }), this.rangeService) {
        var u = { rowIndex: a, rowPinned: s, column: r };
        this.rangeService.setRangeToCell(u);
      }
      return !0;
    }, t.prototype.focusNextGridCoreContainer = function(r, n) {
      return n === void 0 && (n = !1), !n && this.gridCtrl.focusNextInnerContainer(r) ? !0 : ((n || !r && !this.gridCtrl.isDetailGrid()) && this.gridCtrl.forceFocusOutOfContainer(r), !1);
    }, t.prototype.focusAdvancedFilter = function(r) {
      return this.advancedFilterFocusColumn = r == null ? void 0 : r.column, this.advancedFilterService.getCtrl().focusHeaderComp();
    }, t.prototype.focusNextFromAdvancedFilter = function(r, n) {
      var i, a, s = (i = n ? void 0 : this.advancedFilterFocusColumn) !== null && i !== void 0 ? i : (a = this.columnModel.getAllDisplayedColumns()) === null || a === void 0 ? void 0 : a[0];
      return r ? this.focusHeaderPosition({
        headerPosition: {
          column: s,
          headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1
        }
      }) : this.focusGridView(s);
    }, t.prototype.clearAdvancedFilterColumn = function() {
      this.advancedFilterFocusColumn = void 0;
    };
    var e;
    return t.keyboardModeActive = !1, t.instanceCount = 0, Ko([
      N("eGridDiv")
    ], t.prototype, "eGridDiv", void 0), Ko([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ko([
      N("headerNavigationService")
    ], t.prototype, "headerNavigationService", void 0), Ko([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Ko([
      N("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), Ko([
      N("cellPositionUtils")
    ], t.prototype, "cellPositionUtils", void 0), Ko([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), Ko([
      N("navigationService")
    ], t.prototype, "navigationService", void 0), Ko([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ko([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Ko([
      Lt("advancedFilterService")
    ], t.prototype, "advancedFilterService", void 0), Ko([
      Fe
    ], t.prototype, "init", null), t = e = Ko([
      Be("focusService")
    ], t), t;
  }(Me)
), FZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), IZ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, LZ = (
  /** @class */
  function(o) {
    FZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.setMouseOver = function(e) {
      this.selectedColumns = e;
      var r = {
        type: G.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.clearMouseOver = function() {
      this.selectedColumns = null;
      var e = {
        type: G.EVENT_COLUMN_HOVER_CHANGED
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.isHovered = function(e) {
      return !!this.selectedColumns && this.selectedColumns.indexOf(e) >= 0;
    }, t = IZ([
      Be("columnHoverService")
    ], t), t;
  }(Me)
), NZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ab = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, kZ = (
  /** @class */
  function(o) {
    NZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.executeNextFuncs = [], e.executeLaterFuncs = [], e.active = !1, e.animationThreadCount = 0, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        return e.gridBodyCtrl = r.gridBodyCtrl;
      });
    }, t.prototype.isActive = function() {
      return this.active;
    }, t.prototype.start = function() {
      this.active || this.gridOptionsService.get("suppressColumnMoveAnimation") || this.gridOptionsService.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0);
    }, t.prototype.finish = function() {
      this.active && (this.flush(), this.active = !1);
    }, t.prototype.executeNextVMTurn = function(e) {
      this.active ? this.executeNextFuncs.push(e) : e();
    }, t.prototype.executeLaterVMTurn = function(e) {
      this.active ? this.executeLaterFuncs.push(e) : e();
    }, t.prototype.ensureAnimationCssClassPresent = function() {
      var e = this;
      this.animationThreadCount++;
      var r = this.animationThreadCount;
      this.gridBodyCtrl.setColumnMovingCss(!0), this.executeLaterFuncs.push(function() {
        e.animationThreadCount === r && e.gridBodyCtrl.setColumnMovingCss(!1);
      });
    }, t.prototype.flush = function() {
      var e = this.executeNextFuncs;
      this.executeNextFuncs = [];
      var r = this.executeLaterFuncs;
      this.executeLaterFuncs = [], !(e.length === 0 && r.length === 0) && this.getFrameworkOverrides().wrapIncoming(function() {
        window.setTimeout(function() {
          return e.forEach(function(n) {
            return n();
          });
        }, 0), window.setTimeout(function() {
          return r.forEach(function(n) {
            return n();
          });
        }, 300);
      });
    }, ab([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), ab([
      Fe
    ], t.prototype, "postConstruct", null), t = ab([
      Be("columnAnimationService")
    ], t), t;
  }(Me)
), GZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, VZ = (
  /** @class */
  function(o) {
    GZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.ctrlsService.whenReady(function(r) {
        e.centerRowContainerCon = r.centerRowContainerCtrl, e.addManagedListener(e.eventService, G.EVENT_BODY_HEIGHT_CHANGED, e.checkPageSize.bind(e)), e.addManagedListener(e.eventService, G.EVENT_SCROLL_VISIBILITY_CHANGED, e.checkPageSize.bind(e)), e.addManagedPropertyListener("paginationAutoPageSize", e.onPaginationAutoSizeChanged.bind(e)), e.checkPageSize();
      });
    }, t.prototype.notActive = function() {
      return !this.gridOptionsService.get("paginationAutoPageSize") || this.centerRowContainerCon == null;
    }, t.prototype.onPaginationAutoSizeChanged = function() {
      this.notActive() ? this.paginationProxy.unsetAutoCalculatedPageSize() : this.checkPageSize();
    }, t.prototype.checkPageSize = function() {
      var e = this;
      if (!this.notActive()) {
        var r = this.centerRowContainerCon.getViewportSizeFeature().getBodyHeight();
        if (r > 0) {
          var n = function() {
            var i = e.gridOptionsService.getRowHeightAsNumber(), a = Math.floor(r / i);
            e.paginationProxy.setPageSize(a, "autoCalculated");
          };
          this.isBodyRendered ? Oi(function() {
            return n();
          }, 50)() : (n(), this.isBodyRendered = !0);
        } else
          this.isBodyRendered = !1;
      }
    }, zg([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), zg([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), zg([
      Fe
    ], t.prototype, "postConstruct", null), t = zg([
      Be("paginationAutoPageSizeService")
    ], t), t;
  }(Me)
), HZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, HL = (
  /** @class */
  function(o) {
    HZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.cacheVersion = 0, e;
    }
    return t.prototype.init = function() {
      this.active = this.gridOptionsService.get("valueCache"), this.neverExpires = this.gridOptionsService.get("valueCacheNeverExpires");
    }, t.prototype.onDataChanged = function() {
      this.neverExpires || this.expire();
    }, t.prototype.expire = function() {
      this.cacheVersion++;
    }, t.prototype.setValue = function(e, r, n) {
      this.active && (e.__cacheVersion !== this.cacheVersion && (e.__cacheVersion = this.cacheVersion, e.__cacheData = {}), e.__cacheData[r] = n);
    }, t.prototype.getValue = function(e, r) {
      if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
        return e.__cacheData[r];
    }, vP([
      Fe
    ], t.prototype, "init", null), t = vP([
      Be("valueCache")
    ], t), t;
  }(Me)
), BZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, WZ = "paste", jZ = (
  /** @class */
  function(o) {
    BZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel), this.addManagedListener(this.eventService, G.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    }, t.prototype.onCellValueChanged = function(e) {
      e.source !== WZ && this.doChangeDetection(e.node, e.column);
    }, t.prototype.doChangeDetection = function(e, r) {
      if (!this.gridOptionsService.get("suppressChangeDetection")) {
        var n = [e];
        if (this.clientSideRowModel && !e.isRowPinned()) {
          var i = this.gridOptionsService.get("aggregateOnlyChangedColumns"), a = new gv(i, this.clientSideRowModel.getRootNode());
          a.addParentNode(e.parent, [r]), this.clientSideRowModel.doAggregate(a), a.forEachChangedNodeDepthFirst(function(s) {
            n.push(s);
          });
        }
        this.rowRenderer.refreshCells({ rowNodes: n });
      }
    }, Yg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Yg([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Yg([
      Fe
    ], t.prototype, "init", null), t = Yg([
      Be("changeDetectionService")
    ], t), t;
  }(Me)
), UZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, $Z = (
  /** @class */
  function(o) {
    UZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.adaptFunction = function(e, r) {
      var n = this.componentMetadataProvider.retrieve(e);
      return n && n.functionAdapter ? n.functionAdapter(r) : null;
    }, t.prototype.adaptCellRendererFunction = function(e) {
      var r = (
        /** @class */
        function() {
          function n() {
          }
          return n.prototype.refresh = function(i) {
            return !1;
          }, n.prototype.getGui = function() {
            return this.eGui;
          }, n.prototype.init = function(i) {
            var a = e(i), s = typeof a;
            if (s === "string" || s === "number" || s === "boolean") {
              this.eGui = No("<span>" + a + "</span>");
              return;
            }
            if (a == null) {
              this.eGui = No("<span></span>");
              return;
            }
            this.eGui = a;
          }, n;
        }()
      );
      return r;
    }, t.prototype.doesImplementIComponent = function(e) {
      return e ? e.prototype && "getGui" in e.prototype : !1;
    }, gP([
      N("componentMetadataProvider")
    ], t.prototype, "componentMetadataProvider", void 0), t = gP([
      Be("agComponentUtils")
    ], t), t;
  }(Me)
), zZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), sb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, YZ = (
  /** @class */
  function(o) {
    zZ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.componentMetaData = {
        dateComponent: {
          mandatoryMethodList: ["getDate", "setDate"],
          optionalMethodList: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "onParamsUpdated", "refresh"]
        },
        detailCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        headerComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        headerGroupComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        loadingCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: []
        },
        loadingOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        noRowsOverlayComponent: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        floatingFilterComponent: {
          mandatoryMethodList: ["onParentModelChanged"],
          optionalMethodList: ["afterGuiAttached", "onParamsUpdated", "refresh"]
        },
        cellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        cellEditor: {
          mandatoryMethodList: ["getValue"],
          optionalMethodList: ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached", "refresh"]
        },
        innerRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        fullWidthCellRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        groupRowRenderer: {
          mandatoryMethodList: [],
          optionalMethodList: ["afterGuiAttached"],
          functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
        },
        filter: {
          mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
          optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged", "refresh"]
        },
        statusPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh"]
        },
        toolPanel: {
          mandatoryMethodList: [],
          optionalMethodList: ["refresh", "getState"]
        },
        tooltipComponent: {
          mandatoryMethodList: [],
          optionalMethodList: []
        }
      };
    }, t.prototype.retrieve = function(e) {
      return this.componentMetaData[e];
    }, sb([
      N("agComponentUtils")
    ], t.prototype, "agComponentUtils", void 0), sb([
      Fe
    ], t.prototype, "postConstruct", null), t = sb([
      Be("componentMetadataProvider")
    ], t), t;
  }(Me)
), KZ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), lb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, qZ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, XZ = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, ZZ = 25, mP = 10, ub = 8, QZ = 4, cb = 4, db = 6, JZ = 16, yP = 14, pb = 8, eQ = {
  // this item is required for custom themes
  "ag-theme-custom": {
    headerHeight: 25,
    headerCellMinWidth: 24,
    listItemHeight: QZ * 5,
    rowHeight: 25,
    chartMenuPanelWidth: 220
  },
  "ag-theme-material": {
    headerHeight: ub * 7,
    headerCellMinWidth: 48,
    listItemHeight: ub * 4,
    rowHeight: ub * 6,
    chartMenuPanelWidth: 240
  },
  "ag-theme-balham": {
    headerHeight: cb * 8,
    headerCellMinWidth: 24,
    listItemHeight: cb * 6,
    rowHeight: cb * 7,
    chartMenuPanelWidth: 220
  },
  "ag-theme-alpine": {
    headerHeight: db * 8,
    headerCellMinWidth: 36,
    listItemHeight: db * 4,
    rowHeight: db * 7,
    chartMenuPanelWidth: 240
  },
  "ag-theme-quartz": {
    headerHeight: yP + pb * 4.25,
    headerCellMinWidth: 36,
    listItemHeight: JZ + pb,
    rowHeight: yP + pb * 3.5,
    chartMenuPanelWidth: 260
  }
}, CP = {
  headerHeight: ["ag-header-row"],
  headerCellMinWidth: ["ag-header-cell"],
  listItemHeight: ["ag-virtual-list-item"],
  rowHeight: ["ag-row"],
  chartMenuPanelWidth: ["ag-chart-docked-container"]
}, BL = (
  /** @class */
  function(o) {
    KZ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.calculatedSizes = {}, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r, n = (r = this.getTheme().el) !== null && r !== void 0 ? r : this.eGridDiv;
      this.addManagedPropertyListener("rowHeight", function() {
        return e.refreshRowHeightVariable();
      }), this.mutationObserver = new MutationObserver(function() {
        e.calculatedSizes = {}, e.fireGridStylesChangedEvent();
      }), this.mutationObserver.observe(n || this.eGridDiv, {
        attributes: !0,
        attributeFilter: ["class"]
      });
    }, t.prototype.fireGridStylesChangedEvent = function() {
      var e = {
        type: G.EVENT_GRID_STYLES_CHANGED
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.getSassVariable = function(e) {
      var r = this.getTheme(), n = r.themeFamily, i = r.el;
      if (!(!n || n.indexOf("ag-theme") !== 0)) {
        this.calculatedSizes || (this.calculatedSizes = {}), this.calculatedSizes[n] || (this.calculatedSizes[n] = {});
        var a = this.calculatedSizes[n][e];
        return a ?? (this.calculatedSizes[n][e] = this.calculateValueForSassProperty(e, n, i), this.calculatedSizes[n][e]);
      }
    }, t.prototype.calculateValueForSassProperty = function(e, r, n) {
      var i, a = "ag-theme-" + (r.match("material") ? "material" : r.match("balham") ? "balham" : r.match("alpine") ? "alpine" : "custom"), s = eQ[a][e], l = this.gridOptionsService.getDocument();
      if (n || (n = this.eGridDiv), !CP[e])
        return s;
      var u = CP[e], c = l.createElement("div"), d = Array.from(n.classList);
      (i = c.classList).add.apply(i, XZ([r], qZ(d), !1)), c.style.position = "absolute";
      var f = u.reduce(function(m, b) {
        var S = l.createElement("div");
        return S.style.position = "static", S.classList.add(b), m.appendChild(S), S;
      }, c), v = 0;
      if (l.body) {
        l.body.appendChild(c);
        var g = e.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
        v = parseInt(window.getComputedStyle(f)[g], 10), l.body.removeChild(c);
      }
      return v || s;
    }, t.prototype.isThemeDark = function() {
      var e = this.getTheme().theme;
      return !!e && e.indexOf("dark") >= 0;
    }, t.prototype.chartMenuPanelWidth = function() {
      return this.getSassVariable("chartMenuPanelWidth");
    }, t.prototype.getTheme = function() {
      for (var e = /\bag-(material|(?:theme-([\w\-]*)))\b/g, r = this.eGridDiv, n = null, i = []; r; )
        if (n = e.exec(r.className), !n)
          r = r.parentElement || void 0;
        else {
          var a = r.className.match(e);
          a && (i = a);
          break;
        }
      if (!n)
        return { allThemes: i };
      var s = n[0];
      return { theme: s, el: r, themeFamily: s.replace(/-dark$/, ""), allThemes: i };
    }, t.prototype.getFromTheme = function(e, r) {
      var n;
      return (n = this.getSassVariable(r)) !== null && n !== void 0 ? n : e;
    }, t.prototype.getDefaultRowHeight = function() {
      return this.getFromTheme(ZZ, "rowHeight");
    }, t.prototype.getListItemHeight = function() {
      return this.getFromTheme(20, "listItemHeight");
    }, t.prototype.refreshRowHeightVariable = function() {
      var e = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim(), r = this.gridOptionsService.get("rowHeight");
      if (r == null || isNaN(r) || !isFinite(r))
        return e !== null && this.eGridDiv.style.setProperty("--ag-line-height", null), -1;
      var n = "".concat(r, "px");
      return e != n ? (this.eGridDiv.style.setProperty("--ag-line-height", n), r) : e != "" ? parseFloat(e) : -1;
    }, t.prototype.getMinColWidth = function() {
      var e = this.getFromTheme(null, "headerCellMinWidth");
      return Oe(e) ? Math.max(e, mP) : mP;
    }, t.prototype.destroy = function() {
      this.calculatedSizes = null, this.mutationObserver && this.mutationObserver.disconnect(), o.prototype.destroy.call(this);
    }, lb([
      N("eGridDiv")
    ], t.prototype, "eGridDiv", void 0), lb([
      Fe
    ], t.prototype, "postConstruct", null), t = lb([
      Be("environment")
    ], t), t;
  }(Me)
), tQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Kg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, rQ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, nQ = (
  /** @class */
  function(o) {
    tQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.scrollY = 0, e.uiBodyHeight = 0, e;
    }
    return t.prototype.agWire = function(e) {
      this.logger = e.create("RowContainerHeightService");
    }, t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this)), this.maxDivHeight = L2(), this.logger.log("maxDivHeight = " + this.maxDivHeight);
    }, t.prototype.isStretching = function() {
      return this.stretching;
    }, t.prototype.getDivStretchOffset = function() {
      return this.divStretchOffset;
    }, t.prototype.updateOffset = function() {
      if (this.stretching) {
        var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition().top, n = this.getUiBodyHeight(), i = r !== this.scrollY || n !== this.uiBodyHeight;
        i && (this.scrollY = r, this.uiBodyHeight = n, this.calculateOffset());
      }
    }, t.prototype.calculateOffset = function() {
      this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
      var e = this.scrollY / this.maxScrollY, r = e * this.pixelsToShave;
      this.logger.log("Div Stretch Offset = ".concat(r, " (").concat(this.pixelsToShave, " * ").concat(e, ")")), this.setDivStretchOffset(r);
    }, t.prototype.setUiContainerHeight = function(e) {
      e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventService.dispatchEvent({ type: G.EVENT_ROW_CONTAINER_HEIGHT_CHANGED }));
    }, t.prototype.clearOffset = function() {
      this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
    }, t.prototype.setDivStretchOffset = function(e) {
      var r = typeof e == "number" ? Math.floor(e) : null;
      this.divStretchOffset !== r && (this.divStretchOffset = r, this.eventService.dispatchEvent({ type: G.EVENT_HEIGHT_SCALE_CHANGED }));
    }, t.prototype.setModelHeight = function(e) {
      this.modelHeight = e, this.stretching = e != null && this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
    }, t.prototype.getUiContainerHeight = function() {
      return this.uiContainerHeight;
    }, t.prototype.getRealPixelPosition = function(e) {
      return e - this.divStretchOffset;
    }, t.prototype.getUiBodyHeight = function() {
      var e = this.ctrlsService.getGridBodyCtrl(), r = e.getScrollFeature().getVScrollPosition();
      return r.bottom - r.top;
    }, t.prototype.getScrollPositionForPixel = function(e) {
      if (this.pixelsToShave <= 0)
        return e;
      var r = this.modelHeight - this.getUiBodyHeight(), n = e / r, i = this.maxScrollY * n;
      return i;
    }, Kg([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Kg([
      rQ(0, ii("loggerFactory"))
    ], t.prototype, "agWire", null), Kg([
      Fe
    ], t.prototype, "postConstruct", null), t = Kg([
      Be("rowContainerHeightService")
    ], t), t;
  }(Me)
), oQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), qg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, WL = (
  /** @class */
  function(o) {
    oQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.addManagedPropertyListener("isRowSelectable", function() {
        return e.updateSelectable();
      });
    }, t.prototype.updateSelectableAfterGrouping = function() {
      this.updateSelectable(!0);
    }, t.prototype.updateSelectable = function(e) {
      e === void 0 && (e = !1);
      var r = !!this.gridOptionsService.get("rowSelection"), n = this.gridOptionsService.get("isRowSelectable");
      if (!(!r || !n)) {
        var i = this.gridOptionsService.get("groupSelectsChildren"), a = this.rowModel.getType() === "clientSide" && i, s = [], l = function(d) {
          if (!(e && !d.group)) {
            if (a && d.group) {
              var f = d.childrenAfterGroup.some(function(g) {
                return g.selectable === !0;
              });
              d.setRowSelectable(f, !0);
              return;
            }
            var v = n ? n(d) : !0;
            d.setRowSelectable(v, !0), !v && d.isSelected() && s.push(d);
          }
        };
        if (a) {
          var u = this.rowModel, c = new gv(!1, u.getRootNode());
          c.forEachChangedNodeDepthFirst(l, !0, !0);
        } else
          this.rowModel.forEachNode(l);
        s.length && this.selectionService.setNodesSelected({ nodes: s, newValue: !1, source: "selectableChanged" }), a && this.selectionService instanceof ML && this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
      }
    }, qg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), qg([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), qg([
      Fe
    ], t.prototype, "init", null), t = qg([
      Be("selectableService")
    ], t), t;
  }(Me)
), iQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), qo = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, aQ = (
  /** @class */
  function(o) {
    iQ(t, o);
    function t() {
      var e = o.call(this) || this;
      return e.previousAndFirstButtonsDisabled = !1, e.nextButtonDisabled = !1, e.lastButtonDisabled = !1, e.areListenersSetup = !1, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r = this.gridOptionsService.get("enableRtl");
      this.setTemplate(this.getTemplate());
      var n = this, i = n.btFirst, a = n.btPrevious, s = n.btNext, l = n.btLast;
      n.pageSizeComp, this.activateTabIndex([i, a, s, l]), i.insertAdjacentElement("afterbegin", sn(r ? "last" : "first", this.gridOptionsService)), a.insertAdjacentElement("afterbegin", sn(r ? "next" : "previous", this.gridOptionsService)), s.insertAdjacentElement("afterbegin", sn(r ? "previous" : "next", this.gridOptionsService)), l.insertAdjacentElement("afterbegin", sn(r ? "first" : "last", this.gridOptionsService)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"], function() {
        return e.onPageSizeRelatedOptionsChange();
      }), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.onPaginationChanged();
    }, t.prototype.onPaginationChanged = function() {
      var e = this.gridOptionsService.get("pagination"), r = e && !this.gridOptionsService.get("suppressPaginationPanel");
      this.setDisplayed(r), r && (this.setupListeners(), this.enableOrDisableButtons(), this.updateRowLabels(), this.setCurrentPageLabel(), this.setTotalLabels(), this.onPageSizeRelatedOptionsChange());
    }, t.prototype.onPageSizeRelatedOptionsChange = function() {
      this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }, t.prototype.setupListeners = function() {
      var e = this;
      this.areListenersSetup || (this.addManagedListener(this.eventService, G.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this)), [
        { el: this.btFirst, fn: this.onBtFirst.bind(this) },
        { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
        { el: this.btNext, fn: this.onBtNext.bind(this) },
        { el: this.btLast, fn: this.onBtLast.bind(this) }
      ].forEach(function(r) {
        var n = r.el, i = r.fn;
        e.addManagedListener(n, "click", i), e.addManagedListener(n, "keydown", function(a) {
          (a.key === we.ENTER || a.key === we.SPACE) && (a.preventDefault(), i());
        });
      }), this.areListenersSetup = !0);
    }, t.prototype.onBtFirst = function() {
      this.previousAndFirstButtonsDisabled || this.paginationProxy.goToFirstPage();
    }, t.prototype.setCurrentPageLabel = function() {
      var e = this.paginationProxy.getTotalPages() > 0, r = this.paginationProxy.getCurrentPage(), n = e ? r + 1 : 0;
      this.lbCurrent.textContent = this.formatNumber(n);
    }, t.prototype.formatNumber = function(e) {
      var r = this.gridOptionsService.getCallback("paginationNumberFormatter");
      if (r) {
        var n = { value: e };
        return r(n);
      }
      var i = this.localeService.getLocaleTextFunc(), a = i("thousandSeparator", ","), s = i("decimalSeparator", ".");
      return B1(e, a, s);
    }, t.prototype.getTemplate = function() {
      var e = this.localeService.getLocaleTextFunc(), r = e("page", "Page"), n = e("to", "to"), i = e("of", "of"), a = e("firstPage", "First Page"), s = e("previousPage", "Previous Page"), l = e("nextPage", "Next Page"), u = e("lastPage", "Last Page"), c = this.getCompId();
      return (
        /* html */
        '<div class="ag-paging-panel ag-unselectable" id="ag-'.concat(c, `">
                <ag-page-size-selector ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-`).concat(c, `-first-row" ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-`).concat(c, '-to">').concat(n, `</span>
                    <span id="ag-`).concat(c, `-last-row" ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-`).concat(c, '-of">').concat(i, `</span>
                    <span id="ag-`).concat(c, `-row-count" ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="`).concat(a, `"></div>
                    <div ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="`).concat(s, `"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-`).concat(c, '-start-page">').concat(r, `</span>
                        <span id="ag-`).concat(c, `-start-page-number" ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-`).concat(c, '-of-page">').concat(i, `</span>
                        <span id="ag-`).concat(c, `-of-page-number" ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="`).concat(l, `"></div>
                    <div ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="`).concat(u, `"></div>
                </span>
            </div>`)
      );
    }, t.prototype.onBtNext = function() {
      this.nextButtonDisabled || this.paginationProxy.goToNextPage();
    }, t.prototype.onBtPrevious = function() {
      this.previousAndFirstButtonsDisabled || this.paginationProxy.goToPreviousPage();
    }, t.prototype.onBtLast = function() {
      this.lastButtonDisabled || this.paginationProxy.goToLastPage();
    }, t.prototype.enableOrDisableButtons = function() {
      var e = this.paginationProxy.getCurrentPage(), r = this.paginationProxy.isLastPageFound(), n = this.paginationProxy.getTotalPages();
      this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
      var i = this.isZeroPagesToDisplay(), a = e === n - 1;
      this.nextButtonDisabled = a || i, this.lastButtonDisabled = !r || i || e === n - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }, t.prototype.toggleButtonDisabled = function(e, r) {
      P1(e, r), e.classList.toggle("ag-disabled", r);
    }, t.prototype.updateRowLabels = function() {
      var e = this.paginationProxy.getCurrentPage(), r = this.paginationProxy.getPageSize(), n = this.paginationProxy.isLastPageFound(), i = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null, a, s;
      if (this.isZeroPagesToDisplay() ? a = s = 0 : (a = r * e + 1, s = a + r - 1, n && s > i && (s = i)), this.lbFirstRowOnPage.textContent = this.formatNumber(a), this.rowNodeBlockLoader.isLoading()) {
        var l = this.localeService.getLocaleTextFunc();
        this.lbLastRowOnPage.innerHTML = l("pageLastRowUnknown", "?");
      } else
        this.lbLastRowOnPage.textContent = this.formatNumber(s);
    }, t.prototype.isZeroPagesToDisplay = function() {
      var e = this.paginationProxy.isLastPageFound(), r = this.paginationProxy.getTotalPages();
      return e && r === 0;
    }, t.prototype.setTotalLabels = function() {
      var e = this.paginationProxy.isLastPageFound(), r = this.paginationProxy.getTotalPages(), n = e ? this.paginationProxy.getMasterRowCount() : null;
      if (n === 1) {
        var i = this.paginationProxy.getRow(0), a = i && i.group && !(i.groupData || i.aggData);
        if (a) {
          this.setTotalLabelsToZero();
          return;
        }
      }
      if (e)
        this.lbTotal.textContent = this.formatNumber(r), this.lbRecordCount.textContent = this.formatNumber(n);
      else {
        var s = this.localeService.getLocaleTextFunc()("more", "more");
        this.lbTotal.innerHTML = s, this.lbRecordCount.innerHTML = s;
      }
    }, t.prototype.setTotalLabelsToZero = function() {
      this.lbFirstRowOnPage.textContent = this.formatNumber(0), this.lbCurrent.textContent = this.formatNumber(0), this.lbLastRowOnPage.textContent = this.formatNumber(0), this.lbTotal.textContent = this.formatNumber(0), this.lbRecordCount.textContent = this.formatNumber(0);
    }, qo([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), qo([
      N("rowNodeBlockLoader")
    ], t.prototype, "rowNodeBlockLoader", void 0), qo([
      ke("btFirst")
    ], t.prototype, "btFirst", void 0), qo([
      ke("btPrevious")
    ], t.prototype, "btPrevious", void 0), qo([
      ke("btNext")
    ], t.prototype, "btNext", void 0), qo([
      ke("btLast")
    ], t.prototype, "btLast", void 0), qo([
      ke("lbRecordCount")
    ], t.prototype, "lbRecordCount", void 0), qo([
      ke("lbFirstRowOnPage")
    ], t.prototype, "lbFirstRowOnPage", void 0), qo([
      ke("lbLastRowOnPage")
    ], t.prototype, "lbLastRowOnPage", void 0), qo([
      ke("lbCurrent")
    ], t.prototype, "lbCurrent", void 0), qo([
      ke("lbTotal")
    ], t.prototype, "lbTotal", void 0), qo([
      ke("pageSizeComp")
    ], t.prototype, "pageSizeComp", void 0), qo([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), sQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, lQ = (
  /** @class */
  function(o) {
    sQ(t, o);
    function t() {
      var e = o.call(this, t.TEMPLATE) || this;
      return e.inProgress = !1, e.destroyRequested = !1, e;
    }
    return t.prototype.updateLayoutClasses = function(e, r) {
      var n = this.eOverlayWrapper.classList;
      n.toggle(rn.AUTO_HEIGHT, r.autoHeight), n.toggle(rn.NORMAL, r.normal), n.toggle(rn.PRINT, r.print);
    }, t.prototype.postConstruct = function() {
      this.createManagedBean(new p_(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.overlayService.registerOverlayWrapperComp(this);
    }, t.prototype.setWrapperTypeClass = function(e) {
      var r = this.eOverlayWrapper.classList;
      this.activeOverlayWrapperCssClass && r.toggle(this.activeOverlayWrapperCssClass, !1), this.activeOverlayWrapperCssClass = e, r.toggle(e, !0);
    }, t.prototype.showOverlay = function(e, r, n) {
      var i = this;
      this.inProgress || (this.setWrapperTypeClass(r), this.destroyActiveOverlay(), this.inProgress = !0, e && e.then(function(a) {
        i.inProgress = !1, i.eOverlayWrapper.appendChild(a.getGui()), i.activeOverlay = a, i.updateListenerDestroyFunc = n, i.destroyRequested && (i.destroyRequested = !1, i.destroyActiveOverlay());
      }), this.setDisplayed(!0, { skipAriaHidden: !0 }));
    }, t.prototype.destroyActiveOverlay = function() {
      var e;
      if (this.inProgress) {
        this.destroyRequested = !0;
        return;
      }
      this.activeOverlay && (this.activeOverlay = this.getContext().destroyBean(this.activeOverlay), (e = this.updateListenerDestroyFunc) === null || e === void 0 || e.call(this), An(this.eOverlayWrapper));
    }, t.prototype.hideOverlay = function() {
      this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
    }, t.prototype.destroy = function() {
      this.destroyActiveOverlay(), o.prototype.destroy.call(this);
    }, t.TEMPLATE = `
        <div class="ag-overlay" role="presentation">
            <div class="ag-overlay-panel" role="presentation">
                <div class="ag-overlay-wrapper" ref="eOverlayWrapper" role="presentation"></div>
            </div>
        </div>`, fb([
      N("overlayService")
    ], t.prototype, "overlayService", void 0), fb([
      ke("eOverlayWrapper")
    ], t.prototype, "eOverlayWrapper", void 0), fb([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(gt)
), uQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Xg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, jL = (
  /** @class */
  function(o) {
    uQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getFirstRow = function() {
      var e = 0, r;
      return this.pinnedRowModel.getPinnedTopRowCount() ? r = "top" : this.rowModel.getRowCount() ? (r = null, e = this.paginationProxy.getPageFirstRow()) : this.pinnedRowModel.getPinnedBottomRowCount() && (r = "bottom"), r === void 0 ? null : { rowIndex: e, rowPinned: r };
    }, t.prototype.getLastRow = function() {
      var e, r = null, n = this.pinnedRowModel.getPinnedBottomRowCount(), i = this.pinnedRowModel.getPinnedTopRowCount();
      return n ? (r = "bottom", e = n - 1) : this.rowModel.getRowCount() ? (r = null, e = this.paginationProxy.getPageLastRow()) : i && (r = "top", e = i - 1), e === void 0 ? null : { rowIndex: e, rowPinned: r };
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, t.prototype.sameRow = function(e, r) {
      return !e && !r ? !0 : e && !r || !e && r ? !1 : e.rowIndex === r.rowIndex && e.rowPinned == r.rowPinned;
    }, t.prototype.before = function(e, r) {
      switch (e.rowPinned) {
        case "top":
          if (r.rowPinned !== "top")
            return !0;
          break;
        case "bottom":
          if (r.rowPinned !== "bottom")
            return !1;
          break;
        default:
          if (Oe(r.rowPinned))
            return r.rowPinned !== "top";
          break;
      }
      return e.rowIndex < r.rowIndex;
    }, t.prototype.rowMax = function(e) {
      var r = this, n;
      return e.forEach(function(i) {
        (n === void 0 || r.before(n, i)) && (n = i);
      }), n;
    }, t.prototype.rowMin = function(e) {
      var r = this, n;
      return e.forEach(function(i) {
        (n === void 0 || r.before(i, n)) && (n = i);
      }), n;
    }, Xg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Xg([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Xg([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), t = Xg([
      Be("rowPositionUtils")
    ], t), t;
  }(Me)
), cQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), dQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, UL = (
  /** @class */
  function(o) {
    cQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.createId = function(e) {
      var r = e.rowIndex, n = e.rowPinned, i = e.column;
      return this.createIdFromValues({ rowIndex: r, column: i, rowPinned: n });
    }, t.prototype.createIdFromValues = function(e) {
      var r = e.rowIndex, n = e.rowPinned, i = e.column;
      return "".concat(r, ".").concat(n ?? "null", ".").concat(i.getId());
    }, t.prototype.equals = function(e, r) {
      var n = e.column === r.column, i = e.rowPinned === r.rowPinned, a = e.rowIndex === r.rowIndex;
      return n && i && a;
    }, t = dQ([
      Be("cellPositionUtils")
    ], t), t;
  }(Me)
), pQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ch = (
  /** @class */
  /* @__PURE__ */ function() {
    function o(t) {
      this.cellValueChanges = t;
    }
    return o;
  }()
), hb = (
  /** @class */
  function(o) {
    pQ(t, o);
    function t(e, r, n, i) {
      var a = o.call(this, e) || this;
      return a.initialRange = r, a.finalRange = n, a.ranges = i, a;
    }
    return t;
  }(ch)
), wP = (
  /** @class */
  function() {
    function o(t) {
      this.actionStack = [], this.maxStackSize = t || o.DEFAULT_STACK_SIZE, this.actionStack = new Array(this.maxStackSize);
    }
    return o.prototype.pop = function() {
      return this.actionStack.pop();
    }, o.prototype.push = function(t) {
      var e = t.cellValueChanges && t.cellValueChanges.length > 0;
      e && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(t));
    }, o.prototype.clear = function() {
      this.actionStack = [];
    }, o.prototype.getCurrentStackSize = function() {
      return this.actionStack.length;
    }, o.DEFAULT_STACK_SIZE = 10, o;
  }()
), fQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), fy = function() {
  return fy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, fy.apply(this, arguments);
}, Sa = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, hQ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, vQ = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, gQ = (
  /** @class */
  function(o) {
    fQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.cellValueChanges = [], e.activeCellEdit = null, e.activeRowEdit = null, e.isPasting = !1, e.isRangeInAction = !1, e.onCellValueChanged = function(r) {
        var n = { column: r.column, rowIndex: r.rowIndex, rowPinned: r.rowPinned }, i = e.activeCellEdit !== null && e.cellPositionUtils.equals(e.activeCellEdit, n), a = e.activeRowEdit !== null && e.rowPositionUtils.sameRow(e.activeRowEdit, n), s = i || a || e.isPasting || e.isRangeInAction;
        if (s) {
          var l = r.rowPinned, u = r.rowIndex, c = r.column, d = r.oldValue, f = r.value, v = {
            rowPinned: l,
            rowIndex: u,
            columnId: c.getColId(),
            newValue: f,
            oldValue: d
          };
          e.cellValueChanges.push(v);
        }
      }, e.clearStacks = function() {
        e.undoStack.clear(), e.redoStack.clear();
      }, e;
    }
    return t.prototype.init = function() {
      var e = this;
      if (this.gridOptionsService.get("undoRedoCellEditing")) {
        var r = this.gridOptionsService.get("undoRedoCellEditingLimit");
        r <= 0 || (this.undoStack = new wP(r), this.redoStack = new wP(r), this.addRowEditingListeners(), this.addCellEditingListeners(), this.addPasteListeners(), this.addFillListeners(), this.addCellKeyListeners(), this.addManagedListener(this.eventService, G.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged), this.addManagedListener(this.eventService, G.EVENT_MODEL_UPDATED, function(n) {
          n.keepUndoRedoStack || e.clearStacks();
        }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_COLUMN_GROUP_OPENED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_COLUMN_MOVED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PINNED, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VISIBLE, this.clearStacks), this.addManagedListener(this.eventService, G.EVENT_ROW_DRAG_END, this.clearStacks), this.ctrlsService.whenReady(function() {
          e.gridBodyCtrl = e.ctrlsService.getGridBodyCtrl();
        }));
      }
    }, t.prototype.getCurrentUndoStackSize = function() {
      return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
    }, t.prototype.getCurrentRedoStackSize = function() {
      return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
    }, t.prototype.undo = function(e) {
      var r = {
        type: G.EVENT_UNDO_STARTED,
        source: e
      };
      this.eventService.dispatchEvent(r);
      var n = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo"), i = {
        type: G.EVENT_UNDO_ENDED,
        source: e,
        operationPerformed: n
      };
      this.eventService.dispatchEvent(i);
    }, t.prototype.redo = function(e) {
      var r = {
        type: G.EVENT_REDO_STARTED,
        source: e
      };
      this.eventService.dispatchEvent(r);
      var n = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo"), i = {
        type: G.EVENT_REDO_ENDED,
        source: e,
        operationPerformed: n
      };
      this.eventService.dispatchEvent(i);
    }, t.prototype.undoRedo = function(e, r, n, i, a) {
      if (!e)
        return !1;
      var s = e.pop();
      return !s || !s.cellValueChanges ? !1 : (this.processAction(s, function(l) {
        return l[i];
      }, a), s instanceof hb ? this.processRange(s.ranges || [s[n]]) : this.processCell(s.cellValueChanges), r.push(s), !0);
    }, t.prototype.processAction = function(e, r, n) {
      var i = this;
      e.cellValueChanges.forEach(function(a) {
        var s = a.rowIndex, l = a.rowPinned, u = a.columnId, c = { rowIndex: s, rowPinned: l }, d = i.getRowNode(c);
        d.displayed && d.setDataValue(u, r(a), n);
      });
    }, t.prototype.processRange = function(e) {
      var r = this, n;
      this.rangeService.removeAllCellRanges(!0), e.forEach(function(i, a) {
        if (i) {
          var s = i.startRow, l = i.endRow;
          a === e.length - 1 && (n = {
            rowPinned: s.rowPinned,
            rowIndex: s.rowIndex,
            columnId: i.startColumn.getColId()
          }, r.setLastFocusedCell(n));
          var u = {
            rowStartIndex: s.rowIndex,
            rowStartPinned: s.rowPinned,
            rowEndIndex: l.rowIndex,
            rowEndPinned: l.rowPinned,
            columnStart: i.startColumn,
            columns: i.columns
          };
          r.rangeService.addCellRange(u);
        }
      });
    }, t.prototype.processCell = function(e) {
      var r = e[0], n = r.rowIndex, i = r.rowPinned, a = { rowIndex: n, rowPinned: i }, s = this.getRowNode(a), l = {
        rowPinned: r.rowPinned,
        rowIndex: s.rowIndex,
        columnId: r.columnId
      };
      this.setLastFocusedCell(l, !!this.rangeService);
    }, t.prototype.setLastFocusedCell = function(e, r) {
      var n = e.rowIndex, i = e.columnId, a = e.rowPinned, s = this.gridBodyCtrl.getScrollFeature(), l = this.columnModel.getGridColumn(i);
      if (l) {
        s.ensureIndexVisible(n), s.ensureColumnVisible(l);
        var u = { rowIndex: n, column: l, rowPinned: a };
        this.focusService.setFocusedCell(fy(fy({}, u), { forceBrowserFocus: !0 })), r && this.rangeService.setRangeToCell(u);
      }
    }, t.prototype.addRowEditingListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_ROW_EDITING_STARTED, function(r) {
        e.activeRowEdit = { rowIndex: r.rowIndex, rowPinned: r.rowPinned };
      }), this.addManagedListener(this.eventService, G.EVENT_ROW_EDITING_STOPPED, function() {
        var r = new ch(e.cellValueChanges);
        e.pushActionsToUndoStack(r), e.activeRowEdit = null;
      });
    }, t.prototype.addCellEditingListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_CELL_EDITING_STARTED, function(r) {
        e.activeCellEdit = { column: r.column, rowIndex: r.rowIndex, rowPinned: r.rowPinned };
      }), this.addManagedListener(this.eventService, G.EVENT_CELL_EDITING_STOPPED, function(r) {
        e.activeCellEdit = null;
        var n = r.valueChanged && !e.activeRowEdit && !e.isPasting && !e.isRangeInAction;
        if (n) {
          var i = new ch(e.cellValueChanges);
          e.pushActionsToUndoStack(i);
        }
      });
    }, t.prototype.addPasteListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_PASTE_START, function() {
        e.isPasting = !0;
      }), this.addManagedListener(this.eventService, G.EVENT_PASTE_END, function() {
        var r = new ch(e.cellValueChanges);
        e.pushActionsToUndoStack(r), e.isPasting = !1;
      });
    }, t.prototype.addFillListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_FILL_START, function() {
        e.isRangeInAction = !0;
      }), this.addManagedListener(this.eventService, G.EVENT_FILL_END, function(r) {
        var n = new hb(e.cellValueChanges, r.initialRange, r.finalRange);
        e.pushActionsToUndoStack(n), e.isRangeInAction = !1;
      });
    }, t.prototype.addCellKeyListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, function() {
        e.isRangeInAction = !0;
      }), this.addManagedListener(this.eventService, G.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, function() {
        var r;
        e.rangeService && e.gridOptionsService.get("enableRangeSelection") ? r = new hb(e.cellValueChanges, void 0, void 0, vQ([], hQ(e.rangeService.getCellRanges()), !1)) : r = new ch(e.cellValueChanges), e.pushActionsToUndoStack(r), e.isRangeInAction = !1;
      });
    }, t.prototype.pushActionsToUndoStack = function(e) {
      this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
    }, t.prototype.getRowNode = function(e) {
      switch (e.rowPinned) {
        case "top":
          return this.pinnedRowModel.getPinnedTopRowData()[e.rowIndex];
        case "bottom":
          return this.pinnedRowModel.getPinnedBottomRowData()[e.rowIndex];
        default:
          return this.rowModel.getRow(e.rowIndex);
      }
    }, Sa([
      N("focusService")
    ], t.prototype, "focusService", void 0), Sa([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Sa([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Sa([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), Sa([
      N("cellPositionUtils")
    ], t.prototype, "cellPositionUtils", void 0), Sa([
      N("rowPositionUtils")
    ], t.prototype, "rowPositionUtils", void 0), Sa([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Sa([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), Sa([
      Fe
    ], t.prototype, "init", null), t = Sa([
      Be("undoRedoService")
    ], t), t;
  }(Me)
), mQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, $L = (
  /** @class */
  function(o) {
    mQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.findHeader = function(e, r) {
      var n, i, a;
      if (e.column instanceof pn ? (i = "getDisplayedGroup".concat(r), n = this.columnModel[i](e.column)) : (a = "getDisplayedCol".concat(r), n = this.columnModel[a](e.column)), !!n) {
        var s = e.headerRowIndex, l = this.getHeaderRowType(s);
        if (l === On.COLUMN_GROUP) {
          var u = n;
          if (u.isPadding() && this.isAnyChildSpanningHeaderHeight(u)) {
            var c = this.getColumnVisibleChild(u, s, r), d = c.nextFocusColumn, f = c.nextRow;
            d && (n = d, s = f);
          }
        }
        return {
          column: n,
          headerRowIndex: s
        };
      }
    }, t.prototype.isAnyChildSpanningHeaderHeight = function(e) {
      return e ? e.getLeafColumns().some(function(r) {
        return r.isSpanHeaderHeight();
      }) : !1;
    }, t.prototype.getColumnVisibleParent = function(e, r) {
      var n = this.getHeaderRowType(r), i = n === On.FLOATING_FILTER, a = n === On.COLUMN, s = i ? e : e.getParent(), l = r - 1;
      if (a && this.isAnyChildSpanningHeaderHeight(e.getParent())) {
        for (; s && s.isPadding(); )
          s = s.getParent(), l--;
        l < 0 && (s = e, l = r);
      }
      return { nextFocusColumn: s, nextRow: l };
    }, t.prototype.getColumnVisibleChild = function(e, r, n) {
      n === void 0 && (n = "After");
      var i = this.getHeaderRowType(r), a = e, s = r + 1;
      if (i === On.COLUMN_GROUP) {
        var l = e.getDisplayedLeafColumns(), u = n === "After" ? l[0] : Kt(l);
        if (this.isAnyChildSpanningHeaderHeight(u.getParent())) {
          a = u;
          for (var c = u.getParent(); c && c !== e; )
            c = c.getParent(), s++;
        } else
          a = e.getDisplayedChildren()[0];
      }
      return { nextFocusColumn: a, nextRow: s };
    }, t.prototype.getHeaderRowType = function(e) {
      var r = this.ctrlsService.getHeaderRowContainerCtrl();
      if (r)
        return r.getRowType(e);
    }, t.prototype.findColAtEdgeForHeaderRow = function(e, r) {
      var n = this.columnModel.getAllDisplayedColumns(), i = n[r === "start" ? 0 : n.length - 1];
      if (i) {
        var a = this.ctrlsService.getHeaderRowContainerCtrl(i.getPinned()), s = a.getRowType(e);
        if (s == On.COLUMN_GROUP) {
          var l = this.columnModel.getColumnGroupAtLevel(i, e);
          return {
            headerRowIndex: e,
            column: l
          };
        }
        return {
          // if type==null, means the header level didn't exist
          headerRowIndex: s == null ? -1 : e,
          column: i
        };
      }
    }, vb([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), vb([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), t = vb([
      Be("headerPositionUtils")
    ], t), t;
  }(Me)
), yQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, CQ = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.buildColumnDefs = function(t, e, r) {
      var n = this, i = [], a = {};
      return t.forEach(function(s) {
        for (var l = n.createDefFromColumn(s, e, r), u = !0, c = l, d = s.getOriginalParent(), f = null; d; ) {
          var v = null;
          if (d.isPadding()) {
            d = d.getOriginalParent();
            continue;
          }
          var g = a[d.getGroupId()];
          if (g) {
            g.children.push(c), u = !1;
            break;
          }
          if (v = n.createDefFromGroup(d), v && (v.children = [c], a[v.groupId] = v, c = v, d = d.getOriginalParent()), d != null && f === d) {
            u = !1;
            break;
          }
          f = d;
        }
        u && i.push(c);
      }), i;
    }, o.prototype.createDefFromGroup = function(t) {
      var e = Ym(t.getColGroupDef(), ["children"]);
      return e && (e.groupId = t.getGroupId()), e;
    }, o.prototype.createDefFromColumn = function(t, e, r) {
      var n = Ym(t.getColDef());
      return n.colId = t.getColId(), n.width = t.getActualWidth(), n.rowGroup = t.isRowGroupActive(), n.rowGroupIndex = t.isRowGroupActive() ? e.indexOf(t) : null, n.pivot = t.isPivotActive(), n.pivotIndex = t.isPivotActive() ? r.indexOf(t) : null, n.aggFunc = t.isValueActive() ? t.getAggFunc() : null, n.hide = t.isVisible() ? void 0 : !0, n.pinned = t.isPinned() ? t.getPinned() : null, n.sort = t.getSort() ? t.getSort() : null, n.sortIndex = t.getSortIndex() != null ? t.getSortIndex() : null, n;
    }, o = yQ([
      Be("columnDefFactory")
    ], o), o;
  }()
), gb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, wQ = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.getInitialRowClasses = function(t) {
      var e = [];
      return Oe(t.extraCssClass) && e.push(t.extraCssClass), e.push("ag-row"), e.push(t.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), t.fadeRowIn && e.push("ag-opacity-zero"), e.push(t.rowIsEven ? "ag-row-even" : "ag-row-odd"), t.rowNode.isRowPinned() && e.push("ag-row-pinned"), t.rowNode.isSelected() && e.push("ag-row-selected"), t.rowNode.footer && e.push("ag-row-footer"), e.push("ag-row-level-" + t.rowLevel), t.rowNode.stub && e.push("ag-row-loading"), t.fullWidthRow && e.push("ag-full-width-row"), t.expandable && (e.push("ag-row-group"), e.push(t.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted")), t.rowNode.dragging && e.push("ag-row-dragging"), AS(e, this.processClassesFromGridOptions(t.rowNode)), AS(e, this.preProcessRowClassRules(t.rowNode)), e.push(t.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), t.firstRowOnPage && e.push("ag-row-first"), t.lastRowOnPage && e.push("ag-row-last"), t.fullWidthRow && (t.pinned === "left" && e.push("ag-cell-last-left-pinned"), t.pinned === "right" && e.push("ag-cell-first-right-pinned")), e;
    }, o.prototype.processClassesFromGridOptions = function(t) {
      var e = [], r = function(l) {
        typeof l == "string" ? e.push(l) : Array.isArray(l) && l.forEach(function(u) {
          return e.push(u);
        });
      }, n = this.gridOptionsService.get("rowClass");
      if (n) {
        if (typeof n == "function")
          return console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead"), [];
        r(n);
      }
      var i = this.gridOptionsService.getCallback("getRowClass");
      if (i) {
        var a = {
          data: t.data,
          node: t,
          rowIndex: t.rowIndex
        }, s = i(a);
        r(s);
      }
      return e;
    }, o.prototype.preProcessRowClassRules = function(t) {
      var e = [];
      return this.processRowClassRules(t, function(r) {
        e.push(r);
      }, function(r) {
      }), e;
    }, o.prototype.processRowClassRules = function(t, e, r) {
      var n = this.gridOptionsService.addGridCommonParams({
        data: t.data,
        node: t,
        rowIndex: t.rowIndex
      });
      this.stylingService.processClassRules(void 0, this.gridOptionsService.get("rowClassRules"), n, e, r);
    }, o.prototype.calculateRowLevel = function(t) {
      return t.group ? t.level : t.parent ? t.parent.level + 1 : 0;
    }, gb([
      N("stylingService")
    ], o.prototype, "stylingService", void 0), gb([
      N("gridOptionsService")
    ], o.prototype, "gridOptionsService", void 0), o = gb([
      Be("rowCssClassCalculator")
    ], o), o;
  }()
), bQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Zg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, zL = (
  /** @class */
  function(o) {
    bQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      var e = this;
      this.isAccentedSort = this.gridOptionsService.get("accentedSort"), this.primaryColumnsSortGroups = this.gridOptionsService.isColumnsSortingCoupledToGroup(), this.addManagedPropertyListener("accentedSort", function(r) {
        return e.isAccentedSort = r.currentValue;
      }), this.addManagedPropertyListener("autoGroupColumnDef", function() {
        return e.primaryColumnsSortGroups = e.gridOptionsService.isColumnsSortingCoupledToGroup();
      });
    }, t.prototype.doFullSort = function(e, r) {
      var n = function(a, s) {
        return { currentPos: s, rowNode: a };
      }, i = e.map(n);
      return i.sort(this.compareRowNodes.bind(this, r)), i.map(function(a) {
        return a.rowNode;
      });
    }, t.prototype.compareRowNodes = function(e, r, n) {
      for (var i = r.rowNode, a = n.rowNode, s = 0, l = e.length; s < l; s++) {
        var u = e[s], c = u.sort === "desc", d = this.getValue(i, u.column), f = this.getValue(a, u.column), v = void 0, g = this.getComparator(u, i);
        g ? v = g(d, f, i, a, c) : v = yt.defaultComparator(d, f, this.isAccentedSort);
        var m = !isNaN(v);
        if (m && v !== 0)
          return u.sort === "asc" ? v : v * -1;
      }
      return r.currentPos - n.currentPos;
    }, t.prototype.getComparator = function(e, r) {
      var n = e.column, i = n.getColDef().comparator;
      if (i != null)
        return i;
      if (n.getColDef().showRowGroup) {
        var a = !r.group && n.getColDef().field;
        if (a) {
          var s = this.columnModel.getPrimaryColumn(a);
          if (s)
            return s.getColDef().comparator;
        }
      }
    }, t.prototype.getValue = function(e, r) {
      var n, i;
      if (!this.primaryColumnsSortGroups)
        return this.valueService.getValue(r, e, !1, !1);
      var a = e.rowGroupColumn === r;
      if (a) {
        var s = this.gridOptionsService.isGroupUseEntireRow(this.columnModel.isPivotActive());
        if (s) {
          var l = (n = e.allLeafChildren) === null || n === void 0 ? void 0 : n[0];
          return l ? this.valueService.getValue(r, l, !1, !1) : void 0;
        }
        var u = this.columnModel.getGroupDisplayColumnForGroup(r.getId());
        return u ? (i = e.groupData) === null || i === void 0 ? void 0 : i[u.getId()] : void 0;
      }
      if (!(e.group && r.getColDef().showRowGroup))
        return this.valueService.getValue(r, e, !1, !1);
    }, Zg([
      N("valueService")
    ], t.prototype, "valueService", void 0), Zg([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Zg([
      Fe
    ], t.prototype, "init", null), t = Zg([
      Be("rowNodeSorter")
    ], t), t;
  }(Me)
), SQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), EQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, YL = (
  /** @class */
  function(o) {
    SQ(t, o);
    function t() {
      var r = o !== null && o.apply(this, arguments) || this;
      return r.ready = !1, r.readyCallbacks = [], r;
    }
    e = t, t.prototype.checkReady = function() {
      if (this.ready = this.gridCtrl != null && this.gridBodyCtrl != null && this.centerRowContainerCtrl != null && this.leftRowContainerCtrl != null && this.rightRowContainerCtrl != null && this.bottomCenterRowContainerCtrl != null && this.bottomLeftRowContainerCtrl != null && this.bottomRightRowContainerCtrl != null && this.topCenterRowContainerCtrl != null && this.topLeftRowContainerCtrl != null && this.topRightRowContainerCtrl != null && this.stickyTopCenterRowContainerCtrl != null && this.stickyTopLeftRowContainerCtrl != null && this.stickyTopRightRowContainerCtrl != null && this.centerHeaderRowContainerCtrl != null && this.leftHeaderRowContainerCtrl != null && this.rightHeaderRowContainerCtrl != null && this.fakeHScrollComp != null && this.fakeVScrollComp != null && this.gridHeaderCtrl != null, this.ready) {
        var r = this.createReadyParams();
        this.readyCallbacks.forEach(function(n) {
          return n(r);
        }), this.readyCallbacks.length = 0;
      }
    }, t.prototype.whenReady = function(r) {
      this.ready ? r(this.createReadyParams()) : this.readyCallbacks.push(r);
    }, t.prototype.createReadyParams = function() {
      return {
        centerRowContainerCtrl: this.centerRowContainerCtrl,
        leftRowContainerCtrl: this.leftRowContainerCtrl,
        rightRowContainerCtrl: this.rightRowContainerCtrl,
        bottomCenterRowContainerCtrl: this.bottomCenterRowContainerCtrl,
        bottomLeftRowContainerCtrl: this.bottomLeftRowContainerCtrl,
        bottomRightRowContainerCtrl: this.bottomRightRowContainerCtrl,
        topCenterRowContainerCtrl: this.topCenterRowContainerCtrl,
        topLeftRowContainerCtrl: this.topLeftRowContainerCtrl,
        topRightRowContainerCtrl: this.topRightRowContainerCtrl,
        stickyTopCenterRowContainerCtrl: this.stickyTopCenterRowContainerCtrl,
        stickyTopLeftRowContainerCtrl: this.stickyTopLeftRowContainerCtrl,
        stickyTopRightRowContainerCtrl: this.stickyTopRightRowContainerCtrl,
        centerHeaderRowContainerCtrl: this.centerHeaderRowContainerCtrl,
        leftHeaderRowContainerCtrl: this.leftHeaderRowContainerCtrl,
        rightHeaderRowContainerCtrl: this.rightHeaderRowContainerCtrl,
        fakeHScrollComp: this.fakeHScrollComp,
        fakeVScrollComp: this.fakeVScrollComp,
        gridBodyCtrl: this.gridBodyCtrl,
        gridCtrl: this.gridCtrl,
        gridHeaderCtrl: this.gridHeaderCtrl
      };
    }, t.prototype.registerFakeHScrollComp = function(r) {
      this.fakeHScrollComp = r, this.checkReady();
    }, t.prototype.registerFakeVScrollComp = function(r) {
      this.fakeVScrollComp = r, this.checkReady();
    }, t.prototype.registerGridHeaderCtrl = function(r) {
      this.gridHeaderCtrl = r, this.checkReady();
    }, t.prototype.registerCenterRowContainerCtrl = function(r) {
      this.centerRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerLeftRowContainerCtrl = function(r) {
      this.leftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerRightRowContainerCtrl = function(r) {
      this.rightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopCenterRowContainerCtrl = function(r) {
      this.topCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopLeftRowContainerCon = function(r) {
      this.topLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerTopRightRowContainerCtrl = function(r) {
      this.topRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopCenterRowContainerCtrl = function(r) {
      this.stickyTopCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopLeftRowContainerCon = function(r) {
      this.stickyTopLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerStickyTopRightRowContainerCtrl = function(r) {
      this.stickyTopRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomCenterRowContainerCtrl = function(r) {
      this.bottomCenterRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomLeftRowContainerCtrl = function(r) {
      this.bottomLeftRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerBottomRightRowContainerCtrl = function(r) {
      this.bottomRightRowContainerCtrl = r, this.checkReady();
    }, t.prototype.registerHeaderContainer = function(r, n) {
      switch (n) {
        case "left":
          this.leftHeaderRowContainerCtrl = r;
          break;
        case "right":
          this.rightHeaderRowContainerCtrl = r;
          break;
        default:
          this.centerHeaderRowContainerCtrl = r;
          break;
      }
      this.checkReady();
    }, t.prototype.registerGridBodyCtrl = function(r) {
      this.gridBodyCtrl = r, this.checkReady();
    }, t.prototype.registerGridCtrl = function(r) {
      this.gridCtrl = r, this.checkReady();
    }, t.prototype.getFakeHScrollComp = function() {
      return this.fakeHScrollComp;
    }, t.prototype.getFakeVScrollComp = function() {
      return this.fakeVScrollComp;
    }, t.prototype.getGridHeaderCtrl = function() {
      return this.gridHeaderCtrl;
    }, t.prototype.getGridCtrl = function() {
      return this.gridCtrl;
    }, t.prototype.getCenterRowContainerCtrl = function() {
      return this.centerRowContainerCtrl;
    }, t.prototype.getTopCenterRowContainerCtrl = function() {
      return this.topCenterRowContainerCtrl;
    }, t.prototype.getBottomCenterRowContainerCtrl = function() {
      return this.bottomCenterRowContainerCtrl;
    }, t.prototype.getStickyTopCenterRowContainerCtrl = function() {
      return this.stickyTopCenterRowContainerCtrl;
    }, t.prototype.getGridBodyCtrl = function() {
      return this.gridBodyCtrl;
    }, t.prototype.getHeaderRowContainerCtrls = function() {
      return [this.leftHeaderRowContainerCtrl, this.rightHeaderRowContainerCtrl, this.centerHeaderRowContainerCtrl];
    }, t.prototype.getHeaderRowContainerCtrl = function(r) {
      switch (r) {
        case "left":
          return this.leftHeaderRowContainerCtrl;
        case "right":
          return this.rightHeaderRowContainerCtrl;
        default:
          return this.centerHeaderRowContainerCtrl;
      }
    };
    var e;
    return t.NAME = "ctrlsService", t = e = EQ([
      Be(e.NAME)
    ], t), t;
  }(Me)
), _Q = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, RQ = (
  /** @class */
  function(o) {
    _Q(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.registry = {}, e;
    }
    return t.prototype.register = function(e) {
      this.registry[e.controllerName] = e.controllerClass;
    }, t.prototype.getInstance = function(e) {
      var r = this.registry[e];
      if (r != null)
        return new r();
    }, t = xQ([
      Be("ctrlsFactory")
    ], t), t;
  }(Me)
), TQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Uf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, KL = (
  /** @class */
  function(o) {
    TQ(t, o);
    function t(e, r) {
      var n = o.call(this, e) || this;
      return n.direction = r, n.hideTimeout = null, n;
    }
    return t.prototype.postConstruct = function() {
      this.addManagedListener(this.eventService, G.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this)), this.onScrollVisibilityChanged(), this.addOrRemoveCssClass("ag-apple-scrollbar", G1() || jl());
    }, t.prototype.initialiseInvisibleScrollbar = function() {
      this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = H1(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
    }, t.prototype.addActiveListenerToggles = function() {
      var e = this, r = ["mouseenter", "mousedown", "touchstart"], n = ["mouseleave", "touchend"], i = this.getGui();
      r.forEach(function(a) {
        return e.addManagedListener(i, a, function() {
          return e.addOrRemoveCssClass("ag-scrollbar-active", !0);
        });
      }), n.forEach(function(a) {
        return e.addManagedListener(i, a, function() {
          return e.addOrRemoveCssClass("ag-scrollbar-active", !1);
        });
      });
    }, t.prototype.onScrollVisibilityChanged = function() {
      var e = this;
      this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), this.animationFrameService.requestAnimationFrame(function() {
        return e.setScrollVisible();
      });
    }, t.prototype.hideAndShowInvisibleScrollAsNeeded = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL, function(r) {
        r.direction === e.direction && (e.hideTimeout !== null && (window.clearTimeout(e.hideTimeout), e.hideTimeout = null), e.addOrRemoveCssClass("ag-scrollbar-scrolling", !0));
      }), this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL_END, function() {
        e.hideTimeout = window.setTimeout(function() {
          e.addOrRemoveCssClass("ag-scrollbar-scrolling", !1), e.hideTimeout = null;
        }, 400);
      });
    }, t.prototype.attemptSettingScrollPosition = function(e) {
      var r = this, n = this.getViewport();
      b1(function() {
        return ai(n);
      }, function() {
        return r.setScrollPosition(e);
      }, 100);
    }, t.prototype.getViewport = function() {
      return this.eViewport;
    }, t.prototype.getContainer = function() {
      return this.eContainer;
    }, t.prototype.onScrollCallback = function(e) {
      this.addManagedListener(this.getViewport(), "scroll", e);
    }, Uf([
      ke("eViewport")
    ], t.prototype, "eViewport", void 0), Uf([
      ke("eContainer")
    ], t.prototype, "eContainer", void 0), Uf([
      N("scrollVisibleService")
    ], t.prototype, "scrollVisibleService", void 0), Uf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Uf([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), t;
  }(gt)
), OQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), $f = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, PQ = (
  /** @class */
  function(o) {
    OQ(t, o);
    function t() {
      return o.call(this, t.TEMPLATE, "horizontal") || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      o.prototype.postConstruct.call(this);
      var r = this.setFakeHScrollSpacerWidths.bind(this);
      this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, r), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, r), this.addManagedListener(this.eventService, G.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this)), this.addManagedPropertyListener("domLayout", r), this.ctrlsService.registerFakeHScrollComp(this), this.createManagedBean(new h_(function(n) {
        return e.eContainer.style.width = "".concat(n, "px");
      })), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
    }, t.prototype.initialiseInvisibleScrollbar = function() {
      this.invisibleScrollbar === void 0 && (this.enableRtl = this.gridOptionsService.get("enableRtl"), o.prototype.initialiseInvisibleScrollbar.call(this), this.invisibleScrollbar && this.refreshCompBottom());
    }, t.prototype.onPinnedRowDataChanged = function() {
      this.refreshCompBottom();
    }, t.prototype.refreshCompBottom = function() {
      if (this.invisibleScrollbar) {
        var e = this.pinnedRowModel.getPinnedBottomTotalHeight();
        this.getGui().style.bottom = "".concat(e, "px");
      }
    }, t.prototype.onScrollVisibilityChanged = function() {
      o.prototype.onScrollVisibilityChanged.call(this), this.setFakeHScrollSpacerWidths();
    }, t.prototype.setFakeHScrollSpacerWidths = function() {
      var e = this.scrollVisibleService.isVerticalScrollShowing(), r = this.columnModel.getDisplayedColumnsRightWidth(), n = !this.enableRtl && e, i = this.gridOptionsService.getScrollbarWidth();
      n && (r += i), Di(this.eRightSpacer, r), this.eRightSpacer.classList.toggle("ag-scroller-corner", r <= i);
      var a = this.columnModel.getDisplayedColumnsLeftWidth(), s = this.enableRtl && e;
      s && (a += i), Di(this.eLeftSpacer, a), this.eLeftSpacer.classList.toggle("ag-scroller-corner", a <= i);
    }, t.prototype.setScrollVisible = function() {
      var e = this.scrollVisibleService.isHorizontalScrollShowing(), r = this.invisibleScrollbar, n = this.gridOptionsService.get("suppressHorizontalScroll"), i = e && this.gridOptionsService.getScrollbarWidth() || 0, a = i === 0 && r ? 16 : i, s = n ? 0 : a;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", r), sc(this.getGui(), s), sc(this.eViewport, s), sc(this.eContainer, s), this.setDisplayed(e, { skipAriaHidden: !0 });
    }, t.prototype.getScrollPosition = function() {
      return qh(this.getViewport(), this.enableRtl);
    }, t.prototype.setScrollPosition = function(e) {
      ai(this.getViewport()) || this.attemptSettingScrollPosition(e), Xh(this.getViewport(), e, this.enableRtl);
    }, t.TEMPLATE = `<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" ref="eRightSpacer"></div>
        </div>`, $f([
      ke("eLeftSpacer")
    ], t.prototype, "eLeftSpacer", void 0), $f([
      ke("eRightSpacer")
    ], t.prototype, "eRightSpacer", void 0), $f([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), $f([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), $f([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(KL)
), DQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), mb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, AQ = (
  /** @class */
  function(o) {
    DQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this.checkContainerWidths.bind(this);
      this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_CHANGED, e), this.addManagedListener(this.eventService, G.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, e), this.addManagedPropertyListener("domLayout", e);
    }, t.prototype.checkContainerWidths = function() {
      var e = this.gridOptionsService.isDomLayout("print"), r = e ? 0 : this.columnModel.getDisplayedColumnsLeftWidth(), n = e ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
      r != this.leftWidth && (this.leftWidth = r, this.eventService.dispatchEvent({ type: G.EVENT_LEFT_PINNED_WIDTH_CHANGED })), n != this.rightWidth && (this.rightWidth = n, this.eventService.dispatchEvent({ type: G.EVENT_RIGHT_PINNED_WIDTH_CHANGED }));
    }, t.prototype.getPinnedRightWidth = function() {
      return this.rightWidth;
    }, t.prototype.getPinnedLeftWidth = function() {
      return this.leftWidth;
    }, mb([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), mb([
      Fe
    ], t.prototype, "postConstruct", null), t = mb([
      Be("pinnedWidthService")
    ], t), t;
  }(Me)
), MQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Qg = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, FQ = (
  /** @class */
  function(o) {
    MQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.events = [], e;
    }
    return t.prototype.postConstruct = function() {
      this.rowModel.getType() == "clientSide" && (this.clientSideRowModel = this.rowModel);
    }, t.prototype.dispatchExpanded = function(e) {
      var r = this;
      if (this.clientSideRowModel == null) {
        this.eventService.dispatchEvent(e);
        return;
      }
      this.events.push(e);
      var n = function() {
        r.clientSideRowModel && r.clientSideRowModel.onRowGroupOpened(), r.events.forEach(function(i) {
          return r.eventService.dispatchEvent(i);
        }), r.events = [];
      };
      this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.animationFrameService.debounce(n)), this.dispatchExpandedDebounced();
    }, Qg([
      N("animationFrameService")
    ], t.prototype, "animationFrameService", void 0), Qg([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Qg([
      Fe
    ], t.prototype, "postConstruct", null), t = Qg([
      Be("rowNodeEventThrottle")
    ], t), t;
  }(Me)
), IQ = {}, fl = function(o, t) {
  var e;
  return ((e = t.rowModelType) !== null && e !== void 0 ? e : "clientSide") === "clientSide" ? { module: Ye.RowGroupingModule } : null;
}, LQ = {
  // supported on all row models, but need module for client side.
  enableRowGroup: fl,
  rowGroup: fl,
  rowGroupIndex: fl,
  enablePivot: fl,
  enableValue: fl,
  pivot: fl,
  pivotIndex: fl,
  aggFunc: fl,
  cellEditor: function(o) {
    return o.cellEditor === "agRichSelect" || o.cellEditor === "agRichSelectCellEditor" ? { module: Ye.RichSelectModule } : null;
  },
  menuTabs: function(o) {
    var t, e = ["columnsMenuTab", "generalMenuTab"];
    return !((t = o.menuTabs) === null || t === void 0) && t.some(function(r) {
      return e.includes(r);
    }) ? {
      module: Ye.MenuModule
    } : null;
  },
  columnsMenuParams: {
    module: [Ye.MenuModule, Ye.ColumnsToolPanelModule]
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: function(o, t) {
      var e = t.rowSelection;
      return e === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple";
    }
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: function(o, t) {
      var e = t.rowSelection;
      return e === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple";
    }
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    dependencies: function(o, t) {
      var e = t.rowSelection;
      return e === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple";
    }
  },
  children: function() {
    return Ud;
  }
}, Ud = {
  objectName: "colDef",
  allProperties: AI.ALL_PROPERTIES,
  docsUrl: "column-properties/",
  deprecations: IQ,
  validations: LQ
}, bP = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, SP = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, NQ = {
  enableChartToolPanelsButton: { version: "29", message: "The Chart Tool Panels button is now enabled by default. To hide the Chart Tool Panels button and display the hamburger button instead, set suppressChartToolPanelsButton=true." },
  functionsPassive: { version: "29.2" },
  onColumnRowGroupChangeRequest: { version: "29.2" },
  onColumnPivotChangeRequest: { version: "29.2" },
  onColumnValueChangeRequest: { version: "29.2" },
  onColumnAggFuncChangeRequest: { version: "29.2" },
  serverSideFilterAllLevels: { version: "30", message: "All server-side group levels are now filtered by default. This can be toggled using `serverSideOnlyRefreshFilteredGroups`." },
  suppressAggAtRootLevel: { version: "30", message: "The root level aggregation is now suppressed by default. This can be toggled using  `alwaysAggregateAtRootLevel`." },
  excludeHiddenColumnsFromQuickFilter: { version: "30", message: "Hidden columns are now excluded from the Quick Filter by default. This can be toggled using `includeHiddenColumnsInQuickFilter`." },
  enterMovesDown: { version: "30", renamed: "enterNavigatesVertically" },
  enterMovesDownAfterEdit: { version: "30", renamed: "enterNavigatesVerticallyAfterEdit" },
  suppressParentsInRowNodes: { version: "30.2", message: "Using suppressParentsInRowNodes is no longer recommended. To serialize nodes it is now recommended to instead remove the parent node reference before serialization." },
  advancedFilterModel: { version: "31", message: "Use `initialState.filter.advancedFilterModel` instead." },
  suppressAsyncEvents: { version: "31", message: "Events should be handled asynchronously." }
}, kQ = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !1,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  suppressChartToolPanelsButton: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressAsyncEvents: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  enableCellChangeFlash: !1,
  cellFlashDelay: 500,
  cellFadeDelay: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupIncludeTotalFooter: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  suppressServerSideInfiniteScroll: !1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSideSortOnServer: !1,
  serverSideFilterOnServer: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  suppressGroupMaintainValueType: !1,
  functionsPassive: !1,
  groupLockGroupColumns: 0
}, GQ = {
  sideBar: { module: Ye.SideBarModule },
  statusBar: { module: Ye.StatusBarModule },
  enableCharts: { module: Ye.GridChartsModule },
  getMainMenuItems: { module: Ye.MenuModule },
  getContextMenuItems: { module: Ye.MenuModule },
  allowContextMenuWithControlKey: { module: Ye.MenuModule },
  enableAdvancedFilter: { module: Ye.AdvancedFilterModule },
  treeData: {
    supportedRowModels: ["clientSide", "serverSide"],
    module: Ye.RowGroupingModule,
    dependencies: function(o) {
      var t, e = (t = o.rowModelType) !== null && t !== void 0 ? t : "clientSide";
      switch (e) {
        case "clientSide":
          var r = "treeData requires 'getDataPath' in the ".concat(e, " row model.");
          return o.getDataPath ? null : r;
        case "serverSide":
          var n = "treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ".concat(e, " row model.");
          return o.isServerSideGroup && o.getServerSideGroupKey ? null : n;
      }
      return null;
    }
  },
  masterDetail: { module: Ye.MasterDetailModule },
  enableRangeSelection: { module: Ye.RangeSelectionModule },
  enableRangeHandle: {
    dependencies: {
      enableRangeSelection: [!0]
    }
  },
  enableFillHandle: {
    dependencies: {
      enableRangeSelection: [!0]
    }
  },
  groupDefaultExpanded: {
    supportedRowModels: ["clientSide"]
  },
  groupIncludeFooter: {
    supportedRowModels: ["clientSide", "serverSide"],
    dependencies: function(o) {
      var t, e = (t = o.rowModelType) !== null && t !== void 0 ? t : "clientSide";
      switch (e) {
        case "clientSide":
          return null;
        case "serverSide":
          var r = "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll";
          return o.suppressServerSideInfiniteScroll ? r : null;
      }
      return null;
    }
  },
  groupIncludeTotalFooter: {
    supportedRowModels: ["clientSide"]
  },
  groupRemoveSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, !1],
      groupRemoveLowestSingleChildren: [void 0, !1]
    }
  },
  groupRemoveLowestSingleChildren: {
    dependencies: {
      groupHideOpenParents: [void 0, !1],
      groupRemoveSingleChildren: [void 0, !1]
    }
  },
  groupSelectsChildren: {
    dependencies: {
      rowSelection: ["multiple"]
    }
  },
  suppressParentsInRowNodes: {
    dependencies: {
      groupSelectsChildren: [void 0, !1]
    }
  },
  viewportDatasource: {
    supportedRowModels: ["viewport"],
    module: Ye.ViewportRowModelModule
  },
  serverSideDatasource: {
    supportedRowModels: ["serverSide"],
    module: Ye.ServerSideRowModelModule
  },
  cacheBlockSize: {
    supportedRowModels: ["serverSide", "infinite"]
  },
  datasource: {
    supportedRowModels: ["infinite"],
    module: Ye.InfiniteRowModelModule
  },
  rowData: {
    supportedRowModels: ["clientSide"],
    module: Ye.ClientSideRowModelModule
  },
  columnDefs: function() {
    return Ud;
  },
  defaultColDef: function() {
    return Ud;
  },
  defaultColGroupDef: function() {
    return Ud;
  },
  autoGroupColumnDef: function() {
    return Ud;
  }
}, VQ = {
  objectName: "gridOptions",
  allProperties: SP(SP([], bP(qi.ALL_PROPERTIES), !1), bP(R1.EVENT_CALLBACKS), !1),
  propertyExceptions: ["api", "columnApi"],
  docsUrl: "grid-options/",
  deprecations: NQ,
  validations: GQ
}, Ea = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Jg = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, yb = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, w_ = (
  /** @class */
  function() {
    function o() {
      var e = this;
      this.destroyed = !1, this.domDataKey = "__AG_" + Math.random().toString(), this.propertyEventService = new Ts(), this.globalEventHandlerFactory = function(r) {
        return function(n, i) {
          if (!e.destroyed) {
            var a = t.alwaysSyncGlobalEvents.has(n);
            if (!(a && !r || !a && r)) {
              var s = R1.getCallbackForEvent(n), l = e.gridOptions[s];
              typeof l == "function" && e.frameworkOverrides.wrapOutgoing(function() {
                l(i);
              });
            }
          }
        };
      };
    }
    t = o, Object.defineProperty(o.prototype, "context", {
      // This is quicker then having code call gridOptionsService.get('context')
      get: function() {
        return this.gridOptions.context;
      },
      enumerable: !1,
      configurable: !0
    }), o.prototype.init = function() {
      this.columnApi = new dC(this.api);
      var e = !this.get("suppressAsyncEvents");
      this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), e), this.eventService.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides), this.getScrollbarWidth();
    }, o.prototype.destroy = function() {
      this.destroyed = !0, this.columnApi = void 0;
    }, o.prototype.get = function(e) {
      var r;
      return (r = this.gridOptions[e]) !== null && r !== void 0 ? r : kQ[e];
    }, o.prototype.getCallback = function(e) {
      return this.mergeGridCommonParams(this.gridOptions[e]);
    }, o.prototype.exists = function(e) {
      return Oe(this.gridOptions[e]);
    }, o.prototype.mergeGridCommonParams = function(e) {
      var r = this;
      if (e) {
        var n = function(i) {
          var a = i;
          return a.api = r.api, a.columnApi = r.columnApi, a.context = r.context, e(a);
        };
        return n;
      }
      return e;
    }, o.toBoolean = function(e) {
      return typeof e == "boolean" ? e : typeof e == "string" ? e.toUpperCase() === "TRUE" || e == "" : !1;
    }, o.toNumber = function(e) {
      if (typeof e == "number")
        return e;
      if (typeof e == "string") {
        var r = parseInt(e);
        return isNaN(r) ? void 0 : r;
      }
    }, o.toConstrainedNum = function(e, r) {
      return function(n) {
        var i = t.toNumber(n);
        if (!(i == null || i < e || i > r))
          return i;
      };
    }, o.getCoercedValue = function(e, r) {
      var n = t.PROPERTY_COERCIONS.get(e);
      return n ? n(r) : r;
    }, o.getCoercedGridOptions = function(e) {
      var r = {};
      return Object.entries(e).forEach(function(n) {
        var i = Jg(n, 2), a = i[0], s = i[1], l = t.getCoercedValue(a, s);
        r[a] = l;
      }), r;
    }, o.prototype.updateGridOptions = function(e) {
      var r = this, n = e.options, i = e.source, a = i === void 0 ? "api" : i, s = { id: t.changeSetId++, properties: [] }, l = [];
      Object.entries(n).forEach(function(u) {
        var c = Jg(u, 2), d = c[0], f = c[1];
        a === "api" && T$[d] && ht("".concat(d, " is an initial property and cannot be updated."));
        var v = t.getCoercedValue(d, f), g = typeof v == "object" && a === "api", m = r.gridOptions[d];
        if (g || m !== v) {
          r.gridOptions[d] = v;
          var b = {
            type: d,
            currentValue: v,
            previousValue: m,
            changeSet: s,
            source: a
          };
          l.push(b);
        }
      }), this.validationService.processGridOptions(this.gridOptions), s.properties = l.map(function(u) {
        return u.type;
      }), l.forEach(function(u) {
        r.gridOptions.debug && console.log("AG Grid: Updated property ".concat(u.type, " from "), u.previousValue, " to  ", u.currentValue), r.propertyEventService.dispatchEvent(u);
      });
    }, o.prototype.addEventListener = function(e, r) {
      this.propertyEventService.addEventListener(e, r);
    }, o.prototype.removeEventListener = function(e, r) {
      this.propertyEventService.removeEventListener(e, r);
    }, o.prototype.getGridId = function() {
      return this.api.getGridId();
    }, o.prototype.getScrollbarWidth = function() {
      if (this.scrollbarWidth == null) {
        var e = typeof this.gridOptions.scrollbarWidth == "number" && this.gridOptions.scrollbarWidth >= 0, r = e ? this.gridOptions.scrollbarWidth : G2();
        r != null && (this.scrollbarWidth = r, this.eventService.dispatchEvent({
          type: G.EVENT_SCROLLBAR_WIDTH_CHANGED
        }));
      }
      return this.scrollbarWidth;
    }, o.prototype.isRowModelType = function(e) {
      return this.gridOptions.rowModelType === e || e === "clientSide" && tt(this.gridOptions.rowModelType);
    }, o.prototype.isDomLayout = function(e) {
      var r, n = (r = this.gridOptions.domLayout) !== null && r !== void 0 ? r : "normal";
      return n === e;
    }, o.prototype.isRowSelection = function() {
      return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
    }, o.prototype.useAsyncEvents = function() {
      return !this.get("suppressAsyncEvents");
    }, o.prototype.isGetRowHeightFunction = function() {
      return typeof this.gridOptions.getRowHeight == "function";
    }, o.prototype.getRowHeightForNode = function(e, r, n) {
      if (r === void 0 && (r = !1), n == null && (n = this.environment.getDefaultRowHeight()), this.isGetRowHeightFunction()) {
        if (r)
          return { height: n, estimated: !0 };
        var i = {
          node: e,
          data: e.data
        }, a = this.getCallback("getRowHeight")(i);
        if (this.isNumeric(a))
          return a === 0 && ht("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead."), { height: Math.max(1, a), estimated: !1 };
      }
      if (e.detail && this.get("masterDetail"))
        return this.getMasterDetailRowHeight();
      var s = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : n;
      return { height: s, estimated: !1 };
    }, o.prototype.getMasterDetailRowHeight = function() {
      return this.get("detailRowAutoHeight") ? { height: 1, estimated: !1 } : this.isNumeric(this.gridOptions.detailRowHeight) ? { height: this.gridOptions.detailRowHeight, estimated: !1 } : { height: 300, estimated: !1 };
    }, o.prototype.getRowHeightAsNumber = function() {
      if (!this.gridOptions.rowHeight || tt(this.gridOptions.rowHeight))
        return this.environment.getDefaultRowHeight();
      var e = this.environment.refreshRowHeightVariable();
      return e !== -1 ? e : (console.warn("AG Grid row height must be a number if not using standard row model"), this.environment.getDefaultRowHeight());
    }, o.prototype.isNumeric = function(e) {
      return !isNaN(e) && typeof e == "number" && isFinite(e);
    }, o.prototype.getDomDataKey = function() {
      return this.domDataKey;
    }, o.prototype.getDomData = function(e, r) {
      var n = e[this.getDomDataKey()];
      return n ? n[r] : void 0;
    }, o.prototype.setDomData = function(e, r, n) {
      var i = this.getDomDataKey(), a = e[i];
      tt(a) && (a = {}, e[i] = a), a[r] = n;
    }, o.prototype.getDocument = function() {
      var e = null;
      return this.gridOptions.getDocument && Oe(this.gridOptions.getDocument) ? e = this.gridOptions.getDocument() : this.eGridDiv && (e = this.eGridDiv.ownerDocument), e && Oe(e) ? e : document;
    }, o.prototype.getWindow = function() {
      var e = this.getDocument();
      return e.defaultView || window;
    }, o.prototype.getRootNode = function() {
      return this.eGridDiv.getRootNode();
    }, o.prototype.getAsyncTransactionWaitMillis = function() {
      return Oe(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
    }, o.prototype.isAnimateRows = function() {
      return this.get("ensureDomOrder") ? !1 : this.get("animateRows");
    }, o.prototype.isGroupRowsSticky = function() {
      return !(this.get("suppressGroupRowsSticky") || this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print"));
    }, o.prototype.isColumnsSortingCoupledToGroup = function() {
      var e = this.gridOptions.autoGroupColumnDef;
      return !(e != null && e.comparator) && !this.get("treeData");
    }, o.prototype.getGroupAggFiltering = function() {
      var e = this.gridOptions.groupAggFiltering;
      if (typeof e == "function")
        return this.getCallback("groupAggFiltering");
      if (e === !0)
        return function() {
          return !0;
        };
    }, o.prototype.isGroupIncludeFooterTrueOrCallback = function() {
      var e = this.gridOptions.groupIncludeFooter;
      return e === !0 || typeof e == "function";
    }, o.prototype.getGroupIncludeFooter = function() {
      var e = this.gridOptions.groupIncludeFooter;
      return typeof e == "function" ? this.getCallback("groupIncludeFooter") : e === !0 ? function() {
        return !0;
      } : function() {
        return !1;
      };
    }, o.prototype.isGroupMultiAutoColumn = function() {
      return this.gridOptions.groupDisplayType ? this.gridOptions.groupDisplayType === "multipleColumns" : this.get("groupHideOpenParents");
    }, o.prototype.isGroupUseEntireRow = function(e) {
      return e ? !1 : this.gridOptions.groupDisplayType === "groupRows";
    }, o.prototype.getGridCommonParams = function() {
      return {
        api: this.api,
        columnApi: this.columnApi,
        context: this.context
      };
    }, o.prototype.addGridCommonParams = function(e) {
      var r = e;
      return r.api = this.api, r.columnApi = this.columnApi, r.context = this.context, r;
    };
    var t;
    return o.alwaysSyncGlobalEvents = /* @__PURE__ */ new Set([G.EVENT_GRID_PRE_DESTROYED]), o.PROPERTY_COERCIONS = new Map(yb(yb(yb([], Jg(qi.BOOLEAN_PROPERTIES.map(function(e) {
      return [e, t.toBoolean];
    })), !1), Jg(qi.NUMBER_PROPERTIES.map(function(e) {
      return [e, t.toNumber];
    })), !1), [
      ["groupAggFiltering", function(e) {
        return typeof e == "function" ? e : t.toBoolean(e);
      }],
      ["pageSize", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["autoSizePadding", t.toConstrainedNum(0, Number.MAX_VALUE)],
      ["keepDetailRowsCount", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["rowBuffer", t.toConstrainedNum(0, Number.MAX_VALUE)],
      ["infiniteInitialRowCount", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["cacheOverflowSize", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["cacheBlockSize", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["serverSideInitialRowCount", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["viewportRowModelPageSize", t.toConstrainedNum(1, Number.MAX_VALUE)],
      ["viewportRowModelBufferSize", t.toConstrainedNum(0, Number.MAX_VALUE)]
    ], !1)), o.changeSetId = 0, Ea([
      N("gridOptions")
    ], o.prototype, "gridOptions", void 0), Ea([
      N("eventService")
    ], o.prototype, "eventService", void 0), Ea([
      N("environment")
    ], o.prototype, "environment", void 0), Ea([
      N("frameworkOverrides")
    ], o.prototype, "frameworkOverrides", void 0), Ea([
      N("eGridDiv")
    ], o.prototype, "eGridDiv", void 0), Ea([
      N("validationService")
    ], o.prototype, "validationService", void 0), Ea([
      N("gridApi")
    ], o.prototype, "api", void 0), Ea([
      Fe
    ], o.prototype, "init", null), Ea([
      eo
    ], o.prototype, "destroy", null), o = t = Ea([
      Be("gridOptionsService")
    ], o), o;
  }()
), HQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), BQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, qL = (
  /** @class */
  function(o) {
    HQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getLocaleTextFunc = function() {
      var e = this.gridOptionsService.getCallback("getLocaleText");
      if (e)
        return function(n, i, a) {
          var s = {
            key: n,
            defaultValue: i,
            variableValues: a
          };
          return e(s);
        };
      var r = this.gridOptionsService.get("localeText");
      return function(n, i, a) {
        var s = r && r[n];
        if (s && a && a.length)
          for (var l = 0; !(l >= a.length); ) {
            var u = s.indexOf("${variable}");
            if (u === -1)
              break;
            s = s.replace("${variable}", a[l++]);
          }
        return s ?? i;
      };
    }, t = BQ([
      Be("localeService")
    ], t), t;
  }(Me)
), WQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), jQ = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, UQ = (
  /** @class */
  function(o) {
    WQ(t, o);
    function t() {
      return o.call(this, t.TEMPLATE, "vertical") || this;
    }
    return t.prototype.postConstruct = function() {
      o.prototype.postConstruct.call(this), this.createManagedBean(new GI(this.eContainer)), this.ctrlsService.registerFakeVScrollComp(this), this.addManagedListener(this.eventService, G.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onRowContainerHeightChanged.bind(this));
    }, t.prototype.setScrollVisible = function() {
      var e = this.scrollVisibleService.isVerticalScrollShowing(), r = this.invisibleScrollbar, n = e && this.gridOptionsService.getScrollbarWidth() || 0, i = n === 0 && r ? 16 : n;
      this.addOrRemoveCssClass("ag-scrollbar-invisible", r), Di(this.getGui(), i), Di(this.eViewport, i), Di(this.eContainer, i), this.setDisplayed(e, { skipAriaHidden: !0 });
    }, t.prototype.onRowContainerHeightChanged = function() {
      var e = this.ctrlsService, r = e.getGridBodyCtrl(), n = r.getBodyViewportElement(), i = this.getScrollPosition(), a = n.scrollTop;
      i != a && this.setScrollPosition(a, !0);
    }, t.prototype.getScrollPosition = function() {
      return this.getViewport().scrollTop;
    }, t.prototype.setScrollPosition = function(e, r) {
      !r && !ai(this.getViewport()) && this.attemptSettingScrollPosition(e), this.getViewport().scrollTop = e;
    }, t.TEMPLATE = `<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" ref="eViewport">
                <div class="ag-body-vertical-scroll-container" ref="eContainer"></div>
            </div>
        </div>`, jQ([
      Fe
    ], t.prototype, "postConstruct", null), t;
  }(KL)
), $Q = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Fo = function() {
  return Fo = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Fo.apply(this, arguments);
}, ku = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, _a = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, zf = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, EP = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, _P = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"], XL = (
  /** @class */
  function(o) {
    $Q(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.dataTypeDefinitions = {}, e.isWaitingForRowData = !1, e.isColumnTypeOverrideInDataTypeDefinitions = !1, e.columnStateUpdatesPendingInference = {}, e.columnStateUpdateListenerDestroyFuncs = [], e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.groupHideOpenParents = this.gridOptionsService.get("groupHideOpenParents"), this.addManagedPropertyListener("groupHideOpenParents", function() {
        e.groupHideOpenParents = e.gridOptionsService.get("groupHideOpenParents");
      }), this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", function() {
        e.processDataTypeDefinitions(), e.columnModel.recreateColumnDefs("gridOptionsChanged");
      });
    }, t.prototype.processDataTypeDefinitions = function() {
      var e = this, r, n = this.getDefaultDataTypes();
      this.dataTypeDefinitions = {}, Object.entries(n).forEach(function(a) {
        var s = _a(a, 2), l = s[0], u = s[1];
        e.dataTypeDefinitions[l] = Fo(Fo({}, u), { groupSafeValueFormatter: e.createGroupSafeValueFormatter(u) });
      });
      var i = (r = this.gridOptionsService.get("dataTypeDefinitions")) !== null && r !== void 0 ? r : {};
      this.dataTypeMatchers = {}, Object.entries(i).forEach(function(a) {
        var s = _a(a, 2), l = s[0], u = s[1], c = e.processDataTypeDefinition(u, i, [l], n);
        c && (e.dataTypeDefinitions[l] = c, u.dataTypeMatcher && (e.dataTypeMatchers[l] = u.dataTypeMatcher));
      }), this.checkObjectValueHandlers(n), ["dateString", "text", "number", "boolean", "date"].forEach(function(a) {
        var s = e.dataTypeMatchers[a];
        s && delete e.dataTypeMatchers[a], e.dataTypeMatchers[a] = s ?? n[a].dataTypeMatcher;
      });
    }, t.prototype.mergeDataTypeDefinitions = function(e, r) {
      var n = Fo(Fo({}, e), r);
      return e.columnTypes && r.columnTypes && r.appendColumnTypes && (n.columnTypes = zf(zf([], _a(this.convertColumnTypes(e.columnTypes)), !1), _a(this.convertColumnTypes(r.columnTypes)), !1)), n;
    }, t.prototype.processDataTypeDefinition = function(e, r, n, i) {
      var a, s = e.extendsDataType;
      if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
        var l = i[s], u = r[s];
        if (l && u && (l = u), !this.validateDataTypeDefinition(e, l, s))
          return;
        a = this.mergeDataTypeDefinitions(l, e);
      } else {
        if (n.includes(s)) {
          ht('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');
          return;
        }
        var c = r[s];
        if (!this.validateDataTypeDefinition(e, c, s))
          return;
        var d = this.processDataTypeDefinition(c, r, zf(zf([], _a(n), !1), [s], !1), i);
        if (!d)
          return;
        a = this.mergeDataTypeDefinitions(d, e);
      }
      return Fo(Fo({}, a), { groupSafeValueFormatter: this.createGroupSafeValueFormatter(a) });
    }, t.prototype.validateDataTypeDefinition = function(e, r, n) {
      return r ? r.baseDataType !== e.baseDataType ? (ht('The "baseDataType" property of a data type definition must match that of its parent.'), !1) : !0 : (ht("The data type definition ".concat(n, " does not exist.")), !1);
    }, t.prototype.createGroupSafeValueFormatter = function(e) {
      var r = this;
      if (e.valueFormatter)
        return function(n) {
          var i, a;
          if (!((i = n.node) === null || i === void 0) && i.group) {
            var s = n.column.getAggFunc();
            if (s) {
              if (s === "first" || s === "last")
                return e.valueFormatter(n);
              if (e.baseDataType === "number" && s !== "count") {
                if (typeof n.value == "number")
                  return e.valueFormatter(n);
                if (typeof n.value == "object") {
                  if (!n.value)
                    return;
                  if ("toNumber" in n.value)
                    return e.valueFormatter(Fo(Fo({}, n), { value: n.value.toNumber() }));
                  if ("value" in n.value)
                    return e.valueFormatter(Fo(Fo({}, n), { value: n.value.value }));
                }
              }
            }
            if (!r.gridOptionsService.get("suppressGroupMaintainValueType"))
              return;
          } else if (r.groupHideOpenParents && n.column.isRowGroupActive()) {
            if (typeof n.value != "string" || !((a = e.dataTypeMatcher) === null || a === void 0) && a.call(e, n.value))
              return e.valueFormatter(n);
            if (!r.gridOptionsService.get("suppressGroupMaintainValueType"))
              return;
          }
          return e.valueFormatter(n);
        };
    }, t.prototype.updateColDefAndGetDataTypeDefinitionColumnType = function(e, r, n) {
      var i = r.cellDataType, a = r.field;
      if (i === void 0 && (i = e.cellDataType), (i == null || i === !0) && (i = this.canInferCellDataType(e, r) ? this.inferCellDataType(a, n) : !1), !i) {
        e.cellDataType = !1;
        return;
      }
      var s = this.dataTypeDefinitions[i];
      if (!s) {
        ht('Missing data type definition - "'.concat(i, '"'));
        return;
      }
      return e.cellDataType = i, s.groupSafeValueFormatter && (e.valueFormatter = s.groupSafeValueFormatter), s.valueParser && (e.valueParser = s.valueParser), s.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, s, n), s.columnTypes;
    }, t.prototype.updateColDefAndGetColumnType = function(e, r, n) {
      var i, a, s = this.updateColDefAndGetDataTypeDefinitionColumnType(e, r, n), l = (a = (i = r.type) !== null && i !== void 0 ? i : s) !== null && a !== void 0 ? a : e.type;
      return e.type = l, l ? this.convertColumnTypes(l) : void 0;
    }, t.prototype.addColumnListeners = function(e) {
      if (this.isWaitingForRowData) {
        var r = this.columnStateUpdatesPendingInference[e.getColId()];
        if (r) {
          var n = function(i) {
            r.add(i.key);
          };
          e.addEventListener(cr.EVENT_STATE_UPDATED, n), this.columnStateUpdateListenerDestroyFuncs.push(function() {
            return e.removeEventListener(cr.EVENT_STATE_UPDATED, n);
          });
        }
      }
    }, t.prototype.canInferCellDataType = function(e, r) {
      var n = this, i;
      if (this.rowModel.getType() !== "clientSide")
        return !1;
      var a = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
      if (this.doColDefPropsPreventInference(r, a))
        return !1;
      var s = r.type === null ? e.type : r.type;
      if (s) {
        var l = (i = this.gridOptionsService.get("columnTypes")) !== null && i !== void 0 ? i : {}, u = this.convertColumnTypes(s).some(function(c) {
          var d = l[c.trim()];
          return d && n.doColDefPropsPreventInference(d, a);
        });
        if (u)
          return !1;
      }
      return !this.doColDefPropsPreventInference(e, a);
    }, t.prototype.doColDefPropsPreventInference = function(e, r) {
      var n = this;
      return [
        ["cellRenderer", "agSparklineCellRenderer"],
        ["valueGetter", void 0],
        ["valueParser", void 0],
        ["refData", void 0]
      ].some(function(i) {
        var a = _a(i, 2), s = a[0], l = a[1];
        return n.doesColDefPropPreventInference(e, r, s, l);
      });
    }, t.prototype.doesColDefPropPreventInference = function(e, r, n, i) {
      if (!r[n])
        return !1;
      var a = e[n];
      return a === null ? (r[n] = !1, !1) : i === void 0 ? !!a : a === i;
    }, t.prototype.inferCellDataType = function(e, r) {
      var n;
      if (e) {
        var i, a = this.getInitialData();
        if (a) {
          var s = e.indexOf(".") >= 0 && !this.gridOptionsService.get("suppressFieldDotNotation");
          i = qd(a, e, s);
        } else
          this.initWaitForRowData(r);
        if (i != null) {
          var l = _a((n = Object.entries(this.dataTypeMatchers).find(function(c) {
            var d = _a(c, 2);
            d[0];
            var f = d[1];
            return f(i);
          })) !== null && n !== void 0 ? n : ["object"], 1), u = l[0];
          return u;
        }
      }
    }, t.prototype.getInitialData = function() {
      var e = this.gridOptionsService.get("rowData");
      if (e != null && e.length)
        return e[0];
      if (this.initialData)
        return this.initialData;
      var r = this.rowModel.getRootNode().allLeafChildren;
      return r != null && r.length ? r[0].data : null;
    }, t.prototype.initWaitForRowData = function(e) {
      var r = this;
      if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), !this.isWaitingForRowData) {
        this.isWaitingForRowData = !0;
        var n = this.isColumnTypeOverrideInDataTypeDefinitions;
        n && this.columnModel.queueResizeOperations();
        var i = this.addManagedListener(this.eventService, G.EVENT_ROW_DATA_UPDATE_STARTED, function(a) {
          var s = a.firstRowData;
          if (s) {
            i == null || i(), r.isWaitingForRowData = !1, r.processColumnsPendingInference(s, n), r.columnStateUpdatesPendingInference = {}, n && r.columnModel.processResizeOperations();
            var l = {
              type: G.EVENT_DATA_TYPES_INFERRED
            };
            r.eventService.dispatchEvent(l);
          }
        });
      }
    }, t.prototype.isPendingInference = function() {
      return this.isWaitingForRowData;
    }, t.prototype.processColumnsPendingInference = function(e, r) {
      var n = this;
      this.initialData = e;
      var i = [];
      this.columnStateUpdateListenerDestroyFuncs.forEach(function(l) {
        return l();
      }), this.columnStateUpdateListenerDestroyFuncs = [];
      var a = {}, s = {};
      Object.entries(this.columnStateUpdatesPendingInference).forEach(function(l) {
        var u = _a(l, 2), c = u[0], d = u[1], f = n.columnModel.getGridColumn(c);
        if (f) {
          var v = f.getColDef();
          if (n.columnModel.resetColumnDefIntoColumn(f, "cellDataTypeInferred")) {
            var g = f.getColDef();
            if (r && g.type && g.type !== v.type) {
              var m = n.getUpdatedColumnState(f, d);
              m.rowGroup && m.rowGroupIndex == null && (a[c] = m), m.pivot && m.pivotIndex == null && (s[c] = m), i.push(m);
            }
          }
        }
      }), r && i.push.apply(i, zf([], _a(this.columnModel.generateColumnStateForRowGroupAndPivotIndexes(a, s)), !1)), i.length && this.columnModel.applyColumnState({ state: i }, "cellDataTypeInferred"), this.initialData = null;
    }, t.prototype.getUpdatedColumnState = function(e, r) {
      var n = this.columnModel.getColumnStateFromColDef(e);
      return r.forEach(function(i) {
        delete n[i], i === "rowGroup" ? delete n.rowGroupIndex : i === "pivot" && delete n.pivotIndex;
      }), n;
    }, t.prototype.checkObjectValueHandlers = function(e) {
      var r = this.dataTypeDefinitions.object, n = e.object;
      this.hasObjectValueParser = r.valueParser !== n.valueParser, this.hasObjectValueFormatter = r.valueFormatter !== n.valueFormatter;
    }, t.prototype.convertColumnTypes = function(e) {
      var r = [];
      if (e instanceof Array) {
        var n = e.some(function(i) {
          return typeof i != "string";
        });
        n ? console.warn("if colDef.type is supplied an array it should be of type 'string[]'") : r = e;
      } else typeof e == "string" ? r = e.split(",") : console.warn("colDef.type should be of type 'string' | 'string[]'");
      return r;
    }, t.prototype.getDateStringTypeDefinition = function() {
      return this.dataTypeDefinitions.dateString;
    }, t.prototype.getDateParserFunction = function() {
      return this.getDateStringTypeDefinition().dateParser;
    }, t.prototype.getDateFormatterFunction = function() {
      return this.getDateStringTypeDefinition().dateFormatter;
    }, t.prototype.getDataTypeDefinition = function(e) {
      var r = e.getColDef();
      if (r.cellDataType)
        return this.dataTypeDefinitions[r.cellDataType];
    }, t.prototype.getBaseDataType = function(e) {
      var r;
      return (r = this.getDataTypeDefinition(e)) === null || r === void 0 ? void 0 : r.baseDataType;
    }, t.prototype.checkType = function(e, r) {
      var n;
      if (r == null)
        return !0;
      var i = (n = this.getDataTypeDefinition(e)) === null || n === void 0 ? void 0 : n.dataTypeMatcher;
      return i ? i(r) : !0;
    }, t.prototype.validateColDef = function(e) {
      e.cellDataType === "object" && (e.valueFormatter === this.dataTypeDefinitions.object.groupSafeValueFormatter && !this.hasObjectValueFormatter && ht('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"'), e.editable && e.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser && ht('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"'));
    }, t.prototype.setColDefPropertiesForBaseDataType = function(e, r, n) {
      var i = this, a = function(d, f, v) {
        var g = d.getColDef().valueFormatter;
        return g === r.groupSafeValueFormatter && (g = r.valueFormatter), i.valueFormatterService.formatValue(d, f, v, g);
      }, s = Xt.__isRegistered(Ye.SetFilterModule, this.context.getGridId()), l = this.localeService.getLocaleTextFunc(), u = function(d) {
        var f = e.filterParams;
        e.filterParams = typeof f == "object" ? Fo(Fo({}, f), d) : d;
      };
      switch (r.baseDataType) {
        case "number": {
          e.cellEditor = "agNumberCellEditor", s && u({
            comparator: function(d, f) {
              var v = d == null ? 0 : parseInt(d), g = f == null ? 0 : parseInt(f);
              return v === g ? 0 : v > g ? 1 : -1;
            }
          });
          break;
        }
        case "boolean": {
          e.cellEditor = "agCheckboxCellEditor", e.cellRenderer = "agCheckboxCellRenderer", e.suppressKeyboardEvent = function(d) {
            return !!d.colDef.editable && d.event.key === we.SPACE;
          }, u(s ? {
            valueFormatter: function(d) {
              return Oe(d.value) ? l(String(d.value), d.value ? "True" : "False") : l("blanks", "(Blanks)");
            }
          } : {
            maxNumConditions: 1,
            filterOptions: [
              "empty",
              {
                displayKey: "true",
                displayName: "True",
                predicate: function(d, f) {
                  return f;
                },
                numberOfInputs: 0
              },
              {
                displayKey: "false",
                displayName: "False",
                predicate: function(d, f) {
                  return f === !1;
                },
                numberOfInputs: 0
              }
            ]
          });
          break;
        }
        case "date": {
          e.cellEditor = "agDateCellEditor", e.keyCreator = function(d) {
            return a(d.column, d.node, d.value);
          }, s && u({
            valueFormatter: function(d) {
              var f = a(d.column, d.node, d.value);
              return Oe(f) ? f : l("blanks", "(Blanks)");
            },
            treeList: !0,
            treeListFormatter: function(d, f) {
              if (f === 1 && d != null) {
                var v = _P[Number(d) - 1];
                return l(v, EP[v]);
              }
              return d ?? l("blanks", "(Blanks)");
            }
          });
          break;
        }
        case "dateString": {
          e.cellEditor = "agDateStringCellEditor", e.keyCreator = function(d) {
            return a(d.column, d.node, d.value);
          };
          var c = this.getDateParserFunction();
          u(s ? {
            valueFormatter: function(d) {
              var f = a(d.column, d.node, d.value);
              return Oe(f) ? f : l("blanks", "(Blanks)");
            },
            treeList: !0,
            treeListPathGetter: function(d) {
              var f = c(d ?? void 0);
              return f ? [String(f.getFullYear()), String(f.getMonth() + 1), String(f.getDate())] : null;
            },
            treeListFormatter: function(d, f) {
              if (f === 1 && d != null) {
                var v = _P[Number(d) - 1];
                return l(v, EP[v]);
              }
              return d ?? l("blanks", "(Blanks)");
            }
          } : {
            comparator: function(d, f) {
              var v = c(f);
              return f == null || v < d ? -1 : v > d ? 1 : 0;
            }
          });
          break;
        }
        case "object": {
          e.cellEditorParams = {
            useFormatter: !0
          }, e.comparator = function(d, f) {
            var v = i.columnModel.getPrimaryColumn(n), g = v == null ? void 0 : v.getColDef();
            if (!v || !g)
              return 0;
            var m = d == null ? "" : a(v, null, d), b = f == null ? "" : a(v, null, f);
            return m === b ? 0 : m > b ? 1 : -1;
          }, e.keyCreator = function(d) {
            return a(d.column, d.node, d.value);
          }, s ? u({
            valueFormatter: function(d) {
              var f = a(d.column, d.node, d.value);
              return Oe(f) ? f : l("blanks", "(Blanks)");
            }
          }) : e.filterValueGetter = function(d) {
            return a(d.column, d.node, i.valueService.getValue(d.column, d.node));
          };
          break;
        }
      }
    }, t.prototype.getDefaultDataTypes = function() {
      var e = function(n) {
        return !!n.match("^\\d{4}-\\d{2}-\\d{2}$");
      }, r = this.localeService.getLocaleTextFunc();
      return {
        number: {
          baseDataType: "number",
          // can be empty space with legacy copy
          valueParser: function(n) {
            var i, a;
            return ((a = (i = n.newValue) === null || i === void 0 ? void 0 : i.trim) === null || a === void 0 ? void 0 : a.call(i)) === "" ? null : Number(n.newValue);
          },
          valueFormatter: function(n) {
            return n.value == null ? "" : typeof n.value != "number" || isNaN(n.value) ? (console.log("was", typeof n.value, n.value, n), r("invalidNumber", "Invalid Number")) : String(n.value);
          },
          dataTypeMatcher: function(n) {
            return typeof n == "number";
          }
        },
        text: {
          baseDataType: "text",
          valueParser: function(n) {
            return n.newValue === "" ? null : $h(n.newValue);
          },
          dataTypeMatcher: function(n) {
            return typeof n == "string";
          }
        },
        boolean: {
          baseDataType: "boolean",
          valueParser: function(n) {
            var i, a;
            return n.newValue == null ? n.newValue : ((a = (i = n.newValue) === null || i === void 0 ? void 0 : i.trim) === null || a === void 0 ? void 0 : a.call(i)) === "" ? null : String(n.newValue).toLowerCase() === "true";
          },
          valueFormatter: function(n) {
            return n.value == null ? "" : String(n.value);
          },
          dataTypeMatcher: function(n) {
            return typeof n == "boolean";
          }
        },
        date: {
          baseDataType: "date",
          valueParser: function(n) {
            return ko(n.newValue == null ? null : String(n.newValue));
          },
          valueFormatter: function(n) {
            var i;
            return n.value == null ? "" : !(n.value instanceof Date) || isNaN(n.value.getTime()) ? r("invalidDate", "Invalid Date") : (i = Pi(n.value, !1)) !== null && i !== void 0 ? i : "";
          },
          dataTypeMatcher: function(n) {
            return n instanceof Date;
          }
        },
        dateString: {
          baseDataType: "dateString",
          dateParser: function(n) {
            var i;
            return (i = ko(n)) !== null && i !== void 0 ? i : void 0;
          },
          dateFormatter: function(n) {
            var i;
            return (i = Pi(n ?? null, !1)) !== null && i !== void 0 ? i : void 0;
          },
          valueParser: function(n) {
            return e(String(n.newValue)) ? n.newValue : null;
          },
          valueFormatter: function(n) {
            return e(String(n.value)) ? n.value : "";
          },
          dataTypeMatcher: function(n) {
            return typeof n == "string" && e(n);
          }
        },
        object: {
          baseDataType: "object",
          valueParser: function() {
            return null;
          },
          valueFormatter: function(n) {
            var i;
            return (i = $h(n.value)) !== null && i !== void 0 ? i : "";
          }
        }
      };
    }, ku([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), ku([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), ku([
      N("columnUtils")
    ], t.prototype, "columnUtils", void 0), ku([
      N("valueService")
    ], t.prototype, "valueService", void 0), ku([
      N("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), ku([
      Fe
    ], t.prototype, "init", null), t = ku([
      Be("dataTypeService")
    ], t), t;
  }(Me)
), zQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, ZL = (
  /** @class */
  function(o) {
    zQ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.parseValue = function(e, r, n, i) {
      var a = e.getColDef(), s = this.gridOptionsService.addGridCommonParams({
        node: r,
        data: r == null ? void 0 : r.data,
        oldValue: i,
        newValue: n,
        colDef: a,
        column: e
      }), l = a.valueParser;
      return Oe(l) ? typeof l == "function" ? l(s) : this.expressionService.evaluate(l, s) : n;
    }, xP([
      N("expressionService")
    ], t.prototype, "expressionService", void 0), t = xP([
      Be("valueParserService")
    ], t), t;
  }(Me)
), YQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Yf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, KQ = (
  /** @class */
  function(o) {
    YQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.waitingForColumns = !1, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.addManagedPropertyListener("columnDefs", function(r) {
        return e.setColumnDefs(r);
      });
    }, t.prototype.start = function() {
      var e = this;
      this.ctrlsService.whenReady(function() {
        var r = e.gridOptionsService.get("columnDefs");
        r ? e.setColumnsAndData(r) : e.waitingForColumns = !0, e.gridReady();
      });
    }, t.prototype.setColumnsAndData = function(e) {
      this.columnModel.setColumnDefs(e ?? [], "gridInitializing"), this.rowModel.start();
    }, t.prototype.gridReady = function() {
      var e = this;
      this.dispatchGridReadyEvent();
      var r = Xt.__isRegistered(Ye.EnterpriseCoreModule, this.context.getGridId()), n = new pC("AG Grid", function() {
        return e.gridOptionsService.get("debug");
      });
      n.log("initialised successfully, enterprise = ".concat(r));
    }, t.prototype.dispatchGridReadyEvent = function() {
      var e = {
        type: G.EVENT_GRID_READY
      };
      this.eventService.dispatchEvent(e);
    }, t.prototype.setColumnDefs = function(e) {
      var r, n = this.gridOptionsService.get("columnDefs");
      if (n) {
        if (this.waitingForColumns) {
          this.waitingForColumns = !1, this.setColumnsAndData(n);
          return;
        }
        var i = (r = e.source) !== null && r !== void 0 ? r : "api";
        this.columnModel.setColumnDefs(n, i);
      }
    }, Yf([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Yf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Yf([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Yf([
      Fe
    ], t.prototype, "postConstruct", null), t = Yf([
      Be("syncService")
    ], t), t;
  }(Me)
), qQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), zS = function() {
  return zS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, zS.apply(this, arguments);
}, Kf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, XQ = (
  /** @class */
  function(o) {
    qQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.manuallyDisplayed = !1, e;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_ROW_DATA_UPDATED, function() {
        return e.onRowDataUpdated();
      }), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return e.onNewColumnsLoaded();
      });
    }, t.prototype.registerOverlayWrapperComp = function(e) {
      this.overlayWrapperComp = e, (!this.gridOptionsService.get("columnDefs") || this.gridOptionsService.isRowModelType("clientSide") && !this.gridOptionsService.get("rowData")) && this.showLoadingOverlay();
    }, t.prototype.showLoadingOverlay = function() {
      if (!this.gridOptionsService.get("suppressLoadingOverlay")) {
        var e = {}, r = this.userComponentFactory.getLoadingOverlayCompDetails(e);
        this.showOverlay(r, "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
      }
    }, t.prototype.showNoRowsOverlay = function() {
      if (!this.gridOptionsService.get("suppressNoRowsOverlay")) {
        var e = {}, r = this.userComponentFactory.getNoRowsOverlayCompDetails(e);
        this.showOverlay(r, "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
      }
    }, t.prototype.showOverlay = function(e, r, n) {
      var i = this, a = e.newAgStackInstance(), s = this.addManagedPropertyListener(n, function(l) {
        var u = l.currentValue;
        a.then(function(c) {
          c.refresh && c.refresh(i.gridOptionsService.addGridCommonParams(zS({}, u ?? {})));
        });
      });
      this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty(), this.overlayWrapperComp.showOverlay(a, r, s);
    }, t.prototype.hideOverlay = function() {
      this.manuallyDisplayed = !1, this.overlayWrapperComp.hideOverlay();
    }, t.prototype.showOrHideOverlay = function() {
      var e = this.paginationProxy.isEmpty(), r = this.gridOptionsService.get("suppressNoRowsOverlay");
      e && !r ? this.showNoRowsOverlay() : this.hideOverlay();
    }, t.prototype.onRowDataUpdated = function() {
      this.showOrHideOverlay();
    }, t.prototype.onNewColumnsLoaded = function() {
      this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed && this.hideOverlay();
    }, Kf([
      N("userComponentFactory")
    ], t.prototype, "userComponentFactory", void 0), Kf([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Kf([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Kf([
      Fe
    ], t.prototype, "postConstruct", null), t = Kf([
      Be("overlayService")
    ], t), t;
  }(Me)
), ZQ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bl = function() {
  return bl = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, bl.apply(this, arguments);
}, Ri = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, QQ = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, JQ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, eJ = (
  /** @class */
  function(o) {
    ZQ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.suppressEvents = !0, e.queuedUpdateSources = /* @__PURE__ */ new Set(), e.dispatchStateUpdateEventDebounced = Oi(function() {
        return e.dispatchQueuedStateUpdateEvents();
      }, 0), e;
    }
    return t.prototype.postConstruct = function() {
      var e = this, r;
      this.isClientSideRowModel = this.rowModel.getType() === "clientSide", this.cachedState = (r = this.gridOptionsService.get("initialState")) !== null && r !== void 0 ? r : {}, this.ctrlsService.whenReady(function() {
        return e.suppressEventsAndDispatchInitEvent(function() {
          return e.setupStateOnGridReady();
        });
      });
      var n = this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function(s) {
        var l = s.source;
        l === "gridInitializing" && (n == null || n(), e.suppressEventsAndDispatchInitEvent(function() {
          return e.setupStateOnColumnsInitialised();
        }));
      }), i = this.addManagedListener(this.eventService, G.EVENT_ROW_COUNT_READY, function() {
        i == null || i(), e.suppressEventsAndDispatchInitEvent(function() {
          return e.setupStateOnRowCountReady();
        });
      }), a = this.addManagedListener(this.eventService, G.EVENT_FIRST_DATA_RENDERED, function() {
        a == null || a(), e.suppressEventsAndDispatchInitEvent(function() {
          return e.setupStateOnFirstDataRendered();
        });
      });
    }, t.prototype.getState = function() {
      return this.cachedState;
    }, t.prototype.setupStateOnGridReady = function() {
      var e = this;
      this.updateCachedState("sideBar", this.getSideBarState()), this.addManagedListener(this.eventService, G.EVENT_TOOL_PANEL_VISIBLE_CHANGED, function() {
        return e.updateCachedState("sideBar", e.getSideBarState());
      }), this.addManagedListener(this.eventService, G.EVENT_SIDE_BAR_UPDATED, function() {
        return e.updateCachedState("sideBar", e.getSideBarState());
      });
    }, t.prototype.setupStateOnColumnsInitialised = function() {
      var e = this, r, n = (r = this.gridOptionsService.get("initialState")) !== null && r !== void 0 ? r : {}, i = n.columnGroup;
      this.setColumnState(n), i && this.setColumnGroupState(i), this.updateColumnState([
        "aggregation",
        "columnOrder",
        "columnPinning",
        "columnSizing",
        "columnVisibility",
        "pivot",
        "pivot",
        "rowGroup",
        "sort"
      ]), this.updateCachedState("columnGroup", this.getColumnGroupState()), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VALUE_CHANGED, function() {
        return e.updateColumnState(["aggregation"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_MOVED, function() {
        return e.updateColumnState(["columnOrder"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PINNED, function() {
        return e.updateColumnState(["columnPinning"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_RESIZED, function() {
        return e.updateColumnState(["columnSizing"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VISIBLE, function() {
        return e.updateColumnState(["columnVisibility"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_CHANGED, function() {
        return e.updateColumnState(["pivot"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, function() {
        return e.updateColumnState(["pivot"]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, function() {
        return e.updateColumnState(["rowGroup"]);
      }), this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, function() {
        return e.updateColumnState(["sort"]);
      }), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, function() {
        return e.updateColumnState([
          "aggregation",
          "columnOrder",
          "columnPinning",
          "columnSizing",
          "columnVisibility",
          "pivot",
          "pivot",
          "rowGroup",
          "sort"
        ]);
      }), this.addManagedListener(this.eventService, G.EVENT_COLUMN_GROUP_OPENED, function() {
        return e.updateCachedState("columnGroup", e.getColumnGroupState());
      });
    }, t.prototype.setupStateOnRowCountReady = function() {
      var e = this, r, n = (r = this.gridOptionsService.get("initialState")) !== null && r !== void 0 ? r : {}, i = n.filter, a = n.rowGroupExpansion, s = n.rowSelection, l = n.pagination, u = this.gridOptionsService.get("advancedFilterModel");
      (i || u) && this.setFilterState(i, u), a && this.setRowGroupExpansionState(a), s && this.setRowSelectionState(s), l && this.setPaginationState(l), this.updateCachedState("filter", this.getFilterState()), this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("rowSelection", this.getRowSelectionState()), this.updateCachedState("pagination", this.getPaginationState()), this.addManagedListener(this.eventService, G.EVENT_FILTER_CHANGED, function() {
        return e.updateCachedState("filter", e.getFilterState());
      }), this.addManagedListener(this.eventService, G.EVENT_ROW_GROUP_OPENED, function() {
        return e.updateCachedState("rowGroupExpansion", e.getRowGroupExpansionState());
      }), this.addManagedListener(this.eventService, G.EVENT_EXPAND_COLLAPSE_ALL, function() {
        return e.updateCachedState("rowGroupExpansion", e.getRowGroupExpansionState());
      }), this.addManagedListener(this.eventService, G.EVENT_SELECTION_CHANGED, function() {
        return e.updateCachedState("rowSelection", e.getRowSelectionState());
      }), this.addManagedListener(this.eventService, G.EVENT_PAGINATION_CHANGED, function(c) {
        (c.newPage || c.newPageSize) && e.updateCachedState("pagination", e.getPaginationState());
      });
    }, t.prototype.setupStateOnFirstDataRendered = function() {
      var e = this, r, n = (r = this.gridOptionsService.get("initialState")) !== null && r !== void 0 ? r : {}, i = n.scroll, a = n.rangeSelection, s = n.focusedCell, l = n.columnOrder;
      s && this.setFocusedCellState(s), a && this.setRangeSelectionState(a), i && this.setScrollState(i), this.setColumnPivotState(!!(l != null && l.orderedColIds)), this.updateCachedState("sideBar", this.getSideBarState()), this.updateCachedState("focusedCell", this.getFocusedCellState()), this.updateCachedState("rangeSelection", this.getRangeSelectionState()), this.updateCachedState("scroll", this.getScrollState()), this.addManagedListener(this.eventService, G.EVENT_CELL_FOCUSED, function() {
        return e.updateCachedState("focusedCell", e.getFocusedCellState());
      }), this.addManagedListener(this.eventService, G.EVENT_RANGE_SELECTION_CHANGED, function(u) {
        u.finished && e.updateCachedState("rangeSelection", e.getRangeSelectionState());
      }), this.addManagedListener(this.eventService, G.EVENT_BODY_SCROLL_END, function() {
        return e.updateCachedState("scroll", e.getScrollState());
      });
    }, t.prototype.getColumnState = function() {
      for (var e = this.columnModel.isPivotMode(), r = [], n = [], i = [], a = [], s = [], l = [], u = [], c = [], d = [], f = this.columnModel.getColumnState(), v = 0; v < f.length; v++) {
        var g = f[v], m = g.colId, b = g.sort, S = g.sortIndex, R = g.rowGroup, P = g.rowGroupIndex, D = g.aggFunc, x = g.pivot, M = g.pivotIndex, F = g.pinned, H = g.hide, B = g.width, j = g.flex;
        d.push(m), b && (r[S ?? 0] = { colId: m, sort: b }), R && (n[P ?? 0] = m), typeof D == "string" && i.push({ colId: m, aggFunc: D }), x && (a[M ?? 0] = m), F && (F === "right" ? l : s).push(m), H && u.push(m), (j || B) && c.push({ colId: m, flex: j ?? void 0, width: B });
      }
      return {
        sort: r.length ? { sortModel: r } : void 0,
        rowGroup: n.length ? { groupColIds: n } : void 0,
        aggregation: i.length ? { aggregationModel: i } : void 0,
        pivot: a.length || e ? { pivotMode: e, pivotColIds: a } : void 0,
        columnPinning: s.length || l.length ? { leftColIds: s, rightColIds: l } : void 0,
        columnVisibility: u.length ? { hiddenColIds: u } : void 0,
        columnSizing: c.length ? { columnSizingModel: c } : void 0,
        columnOrder: d.length ? { orderedColIds: d } : void 0
      };
    }, t.prototype.setColumnState = function(e) {
      var r = e.sort, n = e.rowGroup, i = e.aggregation, a = e.pivot, s = e.columnPinning, l = e.columnVisibility, u = e.columnSizing, c = e.columnOrder, d = {}, f = function(S) {
        var R = d[S];
        return R || (R = { colId: S }, d[S] = R, R);
      };
      r && r.sortModel.forEach(function(S, R) {
        var P = S.colId, D = S.sort, x = f(P);
        x.sort = D, x.sortIndex = R;
      }), n && n.groupColIds.forEach(function(S, R) {
        var P = f(S);
        P.rowGroup = !0, P.rowGroupIndex = R;
      }), i && i.aggregationModel.forEach(function(S) {
        var R = S.colId, P = S.aggFunc;
        f(R).aggFunc = P;
      }), a && (a.pivotColIds.forEach(function(S, R) {
        var P = f(S);
        P.pivot = !0, P.pivotIndex = R;
      }), this.gridOptionsService.updateGridOptions({ options: { pivotMode: a.pivotMode }, source: "gridInitializing" })), s && (s.leftColIds.forEach(function(S) {
        f(S).pinned = "left";
      }), s.rightColIds.forEach(function(S) {
        f(S).pinned = "right";
      })), l && l.hiddenColIds.forEach(function(S) {
        f(S).hide = !0;
      }), u && u.columnSizingModel.forEach(function(S) {
        var R = S.colId, P = S.flex, D = S.width, x = f(R);
        x.flex = P ?? null, x.width = D;
      });
      var v = c == null ? void 0 : c.orderedColIds, g = !!(v != null && v.length), m = g ? v.map(function(S) {
        return f(S);
      }) : Object.values(d);
      if (m.length) {
        this.columnStates = m;
        var b = {
          sort: null,
          sortIndex: null,
          rowGroup: null,
          rowGroupIndex: null,
          aggFunc: null,
          pivot: null,
          pivotIndex: null,
          pinned: null,
          hide: null,
          flex: null
        };
        this.columnModel.applyColumnState({
          state: m,
          applyOrder: g,
          defaultState: b
        }, "gridInitializing");
      }
    }, t.prototype.setColumnPivotState = function(e) {
      var r, n, i = this.columnStates;
      if (this.columnStates = void 0, !(!i || !this.columnModel.isSecondaryColumnsPresent())) {
        var a = [];
        try {
          for (var s = QQ(i), l = s.next(); !l.done; l = s.next()) {
            var u = l.value;
            this.columnModel.getSecondaryColumn(u.colId) && a.push(u);
          }
        } catch (c) {
          r = { error: c };
        } finally {
          try {
            l && !l.done && (n = s.return) && n.call(s);
          } finally {
            if (r) throw r.error;
          }
        }
        this.columnModel.applyColumnState({
          state: a,
          applyOrder: e
        }, "gridInitializing");
      }
    }, t.prototype.getColumnGroupState = function() {
      var e = this.columnModel.getColumnGroupState(), r = [];
      return e.forEach(function(n) {
        var i = n.groupId, a = n.open;
        a && r.push(i);
      }), r.length ? { openColumnGroupIds: r } : void 0;
    }, t.prototype.setColumnGroupState = function(e) {
      var r = e.openColumnGroupIds, n = new Set(r), i = this.columnModel.getColumnGroupState(), a = i.map(function(s) {
        var l = s.groupId;
        return {
          groupId: l,
          open: n.has(l)
        };
      });
      this.columnModel.setColumnGroupState(a, "gridInitializing");
    }, t.prototype.getFilterState = function() {
      var e, r = this.filterManager.getFilterModel();
      r && Object.keys(r).length === 0 && (r = void 0);
      var n = (e = this.filterManager.getAdvancedFilterModel()) !== null && e !== void 0 ? e : void 0;
      return r || n ? { filterModel: r, advancedFilterModel: n } : void 0;
    }, t.prototype.setFilterState = function(e, r) {
      var n = e ?? { advancedFilterModel: r }, i = n.filterModel, a = n.advancedFilterModel;
      i && this.filterManager.setFilterModel(i, "columnFilter"), a && this.filterManager.setAdvancedFilterModel(a);
    }, t.prototype.getRangeSelectionState = function() {
      var e, r = (e = this.rangeService) === null || e === void 0 ? void 0 : e.getCellRanges().map(function(n) {
        var i = n.id, a = n.type, s = n.startRow, l = n.endRow, u = n.columns, c = n.startColumn;
        return {
          id: i,
          type: a,
          startRow: s,
          endRow: l,
          colIds: u.map(function(d) {
            return d.getColId();
          }),
          startColId: c.getColId()
        };
      });
      return r != null && r.length ? { cellRanges: r } : void 0;
    }, t.prototype.setRangeSelectionState = function(e) {
      var r = this, n;
      if (this.gridOptionsService.get("enableRangeSelection")) {
        var i = e.cellRanges.map(function(a) {
          return bl(bl({}, a), { columns: a.colIds.map(function(s) {
            return r.columnModel.getGridColumn(s);
          }), startColumn: r.columnModel.getGridColumn(a.startColId) });
        });
        (n = this.rangeService) === null || n === void 0 || n.setCellRanges(i);
      }
    }, t.prototype.getScrollState = function() {
      var e, r, n;
      if (this.isClientSideRowModel) {
        var i = (e = this.ctrlsService.getGridBodyCtrl()) === null || e === void 0 ? void 0 : e.getScrollFeature(), a = ((r = i == null ? void 0 : i.getHScrollPosition()) !== null && r !== void 0 ? r : { left: 0 }).left, s = ((n = i == null ? void 0 : i.getVScrollPosition()) !== null && n !== void 0 ? n : { top: 0 }).top;
        return s || a ? {
          top: s,
          left: a
        } : void 0;
      }
    }, t.prototype.setScrollState = function(e) {
      var r;
      if (this.isClientSideRowModel) {
        var n = e.top, i = e.left;
        (r = this.ctrlsService.getGridBodyCtrl()) === null || r === void 0 || r.getScrollFeature().setScrollPosition(n, i);
      }
    }, t.prototype.getSideBarState = function() {
      var e, r;
      return (r = (e = this.sideBarService) === null || e === void 0 ? void 0 : e.getSideBarComp()) === null || r === void 0 ? void 0 : r.getState();
    }, t.prototype.getFocusedCellState = function() {
      if (this.isClientSideRowModel) {
        var e = this.focusService.getFocusedCell();
        if (e) {
          var r = e.column, n = e.rowIndex, i = e.rowPinned;
          return {
            colId: r.getColId(),
            rowIndex: n,
            rowPinned: i
          };
        }
      }
    }, t.prototype.setFocusedCellState = function(e) {
      if (this.isClientSideRowModel) {
        var r = e.colId, n = e.rowIndex, i = e.rowPinned;
        this.focusService.setFocusedCell({
          column: this.columnModel.getGridColumn(r),
          rowIndex: n,
          rowPinned: i,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      }
    }, t.prototype.getPaginationState = function() {
      var e = this.paginationProxy.getCurrentPage(), r = this.gridOptionsService.get("paginationAutoPageSize") ? void 0 : this.paginationProxy.getPageSize();
      if (!(!e && !r))
        return { page: e, pageSize: r };
    }, t.prototype.setPaginationState = function(e) {
      e.pageSize && !this.gridOptionsService.get("paginationAutoPageSize") && this.paginationProxy.setPageSize(e.pageSize, "initialState"), typeof e.page == "number" && this.paginationProxy.setPage(e.page);
    }, t.prototype.getRowSelectionState = function() {
      var e, r = this.selectionService.getSelectionState(), n = !r || !Array.isArray(r) && (r.selectAll === !1 || r.selectAllChildren === !1) && !(!((e = r == null ? void 0 : r.toggledNodes) === null || e === void 0) && e.length);
      return n ? void 0 : r;
    }, t.prototype.setRowSelectionState = function(e) {
      this.selectionService.setSelectionState(e, "gridInitializing");
    }, t.prototype.getRowGroupExpansionState = function() {
      var e = this.expansionService.getExpandedRows();
      return e.length ? {
        expandedRowGroupIds: e
      } : void 0;
    }, t.prototype.setRowGroupExpansionState = function(e) {
      this.expansionService.expandRows(e.expandedRowGroupIds);
    }, t.prototype.updateColumnState = function(e) {
      var r = this, n = this.getColumnState(), i = !1;
      Object.entries(n).forEach(function(a) {
        var s = JQ(a, 2), l = s[0], u = s[1];
        RS(u, r.cachedState[l]) || (i = !0);
      }), this.cachedState = bl(bl({}, this.cachedState), n), i && this.dispatchStateUpdateEvent(e);
    }, t.prototype.updateCachedState = function(e, r) {
      var n, i = this.cachedState[e];
      this.cachedState = bl(bl({}, this.cachedState), (n = {}, n[e] = r, n)), RS(r, i) || this.dispatchStateUpdateEvent([e]);
    }, t.prototype.dispatchStateUpdateEvent = function(e) {
      var r = this;
      this.suppressEvents || (e.forEach(function(n) {
        return r.queuedUpdateSources.add(n);
      }), this.dispatchStateUpdateEventDebounced());
    }, t.prototype.dispatchQueuedStateUpdateEvents = function() {
      var e = Array.from(this.queuedUpdateSources);
      this.queuedUpdateSources.clear();
      var r = {
        type: G.EVENT_STATE_UPDATED,
        sources: e,
        state: this.cachedState
      };
      this.eventService.dispatchEvent(r);
    }, t.prototype.suppressEventsAndDispatchInitEvent = function(e) {
      var r = this;
      this.suppressEvents = !0, e(), setTimeout(function() {
        r.suppressEvents = !1, r.queuedUpdateSources.clear(), r.dispatchStateUpdateEvent(["gridInitializing"]);
      });
    }, Ri([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Ri([
      Lt("rangeService")
    ], t.prototype, "rangeService", void 0), Ri([
      N("ctrlsService")
    ], t.prototype, "ctrlsService", void 0), Ri([
      Lt("sideBarService")
    ], t.prototype, "sideBarService", void 0), Ri([
      N("focusService")
    ], t.prototype, "focusService", void 0), Ri([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Ri([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), Ri([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Ri([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), Ri([
      N("expansionService")
    ], t.prototype, "expansionService", void 0), Ri([
      Fe
    ], t.prototype, "postConstruct", null), t = Ri([
      Be("stateService")
    ], t), t;
  }(Me)
), tJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Gu = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, qf = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, rJ = (
  /** @class */
  function(o) {
    tJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.init = function() {
      this.processGridOptions(this.gridOptions);
    }, t.prototype.processGridOptions = function(e) {
      this.processOptions(e, VQ);
    }, t.prototype.processColumnDefs = function(e) {
      this.processOptions(e, Ud);
    }, t.prototype.processOptions = function(e, r) {
      var n = this, i = r.validations, a = r.deprecations, s = r.allProperties, l = r.propertyExceptions, u = r.objectName, c = r.docsUrl;
      s && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(e, qf(qf([], Gu(l ?? []), !1), Gu(Object.keys(a)), !1), s, u, c);
      var d = /* @__PURE__ */ new Set(), f = Object.keys(e);
      f.forEach(function(v) {
        var g, m = a[v];
        if (m)
          if ("renamed" in m) {
            var b = m.renamed, S = m.version;
            d.add("As of v".concat(S, ", ").concat(String(v), " is deprecated. Please use ").concat(String(b), " instead.")), e[b] = e[v];
          } else {
            var R = m.message, S = m.version;
            d.add("As of v".concat(S, ", ").concat(String(v), " is deprecated. ").concat(R ?? ""));
          }
        var P = e[v];
        if (!(P == null || P === !1)) {
          var D = i[v], x;
          if (D)
            if (typeof D == "function") {
              var M = D(e, n.gridOptions);
              if (!M)
                return;
              if ("objectName" in M) {
                var F = e[v];
                if (Array.isArray(F)) {
                  F.forEach(function(re) {
                    n.processOptions(re, M);
                  });
                  return;
                }
                n.processOptions(e[v], M);
                return;
              }
              x = M;
            } else
              x = D;
          else return;
          var H = x.module, B = x.dependencies, j = x.supportedRowModels;
          if (j) {
            var V = (g = n.gridOptions.rowModelType) !== null && g !== void 0 ? g : "clientSide";
            if (!j.includes(V)) {
              d.add("".concat(String(v), " is not supported with the '").concat(V, "' row model."));
              return;
            }
          }
          if (H) {
            var W = Array.isArray(H) ? H : [H], q = !0;
            if (W.forEach(function(re) {
              Xt.__assertRegistered(re, String(v), n.gridOptionsService.getGridId()) || (q = !1, d.add("".concat(String(v), " is only available when ").concat(re, " is loaded.")));
            }), !q)
              return;
          }
          if (B) {
            var ee = n.checkForWarning(v, B, e);
            if (ee) {
              d.add(ee);
              return;
            }
          }
        }
      }), d.size > 0 && d.forEach(function(v) {
        ht(v);
      });
    }, t.prototype.checkForWarning = function(e, r, n) {
      if (typeof r == "function")
        return r(n, this.gridOptions);
      var i = Object.entries(r), a = i.find(function(c) {
        var d = Gu(c, 2), f = d[0], v = d[1], g = n[f];
        return !v.includes(g);
      });
      if (!a)
        return null;
      var s = Gu(a, 2), l = s[0], u = s[1];
      return u.length > 1 ? "'".concat(String(e), "' requires '").concat(l, "' to be one of [").concat(u.join(", "), "].") : "'".concat(String(e), "' requires '").concat(l, "' to be ").concat(u[0], ".");
    }, t.prototype.checkProperties = function(e, r, n, i, a) {
      var s = ["__ob__", "__v_skip", "__metadata__"], l = K2(Object.getOwnPropertyNames(e), qf(qf(qf([], Gu(s), !1), Gu(r), !1), Gu(n), !1), n);
      if (Xn(l, function(c, d) {
        ht("invalid ".concat(i, " property '").concat(c, "' did you mean any of these: ").concat(d.slice(0, 8).join(", ")));
      }), Object.keys(l).length > 0 && a) {
        var u = this.getFrameworkOverrides().getDocLink(a);
        ht("to see all the valid ".concat(i, " properties please check: ").concat(u));
      }
    }, Cb([
      N("gridOptions")
    ], t.prototype, "gridOptions", void 0), Cb([
      Fe
    ], t.prototype, "init", null), t = Cb([
      Be("validationService")
    ], t), t;
  }(Me)
), nJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), RP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, oJ = (
  /** @class */
  function(o) {
    nJ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.syncEventListeners = /* @__PURE__ */ new Map(), e.asyncEventListeners = /* @__PURE__ */ new Map(), e.syncGlobalEventListeners = /* @__PURE__ */ new Set(), e.asyncGlobalEventListeners = /* @__PURE__ */ new Set(), e;
    }
    return t.prototype.postConstruct = function() {
      this.frameworkEventWrappingService = new S1(this.getFrameworkOverrides());
    }, t.prototype.addEventListener = function(e, r) {
      var n = this.frameworkEventWrappingService.wrap(r), i = this.gridOptionsService.useAsyncEvents(), a = i ? this.asyncEventListeners : this.syncEventListeners;
      a.has(e) || a.set(e, /* @__PURE__ */ new Set()), a.get(e).add(n), this.eventService.addEventListener(e, n, i);
    }, t.prototype.addGlobalListener = function(e) {
      var r = this.frameworkEventWrappingService.wrapGlobal(e), n = this.gridOptionsService.useAsyncEvents(), i = n ? this.asyncGlobalEventListeners : this.syncGlobalEventListeners;
      i.add(r), this.eventService.addGlobalListener(r, n);
    }, t.prototype.removeEventListener = function(e, r) {
      var n, i = this.frameworkEventWrappingService.unwrap(r), a = this.asyncEventListeners.get(e), s = !!(a != null && a.delete(i));
      s || (n = this.asyncEventListeners.get(e)) === null || n === void 0 || n.delete(i), this.eventService.removeEventListener(e, i, s);
    }, t.prototype.removeGlobalListener = function(e) {
      var r = this.frameworkEventWrappingService.unwrapGlobal(e), n = this.asyncGlobalEventListeners.delete(r);
      n || this.syncGlobalEventListeners.delete(r), this.eventService.removeGlobalListener(r, n);
    }, t.prototype.destroyEventListeners = function(e, r) {
      var n = this;
      e.forEach(function(i, a) {
        i.forEach(function(s) {
          return n.eventService.removeEventListener(a, s, r);
        }), i.clear();
      }), e.clear();
    }, t.prototype.destroyGlobalListeners = function(e, r) {
      var n = this;
      e.forEach(function(i) {
        return n.eventService.removeGlobalListener(i, r);
      }), e.clear();
    }, t.prototype.destroy = function() {
      o.prototype.destroy.call(this), this.destroyEventListeners(this.syncEventListeners, !1), this.destroyEventListeners(this.asyncEventListeners, !0), this.destroyGlobalListeners(this.syncGlobalEventListeners, !1), this.destroyGlobalListeners(this.asyncGlobalEventListeners, !0);
    }, RP([
      Fe
    ], t.prototype, "postConstruct", null), t = RP([
      Be("apiEventService")
    ], t), t;
  }(Me)
), iJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), em = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, aJ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, sJ = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, lJ = (
  /** @class */
  function(o) {
    iJ(t, o);
    function t() {
      var e = o.call(
        this,
        /* html */
        '<span class="ag-paging-page-size"></span>'
      ) || this;
      return e.hasEmptyOption = !1, e.handlePageSizeItemSelected = function() {
        if (e.selectPageSizeComp) {
          var r = e.selectPageSizeComp.getValue();
          if (r) {
            var n = Number(r);
            isNaN(n) || n < 1 || n === e.paginationProxy.getPageSize() || (e.paginationProxy.setPageSize(n, "pageSizeSelector"), e.hasEmptyOption && e.toggleSelectDisplay(!0), e.selectPageSizeComp.getFocusableElement().focus());
          }
        }
      }, e;
    }
    return t.prototype.init = function() {
      var e = this;
      this.addManagedPropertyListener("paginationPageSizeSelector", function() {
        e.onPageSizeSelectorValuesChange();
      }), this.addManagedListener(this.eventService, G.EVENT_PAGINATION_CHANGED, function(r) {
        return e.handlePaginationChanged(r);
      });
    }, t.prototype.handlePaginationChanged = function(e) {
      if (!(!this.selectPageSizeComp || !(e != null && e.newPageSize))) {
        var r = this.paginationProxy.getPageSize();
        this.getPageSizeSelectorValues().includes(r) ? this.selectPageSizeComp.setValue(r.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
      }
    }, t.prototype.toggleSelectDisplay = function(e) {
      this.selectPageSizeComp && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp && this.appendChild(this.selectPageSizeComp));
    }, t.prototype.reset = function() {
      An(this.getGui()), this.selectPageSizeComp && (this.destroyBean(this.selectPageSizeComp), this.selectPageSizeComp = void 0);
    }, t.prototype.onPageSizeSelectorValuesChange = function() {
      this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
    }, t.prototype.shouldShowPageSizeSelector = function() {
      return this.gridOptionsService.get("pagination") && !this.gridOptionsService.get("suppressPaginationPanel") && !this.gridOptionsService.get("paginationAutoPageSize") && this.gridOptionsService.get("paginationPageSizeSelector") !== !1;
    }, t.prototype.reloadPageSizesSelector = function() {
      var e = this, r = this.getPageSizeSelectorValues(), n = this.paginationProxy.getPageSize(), i = !n || !r.includes(n);
      i && (r.unshift(""), ht(`The paginationPageSize grid option is set to a value that is not in the list of page size options.
                Please make sure that the paginationPageSize grid option is set to one of the values in the 
                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.`)), this.selectPageSizeComp && (this.destroyBean(this.selectPageSizeComp), this.selectPageSizeComp = void 0);
      var a = this.localeService.getLocaleTextFunc(), s = a("pageSizeSelectorLabel", "Page Size:"), l = r.map(function(c) {
        return {
          value: String(c),
          text: String(c)
        };
      }), u = a("ariaPageSizeSelectorLabel", "Page Size");
      this.selectPageSizeComp = this.createManagedBean(new pv()).addOptions(l).setValue(String(i ? "" : n)).setAriaLabel(u).setLabel(s).onValueChange(function() {
        return e.handlePageSizeItemSelected();
      }), this.hasEmptyOption = i;
    }, t.prototype.getPageSizeSelectorValues = function() {
      var e = [20, 50, 100], r = this.gridOptionsService.get("paginationPageSizeSelector");
      return !Array.isArray(r) || !this.validateValues(r) ? e : sJ([], aJ(r), !1).sort(function(n, i) {
        return n - i;
      });
    }, t.prototype.validateValues = function(e) {
      if (!e.length)
        return ht(`The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.
                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.`), !1;
      for (var r = 0; r < e.length; r++) {
        var n = e[r], i = typeof n == "number", a = n > 0;
        if (!i)
          return ht(`The paginationPageSizeSelector grid option contains a non-numeric value.
                    Please make sure that all values in the paginationPageSizeSelector array are numbers.`), !1;
        if (!a)
          return ht(`The paginationPageSizeSelector grid option contains a negative number or zero.
                    Please make sure that all values in the paginationPageSizeSelector array are positive.`), !1;
      }
      return !0;
    }, t.prototype.destroy = function() {
      this.toggleSelectDisplay(!1), o.prototype.destroy.call(this);
    }, em([
      N("localeService")
    ], t.prototype, "localeService", void 0), em([
      N("gridOptionsService")
    ], t.prototype, "gridOptionsService", void 0), em([
      N("paginationProxy")
    ], t.prototype, "paginationProxy", void 0), em([
      Fe
    ], t.prototype, "init", null), t;
  }(gt)
), TP = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, OP = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
};
function uJ(o, t, e) {
  if (!t)
    return Ji("No gridOptions provided to createGrid"), {};
  var r = w_.getCoercedGridOptions(t), n = new b_().create(o, r, function(a) {
    var s = new C_(o);
    a.createBean(s);
  }, void 0, e);
  if (!Object.isFrozen(t) && !(e != null && e.frameworkOverrides)) {
    var i = "https://ag-grid.com/javascript-data-grid/grid-interface/#grid-api";
    Object.defineProperty(t, "api", {
      get: function() {
        Ji("gridOptions.api is no longer supported. See ".concat(i, "."));
      },
      configurable: !0
    }), Object.defineProperty(t, "columnApi", {
      get: function() {
        Ji("gridOptions.columnApi is no longer supported and all methods moved to the grid api. See ".concat(i, "."));
      },
      configurable: !0
    });
  }
  return n;
}
var cJ = (
  /** @class */
  function() {
    function o(t, e, r) {
      var n = this;
      if (ht("Since v31 new Grid(...) is deprecated. Use createGrid instead: `const gridApi = createGrid(...)`. The grid api is returned from createGrid and will not be available on gridOptions."), !e) {
        Ji("No gridOptions provided to the grid");
        return;
      }
      this.gridOptions = e;
      var i = new b_().create(t, e, function(a) {
        var s = new C_(t), l = a.createBean(s);
        l.addDestroyFunc(function() {
          n.destroy();
        });
      }, void 0, r);
      this.gridOptions.api = i, this.gridOptions.columnApi = new dC(i);
    }
    return o.prototype.destroy = function() {
      var t;
      this.gridOptions && ((t = this.gridOptions.api) === null || t === void 0 || t.destroy(), delete this.gridOptions.api, delete this.gridOptions.columnApi);
    }, o;
  }()
), dJ = 1, b_ = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.create = function(t, e, r, n, i) {
      var a, s = !!e.debug, l = (a = e.gridId) !== null && a !== void 0 ? a : String(dJ++), u = this.getRegisteredModules(i, l), c = this.createBeansList(e.rowModelType, u, l), d = this.createProvidedBeans(t, e, i);
      if (!c) {
        Ji("Failed to create grid.");
        return;
      }
      var f = {
        providedBeanInstances: d,
        beanClasses: c,
        debug: s,
        gridId: l
      }, v = new pC("Context", function() {
        return f.debug;
      }), g = new t2(f, v), m = g.getBean("beans");
      return this.registerModuleUserComponents(m, u), this.registerStackComponents(m, u), this.registerControllers(m, u), r(g), m.syncService.start(), n && n(g), m.gridApi;
    }, o.prototype.registerControllers = function(t, e) {
      e.forEach(function(r) {
        r.controllers && r.controllers.forEach(function(n) {
          return t.ctrlsFactory.register(n);
        });
      });
    }, o.prototype.registerStackComponents = function(t, e) {
      var r = this.createAgStackComponentsList(e);
      t.agStackComponentsRegistry.setupComponents(r);
    }, o.prototype.getRegisteredModules = function(t, e) {
      var r = t ? t.modules : null, n = Xt.__getRegisteredModules(e), i = [], a = {}, s = function(l, u, c) {
        var d = function(f) {
          a[f.moduleName] || (a[f.moduleName] = !0, i.push(f), Xt.__register(f, l, c));
        };
        d(u), u.dependantModules && u.dependantModules.forEach(function(f) {
          return s(l, f, c);
        });
      };
      return r && r.forEach(function(l) {
        return s(!0, l, e);
      }), n && n.forEach(function(l) {
        return s(!Xt.__isPackageBased(), l, void 0);
      }), i;
    }, o.prototype.registerModuleUserComponents = function(t, e) {
      var r = this.extractModuleEntity(e, function(n) {
        return n.userComponents ? n.userComponents : [];
      });
      r.forEach(function(n) {
        t.userComponentRegistry.registerDefaultComponent(n.componentName, n.componentClass);
      });
    }, o.prototype.createProvidedBeans = function(t, e, r) {
      var n = r ? r.frameworkOverrides : null;
      tt(n) && (n = new PL());
      var i = {
        gridOptions: e,
        eGridDiv: t,
        globalEventListener: r ? r.globalEventListener : null,
        globalSyncEventListener: r ? r.globalSyncEventListener : null,
        frameworkOverrides: n
      };
      return r && r.providedBeanInstances && Object.assign(i, r.providedBeanInstances), i;
    }, o.prototype.createAgStackComponentsList = function(t) {
      var e = [
        { componentName: "AgCheckbox", componentClass: fv },
        { componentName: "AgRadioButton", componentClass: o_ },
        { componentName: "AgToggleButton", componentClass: mL },
        { componentName: "AgInputTextField", componentClass: zl },
        { componentName: "AgInputTextArea", componentClass: yL },
        { componentName: "AgInputNumberField", componentClass: oC },
        { componentName: "AgInputDateField", componentClass: CL },
        { componentName: "AgInputRange", componentClass: wL },
        { componentName: "AgRichSelect", componentClass: bL },
        { componentName: "AgSelect", componentClass: pv },
        { componentName: "AgSlider", componentClass: SL },
        { componentName: "AgGridBody", componentClass: HI },
        { componentName: "AgHeaderRoot", componentClass: nL },
        { componentName: "AgSortIndicator", componentClass: aC },
        { componentName: "AgPagination", componentClass: aQ },
        { componentName: "AgPageSizeSelector", componentClass: lJ },
        { componentName: "AgOverlayWrapper", componentClass: lQ },
        { componentName: "AgGroupComponent", componentClass: EL },
        { componentName: "AgPanel", componentClass: y_ },
        { componentName: "AgDialog", componentClass: RL },
        { componentName: "AgRowContainer", componentClass: zI },
        { componentName: "AgFakeHorizontalScroll", componentClass: PQ },
        { componentName: "AgFakeVerticalScroll", componentClass: UQ },
        { componentName: "AgAutocomplete", componentClass: OL }
      ], r = this.extractModuleEntity(t, function(n) {
        return n.agStackComponents ? n.agStackComponents : [];
      });
      return e = e.concat(r), e;
    }, o.prototype.createBeansList = function(t, e, r) {
      t === void 0 && (t = "clientSide");
      var n = e.filter(function(u) {
        return !u.rowModel || u.rowModel === t;
      }), i = {
        clientSide: Ye.ClientSideRowModelModule,
        infinite: Ye.InfiniteRowModelModule,
        serverSide: Ye.ServerSideRowModelModule,
        viewport: Ye.ViewportRowModelModule
      };
      if (!i[t]) {
        Ji("Could not find row model for rowModelType = " + t);
        return;
      }
      if (Xt.__assertRegistered(i[t], "rowModelType = '".concat(t, "'"), r)) {
        var a = [
          f_,
          jL,
          UL,
          $L,
          VZ,
          c_,
          OI,
          $Z,
          YZ,
          sL,
          DI,
          nQ,
          oL,
          qL,
          rJ,
          fL,
          MI,
          y2,
          Ts,
          w_,
          TL,
          ML,
          II,
          g2,
          tL,
          vL,
          dL,
          IL,
          f2,
          LL,
          AL,
          jI,
          HL,
          FL,
          NL,
          m2,
          cL,
          iL,
          fn,
          dC,
          VL,
          WI,
          BL,
          DL,
          pL,
          gL,
          BI,
          GL,
          LZ,
          kZ,
          WL,
          d$,
          jZ,
          lL,
          gQ,
          C2,
          CQ,
          wQ,
          hL,
          zL,
          YL,
          AQ,
          FQ,
          RQ,
          XL,
          ZL,
          FI,
          KQ,
          XQ,
          eJ,
          uL,
          oJ
        ], s = this.extractModuleEntity(n, function(u) {
          return u.beans ? u.beans : [];
        });
        a.push.apply(a, OP([], TP(s), !1));
        var l = [];
        return a.forEach(function(u) {
          l.indexOf(u) < 0 && l.push(u);
        }), l;
      }
    }, o.prototype.extractModuleEntity = function(t, e) {
      return [].concat.apply([], OP([], TP(t.map(e)), !1));
    }, o;
  }()
), pJ = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.wrap = function(t, e, r, n) {
      var i = this;
      r === void 0 && (r = []);
      var a = this.createWrapper(t, n);
      return e.forEach(function(s) {
        i.createMethod(a, s, !0);
      }), r.forEach(function(s) {
        i.createMethod(a, s, !1);
      }), a;
    }, o.prototype.unwrap = function(t) {
      return t;
    }, o.prototype.createMethod = function(t, e, r) {
      t.addMethod(e, this.createMethodProxy(t, e, r));
    }, o.prototype.createMethodProxy = function(t, e, r) {
      return function() {
        return t.hasMethod(e) ? t.callMethod(e, arguments) : (r && console.warn("AG Grid: Framework component is missing the method " + e + "()"), null);
      };
    }, o;
  }()
), fJ = {
  columnGroup: [
    "column",
    "stackedColumn",
    "normalizedColumn"
  ],
  barGroup: [
    "bar",
    "stackedBar",
    "normalizedBar"
  ],
  pieGroup: [
    "pie",
    "doughnut"
  ],
  lineGroup: [
    "line"
  ],
  scatterGroup: [
    "scatter",
    "bubble"
  ],
  areaGroup: [
    "area",
    "stackedArea",
    "normalizedArea"
  ],
  histogramGroup: [
    "histogram"
  ],
  combinationGroup: [
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
  ]
}, hJ = [
  "chartSettings",
  "chartData",
  "chartFormat"
], vJ = [
  "chartUnlink",
  "chartLink",
  "chartDownload"
], gJ = {
  settings: "chartSettings",
  data: "chartData",
  format: "chartFormat"
}, mJ = 0, YS;
(function(o) {
  o.InsideBase = "insideBase", o.InsideEnd = "insideEnd", o.Center = "center", o.OutsideEnd = "outsideEnd";
})(YS || (YS = {}));
/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v31.0.3
 * @link https://www.ag-grid.com/
 * @license MIT
 */
var gp = typeof global > "u" ? {} : global;
gp.HTMLElement = typeof HTMLElement > "u" ? {} : HTMLElement;
gp.HTMLButtonElement = typeof HTMLButtonElement > "u" ? {} : HTMLButtonElement;
gp.HTMLSelectElement = typeof HTMLSelectElement > "u" ? {} : HTMLSelectElement;
gp.HTMLInputElement = typeof HTMLInputElement > "u" ? {} : HTMLInputElement;
gp.Node = typeof Node > "u" ? {} : Node;
gp.MouseEvent = typeof MouseEvent > "u" ? {} : MouseEvent;
var Xf = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Zf = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, yJ = (
  /** @class */
  function() {
    function o(t, e, r, n, i, a) {
      this.nextId = 0, this.allNodesMap = {}, this.rootNode = t, this.gridOptionsService = e, this.eventService = r, this.columnModel = n, this.beans = a, this.selectionService = i, this.rootNode.group = !0, this.rootNode.level = -1, this.rootNode.id = o.ROOT_NODE_ID, this.rootNode.allLeafChildren = [], this.rootNode.childrenAfterGroup = [], this.rootNode.childrenAfterSort = [], this.rootNode.childrenAfterAggFilter = [], this.rootNode.childrenAfterFilter = [];
    }
    return o.prototype.getCopyOfNodesMap = function() {
      return yt.cloneObject(this.allNodesMap);
    }, o.prototype.getRowNode = function(t) {
      return this.allNodesMap[t];
    }, o.prototype.setRowData = function(t) {
      var e = this;
      if (typeof t == "string") {
        console.warn("AG Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first");
        return;
      }
      this.dispatchRowDataUpdateStartedEvent(t);
      var r = this.rootNode, n = this.rootNode.sibling;
      r.childrenAfterFilter = null, r.childrenAfterGroup = null, r.childrenAfterAggFilter = null, r.childrenAfterSort = null, r.childrenMapped = null, r.updateHasChildren(), this.nextId = 0, this.allNodesMap = {}, t ? r.allLeafChildren = t.map(function(i) {
        return e.createNode(i, e.rootNode, o.TOP_LEVEL);
      }) : (r.allLeafChildren = [], r.childrenAfterGroup = []), n && (n.childrenAfterFilter = r.childrenAfterFilter, n.childrenAfterGroup = r.childrenAfterGroup, n.childrenAfterAggFilter = r.childrenAfterAggFilter, n.childrenAfterSort = r.childrenAfterSort, n.childrenMapped = r.childrenMapped, n.allLeafChildren = r.allLeafChildren);
    }, o.prototype.updateRowData = function(t, e) {
      this.dispatchRowDataUpdateStartedEvent(t.add);
      var r = {
        remove: [],
        update: [],
        add: []
      }, n = [];
      return this.executeRemove(t, r, n), this.executeUpdate(t, r, n), this.executeAdd(t, r), this.updateSelection(n, "rowDataChanged"), e && yt.sortRowNodesByOrder(this.rootNode.allLeafChildren, e), r;
    }, o.prototype.dispatchRowDataUpdateStartedEvent = function(t) {
      var e = {
        type: G.EVENT_ROW_DATA_UPDATE_STARTED,
        firstRowData: t != null && t.length ? t[0] : null
      };
      this.eventService.dispatchEvent(e);
    }, o.prototype.updateSelection = function(t, e) {
      var r = t.length > 0;
      if (r && this.selectionService.setNodesSelected({
        newValue: !1,
        nodes: t,
        suppressFinishActions: !0,
        source: e
      }), this.selectionService.updateGroupsFromChildrenSelections(e), r) {
        var n = {
          type: G.EVENT_SELECTION_CHANGED,
          source: e
        };
        this.eventService.dispatchEvent(n);
      }
    }, o.prototype.executeAdd = function(t, e) {
      var r = this, n, i = t.add, a = t.addIndex;
      if (!yt.missingOrEmpty(i)) {
        var s = i.map(function(m) {
          return r.createNode(m, r.rootNode, o.TOP_LEVEL);
        });
        if (typeof a == "number" && a >= 0) {
          var l = this.rootNode.allLeafChildren, u = l.length, c = a, d = this.gridOptionsService.get("treeData");
          if (d && a > 0 && u > 0) {
            for (var f = 0; f < u; f++)
              if (((n = l[f]) === null || n === void 0 ? void 0 : n.rowIndex) == a - 1) {
                c = f + 1;
                break;
              }
          }
          var v = l.slice(0, c), g = l.slice(c, l.length);
          this.rootNode.allLeafChildren = Zf(Zf(Zf([], Xf(v), !1), Xf(s), !1), Xf(g), !1);
        } else
          this.rootNode.allLeafChildren = Zf(Zf([], Xf(this.rootNode.allLeafChildren), !1), Xf(s), !1);
        this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren), e.add = s;
      }
    }, o.prototype.executeRemove = function(t, e, r) {
      var n = this, i = t.remove;
      if (!yt.missingOrEmpty(i)) {
        var a = {};
        i.forEach(function(s) {
          var l = n.lookupRowNode(s);
          l && (l.isSelected() && r.push(l), l.clearRowTopAndRowIndex(), a[l.id] = !0, delete n.allNodesMap[l.id], e.remove.push(l));
        }), this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function(s) {
          return !a[s.id];
        }), this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren);
      }
    }, o.prototype.executeUpdate = function(t, e, r) {
      var n = this, i = t.update;
      yt.missingOrEmpty(i) || i.forEach(function(a) {
        var s = n.lookupRowNode(a);
        s && (s.updateData(a), !s.selectable && s.isSelected() && r.push(s), n.setMasterForRow(s, a, o.TOP_LEVEL, !1), e.update.push(s));
      });
    }, o.prototype.lookupRowNode = function(t) {
      var e = this.gridOptionsService.getCallback("getRowId"), r;
      if (e) {
        var n = e({ data: t, level: 0 });
        if (r = this.allNodesMap[n], !r)
          return console.error("AG Grid: could not find row id=".concat(n, ", data item was not found for this id")), null;
      } else if (r = this.rootNode.allLeafChildren.find(function(i) {
        return i.data === t;
      }), !r)
        return console.error("AG Grid: could not find data item as object was not found", t), console.error("Consider using getRowId to help the Grid find matching row data"), null;
      return r || null;
    }, o.prototype.createNode = function(t, e, r) {
      var n = new St(this.beans);
      n.group = !1, this.setMasterForRow(n, t, r, !0);
      var i = this.gridOptionsService.get("suppressParentsInRowNodes");
      return e && !i && (n.parent = e), n.level = r, n.setDataAndId(t, this.nextId.toString()), this.allNodesMap[n.id] && console.warn("AG Grid: duplicate node id '".concat(n.id, "' detected from getRowId callback, this could cause issues in your grid.")), this.allNodesMap[n.id] = n, this.nextId++, n;
    }, o.prototype.setMasterForRow = function(t, e, r, n) {
      var i = this.gridOptionsService.get("treeData");
      if (i)
        t.setMaster(!1), n && (t.expanded = !1);
      else {
        var a = this.gridOptionsService.get("masterDetail");
        if (a) {
          var s = this.gridOptionsService.get("isRowMaster");
          s ? t.setMaster(s(e)) : t.setMaster(!0);
        } else
          t.setMaster(!1);
        if (n) {
          var l = this.columnModel.getRowGroupColumns(), u = l ? l.length : 0, c = r + u;
          t.expanded = t.master ? this.isExpanded(c) : !1;
        }
      }
    }, o.prototype.isExpanded = function(t) {
      var e = this.gridOptionsService.get("groupDefaultExpanded");
      return e === -1 ? !0 : t < e;
    }, o.TOP_LEVEL = 0, o.ROOT_NODE_ID = "ROOT_NODE_ID", o;
  }()
), CJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Oo = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, Po = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, Do = function(o, t, e) {
  if (e || arguments.length === 2) for (var r = 0, n = t.length, i; r < n; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return o.concat(i || Array.prototype.slice.call(t));
}, Pa;
(function(o) {
  o[o.Normal = 0] = "Normal", o[o.AfterFilter = 1] = "AfterFilter", o[o.AfterFilterAndSort = 2] = "AfterFilterAndSort", o[o.PivotNodes = 3] = "PivotNodes";
})(Pa || (Pa = {}));
var wJ = (
  /** @class */
  function(o) {
    CJ(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.onRowHeightChanged_debounced = yt.debounce(e.onRowHeightChanged.bind(e), 100), e.rowsToDisplay = [], e.hasStarted = !1, e.shouldSkipSettingDataOnStart = !1, e.isRefreshingModel = !1, e.rowCountReady = !1, e;
    }
    return t.prototype.init = function() {
      var e = this, r = this.refreshModel.bind(this, { step: Pt.EVERYTHING }), n = !this.gridOptionsService.get("suppressAnimationFrame"), i = this.refreshModel.bind(this, {
        step: Pt.EVERYTHING,
        afterColumnsChanged: !0,
        keepRenderedRows: !0,
        animate: n
      });
      this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, i), this.addManagedListener(this.eventService, G.EVENT_COLUMN_ROW_GROUP_CHANGED, r), this.addManagedListener(this.eventService, G.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: Pt.PIVOT })), this.addManagedListener(this.eventService, G.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_COLUMN_PIVOT_MODE_CHANGED, r), this.addManagedListener(this.eventService, G.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanges.bind(this)), this.addManagedListener(this.eventService, G.EVENT_GRID_READY, function() {
        return e.onGridReady();
      }), this.addPropertyListeners(), this.rootNode = new St(this.beans), this.nodeManager = new yJ(this.rootNode, this.gridOptionsService, this.eventService, this.columnModel, this.selectionService, this.beans);
    }, t.prototype.addPropertyListeners = function() {
      var e = this, r = /* @__PURE__ */ new Set([
        "treeData",
        "masterDetail"
      ]), n = /* @__PURE__ */ new Set([
        "suppressParentsInRowNodes",
        "groupDefaultExpanded",
        "groupAllowUnbalanced",
        "initialGroupOrderComparator",
        "groupHideOpenParents",
        "groupDisplayType"
      ]), i = /* @__PURE__ */ new Set([
        "excludeChildrenWhenTreeDataFiltering"
      ]), a = /* @__PURE__ */ new Set([
        "removePivotHeaderRowWhenSingleValueColumn",
        "pivotRowTotals",
        "pivotColumnGroupTotals",
        "suppressExpandablePivotGroups"
      ]), s = /* @__PURE__ */ new Set([
        "getGroupRowAgg",
        "alwaysAggregateAtRootLevel",
        "groupIncludeTotalFooter",
        "suppressAggFilteredOnly"
      ]), l = /* @__PURE__ */ new Set([
        "postSortRows",
        "groupDisplayType",
        "accentedSort"
      ]), u = /* @__PURE__ */ new Set([]), c = /* @__PURE__ */ new Set([
        "groupRemoveSingleChildren",
        "groupRemoveLowestSingleChildren",
        "groupIncludeFooter"
      ]), d = Do(Do(Do(Do(Do(Do(Do(Do(Do([], Po(r), !1), Po(n), !1), Po(i), !1), Po(a), !1), Po(a), !1), Po(s), !1), Po(l), !1), Po(u), !1), Po(c), !1);
      this.addManagedPropertyListeners(d, function(f) {
        var v, g = (v = f.changeSet) === null || v === void 0 ? void 0 : v.properties;
        if (g) {
          var m = function(b) {
            return g.some(function(S) {
              return b.has(S);
            });
          };
          if (m(r)) {
            e.setRowData(e.rootNode.allLeafChildren.map(function(b) {
              return b.data;
            }));
            return;
          }
          if (m(n)) {
            e.refreshModel({ step: Pt.EVERYTHING });
            return;
          }
          if (m(i)) {
            e.refreshModel({ step: Pt.FILTER });
            return;
          }
          if (m(a)) {
            e.refreshModel({ step: Pt.PIVOT });
            return;
          }
          if (m(s)) {
            e.refreshModel({ step: Pt.AGGREGATE });
            return;
          }
          if (m(l)) {
            e.refreshModel({ step: Pt.SORT });
            return;
          }
          if (m(u)) {
            e.refreshModel({ step: Pt.FILTER_AGGREGATES });
            return;
          }
          m(c) && e.refreshModel({ step: Pt.MAP });
        }
      }), this.addManagedPropertyListener("rowHeight", function() {
        return e.resetRowHeights();
      });
    }, t.prototype.start = function() {
      this.hasStarted = !0, this.shouldSkipSettingDataOnStart ? this.dispatchUpdateEventsAndRefresh() : this.setInitialData();
    }, t.prototype.setInitialData = function() {
      var e = this.gridOptionsService.get("rowData");
      e && (this.shouldSkipSettingDataOnStart = !0, this.setRowData(e));
    }, t.prototype.ensureRowHeightsValid = function(e, r, n, i) {
      var a, s = !1;
      do {
        a = !1;
        for (var l = this.getRowIndexAtPixel(e), u = this.getRowIndexAtPixel(r), c = Math.max(l, n), d = Math.min(u, i), f = c; f <= d; f++) {
          var v = this.getRow(f);
          if (v.rowHeightEstimated) {
            var g = this.gridOptionsService.getRowHeightForNode(v);
            v.setRowHeight(g.height), a = !0, s = !0;
          }
        }
        a && this.setRowTopAndRowIndex();
      } while (a);
      return s;
    }, t.prototype.setRowTopAndRowIndex = function() {
      for (var e = this.environment.getDefaultRowHeight(), r = 0, n = /* @__PURE__ */ new Set(), i = this.gridOptionsService.isDomLayout("normal"), a = 0; a < this.rowsToDisplay.length; a++) {
        var s = this.rowsToDisplay[a];
        if (s.id != null && n.add(s.id), s.rowHeight == null) {
          var l = this.gridOptionsService.getRowHeightForNode(s, i, e);
          s.setRowHeight(l.height, l.estimated);
        }
        s.setRowTop(r), s.setRowIndex(a), r += s.rowHeight;
      }
      return n;
    }, t.prototype.clearRowTopAndRowIndex = function(e, r) {
      var n = e.isActive(), i = function(s) {
        s && s.id != null && !r.has(s.id) && s.clearRowTopAndRowIndex();
      }, a = function(s) {
        if (i(s), i(s.detailNode), i(s.sibling), s.hasChildren() && s.childrenAfterGroup) {
          var l = s.level == -1, u = n && !l && !s.expanded;
          u || s.childrenAfterGroup.forEach(a);
        }
      };
      a(this.rootNode);
    }, t.prototype.ensureRowsAtPixel = function(e, r, n) {
      var i = this;
      n === void 0 && (n = 0);
      var a = this.getRowIndexAtPixel(r), s = this.getRow(a), l = !this.gridOptionsService.get("suppressAnimationFrame");
      return s === e[0] ? !1 : (e.forEach(function(u) {
        yt.removeFromArray(i.rootNode.allLeafChildren, u);
      }), e.forEach(function(u, c) {
        yt.insertIntoArray(i.rootNode.allLeafChildren, u, Math.max(a + n, 0) + c);
      }), this.refreshModel({
        step: Pt.EVERYTHING,
        keepRenderedRows: !0,
        keepEditingRows: !0,
        animate: l
      }), !0);
    }, t.prototype.highlightRowAtPixel = function(e, r) {
      var n = r != null ? this.getRowIndexAtPixel(r) : null, i = n != null ? this.getRow(n) : null;
      if (!i || !e || i === e || r == null) {
        this.lastHighlightedRow && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null);
        return;
      }
      var a = this.getHighlightPosition(r, i);
      this.lastHighlightedRow && this.lastHighlightedRow !== i && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null), i.setHighlighted(a), this.lastHighlightedRow = i;
    }, t.prototype.getHighlightPosition = function(e, r) {
      if (!r) {
        var n = this.getRowIndexAtPixel(e);
        if (r = this.getRow(n || 0), !r)
          return Na.Below;
      }
      var i = r.rowTop, a = r.rowHeight;
      return e - i < a / 2 ? Na.Above : Na.Below;
    }, t.prototype.getLastHighlightedRowNode = function() {
      return this.lastHighlightedRow;
    }, t.prototype.isLastRowIndexKnown = function() {
      return !0;
    }, t.prototype.getRowCount = function() {
      return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
    }, t.prototype.getTopLevelRowCount = function() {
      var e = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
      if (e)
        return 1;
      var r = this.rootNode.childrenAfterAggFilter;
      return r ? r.length : 0;
    }, t.prototype.getTopLevelRowDisplayedIndex = function(e) {
      var r = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
      if (r)
        return e;
      var n = this.rootNode.childrenAfterSort[e];
      if (this.gridOptionsService.get("groupHideOpenParents"))
        for (; n.expanded && n.childrenAfterSort && n.childrenAfterSort.length > 0; )
          n = n.childrenAfterSort[0];
      return n.rowIndex;
    }, t.prototype.getRowBounds = function(e) {
      if (yt.missing(this.rowsToDisplay))
        return null;
      var r = this.rowsToDisplay[e];
      return r ? {
        rowTop: r.rowTop,
        rowHeight: r.rowHeight
      } : null;
    }, t.prototype.onRowGroupOpened = function() {
      var e = this.gridOptionsService.isAnimateRows();
      this.refreshModel({ step: Pt.MAP, keepRenderedRows: !0, animate: e });
    }, t.prototype.onFilterChanged = function(e) {
      if (!e.afterDataChange) {
        var r = this.gridOptionsService.isAnimateRows(), n = e.columns.length === 0 || e.columns.some(function(a) {
          return a.isPrimary();
        }), i = n ? Pt.FILTER : Pt.FILTER_AGGREGATES;
        this.refreshModel({ step: i, keepRenderedRows: !0, animate: r });
      }
    }, t.prototype.onSortChanged = function() {
      var e = this.gridOptionsService.isAnimateRows();
      this.refreshModel({ step: Pt.SORT, keepRenderedRows: !0, animate: e, keepEditingRows: !0 });
    }, t.prototype.getType = function() {
      return "clientSide";
    }, t.prototype.onValueChanged = function() {
      this.columnModel.isPivotActive() ? this.refreshModel({ step: Pt.PIVOT }) : this.refreshModel({ step: Pt.AGGREGATE });
    }, t.prototype.createChangePath = function(e) {
      var r = yt.missingOrEmpty(e), n = new gv(!1, this.rootNode);
      return (r || this.gridOptionsService.get("treeData")) && n.setInactive(), n;
    }, t.prototype.isSuppressModelUpdateAfterUpdateTransaction = function(e) {
      if (!this.gridOptionsService.get("suppressModelUpdateAfterUpdateTransaction") || e.rowNodeTransactions == null)
        return !1;
      var r = e.rowNodeTransactions.filter(function(i) {
        return i.add != null && i.add.length > 0 || i.remove != null && i.remove.length > 0;
      }), n = r == null || r.length == 0;
      return n;
    }, t.prototype.buildRefreshModelParams = function(e) {
      var r = Pt.EVERYTHING, n = {
        everything: Pt.EVERYTHING,
        group: Pt.EVERYTHING,
        filter: Pt.FILTER,
        map: Pt.MAP,
        aggregate: Pt.AGGREGATE,
        sort: Pt.SORT,
        pivot: Pt.PIVOT
      };
      if (yt.exists(e) && (r = n[e]), yt.missing(r)) {
        console.error("AG Grid: invalid step ".concat(e, ", available steps are ").concat(Object.keys(n).join(", ")));
        return;
      }
      var i = !this.gridOptionsService.get("suppressAnimationFrame"), a = {
        step: r,
        keepRenderedRows: !0,
        keepEditingRows: !0,
        animate: i
      };
      return a;
    }, t.prototype.refreshModel = function(e) {
      if (!(!this.hasStarted || this.isRefreshingModel)) {
        var r = typeof e == "object" && "step" in e ? e : this.buildRefreshModelParams(e);
        if (r && !this.isSuppressModelUpdateAfterUpdateTransaction(r)) {
          var n = this.createChangePath(r.rowNodeTransactions);
          switch (this.isRefreshingModel = !0, r.step) {
            case Pt.EVERYTHING:
              this.doRowGrouping(r.rowNodeTransactions, r.rowNodeOrder, n, !!r.afterColumnsChanged);
            case Pt.FILTER:
              this.doFilter(n);
            case Pt.PIVOT:
              this.doPivot(n);
            case Pt.AGGREGATE:
              this.doAggregate(n);
            case Pt.FILTER_AGGREGATES:
              this.doFilterAggregates(n);
            case Pt.SORT:
              this.doSort(r.rowNodeTransactions, n);
            case Pt.MAP:
              this.doRowsToDisplay();
          }
          var i = this.setRowTopAndRowIndex();
          this.clearRowTopAndRowIndex(n, i), this.isRefreshingModel = !1;
          var a = {
            type: G.EVENT_MODEL_UPDATED,
            animate: r.animate,
            keepRenderedRows: r.keepRenderedRows,
            newData: r.newData,
            newPage: !1,
            keepUndoRedoStack: r.keepUndoRedoStack
          };
          this.eventService.dispatchEvent(a);
        }
      }
    }, t.prototype.isEmpty = function() {
      var e = yt.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
      return yt.missing(this.rootNode) || e || !this.columnModel.isReady();
    }, t.prototype.isRowsToRender = function() {
      return yt.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    }, t.prototype.getNodesInRangeForSelection = function(e, r) {
      var n = !r, i = !1, a = [], s = this.gridOptionsService.get("groupSelectsChildren");
      return this.forEachNodeAfterFilterAndSort(function(l) {
        if (!i) {
          if (n && (l === r || l === e) && (i = !0, l.group && s)) {
            a.push.apply(a, Do([], Po(l.allLeafChildren), !1));
            return;
          }
          if (!n) {
            if (l !== r && l !== e)
              return;
            n = !0;
          }
          var u = !l.group || !s;
          if (u) {
            a.push(l);
            return;
          }
        }
      }), a;
    }, t.prototype.setDatasource = function(e) {
      console.error("AG Grid: should never call setDatasource on clientSideRowController");
    }, t.prototype.getTopLevelNodes = function() {
      return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    }, t.prototype.getRootNode = function() {
      return this.rootNode;
    }, t.prototype.getRow = function(e) {
      return this.rowsToDisplay[e];
    }, t.prototype.isRowPresent = function(e) {
      return this.rowsToDisplay.indexOf(e) >= 0;
    }, t.prototype.getRowIndexAtPixel = function(e) {
      if (this.isEmpty() || this.rowsToDisplay.length === 0)
        return -1;
      var r = 0, n = this.rowsToDisplay.length - 1;
      if (e <= 0)
        return 0;
      var i = yt.last(this.rowsToDisplay);
      if (i.rowTop <= e)
        return this.rowsToDisplay.length - 1;
      for (var a = -1, s = -1; ; ) {
        var l = Math.floor((r + n) / 2), u = this.rowsToDisplay[l];
        if (this.isRowInPixel(u, e))
          return l;
        u.rowTop < e ? r = l + 1 : u.rowTop > e && (n = l - 1);
        var c = a === r && s === n;
        if (c)
          return l;
        a = r, s = n;
      }
    }, t.prototype.isRowInPixel = function(e, r) {
      var n = e.rowTop, i = e.rowTop + e.rowHeight, a = n <= r && i > r;
      return a;
    }, t.prototype.forEachLeafNode = function(e) {
      this.rootNode.allLeafChildren && this.rootNode.allLeafChildren.forEach(function(r, n) {
        return e(r, n);
      });
    }, t.prototype.forEachNode = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Do([], Po(this.rootNode.childrenAfterGroup || []), !1),
        callback: e,
        recursionType: Pa.Normal,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachNodeAfterFilter = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Do([], Po(this.rootNode.childrenAfterAggFilter || []), !1),
        callback: e,
        recursionType: Pa.AfterFilter,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachNodeAfterFilterAndSort = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: Do([], Po(this.rootNode.childrenAfterSort || []), !1),
        callback: e,
        recursionType: Pa.AfterFilterAndSort,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.forEachPivotNode = function(e, r) {
      r === void 0 && (r = !1), this.recursivelyWalkNodesAndCallback({
        nodes: [this.rootNode],
        callback: e,
        recursionType: Pa.PivotNodes,
        index: 0,
        includeFooterNodes: r
      });
    }, t.prototype.recursivelyWalkNodesAndCallback = function(e) {
      for (var r, n = e.nodes, i = e.callback, a = e.recursionType, s = e.includeFooterNodes, l = e.index, u = 0; u < n.length; u++) {
        var c = n[u];
        if (i(c, l++), c.hasChildren() && !c.footer) {
          var d = null;
          switch (a) {
            case Pa.Normal:
              d = c.childrenAfterGroup;
              break;
            case Pa.AfterFilter:
              d = c.childrenAfterAggFilter;
              break;
            case Pa.AfterFilterAndSort:
              d = c.childrenAfterSort;
              break;
            case Pa.PivotNodes:
              d = c.leafGroup ? null : c.childrenAfterSort;
              break;
          }
          d && (l = this.recursivelyWalkNodesAndCallback({
            nodes: Do([], Po(d), !1),
            callback: i,
            recursionType: a,
            index: l,
            includeFooterNodes: s
          }));
        }
      }
      var f = (r = n[0]) === null || r === void 0 ? void 0 : r.parent;
      if (!s || !f)
        return l;
      var v = f === this.rootNode;
      if (v) {
        var g = this.gridOptionsService.get("groupIncludeTotalFooter");
        if (!g)
          return l;
      } else {
        var m = this.gridOptionsService.getGroupIncludeFooter();
        if (!m({ node: f }))
          return l;
      }
      return f.createFooter(), i(f.sibling, l++), l;
    }, t.prototype.doAggregate = function(e) {
      this.aggregationStage && this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.doFilterAggregates = function(e) {
      this.filterAggregatesStage ? this.filterAggregatesStage.execute({ rowNode: this.rootNode, changedPath: e }) : this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
    }, t.prototype.expandOrCollapseAll = function(e) {
      var r = this.gridOptionsService.get("treeData"), n = this.columnModel.isPivotActive(), i = function(l) {
        l && l.forEach(function(u) {
          var c = function() {
            u.expanded = e, i(u.childrenAfterGroup);
          };
          if (r) {
            var d = yt.exists(u.childrenAfterGroup);
            d && c();
            return;
          }
          if (n) {
            var f = !u.leafGroup;
            f && c();
            return;
          }
          var v = u.group;
          v && c();
        });
      };
      this.rootNode && i(this.rootNode.childrenAfterGroup), this.refreshModel({ step: Pt.MAP });
      var a = e ? "expandAll" : "collapseAll", s = {
        type: G.EVENT_EXPAND_COLLAPSE_ALL,
        source: a
      };
      this.eventService.dispatchEvent(s);
    }, t.prototype.doSort = function(e, r) {
      this.sortStage.execute({
        rowNode: this.rootNode,
        rowNodeTransactions: e,
        changedPath: r
      });
    }, t.prototype.doRowGrouping = function(e, r, n, i) {
      if (this.groupStage) {
        if (e ? this.groupStage.execute({
          rowNode: this.rootNode,
          rowNodeTransactions: e,
          rowNodeOrder: r,
          changedPath: n
        }) : this.groupStage.execute({
          rowNode: this.rootNode,
          changedPath: n,
          afterColumnsChanged: i
        }), this.gridOptionsService.get("groupSelectsChildren")) {
          var a = this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", n);
          if (a) {
            var s = {
              type: G.EVENT_SELECTION_CHANGED,
              source: "rowGroupChanged"
            };
            this.eventService.dispatchEvent(s);
          }
        }
      } else
        this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren, this.rootNode.sibling && (this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup), this.rootNode.updateHasChildren();
      this.rowCountReady = !0, this.eventService.dispatchEventOnce({
        type: G.EVENT_ROW_COUNT_READY
      });
    }, t.prototype.doFilter = function(e) {
      this.filterStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.doPivot = function(e) {
      this.pivotStage && this.pivotStage.execute({ rowNode: this.rootNode, changedPath: e });
    }, t.prototype.getCopyOfNodesMap = function() {
      return this.nodeManager.getCopyOfNodesMap();
    }, t.prototype.getRowNode = function(e) {
      var r = typeof e == "string" && e.indexOf(St.ID_PREFIX_ROW_GROUP) == 0;
      if (r) {
        var n = void 0;
        return this.forEachNode(function(i) {
          i.id === e && (n = i);
        }), n;
      }
      return this.nodeManager.getRowNode(e);
    }, t.prototype.setRowData = function(e) {
      this.selectionService.reset("rowDataChanged"), this.nodeManager.setRowData(e), this.hasStarted && this.dispatchUpdateEventsAndRefresh();
    }, t.prototype.dispatchUpdateEventsAndRefresh = function() {
      var e = {
        type: G.EVENT_ROW_DATA_UPDATED
      };
      this.eventService.dispatchEvent(e), this.refreshModel({
        step: Pt.EVERYTHING,
        newData: !0
      });
    }, t.prototype.batchUpdateRowData = function(e, r) {
      var n = this;
      if (this.applyAsyncTransactionsTimeout == null) {
        this.rowDataTransactionBatch = [];
        var i = this.gridOptionsService.getAsyncTransactionWaitMillis();
        this.applyAsyncTransactionsTimeout = window.setTimeout(function() {
          n.executeBatchUpdateRowData();
        }, i);
      }
      this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: r });
    }, t.prototype.flushAsyncTransactions = function() {
      this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
    }, t.prototype.executeBatchUpdateRowData = function() {
      var e = this;
      this.valueCache.onDataChanged();
      var r = [], n = [], i = !1;
      if (this.rowDataTransactionBatch && this.rowDataTransactionBatch.forEach(function(s) {
        var l = e.nodeManager.updateRowData(s.rowDataTransaction, void 0);
        n.push(l), s.callback && r.push(s.callback.bind(null, l)), typeof s.rowDataTransaction.addIndex == "number" && (i = !0);
      }), this.commonUpdateRowData(n, void 0, i), r.length > 0 && window.setTimeout(function() {
        r.forEach(function(s) {
          return s();
        });
      }, 0), n.length > 0) {
        var a = {
          type: G.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
          results: n
        };
        this.eventService.dispatchEvent(a);
      }
      this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
    }, t.prototype.updateRowData = function(e, r) {
      this.valueCache.onDataChanged();
      var n = this.nodeManager.updateRowData(e, r), i = typeof e.addIndex == "number";
      return this.commonUpdateRowData([n], r, i), n;
    }, t.prototype.createRowNodeOrder = function() {
      var e = this.gridOptionsService.get("suppressMaintainUnsortedOrder");
      if (!e) {
        var r = {};
        if (this.rootNode && this.rootNode.allLeafChildren)
          for (var n = 0; n < this.rootNode.allLeafChildren.length; n++) {
            var i = this.rootNode.allLeafChildren[n];
            r[i.id] = n;
          }
        return r;
      }
    }, t.prototype.commonUpdateRowData = function(e, r, n) {
      if (this.hasStarted) {
        var i = !this.gridOptionsService.get("suppressAnimationFrame");
        n && (r = this.createRowNodeOrder());
        var a = {
          type: G.EVENT_ROW_DATA_UPDATED
        };
        this.eventService.dispatchEvent(a), this.refreshModel({
          step: Pt.EVERYTHING,
          rowNodeTransactions: e,
          rowNodeOrder: r,
          keepRenderedRows: !0,
          keepEditingRows: !0,
          animate: i
        });
      }
    }, t.prototype.doRowsToDisplay = function() {
      this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
    }, t.prototype.onRowHeightChanged = function() {
      this.refreshModel({ step: Pt.MAP, keepRenderedRows: !0, keepEditingRows: !0, keepUndoRedoStack: !0 });
    }, t.prototype.onRowHeightChangedDebounced = function() {
      this.onRowHeightChanged_debounced();
    }, t.prototype.resetRowHeights = function() {
      var e = this.resetRowHeightsForAllRowNodes();
      this.rootNode.setRowHeight(this.rootNode.rowHeight, !0), this.rootNode.sibling && this.rootNode.sibling.setRowHeight(this.rootNode.sibling.rowHeight, !0), e && this.onRowHeightChanged();
    }, t.prototype.resetRowHeightsForAllRowNodes = function() {
      var e = !1;
      return this.forEachNode(function(r) {
        r.setRowHeight(r.rowHeight, !0);
        var n = r.detailNode;
        n && n.setRowHeight(n.rowHeight, !0), r.sibling && r.sibling.setRowHeight(r.sibling.rowHeight, !0), e = !0;
      }), e;
    }, t.prototype.onGridStylesChanges = function() {
      this.columnModel.isAutoRowHeightActive() || this.resetRowHeights();
    }, t.prototype.onGridReady = function() {
      this.hasStarted || this.setInitialData();
    }, t.prototype.isRowDataLoaded = function() {
      return this.rowCountReady;
    }, Oo([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Oo([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), Oo([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), Oo([
      N("valueCache")
    ], t.prototype, "valueCache", void 0), Oo([
      N("beans")
    ], t.prototype, "beans", void 0), Oo([
      N("filterStage")
    ], t.prototype, "filterStage", void 0), Oo([
      N("sortStage")
    ], t.prototype, "sortStage", void 0), Oo([
      N("flattenStage")
    ], t.prototype, "flattenStage", void 0), Oo([
      Lt("groupStage")
    ], t.prototype, "groupStage", void 0), Oo([
      Lt("aggregationStage")
    ], t.prototype, "aggregationStage", void 0), Oo([
      Lt("pivotStage")
    ], t.prototype, "pivotStage", void 0), Oo([
      Lt("filterAggregatesStage")
    ], t.prototype, "filterAggregatesStage", void 0), Oo([
      Fe
    ], t.prototype, "init", null), t = Oo([
      Be("rowModel")
    ], t), t;
  }(Me)
), bJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), PP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, SJ = (
  /** @class */
  function(o) {
    bJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = e.changedPath;
      this.filterService.filter(r);
    }, PP([
      N("filterService")
    ], t.prototype, "filterService", void 0), t = PP([
      Be("filterStage")
    ], t), t;
  }(Me)
), EJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), wb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, _J = (
  /** @class */
  function(o) {
    EJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = this, n = this.sortController.getSortOptions(), i = yt.exists(n) && n.length > 0, a = i && yt.exists(e.rowNodeTransactions) && this.gridOptionsService.get("deltaSort"), s = n.some(function(l) {
        var u = r.gridOptionsService.isColumnsSortingCoupledToGroup();
        return u ? l.column.isPrimary() && l.column.isRowGroupActive() : !!l.column.getColDef().showRowGroup;
      });
      this.sortService.sort(n, i, a, e.rowNodeTransactions, e.changedPath, s);
    }, wb([
      N("sortService")
    ], t.prototype, "sortService", void 0), wb([
      N("sortController")
    ], t.prototype, "sortController", void 0), t = wb([
      Be("sortStage")
    ], t), t;
  }(Me)
), xJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), bb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, RJ = (
  /** @class */
  function(o) {
    xJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.execute = function(e) {
      var r = e.rowNode, n = [], i = this.columnModel.isPivotMode(), a = i && r.leafGroup, s = a ? [r] : r.childrenAfterSort, l = this.getFlattenDetails();
      this.recursivelyAddToRowsToDisplay(l, s, n, i, 0);
      var u = n.length > 0, c = !a && u && l.groupIncludeTotalFooter;
      return c && (r.createFooter(), this.addRowNodeToRowsToDisplay(l, r.sibling, n, 0)), n;
    }, t.prototype.getFlattenDetails = function() {
      var e = this.gridOptionsService.get("groupRemoveSingleChildren"), r = !e && this.gridOptionsService.get("groupRemoveLowestSingleChildren");
      return {
        groupRemoveLowestSingleChildren: r,
        groupRemoveSingleChildren: e,
        isGroupMultiAutoColumn: this.gridOptionsService.isGroupMultiAutoColumn(),
        hideOpenParents: this.gridOptionsService.get("groupHideOpenParents"),
        groupIncludeTotalFooter: this.gridOptionsService.get("groupIncludeTotalFooter"),
        getGroupIncludeFooter: this.gridOptionsService.getGroupIncludeFooter()
      };
    }, t.prototype.recursivelyAddToRowsToDisplay = function(e, r, n, i, a) {
      if (!yt.missingOrEmpty(r))
        for (var s = 0; s < r.length; s++) {
          var l = r[s], u = l.hasChildren(), c = i && !u, d = e.groupRemoveSingleChildren && u && l.childrenAfterGroup.length === 1, f = e.groupRemoveLowestSingleChildren && u && l.leafGroup && l.childrenAfterGroup.length === 1, v = i && l.leafGroup, g = e.hideOpenParents && l.expanded && !l.master && !v, m = !c && !g && !d && !f;
          if (m && this.addRowNodeToRowsToDisplay(e, l, n, a), !(i && l.leafGroup)) {
            if (u) {
              var b = d || f;
              if (l.expanded || b) {
                var S = b ? a : a + 1;
                this.recursivelyAddToRowsToDisplay(e, l.childrenAfterSort, n, i, S);
                var R = e.getGroupIncludeFooter({ node: l });
                R ? (l.createFooter(), this.addRowNodeToRowsToDisplay(e, l.sibling, n, S)) : l.destroyFooter();
              }
            } else if (l.master && l.expanded) {
              var P = this.createDetailNode(l);
              this.addRowNodeToRowsToDisplay(e, P, n, a);
            }
          }
        }
    }, t.prototype.addRowNodeToRowsToDisplay = function(e, r, n, i) {
      n.push(r), r.setUiLevel(e.isGroupMultiAutoColumn ? 0 : i);
    }, t.prototype.createDetailNode = function(e) {
      if (yt.exists(e.detailNode))
        return e.detailNode;
      var r = new St(this.beans);
      return r.detail = !0, r.selectable = !1, r.parent = e, yt.exists(e.id) && (r.id = "detail_" + e.id), r.data = e.data, r.level = e.level + 1, e.detailNode = r, r;
    }, bb([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), bb([
      N("beans")
    ], t.prototype, "beans", void 0), t = bb([
      Be("flattenStage")
    ], t), t;
  }(Me)
), TJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Sb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, OJ = (
  /** @class */
  function(o) {
    TJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.sort = function(e, r, n, i, a, s) {
      var l = this, u = this.gridOptionsService.get("groupMaintainOrder"), c = this.columnModel.getAllGridColumns().some(function(m) {
        return m.isRowGroupActive();
      }), d = {};
      n && i && (d = this.calculateDirtyNodes(i));
      var f = this.columnModel.isPivotMode(), v = this.gridOptionsService.getCallback("postSortRows"), g = function(m) {
        var b;
        l.pullDownGroupDataForHideOpenParents(m.childrenAfterAggFilter, !0);
        var S = f && m.leafGroup, R = u && c && !m.leafGroup && !s;
        if (R) {
          var P = (b = l.columnModel.getRowGroupColumns()) === null || b === void 0 ? void 0 : b[m.level + 1], D = (P == null ? void 0 : P.getSort()) === null, x = m.childrenAfterAggFilter.slice(0);
          if (m.childrenAfterSort && !D) {
            var M = {};
            m.childrenAfterSort.forEach(function(H, B) {
              M[H.id] = B;
            }), x.sort(function(H, B) {
              var j, V;
              return ((j = M[H.id]) !== null && j !== void 0 ? j : 0) - ((V = M[B.id]) !== null && V !== void 0 ? V : 0);
            });
          }
          m.childrenAfterSort = x;
        } else !r || S ? m.childrenAfterSort = m.childrenAfterAggFilter.slice(0) : n ? m.childrenAfterSort = l.doDeltaSort(m, d, a, e) : m.childrenAfterSort = l.rowNodeSorter.doFullSort(m.childrenAfterAggFilter, e);
        if (m.sibling && (m.sibling.childrenAfterSort = m.childrenAfterSort), l.updateChildIndexes(m), v) {
          var F = { nodes: m.childrenAfterSort };
          v(F);
        }
      };
      a && a.forEachChangedNodeDepthFirst(g), this.updateGroupDataForHideOpenParents(a);
    }, t.prototype.calculateDirtyNodes = function(e) {
      var r = {}, n = function(i) {
        i && i.forEach(function(a) {
          return r[a.id] = !0;
        });
      };
      return e && e.forEach(function(i) {
        n(i.add), n(i.update), n(i.remove);
      }), r;
    }, t.prototype.doDeltaSort = function(e, r, n, i) {
      var a = this, s = e.childrenAfterAggFilter, l = e.childrenAfterSort;
      if (!l)
        return this.rowNodeSorter.doFullSort(s, i);
      var u = {}, c = [];
      s.forEach(function(g) {
        r[g.id] || !n.canSkip(g) ? c.push(g) : u[g.id] = !0;
      });
      var d = l.filter(function(g) {
        return u[g.id];
      }), f = function(g, m) {
        return { currentPos: m, rowNode: g };
      }, v = c.map(f).sort(function(g, m) {
        return a.rowNodeSorter.compareRowNodes(i, g, m);
      });
      return this.mergeSortedArrays(i, v, d.map(f)).map(function(g) {
        var m = g.rowNode;
        return m;
      });
    }, t.prototype.mergeSortedArrays = function(e, r, n) {
      for (var i = [], a = 0, s = 0; a < r.length && s < n.length; ) {
        var l = this.rowNodeSorter.compareRowNodes(e, r[a], n[s]);
        l < 0 ? i.push(r[a++]) : i.push(n[s++]);
      }
      for (; a < r.length; )
        i.push(r[a++]);
      for (; s < n.length; )
        i.push(n[s++]);
      return i;
    }, t.prototype.updateChildIndexes = function(e) {
      if (!yt.missing(e.childrenAfterSort))
        for (var r = e.childrenAfterSort, n = 0; n < r.length; n++) {
          var i = r[n], a = n === 0, s = n === e.childrenAfterSort.length - 1;
          i.setFirstChild(a), i.setLastChild(s), i.setChildIndex(n);
        }
    }, t.prototype.updateGroupDataForHideOpenParents = function(e) {
      var r = this;
      if (this.gridOptionsService.get("groupHideOpenParents")) {
        if (this.gridOptionsService.get("treeData"))
          return yt.warnOnce("The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them."), !1;
        var n = function(i) {
          r.pullDownGroupDataForHideOpenParents(i.childrenAfterSort, !1), i.childrenAfterSort.forEach(function(a) {
            a.hasChildren() && n(a);
          });
        };
        e && e.executeFromRootNode(function(i) {
          return n(i);
        });
      }
    }, t.prototype.pullDownGroupDataForHideOpenParents = function(e, r) {
      var n = this;
      !this.gridOptionsService.get("groupHideOpenParents") || yt.missing(e) || e.forEach(function(i) {
        var a = n.columnModel.getGroupDisplayColumns();
        a.forEach(function(s) {
          var l = s.getColDef().showRowGroup;
          if (typeof l != "string") {
            console.error("AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
            return;
          }
          var u = l, c = n.columnModel.getPrimaryColumn(u), d = c === i.rowGroupColumn;
          if (!d)
            if (r)
              i.setGroupValue(s.getId(), void 0);
            else {
              var f = i.getFirstChildOfFirstChild(c);
              f && i.setGroupValue(s.getId(), f.key);
            }
        });
      });
    }, Sb([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), Sb([
      N("rowNodeSorter")
    ], t.prototype, "rowNodeSorter", void 0), t = Sb([
      Be("sortService")
    ], t), t;
  }(Me)
), PJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), DP = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, DJ = (
  /** @class */
  function(o) {
    PJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.filter = function(e) {
      var r = this.filterManager.isChildFilterPresent();
      this.filterNodes(r, e);
    }, t.prototype.filterNodes = function(e, r) {
      var n = this, i = function(u, c) {
        u.hasChildren() && e && !c ? u.childrenAfterFilter = u.childrenAfterGroup.filter(function(d) {
          var f = d.childrenAfterFilter && d.childrenAfterFilter.length > 0, v = d.data && n.filterManager.doesRowPassFilter({ rowNode: d });
          return f || v;
        }) : u.childrenAfterFilter = u.childrenAfterGroup, u.sibling && (u.sibling.childrenAfterFilter = u.childrenAfterFilter);
      };
      if (this.doingTreeDataFiltering()) {
        var a = function(u, c) {
          if (u.childrenAfterGroup)
            for (var d = 0; d < u.childrenAfterGroup.length; d++) {
              var f = u.childrenAfterGroup[d], v = c || n.filterManager.doesRowPassFilter({ rowNode: f });
              f.childrenAfterGroup ? a(u.childrenAfterGroup[d], v) : i(f, v);
            }
          i(u, c);
        }, s = function(u) {
          return a(u, !1);
        };
        r.executeFromRootNode(s);
      } else {
        var l = function(u) {
          return i(u, !1);
        };
        r.forEachChangedNodeDepthFirst(l, !0);
      }
    }, t.prototype.doingTreeDataFiltering = function() {
      return this.gridOptionsService.get("treeData") && !this.gridOptionsService.get("excludeChildrenWhenTreeDataFiltering");
    }, DP([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), t = DP([
      Be("filterService")
    ], t), t;
  }(Me)
), AJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Qf = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, MJ = function(o, t) {
  var e = typeof Symbol == "function" && o[Symbol.iterator];
  if (!e) return o;
  var r = e.call(o), n, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = r.next()).done; ) i.push(n.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      n && !n.done && (e = r.return) && e.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}, FJ = (
  /** @class */
  function(o) {
    AJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      var e = this;
      this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel, this.addManagedPropertyListener("rowData", function() {
        return e.onRowDataUpdated();
      }));
    }, t.prototype.isActive = function() {
      var e = this.gridOptionsService.exists("getRowId"), r = this.gridOptionsService.get("resetRowDataOnUpdate");
      return r ? !1 : e;
    }, t.prototype.setRowData = function(e) {
      var r = this.createTransactionForRowData(e);
      if (r) {
        var n = MJ(r, 2), i = n[0], a = n[1];
        this.clientSideRowModel.updateRowData(i, a);
      }
    }, t.prototype.createTransactionForRowData = function(e) {
      if (yt.missing(this.clientSideRowModel)) {
        console.error("AG Grid: ImmutableService only works with ClientSideRowModel");
        return;
      }
      var r = this.gridOptionsService.getCallback("getRowId");
      if (r == null) {
        console.error("AG Grid: ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
        return;
      }
      var n = {
        remove: [],
        update: [],
        add: []
      }, i = this.clientSideRowModel.getCopyOfNodesMap(), a = this.gridOptionsService.get("suppressMaintainUnsortedOrder"), s = a ? void 0 : {};
      return yt.exists(e) && e.forEach(function(l, u) {
        var c = r({ data: l, level: 0 }), d = i[c];
        if (s && (s[c] = u), d) {
          var f = d.data !== l;
          f && n.update.push(l), i[c] = void 0;
        } else
          n.add.push(l);
      }), yt.iterateObject(i, function(l, u) {
        u && n.remove.push(u.data);
      }), [n, s];
    }, t.prototype.onRowDataUpdated = function() {
      var e = this.gridOptionsService.get("rowData");
      e && (this.isActive() ? this.setRowData(e) : (this.selectionService.reset("rowDataChanged"), this.clientSideRowModel.setRowData(e)));
    }, Qf([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), Qf([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), Qf([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), Qf([
      Fe
    ], t.prototype, "postConstruct", null), t = Qf([
      Be("immutableService")
    ], t), t;
  }(Me)
), IJ = "31.0.3", QL = {
  version: IJ,
  moduleName: Ye.ClientSideRowModelModule,
  rowModel: "clientSide",
  beans: [wJ, SJ, _J, RJ, OJ, DJ, FJ]
}, LJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Eb = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, AP = (
  /** @class */
  function(o) {
    LJ(t, o);
    function t(e, r, n) {
      var i = o.call(this, e) || this;
      return i.parentCache = r, i.params = n, i.startRow = e * n.blockSize, i.endRow = i.startRow + n.blockSize, i;
    }
    return t.prototype.postConstruct = function() {
      this.createRowNodes();
    }, t.prototype.getBlockStateJson = function() {
      return {
        id: "" + this.getId(),
        state: {
          blockNumber: this.getId(),
          startRow: this.getStartRow(),
          endRow: this.getEndRow(),
          pageStatus: this.getState()
        }
      };
    }, t.prototype.setDataAndId = function(e, r, n) {
      yt.exists(r) ? e.setDataAndId(r, n.toString()) : e.setDataAndId(void 0, void 0);
    }, t.prototype.loadFromDatasource = function() {
      var e = this, r = this.createLoadParams();
      if (yt.missing(this.params.datasource.getRows)) {
        console.warn("AG Grid: datasource is missing getRows method");
        return;
      }
      window.setTimeout(function() {
        e.params.datasource.getRows(r);
      }, 0);
    }, t.prototype.processServerFail = function() {
    }, t.prototype.createLoadParams = function() {
      var e = {
        startRow: this.getStartRow(),
        endRow: this.getEndRow(),
        successCallback: this.pageLoaded.bind(this, this.getVersion()),
        failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
        sortModel: this.params.sortModel,
        filterModel: this.params.filterModel,
        context: this.gridOptionsService.getGridCommonParams().context
      };
      return e;
    }, t.prototype.forEachNode = function(e, r, n) {
      var i = this;
      this.rowNodes.forEach(function(a, s) {
        var l = i.startRow + s;
        l < n && e(a, r.next());
      });
    }, t.prototype.getLastAccessed = function() {
      return this.lastAccessed;
    }, t.prototype.getRow = function(e, r) {
      r === void 0 && (r = !1), r || (this.lastAccessed = this.params.lastAccessedSequence.next());
      var n = e - this.startRow;
      return this.rowNodes[n];
    }, t.prototype.getStartRow = function() {
      return this.startRow;
    }, t.prototype.getEndRow = function() {
      return this.endRow;
    }, t.prototype.createRowNodes = function() {
      this.rowNodes = [];
      for (var e = 0; e < this.params.blockSize; e++) {
        var r = this.startRow + e, n = new St(this.beans);
        n.setRowHeight(this.params.rowHeight), n.uiLevel = 0, n.setRowIndex(r), n.setRowTop(this.params.rowHeight * r), this.rowNodes.push(n);
      }
    }, t.prototype.processServerResult = function(e) {
      var r = this;
      this.rowNodes.forEach(function(i, a) {
        var s = e.rowData ? e.rowData[a] : void 0;
        !i.id && i.alreadyRendered && s && (r.rowNodes[a] = new St(r.beans), r.rowNodes[a].setRowIndex(i.rowIndex), r.rowNodes[a].setRowTop(i.rowTop), r.rowNodes[a].setRowHeight(i.rowHeight), i.clearRowTopAndRowIndex()), r.setDataAndId(r.rowNodes[a], s, r.startRow + a);
      });
      var n = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
      this.parentCache.pageLoaded(this, n);
    }, t.prototype.destroyRowNodes = function() {
      this.rowNodes.forEach(function(e) {
        e.clearRowTopAndRowIndex();
      });
    }, Eb([
      N("beans")
    ], t.prototype, "beans", void 0), Eb([
      Fe
    ], t.prototype, "postConstruct", null), Eb([
      eo
    ], t.prototype, "destroyRowNodes", null), t;
  }(ly)
), NJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), tm = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, kJ = function(o, t) {
  return function(e, r) {
    t(e, r, o);
  };
}, GJ = (
  /** @class */
  function(o) {
    NJ(t, o);
    function t(e) {
      var r = o.call(this) || this;
      return r.lastRowIndexKnown = !1, r.blocks = {}, r.blockCount = 0, r.rowCount = e.initialRowCount, r.params = e, r;
    }
    return t.prototype.setBeans = function(e) {
      this.logger = e.create("InfiniteCache");
    }, t.prototype.getRow = function(e, r) {
      r === void 0 && (r = !1);
      var n = Math.floor(e / this.params.blockSize), i = this.blocks[n];
      if (!i) {
        if (r)
          return;
        i = this.createBlock(n);
      }
      return i.getRow(e);
    }, t.prototype.createBlock = function(e) {
      var r = this.createBean(new AP(e, this, this.params));
      return this.blocks[r.getId()] = r, this.blockCount++, this.purgeBlocksIfNeeded(r), this.params.rowNodeBlockLoader.addBlock(r), r;
    }, t.prototype.refreshCache = function() {
      var e = this.blockCount == 0;
      if (e) {
        this.purgeCache();
        return;
      }
      this.getBlocksInOrder().forEach(function(r) {
        return r.setStateWaitingToLoad();
      }), this.params.rowNodeBlockLoader.checkBlockToLoad();
    }, t.prototype.destroyAllBlocks = function() {
      var e = this;
      this.getBlocksInOrder().forEach(function(r) {
        return e.destroyBlock(r);
      });
    }, t.prototype.getRowCount = function() {
      return this.rowCount;
    }, t.prototype.isLastRowIndexKnown = function() {
      return this.lastRowIndexKnown;
    }, t.prototype.pageLoaded = function(e, r) {
      this.isAlive() && (this.logger.log("onPageLoaded: page = ".concat(e.getId(), ", lastRow = ").concat(r)), this.checkRowCount(e, r), this.onCacheUpdated());
    }, t.prototype.purgeBlocksIfNeeded = function(e) {
      var r = this, n = this.getBlocksInOrder().filter(function(u) {
        return u != e;
      }), i = function(u, c) {
        return c.getLastAccessed() - u.getLastAccessed();
      };
      n.sort(i);
      var a = this.params.maxBlocksInCache > 0, s = a ? this.params.maxBlocksInCache - 1 : null, l = t.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
      n.forEach(function(u, c) {
        var d = u.getState() === AP.STATE_WAITING_TO_LOAD && c >= l, f = a ? c >= s : !1;
        if (d || f) {
          if (r.isBlockCurrentlyDisplayed(u) || r.isBlockFocused(u))
            return;
          r.removeBlockFromCache(u);
        }
      });
    }, t.prototype.isBlockFocused = function(e) {
      var r = this.focusService.getFocusCellToUseAfterRefresh();
      if (!r || r.rowPinned != null)
        return !1;
      var n = e.getStartRow(), i = e.getEndRow(), a = r.rowIndex >= n && r.rowIndex < i;
      return a;
    }, t.prototype.isBlockCurrentlyDisplayed = function(e) {
      var r = e.getStartRow(), n = e.getEndRow() - 1;
      return this.rowRenderer.isRangeInRenderedViewport(r, n);
    }, t.prototype.removeBlockFromCache = function(e) {
      e && this.destroyBlock(e);
    }, t.prototype.checkRowCount = function(e, r) {
      if (typeof r == "number" && r >= 0)
        this.rowCount = r, this.lastRowIndexKnown = !0;
      else if (!this.lastRowIndexKnown) {
        var n = (e.getId() + 1) * this.params.blockSize, i = n + this.params.overflowSize;
        this.rowCount < i && (this.rowCount = i);
      }
    }, t.prototype.setRowCount = function(e, r) {
      this.rowCount = e, yt.exists(r) && (this.lastRowIndexKnown = r), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
    }, t.prototype.forEachNodeDeep = function(e) {
      var r = this, n = new gc();
      this.getBlocksInOrder().forEach(function(i) {
        return i.forEachNode(e, n, r.rowCount);
      });
    }, t.prototype.getBlocksInOrder = function() {
      var e = function(n, i) {
        return n.getId() - i.getId();
      }, r = yt.getAllValuesInObject(this.blocks).sort(e);
      return r;
    }, t.prototype.destroyBlock = function(e) {
      delete this.blocks[e.getId()], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
    }, t.prototype.onCacheUpdated = function() {
      if (this.isAlive()) {
        this.destroyAllBlocksPastVirtualRowCount();
        var e = {
          type: G.EVENT_STORE_UPDATED
        };
        this.eventService.dispatchEvent(e);
      }
    }, t.prototype.destroyAllBlocksPastVirtualRowCount = function() {
      var e = this, r = [];
      this.getBlocksInOrder().forEach(function(n) {
        var i = n.getId() * e.params.blockSize;
        i >= e.rowCount && r.push(n);
      }), r.length > 0 && r.forEach(function(n) {
        return e.destroyBlock(n);
      });
    }, t.prototype.purgeCache = function() {
      var e = this;
      this.getBlocksInOrder().forEach(function(r) {
        return e.removeBlockFromCache(r);
      }), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
    }, t.prototype.getRowNodesInRange = function(e, r) {
      var n = this, i = [], a = -1, s = !1, l = new gc();
      yt.missing(e) && (s = !0);
      var u = !1;
      this.getBlocksInOrder().forEach(function(d) {
        if (!u) {
          if (s && a + 1 !== d.getId()) {
            u = !0;
            return;
          }
          a = d.getId(), d.forEachNode(function(f) {
            var v = f === e || f === r;
            (s || v) && i.push(f), v && (s = !s);
          }, l, n.rowCount);
        }
      });
      var c = u || s;
      return c ? [] : i;
    }, t.MAX_EMPTY_BLOCKS_TO_KEEP = 2, tm([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), tm([
      N("focusService")
    ], t.prototype, "focusService", void 0), tm([
      kJ(0, ii("loggerFactory"))
    ], t.prototype, "setBeans", null), tm([
      eo
    ], t.prototype, "destroyAllBlocks", null), t;
  }(Me)
), VJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), hl = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, HJ = (
  /** @class */
  function(o) {
    VJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.getRowBounds = function(e) {
      return {
        rowHeight: this.rowHeight,
        rowTop: this.rowHeight * e
      };
    }, t.prototype.ensureRowHeightsValid = function(e, r, n, i) {
      return !1;
    }, t.prototype.init = function() {
      var e = this;
      this.gridOptionsService.isRowModelType("infinite") && (this.rowHeight = this.gridOptionsService.getRowHeightAsNumber(), this.addEventListeners(), this.addDestroyFunc(function() {
        return e.destroyCache();
      }), this.verifyProps());
    }, t.prototype.verifyProps = function() {
      this.gridOptionsService.exists("initialGroupOrderComparator") && yt.warnOnce("initialGroupOrderComparator cannot be used with Infinite Row Model as sorting is done on the server side");
    }, t.prototype.start = function() {
      this.setDatasource(this.gridOptionsService.get("datasource"));
    }, t.prototype.destroyDatasource = function() {
      this.datasource && (this.getContext().destroyBean(this.datasource), this.rowRenderer.datasourceChanged(), this.datasource = null);
    }, t.prototype.addEventListeners = function() {
      var e = this;
      this.addManagedListener(this.eventService, G.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_SORT_CHANGED, this.onSortChanged.bind(this)), this.addManagedListener(this.eventService, G.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this)), this.addManagedListener(this.eventService, G.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this)), this.addManagedPropertyListener("datasource", function() {
        return e.setDatasource(e.gridOptionsService.get("datasource"));
      }), this.addManagedPropertyListener("cacheBlockSize", function() {
        return e.resetCache();
      }), this.addManagedPropertyListener("rowHeight", function() {
        e.rowHeight = e.gridOptionsService.getRowHeightAsNumber(), e.cacheParams.rowHeight = e.rowHeight, e.updateRowHeights();
      });
    }, t.prototype.onFilterChanged = function() {
      this.reset();
    }, t.prototype.onSortChanged = function() {
      this.reset();
    }, t.prototype.onColumnEverything = function() {
      var e;
      this.cacheParams ? e = this.isSortModelDifferent() : e = !0, e && this.reset();
    }, t.prototype.isSortModelDifferent = function() {
      return !yt.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
    }, t.prototype.getType = function() {
      return "infinite";
    }, t.prototype.setDatasource = function(e) {
      this.destroyDatasource(), this.datasource = e, e && this.reset();
    }, t.prototype.isEmpty = function() {
      return !this.infiniteCache;
    }, t.prototype.isRowsToRender = function() {
      return !!this.infiniteCache;
    }, t.prototype.getNodesInRangeForSelection = function(e, r) {
      return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(e, r) : [];
    }, t.prototype.reset = function() {
      if (this.datasource) {
        var e = this.gridOptionsService.getCallback("getRowId"), r = e != null;
        r || this.selectionService.reset("rowDataChanged"), this.resetCache();
      }
    }, t.prototype.createModelUpdatedEvent = function() {
      return {
        type: G.EVENT_MODEL_UPDATED,
        // not sure if these should all be false - noticed if after implementing,
        // maybe they should be true?
        newPage: !1,
        newPageSize: !1,
        newData: !1,
        keepRenderedRows: !0,
        animate: !1
      };
    }, t.prototype.resetCache = function() {
      this.destroyCache(), this.cacheParams = {
        // the user provided datasource
        datasource: this.datasource,
        // sort and filter model
        filterModel: this.filterManager.getFilterModel(),
        sortModel: this.sortController.getSortModel(),
        rowNodeBlockLoader: this.rowNodeBlockLoader,
        // properties - this way we take a snapshot of them, so if user changes any, they will be
        // used next time we create a new cache, which is generally after a filter or sort change,
        // or a new datasource is set
        initialRowCount: this.gridOptionsService.get("infiniteInitialRowCount"),
        maxBlocksInCache: this.gridOptionsService.get("maxBlocksInCache"),
        rowHeight: this.gridOptionsService.getRowHeightAsNumber(),
        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
        // the current page and request first row of next page
        overflowSize: this.gridOptionsService.get("cacheOverflowSize"),
        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
        // server for one page at a time. so the default if not specified is 100.
        blockSize: this.gridOptionsService.get("cacheBlockSize"),
        // the cache could create this, however it is also used by the pages, so handy to create it
        // here as the settings are also passed to the pages
        lastAccessedSequence: new gc()
      }, this.infiniteCache = this.createBean(new GJ(this.cacheParams)), this.eventService.dispatchEventOnce({
        type: G.EVENT_ROW_COUNT_READY
      });
      var e = this.createModelUpdatedEvent();
      this.eventService.dispatchEvent(e);
    }, t.prototype.updateRowHeights = function() {
      var e = this;
      this.forEachNode(function(n) {
        n.setRowHeight(e.rowHeight), n.setRowTop(e.rowHeight * n.rowIndex);
      });
      var r = this.createModelUpdatedEvent();
      this.eventService.dispatchEvent(r);
    }, t.prototype.destroyCache = function() {
      this.infiniteCache && (this.infiniteCache = this.destroyBean(this.infiniteCache));
    }, t.prototype.onCacheUpdated = function() {
      var e = this.createModelUpdatedEvent();
      this.eventService.dispatchEvent(e);
    }, t.prototype.getRow = function(e) {
      if (this.infiniteCache && !(e >= this.infiniteCache.getRowCount()))
        return this.infiniteCache.getRow(e);
    }, t.prototype.getRowNode = function(e) {
      var r;
      return this.forEachNode(function(n) {
        n.id === e && (r = n);
      }), r;
    }, t.prototype.forEachNode = function(e) {
      this.infiniteCache && this.infiniteCache.forEachNodeDeep(e);
    }, t.prototype.getTopLevelRowCount = function() {
      return this.getRowCount();
    }, t.prototype.getTopLevelRowDisplayedIndex = function(e) {
      return e;
    }, t.prototype.getRowIndexAtPixel = function(e) {
      if (this.rowHeight !== 0) {
        var r = Math.floor(e / this.rowHeight), n = this.getRowCount() - 1;
        return r > n ? n : r;
      }
      return 0;
    }, t.prototype.getRowCount = function() {
      return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }, t.prototype.isRowPresent = function(e) {
      var r = this.getRowNode(e.id);
      return !!r;
    }, t.prototype.refreshCache = function() {
      this.infiniteCache && this.infiniteCache.refreshCache();
    }, t.prototype.purgeCache = function() {
      this.infiniteCache && this.infiniteCache.purgeCache();
    }, t.prototype.isLastRowIndexKnown = function() {
      return this.infiniteCache ? this.infiniteCache.isLastRowIndexKnown() : !1;
    }, t.prototype.setRowCount = function(e, r) {
      this.infiniteCache && this.infiniteCache.setRowCount(e, r);
    }, hl([
      N("filterManager")
    ], t.prototype, "filterManager", void 0), hl([
      N("sortController")
    ], t.prototype, "sortController", void 0), hl([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), hl([
      N("rowRenderer")
    ], t.prototype, "rowRenderer", void 0), hl([
      N("rowNodeBlockLoader")
    ], t.prototype, "rowNodeBlockLoader", void 0), hl([
      Fe
    ], t.prototype, "init", null), hl([
      eo
    ], t.prototype, "destroyDatasource", null), t = hl([
      Be("rowModel")
    ], t), t;
  }(Me)
), BJ = "31.0.3", JL = {
  version: BJ,
  moduleName: Ye.InfiniteRowModelModule,
  rowModel: "infinite",
  beans: [HJ]
}, eN = (
  /** @class */
  function() {
    function o() {
    }
    return o.prototype.setBeans = function(t) {
      this.beans = t;
    }, o.prototype.getFileName = function(t) {
      var e = this.getDefaultFileExtension();
      return (t == null || !t.length) && (t = this.getDefaultFileName()), t.indexOf(".") === -1 ? "".concat(t, ".").concat(e) : t;
    }, o.prototype.getData = function(t) {
      var e = this.createSerializingSession(t), r = this.beans.gridSerializer.serialize(e, t);
      return r;
    }, o.prototype.getDefaultFileName = function() {
      return "export.".concat(this.getDefaultFileExtension());
    }, o;
  }()
), tN = (
  /** @class */
  function() {
    function o(t) {
      this.groupColumns = [];
      var e = t.columnModel, r = t.valueService, n = t.gridOptionsService, i = t.valueFormatterService, a = t.valueParserService, s = t.processCellCallback, l = t.processHeaderCallback, u = t.processGroupHeaderCallback, c = t.processRowGroupCallback;
      this.columnModel = e, this.valueService = r, this.gridOptionsService = n, this.valueFormatterService = i, this.valueParserService = a, this.processCellCallback = s, this.processHeaderCallback = l, this.processGroupHeaderCallback = u, this.processRowGroupCallback = c;
    }
    return o.prototype.prepare = function(t) {
      this.groupColumns = t.filter(function(e) {
        return !!e.getColDef().showRowGroup;
      });
    }, o.prototype.extractHeaderValue = function(t) {
      var e = this.getHeaderName(this.processHeaderCallback, t);
      return e ?? "";
    }, o.prototype.extractRowCellValue = function(t, e, r, n, i) {
      var a = this.gridOptionsService.get("groupHideOpenParents"), s = (!a || i.footer) && this.shouldRenderGroupSummaryCell(i, t, e) ? this.createValueForGroupNode(t, i) : this.valueService.getValue(t, i), l = this.processCell({
        accumulatedRowIndex: r,
        rowNode: i,
        column: t,
        value: s,
        processCellCallback: this.processCellCallback,
        type: n
      });
      return l;
    }, o.prototype.shouldRenderGroupSummaryCell = function(t, e, r) {
      var n, i = t && t.group;
      if (!i)
        return !1;
      var a = this.groupColumns.indexOf(e);
      if (a !== -1) {
        if (((n = t.groupData) === null || n === void 0 ? void 0 : n[e.getId()]) != null || this.gridOptionsService.isRowModelType("serverSide") && t.group)
          return !0;
        if (t.footer && t.level === -1) {
          var s = e.getColDef(), l = s == null || s.showRowGroup === !0;
          return l || s.showRowGroup === this.columnModel.getRowGroupColumns()[0].getId();
        }
      }
      var u = this.gridOptionsService.isGroupUseEntireRow(this.columnModel.isPivotMode());
      return r === 0 && u;
    }, o.prototype.getHeaderName = function(t, e) {
      return t ? t(this.gridOptionsService.addGridCommonParams({ column: e })) : this.columnModel.getDisplayNameForColumn(e, "csv", !0);
    }, o.prototype.createValueForGroupNode = function(t, e) {
      var r = this;
      if (this.processRowGroupCallback)
        return this.processRowGroupCallback(this.gridOptionsService.addGridCommonParams({ column: t, node: e }));
      var n = this.gridOptionsService.get("treeData"), i = this.gridOptionsService.get("suppressGroupMaintainValueType"), a = function(c) {
        var d, f;
        if (n || i)
          return c.key;
        var v = (d = c.groupData) === null || d === void 0 ? void 0 : d[t.getId()];
        return !v || !c.rowGroupColumn || c.rowGroupColumn.getColDef().useValueFormatterForExport === !1 ? v : (f = r.valueFormatterService.formatValue(c.rowGroupColumn, c, v)) !== null && f !== void 0 ? f : v;
      }, s = e.footer, l = [a(e)];
      if (!this.gridOptionsService.isGroupMultiAutoColumn())
        for (; e.parent; )
          e = e.parent, l.push(a(e));
      var u = l.reverse().join(" -> ");
      return s ? "Total ".concat(u) : u;
    }, o.prototype.processCell = function(t) {
      var e = this, r, n = t.accumulatedRowIndex, i = t.rowNode, a = t.column, s = t.value, l = t.processCellCallback, u = t.type;
      return l ? {
        value: (r = l(this.gridOptionsService.addGridCommonParams({
          accumulatedRowIndex: n,
          column: a,
          node: i,
          value: s,
          type: u,
          parseValue: function(c) {
            return e.valueParserService.parseValue(a, i, c, e.valueService.getValue(a, i));
          },
          formatValue: function(c) {
            var d;
            return (d = e.valueFormatterService.formatValue(a, i, c)) !== null && d !== void 0 ? d : c;
          }
        }))) !== null && r !== void 0 ? r : ""
      } : a.getColDef().useValueFormatterForExport !== !1 ? {
        value: s ?? "",
        valueFormatted: this.valueFormatterService.formatValue(a, i, s)
      } : { value: s ?? "" };
    }, o;
  }()
), rN = (
  /** @class */
  function() {
    function o() {
    }
    return o.download = function(t, e) {
      var r = document.defaultView || window;
      if (!r) {
        console.warn("AG Grid: There is no `window` associated with the current `document`");
        return;
      }
      var n = document.createElement("a"), i = r.URL.createObjectURL(e);
      n.setAttribute("href", i), n.setAttribute("download", t), n.style.display = "none", document.body.appendChild(n), n.dispatchEvent(new MouseEvent("click", {
        bubbles: !1,
        cancelable: !0,
        view: r
      })), document.body.removeChild(n), r.setTimeout(function() {
        r.URL.revokeObjectURL(i);
      }, 0);
    }, o;
  }()
), WJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), MP = `\r
`, jJ = (
  /** @class */
  function(o) {
    WJ(t, o);
    function t(e) {
      var r = o.call(this, e) || this;
      r.isFirstLine = !0, r.result = "";
      var n = e.suppressQuotes, i = e.columnSeparator;
      return r.suppressQuotes = n, r.columnSeparator = i, r;
    }
    return t.prototype.addCustomContent = function(e) {
      var r = this;
      e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, MP), this.result += e) : e.forEach(function(n) {
        r.beginNewLine(), n.forEach(function(i, a) {
          a !== 0 && (r.result += r.columnSeparator), r.result += r.putInQuotes(i.data.value || ""), i.mergeAcross && r.appendEmptyCells(i.mergeAcross);
        });
      }));
    }, t.prototype.onNewHeaderGroupingRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
      };
    }, t.prototype.onNewHeaderGroupingRowColumn = function(e, r, n, i) {
      n != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(r), this.appendEmptyCells(i);
    }, t.prototype.appendEmptyCells = function(e) {
      for (var r = 1; r <= e; r++)
        this.result += this.columnSeparator + this.putInQuotes("");
    }, t.prototype.onNewHeaderRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewHeaderRowColumn.bind(this)
      };
    }, t.prototype.onNewHeaderRowColumn = function(e, r) {
      r != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
    }, t.prototype.onNewBodyRow = function() {
      return this.beginNewLine(), {
        onColumn: this.onNewBodyRowColumn.bind(this)
      };
    }, t.prototype.onNewBodyRowColumn = function(e, r, n) {
      var i;
      r != 0 && (this.result += this.columnSeparator);
      var a = this.extractRowCellValue(e, r, r, "csv", n);
      this.result += this.putInQuotes((i = a.valueFormatted) !== null && i !== void 0 ? i : a.value);
    }, t.prototype.putInQuotes = function(e) {
      if (this.suppressQuotes)
        return e;
      if (e == null)
        return '""';
      var r;
      typeof e == "string" ? r = e : typeof e.toString == "function" ? r = e.toString() : (console.warn("AG Grid: unknown value type during csv conversion"), r = "");
      var n = r.replace(/"/g, '""');
      return '"' + n + '"';
    }, t.prototype.parse = function() {
      return this.result;
    }, t.prototype.beginNewLine = function() {
      this.isFirstLine || (this.result += MP), this.isFirstLine = !1;
    }, t;
  }(tN)
), UJ = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vl = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, nN = (
  /** @class */
  function(o) {
    UJ(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.postConstruct = function() {
      this.setBeans({
        gridSerializer: this.gridSerializer,
        gridOptionsService: this.gridOptionsService
      });
    }, t.prototype.getMergedParams = function(e) {
      var r = this.gridOptionsService.get("defaultCsvExportParams");
      return Object.assign({}, r, e);
    }, t.prototype.export = function(e) {
      if (this.isExportSuppressed())
        return console.warn("AG Grid: Export cancelled. Export is not allowed as per your configuration."), "";
      var r = this.getMergedParams(e), n = this.getData(r), i = new Blob(["\uFEFF", n], { type: "text/plain" });
      return rN.download(this.getFileName(r.fileName), i), n;
    }, t.prototype.exportDataAsCsv = function(e) {
      return this.export(e);
    }, t.prototype.getDataAsCsv = function(e, r) {
      r === void 0 && (r = !1);
      var n = r ? Object.assign({}, e) : this.getMergedParams(e);
      return this.getData(n);
    }, t.prototype.getDefaultFileExtension = function() {
      return "csv";
    }, t.prototype.createSerializingSession = function(e) {
      var r = this, n = r.columnModel, i = r.valueService, a = r.gridOptionsService, s = r.valueFormatterService, l = r.valueParserService, u = e, c = u.processCellCallback, d = u.processHeaderCallback, f = u.processGroupHeaderCallback, v = u.processRowGroupCallback, g = u.suppressQuotes, m = u.columnSeparator;
      return new jJ({
        columnModel: n,
        valueService: i,
        gridOptionsService: a,
        valueFormatterService: s,
        valueParserService: l,
        processCellCallback: c || void 0,
        processHeaderCallback: d || void 0,
        processGroupHeaderCallback: f || void 0,
        processRowGroupCallback: v || void 0,
        suppressQuotes: g || !1,
        columnSeparator: m || ","
      });
    }, t.prototype.isExportSuppressed = function() {
      return this.gridOptionsService.get("suppressCsvExport");
    }, vl([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), vl([
      N("valueService")
    ], t.prototype, "valueService", void 0), vl([
      N("gridSerializer")
    ], t.prototype, "gridSerializer", void 0), vl([
      N("gridOptionsService")
    ], t.prototype, "gridOptionsService", void 0), vl([
      N("valueFormatterService")
    ], t.prototype, "valueFormatterService", void 0), vl([
      N("valueParserService")
    ], t.prototype, "valueParserService", void 0), vl([
      Fe
    ], t.prototype, "postConstruct", null), t = vl([
      Be("csvCreator")
    ], t), t;
  }(eN)
), $J = /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gl = function(o, t, e, r) {
  var n = arguments.length, i = n < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, e) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(o, t, e, r);
  else for (var s = o.length - 1; s >= 0; s--) (a = o[s]) && (i = (n < 3 ? a(i) : n > 3 ? a(t, e, i) : a(t, e)) || i);
  return n > 3 && i && Object.defineProperty(t, e, i), i;
}, KS;
(function(o) {
  o[o.HEADER_GROUPING = 0] = "HEADER_GROUPING", o[o.HEADER = 1] = "HEADER", o[o.BODY = 2] = "BODY";
})(KS || (KS = {}));
var oN = (
  /** @class */
  function(o) {
    $J(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.serialize = function(e, r) {
      r === void 0 && (r = {});
      var n = r.allColumns, i = r.columnKeys, a = r.skipRowGroups, s = this.getColumnsToExport(n, a, i), l = yt.compose(
        // first pass, put in the header names of the cols
        this.prepareSession(s),
        this.prependContent(r),
        this.exportColumnGroups(r, s),
        this.exportHeaders(r, s),
        this.processPinnedTopRows(r, s),
        this.processRows(r, s),
        this.processPinnedBottomRows(r, s),
        this.appendContent(r)
      );
      return l(e).parse();
    }, t.prototype.processRow = function(e, r, n, i) {
      var a = r.shouldRowBeSkipped || function() {
        return !1;
      }, s = this.gridOptionsService.get("groupRemoveSingleChildren"), l = this.gridOptionsService.get("groupRemoveLowestSingleChildren"), u = r.rowPositions != null, c = u || !!r.onlySelected, d = this.gridOptionsService.get("groupHideOpenParents") && !c, f = this.columnModel.isPivotMode() ? i.leafGroup : !i.group, v = !!i.footer;
      r.skipRowGroups;
      var g = l && i.leafGroup, m = i.allChildrenCount === 1 && (s || g);
      if (!(!f && !v && (r.skipRowGroups || m || d) || r.onlySelected && !i.isSelected() || r.skipPinnedTop && i.rowPinned === "top" || r.skipPinnedBottom && i.rowPinned === "bottom")) {
        var b = i.level === -1;
        if (!(b && !f && !v)) {
          var S = a(this.gridOptionsService.addGridCommonParams({ node: i }));
          if (!S) {
            var R = e.onNewBodyRow(i);
            if (n.forEach(function(D, x) {
              R.onColumn(D, x, i);
            }), r.getCustomContentBelowRow) {
              var P = r.getCustomContentBelowRow(this.gridOptionsService.addGridCommonParams({ node: i }));
              P && e.addCustomContent(P);
            }
          }
        }
      }
    }, t.prototype.appendContent = function(e) {
      return function(r) {
        var n = e.appendContent;
        return n && r.addCustomContent(n), r;
      };
    }, t.prototype.prependContent = function(e) {
      return function(r) {
        var n = e.prependContent;
        return n && r.addCustomContent(n), r;
      };
    }, t.prototype.prepareSession = function(e) {
      return function(r) {
        return r.prepare(e), r;
      };
    }, t.prototype.exportColumnGroups = function(e, r) {
      var n = this;
      return function(i) {
        if (!e.skipColumnGroupHeaders) {
          var a = new x1(), s = n.displayedGroupCreator.createDisplayedGroups(r, a, null);
          n.recursivelyAddHeaderGroups(s, i, e.processGroupHeaderCallback);
        }
        return i;
      };
    }, t.prototype.exportHeaders = function(e, r) {
      return function(n) {
        if (!e.skipColumnHeaders) {
          var i = n.onNewHeaderRow();
          r.forEach(function(a, s) {
            i.onColumn(a, s, void 0);
          });
        }
        return n;
      };
    }, t.prototype.processPinnedTopRows = function(e, r) {
      var n = this;
      return function(i) {
        var a = n.processRow.bind(n, i, e, r);
        return e.rowPositions ? e.rowPositions.filter(function(s) {
          return s.rowPinned === "top";
        }).sort(function(s, l) {
          return s.rowIndex - l.rowIndex;
        }).map(function(s) {
          return n.pinnedRowModel.getPinnedTopRow(s.rowIndex);
        }).forEach(a) : n.pinnedRowModel.forEachPinnedTopRow(a), i;
      };
    }, t.prototype.processRows = function(e, r) {
      var n = this;
      return function(i) {
        var a = n.rowModel, s = a.getType(), l = s === "clientSide", u = s === "serverSide", c = !l && e.onlySelected, d = n.processRow.bind(n, i, e, r), f = e.exportedRows, v = f === void 0 ? "filteredAndSorted" : f;
        if (e.rowPositions)
          e.rowPositions.filter(function(m) {
            return m.rowPinned == null;
          }).sort(function(m, b) {
            return m.rowIndex - b.rowIndex;
          }).map(function(m) {
            return a.getRow(m.rowIndex);
          }).forEach(d);
        else if (n.columnModel.isPivotMode())
          l ? a.forEachPivotNode(d, !0) : u ? a.forEachNodeAfterFilterAndSort(d, !0) : a.forEachNode(d);
        else if (e.onlySelectedAllPages || c) {
          var g = n.selectionService.getSelectedNodes();
          n.replicateSortedOrder(g), g.forEach(d);
        } else
          v === "all" ? a.forEachNode(d) : l || u ? a.forEachNodeAfterFilterAndSort(d, !0) : a.forEachNode(d);
        return i;
      };
    }, t.prototype.replicateSortedOrder = function(e) {
      var r = this, n = this.sortController.getSortOptions(), i = function(a, s) {
        var l, u, c, d;
        return a.rowIndex != null && s.rowIndex != null ? a.rowIndex - s.rowIndex : a.level === s.level ? ((l = a.parent) === null || l === void 0 ? void 0 : l.id) === ((u = s.parent) === null || u === void 0 ? void 0 : u.id) ? r.rowNodeSorter.compareRowNodes(n, {
          rowNode: a,
          currentPos: (c = a.rowIndex) !== null && c !== void 0 ? c : -1
        }, {
          rowNode: s,
          currentPos: (d = s.rowIndex) !== null && d !== void 0 ? d : -1
        }) : i(a.parent, s.parent) : a.level > s.level ? i(a.parent, s) : i(a, s.parent);
      };
      e.sort(i);
    }, t.prototype.processPinnedBottomRows = function(e, r) {
      var n = this;
      return function(i) {
        var a = n.processRow.bind(n, i, e, r);
        return e.rowPositions ? e.rowPositions.filter(function(s) {
          return s.rowPinned === "bottom";
        }).sort(function(s, l) {
          return s.rowIndex - l.rowIndex;
        }).map(function(s) {
          return n.pinnedRowModel.getPinnedBottomRow(s.rowIndex);
        }).forEach(a) : n.pinnedRowModel.forEachPinnedBottomRow(a), i;
      };
    }, t.prototype.getColumnsToExport = function(e, r, n) {
      e === void 0 && (e = !1), r === void 0 && (r = !1);
      var i = this.columnModel.isPivotMode();
      if (n && n.length)
        return this.columnModel.getGridColumns(n);
      var a = this.gridOptionsService.get("treeData"), s = [];
      return e && !i ? s = this.columnModel.getAllGridColumns() : s = this.columnModel.getAllDisplayedColumns(), r && !a && (s = s.filter(function(l) {
        return l.getColId() !== vc;
      })), s;
    }, t.prototype.recursivelyAddHeaderGroups = function(e, r, n) {
      var i = [];
      e.forEach(function(a) {
        var s = a;
        s.getChildren && s.getChildren().forEach(function(l) {
          return i.push(l);
        });
      }), e.length > 0 && e[0] instanceof pn && this.doAddHeaderHeader(r, e, n), i && i.length > 0 && this.recursivelyAddHeaderGroups(i, r, n);
    }, t.prototype.doAddHeaderHeader = function(e, r, n) {
      var i = this, a = e.onNewHeaderGroupingRow(), s = 0;
      r.forEach(function(l) {
        var u = l, c;
        n ? c = n(i.gridOptionsService.addGridCommonParams({
          columnGroup: u
        })) : c = i.columnModel.getDisplayNameForColumnGroup(u, "header");
        var d = u.getLeafColumns().reduce(function(f, v, g, m) {
          var b = yt.last(f), S = v.getColumnGroupShow() === "open";
          return S ? (!b || b[1] != null) && (b = [g], f.push(b)) : b && b[1] == null && (b[1] = g - 1), g === m.length - 1 && b && b[1] == null && (b[1] = g), f;
        }, []);
        a.onColumn(u, c || "", s++, u.getLeafColumns().length - 1, d);
      });
    }, gl([
      N("displayedGroupCreator")
    ], t.prototype, "displayedGroupCreator", void 0), gl([
      N("columnModel")
    ], t.prototype, "columnModel", void 0), gl([
      N("rowModel")
    ], t.prototype, "rowModel", void 0), gl([
      N("pinnedRowModel")
    ], t.prototype, "pinnedRowModel", void 0), gl([
      N("selectionService")
    ], t.prototype, "selectionService", void 0), gl([
      N("rowNodeSorter")
    ], t.prototype, "rowNodeSorter", void 0), gl([
      N("sortController")
    ], t.prototype, "sortController", void 0), t = gl([
      Be("gridSerializer")
    ], t), t;
  }(Me)
), zJ = "31.0.3", iN = {
  version: zJ,
  moduleName: Ye.CsvExportModule,
  beans: [nN, oN]
}, rm = `\r
`, YJ = (
  /** @class */
  function() {
    function o() {
    }
    return o.createHeader = function(t) {
      t === void 0 && (t = {});
      var e = "<?", r = "?>", n = ["version"];
      t.version || (t.version = "1.0"), t.encoding && n.push("encoding"), t.standalone && n.push("standalone");
      var i = n.map(function(a) {
        return "".concat(a, '="').concat(t[a], '"');
      }).join(" ");
      return "".concat(e, "xml ").concat(i, " ").concat(r);
    }, o.createXml = function(t, e) {
      var r = this, n = "";
      t.properties && (t.properties.prefixedAttributes && t.properties.prefixedAttributes.forEach(function(a) {
        Object.keys(a.map).forEach(function(s) {
          n += r.returnAttributeIfPopulated(a.prefix + s, a.map[s], e);
        });
      }), t.properties.rawMap && Object.keys(t.properties.rawMap).forEach(function(a) {
        n += r.returnAttributeIfPopulated(a, t.properties.rawMap[a], e);
      }));
      var i = "<" + t.name + n;
      return !t.children && t.textNode == null ? i + "/>" + rm : t.textNode != null ? i + ">" + t.textNode + "</" + t.name + ">" + rm : (i += ">" + rm, t.children && t.children.forEach(function(a) {
        i += r.createXml(a, e);
      }), i + "</" + t.name + ">" + rm);
    }, o.returnAttributeIfPopulated = function(t, e, r) {
      if (!e && e !== "" && e !== 0)
        return "";
      var n = e;
      return typeof e == "boolean" && r && (n = r(e)), " ".concat(t, '="').concat(n, '"');
    }, o;
  }()
), KJ = function(o) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && o[t], r = 0;
  if (e) return e.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && r >= o.length && (o = void 0), { value: o && o[r++], done: !o };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qJ = new Uint32Array([
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
]), XJ = (
  /** @class */
  function() {
    function o() {
    }
    return o.addFolders = function(t) {
      t.forEach(this.addFolder.bind(this));
    }, o.addFolder = function(t) {
      this.folders.push({
        path: t,
        created: /* @__PURE__ */ new Date(),
        isBase64: !1
      });
    }, o.addFile = function(t, e, r) {
      r === void 0 && (r = !1), this.files.push({
        path: t,
        created: /* @__PURE__ */ new Date(),
        content: e,
        isBase64: r
      });
    }, o.getContent = function(t) {
      t === void 0 && (t = "application/zip");
      var e = this.buildFileStream(), r = this.buildUint8Array(e);
      return this.clearStream(), new Blob([r], { type: t });
    }, o.clearStream = function() {
      this.folders = [], this.files = [];
    }, o.buildFileStream = function(t) {
      var e, r;
      t === void 0 && (t = "");
      var n = this.folders.concat(this.files), i = n.length, a = "", s = 0, l = 0;
      try {
        for (var u = KJ(n), c = u.next(); !c.done; c = u.next()) {
          var d = c.value, f = this.getHeader(d, s), v = f.fileHeader, g = f.folderHeader, m = f.content;
          s += v.length + m.length, l += g.length, t += v + m, a += g;
        }
      } catch (S) {
        e = { error: S };
      } finally {
        try {
          c && !c.done && (r = u.return) && r.call(u);
        } finally {
          if (e) throw e.error;
        }
      }
      var b = this.buildFolderEnd(i, l, s);
      return t + a + b;
    }, o.getHeader = function(t, e) {
      var r = t.content, n = t.path, i = t.created, a = t.isBase64, s = yt.utf8_encode, l = yt.decToHex, u = s(n), c = u !== n, d = this.convertTime(i), f = this.convertDate(i), v = "";
      if (c) {
        var g = l(1, 1) + l(this.getFromCrc32Table(u), 4) + u;
        v = "up" + l(g.length, 2) + g;
      }
      var m = r ? this.getConvertedContent(r, a) : { size: 0, content: "" }, b = m.size, S = m.content, R = `
\0` + (c ? "\0\b" : "\0\0") + "\0\0" + l(d, 2) + // last modified time
      l(f, 2) + // last modified date
      l(b ? this.getFromCrc32Table(S) : 0, 4) + l(b, 4) + // compressed size
      l(b, 4) + // uncompressed size
      l(u.length, 2) + // file name length
      l(v.length, 2), P = "PK" + R + u + v, D = "PK\0" + R + // file header
      "\0\0\0\0\0\0" + (r ? "\0\0\0\0" : "\0\0\0") + // external file attributes
      l(e, 4) + // relative offset of local header
      u + // file name
      v;
      return { fileHeader: P, folderHeader: D, content: S || "" };
    }, o.getConvertedContent = function(t, e) {
      return e === void 0 && (e = !1), e && (t = t.split(";base64,")[1]), t = e ? atob(t) : t, {
        size: t.length,
        content: t
      };
    }, o.buildFolderEnd = function(t, e, r) {
      var n = yt.decToHex;
      return "PK\0\0\0\0" + n(t, 2) + // total number of entries in the central folder
      n(t, 2) + // total number of entries in the central folder
      n(e, 4) + // size of the central folder
      n(r, 4) + // central folder start offset
      "\0\0";
    }, o.buildUint8Array = function(t) {
      for (var e = new Uint8Array(t.length), r = 0; r < e.length; r++)
        e[r] = t.charCodeAt(r);
      return e;
    }, o.getFromCrc32Table = function(t) {
      if (!t.length)
        return 0;
      for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)
        r[n] = t.charCodeAt(n);
      for (var i = -1, a = 0, s = 0, l = 0, n = 0; n < e; n++)
        a = r[n], s = (i ^ a) & 255, l = qJ[s], i = i >>> 8 ^ l;
      return i ^ -1;
    }, o.convertTime = function(t) {
      var e = t.getHours();
      return e <<= 6, e = e | t.getMinutes(), e <<= 5, e = e | t.getSeconds() / 2, e;
    }, o.convertDate = function(t) {
      var e = t.getFullYear() - 1980;
      return e <<= 4, e = e | t.getMonth() + 1, e <<= 5, e = e | t.getDate(), e;
    }, o.folders = [], o.files = [], o;
  }()
), aN = [QL, JL, iN];
Xt.registerModules(aN);
const ZJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbstractHeaderCellCtrl: vv,
  AgAbstractField: r_,
  AgAbstractLabel: t_,
  AgAutocomplete: OL,
  AgCheckbox: fv,
  AgDialog: RL,
  AgGroupComponent: EL,
  AgInputDateField: CL,
  AgInputNumberField: oC,
  AgInputRange: wL,
  AgInputTextArea: yL,
  AgInputTextField: zl,
  AgMenuItemComponent: Hd,
  AgMenuList: _L,
  AgMenuPanel: xL,
  AgPanel: y_,
  AgPickerField: n_,
  AgPromise: Zi,
  get AgPromiseStatus() {
    return Ju;
  },
  AgRadioButton: o_,
  AgRichSelect: bL,
  AgSelect: pv,
  AgSlider: SL,
  AgStackComponentsRegistry: C2,
  AgToggleButton: mL,
  AlignedGridsService: AL,
  AllCommunityModules: aN,
  AnimateShowChangeCellRenderer: CI,
  AnimateSlideCellRenderer: wI,
  AnimationFrameService: lL,
  AutoScrollService: u_,
  AutoWidthCalculator: cL,
  Autowired: N,
  get BarColumnLabelPlacement() {
    return YS;
  },
  BaseComponentWrapper: pJ,
  BaseCreator: eN,
  BaseGridSerializingSession: tN,
  Bean: Be,
  BeanStub: Me,
  Beans: f_,
  BodyDropPivotTarget: YI,
  BodyDropTarget: qI,
  CHART_TOOLBAR_ALLOW_LIST: vJ,
  CHART_TOOL_PANEL_ALLOW_LIST: hJ,
  CHART_TOOL_PANEL_MENU_OPTIONS: gJ,
  CellComp: $I,
  CellCtrl: Ml,
  CellNavigationService: DL,
  CellPositionUtils: UL,
  get CellRangeType() {
    return tc;
  },
  ChangedPath: gv,
  CheckboxCellEditor: TI,
  CheckboxCellRenderer: RI,
  CheckboxSelectionComponent: l_,
  ClientSideRowModelModule: QL,
  get ClientSideRowModelSteps() {
    return Pt;
  },
  ColDefUtil: AI,
  Column: cr,
  ColumnApi: dC,
  ColumnFactory: f2,
  ColumnGroup: pn,
  ColumnKeyCreator: zF,
  ColumnModel: g2,
  ColumnUtils: m2,
  Component: gt,
  ComponentUtil: R1,
  Context: t2,
  CssClassApplier: hv,
  CssClassManager: J2,
  CsvCreator: nN,
  CsvExportModule: iN,
  CtrlsService: YL,
  CustomTooltipFeature: nC,
  DEFAULT_CHART_GROUPS: fJ,
  DataTypeService: XL,
  DateCellEditor: _I,
  DateFilter: a_,
  DateStringCellEditor: xI,
  DisplayedGroupCreator: y2,
  Downloader: rN,
  DragAndDropService: fn,
  DragService: MI,
  get DragSourceType() {
    return ho;
  },
  Environment: BL,
  EventService: Ts,
  Events: G,
  get ExcelFactoryMode() {
    return Jh;
  },
  ExpansionService: uL,
  ExpressionService: IL,
  FilterManager: II,
  FloatingFilterMapper: PI,
  FocusService: VL,
  GROUP_AUTO_COLUMN_ID: vc,
  Grid: cJ,
  GridApi: c_,
  GridBodyComp: HI,
  GridBodyCtrl: kI,
  GridComp: C_,
  GridCoreCreator: b_,
  GridCtrl: kL,
  GridHeaderComp: nL,
  GridHeaderCtrl: rL,
  GridOptionsService: w_,
  GridSerializer: oN,
  GroupCellRenderer: BS,
  GroupCellRendererCtrl: SI,
  GroupInstanceIdCreator: x1,
  HeaderCellCtrl: QI,
  HeaderFilterCellComp: LI,
  HeaderFilterCellCtrl: ZI,
  HeaderGroupCellCtrl: JI,
  get HeaderNavigationDirection() {
    return Xi;
  },
  HeaderNavigationService: tL,
  HeaderPositionUtils: $L,
  HeaderRowComp: XI,
  HeaderRowContainerComp: bm,
  HeaderRowContainerCtrl: eL,
  HeaderRowCtrl: wm,
  get HeaderRowType() {
    return On;
  },
  get HorizontalDirection() {
    return Qn;
  },
  HorizontalResizeService: oL,
  InfiniteRowModelModule: JL,
  KeyCode: we,
  LargeTextCellEditor: mI,
  get LayoutCssClasses() {
    return rn;
  },
  LocaleService: qL,
  Logger: pC,
  LoggerFactory: NL,
  ManagedFocusFeature: $l,
  get ModuleNames() {
    return Ye;
  },
  ModuleRegistry: Xt,
  MouseEventService: WI,
  MoveColumnFeature: KI,
  NavigationService: jI,
  NumberCellEditor: EI,
  NumberFilter: s_,
  NumberSequence: gc,
  Optional: Lt,
  PaginationProxy: vL,
  PinnedRowModel: fL,
  PopupComponent: Yl,
  PopupEditorWrapper: UI,
  PopupService: TL,
  PositionableFeature: e_,
  PostConstruct: Fe,
  PreConstruct: PS,
  PreDestroy: eo,
  PropertyKeys: qi,
  ProvidedColumnGroup: Ur,
  ProvidedFilter: Qh,
  Qualifier: ii,
  QuerySelector: dz,
  RefSelector: ke,
  ResizeObserverService: sL,
  get RowAnimationCssClasses() {
    return yc;
  },
  RowContainerComp: zI,
  RowContainerCtrl: v_,
  get RowContainerName() {
    return Te;
  },
  get RowContainerType() {
    return dn;
  },
  RowCtrl: Fl,
  get RowHighlightPosition() {
    return Na;
  },
  RowNode: St,
  RowNodeBlock: ly,
  RowNodeBlockLoader: hL,
  RowNodeSorter: zL,
  RowPositionUtils: jL,
  RowRenderer: dL,
  get RowType() {
    return KS;
  },
  ScalarFilter: tn,
  ScrollVisibleService: BI,
  SelectCellEditor: yI,
  SelectableService: WL,
  get SelectionHandleType() {
    return ev;
  },
  get ServerSideTransactionResultStatus() {
    return $S;
  },
  SetLeftFeature: cC,
  SimpleFilter: Ir,
  SortController: GL,
  SortIndicatorComp: aC,
  StandardMenuFactory: iL,
  StylingService: gL,
  get TabGuardClassNames() {
    return uc;
  },
  TabGuardComp: vp,
  TabGuardCtrl: aL,
  TabbedLayout: wX,
  TemplateService: LL,
  TextCellEditor: HS,
  TextFilter: iC,
  TextFloatingFilter: gI,
  Timer: sz,
  TooltipFeature: uC,
  TouchListener: Go,
  UserComponentFactory: DI,
  UserComponentRegistry: OI,
  ValueCache: HL,
  ValueFormatterService: pL,
  ValueParserService: ZL,
  ValueService: FL,
  VanillaFrameworkOverrides: PL,
  get VerticalDirection() {
    return mc;
  },
  VirtualList: m_,
  VirtualListDragFeature: rK,
  XmlFactory: YJ,
  ZipContainer: XJ,
  _: yt,
  __FORCE_MODULE_DETECTION: mJ,
  createGrid: uJ,
  getRowContainerTypeForName: VI
}, Symbol.toStringTag, { value: "Module" })), Mn = /* @__PURE__ */ ZN(ZJ);
var fC = {}, Vo = {}, S_ = {}, _c = {};
Object.defineProperty(_c, "__esModule", { value: !0 });
_c.CustomContext = void 0;
var QJ = y;
_c.CustomContext = QJ.createContext({
  setMethods: function() {
  }
});
var qS = ce && ce.__assign || function() {
  return qS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, qS.apply(this, arguments);
}, JJ = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), eee = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), tee = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && JJ(t, o, e);
  return eee(t, o), t;
};
Object.defineProperty(S_, "__esModule", { value: !0 });
var dh = tee(y), ree = _c, nee = function(o) {
  var t = o.initialProps, e = o.addUpdateCallback, r = o.CustomComponentClass, n = o.setMethods, i = dh.useState(t), a = i[0], s = i[1];
  return dh.useEffect(function() {
    e(function(l) {
      return s(l);
    });
  }, []), dh.default.createElement(
    ree.CustomContext.Provider,
    { value: { setMethods: n } },
    dh.default.createElement(r, qS({}, a))
  );
};
S_.default = dh.memo(nee);
var mv = {}, E_ = {};
Object.defineProperty(E_, "__esModule", { value: !0 });
var oee = 0;
function iee() {
  return "agPortalKey_" + ++oee;
}
E_.default = iee;
var xc = {}, Vu = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var FP;
function aee() {
  if (FP) return Vu;
  FP = 1;
  var o = y;
  function t(T) {
    for (var L = "https://reactjs.org/docs/error-decoder.html?invariant=" + T, Y = 1; Y < arguments.length; Y++) L += "&args[]=" + encodeURIComponent(arguments[Y]);
    return "Minified React error #" + T + "; visit " + L + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var e = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, n = {}, i = {};
  function a(T) {
    return e.call(i, T) ? !0 : e.call(n, T) ? !1 : r.test(T) ? i[T] = !0 : (n[T] = !0, !1);
  }
  function s(T, L, Y, Q, be, ge, Re) {
    this.acceptsBooleans = L === 2 || L === 3 || L === 4, this.attributeName = Q, this.attributeNamespace = be, this.mustUseProperty = Y, this.propertyName = T, this.type = L, this.sanitizeURL = ge, this.removeEmptyString = Re;
  }
  var l = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(T) {
    l[T] = new s(T, 0, !1, T, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(T) {
    var L = T[0];
    l[L] = new s(L, 1, !1, T[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(T) {
    l[T] = new s(T, 2, !1, T.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(T) {
    l[T] = new s(T, 2, !1, T, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(T) {
    l[T] = new s(T, 3, !1, T.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(T) {
    l[T] = new s(T, 3, !0, T, null, !1, !1);
  }), ["capture", "download"].forEach(function(T) {
    l[T] = new s(T, 4, !1, T, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(T) {
    l[T] = new s(T, 6, !1, T, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(T) {
    l[T] = new s(T, 5, !1, T.toLowerCase(), null, !1, !1);
  });
  var u = /[\-:]([a-z])/g;
  function c(T) {
    return T[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(T) {
    var L = T.replace(
      u,
      c
    );
    l[L] = new s(L, 1, !1, T, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(T) {
    var L = T.replace(u, c);
    l[L] = new s(L, 1, !1, T, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(T) {
    var L = T.replace(u, c);
    l[L] = new s(L, 1, !1, T, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(T) {
    l[T] = new s(T, 1, !1, T.toLowerCase(), null, !1, !1);
  }), l.xlinkHref = new s("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(T) {
    l[T] = new s(T, 1, !1, T.toLowerCase(), null, !0, !0);
  });
  var d = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, f = ["Webkit", "ms", "Moz", "O"];
  Object.keys(d).forEach(function(T) {
    f.forEach(function(L) {
      L = L + T.charAt(0).toUpperCase() + T.substring(1), d[L] = d[T];
    });
  });
  var v = /["'&<>]/;
  function g(T) {
    if (typeof T == "boolean" || typeof T == "number") return "" + T;
    T = "" + T;
    var L = v.exec(T);
    if (L) {
      var Y = "", Q, be = 0;
      for (Q = L.index; Q < T.length; Q++) {
        switch (T.charCodeAt(Q)) {
          case 34:
            L = "&quot;";
            break;
          case 38:
            L = "&amp;";
            break;
          case 39:
            L = "&#x27;";
            break;
          case 60:
            L = "&lt;";
            break;
          case 62:
            L = "&gt;";
            break;
          default:
            continue;
        }
        be !== Q && (Y += T.substring(be, Q)), be = Q + 1, Y += L;
      }
      T = be !== Q ? Y + T.substring(be, Q) : Y;
    }
    return T;
  }
  var m = /([A-Z])/g, b = /^ms-/, S = Array.isArray;
  function R(T, L) {
    return { insertionMode: T, selectedValue: L };
  }
  function P(T, L, Y) {
    switch (L) {
      case "select":
        return R(1, Y.value != null ? Y.value : Y.defaultValue);
      case "svg":
        return R(2, null);
      case "math":
        return R(3, null);
      case "foreignObject":
        return R(1, null);
      case "table":
        return R(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return R(5, null);
      case "colgroup":
        return R(7, null);
      case "tr":
        return R(6, null);
    }
    return 4 <= T.insertionMode || T.insertionMode === 0 ? R(1, null) : T;
  }
  var D = /* @__PURE__ */ new Map();
  function x(T, L, Y) {
    if (typeof Y != "object") throw Error(t(62));
    L = !0;
    for (var Q in Y) if (e.call(Y, Q)) {
      var be = Y[Q];
      if (be != null && typeof be != "boolean" && be !== "") {
        if (Q.indexOf("--") === 0) {
          var ge = g(Q);
          be = g(("" + be).trim());
        } else {
          ge = Q;
          var Re = D.get(ge);
          Re !== void 0 || (Re = g(ge.replace(m, "-$1").toLowerCase().replace(b, "-ms-")), D.set(ge, Re)), ge = Re, be = typeof be == "number" ? be === 0 || e.call(d, Q) ? "" + be : be + "px" : g(("" + be).trim());
        }
        L ? (L = !1, T.push(' style="', ge, ":", be)) : T.push(";", ge, ":", be);
      }
    }
    L || T.push('"');
  }
  function M(T, L, Y, Q) {
    switch (Y) {
      case "style":
        x(T, L, Q);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < Y.length) || Y[0] !== "o" && Y[0] !== "O" || Y[1] !== "n" && Y[1] !== "N") {
      if (L = l.hasOwnProperty(Y) ? l[Y] : null, L !== null) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!L.acceptsBooleans) return;
        }
        switch (Y = L.attributeName, L.type) {
          case 3:
            Q && T.push(" ", Y, '=""');
            break;
          case 4:
            Q === !0 ? T.push(" ", Y, '=""') : Q !== !1 && T.push(" ", Y, '="', g(Q), '"');
            break;
          case 5:
            isNaN(Q) || T.push(" ", Y, '="', g(Q), '"');
            break;
          case 6:
            !isNaN(Q) && 1 <= Q && T.push(" ", Y, '="', g(Q), '"');
            break;
          default:
            L.sanitizeURL && (Q = "" + Q), T.push(" ", Y, '="', g(Q), '"');
        }
      } else if (a(Y)) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (L = Y.toLowerCase().slice(0, 5), L !== "data-" && L !== "aria-") return;
        }
        T.push(" ", Y, '="', g(Q), '"');
      }
    }
  }
  function F(T, L, Y) {
    if (L != null) {
      if (Y != null) throw Error(t(60));
      if (typeof L != "object" || !("__html" in L)) throw Error(t(61));
      L = L.__html, L != null && T.push("" + L);
    }
  }
  function H(T) {
    var L = "";
    return o.Children.forEach(T, function(Y) {
      Y != null && (L += Y);
    }), L;
  }
  function B(T, L, Y, Q) {
    T.push(W(Y));
    var be = Y = null, ge;
    for (ge in L) if (e.call(L, ge)) {
      var Re = L[ge];
      if (Re != null) switch (ge) {
        case "children":
          Y = Re;
          break;
        case "dangerouslySetInnerHTML":
          be = Re;
          break;
        default:
          M(T, Q, ge, Re);
      }
    }
    return T.push(">"), F(T, be, Y), typeof Y == "string" ? (T.push(g(Y)), null) : Y;
  }
  var j = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, V = /* @__PURE__ */ new Map();
  function W(T) {
    var L = V.get(T);
    if (L === void 0) {
      if (!j.test(T)) throw Error(t(65, T));
      L = "<" + T, V.set(T, L);
    }
    return L;
  }
  function q(T, L, Y, Q, be) {
    switch (L) {
      case "select":
        T.push(W("select"));
        var ge = null, Re = null;
        for (Qe in Y) if (e.call(Y, Qe)) {
          var Ge = Y[Qe];
          if (Ge != null) switch (Qe) {
            case "children":
              ge = Ge;
              break;
            case "dangerouslySetInnerHTML":
              Re = Ge;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              M(T, Q, Qe, Ge);
          }
        }
        return T.push(">"), F(T, Re, ge), ge;
      case "option":
        Re = be.selectedValue, T.push(W("option"));
        var qe = Ge = null, it = null, Qe = null;
        for (ge in Y) if (e.call(Y, ge)) {
          var Wt = Y[ge];
          if (Wt != null) switch (ge) {
            case "children":
              Ge = Wt;
              break;
            case "selected":
              it = Wt;
              break;
            case "dangerouslySetInnerHTML":
              Qe = Wt;
              break;
            case "value":
              qe = Wt;
            default:
              M(T, Q, ge, Wt);
          }
        }
        if (Re != null) if (Y = qe !== null ? "" + qe : H(Ge), S(Re)) {
          for (Q = 0; Q < Re.length; Q++)
            if ("" + Re[Q] === Y) {
              T.push(' selected=""');
              break;
            }
        } else "" + Re === Y && T.push(' selected=""');
        else it && T.push(' selected=""');
        return T.push(">"), F(T, Qe, Ge), Ge;
      case "textarea":
        T.push(W("textarea")), Qe = Re = ge = null;
        for (Ge in Y) if (e.call(Y, Ge) && (qe = Y[Ge], qe != null)) switch (Ge) {
          case "children":
            Qe = qe;
            break;
          case "value":
            ge = qe;
            break;
          case "defaultValue":
            Re = qe;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            M(
              T,
              Q,
              Ge,
              qe
            );
        }
        if (ge === null && Re !== null && (ge = Re), T.push(">"), Qe != null) {
          if (ge != null) throw Error(t(92));
          if (S(Qe) && 1 < Qe.length) throw Error(t(93));
          ge = "" + Qe;
        }
        return typeof ge == "string" && ge[0] === `
` && T.push(`
`), ge !== null && T.push(g("" + ge)), null;
      case "input":
        T.push(W("input")), qe = Qe = Ge = ge = null;
        for (Re in Y) if (e.call(Y, Re) && (it = Y[Re], it != null)) switch (Re) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            qe = it;
            break;
          case "defaultValue":
            Ge = it;
            break;
          case "checked":
            Qe = it;
            break;
          case "value":
            ge = it;
            break;
          default:
            M(T, Q, Re, it);
        }
        return Qe !== null ? M(T, Q, "checked", Qe) : qe !== null && M(T, Q, "checked", qe), ge !== null ? M(T, Q, "value", ge) : Ge !== null && M(T, Q, "value", Ge), T.push("/>"), null;
      case "menuitem":
        T.push(W("menuitem"));
        for (var _n in Y) if (e.call(Y, _n) && (ge = Y[_n], ge != null)) switch (_n) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            M(T, Q, _n, ge);
        }
        return T.push(">"), null;
      case "title":
        T.push(W("title")), ge = null;
        for (Wt in Y) if (e.call(Y, Wt) && (Re = Y[Wt], Re != null)) switch (Wt) {
          case "children":
            ge = Re;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            M(T, Q, Wt, Re);
        }
        return T.push(">"), ge;
      case "listing":
      case "pre":
        T.push(W(L)), Re = ge = null;
        for (qe in Y) if (e.call(Y, qe) && (Ge = Y[qe], Ge != null)) switch (qe) {
          case "children":
            ge = Ge;
            break;
          case "dangerouslySetInnerHTML":
            Re = Ge;
            break;
          default:
            M(T, Q, qe, Ge);
        }
        if (T.push(">"), Re != null) {
          if (ge != null) throw Error(t(60));
          if (typeof Re != "object" || !("__html" in Re)) throw Error(t(61));
          Y = Re.__html, Y != null && (typeof Y == "string" && 0 < Y.length && Y[0] === `
` ? T.push(`
`, Y) : T.push("" + Y));
        }
        return typeof ge == "string" && ge[0] === `
` && T.push(`
`), ge;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        T.push(W(L));
        for (var xn in Y) if (e.call(Y, xn) && (ge = Y[xn], ge != null)) switch (xn) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, L));
          default:
            M(T, Q, xn, ge);
        }
        return T.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return B(
          T,
          Y,
          L,
          Q
        );
      case "html":
        return be.insertionMode === 0 && T.push("<!DOCTYPE html>"), B(T, Y, L, Q);
      default:
        if (L.indexOf("-") === -1 && typeof Y.is != "string") return B(T, Y, L, Q);
        T.push(W(L)), Re = ge = null;
        for (it in Y) if (e.call(Y, it) && (Ge = Y[it], Ge != null)) switch (it) {
          case "children":
            ge = Ge;
            break;
          case "dangerouslySetInnerHTML":
            Re = Ge;
            break;
          case "style":
            x(T, Q, Ge);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            a(it) && typeof Ge != "function" && typeof Ge != "symbol" && T.push(" ", it, '="', g(Ge), '"');
        }
        return T.push(">"), F(T, Re, ge), ge;
    }
  }
  function ee(T, L, Y) {
    if (T.push('<!--$?--><template id="'), Y === null) throw Error(t(395));
    return T.push(Y), T.push('"></template>');
  }
  function re(T, L, Y, Q) {
    switch (Y.insertionMode) {
      case 0:
      case 1:
        return T.push('<div hidden id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 2:
        return T.push('<svg aria-hidden="true" style="display:none" id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 3:
        return T.push('<math aria-hidden="true" style="display:none" id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 4:
        return T.push('<table hidden id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 5:
        return T.push('<table hidden><tbody id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 6:
        return T.push('<table hidden><tr id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      case 7:
        return T.push('<table hidden><colgroup id="'), T.push(L.segmentPrefix), L = Q.toString(16), T.push(L), T.push('">');
      default:
        throw Error(t(397));
    }
  }
  function ie(T, L) {
    switch (L.insertionMode) {
      case 0:
      case 1:
        return T.push("</div>");
      case 2:
        return T.push("</svg>");
      case 3:
        return T.push("</math>");
      case 4:
        return T.push("</table>");
      case 5:
        return T.push("</tbody></table>");
      case 6:
        return T.push("</tr></table>");
      case 7:
        return T.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var ne = /[<\u2028\u2029]/g;
  function se(T) {
    return JSON.stringify(T).replace(ne, function(L) {
      switch (L) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function pe(T, L) {
    return L = L === void 0 ? "" : L, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: L + "P:", segmentPrefix: L + "S:", boundaryPrefix: L + "B:", idPrefix: L, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: T };
  }
  function K(T, L, Y, Q) {
    return Y.generateStaticMarkup ? (T.push(g(L)), !1) : (L === "" ? T = Q : (Q && T.push("<!-- -->"), T.push(g(L)), T = !0), T);
  }
  var J = Object.assign, ue = Symbol.for("react.element"), he = Symbol.for("react.portal"), fe = Symbol.for("react.fragment"), ae = Symbol.for("react.strict_mode"), oe = Symbol.for("react.profiler"), ve = Symbol.for("react.provider"), _e = Symbol.for("react.context"), le = Symbol.for("react.forward_ref"), Ee = Symbol.for("react.suspense"), de = Symbol.for("react.suspense_list"), X = Symbol.for("react.memo"), xe = Symbol.for("react.lazy"), Le = Symbol.for("react.scope"), Ue = Symbol.for("react.debug_trace_mode"), He = Symbol.for("react.legacy_hidden"), et = Symbol.for("react.default_value"), $e = Symbol.iterator;
  function pt(T) {
    if (T == null) return null;
    if (typeof T == "function") return T.displayName || T.name || null;
    if (typeof T == "string") return T;
    switch (T) {
      case fe:
        return "Fragment";
      case he:
        return "Portal";
      case oe:
        return "Profiler";
      case ae:
        return "StrictMode";
      case Ee:
        return "Suspense";
      case de:
        return "SuspenseList";
    }
    if (typeof T == "object") switch (T.$$typeof) {
      case _e:
        return (T.displayName || "Context") + ".Consumer";
      case ve:
        return (T._context.displayName || "Context") + ".Provider";
      case le:
        var L = T.render;
        return T = T.displayName, T || (T = L.displayName || L.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
      case X:
        return L = T.displayName || null, L !== null ? L : pt(T.type) || "Memo";
      case xe:
        L = T._payload, T = T._init;
        try {
          return pt(T(L));
        } catch {
        }
    }
    return null;
  }
  var st = {};
  function Bt(T, L) {
    if (T = T.contextTypes, !T) return st;
    var Y = {}, Q;
    for (Q in T) Y[Q] = L[Q];
    return Y;
  }
  var vt = null;
  function nt(T, L) {
    if (T !== L) {
      T.context._currentValue2 = T.parentValue, T = T.parent;
      var Y = L.parent;
      if (T === null) {
        if (Y !== null) throw Error(t(401));
      } else {
        if (Y === null) throw Error(t(401));
        nt(T, Y);
      }
      L.context._currentValue2 = L.value;
    }
  }
  function ze(T) {
    T.context._currentValue2 = T.parentValue, T = T.parent, T !== null && ze(T);
  }
  function Ct(T) {
    var L = T.parent;
    L !== null && Ct(L), T.context._currentValue2 = T.value;
  }
  function Mt(T, L) {
    if (T.context._currentValue2 = T.parentValue, T = T.parent, T === null) throw Error(t(402));
    T.depth === L.depth ? nt(T, L) : Mt(T, L);
  }
  function fr(T, L) {
    var Y = L.parent;
    if (Y === null) throw Error(t(402));
    T.depth === Y.depth ? nt(T, Y) : fr(T, Y), L.context._currentValue2 = L.value;
  }
  function lt(T) {
    var L = vt;
    L !== T && (L === null ? Ct(T) : T === null ? ze(L) : L.depth === T.depth ? nt(L, T) : L.depth > T.depth ? Mt(L, T) : fr(L, T), vt = T);
  }
  var Et = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(T, L) {
    T = T._reactInternals, T.queue !== null && T.queue.push(L);
  }, enqueueReplaceState: function(T, L) {
    T = T._reactInternals, T.replace = !0, T.queue = [L];
  }, enqueueForceUpdate: function() {
  } };
  function kt(T, L, Y, Q) {
    var be = T.state !== void 0 ? T.state : null;
    T.updater = Et, T.props = Y, T.state = be;
    var ge = { queue: [], replace: !1 };
    T._reactInternals = ge;
    var Re = L.contextType;
    if (T.context = typeof Re == "object" && Re !== null ? Re._currentValue2 : Q, Re = L.getDerivedStateFromProps, typeof Re == "function" && (Re = Re(Y, be), be = Re == null ? be : J({}, be, Re), T.state = be), typeof L.getDerivedStateFromProps != "function" && typeof T.getSnapshotBeforeUpdate != "function" && (typeof T.UNSAFE_componentWillMount == "function" || typeof T.componentWillMount == "function")) if (L = T.state, typeof T.componentWillMount == "function" && T.componentWillMount(), typeof T.UNSAFE_componentWillMount == "function" && T.UNSAFE_componentWillMount(), L !== T.state && Et.enqueueReplaceState(T, T.state, null), ge.queue !== null && 0 < ge.queue.length) if (L = ge.queue, Re = ge.replace, ge.queue = null, ge.replace = !1, Re && L.length === 1) T.state = L[0];
    else {
      for (ge = Re ? L[0] : T.state, be = !0, Re = Re ? 1 : 0; Re < L.length; Re++) {
        var Ge = L[Re];
        Ge = typeof Ge == "function" ? Ge.call(T, ge, Y, Q) : Ge, Ge != null && (be ? (be = !1, ge = J({}, ge, Ge)) : J(ge, Ge));
      }
      T.state = ge;
    }
    else ge.queue = null;
  }
  var $t = { id: 1, overflow: "" };
  function br(T, L, Y) {
    var Q = T.id;
    T = T.overflow;
    var be = 32 - mt(Q) - 1;
    Q &= ~(1 << be), Y += 1;
    var ge = 32 - mt(L) + be;
    if (30 < ge) {
      var Re = be - be % 5;
      return ge = (Q & (1 << Re) - 1).toString(32), Q >>= Re, be -= Re, { id: 1 << 32 - mt(L) + be | Y << be | Q, overflow: ge + T };
    }
    return { id: 1 << ge | Y << be | Q, overflow: T };
  }
  var mt = Math.clz32 ? Math.clz32 : zt, rt = Math.log, Gt = Math.LN2;
  function zt(T) {
    return T >>>= 0, T === 0 ? 32 : 31 - (rt(T) / Gt | 0) | 0;
  }
  function Ze(T, L) {
    return T === L && (T !== 0 || 1 / T === 1 / L) || T !== T && L !== L;
  }
  var Un = typeof Object.is == "function" ? Object.is : Ze, Kr = null, ln = null, Ft = null, ot = null, Gr = !1, wt = !1, Qt = 0, Sr = null, jr = 0;
  function $n() {
    if (Kr === null) throw Error(t(321));
    return Kr;
  }
  function Er() {
    if (0 < jr) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ja() {
    return ot === null ? Ft === null ? (Gr = !1, Ft = ot = Er()) : (Gr = !0, ot = Ft) : ot.next === null ? (Gr = !1, ot = ot.next = Er()) : (Gr = !0, ot = ot.next), ot;
  }
  function Ua() {
    ln = Kr = null, wt = !1, Ft = null, jr = 0, ot = Sr = null;
  }
  function Ps(T, L) {
    return typeof L == "function" ? L(T) : L;
  }
  function Vr(T, L, Y) {
    if (Kr = $n(), ot = ja(), Gr) {
      var Q = ot.queue;
      if (L = Q.dispatch, Sr !== null && (Y = Sr.get(Q), Y !== void 0)) {
        Sr.delete(Q), Q = ot.memoizedState;
        do
          Q = T(Q, Y.action), Y = Y.next;
        while (Y !== null);
        return ot.memoizedState = Q, [Q, L];
      }
      return [ot.memoizedState, L];
    }
    return T = T === Ps ? typeof L == "function" ? L() : L : Y !== void 0 ? Y(L) : L, ot.memoizedState = T, T = ot.queue = { last: null, dispatch: null }, T = T.dispatch = Kl.bind(null, Kr, T), [ot.memoizedState, T];
  }
  function $a(T, L) {
    if (Kr = $n(), ot = ja(), L = L === void 0 ? null : L, ot !== null) {
      var Y = ot.memoizedState;
      if (Y !== null && L !== null) {
        var Q = Y[1];
        e: if (Q === null) Q = !1;
        else {
          for (var be = 0; be < Q.length && be < L.length; be++) if (!Un(L[be], Q[be])) {
            Q = !1;
            break e;
          }
          Q = !0;
        }
        if (Q) return Y[0];
      }
    }
    return T = T(), ot.memoizedState = [T, L], T;
  }
  function Kl(T, L, Y) {
    if (25 <= jr) throw Error(t(301));
    if (T === Kr) if (wt = !0, T = { action: Y, next: null }, Sr === null && (Sr = /* @__PURE__ */ new Map()), Y = Sr.get(L), Y === void 0) Sr.set(L, T);
    else {
      for (L = Y; L.next !== null; ) L = L.next;
      L.next = T;
    }
  }
  function ql() {
    throw Error(t(394));
  }
  function vo() {
  }
  var za = { readContext: function(T) {
    return T._currentValue2;
  }, useContext: function(T) {
    return $n(), T._currentValue2;
  }, useMemo: $a, useReducer: Vr, useRef: function(T) {
    Kr = $n(), ot = ja();
    var L = ot.memoizedState;
    return L === null ? (T = { current: T }, ot.memoizedState = T) : L;
  }, useState: function(T) {
    return Vr(Ps, T);
  }, useInsertionEffect: vo, useLayoutEffect: function() {
  }, useCallback: function(T, L) {
    return $a(function() {
      return T;
    }, L);
  }, useImperativeHandle: vo, useEffect: vo, useDebugValue: vo, useDeferredValue: function(T) {
    return $n(), T;
  }, useTransition: function() {
    return $n(), [
      !1,
      ql
    ];
  }, useId: function() {
    var T = ln.treeContext, L = T.overflow;
    T = T.id, T = (T & ~(1 << 32 - mt(T) - 1)).toString(32) + L;
    var Y = sa;
    if (Y === null) throw Error(t(404));
    return L = Qt++, T = ":" + Y.idPrefix + "R" + T, 0 < L && (T += "H" + L.toString(32)), T + ":";
  }, useMutableSource: function(T, L) {
    return $n(), L(T._source);
  }, useSyncExternalStore: function(T, L, Y) {
    if (Y === void 0) throw Error(t(407));
    return Y();
  } }, sa = null, pi = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function In(T) {
    return console.error(T), null;
  }
  function go() {
  }
  function la(T, L, Y, Q, be, ge, Re, Ge, qe) {
    var it = [], Qe = /* @__PURE__ */ new Set();
    return L = { destination: null, responseState: L, progressiveChunkSize: Q === void 0 ? 12800 : Q, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: Qe, pingedTasks: it, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: be === void 0 ? In : be, onAllReady: go, onShellReady: Re === void 0 ? go : Re, onShellError: go, onFatalError: go }, Y = hi(L, 0, null, Y, !1, !1), Y.parentFlushed = !0, T = fi(L, T, null, Y, Qe, st, null, $t), it.push(T), L;
  }
  function fi(T, L, Y, Q, be, ge, Re, Ge) {
    T.allPendingTasks++, Y === null ? T.pendingRootTasks++ : Y.pendingTasks++;
    var qe = { node: L, ping: function() {
      var it = T.pingedTasks;
      it.push(qe), it.length === 1 && Sn(T);
    }, blockedBoundary: Y, blockedSegment: Q, abortSet: be, legacyContext: ge, context: Re, treeContext: Ge };
    return be.add(qe), qe;
  }
  function hi(T, L, Y, Q, be, ge) {
    return { status: 0, id: -1, index: L, parentFlushed: !1, chunks: [], children: [], formatContext: Q, boundary: Y, lastPushedText: be, textEmbedded: ge };
  }
  function mo(T, L) {
    if (T = T.onError(L), T != null && typeof T != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof T + '" instead');
    return T;
  }
  function vi(T, L) {
    var Y = T.onShellError;
    Y(L), Y = T.onFatalError, Y(L), T.destination !== null ? (T.status = 2, T.destination.destroy(L)) : (T.status = 1, T.fatalError = L);
  }
  function Ln(T, L, Y, Q, be) {
    for (Kr = {}, ln = L, Qt = 0, T = Y(Q, be); wt; ) wt = !1, Qt = 0, jr += 1, ot = null, T = Y(Q, be);
    return Ua(), T;
  }
  function Ds(T, L, Y, Q) {
    var be = Y.render(), ge = Q.childContextTypes;
    if (ge != null) {
      var Re = L.legacyContext;
      if (typeof Y.getChildContext != "function") Q = Re;
      else {
        Y = Y.getChildContext();
        for (var Ge in Y) if (!(Ge in ge)) throw Error(t(108, pt(Q) || "Unknown", Ge));
        Q = J({}, Re, Y);
      }
      L.legacyContext = Q, Hr(T, L, be), L.legacyContext = Re;
    } else Hr(T, L, be);
  }
  function As(T, L) {
    if (T && T.defaultProps) {
      L = J({}, L), T = T.defaultProps;
      for (var Y in T) L[Y] === void 0 && (L[Y] = T[Y]);
      return L;
    }
    return L;
  }
  function Ho(T, L, Y, Q, be) {
    if (typeof Y == "function") if (Y.prototype && Y.prototype.isReactComponent) {
      be = Bt(Y, L.legacyContext);
      var ge = Y.contextType;
      ge = new Y(Q, typeof ge == "object" && ge !== null ? ge._currentValue2 : be), kt(ge, Y, Q, be), Ds(T, L, ge, Y);
    } else {
      ge = Bt(Y, L.legacyContext), be = Ln(T, L, Y, Q, ge);
      var Re = Qt !== 0;
      if (typeof be == "object" && be !== null && typeof be.render == "function" && be.$$typeof === void 0) kt(be, Y, Q, ge), Ds(T, L, be, Y);
      else if (Re) {
        Q = L.treeContext, L.treeContext = br(Q, 1, 0);
        try {
          Hr(T, L, be);
        } finally {
          L.treeContext = Q;
        }
      } else Hr(T, L, be);
    }
    else if (typeof Y == "string") {
      switch (be = L.blockedSegment, ge = q(be.chunks, Y, Q, T.responseState, be.formatContext), be.lastPushedText = !1, Re = be.formatContext, be.formatContext = P(Re, Y, Q), Co(T, L, ge), be.formatContext = Re, Y) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          be.chunks.push("</", Y, ">");
      }
      be.lastPushedText = !1;
    } else {
      switch (Y) {
        case He:
        case Ue:
        case ae:
        case oe:
        case fe:
          Hr(T, L, Q.children);
          return;
        case de:
          Hr(T, L, Q.children);
          return;
        case Le:
          throw Error(t(343));
        case Ee:
          e: {
            Y = L.blockedBoundary, be = L.blockedSegment, ge = Q.fallback, Q = Q.children, Re = /* @__PURE__ */ new Set();
            var Ge = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Re, errorDigest: null }, qe = hi(T, be.chunks.length, Ge, be.formatContext, !1, !1);
            be.children.push(qe), be.lastPushedText = !1;
            var it = hi(T, 0, null, be.formatContext, !1, !1);
            it.parentFlushed = !0, L.blockedBoundary = Ge, L.blockedSegment = it;
            try {
              if (Co(
                T,
                L,
                Q
              ), T.responseState.generateStaticMarkup || it.lastPushedText && it.textEmbedded && it.chunks.push("<!-- -->"), it.status = 1, to(Ge, it), Ge.pendingTasks === 0) break e;
            } catch (Qe) {
              it.status = 4, Ge.forceClientRender = !0, Ge.errorDigest = mo(T, Qe);
            } finally {
              L.blockedBoundary = Y, L.blockedSegment = be;
            }
            L = fi(T, ge, Y, qe, Re, L.legacyContext, L.context, L.treeContext), T.pingedTasks.push(L);
          }
          return;
      }
      if (typeof Y == "object" && Y !== null) switch (Y.$$typeof) {
        case le:
          if (Q = Ln(T, L, Y.render, Q, be), Qt !== 0) {
            Y = L.treeContext, L.treeContext = br(Y, 1, 0);
            try {
              Hr(T, L, Q);
            } finally {
              L.treeContext = Y;
            }
          } else Hr(T, L, Q);
          return;
        case X:
          Y = Y.type, Q = As(Y, Q), Ho(T, L, Y, Q, be);
          return;
        case ve:
          if (be = Q.children, Y = Y._context, Q = Q.value, ge = Y._currentValue2, Y._currentValue2 = Q, Re = vt, vt = Q = { parent: Re, depth: Re === null ? 0 : Re.depth + 1, context: Y, parentValue: ge, value: Q }, L.context = Q, Hr(T, L, be), T = vt, T === null) throw Error(t(403));
          Q = T.parentValue, T.context._currentValue2 = Q === et ? T.context._defaultValue : Q, T = vt = T.parent, L.context = T;
          return;
        case _e:
          Q = Q.children, Q = Q(Y._currentValue2), Hr(T, L, Q);
          return;
        case xe:
          be = Y._init, Y = be(Y._payload), Q = As(Y, Q), Ho(
            T,
            L,
            Y,
            Q,
            void 0
          );
          return;
      }
      throw Error(t(130, Y == null ? Y : typeof Y, ""));
    }
  }
  function Hr(T, L, Y) {
    if (L.node = Y, typeof Y == "object" && Y !== null) {
      switch (Y.$$typeof) {
        case ue:
          Ho(T, L, Y.type, Y.props, Y.ref);
          return;
        case he:
          throw Error(t(257));
        case xe:
          var Q = Y._init;
          Y = Q(Y._payload), Hr(T, L, Y);
          return;
      }
      if (S(Y)) {
        yo(T, L, Y);
        return;
      }
      if (Y === null || typeof Y != "object" ? Q = null : (Q = $e && Y[$e] || Y["@@iterator"], Q = typeof Q == "function" ? Q : null), Q && (Q = Q.call(Y))) {
        if (Y = Q.next(), !Y.done) {
          var be = [];
          do
            be.push(Y.value), Y = Q.next();
          while (!Y.done);
          yo(T, L, be);
        }
        return;
      }
      throw T = Object.prototype.toString.call(Y), Error(t(31, T === "[object Object]" ? "object with keys {" + Object.keys(Y).join(", ") + "}" : T));
    }
    typeof Y == "string" ? (Q = L.blockedSegment, Q.lastPushedText = K(L.blockedSegment.chunks, Y, T.responseState, Q.lastPushedText)) : typeof Y == "number" && (Q = L.blockedSegment, Q.lastPushedText = K(L.blockedSegment.chunks, "" + Y, T.responseState, Q.lastPushedText));
  }
  function yo(T, L, Y) {
    for (var Q = Y.length, be = 0; be < Q; be++) {
      var ge = L.treeContext;
      L.treeContext = br(ge, Q, be);
      try {
        Co(T, L, Y[be]);
      } finally {
        L.treeContext = ge;
      }
    }
  }
  function Co(T, L, Y) {
    var Q = L.blockedSegment.formatContext, be = L.legacyContext, ge = L.context;
    try {
      return Hr(T, L, Y);
    } catch (qe) {
      if (Ua(), typeof qe == "object" && qe !== null && typeof qe.then == "function") {
        Y = qe;
        var Re = L.blockedSegment, Ge = hi(T, Re.chunks.length, null, Re.formatContext, Re.lastPushedText, !0);
        Re.children.push(Ge), Re.lastPushedText = !1, T = fi(T, L.node, L.blockedBoundary, Ge, L.abortSet, L.legacyContext, L.context, L.treeContext).ping, Y.then(T, T), L.blockedSegment.formatContext = Q, L.legacyContext = be, L.context = ge, lt(ge);
      } else throw L.blockedSegment.formatContext = Q, L.legacyContext = be, L.context = ge, lt(ge), qe;
    }
  }
  function gi(T) {
    var L = T.blockedBoundary;
    T = T.blockedSegment, T.status = 3, wo(this, L, T);
  }
  function ua(T, L, Y) {
    var Q = T.blockedBoundary;
    T.blockedSegment.status = 3, Q === null ? (L.allPendingTasks--, L.status !== 2 && (L.status = 2, L.destination !== null && L.destination.push(null))) : (Q.pendingTasks--, Q.forceClientRender || (Q.forceClientRender = !0, T = Y === void 0 ? Error(t(432)) : Y, Q.errorDigest = L.onError(T), Q.parentFlushed && L.clientRenderedBoundaries.push(Q)), Q.fallbackAbortableTasks.forEach(function(be) {
      return ua(be, L, Y);
    }), Q.fallbackAbortableTasks.clear(), L.allPendingTasks--, L.allPendingTasks === 0 && (Q = L.onAllReady, Q()));
  }
  function to(T, L) {
    if (L.chunks.length === 0 && L.children.length === 1 && L.children[0].boundary === null) {
      var Y = L.children[0];
      Y.id = L.id, Y.parentFlushed = !0, Y.status === 1 && to(T, Y);
    } else T.completedSegments.push(L);
  }
  function wo(T, L, Y) {
    if (L === null) {
      if (Y.parentFlushed) {
        if (T.completedRootSegment !== null) throw Error(t(389));
        T.completedRootSegment = Y;
      }
      T.pendingRootTasks--, T.pendingRootTasks === 0 && (T.onShellError = go, L = T.onShellReady, L());
    } else L.pendingTasks--, L.forceClientRender || (L.pendingTasks === 0 ? (Y.parentFlushed && Y.status === 1 && to(L, Y), L.parentFlushed && T.completedBoundaries.push(L), L.fallbackAbortableTasks.forEach(gi, T), L.fallbackAbortableTasks.clear()) : Y.parentFlushed && Y.status === 1 && (to(L, Y), L.completedSegments.length === 1 && L.parentFlushed && T.partialBoundaries.push(L)));
    T.allPendingTasks--, T.allPendingTasks === 0 && (T = T.onAllReady, T());
  }
  function Sn(T) {
    if (T.status !== 2) {
      var L = vt, Y = pi.current;
      pi.current = za;
      var Q = sa;
      sa = T.responseState;
      try {
        var be = T.pingedTasks, ge;
        for (ge = 0; ge < be.length; ge++) {
          var Re = be[ge], Ge = T, qe = Re.blockedSegment;
          if (qe.status === 0) {
            lt(Re.context);
            try {
              Hr(Ge, Re, Re.node), Ge.responseState.generateStaticMarkup || qe.lastPushedText && qe.textEmbedded && qe.chunks.push("<!-- -->"), Re.abortSet.delete(Re), qe.status = 1, wo(Ge, Re.blockedBoundary, qe);
            } catch (Rn) {
              if (Ua(), typeof Rn == "object" && Rn !== null && typeof Rn.then == "function") {
                var it = Re.ping;
                Rn.then(it, it);
              } else {
                Re.abortSet.delete(Re), qe.status = 4;
                var Qe = Re.blockedBoundary, Wt = Rn, _n = mo(Ge, Wt);
                if (Qe === null ? vi(Ge, Wt) : (Qe.pendingTasks--, Qe.forceClientRender || (Qe.forceClientRender = !0, Qe.errorDigest = _n, Qe.parentFlushed && Ge.clientRenderedBoundaries.push(Qe))), Ge.allPendingTasks--, Ge.allPendingTasks === 0) {
                  var xn = Ge.onAllReady;
                  xn();
                }
              }
            } finally {
            }
          }
        }
        be.splice(0, ge), T.destination !== null && En(T, T.destination);
      } catch (Rn) {
        mo(T, Rn), vi(T, Rn);
      } finally {
        sa = Q, pi.current = Y, Y === za && lt(L);
      }
    }
  }
  function mi(T, L, Y) {
    switch (Y.parentFlushed = !0, Y.status) {
      case 0:
        var Q = Y.id = T.nextSegmentId++;
        return Y.lastPushedText = !1, Y.textEmbedded = !1, T = T.responseState, L.push('<template id="'), L.push(T.placeholderPrefix), T = Q.toString(16), L.push(T), L.push('"></template>');
      case 1:
        Y.status = 2;
        var be = !0;
        Q = Y.chunks;
        var ge = 0;
        Y = Y.children;
        for (var Re = 0; Re < Y.length; Re++) {
          for (be = Y[Re]; ge < be.index; ge++) L.push(Q[ge]);
          be = Ni(T, L, be);
        }
        for (; ge < Q.length - 1; ge++) L.push(Q[ge]);
        return ge < Q.length && (be = L.push(Q[ge])), be;
      default:
        throw Error(t(390));
    }
  }
  function Ni(T, L, Y) {
    var Q = Y.boundary;
    if (Q === null) return mi(T, L, Y);
    if (Q.parentFlushed = !0, Q.forceClientRender) return T.responseState.generateStaticMarkup || (Q = Q.errorDigest, L.push("<!--$!-->"), L.push("<template"), Q && (L.push(' data-dgst="'), Q = g(Q), L.push(Q), L.push('"')), L.push("></template>")), mi(T, L, Y), T = T.responseState.generateStaticMarkup ? !0 : L.push("<!--/$-->"), T;
    if (0 < Q.pendingTasks) {
      Q.rootSegmentID = T.nextSegmentId++, 0 < Q.completedSegments.length && T.partialBoundaries.push(Q);
      var be = T.responseState, ge = be.nextSuspenseID++;
      return be = be.boundaryPrefix + ge.toString(16), Q = Q.id = be, ee(L, T.responseState, Q), mi(T, L, Y), L.push("<!--/$-->");
    }
    if (Q.byteSize > T.progressiveChunkSize) return Q.rootSegmentID = T.nextSegmentId++, T.completedBoundaries.push(Q), ee(L, T.responseState, Q.id), mi(T, L, Y), L.push("<!--/$-->");
    if (T.responseState.generateStaticMarkup || L.push("<!--$-->"), Y = Q.completedSegments, Y.length !== 1) throw Error(t(391));
    return Ni(T, L, Y[0]), T = T.responseState.generateStaticMarkup ? !0 : L.push("<!--/$-->"), T;
  }
  function ca(T, L, Y) {
    return re(L, T.responseState, Y.formatContext, Y.id), Ni(T, L, Y), ie(L, Y.formatContext);
  }
  function zn(T, L, Y) {
    for (var Q = Y.completedSegments, be = 0; be < Q.length; be++) bo(T, L, Y, Q[be]);
    if (Q.length = 0, T = T.responseState, Q = Y.id, Y = Y.rootSegmentID, L.push(T.startInlineScript), T.sentCompleteBoundaryFunction ? L.push('$RC("') : (T.sentCompleteBoundaryFunction = !0, L.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), Q === null) throw Error(t(395));
    return Y = Y.toString(16), L.push(Q), L.push('","'), L.push(T.segmentPrefix), L.push(Y), L.push('")<\/script>');
  }
  function bo(T, L, Y, Q) {
    if (Q.status === 2) return !0;
    var be = Q.id;
    if (be === -1) {
      if ((Q.id = Y.rootSegmentID) === -1) throw Error(t(392));
      return ca(T, L, Q);
    }
    return ca(T, L, Q), T = T.responseState, L.push(T.startInlineScript), T.sentCompleteSegmentFunction ? L.push('$RS("') : (T.sentCompleteSegmentFunction = !0, L.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), L.push(T.segmentPrefix), be = be.toString(16), L.push(be), L.push('","'), L.push(T.placeholderPrefix), L.push(be), L.push('")<\/script>');
  }
  function En(T, L) {
    try {
      var Y = T.completedRootSegment;
      if (Y !== null && T.pendingRootTasks === 0) {
        Ni(T, L, Y), T.completedRootSegment = null;
        var Q = T.responseState.bootstrapChunks;
        for (Y = 0; Y < Q.length - 1; Y++) L.push(Q[Y]);
        Y < Q.length && L.push(Q[Y]);
      }
      var be = T.clientRenderedBoundaries, ge;
      for (ge = 0; ge < be.length; ge++) {
        var Re = be[ge];
        Q = L;
        var Ge = T.responseState, qe = Re.id, it = Re.errorDigest, Qe = Re.errorMessage, Wt = Re.errorComponentStack;
        if (Q.push(Ge.startInlineScript), Ge.sentClientRenderFunction ? Q.push('$RX("') : (Ge.sentClientRenderFunction = !0, Q.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), qe === null) throw Error(t(395));
        if (Q.push(qe), Q.push('"'), it || Qe || Wt) {
          Q.push(",");
          var _n = se(it || "");
          Q.push(_n);
        }
        if (Qe || Wt) {
          Q.push(",");
          var xn = se(Qe || "");
          Q.push(xn);
        }
        if (Wt) {
          Q.push(",");
          var Rn = se(Wt);
          Q.push(Rn);
        }
        if (!Q.push(")<\/script>")) {
          T.destination = null, ge++, be.splice(0, ge);
          return;
        }
      }
      be.splice(0, ge);
      var yi = T.completedBoundaries;
      for (ge = 0; ge < yi.length; ge++) if (!zn(T, L, yi[ge])) {
        T.destination = null, ge++, yi.splice(0, ge);
        return;
      }
      yi.splice(0, ge);
      var So = T.partialBoundaries;
      for (ge = 0; ge < So.length; ge++) {
        var pa = So[ge];
        e: {
          be = T, Re = L;
          var Ci = pa.completedSegments;
          for (Ge = 0; Ge < Ci.length; Ge++) if (!bo(be, Re, pa, Ci[Ge])) {
            Ge++, Ci.splice(0, Ge);
            var ki = !1;
            break e;
          }
          Ci.splice(0, Ge), ki = !0;
        }
        if (!ki) {
          T.destination = null, ge++, So.splice(0, ge);
          return;
        }
      }
      So.splice(0, ge);
      var Bo = T.completedBoundaries;
      for (ge = 0; ge < Bo.length; ge++) if (!zn(T, L, Bo[ge])) {
        T.destination = null, ge++, Bo.splice(0, ge);
        return;
      }
      Bo.splice(0, ge);
    } finally {
      T.allPendingTasks === 0 && T.pingedTasks.length === 0 && T.clientRenderedBoundaries.length === 0 && T.completedBoundaries.length === 0 && L.push(null);
    }
  }
  function da(T, L) {
    try {
      var Y = T.abortableTasks;
      Y.forEach(function(Q) {
        return ua(Q, T, L);
      }), Y.clear(), T.destination !== null && En(T, T.destination);
    } catch (Q) {
      mo(T, Q), vi(T, Q);
    }
  }
  function Jr() {
  }
  function Nn(T, L, Y, Q) {
    var be = !1, ge = null, Re = "", Ge = { push: function(it) {
      return it !== null && (Re += it), !0;
    }, destroy: function(it) {
      be = !0, ge = it;
    } }, qe = !1;
    if (T = la(T, pe(Y, L ? L.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, Jr, void 0, function() {
      qe = !0;
    }), Sn(T), da(T, Q), T.status === 1) T.status = 2, Ge.destroy(T.fatalError);
    else if (T.status !== 2 && T.destination === null) {
      T.destination = Ge;
      try {
        En(T, Ge);
      } catch (it) {
        mo(T, it), vi(T, it);
      }
    }
    if (be) throw ge;
    if (!qe) throw Error(t(426));
    return Re;
  }
  return Vu.renderToNodeStream = function() {
    throw Error(t(207));
  }, Vu.renderToStaticMarkup = function(T, L) {
    return Nn(T, L, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Vu.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, Vu.renderToString = function(T, L) {
    return Nn(T, L, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Vu.version = "18.2.0", Vu;
}
var nm = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IP;
function see() {
  if (IP) return nm;
  IP = 1;
  var o = y;
  function t(O) {
    for (var I = "https://reactjs.org/docs/error-decoder.html?invariant=" + O, U = 1; U < arguments.length; U++) I += "&args[]=" + encodeURIComponent(arguments[U]);
    return "Minified React error #" + O + "; visit " + I + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var e = null, r = 0;
  function n(O, I) {
    if (I.length !== 0) if (512 < I.length) 0 < r && (O.enqueue(new Uint8Array(e.buffer, 0, r)), e = new Uint8Array(512), r = 0), O.enqueue(I);
    else {
      var U = e.length - r;
      U < I.length && (U === 0 ? O.enqueue(e) : (e.set(I.subarray(0, U), r), O.enqueue(e), I = I.subarray(U)), e = new Uint8Array(512), r = 0), e.set(I, r), r += I.length;
    }
  }
  function i(O, I) {
    return n(O, I), !0;
  }
  function a(O) {
    e && 0 < r && (O.enqueue(new Uint8Array(e.buffer, 0, r)), e = null, r = 0);
  }
  var s = new TextEncoder();
  function l(O) {
    return s.encode(O);
  }
  function u(O) {
    return s.encode(O);
  }
  function c(O, I) {
    typeof O.error == "function" ? O.error(I) : O.close();
  }
  var d = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, v = {}, g = {};
  function m(O) {
    return d.call(g, O) ? !0 : d.call(v, O) ? !1 : f.test(O) ? g[O] = !0 : (v[O] = !0, !1);
  }
  function b(O, I, U, Z, Se, ye, Pe) {
    this.acceptsBooleans = I === 2 || I === 3 || I === 4, this.attributeName = Z, this.attributeNamespace = Se, this.mustUseProperty = U, this.propertyName = O, this.type = I, this.sanitizeURL = ye, this.removeEmptyString = Pe;
  }
  var S = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(O) {
    S[O] = new b(O, 0, !1, O, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(O) {
    var I = O[0];
    S[I] = new b(I, 1, !1, O[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(O) {
    S[O] = new b(O, 2, !1, O.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(O) {
    S[O] = new b(O, 2, !1, O, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(O) {
    S[O] = new b(O, 3, !1, O.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(O) {
    S[O] = new b(O, 3, !0, O, null, !1, !1);
  }), ["capture", "download"].forEach(function(O) {
    S[O] = new b(O, 4, !1, O, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(O) {
    S[O] = new b(O, 6, !1, O, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(O) {
    S[O] = new b(O, 5, !1, O.toLowerCase(), null, !1, !1);
  });
  var R = /[\-:]([a-z])/g;
  function P(O) {
    return O[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(O) {
    var I = O.replace(
      R,
      P
    );
    S[I] = new b(I, 1, !1, O, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(O) {
    var I = O.replace(R, P);
    S[I] = new b(I, 1, !1, O, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(O) {
    var I = O.replace(R, P);
    S[I] = new b(I, 1, !1, O, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(O) {
    S[O] = new b(O, 1, !1, O.toLowerCase(), null, !1, !1);
  }), S.xlinkHref = new b("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(O) {
    S[O] = new b(O, 1, !1, O.toLowerCase(), null, !0, !0);
  });
  var D = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, x = ["Webkit", "ms", "Moz", "O"];
  Object.keys(D).forEach(function(O) {
    x.forEach(function(I) {
      I = I + O.charAt(0).toUpperCase() + O.substring(1), D[I] = D[O];
    });
  });
  var M = /["'&<>]/;
  function F(O) {
    if (typeof O == "boolean" || typeof O == "number") return "" + O;
    O = "" + O;
    var I = M.exec(O);
    if (I) {
      var U = "", Z, Se = 0;
      for (Z = I.index; Z < O.length; Z++) {
        switch (O.charCodeAt(Z)) {
          case 34:
            I = "&quot;";
            break;
          case 38:
            I = "&amp;";
            break;
          case 39:
            I = "&#x27;";
            break;
          case 60:
            I = "&lt;";
            break;
          case 62:
            I = "&gt;";
            break;
          default:
            continue;
        }
        Se !== Z && (U += O.substring(Se, Z)), Se = Z + 1, U += I;
      }
      O = Se !== Z ? U + O.substring(Se, Z) : U;
    }
    return O;
  }
  var H = /([A-Z])/g, B = /^ms-/, j = Array.isArray, V = u("<script>"), W = u("<\/script>"), q = u('<script src="'), ee = u('<script type="module" src="'), re = u('" async=""><\/script>'), ie = /(<\/|<)(s)(cript)/gi;
  function ne(O, I, U, Z) {
    return "" + I + (U === "s" ? "\\u0073" : "\\u0053") + Z;
  }
  function se(O, I, U, Z, Se) {
    O = O === void 0 ? "" : O, I = I === void 0 ? V : u('<script nonce="' + F(I) + '">');
    var ye = [];
    if (U !== void 0 && ye.push(I, l(("" + U).replace(ie, ne)), W), Z !== void 0) for (U = 0; U < Z.length; U++) ye.push(q, l(F(Z[U])), re);
    if (Se !== void 0) for (Z = 0; Z < Se.length; Z++) ye.push(ee, l(F(Se[Z])), re);
    return { bootstrapChunks: ye, startInlineScript: I, placeholderPrefix: u(O + "P:"), segmentPrefix: u(O + "S:"), boundaryPrefix: O + "B:", idPrefix: O, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function pe(O, I) {
    return { insertionMode: O, selectedValue: I };
  }
  function K(O) {
    return pe(O === "http://www.w3.org/2000/svg" ? 2 : O === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function J(O, I, U) {
    switch (I) {
      case "select":
        return pe(1, U.value != null ? U.value : U.defaultValue);
      case "svg":
        return pe(2, null);
      case "math":
        return pe(3, null);
      case "foreignObject":
        return pe(1, null);
      case "table":
        return pe(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return pe(5, null);
      case "colgroup":
        return pe(7, null);
      case "tr":
        return pe(6, null);
    }
    return 4 <= O.insertionMode || O.insertionMode === 0 ? pe(1, null) : O;
  }
  var ue = u("<!-- -->");
  function he(O, I, U, Z) {
    return I === "" ? Z : (Z && O.push(ue), O.push(l(F(I))), !0);
  }
  var fe = /* @__PURE__ */ new Map(), ae = u(' style="'), oe = u(":"), ve = u(";");
  function _e(O, I, U) {
    if (typeof U != "object") throw Error(t(62));
    I = !0;
    for (var Z in U) if (d.call(U, Z)) {
      var Se = U[Z];
      if (Se != null && typeof Se != "boolean" && Se !== "") {
        if (Z.indexOf("--") === 0) {
          var ye = l(F(Z));
          Se = l(F(("" + Se).trim()));
        } else {
          ye = Z;
          var Pe = fe.get(ye);
          Pe !== void 0 || (Pe = u(F(ye.replace(H, "-$1").toLowerCase().replace(B, "-ms-"))), fe.set(ye, Pe)), ye = Pe, Se = typeof Se == "number" ? Se === 0 || d.call(D, Z) ? l("" + Se) : l(Se + "px") : l(F(("" + Se).trim()));
        }
        I ? (I = !1, O.push(ae, ye, oe, Se)) : O.push(ve, ye, oe, Se);
      }
    }
    I || O.push(de);
  }
  var le = u(" "), Ee = u('="'), de = u('"'), X = u('=""');
  function xe(O, I, U, Z) {
    switch (U) {
      case "style":
        _e(O, I, Z);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < U.length) || U[0] !== "o" && U[0] !== "O" || U[1] !== "n" && U[1] !== "N") {
      if (I = S.hasOwnProperty(U) ? S[U] : null, I !== null) {
        switch (typeof Z) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!I.acceptsBooleans) return;
        }
        switch (U = l(I.attributeName), I.type) {
          case 3:
            Z && O.push(le, U, X);
            break;
          case 4:
            Z === !0 ? O.push(le, U, X) : Z !== !1 && O.push(le, U, Ee, l(F(Z)), de);
            break;
          case 5:
            isNaN(Z) || O.push(le, U, Ee, l(F(Z)), de);
            break;
          case 6:
            !isNaN(Z) && 1 <= Z && O.push(le, U, Ee, l(F(Z)), de);
            break;
          default:
            I.sanitizeURL && (Z = "" + Z), O.push(le, U, Ee, l(F(Z)), de);
        }
      } else if (m(U)) {
        switch (typeof Z) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (I = U.toLowerCase().slice(0, 5), I !== "data-" && I !== "aria-") return;
        }
        O.push(le, l(U), Ee, l(F(Z)), de);
      }
    }
  }
  var Le = u(">"), Ue = u("/>");
  function He(O, I, U) {
    if (I != null) {
      if (U != null) throw Error(t(60));
      if (typeof I != "object" || !("__html" in I)) throw Error(t(61));
      I = I.__html, I != null && O.push(l("" + I));
    }
  }
  function et(O) {
    var I = "";
    return o.Children.forEach(O, function(U) {
      U != null && (I += U);
    }), I;
  }
  var $e = u(' selected=""');
  function pt(O, I, U, Z) {
    O.push(nt(U));
    var Se = U = null, ye;
    for (ye in I) if (d.call(I, ye)) {
      var Pe = I[ye];
      if (Pe != null) switch (ye) {
        case "children":
          U = Pe;
          break;
        case "dangerouslySetInnerHTML":
          Se = Pe;
          break;
        default:
          xe(O, Z, ye, Pe);
      }
    }
    return O.push(Le), He(O, Se, U), typeof U == "string" ? (O.push(l(F(U))), null) : U;
  }
  var st = u(`
`), Bt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, vt = /* @__PURE__ */ new Map();
  function nt(O) {
    var I = vt.get(O);
    if (I === void 0) {
      if (!Bt.test(O)) throw Error(t(65, O));
      I = u("<" + O), vt.set(O, I);
    }
    return I;
  }
  var ze = u("<!DOCTYPE html>");
  function Ct(O, I, U, Z, Se) {
    switch (I) {
      case "select":
        O.push(nt("select"));
        var ye = null, Pe = null;
        for (bt in U) if (d.call(U, bt)) {
          var Ve = U[bt];
          if (Ve != null) switch (bt) {
            case "children":
              ye = Ve;
              break;
            case "dangerouslySetInnerHTML":
              Pe = Ve;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              xe(O, Z, bt, Ve);
          }
        }
        return O.push(Le), He(O, Pe, ye), ye;
      case "option":
        Pe = Se.selectedValue, O.push(nt("option"));
        var at = Ve = null, _t = null, bt = null;
        for (ye in U) if (d.call(U, ye)) {
          var hr = U[ye];
          if (hr != null) switch (ye) {
            case "children":
              Ve = hr;
              break;
            case "selected":
              _t = hr;
              break;
            case "dangerouslySetInnerHTML":
              bt = hr;
              break;
            case "value":
              at = hr;
            default:
              xe(O, Z, ye, hr);
          }
        }
        if (Pe != null) if (U = at !== null ? "" + at : et(Ve), j(Pe)) {
          for (Z = 0; Z < Pe.length; Z++)
            if ("" + Pe[Z] === U) {
              O.push($e);
              break;
            }
        } else "" + Pe === U && O.push($e);
        else _t && O.push($e);
        return O.push(Le), He(O, bt, Ve), Ve;
      case "textarea":
        O.push(nt("textarea")), bt = Pe = ye = null;
        for (Ve in U) if (d.call(U, Ve) && (at = U[Ve], at != null)) switch (Ve) {
          case "children":
            bt = at;
            break;
          case "value":
            ye = at;
            break;
          case "defaultValue":
            Pe = at;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            xe(O, Z, Ve, at);
        }
        if (ye === null && Pe !== null && (ye = Pe), O.push(Le), bt != null) {
          if (ye != null) throw Error(t(92));
          if (j(bt) && 1 < bt.length) throw Error(t(93));
          ye = "" + bt;
        }
        return typeof ye == "string" && ye[0] === `
` && O.push(st), ye !== null && O.push(l(F("" + ye))), null;
      case "input":
        O.push(nt("input")), at = bt = Ve = ye = null;
        for (Pe in U) if (d.call(U, Pe) && (_t = U[Pe], _t != null)) switch (Pe) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            at = _t;
            break;
          case "defaultValue":
            Ve = _t;
            break;
          case "checked":
            bt = _t;
            break;
          case "value":
            ye = _t;
            break;
          default:
            xe(O, Z, Pe, _t);
        }
        return bt !== null ? xe(
          O,
          Z,
          "checked",
          bt
        ) : at !== null && xe(O, Z, "checked", at), ye !== null ? xe(O, Z, "value", ye) : Ve !== null && xe(O, Z, "value", Ve), O.push(Ue), null;
      case "menuitem":
        O.push(nt("menuitem"));
        for (var Gn in U) if (d.call(U, Gn) && (ye = U[Gn], ye != null)) switch (Gn) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            xe(O, Z, Gn, ye);
        }
        return O.push(Le), null;
      case "title":
        O.push(nt("title")), ye = null;
        for (hr in U) if (d.call(U, hr) && (Pe = U[hr], Pe != null)) switch (hr) {
          case "children":
            ye = Pe;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            xe(O, Z, hr, Pe);
        }
        return O.push(Le), ye;
      case "listing":
      case "pre":
        O.push(nt(I)), Pe = ye = null;
        for (at in U) if (d.call(U, at) && (Ve = U[at], Ve != null)) switch (at) {
          case "children":
            ye = Ve;
            break;
          case "dangerouslySetInnerHTML":
            Pe = Ve;
            break;
          default:
            xe(O, Z, at, Ve);
        }
        if (O.push(Le), Pe != null) {
          if (ye != null) throw Error(t(60));
          if (typeof Pe != "object" || !("__html" in Pe)) throw Error(t(61));
          U = Pe.__html, U != null && (typeof U == "string" && 0 < U.length && U[0] === `
` ? O.push(st, l(U)) : O.push(l("" + U)));
        }
        return typeof ye == "string" && ye[0] === `
` && O.push(st), ye;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        O.push(nt(I));
        for (var no in U) if (d.call(U, no) && (ye = U[no], ye != null)) switch (no) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, I));
          default:
            xe(O, Z, no, ye);
        }
        return O.push(Ue), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return pt(O, U, I, Z);
      case "html":
        return Se.insertionMode === 0 && O.push(ze), pt(O, U, I, Z);
      default:
        if (I.indexOf("-") === -1 && typeof U.is != "string") return pt(O, U, I, Z);
        O.push(nt(I)), Pe = ye = null;
        for (_t in U) if (d.call(U, _t) && (Ve = U[_t], Ve != null)) switch (_t) {
          case "children":
            ye = Ve;
            break;
          case "dangerouslySetInnerHTML":
            Pe = Ve;
            break;
          case "style":
            _e(O, Z, Ve);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            m(_t) && typeof Ve != "function" && typeof Ve != "symbol" && O.push(le, l(_t), Ee, l(F(Ve)), de);
        }
        return O.push(Le), He(O, Pe, ye), ye;
    }
  }
  var Mt = u("</"), fr = u(">"), lt = u('<template id="'), Et = u('"></template>'), kt = u("<!--$-->"), $t = u('<!--$?--><template id="'), br = u('"></template>'), mt = u("<!--$!-->"), rt = u("<!--/$-->"), Gt = u("<template"), zt = u('"'), Ze = u(' data-dgst="');
  u(' data-msg="'), u(' data-stck="');
  var Un = u("></template>");
  function Kr(O, I, U) {
    if (n(O, $t), U === null) throw Error(t(395));
    return n(O, U), i(O, br);
  }
  var ln = u('<div hidden id="'), Ft = u('">'), ot = u("</div>"), Gr = u('<svg aria-hidden="true" style="display:none" id="'), wt = u('">'), Qt = u("</svg>"), Sr = u('<math aria-hidden="true" style="display:none" id="'), jr = u('">'), $n = u("</math>"), Er = u('<table hidden id="'), ja = u('">'), Ua = u("</table>"), Ps = u('<table hidden><tbody id="'), Vr = u('">'), $a = u("</tbody></table>"), Kl = u('<table hidden><tr id="'), ql = u('">'), vo = u("</tr></table>"), za = u('<table hidden><colgroup id="'), sa = u('">'), pi = u("</colgroup></table>");
  function In(O, I, U, Z) {
    switch (U.insertionMode) {
      case 0:
      case 1:
        return n(O, ln), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, Ft);
      case 2:
        return n(O, Gr), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, wt);
      case 3:
        return n(O, Sr), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, jr);
      case 4:
        return n(O, Er), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, ja);
      case 5:
        return n(O, Ps), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, Vr);
      case 6:
        return n(O, Kl), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, ql);
      case 7:
        return n(
          O,
          za
        ), n(O, I.segmentPrefix), n(O, l(Z.toString(16))), i(O, sa);
      default:
        throw Error(t(397));
    }
  }
  function go(O, I) {
    switch (I.insertionMode) {
      case 0:
      case 1:
        return i(O, ot);
      case 2:
        return i(O, Qt);
      case 3:
        return i(O, $n);
      case 4:
        return i(O, Ua);
      case 5:
        return i(O, $a);
      case 6:
        return i(O, vo);
      case 7:
        return i(O, pi);
      default:
        throw Error(t(397));
    }
  }
  var la = u('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), fi = u('$RS("'), hi = u('","'), mo = u('")<\/script>'), vi = u('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), Ln = u('$RC("'), Ds = u('","'), As = u('")<\/script>'), Ho = u('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Hr = u('$RX("'), yo = u('"'), Co = u(")<\/script>"), gi = u(","), ua = /[<\u2028\u2029]/g;
  function to(O) {
    return JSON.stringify(O).replace(ua, function(I) {
      switch (I) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var wo = Object.assign, Sn = Symbol.for("react.element"), mi = Symbol.for("react.portal"), Ni = Symbol.for("react.fragment"), ca = Symbol.for("react.strict_mode"), zn = Symbol.for("react.profiler"), bo = Symbol.for("react.provider"), En = Symbol.for("react.context"), da = Symbol.for("react.forward_ref"), Jr = Symbol.for("react.suspense"), Nn = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), Y = Symbol.for("react.scope"), Q = Symbol.for("react.debug_trace_mode"), be = Symbol.for("react.legacy_hidden"), ge = Symbol.for("react.default_value"), Re = Symbol.iterator;
  function Ge(O) {
    if (O == null) return null;
    if (typeof O == "function") return O.displayName || O.name || null;
    if (typeof O == "string") return O;
    switch (O) {
      case Ni:
        return "Fragment";
      case mi:
        return "Portal";
      case zn:
        return "Profiler";
      case ca:
        return "StrictMode";
      case Jr:
        return "Suspense";
      case Nn:
        return "SuspenseList";
    }
    if (typeof O == "object") switch (O.$$typeof) {
      case En:
        return (O.displayName || "Context") + ".Consumer";
      case bo:
        return (O._context.displayName || "Context") + ".Provider";
      case da:
        var I = O.render;
        return O = O.displayName, O || (O = I.displayName || I.name || "", O = O !== "" ? "ForwardRef(" + O + ")" : "ForwardRef"), O;
      case T:
        return I = O.displayName || null, I !== null ? I : Ge(O.type) || "Memo";
      case L:
        I = O._payload, O = O._init;
        try {
          return Ge(O(I));
        } catch {
        }
    }
    return null;
  }
  var qe = {};
  function it(O, I) {
    if (O = O.contextTypes, !O) return qe;
    var U = {}, Z;
    for (Z in O) U[Z] = I[Z];
    return U;
  }
  var Qe = null;
  function Wt(O, I) {
    if (O !== I) {
      O.context._currentValue = O.parentValue, O = O.parent;
      var U = I.parent;
      if (O === null) {
        if (U !== null) throw Error(t(401));
      } else {
        if (U === null) throw Error(t(401));
        Wt(O, U);
      }
      I.context._currentValue = I.value;
    }
  }
  function _n(O) {
    O.context._currentValue = O.parentValue, O = O.parent, O !== null && _n(O);
  }
  function xn(O) {
    var I = O.parent;
    I !== null && xn(I), O.context._currentValue = O.value;
  }
  function Rn(O, I) {
    if (O.context._currentValue = O.parentValue, O = O.parent, O === null) throw Error(t(402));
    O.depth === I.depth ? Wt(O, I) : Rn(O, I);
  }
  function yi(O, I) {
    var U = I.parent;
    if (U === null) throw Error(t(402));
    O.depth === U.depth ? Wt(O, U) : yi(O, U), I.context._currentValue = I.value;
  }
  function So(O) {
    var I = Qe;
    I !== O && (I === null ? xn(O) : O === null ? _n(I) : I.depth === O.depth ? Wt(I, O) : I.depth > O.depth ? Rn(I, O) : yi(I, O), Qe = O);
  }
  var pa = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(O, I) {
    O = O._reactInternals, O.queue !== null && O.queue.push(I);
  }, enqueueReplaceState: function(O, I) {
    O = O._reactInternals, O.replace = !0, O.queue = [I];
  }, enqueueForceUpdate: function() {
  } };
  function Ci(O, I, U, Z) {
    var Se = O.state !== void 0 ? O.state : null;
    O.updater = pa, O.props = U, O.state = Se;
    var ye = { queue: [], replace: !1 };
    O._reactInternals = ye;
    var Pe = I.contextType;
    if (O.context = typeof Pe == "object" && Pe !== null ? Pe._currentValue : Z, Pe = I.getDerivedStateFromProps, typeof Pe == "function" && (Pe = Pe(U, Se), Se = Pe == null ? Se : wo({}, Se, Pe), O.state = Se), typeof I.getDerivedStateFromProps != "function" && typeof O.getSnapshotBeforeUpdate != "function" && (typeof O.UNSAFE_componentWillMount == "function" || typeof O.componentWillMount == "function")) if (I = O.state, typeof O.componentWillMount == "function" && O.componentWillMount(), typeof O.UNSAFE_componentWillMount == "function" && O.UNSAFE_componentWillMount(), I !== O.state && pa.enqueueReplaceState(O, O.state, null), ye.queue !== null && 0 < ye.queue.length) if (I = ye.queue, Pe = ye.replace, ye.queue = null, ye.replace = !1, Pe && I.length === 1) O.state = I[0];
    else {
      for (ye = Pe ? I[0] : O.state, Se = !0, Pe = Pe ? 1 : 0; Pe < I.length; Pe++) {
        var Ve = I[Pe];
        Ve = typeof Ve == "function" ? Ve.call(O, ye, U, Z) : Ve, Ve != null && (Se ? (Se = !1, ye = wo({}, ye, Ve)) : wo(ye, Ve));
      }
      O.state = ye;
    }
    else ye.queue = null;
  }
  var ki = { id: 1, overflow: "" };
  function Bo(O, I, U) {
    var Z = O.id;
    O = O.overflow;
    var Se = 32 - Gi(Z) - 1;
    Z &= ~(1 << Se), U += 1;
    var ye = 32 - Gi(I) + Se;
    if (30 < ye) {
      var Pe = Se - Se % 5;
      return ye = (Z & (1 << Pe) - 1).toString(32), Z >>= Pe, Se -= Pe, { id: 1 << 32 - Gi(I) + Se | U << Se | Z, overflow: ye + O };
    }
    return { id: 1 << ye | U << Se | Z, overflow: O };
  }
  var Gi = Math.clz32 ? Math.clz32 : Ms, wp = Math.log, bp = Math.LN2;
  function Ms(O) {
    return O >>>= 0, O === 0 ? 32 : 31 - (wp(O) / bp | 0) | 0;
  }
  function Eo(O, I) {
    return O === I && (O !== 0 || 1 / O === 1 / I) || O !== O && I !== I;
  }
  var Sp = typeof Object.is == "function" ? Object.is : Eo, Wo = null, Xl = null, Fs = null, rr = null, Vi = !1, Is = !1, Hi = 0, wi = null, Ls = 0;
  function bi() {
    if (Wo === null) throw Error(t(321));
    return Wo;
  }
  function ro() {
    if (0 < Ls) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Zl() {
    return rr === null ? Fs === null ? (Vi = !1, Fs = rr = ro()) : (Vi = !0, rr = Fs) : rr.next === null ? (Vi = !1, rr = rr.next = ro()) : (Vi = !0, rr = rr.next), rr;
  }
  function Ya() {
    Xl = Wo = null, Is = !1, Fs = null, Ls = 0, rr = wi = null;
  }
  function Rc(O, I) {
    return typeof I == "function" ? I(O) : I;
  }
  function Ns(O, I, U) {
    if (Wo = bi(), rr = Zl(), Vi) {
      var Z = rr.queue;
      if (I = Z.dispatch, wi !== null && (U = wi.get(Z), U !== void 0)) {
        wi.delete(Z), Z = rr.memoizedState;
        do
          Z = O(Z, U.action), U = U.next;
        while (U !== null);
        return rr.memoizedState = Z, [Z, I];
      }
      return [rr.memoizedState, I];
    }
    return O = O === Rc ? typeof I == "function" ? I() : I : U !== void 0 ? U(I) : I, rr.memoizedState = O, O = rr.queue = { last: null, dispatch: null }, O = O.dispatch = Ep.bind(null, Wo, O), [rr.memoizedState, O];
  }
  function Tc(O, I) {
    if (Wo = bi(), rr = Zl(), I = I === void 0 ? null : I, rr !== null) {
      var U = rr.memoizedState;
      if (U !== null && I !== null) {
        var Z = U[1];
        e: if (Z === null) Z = !1;
        else {
          for (var Se = 0; Se < Z.length && Se < I.length; Se++) if (!Sp(I[Se], Z[Se])) {
            Z = !1;
            break e;
          }
          Z = !0;
        }
        if (Z) return U[0];
      }
    }
    return O = O(), rr.memoizedState = [O, I], O;
  }
  function Ep(O, I, U) {
    if (25 <= Ls) throw Error(t(301));
    if (O === Wo) if (Is = !0, O = { action: U, next: null }, wi === null && (wi = /* @__PURE__ */ new Map()), U = wi.get(I), U === void 0) wi.set(I, O);
    else {
      for (I = U; I.next !== null; ) I = I.next;
      I.next = O;
    }
  }
  function _p() {
    throw Error(t(394));
  }
  function ks() {
  }
  var Oc = { readContext: function(O) {
    return O._currentValue;
  }, useContext: function(O) {
    return bi(), O._currentValue;
  }, useMemo: Tc, useReducer: Ns, useRef: function(O) {
    Wo = bi(), rr = Zl();
    var I = rr.memoizedState;
    return I === null ? (O = { current: O }, rr.memoizedState = O) : I;
  }, useState: function(O) {
    return Ns(Rc, O);
  }, useInsertionEffect: ks, useLayoutEffect: function() {
  }, useCallback: function(O, I) {
    return Tc(function() {
      return O;
    }, I);
  }, useImperativeHandle: ks, useEffect: ks, useDebugValue: ks, useDeferredValue: function(O) {
    return bi(), O;
  }, useTransition: function() {
    return bi(), [!1, _p];
  }, useId: function() {
    var O = Xl.treeContext, I = O.overflow;
    O = O.id, O = (O & ~(1 << 32 - Gi(O) - 1)).toString(32) + I;
    var U = Ka;
    if (U === null) throw Error(t(404));
    return I = Hi++, O = ":" + U.idPrefix + "R" + O, 0 < I && (O += "H" + I.toString(32)), O + ":";
  }, useMutableSource: function(O, I) {
    return bi(), I(O._source);
  }, useSyncExternalStore: function(O, I, U) {
    if (U === void 0) throw Error(t(407));
    return U();
  } }, Ka = null, Ql = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function xp(O) {
    return console.error(O), null;
  }
  function fa() {
  }
  function Jl(O, I, U, Z, Se, ye, Pe, Ve, at) {
    var _t = [], bt = /* @__PURE__ */ new Set();
    return I = { destination: null, responseState: I, progressiveChunkSize: Z === void 0 ? 12800 : Z, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: bt, pingedTasks: _t, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: Se === void 0 ? xp : Se, onAllReady: ye === void 0 ? fa : ye, onShellReady: Pe === void 0 ? fa : Pe, onShellError: Ve === void 0 ? fa : Ve, onFatalError: at === void 0 ? fa : at }, U = ha(I, 0, null, U, !1, !1), U.parentFlushed = !0, O = eu(I, O, null, U, bt, qe, null, ki), _t.push(O), I;
  }
  function eu(O, I, U, Z, Se, ye, Pe, Ve) {
    O.allPendingTasks++, U === null ? O.pendingRootTasks++ : U.pendingTasks++;
    var at = { node: I, ping: function() {
      var _t = O.pingedTasks;
      _t.push(at), _t.length === 1 && Lc(O);
    }, blockedBoundary: U, blockedSegment: Z, abortSet: Se, legacyContext: ye, context: Pe, treeContext: Ve };
    return Se.add(at), at;
  }
  function ha(O, I, U, Z, Se, ye) {
    return { status: 0, id: -1, index: I, parentFlushed: !1, chunks: [], children: [], formatContext: Z, boundary: U, lastPushedText: Se, textEmbedded: ye };
  }
  function qa(O, I) {
    if (O = O.onError(I), O != null && typeof O != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof O + '" instead');
    return O;
  }
  function Gs(O, I) {
    var U = O.onShellError;
    U(I), U = O.onFatalError, U(I), O.destination !== null ? (O.status = 2, c(O.destination, I)) : (O.status = 1, O.fatalError = I);
  }
  function Pc(O, I, U, Z, Se) {
    for (Wo = {}, Xl = I, Hi = 0, O = U(Z, Se); Is; ) Is = !1, Hi = 0, Ls += 1, rr = null, O = U(Z, Se);
    return Ya(), O;
  }
  function Dc(O, I, U, Z) {
    var Se = U.render(), ye = Z.childContextTypes;
    if (ye != null) {
      var Pe = I.legacyContext;
      if (typeof U.getChildContext != "function") Z = Pe;
      else {
        U = U.getChildContext();
        for (var Ve in U) if (!(Ve in ye)) throw Error(t(108, Ge(Z) || "Unknown", Ve));
        Z = wo({}, Pe, U);
      }
      I.legacyContext = Z, kn(O, I, Se), I.legacyContext = Pe;
    } else kn(O, I, Se);
  }
  function Ac(O, I) {
    if (O && O.defaultProps) {
      I = wo({}, I), O = O.defaultProps;
      for (var U in O) I[U] === void 0 && (I[U] = O[U]);
      return I;
    }
    return I;
  }
  function Vs(O, I, U, Z, Se) {
    if (typeof U == "function") if (U.prototype && U.prototype.isReactComponent) {
      Se = it(U, I.legacyContext);
      var ye = U.contextType;
      ye = new U(Z, typeof ye == "object" && ye !== null ? ye._currentValue : Se), Ci(ye, U, Z, Se), Dc(O, I, ye, U);
    } else {
      ye = it(U, I.legacyContext), Se = Pc(O, I, U, Z, ye);
      var Pe = Hi !== 0;
      if (typeof Se == "object" && Se !== null && typeof Se.render == "function" && Se.$$typeof === void 0) Ci(Se, U, Z, ye), Dc(O, I, Se, U);
      else if (Pe) {
        Z = I.treeContext, I.treeContext = Bo(Z, 1, 0);
        try {
          kn(O, I, Se);
        } finally {
          I.treeContext = Z;
        }
      } else kn(O, I, Se);
    }
    else if (typeof U == "string") {
      switch (Se = I.blockedSegment, ye = Ct(Se.chunks, U, Z, O.responseState, Se.formatContext), Se.lastPushedText = !1, Pe = Se.formatContext, Se.formatContext = J(Pe, U, Z), Hs(O, I, ye), Se.formatContext = Pe, U) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          Se.chunks.push(Mt, l(U), fr);
      }
      Se.lastPushedText = !1;
    } else {
      switch (U) {
        case be:
        case Q:
        case ca:
        case zn:
        case Ni:
          kn(O, I, Z.children);
          return;
        case Nn:
          kn(O, I, Z.children);
          return;
        case Y:
          throw Error(t(343));
        case Jr:
          e: {
            U = I.blockedBoundary, Se = I.blockedSegment, ye = Z.fallback, Z = Z.children, Pe = /* @__PURE__ */ new Set();
            var Ve = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Pe, errorDigest: null }, at = ha(O, Se.chunks.length, Ve, Se.formatContext, !1, !1);
            Se.children.push(at), Se.lastPushedText = !1;
            var _t = ha(O, 0, null, Se.formatContext, !1, !1);
            _t.parentFlushed = !0, I.blockedBoundary = Ve, I.blockedSegment = _t;
            try {
              if (Hs(
                O,
                I,
                Z
              ), _t.lastPushedText && _t.textEmbedded && _t.chunks.push(ue), _t.status = 1, Bs(Ve, _t), Ve.pendingTasks === 0) break e;
            } catch (bt) {
              _t.status = 4, Ve.forceClientRender = !0, Ve.errorDigest = qa(O, bt);
            } finally {
              I.blockedBoundary = U, I.blockedSegment = Se;
            }
            I = eu(O, ye, U, at, Pe, I.legacyContext, I.context, I.treeContext), O.pingedTasks.push(I);
          }
          return;
      }
      if (typeof U == "object" && U !== null) switch (U.$$typeof) {
        case da:
          if (Z = Pc(O, I, U.render, Z, Se), Hi !== 0) {
            U = I.treeContext, I.treeContext = Bo(U, 1, 0);
            try {
              kn(O, I, Z);
            } finally {
              I.treeContext = U;
            }
          } else kn(O, I, Z);
          return;
        case T:
          U = U.type, Z = Ac(U, Z), Vs(O, I, U, Z, Se);
          return;
        case bo:
          if (Se = Z.children, U = U._context, Z = Z.value, ye = U._currentValue, U._currentValue = Z, Pe = Qe, Qe = Z = { parent: Pe, depth: Pe === null ? 0 : Pe.depth + 1, context: U, parentValue: ye, value: Z }, I.context = Z, kn(O, I, Se), O = Qe, O === null) throw Error(t(403));
          Z = O.parentValue, O.context._currentValue = Z === ge ? O.context._defaultValue : Z, O = Qe = O.parent, I.context = O;
          return;
        case En:
          Z = Z.children, Z = Z(U._currentValue), kn(O, I, Z);
          return;
        case L:
          Se = U._init, U = Se(U._payload), Z = Ac(U, Z), Vs(O, I, U, Z, void 0);
          return;
      }
      throw Error(t(
        130,
        U == null ? U : typeof U,
        ""
      ));
    }
  }
  function kn(O, I, U) {
    if (I.node = U, typeof U == "object" && U !== null) {
      switch (U.$$typeof) {
        case Sn:
          Vs(O, I, U.type, U.props, U.ref);
          return;
        case mi:
          throw Error(t(257));
        case L:
          var Z = U._init;
          U = Z(U._payload), kn(O, I, U);
          return;
      }
      if (j(U)) {
        Mc(O, I, U);
        return;
      }
      if (U === null || typeof U != "object" ? Z = null : (Z = Re && U[Re] || U["@@iterator"], Z = typeof Z == "function" ? Z : null), Z && (Z = Z.call(U))) {
        if (U = Z.next(), !U.done) {
          var Se = [];
          do
            Se.push(U.value), U = Z.next();
          while (!U.done);
          Mc(O, I, Se);
        }
        return;
      }
      throw O = Object.prototype.toString.call(U), Error(t(31, O === "[object Object]" ? "object with keys {" + Object.keys(U).join(", ") + "}" : O));
    }
    typeof U == "string" ? (Z = I.blockedSegment, Z.lastPushedText = he(I.blockedSegment.chunks, U, O.responseState, Z.lastPushedText)) : typeof U == "number" && (Z = I.blockedSegment, Z.lastPushedText = he(I.blockedSegment.chunks, "" + U, O.responseState, Z.lastPushedText));
  }
  function Mc(O, I, U) {
    for (var Z = U.length, Se = 0; Se < Z; Se++) {
      var ye = I.treeContext;
      I.treeContext = Bo(ye, Z, Se);
      try {
        Hs(O, I, U[Se]);
      } finally {
        I.treeContext = ye;
      }
    }
  }
  function Hs(O, I, U) {
    var Z = I.blockedSegment.formatContext, Se = I.legacyContext, ye = I.context;
    try {
      return kn(O, I, U);
    } catch (at) {
      if (Ya(), typeof at == "object" && at !== null && typeof at.then == "function") {
        U = at;
        var Pe = I.blockedSegment, Ve = ha(O, Pe.chunks.length, null, Pe.formatContext, Pe.lastPushedText, !0);
        Pe.children.push(Ve), Pe.lastPushedText = !1, O = eu(O, I.node, I.blockedBoundary, Ve, I.abortSet, I.legacyContext, I.context, I.treeContext).ping, U.then(O, O), I.blockedSegment.formatContext = Z, I.legacyContext = Se, I.context = ye, So(ye);
      } else throw I.blockedSegment.formatContext = Z, I.legacyContext = Se, I.context = ye, So(ye), at;
    }
  }
  function Rp(O) {
    var I = O.blockedBoundary;
    O = O.blockedSegment, O.status = 3, Ic(this, I, O);
  }
  function Fc(O, I, U) {
    var Z = O.blockedBoundary;
    O.blockedSegment.status = 3, Z === null ? (I.allPendingTasks--, I.status !== 2 && (I.status = 2, I.destination !== null && I.destination.close())) : (Z.pendingTasks--, Z.forceClientRender || (Z.forceClientRender = !0, O = U === void 0 ? Error(t(432)) : U, Z.errorDigest = I.onError(O), Z.parentFlushed && I.clientRenderedBoundaries.push(Z)), Z.fallbackAbortableTasks.forEach(function(Se) {
      return Fc(Se, I, U);
    }), Z.fallbackAbortableTasks.clear(), I.allPendingTasks--, I.allPendingTasks === 0 && (Z = I.onAllReady, Z()));
  }
  function Bs(O, I) {
    if (I.chunks.length === 0 && I.children.length === 1 && I.children[0].boundary === null) {
      var U = I.children[0];
      U.id = I.id, U.parentFlushed = !0, U.status === 1 && Bs(O, U);
    } else O.completedSegments.push(I);
  }
  function Ic(O, I, U) {
    if (I === null) {
      if (U.parentFlushed) {
        if (O.completedRootSegment !== null) throw Error(t(389));
        O.completedRootSegment = U;
      }
      O.pendingRootTasks--, O.pendingRootTasks === 0 && (O.onShellError = fa, I = O.onShellReady, I());
    } else I.pendingTasks--, I.forceClientRender || (I.pendingTasks === 0 ? (U.parentFlushed && U.status === 1 && Bs(I, U), I.parentFlushed && O.completedBoundaries.push(I), I.fallbackAbortableTasks.forEach(Rp, O), I.fallbackAbortableTasks.clear()) : U.parentFlushed && U.status === 1 && (Bs(I, U), I.completedSegments.length === 1 && I.parentFlushed && O.partialBoundaries.push(I)));
    O.allPendingTasks--, O.allPendingTasks === 0 && (O = O.onAllReady, O());
  }
  function Lc(O) {
    if (O.status !== 2) {
      var I = Qe, U = Ql.current;
      Ql.current = Oc;
      var Z = Ka;
      Ka = O.responseState;
      try {
        var Se = O.pingedTasks, ye;
        for (ye = 0; ye < Se.length; ye++) {
          var Pe = Se[ye], Ve = O, at = Pe.blockedSegment;
          if (at.status === 0) {
            So(Pe.context);
            try {
              kn(Ve, Pe, Pe.node), at.lastPushedText && at.textEmbedded && at.chunks.push(ue), Pe.abortSet.delete(Pe), at.status = 1, Ic(Ve, Pe.blockedBoundary, at);
            } catch (oo) {
              if (Ya(), typeof oo == "object" && oo !== null && typeof oo.then == "function") {
                var _t = Pe.ping;
                oo.then(_t, _t);
              } else {
                Pe.abortSet.delete(Pe), at.status = 4;
                var bt = Pe.blockedBoundary, hr = oo, Gn = qa(Ve, hr);
                if (bt === null ? Gs(Ve, hr) : (bt.pendingTasks--, bt.forceClientRender || (bt.forceClientRender = !0, bt.errorDigest = Gn, bt.parentFlushed && Ve.clientRenderedBoundaries.push(bt))), Ve.allPendingTasks--, Ve.allPendingTasks === 0) {
                  var no = Ve.onAllReady;
                  no();
                }
              }
            } finally {
            }
          }
        }
        Se.splice(0, ye), O.destination !== null && tu(O, O.destination);
      } catch (oo) {
        qa(O, oo), Gs(O, oo);
      } finally {
        Ka = Z, Ql.current = U, U === Oc && So(I);
      }
    }
  }
  function Ws(O, I, U) {
    switch (U.parentFlushed = !0, U.status) {
      case 0:
        var Z = U.id = O.nextSegmentId++;
        return U.lastPushedText = !1, U.textEmbedded = !1, O = O.responseState, n(I, lt), n(I, O.placeholderPrefix), O = l(Z.toString(16)), n(I, O), i(I, Et);
      case 1:
        U.status = 2;
        var Se = !0;
        Z = U.chunks;
        var ye = 0;
        U = U.children;
        for (var Pe = 0; Pe < U.length; Pe++) {
          for (Se = U[Pe]; ye < Se.index; ye++) n(I, Z[ye]);
          Se = js(O, I, Se);
        }
        for (; ye < Z.length - 1; ye++) n(I, Z[ye]);
        return ye < Z.length && (Se = i(I, Z[ye])), Se;
      default:
        throw Error(t(390));
    }
  }
  function js(O, I, U) {
    var Z = U.boundary;
    if (Z === null) return Ws(O, I, U);
    if (Z.parentFlushed = !0, Z.forceClientRender) Z = Z.errorDigest, i(I, mt), n(I, Gt), Z && (n(I, Ze), n(I, l(F(Z))), n(I, zt)), i(I, Un), Ws(O, I, U);
    else if (0 < Z.pendingTasks) {
      Z.rootSegmentID = O.nextSegmentId++, 0 < Z.completedSegments.length && O.partialBoundaries.push(Z);
      var Se = O.responseState, ye = Se.nextSuspenseID++;
      Se = u(Se.boundaryPrefix + ye.toString(16)), Z = Z.id = Se, Kr(I, O.responseState, Z), Ws(O, I, U);
    } else if (Z.byteSize > O.progressiveChunkSize) Z.rootSegmentID = O.nextSegmentId++, O.completedBoundaries.push(Z), Kr(I, O.responseState, Z.id), Ws(O, I, U);
    else {
      if (i(I, kt), U = Z.completedSegments, U.length !== 1) throw Error(t(391));
      js(O, I, U[0]);
    }
    return i(I, rt);
  }
  function Nc(O, I, U) {
    return In(I, O.responseState, U.formatContext, U.id), js(O, I, U), go(I, U.formatContext);
  }
  function kc(O, I, U) {
    for (var Z = U.completedSegments, Se = 0; Se < Z.length; Se++) Gc(O, I, U, Z[Se]);
    if (Z.length = 0, O = O.responseState, Z = U.id, U = U.rootSegmentID, n(I, O.startInlineScript), O.sentCompleteBoundaryFunction ? n(I, Ln) : (O.sentCompleteBoundaryFunction = !0, n(I, vi)), Z === null) throw Error(t(395));
    return U = l(U.toString(16)), n(I, Z), n(I, Ds), n(I, O.segmentPrefix), n(I, U), i(I, As);
  }
  function Gc(O, I, U, Z) {
    if (Z.status === 2) return !0;
    var Se = Z.id;
    if (Se === -1) {
      if ((Z.id = U.rootSegmentID) === -1) throw Error(t(392));
      return Nc(O, I, Z);
    }
    return Nc(O, I, Z), O = O.responseState, n(I, O.startInlineScript), O.sentCompleteSegmentFunction ? n(I, fi) : (O.sentCompleteSegmentFunction = !0, n(I, la)), n(I, O.segmentPrefix), Se = l(Se.toString(16)), n(I, Se), n(I, hi), n(I, O.placeholderPrefix), n(I, Se), i(I, mo);
  }
  function tu(O, I) {
    e = new Uint8Array(512), r = 0;
    try {
      var U = O.completedRootSegment;
      if (U !== null && O.pendingRootTasks === 0) {
        js(O, I, U), O.completedRootSegment = null;
        var Z = O.responseState.bootstrapChunks;
        for (U = 0; U < Z.length - 1; U++) n(I, Z[U]);
        U < Z.length && i(I, Z[U]);
      }
      var Se = O.clientRenderedBoundaries, ye;
      for (ye = 0; ye < Se.length; ye++) {
        var Pe = Se[ye];
        Z = I;
        var Ve = O.responseState, at = Pe.id, _t = Pe.errorDigest, bt = Pe.errorMessage, hr = Pe.errorComponentStack;
        if (n(Z, Ve.startInlineScript), Ve.sentClientRenderFunction ? n(Z, Hr) : (Ve.sentClientRenderFunction = !0, n(
          Z,
          Ho
        )), at === null) throw Error(t(395));
        n(Z, at), n(Z, yo), (_t || bt || hr) && (n(Z, gi), n(Z, l(to(_t || "")))), (bt || hr) && (n(Z, gi), n(Z, l(to(bt || "")))), hr && (n(Z, gi), n(Z, l(to(hr)))), i(Z, Co);
      }
      Se.splice(0, ye);
      var Gn = O.completedBoundaries;
      for (ye = 0; ye < Gn.length; ye++) kc(O, I, Gn[ye]);
      Gn.splice(0, ye), a(I), e = new Uint8Array(512), r = 0;
      var no = O.partialBoundaries;
      for (ye = 0; ye < no.length; ye++) {
        var oo = no[ye];
        e: {
          Se = O, Pe = I;
          var Us = oo.completedSegments;
          for (Ve = 0; Ve < Us.length; Ve++) if (!Gc(
            Se,
            Pe,
            oo,
            Us[Ve]
          )) {
            Ve++, Us.splice(0, Ve);
            var Hc = !1;
            break e;
          }
          Us.splice(0, Ve), Hc = !0;
        }
        if (!Hc) {
          O.destination = null, ye++, no.splice(0, ye);
          return;
        }
      }
      no.splice(0, ye);
      var Xa = O.completedBoundaries;
      for (ye = 0; ye < Xa.length; ye++) kc(O, I, Xa[ye]);
      Xa.splice(0, ye);
    } finally {
      a(I), O.allPendingTasks === 0 && O.pingedTasks.length === 0 && O.clientRenderedBoundaries.length === 0 && O.completedBoundaries.length === 0 && I.close();
    }
  }
  function Vc(O, I) {
    try {
      var U = O.abortableTasks;
      U.forEach(function(Z) {
        return Fc(Z, O, I);
      }), U.clear(), O.destination !== null && tu(O, O.destination);
    } catch (Z) {
      qa(O, Z), Gs(O, Z);
    }
  }
  return nm.renderToReadableStream = function(O, I) {
    return new Promise(function(U, Z) {
      var Se, ye, Pe = new Promise(function(bt, hr) {
        ye = bt, Se = hr;
      }), Ve = Jl(O, se(I ? I.identifierPrefix : void 0, I ? I.nonce : void 0, I ? I.bootstrapScriptContent : void 0, I ? I.bootstrapScripts : void 0, I ? I.bootstrapModules : void 0), K(I ? I.namespaceURI : void 0), I ? I.progressiveChunkSize : void 0, I ? I.onError : void 0, ye, function() {
        var bt = new ReadableStream({ type: "bytes", pull: function(hr) {
          if (Ve.status === 1) Ve.status = 2, c(hr, Ve.fatalError);
          else if (Ve.status !== 2 && Ve.destination === null) {
            Ve.destination = hr;
            try {
              tu(Ve, hr);
            } catch (Gn) {
              qa(Ve, Gn), Gs(Ve, Gn);
            }
          }
        }, cancel: function() {
          Vc(Ve);
        } }, { highWaterMark: 0 });
        bt.allReady = Pe, U(bt);
      }, function(bt) {
        Pe.catch(function() {
        }), Z(bt);
      }, Se);
      if (I && I.signal) {
        var at = I.signal, _t = function() {
          Vc(Ve, at.reason), at.removeEventListener("abort", _t);
        };
        at.addEventListener("abort", _t);
      }
      Lc(Ve);
    });
  }, nm.version = "18.2.0", nm;
}
var Hu = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LP;
function lee() {
  return LP || (LP = 1, process.env.NODE_ENV !== "production" && function() {
    var o = y, t = "18.2.0", e = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(p) {
      {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), E = 1; E < h; E++)
          C[E - 1] = arguments[E];
        i("warn", p, C);
      }
    }
    function n(p) {
      {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), E = 1; E < h; E++)
          C[E - 1] = arguments[E];
        i("error", p, C);
      }
    }
    function i(p, h, C) {
      {
        var E = e.ReactDebugCurrentFrame, A = E.getStackAddendum();
        A !== "" && (h += "%s", C = C.concat([A]));
        var k = C.map(function($) {
          return String($);
        });
        k.unshift("Warning: " + h), Function.prototype.apply.call(console[p], console, k);
      }
    }
    function a(p) {
      p();
    }
    function s(p) {
    }
    function l(p, h) {
      u(p, h);
    }
    function u(p, h) {
      return p.push(h);
    }
    function c(p) {
    }
    function d(p) {
      p.push(null);
    }
    function f(p) {
      return p;
    }
    function v(p) {
      return p;
    }
    function g(p, h) {
      p.destroy(h);
    }
    function m(p) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, C = h && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return C;
      }
    }
    function b(p) {
      try {
        return S(p), !1;
      } catch {
        return !0;
      }
    }
    function S(p) {
      return "" + p;
    }
    function R(p, h) {
      if (b(p))
        return n("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", h, m(p)), S(p);
    }
    function P(p, h) {
      if (b(p))
        return n("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", h, m(p)), S(p);
    }
    function D(p) {
      if (b(p))
        return n("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", m(p)), S(p);
    }
    var x = Object.prototype.hasOwnProperty, M = 0, F = 1, H = 2, B = 3, j = 4, V = 5, W = 6, q = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ee = q + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", re = new RegExp("^[" + q + "][" + ee + "]*$"), ie = {}, ne = {};
    function se(p) {
      return x.call(ne, p) ? !0 : x.call(ie, p) ? !1 : re.test(p) ? (ne[p] = !0, !0) : (ie[p] = !0, n("Invalid attribute name: `%s`", p), !1);
    }
    function pe(p, h, C, E) {
      if (C !== null && C.type === M)
        return !1;
      switch (typeof h) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (C !== null)
            return !C.acceptsBooleans;
          var A = p.toLowerCase().slice(0, 5);
          return A !== "data-" && A !== "aria-";
        }
        default:
          return !1;
      }
    }
    function K(p) {
      return ue.hasOwnProperty(p) ? ue[p] : null;
    }
    function J(p, h, C, E, A, k, $) {
      this.acceptsBooleans = h === H || h === B || h === j, this.attributeName = E, this.attributeNamespace = A, this.mustUseProperty = C, this.propertyName = p, this.type = h, this.sanitizeURL = k, this.removeEmptyString = $;
    }
    var ue = {}, he = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    he.forEach(function(p) {
      ue[p] = new J(
        p,
        M,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(p) {
      var h = p[0], C = p[1];
      ue[h] = new J(
        h,
        F,
        !1,
        // mustUseProperty
        C,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(p) {
      ue[p] = new J(
        p,
        H,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(p) {
      ue[p] = new J(
        p,
        H,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(p) {
      ue[p] = new J(
        p,
        B,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      ue[p] = new J(
        p,
        B,
        !0,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      ue[p] = new J(
        p,
        j,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      ue[p] = new J(
        p,
        W,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(p) {
      ue[p] = new J(
        p,
        V,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var fe = /[\-\:]([a-z])/g, ae = function(p) {
      return p[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var h = p.replace(fe, ae);
      ue[h] = new J(
        h,
        F,
        !1,
        // mustUseProperty
        p,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var h = p.replace(fe, ae);
      ue[h] = new J(
        h,
        F,
        !1,
        // mustUseProperty
        p,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var h = p.replace(fe, ae);
      ue[h] = new J(
        h,
        F,
        !1,
        // mustUseProperty
        p,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(p) {
      ue[p] = new J(
        p,
        F,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var oe = "xlinkHref";
    ue[oe] = new J(
      "xlinkHref",
      F,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(p) {
      ue[p] = new J(
        p,
        F,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ve = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function _e(p, h) {
      return p + h.charAt(0).toUpperCase() + h.substring(1);
    }
    var le = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ve).forEach(function(p) {
      le.forEach(function(h) {
        ve[_e(h, p)] = ve[p];
      });
    });
    var Ee = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function de(p, h) {
      Ee[h.type] || h.onChange || h.onInput || h.readOnly || h.disabled || h.value == null || n("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), h.onChange || h.readOnly || h.disabled || h.checked == null || n("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function X(p, h) {
      if (p.indexOf("-") === -1)
        return typeof h.is == "string";
      switch (p) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var xe = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Le = {}, Ue = new RegExp("^(aria)-[" + ee + "]*$"), He = new RegExp("^(aria)[A-Z][" + ee + "]*$");
    function et(p, h) {
      {
        if (x.call(Le, h) && Le[h])
          return !0;
        if (He.test(h)) {
          var C = "aria-" + h.slice(4).toLowerCase(), E = xe.hasOwnProperty(C) ? C : null;
          if (E == null)
            return n("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", h), Le[h] = !0, !0;
          if (h !== E)
            return n("Invalid ARIA attribute `%s`. Did you mean `%s`?", h, E), Le[h] = !0, !0;
        }
        if (Ue.test(h)) {
          var A = h.toLowerCase(), k = xe.hasOwnProperty(A) ? A : null;
          if (k == null)
            return Le[h] = !0, !1;
          if (h !== k)
            return n("Unknown ARIA attribute `%s`. Did you mean `%s`?", h, k), Le[h] = !0, !0;
        }
      }
      return !0;
    }
    function $e(p, h) {
      {
        var C = [];
        for (var E in h) {
          var A = et(p, E);
          A || C.push(E);
        }
        var k = C.map(function($) {
          return "`" + $ + "`";
        }).join(", ");
        C.length === 1 ? n("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", k, p) : C.length > 1 && n("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", k, p);
      }
    }
    function pt(p, h) {
      X(p, h) || $e(p, h);
    }
    var st = !1;
    function Bt(p, h) {
      {
        if (p !== "input" && p !== "textarea" && p !== "select")
          return;
        h != null && h.value === null && !st && (st = !0, p === "select" && h.multiple ? n("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", p) : n("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", p));
      }
    }
    var vt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, nt = function() {
    };
    {
      var ze = {}, Ct = /^on./, Mt = /^on[^A-Z]/, fr = new RegExp("^(aria)-[" + ee + "]*$"), lt = new RegExp("^(aria)[A-Z][" + ee + "]*$");
      nt = function(p, h, C, E) {
        if (x.call(ze, h) && ze[h])
          return !0;
        var A = h.toLowerCase();
        if (A === "onfocusin" || A === "onfocusout")
          return n("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ze[h] = !0, !0;
        if (E != null) {
          var k = E.registrationNameDependencies, $ = E.possibleRegistrationNames;
          if (k.hasOwnProperty(h))
            return !0;
          var te = $.hasOwnProperty(A) ? $[A] : null;
          if (te != null)
            return n("Invalid event handler property `%s`. Did you mean `%s`?", h, te), ze[h] = !0, !0;
          if (Ct.test(h))
            return n("Unknown event handler property `%s`. It will be ignored.", h), ze[h] = !0, !0;
        } else if (Ct.test(h))
          return Mt.test(h) && n("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", h), ze[h] = !0, !0;
        if (fr.test(h) || lt.test(h))
          return !0;
        if (A === "innerhtml")
          return n("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ze[h] = !0, !0;
        if (A === "aria")
          return n("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ze[h] = !0, !0;
        if (A === "is" && C !== null && C !== void 0 && typeof C != "string")
          return n("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof C), ze[h] = !0, !0;
        if (typeof C == "number" && isNaN(C))
          return n("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", h), ze[h] = !0, !0;
        var me = K(h), Ae = me !== null && me.type === M;
        if (vt.hasOwnProperty(A)) {
          var Ie = vt[A];
          if (Ie !== h)
            return n("Invalid DOM property `%s`. Did you mean `%s`?", h, Ie), ze[h] = !0, !0;
        } else if (!Ae && h !== A)
          return n("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", h, A), ze[h] = !0, !0;
        return typeof C == "boolean" && pe(h, C, me) ? (C ? n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', C, h, h, C, h) : n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', C, h, h, C, h, h, h), ze[h] = !0, !0) : Ae ? !0 : pe(h, C, me) ? (ze[h] = !0, !1) : ((C === "false" || C === "true") && me !== null && me.type === B && (n("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", C, h, C === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', h, C), ze[h] = !0), !0);
      };
    }
    var Et = function(p, h, C) {
      {
        var E = [];
        for (var A in h) {
          var k = nt(p, A, h[A], C);
          k || E.push(A);
        }
        var $ = E.map(function(te) {
          return "`" + te + "`";
        }).join(", ");
        E.length === 1 ? n("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, p) : E.length > 1 && n("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, p);
      }
    };
    function kt(p, h, C) {
      X(p, h) || Et(p, h, C);
    }
    var $t = function() {
    };
    {
      var br = /^(?:webkit|moz|o)[A-Z]/, mt = /^-ms-/, rt = /-(.)/g, Gt = /;\s*$/, zt = {}, Ze = {}, Un = !1, Kr = !1, ln = function(p) {
        return p.replace(rt, function(h, C) {
          return C.toUpperCase();
        });
      }, Ft = function(p) {
        zt.hasOwnProperty(p) && zt[p] || (zt[p] = !0, n(
          "Unsupported style property %s. Did you mean %s?",
          p,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          ln(p.replace(mt, "ms-"))
        ));
      }, ot = function(p) {
        zt.hasOwnProperty(p) && zt[p] || (zt[p] = !0, n("Unsupported vendor-prefixed style property %s. Did you mean %s?", p, p.charAt(0).toUpperCase() + p.slice(1)));
      }, Gr = function(p, h) {
        Ze.hasOwnProperty(h) && Ze[h] || (Ze[h] = !0, n(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, p, h.replace(Gt, "")));
      }, wt = function(p, h) {
        Un || (Un = !0, n("`NaN` is an invalid value for the `%s` css style property.", p));
      }, Qt = function(p, h) {
        Kr || (Kr = !0, n("`Infinity` is an invalid value for the `%s` css style property.", p));
      };
      $t = function(p, h) {
        p.indexOf("-") > -1 ? Ft(p) : br.test(p) ? ot(p) : Gt.test(h) && Gr(p, h), typeof h == "number" && (isNaN(h) ? wt(p, h) : isFinite(h) || Qt(p, h));
      };
    }
    var Sr = $t, jr = /["'&<>]/;
    function $n(p) {
      D(p);
      var h = "" + p, C = jr.exec(h);
      if (!C)
        return h;
      var E, A = "", k, $ = 0;
      for (k = C.index; k < h.length; k++) {
        switch (h.charCodeAt(k)) {
          case 34:
            E = "&quot;";
            break;
          case 38:
            E = "&amp;";
            break;
          case 39:
            E = "&#x27;";
            break;
          case 60:
            E = "&lt;";
            break;
          case 62:
            E = "&gt;";
            break;
          default:
            continue;
        }
        $ !== k && (A += h.substring($, k)), $ = k + 1, A += E;
      }
      return $ !== k ? A + h.substring($, k) : A;
    }
    function Er(p) {
      return typeof p == "boolean" || typeof p == "number" ? "" + p : $n(p);
    }
    var ja = /([A-Z])/g, Ua = /^ms-/;
    function Ps(p) {
      return p.replace(ja, "-$1").toLowerCase().replace(Ua, "-ms-");
    }
    var Vr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, $a = !1;
    function Kl(p) {
      !$a && Vr.test(p) && ($a = !0, n("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(p)));
    }
    var ql = Array.isArray;
    function vo(p) {
      return ql(p);
    }
    var za = "<script>";
    function sa(p, h, C, E, A) {
      var k = p === void 0 ? "" : p, $ = za, te = [];
      return {
        bootstrapChunks: te,
        startInlineScript: $,
        placeholderPrefix: k + "P:",
        segmentPrefix: k + "S:",
        boundaryPrefix: k + "B:",
        idPrefix: k,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var pi = 0, In = 1, go = 2, la = 3, fi = 4, hi = 5, mo = 6, vi = 7;
    function Ln(p, h) {
      return {
        insertionMode: p,
        selectedValue: h
      };
    }
    function Ds(p, h, C) {
      switch (h) {
        case "select":
          return Ln(In, C.value != null ? C.value : C.defaultValue);
        case "svg":
          return Ln(go, null);
        case "math":
          return Ln(la, null);
        case "foreignObject":
          return Ln(In, null);
        case "table":
          return Ln(fi, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Ln(hi, null);
        case "colgroup":
          return Ln(vi, null);
        case "tr":
          return Ln(mo, null);
      }
      return p.insertionMode >= fi || p.insertionMode === pi ? Ln(In, null) : p;
    }
    var As = null;
    function Ho(p) {
      var h = p.nextSuspenseID++;
      return p.boundaryPrefix + h.toString(16);
    }
    function Hr(p, h, C) {
      var E = p.idPrefix, A = ":" + E + "R" + h;
      return C > 0 && (A += "H" + C.toString(32)), A + ":";
    }
    function yo(p) {
      return Er(p);
    }
    var Co = "<!-- -->";
    function gi(p, h, C, E) {
      return h === "" ? E : (E && p.push(Co), p.push(yo(h)), !0);
    }
    function ua(p, h, C, E) {
      C && E && p.push(Co);
    }
    var to = /* @__PURE__ */ new Map();
    function wo(p) {
      var h = to.get(p);
      if (h !== void 0)
        return h;
      var C = Er(Ps(p));
      return to.set(p, C), C;
    }
    var Sn = ' style="', mi = ":", Ni = ";";
    function ca(p, h, C) {
      if (typeof C != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var E = !0;
      for (var A in C)
        if (x.call(C, A)) {
          var k = C[A];
          if (!(k == null || typeof k == "boolean" || k === "")) {
            var $ = void 0, te = void 0, me = A.indexOf("--") === 0;
            me ? ($ = Er(A), P(k, A), te = Er(("" + k).trim())) : (Sr(A, k), $ = wo(A), typeof k == "number" ? k !== 0 && !x.call(ve, A) ? te = k + "px" : te = "" + k : (P(k, A), te = Er(("" + k).trim()))), E ? (E = !1, p.push(Sn, $, mi, te)) : p.push(Ni, $, mi, te);
          }
        }
      E || p.push(En);
    }
    var zn = " ", bo = '="', En = '"', da = '=""';
    function Jr(p, h, C, E) {
      switch (C) {
        case "style": {
          ca(p, h, E);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(C.length > 2 && (C[0] === "o" || C[0] === "O") && (C[1] === "n" || C[1] === "N"))
      ) {
        var A = K(C);
        if (A !== null) {
          switch (typeof E) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!A.acceptsBooleans)
                return;
          }
          var k = A.attributeName, $ = k;
          switch (A.type) {
            case B:
              E && p.push(zn, $, da);
              return;
            case j:
              E === !0 ? p.push(zn, $, da) : E === !1 || p.push(zn, $, bo, Er(E), En);
              return;
            case V:
              isNaN(E) || p.push(zn, $, bo, Er(E), En);
              break;
            case W:
              !isNaN(E) && E >= 1 && p.push(zn, $, bo, Er(E), En);
              break;
            default:
              A.sanitizeURL && (R(E, k), E = "" + E, Kl(E)), p.push(zn, $, bo, Er(E), En);
          }
        } else if (se(C)) {
          switch (typeof E) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var te = C.toLowerCase().slice(0, 5);
              if (te !== "data-" && te !== "aria-")
                return;
            }
          }
          p.push(zn, C, bo, Er(E), En);
        }
      }
    }
    var Nn = ">", T = "/>";
    function L(p, h, C) {
      if (h != null) {
        if (C != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof h != "object" || !("__html" in h))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var E = h.__html;
        E != null && (D(E), p.push("" + E));
      }
    }
    var Y = !1, Q = !1, be = !1, ge = !1, Re = !1, Ge = !1, qe = !1;
    function it(p, h) {
      {
        var C = p[h];
        if (C != null) {
          var E = vo(C);
          p.multiple && !E ? n("The `%s` prop supplied to <select> must be an array if `multiple` is true.", h) : !p.multiple && E && n("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", h);
        }
      }
    }
    function Qe(p, h, C) {
      de("select", h), it(h, "value"), it(h, "defaultValue"), h.value !== void 0 && h.defaultValue !== void 0 && !be && (n("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), be = !0), p.push(Eo("select"));
      var E = null, A = null;
      for (var k in h)
        if (x.call(h, k)) {
          var $ = h[k];
          if ($ == null)
            continue;
          switch (k) {
            case "children":
              E = $;
              break;
            case "dangerouslySetInnerHTML":
              A = $;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Jr(p, C, k, $);
              break;
          }
        }
      return p.push(Nn), L(p, A, E), E;
    }
    function Wt(p) {
      var h = "";
      return o.Children.forEach(p, function(C) {
        C != null && (h += C, !Re && typeof C != "string" && typeof C != "number" && (Re = !0, n("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), h;
    }
    var _n = ' selected=""';
    function xn(p, h, C, E) {
      var A = E.selectedValue;
      p.push(Eo("option"));
      var k = null, $ = null, te = null, me = null;
      for (var Ae in h)
        if (x.call(h, Ae)) {
          var Ie = h[Ae];
          if (Ie == null)
            continue;
          switch (Ae) {
            case "children":
              k = Ie;
              break;
            case "selected":
              te = Ie, qe || (n("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), qe = !0);
              break;
            case "dangerouslySetInnerHTML":
              me = Ie;
              break;
            case "value":
              $ = Ie;
            default:
              Jr(p, C, Ae, Ie);
              break;
          }
        }
      if (A != null) {
        var je;
        if ($ !== null ? (R($, "value"), je = "" + $) : (me !== null && (Ge || (Ge = !0, n("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), je = Wt(k)), vo(A))
          for (var ct = 0; ct < A.length; ct++) {
            R(A[ct], "value");
            var Yt = "" + A[ct];
            if (Yt === je) {
              p.push(_n);
              break;
            }
          }
        else
          R(A, "select.value"), "" + A === je && p.push(_n);
      } else te && p.push(_n);
      return p.push(Nn), L(p, me, k), k;
    }
    function Rn(p, h, C) {
      de("input", h), h.checked !== void 0 && h.defaultChecked !== void 0 && !Q && (n("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", h.type), Q = !0), h.value !== void 0 && h.defaultValue !== void 0 && !Y && (n("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", h.type), Y = !0), p.push(Eo("input"));
      var E = null, A = null, k = null, $ = null;
      for (var te in h)
        if (x.call(h, te)) {
          var me = h[te];
          if (me == null)
            continue;
          switch (te) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              $ = me;
              break;
            case "defaultValue":
              A = me;
              break;
            case "checked":
              k = me;
              break;
            case "value":
              E = me;
              break;
            default:
              Jr(p, C, te, me);
              break;
          }
        }
      return k !== null ? Jr(p, C, "checked", k) : $ !== null && Jr(p, C, "checked", $), E !== null ? Jr(p, C, "value", E) : A !== null && Jr(p, C, "value", A), p.push(T), null;
    }
    function yi(p, h, C) {
      de("textarea", h), h.value !== void 0 && h.defaultValue !== void 0 && !ge && (n("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), ge = !0), p.push(Eo("textarea"));
      var E = null, A = null, k = null;
      for (var $ in h)
        if (x.call(h, $)) {
          var te = h[$];
          if (te == null)
            continue;
          switch ($) {
            case "children":
              k = te;
              break;
            case "value":
              E = te;
              break;
            case "defaultValue":
              A = te;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              Jr(p, C, $, te);
              break;
          }
        }
      if (E === null && A !== null && (E = A), p.push(Nn), k != null) {
        if (n("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), E != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (vo(k)) {
          if (k.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          D(k[0]), E = "" + k[0];
        }
        D(k), E = "" + k;
      }
      return typeof E == "string" && E[0] === `
` && p.push(Gi), E !== null && (R(E, "value"), p.push(yo("" + E))), null;
    }
    function So(p, h, C, E) {
      p.push(Eo(C));
      for (var A in h)
        if (x.call(h, A)) {
          var k = h[A];
          if (k == null)
            continue;
          switch (A) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(C + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              Jr(p, E, A, k);
              break;
          }
        }
      return p.push(T), null;
    }
    function pa(p, h, C) {
      p.push(Eo("menuitem"));
      for (var E in h)
        if (x.call(h, E)) {
          var A = h[E];
          if (A == null)
            continue;
          switch (E) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              Jr(p, C, E, A);
              break;
          }
        }
      return p.push(Nn), null;
    }
    function Ci(p, h, C) {
      p.push(Eo("title"));
      var E = null;
      for (var A in h)
        if (x.call(h, A)) {
          var k = h[A];
          if (k == null)
            continue;
          switch (A) {
            case "children":
              E = k;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              Jr(p, C, A, k);
              break;
          }
        }
      p.push(Nn);
      {
        var $ = Array.isArray(E) && E.length < 2 ? E[0] || null : E;
        Array.isArray(E) && E.length > 1 ? n("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : $ != null && $.$$typeof != null ? n("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : $ != null && typeof $ != "string" && typeof $ != "number" && n("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return E;
    }
    function ki(p, h, C, E) {
      p.push(Eo(C));
      var A = null, k = null;
      for (var $ in h)
        if (x.call(h, $)) {
          var te = h[$];
          if (te == null)
            continue;
          switch ($) {
            case "children":
              A = te;
              break;
            case "dangerouslySetInnerHTML":
              k = te;
              break;
            default:
              Jr(p, E, $, te);
              break;
          }
        }
      return p.push(Nn), L(p, k, A), typeof A == "string" ? (p.push(yo(A)), null) : A;
    }
    function Bo(p, h, C, E) {
      p.push(Eo(C));
      var A = null, k = null;
      for (var $ in h)
        if (x.call(h, $)) {
          var te = h[$];
          if (te == null)
            continue;
          switch ($) {
            case "children":
              A = te;
              break;
            case "dangerouslySetInnerHTML":
              k = te;
              break;
            case "style":
              ca(p, E, te);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              se($) && typeof te != "function" && typeof te != "symbol" && p.push(zn, $, bo, Er(te), En);
              break;
          }
        }
      return p.push(Nn), L(p, k, A), A;
    }
    var Gi = `
`;
    function wp(p, h, C, E) {
      p.push(Eo(C));
      var A = null, k = null;
      for (var $ in h)
        if (x.call(h, $)) {
          var te = h[$];
          if (te == null)
            continue;
          switch ($) {
            case "children":
              A = te;
              break;
            case "dangerouslySetInnerHTML":
              k = te;
              break;
            default:
              Jr(p, E, $, te);
              break;
          }
        }
      if (p.push(Nn), k != null) {
        if (A != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof k != "object" || !("__html" in k))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var me = k.__html;
        me != null && (typeof me == "string" && me.length > 0 && me[0] === `
` ? p.push(Gi, me) : (D(me), p.push("" + me)));
      }
      return typeof A == "string" && A[0] === `
` && p.push(Gi), A;
    }
    var bp = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ms = /* @__PURE__ */ new Map();
    function Eo(p) {
      var h = Ms.get(p);
      if (h === void 0) {
        if (!bp.test(p))
          throw new Error("Invalid tag: " + p);
        h = "<" + p, Ms.set(p, h);
      }
      return h;
    }
    var Sp = "<!DOCTYPE html>";
    function Wo(p, h, C, E, A) {
      switch (pt(h, C), Bt(h, C), kt(h, C, null), !C.suppressContentEditableWarning && C.contentEditable && C.children != null && n("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), A.insertionMode !== go && A.insertionMode !== la && h.indexOf("-") === -1 && typeof C.is != "string" && h.toLowerCase() !== h && n("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", h), h) {
        case "select":
          return Qe(p, C, E);
        case "option":
          return xn(p, C, E, A);
        case "textarea":
          return yi(p, C, E);
        case "input":
          return Rn(p, C, E);
        case "menuitem":
          return pa(p, C, E);
        case "title":
          return Ci(p, C, E);
        case "listing":
        case "pre":
          return wp(p, C, h, E);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return So(p, C, h, E);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return ki(p, C, h, E);
        case "html":
          return A.insertionMode === pi && p.push(Sp), ki(p, C, h, E);
        default:
          return h.indexOf("-") === -1 && typeof C.is != "string" ? ki(p, C, h, E) : Bo(p, C, h, E);
      }
    }
    var Xl = "</", Fs = ">";
    function rr(p, h, C) {
      switch (h) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          p.push(Xl, h, Fs);
      }
    }
    function Vi(p, h) {
      for (var C = h.bootstrapChunks, E = 0; E < C.length - 1; E++)
        l(p, C[E]);
      return E < C.length ? u(p, C[E]) : !0;
    }
    var Is = '<template id="', Hi = '"></template>';
    function wi(p, h, C) {
      l(p, Is), l(p, h.placeholderPrefix);
      var E = C.toString(16);
      return l(p, E), u(p, Hi);
    }
    var Ls = "<!--$-->", bi = '<!--$?--><template id="', ro = '"></template>', Zl = "<!--$!-->", Ya = "<!--/$-->", Rc = "<template", Ns = '"', Tc = ' data-dgst="', Ep = ' data-msg="', _p = ' data-stck="', ks = "></template>";
    function Oc(p, h) {
      return u(p, Ls);
    }
    function Ka(p, h, C) {
      if (l(p, bi), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(p, C), u(p, ro);
    }
    function Ql(p, h, C, E, A) {
      var k;
      return k = u(p, Zl), l(p, Rc), C && (l(p, Tc), l(p, Er(C)), l(p, Ns)), E && (l(p, Ep), l(p, Er(E)), l(p, Ns)), A && (l(p, _p), l(p, Er(A)), l(p, Ns)), k = u(p, ks), k;
    }
    function xp(p, h) {
      return u(p, Ya);
    }
    function fa(p, h) {
      return u(p, Ya);
    }
    function Jl(p, h) {
      return u(p, Ya);
    }
    var eu = '<div hidden id="', ha = '">', qa = "</div>", Gs = '<svg aria-hidden="true" style="display:none" id="', Pc = '">', Dc = "</svg>", Ac = '<math aria-hidden="true" style="display:none" id="', Vs = '">', kn = "</math>", Mc = '<table hidden id="', Hs = '">', Rp = "</table>", Fc = '<table hidden><tbody id="', Bs = '">', Ic = "</tbody></table>", Lc = '<table hidden><tr id="', Ws = '">', js = "</tr></table>", Nc = '<table hidden><colgroup id="', kc = '">', Gc = "</colgroup></table>";
    function tu(p, h, C, E) {
      switch (C.insertionMode) {
        case pi:
        case In:
          return l(p, eu), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, ha);
        case go:
          return l(p, Gs), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, Pc);
        case la:
          return l(p, Ac), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, Vs);
        case fi:
          return l(p, Mc), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, Hs);
        case hi:
          return l(p, Fc), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, Bs);
        case mo:
          return l(p, Lc), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, Ws);
        case vi:
          return l(p, Nc), l(p, h.segmentPrefix), l(p, E.toString(16)), u(p, kc);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Vc(p, h) {
      switch (h.insertionMode) {
        case pi:
        case In:
          return u(p, qa);
        case go:
          return u(p, Dc);
        case la:
          return u(p, kn);
        case fi:
          return u(p, Rp);
        case hi:
          return u(p, Ic);
        case mo:
          return u(p, js);
        case vi:
          return u(p, Gc);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var O = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", I = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', U = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Z = O + ';$RS("', Se = '$RS("', ye = '","', Pe = '")<\/script>';
    function Ve(p, h, C) {
      l(p, h.startInlineScript), h.sentCompleteSegmentFunction ? l(p, Se) : (h.sentCompleteSegmentFunction = !0, l(p, Z)), l(p, h.segmentPrefix);
      var E = C.toString(16);
      return l(p, E), l(p, ye), l(p, h.placeholderPrefix), l(p, E), u(p, Pe);
    }
    var at = I + ';$RC("', _t = '$RC("', bt = '","', hr = '")<\/script>';
    function Gn(p, h, C, E) {
      if (l(p, h.startInlineScript), h.sentCompleteBoundaryFunction ? l(p, _t) : (h.sentCompleteBoundaryFunction = !0, l(p, at)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var A = E.toString(16);
      return l(p, C), l(p, bt), l(p, h.segmentPrefix), l(p, A), u(p, hr);
    }
    var no = U + ';$RX("', oo = '$RX("', Us = '"', Hc = ")<\/script>", Xa = ",";
    function TC(p, h, C, E, A, k) {
      if (l(p, h.startInlineScript), h.sentClientRenderFunction ? l(p, oo) : (h.sentClientRenderFunction = !0, l(p, no)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(p, C), l(p, Us), (E || A || k) && (l(p, Xa), l(p, Tp(E || ""))), (A || k) && (l(p, Xa), l(p, Tp(A || ""))), k && (l(p, Xa), l(p, Tp(k))), u(p, Hc);
    }
    var OC = /[<\u2028\u2029]/g;
    function Tp(p) {
      var h = JSON.stringify(p);
      return h.replace(OC, function(C) {
        switch (C) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function PC(p, h) {
      var C = sa(h);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: C.bootstrapChunks,
        startInlineScript: C.startInlineScript,
        placeholderPrefix: C.placeholderPrefix,
        segmentPrefix: C.segmentPrefix,
        boundaryPrefix: C.boundaryPrefix,
        idPrefix: C.idPrefix,
        nextSuspenseID: C.nextSuspenseID,
        sentCompleteSegmentFunction: C.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: C.sentCompleteBoundaryFunction,
        sentClientRenderFunction: C.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: p
      };
    }
    function DC() {
      return {
        insertionMode: In,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function Cv(p, h, C, E) {
      return C.generateStaticMarkup ? (p.push(Er(h)), !1) : gi(p, h, C, E);
    }
    function wv(p, h, C, E) {
      if (!h.generateStaticMarkup)
        return ua(p, h, C, E);
    }
    function AC(p, h) {
      return h.generateStaticMarkup ? !0 : Oc(p);
    }
    function MC(p, h, C, E, A) {
      return h.generateStaticMarkup ? !0 : Ql(p, h, C, E, A);
    }
    function FC(p, h) {
      return h.generateStaticMarkup ? !0 : xp(p);
    }
    function IC(p, h) {
      return h.generateStaticMarkup ? !0 : Jl(p);
    }
    var Yn = Object.assign, LC = Symbol.for("react.element"), bv = Symbol.for("react.portal"), Bc = Symbol.for("react.fragment"), io = Symbol.for("react.strict_mode"), Sv = Symbol.for("react.profiler"), Wc = Symbol.for("react.provider"), jc = Symbol.for("react.context"), Uc = Symbol.for("react.forward_ref"), $c = Symbol.for("react.suspense"), ru = Symbol.for("react.suspense_list"), nu = Symbol.for("react.memo"), $s = Symbol.for("react.lazy"), Op = Symbol.for("react.scope"), Pp = Symbol.for("react.debug_trace_mode"), Dp = Symbol.for("react.legacy_hidden"), zc = Symbol.for("react.default_value"), Ev = Symbol.iterator, NC = "@@iterator";
    function kC(p) {
      if (p === null || typeof p != "object")
        return null;
      var h = Ev && p[Ev] || p[NC];
      return typeof h == "function" ? h : null;
    }
    function GC(p, h, C) {
      var E = p.displayName;
      if (E)
        return E;
      var A = h.displayName || h.name || "";
      return A !== "" ? C + "(" + A + ")" : C;
    }
    function Ap(p) {
      return p.displayName || "Context";
    }
    function Ar(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && n("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case Bc:
          return "Fragment";
        case bv:
          return "Portal";
        case Sv:
          return "Profiler";
        case io:
          return "StrictMode";
        case $c:
          return "Suspense";
        case ru:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case jc:
            var h = p;
            return Ap(h) + ".Consumer";
          case Wc:
            var C = p;
            return Ap(C._context) + ".Provider";
          case Uc:
            return GC(p, p.render, "ForwardRef");
          case nu:
            var E = p.displayName || null;
            return E !== null ? E : Ar(p.type) || "Memo";
          case $s: {
            var A = p, k = A._payload, $ = A._init;
            try {
              return Ar($(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ou = 0, _v, Mp, Or, zs, Fp, Ip, Lp;
    function Np() {
    }
    Np.__reactDisabledLog = !0;
    function xv() {
      {
        if (ou === 0) {
          _v = console.log, Mp = console.info, Or = console.warn, zs = console.error, Fp = console.group, Ip = console.groupCollapsed, Lp = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: Np,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        ou++;
      }
    }
    function Rv() {
      {
        if (ou--, ou === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Yn({}, p, {
              value: _v
            }),
            info: Yn({}, p, {
              value: Mp
            }),
            warn: Yn({}, p, {
              value: Or
            }),
            error: Yn({}, p, {
              value: zs
            }),
            group: Yn({}, p, {
              value: Fp
            }),
            groupCollapsed: Yn({}, p, {
              value: Ip
            }),
            groupEnd: Yn({}, p, {
              value: Lp
            })
          });
        }
        ou < 0 && n("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Yc = e.ReactCurrentDispatcher, Kc;
    function iu(p, h, C) {
      {
        if (Kc === void 0)
          try {
            throw Error();
          } catch (A) {
            var E = A.stack.trim().match(/\n( *(at )?)/);
            Kc = E && E[1] || "";
          }
        return `
` + Kc + p;
      }
    }
    var kp = !1, Ys;
    {
      var Gp = typeof WeakMap == "function" ? WeakMap : Map;
      Ys = new Gp();
    }
    function Za(p, h) {
      if (!p || kp)
        return "";
      {
        var C = Ys.get(p);
        if (C !== void 0)
          return C;
      }
      var E;
      kp = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = Yc.current, Yc.current = null, xv();
      try {
        if (h) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (mn) {
              E = mn;
            }
            Reflect.construct(p, [], $);
          } else {
            try {
              $.call();
            } catch (mn) {
              E = mn;
            }
            p.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mn) {
            E = mn;
          }
          p();
        }
      } catch (mn) {
        if (mn && E && typeof mn.stack == "string") {
          for (var te = mn.stack.split(`
`), me = E.stack.split(`
`), Ae = te.length - 1, Ie = me.length - 1; Ae >= 1 && Ie >= 0 && te[Ae] !== me[Ie]; )
            Ie--;
          for (; Ae >= 1 && Ie >= 0; Ae--, Ie--)
            if (te[Ae] !== me[Ie]) {
              if (Ae !== 1 || Ie !== 1)
                do
                  if (Ae--, Ie--, Ie < 0 || te[Ae] !== me[Ie]) {
                    var je = `
` + te[Ae].replace(" at new ", " at ");
                    return p.displayName && je.includes("<anonymous>") && (je = je.replace("<anonymous>", p.displayName)), typeof p == "function" && Ys.set(p, je), je;
                  }
                while (Ae >= 1 && Ie >= 0);
              break;
            }
        }
      } finally {
        kp = !1, Yc.current = k, Rv(), Error.prepareStackTrace = A;
      }
      var ct = p ? p.displayName || p.name : "", Yt = ct ? iu(ct) : "";
      return typeof p == "function" && Ys.set(p, Yt), Yt;
    }
    function Vp(p, h, C) {
      return Za(p, !0);
    }
    function au(p, h, C) {
      return Za(p, !1);
    }
    function VC(p) {
      var h = p.prototype;
      return !!(h && h.isReactComponent);
    }
    function su(p, h, C) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return Za(p, VC(p));
      if (typeof p == "string")
        return iu(p);
      switch (p) {
        case $c:
          return iu("Suspense");
        case ru:
          return iu("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case Uc:
            return au(p.render);
          case nu:
            return su(p.type, h, C);
          case $s: {
            var E = p, A = E._payload, k = E._init;
            try {
              return su(k(A), h, C);
            } catch {
            }
          }
        }
      return "";
    }
    var Tv = {}, Hp = e.ReactDebugCurrentFrame;
    function qc(p) {
      if (p) {
        var h = p._owner, C = su(p.type, p._source, h ? h.type : null);
        Hp.setExtraStackFrame(C);
      } else
        Hp.setExtraStackFrame(null);
    }
    function Xc(p, h, C, E, A) {
      {
        var k = Function.call.bind(x);
        for (var $ in p)
          if (k(p, $)) {
            var te = void 0;
            try {
              if (typeof p[$] != "function") {
                var me = Error((E || "React class") + ": " + C + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw me.name = "Invariant Violation", me;
              }
              te = p[$](h, $, E, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ae) {
              te = Ae;
            }
            te && !(te instanceof Error) && (qc(A), n("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", C, $, typeof te), qc(null)), te instanceof Error && !(te.message in Tv) && (Tv[te.message] = !0, qc(A), n("Failed %s type: %s", C, te.message), qc(null));
          }
      }
    }
    var Zc;
    Zc = {};
    var lu = {};
    Object.freeze(lu);
    function uu(p, h) {
      {
        var C = p.contextTypes;
        if (!C)
          return lu;
        var E = {};
        for (var A in C)
          E[A] = h[A];
        {
          var k = Ar(p) || "Unknown";
          Xc(C, E, "context", k);
        }
        return E;
      }
    }
    function Ov(p, h, C, E) {
      {
        if (typeof p.getChildContext != "function") {
          {
            var A = Ar(h) || "Unknown";
            Zc[A] || (Zc[A] = !0, n("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", A, A));
          }
          return C;
        }
        var k = p.getChildContext();
        for (var $ in k)
          if (!($ in E))
            throw new Error((Ar(h) || "Unknown") + '.getChildContext(): key "' + $ + '" is not defined in childContextTypes.');
        {
          var te = Ar(h) || "Unknown";
          Xc(E, k, "child context", te);
        }
        return Yn({}, C, k);
      }
    }
    var Qa;
    Qa = {};
    var Qc = null, va = null;
    function Bp(p) {
      p.context._currentValue2 = p.parentValue;
    }
    function Ja(p) {
      p.context._currentValue2 = p.value;
    }
    function Jc(p, h) {
      if (p !== h) {
        Bp(p);
        var C = p.parent, E = h.parent;
        if (C === null) {
          if (E !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (E === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Jc(C, E);
        }
        Ja(h);
      }
    }
    function ga(p) {
      Bp(p);
      var h = p.parent;
      h !== null && ga(h);
    }
    function ed(p) {
      var h = p.parent;
      h !== null && ed(h), Ja(p);
    }
    function td(p, h) {
      Bp(p);
      var C = p.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      C.depth === h.depth ? Jc(C, h) : td(C, h);
    }
    function cu(p, h) {
      var C = h.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      p.depth === C.depth ? Jc(p, C) : cu(p, C), Ja(h);
    }
    function du(p) {
      var h = va, C = p;
      h !== C && (h === null ? ed(C) : C === null ? ga(h) : h.depth === C.depth ? Jc(h, C) : h.depth > C.depth ? td(h, C) : cu(h, C), va = C);
    }
    function Pv(p, h) {
      var C;
      C = p._currentValue2, p._currentValue2 = h, p._currentRenderer2 !== void 0 && p._currentRenderer2 !== null && p._currentRenderer2 !== Qa && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), p._currentRenderer2 = Qa;
      var E = va, A = {
        parent: E,
        depth: E === null ? 0 : E.depth + 1,
        context: p,
        parentValue: C,
        value: h
      };
      return va = A, A;
    }
    function Dv(p) {
      var h = va;
      if (h === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      h.context !== p && n("The parent context is not the expected context. This is probably a bug in React.");
      {
        var C = h.parentValue;
        C === zc ? h.context._currentValue2 = h.context._defaultValue : h.context._currentValue2 = C, p._currentRenderer2 !== void 0 && p._currentRenderer2 !== null && p._currentRenderer2 !== Qa && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), p._currentRenderer2 = Qa;
      }
      return va = h.parent;
    }
    function Av() {
      return va;
    }
    function ma(p) {
      var h = p._currentValue2;
      return h;
    }
    function Wp(p) {
      return p._reactInternals;
    }
    function HC(p, h) {
      p._reactInternals = h;
    }
    var Mv = {}, Ks = {}, pu, jp, rd, nd, od, qs, fu, hu, id;
    {
      pu = /* @__PURE__ */ new Set(), jp = /* @__PURE__ */ new Set(), rd = /* @__PURE__ */ new Set(), fu = /* @__PURE__ */ new Set(), nd = /* @__PURE__ */ new Set(), hu = /* @__PURE__ */ new Set(), id = /* @__PURE__ */ new Set();
      var vu = /* @__PURE__ */ new Set();
      qs = function(p, h) {
        if (!(p === null || typeof p == "function")) {
          var C = h + "_" + p;
          vu.has(C) || (vu.add(C), n("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", h, p));
        }
      }, od = function(p, h) {
        if (h === void 0) {
          var C = Ar(p) || "Component";
          nd.has(C) || (nd.add(C), n("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", C));
        }
      };
    }
    function ad(p, h) {
      {
        var C = p.constructor, E = C && Ar(C) || "ReactClass", A = E + "." + h;
        if (Mv[A])
          return;
        n(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, h, h, E), Mv[A] = !0;
      }
    }
    var sd = {
      isMounted: function(p) {
        return !1;
      },
      enqueueSetState: function(p, h, C) {
        var E = Wp(p);
        E.queue === null ? ad(p, "setState") : (E.queue.push(h), C != null && qs(C, "setState"));
      },
      enqueueReplaceState: function(p, h, C) {
        var E = Wp(p);
        E.replace = !0, E.queue = [h], C != null && qs(C, "setState");
      },
      enqueueForceUpdate: function(p, h) {
        var C = Wp(p);
        C.queue === null ? ad(p, "forceUpdate") : h != null && qs(h, "setState");
      }
    };
    function Up(p, h, C, E, A) {
      var k = C(A, E);
      od(h, k);
      var $ = k == null ? E : Yn({}, E, k);
      return $;
    }
    function Fv(p, h, C) {
      var E = lu, A = p.contextType;
      if ("contextType" in p) {
        var k = (
          // Allow null for conditional declaration
          A === null || A !== void 0 && A.$$typeof === jc && A._context === void 0
        );
        if (!k && !id.has(p)) {
          id.add(p);
          var $ = "";
          A === void 0 ? $ = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof A != "object" ? $ = " However, it is set to a " + typeof A + "." : A.$$typeof === Wc ? $ = " Did you accidentally pass the Context.Provider instead?" : A._context !== void 0 ? $ = " Did you accidentally pass the Context.Consumer instead?" : $ = " However, it is set to an object with keys {" + Object.keys(A).join(", ") + "}.", n("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Ar(p) || "Component", $);
        }
      }
      typeof A == "object" && A !== null ? E = ma(A) : E = C;
      var te = new p(h, E);
      {
        if (typeof p.getDerivedStateFromProps == "function" && (te.state === null || te.state === void 0)) {
          var me = Ar(p) || "Component";
          pu.has(me) || (pu.add(me), n("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", me, te.state === null ? "null" : "undefined", me));
        }
        if (typeof p.getDerivedStateFromProps == "function" || typeof te.getSnapshotBeforeUpdate == "function") {
          var Ae = null, Ie = null, je = null;
          if (typeof te.componentWillMount == "function" && te.componentWillMount.__suppressDeprecationWarning !== !0 ? Ae = "componentWillMount" : typeof te.UNSAFE_componentWillMount == "function" && (Ae = "UNSAFE_componentWillMount"), typeof te.componentWillReceiveProps == "function" && te.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ie = "componentWillReceiveProps" : typeof te.UNSAFE_componentWillReceiveProps == "function" && (Ie = "UNSAFE_componentWillReceiveProps"), typeof te.componentWillUpdate == "function" && te.componentWillUpdate.__suppressDeprecationWarning !== !0 ? je = "componentWillUpdate" : typeof te.UNSAFE_componentWillUpdate == "function" && (je = "UNSAFE_componentWillUpdate"), Ae !== null || Ie !== null || je !== null) {
            var ct = Ar(p) || "Component", Yt = typeof p.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            rd.has(ct) || (rd.add(ct), n(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ct, Yt, Ae !== null ? `
  ` + Ae : "", Ie !== null ? `
  ` + Ie : "", je !== null ? `
  ` + je : ""));
          }
        }
      }
      return te;
    }
    function Iv(p, h, C) {
      {
        var E = Ar(h) || "Component", A = p.render;
        A || (h.prototype && typeof h.prototype.render == "function" ? n("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", E) : n("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", E)), p.getInitialState && !p.getInitialState.isReactClassApproved && !p.state && n("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", E), p.getDefaultProps && !p.getDefaultProps.isReactClassApproved && n("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", E), p.propTypes && n("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", E), p.contextType && n("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", E), p.contextTypes && n("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", E), h.contextType && h.contextTypes && !hu.has(h) && (hu.add(h), n("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", E)), typeof p.componentShouldUpdate == "function" && n("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", E), h.prototype && h.prototype.isPureReactComponent && typeof p.shouldComponentUpdate < "u" && n("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Ar(h) || "A pure component"), typeof p.componentDidUnmount == "function" && n("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", E), typeof p.componentDidReceiveProps == "function" && n("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", E), typeof p.componentWillRecieveProps == "function" && n("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", E), typeof p.UNSAFE_componentWillRecieveProps == "function" && n("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", E);
        var k = p.props !== C;
        p.props !== void 0 && k && n("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", E, E), p.defaultProps && n("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", E, E), typeof p.getSnapshotBeforeUpdate == "function" && typeof p.componentDidUpdate != "function" && !jp.has(h) && (jp.add(h), n("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Ar(h))), typeof p.getDerivedStateFromProps == "function" && n("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", E), typeof p.getDerivedStateFromError == "function" && n("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", E), typeof h.getSnapshotBeforeUpdate == "function" && n("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", E);
        var $ = p.state;
        $ && (typeof $ != "object" || vo($)) && n("%s.state: must be set to an object or null", E), typeof p.getChildContext == "function" && typeof h.childContextTypes != "object" && n("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", E);
      }
    }
    function Lv(p, h) {
      var C = h.state;
      if (typeof h.componentWillMount == "function") {
        if (h.componentWillMount.__suppressDeprecationWarning !== !0) {
          var E = Ar(p) || "Unknown";
          Ks[E] || (r(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            E
          ), Ks[E] = !0);
        }
        h.componentWillMount();
      }
      typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount(), C !== h.state && (n("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Ar(p) || "Component"), sd.enqueueReplaceState(h, h.state, null));
    }
    function BC(p, h, C, E) {
      if (p.queue !== null && p.queue.length > 0) {
        var A = p.queue, k = p.replace;
        if (p.queue = null, p.replace = !1, k && A.length === 1)
          h.state = A[0];
        else {
          for (var $ = k ? A[0] : h.state, te = !0, me = k ? 1 : 0; me < A.length; me++) {
            var Ae = A[me], Ie = typeof Ae == "function" ? Ae.call(h, $, C, E) : Ae;
            Ie != null && (te ? (te = !1, $ = Yn({}, $, Ie)) : Yn($, Ie));
          }
          h.state = $;
        }
      } else
        p.queue = null;
    }
    function Nv(p, h, C, E) {
      Iv(p, h, C);
      var A = p.state !== void 0 ? p.state : null;
      p.updater = sd, p.props = C, p.state = A;
      var k = {
        queue: [],
        replace: !1
      };
      HC(p, k);
      var $ = h.contextType;
      if (typeof $ == "object" && $ !== null ? p.context = ma($) : p.context = E, p.state === C) {
        var te = Ar(h) || "Component";
        fu.has(te) || (fu.add(te), n("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", te));
      }
      var me = h.getDerivedStateFromProps;
      typeof me == "function" && (p.state = Up(p, h, me, A, C)), typeof h.getDerivedStateFromProps != "function" && typeof p.getSnapshotBeforeUpdate != "function" && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (Lv(h, p), BC(k, p, C, E));
    }
    var WC = {
      id: 1,
      overflow: ""
    };
    function jC(p) {
      var h = p.overflow, C = p.id, E = C & ~UC(C);
      return E.toString(32) + h;
    }
    function $p(p, h, C) {
      var E = p.id, A = p.overflow, k = gu(E) - 1, $ = E & ~(1 << k), te = C + 1, me = gu(h) + k;
      if (me > 30) {
        var Ae = k - k % 5, Ie = (1 << Ae) - 1, je = ($ & Ie).toString(32), ct = $ >> Ae, Yt = k - Ae, mn = gu(h) + Yt, as = te << Yt, ss = as | ct, $i = je + A;
        return {
          id: 1 << mn | ss,
          overflow: $i
        };
      } else {
        var rl = te << k, S0 = rl | $, jN = A;
        return {
          id: 1 << me | S0,
          overflow: jN
        };
      }
    }
    function gu(p) {
      return 32 - $C(p);
    }
    function UC(p) {
      return 1 << gu(p) - 1;
    }
    var $C = Math.clz32 ? Math.clz32 : zC, zp = Math.log, ld = Math.LN2;
    function zC(p) {
      var h = p >>> 0;
      return h === 0 ? 32 : 31 - (zp(h) / ld | 0) | 0;
    }
    function YC(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    var KC = typeof Object.is == "function" ? Object.is : YC, Bi = null, Yp = null, ud = null, _r = null, ao = !1, Xs = !1, es = 0, jt = null, ya = 0, cd = 25, so = !1, lo;
    function Si() {
      if (Bi === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return so && n("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Bi;
    }
    function qC(p, h) {
      if (h === null)
        return n("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", lo), !1;
      p.length !== h.length && n(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, lo, "[" + p.join(", ") + "]", "[" + h.join(", ") + "]");
      for (var C = 0; C < h.length && C < p.length; C++)
        if (!KC(p[C], h[C]))
          return !1;
      return !0;
    }
    function jo() {
      if (ya > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Ca() {
      return _r === null ? ud === null ? (ao = !1, ud = _r = jo()) : (ao = !0, _r = ud) : _r.next === null ? (ao = !1, _r = _r.next = jo()) : (ao = !0, _r = _r.next), _r;
    }
    function ts(p, h) {
      Bi = h, Yp = p, so = !1, es = 0;
    }
    function XC(p, h, C, E) {
      for (; Xs; )
        Xs = !1, es = 0, ya += 1, _r = null, C = p(h, E);
      return mu(), C;
    }
    function Kp() {
      var p = es !== 0;
      return p;
    }
    function mu() {
      so = !1, Bi = null, Yp = null, Xs = !1, ud = null, ya = 0, jt = null, _r = null;
    }
    function ZC(p) {
      return so && n("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), ma(p);
    }
    function QC(p) {
      return lo = "useContext", Si(), ma(p);
    }
    function dd(p, h) {
      return typeof h == "function" ? h(p) : h;
    }
    function qp(p) {
      return lo = "useState", kv(
        dd,
        // useReducer has a special case to support lazy useState initializers
        p
      );
    }
    function kv(p, h, C) {
      if (p !== dd && (lo = "useReducer"), Bi = Si(), _r = Ca(), ao) {
        var E = _r.queue, A = E.dispatch;
        if (jt !== null) {
          var k = jt.get(E);
          if (k !== void 0) {
            jt.delete(E);
            var $ = _r.memoizedState, te = k;
            do {
              var me = te.action;
              so = !0, $ = p($, me), so = !1, te = te.next;
            } while (te !== null);
            return _r.memoizedState = $, [$, A];
          }
        }
        return [_r.memoizedState, A];
      } else {
        so = !0;
        var Ae;
        p === dd ? Ae = typeof h == "function" ? h() : h : Ae = C !== void 0 ? C(h) : h, so = !1, _r.memoizedState = Ae;
        var Ie = _r.queue = {
          last: null,
          dispatch: null
        }, je = Ie.dispatch = Vv.bind(null, Bi, Ie);
        return [_r.memoizedState, je];
      }
    }
    function Gv(p, h) {
      Bi = Si(), _r = Ca();
      var C = h === void 0 ? null : h;
      if (_r !== null) {
        var E = _r.memoizedState;
        if (E !== null && C !== null) {
          var A = E[1];
          if (qC(C, A))
            return E[0];
        }
      }
      so = !0;
      var k = p();
      return so = !1, _r.memoizedState = [k, C], k;
    }
    function Xp(p) {
      Bi = Si(), _r = Ca();
      var h = _r.memoizedState;
      if (h === null) {
        var C = {
          current: p
        };
        return Object.seal(C), _r.memoizedState = C, C;
      } else
        return h;
    }
    function JC(p, h) {
      lo = "useLayoutEffect", n("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Vv(p, h, C) {
      if (ya >= cd)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (p === Bi) {
        Xs = !0;
        var E = {
          action: C,
          next: null
        };
        jt === null && (jt = /* @__PURE__ */ new Map());
        var A = jt.get(h);
        if (A === void 0)
          jt.set(h, E);
        else {
          for (var k = A; k.next !== null; )
            k = k.next;
          k.next = E;
        }
      }
    }
    function Hv(p, h) {
      return Gv(function() {
        return p;
      }, h);
    }
    function e0(p, h, C) {
      return Si(), h(p._source);
    }
    function t0(p, h, C) {
      if (C === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return C();
    }
    function r0(p) {
      return Si(), p;
    }
    function n0() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function o0() {
      return Si(), [!1, n0];
    }
    function i0() {
      var p = Yp, h = jC(p.treeContext), C = Zp;
      if (C === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var E = es++;
      return Hr(C, h, E);
    }
    function pd() {
    }
    var Bv = {
      readContext: ZC,
      useContext: QC,
      useMemo: Gv,
      useReducer: kv,
      useRef: Xp,
      useState: qp,
      useInsertionEffect: pd,
      useLayoutEffect: JC,
      useCallback: Hv,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: pd,
      // Effects are not run in the server environment.
      useEffect: pd,
      // Debugging effect
      useDebugValue: pd,
      useDeferredValue: r0,
      useTransition: o0,
      useId: i0,
      // Subscriptions are not setup in a server environment.
      useMutableSource: e0,
      useSyncExternalStore: t0
    }, Zp = null;
    function Wv(p) {
      Zp = p;
    }
    function fd(p) {
      try {
        var h = "", C = p;
        do {
          switch (C.tag) {
            case 0:
              h += iu(C.type, null, null);
              break;
            case 1:
              h += au(C.type, null, null);
              break;
            case 2:
              h += Vp(C.type, null, null);
              break;
          }
          C = C.parent;
        } while (C);
        return h;
      } catch (E) {
        return `
Error generating stack: ` + E.message + `
` + E.stack;
      }
    }
    var hd = e.ReactCurrentDispatcher, yu = e.ReactDebugCurrentFrame, vd = 0, Zs = 1, gd = 2, md = 3, yd = 4, Qs = 0, Qp = 1, rs = 2, jv = 12800;
    function a0(p) {
      return console.error(p), null;
    }
    function Js() {
    }
    function el(p, h, C, E, A, k, $, te, me) {
      var Ae = [], Ie = /* @__PURE__ */ new Set(), je = {
        destination: null,
        responseState: h,
        progressiveChunkSize: E === void 0 ? jv : E,
        status: Qs,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Ie,
        pingedTasks: Ae,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: A === void 0 ? a0 : A,
        onAllReady: Js,
        onShellReady: $ === void 0 ? Js : $,
        onShellError: Js,
        onFatalError: Js
      }, ct = Cd(
        je,
        0,
        null,
        C,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      ct.parentFlushed = !0;
      var Yt = ns(je, p, null, ct, Ie, lu, Qc, WC);
      return Ae.push(Yt), je;
    }
    function s0(p, h) {
      var C = p.pingedTasks;
      C.push(h), C.length === 1 && a(function() {
        return lf(p);
      });
    }
    function l0(p, h) {
      return {
        id: As,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: h,
        errorDigest: null
      };
    }
    function ns(p, h, C, E, A, k, $, te) {
      p.allPendingTasks++, C === null ? p.pendingRootTasks++ : C.pendingTasks++;
      var me = {
        node: h,
        ping: function() {
          return s0(p, me);
        },
        blockedBoundary: C,
        blockedSegment: E,
        abortSet: A,
        legacyContext: k,
        context: $,
        treeContext: te
      };
      return me.componentStack = null, A.add(me), me;
    }
    function Cd(p, h, C, E, A, k) {
      return {
        status: vd,
        id: -1,
        // lazily assigned later
        index: h,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: E,
        boundary: C,
        lastPushedText: A,
        textEmbedded: k
      };
    }
    var Wi = null;
    function Jp() {
      return Wi === null || Wi.componentStack === null ? "" : fd(Wi.componentStack);
    }
    function os(p, h) {
      p.componentStack = {
        tag: 0,
        parent: p.componentStack,
        type: h
      };
    }
    function Cu(p, h) {
      p.componentStack = {
        tag: 1,
        parent: p.componentStack,
        type: h
      };
    }
    function ji(p, h) {
      p.componentStack = {
        tag: 2,
        parent: p.componentStack,
        type: h
      };
    }
    function Ei(p) {
      p.componentStack === null ? n("Unexpectedly popped too many stack frames. This is a bug in React.") : p.componentStack = p.componentStack.parent;
    }
    var Ui = null;
    function wd(p, h) {
      {
        var C;
        typeof h == "string" ? C = h : h && typeof h.message == "string" ? C = h.message : C = String(h);
        var E = Ui || Jp();
        Ui = null, p.errorMessage = C, p.errorComponentStack = E;
      }
    }
    function wu(p, h) {
      var C = p.onError(h);
      if (C != null && typeof C != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof C + '" instead');
      return C;
    }
    function Uo(p, h) {
      var C = p.onShellError;
      C(h);
      var E = p.onFatalError;
      E(h), p.destination !== null ? (p.status = rs, g(p.destination, h)) : (p.status = Qp, p.fatalError = h);
    }
    function bu(p, h, C) {
      os(h, "Suspense");
      var E = h.blockedBoundary, A = h.blockedSegment, k = C.fallback, $ = C.children, te = /* @__PURE__ */ new Set(), me = l0(p, te), Ae = A.chunks.length, Ie = Cd(
        p,
        Ae,
        me,
        A.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      A.children.push(Ie), A.lastPushedText = !1;
      var je = Cd(
        p,
        0,
        null,
        A.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      je.parentFlushed = !0, h.blockedBoundary = me, h.blockedSegment = je;
      try {
        if (Vn(p, h, $), wv(je.chunks, p.responseState, je.lastPushedText, je.textEmbedded), je.status = Zs, tl(me, je), me.pendingTasks === 0) {
          Ei(h);
          return;
        }
      } catch (Yt) {
        je.status = yd, me.forceClientRender = !0, me.errorDigest = wu(p, Yt), wd(me, Yt);
      } finally {
        h.blockedBoundary = E, h.blockedSegment = A;
      }
      var ct = ns(p, k, E, Ie, te, h.legacyContext, h.context, h.treeContext);
      ct.componentStack = h.componentStack, p.pingedTasks.push(ct), Ei(h);
    }
    function ef(p, h, C, E) {
      os(h, C);
      var A = h.blockedSegment, k = Wo(A.chunks, C, E, p.responseState, A.formatContext);
      A.lastPushedText = !1;
      var $ = A.formatContext;
      A.formatContext = Ds($, C, E), Vn(p, h, k), A.formatContext = $, rr(A.chunks, C), A.lastPushedText = !1, Ei(h);
    }
    function Su(p) {
      return p.prototype && p.prototype.isReactComponent;
    }
    function Eu(p, h, C, E, A) {
      var k = {};
      ts(h, k);
      var $ = C(E, A);
      return XC(C, E, $, A);
    }
    function Uv(p, h, C, E, A) {
      var k = C.render();
      C.props !== A && (rf || n("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Ar(E) || "a component"), rf = !0);
      {
        var $ = E.childContextTypes;
        if ($ != null) {
          var te = h.legacyContext, me = Ov(C, E, te, $);
          h.legacyContext = me, uo(p, h, k), h.legacyContext = te;
          return;
        }
      }
      uo(p, h, k);
    }
    function u0(p, h, C, E) {
      ji(h, C);
      var A = uu(C, h.legacyContext), k = Fv(C, E, A);
      Nv(k, C, E, A), Uv(p, h, k, C, E), Ei(h);
    }
    var $v = {}, _u = {}, tf = {}, zv = {}, rf = !1, xu = !1, nf = !1, of = !1;
    function Yv(p, h, C, E) {
      var A;
      if (A = uu(C, h.legacyContext), Cu(h, C), C.prototype && typeof C.prototype.render == "function") {
        var k = Ar(C) || "Unknown";
        $v[k] || (n("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", k, k), $v[k] = !0);
      }
      var $ = Eu(p, h, C, E, A), te = Kp();
      if (typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0) {
        var me = Ar(C) || "Unknown";
        _u[me] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", me, me, me), _u[me] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0
      ) {
        {
          var Ae = Ar(C) || "Unknown";
          _u[Ae] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ae, Ae, Ae), _u[Ae] = !0);
        }
        Nv($, C, E, A), Uv(p, h, $, C, E);
      } else if (Kv(C), te) {
        var Ie = h.treeContext, je = 1, ct = 0;
        h.treeContext = $p(Ie, je, ct);
        try {
          uo(p, h, $);
        } finally {
          h.treeContext = Ie;
        }
      } else
        uo(p, h, $);
      Ei(h);
    }
    function Kv(p) {
      {
        if (p && p.childContextTypes && n("%s(...): childContextTypes cannot be defined on a function component.", p.displayName || p.name || "Component"), typeof p.getDerivedStateFromProps == "function") {
          var h = Ar(p) || "Unknown";
          zv[h] || (n("%s: Function components do not support getDerivedStateFromProps.", h), zv[h] = !0);
        }
        if (typeof p.contextType == "object" && p.contextType !== null) {
          var C = Ar(p) || "Unknown";
          tf[C] || (n("%s: Function components do not support contextType.", C), tf[C] = !0);
        }
      }
    }
    function af(p, h) {
      if (p && p.defaultProps) {
        var C = Yn({}, h), E = p.defaultProps;
        for (var A in E)
          C[A] === void 0 && (C[A] = E[A]);
        return C;
      }
      return h;
    }
    function qv(p, h, C, E, A) {
      Cu(h, C.render);
      var k = Eu(p, h, C.render, E, A), $ = Kp();
      if ($) {
        var te = h.treeContext, me = 1, Ae = 0;
        h.treeContext = $p(te, me, Ae);
        try {
          uo(p, h, k);
        } finally {
          h.treeContext = te;
        }
      } else
        uo(p, h, k);
      Ei(h);
    }
    function c0(p, h, C, E, A) {
      var k = C.type, $ = af(k, E);
      sf(p, h, k, $, A);
    }
    function d0(p, h, C, E) {
      C._context === void 0 ? C !== C.Consumer && (of || (of = !0, n("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : C = C._context;
      var A = E.children;
      typeof A != "function" && n("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var k = ma(C), $ = A(k);
      uo(p, h, $);
    }
    function Xv(p, h, C, E) {
      var A = C._context, k = E.value, $ = E.children, te;
      te = h.context, h.context = Pv(A, k), uo(p, h, $), h.context = Dv(A), te !== h.context && n("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function p0(p, h, C, E, A) {
      os(h, "Lazy");
      var k = C._payload, $ = C._init, te = $(k), me = af(te, E);
      sf(p, h, te, me, A), Ei(h);
    }
    function sf(p, h, C, E, A) {
      if (typeof C == "function")
        if (Su(C)) {
          u0(p, h, C, E);
          return;
        } else {
          Yv(p, h, C, E);
          return;
        }
      if (typeof C == "string") {
        ef(p, h, C, E);
        return;
      }
      switch (C) {
        case Dp:
        case Pp:
        case io:
        case Sv:
        case Bc: {
          uo(p, h, E.children);
          return;
        }
        case ru: {
          os(h, "SuspenseList"), uo(p, h, E.children), Ei(h);
          return;
        }
        case Op:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case $c: {
          bu(p, h, E);
          return;
        }
      }
      if (typeof C == "object" && C !== null)
        switch (C.$$typeof) {
          case Uc: {
            qv(p, h, C, E, A);
            return;
          }
          case nu: {
            c0(p, h, C, E, A);
            return;
          }
          case Wc: {
            Xv(p, h, C, E);
            return;
          }
          case jc: {
            d0(p, h, C, E);
            return;
          }
          case $s: {
            p0(p, h, C, E);
            return;
          }
        }
      var k = "";
      throw (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (C == null ? C : typeof C) + "." + k));
    }
    function f0(p, h) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      p[Symbol.toStringTag] === "Generator" && (xu || n("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), xu = !0), p.entries === h && (nf || n("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), nf = !0);
    }
    function uo(p, h, C) {
      try {
        return h0(p, h, C);
      } catch (E) {
        throw typeof E == "object" && E !== null && typeof E.then == "function" || (Ui = Ui !== null ? Ui : Jp()), E;
      }
    }
    function h0(p, h, C) {
      if (h.node = C, typeof C == "object" && C !== null) {
        switch (C.$$typeof) {
          case LC: {
            var E = C, A = E.type, k = E.props, $ = E.ref;
            sf(p, h, A, k, $);
            return;
          }
          case bv:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case $s: {
            var te = C, me = te._payload, Ae = te._init, Ie;
            try {
              Ie = Ae(me);
            } catch (rl) {
              throw typeof rl == "object" && rl !== null && typeof rl.then == "function" && os(h, "Lazy"), rl;
            }
            uo(p, h, Ie);
            return;
          }
        }
        if (vo(C)) {
          bd(p, h, C);
          return;
        }
        var je = kC(C);
        if (je) {
          f0(C, je);
          var ct = je.call(C);
          if (ct) {
            var Yt = ct.next();
            if (!Yt.done) {
              var mn = [];
              do
                mn.push(Yt.value), Yt = ct.next();
              while (!Yt.done);
              bd(p, h, mn);
              return;
            }
            return;
          }
        }
        var as = Object.prototype.toString.call(C);
        throw new Error("Objects are not valid as a React child (found: " + (as === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : as) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof C == "string") {
        var ss = h.blockedSegment;
        ss.lastPushedText = Cv(h.blockedSegment.chunks, C, p.responseState, ss.lastPushedText);
        return;
      }
      if (typeof C == "number") {
        var $i = h.blockedSegment;
        $i.lastPushedText = Cv(h.blockedSegment.chunks, "" + C, p.responseState, $i.lastPushedText);
        return;
      }
      typeof C == "function" && n("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function bd(p, h, C) {
      for (var E = C.length, A = 0; A < E; A++) {
        var k = h.treeContext;
        h.treeContext = $p(k, E, A);
        try {
          Vn(p, h, C[A]);
        } finally {
          h.treeContext = k;
        }
      }
    }
    function v0(p, h, C) {
      var E = h.blockedSegment, A = E.chunks.length, k = Cd(
        p,
        A,
        null,
        E.formatContext,
        // Adopt the parent segment's leading text embed
        E.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      E.children.push(k), E.lastPushedText = !1;
      var $ = ns(p, h.node, h.blockedBoundary, k, h.abortSet, h.legacyContext, h.context, h.treeContext);
      h.componentStack !== null && ($.componentStack = h.componentStack.parent);
      var te = $.ping;
      C.then(te, te);
    }
    function Vn(p, h, C) {
      var E = h.blockedSegment.formatContext, A = h.legacyContext, k = h.context, $ = null;
      $ = h.componentStack;
      try {
        return uo(p, h, C);
      } catch (te) {
        if (mu(), typeof te == "object" && te !== null && typeof te.then == "function") {
          v0(p, h, te), h.blockedSegment.formatContext = E, h.legacyContext = A, h.context = k, du(k), h.componentStack = $;
          return;
        } else
          throw h.blockedSegment.formatContext = E, h.legacyContext = A, h.context = k, du(k), h.componentStack = $, te;
      }
    }
    function g0(p, h, C, E) {
      var A = wu(p, E);
      if (h === null ? Uo(p, E) : (h.pendingTasks--, h.forceClientRender || (h.forceClientRender = !0, h.errorDigest = A, wd(h, E), h.parentFlushed && p.clientRenderedBoundaries.push(h))), p.allPendingTasks--, p.allPendingTasks === 0) {
        var k = p.onAllReady;
        k();
      }
    }
    function Zv(p) {
      var h = this, C = p.blockedBoundary, E = p.blockedSegment;
      E.status = md, Jv(h, C, E);
    }
    function Qv(p, h, C) {
      var E = p.blockedBoundary, A = p.blockedSegment;
      if (A.status = md, E === null)
        h.allPendingTasks--, h.status !== rs && (h.status = rs, h.destination !== null && d(h.destination));
      else {
        if (E.pendingTasks--, !E.forceClientRender) {
          E.forceClientRender = !0;
          var k = C === void 0 ? new Error("The render was aborted by the server without a reason.") : C;
          E.errorDigest = h.onError(k);
          {
            var $ = "The server did not finish this Suspense boundary: ";
            k && typeof k.message == "string" ? k = $ + k.message : k = $ + String(k);
            var te = Wi;
            Wi = p;
            try {
              wd(E, k);
            } finally {
              Wi = te;
            }
          }
          E.parentFlushed && h.clientRenderedBoundaries.push(E);
        }
        if (E.fallbackAbortableTasks.forEach(function(Ae) {
          return Qv(Ae, h, C);
        }), E.fallbackAbortableTasks.clear(), h.allPendingTasks--, h.allPendingTasks === 0) {
          var me = h.onAllReady;
          me();
        }
      }
    }
    function tl(p, h) {
      if (h.chunks.length === 0 && h.children.length === 1 && h.children[0].boundary === null) {
        var C = h.children[0];
        C.id = h.id, C.parentFlushed = !0, C.status === Zs && tl(p, C);
      } else {
        var E = p.completedSegments;
        E.push(h);
      }
    }
    function Jv(p, h, C) {
      if (h === null) {
        if (C.parentFlushed) {
          if (p.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          p.completedRootSegment = C;
        }
        if (p.pendingRootTasks--, p.pendingRootTasks === 0) {
          p.onShellError = Js;
          var E = p.onShellReady;
          E();
        }
      } else if (h.pendingTasks--, !h.forceClientRender) {
        if (h.pendingTasks === 0)
          C.parentFlushed && C.status === Zs && tl(h, C), h.parentFlushed && p.completedBoundaries.push(h), h.fallbackAbortableTasks.forEach(Zv, p), h.fallbackAbortableTasks.clear();
        else if (C.parentFlushed && C.status === Zs) {
          tl(h, C);
          var A = h.completedSegments;
          A.length === 1 && h.parentFlushed && p.partialBoundaries.push(h);
        }
      }
      if (p.allPendingTasks--, p.allPendingTasks === 0) {
        var k = p.onAllReady;
        k();
      }
    }
    function m0(p, h) {
      var C = h.blockedSegment;
      if (C.status === vd) {
        du(h.context);
        var E = null;
        E = Wi, Wi = h;
        try {
          uo(p, h, h.node), wv(C.chunks, p.responseState, C.lastPushedText, C.textEmbedded), h.abortSet.delete(h), C.status = Zs, Jv(p, h.blockedBoundary, C);
        } catch (k) {
          if (mu(), typeof k == "object" && k !== null && typeof k.then == "function") {
            var A = h.ping;
            k.then(A, A);
          } else
            h.abortSet.delete(h), C.status = yd, g0(p, h.blockedBoundary, C, k);
        } finally {
          Wi = E;
        }
      }
    }
    function lf(p) {
      if (p.status !== rs) {
        var h = Av(), C = hd.current;
        hd.current = Bv;
        var E;
        E = yu.getCurrentStack, yu.getCurrentStack = Jp;
        var A = Zp;
        Wv(p.responseState);
        try {
          var k = p.pingedTasks, $;
          for ($ = 0; $ < k.length; $++) {
            var te = k[$];
            m0(p, te);
          }
          k.splice(0, $), p.destination !== null && Ed(p, p.destination);
        } catch (me) {
          wu(p, me), Uo(p, me);
        } finally {
          Wv(A), hd.current = C, yu.getCurrentStack = E, C === Bv && du(h);
        }
      }
    }
    function is(p, h, C) {
      switch (C.parentFlushed = !0, C.status) {
        case vd: {
          var E = C.id = p.nextSegmentId++;
          return C.lastPushedText = !1, C.textEmbedded = !1, wi(h, p.responseState, E);
        }
        case Zs: {
          C.status = gd;
          for (var A = !0, k = C.chunks, $ = 0, te = C.children, me = 0; me < te.length; me++) {
            for (var Ae = te[me]; $ < Ae.index; $++)
              l(h, k[$]);
            A = Ru(p, h, Ae);
          }
          for (; $ < k.length - 1; $++)
            l(h, k[$]);
          return $ < k.length && (A = u(h, k[$])), A;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Ru(p, h, C) {
      var E = C.boundary;
      if (E === null)
        return is(p, h, C);
      if (E.parentFlushed = !0, E.forceClientRender)
        return MC(h, p.responseState, E.errorDigest, E.errorMessage, E.errorComponentStack), is(p, h, C), IC(h, p.responseState);
      if (E.pendingTasks > 0) {
        E.rootSegmentID = p.nextSegmentId++, E.completedSegments.length > 0 && p.partialBoundaries.push(E);
        var A = E.id = Ho(p.responseState);
        return Ka(h, p.responseState, A), is(p, h, C), fa(h, p.responseState);
      } else {
        if (E.byteSize > p.progressiveChunkSize)
          return E.rootSegmentID = p.nextSegmentId++, p.completedBoundaries.push(E), Ka(h, p.responseState, E.id), is(p, h, C), fa(h, p.responseState);
        AC(h, p.responseState);
        var k = E.completedSegments;
        if (k.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var $ = k[0];
        return Ru(p, h, $), FC(h, p.responseState);
      }
    }
    function y0(p, h, C) {
      return TC(h, p.responseState, C.id, C.errorDigest, C.errorMessage, C.errorComponentStack);
    }
    function uf(p, h, C) {
      return tu(h, p.responseState, C.formatContext, C.id), Ru(p, h, C), Vc(h, C.formatContext);
    }
    function Tu(p, h, C) {
      for (var E = C.completedSegments, A = 0; A < E.length; A++) {
        var k = E[A];
        eg(p, h, C, k);
      }
      return E.length = 0, Gn(h, p.responseState, C.id, C.rootSegmentID);
    }
    function Sd(p, h, C) {
      for (var E = C.completedSegments, A = 0; A < E.length; A++) {
        var k = E[A];
        if (!eg(p, h, C, k))
          return A++, E.splice(0, A), !1;
      }
      return E.splice(0, A), !0;
    }
    function eg(p, h, C, E) {
      if (E.status === gd)
        return !0;
      var A = E.id;
      if (A === -1) {
        var k = E.id = C.rootSegmentID;
        if (k === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return uf(p, h, E);
      } else
        return uf(p, h, E), Ve(h, p.responseState, A);
    }
    function Ed(p, h) {
      try {
        var C = p.completedRootSegment;
        C !== null && p.pendingRootTasks === 0 && (Ru(p, h, C), p.completedRootSegment = null, Vi(h, p.responseState));
        var E = p.clientRenderedBoundaries, A;
        for (A = 0; A < E.length; A++) {
          var k = E[A];
          if (!y0(p, h, k)) {
            p.destination = null, A++, E.splice(0, A);
            return;
          }
        }
        E.splice(0, A);
        var $ = p.completedBoundaries;
        for (A = 0; A < $.length; A++) {
          var te = $[A];
          if (!Tu(p, h, te)) {
            p.destination = null, A++, $.splice(0, A);
            return;
          }
        }
        $.splice(0, A);
        var me = p.partialBoundaries;
        for (A = 0; A < me.length; A++) {
          var Ae = me[A];
          if (!Sd(p, h, Ae)) {
            p.destination = null, A++, me.splice(0, A);
            return;
          }
        }
        me.splice(0, A);
        var Ie = p.completedBoundaries;
        for (A = 0; A < Ie.length; A++) {
          var je = Ie[A];
          if (!Tu(p, h, je)) {
            p.destination = null, A++, Ie.splice(0, A);
            return;
          }
        }
        Ie.splice(0, A);
      } finally {
        p.allPendingTasks === 0 && p.pingedTasks.length === 0 && p.clientRenderedBoundaries.length === 0 && p.completedBoundaries.length === 0 && (p.abortableTasks.size !== 0 && n("There was still abortable task at the root when we closed. This is a bug in React."), d(h));
      }
    }
    function tg(p) {
      a(function() {
        return lf(p);
      });
    }
    function C0(p, h) {
      if (p.status === Qp) {
        p.status = rs, g(h, p.fatalError);
        return;
      }
      if (p.status !== rs && p.destination === null) {
        p.destination = h;
        try {
          Ed(p, h);
        } catch (C) {
          wu(p, C), Uo(p, C);
        }
      }
    }
    function rg(p, h) {
      try {
        var C = p.abortableTasks;
        C.forEach(function(E) {
          return Qv(E, p, h);
        }), C.clear(), p.destination !== null && Ed(p, p.destination);
      } catch (E) {
        wu(p, E), Uo(p, E);
      }
    }
    function cf() {
    }
    function ng(p, h, C, E) {
      var A = !1, k = null, $ = "", te = {
        push: function(je) {
          return je !== null && ($ += je), !0;
        },
        destroy: function(je) {
          A = !0, k = je;
        }
      }, me = !1;
      function Ae() {
        me = !0;
      }
      var Ie = el(p, PC(C, h ? h.identifierPrefix : void 0), DC(), 1 / 0, cf, void 0, Ae);
      if (tg(Ie), rg(Ie, E), C0(Ie, te), A)
        throw k;
      if (!me)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return $;
    }
    function w0(p, h) {
      return ng(p, h, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function og(p, h) {
      return ng(p, h, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function b0() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function w() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    Hu.renderToNodeStream = b0, Hu.renderToStaticMarkup = og, Hu.renderToStaticNodeStream = w, Hu.renderToString = w0, Hu.version = t;
  }()), Hu;
}
var om = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NP;
function uee() {
  return NP || (NP = 1, process.env.NODE_ENV !== "production" && function() {
    var o = y, t = "18.2.0", e = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(w) {
      {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), C = 1; C < p; C++)
          h[C - 1] = arguments[C];
        i("warn", w, h);
      }
    }
    function n(w) {
      {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), C = 1; C < p; C++)
          h[C - 1] = arguments[C];
        i("error", w, h);
      }
    }
    function i(w, p, h) {
      {
        var C = e.ReactDebugCurrentFrame, E = C.getStackAddendum();
        E !== "" && (p += "%s", h = h.concat([E]));
        var A = h.map(function(k) {
          return String(k);
        });
        A.unshift("Warning: " + p), Function.prototype.apply.call(console[w], console, A);
      }
    }
    function a(w) {
      w();
    }
    var s = 512, l = null, u = 0;
    function c(w) {
      l = new Uint8Array(s), u = 0;
    }
    function d(w, p) {
      if (p.length !== 0) {
        if (p.length > s) {
          u > 0 && (w.enqueue(new Uint8Array(l.buffer, 0, u)), l = new Uint8Array(s), u = 0), w.enqueue(p);
          return;
        }
        var h = p, C = l.length - u;
        C < h.length && (C === 0 ? w.enqueue(l) : (l.set(h.subarray(0, C), u), w.enqueue(l), h = h.subarray(C)), l = new Uint8Array(s), u = 0), l.set(h, u), u += h.length;
      }
    }
    function f(w, p) {
      return d(w, p), !0;
    }
    function v(w) {
      l && u > 0 && (w.enqueue(new Uint8Array(l.buffer, 0, u)), l = null, u = 0);
    }
    function g(w) {
      w.close();
    }
    var m = new TextEncoder();
    function b(w) {
      return m.encode(w);
    }
    function S(w) {
      return m.encode(w);
    }
    function R(w, p) {
      typeof w.error == "function" ? w.error(p) : w.close();
    }
    function P(w) {
      {
        var p = typeof Symbol == "function" && Symbol.toStringTag, h = p && w[Symbol.toStringTag] || w.constructor.name || "Object";
        return h;
      }
    }
    function D(w) {
      try {
        return x(w), !1;
      } catch {
        return !0;
      }
    }
    function x(w) {
      return "" + w;
    }
    function M(w, p) {
      if (D(w))
        return n("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", p, P(w)), x(w);
    }
    function F(w, p) {
      if (D(w))
        return n("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", p, P(w)), x(w);
    }
    function H(w) {
      if (D(w))
        return n("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", P(w)), x(w);
    }
    var B = Object.prototype.hasOwnProperty, j = 0, V = 1, W = 2, q = 3, ee = 4, re = 5, ie = 6, ne = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", se = ne + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", pe = new RegExp("^[" + ne + "][" + se + "]*$"), K = {}, J = {};
    function ue(w) {
      return B.call(J, w) ? !0 : B.call(K, w) ? !1 : pe.test(w) ? (J[w] = !0, !0) : (K[w] = !0, n("Invalid attribute name: `%s`", w), !1);
    }
    function he(w, p, h, C) {
      if (h !== null && h.type === j)
        return !1;
      switch (typeof p) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (h !== null)
            return !h.acceptsBooleans;
          var E = w.toLowerCase().slice(0, 5);
          return E !== "data-" && E !== "aria-";
        }
        default:
          return !1;
      }
    }
    function fe(w) {
      return oe.hasOwnProperty(w) ? oe[w] : null;
    }
    function ae(w, p, h, C, E, A, k) {
      this.acceptsBooleans = p === W || p === q || p === ee, this.attributeName = C, this.attributeNamespace = E, this.mustUseProperty = h, this.propertyName = w, this.type = p, this.sanitizeURL = A, this.removeEmptyString = k;
    }
    var oe = {}, ve = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    ve.forEach(function(w) {
      oe[w] = new ae(
        w,
        j,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(w) {
      var p = w[0], h = w[1];
      oe[p] = new ae(
        p,
        V,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(w) {
      oe[w] = new ae(
        w,
        W,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(w) {
      oe[w] = new ae(
        w,
        W,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(w) {
      oe[w] = new ae(
        w,
        q,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      oe[w] = new ae(
        w,
        q,
        !0,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      oe[w] = new ae(
        w,
        ee,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      oe[w] = new ae(
        w,
        ie,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(w) {
      oe[w] = new ae(
        w,
        re,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var _e = /[\-\:]([a-z])/g, le = function(w) {
      return w[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(_e, le);
      oe[p] = new ae(
        p,
        V,
        !1,
        // mustUseProperty
        w,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(_e, le);
      oe[p] = new ae(
        p,
        V,
        !1,
        // mustUseProperty
        w,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(_e, le);
      oe[p] = new ae(
        p,
        V,
        !1,
        // mustUseProperty
        w,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(w) {
      oe[w] = new ae(
        w,
        V,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Ee = "xlinkHref";
    oe[Ee] = new ae(
      "xlinkHref",
      V,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(w) {
      oe[w] = new ae(
        w,
        V,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var de = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function X(w, p) {
      return w + p.charAt(0).toUpperCase() + p.substring(1);
    }
    var xe = ["Webkit", "ms", "Moz", "O"];
    Object.keys(de).forEach(function(w) {
      xe.forEach(function(p) {
        de[X(p, w)] = de[w];
      });
    });
    var Le = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ue(w, p) {
      Le[p.type] || p.onChange || p.onInput || p.readOnly || p.disabled || p.value == null || n("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), p.onChange || p.readOnly || p.disabled || p.checked == null || n("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function He(w, p) {
      if (w.indexOf("-") === -1)
        return typeof p.is == "string";
      switch (w) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var et = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, $e = {}, pt = new RegExp("^(aria)-[" + se + "]*$"), st = new RegExp("^(aria)[A-Z][" + se + "]*$");
    function Bt(w, p) {
      {
        if (B.call($e, p) && $e[p])
          return !0;
        if (st.test(p)) {
          var h = "aria-" + p.slice(4).toLowerCase(), C = et.hasOwnProperty(h) ? h : null;
          if (C == null)
            return n("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", p), $e[p] = !0, !0;
          if (p !== C)
            return n("Invalid ARIA attribute `%s`. Did you mean `%s`?", p, C), $e[p] = !0, !0;
        }
        if (pt.test(p)) {
          var E = p.toLowerCase(), A = et.hasOwnProperty(E) ? E : null;
          if (A == null)
            return $e[p] = !0, !1;
          if (p !== A)
            return n("Unknown ARIA attribute `%s`. Did you mean `%s`?", p, A), $e[p] = !0, !0;
        }
      }
      return !0;
    }
    function vt(w, p) {
      {
        var h = [];
        for (var C in p) {
          var E = Bt(w, C);
          E || h.push(C);
        }
        var A = h.map(function(k) {
          return "`" + k + "`";
        }).join(", ");
        h.length === 1 ? n("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", A, w) : h.length > 1 && n("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", A, w);
      }
    }
    function nt(w, p) {
      He(w, p) || vt(w, p);
    }
    var ze = !1;
    function Ct(w, p) {
      {
        if (w !== "input" && w !== "textarea" && w !== "select")
          return;
        p != null && p.value === null && !ze && (ze = !0, w === "select" && p.multiple ? n("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", w) : n("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", w));
      }
    }
    var Mt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, fr = function() {
    };
    {
      var lt = {}, Et = /^on./, kt = /^on[^A-Z]/, $t = new RegExp("^(aria)-[" + se + "]*$"), br = new RegExp("^(aria)[A-Z][" + se + "]*$");
      fr = function(w, p, h, C) {
        if (B.call(lt, p) && lt[p])
          return !0;
        var E = p.toLowerCase();
        if (E === "onfocusin" || E === "onfocusout")
          return n("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), lt[p] = !0, !0;
        if (C != null) {
          var A = C.registrationNameDependencies, k = C.possibleRegistrationNames;
          if (A.hasOwnProperty(p))
            return !0;
          var $ = k.hasOwnProperty(E) ? k[E] : null;
          if ($ != null)
            return n("Invalid event handler property `%s`. Did you mean `%s`?", p, $), lt[p] = !0, !0;
          if (Et.test(p))
            return n("Unknown event handler property `%s`. It will be ignored.", p), lt[p] = !0, !0;
        } else if (Et.test(p))
          return kt.test(p) && n("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", p), lt[p] = !0, !0;
        if ($t.test(p) || br.test(p))
          return !0;
        if (E === "innerhtml")
          return n("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), lt[p] = !0, !0;
        if (E === "aria")
          return n("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), lt[p] = !0, !0;
        if (E === "is" && h !== null && h !== void 0 && typeof h != "string")
          return n("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof h), lt[p] = !0, !0;
        if (typeof h == "number" && isNaN(h))
          return n("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", p), lt[p] = !0, !0;
        var te = fe(p), me = te !== null && te.type === j;
        if (Mt.hasOwnProperty(E)) {
          var Ae = Mt[E];
          if (Ae !== p)
            return n("Invalid DOM property `%s`. Did you mean `%s`?", p, Ae), lt[p] = !0, !0;
        } else if (!me && p !== E)
          return n("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", p, E), lt[p] = !0, !0;
        return typeof h == "boolean" && he(p, h, te) ? (h ? n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', h, p, p, h, p) : n('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', h, p, p, h, p, p, p), lt[p] = !0, !0) : me ? !0 : he(p, h, te) ? (lt[p] = !0, !1) : ((h === "false" || h === "true") && te !== null && te.type === q && (n("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", h, p, h === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', p, h), lt[p] = !0), !0);
      };
    }
    var mt = function(w, p, h) {
      {
        var C = [];
        for (var E in p) {
          var A = fr(w, E, p[E], h);
          A || C.push(E);
        }
        var k = C.map(function($) {
          return "`" + $ + "`";
        }).join(", ");
        C.length === 1 ? n("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", k, w) : C.length > 1 && n("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", k, w);
      }
    };
    function rt(w, p, h) {
      He(w, p) || mt(w, p, h);
    }
    var Gt = function() {
    };
    {
      var zt = /^(?:webkit|moz|o)[A-Z]/, Ze = /^-ms-/, Un = /-(.)/g, Kr = /;\s*$/, ln = {}, Ft = {}, ot = !1, Gr = !1, wt = function(w) {
        return w.replace(Un, function(p, h) {
          return h.toUpperCase();
        });
      }, Qt = function(w) {
        ln.hasOwnProperty(w) && ln[w] || (ln[w] = !0, n(
          "Unsupported style property %s. Did you mean %s?",
          w,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          wt(w.replace(Ze, "ms-"))
        ));
      }, Sr = function(w) {
        ln.hasOwnProperty(w) && ln[w] || (ln[w] = !0, n("Unsupported vendor-prefixed style property %s. Did you mean %s?", w, w.charAt(0).toUpperCase() + w.slice(1)));
      }, jr = function(w, p) {
        Ft.hasOwnProperty(p) && Ft[p] || (Ft[p] = !0, n(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, w, p.replace(Kr, "")));
      }, $n = function(w, p) {
        ot || (ot = !0, n("`NaN` is an invalid value for the `%s` css style property.", w));
      }, Er = function(w, p) {
        Gr || (Gr = !0, n("`Infinity` is an invalid value for the `%s` css style property.", w));
      };
      Gt = function(w, p) {
        w.indexOf("-") > -1 ? Qt(w) : zt.test(w) ? Sr(w) : Kr.test(p) && jr(w, p), typeof p == "number" && (isNaN(p) ? $n(w, p) : isFinite(p) || Er(w, p));
      };
    }
    var ja = Gt, Ua = /["'&<>]/;
    function Ps(w) {
      H(w);
      var p = "" + w, h = Ua.exec(p);
      if (!h)
        return p;
      var C, E = "", A, k = 0;
      for (A = h.index; A < p.length; A++) {
        switch (p.charCodeAt(A)) {
          case 34:
            C = "&quot;";
            break;
          case 38:
            C = "&amp;";
            break;
          case 39:
            C = "&#x27;";
            break;
          case 60:
            C = "&lt;";
            break;
          case 62:
            C = "&gt;";
            break;
          default:
            continue;
        }
        k !== A && (E += p.substring(k, A)), k = A + 1, E += C;
      }
      return k !== A ? E + p.substring(k, A) : E;
    }
    function Vr(w) {
      return typeof w == "boolean" || typeof w == "number" ? "" + w : Ps(w);
    }
    var $a = /([A-Z])/g, Kl = /^ms-/;
    function ql(w) {
      return w.replace($a, "-$1").toLowerCase().replace(Kl, "-ms-");
    }
    var vo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, za = !1;
    function sa(w) {
      !za && vo.test(w) && (za = !0, n("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(w)));
    }
    var pi = Array.isArray;
    function In(w) {
      return pi(w);
    }
    var go = S("<script>"), la = S("<\/script>"), fi = S('<script src="'), hi = S('<script type="module" src="'), mo = S('" async=""><\/script>');
    function vi(w) {
      return H(w), ("" + w).replace(Ln, Ds);
    }
    var Ln = /(<\/|<)(s)(cript)/gi, Ds = function(w, p, h, C) {
      return "" + p + (h === "s" ? "\\u0073" : "\\u0053") + C;
    };
    function As(w, p, h, C, E) {
      var A = w === void 0 ? "" : w, k = p === void 0 ? go : S('<script nonce="' + Vr(p) + '">'), $ = [];
      if (h !== void 0 && $.push(k, b(vi(h)), la), C !== void 0)
        for (var te = 0; te < C.length; te++)
          $.push(fi, b(Vr(C[te])), mo);
      if (E !== void 0)
        for (var me = 0; me < E.length; me++)
          $.push(hi, b(Vr(E[me])), mo);
      return {
        bootstrapChunks: $,
        startInlineScript: k,
        placeholderPrefix: S(A + "P:"),
        segmentPrefix: S(A + "S:"),
        boundaryPrefix: A + "B:",
        idPrefix: A,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Ho = 0, Hr = 1, yo = 2, Co = 3, gi = 4, ua = 5, to = 6, wo = 7;
    function Sn(w, p) {
      return {
        insertionMode: w,
        selectedValue: p
      };
    }
    function mi(w) {
      var p = w === "http://www.w3.org/2000/svg" ? yo : w === "http://www.w3.org/1998/Math/MathML" ? Co : Ho;
      return Sn(p, null);
    }
    function Ni(w, p, h) {
      switch (p) {
        case "select":
          return Sn(Hr, h.value != null ? h.value : h.defaultValue);
        case "svg":
          return Sn(yo, null);
        case "math":
          return Sn(Co, null);
        case "foreignObject":
          return Sn(Hr, null);
        case "table":
          return Sn(gi, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Sn(ua, null);
        case "colgroup":
          return Sn(wo, null);
        case "tr":
          return Sn(to, null);
      }
      return w.insertionMode >= gi || w.insertionMode === Ho ? Sn(Hr, null) : w;
    }
    var ca = null;
    function zn(w) {
      var p = w.nextSuspenseID++;
      return S(w.boundaryPrefix + p.toString(16));
    }
    function bo(w, p, h) {
      var C = w.idPrefix, E = ":" + C + "R" + p;
      return h > 0 && (E += "H" + h.toString(32)), E + ":";
    }
    function En(w) {
      return Vr(w);
    }
    var da = S("<!-- -->");
    function Jr(w, p, h, C) {
      return p === "" ? C : (C && w.push(da), w.push(b(En(p))), !0);
    }
    function Nn(w, p, h, C) {
      h && C && w.push(da);
    }
    var T = /* @__PURE__ */ new Map();
    function L(w) {
      var p = T.get(w);
      if (p !== void 0)
        return p;
      var h = S(Vr(ql(w)));
      return T.set(w, h), h;
    }
    var Y = S(' style="'), Q = S(":"), be = S(";");
    function ge(w, p, h) {
      if (typeof h != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var C = !0;
      for (var E in h)
        if (B.call(h, E)) {
          var A = h[E];
          if (!(A == null || typeof A == "boolean" || A === "")) {
            var k = void 0, $ = void 0, te = E.indexOf("--") === 0;
            te ? (k = b(Vr(E)), F(A, E), $ = b(Vr(("" + A).trim()))) : (ja(E, A), k = L(E), typeof A == "number" ? A !== 0 && !B.call(de, E) ? $ = b(A + "px") : $ = b("" + A) : (F(A, E), $ = b(Vr(("" + A).trim())))), C ? (C = !1, w.push(Y, k, Q, $)) : w.push(be, k, Q, $);
          }
        }
      C || w.push(qe);
    }
    var Re = S(" "), Ge = S('="'), qe = S('"'), it = S('=""');
    function Qe(w, p, h, C) {
      switch (h) {
        case "style": {
          ge(w, p, C);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(h.length > 2 && (h[0] === "o" || h[0] === "O") && (h[1] === "n" || h[1] === "N"))
      ) {
        var E = fe(h);
        if (E !== null) {
          switch (typeof C) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!E.acceptsBooleans)
                return;
          }
          var A = E.attributeName, k = b(A);
          switch (E.type) {
            case q:
              C && w.push(Re, k, it);
              return;
            case ee:
              C === !0 ? w.push(Re, k, it) : C === !1 || w.push(Re, k, Ge, b(Vr(C)), qe);
              return;
            case re:
              isNaN(C) || w.push(Re, k, Ge, b(Vr(C)), qe);
              break;
            case ie:
              !isNaN(C) && C >= 1 && w.push(Re, k, Ge, b(Vr(C)), qe);
              break;
            default:
              E.sanitizeURL && (M(C, A), C = "" + C, sa(C)), w.push(Re, k, Ge, b(Vr(C)), qe);
          }
        } else if (ue(h)) {
          switch (typeof C) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var $ = h.toLowerCase().slice(0, 5);
              if ($ !== "data-" && $ !== "aria-")
                return;
            }
          }
          w.push(Re, b(h), Ge, b(Vr(C)), qe);
        }
      }
    }
    var Wt = S(">"), _n = S("/>");
    function xn(w, p, h) {
      if (p != null) {
        if (h != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof p != "object" || !("__html" in p))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var C = p.__html;
        C != null && (H(C), w.push(b("" + C)));
      }
    }
    var Rn = !1, yi = !1, So = !1, pa = !1, Ci = !1, ki = !1, Bo = !1;
    function Gi(w, p) {
      {
        var h = w[p];
        if (h != null) {
          var C = In(h);
          w.multiple && !C ? n("The `%s` prop supplied to <select> must be an array if `multiple` is true.", p) : !w.multiple && C && n("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", p);
        }
      }
    }
    function wp(w, p, h) {
      Ue("select", p), Gi(p, "value"), Gi(p, "defaultValue"), p.value !== void 0 && p.defaultValue !== void 0 && !So && (n("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), So = !0), w.push(ro("select"));
      var C = null, E = null;
      for (var A in p)
        if (B.call(p, A)) {
          var k = p[A];
          if (k == null)
            continue;
          switch (A) {
            case "children":
              C = k;
              break;
            case "dangerouslySetInnerHTML":
              E = k;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Qe(w, h, A, k);
              break;
          }
        }
      return w.push(Wt), xn(w, E, C), C;
    }
    function bp(w) {
      var p = "";
      return o.Children.forEach(w, function(h) {
        h != null && (p += h, !Ci && typeof h != "string" && typeof h != "number" && (Ci = !0, n("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), p;
    }
    var Ms = S(' selected=""');
    function Eo(w, p, h, C) {
      var E = C.selectedValue;
      w.push(ro("option"));
      var A = null, k = null, $ = null, te = null;
      for (var me in p)
        if (B.call(p, me)) {
          var Ae = p[me];
          if (Ae == null)
            continue;
          switch (me) {
            case "children":
              A = Ae;
              break;
            case "selected":
              $ = Ae, Bo || (n("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Bo = !0);
              break;
            case "dangerouslySetInnerHTML":
              te = Ae;
              break;
            case "value":
              k = Ae;
            default:
              Qe(w, h, me, Ae);
              break;
          }
        }
      if (E != null) {
        var Ie;
        if (k !== null ? (M(k, "value"), Ie = "" + k) : (te !== null && (ki || (ki = !0, n("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Ie = bp(A)), In(E))
          for (var je = 0; je < E.length; je++) {
            M(E[je], "value");
            var ct = "" + E[je];
            if (ct === Ie) {
              w.push(Ms);
              break;
            }
          }
        else
          M(E, "select.value"), "" + E === Ie && w.push(Ms);
      } else $ && w.push(Ms);
      return w.push(Wt), xn(w, te, A), A;
    }
    function Sp(w, p, h) {
      Ue("input", p), p.checked !== void 0 && p.defaultChecked !== void 0 && !yi && (n("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", p.type), yi = !0), p.value !== void 0 && p.defaultValue !== void 0 && !Rn && (n("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", p.type), Rn = !0), w.push(ro("input"));
      var C = null, E = null, A = null, k = null;
      for (var $ in p)
        if (B.call(p, $)) {
          var te = p[$];
          if (te == null)
            continue;
          switch ($) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              k = te;
              break;
            case "defaultValue":
              E = te;
              break;
            case "checked":
              A = te;
              break;
            case "value":
              C = te;
              break;
            default:
              Qe(w, h, $, te);
              break;
          }
        }
      return A !== null ? Qe(w, h, "checked", A) : k !== null && Qe(w, h, "checked", k), C !== null ? Qe(w, h, "value", C) : E !== null && Qe(w, h, "value", E), w.push(_n), null;
    }
    function Wo(w, p, h) {
      Ue("textarea", p), p.value !== void 0 && p.defaultValue !== void 0 && !pa && (n("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), pa = !0), w.push(ro("textarea"));
      var C = null, E = null, A = null;
      for (var k in p)
        if (B.call(p, k)) {
          var $ = p[k];
          if ($ == null)
            continue;
          switch (k) {
            case "children":
              A = $;
              break;
            case "value":
              C = $;
              break;
            case "defaultValue":
              E = $;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              Qe(w, h, k, $);
              break;
          }
        }
      if (C === null && E !== null && (C = E), w.push(Wt), A != null) {
        if (n("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), C != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (In(A)) {
          if (A.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          H(A[0]), C = "" + A[0];
        }
        H(A), C = "" + A;
      }
      return typeof C == "string" && C[0] === `
` && w.push(Hi), C !== null && (M(C, "value"), w.push(b(En("" + C)))), null;
    }
    function Xl(w, p, h, C) {
      w.push(ro(h));
      for (var E in p)
        if (B.call(p, E)) {
          var A = p[E];
          if (A == null)
            continue;
          switch (E) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(h + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              Qe(w, C, E, A);
              break;
          }
        }
      return w.push(_n), null;
    }
    function Fs(w, p, h) {
      w.push(ro("menuitem"));
      for (var C in p)
        if (B.call(p, C)) {
          var E = p[C];
          if (E == null)
            continue;
          switch (C) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              Qe(w, h, C, E);
              break;
          }
        }
      return w.push(Wt), null;
    }
    function rr(w, p, h) {
      w.push(ro("title"));
      var C = null;
      for (var E in p)
        if (B.call(p, E)) {
          var A = p[E];
          if (A == null)
            continue;
          switch (E) {
            case "children":
              C = A;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              Qe(w, h, E, A);
              break;
          }
        }
      w.push(Wt);
      {
        var k = Array.isArray(C) && C.length < 2 ? C[0] || null : C;
        Array.isArray(C) && C.length > 1 ? n("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : k != null && k.$$typeof != null ? n("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : k != null && typeof k != "string" && typeof k != "number" && n("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return C;
    }
    function Vi(w, p, h, C) {
      w.push(ro(h));
      var E = null, A = null;
      for (var k in p)
        if (B.call(p, k)) {
          var $ = p[k];
          if ($ == null)
            continue;
          switch (k) {
            case "children":
              E = $;
              break;
            case "dangerouslySetInnerHTML":
              A = $;
              break;
            default:
              Qe(w, C, k, $);
              break;
          }
        }
      return w.push(Wt), xn(w, A, E), typeof E == "string" ? (w.push(b(En(E))), null) : E;
    }
    function Is(w, p, h, C) {
      w.push(ro(h));
      var E = null, A = null;
      for (var k in p)
        if (B.call(p, k)) {
          var $ = p[k];
          if ($ == null)
            continue;
          switch (k) {
            case "children":
              E = $;
              break;
            case "dangerouslySetInnerHTML":
              A = $;
              break;
            case "style":
              ge(w, C, $);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              ue(k) && typeof $ != "function" && typeof $ != "symbol" && w.push(Re, b(k), Ge, b(Vr($)), qe);
              break;
          }
        }
      return w.push(Wt), xn(w, A, E), E;
    }
    var Hi = S(`
`);
    function wi(w, p, h, C) {
      w.push(ro(h));
      var E = null, A = null;
      for (var k in p)
        if (B.call(p, k)) {
          var $ = p[k];
          if ($ == null)
            continue;
          switch (k) {
            case "children":
              E = $;
              break;
            case "dangerouslySetInnerHTML":
              A = $;
              break;
            default:
              Qe(w, C, k, $);
              break;
          }
        }
      if (w.push(Wt), A != null) {
        if (E != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof A != "object" || !("__html" in A))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var te = A.__html;
        te != null && (typeof te == "string" && te.length > 0 && te[0] === `
` ? w.push(Hi, b(te)) : (H(te), w.push(b("" + te))));
      }
      return typeof E == "string" && E[0] === `
` && w.push(Hi), E;
    }
    var Ls = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, bi = /* @__PURE__ */ new Map();
    function ro(w) {
      var p = bi.get(w);
      if (p === void 0) {
        if (!Ls.test(w))
          throw new Error("Invalid tag: " + w);
        p = S("<" + w), bi.set(w, p);
      }
      return p;
    }
    var Zl = S("<!DOCTYPE html>");
    function Ya(w, p, h, C, E) {
      switch (nt(p, h), Ct(p, h), rt(p, h, null), !h.suppressContentEditableWarning && h.contentEditable && h.children != null && n("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), E.insertionMode !== yo && E.insertionMode !== Co && p.indexOf("-") === -1 && typeof h.is != "string" && p.toLowerCase() !== p && n("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", p), p) {
        case "select":
          return wp(w, h, C);
        case "option":
          return Eo(w, h, C, E);
        case "textarea":
          return Wo(w, h, C);
        case "input":
          return Sp(w, h, C);
        case "menuitem":
          return Fs(w, h, C);
        case "title":
          return rr(w, h, C);
        case "listing":
        case "pre":
          return wi(w, h, p, C);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return Xl(w, h, p, C);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Vi(w, h, p, C);
        case "html":
          return E.insertionMode === Ho && w.push(Zl), Vi(w, h, p, C);
        default:
          return p.indexOf("-") === -1 && typeof h.is != "string" ? Vi(w, h, p, C) : Is(w, h, p, C);
      }
    }
    var Rc = S("</"), Ns = S(">");
    function Tc(w, p, h) {
      switch (p) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          w.push(Rc, b(p), Ns);
      }
    }
    function Ep(w, p) {
      for (var h = p.bootstrapChunks, C = 0; C < h.length - 1; C++)
        d(w, h[C]);
      return C < h.length ? f(w, h[C]) : !0;
    }
    var _p = S('<template id="'), ks = S('"></template>');
    function Oc(w, p, h) {
      d(w, _p), d(w, p.placeholderPrefix);
      var C = b(h.toString(16));
      return d(w, C), f(w, ks);
    }
    var Ka = S("<!--$-->"), Ql = S('<!--$?--><template id="'), xp = S('"></template>'), fa = S("<!--$!-->"), Jl = S("<!--/$-->"), eu = S("<template"), ha = S('"'), qa = S(' data-dgst="'), Gs = S(' data-msg="'), Pc = S(' data-stck="'), Dc = S("></template>");
    function Ac(w, p) {
      return f(w, Ka);
    }
    function Vs(w, p, h) {
      if (d(w, Ql), h === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return d(w, h), f(w, xp);
    }
    function kn(w, p, h, C, E) {
      var A;
      return A = f(w, fa), d(w, eu), h && (d(w, qa), d(w, b(Vr(h))), d(w, ha)), C && (d(w, Gs), d(w, b(Vr(C))), d(w, ha)), E && (d(w, Pc), d(w, b(Vr(E))), d(w, ha)), A = f(w, Dc), A;
    }
    function Mc(w, p) {
      return f(w, Jl);
    }
    function Hs(w, p) {
      return f(w, Jl);
    }
    function Rp(w, p) {
      return f(w, Jl);
    }
    var Fc = S('<div hidden id="'), Bs = S('">'), Ic = S("</div>"), Lc = S('<svg aria-hidden="true" style="display:none" id="'), Ws = S('">'), js = S("</svg>"), Nc = S('<math aria-hidden="true" style="display:none" id="'), kc = S('">'), Gc = S("</math>"), tu = S('<table hidden id="'), Vc = S('">'), O = S("</table>"), I = S('<table hidden><tbody id="'), U = S('">'), Z = S("</tbody></table>"), Se = S('<table hidden><tr id="'), ye = S('">'), Pe = S("</tr></table>"), Ve = S('<table hidden><colgroup id="'), at = S('">'), _t = S("</colgroup></table>");
    function bt(w, p, h, C) {
      switch (h.insertionMode) {
        case Ho:
        case Hr:
          return d(w, Fc), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, Bs);
        case yo:
          return d(w, Lc), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, Ws);
        case Co:
          return d(w, Nc), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, kc);
        case gi:
          return d(w, tu), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, Vc);
        case ua:
          return d(w, I), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, U);
        case to:
          return d(w, Se), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, ye);
        case wo:
          return d(w, Ve), d(w, p.segmentPrefix), d(w, b(C.toString(16))), f(w, at);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function hr(w, p) {
      switch (p.insertionMode) {
        case Ho:
        case Hr:
          return f(w, Ic);
        case yo:
          return f(w, js);
        case Co:
          return f(w, Gc);
        case gi:
          return f(w, O);
        case ua:
          return f(w, Z);
        case to:
          return f(w, Pe);
        case wo:
          return f(w, _t);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var Gn = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", no = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', oo = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Us = S(Gn + ';$RS("'), Hc = S('$RS("'), Xa = S('","'), TC = S('")<\/script>');
    function OC(w, p, h) {
      d(w, p.startInlineScript), p.sentCompleteSegmentFunction ? d(w, Hc) : (p.sentCompleteSegmentFunction = !0, d(w, Us)), d(w, p.segmentPrefix);
      var C = b(h.toString(16));
      return d(w, C), d(w, Xa), d(w, p.placeholderPrefix), d(w, C), f(w, TC);
    }
    var Tp = S(no + ';$RC("'), PC = S('$RC("'), DC = S('","'), Cv = S('")<\/script>');
    function wv(w, p, h, C) {
      if (d(w, p.startInlineScript), p.sentCompleteBoundaryFunction ? d(w, PC) : (p.sentCompleteBoundaryFunction = !0, d(w, Tp)), h === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var E = b(C.toString(16));
      return d(w, h), d(w, DC), d(w, p.segmentPrefix), d(w, E), f(w, Cv);
    }
    var AC = S(oo + ';$RX("'), MC = S('$RX("'), FC = S('"'), IC = S(")<\/script>"), Yn = S(",");
    function LC(w, p, h, C, E, A) {
      if (d(w, p.startInlineScript), p.sentClientRenderFunction ? d(w, MC) : (p.sentClientRenderFunction = !0, d(w, AC)), h === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return d(w, h), d(w, FC), (C || E || A) && (d(w, Yn), d(w, b(Bc(C || "")))), (E || A) && (d(w, Yn), d(w, b(Bc(E || "")))), A && (d(w, Yn), d(w, b(Bc(A)))), f(w, IC);
    }
    var bv = /[<\u2028\u2029]/g;
    function Bc(w) {
      var p = JSON.stringify(w);
      return p.replace(bv, function(h) {
        switch (h) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var io = Object.assign, Sv = Symbol.for("react.element"), Wc = Symbol.for("react.portal"), jc = Symbol.for("react.fragment"), Uc = Symbol.for("react.strict_mode"), $c = Symbol.for("react.profiler"), ru = Symbol.for("react.provider"), nu = Symbol.for("react.context"), $s = Symbol.for("react.forward_ref"), Op = Symbol.for("react.suspense"), Pp = Symbol.for("react.suspense_list"), Dp = Symbol.for("react.memo"), zc = Symbol.for("react.lazy"), Ev = Symbol.for("react.scope"), NC = Symbol.for("react.debug_trace_mode"), kC = Symbol.for("react.legacy_hidden"), GC = Symbol.for("react.default_value"), Ap = Symbol.iterator, Ar = "@@iterator";
    function ou(w) {
      if (w === null || typeof w != "object")
        return null;
      var p = Ap && w[Ap] || w[Ar];
      return typeof p == "function" ? p : null;
    }
    function _v(w, p, h) {
      var C = w.displayName;
      if (C)
        return C;
      var E = p.displayName || p.name || "";
      return E !== "" ? h + "(" + E + ")" : h;
    }
    function Mp(w) {
      return w.displayName || "Context";
    }
    function Or(w) {
      if (w == null)
        return null;
      if (typeof w.tag == "number" && n("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof w == "function")
        return w.displayName || w.name || null;
      if (typeof w == "string")
        return w;
      switch (w) {
        case jc:
          return "Fragment";
        case Wc:
          return "Portal";
        case $c:
          return "Profiler";
        case Uc:
          return "StrictMode";
        case Op:
          return "Suspense";
        case Pp:
          return "SuspenseList";
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case nu:
            var p = w;
            return Mp(p) + ".Consumer";
          case ru:
            var h = w;
            return Mp(h._context) + ".Provider";
          case $s:
            return _v(w, w.render, "ForwardRef");
          case Dp:
            var C = w.displayName || null;
            return C !== null ? C : Or(w.type) || "Memo";
          case zc: {
            var E = w, A = E._payload, k = E._init;
            try {
              return Or(k(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var zs = 0, Fp, Ip, Lp, Np, xv, Rv, Yc;
    function Kc() {
    }
    Kc.__reactDisabledLog = !0;
    function iu() {
      {
        if (zs === 0) {
          Fp = console.log, Ip = console.info, Lp = console.warn, Np = console.error, xv = console.group, Rv = console.groupCollapsed, Yc = console.groupEnd;
          var w = {
            configurable: !0,
            enumerable: !0,
            value: Kc,
            writable: !0
          };
          Object.defineProperties(console, {
            info: w,
            log: w,
            warn: w,
            error: w,
            group: w,
            groupCollapsed: w,
            groupEnd: w
          });
        }
        zs++;
      }
    }
    function kp() {
      {
        if (zs--, zs === 0) {
          var w = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: io({}, w, {
              value: Fp
            }),
            info: io({}, w, {
              value: Ip
            }),
            warn: io({}, w, {
              value: Lp
            }),
            error: io({}, w, {
              value: Np
            }),
            group: io({}, w, {
              value: xv
            }),
            groupCollapsed: io({}, w, {
              value: Rv
            }),
            groupEnd: io({}, w, {
              value: Yc
            })
          });
        }
        zs < 0 && n("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ys = e.ReactCurrentDispatcher, Gp;
    function Za(w, p, h) {
      {
        if (Gp === void 0)
          try {
            throw Error();
          } catch (E) {
            var C = E.stack.trim().match(/\n( *(at )?)/);
            Gp = C && C[1] || "";
          }
        return `
` + Gp + w;
      }
    }
    var Vp = !1, au;
    {
      var VC = typeof WeakMap == "function" ? WeakMap : Map;
      au = new VC();
    }
    function su(w, p) {
      if (!w || Vp)
        return "";
      {
        var h = au.get(w);
        if (h !== void 0)
          return h;
      }
      var C;
      Vp = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Ys.current, Ys.current = null, iu();
      try {
        if (p) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (Yt) {
              C = Yt;
            }
            Reflect.construct(w, [], k);
          } else {
            try {
              k.call();
            } catch (Yt) {
              C = Yt;
            }
            w.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Yt) {
            C = Yt;
          }
          w();
        }
      } catch (Yt) {
        if (Yt && C && typeof Yt.stack == "string") {
          for (var $ = Yt.stack.split(`
`), te = C.stack.split(`
`), me = $.length - 1, Ae = te.length - 1; me >= 1 && Ae >= 0 && $[me] !== te[Ae]; )
            Ae--;
          for (; me >= 1 && Ae >= 0; me--, Ae--)
            if ($[me] !== te[Ae]) {
              if (me !== 1 || Ae !== 1)
                do
                  if (me--, Ae--, Ae < 0 || $[me] !== te[Ae]) {
                    var Ie = `
` + $[me].replace(" at new ", " at ");
                    return w.displayName && Ie.includes("<anonymous>") && (Ie = Ie.replace("<anonymous>", w.displayName)), typeof w == "function" && au.set(w, Ie), Ie;
                  }
                while (me >= 1 && Ae >= 0);
              break;
            }
        }
      } finally {
        Vp = !1, Ys.current = A, kp(), Error.prepareStackTrace = E;
      }
      var je = w ? w.displayName || w.name : "", ct = je ? Za(je) : "";
      return typeof w == "function" && au.set(w, ct), ct;
    }
    function Tv(w, p, h) {
      return su(w, !0);
    }
    function Hp(w, p, h) {
      return su(w, !1);
    }
    function qc(w) {
      var p = w.prototype;
      return !!(p && p.isReactComponent);
    }
    function Xc(w, p, h) {
      if (w == null)
        return "";
      if (typeof w == "function")
        return su(w, qc(w));
      if (typeof w == "string")
        return Za(w);
      switch (w) {
        case Op:
          return Za("Suspense");
        case Pp:
          return Za("SuspenseList");
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case $s:
            return Hp(w.render);
          case Dp:
            return Xc(w.type, p, h);
          case zc: {
            var C = w, E = C._payload, A = C._init;
            try {
              return Xc(A(E), p, h);
            } catch {
            }
          }
        }
      return "";
    }
    var Zc = {}, lu = e.ReactDebugCurrentFrame;
    function uu(w) {
      if (w) {
        var p = w._owner, h = Xc(w.type, w._source, p ? p.type : null);
        lu.setExtraStackFrame(h);
      } else
        lu.setExtraStackFrame(null);
    }
    function Ov(w, p, h, C, E) {
      {
        var A = Function.call.bind(B);
        for (var k in w)
          if (A(w, k)) {
            var $ = void 0;
            try {
              if (typeof w[k] != "function") {
                var te = Error((C || "React class") + ": " + h + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof w[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              $ = w[k](p, k, C, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (me) {
              $ = me;
            }
            $ && !($ instanceof Error) && (uu(E), n("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", h, k, typeof $), uu(null)), $ instanceof Error && !($.message in Zc) && (Zc[$.message] = !0, uu(E), n("Failed %s type: %s", h, $.message), uu(null));
          }
      }
    }
    var Qa;
    Qa = {};
    var Qc = {};
    Object.freeze(Qc);
    function va(w, p) {
      {
        var h = w.contextTypes;
        if (!h)
          return Qc;
        var C = {};
        for (var E in h)
          C[E] = p[E];
        {
          var A = Or(w) || "Unknown";
          Ov(h, C, "context", A);
        }
        return C;
      }
    }
    function Bp(w, p, h, C) {
      {
        if (typeof w.getChildContext != "function") {
          {
            var E = Or(p) || "Unknown";
            Qa[E] || (Qa[E] = !0, n("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", E, E));
          }
          return h;
        }
        var A = w.getChildContext();
        for (var k in A)
          if (!(k in C))
            throw new Error((Or(p) || "Unknown") + '.getChildContext(): key "' + k + '" is not defined in childContextTypes.');
        {
          var $ = Or(p) || "Unknown";
          Ov(C, A, "child context", $);
        }
        return io({}, h, A);
      }
    }
    var Ja;
    Ja = {};
    var Jc = null, ga = null;
    function ed(w) {
      w.context._currentValue = w.parentValue;
    }
    function td(w) {
      w.context._currentValue = w.value;
    }
    function cu(w, p) {
      if (w !== p) {
        ed(w);
        var h = w.parent, C = p.parent;
        if (h === null) {
          if (C !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (C === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          cu(h, C);
        }
        td(p);
      }
    }
    function du(w) {
      ed(w);
      var p = w.parent;
      p !== null && du(p);
    }
    function Pv(w) {
      var p = w.parent;
      p !== null && Pv(p), td(w);
    }
    function Dv(w, p) {
      ed(w);
      var h = w.parent;
      if (h === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      h.depth === p.depth ? cu(h, p) : Dv(h, p);
    }
    function Av(w, p) {
      var h = p.parent;
      if (h === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      w.depth === h.depth ? cu(w, h) : Av(w, h), td(p);
    }
    function ma(w) {
      var p = ga, h = w;
      p !== h && (p === null ? Pv(h) : h === null ? du(p) : p.depth === h.depth ? cu(p, h) : p.depth > h.depth ? Dv(p, h) : Av(p, h), ga = h);
    }
    function Wp(w, p) {
      var h;
      h = w._currentValue, w._currentValue = p, w._currentRenderer !== void 0 && w._currentRenderer !== null && w._currentRenderer !== Ja && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), w._currentRenderer = Ja;
      var C = ga, E = {
        parent: C,
        depth: C === null ? 0 : C.depth + 1,
        context: w,
        parentValue: h,
        value: p
      };
      return ga = E, E;
    }
    function HC(w) {
      var p = ga;
      if (p === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      p.context !== w && n("The parent context is not the expected context. This is probably a bug in React.");
      {
        var h = p.parentValue;
        h === GC ? p.context._currentValue = p.context._defaultValue : p.context._currentValue = h, w._currentRenderer !== void 0 && w._currentRenderer !== null && w._currentRenderer !== Ja && n("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), w._currentRenderer = Ja;
      }
      return ga = p.parent;
    }
    function Mv() {
      return ga;
    }
    function Ks(w) {
      var p = w._currentValue;
      return p;
    }
    function pu(w) {
      return w._reactInternals;
    }
    function jp(w, p) {
      w._reactInternals = p;
    }
    var rd = {}, nd = {}, od, qs, fu, hu, id, vu, ad, sd, Up;
    {
      od = /* @__PURE__ */ new Set(), qs = /* @__PURE__ */ new Set(), fu = /* @__PURE__ */ new Set(), ad = /* @__PURE__ */ new Set(), hu = /* @__PURE__ */ new Set(), sd = /* @__PURE__ */ new Set(), Up = /* @__PURE__ */ new Set();
      var Fv = /* @__PURE__ */ new Set();
      vu = function(w, p) {
        if (!(w === null || typeof w == "function")) {
          var h = p + "_" + w;
          Fv.has(h) || (Fv.add(h), n("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", p, w));
        }
      }, id = function(w, p) {
        if (p === void 0) {
          var h = Or(w) || "Component";
          hu.has(h) || (hu.add(h), n("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", h));
        }
      };
    }
    function Iv(w, p) {
      {
        var h = w.constructor, C = h && Or(h) || "ReactClass", E = C + "." + p;
        if (rd[E])
          return;
        n(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, p, p, C), rd[E] = !0;
      }
    }
    var Lv = {
      isMounted: function(w) {
        return !1;
      },
      enqueueSetState: function(w, p, h) {
        var C = pu(w);
        C.queue === null ? Iv(w, "setState") : (C.queue.push(p), h != null && vu(h, "setState"));
      },
      enqueueReplaceState: function(w, p, h) {
        var C = pu(w);
        C.replace = !0, C.queue = [p], h != null && vu(h, "setState");
      },
      enqueueForceUpdate: function(w, p) {
        var h = pu(w);
        h.queue === null ? Iv(w, "forceUpdate") : p != null && vu(p, "setState");
      }
    };
    function BC(w, p, h, C, E) {
      var A = h(E, C);
      id(p, A);
      var k = A == null ? C : io({}, C, A);
      return k;
    }
    function Nv(w, p, h) {
      var C = Qc, E = w.contextType;
      if ("contextType" in w) {
        var A = (
          // Allow null for conditional declaration
          E === null || E !== void 0 && E.$$typeof === nu && E._context === void 0
        );
        if (!A && !Up.has(w)) {
          Up.add(w);
          var k = "";
          E === void 0 ? k = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof E != "object" ? k = " However, it is set to a " + typeof E + "." : E.$$typeof === ru ? k = " Did you accidentally pass the Context.Provider instead?" : E._context !== void 0 ? k = " Did you accidentally pass the Context.Consumer instead?" : k = " However, it is set to an object with keys {" + Object.keys(E).join(", ") + "}.", n("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Or(w) || "Component", k);
        }
      }
      typeof E == "object" && E !== null ? C = Ks(E) : C = h;
      var $ = new w(p, C);
      {
        if (typeof w.getDerivedStateFromProps == "function" && ($.state === null || $.state === void 0)) {
          var te = Or(w) || "Component";
          od.has(te) || (od.add(te), n("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", te, $.state === null ? "null" : "undefined", te));
        }
        if (typeof w.getDerivedStateFromProps == "function" || typeof $.getSnapshotBeforeUpdate == "function") {
          var me = null, Ae = null, Ie = null;
          if (typeof $.componentWillMount == "function" && $.componentWillMount.__suppressDeprecationWarning !== !0 ? me = "componentWillMount" : typeof $.UNSAFE_componentWillMount == "function" && (me = "UNSAFE_componentWillMount"), typeof $.componentWillReceiveProps == "function" && $.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ae = "componentWillReceiveProps" : typeof $.UNSAFE_componentWillReceiveProps == "function" && (Ae = "UNSAFE_componentWillReceiveProps"), typeof $.componentWillUpdate == "function" && $.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ie = "componentWillUpdate" : typeof $.UNSAFE_componentWillUpdate == "function" && (Ie = "UNSAFE_componentWillUpdate"), me !== null || Ae !== null || Ie !== null) {
            var je = Or(w) || "Component", ct = typeof w.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            fu.has(je) || (fu.add(je), n(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, je, ct, me !== null ? `
  ` + me : "", Ae !== null ? `
  ` + Ae : "", Ie !== null ? `
  ` + Ie : ""));
          }
        }
      }
      return $;
    }
    function WC(w, p, h) {
      {
        var C = Or(p) || "Component", E = w.render;
        E || (p.prototype && typeof p.prototype.render == "function" ? n("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : n("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), w.getInitialState && !w.getInitialState.isReactClassApproved && !w.state && n("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), w.getDefaultProps && !w.getDefaultProps.isReactClassApproved && n("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), w.propTypes && n("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), w.contextType && n("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), w.contextTypes && n("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), p.contextType && p.contextTypes && !sd.has(p) && (sd.add(p), n("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof w.componentShouldUpdate == "function" && n("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), p.prototype && p.prototype.isPureReactComponent && typeof w.shouldComponentUpdate < "u" && n("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Or(p) || "A pure component"), typeof w.componentDidUnmount == "function" && n("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof w.componentDidReceiveProps == "function" && n("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof w.componentWillRecieveProps == "function" && n("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof w.UNSAFE_componentWillRecieveProps == "function" && n("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var A = w.props !== h;
        w.props !== void 0 && A && n("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), w.defaultProps && n("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof w.getSnapshotBeforeUpdate == "function" && typeof w.componentDidUpdate != "function" && !qs.has(p) && (qs.add(p), n("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Or(p))), typeof w.getDerivedStateFromProps == "function" && n("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof w.getDerivedStateFromError == "function" && n("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof p.getSnapshotBeforeUpdate == "function" && n("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var k = w.state;
        k && (typeof k != "object" || In(k)) && n("%s.state: must be set to an object or null", C), typeof w.getChildContext == "function" && typeof p.childContextTypes != "object" && n("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function jC(w, p) {
      var h = p.state;
      if (typeof p.componentWillMount == "function") {
        if (p.componentWillMount.__suppressDeprecationWarning !== !0) {
          var C = Or(w) || "Unknown";
          nd[C] || (r(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            C
          ), nd[C] = !0);
        }
        p.componentWillMount();
      }
      typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount(), h !== p.state && (n("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Or(w) || "Component"), Lv.enqueueReplaceState(p, p.state, null));
    }
    function $p(w, p, h, C) {
      if (w.queue !== null && w.queue.length > 0) {
        var E = w.queue, A = w.replace;
        if (w.queue = null, w.replace = !1, A && E.length === 1)
          p.state = E[0];
        else {
          for (var k = A ? E[0] : p.state, $ = !0, te = A ? 1 : 0; te < E.length; te++) {
            var me = E[te], Ae = typeof me == "function" ? me.call(p, k, h, C) : me;
            Ae != null && ($ ? ($ = !1, k = io({}, k, Ae)) : io(k, Ae));
          }
          p.state = k;
        }
      } else
        w.queue = null;
    }
    function gu(w, p, h, C) {
      WC(w, p, h);
      var E = w.state !== void 0 ? w.state : null;
      w.updater = Lv, w.props = h, w.state = E;
      var A = {
        queue: [],
        replace: !1
      };
      jp(w, A);
      var k = p.contextType;
      if (typeof k == "object" && k !== null ? w.context = Ks(k) : w.context = C, w.state === h) {
        var $ = Or(p) || "Component";
        ad.has($) || (ad.add($), n("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", $));
      }
      var te = p.getDerivedStateFromProps;
      typeof te == "function" && (w.state = BC(w, p, te, E, h)), typeof p.getDerivedStateFromProps != "function" && typeof w.getSnapshotBeforeUpdate != "function" && (typeof w.UNSAFE_componentWillMount == "function" || typeof w.componentWillMount == "function") && (jC(p, w), $p(A, w, h, C));
    }
    var UC = {
      id: 1,
      overflow: ""
    };
    function $C(w) {
      var p = w.overflow, h = w.id, C = h & ~zC(h);
      return C.toString(32) + p;
    }
    function zp(w, p, h) {
      var C = w.id, E = w.overflow, A = ld(C) - 1, k = C & ~(1 << A), $ = h + 1, te = ld(p) + A;
      if (te > 30) {
        var me = A - A % 5, Ae = (1 << me) - 1, Ie = (k & Ae).toString(32), je = k >> me, ct = A - me, Yt = ld(p) + ct, mn = $ << ct, as = mn | je, ss = Ie + E;
        return {
          id: 1 << Yt | as,
          overflow: ss
        };
      } else {
        var $i = $ << A, rl = $i | k, S0 = E;
        return {
          id: 1 << te | rl,
          overflow: S0
        };
      }
    }
    function ld(w) {
      return 32 - YC(w);
    }
    function zC(w) {
      return 1 << ld(w) - 1;
    }
    var YC = Math.clz32 ? Math.clz32 : Yp, KC = Math.log, Bi = Math.LN2;
    function Yp(w) {
      var p = w >>> 0;
      return p === 0 ? 32 : 31 - (KC(p) / Bi | 0) | 0;
    }
    function ud(w, p) {
      return w === p && (w !== 0 || 1 / w === 1 / p) || w !== w && p !== p;
    }
    var _r = typeof Object.is == "function" ? Object.is : ud, ao = null, Xs = null, es = null, jt = null, ya = !1, cd = !1, so = 0, lo = null, Si = 0, qC = 25, jo = !1, Ca;
    function ts() {
      if (ao === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return jo && n("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), ao;
    }
    function XC(w, p) {
      if (p === null)
        return n("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ca), !1;
      w.length !== p.length && n(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ca, "[" + w.join(", ") + "]", "[" + p.join(", ") + "]");
      for (var h = 0; h < p.length && h < w.length; h++)
        if (!_r(w[h], p[h]))
          return !1;
      return !0;
    }
    function Kp() {
      if (Si > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function mu() {
      return jt === null ? es === null ? (ya = !1, es = jt = Kp()) : (ya = !0, jt = es) : jt.next === null ? (ya = !1, jt = jt.next = Kp()) : (ya = !0, jt = jt.next), jt;
    }
    function ZC(w, p) {
      ao = p, Xs = w, jo = !1, so = 0;
    }
    function QC(w, p, h, C) {
      for (; cd; )
        cd = !1, so = 0, Si += 1, jt = null, h = w(p, C);
      return qp(), h;
    }
    function dd() {
      var w = so !== 0;
      return w;
    }
    function qp() {
      jo = !1, ao = null, Xs = null, cd = !1, es = null, Si = 0, lo = null, jt = null;
    }
    function kv(w) {
      return jo && n("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Ks(w);
    }
    function Gv(w) {
      return Ca = "useContext", ts(), Ks(w);
    }
    function Xp(w, p) {
      return typeof p == "function" ? p(w) : p;
    }
    function JC(w) {
      return Ca = "useState", Vv(
        Xp,
        // useReducer has a special case to support lazy useState initializers
        w
      );
    }
    function Vv(w, p, h) {
      if (w !== Xp && (Ca = "useReducer"), ao = ts(), jt = mu(), ya) {
        var C = jt.queue, E = C.dispatch;
        if (lo !== null) {
          var A = lo.get(C);
          if (A !== void 0) {
            lo.delete(C);
            var k = jt.memoizedState, $ = A;
            do {
              var te = $.action;
              jo = !0, k = w(k, te), jo = !1, $ = $.next;
            } while ($ !== null);
            return jt.memoizedState = k, [k, E];
          }
        }
        return [jt.memoizedState, E];
      } else {
        jo = !0;
        var me;
        w === Xp ? me = typeof p == "function" ? p() : p : me = h !== void 0 ? h(p) : p, jo = !1, jt.memoizedState = me;
        var Ae = jt.queue = {
          last: null,
          dispatch: null
        }, Ie = Ae.dispatch = r0.bind(null, ao, Ae);
        return [jt.memoizedState, Ie];
      }
    }
    function Hv(w, p) {
      ao = ts(), jt = mu();
      var h = p === void 0 ? null : p;
      if (jt !== null) {
        var C = jt.memoizedState;
        if (C !== null && h !== null) {
          var E = C[1];
          if (XC(h, E))
            return C[0];
        }
      }
      jo = !0;
      var A = w();
      return jo = !1, jt.memoizedState = [A, h], A;
    }
    function e0(w) {
      ao = ts(), jt = mu();
      var p = jt.memoizedState;
      if (p === null) {
        var h = {
          current: w
        };
        return Object.seal(h), jt.memoizedState = h, h;
      } else
        return p;
    }
    function t0(w, p) {
      Ca = "useLayoutEffect", n("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function r0(w, p, h) {
      if (Si >= qC)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (w === ao) {
        cd = !0;
        var C = {
          action: h,
          next: null
        };
        lo === null && (lo = /* @__PURE__ */ new Map());
        var E = lo.get(p);
        if (E === void 0)
          lo.set(p, C);
        else {
          for (var A = E; A.next !== null; )
            A = A.next;
          A.next = C;
        }
      }
    }
    function n0(w, p) {
      return Hv(function() {
        return w;
      }, p);
    }
    function o0(w, p, h) {
      return ts(), p(w._source);
    }
    function i0(w, p, h) {
      if (h === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return h();
    }
    function pd(w) {
      return ts(), w;
    }
    function Bv() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Zp() {
      return ts(), [!1, Bv];
    }
    function Wv() {
      var w = Xs, p = $C(w.treeContext), h = yu;
      if (h === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var C = so++;
      return bo(h, p, C);
    }
    function fd() {
    }
    var hd = {
      readContext: kv,
      useContext: Gv,
      useMemo: Hv,
      useReducer: Vv,
      useRef: e0,
      useState: JC,
      useInsertionEffect: fd,
      useLayoutEffect: t0,
      useCallback: n0,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: fd,
      // Effects are not run in the server environment.
      useEffect: fd,
      // Debugging effect
      useDebugValue: fd,
      useDeferredValue: pd,
      useTransition: Zp,
      useId: Wv,
      // Subscriptions are not setup in a server environment.
      useMutableSource: o0,
      useSyncExternalStore: i0
    }, yu = null;
    function vd(w) {
      yu = w;
    }
    function Zs(w) {
      try {
        var p = "", h = w;
        do {
          switch (h.tag) {
            case 0:
              p += Za(h.type, null, null);
              break;
            case 1:
              p += Hp(h.type, null, null);
              break;
            case 2:
              p += Tv(h.type, null, null);
              break;
          }
          h = h.parent;
        } while (h);
        return p;
      } catch (C) {
        return `
Error generating stack: ` + C.message + `
` + C.stack;
      }
    }
    var gd = e.ReactCurrentDispatcher, md = e.ReactDebugCurrentFrame, yd = 0, Qs = 1, Qp = 2, rs = 3, jv = 4, a0 = 0, Js = 1, el = 2, s0 = 12800;
    function l0(w) {
      return console.error(w), null;
    }
    function ns() {
    }
    function Cd(w, p, h, C, E, A, k, $, te) {
      var me = [], Ae = /* @__PURE__ */ new Set(), Ie = {
        destination: null,
        responseState: p,
        progressiveChunkSize: C === void 0 ? s0 : C,
        status: a0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Ae,
        pingedTasks: me,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: E === void 0 ? l0 : E,
        onAllReady: A === void 0 ? ns : A,
        onShellReady: k === void 0 ? ns : k,
        onShellError: $ === void 0 ? ns : $,
        onFatalError: te === void 0 ? ns : te
      }, je = Cu(
        Ie,
        0,
        null,
        h,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      je.parentFlushed = !0;
      var ct = os(Ie, w, null, je, Ae, Qc, Jc, UC);
      return me.push(ct), Ie;
    }
    function Wi(w, p) {
      var h = w.pingedTasks;
      h.push(p), h.length === 1 && a(function() {
        return uf(w);
      });
    }
    function Jp(w, p) {
      return {
        id: ca,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: p,
        errorDigest: null
      };
    }
    function os(w, p, h, C, E, A, k, $) {
      w.allPendingTasks++, h === null ? w.pendingRootTasks++ : h.pendingTasks++;
      var te = {
        node: p,
        ping: function() {
          return Wi(w, te);
        },
        blockedBoundary: h,
        blockedSegment: C,
        abortSet: E,
        legacyContext: A,
        context: k,
        treeContext: $
      };
      return te.componentStack = null, E.add(te), te;
    }
    function Cu(w, p, h, C, E, A) {
      return {
        status: yd,
        id: -1,
        // lazily assigned later
        index: p,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: C,
        boundary: h,
        lastPushedText: E,
        textEmbedded: A
      };
    }
    var ji = null;
    function Ei() {
      return ji === null || ji.componentStack === null ? "" : Zs(ji.componentStack);
    }
    function Ui(w, p) {
      w.componentStack = {
        tag: 0,
        parent: w.componentStack,
        type: p
      };
    }
    function wd(w, p) {
      w.componentStack = {
        tag: 1,
        parent: w.componentStack,
        type: p
      };
    }
    function wu(w, p) {
      w.componentStack = {
        tag: 2,
        parent: w.componentStack,
        type: p
      };
    }
    function Uo(w) {
      w.componentStack === null ? n("Unexpectedly popped too many stack frames. This is a bug in React.") : w.componentStack = w.componentStack.parent;
    }
    var bu = null;
    function ef(w, p) {
      {
        var h;
        typeof p == "string" ? h = p : p && typeof p.message == "string" ? h = p.message : h = String(p);
        var C = bu || Ei();
        bu = null, w.errorMessage = h, w.errorComponentStack = C;
      }
    }
    function Su(w, p) {
      var h = w.onError(p);
      if (h != null && typeof h != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof h + '" instead');
      return h;
    }
    function Eu(w, p) {
      var h = w.onShellError;
      h(p);
      var C = w.onFatalError;
      C(p), w.destination !== null ? (w.status = el, R(w.destination, p)) : (w.status = Js, w.fatalError = p);
    }
    function Uv(w, p, h) {
      Ui(p, "Suspense");
      var C = p.blockedBoundary, E = p.blockedSegment, A = h.fallback, k = h.children, $ = /* @__PURE__ */ new Set(), te = Jp(w, $), me = E.chunks.length, Ae = Cu(
        w,
        me,
        te,
        E.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      E.children.push(Ae), E.lastPushedText = !1;
      var Ie = Cu(
        w,
        0,
        null,
        E.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Ie.parentFlushed = !0, p.blockedBoundary = te, p.blockedSegment = Ie;
      try {
        if (tl(w, p, k), Nn(Ie.chunks, w.responseState, Ie.lastPushedText, Ie.textEmbedded), Ie.status = Qs, is(te, Ie), te.pendingTasks === 0) {
          Uo(p);
          return;
        }
      } catch (ct) {
        Ie.status = jv, te.forceClientRender = !0, te.errorDigest = Su(w, ct), ef(te, ct);
      } finally {
        p.blockedBoundary = C, p.blockedSegment = E;
      }
      var je = os(w, A, C, Ae, $, p.legacyContext, p.context, p.treeContext);
      je.componentStack = p.componentStack, w.pingedTasks.push(je), Uo(p);
    }
    function u0(w, p, h, C) {
      Ui(p, h);
      var E = p.blockedSegment, A = Ya(E.chunks, h, C, w.responseState, E.formatContext);
      E.lastPushedText = !1;
      var k = E.formatContext;
      E.formatContext = Ni(k, h, C), tl(w, p, A), E.formatContext = k, Tc(E.chunks, h), E.lastPushedText = !1, Uo(p);
    }
    function $v(w) {
      return w.prototype && w.prototype.isReactComponent;
    }
    function _u(w, p, h, C, E) {
      var A = {};
      ZC(p, A);
      var k = h(C, E);
      return QC(h, C, k, E);
    }
    function tf(w, p, h, C, E) {
      var A = h.render();
      h.props !== E && (Yv || n("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Or(C) || "a component"), Yv = !0);
      {
        var k = C.childContextTypes;
        if (k != null) {
          var $ = p.legacyContext, te = Bp(h, C, $, k);
          p.legacyContext = te, Vn(w, p, A), p.legacyContext = $;
          return;
        }
      }
      Vn(w, p, A);
    }
    function zv(w, p, h, C) {
      wu(p, h);
      var E = va(h, p.legacyContext), A = Nv(h, C, E);
      gu(A, h, C, E), tf(w, p, A, h, C), Uo(p);
    }
    var rf = {}, xu = {}, nf = {}, of = {}, Yv = !1, Kv = !1, af = !1, qv = !1;
    function c0(w, p, h, C) {
      var E;
      if (E = va(h, p.legacyContext), wd(p, h), h.prototype && typeof h.prototype.render == "function") {
        var A = Or(h) || "Unknown";
        rf[A] || (n("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", A, A), rf[A] = !0);
      }
      var k = _u(w, p, h, C, E), $ = dd();
      if (typeof k == "object" && k !== null && typeof k.render == "function" && k.$$typeof === void 0) {
        var te = Or(h) || "Unknown";
        xu[te] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", te, te, te), xu[te] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof k == "object" && k !== null && typeof k.render == "function" && k.$$typeof === void 0
      ) {
        {
          var me = Or(h) || "Unknown";
          xu[me] || (n("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", me, me, me), xu[me] = !0);
        }
        gu(k, h, C, E), tf(w, p, k, h, C);
      } else if (d0(h), $) {
        var Ae = p.treeContext, Ie = 1, je = 0;
        p.treeContext = zp(Ae, Ie, je);
        try {
          Vn(w, p, k);
        } finally {
          p.treeContext = Ae;
        }
      } else
        Vn(w, p, k);
      Uo(p);
    }
    function d0(w) {
      {
        if (w && w.childContextTypes && n("%s(...): childContextTypes cannot be defined on a function component.", w.displayName || w.name || "Component"), typeof w.getDerivedStateFromProps == "function") {
          var p = Or(w) || "Unknown";
          of[p] || (n("%s: Function components do not support getDerivedStateFromProps.", p), of[p] = !0);
        }
        if (typeof w.contextType == "object" && w.contextType !== null) {
          var h = Or(w) || "Unknown";
          nf[h] || (n("%s: Function components do not support contextType.", h), nf[h] = !0);
        }
      }
    }
    function Xv(w, p) {
      if (w && w.defaultProps) {
        var h = io({}, p), C = w.defaultProps;
        for (var E in C)
          h[E] === void 0 && (h[E] = C[E]);
        return h;
      }
      return p;
    }
    function p0(w, p, h, C, E) {
      wd(p, h.render);
      var A = _u(w, p, h.render, C, E), k = dd();
      if (k) {
        var $ = p.treeContext, te = 1, me = 0;
        p.treeContext = zp($, te, me);
        try {
          Vn(w, p, A);
        } finally {
          p.treeContext = $;
        }
      } else
        Vn(w, p, A);
      Uo(p);
    }
    function sf(w, p, h, C, E) {
      var A = h.type, k = Xv(A, C);
      bd(w, p, A, k, E);
    }
    function f0(w, p, h, C) {
      h._context === void 0 ? h !== h.Consumer && (qv || (qv = !0, n("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : h = h._context;
      var E = C.children;
      typeof E != "function" && n("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var A = Ks(h), k = E(A);
      Vn(w, p, k);
    }
    function uo(w, p, h, C) {
      var E = h._context, A = C.value, k = C.children, $;
      $ = p.context, p.context = Wp(E, A), Vn(w, p, k), p.context = HC(E), $ !== p.context && n("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function h0(w, p, h, C, E) {
      Ui(p, "Lazy");
      var A = h._payload, k = h._init, $ = k(A), te = Xv($, C);
      bd(w, p, $, te, E), Uo(p);
    }
    function bd(w, p, h, C, E) {
      if (typeof h == "function")
        if ($v(h)) {
          zv(w, p, h, C);
          return;
        } else {
          c0(w, p, h, C);
          return;
        }
      if (typeof h == "string") {
        u0(w, p, h, C);
        return;
      }
      switch (h) {
        case kC:
        case NC:
        case Uc:
        case $c:
        case jc: {
          Vn(w, p, C.children);
          return;
        }
        case Pp: {
          Ui(p, "SuspenseList"), Vn(w, p, C.children), Uo(p);
          return;
        }
        case Ev:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case Op: {
          Uv(w, p, C);
          return;
        }
      }
      if (typeof h == "object" && h !== null)
        switch (h.$$typeof) {
          case $s: {
            p0(w, p, h, C, E);
            return;
          }
          case Dp: {
            sf(w, p, h, C, E);
            return;
          }
          case ru: {
            uo(w, p, h, C);
            return;
          }
          case nu: {
            f0(w, p, h, C);
            return;
          }
          case zc: {
            h0(w, p, h, C);
            return;
          }
        }
      var A = "";
      throw (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (A += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (h == null ? h : typeof h) + "." + A));
    }
    function v0(w, p) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      w[Symbol.toStringTag] === "Generator" && (Kv || n("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Kv = !0), w.entries === p && (af || n("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), af = !0);
    }
    function Vn(w, p, h) {
      try {
        return g0(w, p, h);
      } catch (C) {
        throw typeof C == "object" && C !== null && typeof C.then == "function" || (bu = bu !== null ? bu : Ei()), C;
      }
    }
    function g0(w, p, h) {
      if (p.node = h, typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case Sv: {
            var C = h, E = C.type, A = C.props, k = C.ref;
            bd(w, p, E, A, k);
            return;
          }
          case Wc:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case zc: {
            var $ = h, te = $._payload, me = $._init, Ae;
            try {
              Ae = me(te);
            } catch ($i) {
              throw typeof $i == "object" && $i !== null && typeof $i.then == "function" && Ui(p, "Lazy"), $i;
            }
            Vn(w, p, Ae);
            return;
          }
        }
        if (In(h)) {
          Zv(w, p, h);
          return;
        }
        var Ie = ou(h);
        if (Ie) {
          v0(h, Ie);
          var je = Ie.call(h);
          if (je) {
            var ct = je.next();
            if (!ct.done) {
              var Yt = [];
              do
                Yt.push(ct.value), ct = je.next();
              while (!ct.done);
              Zv(w, p, Yt);
              return;
            }
            return;
          }
        }
        var mn = Object.prototype.toString.call(h);
        throw new Error("Objects are not valid as a React child (found: " + (mn === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : mn) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof h == "string") {
        var as = p.blockedSegment;
        as.lastPushedText = Jr(p.blockedSegment.chunks, h, w.responseState, as.lastPushedText);
        return;
      }
      if (typeof h == "number") {
        var ss = p.blockedSegment;
        ss.lastPushedText = Jr(p.blockedSegment.chunks, "" + h, w.responseState, ss.lastPushedText);
        return;
      }
      typeof h == "function" && n("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Zv(w, p, h) {
      for (var C = h.length, E = 0; E < C; E++) {
        var A = p.treeContext;
        p.treeContext = zp(A, C, E);
        try {
          tl(w, p, h[E]);
        } finally {
          p.treeContext = A;
        }
      }
    }
    function Qv(w, p, h) {
      var C = p.blockedSegment, E = C.chunks.length, A = Cu(
        w,
        E,
        null,
        C.formatContext,
        // Adopt the parent segment's leading text embed
        C.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      C.children.push(A), C.lastPushedText = !1;
      var k = os(w, p.node, p.blockedBoundary, A, p.abortSet, p.legacyContext, p.context, p.treeContext);
      p.componentStack !== null && (k.componentStack = p.componentStack.parent);
      var $ = k.ping;
      h.then($, $);
    }
    function tl(w, p, h) {
      var C = p.blockedSegment.formatContext, E = p.legacyContext, A = p.context, k = null;
      k = p.componentStack;
      try {
        return Vn(w, p, h);
      } catch ($) {
        if (qp(), typeof $ == "object" && $ !== null && typeof $.then == "function") {
          Qv(w, p, $), p.blockedSegment.formatContext = C, p.legacyContext = E, p.context = A, ma(A), p.componentStack = k;
          return;
        } else
          throw p.blockedSegment.formatContext = C, p.legacyContext = E, p.context = A, ma(A), p.componentStack = k, $;
      }
    }
    function Jv(w, p, h, C) {
      var E = Su(w, C);
      if (p === null ? Eu(w, C) : (p.pendingTasks--, p.forceClientRender || (p.forceClientRender = !0, p.errorDigest = E, ef(p, C), p.parentFlushed && w.clientRenderedBoundaries.push(p))), w.allPendingTasks--, w.allPendingTasks === 0) {
        var A = w.onAllReady;
        A();
      }
    }
    function m0(w) {
      var p = this, h = w.blockedBoundary, C = w.blockedSegment;
      C.status = rs, Ru(p, h, C);
    }
    function lf(w, p, h) {
      var C = w.blockedBoundary, E = w.blockedSegment;
      if (E.status = rs, C === null)
        p.allPendingTasks--, p.status !== el && (p.status = el, p.destination !== null && g(p.destination));
      else {
        if (C.pendingTasks--, !C.forceClientRender) {
          C.forceClientRender = !0;
          var A = h === void 0 ? new Error("The render was aborted by the server without a reason.") : h;
          C.errorDigest = p.onError(A);
          {
            var k = "The server did not finish this Suspense boundary: ";
            A && typeof A.message == "string" ? A = k + A.message : A = k + String(A);
            var $ = ji;
            ji = w;
            try {
              ef(C, A);
            } finally {
              ji = $;
            }
          }
          C.parentFlushed && p.clientRenderedBoundaries.push(C);
        }
        if (C.fallbackAbortableTasks.forEach(function(me) {
          return lf(me, p, h);
        }), C.fallbackAbortableTasks.clear(), p.allPendingTasks--, p.allPendingTasks === 0) {
          var te = p.onAllReady;
          te();
        }
      }
    }
    function is(w, p) {
      if (p.chunks.length === 0 && p.children.length === 1 && p.children[0].boundary === null) {
        var h = p.children[0];
        h.id = p.id, h.parentFlushed = !0, h.status === Qs && is(w, h);
      } else {
        var C = w.completedSegments;
        C.push(p);
      }
    }
    function Ru(w, p, h) {
      if (p === null) {
        if (h.parentFlushed) {
          if (w.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          w.completedRootSegment = h;
        }
        if (w.pendingRootTasks--, w.pendingRootTasks === 0) {
          w.onShellError = ns;
          var C = w.onShellReady;
          C();
        }
      } else if (p.pendingTasks--, !p.forceClientRender) {
        if (p.pendingTasks === 0)
          h.parentFlushed && h.status === Qs && is(p, h), p.parentFlushed && w.completedBoundaries.push(p), p.fallbackAbortableTasks.forEach(m0, w), p.fallbackAbortableTasks.clear();
        else if (h.parentFlushed && h.status === Qs) {
          is(p, h);
          var E = p.completedSegments;
          E.length === 1 && p.parentFlushed && w.partialBoundaries.push(p);
        }
      }
      if (w.allPendingTasks--, w.allPendingTasks === 0) {
        var A = w.onAllReady;
        A();
      }
    }
    function y0(w, p) {
      var h = p.blockedSegment;
      if (h.status === yd) {
        ma(p.context);
        var C = null;
        C = ji, ji = p;
        try {
          Vn(w, p, p.node), Nn(h.chunks, w.responseState, h.lastPushedText, h.textEmbedded), p.abortSet.delete(p), h.status = Qs, Ru(w, p.blockedBoundary, h);
        } catch (A) {
          if (qp(), typeof A == "object" && A !== null && typeof A.then == "function") {
            var E = p.ping;
            A.then(E, E);
          } else
            p.abortSet.delete(p), h.status = jv, Jv(w, p.blockedBoundary, h, A);
        } finally {
          ji = C;
        }
      }
    }
    function uf(w) {
      if (w.status !== el) {
        var p = Mv(), h = gd.current;
        gd.current = hd;
        var C;
        C = md.getCurrentStack, md.getCurrentStack = Ei;
        var E = yu;
        vd(w.responseState);
        try {
          var A = w.pingedTasks, k;
          for (k = 0; k < A.length; k++) {
            var $ = A[k];
            y0(w, $);
          }
          A.splice(0, k), w.destination !== null && cf(w, w.destination);
        } catch (te) {
          Su(w, te), Eu(w, te);
        } finally {
          vd(E), gd.current = h, md.getCurrentStack = C, h === hd && ma(p);
        }
      }
    }
    function Tu(w, p, h) {
      switch (h.parentFlushed = !0, h.status) {
        case yd: {
          var C = h.id = w.nextSegmentId++;
          return h.lastPushedText = !1, h.textEmbedded = !1, Oc(p, w.responseState, C);
        }
        case Qs: {
          h.status = Qp;
          for (var E = !0, A = h.chunks, k = 0, $ = h.children, te = 0; te < $.length; te++) {
            for (var me = $[te]; k < me.index; k++)
              d(p, A[k]);
            E = Sd(w, p, me);
          }
          for (; k < A.length - 1; k++)
            d(p, A[k]);
          return k < A.length && (E = f(p, A[k])), E;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Sd(w, p, h) {
      var C = h.boundary;
      if (C === null)
        return Tu(w, p, h);
      if (C.parentFlushed = !0, C.forceClientRender)
        return kn(p, w.responseState, C.errorDigest, C.errorMessage, C.errorComponentStack), Tu(w, p, h), Rp(p, w.responseState);
      if (C.pendingTasks > 0) {
        C.rootSegmentID = w.nextSegmentId++, C.completedSegments.length > 0 && w.partialBoundaries.push(C);
        var E = C.id = zn(w.responseState);
        return Vs(p, w.responseState, E), Tu(w, p, h), Hs(p, w.responseState);
      } else {
        if (C.byteSize > w.progressiveChunkSize)
          return C.rootSegmentID = w.nextSegmentId++, w.completedBoundaries.push(C), Vs(p, w.responseState, C.id), Tu(w, p, h), Hs(p, w.responseState);
        Ac(p, w.responseState);
        var A = C.completedSegments;
        if (A.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var k = A[0];
        return Sd(w, p, k), Mc(p, w.responseState);
      }
    }
    function eg(w, p, h) {
      return LC(p, w.responseState, h.id, h.errorDigest, h.errorMessage, h.errorComponentStack);
    }
    function Ed(w, p, h) {
      return bt(p, w.responseState, h.formatContext, h.id), Sd(w, p, h), hr(p, h.formatContext);
    }
    function tg(w, p, h) {
      for (var C = h.completedSegments, E = 0; E < C.length; E++) {
        var A = C[E];
        rg(w, p, h, A);
      }
      return C.length = 0, wv(p, w.responseState, h.id, h.rootSegmentID);
    }
    function C0(w, p, h) {
      for (var C = h.completedSegments, E = 0; E < C.length; E++) {
        var A = C[E];
        if (!rg(w, p, h, A))
          return E++, C.splice(0, E), !1;
      }
      return C.splice(0, E), !0;
    }
    function rg(w, p, h, C) {
      if (C.status === Qp)
        return !0;
      var E = C.id;
      if (E === -1) {
        var A = C.id = h.rootSegmentID;
        if (A === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Ed(w, p, C);
      } else
        return Ed(w, p, C), OC(p, w.responseState, E);
    }
    function cf(w, p) {
      c();
      try {
        var h = w.completedRootSegment;
        h !== null && w.pendingRootTasks === 0 && (Sd(w, p, h), w.completedRootSegment = null, Ep(p, w.responseState));
        var C = w.clientRenderedBoundaries, E;
        for (E = 0; E < C.length; E++) {
          var A = C[E];
          eg(w, p, A);
        }
        C.splice(0, E);
        var k = w.completedBoundaries;
        for (E = 0; E < k.length; E++) {
          var $ = k[E];
          tg(w, p, $);
        }
        k.splice(0, E), v(p), c(p);
        var te = w.partialBoundaries;
        for (E = 0; E < te.length; E++) {
          var me = te[E];
          if (!C0(w, p, me)) {
            w.destination = null, E++, te.splice(0, E);
            return;
          }
        }
        te.splice(0, E);
        var Ae = w.completedBoundaries;
        for (E = 0; E < Ae.length; E++) {
          var Ie = Ae[E];
          tg(w, p, Ie);
        }
        Ae.splice(0, E);
      } finally {
        v(p), w.allPendingTasks === 0 && w.pingedTasks.length === 0 && w.clientRenderedBoundaries.length === 0 && w.completedBoundaries.length === 0 && (w.abortableTasks.size !== 0 && n("There was still abortable task at the root when we closed. This is a bug in React."), g(p));
      }
    }
    function ng(w) {
      a(function() {
        return uf(w);
      });
    }
    function w0(w, p) {
      if (w.status === Js) {
        w.status = el, R(p, w.fatalError);
        return;
      }
      if (w.status !== el && w.destination === null) {
        w.destination = p;
        try {
          cf(w, p);
        } catch (h) {
          Su(w, h), Eu(w, h);
        }
      }
    }
    function og(w, p) {
      try {
        var h = w.abortableTasks;
        h.forEach(function(C) {
          return lf(C, w, p);
        }), h.clear(), w.destination !== null && cf(w, w.destination);
      } catch (C) {
        Su(w, C), Eu(w, C);
      }
    }
    function b0(w, p) {
      return new Promise(function(h, C) {
        var E, A, k = new Promise(function(je, ct) {
          A = je, E = ct;
        });
        function $() {
          var je = new ReadableStream(
            {
              type: "bytes",
              pull: function(ct) {
                w0(me, ct);
              },
              cancel: function(ct) {
                og(me);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          je.allReady = k, h(je);
        }
        function te(je) {
          k.catch(function() {
          }), C(je);
        }
        var me = Cd(w, As(p ? p.identifierPrefix : void 0, p ? p.nonce : void 0, p ? p.bootstrapScriptContent : void 0, p ? p.bootstrapScripts : void 0, p ? p.bootstrapModules : void 0), mi(p ? p.namespaceURI : void 0), p ? p.progressiveChunkSize : void 0, p ? p.onError : void 0, A, $, te, E);
        if (p && p.signal) {
          var Ae = p.signal, Ie = function() {
            og(me, Ae.reason), Ae.removeEventListener("abort", Ie);
          };
          Ae.addEventListener("abort", Ie);
        }
        ng(me);
      });
    }
    om.renderToReadableStream = b0, om.version = t;
  }()), om;
}
var Cc, XS;
process.env.NODE_ENV === "production" ? (Cc = aee(), XS = see()) : (Cc = lee(), XS = uee());
xc.version = Cc.version;
xc.renderToString = Cc.renderToString;
xc.renderToStaticMarkup = Cc.renderToStaticMarkup;
xc.renderToNodeStream = Cc.renderToNodeStream;
xc.renderToStaticNodeStream = Cc.renderToStaticNodeStream;
xc.renderToReadableStream = XS.renderToReadableStream;
var hy = ce && ce.__assign || function() {
  return hy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, hy.apply(this, arguments);
}, cee = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(mv, "__esModule", { value: !0 });
mv.ReactComponent = void 0;
var kP = y, _b = Mn, GP = cee(E_), dee = qu, pee = xc, fee = (
  /** @class */
  function() {
    function o(t, e, r, n) {
      var i = this;
      this.portal = null, this.oldPortal = null, this.reactComponent = t, this.portalManager = e, this.componentType = r, this.suppressFallbackMethods = !!n, this.statelessComponent = this.isStateless(this.reactComponent), this.key = GP.default(), this.portalKey = GP.default(), this.instanceCreated = this.isStatelessComponent() ? _b.AgPromise.resolve(!1) : new _b.AgPromise(function(a) {
        i.resolveInstanceCreated = a;
      });
    }
    return o.prototype.getGui = function() {
      return this.eParentElement;
    }, o.prototype.destroy = function() {
      return this.componentInstance && typeof this.componentInstance.destroy == "function" && this.componentInstance.destroy(), this.portalManager.destroyPortal(this.portal);
    }, o.prototype.createParentElement = function(t) {
      var e = this.portalManager.getComponentWrappingElement(), r = document.createElement(e || "div");
      return r.classList.add("ag-react-container"), t.reactContainer = r, r;
    }, o.prototype.addParentContainerStyleAndClasses = function() {
      var t = this;
      if (this.componentInstance && (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle() && Object.assign(this.eParentElement.style, this.componentInstance.getReactContainerStyle()), this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses())) {
        var e = this.componentInstance.getReactContainerClasses();
        e.forEach(function(r) {
          return t.eParentElement.classList.add(r);
        });
      }
    }, o.prototype.statelessComponentRendered = function() {
      return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }, o.prototype.getFrameworkComponentInstance = function() {
      return this.componentInstance;
    }, o.prototype.isStatelessComponent = function() {
      return this.statelessComponent;
    }, o.prototype.getReactComponentName = function() {
      return this.reactComponent.name;
    }, o.prototype.getMemoType = function() {
      return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }, o.prototype.hasSymbol = function() {
      return typeof Symbol == "function" && Symbol.for;
    }, o.prototype.isStateless = function(t) {
      return typeof t == "function" && !(t.prototype && t.prototype.isReactComponent) || typeof t == "object" && t.$$typeof === this.getMemoType();
    }, o.prototype.hasMethod = function(t) {
      var e = this.getFrameworkComponentInstance();
      return !!e && e[t] !== null || this.fallbackMethodAvailable(t);
    }, o.prototype.callMethod = function(t, e) {
      var r = this, n = this.getFrameworkComponentInstance();
      if (this.isStatelessComponent())
        return this.fallbackMethod(t, e && e[0] ? e[0] : {});
      if (!n) {
        setTimeout(function() {
          return r.callMethod(t, e);
        });
        return;
      }
      var i = n[t];
      if (i)
        return i.apply(n, e);
      if (this.fallbackMethodAvailable(t))
        return this.fallbackMethod(t, e && e[0] ? e[0] : {});
    }, o.prototype.addMethod = function(t, e) {
      this[t] = e;
    }, o.prototype.init = function(t) {
      var e = this;
      return this.eParentElement = this.createParentElement(t), this.params = t, this.createOrUpdatePortal(t), new _b.AgPromise(function(r) {
        return e.createReactComponent(r);
      });
    }, o.prototype.createOrUpdatePortal = function(t) {
      var e = this;
      this.isStatelessComponent() || (t.ref = function(r) {
        var n;
        e.componentInstance = r, e.addParentContainerStyleAndClasses(), (n = e.resolveInstanceCreated) === null || n === void 0 || n.call(e, !0), e.resolveInstanceCreated = void 0;
      }), this.reactElement = this.createElement(this.reactComponent, hy(hy({}, t), { key: this.key })), this.portal = dee.createPortal(
        this.reactElement,
        this.eParentElement,
        this.portalKey
        // fixed deltaRowModeRefreshCompRenderer
      );
    }, o.prototype.createElement = function(t, e) {
      return kP.createElement(t, e);
    }, o.prototype.createReactComponent = function(t) {
      this.portalManager.mountReactPortal(this.portal, this, function(e) {
        t(e);
      });
    }, o.prototype.isNullValue = function() {
      return this.valueRenderedIsNull(this.params);
    }, o.prototype.rendered = function() {
      return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }, o.prototype.valueRenderedIsNull = function(t) {
      if (!this.componentType.cellRenderer)
        return !1;
      var e = console.error;
      try {
        console.error = function() {
        };
        var r = pee.renderToStaticMarkup(kP.createElement(this.reactComponent, t));
        return r === "";
      } catch {
      } finally {
        console.error = e;
      }
      return !1;
    }, o.prototype.refreshComponent = function(t) {
      this.oldPortal = this.portal, this.createOrUpdatePortal(t), this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }, o.prototype.fallbackMethod = function(t, e) {
      var r = this[t + "Component"];
      if (!this.suppressFallbackMethods && r)
        return r.bind(this)(e);
    }, o.prototype.fallbackMethodAvailable = function(t) {
      if (this.suppressFallbackMethods)
        return !1;
      var e = this[t + "Component"];
      return !!e;
    }, o;
  }()
);
mv.ReactComponent = fee;
var hee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), vy = ce && ce.__assign || function() {
  return vy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, vy.apply(this, arguments);
}, vee = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(Vo, "__esModule", { value: !0 });
Vo.CustomComponentWrapper = Vo.addOptionalMethods = void 0;
var gee = vee(S_), mee = mv;
function sN(o, t, e) {
  o.forEach(function(r) {
    var n = t[r];
    n && (e[r] = n);
  });
}
Vo.addOptionalMethods = sN;
var yee = (
  /** @class */
  function(o) {
    hee(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.wrapperComponent = gee.default, e;
    }
    return t.prototype.init = function(e) {
      return this.sourceParams = e, o.prototype.init.call(this, this.getProps());
    }, t.prototype.addMethod = function() {
    }, t.prototype.getInstance = function() {
      var e = this;
      return this.instanceCreated.then(function() {
        return e.componentInstance;
      });
    }, t.prototype.getFrameworkComponentInstance = function() {
      return this;
    }, t.prototype.createElement = function(e, r) {
      var n = this;
      return o.prototype.createElement.call(this, this.wrapperComponent, {
        initialProps: r,
        CustomComponentClass: e,
        setMethods: function(i) {
          return n.setMethods(i);
        },
        addUpdateCallback: function(i) {
          n.refreshProps = function() {
            return i(n.getProps());
          };
        }
      });
    }, t.prototype.setMethods = function(e) {
      this.providedMethods = e, sN(this.getOptionalMethods(), this.providedMethods, this);
    }, t.prototype.getOptionalMethods = function() {
      return [];
    }, t.prototype.getProps = function() {
      return vy(vy({}, this.sourceParams), { key: this.key });
    }, t;
  }(mee.ReactComponent)
);
Vo.CustomComponentWrapper = yee;
var Cee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), gy = ce && ce.__assign || function() {
  return gy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, gy.apply(this, arguments);
};
Object.defineProperty(fC, "__esModule", { value: !0 });
fC.DateComponentWrapper = void 0;
var wee = Vo, bee = (
  /** @class */
  function(o) {
    Cee(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.date = null, e;
    }
    return t.prototype.getDate = function() {
      return this.date;
    }, t.prototype.setDate = function(e) {
      this.date = e, this.refreshProps();
    }, t.prototype.refresh = function(e) {
      this.sourceParams = e, this.refreshProps();
    }, t.prototype.getOptionalMethods = function() {
      return ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled"];
    }, t.prototype.updateDate = function(e) {
      this.setDate(e), this.sourceParams.onDateChanged();
    }, t.prototype.getProps = function() {
      var e = this, r = gy(gy({}, this.sourceParams), { date: this.date, onDateChange: function(n) {
        return e.updateDate(n);
      }, key: this.key });
      return delete r.onDateChanged, r;
    }, t;
  }(wee.CustomComponentWrapper)
);
fC.DateComponentWrapper = bee;
var hC = {}, See = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), my = ce && ce.__assign || function() {
  return my = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, my.apply(this, arguments);
};
Object.defineProperty(hC, "__esModule", { value: !0 });
hC.FilterComponentWrapper = void 0;
var Eee = Vo, _ee = (
  /** @class */
  function(o) {
    See(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.model = null, e;
    }
    return t.prototype.isFilterActive = function() {
      return this.model != null;
    }, t.prototype.doesFilterPass = function(e) {
      return this.providedMethods.doesFilterPass(e);
    }, t.prototype.getModel = function() {
      return this.model;
    }, t.prototype.setModel = function(e) {
      this.model = e, this.refreshProps();
    }, t.prototype.refresh = function(e) {
      return this.sourceParams = e, this.refreshProps(), !0;
    }, t.prototype.getOptionalMethods = function() {
      return ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onAnyFilterChanged"];
    }, t.prototype.updateModel = function(e) {
      var r = this;
      this.setModel(e), setTimeout(function() {
        r.sourceParams.filterChangedCallback();
      });
    }, t.prototype.getProps = function() {
      var e = this, r = my(my({}, this.sourceParams), { model: this.model, onModelChange: function(n) {
        return e.updateModel(n);
      }, onUiChange: function() {
        return e.sourceParams.filterChangedCallback();
      }, key: this.key });
      return delete r.filterChangedCallback, delete r.filterModifiedCallback, delete r.valueGetter, r;
    }, t;
  }(Eee.CustomComponentWrapper)
);
hC.FilterComponentWrapper = _ee;
var vC = {}, wc = {}, yy = ce && ce.__assign || function() {
  return yy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, yy.apply(this, arguments);
};
Object.defineProperty(wc, "__esModule", { value: !0 });
wc.FloatingFilterComponentProxy = wc.updateFloatingFilterParent = void 0;
var xee = Mn, Ree = Vo;
function lN(o, t) {
  o.parentFilterInstance(function(e) {
    (e.setModel(t) || xee.AgPromise.resolve()).then(function() {
      setTimeout(function() {
        o.filterParams.filterChangedCallback();
      });
    });
  });
}
wc.updateFloatingFilterParent = lN;
var Tee = (
  /** @class */
  function() {
    function o(t, e) {
      this.floatingFilterParams = t, this.refreshProps = e, this.model = null;
    }
    return o.prototype.getProps = function() {
      var t = this;
      return yy(yy({}, this.floatingFilterParams), { model: this.model, onModelChange: function(e) {
        return t.updateModel(e);
      } });
    }, o.prototype.onParentModelChanged = function(t) {
      this.model = t, this.refreshProps();
    }, o.prototype.refresh = function(t) {
      this.floatingFilterParams = t, this.refreshProps();
    }, o.prototype.setMethods = function(t) {
      Ree.addOptionalMethods(this.getOptionalMethods(), t, this);
    }, o.prototype.getOptionalMethods = function() {
      return ["afterGuiAttached"];
    }, o.prototype.updateModel = function(t) {
      this.model = t, this.refreshProps(), lN(this.floatingFilterParams, t);
    }, o;
  }()
);
wc.FloatingFilterComponentProxy = Tee;
var Oee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), Cy = ce && ce.__assign || function() {
  return Cy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Cy.apply(this, arguments);
};
Object.defineProperty(vC, "__esModule", { value: !0 });
vC.FloatingFilterComponentWrapper = void 0;
var Pee = Vo, Dee = wc, Aee = (
  /** @class */
  function(o) {
    Oee(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.model = null, e;
    }
    return t.prototype.onParentModelChanged = function(e) {
      this.model = e, this.refreshProps();
    }, t.prototype.refresh = function(e) {
      this.sourceParams = e, this.refreshProps();
    }, t.prototype.getOptionalMethods = function() {
      return ["afterGuiAttached"];
    }, t.prototype.updateModel = function(e) {
      this.model = e, this.refreshProps(), Dee.updateFloatingFilterParent(this.sourceParams, e);
    }, t.prototype.getProps = function() {
      var e = this;
      return Cy(Cy({}, this.sourceParams), { model: this.model, onModelChange: function(r) {
        return e.updateModel(r);
      }, key: this.key });
    }, t;
  }(Pee.CustomComponentWrapper)
);
vC.FloatingFilterComponentWrapper = Aee;
var gC = {}, Mee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty(gC, "__esModule", { value: !0 });
gC.LoadingOverlayComponentWrapper = void 0;
var Fee = Vo, Iee = (
  /** @class */
  function(o) {
    Mee(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.refresh = function(e) {
      this.sourceParams = e, this.refreshProps();
    }, t;
  }(Fee.CustomComponentWrapper)
);
gC.LoadingOverlayComponentWrapper = Iee;
var mC = {}, Lee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty(mC, "__esModule", { value: !0 });
mC.NoRowsOverlayComponentWrapper = void 0;
var Nee = Vo, kee = (
  /** @class */
  function(o) {
    Lee(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.refresh = function(e) {
      this.sourceParams = e, this.refreshProps();
    }, t;
  }(Nee.CustomComponentWrapper)
);
mC.NoRowsOverlayComponentWrapper = kee;
var yC = {}, Gee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}();
Object.defineProperty(yC, "__esModule", { value: !0 });
yC.StatusPanelComponentWrapper = void 0;
var Vee = Vo, Hee = (
  /** @class */
  function(o) {
    Gee(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.refresh = function(e) {
      return this.sourceParams = e, this.refreshProps(), !0;
    }, t;
  }(Vee.CustomComponentWrapper)
);
yC.StatusPanelComponentWrapper = Hee;
var CC = {}, Bee = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), wy = ce && ce.__assign || function() {
  return wy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, wy.apply(this, arguments);
};
Object.defineProperty(CC, "__esModule", { value: !0 });
CC.ToolPanelComponentWrapper = void 0;
var Wee = Vo, jee = (
  /** @class */
  function(o) {
    Bee(t, o);
    function t() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return t.prototype.refresh = function(e) {
      return this.sourceParams = e, this.refreshProps(), !0;
    }, t.prototype.getState = function() {
      return this.state;
    }, t.prototype.updateState = function(e) {
      this.state = e, this.refreshProps(), this.sourceParams.onStateUpdated();
    }, t.prototype.getProps = function() {
      var e = this;
      return wy(wy({}, this.sourceParams), { key: this.key, state: this.state, onStateChange: function(r) {
        return e.updateState(r);
      } });
    }, t;
  }(Wee.CustomComponentWrapper)
);
CC.ToolPanelComponentWrapper = jee;
var wC = {}, VP = ce && ce.__spreadArray || function(o, t) {
  for (var e = 0, r = t.length, n = o.length; e < r; e++, n++)
    o[n] = t[e];
  return o;
};
Object.defineProperty(wC, "__esModule", { value: !0 });
wC.PortalManager = void 0;
var Uee = (
  /** @class */
  function() {
    function o(t, e, r) {
      this.destroyed = !1, this.portals = [], this.hasPendingPortalUpdate = !1, this.wrappingElement = e || "div", this.refresher = t, this.maxComponentCreationTimeMs = r || o.MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    return o.prototype.getPortals = function() {
      return this.portals;
    }, o.prototype.destroy = function() {
      this.destroyed = !0;
    }, o.prototype.destroyPortal = function(t) {
      this.portals = this.portals.filter(function(e) {
        return e !== t;
      }), this.batchUpdate();
    }, o.prototype.getComponentWrappingElement = function() {
      return this.wrappingElement;
    }, o.prototype.mountReactPortal = function(t, e, r) {
      this.portals = VP(VP([], this.portals), [t]), this.waitForInstance(e, r), this.batchUpdate();
    }, o.prototype.updateReactPortal = function(t, e) {
      this.portals[this.portals.indexOf(t)] = e, this.batchUpdate();
    }, o.prototype.batchUpdate = function() {
      var t = this;
      this.hasPendingPortalUpdate || (setTimeout(function() {
        t.destroyed || (t.refresher(), t.hasPendingPortalUpdate = !1);
      }), this.hasPendingPortalUpdate = !0);
    }, o.prototype.waitForInstance = function(t, e, r) {
      var n = this;
      if (r === void 0 && (r = Date.now()), this.destroyed) {
        e(null);
        return;
      }
      if (t.rendered())
        e(t);
      else {
        if (Date.now() - r >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
          if (t.isNullValue()) {
            e(t);
            return;
          }
          console.error("AG Grid: React Component '" + t.getReactComponentName() + "' not created within " + this.maxComponentCreationTimeMs + "ms."), console.error("    If the component is using `forwardRef` but not `useImperativeHandle`, add the following: `useImperativeHandle(ref, () => ({}));`");
          return;
        }
        window.setTimeout(function() {
          n.waitForInstance(t, e, r);
        });
      }
    }, o.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3, o;
  }()
);
wC.PortalManager = Uee;
var Fn = {}, $ee = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(Fn, "__esModule", { value: !0 });
Fn.BeansContext = void 0;
var zee = $ee(y);
Fn.BeansContext = zee.default.createContext({});
var zr = {}, ZS = ce && ce.__assign || function() {
  return ZS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, ZS.apply(this, arguments);
}, HP = ce && ce.__spreadArray || function(o, t) {
  for (var e = 0, r = t.length, n = o.length; e < r; e++, n++)
    o[n] = t[e];
  return o;
}, Yee = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(zr, "__esModule", { value: !0 });
zr.getNextValueIfDifferent = zr.agFlushSync = zr.isComponentStateless = zr.CssClasses = zr.classesList = void 0;
var QS = Yee(qu), Kee = function() {
  for (var o = [], t = 0; t < arguments.length; t++)
    o[t] = arguments[t];
  var e = o.filter(function(r) {
    return r != null && r !== "";
  });
  return e.join(" ");
};
zr.classesList = Kee;
var qee = (
  /** @class */
  function() {
    function o() {
      for (var t = this, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      this.classesMap = {}, e.forEach(function(n) {
        t.classesMap[n] = !0;
      });
    }
    return o.prototype.setClass = function(t, e) {
      var r = !!this.classesMap[t] == e;
      if (r)
        return this;
      var n = new o();
      return n.classesMap = ZS({}, this.classesMap), n.classesMap[t] = e, n;
    }, o.prototype.toString = function() {
      var t = this, e = Object.keys(this.classesMap).filter(function(r) {
        return t.classesMap[r];
      }).join(" ");
      return e;
    }, o;
  }()
);
zr.CssClasses = qee;
var Xee = function(o) {
  var t = function() {
    return typeof Symbol == "function" && Symbol.for;
  }, e = function() {
    return t() ? Symbol.for("react.memo") : 60115;
  };
  return typeof o == "function" && !(o.prototype && o.prototype.isReactComponent) || typeof o == "object" && o.$$typeof === e();
};
zr.isComponentStateless = Xee;
var Zee = QS.default.createRoot != null && QS.default.flushSync != null, Qee = function(o, t) {
  Zee && o ? QS.default.flushSync(t) : t();
};
zr.agFlushSync = Qee;
function Jee(o, t, e) {
  if (t == null || o == null)
    return t;
  if (o === t || t.length === 0 && o.length === 0)
    return o;
  if (e || o.length === 0 && t.length > 0 || o.length > 0 && t.length === 0)
    return t;
  for (var r = [], n = [], i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = 0; s < t.length; s++) {
    var l = t[s];
    a.set(l.getInstanceId(), l);
  }
  for (var s = 0; s < o.length; s++) {
    var l = o[s];
    i.set(l.getInstanceId(), l), a.has(l.getInstanceId()) && r.push(l);
  }
  for (var s = 0; s < t.length; s++) {
    var l = t[s], u = l.getInstanceId();
    i.has(u) || n.push(l);
  }
  return r.length === o.length && n.length === 0 ? o : r.length === 0 && n.length === t.length ? t : HP(HP([], r), n);
}
zr.getNextValueIfDifferent = Jee;
var __ = {}, ia = {};
Object.defineProperty(ia, "__esModule", { value: !0 });
ia.createSyncJsComp = ia.showJsComp = void 0;
var ete = function(o, t, e, r) {
  var n = !o || o.componentFromFramework || t.isDestroyed();
  if (!n) {
    var i = o.newAgStackInstance();
    if (i) {
      var a, s, l = !1;
      return i.then(function(u) {
        if (l) {
          t.destroyBean(u);
          return;
        }
        a = u, s = a.getGui(), e.appendChild(s), BP(r, a);
      }), function() {
        l = !0, a && (s && s.parentElement && s.parentElement.removeChild(s), t.destroyBean(a), r && BP(r, void 0));
      };
    }
  }
};
ia.showJsComp = ete;
var BP = function(o, t) {
  if (o)
    if (o instanceof Function) {
      var e = o;
      e(t);
    } else {
      var r = o;
      r.current = t;
    }
}, tte = function(o) {
  var t = o.newAgStackInstance();
  if (t)
    return t.resolveNow(null, function(e) {
      return e;
    });
};
ia.createSyncJsComp = tte;
var JS = ce && ce.__assign || function() {
  return JS = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, JS.apply(this, arguments);
}, rte = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), nte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), ote = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && rte(t, o, e);
  return nte(t, o), t;
};
Object.defineProperty(__, "__esModule", { value: !0 });
var WP = Mn, Jt = ote(y), ite = Fn, ate = ia, im = zr, uN = Jt.forwardRef(function(o, t) {
  var e, r = Jt.useContext(ite.BeansContext).context, n = Jt.useRef(null), i = Jt.useRef(null), a = Jt.useRef(null), s = Jt.useRef(null), l = Jt.useRef(null), u = Jt.useRef(), c = Jt.useState(), d = c[0], f = c[1], v = Jt.useState(), g = v[0], m = v[1], b = Jt.useState(), S = b[0], R = b[1], P = Jt.useState(function() {
    return new im.CssClasses();
  }), D = P[0], x = P[1], M = Jt.useState(function() {
    return new im.CssClasses("ag-hidden");
  }), F = M[0], H = M[1], B = Jt.useState(function() {
    return new im.CssClasses("ag-hidden");
  }), j = B[0], V = B[1], W = Jt.useState(function() {
    return new im.CssClasses("ag-invisible");
  }), q = W[0], ee = W[1];
  Jt.useImperativeHandle(t, function() {
    return {
      // force new instance when grid tries to refresh
      refresh: function() {
        return !1;
      }
    };
  }), Jt.useLayoutEffect(function() {
    return ate.showJsComp(d, r, i.current);
  }, [d]);
  var re = Jt.useCallback(function(fe) {
    if (n.current = fe, !n.current) {
      r.destroyBean(u.current), u.current = null;
      return;
    }
    var ae = {
      setInnerRenderer: function(oe, ve) {
        f(oe), R(ve);
      },
      setChildCount: function(oe) {
        return m(oe);
      },
      addOrRemoveCssClass: function(oe, ve) {
        return x(function(_e) {
          return _e.setClass(oe, ve);
        });
      },
      setContractedDisplayed: function(oe) {
        return V(function(ve) {
          return ve.setClass("ag-hidden", !oe);
        });
      },
      setExpandedDisplayed: function(oe) {
        return H(function(ve) {
          return ve.setClass("ag-hidden", !oe);
        });
      },
      setCheckboxVisible: function(oe) {
        return ee(function(ve) {
          return ve.setClass("ag-invisible", !oe);
        });
      }
    };
    u.current = r.createBean(new WP.GroupCellRendererCtrl()), u.current.init(ae, n.current, a.current, s.current, l.current, uN, o);
  }, []), ie = Jt.useMemo(function() {
    return "ag-cell-wrapper " + D.toString();
  }, [D]), ne = Jt.useMemo(function() {
    return "ag-group-expanded " + F.toString();
  }, [F]), se = Jt.useMemo(function() {
    return "ag-group-contracted " + j.toString();
  }, [j]), pe = Jt.useMemo(function() {
    return "ag-group-checkbox " + q.toString();
  }, [q]), K = d && d.componentFromFramework, J = K ? d.componentClass : void 0, ue = d == null && S != null, he = WP._.escapeString(S, !0);
  return Jt.default.createElement(
    "span",
    { className: ie, ref: re, role: (e = u.current) === null || e === void 0 ? void 0 : e.getCellAriaRole() },
    Jt.default.createElement("span", { className: ne, ref: s }),
    Jt.default.createElement("span", { className: se, ref: l }),
    Jt.default.createElement("span", { className: pe, ref: a }),
    Jt.default.createElement(
      "span",
      { className: "ag-group-value", ref: i },
      ue && Jt.default.createElement(Jt.default.Fragment, null, he),
      K && Jt.default.createElement(J, JS({}, d.params))
    ),
    Jt.default.createElement("span", { className: "ag-group-child-count" }, g)
  );
});
__.default = uN;
var x_ = {}, R_ = {}, T_ = {}, O_ = {}, P_ = {}, D_ = {}, by = ce && ce.__assign || function() {
  return by = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, by.apply(this, arguments);
}, ste = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), lte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), ute = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && ste(t, o, e);
  return lte(t, o), t;
};
Object.defineProperty(D_, "__esModule", { value: !0 });
var Bn = ute(y), cte = Fn, am = Mn, dte = zr, pte = ia, fte = function(o) {
  var t = o.ctrl, e = Bn.useContext(cte.BeansContext).context, r = t.getColId(), n = Bn.useState(), i = n[0], a = n[1], s = Bn.useRef(null), l = Bn.useRef(null), u = Bn.useRef(null), c = Bn.useRef(), d = Bn.useRef();
  d.current || (d.current = new am.CssClassManager(function() {
    return s.current;
  }));
  var f = Bn.useCallback(function(b) {
    var S;
    if (s.current = b, !!s.current) {
      var R = {
        setWidth: function(D) {
          s.current && (s.current.style.width = D);
        },
        addOrRemoveCssClass: function(D, x) {
          return d.current.addOrRemoveCssClass(D, x);
        },
        setAriaDescription: function(D) {
          s.current && am._.setAriaDescription(s.current, D);
        },
        setAriaSort: function(D) {
          s.current && (D ? am._.setAriaSort(s.current, D) : am._.removeAriaSort(s.current));
        },
        setUserCompDetails: function(D) {
          return a(D);
        },
        getUserCompInstance: function() {
          return c.current || void 0;
        }
      };
      t.setComp(R, s.current, l.current, u.current);
      var P = t.getSelectAllGui();
      (S = l.current) === null || S === void 0 || S.insertAdjacentElement("afterend", P);
    }
  }, []);
  Bn.useLayoutEffect(function() {
    return pte.showJsComp(i, e, u.current, c);
  }, [i]), Bn.useEffect(function() {
    t.setDragSource(s.current);
  }, [i]);
  var v = Bn.useMemo(function() {
    var b = (i == null ? void 0 : i.componentFromFramework) && dte.isComponentStateless(i.componentClass);
    return !!b;
  }, [i]), g = i && i.componentFromFramework, m = i && i.componentClass;
  return Bn.default.createElement(
    "div",
    { ref: f, className: "ag-header-cell", "col-id": r, role: "columnheader", tabIndex: -1 },
    Bn.default.createElement("div", { ref: l, className: "ag-header-cell-resize", role: "presentation" }),
    Bn.default.createElement(
      "div",
      { ref: u, className: "ag-header-cell-comp-wrapper", role: "presentation" },
      g && v && Bn.default.createElement(m, by({}, i.params)),
      g && !v && Bn.default.createElement(m, by({}, i.params, { ref: c }))
    )
  );
};
D_.default = Bn.memo(fte);
var A_ = {}, Sy = ce && ce.__assign || function() {
  return Sy = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Sy.apply(this, arguments);
}, hte = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), vte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), gte = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && hte(t, o, e);
  return vte(t, o), t;
};
Object.defineProperty(A_, "__esModule", { value: !0 });
var en = gte(y), mte = Fn, yte = ia, xb = zr, Cte = function(o) {
  var t = en.useContext(mte.BeansContext).context, e = o.ctrl, r = en.useState(function() {
    return new xb.CssClasses();
  }), n = r[0], i = r[1], a = en.useState(function() {
    return new xb.CssClasses();
  }), s = a[0], l = a[1], u = en.useState("false"), c = u[0], d = u[1], f = en.useState(), v = f[0], g = f[1], m = en.useState(), b = m[0], S = m[1], R = en.useMemo(function() {
    return e.getColId();
  }, []), P = en.useRef(null), D = en.useRef(null), x = en.useRef(), M = en.useCallback(function(W) {
    if (P.current = W, !!P.current) {
      var q = {
        setWidth: function(ee) {
          P.current && (P.current.style.width = ee);
        },
        addOrRemoveCssClass: function(ee, re) {
          return i(function(ie) {
            return ie.setClass(ee, re);
          });
        },
        setUserCompDetails: function(ee) {
          return S(ee);
        },
        setResizableDisplayed: function(ee) {
          l(function(re) {
            return re.setClass("ag-hidden", !ee);
          }), d(ee ? "false" : "true");
        },
        setAriaExpanded: function(ee) {
          return g(ee);
        },
        getUserCompInstance: function() {
          return x.current || void 0;
        }
      };
      e.setComp(q, P.current, D.current);
    }
  }, []);
  en.useLayoutEffect(function() {
    return yte.showJsComp(b, t, P.current);
  }, [b]), en.useEffect(function() {
    P.current && e.setDragSource(P.current);
  }, [b]);
  var F = en.useMemo(function() {
    var W = (b == null ? void 0 : b.componentFromFramework) && xb.isComponentStateless(b.componentClass);
    return !!W;
  }, [b]), H = en.useMemo(function() {
    return "ag-header-group-cell " + n.toString();
  }, [n]), B = en.useMemo(function() {
    return "ag-header-cell-resize " + s.toString();
  }, [s]), j = b && b.componentFromFramework, V = b && b.componentClass;
  return en.default.createElement(
    "div",
    { ref: M, className: H, "col-id": R, role: "columnheader", tabIndex: -1, "aria-expanded": v },
    j && F && en.default.createElement(V, Sy({}, b.params)),
    j && !F && en.default.createElement(V, Sy({}, b.params, { ref: x })),
    en.default.createElement("div", { ref: D, "aria-hidden": c, className: B })
  );
};
A_.default = en.memo(Cte);
var M_ = {}, Ey = ce && ce.__assign || function() {
  return Ey = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, Ey.apply(this, arguments);
}, wte = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), bte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), Ste = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && wte(t, o, e);
  return bte(t, o), t;
};
Object.defineProperty(M_, "__esModule", { value: !0 });
var vr = Ste(y), Ete = Fn, _te = Mn, sm = zr, xte = ia, Rte = wc, Tte = _c, Ote = function(o) {
  var t = vr.useContext(Ete.BeansContext), e = t.context, r = t.gridOptionsService, n = vr.useState(function() {
    return new sm.CssClasses("ag-header-cell", "ag-floating-filter");
  }), i = n[0], a = n[1], s = vr.useState(function() {
    return new sm.CssClasses();
  }), l = s[0], u = s[1], c = vr.useState(function() {
    return new sm.CssClasses("ag-floating-filter-button", "ag-hidden");
  }), d = c[0], f = c[1], v = vr.useState("false"), g = v[0], m = v[1], b = vr.useState(), S = b[0], R = b[1], P = vr.useState(1);
  P[0];
  var D = P[1], x = vr.useRef(null), M = vr.useRef(null), F = vr.useRef(null), H = vr.useRef(null), B = vr.useRef(), j = vr.useRef(), V = function(he) {
    he != null && B.current && B.current(he);
  }, W = o.ctrl, q = vr.useCallback(function(he) {
    if (x.current = he, !!x.current) {
      j.current = new _te.AgPromise(function(ae) {
        B.current = ae;
      });
      var fe = {
        addOrRemoveCssClass: function(ae, oe) {
          return a(function(ve) {
            return ve.setClass(ae, oe);
          });
        },
        addOrRemoveBodyCssClass: function(ae, oe) {
          return u(function(ve) {
            return ve.setClass(ae, oe);
          });
        },
        setButtonWrapperDisplayed: function(ae) {
          f(function(oe) {
            return oe.setClass("ag-hidden", !ae);
          }), m(ae ? "false" : "true");
        },
        setWidth: function(ae) {
          x.current && (x.current.style.width = ae);
        },
        setCompDetails: function(ae) {
          return R(ae);
        },
        getFloatingFilterComp: function() {
          return j.current ? j.current : null;
        },
        setMenuIcon: function(ae) {
          var oe;
          return (oe = H.current) === null || oe === void 0 ? void 0 : oe.appendChild(ae);
        }
      };
      W.setComp(fe, x.current, H.current, M.current);
    }
  }, []);
  vr.useLayoutEffect(function() {
    return xte.showJsComp(S, e, M.current, V);
  }, [S]);
  var ee = vr.useMemo(function() {
    return i.toString();
  }, [i]), re = vr.useMemo(function() {
    return l.toString();
  }, [l]), ie = vr.useMemo(function() {
    return d.toString();
  }, [d]), ne = vr.useMemo(function() {
    var he = S && S.componentFromFramework && sm.isComponentStateless(S.componentClass);
    return !!he;
  }, [S]), se = vr.useMemo(function() {
    return r.get("reactiveCustomComponents");
  }, []), pe = vr.useMemo(function() {
    if (se && S) {
      var he = new Rte.FloatingFilterComponentProxy(S.params, function() {
        return D(function(fe) {
          return fe + 1;
        });
      });
      return V(he), he;
    }
  }, [S]), K = pe == null ? void 0 : pe.getProps(), J = S && S.componentFromFramework, ue = S && S.componentClass;
  return vr.default.createElement(
    "div",
    { ref: q, className: ee, role: "gridcell", tabIndex: -1 },
    vr.default.createElement(
      "div",
      { ref: M, className: re, role: "presentation" },
      J && !se && vr.default.createElement(ue, Ey({}, S.params, { ref: ne ? function() {
      } : V })),
      J && se && vr.default.createElement(
        Tte.CustomContext.Provider,
        { value: {
          setMethods: function(he) {
            return pe.setMethods(he);
          }
        } },
        vr.default.createElement(ue, Ey({}, K))
      )
    ),
    vr.default.createElement(
      "div",
      { ref: F, "aria-hidden": g, className: ie, role: "presentation" },
      vr.default.createElement("button", { ref: H, type: "button", className: "ag-button ag-floating-filter-button-button", tabIndex: -1 })
    )
  );
};
M_.default = vr.memo(Ote);
var Pte = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), Dte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), Ate = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Pte(t, o, e);
  return Dte(t, o), t;
}, F_ = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(P_, "__esModule", { value: !0 });
var jP = Mn, Ao = Ate(y), Mte = F_(D_), Fte = F_(A_), Ite = F_(M_), UP = zr, Lte = function(o) {
  var t = o.ctrl, e = Ao.useMemo(function() {
    return t.getTopAndHeight();
  }, []), r = e.topOffset, n = e.rowHeight, i = t.getAriaRowIndex(), a = t.getHeaderRowClass(), s = Ao.useMemo(function() {
    return t.getTransform();
  }, []), l = Ao.useState(function() {
    return n + "px";
  }), u = l[0], c = l[1], d = Ao.useState(function() {
    return r + "px";
  }), f = d[0], v = d[1], g = Ao.useState(function() {
    return t.getHeaderCtrls();
  }), m = g[0], b = g[1], S = Ao.useRef(null), R = Ao.useCallback(function(x) {
    if (S.current = x, !!x) {
      var M = {
        setHeight: function(F) {
          return c(F);
        },
        setTop: function(F) {
          return v(F);
        },
        setHeaderCtrls: function(F, H, B) {
          UP.agFlushSync(B, function() {
            b(function(j) {
              return UP.getNextValueIfDifferent(j, F, H);
            });
          });
        },
        setWidth: function(F) {
          S.current && (S.current.style.width = F);
        }
      };
      t.setComp(M, !1);
    }
  }, []), P = Ao.useMemo(function() {
    return {
      transform: s,
      height: u,
      top: f
    };
  }, [s, u, f]), D = Ao.useCallback(function(x) {
    switch (t.getType()) {
      case jP.HeaderRowType.COLUMN_GROUP:
        return Ao.default.createElement(Fte.default, { ctrl: x, key: x.getInstanceId() });
      case jP.HeaderRowType.FLOATING_FILTER:
        return Ao.default.createElement(Ite.default, { ctrl: x, key: x.getInstanceId() });
      default:
        return Ao.default.createElement(Mte.default, { ctrl: x, key: x.getInstanceId() });
    }
  }, []);
  return Ao.default.createElement("div", { ref: R, className: a, role: "row", style: P, "aria-rowindex": i }, m.map(D));
};
P_.default = Ao.memo(Lte);
var Nte = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), kte = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), Gte = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Nte(t, o, e);
  return kte(t, o), t;
}, Vte = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(O_, "__esModule", { value: !0 });
var co = Gte(y), Hte = Fn, Bte = Mn, Wte = Vte(P_), jte = function(o) {
  var t = co.useState(!0), e = t[0], r = t[1], n = co.useState([]), i = n[0], a = n[1], s = co.useContext(Hte.BeansContext).context, l = co.useRef(null), u = co.useRef(null), c = co.useRef(null), d = o.pinned === "left", f = o.pinned === "right", v = !d && !f, g = co.useCallback(function(S) {
    if (l.current = S, !l.current) {
      s.destroyBean(c.current), c.current = null;
      return;
    }
    var R = {
      setDisplayed: r,
      setCtrls: function(P) {
        return a(P);
      },
      // centre only
      setCenterWidth: function(P) {
        u.current && (u.current.style.width = P);
      },
      setViewportScrollLeft: function(P) {
        l.current && (l.current.scrollLeft = P);
      },
      // pinned only
      setPinnedContainerWidth: function(P) {
        l.current && (l.current.style.width = P, l.current.style.minWidth = P, l.current.style.maxWidth = P);
      }
    };
    c.current = s.createBean(new Bte.HeaderRowContainerCtrl(o.pinned)), c.current.setComp(R, l.current);
  }, []), m = e ? "" : "ag-hidden", b = function() {
    return i.map(function(S) {
      return co.default.createElement(Wte.default, { ctrl: S, key: S.getInstanceId() });
    });
  };
  return co.default.createElement(
    co.default.Fragment,
    null,
    d && co.default.createElement("div", { ref: g, className: "ag-pinned-left-header " + m, "aria-hidden": !e, role: "rowgroup" }, b()),
    f && co.default.createElement("div", { ref: g, className: "ag-pinned-right-header " + m, "aria-hidden": !e, role: "rowgroup" }, b()),
    v && co.default.createElement(
      "div",
      { ref: g, className: "ag-header-viewport " + m, role: "presentation" },
      co.default.createElement("div", { ref: u, className: "ag-header-container", role: "rowgroup" }, b())
    )
  );
};
O_.default = co.memo(jte);
var Ute = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), $te = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), zte = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Ute(t, o, e);
  return $te(t, o), t;
}, Yte = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(T_, "__esModule", { value: !0 });
var Zo = zte(y), Kte = Fn, qte = Mn, Xte = zr, Rb = Yte(O_), Zte = function() {
  var o = Zo.useState(function() {
    return new Xte.CssClasses();
  }), t = o[0], e = o[1], r = Zo.useState(), n = r[0], i = r[1], a = Zo.useContext(Kte.BeansContext).context, s = Zo.useRef(null), l = Zo.useRef(null), u = Zo.useCallback(function(f) {
    if (s.current = f, !f) {
      a.destroyBean(l.current), l.current = null;
      return;
    }
    var v = {
      addOrRemoveCssClass: function(g, m) {
        return e(function(b) {
          return b.setClass(g, m);
        });
      },
      setHeightAndMinHeight: function(g) {
        return i(g);
      }
    };
    l.current = a.createBean(new qte.GridHeaderCtrl()), l.current.setComp(v, s.current, s.current);
  }, []), c = Zo.useMemo(function() {
    var f = t.toString();
    return "ag-header " + f;
  }, [t]), d = Zo.useMemo(function() {
    return {
      height: n,
      minHeight: n
    };
  }, [n]);
  return Zo.default.createElement(
    "div",
    { ref: u, className: c, style: d, role: "presentation" },
    Zo.default.createElement(Rb.default, { pinned: "left" }),
    Zo.default.createElement(Rb.default, { pinned: null }),
    Zo.default.createElement(Rb.default, { pinned: "right" })
  );
};
T_.default = Zo.memo(Zte);
var yv = {};
Object.defineProperty(yv, "__esModule", { value: !0 });
var Qte = y, Jte = function(o, t) {
  Qte.useEffect(function() {
    var e = t.current;
    if (e) {
      var r = e.parentElement;
      if (r) {
        var n = document.createComment(o);
        return r.insertBefore(n, e), function() {
          r.removeChild(n);
        };
      }
    }
  }, [o]);
};
yv.default = Jte;
var I_ = {}, L_ = {}, cN = {}, N_ = {}, bC = {};
Object.defineProperty(bC, "__esModule", { value: !0 });
bC.useEffectOnce = void 0;
var Nd = y, ere = function(o) {
  var t = Nd.useRef(o), e = Nd.useRef(), r = Nd.useRef(!1), n = Nd.useRef(!1), i = Nd.useState(0), a = i[1];
  r.current && (n.current = !0), Nd.useEffect(function() {
    return r.current || (e.current = t.current(), r.current = !0), a(function(s) {
      return s + 1;
    }), function() {
      n.current && e.current && e.current();
    };
  }, []);
};
bC.useEffectOnce = ere;
var tre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), rre = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), nre = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && tre(t, o, e);
  return rre(t, o), t;
};
Object.defineProperty(N_, "__esModule", { value: !0 });
var ore = Mn, ph = nre(y), ire = qu, are = Fn, sre = bC, lre = function(o) {
  var t = ph.useState(), e = t[0], r = t[1], n = ph.useContext(are.BeansContext), i = n.context, a = n.popupService, s = n.localeService, l = n.gridOptionsService;
  return sre.useEffectOnce(function() {
    var u = o.editDetails, c = o.cellCtrl, d = o.eParentCell, f = u.compDetails, v = l.get("stopEditingWhenCellsLoseFocus"), g = i.createBean(new ore.PopupEditorWrapper(f.params)), m = g.getGui();
    if (o.jsChildComp) {
      var b = o.jsChildComp.getGui();
      b && m.appendChild(b);
    }
    var S = {
      column: c.getColumn(),
      rowNode: c.getRowNode(),
      type: "popupCellEditor",
      eventSource: d,
      ePopup: m,
      position: u.popupPosition,
      keepWithinBounds: !0
    }, R = a.positionPopupByComponent.bind(a, S), P = s.getLocaleTextFunc(), D = a.addPopup({
      modal: v,
      eChild: m,
      closeOnEsc: !0,
      closedCallback: function() {
        c.onPopupEditorClosed();
      },
      anchorToElement: d,
      positionCallback: R,
      ariaLabel: P("ariaLabelCellEditor", "Cell Editor")
    }), x = D ? D.hideFunc : void 0;
    return r(g), o.jsChildComp && o.jsChildComp.afterGuiAttached && o.jsChildComp.afterGuiAttached(), function() {
      x != null && x(), i.destroyBean(g);
    };
  }), ph.default.createElement(ph.default.Fragment, null, e && o.wrappedContent && ire.createPortal(o.wrappedContent, e.getGui()));
};
N_.default = ph.memo(lre);
var k_ = {};
Object.defineProperty(k_, "__esModule", { value: !0 });
var lm = y, ure = Fn, cre = function(o, t, e, r, n, i) {
  var a = lm.useContext(ure.BeansContext).context, s = lm.useCallback(function() {
    var l = n.current;
    if (l) {
      var u = l.getGui();
      u && u.parentElement && u.parentElement.removeChild(u), a.destroyBean(l), n.current = void 0;
    }
  }, []);
  lm.useEffect(function() {
    var l = o != null, u = o && o.compDetails && !o.compDetails.componentFromFramework, c = t && e == null, d = l && u && !c;
    if (!d) {
      s();
      return;
    }
    var f = o.compDetails;
    if (n.current) {
      var v = n.current, g = v.refresh != null && o.force == !1, m = g ? v.refresh(f.params) : !1, b = m === !0 || m === void 0;
      if (b)
        return;
      s();
    }
    var S = f.newAgStackInstance();
    if (S) {
      var R = S.resolveNow(null, function(x) {
        return x;
      });
      if (R) {
        var P = R.getGui();
        if (P) {
          var D = t ? e : i.current;
          D.appendChild(P), n.current = R;
        }
      }
    }
  }, [o, t, r]), lm.useEffect(function() {
    return s;
  }, []);
};
k_.default = cre;
var SC = {}, _y = ce && ce.__assign || function() {
  return _y = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, _y.apply(this, arguments);
};
Object.defineProperty(SC, "__esModule", { value: !0 });
SC.CellEditorComponentProxy = void 0;
var dre = Mn, pre = Vo, fre = (
  /** @class */
  function() {
    function o(t, e) {
      var r = this;
      this.cellEditorParams = t, this.refreshProps = e, this.instanceCreated = new dre.AgPromise(function(n) {
        r.resolveInstanceCreated = n;
      }), this.value = t.value;
    }
    return o.prototype.getProps = function() {
      var t = this;
      return _y(_y({}, this.cellEditorParams), { initialValue: this.cellEditorParams.value, value: this.value, onValueChange: function(e) {
        return t.updateValue(e);
      } });
    }, o.prototype.getValue = function() {
      return this.value;
    }, o.prototype.refresh = function(t) {
      this.cellEditorParams = t, this.refreshProps();
    }, o.prototype.setMethods = function(t) {
      pre.addOptionalMethods(this.getOptionalMethods(), t, this);
    }, o.prototype.getInstance = function() {
      var t = this;
      return this.instanceCreated.then(function() {
        return t.componentInstance;
      });
    }, o.prototype.setRef = function(t) {
      var e;
      this.componentInstance = t, (e = this.resolveInstanceCreated) === null || e === void 0 || e.call(this), this.resolveInstanceCreated = void 0;
    }, o.prototype.getOptionalMethods = function() {
      return ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached"];
    }, o.prototype.updateValue = function(t) {
      this.value = t, this.refreshProps();
    }, o;
  }()
);
SC.CellEditorComponentProxy = fre;
(function(o) {
  var t = ce && ce.__assign || function() {
    return t = Object.assign || function(x) {
      for (var M, F = 1, H = arguments.length; F < H; F++) {
        M = arguments[F];
        for (var B in M) Object.prototype.hasOwnProperty.call(M, B) && (x[B] = M[B]);
      }
      return x;
    }, t.apply(this, arguments);
  }, e = ce && ce.__createBinding || (Object.create ? function(x, M, F, H) {
    H === void 0 && (H = F), Object.defineProperty(x, H, { enumerable: !0, get: function() {
      return M[F];
    } });
  } : function(x, M, F, H) {
    H === void 0 && (H = F), x[H] = M[F];
  }), r = ce && ce.__setModuleDefault || (Object.create ? function(x, M) {
    Object.defineProperty(x, "default", { enumerable: !0, value: M });
  } : function(x, M) {
    x.default = M;
  }), n = ce && ce.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var M = {};
    if (x != null) for (var F in x) F !== "default" && Object.prototype.hasOwnProperty.call(x, F) && e(M, x, F);
    return r(M, x), M;
  }, i = ce && ce.__importDefault || function(x) {
    return x && x.__esModule ? x : { default: x };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.CellCompState = void 0;
  var a = Mn, s = n(y), l = zr, u = i(N_), c = i(k_), d = Fn, f = ia, v = SC, g = _c;
  (function(x) {
    x[x.ShowValue = 0] = "ShowValue", x[x.EditValue = 1] = "EditValue";
  })(o.CellCompState || (o.CellCompState = {}));
  var m = function(x, M, F) {
    var H = F.getColumn();
    if (!x && M.isPopup && M.isPopup()) {
      var B = "AG Grid: Found an issue in column " + H.getColId() + ". If using React, specify an editor is a popup using colDef.cellEditorPopup=true. AG Grid React cannot depend on the editor component specifying if it's in a popup (via the isPopup() method on the editor), as React needs to know this information BEFORE the component is created.";
      a._.doOnce(function() {
        return console.warn(B);
      }, "jsEditorComp-isPopup-" + F.getColumn().getColId());
    }
    if (x && M.getPopupPosition && M.getPopupPosition() != null) {
      var j = "AG Grid: Found an issue in column " + H.getColId() + ". If using React, specify an editor popup position using colDef.cellEditorPopupPosition=true. AG Grid React cannot depend on the editor component specifying it's position (via the getPopupPosition() method on the editor), as React needs to know this information BEFORE the component is created.";
      a._.doOnce(function() {
        return console.warn(j);
      }, "jsEditorComp-getPopupPosition-" + F.getColumn().getColId());
    }
  }, b = function(x, M, F) {
    var H = x.compProxy;
    F(H);
    var B = H.getProps(), j = l.isComponentStateless(M);
    return s.default.createElement(
      g.CustomContext.Provider,
      { value: {
        setMethods: function(V) {
          return H.setMethods(V);
        }
      } },
      j && s.default.createElement(M, t({}, B)),
      !j && s.default.createElement(M, t({}, B, { ref: function(V) {
        return H.setRef(V);
      } }))
    );
  }, S = function(x, M, F) {
    var H = x.compProxy;
    return s.default.createElement(
      s.default.Fragment,
      null,
      !H && s.default.createElement(M, t({}, x.compDetails.params, { ref: F })),
      H && b(x, M, F)
    );
  }, R = function(x, M, F, H, B, j) {
    var V = x.compDetails, W = V.componentClass, q = V.componentFromFramework && !x.popup, ee = V.componentFromFramework && x.popup, re = !V.componentFromFramework && x.popup;
    return s.default.createElement(
      s.default.Fragment,
      null,
      q && S(x, W, M),
      ee && s.default.createElement(u.default, { editDetails: x, cellCtrl: B, eParentCell: H, wrappedContent: S(x, W, F) }),
      re && j && s.default.createElement(u.default, { editDetails: x, cellCtrl: B, eParentCell: H, jsChildComp: j })
    );
  }, P = function(x, M, F, H, B, j, V) {
    var W = x.compDetails, q = x.value, ee = !W, re = W && W.componentFromFramework, ie = W && W.componentClass, ne = q != null && q.toString ? q.toString() : q, se = function() {
      return s.default.createElement(
        s.default.Fragment,
        null,
        ee && s.default.createElement(s.default.Fragment, null, ne),
        re && !j && s.default.createElement(ie, t({}, W.params, { key: M, ref: H })),
        re && j && s.default.createElement(ie, t({}, W.params, { key: M }))
      );
    };
    return s.default.createElement(s.default.Fragment, null, B ? s.default.createElement("span", { role: "presentation", id: "cell-" + F, className: "ag-cell-value", ref: V }, se()) : se());
  }, D = function(x) {
    var M = s.useContext(d.BeansContext).context, F = x.cellCtrl, H = x.printLayout, B = x.editingRow, j = F.getTabIndex(), V = F.getColumnIdSanitised(), W = F.getInstanceId(), q = s.useState(function() {
      return F.isCellRenderer() ? void 0 : { compDetails: void 0, value: F.getValueToDisplay(), force: !1 };
    }), ee = q[0], re = q[1], ie = s.useState(), ne = ie[0], se = ie[1], pe = s.useState(1), K = pe[0], J = pe[1], ue = s.useState(), he = ue[0], fe = ue[1], ae = s.useState(!1), oe = ae[0], ve = ae[1], _e = s.useState(!1), le = _e[0], Ee = _e[1], de = s.useState(!1), X = de[0], xe = de[1], Le = s.useState(), Ue = Le[0], He = Le[1], et = s.useMemo(function() {
      return F.isForceWrapper();
    }, [F]), $e = s.useMemo(function() {
      return F.getCellAriaRole();
    }, [F]), pt = s.useRef(null), st = s.useRef(null), Bt = s.useRef(), vt = s.useRef(), nt = s.useRef(), ze = s.useRef([]), Ct = s.useRef(), Mt = s.useState(0), fr = Mt[0], lt = Mt[1], Et = s.useCallback(function(Ft) {
      Ct.current = Ft, lt(function(ot) {
        return ot + 1;
      });
    }, []), kt = ee != null && (oe || X || le), $t = et || kt, br = s.useCallback(function(Ft, ot) {
      if (vt.current = ot, ot) {
        m(Ft, ot, F);
        var Gr = ot.isCancelBeforeStart && ot.isCancelBeforeStart();
        Gr && setTimeout(function() {
          F.stopEditing(!0), F.focusCell(!0);
        });
      }
    }, [F]), mt = s.useCallback(function(Ft) {
      return br(!0, Ft);
    }, [br]), rt = s.useCallback(function(Ft) {
      return br(!1, Ft);
    }, [br]), Gt = s.useRef();
    Gt.current || (Gt.current = new a.CssClassManager(function() {
      return pt.current;
    })), c.default(ee, $t, Ct.current, fr, Bt, pt);
    var zt = s.useRef();
    s.useLayoutEffect(function() {
      var Ft = zt.current, ot = ee;
      if (zt.current = ee, !(Ft == null || Ft.compDetails == null || ot == null || ot.compDetails == null)) {
        var Gr = Ft.compDetails, wt = ot.compDetails;
        if (Gr.componentClass == wt.componentClass && !(st.current == null || st.current.refresh == null)) {
          var Qt = st.current.refresh(wt.params);
          Qt != !0 && J(function(Sr) {
            return Sr + 1;
          });
        }
      }
    }, [ee]), s.useLayoutEffect(function() {
      var Ft = ne && !ne.compDetails.componentFromFramework;
      if (Ft) {
        var ot = ne.compDetails, Gr = ne.popup === !0, wt = f.createSyncJsComp(ot);
        if (wt) {
          var Qt = wt.getGui();
          if (br(Gr, wt), !Gr) {
            var Sr = (et ? nt : pt).current;
            Sr == null || Sr.appendChild(Qt), wt.afterGuiAttached && wt.afterGuiAttached();
          }
          return He(wt), function() {
            M.destroyBean(wt), br(Gr, void 0), He(void 0), Qt && Qt.parentElement && Qt.parentElement.removeChild(Qt);
          };
        }
      }
    }, [ne]);
    var Ze = s.useCallback(function(Ft) {
      if (nt.current = Ft, !nt.current) {
        ze.current.forEach(function(wt) {
          return wt();
        }), ze.current = [];
        return;
      }
      var ot = function(wt) {
        var Qt;
        if (wt) {
          var Sr = wt.getGui();
          (Qt = nt.current) === null || Qt === void 0 || Qt.insertAdjacentElement("afterbegin", Sr), ze.current.push(function() {
            M.destroyBean(wt), a._.removeFromParent(Sr);
          });
        }
        return wt;
      };
      if (oe) {
        var Gr = F.createSelectionCheckbox();
        ot(Gr);
      }
      X && ot(F.createDndSource()), le && ot(F.createRowDragComp());
    }, [F, M, X, le, oe]), Un = s.useCallback(function(Ft) {
      if (pt.current = Ft, !!pt.current && F) {
        var ot = {
          addOrRemoveCssClass: function(wt, Qt) {
            return Gt.current.addOrRemoveCssClass(wt, Qt);
          },
          setUserStyles: function(wt) {
            return fe(wt);
          },
          getFocusableElement: function() {
            return pt.current;
          },
          setIncludeSelection: function(wt) {
            return ve(wt);
          },
          setIncludeRowDrag: function(wt) {
            return Ee(wt);
          },
          setIncludeDndSource: function(wt) {
            return xe(wt);
          },
          getCellEditor: function() {
            return vt.current || null;
          },
          getCellRenderer: function() {
            return st.current ? st.current : Bt.current;
          },
          getParentOfValue: function() {
            return Ct.current ? Ct.current : nt.current ? nt.current : pt.current;
          },
          setRenderDetails: function(wt, Qt, Sr) {
            re(function(jr) {
              return (jr == null ? void 0 : jr.compDetails) !== wt || (jr == null ? void 0 : jr.value) !== Qt || (jr == null ? void 0 : jr.force) !== Sr ? {
                value: Qt,
                compDetails: wt,
                force: Sr
              } : jr;
            });
          },
          setEditDetails: function(wt, Qt, Sr, jr) {
            if (wt) {
              var $n = void 0;
              jr && ($n = new v.CellEditorComponentProxy(wt.params, function() {
                return J(function(Er) {
                  return Er + 1;
                });
              })), se({
                compDetails: wt,
                popup: Qt,
                popupPosition: Sr,
                compProxy: $n
              }), Qt || re(void 0);
            } else
              se(function(Er) {
                Er != null && Er.compProxy && (vt.current = void 0);
              });
          }
        }, Gr = nt.current || void 0;
        F.setComp(ot, pt.current, Gr, H, B);
      }
    }, []), Kr = s.useMemo(function() {
      var Ft = ee && ee.compDetails && ee.compDetails.componentFromFramework && l.isComponentStateless(ee.compDetails.componentClass);
      return !!Ft;
    }, [ee]);
    s.useLayoutEffect(function() {
      var Ft;
      pt.current && (Gt.current.addOrRemoveCssClass("ag-cell-value", !$t), Gt.current.addOrRemoveCssClass("ag-cell-inline-editing", !!ne && !ne.popup), Gt.current.addOrRemoveCssClass("ag-cell-popup-editing", !!ne && !!ne.popup), Gt.current.addOrRemoveCssClass("ag-cell-not-inline-editing", !ne || !!ne.popup), (Ft = F.getRowCtrl()) === null || Ft === void 0 || Ft.setInlineEditingCss(!!ne), F.shouldRestoreFocus() && !F.isEditing() && pt.current.focus({ preventScroll: !0 }));
    });
    var ln = function() {
      return s.default.createElement(
        s.default.Fragment,
        null,
        ee != null && P(ee, K, W, st, $t, Kr, Et),
        ne != null && R(ne, rt, mt, pt.current, F, Ue)
      );
    };
    return s.default.createElement("div", { ref: Un, style: he, tabIndex: j, role: $e, "col-id": V }, $t ? s.default.createElement("div", { className: "ag-cell-wrapper", role: "presentation", ref: Ze }, ln()) : ln());
  };
  o.default = s.memo(D);
})(cN);
var $d = ce && ce.__assign || function() {
  return $d = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, $d.apply(this, arguments);
}, hre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), vre = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), gre = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && hre(t, o, e);
  return vre(t, o), t;
}, mre = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(L_, "__esModule", { value: !0 });
var gr = gre(y), yre = Mn, Cre = ia, Tb = zr, wre = Fn, bre = mre(cN), Sre = function(o) {
  var t = gr.useContext(wre.BeansContext), e = t.context, r = t.gridOptionsService, n = o.rowCtrl, i = o.containerType, a = n.getTabIndex(), s = gr.useRef(n.getDomOrder()), l = n.isFullWidth(), u = n.getRowNode().displayed, c = gr.useState(function() {
    return u ? n.getRowIndex() : null;
  }), d = c[0], f = c[1], v = gr.useState(function() {
    return n.getRowId();
  }), g = v[0], m = v[1], b = gr.useState(function() {
    return n.getBusinessKey();
  }), S = b[0], R = b[1], P = gr.useState(function() {
    return n.getRowStyles();
  }), D = P[0], x = P[1], M = gr.useState(function() {
    return null;
  }), F = M[0], H = M[1], B = gr.useState(), j = B[0], V = B[1], W = gr.useState(function() {
    return u ? n.getInitialRowTop(i) : void 0;
  }), q = W[0], ee = W[1], re = gr.useState(function() {
    return u ? n.getInitialTransform(i) : void 0;
  }), ie = re[0], ne = re[1], se = gr.useRef(null), pe = gr.useRef(), K = gr.useRef(!1), J = gr.useState(0), ue = J[0], he = J[1];
  gr.useEffect(function() {
    var xe;
    if (!K.current && j && !(ue > 10)) {
      var Le = (xe = se.current) === null || xe === void 0 ? void 0 : xe.firstChild;
      Le ? (n.setupDetailRowAutoHeight(Le), K.current = !0) : he(function(Ue) {
        return Ue + 1;
      });
    }
  }, [j, ue]);
  var fe = gr.useRef();
  fe.current || (fe.current = new yre.CssClassManager(function() {
    return se.current;
  }));
  var ae = gr.useCallback(function(xe) {
    if (se.current = xe, !se.current) {
      n.unsetComp(i);
      return;
    }
    if (n.isAlive()) {
      var Le = {
        // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
        // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
        setTop: ee,
        setTransform: ne,
        // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
        // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
        addOrRemoveCssClass: function(Ue, He) {
          return fe.current.addOrRemoveCssClass(Ue, He);
        },
        setDomOrder: function(Ue) {
          return s.current = Ue;
        },
        setRowIndex: f,
        setRowId: m,
        setRowBusinessKey: R,
        setUserStyles: x,
        // if we don't maintain the order, then cols will be ripped out and into the dom
        // when cols reordered, which would stop the CSS transitions from working
        setCellCtrls: function(Ue, He) {
          Tb.agFlushSync(He, function() {
            H(function(et) {
              return Tb.getNextValueIfDifferent(et, Ue, s.current);
            });
          });
        },
        showFullWidth: function(Ue) {
          return V(Ue);
        },
        getFullWidthCellRenderer: function() {
          return pe.current;
        },
        refreshFullWidth: function(Ue) {
          return Ee.current ? (V(function(He) {
            return $d($d({}, He), { params: Ue() });
          }), !0) : !pe.current || !pe.current.refresh ? !1 : pe.current.refresh(Ue());
        }
      };
      n.setComp(Le, se.current, i);
    }
  }, []);
  gr.useLayoutEffect(function() {
    return Cre.showJsComp(j, e, se.current, pe);
  }, [j]);
  var oe = gr.useMemo(function() {
    var xe = { top: q, transform: ie };
    return Object.assign(xe, D), xe;
  }, [q, ie, D]), ve = l && j && j.componentFromFramework, _e = !l && F != null, le = gr.useMemo(function() {
    var xe = (j == null ? void 0 : j.componentFromFramework) && Tb.isComponentStateless(j.componentClass);
    return !!xe;
  }, [j]), Ee = gr.useRef(!1);
  gr.useEffect(function() {
    Ee.current = le && !!j && !!r.get("reactiveCustomComponents");
  }, [le, j]);
  var de = function() {
    return F == null ? void 0 : F.map(function(xe) {
      return gr.default.createElement(bre.default, { cellCtrl: xe, editingRow: n.isEditing(), printLayout: n.isPrintLayout(), key: xe.getInstanceId() });
    });
  }, X = function() {
    var xe = j.componentClass;
    return gr.default.createElement(
      gr.default.Fragment,
      null,
      le && gr.default.createElement(xe, $d({}, j.params)),
      !le && gr.default.createElement(xe, $d({}, j.params, { ref: pe }))
    );
  };
  return gr.default.createElement(
    "div",
    { ref: ae, role: "row", style: oe, "row-index": d, "row-id": g, "row-business-key": S, tabIndex: a },
    _e && de(),
    ve && X()
  );
};
L_.default = gr.memo(Sre);
var Ere = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), _re = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), xre = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Ere(t, o, e);
  return _re(t, o), t;
}, dN = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(I_, "__esModule", { value: !0 });
var Bu = Mn, qr = xre(y), um = zr, Rre = dN(yv), Tre = dN(L_), Ore = Fn, Pre = function(o) {
  var t = qr.useContext(Ore.BeansContext).context, e = o.name, r = qr.useMemo(function() {
    return Bu.getRowContainerTypeForName(e);
  }, [e]), n = qr.useRef(null), i = qr.useRef(null), a = qr.useRef([]), s = qr.useState(function() {
    return [];
  }), l = s[0], u = s[1], c = qr.useRef(!1), d = qr.useRef(), f = qr.useMemo(function() {
    return Bu.RowContainerCtrl.getRowContainerCssClasses(e);
  }, [e]), v = qr.useMemo(function() {
    return um.classesList(f.viewport);
  }, [f]), g = qr.useMemo(function() {
    return um.classesList(f.container);
  }, [f]), m = e === Bu.RowContainerName.CENTER || e === Bu.RowContainerName.TOP_CENTER || e === Bu.RowContainerName.BOTTOM_CENTER || e === Bu.RowContainerName.STICKY_TOP_CENTER, b = m ? n : i;
  Rre.default(" AG Row Container " + e + " ", b);
  var S = qr.useCallback(function() {
    return m ? n.current != null && i.current != null : i.current != null;
  }, []), R = qr.useCallback(function() {
    return m ? n.current == null && i.current == null : i.current == null;
  }, []), P = qr.useCallback(function() {
    if (R() && (t.destroyBean(d.current), d.current = null), S()) {
      var F = function(B) {
        um.agFlushSync(B, function() {
          u(function(j) {
            return um.getNextValueIfDifferent(j, a.current, c.current);
          });
        });
      }, H = {
        setViewportHeight: function(B) {
          n.current && (n.current.style.height = B);
        },
        setRowCtrls: function(B) {
          var j = B.rowCtrls, V = B.useFlushSync, W = !!V && a.current.length > 0 && j.length > 0;
          a.current = j, F(W);
        },
        setDomOrder: function(B) {
          c.current != B && (c.current = B, F(!1));
        },
        setContainerWidth: function(B) {
          i.current && (i.current.style.width = B);
        }
      };
      d.current = t.createBean(new Bu.RowContainerCtrl(e)), d.current.setComp(H, i.current, n.current);
    }
  }, [S, R]), D = qr.useCallback(function(F) {
    i.current = F, P();
  }, [P]), x = qr.useCallback(function(F) {
    n.current = F, P();
  }, [P]), M = function() {
    return qr.default.createElement("div", { className: g, ref: D, role: "rowgroup" }, l.map(function(F) {
      return qr.default.createElement(Tre.default, { rowCtrl: F, containerType: r, key: F.getInstanceId() });
    }));
  };
  return qr.default.createElement(qr.default.Fragment, null, m ? qr.default.createElement("div", { className: v, ref: x, role: "presentation" }, M()) : M());
};
I_.default = qr.memo(Pre);
var Dre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), Are = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), Mre = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Dre(t, o, e);
  return Are(t, o), t;
}, G_ = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(R_, "__esModule", { value: !0 });
var un = Mn, It = Mre(y), Fre = Fn, Ire = G_(T_), Jf = G_(yv), Lre = G_(I_), kd = zr, Nre = function() {
  var o = It.useContext(Fre.BeansContext), t = o.context, e = o.agStackComponentsRegistry, r = o.resizeObserverService, n = It.useState(""), i = n[0], a = n[1], s = It.useState(0), l = s[0], u = s[1], c = It.useState(0), d = c[0], f = c[1], v = It.useState("0px"), g = v[0], m = v[1], b = It.useState("0px"), S = b[0], R = b[1], P = It.useState("100%"), D = P[0], x = P[1], M = It.useState(""), F = M[0], H = M[1], B = It.useState(""), j = B[0], V = B[1], W = It.useState(null), q = W[0], ee = W[1], re = It.useState(""), ie = re[0], ne = re[1], se = It.useState(null), pe = se[0], K = se[1], J = It.useState("ag-layout-normal"), ue = J[0], he = J[1], fe = It.useRef();
  fe.current || (fe.current = new un.CssClassManager(function() {
    return ae.current;
  }));
  var ae = It.useRef(null), oe = It.useRef(null), ve = It.useRef(null), _e = It.useRef(null), le = It.useRef(null), Ee = It.useRef(null), de = It.useRef([]), X = It.useRef([]);
  Jf.default(" AG Grid Body ", ae), Jf.default(" AG Pinned Top ", oe), Jf.default(" AG Sticky Top ", ve), Jf.default(" AG Middle ", le), Jf.default(" AG Pinned Bottom ", Ee);
  var xe = It.useCallback(function(Ct) {
    if (ae.current = Ct, !ae.current) {
      t.destroyBeans(de.current), X.current.forEach(function(kt) {
        return kt();
      }), de.current = [], X.current = [];
      return;
    }
    if (t) {
      var Mt = function(kt) {
        var $t = e.getComponentClass(kt), br = t.createBean(new $t());
        return de.current.push(br), br;
      }, fr = function(kt, $t) {
        kt.appendChild($t), X.current.push(function() {
          return kt.removeChild($t);
        });
      };
      fr(ae.current, document.createComment(" AG Fake Horizontal Scroll ")), fr(ae.current, Mt("AG-FAKE-HORIZONTAL-SCROLL").getGui()), fr(ae.current, document.createComment(" AG Overlay Wrapper ")), fr(ae.current, Mt("AG-OVERLAY-WRAPPER").getGui()), _e.current && (fr(_e.current, document.createComment(" AG Fake Vertical Scroll ")), fr(_e.current, Mt("AG-FAKE-VERTICAL-SCROLL").getGui()));
      var lt = {
        setRowAnimationCssOnBodyViewport: a,
        setColumnCount: function(kt) {
          ae.current && un._.setAriaColCount(ae.current, kt);
        },
        setRowCount: function(kt) {
          ae.current && un._.setAriaRowCount(ae.current, kt);
        },
        setTopHeight: u,
        setBottomHeight: f,
        setStickyTopHeight: m,
        setStickyTopTop: R,
        setStickyTopWidth: x,
        setTopDisplay: H,
        setBottomDisplay: V,
        setColumnMovingCss: function(kt, $t) {
          return fe.current.addOrRemoveCssClass(kt, $t);
        },
        updateLayoutClasses: he,
        setAlwaysVerticalScrollClass: ee,
        setPinnedTopBottomOverflowY: ne,
        setCellSelectableCss: function(kt, $t) {
          return K($t ? kt : null);
        },
        setBodyViewportWidth: function(kt) {
          le.current && (le.current.style.width = kt);
        },
        registerBodyViewportResizeListener: function(kt) {
          if (le.current) {
            var $t = r.observeResize(le.current, kt);
            X.current.push(function() {
              return $t();
            });
          }
        }
      }, Et = t.createBean(new un.GridBodyCtrl());
      de.current.push(Et), Et.setComp(lt, ae.current, le.current, oe.current, Ee.current, ve.current);
    }
  }, []), Le = It.useMemo(function() {
    return kd.classesList("ag-root", "ag-unselectable", ue);
  }, [ue]), Ue = It.useMemo(function() {
    return kd.classesList("ag-body-viewport", i, ue, q, pe);
  }, [i, ue, q, pe]), He = It.useMemo(function() {
    return kd.classesList("ag-body", ue);
  }, [ue]), et = It.useMemo(function() {
    return kd.classesList("ag-floating-top", pe);
  }, [pe]), $e = It.useMemo(function() {
    return kd.classesList("ag-sticky-top", pe);
  }, [pe]), pt = It.useMemo(function() {
    return kd.classesList("ag-floating-bottom", pe);
  }, [pe]), st = It.useMemo(function() {
    return {
      height: l,
      minHeight: l,
      display: F,
      overflowY: ie
    };
  }, [l, F, ie]), Bt = It.useMemo(function() {
    return {
      height: g,
      top: S,
      width: D
    };
  }, [g, S, D]), vt = It.useMemo(function() {
    return {
      height: d,
      minHeight: d,
      display: j,
      overflowY: ie
    };
  }, [d, j, ie]), nt = function(Ct) {
    return It.default.createElement(Lre.default, { name: Ct, key: Ct + "-container" });
  }, ze = function(Ct) {
    var Mt = Ct.section, fr = Ct.children, lt = Ct.className, Et = Ct.style;
    return It.default.createElement("div", { ref: Mt, className: lt, role: "presentation", style: Et }, fr.map(nt));
  };
  return It.default.createElement(
    "div",
    { ref: xe, className: Le, role: "treegrid" },
    It.default.createElement(Ire.default, null),
    ze({ section: oe, className: et, style: st, children: [
      un.RowContainerName.TOP_LEFT,
      un.RowContainerName.TOP_CENTER,
      un.RowContainerName.TOP_RIGHT,
      un.RowContainerName.TOP_FULL_WIDTH
    ] }),
    It.default.createElement("div", { className: He, ref: _e, role: "presentation" }, ze({
      section: le,
      className: Ue,
      children: [
        un.RowContainerName.LEFT,
        un.RowContainerName.CENTER,
        un.RowContainerName.RIGHT,
        un.RowContainerName.FULL_WIDTH
      ]
    })),
    ze({ section: ve, className: $e, style: Bt, children: [
      un.RowContainerName.STICKY_TOP_LEFT,
      un.RowContainerName.STICKY_TOP_CENTER,
      un.RowContainerName.STICKY_TOP_RIGHT,
      un.RowContainerName.STICKY_TOP_FULL_WIDTH
    ] }),
    ze({ section: Ee, className: pt, style: vt, children: [
      un.RowContainerName.BOTTOM_LEFT,
      un.RowContainerName.BOTTOM_CENTER,
      un.RowContainerName.BOTTOM_RIGHT,
      un.RowContainerName.BOTTOM_FULL_WIDTH
    ] })
  );
};
R_.default = It.memo(Nre);
var V_ = {}, kre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), Gre = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), Vre = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && kre(t, o, e);
  return Gre(t, o), t;
};
Object.defineProperty(V_, "__esModule", { value: !0 });
var Qo = Vre(y), cm = Mn, Hre = Fn, Bre = function(o, t) {
  var e = o.children, r = o.eFocusableElement, n = o.onTabKeyDown, i = o.gridCtrl, a = Qo.useContext(Hre.BeansContext).context, s = Qo.useRef(null), l = Qo.useRef(null), u = Qo.useRef(), c = function(m) {
    var b = m == null ? void 0 : parseInt(m, 10).toString();
    [s, l].forEach(function(S) {
      var R, P;
      b === void 0 ? (R = S.current) === null || R === void 0 || R.removeAttribute("tabindex") : (P = S.current) === null || P === void 0 || P.setAttribute("tabindex", b);
    });
  };
  Qo.useImperativeHandle(t, function() {
    return {
      forceFocusOutOfContainer: function() {
        var m;
        (m = u.current) === null || m === void 0 || m.forceFocusOutOfContainer();
      }
    };
  });
  var d = Qo.useCallback(function() {
    if (!s.current && !l.current) {
      a.destroyBean(u.current), u.current = null;
      return;
    }
    if (s.current && l.current) {
      var m = {
        setTabIndex: c
      };
      u.current = a.createBean(new cm.TabGuardCtrl({
        comp: m,
        eTopGuard: s.current,
        eBottomGuard: l.current,
        eFocusableElement: r,
        onTabKeyDown: n,
        focusInnerElement: function(b) {
          return i.focusInnerElement(b);
        }
      }));
    }
  }, []), f = Qo.useCallback(function(m) {
    s.current = m, d();
  }, [d]), v = Qo.useCallback(function(m) {
    l.current = m, d();
  }, [d]), g = function(m) {
    var b = m === "top" ? cm.TabGuardClassNames.TAB_GUARD_TOP : cm.TabGuardClassNames.TAB_GUARD_BOTTOM;
    return Qo.default.createElement("div", { className: cm.TabGuardClassNames.TAB_GUARD + " " + b, role: "presentation", ref: m === "top" ? f : v });
  };
  return Qo.default.createElement(
    Qo.default.Fragment,
    null,
    g("top"),
    e,
    g("bottom")
  );
}, Wre = Qo.forwardRef(Bre);
V_.default = Qo.memo(Wre);
var jre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), Ure = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), $re = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && jre(t, o, e);
  return Ure(t, o), t;
}, H_ = ce && ce.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(x_, "__esModule", { value: !0 });
var zre = Mn, Pr = $re(y), Yre = Fn, Kre = H_(R_), qre = H_(yv), Xre = H_(V_), $P = zr, Zre = function(o) {
  var t = o.context, e = Pr.useState(""), r = e[0], n = e[1], i = Pr.useState(""), a = i[0];
  i[1];
  var s = Pr.useState(""), l = s[0], u = s[1], c = Pr.useState(null), d = c[0], f = c[1], v = Pr.useState(null), g = v[0], m = v[1], b = Pr.useState(!1), S = b[0], R = b[1], P = Pr.useState(), D = P[0], x = P[1], M = Pr.useRef(null), F = Pr.useRef(null), H = Pr.useRef(), B = Pr.useState(null), j = B[0], V = B[1], W = Pr.useRef(function() {
  }), q = Pr.useCallback(function() {
  }, []), ee = Pr.useMemo(function() {
    return t.isDestroyed() ? null : t.getBean("beans");
  }, [t]);
  qre.default(" AG Grid ", F);
  var re = Pr.useCallback(function(K) {
    if (F.current = K, !F.current) {
      t.destroyBean(M.current), M.current = null;
      return;
    }
    if (!t.isDestroyed()) {
      M.current = t.createBean(new zre.GridCtrl());
      var J = M.current;
      W.current = J.focusInnerElement.bind(J);
      var ue = {
        destroyGridUi: function() {
        },
        setRtlClass: n,
        forceFocusOutOfContainer: function() {
          var he;
          (he = H.current) === null || he === void 0 || he.forceFocusOutOfContainer();
        },
        updateLayoutClasses: u,
        getFocusableContainers: function() {
          var he, fe, ae = [], oe = (he = F.current) === null || he === void 0 ? void 0 : he.querySelector(".ag-root"), ve = (fe = F.current) === null || fe === void 0 ? void 0 : fe.querySelector(".ag-side-bar:not(.ag-hidden)");
          return oe && ae.push(oe), ve && ae.push(ve), ae;
        },
        setCursor: f,
        setUserSelect: m
      };
      J.setComp(ue, F.current, F.current), R(!0);
    }
  }, []);
  Pr.useEffect(function() {
    if (!(!D || !ee || !M.current || !j || !F.current)) {
      var K = M.current, J = [], ue = ee.agStackComponentsRegistry, he = ue.getComponentClass("AG-GRID-HEADER-DROP-ZONES"), fe = ue.getComponentClass("AG-SIDE-BAR"), ae = ue.getComponentClass("AG-STATUS-BAR"), oe = ue.getComponentClass("AG-WATERMARK"), ve = ue.getComponentClass("AG-PAGINATION"), _e = [], le = F.current;
      if (K.showDropZones() && he) {
        var Ee = t.createBean(new he()), de = Ee.getGui();
        le.insertAdjacentElement("afterbegin", de), _e.push(de), J.push(Ee);
      }
      if (K.showSideBar() && fe) {
        var X = t.createBean(new fe()), de = X.getGui(), xe = j.querySelector(".ag-tab-guard-bottom");
        xe && (xe.insertAdjacentElement("beforebegin", de), _e.push(de)), J.push(X);
      }
      if (K.showStatusBar() && ae) {
        var Le = t.createBean(new ae()), de = Le.getGui();
        le.insertAdjacentElement("beforeend", de), _e.push(de), J.push(Le);
      }
      if (ve) {
        var Ue = t.createBean(new ve()), de = Ue.getGui();
        le.insertAdjacentElement("beforeend", de), _e.push(de), J.push(Ue);
      }
      if (K.showWatermark() && oe) {
        var He = t.createBean(new oe()), de = He.getGui();
        le.insertAdjacentElement("beforeend", de), _e.push(de), J.push(He);
      }
      return function() {
        t.destroyBeans(J), _e.forEach(function(et) {
          et.parentElement && et.parentElement.removeChild(et);
        });
      };
    }
  }, [D, j, ee]);
  var ie = Pr.useMemo(function() {
    return $P.classesList("ag-root-wrapper", r, a, l);
  }, [r, a, l]), ne = Pr.useMemo(function() {
    return $P.classesList("ag-root-wrapper-body", "ag-focus-managed", l);
  }, [l]), se = Pr.useMemo(function() {
    return {
      userSelect: g ?? "",
      WebkitUserSelect: g ?? "",
      cursor: d ?? ""
    };
  }, [g, d]), pe = Pr.useCallback(function(K) {
    H.current = K, x(K !== null);
  }, []);
  return Pr.default.createElement(
    "div",
    { ref: re, className: ie, style: se, role: "presentation" },
    Pr.default.createElement("div", { className: ne, ref: V, role: "presentation" }, S && j && ee && Pr.default.createElement(
      Yre.BeansContext.Provider,
      { value: ee },
      Pr.default.createElement(
        Xre.default,
        { ref: pe, eFocusableElement: j, onTabKeyDown: q, gridCtrl: M.current },
        // we wait for initialised before rending the children, so GridComp has created and registered with it's
        // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
        // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
        // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
        // hangs the UI)
        Pr.default.createElement(Kre.default, null)
      )
    ))
  );
};
x_.default = Pr.memo(Zre);
(function(o) {
  var t = ce && ce.__extends || /* @__PURE__ */ function() {
    var V = function(W, q) {
      return V = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ee, re) {
        ee.__proto__ = re;
      } || function(ee, re) {
        for (var ie in re) Object.prototype.hasOwnProperty.call(re, ie) && (ee[ie] = re[ie]);
      }, V(W, q);
    };
    return function(W, q) {
      if (typeof q != "function" && q !== null)
        throw new TypeError("Class extends value " + String(q) + " is not a constructor or null");
      V(W, q);
      function ee() {
        this.constructor = W;
      }
      W.prototype = q === null ? Object.create(q) : (ee.prototype = q.prototype, new ee());
    };
  }(), e = ce && ce.__assign || function() {
    return e = Object.assign || function(V) {
      for (var W, q = 1, ee = arguments.length; q < ee; q++) {
        W = arguments[q];
        for (var re in W) Object.prototype.hasOwnProperty.call(W, re) && (V[re] = W[re]);
      }
      return V;
    }, e.apply(this, arguments);
  }, r = ce && ce.__createBinding || (Object.create ? function(V, W, q, ee) {
    ee === void 0 && (ee = q), Object.defineProperty(V, ee, { enumerable: !0, get: function() {
      return W[q];
    } });
  } : function(V, W, q, ee) {
    ee === void 0 && (ee = q), V[ee] = W[q];
  }), n = ce && ce.__setModuleDefault || (Object.create ? function(V, W) {
    Object.defineProperty(V, "default", { enumerable: !0, value: W });
  } : function(V, W) {
    V.default = W;
  }), i = ce && ce.__importStar || function(V) {
    if (V && V.__esModule) return V;
    var W = {};
    if (V != null) for (var q in V) q !== "default" && Object.prototype.hasOwnProperty.call(V, q) && r(W, V, q);
    return n(W, V), W;
  }, a = ce && ce.__importDefault || function(V) {
    return V && V.__esModule ? V : { default: V };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.AgGridReactUi = void 0;
  var s = Mn, l = i(y), u = fC, c = hC, d = vC, f = gC, v = mC, g = yC, m = CC, b = mv, S = wC, R = Fn, P = zr, D = a(__), x = a(x_), M = function(V) {
    var W, q, ee = l.useRef(), re = l.useRef(null), ie = l.useRef(null), ne = l.useRef([]), se = l.useRef([]), pe = l.useRef(V), K = l.useRef(!1), J = l.useState(void 0), ue = J[0], he = J[1], fe = l.useState(0), ae = fe[1], oe = l.useCallback(function(le) {
      if (re.current = le, !re.current) {
        ne.current.forEach(function(He) {
          return He();
        }), ne.current.length = 0;
        return;
      }
      var Ee = V.modules || [];
      ie.current || (ie.current = new S.PortalManager(function() {
        return ae(function(He) {
          return He + 1;
        });
      }, V.componentWrappingElement, V.maxComponentCreationTimeMs), ne.current.push(function() {
        var He;
        (He = ie.current) === null || He === void 0 || He.destroy(), ie.current = null;
      }));
      var de = s.ComponentUtil.combineAttributesAndGridOptions(V.gridOptions, V), X = {
        providedBeanInstances: {
          frameworkComponentWrapper: new H(ie.current, !!de.reactiveCustomComponents)
        },
        modules: Ee,
        frameworkOverrides: new j()
      }, xe = function(He) {
        he(He), ne.current.push(function() {
          He.destroy();
        });
        var et = He.getBean(s.CtrlsService.NAME);
        et.whenReady(function() {
          if (!He.isDestroyed()) {
            var $e = ee.current;
            $e && V.setGridApi && V.setGridApi($e, new s.ColumnApi($e));
          }
        });
      }, Le = function(He) {
        var et = He.getBean(s.CtrlsService.NAME);
        et.whenReady(function() {
          se.current.forEach(function($e) {
            return $e();
          }), se.current.length = 0, K.current = !0;
        });
      }, Ue = new s.GridCoreCreator();
      ee.current = Ue.create(re.current, de, xe, Le, X);
    }, []), ve = l.useMemo(function() {
      return e({ height: "100%" }, V.containerStyle || {});
    }, [V.containerStyle]), _e = l.useCallback(function(le) {
      K.current ? le() : se.current.push(le);
    }, []);
    return l.useEffect(function() {
      var le = F(pe.current, V);
      pe.current = V, _e(function() {
        ee.current && s.ComponentUtil.processOnChange(le, ee.current);
      });
    }, [V]), l.default.createElement(
      "div",
      { style: ve, className: V.className, ref: oe },
      ue && !ue.isDestroyed() ? l.default.createElement(x.default, { context: ue }) : null,
      (q = (W = ie.current) === null || W === void 0 ? void 0 : W.getPortals()) !== null && q !== void 0 ? q : null
    );
  };
  o.AgGridReactUi = M;
  function F(V, W) {
    var q = {};
    return Object.keys(W).forEach(function(ee) {
      var re = W[ee];
      V[ee] !== re && (q[ee] = re);
    }), q;
  }
  var H = (
    /** @class */
    function(V) {
      t(W, V);
      function W(q, ee) {
        var re = V.call(this) || this;
        return re.parent = q, re.reactiveCustomComponents = ee, re;
      }
      return W.prototype.createWrapper = function(q, ee) {
        if (this.reactiveCustomComponents) {
          var re = function(se) {
            switch (se) {
              case "filter":
                return c.FilterComponentWrapper;
              case "floatingFilterComponent":
                return d.FloatingFilterComponentWrapper;
              case "dateComponent":
                return u.DateComponentWrapper;
              case "loadingOverlayComponent":
                return f.LoadingOverlayComponentWrapper;
              case "noRowsOverlayComponent":
                return v.NoRowsOverlayComponentWrapper;
              case "statusPanel":
                return g.StatusPanelComponentWrapper;
              case "toolPanel":
                return m.ToolPanelComponentWrapper;
            }
          }, ie = re(ee.propertyName);
          if (ie)
            return new ie(q, this.parent, ee);
        }
        var ne = !ee.cellRenderer && ee.propertyName !== "toolPanel";
        return new b.ReactComponent(q, this.parent, ee, ne);
      }, W;
    }(s.BaseComponentWrapper)
  ), B = l.forwardRef(function(V, W) {
    var q = l.useContext(R.BeansContext), ee = q.ctrlsFactory, re = q.context, ie = q.gridOptionsService, ne = q.resizeObserverService, se = q.clientSideRowModel, pe = q.serverSideRowModel, K = l.useState(function() {
      return new P.CssClasses();
    }), J = K[0], ue = K[1], he = l.useState(function() {
      return new P.CssClasses();
    }), fe = he[0], ae = he[1], oe = l.useState(), ve = oe[0], _e = oe[1], le = l.useState(), Ee = le[0], de = le[1], X = l.useRef(), xe = l.useRef(null), Le = l.useRef(), Ue = l.useMemo(function() {
      return s.ModuleRegistry.__getGridRegisteredModules(V.api.getGridId());
    }, [V]), He = l.useMemo(function() {
      return J.toString() + " ag-details-row";
    }, [J]), et = l.useMemo(function() {
      return fe.toString() + " ag-details-grid";
    }, [fe]);
    W && l.useImperativeHandle(W, function() {
      return {
        refresh: function() {
          var st, Bt;
          return (Bt = (st = X.current) === null || st === void 0 ? void 0 : st.refresh()) !== null && Bt !== void 0 ? Bt : !1;
        }
      };
    }), V.template && s._.warnOnce("detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://ag-grid.com/react-data-grid/master-detail-custom-detail/");
    var $e = l.useCallback(function(st) {
      if (xe.current = st, !xe.current) {
        re.destroyBean(X.current), Le.current && Le.current();
        return;
      }
      var Bt = {
        addOrRemoveCssClass: function(ze, Ct) {
          return ue(function(Mt) {
            return Mt.setClass(ze, Ct);
          });
        },
        addOrRemoveDetailGridCssClass: function(ze, Ct) {
          return ae(function(Mt) {
            return Mt.setClass(ze, Ct);
          });
        },
        setDetailGrid: function(ze) {
          return _e(ze);
        },
        setRowData: function(ze) {
          return de(ze);
        },
        getGui: function() {
          return xe.current;
        }
      }, vt = ee.getInstance("detailCellRenderer");
      if (vt && (re.createBean(vt), vt.init(Bt, V), X.current = vt, ie.get("detailRowAutoHeight"))) {
        var nt = function() {
          if (xe.current != null) {
            var ze = xe.current.clientHeight;
            if (ze != null && ze > 0) {
              var Ct = function() {
                V.node.setRowHeight(ze), se ? se.onRowHeightChanged() : pe && pe.onRowHeightChanged();
              };
              setTimeout(Ct, 0);
            }
          }
        };
        Le.current = ne.observeResize(xe.current, nt), nt();
      }
    }, []), pt = l.useCallback(function(st, Bt) {
      var vt;
      (vt = X.current) === null || vt === void 0 || vt.registerDetailWithMaster(st, Bt);
    }, []);
    return l.default.createElement("div", { className: He, ref: $e }, ve && l.default.createElement(o.AgGridReactUi, e({ className: et }, ve, { modules: Ue, rowData: Ee, setGridApi: pt })));
  }), j = (
    /** @class */
    function(V) {
      t(W, V);
      function W() {
        var q = V.call(this, "react") || this;
        return q.frameworkComponents = {
          agGroupCellRenderer: D.default,
          agGroupRowRenderer: D.default,
          agDetailCellRenderer: B
        }, q.renderingEngine = "react", q;
      }
      return W.prototype.frameworkComponent = function(q) {
        return this.frameworkComponents[q];
      }, W.prototype.isFrameworkComponent = function(q) {
        if (!q)
          return !1;
        var ee = q.prototype, re = ee && "getGui" in ee;
        return !re;
      }, W;
    }(s.VanillaFrameworkOverrides)
  );
})($F);
var Qre = ce && ce.__extends || /* @__PURE__ */ function() {
  var o = function(t, e) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, o(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    o(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), eE = ce && ce.__assign || function() {
  return eE = Object.assign || function(o) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, eE.apply(this, arguments);
}, Jre = ce && ce.__createBinding || (Object.create ? function(o, t, e, r) {
  r === void 0 && (r = e), Object.defineProperty(o, r, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(o, t, e, r) {
  r === void 0 && (r = e), o[r] = t[e];
}), ene = ce && ce.__setModuleDefault || (Object.create ? function(o, t) {
  Object.defineProperty(o, "default", { enumerable: !0, value: t });
} : function(o, t) {
  o.default = t;
}), tne = ce && ce.__importStar || function(o) {
  if (o && o.__esModule) return o;
  var t = {};
  if (o != null) for (var e in o) e !== "default" && Object.prototype.hasOwnProperty.call(o, e) && Jre(t, o, e);
  return ene(t, o), t;
};
Object.defineProperty(qy, "__esModule", { value: !0 });
qy.AgGridReact = void 0;
var zP = tne(y), rne = $F, nne = (
  /** @class */
  function(o) {
    Qre(t, o);
    function t() {
      var e = o !== null && o.apply(this, arguments) || this;
      return e.apiListeners = [], e.setGridApi = function(r, n) {
        e.api = r, e.columnApi = n, e.apiListeners.forEach(function(i) {
          return i(r);
        });
      }, e;
    }
    return t.prototype.registerApiListener = function(e) {
      this.apiListeners.push(e);
    }, t.prototype.componentWillUnmount = function() {
      this.apiListeners.length = 0;
    }, t.prototype.render = function() {
      return zP.default.createElement(rne.AgGridReactUi, eE({}, this.props, { setGridApi: this.setGridApi }));
    }, t;
  }(zP.Component)
);
qy.AgGridReact = nne;
var pN = {};
(function(o) {
  Object.defineProperty(o, "__esModule", { value: !0 }), o.ChangeDetectionStrategyType = void 0, function(t) {
    t.IdentityCheck = "IdentityCheck", t.DeepValueCheck = "DeepValueCheck", t.NoCheck = "NoCheck";
  }(o.ChangeDetectionStrategyType || (o.ChangeDetectionStrategyType = {}));
})(pN);
var Ma = {};
Object.defineProperty(Ma, "__esModule", { value: !0 });
Ma.useGridFloatingFilter = Ma.useGridFilter = Ma.useGridDate = Ma.useGridCellEditor = void 0;
var one = y, ine = _c;
function EC(o) {
  var t = one.useContext(ine.CustomContext).setMethods;
  t(o);
}
function ane(o) {
  EC(o);
}
Ma.useGridCellEditor = ane;
function sne(o) {
  return EC(o);
}
Ma.useGridDate = sne;
function lne(o) {
  return EC(o);
}
Ma.useGridFilter = lne;
function une(o) {
  EC(o);
}
Ma.useGridFloatingFilter = une;
var _C = {};
Object.defineProperty(_C, "__esModule", { value: !0 });
_C.getInstance = void 0;
var cne = Mn;
function dne(o, t) {
  var e, r, n, i = (n = (r = (e = o) === null || e === void 0 ? void 0 : e.getInstance) === null || r === void 0 ? void 0 : r.call(e)) !== null && n !== void 0 ? n : cne.AgPromise.resolve(void 0);
  i.then(function(a) {
    return t(a);
  });
}
_C.getInstance = dne;
(function(o) {
  var t = ce && ce.__createBinding || (Object.create ? function(n, i, a, s) {
    s === void 0 && (s = a), Object.defineProperty(n, s, { enumerable: !0, get: function() {
      return i[a];
    } });
  } : function(n, i, a, s) {
    s === void 0 && (s = a), n[s] = i[a];
  }), e = ce && ce.__exportStar || function(n, i) {
    for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, n, a);
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.AgGridReact = void 0;
  var r = qy;
  Object.defineProperty(o, "AgGridReact", { enumerable: !0, get: function() {
    return r.AgGridReact;
  } }), e(pN, o), e(Ma, o), e(_C, o);
})(AU);
function fN(o, [t, e]) {
  return Math.min(e, Math.max(t, o));
}
function zd(o, t, { checkForDefaultPrevented: e = !0 } = {}) {
  return function(n) {
    if (o == null || o(n), e === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
function YP(o, t) {
  if (typeof o == "function")
    return o(t);
  o != null && (o.current = t);
}
function hN(...o) {
  return (t) => {
    let e = !1;
    const r = o.map((n) => {
      const i = YP(n, t);
      return !e && typeof i == "function" && (e = !0), i;
    });
    if (e)
      return () => {
        for (let n = 0; n < r.length; n++) {
          const i = r[n];
          typeof i == "function" ? i() : YP(o[n], null);
        }
      };
  };
}
function bc(...o) {
  return z.useCallback(hN(...o), o);
}
function vN(o, t = []) {
  let e = [];
  function r(i, a) {
    const s = z.createContext(a), l = e.length;
    e = [...e, a];
    const u = (d) => {
      var S;
      const { scope: f, children: v, ...g } = d, m = ((S = f == null ? void 0 : f[o]) == null ? void 0 : S[l]) || s, b = z.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ Dr.jsx(m.Provider, { value: b, children: v });
    };
    u.displayName = i + "Provider";
    function c(d, f) {
      var m;
      const v = ((m = f == null ? void 0 : f[o]) == null ? void 0 : m[l]) || s, g = z.useContext(v);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [u, c];
  }
  const n = () => {
    const i = e.map((a) => z.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[o]) || i;
      return z.useMemo(
        () => ({ [`__scope${o}`]: { ...s, [o]: l } }),
        [s, l]
      );
    };
  };
  return n.scopeName = o, [r, pne(n, ...t)];
}
function pne(...o) {
  const t = o[0];
  if (o.length === 1) return t;
  const e = () => {
    const r = o.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const d = l(i)[`__scope${u}`];
        return { ...s, ...d };
      }, {});
      return z.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return e.scopeName = t.scopeName, e;
}
function gN(o) {
  const t = z.useRef(o);
  return z.useEffect(() => {
    t.current = o;
  }), z.useMemo(() => (...e) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...e);
  }, []);
}
function fne({
  prop: o,
  defaultProp: t,
  onChange: e = () => {
  }
}) {
  const [r, n] = hne({ defaultProp: t, onChange: e }), i = o !== void 0, a = i ? o : r, s = gN(e), l = z.useCallback(
    (u) => {
      if (i) {
        const d = typeof u == "function" ? u(o) : u;
        d !== o && s(d);
      } else
        n(u);
    },
    [i, o, n, s]
  );
  return [a, l];
}
function hne({
  defaultProp: o,
  onChange: t
}) {
  const e = z.useState(o), [r] = e, n = z.useRef(r), i = gN(t);
  return z.useEffect(() => {
    n.current !== r && (i(r), n.current = r);
  }, [r, n, i]), e;
}
var vne = z.createContext(void 0);
function gne(o) {
  const t = z.useContext(vne);
  return o || t || "ltr";
}
function mne(o) {
  const t = z.useRef({ value: o, previous: o });
  return z.useMemo(() => (t.current.value !== o && (t.current.previous = t.current.value, t.current.value = o), t.current.previous), [o]);
}
var yne = globalThis != null && globalThis.document ? z.useLayoutEffect : () => {
};
function Cne(o) {
  const [t, e] = z.useState(void 0);
  return yne(() => {
    if (o) {
      e({ width: o.offsetWidth, height: o.offsetHeight });
      const r = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const i = n[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = o.offsetWidth, s = o.offsetHeight;
        e({ width: a, height: s });
      });
      return r.observe(o, { box: "border-box" }), () => r.unobserve(o);
    } else
      e(void 0);
  }, [o]), t;
}
var xy = z.forwardRef((o, t) => {
  const { children: e, ...r } = o, n = z.Children.toArray(e), i = n.find(bne);
  if (i) {
    const a = i.props.children, s = n.map((l) => l === i ? z.Children.count(a) > 1 ? z.Children.only(null) : z.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ Dr.jsx(tE, { ...r, ref: t, children: z.isValidElement(a) ? z.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ Dr.jsx(tE, { ...r, ref: t, children: e });
});
xy.displayName = "Slot";
var tE = z.forwardRef((o, t) => {
  const { children: e, ...r } = o;
  if (z.isValidElement(e)) {
    const n = Ene(e);
    return z.cloneElement(e, {
      ...Sne(r, e.props),
      // @ts-ignore
      ref: t ? hN(t, n) : n
    });
  }
  return z.Children.count(e) > 1 ? z.Children.only(null) : null;
});
tE.displayName = "SlotClone";
var wne = ({ children: o }) => /* @__PURE__ */ Dr.jsx(Dr.Fragment, { children: o });
function bne(o) {
  return z.isValidElement(o) && o.type === wne;
}
function Sne(o, t) {
  const e = { ...t };
  for (const r in t) {
    const n = o[r], i = t[r];
    /^on[A-Z]/.test(r) ? n && i ? e[r] = (...s) => {
      i(...s), n(...s);
    } : n && (e[r] = n) : r === "style" ? e[r] = { ...n, ...i } : r === "className" && (e[r] = [n, i].filter(Boolean).join(" "));
  }
  return { ...o, ...e };
}
function Ene(o) {
  var r, n;
  let t = (r = Object.getOwnPropertyDescriptor(o.props, "ref")) == null ? void 0 : r.get, e = t && "isReactWarning" in t && t.isReactWarning;
  return e ? o.ref : (t = (n = Object.getOwnPropertyDescriptor(o, "ref")) == null ? void 0 : n.get, e = t && "isReactWarning" in t && t.isReactWarning, e ? o.props.ref : o.props.ref || o.ref);
}
var _ne = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xC = _ne.reduce((o, t) => {
  const e = z.forwardRef((r, n) => {
    const { asChild: i, ...a } = r, s = i ? xy : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ Dr.jsx(s, { ...a, ref: n });
  });
  return e.displayName = `Primitive.${t}`, { ...o, [t]: e };
}, {});
function xne(o) {
  const t = o + "CollectionProvider", [e, r] = vN(t), [n, i] = e(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (v) => {
    const { scope: g, children: m } = v, b = y.useRef(null), S = y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Dr.jsx(n, { scope: g, itemMap: S, collectionRef: b, children: m });
  };
  a.displayName = t;
  const s = o + "CollectionSlot", l = y.forwardRef(
    (v, g) => {
      const { scope: m, children: b } = v, S = i(s, m), R = bc(g, S.collectionRef);
      return /* @__PURE__ */ Dr.jsx(xy, { ref: R, children: b });
    }
  );
  l.displayName = s;
  const u = o + "CollectionItemSlot", c = "data-radix-collection-item", d = y.forwardRef(
    (v, g) => {
      const { scope: m, children: b, ...S } = v, R = y.useRef(null), P = bc(g, R), D = i(u, m);
      return y.useEffect(() => (D.itemMap.set(R, { ref: R, ...S }), () => void D.itemMap.delete(R))), /* @__PURE__ */ Dr.jsx(xy, { [c]: "", ref: P, children: b });
    }
  );
  d.displayName = u;
  function f(v) {
    const g = i(o + "CollectionConsumer", v);
    return y.useCallback(() => {
      const b = g.collectionRef.current;
      if (!b) return [];
      const S = Array.from(b.querySelectorAll(`[${c}]`));
      return Array.from(g.itemMap.values()).sort(
        (D, x) => S.indexOf(D.ref.current) - S.indexOf(x.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var mN = ["PageUp", "PageDown"], yN = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], CN = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, mp = "Slider", [rE, Rne, Tne] = xne(mp), [wN, sie] = vN(mp, [
  Tne
]), [One, RC] = wN(mp), bN = z.forwardRef(
  (o, t) => {
    const {
      name: e,
      min: r = 0,
      max: n = 100,
      step: i = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: u = [r],
      value: c,
      onValueChange: d = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: v = !1,
      form: g,
      ...m
    } = o, b = z.useRef(/* @__PURE__ */ new Set()), S = z.useRef(0), P = a === "horizontal" ? Pne : Dne, [D = [], x] = fne({
      prop: c,
      defaultProp: u,
      onChange: (V) => {
        var q;
        (q = [...b.current][S.current]) == null || q.focus(), d(V);
      }
    }), M = z.useRef(D);
    function F(V) {
      const W = Lne(D, V);
      j(V, W);
    }
    function H(V) {
      j(V, S.current);
    }
    function B() {
      const V = M.current[S.current];
      D[S.current] !== V && f(D);
    }
    function j(V, W, { commit: q } = { commit: !1 }) {
      const ee = Vne(i), re = Hne(Math.round((V - r) / i) * i + r, ee), ie = fN(re, [r, n]);
      x((ne = []) => {
        const se = Fne(ne, ie, W);
        if (Gne(se, l * i)) {
          S.current = se.indexOf(ie);
          const pe = String(se) !== String(ne);
          return pe && q && f(se), pe ? se : ne;
        } else
          return ne;
      });
    }
    return /* @__PURE__ */ Dr.jsx(
      One,
      {
        scope: o.__scopeSlider,
        name: e,
        disabled: s,
        min: r,
        max: n,
        valueIndexToChangeRef: S,
        thumbs: b.current,
        values: D,
        orientation: a,
        form: g,
        children: /* @__PURE__ */ Dr.jsx(rE.Provider, { scope: o.__scopeSlider, children: /* @__PURE__ */ Dr.jsx(rE.Slot, { scope: o.__scopeSlider, children: /* @__PURE__ */ Dr.jsx(
          P,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...m,
            ref: t,
            onPointerDown: zd(m.onPointerDown, () => {
              s || (M.current = D);
            }),
            min: r,
            max: n,
            inverted: v,
            onSlideStart: s ? void 0 : F,
            onSlideMove: s ? void 0 : H,
            onSlideEnd: s ? void 0 : B,
            onHomeKeyDown: () => !s && j(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && j(n, D.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: V, direction: W }) => {
              if (!s) {
                const re = mN.includes(V.key) || V.shiftKey && yN.includes(V.key) ? 10 : 1, ie = S.current, ne = D[ie], se = i * re * W;
                j(ne + se, ie, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
bN.displayName = mp;
var [SN, EN] = wN(mp, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Pne = z.forwardRef(
  (o, t) => {
    const {
      min: e,
      max: r,
      dir: n,
      inverted: i,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: u,
      ...c
    } = o, [d, f] = z.useState(null), v = bc(t, (P) => f(P)), g = z.useRef(void 0), m = gne(n), b = m === "ltr", S = b && !i || !b && i;
    function R(P) {
      const D = g.current || d.getBoundingClientRect(), x = [0, D.width], F = B_(x, S ? [e, r] : [r, e]);
      return g.current = D, F(P - D.left);
    }
    return /* @__PURE__ */ Dr.jsx(
      SN,
      {
        scope: o.__scopeSlider,
        startEdge: S ? "left" : "right",
        endEdge: S ? "right" : "left",
        direction: S ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ Dr.jsx(
          _N,
          {
            dir: m,
            "data-orientation": "horizontal",
            ...c,
            ref: v,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (P) => {
              const D = R(P.clientX);
              a == null || a(D);
            },
            onSlideMove: (P) => {
              const D = R(P.clientX);
              s == null || s(D);
            },
            onSlideEnd: () => {
              g.current = void 0, l == null || l();
            },
            onStepKeyDown: (P) => {
              const x = CN[S ? "from-left" : "from-right"].includes(P.key);
              u == null || u({ event: P, direction: x ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Dne = z.forwardRef(
  (o, t) => {
    const {
      min: e,
      max: r,
      inverted: n,
      onSlideStart: i,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...u
    } = o, c = z.useRef(null), d = bc(t, c), f = z.useRef(void 0), v = !n;
    function g(m) {
      const b = f.current || c.current.getBoundingClientRect(), S = [0, b.height], P = B_(S, v ? [r, e] : [e, r]);
      return f.current = b, P(m - b.top);
    }
    return /* @__PURE__ */ Dr.jsx(
      SN,
      {
        scope: o.__scopeSlider,
        startEdge: v ? "bottom" : "top",
        endEdge: v ? "top" : "bottom",
        size: "height",
        direction: v ? 1 : -1,
        children: /* @__PURE__ */ Dr.jsx(
          _N,
          {
            "data-orientation": "vertical",
            ...u,
            ref: d,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (m) => {
              const b = g(m.clientY);
              i == null || i(b);
            },
            onSlideMove: (m) => {
              const b = g(m.clientY);
              a == null || a(b);
            },
            onSlideEnd: () => {
              f.current = void 0, s == null || s();
            },
            onStepKeyDown: (m) => {
              const S = CN[v ? "from-bottom" : "from-top"].includes(m.key);
              l == null || l({ event: m, direction: S ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), _N = z.forwardRef(
  (o, t) => {
    const {
      __scopeSlider: e,
      onSlideStart: r,
      onSlideMove: n,
      onSlideEnd: i,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...u
    } = o, c = RC(mp, e);
    return /* @__PURE__ */ Dr.jsx(
      xC.span,
      {
        ...u,
        ref: t,
        onKeyDown: zd(o.onKeyDown, (d) => {
          d.key === "Home" ? (a(d), d.preventDefault()) : d.key === "End" ? (s(d), d.preventDefault()) : mN.concat(yN).includes(d.key) && (l(d), d.preventDefault());
        }),
        onPointerDown: zd(o.onPointerDown, (d) => {
          const f = d.target;
          f.setPointerCapture(d.pointerId), d.preventDefault(), c.thumbs.has(f) ? f.focus() : r(d);
        }),
        onPointerMove: zd(o.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && n(d);
        }),
        onPointerUp: zd(o.onPointerUp, (d) => {
          const f = d.target;
          f.hasPointerCapture(d.pointerId) && (f.releasePointerCapture(d.pointerId), i(d));
        })
      }
    );
  }
), xN = "SliderTrack", RN = z.forwardRef(
  (o, t) => {
    const { __scopeSlider: e, ...r } = o, n = RC(xN, e);
    return /* @__PURE__ */ Dr.jsx(
      xC.span,
      {
        "data-disabled": n.disabled ? "" : void 0,
        "data-orientation": n.orientation,
        ...r,
        ref: t
      }
    );
  }
);
RN.displayName = xN;
var nE = "SliderRange", TN = z.forwardRef(
  (o, t) => {
    const { __scopeSlider: e, ...r } = o, n = RC(nE, e), i = EN(nE, e), a = z.useRef(null), s = bc(t, a), l = n.values.length, u = n.values.map(
      (f) => PN(f, n.min, n.max)
    ), c = l > 1 ? Math.min(...u) : 0, d = 100 - Math.max(...u);
    return /* @__PURE__ */ Dr.jsx(
      xC.span,
      {
        "data-orientation": n.orientation,
        "data-disabled": n.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...o.style,
          [i.startEdge]: c + "%",
          [i.endEdge]: d + "%"
        }
      }
    );
  }
);
TN.displayName = nE;
var oE = "SliderThumb", ON = z.forwardRef(
  (o, t) => {
    const e = Rne(o.__scopeSlider), [r, n] = z.useState(null), i = bc(t, (s) => n(s)), a = z.useMemo(
      () => r ? e().findIndex((s) => s.ref.current === r) : -1,
      [e, r]
    );
    return /* @__PURE__ */ Dr.jsx(Ane, { ...o, ref: i, index: a });
  }
), Ane = z.forwardRef(
  (o, t) => {
    const { __scopeSlider: e, index: r, name: n, ...i } = o, a = RC(oE, e), s = EN(oE, e), [l, u] = z.useState(null), c = bc(t, (R) => u(R)), d = l ? a.form || !!l.closest("form") : !0, f = Cne(l), v = a.values[r], g = v === void 0 ? 0 : PN(v, a.min, a.max), m = Ine(r, a.values.length), b = f == null ? void 0 : f[s.size], S = b ? Nne(b, g, s.direction) : 0;
    return z.useEffect(() => {
      if (l)
        return a.thumbs.add(l), () => {
          a.thumbs.delete(l);
        };
    }, [l, a.thumbs]), /* @__PURE__ */ Dr.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${g}% + ${S}px)`
        },
        children: [
          /* @__PURE__ */ Dr.jsx(rE.ItemSlot, { scope: o.__scopeSlider, children: /* @__PURE__ */ Dr.jsx(
            xC.span,
            {
              role: "slider",
              "aria-label": o["aria-label"] || m,
              "aria-valuemin": a.min,
              "aria-valuenow": v,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...i,
              ref: c,
              style: v === void 0 ? { display: "none" } : o.style,
              onFocus: zd(o.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ Dr.jsx(
            Mne,
            {
              name: n ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              form: a.form,
              value: v
            },
            r
          )
        ]
      }
    );
  }
);
ON.displayName = oE;
var Mne = (o) => {
  const { value: t, ...e } = o, r = z.useRef(null), n = mne(t);
  return z.useEffect(() => {
    const i = r.current, a = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(a, "value").set;
    if (n !== t && l) {
      const u = new Event("input", { bubbles: !0 });
      l.call(i, t), i.dispatchEvent(u);
    }
  }, [n, t]), /* @__PURE__ */ Dr.jsx("input", { style: { display: "none" }, ...e, ref: r, defaultValue: t });
};
function Fne(o = [], t, e) {
  const r = [...o];
  return r[e] = t, r.sort((n, i) => n - i);
}
function PN(o, t, e) {
  const i = 100 / (e - t) * (o - t);
  return fN(i, [0, 100]);
}
function Ine(o, t) {
  return t > 2 ? `Value ${o + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][o] : void 0;
}
function Lne(o, t) {
  if (o.length === 1) return 0;
  const e = o.map((n) => Math.abs(n - t)), r = Math.min(...e);
  return e.indexOf(r);
}
function Nne(o, t, e) {
  const r = o / 2, i = B_([0, 50], [0, r]);
  return (r - i(t) * e) * e;
}
function kne(o) {
  return o.slice(0, -1).map((t, e) => o[e + 1] - t);
}
function Gne(o, t) {
  if (t > 0) {
    const e = kne(o);
    return Math.min(...e) >= t;
  }
  return !0;
}
function B_(o, t) {
  return (e) => {
    if (o[0] === o[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (o[1] - o[0]);
    return t[0] + r * (e - o[0]);
  };
}
function Vne(o) {
  return (String(o).split(".")[1] || "").length;
}
function Hne(o, t) {
  const e = Math.pow(10, t);
  return Math.round(o * e) / e;
}
var DN = bN, Bne = RN, Wne = TN, jne = ON;
const AN = ({ type: o = "submit", size: t = "lg", ...e }) => {
  const r = { onClick: e.onClick };
  let n = "", i = "";
  t == "sm" ? (n = "h-11 text-size-base", i = "initial:text-size-12") : t == "lg" && (n = "h-14 text-size-18", i = "initial:text-size-base");
  let a = `rounded-5 px-8 py-2 font-opensans font-semibold  ${n}`;
  a = e.fullwidth ? `${a} w-full` : `${a}`, a = e.customClass ? `${a} ${e.customClass}` : a;
  let s = `${a} bg-primary hover:bg-primary-110 text-white dark:bg-primary-dark dark:hover:bg-primary-110`, l = `${a} bg-neutral-0 hover:bg-neutral-5 border
  border-solid border-primary hover:border-primary-110
  text-primary hover:text-primary-110 dark:border-primary-dark dark:hover:border-primary-110 dark:text-primary-dark dark:hover:text-primary-110 dark:bg-neutral-dark-0 dark:hover:bg-neutral-dark-0`, u = `${a} text-neutral-40 bg-neutral-20 hover:bg-neutral-20
  cursor-not-allowed dark:bg-neutral-dark-20 dark:text-neutral-dark-40`, c = `text-link-color hover:text-link-color-dark hover:underline  dark:text-link-color dark:hover:text-link-color-dark ${i}`;
  c = e.disabled ? "text-neutral-40 cursor-not-allowed  dark:text-neutral-dark-40 filter grayscale" : `${c}`, c = e.customClass ? `${c} ${e.customClass}` : c;
  let f = `text-success hover:text-success hover:underline ${i}`, v = `text-error hover:text-error hover:underline ${i}`;
  f = e.customClass ? `${f} ${e.customClass}` : f, v = e.customClass ? `${v} ${e.customClass}` : v;
  let g = "";
  e.status === "success" ? g = f : e.status === "error" ? g = v : g = c;
  const m = {
    primary: () => y.createElement("button", { type: o, className: s, ...r }, e.children),
    secondary: () => y.createElement("button", { type: o, className: l, ...r }, e.children),
    disabled: () => y.createElement("button", { type: o, className: u, disabled: !0 }, e.children),
    text: () => y.createElement("button", { type: o, className: g, disabled: e.disabled, ...r }, e.children)
  };
  return m[e.variant || "primary"]();
};
function MN(o) {
  var t, e, r = "";
  if (typeof o == "string" || typeof o == "number") r += o;
  else if (typeof o == "object") if (Array.isArray(o)) {
    var n = o.length;
    for (t = 0; t < n; t++) o[t] && (e = MN(o[t])) && (r && (r += " "), r += e);
  } else for (e in o) o[e] && (r && (r += " "), r += e);
  return r;
}
function Une() {
  for (var o, t, e = 0, r = "", n = arguments.length; e < n; e++) (o = arguments[e]) && (t = MN(o)) && (r && (r += " "), r += t);
  return r;
}
const W_ = "-", $ne = (o) => {
  const t = Yne(o), {
    conflictingClassGroups: e,
    conflictingClassGroupModifiers: r
  } = o;
  return {
    getClassGroupId: (a) => {
      const s = a.split(W_);
      return s[0] === "" && s.length !== 1 && s.shift(), FN(s, t) || zne(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = e[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, FN = (o, t) => {
  var a;
  if (o.length === 0)
    return t.classGroupId;
  const e = o[0], r = t.nextPart.get(e), n = r ? FN(o.slice(1), r) : void 0;
  if (n)
    return n;
  if (t.validators.length === 0)
    return;
  const i = o.join(W_);
  return (a = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : a.classGroupId;
}, KP = /^\[(.+)\]$/, zne = (o) => {
  if (KP.test(o)) {
    const t = KP.exec(o)[1], e = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (e)
      return "arbitrary.." + e;
  }
}, Yne = (o) => {
  const {
    theme: t,
    prefix: e
  } = o, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return qne(Object.entries(o.classGroups), e).forEach(([i, a]) => {
    iE(a, r, i, t);
  }), r;
}, iE = (o, t, e, r) => {
  o.forEach((n) => {
    if (typeof n == "string") {
      const i = n === "" ? t : qP(t, n);
      i.classGroupId = e;
      return;
    }
    if (typeof n == "function") {
      if (Kne(n)) {
        iE(n(r), t, e, r);
        return;
      }
      t.validators.push({
        validator: n,
        classGroupId: e
      });
      return;
    }
    Object.entries(n).forEach(([i, a]) => {
      iE(a, qP(t, i), e, r);
    });
  });
}, qP = (o, t) => {
  let e = o;
  return t.split(W_).forEach((r) => {
    e.nextPart.has(r) || e.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), e = e.nextPart.get(r);
  }), e;
}, Kne = (o) => o.isThemeGetter, qne = (o, t) => t ? o.map(([e, r]) => {
  const n = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [t + a, s])) : i);
  return [e, n];
}) : o, Xne = (o) => {
  if (o < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const n = (i, a) => {
    e.set(i, a), t++, t > o && (t = 0, r = e, e = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = e.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return n(i, a), a;
    },
    set(i, a) {
      e.has(i) ? e.set(i, a) : n(i, a);
    }
  };
}, IN = "!", Zne = (o) => {
  const {
    separator: t,
    experimentalParseClassName: e
  } = o, r = t.length === 1, n = t[0], i = t.length, a = (s) => {
    const l = [];
    let u = 0, c = 0, d;
    for (let b = 0; b < s.length; b++) {
      let S = s[b];
      if (u === 0) {
        if (S === n && (r || s.slice(b, b + i) === t)) {
          l.push(s.slice(c, b)), c = b + i;
          continue;
        }
        if (S === "/") {
          d = b;
          continue;
        }
      }
      S === "[" ? u++ : S === "]" && u--;
    }
    const f = l.length === 0 ? s : s.substring(c), v = f.startsWith(IN), g = v ? f.substring(1) : f, m = d && d > c ? d - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: v,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return e ? (s) => e({
    className: s,
    parseClassName: a
  }) : a;
}, Qne = (o) => {
  if (o.length <= 1)
    return o;
  const t = [];
  let e = [];
  return o.forEach((r) => {
    r[0] === "[" ? (t.push(...e.sort(), r), e = []) : e.push(r);
  }), t.push(...e.sort()), t;
}, Jne = (o) => ({
  cache: Xne(o.cacheSize),
  parseClassName: Zne(o),
  ...$ne(o)
}), eoe = /\s+/, toe = (o, t) => {
  const {
    parseClassName: e,
    getClassGroupId: r,
    getConflictingClassGroupIds: n
  } = t, i = [], a = o.trim().split(eoe);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      modifiers: c,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: v
    } = e(u);
    let g = !!v, m = r(g ? f.substring(0, v) : f);
    if (!m) {
      if (!g) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(f), !m) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const b = Qne(c).join(":"), S = d ? b + IN : b, R = S + m;
    if (i.includes(R))
      continue;
    i.push(R);
    const P = n(m, g);
    for (let D = 0; D < P.length; ++D) {
      const x = P[D];
      i.push(S + x);
    }
    s = u + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function roe() {
  let o = 0, t, e, r = "";
  for (; o < arguments.length; )
    (t = arguments[o++]) && (e = LN(t)) && (r && (r += " "), r += e);
  return r;
}
const LN = (o) => {
  if (typeof o == "string")
    return o;
  let t, e = "";
  for (let r = 0; r < o.length; r++)
    o[r] && (t = LN(o[r])) && (e && (e += " "), e += t);
  return e;
};
function noe(o, ...t) {
  let e, r, n, i = a;
  function a(l) {
    const u = t.reduce((c, d) => d(c), o());
    return e = Jne(u), r = e.cache.get, n = e.cache.set, i = s, s(l);
  }
  function s(l) {
    const u = r(l);
    if (u)
      return u;
    const c = toe(l, e);
    return n(l, c), c;
  }
  return function() {
    return i(roe.apply(null, arguments));
  };
}
const Mr = (o) => {
  const t = (e) => e[o] || [];
  return t.isThemeGetter = !0, t;
}, NN = /^\[(?:([a-z-]+):)?(.+)\]$/i, ooe = /^\d+\/\d+$/, ioe = /* @__PURE__ */ new Set(["px", "full", "screen"]), aoe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, soe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, loe = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, uoe = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, coe = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, cs = (o) => Qd(o) || ioe.has(o) || ooe.test(o), ml = (o) => yp(o, "length", yoe), Qd = (o) => !!o && !Number.isNaN(Number(o)), Ob = (o) => yp(o, "number", Qd), eh = (o) => !!o && Number.isInteger(Number(o)), doe = (o) => o.endsWith("%") && Qd(o.slice(0, -1)), Tt = (o) => NN.test(o), yl = (o) => aoe.test(o), poe = /* @__PURE__ */ new Set(["length", "size", "percentage"]), foe = (o) => yp(o, poe, kN), hoe = (o) => yp(o, "position", kN), voe = /* @__PURE__ */ new Set(["image", "url"]), goe = (o) => yp(o, voe, woe), moe = (o) => yp(o, "", Coe), th = () => !0, yp = (o, t, e) => {
  const r = NN.exec(o);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : e(r[2]) : !1;
}, yoe = (o) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  soe.test(o) && !loe.test(o)
), kN = () => !1, Coe = (o) => uoe.test(o), woe = (o) => coe.test(o), boe = () => {
  const o = Mr("colors"), t = Mr("spacing"), e = Mr("blur"), r = Mr("brightness"), n = Mr("borderColor"), i = Mr("borderRadius"), a = Mr("borderSpacing"), s = Mr("borderWidth"), l = Mr("contrast"), u = Mr("grayscale"), c = Mr("hueRotate"), d = Mr("invert"), f = Mr("gap"), v = Mr("gradientColorStops"), g = Mr("gradientColorStopPositions"), m = Mr("inset"), b = Mr("margin"), S = Mr("opacity"), R = Mr("padding"), P = Mr("saturate"), D = Mr("scale"), x = Mr("sepia"), M = Mr("skew"), F = Mr("space"), H = Mr("translate"), B = () => ["auto", "contain", "none"], j = () => ["auto", "hidden", "clip", "visible", "scroll"], V = () => ["auto", Tt, t], W = () => [Tt, t], q = () => ["", cs, ml], ee = () => ["auto", Qd, Tt], re = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ie = () => ["solid", "dashed", "dotted", "double", "none"], ne = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], se = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], pe = () => ["", "0", Tt], K = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], J = () => [Qd, Tt];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [th],
      spacing: [cs, ml],
      blur: ["none", "", yl, Tt],
      brightness: J(),
      borderColor: [o],
      borderRadius: ["none", "", "full", yl, Tt],
      borderSpacing: W(),
      borderWidth: q(),
      contrast: J(),
      grayscale: pe(),
      hueRotate: J(),
      invert: pe(),
      gap: W(),
      gradientColorStops: [o],
      gradientColorStopPositions: [doe, ml],
      inset: V(),
      margin: V(),
      opacity: J(),
      padding: W(),
      saturate: J(),
      scale: J(),
      sepia: pe(),
      skew: J(),
      space: W(),
      translate: W()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Tt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [yl]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": K()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": K()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...re(), Tt]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: j()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": j()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": j()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", eh, Tt]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: V()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Tt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: pe()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: pe()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", eh, Tt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [th]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", eh, Tt]
        }, Tt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ee()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ee()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [th]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [eh, Tt]
        }, Tt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ee()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ee()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Tt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Tt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...se()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...se(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...se(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [R]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [R]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [R]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [R]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [R]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [R]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [R]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [R]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [R]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [F]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [F]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Tt, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Tt, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Tt, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [yl]
        }, yl]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Tt, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Tt, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Tt, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Tt, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", yl, ml]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ob]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [th]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Tt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Qd, Ob]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", cs, Tt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Tt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Tt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [o]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [S]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [o]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [S]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ie(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", cs, ml]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", cs, Tt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [o]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: W()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Tt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Tt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [S]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...re(), hoe]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", foe]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, goe]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [o]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [S]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ie(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [S]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ie()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [n]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ie()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [cs, Tt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [cs, ml]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [o]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: q()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [o]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [S]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [cs, ml]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [o]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", yl, moe]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [th]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [S]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ne(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ne()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [e]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", yl, Tt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [P]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [e]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [S]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [P]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Tt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: J()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Tt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: J()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Tt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [D]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [D]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [D]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [eh, Tt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [H]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [H]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Tt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", o]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Tt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [o]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": W()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": W()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": W()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": W()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": W()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": W()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": W()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": W()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": W()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": W()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": W()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": W()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": W()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": W()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": W()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": W()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": W()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": W()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Tt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [o, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [cs, ml, Ob]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [o, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Soe = /* @__PURE__ */ noe(boe);
function Dt({ check: o, children: t }) {
  return o ? y.createElement(y.Fragment, null, t) : y.createElement(y.Fragment, null);
}
function Ot(o, t) {
  return t ? `${o} ${t}` : o;
}
function Ry(o) {
  return o ?? "";
}
function Ut(o, t, e) {
  return o ? t : e;
}
function Eoe(...o) {
  return Soe(Une(o));
}
function _oe({ onFocus: o, onBlur: t, name: e, suffix: r, prefix: n, wrapActiveClasses: i, wrapperClasses: a, inputClasses: s, customClass: l, variant: u, ...c }) {
  const [d, f] = er(!1), v = (m) => {
    o && o(m), f(!0);
  }, g = (m) => {
    t && t(m), f(!1);
  };
  return y.createElement(
    "div",
    { className: d ? i : a, "data-name": e },
    y.createElement(
      Dt,
      { check: !!n },
      y.createElement("span", { className: "block pl-2" }, n)
    ),
    y.createElement("input", { ...c, className: s, onFocus: v, onBlur: g }),
    y.createElement(
      Dt,
      { check: !!r },
      y.createElement("span", { className: "block pr-2" }, r)
    )
  );
}
function xoe({ onFocus: o, onBlur: t, name: e, suffix: r, prefix: n, wrapActiveClasses: i, wrapperClasses: a, inputClasses: s, value: l, onClick: u, onChange: c, customClass: d, variant: f, ...v }) {
  const g = { onClick: u }, [m, b] = er(!1), [S, R] = er(""), P = (j) => {
    o && o(j), b(!0);
  }, D = (j) => {
    t && t(j), b(!1);
  };
  wr(() => {
    l && R(l);
  }, [l]);
  const [x, M] = er(0), [F, H] = er(0), B = (j) => {
    var ee, re, ie, ne;
    let V = (ee = j == null ? void 0 : j.target) == null ? void 0 : ee.value;
    const W = (re = j == null ? void 0 : j.nativeEvent) == null ? void 0 : re.data, q = (ie = j == null ? void 0 : j.nativeEvent) == null ? void 0 : ie.inputType;
    (ne = j == null ? void 0 : j.target) != null && ne.value && W ? (F !== x ? V = S.slice(0, F) + W + S.slice(x, S.length) : V = S.slice(0, F) + W + S.slice(F, S.length), R(V)) : W === null && (F !== x ? q === "deleteContentBackward" ? V = S.slice(0, F) + S.slice(x, S.length) : q === "deleteContentForward" && (V = S.slice(0, F) + S.slice(x + 1, S.length)) : q === "deleteContentBackward" ? V = S.slice(0, F - 1) + S.slice(x, S.length) : q === "deleteContentForward" && (V = S.slice(0, F) + S.slice(x + 1, S.length)), R(V)), c && (j.target.value = V, c(j));
  };
  return y.createElement(
    "div",
    { className: Ut(m, i, a), "data-name": e },
    y.createElement(
      Dt,
      { check: !!n },
      y.createElement("span", { className: "block pl-2" }, n)
    ),
    y.createElement("input", { ...v, className: s, ...g, onPaste: (j) => (j.preventDefault(), !1), onCopy: (j) => (j.preventDefault(), !1), onCut: (j) => (j.preventDefault(), !1), value: "•".repeat(S == null ? void 0 : S.length), onFocus: P, onBlur: D, onChange: B, onSelect: (j) => {
      var V, W;
      H((V = j == null ? void 0 : j.target) == null ? void 0 : V.selectionStart), M((W = j == null ? void 0 : j.target) == null ? void 0 : W.selectionEnd);
    } }),
    y.createElement(
      Dt,
      { check: !!r },
      y.createElement("span", { className: "block pr-2" }, r)
    )
  );
}
function lie(o) {
  const { type: t, variant: e = "default", theme: r, placeholder: n, icon: i, fill: a, bgColor: s, prefix: l, suffix: u, customClass: c = "", disabled: d, status: f, onChange: v, name: g = null, value: m, onBlur: b, onInput: S, maxLength: R, ...P } = o, D = { ...P };
  ["prefix", "suffix", "variant", "customClass"].map((K) => {
    D[K] && delete D[K];
  });
  let M = " bg-primary-N5", F = "normal-case";
  r && (M = Ut(r.bgColorClass, r.bgColorClass, M), r.format === "uppercase" ? F = "uppercase" : r.format === "lowercase" ? F = "lowercase" : r.format === "capitalize" && (F = "capitalize"));
  let H = "border-primary-neutral-10 dark:border-neutral-dark-10", B = "border-primary dark:border-primary-dark", j = "border-error dark:border-error", V = "border-warning dark:border-warning", W = H, q = B;
  f === "error" ? (W = j, q = j) : f === "alert" && (W = V, q = V);
  let ee = `${M} flex border border-solid rounded-md items-center hover:bg-neutral-0 focus:bg-neutral-0
  focus:border-primary py-2.5 h-12 outline-none font-opensans
   dark:bg-neutral-dark-10 dark:hover:bg-neutral-dark-5  dark:focus:border-primary-dark`;
  ee = Ot(ee, c);
  let re = `${ee} ${W}`, ie = `${ee} ${q}`, ne = `flex rounded-md items-center border border-solid border-neutral-20 bg-neutral-10 hover:bg-neutral-10 
  text-neutral placeholder-neutral-30 w-full py-2.5 h-12 outline-none dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 cursor-not-allowed`, se = `${F} text-neutral-dark-0 bg-transparent outline-none flex-1 placeholder-neutral-30
  py-4 px-2 outline-none h-12 text-size-16 dark:text-neutral-dark-110 rounded-md w-full`;
  return d === !0 && (ie = ne, re = ne, se = `${se} cursor-not-allowed dark:text-neutral-40 dark:placeholder-neutral-40`), (() => {
    switch (e) {
      case "default":
        return y.createElement(_oe, { wrapActiveClasses: ie, wrapperClasses: re, inputClasses: se, ...o });
      case "inputSecure":
        return y.createElement(xoe, { wrapActiveClasses: ie, wrapperClasses: re, inputClasses: se, ...o });
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}
const uie = ({ message: o, customClass: t, required: e = !1 }) => {
  let r = "font-opensans text-neutral-60 text-size-14 font-semibold block mb-1 dark:text-neutral-dark-80";
  return r = t ? `${r} ${t}` : r, y.createElement(
    "label",
    { className: r },
    o,
    " ",
    e && y.createElement("span", { className: "text-error" }, "*")
  );
}, GN = function(o, t) {
  let e = t.split(".");
  return !!o && (e.length > 1 ? GN(o[t.split(".")[0]], e.slice(1).join(".")) : o.hasOwnProperty(t));
}, Dn = (o) => {
  let { className: t, fill: e } = o;
  const { name: r = "Default" } = o, n = "#3E74FF";
  t = `icon-svg ${t}`, e || (e = n);
  const i = {
    Check: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
      y.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
      y.createElement("path", { d: "M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z", fill: e })
    ),
    Alert: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14.002", viewBox: "0 0 14 14.002" },
      y.createElement(
        "g",
        { id: "Group_7952", "data-name": "Group 7952", transform: "translate(0 0.001)" },
        y.createElement("path", { id: "Subtraction_16", "data-name": "Subtraction 16", d: "M2737-11923a7.009,7.009,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.008,7.008,0,0,1,7,7A7.008,7.008,0,0,1,2737-11923Zm0-13a6.007,6.007,0,0,0-6,6,6.008,6.008,0,0,0,6,6,6.008,6.008,0,0,0,6-6A6.007,6.007,0,0,0,2737-11936Z", transform: "translate(-2730 11937)", fill: "#ffd591" }),
        y.createElement(
          "g",
          { id: "Group_6395", "data-name": "Group 6395", transform: "translate(0.868 0.868)" },
          y.createElement("rect", { id: "Rectangle_4413", "data-name": "Rectangle 4413", width: "1.625", height: "5.688", rx: "0.813", transform: "translate(5.318 1.941)", fill: "#ffa940" }),
          y.createElement("path", { id: "Path_20116", "data-name": "Path 20116", d: "M.813,0A.813.813,0,1,1,0,.813.813.813,0,0,1,.813,0Z", transform: "translate(5.318 8.71)", fill: "#ffa940" })
        )
      )
    ),
    Info: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
      y.createElement(
        "g",
        { id: "Group_6927", "data-name": "Group 6927", transform: "translate(-324 -687.001)" },
        y.createElement(
          "g",
          { id: "Group_6850", "data-name": "Group 6850", transform: "translate(324 687.27)" },
          y.createElement(
            "g",
            { id: "Rectangle_3008", "data-name": "Rectangle 3008", transform: "translate(0 -0.269)", stroke: "#e7edf9", strokeWidth: "1", className: "fill-neutral-dark-110 dark:fill-neutral-dark-0" },
            y.createElement("rect", { width: "16", height: "16", rx: "2", stroke: "none" }),
            y.createElement("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "1.5", fill: "none" })
          )
        ),
        y.createElement(
          "g",
          { id: "Layer_x0020_1", transform: "translate(324.443 687.416)" },
          y.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M9.437,4.524a1.339,1.339,0,0,1-1.8,0,1.1,1.1,0,0,1-.375-.839,1.115,1.115,0,0,1,.375-.841,1.274,1.274,0,0,1,.9-.349,1.26,1.26,0,0,1,.9.349,1.132,1.132,0,0,1,0,1.679Zm.094,7.648q-.641.253-1.023.385a2.7,2.7,0,0,1-.887.133,1.767,1.767,0,0,1-1.207-.379,1.223,1.223,0,0,1-.43-.961,3.483,3.483,0,0,1,.032-.463c.022-.157.056-.335.1-.534l.535-1.89c.047-.181.088-.354.12-.514A2.282,2.282,0,0,0,6.822,7.5.685.685,0,0,0,6.673,7,.847.847,0,0,0,6.1,6.859a1.491,1.491,0,0,0-.425.063c-.144.044-.269.084-.372.124l.141-.582Q5.971,6.25,6.451,6.1a2.973,2.973,0,0,1,.907-.153,1.735,1.735,0,0,1,1.19.373,1.238,1.238,0,0,1,.418.967q0,.123-.029.434a2.9,2.9,0,0,1-.107.57L8.3,10.173a5.289,5.289,0,0,0-.117.518,2.727,2.727,0,0,0-.051.44.632.632,0,0,0,.168.512.94.94,0,0,0,.582.137,1.682,1.682,0,0,0,.44-.068,2.531,2.531,0,0,0,.356-.119l-.143.582Z", transform: "translate(0 -0.01)", fill: "#9faabe", fillRule: "evenodd" })
        )
      )
    ),
    infoRound: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "14.002", height: "13.999", viewBox: "0 0 14.002 13.999" },
      y.createElement(
        "g",
        { id: "Group_7953", "data-name": "Group 7953", transform: "translate(0.001)" },
        y.createElement(
          "g",
          { id: "Group_6850", "data-name": "Group 6850", transform: "translate(0 0)" },
          y.createElement(
            "g",
            { id: "Subtraction_15", "data-name": "Subtraction 15", transform: "translate(-2730 11911)", fill: "none" },
            y.createElement("path", { d: "M2737-11897a7.008,7.008,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.008,7.008,0,0,1,2737-11897Zm0-13a6.006,6.006,0,0,0-6,6,6.006,6.006,0,0,0,6,6,6.006,6.006,0,0,0,6-6A6.006,6.006,0,0,0,2737-11910Z", stroke: "none" }),
            y.createElement("path", { d: "M 2736.999755859375 -11897.0009765625 C 2733.139404296875 -11897.0009765625 2729.998779296875 -11900.140625 2729.998779296875 -11903.9990234375 C 2729.998779296875 -11907.859375 2733.139404296875 -11911 2736.999755859375 -11911 C 2740.85986328125 -11911 2744.00048828125 -11907.859375 2744.00048828125 -11903.9990234375 C 2744.00048828125 -11900.140625 2740.85986328125 -11897.0009765625 2736.999755859375 -11897.0009765625 Z M 2736.999755859375 -11909.9990234375 C 2733.691650390625 -11909.9990234375 2731.000244140625 -11907.3076171875 2731.000244140625 -11903.9990234375 C 2731.000244140625 -11900.69140625 2733.691650390625 -11898 2736.999755859375 -11898 C 2740.307861328125 -11898 2742.9990234375 -11900.69140625 2742.9990234375 -11903.9990234375 C 2742.9990234375 -11907.3076171875 2740.307861328125 -11909.9990234375 2736.999755859375 -11909.9990234375 Z", stroke: "none", fill: "#7ea2ff" })
          )
        ),
        y.createElement(
          "g",
          { id: "Layer_x0020_1", transform: "translate(4.981 2.588)" },
          y.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M8.779,4.2a1.125,1.125,0,0,1-1.51,0A.928.928,0,0,1,6.954,3.5a.938.938,0,0,1,.315-.707A1.071,1.071,0,0,1,8.025,2.5a1.059,1.059,0,0,1,.754.294.952.952,0,0,1,0,1.412Zm.079,6.43q-.539.213-.86.324a2.269,2.269,0,0,1-.746.112,1.486,1.486,0,0,1-1.015-.319,1.029,1.029,0,0,1-.361-.808A2.928,2.928,0,0,1,5.9,9.55c.018-.132.047-.281.087-.449l.45-1.589c.04-.152.074-.3.1-.432a1.918,1.918,0,0,0,.04-.374.576.576,0,0,0-.125-.424.712.712,0,0,0-.481-.119,1.254,1.254,0,0,0-.358.053c-.121.037-.226.071-.313.1l.119-.489q.442-.18.845-.308A2.5,2.5,0,0,1,7.031,5.4a1.459,1.459,0,0,1,1,.313,1.041,1.041,0,0,1,.351.813q0,.1-.024.365a2.435,2.435,0,0,1-.09.479L7.821,8.95a4.447,4.447,0,0,0-.1.435,2.293,2.293,0,0,0-.043.37.532.532,0,0,0,.141.43.79.79,0,0,0,.489.115,1.414,1.414,0,0,0,.37-.057,2.128,2.128,0,0,0,.3-.1l-.12.489Z", transform: "translate(-5.305 -2.496)", fill: "#5081ff", fillRule: "evenodd" })
        )
      )
    ),
    Error: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "14.002", height: "14.002", viewBox: "0 0 14.002 14.002" },
      y.createElement(
        "g",
        { id: "Group_7950", "data-name": "Group 7950", transform: "translate(0 -0.008)" },
        y.createElement("path", { id: "Subtraction_18", "data-name": "Subtraction 18", d: "M2737-11973.99a7.009,7.009,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.009,7.009,0,0,1,2737-11973.99Zm0-13a6.006,6.006,0,0,0-6,6,6.006,6.006,0,0,0,6,6,6.006,6.006,0,0,0,6-6A6.006,6.006,0,0,0,2737-11986.99Z", transform: "translate(-2730 11988)", fill: "#ffa39e" }),
        y.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M4.559,5.642,2.933,4.017,1.308,5.642A.766.766,0,1,1,.224,4.559L1.85,2.933.225,1.309A.767.767,0,1,1,1.309.224L2.934,1.849,4.559.224A.766.766,0,1,1,5.642,1.308L4.018,2.932,5.643,4.559A.766.766,0,1,1,4.559,5.642Z", transform: "translate(4.067 4.345)", fill: "#ff4d4f" })
      )
    ),
    successInfo: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
      y.createElement(
        "g",
        { id: "Group_7951", "data-name": "Group 7951", transform: "translate(0 -0.017)" },
        y.createElement("path", { id: "Subtraction_17", "data-name": "Subtraction 17", d: "M2737-11948.983a7.006,7.006,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.008,7.008,0,0,1,2737-11948.983Zm0-13a6.007,6.007,0,0,0-6,6,6,6,0,0,0,6,6,6.007,6.007,0,0,0,6-6A6.009,6.009,0,0,0,2737-11961.983Z", transform: "translate(-2730 11963)", fill: "#8cedb9" }),
        y.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M2.336,5.01a.757.757,0,0,1-.552-.24L.228,3.134a.851.851,0,0,1,0-1.158.753.753,0,0,1,1.1,0L2.336,3.035,4.994.24a.75.75,0,0,1,1.1,0,.848.848,0,0,1,0,1.157L2.889,4.77a.758.758,0,0,1-.551.24Z", transform: "translate(3.839 4.679)", fill: "#15c87a" })
      )
    ),
    Notfound: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "47.998", height: "47.998", viewBox: "0 0 47.998 47.998" },
      y.createElement(
        "g",
        { id: "Group_7133", "data-name": "Group 7133", transform: "translate(0.024 0.023)" },
        y.createElement("path", { id: "Path_20209", "data-name": "Path 20209", d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z", transform: "translate(-0.024 -0.023)", fill: "#ffd591" }),
        y.createElement(
          "g",
          { id: "Group_6395", "data-name": "Group 6395", transform: "translate(2.976 2.976)" },
          y.createElement("path", { id: "Subtraction_3", "data-name": "Subtraction 3", d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z", transform: "translate(-0.001 -0.002)", fill: "#fff" }),
          y.createElement("rect", { id: "Rectangle_4413", "data-name": "Rectangle 4413", width: "4.601", height: "16.102", rx: "2.3", transform: "translate(18.697 9.195)", fill: "#ffa940" }),
          y.createElement("path", { id: "Path_20116", "data-name": "Path 20116", d: "M2.3,0A2.3,2.3,0,1,1,0,2.3,2.3,2.3,0,0,1,2.3,0Z", transform: "translate(18.697 28.203)", fill: "#ffa940" })
        )
      )
    ),
    Success: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" },
      y.createElement(
        "g",
        { id: "Group_7023", "data-name": "Group 7023", transform: "translate(-198 -92)" },
        y.createElement("circle", { id: "Ellipse_845", "data-name": "Ellipse 845", cx: "24", cy: "24", r: "24", transform: "translate(198 92)", fill: "#8cedb9" }),
        y.createElement("circle", { id: "Ellipse_844", "data-name": "Ellipse 844", cx: "21", cy: "21", r: "21", transform: "translate(201 95)", fill: "#fff" }),
        y.createElement("path", { id: "right_1_", "data-name": "right (1)", d: "M16.217,29.972l2.471,2.472L7.127,44,0,36.877l2.471-2.472,4.656,4.656Z", transform: "translate(212.149 79.298)", fill: "#15c87a" })
      )
    ),
    Unsuccessful: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" },
      y.createElement(
        "g",
        { id: "Group_7023", "data-name": "Group 7023", transform: "translate(-198 -92)" },
        y.createElement("circle", { id: "Ellipse_845", "data-name": "Ellipse 845", cx: "24", cy: "24", r: "24", transform: "translate(198 92)", fill: "#ffa39e" }),
        y.createElement("circle", { id: "Ellipse_844", "data-name": "Ellipse 844", cx: "21", cy: "21", r: "21", transform: "translate(201 95)", fill: "#fff" }),
        y.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M14077.177,21391.566l-5.1-5.09-5.089,5.09a2,2,0,0,1-2.83,0l-.424-.424a2,2,0,0,1,0-2.83l5.09-5.09-5.09-5.09a2,2,0,0,1,0-2.828l.43-.424a1.988,1.988,0,0,1,2.824,0l5.089,5.09,5.09-5.09a1.993,1.993,0,0,1,2.829,0l.425.424a2,2,0,0,1,0,2.828l-5.09,5.09,5.095,5.09a2,2,0,0,1,0,2.83l-.424.424a2,2,0,0,1-1.418.59A1.978,1.978,0,0,1,14077.177,21391.566Z", transform: "translate(-13850.151 -21267.291)", fill: "#ff4d4f" })
      )
    ),
    Netbanking: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
      y.createElement(
        "g",
        { id: "Group_6883", "data-name": "Group 6883", transform: "translate(-51 -291)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
        y.createElement(
          "g",
          { id: "_4987286121594941299", "data-name": "4987286121594941299", transform: "translate(54.827 297)" },
          y.createElement("path", { id: "Path_19995", "data-name": "Path 19995", d: "M13.655,3,3,8.393V10.7H24.311V8.393Z", transform: "translate(-1.345 -3)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
          y.createElement("rect", { id: "Rectangle_4654", "data-name": "Rectangle 4654", width: "3.169", height: "7.447", transform: "translate(11.091 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
          y.createElement("rect", { id: "Rectangle_4655", "data-name": "Rectangle 4655", width: "3.169", height: "7.447", transform: "translate(18.221 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
          y.createElement("rect", { id: "Rectangle_4656", "data-name": "Rectangle 4656", width: "3.169", height: "7.447", transform: "translate(3.169 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
          y.createElement("rect", { id: "Rectangle_4657", "data-name": "Rectangle 4657", width: "21.389", height: "2.234", transform: "translate(1.584 15.533)", fill: "none", className: "dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
          y.createElement("rect", { id: "Rectangle_4658", "data-name": "Rectangle 4658", width: "24.558", height: "2.234", transform: "translate(0 17.767)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" })
        )
      )
    ),
    Upi: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
      y.createElement(
        "g",
        { id: "Group_6884", "data-name": "Group 6884", transform: "translate(-51 -291)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
        y.createElement(
          "g",
          { id: "upi-ar21", transform: "translate(42.999 286.937)" },
          y.createElement("path", { id: "Path_20192", "data-name": "Path 20192", d: "M95.678,23.762l4.01-3.658-1.9-3.785Z", transform: "translate(-61.687 -0.087)", fill: "#097939" }),
          y.createElement("path", { id: "Path_20193", "data-name": "Path 20193", d: "M90.854,23.762l4.01-3.658-1.9-3.785Z", transform: "translate(-58.214 -0.087)", fill: "#ed752e" }),
          y.createElement("path", { id: "Path_20194", "data-name": "Path 20194", d: "M13.476,16.275l-1.688,6.013,5.994.042,1.646-6.055h1.52l-1.974,7.039a.706.706,0,0,1-.643.487H10.648a.606.606,0,0,1-.616-.812l1.883-6.714Zm18.531-.042h1.52L31.416,23.8H29.853Zm-10.89,3.153,7.6-.042.507-1.6H21.5l.464-1.472,8.232-.076a.664.664,0,0,1,.683.887L30.1,19.92a1.284,1.284,0,0,1-1.173.9h-6.8l-.8,3.112H19.85Z", transform: "translate(0)", className: "fill-base-color dark:fill-neutral-40" })
        )
      )
    ),
    Emandate: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
      y.createElement(
        "g",
        { id: "Group_6885", "data-name": "Group 6885", transform: "translate(-51 -291)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
        y.createElement("path", { id: "_7117553871579156629", "data-name": "7117553871579156629", d: "M19.146,10.951l.718-.792a1.8,1.8,0,0,0,0-2.375s.126-.046-.588-.4-1.566.4-1.566.4L16.246,9.4V6.718L10.16,0H2.539A2.681,2.681,0,0,0,0,2.8V19.593a2.681,2.681,0,0,0,2.539,2.8H13.711a2.681,2.681,0,0,0,2.539-2.8V14.148l2.182-2.405.357.394-.718.792a.6.6,0,0,0-.012.792.475.475,0,0,0,.718.013l.012-.013,1.079-1.19a.6.6,0,0,0,0-.792Zm-8.482-8.8,3.63,4.01H12.188a1.608,1.608,0,0,1-1.523-1.679Zm4.57,17.446a1.608,1.608,0,0,1-1.523,1.679H2.539a1.608,1.608,0,0,1-1.523-1.679V2.8A1.608,1.608,0,0,1,2.539,1.12H9.648V4.478a2.681,2.681,0,0,0,2.539,2.8h3.047v3.241L10.529,15.7a1.8,1.8,0,0,0-.294,1.907l-.044.048A1.858,1.858,0,0,0,8.569,16.8a1.733,1.733,0,0,0-1.075.735c-.186.223-.309.363-.448.385-.06,0-.218-.2-.313-.324a1.729,1.729,0,0,0-1.091-.8c-.663-.087-1.309.35-1.988,1.338a.6.6,0,0,0,.087.787.476.476,0,0,0,.714-.1l.012-.013c.417-.608.8-.94,1.059-.9.127.017.258.171.436.407a1.435,1.435,0,0,0,1.071.722c.044,0,.091,0,.135-.009A1.733,1.733,0,0,0,8.244,18.3c.19-.227.309-.363.448-.385.254-.039.639.3,1.059.9a.493.493,0,0,0,.4.219H10.2a.476.476,0,0,0,.333-.162l.424-.468a1.4,1.4,0,0,0,1.73-.324l2.555-2.812v4.325Zm-3.269-2.309a.475.475,0,0,1-.718,0h0a.6.6,0,0,1,0-.792l5.745-6.333.718.792Zm6.463-7.124-.131-.144-.587-.647.718-.792a.6.6,0,0,1,.131-.1.417.417,0,0,1,.139-.052.59.59,0,0,1,.087-.009.329.329,0,0,1,.091.013.561.561,0,0,1,.167.066.59.59,0,0,1,.175.77.654.654,0,0,1-.075.109ZM3.555,8.4a.534.534,0,0,1,.508-.56H7.125a.562.562,0,0,1,0,1.12H4.063a.534.534,0,0,1-.508-.56Zm0,2.239a.534.534,0,0,1,.508-.56h6.11a.562.562,0,0,1,0,1.12H4.063A.534.534,0,0,1,3.555,10.636Z", transform: "translate(56.845 295.805)", className: "fill-neutral-80 dark:fill-neutral-40" })
      )
    ),
    Trash: y.createElement(
      "svg",
      { className: t, fill: "#FF4D4F", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", width: "18px", height: "18px" },
      y.createElement("path", { d: "M 24 4 C 20.491685 4 17.570396 6.6214322 17.080078 10 L 10.238281 10 A 1.50015 1.50015 0 0 0 9.9804688 9.9785156 A 1.50015 1.50015 0 0 0 9.7578125 10 L 6.5 10 A 1.50015 1.50015 0 1 0 6.5 13 L 8.6386719 13 L 11.15625 39.029297 C 11.427329 41.835926 13.811782 44 16.630859 44 L 31.367188 44 C 34.186411 44 36.570826 41.836168 36.841797 39.029297 L 39.361328 13 L 41.5 13 A 1.50015 1.50015 0 1 0 41.5 10 L 38.244141 10 A 1.50015 1.50015 0 0 0 37.763672 10 L 30.919922 10 C 30.429604 6.6214322 27.508315 4 24 4 z M 24 7 C 25.879156 7 27.420767 8.2681608 27.861328 10 L 20.138672 10 C 20.579233 8.2681608 22.120844 7 24 7 z M 11.650391 13 L 36.347656 13 L 33.855469 38.740234 C 33.730439 40.035363 32.667963 41 31.367188 41 L 16.630859 41 C 15.331937 41 14.267499 40.033606 14.142578 38.740234 L 11.650391 13 z M 20.476562 17.978516 A 1.50015 1.50015 0 0 0 19 19.5 L 19 34.5 A 1.50015 1.50015 0 1 0 22 34.5 L 22 19.5 A 1.50015 1.50015 0 0 0 20.476562 17.978516 z M 27.476562 17.978516 A 1.50015 1.50015 0 0 0 26 19.5 L 26 34.5 A 1.50015 1.50015 0 1 0 29 34.5 L 29 19.5 A 1.50015 1.50015 0 0 0 27.476562 17.978516 z" })
    ),
    Back: y.createElement(
      "svg",
      { className: `fill-neutral-80 dark:fill-neutral-40 ${t}`, xmlns: "http://www.w3.org/2000/svg", width: "26px", height: "26px", viewBox: "0 0 24 24" },
      y.createElement(
        "g",
        { "data-name": "Layer 2" },
        y.createElement(
          "g",
          { "data-name": "arrow-back" },
          y.createElement("rect", { width: "24", height: "24", opacity: "0", transform: "rotate(90 12 12)" }),
          y.createElement("path", { d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" })
        )
      )
    ),
    DownArrow: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
      y.createElement(
        "g",
        { id: "Group_7454", "data-name": "Group 7454", transform: "translate(-371 -256.265)" },
        y.createElement("rect", { id: "Rectangle_5802", "data-name": "Rectangle 5802", width: "16", height: "16", transform: "translate(371 256.265)", fill: "none" }),
        y.createElement(
          "g",
          { id: "Group_6928", "data-name": "Group 6928", transform: "translate(373.941 267.067) rotate(-90)" },
          y.createElement("path", { id: "Vector_7", "data-name": "Vector 7", d: "M10.147,1.393A.8.8,0,0,0,9.069.208ZM5.2,4.8,4.665,5.4a.8.8,0,0,0,1.078,0ZM1.339.208A.8.8,0,0,0,.262,1.393Zm7.73,0-4.4,4L5.743,5.4l4.4-4Zm-3.326,4-4.4-4L.262,1.393l4.4,4Z", transform: "translate(5.605 0) rotate(90)", className: "fill-neutral-80 dark:fill-neutral-40" })
        )
      )
    ),
    rightArrow: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-mini/chevron-right" },
        y.createElement("path", { id: "Vector (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M7.20938 14.7698C6.92228 14.4713 6.93159 13.9965 7.23017 13.7094L11.1679 10L7.23017 6.29062C6.93159 6.00353 6.92228 5.52875 7.20938 5.23017C7.49647 4.93159 7.97125 4.92228 8.26983 5.20937L12.7698 9.45937C12.9169 9.60078 13 9.79599 13 10C13 10.204 12.9169 10.3992 12.7698 10.5406L8.26983 14.7906C7.97125 15.0777 7.49647 15.0684 7.20938 14.7698Z", fill: "#788393" })
      )
    ),
    RightArrowDark: y.createElement(
      "svg",
      { className: t, width: "10", height: "16", viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M2 14L8 8L2 2", stroke: "#444444", strokeWidth: "2.4", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Language: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
      y.createElement(
        "g",
        { id: "Group_7456", "data-name": "Group 7456", transform: "translate(-345.293 -830.293)" },
        y.createElement(
          "g",
          { id: "Group_7450", "data-name": "Group 7450", transform: "translate(345 830)" },
          y.createElement("rect", { id: "Rectangle_5802", "data-name": "Rectangle 5802", width: "16", height: "16", transform: "translate(0.293 0.293)", fill: "none" })
        ),
        y.createElement(
          "g",
          { id: "Group_7452", "data-name": "Group 7452", transform: "translate(346.844 833.292)" },
          y.createElement("path", { id: "Union_2", "data-name": "Union 2", d: "M2.91,11.5,2.1,10.176a1.038,1.038,0,0,0-.071-.1l-.336-.422A2,2,0,0,1,0,7.675V2A2,2,0,0,1,2,0h8.9a2,2,0,0,1,2,2V7.675a2,2,0,0,1-2,2H5.813l-.317.4a.912.912,0,0,0-.072.1L4.617,11.5a1,1,0,0,1-1.707,0Z", transform: "translate(-0.001 0.001)", fill: "#9faabe" }),
          y.createElement("path", { id: "Path_20254", "data-name": "Path 20254", d: "M17.1,12H16.01a.547.547,0,1,0,0,1.095v1.095h-.651a1.7,1.7,0,0,0,.1-.547,1.642,1.642,0,0,0-3.065-.821.547.547,0,0,0,.947.547h0a.547.547,0,1,1,.476.821.547.547,0,0,0,0,1.095.547.547,0,1,1-.476.821.548.548,0,0,0-.952.542h0a1.642,1.642,0,0,0,3.065-.821,1.7,1.7,0,0,0-.1-.547H16v1.642a.547.547,0,0,0,1.095,0V13.093A.547.547,0,1,0,17.1,12Z", transform: "translate(-8.534 -9.894)", fill: "#fff" })
        )
      )
    ),
    Edit: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26" },
      y.createElement(
        "g",
        { id: "Group_7442", "data-name": "Group 7442", transform: "translate(-50.529 -290.529)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "26", height: "26", transform: "translate(50.529 290.529)", fill: "none" }),
        y.createElement("path", { id: "icons8-edit", d: "M14.841,2a2.064,2.064,0,0,0-1.464.606l-.858.858,2.929,2.929.858-.858A2.071,2.071,0,0,0,14.841,2ZM11.421,4.563,3,12.983v2.929H5.929l8.421-8.421Z", transform: "translate(54.073 295.073)", fill: "#3f567e" })
      )
    ),
    Light: y.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" },
      y.createElement(
        "g",
        { id: "Group_8203", "data-name": "Group 8203", transform: "translate(3431 -9582)" },
        y.createElement("rect", { id: "Rectangle_7169", "data-name": "Rectangle 7169", width: "22", height: "22", transform: "translate(-3431 9582)", fill: "none" }),
        y.createElement(
          "g",
          { id: "dark-mode", transform: "translate(-3432.31 9580.666)" },
          y.createElement(
            "g",
            { id: "sun-8726", transform: "translate(3.808 3.831)" },
            y.createElement(
              "g",
              { id: "Group_6730", "data-name": "Group 6730", transform: "translate(0)" },
              y.createElement("path", { id: "Path_20084", "data-name": "Path 20084", d: "M66.486,71.354a4.868,4.868,0,1,1,4.868-4.868A4.874,4.874,0,0,1,66.486,71.354Zm0-8.466a3.6,3.6,0,1,0,3.6,3.6A3.6,3.6,0,0,0,66.486,62.888Z", transform: "translate(-57.984 -57.984)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20085", "data-name": "Path 20085", d: "M118.312,12.628a.679.679,0,0,1-.679-.679V10.679a.679.679,0,1,1,1.357,0v1.271A.679.679,0,0,1,118.312,12.628Z", transform: "translate(-109.811 -10)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20086", "data-name": "Path 20086", d: "M118.312,205.529a.679.679,0,0,1-.679-.679V203.58a.679.679,0,0,1,1.357,0v1.271A.679.679,0,0,1,118.312,205.529Z", transform: "translate(-109.811 -188.526)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20087", "data-name": "Path 20087", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(13.935 2.108) rotate(45)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20088", "data-name": "Path 20088", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(3.966 12.077) rotate(45)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20089", "data-name": "Path 20089", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(17.003 7.823) rotate(90)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20090", "data-name": "Path 20090", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(2.628 7.823) rotate(90)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20091", "data-name": "Path 20091", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(14.895 13.935) rotate(135)", className: "fill-neutral-110 dark:fill-neutral-40" }),
              y.createElement("path", { id: "Path_20092", "data-name": "Path 20092", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(4.926 3.966) rotate(135)", className: "fill-neutral-110 dark:fill-neutral-40" })
            )
          )
        )
      )
    ),
    Dark: y.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" },
      y.createElement(
        "g",
        { id: "Group_8202", "data-name": "Group 8202", transform: "translate(3455 -9582)" },
        y.createElement("rect", { id: "Rectangle_7168", "data-name": "Rectangle 7168", width: "22", height: "22", transform: "translate(-3455 9582)", fill: "none" }),
        y.createElement(
          "g",
          { id: "moon-6681", transform: "translate(-3451.148 9585.081)" },
          y.createElement(
            "g",
            { id: "Group_6729", "data-name": "Group 6729", transform: "translate(0.298 0.303)" },
            y.createElement("path", { id: "Subtraction_24", "data-name": "Subtraction 24", d: "M7.63,15.231a7.646,7.646,0,0,1-6.608-3.808A7.614,7.614,0,0,1,7.6,0a7.539,7.539,0,0,1,.983.062.6.6,0,0,1,.507.462.6.6,0,0,1-.266.635A4.991,4.991,0,0,0,13.812,9.8a.608.608,0,0,1,.279-.07.6.6,0,0,1,.55.827A7.618,7.618,0,0,1,7.63,15.231ZM6.864,1.189h0l-.73.174a6.423,6.423,0,1,0,6.157,10.663l.516-.546-.748.073c-.192.018-.392.029-.6.029A6.191,6.191,0,0,1,6.428,1.8l.435-.611Z", transform: "translate(0 0)", className: "fill-neutral-110 dark:fill-neutral-40" })
          )
        )
      )
    ),
    System: y.createElement(
      "svg",
      { viewBox: "0 0 24 24", fill: "none", className: "mr-2 h-6 w-6" },
      y.createElement("path", { d: "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z", strokeWidth: "1", strokeLinejoin: "round", className: "fill-neutral-20/20 stroke-neutral-80" }),
      y.createElement("path", { d: "M14 15c0 3 2 5 2 5H8s2-2 2-5", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-neutral-80" })
    ),
    Avatar: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "Icon/Outline/user-circle" },
        y.createElement("path", { id: "Icon", d: "M5.12104 17.8037C7.15267 16.6554 9.4998 16 12 16C14.5002 16 16.8473 16.6554 18.879 17.8037M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", className: "stroke-neutral-80 dark:stroke-neutral-40", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      )
    ),
    Calendar: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 24 24" },
      y.createElement("path", { d: "M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z", fill: "#3f567e" })
    ),
    Close: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
      y.createElement(
        "g",
        { id: "Group_7359", "data-name": "Group 7359", transform: "translate(0 0.398)" },
        y.createElement("rect", { id: "Rectangle_5670", "data-name": "Rectangle 5670", width: "24", height: "24", transform: "translate(0 -0.398)", fill: "none" }),
        y.createElement(
          "g",
          { id: "Group_3819", "data-name": "Group 3819", transform: "translate(18 18.128) rotate(180)" },
          y.createElement(
            "g",
            { id: "Group_2994", "data-name": "Group 2994" },
            y.createElement("path", { id: "Line_5", "data-name": "Line 5", d: "M.889,15.026H.878a.889.889,0,0,1-.878-.9L.167.878A.889.889,0,0,1,1.945.9L1.778,14.148A.889.889,0,0,1,.889,15.026Z", transform: "translate(12 10.625) rotate(135)", className: "fill-neutral-80 dark:fill-neutral-40" }),
            y.createElement("path", { id: "Line_6", "data-name": "Line 6", d: "M.889,1.945A.889.889,0,0,1,.878.167L14.125,0a.889.889,0,1,1,.022,1.778L.9,1.945Z", transform: "translate(12 1.375) rotate(135)", className: "fill-neutral-80 dark:fill-neutral-40" })
          )
        )
      )
    ),
    Helper: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "14.001", height: "14.001", viewBox: "0 0 14.001 14.001" },
      y.createElement(
        "g",
        { id: "Group_7954", "data-name": "Group 7954", transform: "translate(0.001 0.001)" },
        y.createElement(
          "g",
          { id: "Subtraction_14", "data-name": "Subtraction 14", transform: "translate(-2730 11885)", className: "fill-neutral-20" },
          y.createElement("path", { d: "M 2733.396484375 -11872.5927734375 C 2731.651123046875 -11873.7587890625 2730.499267578125 -11875.748046875 2730.499267578125 -11878 C 2730.499267578125 -11881.5849609375 2733.415283203125 -11884.5009765625 2736.999755859375 -11884.5009765625 C 2733.41650390625 -11884.5009765625 2730.50146484375 -11881.5849609375 2730.50146484375 -11878 C 2730.50146484375 -11875.748046875 2731.652099609375 -11873.759765625 2733.396484375 -11872.5927734375 Z", stroke: "none" }),
          y.createElement("path", { d: "M 2736.999755859375 -11871 C 2733.1396484375 -11871 2729.999267578125 -11874.140625 2729.999267578125 -11878 C 2729.999267578125 -11881.8603515625 2733.1396484375 -11885.0009765625 2736.999755859375 -11885.0009765625 C 2740.85986328125 -11885.0009765625 2744.000244140625 -11881.8603515625 2744.000244140625 -11878 C 2744.000244140625 -11874.140625 2740.85986328125 -11871 2736.999755859375 -11871 Z M 2736.999755859375 -11884.0009765625 C 2733.6923828125 -11884.0009765625 2731.00146484375 -11881.30859375 2731.00146484375 -11878 C 2731.00146484375 -11874.69140625 2733.6923828125 -11871.9990234375 2736.999755859375 -11871.9990234375 C 2740.308837890625 -11871.9990234375 2743.0009765625 -11874.69140625 2743.0009765625 -11878 C 2743.0009765625 -11881.30859375 2740.308837890625 -11884.0009765625 2736.999755859375 -11884.0009765625 Z", stroke: "none", className: "fill-neutral-40" })
        ),
        y.createElement(
          "g",
          { id: "Layer_x0020_1", transform: "translate(4.981 2.588)" },
          y.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M8.779,4.2a1.125,1.125,0,0,1-1.51,0A.928.928,0,0,1,6.954,3.5a.938.938,0,0,1,.315-.707A1.071,1.071,0,0,1,8.025,2.5a1.059,1.059,0,0,1,.754.294.952.952,0,0,1,0,1.412Zm.079,6.43q-.539.213-.86.324a2.269,2.269,0,0,1-.746.112,1.486,1.486,0,0,1-1.015-.319,1.029,1.029,0,0,1-.361-.808A2.928,2.928,0,0,1,5.9,9.55c.018-.132.047-.281.087-.449l.45-1.589c.04-.152.074-.3.1-.432a1.918,1.918,0,0,0,.04-.374.576.576,0,0,0-.125-.424.712.712,0,0,0-.481-.119,1.254,1.254,0,0,0-.358.053c-.121.037-.226.071-.313.1l.119-.489q.442-.18.845-.308A2.5,2.5,0,0,1,7.031,5.4a1.459,1.459,0,0,1,1,.313,1.041,1.041,0,0,1,.351.813q0,.1-.024.365a2.435,2.435,0,0,1-.09.479L7.821,8.95a4.447,4.447,0,0,0-.1.435,2.293,2.293,0,0,0-.043.37.532.532,0,0,0,.141.43.79.79,0,0,0,.489.115,1.414,1.414,0,0,0,.37-.057,2.128,2.128,0,0,0,.3-.1l-.12.489Z", transform: "translate(-5.305 -2.496)", className: "fill-neutral-40", fillRule: "evenodd" })
        )
      )
    ),
    Play: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "100", height: "100", viewBox: "0 0 100 100" },
      y.createElement(
        "g",
        { id: "Group_8114", "data-name": "Group 8114", transform: "translate(-5624.757 -19078.758)", opacity: "0.75" },
        y.createElement("path", { id: "Subtraction_21", "data-name": "Subtraction 21", d: "M50,100A50.013,50.013,0,0,1,30.538,3.929,50.013,50.013,0,0,1,69.462,96.071,49.686,49.686,0,0,1,50,100ZM50,6.25A43.762,43.762,0,0,0,32.97,90.312,43.762,43.762,0,0,0,67.03,9.688,43.476,43.476,0,0,0,50,6.25Z", transform: "translate(5624.757 19078.758)", fill: "#fff" }),
        y.createElement("path", { id: "Polygon_26", "data-name": "Polygon 26", d: "M23.307,5.49a3,3,0,0,1,5.387,0L49.88,48.679A3,3,0,0,1,47.187,53H4.813A3,3,0,0,1,2.12,48.679Z", transform: "translate(5706.757 19101.758) rotate(90)", fill: "#fff" })
      )
    ),
    Upload: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
      y.createElement(
        "g",
        { id: "Group_8129", "data-name": "Group 8129", transform: "translate(-51.035 -291.035)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "24", height: "24", transform: "translate(51.035 291.035)", fill: "none" }),
        y.createElement(
          "g",
          { id: "Image", transform: "translate(55.468 295.468)" },
          y.createElement("path", { id: "Path_20233", "data-name": "Path 20233", d: "M14.432,2H4.7A2.7,2.7,0,0,0,2,4.7v9.729a2.7,2.7,0,0,0,2.7,2.7h9.729a2.7,2.7,0,0,0,2.7-2.7V4.7A2.7,2.7,0,0,0,14.432,2ZM4.7,3.081h9.729A1.622,1.622,0,0,1,16.053,4.7V7.724L15.037,6.708a1.622,1.622,0,0,0-2.292,0l-4.3,4.324L6.827,9.724a1.622,1.622,0,0,0-2.054,0L3.081,11.113V4.7A1.622,1.622,0,0,1,4.7,3.081Zm9.729,12.972H4.7a1.622,1.622,0,0,1-1.622-1.622V12.524l2.367-1.978a.541.541,0,0,1,.686,0l2.016,1.622a.541.541,0,0,0,.719-.038l4.638-4.643a.541.541,0,0,1,.768,0l1.778,1.762v5.184a1.622,1.622,0,0,1-1.622,1.622Z", transform: "translate(-2 -2)", fill: "#3f567e" }),
          y.createElement("path", { id: "Path_20234", "data-name": "Path 20234", d: "M8.622,10.243A1.622,1.622,0,1,0,7,8.622,1.622,1.622,0,0,0,8.622,10.243Zm0-2.162a.541.541,0,1,1-.541.541A.541.541,0,0,1,8.622,8.081Z", transform: "translate(-4.297 -4.297)", fill: "#3f567e" })
        )
      )
    ),
    Pdf: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
      y.createElement(
        "g",
        { id: "Group_8149", "data-name": "Group 8149", transform: "translate(-77 -232)" },
        y.createElement("rect", { id: "Rectangle_7054", "data-name": "Rectangle 7054", width: "32", height: "32", transform: "translate(77 232)", fill: "none" }),
        y.createElement("path", { id: "file-pdf-svgrepo-com", d: "M23.071,9.329H22.4l.036-2.465a.6.6,0,0,0-.157-.388L16.521.175a.512.512,0,0,0-.134-.109.5.5,0,0,0-.1-.042A.48.48,0,0,0,16.151,0H4.1A1.042,1.042,0,0,0,3.075,1.023V9.329H2.4a1.375,1.375,0,0,0-.992.428A1.494,1.494,0,0,0,1,10.791v7.6a1.434,1.434,0,0,0,1.4,1.462h.672v5.2A1.042,1.042,0,0,0,4.1,26.082H21.418a1.034,1.034,0,0,0,1.017-1.023v-5.2h.635a1.434,1.434,0,0,0,1.4-1.462v-7.6a1.494,1.494,0,0,0-.411-1.034A1.375,1.375,0,0,0,23.071,9.329ZM4.847,1.8h9.071V7.766a.522.522,0,0,0,.144.362.481.481,0,0,0,.347.15h6.207V9.33H4.847Zm0,22.488V19.855H20.616v4.429Zm10.878-22.3.5.566,3.366,3.721.185.225H16.338q-.39,0-.493-.129a.727.727,0,0,1-.12-.409ZM3.608,18.56V10.736h2.5a8.948,8.948,0,0,1,1.853.117,2.023,2.023,0,0,1,1.111.766,2.452,2.452,0,0,1,.448,1.524,2.582,2.582,0,0,1-.258,1.212,2.137,2.137,0,0,1-.655.771A2.244,2.244,0,0,1,7.8,15.5a8.777,8.777,0,0,1-1.616.112H5.167V18.56Zm1.558-6.5v2.22H6.02a3.978,3.978,0,0,0,1.232-.123,1.025,1.025,0,0,0,.487-.384,1.062,1.062,0,0,0,.176-.608,1.019,1.019,0,0,0-.247-.7,1.074,1.074,0,0,0-.627-.347,7.39,7.39,0,0,0-1.121-.053Zm5.269-1.324h2.848a5.49,5.49,0,0,1,1.469.149,2.575,2.575,0,0,1,1.164.721,3.429,3.429,0,0,1,.737,1.268,5.848,5.848,0,0,1,.253,1.849,5.208,5.208,0,0,1-.237,1.665,3.458,3.458,0,0,1-.827,1.382,2.73,2.73,0,0,1-1.1.624,4.654,4.654,0,0,1-1.379.165H10.435Zm1.558,1.324v5.183h1.164a4.19,4.19,0,0,0,.942-.075,1.432,1.432,0,0,0,.629-.326,1.663,1.663,0,0,0,.408-.755,5.171,5.171,0,0,0,.158-1.433,4.735,4.735,0,0,0-.158-1.393,1.8,1.8,0,0,0-.442-.758,1.476,1.476,0,0,0-.721-.368,6.971,6.971,0,0,0-1.279-.075Zm5.885,6.5V10.736H23.17v1.324H19.437v1.852h3.222v1.324H19.437V18.56Z", transform: "translate(80.263 234.959)", fill: "#3f567e" })
      )
    ),
    Copy: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
      y.createElement(
        "g",
        { id: "Group_8178", "data-name": "Group 8178", transform: "translate(-336 -700)" },
        y.createElement("rect", { id: "Rectangle_7130", "data-name": "Rectangle 7130", width: "24", height: "24", transform: "translate(336 700)", fill: "none" }),
        y.createElement(
          "g",
          { id: "copy", transform: "translate(323.653 705)" },
          y.createElement("path", { id: "Path_20574", "data-name": "Path 20574", d: "M28.738,0H22.63A1.582,1.582,0,0,0,21.02,1.549v.19H19.956a1.582,1.582,0,0,0-1.609,1.549v9.161A1.582,1.582,0,0,0,19.956,14h6.108a1.582,1.582,0,0,0,1.609-1.549v-.19h1.064a1.582,1.582,0,0,0,1.609-1.549V1.549A1.582,1.582,0,0,0,28.738,0Zm-2.1,12.451a.562.562,0,0,1-.571.55H19.956a.562.562,0,0,1-.571-.55V3.289a.562.562,0,0,1,.571-.55h6.108a.561.561,0,0,1,.571.55v9.161Zm2.673-1.74a.562.562,0,0,1-.571.55H27.674V3.289A1.582,1.582,0,0,0,26.065,1.74H22.058v-.19A.562.562,0,0,1,22.63,1h6.108a.562.562,0,0,1,.571.55Z", transform: "translate(0 0)", className: "fill-primary" })
        )
      )
    ),
    Search: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
      y.createElement(
        "g",
        { id: "Group_8408", "data-name": "Group 8408", transform: "translate(-257.718 -7)" },
        y.createElement("path", { id: "download", d: "M21.054,19.855l-4.436-4.425a6.4,6.4,0,1,0-.938.938L20.1,20.8a.671.671,0,1,0,.949-.949ZM6.583,11.4a5.065,5.065,0,1,1,5.065,5.065A5.065,5.065,0,0,1,6.583,11.4Z", transform: "translate(256.468 6.301)", className: "fill-neutral-110 dark:fill-neutral-40" }),
        y.createElement("rect", { id: "Rectangle_7245", "data-name": "Rectangle 7245", width: "24", height: "24", transform: "translate(257.718 7)", fill: "none" })
      )
    ),
    Salary: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "42", height: "42", viewBox: "0 0 42 42" },
      y.createElement(
        "g",
        { id: "Group_8163", "data-name": "Group 8163", transform: "translate(-364 -193)" },
        y.createElement(
          "g",
          { id: "salary", transform: "translate(343.092 159.56)" },
          y.createElement("path", { id: "Path_20571", "data-name": "Path 20571", d: "M5,4H15a5,5,0,0,1,5,5V19s-2.963,1.07-5.923,2.438L10.191,23C7.521,21.8,0,19,0,19V9A5,5,0,0,1,5,4Z", transform: "translate(31.908 38.44)", fill: "#fbfcfe" }),
          y.createElement("path", { id: "Path_20571_-_Outline", "data-name": "Path 20571 - Outline", d: "M5,5A4,4,0,0,0,1,9v9.306c1.795.672,6.781,2.553,9.21,3.608l3.471-1.4C15.834,19.525,17.958,18.7,19,18.3V9a4,4,0,0,0-4-4H5M5,4H15a5,5,0,0,1,5,5V19s-2.963,1.07-5.923,2.438L10.191,23C7.521,21.8,0,19,0,19V9A5,5,0,0,1,5,4Z", transform: "translate(31.908 38.44)", fill: "#3f567e" }),
          y.createElement("path", { id: "Path_20568", "data-name": "Path 20568", d: "M58.933,173.787a.464.464,0,0,0-.634-.432l-16.391,6.438-16.391-6.438a.464.464,0,0,0-.634.432v11.068a4.418,4.418,0,0,0,4.419,4.418H54.514a4.418,4.418,0,0,0,4.419-4.419Zm-.928.681v10.387a3.49,3.49,0,0,1-3.491,3.491H29.3a3.49,3.49,0,0,1-3.491-3.491V174.468l15.927,6.256a.464.464,0,0,0,.339,0Z", transform: "translate(0 -119.38)", fill: "#3f567e", fillRule: "evenodd" }),
          y.createElement("path", { id: "Path_20569", "data-name": "Path 20569", d: "M25.812,54.408V48.786a3.49,3.49,0,0,1,1.735-3.017l.632-.368a.464.464,0,0,0-.467-.8l-.632.368a4.418,4.418,0,0,0-2.2,3.819v5.621a.464.464,0,1,0,.928,0Zm3.98-9.944L40.3,38.347a3.2,3.2,0,0,1,3.216,0c2.537,1.468,7.284,4.136,10.612,6.116a.464.464,0,1,0,.474-.8c-3.332-1.982-8.083-4.652-10.622-6.122a4.123,4.123,0,0,0-4.147,0l-10.51,6.116a.464.464,0,0,0,.467.8Zm25.879.932q.293.181.585.365A3.693,3.693,0,0,1,58,48.786v5.621a.464.464,0,0,0,.928,0V48.786a4.638,4.638,0,0,0-2.181-3.81q-.3-.187-.594-.371a.464.464,0,1,0-.487.79Z", fill: "#3f567e", fillRule: "evenodd" }),
          y.createElement(
            "g",
            { id: "layer1", transform: "translate(37.647 -756.492)" },
            y.createElement("path", { id: "path4158", d: "M4.962,814.793.477,809.182.5,808.069c2.1.145,3.741-.078,4.122-2.069L.14,805.975l.726-1.215,3.577.051C3.9,803.678,2.4,803.539.062,803.622l.8-1.19,7.6-.011L7.71,803.6H5.61a2.147,2.147,0,0,1,.674,1.267l2.178-.026L7.71,806l-1.452.026c-.227,1.736-1.821,2.763-3.837,3l4.515,5.765H4.962Z", transform: "translate(0 0)", fill: "#3f567e" })
          )
        ),
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "42", height: "42", transform: "translate(364 193)", fill: "none" })
      )
    ),
    TrendingDown: y.createElement(
      "svg",
      { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { className: "stroke-error", d: "M13 17H21M21 17V9M21 17L13 9L9 13L3 7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    TrendingUp: y.createElement(
      "svg",
      { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { className: "stroke-success", d: "M13 7H21M21 7V15M21 7L13 15L9 11L3 17", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Hamburger: y.createElement(
      "svg",
      { className: t, xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26" },
      y.createElement(
        "g",
        { id: "Group_7165", "data-name": "Group 7165", transform: "translate(-50.529 -290.529)" },
        y.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "26", height: "26", transform: "translate(50.529 290.529)", fill: "none" }),
        y.createElement(
          "g",
          { id: "Group_7166", "data-name": "Group 7166", transform: "translate(-350.74 275.848)" },
          y.createElement(
            "g",
            { id: "Group_7135", "data-name": "Group 7135", transform: "translate(406 21)" },
            y.createElement("path", { id: "Line_15895", "data-name": "Line 15895", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 -0.318)", className: "fill-neutral-110 dark:fill-neutral-40" }),
            y.createElement("path", { id: "Line_15896", "data-name": "Line 15896", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 6.682)", className: "fill-neutral-110 dark:fill-neutral-40" }),
            y.createElement("path", { id: "Line_15897", "data-name": "Line 15897", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 13.682)", className: "fill-neutral-110 dark:fill-neutral-40" })
          )
        )
      )
    ),
    Star: y.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", className: t },
      y.createElement(
        "g",
        { id: "Group_8410", "data-name": "Group 8410", transform: "translate(-5635 -21929)" },
        y.createElement("rect", { id: "Rectangle_7246", "data-name": "Rectangle 7246", width: "16", height: "16", transform: "translate(5635 21929)", fill: "none" }),
        y.createElement("path", { id: "Polygon_61", "data-name": "Polygon 61", d: "M6.543,1.022a.5.5,0,0,1,.913,0l1.53,3.423a.5.5,0,0,0,.391.292l3.61.477a.5.5,0,0,1,.286.852L10.586,8.714a.5.5,0,0,0-.141.446l.687,3.776a.5.5,0,0,1-.742.522L7.25,11.641a.5.5,0,0,0-.5,0L3.61,13.458a.5.5,0,0,1-.742-.522L3.555,9.16a.5.5,0,0,0-.141-.446L.728,6.065a.5.5,0,0,1,.286-.852l3.61-.477a.5.5,0,0,0,.391-.292Z", transform: "translate(5636 21930)", className: "fill-neutral-40" })
      )
    ),
    SuccessTick: y.createElement(
      "svg",
      { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: t },
      y.createElement(
        "g",
        { id: "check-svgrepo-com 1" },
        y.createElement(
          "g",
          { id: "Interface / Check" },
          y.createElement("path", { id: "Vector", d: "M5 12L10.0003 17L20 7", stroke: "#3CAF7F", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" })
        )
      )
    ),
    Resume: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "resume-svgrepo-com 2" },
        y.createElement(
          "g",
          { id: "Group 6975" },
          y.createElement(
            "g",
            { id: "Group 6974" },
            y.createElement("path", { id: "Line 3", d: "M3.82608 5.80872L3.82608 19.0261", stroke: "#FFA940", strokeWidth: "2.5", strokeLinecap: "round" })
          ),
          y.createElement("path", { id: "Polygon 1", d: "M9 6.43782L19.5 12.5L9 18.5622L9 6.43782Z", stroke: "#FFA940", strokeWidth: "2.5" })
        )
      )
    ),
    AlertFilled: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "alert-filled-svgrepo-com" },
        y.createElement(
          "g",
          { id: "Alert-Filled" },
          y.createElement(
            "g",
            { id: "Group" },
            y.createElement("path", { id: "Vector", d: "M12.8779 3.60947C12.4989 2.91461 11.5011 2.91461 11.1221 3.60948L2.80665 18.8545C2.44317 19.5209 2.92548 20.3333 3.68454 20.3333H20.3155C21.0745 20.3333 21.5568 19.5209 21.1934 18.8545L12.8779 3.60947ZM12.8333 16.8333C12.8333 17.2936 12.4602 17.6667 12 17.6667C11.5398 17.6667 11.1667 17.2936 11.1667 16.8333C11.1667 16.3731 11.5398 16 12 16C12.4602 16 12.8333 16.3731 12.8333 16.8333ZM12 15.1667C11.5398 15.1667 11.1667 14.7936 11.1667 14.3333V9.5C11.1667 9.03976 11.5398 8.66667 12 8.66667C12.4602 8.66667 12.8333 9.03976 12.8333 9.5V14.3333C12.8333 14.7936 12.4602 15.1667 12 15.1667Z", fill: "#F5222D" })
          )
        )
      )
    ),
    UserOutlined: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-outline/user" },
        y.createElement(
          "g",
          { id: "Vector" },
          y.createElement("path", { d: "M15.7508 6C15.7508 8.07107 14.0719 9.75 12.0008 9.75C9.92975 9.75 8.25082 8.07107 8.25082 6C8.25082 3.92893 9.92975 2.25 12.0008 2.25C14.0719 2.25 15.7508 3.92893 15.7508 6Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
          y.createElement("path", { d: "M4.50195 20.1182C4.57226 16.0369 7.90269 12.75 12.0008 12.75C16.099 12.75 19.4295 16.0371 19.4997 20.1185C17.2169 21.166 14.6772 21.75 12.0011 21.75C9.32481 21.75 6.78491 21.1659 4.50195 20.1182Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
        )
      )
    ),
    ContactOutlined: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-outline/identification" },
        y.createElement("path", { id: "Vector", d: "M15 9H18.75M15 12H18.75M15 15H18.75M4.5 19.5H19.5C20.7426 19.5 21.75 18.4926 21.75 17.25V6.75C21.75 5.50736 20.7426 4.5 19.5 4.5H4.5C3.25736 4.5 2.25 5.50736 2.25 6.75V17.25C2.25 18.4926 3.25736 19.5 4.5 19.5ZM10.5 9.375C10.5 10.4105 9.66053 11.25 8.625 11.25C7.58947 11.25 6.75 10.4105 6.75 9.375C6.75 8.33947 7.58947 7.5 8.625 7.5C9.66053 7.5 10.5 8.33947 10.5 9.375ZM11.7939 15.7114C10.8489 16.2147 9.77021 16.5 8.62484 16.5C7.47948 16.5 6.40074 16.2147 5.45581 15.7114C5.92986 14.4207 7.16983 13.5 8.62484 13.5C10.0799 13.5 11.3198 14.4207 11.7939 15.7114Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      )
    ),
    UsersOutlined: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-outline/users" },
        y.createElement("path", { id: "Vector", d: "M15 19.1276C15.8329 19.37 16.7138 19.5 17.625 19.5C19.1037 19.5 20.5025 19.1576 21.7464 18.5478C21.7488 18.4905 21.75 18.4329 21.75 18.375C21.75 16.0968 19.9031 14.25 17.625 14.25C16.2069 14.25 14.956 14.9655 14.2136 16.0552M15 19.1276V19.125C15 18.0121 14.7148 16.9658 14.2136 16.0552M15 19.1276C15 19.1632 14.9997 19.1988 14.9991 19.2343C13.1374 20.3552 10.9565 21 8.625 21C6.29353 21 4.11264 20.3552 2.25092 19.2343C2.25031 19.198 2.25 19.1615 2.25 19.125C2.25 15.6042 5.10418 12.75 8.625 12.75C11.0329 12.75 13.129 14.085 14.2136 16.0552M12 6.375C12 8.23896 10.489 9.75 8.625 9.75C6.76104 9.75 5.25 8.23896 5.25 6.375C5.25 4.51104 6.76104 3 8.625 3C10.489 3 12 4.51104 12 6.375ZM20.25 8.625C20.25 10.0747 19.0747 11.25 17.625 11.25C16.1753 11.25 15 10.0747 15 8.625C15 7.17525 16.1753 6 17.625 6C19.0747 6 20.25 7.17525 20.25 8.625Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      )
    ),
    financeOutlined: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-outline/banknotes" },
        y.createElement("path", { id: "Vector", d: "M2.25 18.75C7.71719 18.75 13.0136 19.4812 18.0468 20.8512C18.7738 21.0491 19.5 20.5086 19.5 19.7551V18.75M3.75 4.5V5.25C3.75 5.66421 3.41421 6 3 6H2.25M2.25 6V5.625C2.25 5.00368 2.75368 4.5 3.375 4.5H20.25M2.25 6V15M20.25 4.5V5.25C20.25 5.66421 20.5858 6 21 6H21.75M20.25 4.5H20.625C21.2463 4.5 21.75 5.00368 21.75 5.625V15.375C21.75 15.9963 21.2463 16.5 20.625 16.5H20.25M21.75 15H21C20.5858 15 20.25 15.3358 20.25 15.75V16.5M20.25 16.5H3.75M3.75 16.5H3.375C2.75368 16.5 2.25 15.9963 2.25 15.375V15M3.75 16.5V15.75C3.75 15.3358 3.41421 15 3 15H2.25M15 10.5C15 12.1569 13.6569 13.5 12 13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5C13.6569 7.5 15 8.84315 15 10.5ZM18 10.5H18.0075V10.5075H18V10.5ZM6 10.5H6.0075V10.5075H6V10.5Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      )
    ),
    BankOutlined: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { id: "heroicons-outline/building-library" },
        y.createElement("path", { id: "Vector", d: "M12 21V12.75M15.75 21V12.75M8.25 21V12.75M3 9L12 3L21 9M19.5 21V10.3325C17.0563 9.94906 14.5514 9.75 12 9.75C9.44861 9.75 6.94372 9.94906 4.5 10.3325V21M3 21H21M12 6.75H12.0075V6.7575H12V6.75Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      )
    ),
    Plus: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M10.0003 4.16699V15.8337M4.16699 10.0003H15.8337", className: "stroke-primary", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Home: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M11.9004 2.53373C11.5784 2.28324 11.4174 2.158 11.2396 2.10986C11.0827 2.06738 10.9173 2.06738 10.7604 2.10986C10.5826 2.158 10.4216 2.28324 10.0996 2.53373L3.88244 7.36926C3.46685 7.69249 3.25906 7.85411 3.10936 8.05651C2.97675 8.2358 2.87797 8.43778 2.81786 8.65252C2.75 8.89495 2.75 9.1582 2.75 9.68469V16.3167C2.75 17.3435 2.75 17.8569 2.94982 18.249C3.12559 18.594 3.40605 18.8745 3.75102 19.0502C4.14319 19.25 4.65657 19.25 5.68333 19.25H7.51667C7.77336 19.25 7.9017 19.25 7.99975 19.2001C8.08599 19.1562 8.1561 19.086 8.20004 18.9998C8.25 18.9018 8.25 18.7734 8.25 18.5167V12.4667C8.25 11.9533 8.25 11.6966 8.34991 11.5006C8.43779 11.3281 8.57803 11.1878 8.75051 11.1C8.94659 11 9.20329 11 9.71667 11H12.2833C12.7967 11 13.0534 11 13.2495 11.1C13.422 11.1878 13.5622 11.3281 13.6501 11.5006C13.75 11.6966 13.75 11.9533 13.75 12.4667V18.5167C13.75 18.7734 13.75 18.9018 13.8 18.9998C13.8439 19.086 13.914 19.1562 14.0003 19.2001C14.0983 19.25 14.2266 19.25 14.4833 19.25H16.3167C17.3434 19.25 17.8568 19.25 18.249 19.0502C18.5939 18.8745 18.8744 18.594 19.0502 18.249C19.25 17.8569 19.25 17.3435 19.25 16.3167V9.68469C19.25 9.1582 19.25 8.89495 19.1821 8.65252C19.122 8.43778 19.0232 8.2358 18.8906 8.05651C18.7409 7.85411 18.5331 7.69249 18.1176 7.36926L11.9004 2.53373Z", className: "stroke-neutral-60", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Transaction: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M7.33301 6.41667L18.333 6.41667M18.333 6.41667L14.6663 2.75M18.333 6.41667L14.6663 10.0833M14.6663 15.5833L3.66634 15.5833M3.66634 15.5833L7.33301 19.25M3.66634 15.5833L7.33301 11.9167", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Users: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("ellipse", { cx: "8.24967", cy: "6.41667", rx: "3.66667", ry: "3.66667", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M2.75 19.25V17.4167C2.75 15.3916 4.39162 13.75 6.41667 13.75H10.0833C12.1084 13.75 13.75 15.3916 13.75 17.4167V19.25", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M14.667 2.86908C16.2894 3.28449 17.4242 4.7464 17.4242 6.42116C17.4242 8.09592 16.2894 9.55784 14.667 9.97325", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M19.25 19.2499V17.4166C19.2404 15.7524 18.1113 14.3034 16.5 13.8874", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Bell: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M13.7485 17.4167C13.7485 18.9355 12.5173 20.1667 10.9985 20.1667C9.47974 20.1667 8.24852 18.9355 8.24852 17.4167M12.6453 5.71872C13.0445 5.3063 13.2902 4.74436 13.2902 4.12504C13.2902 2.85939 12.2642 1.83337 10.9985 1.83337C9.73287 1.83337 8.70686 2.85939 8.70686 4.12504C8.70686 4.74436 8.95253 5.3063 9.35173 5.71872M16.4985 10.2667C16.4985 9.00251 15.9191 7.79009 14.8876 6.89617C13.8562 6.00224 12.4572 5.50004 10.9985 5.50004C9.53983 5.50004 8.14089 6.00224 7.10944 6.89617C6.07799 7.79009 5.49852 9.00251 5.49852 10.2667C5.49852 12.3584 4.97981 13.8881 4.33258 14.9827C3.59492 16.2302 3.22608 16.854 3.24065 17.003C3.25731 17.1734 3.288 17.2272 3.42625 17.3283C3.5471 17.4167 4.15424 17.4167 5.36853 17.4167H16.6285C17.8428 17.4167 18.45 17.4167 18.5708 17.3283C18.7091 17.2272 18.7397 17.1734 18.7564 17.003C18.771 16.854 18.4021 16.2302 17.6645 14.9827C17.0172 13.8881 16.4985 12.3584 16.4985 10.2667Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Filter: y.createElement(
      "svg",
      { className: t, width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M8.99961 4.95156V3.60156M8.99961 4.95156C8.25402 4.95156 7.64961 5.55598 7.64961 6.30156C7.64961 7.04715 8.25402 7.65156 8.99961 7.65156M8.99961 4.95156C9.74519 4.95156 10.3496 5.55598 10.3496 6.30156C10.3496 7.04715 9.74519 7.65156 8.99961 7.65156M4.94961 13.0516C5.69519 13.0516 6.29961 12.4471 6.29961 11.7016C6.29961 10.956 5.69519 10.3516 4.94961 10.3516M4.94961 13.0516C4.20402 13.0516 3.59961 12.4471 3.59961 11.7016C3.59961 10.956 4.20402 10.3516 4.94961 10.3516M4.94961 13.0516V14.4016M4.94961 10.3516V3.60156M8.99961 7.65156V14.4016M13.0496 13.0516C13.7952 13.0516 14.3996 12.4471 14.3996 11.7016C14.3996 10.956 13.7952 10.3516 13.0496 10.3516M13.0496 13.0516C12.304 13.0516 11.6996 12.4471 11.6996 11.7016C11.6996 10.956 12.304 10.3516 13.0496 10.3516M13.0496 13.0516V14.4016M13.0496 10.3516V3.60156", stroke: "#8B909A", strokeWidth: "1.35", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Config: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M6.36699 6.31548L9.96699 9.91548M6.36699 6.31548H3.96699L3.16699 3.91548L3.96699 3.11548L6.36699 3.91548V6.31548ZM9.96699 9.91548L10.0926 9.78985M9.96699 9.91548L4.36699 15.5155M14.767 11.9155C17.197 11.9155 19.167 9.94553 19.167 7.51548C19.167 6.92379 19.0502 6.35939 18.8384 5.84405L16.8721 7.81038C16.5553 8.12719 16.3969 8.2856 16.2142 8.34495C16.0535 8.39716 15.8805 8.39716 15.7198 8.34495C15.5371 8.2856 15.3787 8.12719 15.0619 7.81038L14.8721 7.62057C14.5553 7.30376 14.3969 7.14535 14.3375 6.96269C14.2853 6.80202 14.2853 6.62894 14.3375 6.46826C14.3969 6.2856 14.5553 6.12719 14.8721 5.81038L16.9742 3.70829C16.3254 3.33134 15.5714 3.11548 14.767 3.11548C12.3369 3.11548 10.367 5.08543 10.367 7.51548C10.367 7.80844 10.3956 8.09472 10.4502 8.37167C10.5269 8.76058 10.5653 8.95504 10.5536 9.07293C10.5411 9.19825 10.5223 9.26002 10.4628 9.37107C10.4069 9.47552 10.3022 9.5803 10.0926 9.78985M14.767 11.9155C14.6254 11.9155 14.4854 11.9088 14.3472 11.8957M14.767 11.9155C14.6205 11.9155 14.4757 11.9083 14.3329 11.8943M10.0926 9.78985L4.36699 15.5155M4.36699 15.5155C3.70425 16.1782 3.70425 17.2527 4.36699 17.9155C5.02973 18.5782 6.10425 18.5782 6.76699 17.9155M12.4926 12.1899L6.76699 17.9155M12.4926 12.1899C12.6619 12.0205 12.7629 11.9196 12.8505 11.8576M12.4926 12.1899L12.7187 11.9637M12.4926 12.1899L11.167 13.5154M6.76699 17.9155L11.167 13.5154M11.167 13.5154L15.567 17.9154C16.2297 18.5781 17.3042 18.5781 17.967 17.9154C18.6297 17.2526 18.6297 16.1781 17.967 15.5154L14.3472 11.8957M11.167 13.5154L12.7187 11.9637M14.3472 11.8957C14.3425 11.8953 14.3377 11.8948 14.3329 11.8943M12.7187 11.9637C12.7593 11.9231 12.8035 11.8878 12.8505 11.8576M13.9092 11.8319C13.8047 11.8113 13.7014 11.7869 13.5996 11.7589C13.4781 11.7256 13.352 11.7147 13.2298 11.7274M13.9092 11.8319C13.6185 11.7746 13.4366 11.7387 13.3142 11.7293C13.2823 11.7269 13.2545 11.7262 13.2298 11.7274M13.9092 11.8319L13.9108 11.8322C14.0493 11.8595 14.1901 11.8803 14.3329 11.8943M13.9092 11.8319C14.0482 11.8594 14.1895 11.8803 14.3329 11.8943M13.2298 11.7274C13.0947 11.7415 12.9644 11.7844 12.8505 11.8576M13.2298 11.7274C13.2228 11.7278 13.2161 11.7283 13.2095 11.7289C13.0842 11.7414 13.0224 11.7602 12.9114 11.8196C12.8913 11.8304 12.8713 11.8429 12.8505 11.8576", stroke: "#6F809E", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Data: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M7.9375 14.5833L7.25 17.3333L6.33333 18.25H13.6667L12.75 17.3333L12.0625 14.5833M1.75 10.9167H18.25M3.58333 14.5833H16.4167C17.4292 14.5833 18.25 13.7625 18.25 12.75V3.58333C18.25 2.57081 17.4292 1.75 16.4167 1.75H3.58333C2.57081 1.75 1.75 2.57081 1.75 3.58333V12.75C1.75 13.7625 2.57081 14.5833 3.58333 14.5833Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Operation: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M8.99902 9.63872C8.99902 9.4147 8.99902 9.30269 9.04262 9.21712C9.08097 9.14186 9.14216 9.08067 9.21743 9.04232C9.30299 8.99872 9.415 8.99872 9.63902 8.99872H12.359C12.583 8.99872 12.6951 8.99872 12.7806 9.04232C12.8559 9.08067 12.9171 9.14186 12.9554 9.21712C12.999 9.30269 12.999 9.4147 12.999 9.63872V12.3587C12.999 12.5827 12.999 12.6947 12.9554 12.7803C12.9171 12.8556 12.8559 12.9168 12.7806 12.9551C12.6951 12.9987 12.583 12.9987 12.359 12.9987H9.63902C9.415 12.9987 9.30299 12.9987 9.21743 12.9551C9.14216 12.9168 9.08097 12.8556 9.04262 12.7803C8.99902 12.6947 8.99902 12.5827 8.99902 12.3587V9.63872Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M14.999 15.6387C14.999 15.4147 14.999 15.3027 15.0426 15.2171C15.081 15.1419 15.1422 15.0807 15.2174 15.0423C15.303 14.9987 15.415 14.9987 15.639 14.9987H18.359C18.583 14.9987 18.6951 14.9987 18.7806 15.0423C18.8559 15.0807 18.9171 15.1419 18.9554 15.2171C18.999 15.3027 18.999 15.4147 18.999 15.6387V18.3587C18.999 18.5827 18.999 18.6947 18.9554 18.7803C18.9171 18.8556 18.8559 18.9168 18.7806 18.9551C18.6951 18.9987 18.583 18.9987 18.359 18.9987H15.639C15.415 18.9987 15.303 18.9987 15.2174 18.9551C15.1422 18.9168 15.081 18.8556 15.0426 18.7803C14.999 18.6947 14.999 18.5827 14.999 18.3587V15.6387Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M2.99902 3.63872C2.99902 3.4147 2.99902 3.30269 3.04262 3.21712C3.08097 3.14186 3.14216 3.08067 3.21743 3.04232C3.30299 2.99872 3.415 2.99872 3.63902 2.99872H6.35902C6.58304 2.99872 6.69506 2.99872 6.78062 3.04232C6.85588 3.08067 6.91708 3.14186 6.95543 3.21712C6.99902 3.30269 6.99902 3.4147 6.99902 3.63872V6.35872C6.99902 6.58274 6.99902 6.69475 6.95543 6.78031C6.91708 6.85558 6.85588 6.91677 6.78062 6.95512C6.69506 6.99872 6.58304 6.99872 6.35902 6.99872H3.63902C3.415 6.99872 3.30299 6.99872 3.21743 6.95512C3.14216 6.91677 3.08097 6.85558 3.04262 6.78031C2.99902 6.69475 2.99902 6.58274 2.99902 6.35872V3.63872Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M10.199 4.99872H16.039C16.9351 4.99872 17.3832 4.99872 17.7254 5.17311C18.0265 5.32651 18.2712 5.57127 18.4246 5.87233C18.599 6.21459 18.599 6.66263 18.599 7.55872V8.59872C18.599 9.34423 18.599 9.71698 18.4772 10.011C18.3148 10.4031 18.0034 10.7145 17.6113 10.8769C17.3173 10.9987 16.9445 10.9987 16.199 10.9987M11.799 16.9987H5.95902C5.06294 16.9987 4.6149 16.9987 4.27264 16.8243C3.97158 16.6709 3.72681 16.4262 3.57341 16.1251C3.39902 15.7828 3.39902 15.3348 3.39902 14.4387V13.3987C3.39902 12.6532 3.39902 12.2805 3.52082 11.9864C3.68321 11.5944 3.99469 11.2829 4.38673 11.1205C4.68076 10.9987 5.05352 10.9987 5.79902 10.9987M9.63902 12.9987H12.359C12.583 12.9987 12.6951 12.9987 12.7806 12.9551C12.8559 12.9168 12.9171 12.8556 12.9554 12.7803C12.999 12.6948 12.999 12.5827 12.999 12.3587V9.63872C12.999 9.4147 12.999 9.30269 12.9554 9.21712C12.9171 9.14186 12.8559 9.08067 12.7806 9.04232C12.6951 8.99872 12.583 8.99872 12.359 8.99872H9.63902C9.415 8.99872 9.30299 8.99872 9.21743 9.04232C9.14216 9.08067 9.08097 9.14186 9.04262 9.21712C8.99902 9.30269 8.99902 9.4147 8.99902 9.63872V12.3587C8.99902 12.5827 8.99902 12.6948 9.04262 12.7803C9.08097 12.8556 9.14216 12.9168 9.21743 12.9551C9.30299 12.9987 9.415 12.9987 9.63902 12.9987ZM15.639 18.9987H18.359C18.583 18.9987 18.6951 18.9987 18.7806 18.9551C18.8559 18.9168 18.9171 18.8556 18.9554 18.7803C18.999 18.6948 18.999 18.5827 18.999 18.3587V15.6387C18.999 15.4147 18.999 15.3027 18.9554 15.2171C18.9171 15.1419 18.8559 15.0807 18.7806 15.0423C18.6951 14.9987 18.583 14.9987 18.359 14.9987H15.639C15.415 14.9987 15.303 14.9987 15.2174 15.0423C15.1422 15.0807 15.081 15.1419 15.0426 15.2171C14.999 15.3027 14.999 15.4147 14.999 15.6387V18.3587C14.999 18.5827 14.999 18.6948 15.0426 18.7803C15.081 18.8556 15.1422 18.9168 15.2174 18.9551C15.303 18.9987 15.415 18.9987 15.639 18.9987ZM3.63902 6.99872H6.35902C6.58304 6.99872 6.69506 6.99872 6.78062 6.95512C6.85588 6.91677 6.91708 6.85558 6.95543 6.78031C6.99902 6.69475 6.99902 6.58274 6.99902 6.35872V3.63872C6.99902 3.4147 6.99902 3.30269 6.95543 3.21712C6.91708 3.14186 6.85588 3.08067 6.78062 3.04232C6.69506 2.99872 6.58304 2.99872 6.35902 2.99872H3.63902C3.415 2.99872 3.30299 2.99872 3.21743 3.04232C3.14216 3.08067 3.08097 3.14186 3.04262 3.21712C2.99902 3.30269 2.99902 3.4147 2.99902 3.63872V6.35872C2.99902 6.58274 2.99902 6.69475 3.04262 6.78031C3.08097 6.85558 3.14216 6.91677 3.21743 6.95512C3.30299 6.99872 3.415 6.99872 3.63902 6.99872Z", stroke: "#6F809E", strokeWidth: "1.83333", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    PlusDark: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M10.0003 4.16699V15.8337M4.16699 10.0003H15.8337", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-base-color dark:stroke-neutral-40" })
    ),
    Collapse: y.createElement(
      "svg",
      { className: t, width: "11", height: "10", viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M10 1L6.25 4.75L10 8.5M4.75 1L1 4.75L4.75 8.5", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Download: y.createElement(
      "svg",
      { width: "20", height: "20", viewBox: "0 0 20 20", className: t, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M6.66699 9.99999L10.0003 13.3333M10.0003 13.3333L13.3337 9.99999M10.0003 13.3333V6.66666M18.3337 9.99999C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 9.99999C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 9.99999Z", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-base-color dark:stroke-neutral-40" })
    ),
    Developer: y.createElement(
      "svg",
      { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: t },
      y.createElement("path", { d: "M9.16634 18.3346L12.833 3.66797M16.4997 7.33464L20.1663 11.0013L16.4997 14.668M5.49967 14.668L1.83301 11.0013L5.49967 7.33464", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Action: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M17.4445 2.55546C18.5185 3.6294 18.5185 5.3706 17.4445 6.44454C16.3706 7.51849 14.6294 7.51849 13.5555 6.44454C12.4815 5.3706 12.4815 3.6294 13.5555 2.55546C14.6294 1.48151 16.3706 1.48151 17.4445 2.55546Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M9.08333 2.66667H6.15C4.60986 2.66667 3.83978 2.66667 3.25153 2.9664C2.73408 3.23005 2.31338 3.65075 2.04973 4.16819C1.75 4.75645 1.75 5.52652 1.75 7.06667V13.85C1.75 15.3901 1.75 16.1602 2.04973 16.7485C2.31338 17.2659 2.73408 17.6866 3.25153 17.9503C3.83978 18.25 4.60986 18.25 6.15 18.25H12.9333C14.4735 18.25 15.2436 18.25 15.8318 17.9503C16.3493 17.6866 16.7699 17.2659 17.0336 16.7485C17.3333 16.1602 17.3333 15.3901 17.3333 13.85V10.9167M10.9167 14.5833H5.41667M12.75 10.9167H5.41667M17.4445 2.55546C18.5185 3.6294 18.5185 5.3706 17.4445 6.44454C16.3706 7.51849 14.6294 7.51849 13.5555 6.44454C12.4815 5.3706 12.4815 3.6294 13.5555 2.55546C14.6294 1.48151 16.3706 1.48151 17.4445 2.55546Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    infoError: y.createElement(
      "svg",
      { className: t, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 0.631581C3.0351 0.631581 0.631581 3.0351 0.631581 6C0.631581 8.9649 3.0351 11.3684 6 11.3684C8.9649 11.3684 11.3684 8.9649 11.3684 6C11.3684 3.0351 8.9649 0.631581 6 0.631581ZM5.73704 4.54905C5.20532 4.79675 4.75309 5.22389 4.30051 5.84841C4.23597 5.93747 4.23336 5.99158 4.29967 6.03944C4.34628 6.07309 4.37337 6.06233 4.44127 5.98989C4.45035 5.98013 4.45035 5.98013 4.45964 5.97006C4.51834 5.90649 4.56562 5.85256 4.66661 5.73527C5.00031 5.34774 5.16331 5.18824 5.41663 5.04236C5.63585 4.91612 5.82851 5.10164 5.79182 5.33905C5.78153 5.4057 5.7638 5.45489 5.71813 5.5605C5.69996 5.60251 5.69229 5.62079 5.68377 5.64319C5.60144 5.85962 5.53209 6.04017 5.38678 6.41725L5.37983 6.43529C5.33589 6.5493 5.33589 6.5493 5.292 6.66329C5.10169 7.1579 4.98621 7.4612 4.86706 7.78196L4.86007 7.80076C4.83876 7.85796 4.81753 7.91519 4.79639 7.97244C4.65986 8.34268 4.58178 8.58325 4.5224 8.83912C4.51312 8.87893 4.51312 8.87893 4.50373 8.9194C4.47027 9.06414 4.45236 9.15741 4.44235 9.25328C4.42504 9.41904 4.43896 9.55478 4.49105 9.66886C4.55 9.79795 4.67666 9.89029 4.82117 9.91127C5.06191 9.94622 5.29419 9.94373 5.49314 9.89847C5.6051 9.87301 5.71588 9.83969 5.82457 9.79883C6.13928 9.68051 6.44246 9.49588 6.73611 9.25183C6.99305 9.03771 7.23616 8.77683 7.49104 8.45263C7.51326 8.42456 7.51326 8.42456 7.5354 8.39653C7.61239 8.29836 7.6501 8.23461 7.66418 8.16726C7.67949 8.09415 7.61769 8.02005 7.56829 8.04484C7.54387 8.05709 7.51833 8.08246 7.47941 8.13154C7.45158 8.16726 7.43644 8.18636 7.4213 8.20351C7.36086 8.27194 7.29703 8.34199 7.22788 8.41599C7.11388 8.53795 6.99804 8.65729 6.83003 8.82718C6.74447 8.9137 6.63686 8.98934 6.52116 9.04621C6.33597 9.13721 6.16892 9.02251 6.18898 8.81724C6.20222 8.68174 6.23504 8.54164 6.28413 8.4062C6.39136 8.11016 6.47902 7.87083 6.67298 7.3434C6.7571 7.11465 6.79342 7.01584 6.83878 6.89214C6.97327 6.52557 7.08063 6.23047 7.18278 5.94574C7.30897 5.59402 7.38026 5.33184 7.41326 5.06109C7.43818 4.85689 7.38137 4.66158 7.2518 4.52731C7.10814 4.37846 6.9038 4.30989 6.64931 4.31291C6.36773 4.31625 6.03926 4.40826 5.73704 4.54905ZM7.66442 2.12141C7.1584 1.92454 6.55121 2.26276 6.44953 2.79848C6.37581 3.18675 6.52086 3.52198 6.81691 3.66238C7.40377 3.9407 8.10808 3.49474 8.10811 2.84472C8.10814 2.48312 7.9537 2.23398 7.66442 2.12141Z", fill: "#FF2E00" })
    ),
    Pending: y.createElement(
      "svg",
      { className: t, width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("circle", { cx: "4", cy: "4", r: "4", fill: "#FF2E00" })
    ),
    UserProfile: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("circle", { cx: "11", cy: "11", r: "8.25", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("ellipse", { cx: "11", cy: "9.16666", rx: "2.75", ry: "2.75", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M5.65381 17.2782C6.11969 15.7277 7.54742 14.6662 9.16648 14.6667H12.8331C14.4544 14.6661 15.8836 15.7303 16.3476 17.2837", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    UserFilled: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M20.1666 19.25V17.4167C20.1666 15.7081 18.998 14.2726 17.4166 13.8655M14.2083 3.01653C15.552 3.56047 16.4999 4.87787 16.4999 6.41667C16.4999 7.95547 15.552 9.27287 14.2083 9.8168M15.5833 19.25C15.5833 17.5415 15.5833 16.6873 15.3041 16.0135C14.932 15.1151 14.2182 14.4013 13.3198 14.0291C12.6459 13.75 11.7917 13.75 10.0833 13.75H7.33325C5.6248 13.75 4.77057 13.75 4.09675 14.0291C3.19831 14.4013 2.4845 15.1151 2.11236 16.0135C1.83325 16.6873 1.83325 17.5415 1.83325 19.25M12.3749 6.41667C12.3749 8.44171 10.7333 10.0833 8.70825 10.0833C6.68321 10.0833 5.04159 8.44171 5.04159 6.41667C5.04159 4.39162 6.68321 2.75 8.70825 2.75C10.7333 2.75 12.3749 4.39162 12.3749 6.41667Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    ExternalLink: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14", stroke: "#3E74FF", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    ExternalLinkWhite: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14", stroke: "#ffffff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    InfoGrey: y.createElement(
      "svg",
      { className: t, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M7.99999 10.6667V8M7.99999 5.33334H8.00666M14.6667 8C14.6667 11.6819 11.6819 14.6667 7.99999 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33334 7.99999 1.33334C11.6819 1.33334 14.6667 4.3181 14.6667 8Z", stroke: "#6F809E", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    InfoWhite: y.createElement(
      "svg",
      { className: t, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M8.00001 10.6667V8M8.00001 5.33333H8.00668M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8C1.33334 4.3181 4.31811 1.33333 8.00001 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z", stroke: "white", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    tickWhite: y.createElement(
      "svg",
      { className: t, width: "12", height: "9", viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M11.3333 1L4.00001 8.33333L0.666672 5", stroke: "white", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    CrossGrey: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M7.5364 6.2636C7.18492 5.91213 6.61508 5.91213 6.2636 6.2636C5.91213 6.61508 5.91213 7.18492 6.2636 7.5364L10.7272 12L6.2636 16.4636C5.91213 16.8151 5.91213 17.3849 6.2636 17.7364C6.61508 18.0879 7.18492 18.0879 7.5364 17.7364L12 13.2728L16.4636 17.7364C16.8151 18.0879 17.3849 18.0879 17.7364 17.7364C18.0879 17.3849 18.0879 16.8151 17.7364 16.4636L13.2728 12L17.7364 7.5364C18.0879 7.18492 18.0879 6.61508 17.7364 6.2636C17.3849 5.91213 16.8151 5.91213 16.4636 6.2636L12 10.7272L7.5364 6.2636Z", fill: "#6F809E" })
    ),
    CrossWhite: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M7.5364 6.2636C7.18492 5.91213 6.61508 5.91213 6.2636 6.2636C5.91213 6.61508 5.91213 7.18492 6.2636 7.5364L10.7272 12L6.2636 16.4636C5.91213 16.8151 5.91213 17.3849 6.2636 17.7364C6.61508 18.0879 7.18492 18.0879 7.5364 17.7364L12 13.2728L16.4636 17.7364C16.8151 18.0879 17.3849 18.0879 17.7364 17.7364C18.0879 17.3849 18.0879 16.8151 17.7364 16.4636L13.2728 12L17.7364 7.5364C18.0879 7.18492 18.0879 6.61508 17.7364 6.2636C17.3849 5.91213 16.8151 5.91213 16.4636 6.2636L12 10.7272L7.5364 6.2636Z", fill: "#ffffff" })
    ),
    InfoRed: y.createElement(
      "svg",
      { className: t, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 0.631581C3.0351 0.631581 0.631581 3.0351 0.631581 6C0.631581 8.9649 3.0351 11.3684 6 11.3684C8.9649 11.3684 11.3684 8.9649 11.3684 6C11.3684 3.0351 8.9649 0.631581 6 0.631581ZM5.73704 4.54905C5.20532 4.79675 4.75309 5.22389 4.30051 5.84841C4.23597 5.93747 4.23336 5.99158 4.29967 6.03944C4.34628 6.07309 4.37337 6.06233 4.44127 5.98989C4.45035 5.98013 4.45035 5.98013 4.45964 5.97006C4.51834 5.90649 4.56562 5.85256 4.66661 5.73527C5.00031 5.34774 5.16331 5.18824 5.41663 5.04236C5.63585 4.91612 5.82851 5.10164 5.79182 5.33905C5.78153 5.4057 5.7638 5.45489 5.71813 5.5605C5.69996 5.60251 5.69229 5.62079 5.68377 5.64319C5.60144 5.85962 5.53209 6.04017 5.38678 6.41725L5.37983 6.43529C5.33589 6.5493 5.33589 6.5493 5.292 6.66329C5.10169 7.1579 4.98621 7.4612 4.86706 7.78196L4.86007 7.80076C4.83876 7.85796 4.81753 7.91519 4.79639 7.97244C4.65986 8.34268 4.58178 8.58325 4.5224 8.83912C4.51312 8.87893 4.51312 8.87893 4.50373 8.9194C4.47027 9.06414 4.45236 9.15741 4.44235 9.25328C4.42504 9.41904 4.43896 9.55478 4.49105 9.66886C4.55 9.79795 4.67666 9.89029 4.82117 9.91127C5.06191 9.94622 5.29419 9.94373 5.49314 9.89847C5.6051 9.87301 5.71588 9.83969 5.82457 9.79883C6.13928 9.68051 6.44246 9.49588 6.73611 9.25183C6.99305 9.03771 7.23616 8.77683 7.49104 8.45263C7.51326 8.42456 7.51326 8.42456 7.5354 8.39653C7.61239 8.29836 7.6501 8.23461 7.66418 8.16726C7.67949 8.09415 7.61769 8.02005 7.56829 8.04484C7.54387 8.05709 7.51833 8.08246 7.47941 8.13154C7.45158 8.16726 7.43644 8.18636 7.4213 8.20351C7.36086 8.27194 7.29703 8.34199 7.22788 8.41599C7.11388 8.53795 6.99804 8.65729 6.83003 8.82718C6.74447 8.9137 6.63686 8.98934 6.52116 9.04621C6.33597 9.13721 6.16892 9.02251 6.18898 8.81724C6.20222 8.68174 6.23504 8.54164 6.28413 8.4062C6.39136 8.11016 6.47902 7.87083 6.67298 7.3434C6.7571 7.11465 6.79342 7.01584 6.83878 6.89214C6.97327 6.52557 7.08063 6.23047 7.18278 5.94574C7.30897 5.59402 7.38026 5.33184 7.41326 5.06109C7.43818 4.85689 7.38137 4.66158 7.2518 4.52731C7.10814 4.37846 6.9038 4.30989 6.64931 4.31291C6.36773 4.31625 6.03926 4.40826 5.73704 4.54905ZM7.66442 2.12141C7.1584 1.92454 6.55121 2.26276 6.44953 2.79848C6.37581 3.18675 6.52086 3.52198 6.81691 3.66238C7.40377 3.9407 8.10808 3.49474 8.10811 2.84472C8.10814 2.48312 7.9537 2.23398 7.66442 2.12141Z", fill: "#FF2E00" })
    ),
    Tenant: y.createElement(
      "svg",
      { className: t, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement(
        "g",
        { clipPath: "url(#clip0_131_9801)" },
        y.createElement("path", { d: "M3.66661 19.9995C4.21897 20.1668 4.96504 20.1668 6.23325 20.1668H15.7666C17.0348 20.1668 17.7809 20.1668 18.3332 19.9995M3.66661 19.9995C3.54817 19.9636 3.43864 19.92 3.33478 19.8671C2.81733 19.6034 2.39664 19.1827 2.13298 18.6653C1.83325 18.077 1.83325 17.307 1.83325 15.7668V6.2335C1.83325 4.69335 1.83325 3.92328 2.13298 3.33502C2.39664 2.81758 2.81733 2.39688 3.33478 2.13323C3.92304 1.8335 4.69311 1.8335 6.23325 1.8335H15.7666C17.3067 1.8335 18.0768 1.8335 18.6651 2.13323C19.1825 2.39688 19.6032 2.81758 19.8669 3.33502C20.1666 3.92328 20.1666 4.69335 20.1666 6.2335V15.7668C20.1666 17.307 20.1666 18.077 19.8669 18.6653C19.6032 19.1827 19.1825 19.6034 18.6651 19.8671C18.5612 19.92 18.4517 19.9636 18.3332 19.9995M3.66661 19.9995C3.66691 19.2576 3.67136 18.865 3.73704 18.5348C4.02636 17.0803 5.16339 15.9433 6.61792 15.6539C6.97212 15.5835 7.39805 15.5835 8.24992 15.5835H13.7499C14.6018 15.5835 15.0277 15.5835 15.3819 15.6539C16.8364 15.9433 17.9735 17.0803 18.2628 18.5348C18.3285 18.865 18.3329 19.2576 18.3332 19.9995M14.6666 8.7085C14.6666 10.7335 13.025 12.3752 10.9999 12.3752C8.97487 12.3752 7.33325 10.7335 7.33325 8.7085C7.33325 6.68345 8.97487 5.04183 10.9999 5.04183C13.025 5.04183 14.6666 6.68345 14.6666 8.7085Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })
      ),
      y.createElement(
        "defs",
        null,
        y.createElement(
          "clipPath",
          { id: "clip0_131_9801" },
          y.createElement("rect", { width: "22", height: "22", fill: "white" })
        )
      )
    ),
    FailureCode: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M8 21H16M12 17V21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M18 7V10M18 13H18.0075", stroke: "#6F809E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M10.5 10H6M7.5 13H6M12 7H6", stroke: "#6F809E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    PIN: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M14.541 13.9997L14.6408 12.242L13.1652 13.2098L12.6357 12.2897L14.2112 11.4998L12.6357 10.71L13.1652 9.78988L14.6408 10.7577L14.541 9H15.5956L15.5001 10.7577L16.9757 9.78988L17.5052 10.71L15.9255 11.4998L17.5052 12.2897L16.9757 13.2098L15.5001 12.242L15.5956 13.9997H14.541Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M7.90526 13.9997L8.00508 12.242L6.52948 13.2098L6 12.2897L7.57542 11.4998L6 10.71L6.52948 9.78988L8.00508 10.7577L7.90526 9H8.95988L8.8644 10.7577L10.34 9.78988L10.8695 10.71L9.28972 11.4998L10.8695 12.2897L10.34 13.2098L8.8644 12.242L8.95988 13.9997H7.90526Z", fill: "#6F809E" })
    ),
    IFSC: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      y.createElement("path", { d: "M19 11.7826H17.7369C17.7279 11.6781 17.7041 11.5833 17.6652 11.4982C17.6279 11.4131 17.5757 11.3399 17.5085 11.2787C17.4428 11.216 17.3629 11.1683 17.2689 11.1354C17.1748 11.1011 17.0681 11.0839 16.9486 11.0839C16.7396 11.0839 16.5627 11.1347 16.4179 11.2362C16.2745 11.3377 16.1655 11.4833 16.0909 11.6729C16.0177 11.8625 15.9812 12.0902 15.9812 12.3559C15.9812 12.6366 16.0185 12.8717 16.0931 13.0613C16.1693 13.2495 16.279 13.3913 16.4223 13.4868C16.5657 13.5809 16.7381 13.6279 16.9397 13.6279C17.0546 13.6279 17.1576 13.6137 17.2487 13.5854C17.3398 13.5555 17.4189 13.513 17.4861 13.4577C17.5533 13.4025 17.6078 13.3361 17.6496 13.2584C17.6929 13.1793 17.722 13.0905 17.7369 12.9919L19 13.0009C18.985 13.195 18.9305 13.3928 18.8365 13.5943C18.7424 13.7944 18.6088 13.9795 18.4356 14.1497C18.2639 14.3184 18.0512 14.4543 17.7974 14.5573C17.5436 14.6603 17.2487 14.7118 16.9128 14.7118C16.4918 14.7118 16.114 14.6215 15.7796 14.4409C15.4467 14.2602 15.1832 13.9945 14.9891 13.6436C14.7965 13.2928 14.7002 12.8635 14.7002 12.3559C14.7002 11.8453 14.7987 11.4153 14.9958 11.066C15.1929 10.7151 15.4586 10.4501 15.7931 10.271C16.1275 10.0903 16.5007 10 16.9128 10C17.2024 10 17.4689 10.0396 17.7123 10.1187C17.9556 10.1978 18.1691 10.3135 18.3528 10.4658C18.5364 10.6166 18.6842 10.8025 18.7962 11.0234C18.9081 11.2444 18.9761 11.4975 19 11.7826Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M12.9902 11.496C12.9782 11.3467 12.9223 11.2302 12.8222 11.1466C12.7237 11.063 12.5736 11.0212 12.3721 11.0212C12.2437 11.0212 12.1384 11.0369 12.0563 11.0682C11.9757 11.0981 11.916 11.1391 11.8772 11.1914C11.8384 11.2436 11.8182 11.3034 11.8167 11.3706C11.8137 11.4258 11.8234 11.4758 11.8458 11.5206C11.8697 11.5639 11.907 11.6035 11.9578 11.6393C12.0086 11.6736 12.0735 11.705 12.1526 11.7333C12.2318 11.7617 12.3258 11.7871 12.4348 11.8095L12.811 11.8901C13.0648 11.9439 13.2821 12.0148 13.4627 12.1029C13.6434 12.1909 13.7912 12.2947 13.9061 12.4141C14.0211 12.5321 14.1054 12.665 14.1592 12.8128C14.2144 12.9606 14.2428 13.1218 14.2443 13.2965C14.2428 13.5981 14.1674 13.8534 14.0181 14.0624C13.8688 14.2714 13.6553 14.4304 13.3776 14.5394C13.1014 14.6484 12.7692 14.7029 12.3811 14.7029C11.9824 14.7029 11.6346 14.6439 11.3375 14.526C11.0419 14.408 10.8119 14.2266 10.6477 13.9818C10.485 13.7354 10.4029 13.4204 10.4014 13.0367H11.5838C11.5913 13.1771 11.6264 13.295 11.6891 13.3905C11.7518 13.4861 11.8398 13.5585 11.9533 13.6078C12.0683 13.657 12.2049 13.6817 12.3631 13.6817C12.496 13.6817 12.6072 13.6653 12.6968 13.6324C12.7864 13.5996 12.8543 13.554 12.9006 13.4958C12.9469 13.4376 12.9708 13.3711 12.9723 13.2965C12.9708 13.2263 12.9476 13.1651 12.9028 13.1129C12.8596 13.0591 12.7879 13.0113 12.6879 12.9695C12.5878 12.9262 12.4527 12.8859 12.2825 12.8486L11.8257 12.7501C11.4196 12.662 11.0993 12.5149 10.8649 12.3089C10.632 12.1014 10.5163 11.8184 10.5178 11.4601C10.5163 11.169 10.594 10.9144 10.7507 10.6965C10.909 10.477 11.1277 10.3061 11.4069 10.1836C11.6876 10.0612 12.0093 10 12.3721 10C12.7424 10 13.0626 10.062 13.3328 10.1859C13.6031 10.3098 13.8113 10.4845 13.9576 10.7099C14.1054 10.9339 14.1801 11.1959 14.1816 11.496H12.9902Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M6.83521 14.6489V10.0625H10.06V11.0658H8.08035V11.8541H9.86296V12.8573H8.08035V14.6489H6.83521Z", fill: "#6F809E" }),
      y.createElement("path", { d: "M6.24514 10.0625V14.6489H5V10.0625H6.24514Z", fill: "#6F809E" })
    ),
    CheckCircle: y.createElement(
      "svg",
      { className: t, width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M6.33333 9.66667L8.33333 11.6667L11.6667 7M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z", stroke: "#3CAF7F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    CheckedCircle: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", fill: "#3CAF7F" }),
      y.createElement("path", { d: "M7 10.75L9.25 13L13 7.75M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", stroke: "#FBFCFE", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    CrossCircle: y.createElement(
      "svg",
      { className: t, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", fill: "#E20707" }),
      y.createElement("path", { d: "M7.75 7.75L12.25 12.25M12.25 7.75L7.75 12.25M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", stroke: "#FBFCFE", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Link: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M12.459 16.1313L11.541 17.0493C10.2734 18.3169 8.21825 18.3169 6.95068 17.0493C5.68311 15.7817 5.68311 13.7266 6.95068 12.459L7.86874 11.541M16.1313 12.459L17.0493 11.541C18.3169 10.2734 18.3169 8.21825 17.0493 6.95068C15.7817 5.68311 13.7266 5.68311 12.459 6.95068L11.541 7.86874M9.72792 14.2721L14.2721 9.72791", stroke: "#2955D9", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    Refresh: y.createElement(
      "svg",
      { className: t, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      y.createElement("path", { d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z", className: "fill-neutral-110 dark:fill-neutral-40" })
    ),
    Date: y.createElement(
      "svg",
      { className: t, width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", id: "calendar" },
      y.createElement("path", { className: "fill-neutral-80 dark:fill-neutral-40", d: "M58 5.5h-5.5V5a5 5 0 0 0-10 0v.5h-21V5a5 5 0 0 0-10 0v.5H6a6 6 0 0 0-6 6v41a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-41a6 6 0 0 0-6-6ZM46.5 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0Zm-31 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM60 52.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V22h56ZM60 18H4v-6.5a2 2 0 0 1 2-2h5.5V11a5 5 0 0 0 10 0V9.5h21V11a5 5 0 0 0 10 0V9.5H58a2 2 0 0 1 2 2Z" })
    ),
    Default: y.createElement(y.Fragment, null)
  };
  return GN(i, r) ? i[r] : i.Default;
};
function Roe(o) {
  return (o == null ? void 0 : o.format) == "uppercase" ? "uppercase" : (o == null ? void 0 : o.format) == "lowercase" ? "lowercase" : (o == null ? void 0 : o.format) == "capitalize" ? "capitalize" : "normal-case";
}
function cie({ type: o = "default", text: t = "Button", onClick: e, customClass: r = "", children: n, logo: i, label: a, theme: s, footer: l }) {
  let u = Roe(s), c = "flex initial:items-center mt-1 mb-1 rounded-md";
  c = Ot(c, r);
  let d = `${c} bg-primary-10 p-1 dark:bg-neutral-dark-5`, f = `${c} bg-secondary-5 p-1 dark:bg-neutral-dark-5`, v = "flex initial:items-center justify-between px-4 py-2", g = `${u} text-neutral-40 text-size-12 leading-tight mb-1 dark:text-neutral-40`;
  g = Ot(g, r);
  let m = `${u} block text-size-12 text-neutra-N40 leading-tight dark:text-neutral-40`, b = `${m} text-error`, S = `${u} text-neutral-60 text-size-14 leading-tight block  dark:text-neutral-40`, R = `${u} flex justify-between items-center border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2 initial:mb-2 bg-primary-N5 dark:bg-neutral-dark-5`;
  R = Ot(R, r);
  let P = "flex justify-between items-center border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-1 mb-2";
  P = Ot(P, r);
  let D = `${u} text-neutral-60 mb-6 leading-snug text-size-14`, x = Ot(D, r), M = `${u} rounded-md bg-primary-10 px-4 py-2 dark:bg-neutral-dark-10`, F = r ? `${M} ${r}` : `${M}`, B = Ot("rounded-md border border-solid border-neutral-10 py-2 px-2 dark:border-neutral-dark-10", r);
  const j = {
    default: () => y.createElement(
      "div",
      { className: c },
      y.createElement(Dn, { name: "Info", className: "mr-2" }),
      y.createElement("span", { className: m }, t)
    ),
    withBg: () => y.createElement(
      "div",
      { className: d },
      y.createElement(
        "i",
        { className: "block" },
        y.createElement(Dn, { name: "infoRound", className: "mr-2" })
      ),
      y.createElement("span", { className: m }, t)
    ),
    verified: () => y.createElement(
      "div",
      { className: f },
      y.createElement(Dn, { name: "successInfo", className: "mr-2" }),
      y.createElement("span", { className: m }, t)
    ),
    error: () => y.createElement(
      "div",
      { className: c },
      y.createElement(Dn, { name: "Error", className: "mr-2" }),
      y.createElement("span", { className: b }, t)
    ),
    notes: () => {
      function W() {
        return y.createElement(
          Dt,
          { check: !!l },
          y.createElement("div", { className: "bg-primary-20 dark:bg-neutral-dark-20 rounded-b-md px-4 py-2" }, l)
        );
      }
      return y.createElement(
        "div",
        { className: "bg-primary-10 dark:bg-neutral-dark-5 mt-1 mb-1 rounded-md" },
        y.createElement(
          "div",
          { className: v },
          y.createElement("span", { className: S }, t),
          y.createElement("div", null, n)
        ),
        W()
      );
    },
    borderedNotes: () => {
      function W() {
        return y.createElement(
          Dt,
          { check: !!i },
          y.createElement(
            "i",
            { className: "mr-2 block" },
            y.createElement("img", { src: i, alt: "placeholder logo", className: "w-6" })
          )
        );
      }
      return y.createElement(
        "div",
        { className: R },
        y.createElement(
          "div",
          { className: "flex items-center" },
          W(),
          y.createElement("span", { className: "font-opensans text-size-base text-neutral dark:text-neutral-dark-110 font-semibold" }, t)
        ),
        y.createElement("div", null, n)
      );
    },
    keyValueNotes: () => y.createElement(
      "div",
      { className: P },
      y.createElement(
        "div",
        { className: "flex items-center" },
        y.createElement("label", { className: "text-size-14 text-neutral-40 mr-2" }, a),
        y.createElement("span", { className: "font-opensans text-size-14 text-neutral-dark-0 dark:text-neutral-dark-80 font-semibold" }, t)
      )
    ),
    labelDesc: () => y.createElement("p", { className: g }, t),
    text: () => y.createElement("p", { className: x }, t),
    pop: () => y.createElement(
      "div",
      { className: F },
      y.createElement(
        Dt,
        { check: !!a },
        y.createElement("span", { className: "font-opensans text-size-12 text-neutral-60 dark:text-neutral-40" }, a)
      ),
      y.createElement("h5", { className: "size-base font-opensans text-neutral-110 dark:text-neutral-dark-110 font-semibold" }, t)
    ),
    borderedPop: () => {
      function W() {
        return y.createElement(
          Dt,
          { check: !!i },
          y.createElement(
            "div",
            { className: "mr-2" },
            y.createElement("img", { src: i, alt: i, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" })
          )
        );
      }
      return y.createElement(
        "div",
        { className: B },
        y.createElement(
          "div",
          { className: "flex items-center" },
          W(),
          y.createElement("span", { className: "text-size-14 text-neutral-60 block" }, a)
        ),
        y.createElement("h5", { className: "text-size-12 text-neutral-40" }, t)
      );
    }
  };
  return j[o]();
}
const dr = ({ name: o = "Alert", className: t, fill: e }) => y.createElement(Dn, { name: o, className: t, fill: e });
function die({ variant: o = "default", fullWidth: t = !1, contentHeightMax: e = !1, children: r, isOpen: n, toggleModal: i, title: a, customClass: s = "", hideClose: l, desc: u, size: c = "sm" }) {
  let d = `modal-wrapper flex flex-col justify-end 
   h-full max-h-screen w-full z-50 fixed left-0 right-0 top-0 bottom-0`;
  d = Ut(!!t, `${d} md:max-w-full md:items-center md:justify-center bg-neutral-20/[.9] dark:bg-neutral-dark-0/[.9] backdrop-blur-sm`, d);
  let f = `${d} m-auto sm:max-w-29`, v = Ut(!!t, d, f), g = "absolute top-0 bottom-0 w-full z-50 left-0 right-0 z-20 bg-neutral-dark-110/[.9] dark:bg-neutral-dark-0/[.9] backdrop-blur-sm", m = Ot(v, s), b = Ot(g, s), S = "modal shadow-txl dark:shadow-none bg-neutral-0 relative z-50 dark:bg-neutral-dark-5", R = "modal bg-neutral-0 relative z-50 dark:bg-neutral-dark-5 flex-1";
  R = Ut(!!t, `${R} md:flex-none md:max-w-29`, R);
  let P = "px-8 py-4 flex justify-between items-center border-b border-solid border-neutral-10 dark:border-neutral-dark-20", D = "px-8 pt-6 overflow-y-auto", x = Ut(!!e, `${D} max-h-80vh`, `${D} max-h-70vh`), M = Ut(!!t, `${D} max-h-80vh`, x), F = "modal rounded-xl bg-neutral-0 relative z-50 dark:bg-neutral-dark-5 flex-1 md:flex-none";
  c === "sm" ? F = Ot(F, "md:max-w-29") : c === "md" ? F = Ot(F, "max-w-2xl") : c && (F = Ot(F, `${c}`)), F = Ut(!!a, `${F} py-6`, `${F} pb-6 pt-9`);
  let H = "overflow-y-auto max-h-80vh px-6";
  const B = () => i(!1);
  wr(() => {
    n ? document.body.classList.add("overflow-hidden") : document.querySelectorAll("[data-component=modal]").length || document.body.classList.remove("overflow-hidden");
  }, [n]);
  const j = {
    default: () => y.createElement(
      Dt,
      { check: !!n },
      y.createElement(
        "div",
        { className: m, "data-component": "modal" },
        y.createElement("div", { className: b, onClick: B }),
        y.createElement(
          "div",
          { className: S },
          y.createElement(
            "div",
            { className: P },
            y.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110" }, a),
            y.createElement(
              "i",
              { onClick: B, className: Ut(!!l, "hidden cursor-pointer", "cursor-pointer") },
              y.createElement(Dn, { name: "Close" })
            )
          ),
          y.createElement("div", { className: "modal-content max-h-50vh overflow-y-auto px-8 py-4" }, r)
        )
      )
    ),
    fullPage: () => y.createElement(
      Dt,
      { check: !!n },
      y.createElement(
        "div",
        { className: m, "data-component": "modal" },
        y.createElement(
          "div",
          { className: R },
          y.createElement(
            "div",
            { className: P },
            y.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110" }, a),
            y.createElement(
              "i",
              { onClick: B, className: Ut(!!l, "hidden cursor-pointer", "cursor-pointer") },
              y.createElement(Dn, { name: "Close" })
            )
          ),
          y.createElement("div", { className: M }, r)
        )
      )
    ),
    curvedEdge: () => y.createElement(
      Dt,
      { check: !!n },
      y.createElement(
        "div",
        { className: m, "data-component": "modal" },
        y.createElement(
          "div",
          { className: F },
          y.createElement(
            "i",
            { onClick: B, className: Ut(!!l, "hidden cursor-pointer", "absolute right-4 top-4 cursor-pointer") },
            y.createElement(Dn, { name: "Close" })
          ),
          y.createElement(
            Dt,
            { check: !!a },
            y.createElement(
              "div",
              { className: "modal-header px-6" },
              y.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110 mb-3" }, a),
              y.createElement(
                Dt,
                { check: !!u },
                y.createElement("p", { className: "text-size-14 text-neutral-60 mb-4 normal-case leading-snug" }, u)
              )
            )
          ),
          y.createElement("div", { className: H }, r)
        )
      )
    )
  };
  return j[o]();
}
function pie({ variant: o = "pills", onChange: t, name: e, group: r = [], checked: n = 0, disabled: i = [], showOptions: a, size: s = "", equalWidth: l = !1, customClass: u = "" }) {
  let d = Ot("flex flex-wrap", u), v = Ot("flex flex-wrap", u), m = Ot("mb-8 flex flex-wrap justify-center text-center", u), S = Ot("flex flex-wrap text-center", u), P = Ot("radio-text flex flex-wrap", u), x = Ot("radio-bar flex flex-wrap", u), F = Ot("flex items-center", u), H = `text-neutral-80 flex items-center rounded-2xl 
  border border-solid border-neutral-40 hover:bg-neutral-5 cursor-pointer font-opensans font-semibold
  dark:bg-neutral-dark-5 dark:text-neutral-40 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10`;
  function B(le) {
    return le === "sm" ? "h-8 px-5 text-size-14" : "h-10 px-4";
  }
  let j = B(s), V = `${H} ${j}`, W = `border border-solid border-neutral-40 hover:bg-neutral-5 flex flex-1 
    items-center cursor-pointer text-base-color px-10 py-1 font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10 dark:text-neutral-40`, q = `border border-solid border-neutral-40 hover:bg-neutral-5 flex flex-1 
items-center cursor-pointer text-base-color px-4 py-px font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10 dark:text-neutral-40`, ee = `text-base-color text-size-14 font-semibold block 
    cursor-pointer font-opensans dark:text-neutral-40`, re = "radio-label cursor-pointer flex items-center flex-col", ie = `block flex justify-center items-center mb-1 bg-neutral-5 
    border border-solid border-neutral-40 rounded-2xl h-60px w-60px font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20`, ne = "flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-neutral-20", se = "font-opensans font-semibold text-center text-size-14 leading-tight block text-base-color dark:border-neutral-dark-20 dark:text-neutral-40", pe = `text-neutral-60 text-size-14 block 
  cursor-pointer font-opensans dark:text-neutral-40`;
  const K = (le) => !(Array.isArray(le) && le.length);
  function J() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: d, "data-name": e }, !K(r) && r.map((le, Ee) => {
      const X = `${le.label ? le.label : le}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "radio-pills mr-2 mb-2 last:mr-0", key: Ee },
        y.createElement("input", { id: X, type: "radio", name: e, value: le, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (xe) => {
          t && t(xe, le);
        } }),
        y.createElement("label", { htmlFor: X, className: V }, le.label ? le.label : le)
      );
    }));
  }
  function ue() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: v, "data-name": e }, !K(r) && r.map((le, Ee) => {
      const X = `${le.label ? le.label : le}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "radio-rounded mr-2 last:mr-0", key: X },
        y.createElement("input", { id: X, type: "radio", name: e, value: le, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (xe) => {
          t && t(xe, le);
        } }),
        y.createElement(
          "label",
          { htmlFor: X, className: "flex items-center" },
          y.createElement("span", { className: ne }),
          a ? y.createElement(
            "span",
            null,
            " ",
            le.label ? le.label : le
          ) : null
        )
      );
    }));
  }
  function he() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: m, "data-name": e }, !K(r) && r.map((le, Ee) => {
      const X = `${le.label ? le.label : le}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "radio-solid flex items-center", key: X },
        y.createElement("input", { id: X, type: "radio", name: e, value: le, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (xe) => {
          t && t(xe, le);
        } }),
        y.createElement("label", { htmlFor: X, className: W }, le.label ? le.label : le)
      );
    }));
  }
  function fe() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: S, "data-name": e }, !K(r) && r.map((le, Ee) => {
      const X = `${le.label ? le.label : le}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "radio-solid flex items-center", key: X },
        y.createElement("input", { id: X, type: "radio", name: e, value: le, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (xe) => {
          t && t(xe, le);
        } }),
        y.createElement(
          "label",
          { htmlFor: X, className: q },
          y.createElement(Dn, { name: le.label ? le.label : le })
        )
      );
    }));
  }
  function ae() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: P, "data-name": e }, !K(r) && r.map((le, Ee) => {
      const X = `${le.label ? le.label : le}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "mr-6 mb-2 last:mr-0", key: X },
        y.createElement("input", { id: X, type: "radio", name: e, value: le, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (xe) => {
          t && t(xe, le);
        } }),
        y.createElement("label", { htmlFor: X, className: ee }, le.label ? le.label : le)
      );
    }));
  }
  function oe() {
    const le = l ? "flex-1 text-center" : "px-4";
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: `${x} flex`, "data-name": e }, !K(r) && r.map((Ee, de) => {
      const xe = `${Ee.label ? Ee.label : Ee}_${de}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: `relative border-r border-gray-300 last:border-r-0 ${le}`, key: xe },
        y.createElement("input", { id: xe, type: "radio", name: e, value: Ee, className: "hidden", checked: n === de, disabled: i.includes(de), onChange: (Le) => {
          t && t(Le, Ee);
        } }),
        y.createElement("label", { htmlFor: xe, className: pe }, Ee.label ? Ee.label : Ee)
      );
    }));
  }
  function ve() {
    return K(r) ? y.createElement(y.Fragment, null) : y.createElement("div", { className: F, "data-name": e }, r.map((le, Ee) => {
      const de = le.label, X = le.icon, xe = `${de}_${Ee}_${e}`.toLowerCase().replace(" ", "_");
      return y.createElement(
        "div",
        { className: "radio-icon", key: xe },
        y.createElement("input", { id: xe, type: "radio", name: e, value: le.value, className: "hidden", checked: n === Ee, disabled: i.includes(Ee), onChange: (Le) => {
          t && t(Le, le);
        } }),
        y.createElement(
          "label",
          { htmlFor: xe, className: re },
          y.createElement(
            "div",
            { className: ie },
            y.createElement(Dn, { name: X || "Info", className: "block" })
          ),
          y.createElement("span", { className: se }, le.label)
        )
      );
    }));
  }
  return (() => {
    switch (o) {
      case "pills":
        return J();
      case "rounded":
        return ue();
      case "solid":
        return he();
      case "solidIcon":
        return fe();
      case "text":
        return ae();
      case "iconBased":
        return ve();
      case "bar":
        return oe();
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}
const VN = ({ variant: o = "default", children: t, description: e, disabled: r, onChange: n, id: i, value: a, required: s, checked: l, customClass: u, name: c = null }) => {
  const d = { onChange: n };
  let f = "flex relative", v = u ? `${f} ${u}` : `${f}`, g = "flex mr-4 initial:mb-8 p-2 border border-solid border-neutral-20 rounded-lg dark:border-neutral-dark-20", m = u ? `${g} ${u}` : `${g}`, b = r ? "opacity-0 absolute h-5 w-5 checkbox cursor-not-allowed" : "opacity-0 absolute h-5 w-5 checkbox cursor-pointer", S = "border-2 border-primary  w-5 h-5 rounded-md flex flex-shrink-0 justify-center items-center mr-2 dark:border-primary-dark", R = r ? "opacity-0 absolute h-4 w-4 checkbox cursor-not-allowed" : "opacity-0 absolute h-4 w-4 checkbox cursor-pointer", P = "border-2 border-primary  w-4 h-4 rounded-sm flex flex-shrink-0 justify-center items-center mr-2 dark:border-primary-dark", D = "flex-1 select-none cursor-pointer text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40";
  S = r ? "border-2 border-neutral-10 w-5 h-5 rounded-md flex flex-shrink-0 justify-center items-center mr-2 dark:border-neutral-40" : S;
  let M = "w-3 h-3 text-blue-600 pointer-events-none cursor-not-allowed hidden", F = "select-none cursor-pointer text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40";
  F = r ? "select-none cursor-not-allowed text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40" : `${F}`;
  const B = {
    default: () => y.createElement(
      "div",
      { className: v, "data-name": c },
      y.createElement(
        "div",
        null,
        y.createElement("input", { type: "checkbox", id: i, checked: l, required: s, value: a, className: b, ...d, disabled: r }),
        y.createElement(
          "div",
          { className: S },
          y.createElement(Dn, { name: "Check", className: M, fill: "#ffffff" })
        )
      ),
      t ? y.createElement("label", { htmlFor: i, className: F }, t) : null
    ),
    square: () => y.createElement(
      "div",
      { className: v, "data-name": c },
      y.createElement(
        "div",
        null,
        y.createElement("input", { type: "checkbox", id: i, checked: l, required: s, value: a, className: R, ...d, disabled: r }),
        y.createElement(
          "div",
          { className: P },
          y.createElement(Dn, { name: "Check", className: M, fill: "#ffffff" })
        )
      ),
      t ? y.createElement("label", { htmlFor: i, className: D }, t) : null
    ),
    cardType: () => y.createElement(
      "div",
      { className: m, "data-name": c },
      y.createElement(
        "div",
        { className: "mt-1" },
        y.createElement("input", { type: "checkbox", id: i, checked: l, required: s, value: a, className: b, ...d, disabled: r }),
        y.createElement(
          "div",
          { className: S },
          y.createElement(Dn, { name: "Check", className: M, fill: "#ffffff" })
        )
      ),
      y.createElement(
        "div",
        null,
        y.createElement("label", { htmlFor: i, className: F }, t),
        y.createElement("p", { className: "text-size-12 text-neutral-40 mx-0 my-0 leading-tight" }, e)
      )
    )
  };
  return B[o]();
}, HN = ({ variant: o = "default", customClass: t = "", size: e = "lg", msg: r, title: n, opaque: i = !0 }) => {
  let a = "";
  a = Ot(a, t);
  const s = i ? "bg-opacity-100" : "bg-opacity-70";
  let l = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full absolute z-50 backdrop-blur-sm bg-primary-DN110 ${s} dark:bg-neutral-dark-10 dark:${s}`;
  l = Ot(l, t);
  let u = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full absolute z-40 backdrop-blur-sm bg-primary-DN110 ${s} dark:bg-neutral-dark-10 dark:${s}`;
  u = Ot(u, t);
  let c = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full fixed z-50 backdrop-blur-sm bg-primary-DN110 ${s} dark:bg-neutral-dark-10 dark:${s}`;
  c = Ot(c, t);
  let d = "loader-round relative";
  e == "sm" ? d = `${d}  h-8 w-8 scale-50` : e == "md" ? d = `${d} h-8 w-8 scale-75` : e == "lg" && (d = `${d} h-8 w-8`);
  const f = {
    default: () => y.createElement(
      "div",
      { className: a },
      y.createElement("div", { className: "loader-round relative h-8 w-8 scale-50" })
    ),
    fullpage: () => y.createElement(
      "div",
      { className: l },
      y.createElement("div", { className: d }),
      n ? y.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, n) : null,
      r ? y.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, r) : null
    ),
    container: () => y.createElement(
      "div",
      { className: u },
      y.createElement("div", { className: d }),
      n ? y.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, n) : null,
      r ? y.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, r) : null
    ),
    screenCover: () => y.createElement(
      "div",
      { className: c },
      y.createElement("div", { className: d }),
      n ? y.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, n) : null,
      r ? y.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, r) : null
    )
  };
  return f[o]();
}, Toe = ({ id: o, title: t, isSelected: e, setSelectedTab: r, disabled: n, disabledMessage: i, _args: a, onChange: s, navFullWidth: l = !0 }) => {
  const [u, c] = er(n);
  wr(() => {
    c(n);
  }, [n]);
  const d = `${l ? "flex-1" : "px-4"} text-center cursor-pointer
    border-b border-solid border-neutral-10 text-neutral py-1 dark:text-neutral-40 dark:border-neutral-40`, f = "flex-1 text-center border-b border-solid border-neutral-10 text-neutral-20 dark:text-neutral-80 dark:border-neutral-80 relative", v = `${d} relative active`, g = (m) => {
    u || (m.target.value = o, r(o), s && s(m));
  };
  return y.createElement(
    "li",
    { className: `group relative ${u ? f : e ? v : d}`, onClick: g, ...a },
    y.createElement("span", { className: u ? "pointer-events-none" : "" }, t),
    u && i && y.createElement(
      "span",
      { className: "bg-neutral-40 absolute left-0 right-0 bottom-full z-10 mb-1 rounded-md px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100" },
      i,
      y.createElement("span", { className: "border-t-neutral-40 absolute top-full left-1/2 -translate-x-1/2 transform border-4 border-transparent" })
    )
  );
}, Ooe = ({ id: o, selectedTab: t, children: e }) => y.createElement(y.Fragment, null, t === o ? y.createElement("div", { className: "pt-6 pb-2" }, e) : null), Poe = ({ id: o, title: t, isSelected: e, setSelectedTab: r, disabled: n, onChange: i, _args: a }) => {
  const [s, l] = er(n);
  wr(() => {
    l(n);
  }, []);
  let u = `
  border border-solid border-neutral-40 hover:bg-neutral-5 flex 
  items-center cursor-pointer text-base-color px-10 py-1 font-opensans tab-pill-item dark:bg-neutral-dark-5 dark:text-neutral-40 dark:border-neutral-dark-20`, c = `${u} active`, d = ` 
    tab-pill-item
    border-solid  border-r border-neutral-20
    flex items-center
    px-10 py-1
    font-opensans
    bg-neutral-20
    text-neutral-40
    hover:bg-neutral-20
    pointer-events-none
    dark:bg-neutral-dark-10 dark:border-neutral-dark-20 dark:text-neutral-dark-20`;
  const f = (v) => {
    v.target.value = o, r(o), i && i(v);
  };
  return y.createElement("li", { className: s ? d : e ? c : u, onClick: f, ...a }, t);
}, Doe = ({ id: o, selectedTab: t, children: e }) => y.createElement(y.Fragment, null, t === o ? y.createElement("div", { className: "pt-6 pb-2" }, e) : null), fie = ({ group: o, args: t, variant: e = "default", selected: r, onChange: n, navFullWidth: i = !0 }) => {
  const [a, s] = er(0);
  wr(() => {
    r && s(r);
  }, [r]);
  const l = {
    default: () => y.createElement(
      "div",
      null,
      y.createElement("ul", { className: "tab-default border-neutral-1 flex border-b border-solid" }, o == null ? void 0 : o.map((c, d) => {
        let f = !1;
        return f = c.content === void 0 || c.content.length === 0 ? !0 : !!c.disabled, y.createElement(Toe, { title: c.title, id: d, isSelected: a === d, setSelectedTab: s, disabled: f, disabledMessage: c.disabledMessage, key: `${c.title}_${d}`, onChange: () => n == null ? void 0 : n(d), navFullWidth: i, ...t });
      })),
      y.createElement("div", { className: "outlet" }, o == null ? void 0 : o.map((c, d) => {
        const f = d;
        return f === a ? y.createElement(
          Ooe,
          { id: f, selectedTab: a, key: c + d },
          y.createElement("div", null, c.content)
        ) : null;
      }))
    ),
    pills: () => y.createElement(
      "div",
      null,
      y.createElement("ul", { className: "tab-pills flex justify-center" }, o == null ? void 0 : o.map((c, d) => {
        let f = !1;
        return f = c.content === void 0 || c.content.length === 0 ? !0 : !!c.disabled, y.createElement(Poe, { title: c.title, id: d, isSelected: a === d, setSelectedTab: s, disabled: f, key: `${c.title}_${d}`, onChange: () => n == null ? void 0 : n(d), ...t });
      })),
      y.createElement("div", { className: "outlet" }, o == null ? void 0 : o.map((c, d) => {
        const f = d;
        return f === a ? y.createElement(
          Doe,
          { id: f, selectedTab: a, key: c + d },
          y.createElement("div", null, c.content)
        ) : null;
      }))
    )
  };
  return l[e]();
};
function Aoe(o, t) {
  let e = `${t} bg-warning-5 dark:bg-warning-20`, r = `${t} bg-primary-10 dark:bg-primary-40`;
  return o === "red" ? e : o === "blue" ? r : "";
}
function Moe(o) {
  const t = "border-error-110 text-neutral-dark-0 dark:text-neutral-dark-110", e = "border-success-110 text-neutral-dark-0 dark:text-neutral-dark-110", r = "border-warning-110 text-neutral-dark-0 dark:text-neutral-dark-110", n = "border-neutral-10 text-neutral-dark-0 dark:border-neutral-dark-10", i = "border-primary text-primary dark:text-neutral-dark-110";
  switch (o) {
    case "error":
      return t;
    case "success":
      return e;
    case "warning":
      return r;
    case "processing":
      return i;
    case "default":
    default:
      return n;
  }
}
function Foe(o) {
  let t = "bg-error-110", e = "bg-success-110", r = "bg-warning-110";
  if (o === "error")
    return t;
  if (o === "success")
    return e;
  if (o === "warning")
    return r;
}
function aE({ position: o, children: t, message: e, ButtonText: r, color: n = "", onClick: i, variant: a = "default", customClass: s = "", status: l = "error", size: u = "sm", fullWidth: c = !1 }) {
  const d = { onClick: i };
  let f = "py-2 px-4 text-base-color text-size-12", v = "self-center leading-tight bg-primary-10 rounded-md py-1 px-2 text-size-10 text-size-12 dark:bg-neutral-dark-10 dark:text-neutral-40";
  u === "lg" && (v = "self-center leading-tight bg-primary-10 rounded-md py-2 px-4 text-neutral-dark-0 dark:text-neutral-dark-110 text-size-16 dark:bg-neutral-dark-10 dark:text-neutral-dark-110");
  let g = "radio hidden flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-primary", m = "checkbox hidden pointer-events-none", b = Ot(v, s);
  b = c ? `${b} w-full` : `${b}`;
  let S = Aoe(n, f), R = `${S} ${f} rounded-b-md`, P = `${S} ${f} rounded-t-md`, D = Ut(o === "top", `${P}`, `${R}`), x = "rounded-b-md border border-solid border-neutral-10 px-4 py-4 initial:mb-4 dark:border-neutral-dark-10 relative -top-1", M = "bg-neutral-5 dark:bg-neutral-dark-5", F = "bg-warning-5 dark:bg-warning-20", H = "initial:text-neutral-60 initial:text-size-12 initial:mb-2", B = "";
  l === "warning" ? (B = F, H = "initial:text-neutral-60 initial:text-size-12 initial:mb-2 dark:text-neutral-80") : B = M;
  let j = `${x} ${B}`;
  j = Ot(j, s);
  let V = "self-center inline-block leading-tight border border-solid rounded-md py-1 px-2 text-size-12", W = Moe(l);
  V = Ut(!!s, `${V} ${s} ${W}`, `${V} ${W}`);
  let q = "self-center inline-block leading-tight rounded-md py-1 px-2 text-size-12 text-neutral-0", ee = Foe(l);
  q = Ut(!!s, `${q} ${s} ${ee}`, `${q} ${ee}`);
  function re() {
    return y.createElement(
      "div",
      { className: D },
      y.createElement(
        "div",
        { className: "flex items-center" },
        y.createElement(
          Dt,
          { check: o === "top" },
          y.createElement("div", { className: g }),
          y.createElement(
            "div",
            { className: m },
            y.createElement(VN, null)
          )
        ),
        y.createElement("div", { className: "text-base-color flex-1" }, e)
      ),
      y.createElement(
        Dt,
        { check: !!r },
        y.createElement(
          "div",
          { className: "text-center" },
          y.createElement(AN, { variant: "text", ...d }, r)
        )
      )
    );
  }
  function ie() {
    return y.createElement(
      "div",
      { className: j, style: { top: "-4px" } },
      y.createElement(
        "div",
        null,
        y.createElement(
          Dt,
          { check: !!e },
          y.createElement("div", { className: H }, e)
        )
      ),
      y.createElement("div", null, t)
    );
  }
  function ne() {
    return y.createElement(
      "span",
      { ...d, className: b },
      e,
      t
    );
  }
  function se() {
    return y.createElement("span", { className: V }, e);
  }
  function pe() {
    return y.createElement("span", { className: q }, e);
  }
  return (() => {
    switch (a) {
      case "default":
        return re();
      case "note":
        return ie();
      case "pill":
        return ne();
      case "outline":
        return se();
      case "filled":
        return pe();
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}
const hie = ({ title: o, icon: t, variant: e = "main", semiBold: r = !1, customClass: n = "", onClick: i }) => {
  const a = { onClick: i };
  let u = Ot(`text-neutral-110 mb-2 flex items-center dark:text-neutral-dark-110 ${r ? "font-semibold text-size-18" : "font-bold"}`, n), d = Ot("text-neutral-dark-0 mb-1 text-size-14 dark:text-neutral-dark-110", n), v = Ot("text-neutral-60 mb-1 pt-3 text-size-12 font-normal", n);
  const g = {
    main: () => y.createElement(
      "h4",
      { className: u },
      t ? y.createElement(
        "button",
        { type: "button", ...a, className: "mr-3" },
        y.createElement(Dn, { name: t })
      ) : null,
      y.createElement("span", { className: "block" }, o)
    ),
    sub: () => y.createElement("h5", { className: d }, o),
    group: () => y.createElement("h5", { className: v }, o)
  };
  return g[e]();
};
function Ioe({ tableData: o, title: t, defaultClasses: e, tableheaderClasses: r, tableValueClasses: n, listItemClasses: i, tableLabelClasses: a }) {
  return y.createElement(
    "div",
    { className: e },
    y.createElement(
      Dt,
      { check: !!t },
      y.createElement(
        "div",
        { className: "border-neutral-20 dark:border-neutral-dark-20 border-b border-solid p-4" },
        y.createElement("h6", { className: r }, t)
      )
    ),
    y.createElement("ul", { className: "flex flex-wrap px-4 pt-3" }, o == null ? void 0 : o.map((s, l) => {
      var u, c;
      return y.createElement(
        "li",
        { className: ` ${s.colSpan ? `${i} ${s.colSpan}` : `${i} `} `, key: s + l },
        y.createElement("span", { className: a }, s.label),
        y.createElement(
          "div",
          { className: "flex items-center" },
          s.logo && y.createElement(
            "span",
            { className: "mr-2" },
            y.createElement("img", { src: s.logo, alt: "", className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" })
          ),
          y.createElement(
            "span",
            { className: n },
            y.createElement(Dt, { check: !!(s != null && s.value) }, Array.isArray(s == null ? void 0 : s.value) && ((u = s == null ? void 0 : s.value) != null && u.length) ? y.createElement("ul", { className: "text-size-14 list-disc pl-5" }, (c = s.value) == null ? void 0 : c.map((d, f) => y.createElement("li", { key: f }, d))) : s.onClick ? y.createElement("button", { type: "button", onClick: s.onClick, className: "text-primary text-size-14 hover:underline" }, s.value) : s.value)
          )
        )
      );
    }))
  );
}
function Loe({ title: o, iconTableClasses: t, buttonText: e, bgTableIconClasses: r, icon: n, label: i, value: a, footer: s }) {
  return y.createElement(
    "div",
    { className: "mb-8" },
    y.createElement(
      "div",
      { className: t },
      y.createElement(
        "div",
        { className: "p-4" },
        y.createElement(
          "div",
          { className: "flex justify-between" },
          y.createElement("h6", { className: "text-base-color dark:text-neutral-dark-110" }, o),
          y.createElement(AN, { variant: "text" }, e)
        ),
        y.createElement(
          "div",
          { className: "flex items-center" },
          y.createElement(
            "div",
            { className: r },
            y.createElement(Dn, { name: n })
          ),
          y.createElement(
            "div",
            null,
            y.createElement("span", { className: "font-opensans text-size-14 text-neutral-60 dark:text-neutral-40 block font-bold" }, i),
            y.createElement(
              "span",
              { className: "font-opensans text-size-14 text-neutral-60 dark:text-neutral-40 block font-semibold" },
              y.createElement(Dt, { check: !!a }, Array.isArray(a) && (a != null && a.length) ? y.createElement("ul", { className: "text-size-14 list-disc pl-5" }, a == null ? void 0 : a.map((l, u) => y.createElement("li", { key: u }, l))) : a)
            )
          )
        )
      ),
      y.createElement(
        Dt,
        { check: !!s },
        y.createElement(aE, { message: s == null ? void 0 : s.title, color: s == null ? void 0 : s.bgColor, ButtonText: s == null ? void 0 : s.buttonText })
      )
    )
  );
}
const vie = (o) => {
  const { variant: t = "default", customClass: e = "", view: r } = o;
  let a = Ut(r === "error", "border border-solid border-error bg-error-5 dark:bg-neutral-dark-10 dark:border-error-40 rounded-lg mb-8", "border border-solid border-neutral-20 dark:border-neutral-dark-20 rounded-lg mb-8"), s = Ot(a, e), l = "text-neutral-dark-0 text-size-14 font-semibold font-opensans dark:text-neutral-dark-110", u = "text-neutral-40 text-size-14 block dark:text-neutral-40", c = "break-words overflow-auto leading-snug text-neutral-dark-0 text-size-14 block font-semibold font-opensans dark:text-neutral-dark-110", f = Ot("border border-solid border-neutral-10 rounded-lg bg-neutral-5 dark:border-neutral-dark-20 dark:bg-transparent", e), v = "flex justify-center items-center rounded-xl border border-solid border-primary w-12 h-12 mr-2 dark:border-neutral-dark-20 dark:bg-neutral-dark-110", g = "initial:basis-1/2 w-1/2 pb-3 pr-2";
  return (() => {
    switch (t) {
      case "default":
        return y.createElement(Ioe, { ...o, defaultClasses: s, tableheaderClasses: l, tableValueClasses: c, listItemClasses: g, tableLabelClasses: u });
      case "withIcon":
        return y.createElement(Loe, { ...o, iconTableClasses: f, bgTableIconClasses: v });
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}, gie = ({ children: o, variant: t = "default" }) => {
  let e = "mobile-center-layout sm:max-w-29 pb-9 bg-neutral-dark-110 flex flex-col min-h-screen m-auto relative dark:bg-neutral-dark-0 dark:text-neutral-dark-80", r = `${e} p-8`, n = `${e}`;
  const i = {
    default: () => y.createElement(
      "div",
      { className: "bg-neutral-20 dark:bg-neutral-dark-10 mobile-center-wrapper" },
      y.createElement("div", { className: r }, o)
    ),
    plain: () => y.createElement(
      "div",
      { className: "bg-neutral-20 dark:bg-neutral-dark-10 mobile-center-wrapper" },
      y.createElement("div", { className: n }, o)
    ),
    web: () => y.createElement("div", null, o)
  };
  return i[t]();
}, mie = ({ inputName: o, customClass: t, handleFile: e, accept: r, value: n, uploadStatus: i }) => {
  const [a, s] = er(n || null), l = (R) => {
    var F, H;
    R.preventDefault();
    const P = R.dataTransfer.files[0], D = r == null ? void 0 : r.split(","), x = D == null ? void 0 : D.some((B) => B.includes(P == null ? void 0 : P.name.split(".")[1])), M = ((F = P == null ? void 0 : P.type) == null ? void 0 : F.includes("image")) || ((H = P == null ? void 0 : P.type) == null ? void 0 : H.includes("pdf"));
    (r && x || !r && M) && (e(P), s(P));
  }, u = (R) => {
    R.preventDefault();
  }, c = (R) => {
    const P = R.target.files && R.target.files[0];
    P && (e(P), s(P));
  }, d = () => {
    e(null), s(null);
  };
  wr(() => {
    s(n || null);
  }, [n]);
  const f = () => a ? a.type === "application/pdf" ? y.createElement(dr, { name: "Pdf", className: "w-7" }) : y.createElement(dr, { name: "Upload" }) : y.createElement(dr, { name: "Upload" });
  let v = "flex items-center rounded-md p-2 mb-2 dark:bg-neutral-dark-10";
  v = t ? `${v} ${t}` : `${v}`;
  let g = `${v} border border-solid border-neutral-10 dark:border-neutral-dark-10`, m = `${v} border border-solid border-primary-dark`, b = `${v} border border-solid border-error`, S = i == "uploadFailure" ? `${b}` : `${m}`;
  return y.createElement("div", { onDrop: l, onDragOver: u }, a ? y.createElement(
    "div",
    { className: S },
    f(),
    y.createElement("div", { className: "block w-52 flex-1 truncate px-2 md:w-60" }, a.name),
    y.createElement(
      "button",
      { onClick: d },
      y.createElement(dr, { name: "Trash" })
    )
  ) : y.createElement(
    "div",
    { className: g },
    y.createElement(
      "label",
      { className: `flex flex-1 cursor-pointer 
        items-center rounded-md border border-dashed border-neutral-10 bg-neutral-5 px-2 text-primary dark:border-neutral-dark-20 dark:bg-transparent dark:text-primary-dark`, htmlFor: o },
      y.createElement(dr, { name: "Upload", className: "mr-2" }),
      y.createElement("div", null, "Choose file"),
      y.createElement("input", { type: "file", id: o, accept: r || "image/*, application/pdf", onChange: c, style: { display: "none" }, name: o })
    )
  ));
}, yie = ({ variant: o = "default", header: t, footer: e, footerNotes: r, children: n, selected: i, customClass: a, disabled: s = !1, innerRef: l, onClick: u, cardSpacing: c = !0 }) => {
  const d = { onClick: u };
  let f = "radio hidden flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-primary", v = "checkbox hidden pointer-events-none", g = "rounded-md border border-solid border-neutral-10 mb-4 bg-neutral-5 dark:bg-neutral-dark-5 dark:border-neutral-dark-10", m = i ? `${g}  border border-solid border-primary selected dark:border-primary-dark` : `${g}`;
  m = a ? `${m} ${a}` : `${m}`;
  let b = c ? "px-4 pt-2 pb-2" : "";
  const S = {
    default: () => y.createElement(
      "div",
      { className: m, ref: l },
      t ? y.createElement(aE, { message: t.title, color: t.bgColor, ButtonText: t.buttonText, position: "top" }) : null,
      y.createElement(
        "div",
        { className: b },
        y.createElement(
          "div",
          { className: "flex items-center" },
          t ? null : y.createElement(
            y.Fragment,
            null,
            y.createElement("div", { className: f }),
            y.createElement(
              "div",
              { className: v },
              y.createElement(VN, null)
            )
          ),
          y.createElement("div", { className: "flex-1" }, n)
        )
      ),
      r ? y.createElement("div", { className: "bg-primary-20 px-2 py-2 font-roboto  text-size-12 font-normal text-neutral-80 dark:bg-info-20" }, r) : null,
      e ? y.createElement(aE, { message: e.title, color: e.bgColor, ButtonText: e.buttonText, ...d }) : null
    )
  };
  return S[o]();
};
function Noe({ multiSelected: o, onChange: t, children: e }) {
  const [r, n] = er(o), i = (a, s) => {
    let l = [];
    if (r.includes(s)) {
      const u = r;
      u.splice(r.indexOf(s), 1), l = [...u];
    } else
      n([...r, s]), l = [...r, s];
    a.target.value = l, n(l), t && t(a);
  };
  return y.createElement(y.Fragment, null, e.length ? e.map((a, s) => y.createElement(
    "section",
    { key: s },
    y.createElement("div", { className: "multiselect cursor-pointer", onClick: (l) => i(l, s) }, y.cloneElement(a, {
      selected: r.includes(s)
    }))
  )) : y.createElement(
    "section",
    null,
    y.createElement("div", { className: "multiselect cursor-pointer", onClick: () => {
    } }, y.cloneElement(e, {
      selected: !0
    }))
  ));
}
function koe({ selected: o, onChange: t, children: e }) {
  const [r, n] = er(o), i = sD.toArray(e);
  return y.createElement(y.Fragment, null, i.length ? i.map((a, s) => {
    var l;
    if (s === r)
      return y.createElement(
        "section",
        { key: s },
        y.createElement("div", { className: "select cursor-pointer" }, y.cloneElement(a, { selected: !0 }))
      );
    {
      const u = a;
      return y.isValidElement(u) ? y.createElement(
        "section",
        { key: s },
        y.createElement("div", { className: `select ${Ut(!!((l = a == null ? void 0 : a.props) != null && l.disabled), "disabled cursor-not-allowed", "cursor-pointer")}`, onClick: (c) => {
          var d;
          (d = a == null ? void 0 : a.props) != null && d.disabled || (c.target.value = s, n(s), t && t(c));
        } }, a)
      ) : y.createElement(y.Fragment, null);
    }
  }) : y.createElement(
    "section",
    null,
    y.createElement("div", { className: "select cursor-pointer", onClick: (a) => {
      a.target.value = 0, n(0), t && t(a);
    } }, y.cloneElement(e, {
      selected: !0
    }))
  ));
}
function Cie({ variant: o = "default", selected: t, children: e, multiSelected: r, onChange: n }) {
  function i() {
    switch (o) {
      case "multiSelectable":
        return y.createElement(Noe, { multiSelected: r, onChange: n }, e);
      case "selectable":
        return y.createElement(koe, { selected: t, onChange: n }, e);
      default:
        return y.createElement(y.Fragment, null);
    }
  }
  return i();
}
function Goe(o, t, e) {
  if (t === "row")
    return `${o} flex flex-row items-center ${e ? "border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2" : ""}`;
  if (t === "column")
    return `${o} flex flex-col` + (e ? " border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2" : "");
}
function Voe(o, t, e) {
  return o ? "initial:font-opensans initial:text-size-12 text-neutral-60 initial:dark:text-neutral-40 leading-6" + (t === "row" ? " mr-2" : "") + (e ? " font-roboto block text-size-14 text-neutral-60 dark:text-neutral-60" : "") : "text-neutral-60 initial:font-opensans initial:text-size-12 initial:dark:text-neutral-40 leading-6" + (t === "row" ? " mr-2" : "") + (e ? " font-roboto block text-size-14 text-neutral-60 dark:text-neutral-60" : "");
}
function wie({ label: o, value: t, icon: e, loader: r, symbol: n, logo: i, customClass: a, iconPlacement: s = "right", variant: l = "default", background: u = !1, direction: c = "column", border: d = !1 }) {
  let f = a ? `${a}` : "", v = u ? `${f} rounded-md bg-primary-10 px-4 py-2 dark:bg-neutral-dark-10` : f, g = Goe(v, c, d), m = Voe(u, c, n), b = u ? "initial:text-size-base font-opensans font-semibold initial:text-neutral-110 dark:text-neutral-dark-110 overflow-wrap-anywhere" : "block initial:text-neutral-dark-0 initial:text-size-14 leading-normal font-opensans font-semibold initial:dark:text-neutral-dark-110 overflow-wrap-anywhere";
  b = n ? `${b} block text-size-12 text-neutral-40 dark:text-neutral-40` : b;
  const S = {
    default: () => y.createElement(
      "div",
      { className: g },
      y.createElement(
        "div",
        { className: "flex items-center" },
        y.createElement(
          Dt,
          { check: !!n },
          y.createElement(
            "div",
            { className: "mr-2 shrink-0" },
            y.createElement("img", { src: n, alt: n, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" })
          )
        ),
        y.createElement("span", { className: m }, o)
      ),
      y.createElement(
        "div",
        { className: "flex items-center" },
        y.createElement(
          Dt,
          { check: !!i },
          y.createElement(
            "div",
            { className: "mr-2 shrink-0" },
            y.createElement("img", { src: i, alt: i, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" })
          )
        ),
        y.createElement(
          Dt,
          { check: !!e },
          y.createElement(
            Dt,
            { check: s === "left" },
            y.createElement(
              "span",
              { className: "mr-2" },
              y.createElement(Dn, { name: e })
            )
          )
        ),
        y.createElement("span", { className: b }, t),
        y.createElement(
          Dt,
          { check: !!r },
          y.createElement(HN, null)
        ),
        y.createElement(
          Dt,
          { check: !!e },
          y.createElement(
            Dt,
            { check: s === "right" },
            y.createElement(
              "span",
              { className: "ml-3" },
              y.createElement(Dn, { name: e })
            )
          )
        )
      )
    )
  };
  return S[l]();
}
var Cp = {
  content: ["./src/**/*.{js,ts,jsx,tsx}"],
  darkMode: "class",
  // or 'media' or 'class'
  theme: {
    fontFamily: {
      opensans: ["Open Sans", "sans-serif"],
      roboto: ["Roboto", "sans-serif"],
      inter: ["Inter", "sans-serif"]
    },
    extend: {
      fontSize: {
        "size-base": ["1rem", "1.5rem"],
        "size-56": ["3.5rem", "4rem"],
        "size-32": ["2rem", "2.5rem"],
        "size-26": ["1.625rem", "2rem"],
        "size-22": ["1.375rem", "1.8125rem"],
        "size-20": ["1.25rem", "1.75rem"],
        "size-18": ["1.125rem", "1.75rem"],
        "size-14": ["0.875rem", "1.375rem"],
        "size-12": ["0.75rem", "1.1rem"],
        "size-11": ["0.688rem", "1rem"],
        "size-10": ["0.625rem", "1rem"]
      },
      colors: {
        /* New palette */
        "base-color": "#3F567E",
        "link-color": {
          DEFAULT: "#3E74FF",
          dark: {
            DEFAULT: "#2955D9"
          }
        },
        primary: {
          DEFAULT: "#3E74FF",
          10: "#F0F7FF",
          20: "#E0EDFF",
          40: "#B8D3FF",
          110: "#2955D9",
          dark: {
            DEFAULT: "#5081FF"
          }
        },
        secondary: {
          DEFAULT: "#009666",
          10: "#E5F4EF",
          20: "#CCEAE0",
          40: "#99D5C2",
          110: "#007050",
          dark: {
            DEFAULT: "#109F72"
          }
        },
        neutral: {
          DEFAULT: "#0F2C5E",
          0: "#ffffff",
          5: "#FBFCFE",
          6: "#FAFAFA",
          10: "#E7EDF9",
          15: "#ebf0ff",
          20: "#CFD4DF",
          30: "#B6BFCE",
          40: "#9FAABE",
          60: "#6F809E",
          80: "#3F567E",
          85: "#4A5263",
          110: "#061738",
          dark: {
            DEFAULT: "#E6E7E9",
            0: "#1F222A",
            5: "#2A2D34",
            10: "#34373E",
            20: "#4B4E54",
            30: "#616369",
            40: "#787A7F",
            60: "#A5A6A9",
            80: "#D2D2D4",
            100: "#E6E7E9",
            110: "#FFFFFF"
          }
        },
        success: {
          DEFAULT: "#15C87A",
          5: "#F3FFF8",
          20: "#BBFAD6",
          40: "#8CEDB9",
          110: "#0AA164"
        },
        error: {
          DEFAULT: "#FF4D4F",
          5: "#FFF8F7",
          20: "#FFCCC7",
          40: "#FFA39E",
          110: "#F5222D"
        },
        warning: {
          DEFAULT: "#FFA940",
          5: "#FFFBF2",
          20: "#FFE7BA",
          40: "#FFD591",
          110: "#FA8C16"
        },
        info: {
          DEFAULT: "#9254DE",
          5: "#FDFAFF",
          20: "#EFDBFF",
          40: "#D3ADF7",
          100: "#9254DE",
          110: "#722ED1"
        },
        /* Old Palette for fallback. --use new palette for new components */
        "primary-B110": "#2955D9",
        "primary-B100": "#3E74FF",
        "primary-B40": "#B8D3FF",
        "primary-B20": "#E0EDFF",
        "primary-B10": "#F0F7FF",
        "primary-G100": "#009666",
        "primary-G40": "#99D5C2",
        "primary-G20": "#CCEAE0",
        "primary-G10": "#E5F4EF",
        "primary-G110": "#007050",
        "primary-N0": "#ffffff",
        "primary-N10": "#E7EDF9",
        "primary-N30": "#B6BFCE",
        "primary-N40": "#9FAABE",
        "primary-N60": "#6F809E",
        "primary-N80": "#3F567E",
        "primary-N20": "#CFD4DF",
        "primary-N5": "#FBFCFE",
        "primary-N100": "#0F2C5E",
        "primary-N110": "#061738",
        "secondary-R100": "#FF4D4F",
        "secondary-R40": "#FFA39E",
        "secondary-R20": "#FFCCC7",
        "secondary-R5": "#FFF8F7",
        "secondary-R110": "#F5222D",
        "secondary-O100": "#FFA940",
        "secondary-O40": "#FFD591",
        "secondary-O20": "#FFE7BA",
        "secondary-O5": "#FFFBF2",
        "secondary-O110": "#FA8C16",
        "secondary-G100": "#15C87A",
        "secondary-G40": "#8CEDB9",
        "secondary-G20": "#BBFAD6",
        "secondary-G5": "#F3FFF8",
        "secondary-G110": "#0AA164",
        "secondary-P100": "#9254DE",
        "secondary-P40": "#D3ADF7",
        "secondary-P20": "#EFDBFF",
        "secondary-P5": "#FDFAFF",
        "secondary-P110": "#722ED1",
        // Darkmode
        "primary-DB100": "#5081FF",
        "primary-DG100": "#109F72",
        "primary-DN0": "#1F222A",
        "primary-DN05": "#2A2D34",
        "primary-DN10": "#34373E",
        "primary-DN20": "#4B4E54",
        "primary-DN30": "#616369",
        "primary-DN40": "#787A7F",
        "primary-DN60": "#A5A6A9",
        "primary-DN80": "#D2D2D4",
        "primary-DN100": "#E6E7E9",
        "primary-DN110": "#FFFFFF"
      },
      borderRadius: {
        5: "0.313rem"
      },
      borderWidth: {
        0.5: "0.03125rem"
      },
      spacing: {
        360: "360px",
        "60px": "60px",
        95: "95%",
        "50vh": "50vh",
        "70vh": "70vh",
        "80vh": "80vh",
        "90vh": "90vh",
        32: "32px"
      },
      zIndex: {
        "-1": "-1",
        1e3: "1000"
      },
      minWidth: {
        12: "12rem"
      },
      maxWidth: {
        29: "28.75rem"
        // 460px
      },
      boxShadow: {
        "3xl": "0px 3px 6px #BACBDB",
        "4xl": "0px 0px 5px #E2E6EB",
        "5xl": "0px 6px 5px #3F567E26",
        "6xl": "0px 0px 6px #bacbdb",
        D4xl: "0px 0px 5px #10151EE3",
        txl: "0 0 6px #bacbdb",
        r4xl: "-5px 0px 10px #E2E6EB"
      }
    }
  },
  variants: {
    extend: {
      display: ["dark"],
      borderOpacity: ["active"]
    }
  },
  plugins: [
    function({ addVariant: o }) {
      o("initial", "html :where(&)");
    }
  ]
};
let Gd = Cp.theme.extend.colors.primary.DEFAULT, Hoe = Cp.theme.extend.colors.primary[110], Boe = Cp.theme.extend.colors.neutral.dark[0], Woe = Cp.theme.extend.colors.neutral[40], joe = Cp.theme.extend.colors.neutral[5], Uoe = Cp.theme.extend.colors.neutral[10];
const XP = rA({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: Gd
      }
    },
    MuiPickersDay: {
      day: {
        color: Boe
      },
      daySelected: {
        backgroundColor: Gd,
        "&:hover": {
          backgroundColor: Hoe
        }
      },
      dayDisabled: {
        color: Woe
      },
      current: {
        color: Gd
      }
    },
    MuiButton: {
      textPrimary: {
        color: Gd
      }
    },
    MuiPickersYear: {
      yearSelected: {
        color: Gd
      }
    },
    MuiPickersMonth: {
      monthSelected: {
        color: Gd
      }
    },
    MuiOutlinedInput: {
      root: {
        background: joe
      },
      input: {
        height: "11px"
      },
      notchedOutline: {
        borderColor: Uoe
      }
    }
  }
}), bie = ({ variant: o = "default", name: t = null, selectedDate: e, handleDateChange: r, onChange: n, ...i }) => {
  const a = {
    default: () => y.createElement(
      "div",
      { className: "datepicker-wrapper flex", "data-name": t },
      y.createElement(
        Bb,
        { utils: Dx },
        y.createElement(
          Fh,
          { theme: XP },
          y.createElement(wM, { autoOk: !0, inputVariant: "outlined", value: e, onChange: r, format: "yyyy-MM-dd", ...i })
        )
      )
    ),
    keyboardInputDOB: () => y.createElement(
      "div",
      { className: "datepicker-wrapper flex", "data-name": t },
      y.createElement(
        Bb,
        { utils: Dx },
        y.createElement(
          Fh,
          { theme: XP },
          y.createElement(bM, { autoOk: !0, inputVariant: "outlined", format: "yyyy-MM-dd", value: e, openTo: "year", views: ["year", "month", "date"], disableFuture: !0, onChange: (l, u) => r(l, u), ...i })
        )
      )
    )
  };
  return a[o]();
}, Sie = ({ content: o, children: t, delay: e, variant: r = "default", placement: n = "bottom", customClass: i = "", size: a = "md", hidden: s = !1 }) => {
  let u = Ot("cursor-pointer initial:inline-block", i), c = "max-w-sm w-max", d = "w-56", f = "absolute block bg-primary-B10 py-2 px-2 shadow-md z-50 rounded-md text-primary-N40 dark:text-neutral-dark-80 dark:bg-neutral-dark-10 dark:border-neutral-dark-20 text-size-12";
  f = a === "sm" ? `${f} ${d}` : `${f} ${c}`;
  const v = Cr(null), [g, m] = er(!1), [b, S] = er({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0
  });
  wr(() => () => {
    v.current && clearTimeout(v.current);
  }, []);
  const R = (F) => {
    F.stopPropagation();
    const { left: H, right: B, top: j, bottom: V, width: W, height: q } = F.currentTarget.getBoundingClientRect();
    v.current && clearTimeout(v.current), v.current = setTimeout(() => {
      S({ left: H, right: B, top: j, bottom: V, width: W, height: q }), m(!0);
    }, e ?? 400);
  }, P = (F) => {
    F.stopPropagation(), v.current && clearTimeout(v.current), m(!1);
  }, D = () => {
    switch (n) {
      case "bottom-start":
        return {
          left: b.left,
          top: b.top + b.height + 4
        };
      case "bottom-end":
        return {
          left: b.left + b.width,
          top: b.top + b.height + 4,
          transform: "translateX(-100%)"
        };
      case "top":
        return {
          left: b.left + b.width / 2,
          top: b.top - 4,
          transform: "translate(-50%, -100%)"
        };
      case "top-start":
        return {
          left: b.left,
          top: b.top - 4,
          transform: "translateY(-100%)"
        };
      case "top-end":
        return {
          left: b.left + b.width,
          top: b.top - 4,
          transform: "translate(-100%,-100%)"
        };
      case "right":
        return {
          left: b.right + 4,
          top: b.top + b.height / 2,
          transform: "translateY(-50%)"
        };
      case "right-start":
        return {
          left: b.right + 4,
          top: b.top
        };
      case "right-end":
        return {
          left: b.right + 4,
          top: b.top + b.height,
          transform: "translateY(-100%)"
        };
      case "left":
        return {
          left: b.left - 4,
          top: b.top + b.height / 2,
          transform: "translate(-100%, -50%)"
        };
      case "left-start":
        return {
          left: b.left - 4,
          top: b.top,
          transform: "translate(-100%, 0)"
        };
      case "left-end":
        return {
          left: b.left - 4,
          top: b.top + b.height,
          transform: "translate(-100%, -100%)"
        };
      case "bottom":
      default:
        return {
          left: b.left + b.width / 2,
          top: b.top + b.height + 4,
          transform: "translateX(-50%)"
        };
    }
  }, x = {
    default: () => s ? t : y.createElement(
      "div",
      { onMouseEnter: R, onMouseLeave: P, className: u },
      t,
      y.createElement(Dt, { check: g }, XN(y.createElement(
        "div",
        { className: f, style: {
          ...D()
        } },
        y.createElement("div", null, o)
      ), document.body))
    )
  };
  return x[r]();
}, Eie = ({ name: o = null, onChange: t, ...e }) => {
  const r = { onChange: t }, n = { ...e };
  ["customClass"].map((v) => {
    n[v] && delete n[v];
  });
  let a = "border-primary-neutral-10 dark:border-neutral-dark-10 focus:border-primary dark:focus:border-primary-dark";
  e.status == "error" ? a = "border-error dark:border-error" : e.status == "alert" && (a = "border-warning dark:border-warning");
  let u = `block w-full leading-normal placeholder-neutral-30 py-2 px-2 text-size-16 
  outline-none rounded-md font-opensans`, c = `${u} bg-primary-N5 text-neutral-dark-0 
  hover:bg-neutral-0 focus:bg-neutral-0 dark:bg-neutral-dark-10 dark:hover:bg-neutral-dark-5 
   dark:text-neutral-dark-110 border border-solid ${a}`, d = `${u} border border-solid border-neutral-20 bg-neutral-10 hover:bg-neutral-10 
  text-neutral placeholder-neutral-30  dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 cursor-not-allowed`;
  d = e.customClass ? `${d} ${e.customClass}` : `${d}`, c = e.customClass ? `${c} ${e.customClass}` : `${c}`;
  let f = e.disabled ? d : c;
  return y.createElement("textarea", { className: f, ...n, ...r, "data-name": o });
}, _ie = ({ variant: o = "field", customClass: t, title: e, content: r, type: n, iconVisibility: i = !0, loader: a = !1 }) => {
  let s = "flex text-size-12";
  s = t ? `${s} ${t}` : `${s}`;
  let l, u = "", c = "";
  switch (n) {
    case "helper":
      l = "Helper", u = "bg-neutral-10 dark:bg-primary-40", c = "text-neutral-60 text-size-12 font-roboto font-normal";
      break;
    case "important":
      l = "infoRound", u = "bg-primary-20 dark:bg-info-20", c = "text-primary-dark text-size-12 font-roboto font-normal";
      break;
    case "alert":
      l = "Alert", u = "bg-warning-5 dark:bg-warning-40", c = "text-warning text-size-12 font-roboto font-normal";
      break;
    case "success":
      l = "successInfo", u = "bg-success-5 dark:bg-success-20", c = "text-success text-size-12 font-roboto font-normal";
      break;
    case "error":
      l = "Error", u = "bg-error-5 dark:bg-error-20", c = "text-error text-size-12 font-roboto font-normal";
      break;
  }
  let d = "text-neutral-80 text-size-12 font-roboto font-normal", f = "text-neutral-80 text-size-14 leading-tight", v = "block mr-2 mt-0.5", g = `mt-1 ${s}`, m = `${u} px-2 py-2 rounded-md ${s}`;
  const b = {
    field: () => y.createElement(
      "div",
      { className: g },
      a ? null : i && y.createElement(
        "i",
        { className: v },
        y.createElement(dr, { name: l })
      ),
      a ? y.createElement(
        "div",
        { className: "flex items-center justify-center" },
        y.createElement("h4", { className: c }, e),
        y.createElement(HN, null)
      ) : y.createElement("h4", { className: c }, e)
    ),
    flash: () => y.createElement(
      "div",
      { className: m },
      i && y.createElement(
        "i",
        { className: v },
        y.createElement(dr, { name: l })
      ),
      y.createElement(
        "div",
        null,
        y.createElement("h4", { className: d }, e)
      )
    ),
    spot: () => y.createElement(
      "div",
      { className: m },
      i && y.createElement(
        "i",
        { className: v },
        y.createElement(dr, { name: l })
      ),
      y.createElement(
        "div",
        null,
        y.createElement("h4", { className: f }, e),
        y.createElement("div", { className: "text-size-12 dark:text-neutral-80" }, r)
      )
    )
  };
  return b[o]();
}, xie = sE(({ customClass: o, portrait: t, children: e, ...r }, n) => {
  let i = "h-full object-cover", a = "";
  return a = o ? `${a} ${o}` : `${a}`, a = t ? `${a} ${i}` : `${a}`, y.createElement("video", { className: a, ...r, ref: n }, e);
}), Rie = ({ value: o, onChange: t, options: e, status: r, variant: n = "default", showClear: i = !1, name: a = null, iconName: s, placement: l, placeholder: u, selectDisable: c }) => {
  const d = o, [f, v] = er(!1), g = () => {
    t(void 0);
  }, m = ($e) => {
    t($e);
  }, b = ($e) => $e.value === (d == null ? void 0 : d.value);
  let S = `box-border h-12 py-2 px-4 w-full relative 
  cursor-pointer text-size-base text-neutral-dark-0 flex items-center  rounded-md 
  appearance-none bg-neutral-5 hover:bg-neutral-0 dark:bg-neutral-dark-10 dark:text-neutral-dark110 dark:hover:bg-neutral-dark-05 dark:border-neutral-dark-10`, R = `${S} border border-solid border-neutral-10`, P = `${S} border border-solid border-error`, D = Ut(r === "error", P, R), M = Ut(!!c, `box-border h-12 py-2 px-4 w-full relative 
  cursor-pointer text-size-base flex items-center  rounded-md 
  appearance-none bg-neutral-10 border border-neutral-20 dark:bg-neutral-dark-20 dark:border-neutral-dark-10 border-solid cursor-not-allowed pointer-events-none`, D), B = Ut(!!c, "flex-1 text-neutral-60 dark:text-neutral-40", "flex-1 text-neutral-dark-0 dark:text-neutral-40 truncate"), j = "w-full z-50 shadow-6xl top-12 absolute left-0 bg-neutral-0 ease-in duration-200 z-50 rounded-b-md max-h-56 overflow-y-auto dark:bg-neutral-dark-5 dark:shadow-D4xl", V = Ut(!!f, `${j} block`, `${j} hidden`), W = "cursor-pointer text-neutral-dark-0 py-1.5 px-4 hover:bg-neutral-5 dark:text-neutral-40 dark:hover:bg-neutral-dark-0", q = "bg-neutral-20 hover:bg-neutral-20 dark:bg-neutral-dark-20", ee = "relative inline-flex", re = "w-28 z-50 shadow-6xl top-7 absolute right-0 overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-md max-h-56 dark:bg-neutral-dark-5 dark:shadow-D4xl", ie = Ut(!!f, `${re} block`, `${re} hidden`), ne = "option py-1 px-2 text-neutral-dark-0 hover:bg-neutral-5 cursor-pointer dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-0 flex items-center", se = "relative inline-flex", pe = "w-28 z-50 shadow-6xl  absolute overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-md max-h-56 dark:bg-neutral-dark-5 dark:shadow-D4xl", K = Ut(!!f, `${pe} block`, `${pe} hidden`), J = "option py-1 px-2 text-neutral-dark-0 hover:bg-neutral-5 cursor-pointer dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-0 flex items-center", ue = "text-primary bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-0 dark:hover:bg-neutral-dark-0 dark:text-primary-dark ", he = "py-1 px-2 pointer-events-none bg-neutral-20 text-neutral-30  dark:bg-neutral-dark-10 dark:text-neutral-dark-20", fe = `${K} ${l === "top" ? "bottom-6" : "top-7"} right-0`, ae = "inline-flex items-center relative py-1", oe = "w-full z-50 shadow-6xl absolute left-0 overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-b-md  dark:bg-neutral-dark-5 dark:shadow-D4xl", ve = Ut(!!f, `${oe} block`, `${oe} hidden`), _e = "break-words cursor-pointer text-neutral-dark-0 py-1.5 px-4 hover:bg-neutral-5 dark:text-neutral-40 dark:hover:bg-neutral-dark-0", le = "bg-neutral-20 hover:bg-neutral-20 dark:bg-neutral-dark-20", X = Ut(!!c, "dark:text-neutral-40", "text-neutral-40 dark:text-neutral-dark-110");
  function xe() {
    return y.createElement(
      "div",
      { onBlur: () => v(!1), onClick: () => v(!f), tabIndex: 0, className: M, "data-name": a },
      y.createElement("div", { className: B }, u && !(d != null && d.label) ? y.createElement("span", { className: X }, u) : d == null ? void 0 : d.label),
      y.createElement(
        Dt,
        { check: !!(i && (d != null && d.label)) },
        y.createElement(
          "button",
          { onClick: ($e) => {
            $e.stopPropagation(), g();
          } },
          y.createElement(dr, { name: "Close", className: "mr-2 w-4" })
        )
      ),
      y.createElement(
        "div",
        null,
        y.createElement(dr, { name: "DownArrow" })
      ),
      y.createElement("ul", { className: V }, e.map(($e, pt) => y.createElement("li", { key: pt, className: `${W}  ${Ut(b($e), `${q}`, "")} `, onClick: (st) => {
        st.stopPropagation(), m($e), v(!f);
      } }, $e.label)))
    );
  }
  function Le() {
    return y.createElement(
      "div",
      { className: "inline-flex" },
      y.createElement(
        "div",
        { onBlur: () => v(!1), onClick: () => v(!f), tabIndex: 0, className: se, "data-name": a },
        y.createElement(
          "div",
          { className: "text-size-10 dark:text-neutral-40 flex flex-1 cursor-pointer" },
          y.createElement("span", null, d == null ? void 0 : d.label),
          y.createElement(dr, { name: "DownArrow" })
        ),
        y.createElement("ul", { className: fe }, e.map(($e, pt) => y.createElement("li", { key: pt, className: `${$e.disabled ? `${he}` : `${J}  ${b($e) ? `${ue}` : ""}`} `, onClick: (st) => {
          st.stopPropagation(), m($e), v(!f);
        } }, $e.label)))
      )
    );
  }
  function Ue() {
    return y.createElement(
      "div",
      { className: "inline-flex" },
      y.createElement(
        "div",
        { onBlur: () => v(!1), onClick: () => v(!f), tabIndex: 0, className: ee, "data-name": a },
        y.createElement(
          "div",
          { className: "flex-1 cursor-pointer" },
          y.createElement(dr, { name: s })
        ),
        y.createElement("ul", { className: ie }, e.map(($e, pt) => y.createElement(
          "li",
          { key: pt, className: `${ne}`, onClick: (st) => {
            st.stopPropagation(), m($e), v(!f);
          } },
          y.createElement(
            "span",
            { className: "mr-2 inline-block" },
            y.createElement(dr, { name: $e.icon, className: "w-4" })
          ),
          y.createElement("span", null, $e.label)
        )))
      )
    );
  }
  function He() {
    return y.createElement(
      "div",
      { onBlur: () => v(!1), onClick: () => v(!f), tabIndex: 0, className: ae, "data-name": a },
      y.createElement("div", { className: "font-opensans text-size-base text-neutral-dark-0 dark:text-neutral-40 mr-2 font-semibold" }, d == null ? void 0 : d.label),
      y.createElement(
        "div",
        null,
        y.createElement(dr, { name: "DownArrow", fill: "#768395" })
      ),
      y.createElement("ul", { className: ve, style: { maxWidth: "200px", minWidth: "175px", top: "35px", maxHeight: "390px" } }, e.map(($e, pt) => y.createElement("li", { key: pt, className: `${_e}  ${Ut(b($e), `${le}`, "")} `, onClick: (st) => {
        st.stopPropagation(), m($e), v(!f);
      } }, $e.label)))
    );
  }
  return (() => {
    switch (n) {
      case "default":
        return xe();
      case "menuPicker":
        return Le();
      case "iconBased":
        return Ue();
      case "borderLess":
        return He();
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}, Tie = ({ children: o, customClass: t = "", variant: e = "default" }) => {
  let r = "fixed-wrapper sticky border-y border-solid border-neutral-10 dark:border-neutral-dark-10 dark:bg-neutral-dark-5 bg-neutral-0 left-0 initial:bottom-32 right-0 w-full py-2";
  r = Ot(r, t);
  let n = "shadow-4xl dark:shadow-transparent bg-neutral-0  dark:bg-neutral-dark-20 fixed bottom-0 right-auto -translate-x-4 w-72 px-4 py-2";
  n = Ot(n, t);
  const i = {
    default: () => y.createElement("section", { className: r }, o),
    contained: () => y.createElement("section", { className: n }, o)
  };
  return i[e]();
}, Oie = ({ children: o, title: t, ...e }) => {
  let r = `text-size-14 py-3 px-3 rounded-md border border-solid 
  border-neutral-10 mb-4 bg-neutral-5 dark:bg-neutral-dark-5 dark:border-neutral-dark-10`;
  return r = e.customClass ? `${r} ${e.customClass}` : `${r}`, y.createElement(
    "div",
    { className: r },
    t ? y.createElement("h5", { className: "mb-4 leading-6 text-neutral dark:text-neutral-dark-110" }, t) : null,
    o
  );
}, Pie = ({ children: o, label: t, title: e, ...r }) => {
  let n = "initial:mb-3", i = `block bg-neutral-5 border-2 border-dashed 
  border-neutral-10 flex px-3 py-0.5 rounded-md bg-neutral-0 dark:bg-transparent dark:border-neutral-dark-20 dark:text-primary-dark flex items-center justify-between`;
  return n = r.customClass ? `${n} ${r.customClass}` : `${n}`, y.createElement(
    "div",
    { className: n },
    y.createElement("h5", { className: "text-neutral-60 dark:text-neutral-dark-40 mb-1 text-size-14" }, e),
    y.createElement(
      "div",
      { className: i },
      y.createElement("h5", { className: "font-semibold uppercase text-neutral-80 dark:text-neutral-dark-110" }, t),
      y.createElement("div", { className: "flex items-center cursor-pointer" }, o)
    )
  );
}, $oe = ({ ...o }) => {
  let t = "-mr-2 -ml-2 flex flex-wrap";
  return t = o.customClass ? `${t} ${o.customClass}` : `${t}`, y.createElement("ul", { className: t }, o.children);
}, Pb = ({ ...o }) => {
  let t = "leading-tight px-2 initial:text-size-10 text-neutral-40 border-l border-neutral-40 border-solid first:border-0";
  return t = o.customClass ? `${t} ${o.customClass}` : `${t}`, y.createElement("li", { className: t }, o.children);
}, Die = ({ children: o, variant: t = "default", footer: e, ...r }) => {
  const n = { onClick: r.onClick };
  let i = "cursor-pointer rounded-md border border-solid border-neutral-10 mb-4 dark:border-neutral-dark-10";
  i = r.customClass ? `${i} ${r.customClass}` : i;
  let a = r.selected ? `${i} border-primary dark:border-border-primary-dark` : `${i} border-neutral-10 dark:border-neutral-dark-10`;
  const s = {
    default: () => y.createElement(
      "div",
      { className: a, ...n },
      y.createElement("div", null, o),
      e ? y.createElement(
        "div",
        { className: "px-4 py-4 flex justify-between items-center" },
        y.createElement("div", { className: "basis-1/2 text-center" }, e.leftCol),
        y.createElement("div", { className: "basis-1/2" }, e.rightCol)
      ) : null
    )
  };
  return s[t]();
};
function Aie({ variant: o = "default", value: t, options: e, searchAttribute: r, placeholder: n, disabled: i, onChange: a, autocomplete: s = "off", getQueryText: l, shouldFocusAndSelectInputOnDropdown: u }) {
  const c = Cr(null), [d, f] = er("");
  let v = ` 
    relative w-full cursor-default overflow-hidden rounded-md 
    border border-solid border-neutral-10 dark:border-neutral-dark-10
    text-left  
    focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary`, g = Ut(!!i, "cursor-not-allowed bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-20 hover:dark:bg-neutral-dark-20 dark:text-neutral-40 text-neutral-40", "bg-neutral-5 dark:bg-neutral-dark-10 text-neutral-dark-0 dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-5 hover:bg-white"), m = `h-12 w-full rounded-md border-none py-2 pl-4 pr-12 text-size-base focus:outline-none focus:ring-0 dark:border-neutral-dark-10 ${g}`, b = "relative w-full cursor-default overflow-hidden text-left focus:outline-none rounded-md border border-solid border-neutral-10 dark:border-neutral-dark-10", R = `w-full border-none text-size-14 font-medium focus:ring-0  px-2 py-1 focus:outline-none ${Ut(!!i, "cursor-not-allowed bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-20 hover:dark:bg-neutral-dark-20 dark:text-neutral-40 text-neutral-40", "bg-neutral-0 text-neutral-dark-0 dark:text-neutral-dark-110")} ${g}`, P = `absolute inset-y-0 right-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none
  absolute inset-y-0 right-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none`, D = "left-0 right-0 absolute z-10 mt-1 overflow-y-auto shadow-6xl dark:shadow-none rounded-md bg-neutral-0 dark:bg-neutral-dark-10 dark:text-neutral-dark-110 dark:border dark:border-solid dark:border-neutral-dark-5 max-h-56", x = "text-neutral-60 font-opensans text-size-12 dark:text-neutral-dark-80";
  const M = d === "" ? e : e.filter((W) => W[r].toLowerCase().includes(d.toLowerCase()));
  function F() {
    return y.createElement(
      Tn,
      { value: t, disabled: i, onChange: a, nullable: !0 },
      y.createElement(
        "div",
        { className: "relative mt-1" },
        y.createElement(
          "div",
          { className: v },
          y.createElement(Tn.Input, { className: m, onChange: (W) => {
            f(W.target.value), l == null || l(W.target.value);
          }, displayValue: (W) => W == null ? void 0 : W[r], autoComplete: s }),
          y.createElement(
            Dt,
            { check: !!t },
            y.createElement(
              "button",
              { onClick: () => a(null), className: "absolute right-0 h-12 px-3" },
              y.createElement(dr, { name: "Close" })
            )
          ),
          y.createElement(
            Dt,
            { check: !t },
            y.createElement(dr, { name: "Search", className: P })
          )
        ),
        y.createElement(
          cg,
          { as: yn, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => f("") },
          y.createElement(Tn.Options, { className: D }, M.map((W) => y.createElement(
            "div",
            { key: W.id, className: "border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid" },
            y.createElement(Tn.Option, { value: W, as: yn }, ({ active: q, selected: ee }) => y.createElement("li", { className: `dark:text-neutral-dark-110 px-3 py-3 ${Ut(q, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, W[r]))
          )))
        )
      )
    );
  }
  function H() {
    return y.createElement(
      Tn,
      { value: t, disabled: i, onChange: a, nullable: !0 },
      y.createElement(
        "div",
        { className: "relative mt-1" },
        y.createElement(
          "div",
          { className: v },
          y.createElement(Tn.Input, { className: m, onChange: (W) => f(W.target.value), displayValue: (W) => W == null ? void 0 : W[r], autoComplete: s }),
          y.createElement(
            Dt,
            { check: !!t },
            y.createElement(
              "button",
              { onClick: () => a(null), className: "absolute right-0 h-12 px-3" },
              y.createElement(dr, { name: "Close" })
            )
          ),
          y.createElement(
            Dt,
            { check: !t },
            y.createElement(dr, { name: "Search", className: P })
          )
        ),
        y.createElement(
          cg,
          { as: yn, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => f("") },
          y.createElement(Tn.Options, { className: D }, M.map((W) => y.createElement(
            "div",
            { key: W.id },
            y.createElement(Tn.Option, { value: W, as: yn }, ({ active: q, selected: ee }) => y.createElement(
              "div",
              { className: `border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid px-3 py-3 ${Ut(q, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` },
              y.createElement("h5", { className: x }, W.fundName),
              y.createElement(
                Dt,
                { check: W.type || W.risk || W.rating },
                y.createElement(
                  $oe,
                  null,
                  y.createElement(
                    Dt,
                    { check: W.type },
                    y.createElement(Pb, null, W.type)
                  ),
                  y.createElement(
                    Dt,
                    { check: W.risk },
                    y.createElement(Pb, null, W.risk)
                  ),
                  y.createElement(
                    Dt,
                    { check: W.rating },
                    y.createElement(
                      Pb,
                      null,
                      y.createElement(
                        "div",
                        { className: "flex items-center" },
                        y.createElement(dr, { name: "Star", className: "mr-1 h-2 w-2" }),
                        y.createElement("span", null, W.rating)
                      )
                    )
                  )
                )
              )
            ))
          )))
        )
      )
    );
  }
  function B() {
    return y.createElement(Tn, { value: t, disabled: i, onChange: a, nullable: !0 }, ({ open: W }) => y.createElement(
      "div",
      { className: "relative mt-1" },
      y.createElement(
        "div",
        { className: v },
        y.createElement(Tn.Input, { className: m, onChange: (q) => f(q.target.value), displayValue: (q) => q == null ? void 0 : q[r], placeholder: Ry(n), autoComplete: s }),
        !i && t ? y.createElement(
          "button",
          { onClick: () => a(null), className: "absolute right-0 h-12 px-3" },
          y.createElement(dr, { name: "Close" })
        ) : y.createElement(
          Tn.Button,
          { className: "absolute inset-y-0 right-0 flex items-center pr-2" },
          y.createElement(dr, { name: "DownArrow", className: `duration-300 ease-in ${Ut(W, "rotate-180", "")}` })
        )
      ),
      y.createElement(
        cg,
        { as: yn, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => f("") },
        y.createElement(Tn.Options, { className: D }, M.map((q) => y.createElement(
          "div",
          { key: q.id, className: "border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid" },
          y.createElement(Tn.Option, { value: q, as: yn }, ({ active: ee, selected: re }) => y.createElement("li", { className: `dark:text-neutral-dark-110 px-3 py-3  ${Ut(ee, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, q[r]))
        )))
      )
    ));
  }
  function j() {
    return y.createElement(Tn, { value: t, disabled: i, onChange: a, nullable: !0 }, ({ open: W }) => y.createElement(
      "div",
      { className: "relative mt-1" },
      y.createElement(
        "div",
        { className: b },
        y.createElement(Tn.Input, { className: R, onChange: (q) => f(q.target.value), displayValue: (q) => q == null ? void 0 : q[r], placeholder: Ry(n), ref: c, autoComplete: s }),
        y.createElement(
          Tn.Button,
          { className: "absolute inset-y-0 right-0 flex items-center pr-2", onClick: () => {
            var q, ee;
            u && ((q = c.current) == null || q.focus(), (ee = c.current) == null || ee.select());
          } },
          y.createElement(dr, { name: "DownArrow", className: `duration-300 ease-in ${Ut(W, "rotate-180", "")}` })
        )
      ),
      y.createElement(
        cg,
        { as: yn, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => f("") },
        y.createElement(Tn.Options, { className: D, style: { maxWidth: "200px", minWidth: "175px", top: "35px", maxHeight: "390px" } }, M.map((q) => y.createElement(
          "li",
          { key: q.id, className: "cursor-pointer" },
          y.createElement(Tn.Option, { value: q, as: yn }, ({ active: ee, selected: re }) => y.createElement("div", { className: `dark:text-neutral-dark-110 py-1.5 px-4  ${Ut(ee, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, q[r]))
        )))
      )
    ));
  }
  return (() => {
    switch (o) {
      case "default":
        return F();
      case "fund":
        return H();
      case "autocomplete":
        return B();
      case "borderless":
        return j();
      default:
        return y.createElement(y.Fragment, null);
    }
  })();
}
const Mie = ({ variant: o = "default", status: t, icon: e, disabled: r, title: n, subtitle: i, onClick: a, ...s }) => {
  let l = "flex bg-neutral-5 initial:px-2 py-2 rounded-md border border-solid initial:mb-2", c = r ? `${l} text-neutral-20 dark:bg-neutral-dark-5 dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 step-disabled` : `${l} border-neutral-10 dark:bg-neutral-dark-10 dark:border-neutral-dark-20  text-neutral-110 dark:text-neutral-dark-80`;
  c = a ? `${c} cursor-pointer` : `${c}`;
  let d = `${c} flex items-center relative overflow-hidden pl-4`, f;
  switch (t) {
    case "success":
      f = "SuccessTick";
      break;
    case "error":
      f = "AlertFilled";
      break;
    case "resume":
      f = "Resume";
      break;
    default:
      f = "Default";
      break;
  }
  let v, g = "";
  switch (t) {
    case "success":
      v = "SuccessTick", g = "bg-success";
      break;
    case "error":
      v = "AlertFilled", g = "bg-error";
      break;
    case "resume":
      v = "Resume", g = "bg-warning";
      break;
    default:
      v = "Default", g = "";
      break;
  }
  const m = t ? f : e, b = t ? v : e;
  g = `absolute w-1 block left-0 h-full ${g}`;
  const S = {
    default: () => y.createElement(
      "li",
      { className: c, onClick: a },
      y.createElement("span", { className: "mr-4 w-5 flex-shrink-0" }, m && y.createElement(dr, { name: m })),
      y.createElement(
        "div",
        { className: "font-opensans flex flex-1 font-semibold" },
        y.createElement("div", { className: "flex-1" }, s.children),
        a && y.createElement(
          "span",
          { className: "ml-2 w-5 flex-shrink-0" },
          y.createElement(dr, { name: "rightArrow" })
        )
      )
    ),
    plus: () => y.createElement(
      "li",
      { className: d, onClick: a },
      t && y.createElement("span", { className: g }),
      y.createElement(
        "div",
        { className: "flex-1" },
        n && y.createElement("h5", null, n),
        i && y.createElement(
          "div",
          { className: "flex items-start" },
          b && y.createElement(
            "span",
            { className: "mr-2 w-4 flex-shrink-0" },
            y.createElement(dr, { name: b, className: "h-4 w-4" })
          ),
          y.createElement("p", { className: "text-neutral-60 text-size-12 dark:text-neutral-dark-80" }, i)
        )
      ),
      a && y.createElement(
        "span",
        { className: "ml-2 w-5 flex-shrink-0" },
        y.createElement(dr, { name: "rightArrow" })
      )
    )
  };
  return S[o]();
}, ZP = {
  bright: ["#FFD976", "#FA8C16", "#E44632", "#009666", "#2955D9", "#E967E4", "#722ED1"],
  dull: ["#EABE6E", "#D67C1C", "#A52535", "#5E7D56", "#37509B", "#DFB5DD", "#7B5AA9"],
  neutral: ["#E8E8E8", "#C7C7C7", "#A4A4A4", "#828282", "#5B5B5B", "#505050", "#383838"]
};
function Fie(o) {
  var v, g, m, b;
  const { chartData: t, innerRadius: e, colorPalette: r } = o, [n, i] = er(null);
  wr(() => {
    const S = {
      ...t
    };
    r && ZP[r] && (S.datasets[0].backgroundColor = ZP[r]), i(S);
  }, [t, e, r]);
  function a(S) {
    var R, P;
    return (R = S == null ? void 0 : S.dataset) != null && R.customLegendLabel ? (P = S == null ? void 0 : S.dataset) == null ? void 0 : P.customLegendLabel[S.dataIndex] : Ry(S == null ? void 0 : S.label);
  }
  function s(S) {
    var R, P;
    return (R = S == null ? void 0 : S.dataset) != null && R.customLegendValue ? (P = S == null ? void 0 : S.dataset) == null ? void 0 : P.customLegendValue[S.dataIndex] : "";
  }
  wr(() => {
    if (n) {
      const S = document.getElementById("doughnutChart");
      new hs(S, {
        type: "doughnut",
        data: n,
        options: {
          cutout: e ? `${e}%` : "0%",
          plugins: {
            legend: {
              display: !1
            },
            datalabels: {
              color: "#6F809E",
              align: "end",
              anchor: "end",
              formatter: function(R, P) {
                var D, x, M;
                return ((M = (x = (D = P == null ? void 0 : P.chart) == null ? void 0 : D.data) == null ? void 0 : x.labels) == null ? void 0 : M[P.dataIndex]) ?? R;
              },
              font: {
                size: 11,
                weight: "bold"
              }
            },
            tooltip: {
              backgroundColor: "#F0F0F0",
              callbacks: {
                label: a,
                afterLabel: s,
                title: function(R) {
                  return Ry(R == null ? void 0 : R.title);
                },
                labelTextColor: (R) => "#000000",
                labelPointStyle: function(R) {
                  return {
                    pointStyle: "circle",
                    rotation: 0
                  };
                }
              }
            }
          },
          layout: {
            padding: {
              left: 40,
              right: 40,
              top: 30,
              bottom: 30
            }
          }
        },
        plugins: [DU]
      });
    }
  }, [n, e, r]);
  const l = ((g = (v = n == null ? void 0 : n.datasets) == null ? void 0 : v[0]) == null ? void 0 : g.customLegendLabel) && ((b = (m = n == null ? void 0 : n.datasets) == null ? void 0 : m[0]) == null ? void 0 : b.customLegendValue);
  function u(S) {
    return S ? "md:basis-3/5 md:w-3/5 w-1/2 basis-3/4 flex justify-center" : "basis-full";
  }
  const c = u(l);
  function d() {
    var S, R, P;
    return l ? y.createElement("div", { className: "custom-legends max-h-72 shrink-0  basis-1/4 overflow-y-auto pr-1 md:basis-2/5 md:pr-2" }, (P = (R = (S = n == null ? void 0 : n.datasets) == null ? void 0 : S[0]) == null ? void 0 : R.customLegendLabel) == null ? void 0 : P.map((D, x) => {
      var j, V, W, q, ee, re;
      const M = D, F = (W = (V = (j = n == null ? void 0 : n.datasets) == null ? void 0 : j[0]) == null ? void 0 : V.customLegendValue) == null ? void 0 : W[x], H = (re = (ee = (q = n == null ? void 0 : n.datasets) == null ? void 0 : q[0]) == null ? void 0 : ee.backgroundColor) == null ? void 0 : re[x], B = `${H}${M}${F}`;
      return y.createElement(
        "div",
        { key: B, className: "font-roboto text-size-10 md:text-size-12 mb-4 font-normal" },
        y.createElement(
          "div",
          { className: "text-neutral-40 dark:text-neutral-40 flex font-bold" },
          y.createElement("i", { className: "mr-1 mt-1 block h-2 w-2 shrink-0 rounded-full", style: { backgroundColor: H } }),
          M,
          ":"
        ),
        y.createElement("div", { className: "text-neutral-dark-0 dark:text-neutral-dark-110 pl-3 font-bold" }, F)
      );
    })) : null;
  }
  function f() {
    return n ? y.createElement(
      "div",
      { className: "container flex items-center justify-center" },
      d(),
      y.createElement(
        "div",
        { className: c },
        y.createElement("canvas", { id: "doughnutChart" })
      )
    ) : y.createElement(y.Fragment, null);
  }
  return f();
}
const Iie = ({ customClass: o, children: t }) => {
  const e = `flex flex-row -mr-2 -ml-2 flex-wrap ${o || ""}`;
  return y.createElement("div", { className: e }, t);
}, Lie = ({ span: o, verticalGap: t = !0, customClass: e, children: r }) => {
  let n = "flex-grow pr-2 pl-2";
  return o ? n += o === 12 ? " w-full" : ` w-${o}/12` : n += " max-w-1/2 flex-basis-1/2", t && (n += " mb-3"), e && (n += ` ${e}`), y.createElement("div", { className: n }, r);
}, Ty = Mi(null), Nie = ({ expanded: o = !1, variant: t = "default", onChange: e, children: r, bg: n }) => {
  const i = pr(() => ({ expanded: o, onChange: e }), [o, e]);
  let a = n ? "py-1 bg-neutral-6 rounded-md mb-2 accordion-wrapper dark:bg-neutral-dark-5" : "py-2 accordion-wrapper", s = "bg-neutral-0 shadow-4xl rounded-lg mb-2 accordion-wrapper dark:bg-neutral-dark-5 dark:border-neutral-dark-10 dark:shadow-transparent";
  const l = {
    default: () => y.createElement(
      "div",
      { className: a },
      y.createElement(Ty.Provider, { value: i }, r)
    ),
    panel: () => y.createElement(
      "div",
      { className: s },
      y.createElement(Ty.Provider, { value: i }, r)
    )
  };
  return l[t]();
}, kie = ({ variant: o = "default", children: t, ...e }) => {
  const r = si(Ty);
  let n = "accordion-summary flex justify-between items-center cursor-pointer font-inter py-1";
  n = e.bg ? `${n} text-neutral-110 font-semibold px-2` : n;
  let i = e.active ? "accordion-content-active flex items-center" : "flex items-center", a = e.active ? "accordion-title font-inter text-neutral-110 font-semibold dark:text-neutral-dark-80" : "accordion-title font-inter  text-neutral-60 dark:text-neutral-40";
  i = e.bg ? `${i} text-size-12 text-neutral-110 py-1 px-2 dark:text-neutral-40` : `${i} text-size-base`;
  let s = e.active ? "icon-active " : "", l = "flex justify-between items-center cursor-pointer font-inter p-3";
  const u = {
    default: () => y.createElement(
      "div",
      { onClick: (d) => {
        var f;
        return (f = r == null ? void 0 : r.onChange) == null ? void 0 : f.call(r, d, !r.expanded);
      }, className: n },
      y.createElement("div", { className: i }, t),
      y.createElement("div", { className: "accordion-arrow" }, r != null && r.expanded ? y.createElement(dr, { name: "DownArrow", className: `${s} rotate-180` }) : y.createElement(dr, { name: "DownArrow", className: s, fill: "#768395" }))
    ),
    panel: () => y.createElement(
      "div",
      { onClick: (d) => {
        var f;
        return (f = r == null ? void 0 : r.onChange) == null ? void 0 : f.call(r, d, !r.expanded);
      }, className: l },
      y.createElement(
        "div",
        { className: "flex items-center" },
        y.createElement("div", { className: a }, t)
      ),
      y.createElement("div", null, r != null && r.expanded ? y.createElement(dr, { name: "DownArrow", className: `${s} rotate-180` }) : y.createElement(dr, { name: "DownArrow", className: s }))
    )
  };
  return u[o]();
}, Gie = ({ children: o, variant: t = "default", ...e }) => {
  const r = si(Ty), n = r != null && r.expanded ? "block" : "hidden";
  let i = "";
  i = e.bg ? `${i} text-size-12` : `${i} pl-8 pr-4`;
  let a = "p-3";
  const s = {
    default: () => y.createElement("div", { className: `${n} ${i}` }, o),
    panel: () => y.createElement("div", { className: `${n} ${a}` }, o)
  };
  return s[t]();
}, Vie = ({ ...o }) => {
  let t = "panel font-inter bg-neutral-0 p-4 rounded-md mb-4 shadow-4xl dark:bg-neutral-dark-5 dark:border-neutral-dark-10 dark:shadow-transparent";
  const e = { onClick: o.onClick };
  return o.onClick && (t += " cursor-pointer"), t = o.customClass ? `${t} ${o.customClass}` : `${t}`, y.createElement("div", { className: t, ...e }, o.children);
}, Hie = ({ customClass: o = "", ...t }) => {
  let e = "panel-card rounded-md border border-solid border-neutral-10 dark:border-neutral-dark-10 bg-neutral-5 dark:bg-neutral-dark-10", r = "panel-card-inner";
  t.header || t.footer ? (e = Ot(e, "p-0"), r = Ot(r, "p-4")) : e = Ot(e, "p-4"), e = Ot(e, o);
  let n = "panel-card-header py-2 px-4 text-base-color text-size-12 bg-primary-10 rounded-t-md dark:bg-neutral-80";
  t.removeHeaderSpacing || (n = Ot(n, "py-2 px-4"));
  let i = "panel-card-footer text-base-color text-size-12 bg-primary-10 rounded-b-md";
  return t.removeFoooterSpacing || (i = Ot(i, "py-2 px-4")), y.createElement(
    "div",
    { className: e },
    y.createElement(
      Dt,
      { check: !!t.header },
      y.createElement("div", { className: n }, t.header)
    ),
    y.createElement("div", { className: r }, t.children),
    y.createElement(
      Dt,
      { check: !!t.footer },
      y.createElement("div", { className: i }, t.footer)
    )
  );
}, Bie = ({ span: o, ...t }) => {
  let e = "panel-col px-4 ";
  return o && (e += o === 12 ? "flex-grow w-full" : `w-${o}/12 basis-${o}/12`), t.customClass && (e += ` ${t.customClass}`), t.verticalGap && (e += " mb-3"), y.createElement("div", { className: e }, t.children);
}, Wie = ({ ...o }) => {
  let t = "panel-row flex flex-row -mx-4 flex-wrap";
  return t = o.customClass ? `${t} ${o.customClass}` : `${t}`, y.createElement("div", { className: t }, o.children);
};
var Ph = { exports: {} }, Db = { exports: {} }, sr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QP;
function zoe() {
  if (QP) return sr;
  QP = 1;
  var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
  function P(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case t:
          switch (x = x.type, x) {
            case l:
            case u:
            case r:
            case i:
            case n:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case c:
                case g:
                case v:
                case a:
                  return x;
                default:
                  return M;
              }
          }
        case e:
          return M;
      }
    }
  }
  function D(x) {
    return P(x) === u;
  }
  return sr.AsyncMode = l, sr.ConcurrentMode = u, sr.ContextConsumer = s, sr.ContextProvider = a, sr.Element = t, sr.ForwardRef = c, sr.Fragment = r, sr.Lazy = g, sr.Memo = v, sr.Portal = e, sr.Profiler = i, sr.StrictMode = n, sr.Suspense = d, sr.isAsyncMode = function(x) {
    return D(x) || P(x) === l;
  }, sr.isConcurrentMode = D, sr.isContextConsumer = function(x) {
    return P(x) === s;
  }, sr.isContextProvider = function(x) {
    return P(x) === a;
  }, sr.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, sr.isForwardRef = function(x) {
    return P(x) === c;
  }, sr.isFragment = function(x) {
    return P(x) === r;
  }, sr.isLazy = function(x) {
    return P(x) === g;
  }, sr.isMemo = function(x) {
    return P(x) === v;
  }, sr.isPortal = function(x) {
    return P(x) === e;
  }, sr.isProfiler = function(x) {
    return P(x) === i;
  }, sr.isStrictMode = function(x) {
    return P(x) === n;
  }, sr.isSuspense = function(x) {
    return P(x) === d;
  }, sr.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === u || x === i || x === n || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === v || x.$$typeof === a || x.$$typeof === s || x.$$typeof === c || x.$$typeof === b || x.$$typeof === S || x.$$typeof === R || x.$$typeof === m);
  }, sr.typeOf = P, sr;
}
var lr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JP;
function Yoe() {
  return JP || (JP = 1, process.env.NODE_ENV !== "production" && function() {
    var o = typeof Symbol == "function" && Symbol.for, t = o ? Symbol.for("react.element") : 60103, e = o ? Symbol.for("react.portal") : 60106, r = o ? Symbol.for("react.fragment") : 60107, n = o ? Symbol.for("react.strict_mode") : 60108, i = o ? Symbol.for("react.profiler") : 60114, a = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, l = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, c = o ? Symbol.for("react.forward_ref") : 60112, d = o ? Symbol.for("react.suspense") : 60113, f = o ? Symbol.for("react.suspense_list") : 60120, v = o ? Symbol.for("react.memo") : 60115, g = o ? Symbol.for("react.lazy") : 60116, m = o ? Symbol.for("react.block") : 60121, b = o ? Symbol.for("react.fundamental") : 60117, S = o ? Symbol.for("react.responder") : 60118, R = o ? Symbol.for("react.scope") : 60119;
    function P(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === u || X === i || X === n || X === d || X === f || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === v || X.$$typeof === a || X.$$typeof === s || X.$$typeof === c || X.$$typeof === b || X.$$typeof === S || X.$$typeof === R || X.$$typeof === m);
    }
    function D(X) {
      if (typeof X == "object" && X !== null) {
        var xe = X.$$typeof;
        switch (xe) {
          case t:
            var Le = X.type;
            switch (Le) {
              case l:
              case u:
              case r:
              case i:
              case n:
              case d:
                return Le;
              default:
                var Ue = Le && Le.$$typeof;
                switch (Ue) {
                  case s:
                  case c:
                  case g:
                  case v:
                  case a:
                    return Ue;
                  default:
                    return xe;
                }
            }
          case e:
            return xe;
        }
      }
    }
    var x = l, M = u, F = s, H = a, B = t, j = c, V = r, W = g, q = v, ee = e, re = i, ie = n, ne = d, se = !1;
    function pe(X) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(X) || D(X) === l;
    }
    function K(X) {
      return D(X) === u;
    }
    function J(X) {
      return D(X) === s;
    }
    function ue(X) {
      return D(X) === a;
    }
    function he(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function fe(X) {
      return D(X) === c;
    }
    function ae(X) {
      return D(X) === r;
    }
    function oe(X) {
      return D(X) === g;
    }
    function ve(X) {
      return D(X) === v;
    }
    function _e(X) {
      return D(X) === e;
    }
    function le(X) {
      return D(X) === i;
    }
    function Ee(X) {
      return D(X) === n;
    }
    function de(X) {
      return D(X) === d;
    }
    lr.AsyncMode = x, lr.ConcurrentMode = M, lr.ContextConsumer = F, lr.ContextProvider = H, lr.Element = B, lr.ForwardRef = j, lr.Fragment = V, lr.Lazy = W, lr.Memo = q, lr.Portal = ee, lr.Profiler = re, lr.StrictMode = ie, lr.Suspense = ne, lr.isAsyncMode = pe, lr.isConcurrentMode = K, lr.isContextConsumer = J, lr.isContextProvider = ue, lr.isElement = he, lr.isForwardRef = fe, lr.isFragment = ae, lr.isLazy = oe, lr.isMemo = ve, lr.isPortal = _e, lr.isProfiler = le, lr.isStrictMode = Ee, lr.isSuspense = de, lr.isValidElementType = P, lr.typeOf = D;
  }()), lr;
}
var eD;
function BN() {
  return eD || (eD = 1, function(o) {
    process.env.NODE_ENV === "production" ? o.exports = zoe() : o.exports = Yoe();
  }(Db)), Db.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ab, tD;
function Koe() {
  if (tD) return Ab;
  tD = 1;
  var o = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ab = n() ? Object.assign : function(i, a) {
    for (var s, l = r(i), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (o) {
        u = o(s);
        for (var f = 0; f < u.length; f++)
          e.call(s, u[f]) && (l[u[f]] = s[u[f]]);
      }
    }
    return l;
  }, Ab;
}
var Mb, rD;
function j_() {
  if (rD) return Mb;
  rD = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Mb = o, Mb;
}
var Fb, nD;
function WN() {
  return nD || (nD = 1, Fb = Function.call.bind(Object.prototype.hasOwnProperty)), Fb;
}
var Ib, oD;
function qoe() {
  if (oD) return Ib;
  oD = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = j_(), e = {}, r = WN();
    o = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function n(i, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[c](a, c, l, s, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && o(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in e)) {
            e[d.message] = !0;
            var v = u ? u() : "";
            o(
              "Failed " + s + " type: " + d.message + (v ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, Ib = n, Ib;
}
var Lb, iD;
function Xoe() {
  if (iD) return Lb;
  iD = 1;
  var o = BN(), t = Koe(), e = j_(), r = WN(), n = qoe(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Lb = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(K) {
      var J = K && (u && K[u] || K[c]);
      if (typeof J == "function")
        return J;
    }
    var f = "<<anonymous>>", v = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: R(),
      arrayOf: P,
      element: D(),
      elementType: x(),
      instanceOf: M,
      node: j(),
      objectOf: H,
      oneOf: F,
      oneOfType: B,
      shape: W,
      exact: q
    };
    function g(K, J) {
      return K === J ? K !== 0 || 1 / K === 1 / J : K !== K && J !== J;
    }
    function m(K, J) {
      this.message = K, this.data = J && typeof J == "object" ? J : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(K) {
      if (process.env.NODE_ENV !== "production")
        var J = {}, ue = 0;
      function he(ae, oe, ve, _e, le, Ee, de) {
        if (_e = _e || f, Ee = Ee || ve, de !== e) {
          if (l) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xe = _e + ":" + ve;
            !J[xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            ue < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Ee + "` prop on `" + _e + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), J[xe] = !0, ue++);
          }
        }
        return oe[ve] == null ? ae ? oe[ve] === null ? new m("The " + le + " `" + Ee + "` is marked as required " + ("in `" + _e + "`, but its value is `null`.")) : new m("The " + le + " `" + Ee + "` is marked as required in " + ("`" + _e + "`, but its value is `undefined`.")) : null : K(oe, ve, _e, le, Ee);
      }
      var fe = he.bind(null, !1);
      return fe.isRequired = he.bind(null, !0), fe;
    }
    function S(K) {
      function J(ue, he, fe, ae, oe, ve) {
        var _e = ue[he], le = ie(_e);
        if (le !== K) {
          var Ee = ne(_e);
          return new m(
            "Invalid " + ae + " `" + oe + "` of type " + ("`" + Ee + "` supplied to `" + fe + "`, expected ") + ("`" + K + "`."),
            { expectedType: K }
          );
        }
        return null;
      }
      return b(J);
    }
    function R() {
      return b(a);
    }
    function P(K) {
      function J(ue, he, fe, ae, oe) {
        if (typeof K != "function")
          return new m("Property `" + oe + "` of component `" + fe + "` has invalid PropType notation inside arrayOf.");
        var ve = ue[he];
        if (!Array.isArray(ve)) {
          var _e = ie(ve);
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected an array."));
        }
        for (var le = 0; le < ve.length; le++) {
          var Ee = K(ve, le, fe, ae, oe + "[" + le + "]", e);
          if (Ee instanceof Error)
            return Ee;
        }
        return null;
      }
      return b(J);
    }
    function D() {
      function K(J, ue, he, fe, ae) {
        var oe = J[ue];
        if (!s(oe)) {
          var ve = ie(oe);
          return new m("Invalid " + fe + " `" + ae + "` of type " + ("`" + ve + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(K);
    }
    function x() {
      function K(J, ue, he, fe, ae) {
        var oe = J[ue];
        if (!o.isValidElementType(oe)) {
          var ve = ie(oe);
          return new m("Invalid " + fe + " `" + ae + "` of type " + ("`" + ve + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(K);
    }
    function M(K) {
      function J(ue, he, fe, ae, oe) {
        if (!(ue[he] instanceof K)) {
          var ve = K.name || f, _e = pe(ue[he]);
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected ") + ("instance of `" + ve + "`."));
        }
        return null;
      }
      return b(J);
    }
    function F(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function J(ue, he, fe, ae, oe) {
        for (var ve = ue[he], _e = 0; _e < K.length; _e++)
          if (g(ve, K[_e]))
            return null;
        var le = JSON.stringify(K, function(de, X) {
          var xe = ne(X);
          return xe === "symbol" ? String(X) : X;
        });
        return new m("Invalid " + ae + " `" + oe + "` of value `" + String(ve) + "` " + ("supplied to `" + fe + "`, expected one of " + le + "."));
      }
      return b(J);
    }
    function H(K) {
      function J(ue, he, fe, ae, oe) {
        if (typeof K != "function")
          return new m("Property `" + oe + "` of component `" + fe + "` has invalid PropType notation inside objectOf.");
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type " + ("`" + _e + "` supplied to `" + fe + "`, expected an object."));
        for (var le in ve)
          if (r(ve, le)) {
            var Ee = K(ve, le, fe, ae, oe + "." + le, e);
            if (Ee instanceof Error)
              return Ee;
          }
        return null;
      }
      return b(J);
    }
    function B(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var J = 0; J < K.length; J++) {
        var ue = K[J];
        if (typeof ue != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(ue) + " at index " + J + "."
          ), a;
      }
      function he(fe, ae, oe, ve, _e) {
        for (var le = [], Ee = 0; Ee < K.length; Ee++) {
          var de = K[Ee], X = de(fe, ae, oe, ve, _e, e);
          if (X == null)
            return null;
          X.data && r(X.data, "expectedType") && le.push(X.data.expectedType);
        }
        var xe = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new m("Invalid " + ve + " `" + _e + "` supplied to " + ("`" + oe + "`" + xe + "."));
      }
      return b(he);
    }
    function j() {
      function K(J, ue, he, fe, ae) {
        return ee(J[ue]) ? null : new m("Invalid " + fe + " `" + ae + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return b(K);
    }
    function V(K, J, ue, he, fe) {
      return new m(
        (K || "React class") + ": " + J + " type `" + ue + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + fe + "`."
      );
    }
    function W(K) {
      function J(ue, he, fe, ae, oe) {
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type `" + _e + "` " + ("supplied to `" + fe + "`, expected `object`."));
        for (var le in K) {
          var Ee = K[le];
          if (typeof Ee != "function")
            return V(fe, ae, oe, le, ne(Ee));
          var de = Ee(ve, le, fe, ae, oe + "." + le, e);
          if (de)
            return de;
        }
        return null;
      }
      return b(J);
    }
    function q(K) {
      function J(ue, he, fe, ae, oe) {
        var ve = ue[he], _e = ie(ve);
        if (_e !== "object")
          return new m("Invalid " + ae + " `" + oe + "` of type `" + _e + "` " + ("supplied to `" + fe + "`, expected `object`."));
        var le = t({}, ue[he], K);
        for (var Ee in le) {
          var de = K[Ee];
          if (r(K, Ee) && typeof de != "function")
            return V(fe, ae, oe, Ee, ne(de));
          if (!de)
            return new m(
              "Invalid " + ae + " `" + oe + "` key `" + Ee + "` supplied to `" + fe + "`.\nBad object: " + JSON.stringify(ue[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(K), null, "  ")
            );
          var X = de(ve, Ee, fe, ae, oe + "." + Ee, e);
          if (X)
            return X;
        }
        return null;
      }
      return b(J);
    }
    function ee(K) {
      switch (typeof K) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !K;
        case "object":
          if (Array.isArray(K))
            return K.every(ee);
          if (K === null || s(K))
            return !0;
          var J = d(K);
          if (J) {
            var ue = J.call(K), he;
            if (J !== K.entries) {
              for (; !(he = ue.next()).done; )
                if (!ee(he.value))
                  return !1;
            } else
              for (; !(he = ue.next()).done; ) {
                var fe = he.value;
                if (fe && !ee(fe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(K, J) {
      return K === "symbol" ? !0 : J ? J["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && J instanceof Symbol : !1;
    }
    function ie(K) {
      var J = typeof K;
      return Array.isArray(K) ? "array" : K instanceof RegExp ? "object" : re(J, K) ? "symbol" : J;
    }
    function ne(K) {
      if (typeof K > "u" || K === null)
        return "" + K;
      var J = ie(K);
      if (J === "object") {
        if (K instanceof Date)
          return "date";
        if (K instanceof RegExp)
          return "regexp";
      }
      return J;
    }
    function se(K) {
      var J = ne(K);
      switch (J) {
        case "array":
        case "object":
          return "an " + J;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + J;
        default:
          return J;
      }
    }
    function pe(K) {
      return !K.constructor || !K.constructor.name ? f : K.constructor.name;
    }
    return v.checkPropTypes = n, v.resetWarningCache = n.resetWarningCache, v.PropTypes = v, v;
  }, Lb;
}
var Nb, aD;
function Zoe() {
  if (aD) return Nb;
  aD = 1;
  var o = j_();
  function t() {
  }
  function e() {
  }
  return e.resetWarningCache = t, Nb = function() {
    function r(a, s, l, u, c, d) {
      if (d !== o) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: e,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Nb;
}
if (process.env.NODE_ENV !== "production") {
  var Qoe = BN(), Joe = !0;
  Ph.exports = Xoe()(Qoe.isElement, Joe);
} else
  Ph.exports = Zoe()();
Ph.exports.string.isRequired, Ph.exports.number, Ph.exports.func;
Mi(null);
const jie = ({ name: o, isOpen: t = !1, title: e, toggleDaySelector: r, selectedDay: n, onSelectDay: i, customClass: a = "", hideClose: s, ...l }) => {
  const u = () => r == null ? void 0 : r(!1), c = (b) => {
    i(b), u();
  };
  let f = Ot(`modal-wrapper flex flex-col justify-end 
    h-full max-h-screen w-full z-50 fixed left-0 right-0 top-0 bottom-0 m-auto sm:max-w-29`, a);
  return y.createElement(
    Dt,
    { check: !!t },
    y.createElement(
      "div",
      { className: f, "data-component": "dayselector" },
      y.createElement("div", { className: "absolute top-0 bottom-0 w-full z-50 left-0 right-0 dark:bg-neutral-dark-0/[.9] backdrop-blur-sm" }),
      y.createElement(
        "div",
        { className: "modal shadow-txl dark:shadow-none bg-neutral-0 relative z-50 dark:bg-neutral-dark-5" },
        y.createElement(
          "div",
          { className: "flex flex-col px-4 pt-4 pb-6" },
          y.createElement(
            "div",
            { className: "flex items-center justify-between pb-4" },
            y.createElement("h4", { className: "text-neutral-dark-0 mb-1 text-size-14 dark:text-neutral-dark-110" }, e),
            y.createElement(
              "i",
              { onClick: u, className: Ut(!!s, "hidden cursor-pointer", "cursor-pointer") },
              y.createElement(Dn, { name: "Close" })
            )
          ),
          y.createElement("div", { className: "grid grid-cols-7 gap-2", "data-name": o }, Array.from({ length: 28 }, (b, S) => S + 1).map((b) => y.createElement("button", { type: "button", key: b, ...l, onClick: () => c(b), className: `w-full rounded-md py-2 text-center ${n === b ? "bg-primary dark:bg-primary-110 text-white" : "hover:bg-primary-10 text-neutral-60 dark:bg-neutral-dark-10 bg-white"}` }, b)))
        )
      )
    )
  );
}, eie = y.forwardRef(({ className: o, ...t }, e) => y.createElement(
  DN,
  { ref: e, className: Eoe("relative flex w-full touch-none select-none items-center", o), ...t },
  y.createElement(
    Bne,
    { className: "bg-neutral-20 dark:bg-neutral-dark-10 relative h-1.5 w-full grow overflow-hidden rounded-full" },
    y.createElement(Wne, { className: "bg-primary absolute h-full" })
  ),
  y.createElement(jne, { className: "dark:bg-neutral-dark-80 bg-neutral-5 block h-5 w-5 rounded-[10px] shadow-[0_1px_5px_rgba(0,0,0,0.5)] hover:bg-white focus:shadow-[0_0_0_5px_rgba(62,116,255,0.5)] focus:outline-none dark:focus:shadow-[0_0_0_5px_rgba(0,0,0,0.4)]" })
));
eie.displayName = DN.displayName;
const Uie = ({ enabled: o, onChange: t, customClass: e = "" }) => {
  let r = `group relative flex h-7 w-14 cursor-pointer rounded-full p-1 transition-colors duration-200 ease-in-out focus:outline-none ${o ? "bg-primary" : "bg-neutral-20 dark:bg-neutral-dark-10"} data-[focus]:outline-1 data-[focus]:outline-white`;
  return r = Ot(r, e), y.createElement(
    $V,
    { checked: o, onChange: t, className: r },
    y.createElement("span", { "aria-hidden": "true", className: `pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${o ? "translate-x-7" : "translate-x-0"}` })
  );
};
export {
  h5 as $,
  Wie as A,
  AN as B,
  Lie as C,
  cie as D,
  Bie as E,
  Tie as F,
  Vie as G,
  Nie as H,
  dr as I,
  kie as J,
  Gie as K,
  gie as L,
  _ie as M,
  ZN as N,
  vie as O,
  hie as P,
  Mie as Q,
  pie as R,
  yie as S,
  lie as T,
  ka as U,
  xie as V,
  UD as W,
  dp as X,
  Tm as Y,
  cp as Z,
  Ce as _,
  HN as a,
  die as b,
  wie as c,
  Cie as d,
  uie as e,
  Oie as f,
  uD as g,
  Pie as h,
  aE as i,
  mie as j,
  Rie as k,
  bie as l,
  Aie as m,
  Fie as n,
  tv as o,
  Iie as p,
  fie as q,
  VN as r,
  Eie as s,
  Die as t,
  ce as u,
  jie as v,
  Uie as w,
  eie as x,
  Sie as y,
  Hie as z
};
